
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
//@ts-check
// Main entry point - imports modules and exposes functions needed by Alpine/HTML
// packages/alpinejs/src/scheduler.js
var $b42d55c73dda5cc5$var$flushPending = false;
var $b42d55c73dda5cc5$var$flushing = false;
var $b42d55c73dda5cc5$var$queue = [];
var $b42d55c73dda5cc5$var$lastFlushedIndex = -1;
function $b42d55c73dda5cc5$var$scheduler(callback) {
    $b42d55c73dda5cc5$var$queueJob(callback);
}
function $b42d55c73dda5cc5$var$queueJob(job) {
    if (!$b42d55c73dda5cc5$var$queue.includes(job)) $b42d55c73dda5cc5$var$queue.push(job);
    $b42d55c73dda5cc5$var$queueFlush();
}
function $b42d55c73dda5cc5$var$dequeueJob(job) {
    let index = $b42d55c73dda5cc5$var$queue.indexOf(job);
    if (index !== -1 && index > $b42d55c73dda5cc5$var$lastFlushedIndex) $b42d55c73dda5cc5$var$queue.splice(index, 1);
}
function $b42d55c73dda5cc5$var$queueFlush() {
    if (!$b42d55c73dda5cc5$var$flushing && !$b42d55c73dda5cc5$var$flushPending) {
        $b42d55c73dda5cc5$var$flushPending = true;
        queueMicrotask($b42d55c73dda5cc5$var$flushJobs);
    }
}
function $b42d55c73dda5cc5$var$flushJobs() {
    $b42d55c73dda5cc5$var$flushPending = false;
    $b42d55c73dda5cc5$var$flushing = true;
    for(let i = 0; i < $b42d55c73dda5cc5$var$queue.length; i++){
        $b42d55c73dda5cc5$var$queue[i]();
        $b42d55c73dda5cc5$var$lastFlushedIndex = i;
    }
    $b42d55c73dda5cc5$var$queue.length = 0;
    $b42d55c73dda5cc5$var$lastFlushedIndex = -1;
    $b42d55c73dda5cc5$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $b42d55c73dda5cc5$var$reactive;
var $b42d55c73dda5cc5$var$effect;
var $b42d55c73dda5cc5$var$release;
var $b42d55c73dda5cc5$var$raw;
var $b42d55c73dda5cc5$var$shouldSchedule = true;
function $b42d55c73dda5cc5$var$disableEffectScheduling(callback) {
    $b42d55c73dda5cc5$var$shouldSchedule = false;
    callback();
    $b42d55c73dda5cc5$var$shouldSchedule = true;
}
function $b42d55c73dda5cc5$var$setReactivityEngine(engine) {
    $b42d55c73dda5cc5$var$reactive = engine.reactive;
    $b42d55c73dda5cc5$var$release = engine.release;
    $b42d55c73dda5cc5$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($b42d55c73dda5cc5$var$shouldSchedule) $b42d55c73dda5cc5$var$scheduler(task);
                else task();
            }
        });
    $b42d55c73dda5cc5$var$raw = engine.raw;
}
function $b42d55c73dda5cc5$var$overrideEffect(override) {
    $b42d55c73dda5cc5$var$effect = override;
}
function $b42d55c73dda5cc5$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $b42d55c73dda5cc5$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $b42d55c73dda5cc5$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $b42d55c73dda5cc5$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $b42d55c73dda5cc5$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$b42d55c73dda5cc5$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $b42d55c73dda5cc5$var$onAttributeAddeds = [];
var $b42d55c73dda5cc5$var$onElRemoveds = [];
var $b42d55c73dda5cc5$var$onElAddeds = [];
function $b42d55c73dda5cc5$var$onElAdded(callback) {
    $b42d55c73dda5cc5$var$onElAddeds.push(callback);
}
function $b42d55c73dda5cc5$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $b42d55c73dda5cc5$var$onElRemoveds.push(callback);
    }
}
function $b42d55c73dda5cc5$var$onAttributesAdded(callback) {
    $b42d55c73dda5cc5$var$onAttributeAddeds.push(callback);
}
function $b42d55c73dda5cc5$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $b42d55c73dda5cc5$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $b42d55c73dda5cc5$var$cleanupElement(el) {
    el._x_effects?.forEach($b42d55c73dda5cc5$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $b42d55c73dda5cc5$var$observer = new MutationObserver($b42d55c73dda5cc5$var$onMutate);
var $b42d55c73dda5cc5$var$currentlyObserving = false;
function $b42d55c73dda5cc5$var$startObservingMutations() {
    $b42d55c73dda5cc5$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $b42d55c73dda5cc5$var$currentlyObserving = true;
}
function $b42d55c73dda5cc5$var$stopObservingMutations() {
    $b42d55c73dda5cc5$var$flushObserver();
    $b42d55c73dda5cc5$var$observer.disconnect();
    $b42d55c73dda5cc5$var$currentlyObserving = false;
}
var $b42d55c73dda5cc5$var$queuedMutations = [];
function $b42d55c73dda5cc5$var$flushObserver() {
    let records = $b42d55c73dda5cc5$var$observer.takeRecords();
    $b42d55c73dda5cc5$var$queuedMutations.push(()=>records.length > 0 && $b42d55c73dda5cc5$var$onMutate(records));
    let queueLengthWhenTriggered = $b42d55c73dda5cc5$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($b42d55c73dda5cc5$var$queuedMutations.length === queueLengthWhenTriggered) while($b42d55c73dda5cc5$var$queuedMutations.length > 0)$b42d55c73dda5cc5$var$queuedMutations.shift()();
    });
}
function $b42d55c73dda5cc5$var$mutateDom(callback) {
    if (!$b42d55c73dda5cc5$var$currentlyObserving) return callback();
    $b42d55c73dda5cc5$var$stopObservingMutations();
    let result = callback();
    $b42d55c73dda5cc5$var$startObservingMutations();
    return result;
}
var $b42d55c73dda5cc5$var$isCollecting = false;
var $b42d55c73dda5cc5$var$deferredMutations = [];
function $b42d55c73dda5cc5$var$deferMutations() {
    $b42d55c73dda5cc5$var$isCollecting = true;
}
function $b42d55c73dda5cc5$var$flushAndStopDeferringMutations() {
    $b42d55c73dda5cc5$var$isCollecting = false;
    $b42d55c73dda5cc5$var$onMutate($b42d55c73dda5cc5$var$deferredMutations);
    $b42d55c73dda5cc5$var$deferredMutations = [];
}
function $b42d55c73dda5cc5$var$onMutate(mutations) {
    if ($b42d55c73dda5cc5$var$isCollecting) {
        $b42d55c73dda5cc5$var$deferredMutations = $b42d55c73dda5cc5$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $b42d55c73dda5cc5$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $b42d55c73dda5cc5$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $b42d55c73dda5cc5$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $b42d55c73dda5cc5$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $b42d55c73dda5cc5$var$scope(node) {
    return $b42d55c73dda5cc5$var$mergeProxies($b42d55c73dda5cc5$var$closestDataStack(node));
}
function $b42d55c73dda5cc5$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$b42d55c73dda5cc5$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $b42d55c73dda5cc5$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $b42d55c73dda5cc5$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $b42d55c73dda5cc5$var$closestDataStack(node.parentNode);
}
function $b42d55c73dda5cc5$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $b42d55c73dda5cc5$var$mergeProxyTrap);
}
var $b42d55c73dda5cc5$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $b42d55c73dda5cc5$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $b42d55c73dda5cc5$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $b42d55c73dda5cc5$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $b42d55c73dda5cc5$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$b42d55c73dda5cc5$var$get(data2, path), (value)=>$b42d55c73dda5cc5$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $b42d55c73dda5cc5$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $b42d55c73dda5cc5$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $b42d55c73dda5cc5$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $b42d55c73dda5cc5$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $b42d55c73dda5cc5$var$magics = {};
function $b42d55c73dda5cc5$var$magic(name, callback) {
    $b42d55c73dda5cc5$var$magics[name] = callback;
}
function $b42d55c73dda5cc5$var$injectMagics(obj, el) {
    let memoizedUtilities = $b42d55c73dda5cc5$var$getUtilities(el);
    Object.entries($b42d55c73dda5cc5$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $b42d55c73dda5cc5$var$getUtilities(el) {
    let [utilities, cleanup2] = $b42d55c73dda5cc5$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $b42d55c73dda5cc5$var$interceptor,
        ...utilities
    };
    $b42d55c73dda5cc5$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $b42d55c73dda5cc5$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $b42d55c73dda5cc5$var$handleError(e, el, expression);
    }
}
function $b42d55c73dda5cc5$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $b42d55c73dda5cc5$var$shouldAutoEvaluateFunctions = true;
function $b42d55c73dda5cc5$var$dontAutoEvaluateFunctions(callback) {
    let cache = $b42d55c73dda5cc5$var$shouldAutoEvaluateFunctions;
    $b42d55c73dda5cc5$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $b42d55c73dda5cc5$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $b42d55c73dda5cc5$var$evaluate(el, expression, extras = {}) {
    let result;
    $b42d55c73dda5cc5$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $b42d55c73dda5cc5$var$evaluateLater(...args) {
    return $b42d55c73dda5cc5$var$theEvaluatorFunction(...args);
}
var $b42d55c73dda5cc5$var$theEvaluatorFunction = $b42d55c73dda5cc5$var$normalEvaluator;
function $b42d55c73dda5cc5$var$setEvaluator(newEvaluator) {
    $b42d55c73dda5cc5$var$theEvaluatorFunction = newEvaluator;
}
function $b42d55c73dda5cc5$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $b42d55c73dda5cc5$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$b42d55c73dda5cc5$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $b42d55c73dda5cc5$var$generateEvaluatorFromFunction(dataStack, expression) : $b42d55c73dda5cc5$var$generateEvaluatorFromString(dataStack, expression, el);
    return $b42d55c73dda5cc5$var$tryCatch.bind(null, el, expression, evaluator);
}
function $b42d55c73dda5cc5$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        let result = func.apply($b42d55c73dda5cc5$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $b42d55c73dda5cc5$var$runIfTypeOfFunction(receiver, result);
    };
}
var $b42d55c73dda5cc5$var$evaluatorMemo = {};
function $b42d55c73dda5cc5$var$generateFunctionFromString(expression, el) {
    if ($b42d55c73dda5cc5$var$evaluatorMemo[expression]) return $b42d55c73dda5cc5$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $b42d55c73dda5cc5$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $b42d55c73dda5cc5$var$evaluatorMemo[expression] = func;
    return func;
}
function $b42d55c73dda5cc5$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $b42d55c73dda5cc5$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $b42d55c73dda5cc5$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$b42d55c73dda5cc5$var$handleError(error2, el, expression));
            if (func.finished) {
                $b42d55c73dda5cc5$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $b42d55c73dda5cc5$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$b42d55c73dda5cc5$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $b42d55c73dda5cc5$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($b42d55c73dda5cc5$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$b42d55c73dda5cc5$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$b42d55c73dda5cc5$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $b42d55c73dda5cc5$var$prefixAsString = "x-";
function $b42d55c73dda5cc5$var$prefix(subject = "") {
    return $b42d55c73dda5cc5$var$prefixAsString + subject;
}
function $b42d55c73dda5cc5$var$setPrefix(newPrefix) {
    $b42d55c73dda5cc5$var$prefixAsString = newPrefix;
}
var $b42d55c73dda5cc5$var$directiveHandlers = {};
function $b42d55c73dda5cc5$var$directive(name, callback) {
    $b42d55c73dda5cc5$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$b42d55c73dda5cc5$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $b42d55c73dda5cc5$var$directiveOrder.indexOf(directive2);
            $b42d55c73dda5cc5$var$directiveOrder.splice(pos >= 0 ? pos : $b42d55c73dda5cc5$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $b42d55c73dda5cc5$var$directiveExists(name) {
    return Object.keys($b42d55c73dda5cc5$var$directiveHandlers).includes(name);
}
function $b42d55c73dda5cc5$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $b42d55c73dda5cc5$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($b42d55c73dda5cc5$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($b42d55c73dda5cc5$var$outNonAlpineAttributes).map($b42d55c73dda5cc5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($b42d55c73dda5cc5$var$byPriority);
    return directives2.map((directive2)=>{
        return $b42d55c73dda5cc5$var$getDirectiveHandler(el, directive2);
    });
}
function $b42d55c73dda5cc5$var$attributesOnly(attributes) {
    return Array.from(attributes).map($b42d55c73dda5cc5$var$toTransformedAttributes()).filter((attr)=>!$b42d55c73dda5cc5$var$outNonAlpineAttributes(attr));
}
var $b42d55c73dda5cc5$var$isDeferringHandlers = false;
var $b42d55c73dda5cc5$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $b42d55c73dda5cc5$var$currentHandlerStackKey = Symbol();
function $b42d55c73dda5cc5$var$deferHandlingDirectives(callback) {
    $b42d55c73dda5cc5$var$isDeferringHandlers = true;
    let key = Symbol();
    $b42d55c73dda5cc5$var$currentHandlerStackKey = key;
    $b42d55c73dda5cc5$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($b42d55c73dda5cc5$var$directiveHandlerStacks.get(key).length)$b42d55c73dda5cc5$var$directiveHandlerStacks.get(key).shift()();
        $b42d55c73dda5cc5$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $b42d55c73dda5cc5$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $b42d55c73dda5cc5$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $b42d55c73dda5cc5$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $b42d55c73dda5cc5$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $b42d55c73dda5cc5$var$evaluateLater.bind($b42d55c73dda5cc5$var$evaluateLater, el),
        evaluate: $b42d55c73dda5cc5$var$evaluate.bind($b42d55c73dda5cc5$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $b42d55c73dda5cc5$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $b42d55c73dda5cc5$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $b42d55c73dda5cc5$var$getElementBoundUtilities(el);
    $b42d55c73dda5cc5$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $b42d55c73dda5cc5$var$isDeferringHandlers ? $b42d55c73dda5cc5$var$directiveHandlerStacks.get($b42d55c73dda5cc5$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $b42d55c73dda5cc5$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $b42d55c73dda5cc5$var$into = (i)=>i;
function $b42d55c73dda5cc5$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $b42d55c73dda5cc5$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $b42d55c73dda5cc5$var$attributeTransformers = [];
function $b42d55c73dda5cc5$var$mapAttributes(callback) {
    $b42d55c73dda5cc5$var$attributeTransformers.push(callback);
}
function $b42d55c73dda5cc5$var$outNonAlpineAttributes({ name: name }) {
    return $b42d55c73dda5cc5$var$alpineAttributeRegex().test(name);
}
var $b42d55c73dda5cc5$var$alpineAttributeRegex = ()=>new RegExp(`^${$b42d55c73dda5cc5$var$prefixAsString}([^:^.]+)\\b`);
function $b42d55c73dda5cc5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($b42d55c73dda5cc5$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $b42d55c73dda5cc5$var$DEFAULT = "DEFAULT";
var $b42d55c73dda5cc5$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $b42d55c73dda5cc5$var$DEFAULT,
    "teleport"
];
function $b42d55c73dda5cc5$var$byPriority(a, b) {
    let typeA = $b42d55c73dda5cc5$var$directiveOrder.indexOf(a.type) === -1 ? $b42d55c73dda5cc5$var$DEFAULT : a.type;
    let typeB = $b42d55c73dda5cc5$var$directiveOrder.indexOf(b.type) === -1 ? $b42d55c73dda5cc5$var$DEFAULT : b.type;
    return $b42d55c73dda5cc5$var$directiveOrder.indexOf(typeA) - $b42d55c73dda5cc5$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $b42d55c73dda5cc5$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $b42d55c73dda5cc5$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$b42d55c73dda5cc5$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $b42d55c73dda5cc5$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $b42d55c73dda5cc5$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $b42d55c73dda5cc5$var$started = false;
function $b42d55c73dda5cc5$var$start() {
    if ($b42d55c73dda5cc5$var$started) $b42d55c73dda5cc5$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $b42d55c73dda5cc5$var$started = true;
    if (!document.body) $b42d55c73dda5cc5$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $b42d55c73dda5cc5$var$dispatch(document, "alpine:init");
    $b42d55c73dda5cc5$var$dispatch(document, "alpine:initializing");
    $b42d55c73dda5cc5$var$startObservingMutations();
    $b42d55c73dda5cc5$var$onElAdded((el)=>$b42d55c73dda5cc5$var$initTree(el, $b42d55c73dda5cc5$var$walk));
    $b42d55c73dda5cc5$var$onElRemoved((el)=>$b42d55c73dda5cc5$var$destroyTree(el));
    $b42d55c73dda5cc5$var$onAttributesAdded((el, attrs)=>{
        $b42d55c73dda5cc5$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$b42d55c73dda5cc5$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($b42d55c73dda5cc5$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $b42d55c73dda5cc5$var$initTree(el);
    });
    $b42d55c73dda5cc5$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $b42d55c73dda5cc5$var$warnAboutMissingPlugins();
    });
}
var $b42d55c73dda5cc5$var$rootSelectorCallbacks = [];
var $b42d55c73dda5cc5$var$initSelectorCallbacks = [];
function $b42d55c73dda5cc5$var$rootSelectors() {
    return $b42d55c73dda5cc5$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $b42d55c73dda5cc5$var$allSelectors() {
    return $b42d55c73dda5cc5$var$rootSelectorCallbacks.concat($b42d55c73dda5cc5$var$initSelectorCallbacks).map((fn)=>fn());
}
function $b42d55c73dda5cc5$var$addRootSelector(selectorCallback) {
    $b42d55c73dda5cc5$var$rootSelectorCallbacks.push(selectorCallback);
}
function $b42d55c73dda5cc5$var$addInitSelector(selectorCallback) {
    $b42d55c73dda5cc5$var$initSelectorCallbacks.push(selectorCallback);
}
function $b42d55c73dda5cc5$var$closestRoot(el, includeInitSelectors = false) {
    return $b42d55c73dda5cc5$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $b42d55c73dda5cc5$var$allSelectors() : $b42d55c73dda5cc5$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $b42d55c73dda5cc5$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $b42d55c73dda5cc5$var$findClosest(el.parentElement, callback);
}
function $b42d55c73dda5cc5$var$isRoot(el) {
    return $b42d55c73dda5cc5$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $b42d55c73dda5cc5$var$initInterceptors2 = [];
function $b42d55c73dda5cc5$var$interceptInit(callback) {
    $b42d55c73dda5cc5$var$initInterceptors2.push(callback);
}
var $b42d55c73dda5cc5$var$markerDispenser = 1;
function $b42d55c73dda5cc5$var$initTree(el, walker = $b42d55c73dda5cc5$var$walk, intercept = ()=>{}) {
    if ($b42d55c73dda5cc5$var$findClosest(el, (i)=>i._x_ignore)) return;
    $b42d55c73dda5cc5$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $b42d55c73dda5cc5$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $b42d55c73dda5cc5$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $b42d55c73dda5cc5$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $b42d55c73dda5cc5$var$destroyTree(root, walker = $b42d55c73dda5cc5$var$walk) {
    walker(root, (el)=>{
        $b42d55c73dda5cc5$var$cleanupElement(el);
        $b42d55c73dda5cc5$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $b42d55c73dda5cc5$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($b42d55c73dda5cc5$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $b42d55c73dda5cc5$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $b42d55c73dda5cc5$var$tickStack = [];
var $b42d55c73dda5cc5$var$isHolding = false;
function $b42d55c73dda5cc5$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $b42d55c73dda5cc5$var$isHolding || setTimeout(()=>{
            $b42d55c73dda5cc5$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $b42d55c73dda5cc5$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $b42d55c73dda5cc5$var$releaseNextTicks() {
    $b42d55c73dda5cc5$var$isHolding = false;
    while($b42d55c73dda5cc5$var$tickStack.length)$b42d55c73dda5cc5$var$tickStack.shift()();
}
function $b42d55c73dda5cc5$var$holdNextTicks() {
    $b42d55c73dda5cc5$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $b42d55c73dda5cc5$var$setClasses(el, value) {
    if (Array.isArray(value)) return $b42d55c73dda5cc5$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $b42d55c73dda5cc5$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $b42d55c73dda5cc5$var$setClasses(el, value());
    return $b42d55c73dda5cc5$var$setClassesFromString(el, value);
}
function $b42d55c73dda5cc5$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $b42d55c73dda5cc5$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $b42d55c73dda5cc5$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $b42d55c73dda5cc5$var$setStylesFromObject(el, value);
    return $b42d55c73dda5cc5$var$setStylesFromString(el, value);
}
function $b42d55c73dda5cc5$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $b42d55c73dda5cc5$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $b42d55c73dda5cc5$var$setStyles(el, previousStyles);
    };
}
function $b42d55c73dda5cc5$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $b42d55c73dda5cc5$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $b42d55c73dda5cc5$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$b42d55c73dda5cc5$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $b42d55c73dda5cc5$var$registerTransitionsFromHelper(el, modifiers, value);
    else $b42d55c73dda5cc5$var$registerTransitionsFromClassString(el, expression, value);
});
function $b42d55c73dda5cc5$var$registerTransitionsFromClassString(el, classString, stage) {
    $b42d55c73dda5cc5$var$registerTransitionObject(el, $b42d55c73dda5cc5$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $b42d55c73dda5cc5$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $b42d55c73dda5cc5$var$registerTransitionObject(el, $b42d55c73dda5cc5$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $b42d55c73dda5cc5$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $b42d55c73dda5cc5$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $b42d55c73dda5cc5$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $b42d55c73dda5cc5$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $b42d55c73dda5cc5$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $b42d55c73dda5cc5$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $b42d55c73dda5cc5$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $b42d55c73dda5cc5$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $b42d55c73dda5cc5$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $b42d55c73dda5cc5$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $b42d55c73dda5cc5$var$closestHide(parent);
}
function $b42d55c73dda5cc5$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $b42d55c73dda5cc5$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $b42d55c73dda5cc5$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $b42d55c73dda5cc5$var$once(()=>{
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $b42d55c73dda5cc5$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $b42d55c73dda5cc5$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $b42d55c73dda5cc5$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $b42d55c73dda5cc5$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                stages.end();
            });
            $b42d55c73dda5cc5$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $b42d55c73dda5cc5$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $b42d55c73dda5cc5$var$isCloning = false;
function $b42d55c73dda5cc5$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$b42d55c73dda5cc5$var$isCloning ? fallback(...args) : callback(...args);
}
function $b42d55c73dda5cc5$var$onlyDuringClone(callback) {
    return (...args)=>$b42d55c73dda5cc5$var$isCloning && callback(...args);
}
var $b42d55c73dda5cc5$var$interceptors = [];
function $b42d55c73dda5cc5$var$interceptClone(callback) {
    $b42d55c73dda5cc5$var$interceptors.push(callback);
}
function $b42d55c73dda5cc5$var$cloneNode(from, to) {
    $b42d55c73dda5cc5$var$interceptors.forEach((i)=>i(from, to));
    $b42d55c73dda5cc5$var$isCloning = true;
    $b42d55c73dda5cc5$var$dontRegisterReactiveSideEffects(()=>{
        $b42d55c73dda5cc5$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $b42d55c73dda5cc5$var$isCloning = false;
}
var $b42d55c73dda5cc5$var$isCloningLegacy = false;
function $b42d55c73dda5cc5$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $b42d55c73dda5cc5$var$isCloning = true;
    $b42d55c73dda5cc5$var$isCloningLegacy = true;
    $b42d55c73dda5cc5$var$dontRegisterReactiveSideEffects(()=>{
        $b42d55c73dda5cc5$var$cloneTree(newEl);
    });
    $b42d55c73dda5cc5$var$isCloning = false;
    $b42d55c73dda5cc5$var$isCloningLegacy = false;
}
function $b42d55c73dda5cc5$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $b42d55c73dda5cc5$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $b42d55c73dda5cc5$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $b42d55c73dda5cc5$var$initTree(el, shallowWalker);
}
function $b42d55c73dda5cc5$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $b42d55c73dda5cc5$var$effect;
    $b42d55c73dda5cc5$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $b42d55c73dda5cc5$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $b42d55c73dda5cc5$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $b42d55c73dda5cc5$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $b42d55c73dda5cc5$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $b42d55c73dda5cc5$var$camelCase(name) : name;
    switch(name){
        case "value":
            $b42d55c73dda5cc5$var$bindInputValue(el, value);
            break;
        case "style":
            $b42d55c73dda5cc5$var$bindStyles(el, value);
            break;
        case "class":
            $b42d55c73dda5cc5$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $b42d55c73dda5cc5$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $b42d55c73dda5cc5$var$bindAttribute(el, name, value);
            break;
    }
}
function $b42d55c73dda5cc5$var$bindInputValue(el, value) {
    if ($b42d55c73dda5cc5$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $b42d55c73dda5cc5$var$safeParseBoolean(el.value) === value;
            else el.checked = $b42d55c73dda5cc5$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($b42d55c73dda5cc5$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$b42d55c73dda5cc5$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $b42d55c73dda5cc5$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $b42d55c73dda5cc5$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $b42d55c73dda5cc5$var$setClasses(el, value);
}
function $b42d55c73dda5cc5$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $b42d55c73dda5cc5$var$setStyles(el, value);
}
function $b42d55c73dda5cc5$var$bindAttributeAndProperty(el, name, value) {
    $b42d55c73dda5cc5$var$bindAttribute(el, name, value);
    $b42d55c73dda5cc5$var$setPropertyIfChanged(el, name, value);
}
function $b42d55c73dda5cc5$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $b42d55c73dda5cc5$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($b42d55c73dda5cc5$var$isBooleanAttr(name)) value = name;
        $b42d55c73dda5cc5$var$setIfChanged(el, name, value);
    }
}
function $b42d55c73dda5cc5$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $b42d55c73dda5cc5$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $b42d55c73dda5cc5$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $b42d55c73dda5cc5$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b42d55c73dda5cc5$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $b42d55c73dda5cc5$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $b42d55c73dda5cc5$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $b42d55c73dda5cc5$var$isBooleanAttr(attrName) {
    return $b42d55c73dda5cc5$var$booleanAttributes.has(attrName);
}
function $b42d55c73dda5cc5$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $b42d55c73dda5cc5$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $b42d55c73dda5cc5$var$getAttributeBinding(el, name, fallback);
}
function $b42d55c73dda5cc5$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $b42d55c73dda5cc5$var$dontAutoEvaluateFunctions(()=>{
            return $b42d55c73dda5cc5$var$evaluate(el, binding.expression);
        });
    }
    return $b42d55c73dda5cc5$var$getAttributeBinding(el, name, fallback);
}
function $b42d55c73dda5cc5$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($b42d55c73dda5cc5$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $b42d55c73dda5cc5$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $b42d55c73dda5cc5$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $b42d55c73dda5cc5$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $b42d55c73dda5cc5$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $b42d55c73dda5cc5$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $b42d55c73dda5cc5$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($b42d55c73dda5cc5$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($b42d55c73dda5cc5$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($b42d55c73dda5cc5$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $b42d55c73dda5cc5$var$release(reference);
    };
}
function $b42d55c73dda5cc5$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $b42d55c73dda5cc5$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($b42d55c73dda5cc5$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $b42d55c73dda5cc5$var$stores = {};
var $b42d55c73dda5cc5$var$isReactive = false;
function $b42d55c73dda5cc5$var$store(name, value) {
    if (!$b42d55c73dda5cc5$var$isReactive) {
        $b42d55c73dda5cc5$var$stores = $b42d55c73dda5cc5$var$reactive($b42d55c73dda5cc5$var$stores);
        $b42d55c73dda5cc5$var$isReactive = true;
    }
    if (value === void 0) return $b42d55c73dda5cc5$var$stores[name];
    $b42d55c73dda5cc5$var$stores[name] = value;
    $b42d55c73dda5cc5$var$initInterceptors($b42d55c73dda5cc5$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $b42d55c73dda5cc5$var$stores[name].init();
}
function $b42d55c73dda5cc5$var$getStores() {
    return $b42d55c73dda5cc5$var$stores;
}
// packages/alpinejs/src/binds.js
var $b42d55c73dda5cc5$var$binds = {};
function $b42d55c73dda5cc5$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $b42d55c73dda5cc5$var$applyBindingsObject(name, getBindings());
    else $b42d55c73dda5cc5$var$binds[name] = getBindings;
    return ()=>{};
}
function $b42d55c73dda5cc5$var$injectBindingProviders(obj) {
    Object.entries($b42d55c73dda5cc5$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $b42d55c73dda5cc5$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $b42d55c73dda5cc5$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $b42d55c73dda5cc5$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $b42d55c73dda5cc5$var$datas = {};
function $b42d55c73dda5cc5$var$data(name, callback) {
    $b42d55c73dda5cc5$var$datas[name] = callback;
}
function $b42d55c73dda5cc5$var$injectDataProviders(obj, context) {
    Object.entries($b42d55c73dda5cc5$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $b42d55c73dda5cc5$var$Alpine = {
    get reactive () {
        return $b42d55c73dda5cc5$var$reactive;
    },
    get release () {
        return $b42d55c73dda5cc5$var$release;
    },
    get effect () {
        return $b42d55c73dda5cc5$var$effect;
    },
    get raw () {
        return $b42d55c73dda5cc5$var$raw;
    },
    version: "3.15.0",
    flushAndStopDeferringMutations: $b42d55c73dda5cc5$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $b42d55c73dda5cc5$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $b42d55c73dda5cc5$var$disableEffectScheduling,
    startObservingMutations: $b42d55c73dda5cc5$var$startObservingMutations,
    stopObservingMutations: $b42d55c73dda5cc5$var$stopObservingMutations,
    setReactivityEngine: $b42d55c73dda5cc5$var$setReactivityEngine,
    onAttributeRemoved: $b42d55c73dda5cc5$var$onAttributeRemoved,
    onAttributesAdded: $b42d55c73dda5cc5$var$onAttributesAdded,
    closestDataStack: $b42d55c73dda5cc5$var$closestDataStack,
    skipDuringClone: $b42d55c73dda5cc5$var$skipDuringClone,
    onlyDuringClone: $b42d55c73dda5cc5$var$onlyDuringClone,
    addRootSelector: $b42d55c73dda5cc5$var$addRootSelector,
    addInitSelector: $b42d55c73dda5cc5$var$addInitSelector,
    interceptClone: $b42d55c73dda5cc5$var$interceptClone,
    addScopeToNode: $b42d55c73dda5cc5$var$addScopeToNode,
    deferMutations: $b42d55c73dda5cc5$var$deferMutations,
    mapAttributes: $b42d55c73dda5cc5$var$mapAttributes,
    evaluateLater: $b42d55c73dda5cc5$var$evaluateLater,
    interceptInit: $b42d55c73dda5cc5$var$interceptInit,
    setEvaluator: $b42d55c73dda5cc5$var$setEvaluator,
    mergeProxies: $b42d55c73dda5cc5$var$mergeProxies,
    extractProp: $b42d55c73dda5cc5$var$extractProp,
    findClosest: $b42d55c73dda5cc5$var$findClosest,
    onElRemoved: $b42d55c73dda5cc5$var$onElRemoved,
    closestRoot: $b42d55c73dda5cc5$var$closestRoot,
    destroyTree: $b42d55c73dda5cc5$var$destroyTree,
    interceptor: $b42d55c73dda5cc5$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $b42d55c73dda5cc5$var$transition,
    setStyles: // INTERNAL
    $b42d55c73dda5cc5$var$setStyles,
    mutateDom: // INTERNAL
    $b42d55c73dda5cc5$var$mutateDom,
    directive: $b42d55c73dda5cc5$var$directive,
    entangle: $b42d55c73dda5cc5$var$entangle,
    throttle: $b42d55c73dda5cc5$var$throttle,
    debounce: $b42d55c73dda5cc5$var$debounce,
    evaluate: $b42d55c73dda5cc5$var$evaluate,
    initTree: $b42d55c73dda5cc5$var$initTree,
    nextTick: $b42d55c73dda5cc5$var$nextTick,
    prefixed: $b42d55c73dda5cc5$var$prefix,
    prefix: $b42d55c73dda5cc5$var$setPrefix,
    plugin: $b42d55c73dda5cc5$var$plugin,
    magic: $b42d55c73dda5cc5$var$magic,
    store: $b42d55c73dda5cc5$var$store,
    start: $b42d55c73dda5cc5$var$start,
    clone: $b42d55c73dda5cc5$var$clone,
    cloneNode: // INTERNAL
    $b42d55c73dda5cc5$var$cloneNode,
    // INTERNAL
    bound: $b42d55c73dda5cc5$var$getBinding,
    $data: $b42d55c73dda5cc5$var$scope,
    watch: $b42d55c73dda5cc5$var$watch,
    walk: $b42d55c73dda5cc5$var$walk,
    data: $b42d55c73dda5cc5$var$data,
    bind: $b42d55c73dda5cc5$var$bind2
};
var $b42d55c73dda5cc5$var$alpine_default = $b42d55c73dda5cc5$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $b42d55c73dda5cc5$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $b42d55c73dda5cc5$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $b42d55c73dda5cc5$var$isBooleanAttr2 = /* @__PURE__ */ $b42d55c73dda5cc5$var$makeMap($b42d55c73dda5cc5$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $b42d55c73dda5cc5$var$EMPTY_OBJ = Object.freeze({});
var $b42d55c73dda5cc5$var$EMPTY_ARR = Object.freeze([]);
var $b42d55c73dda5cc5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b42d55c73dda5cc5$var$hasOwn = (val, key)=>$b42d55c73dda5cc5$var$hasOwnProperty.call(val, key);
var $b42d55c73dda5cc5$var$isArray = Array.isArray;
var $b42d55c73dda5cc5$var$isMap = (val)=>$b42d55c73dda5cc5$var$toTypeString(val) === "[object Map]";
var $b42d55c73dda5cc5$var$isString = (val)=>typeof val === "string";
var $b42d55c73dda5cc5$var$isSymbol = (val)=>typeof val === "symbol";
var $b42d55c73dda5cc5$var$isObject = (val)=>val !== null && typeof val === "object";
var $b42d55c73dda5cc5$var$objectToString = Object.prototype.toString;
var $b42d55c73dda5cc5$var$toTypeString = (value)=>$b42d55c73dda5cc5$var$objectToString.call(value);
var $b42d55c73dda5cc5$var$toRawType = (value)=>{
    return $b42d55c73dda5cc5$var$toTypeString(value).slice(8, -1);
};
var $b42d55c73dda5cc5$var$isIntegerKey = (key)=>$b42d55c73dda5cc5$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $b42d55c73dda5cc5$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $b42d55c73dda5cc5$var$camelizeRE = /-(\w)/g;
var $b42d55c73dda5cc5$var$camelize = $b42d55c73dda5cc5$var$cacheStringFunction((str)=>{
    return str.replace($b42d55c73dda5cc5$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $b42d55c73dda5cc5$var$hyphenateRE = /\B([A-Z])/g;
var $b42d55c73dda5cc5$var$hyphenate = $b42d55c73dda5cc5$var$cacheStringFunction((str)=>str.replace($b42d55c73dda5cc5$var$hyphenateRE, "-$1").toLowerCase());
var $b42d55c73dda5cc5$var$capitalize = $b42d55c73dda5cc5$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $b42d55c73dda5cc5$var$toHandlerKey = $b42d55c73dda5cc5$var$cacheStringFunction((str)=>str ? `on${$b42d55c73dda5cc5$var$capitalize(str)}` : ``);
var $b42d55c73dda5cc5$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $b42d55c73dda5cc5$var$targetMap = /* @__PURE__ */ new WeakMap();
var $b42d55c73dda5cc5$var$effectStack = [];
var $b42d55c73dda5cc5$var$activeEffect;
var $b42d55c73dda5cc5$var$ITERATE_KEY = Symbol("iterate");
var $b42d55c73dda5cc5$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $b42d55c73dda5cc5$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $b42d55c73dda5cc5$var$effect2(fn, options = $b42d55c73dda5cc5$var$EMPTY_OBJ) {
    if ($b42d55c73dda5cc5$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $b42d55c73dda5cc5$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $b42d55c73dda5cc5$var$stop(effect3) {
    if (effect3.active) {
        $b42d55c73dda5cc5$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $b42d55c73dda5cc5$var$uid = 0;
function $b42d55c73dda5cc5$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$b42d55c73dda5cc5$var$effectStack.includes(effect3)) {
            $b42d55c73dda5cc5$var$cleanup(effect3);
            try {
                $b42d55c73dda5cc5$var$enableTracking();
                $b42d55c73dda5cc5$var$effectStack.push(effect3);
                $b42d55c73dda5cc5$var$activeEffect = effect3;
                return fn();
            } finally{
                $b42d55c73dda5cc5$var$effectStack.pop();
                $b42d55c73dda5cc5$var$resetTracking();
                $b42d55c73dda5cc5$var$activeEffect = $b42d55c73dda5cc5$var$effectStack[$b42d55c73dda5cc5$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $b42d55c73dda5cc5$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $b42d55c73dda5cc5$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $b42d55c73dda5cc5$var$shouldTrack = true;
var $b42d55c73dda5cc5$var$trackStack = [];
function $b42d55c73dda5cc5$var$pauseTracking() {
    $b42d55c73dda5cc5$var$trackStack.push($b42d55c73dda5cc5$var$shouldTrack);
    $b42d55c73dda5cc5$var$shouldTrack = false;
}
function $b42d55c73dda5cc5$var$enableTracking() {
    $b42d55c73dda5cc5$var$trackStack.push($b42d55c73dda5cc5$var$shouldTrack);
    $b42d55c73dda5cc5$var$shouldTrack = true;
}
function $b42d55c73dda5cc5$var$resetTracking() {
    const last = $b42d55c73dda5cc5$var$trackStack.pop();
    $b42d55c73dda5cc5$var$shouldTrack = last === void 0 ? true : last;
}
function $b42d55c73dda5cc5$var$track(target, type, key) {
    if (!$b42d55c73dda5cc5$var$shouldTrack || $b42d55c73dda5cc5$var$activeEffect === void 0) return;
    let depsMap = $b42d55c73dda5cc5$var$targetMap.get(target);
    if (!depsMap) $b42d55c73dda5cc5$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($b42d55c73dda5cc5$var$activeEffect)) {
        dep.add($b42d55c73dda5cc5$var$activeEffect);
        $b42d55c73dda5cc5$var$activeEffect.deps.push(dep);
        if ($b42d55c73dda5cc5$var$activeEffect.options.onTrack) $b42d55c73dda5cc5$var$activeEffect.options.onTrack({
            effect: $b42d55c73dda5cc5$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $b42d55c73dda5cc5$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $b42d55c73dda5cc5$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $b42d55c73dda5cc5$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $b42d55c73dda5cc5$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$b42d55c73dda5cc5$var$isArray(target)) {
                    add2(depsMap.get($b42d55c73dda5cc5$var$ITERATE_KEY));
                    if ($b42d55c73dda5cc5$var$isMap(target)) add2(depsMap.get($b42d55c73dda5cc5$var$MAP_KEY_ITERATE_KEY));
                } else if ($b42d55c73dda5cc5$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$b42d55c73dda5cc5$var$isArray(target)) {
                    add2(depsMap.get($b42d55c73dda5cc5$var$ITERATE_KEY));
                    if ($b42d55c73dda5cc5$var$isMap(target)) add2(depsMap.get($b42d55c73dda5cc5$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($b42d55c73dda5cc5$var$isMap(target)) add2(depsMap.get($b42d55c73dda5cc5$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $b42d55c73dda5cc5$var$isNonTrackableKeys = /* @__PURE__ */ $b42d55c73dda5cc5$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $b42d55c73dda5cc5$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($b42d55c73dda5cc5$var$isSymbol));
var $b42d55c73dda5cc5$var$get2 = /* @__PURE__ */ $b42d55c73dda5cc5$var$createGetter();
var $b42d55c73dda5cc5$var$readonlyGet = /* @__PURE__ */ $b42d55c73dda5cc5$var$createGetter(true);
var $b42d55c73dda5cc5$var$arrayInstrumentations = /* @__PURE__ */ $b42d55c73dda5cc5$var$createArrayInstrumentations();
function $b42d55c73dda5cc5$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $b42d55c73dda5cc5$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$b42d55c73dda5cc5$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($b42d55c73dda5cc5$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $b42d55c73dda5cc5$var$pauseTracking();
            const res = $b42d55c73dda5cc5$var$toRaw(this)[key].apply(this, args);
            $b42d55c73dda5cc5$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $b42d55c73dda5cc5$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $b42d55c73dda5cc5$var$shallowReadonlyMap : $b42d55c73dda5cc5$var$readonlyMap : shallow ? $b42d55c73dda5cc5$var$shallowReactiveMap : $b42d55c73dda5cc5$var$reactiveMap).get(target)) return target;
        const targetIsArray = $b42d55c73dda5cc5$var$isArray(target);
        if (!isReadonly && targetIsArray && $b42d55c73dda5cc5$var$hasOwn($b42d55c73dda5cc5$var$arrayInstrumentations, key)) return Reflect.get($b42d55c73dda5cc5$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($b42d55c73dda5cc5$var$isSymbol(key) ? $b42d55c73dda5cc5$var$builtInSymbols.has(key) : $b42d55c73dda5cc5$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $b42d55c73dda5cc5$var$track(target, "get", key);
        if (shallow) return res;
        if ($b42d55c73dda5cc5$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$b42d55c73dda5cc5$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($b42d55c73dda5cc5$var$isObject(res)) return isReadonly ? $b42d55c73dda5cc5$var$readonly(res) : $b42d55c73dda5cc5$var$reactive2(res);
        return res;
    };
}
var $b42d55c73dda5cc5$var$set2 = /* @__PURE__ */ $b42d55c73dda5cc5$var$createSetter();
function $b42d55c73dda5cc5$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $b42d55c73dda5cc5$var$toRaw(value);
            oldValue = $b42d55c73dda5cc5$var$toRaw(oldValue);
            if (!$b42d55c73dda5cc5$var$isArray(target) && $b42d55c73dda5cc5$var$isRef(oldValue) && !$b42d55c73dda5cc5$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $b42d55c73dda5cc5$var$isArray(target) && $b42d55c73dda5cc5$var$isIntegerKey(key) ? Number(key) < target.length : $b42d55c73dda5cc5$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $b42d55c73dda5cc5$var$toRaw(receiver)) {
            if (!hadKey) $b42d55c73dda5cc5$var$trigger(target, "add", key, value);
            else if ($b42d55c73dda5cc5$var$hasChanged(value, oldValue)) $b42d55c73dda5cc5$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $b42d55c73dda5cc5$var$deleteProperty(target, key) {
    const hadKey = $b42d55c73dda5cc5$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $b42d55c73dda5cc5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $b42d55c73dda5cc5$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$b42d55c73dda5cc5$var$isSymbol(key) || !$b42d55c73dda5cc5$var$builtInSymbols.has(key)) $b42d55c73dda5cc5$var$track(target, "has", key);
    return result;
}
function $b42d55c73dda5cc5$var$ownKeys(target) {
    $b42d55c73dda5cc5$var$track(target, "iterate", $b42d55c73dda5cc5$var$isArray(target) ? "length" : $b42d55c73dda5cc5$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $b42d55c73dda5cc5$var$mutableHandlers = {
    get: $b42d55c73dda5cc5$var$get2,
    set: $b42d55c73dda5cc5$var$set2,
    deleteProperty: $b42d55c73dda5cc5$var$deleteProperty,
    has: $b42d55c73dda5cc5$var$has,
    ownKeys: $b42d55c73dda5cc5$var$ownKeys
};
var $b42d55c73dda5cc5$var$readonlyHandlers = {
    get: $b42d55c73dda5cc5$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $b42d55c73dda5cc5$var$toReactive = (value)=>$b42d55c73dda5cc5$var$isObject(value) ? $b42d55c73dda5cc5$var$reactive2(value) : value;
var $b42d55c73dda5cc5$var$toReadonly = (value)=>$b42d55c73dda5cc5$var$isObject(value) ? $b42d55c73dda5cc5$var$readonly(value) : value;
var $b42d55c73dda5cc5$var$toShallow = (value)=>value;
var $b42d55c73dda5cc5$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $b42d55c73dda5cc5$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $b42d55c73dda5cc5$var$toRaw(target);
    const rawKey = $b42d55c73dda5cc5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "get", key);
    !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $b42d55c73dda5cc5$var$getProto(rawTarget);
    const wrap = isShallow ? $b42d55c73dda5cc5$var$toShallow : isReadonly ? $b42d55c73dda5cc5$var$toReadonly : $b42d55c73dda5cc5$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $b42d55c73dda5cc5$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $b42d55c73dda5cc5$var$toRaw(target);
    const rawKey = $b42d55c73dda5cc5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "has", key);
    !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $b42d55c73dda5cc5$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $b42d55c73dda5cc5$var$track($b42d55c73dda5cc5$var$toRaw(target), "iterate", $b42d55c73dda5cc5$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $b42d55c73dda5cc5$var$add(value) {
    value = $b42d55c73dda5cc5$var$toRaw(value);
    const target = $b42d55c73dda5cc5$var$toRaw(this);
    const proto = $b42d55c73dda5cc5$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $b42d55c73dda5cc5$var$trigger(target, "add", value, value);
    }
    return this;
}
function $b42d55c73dda5cc5$var$set$1(key, value) {
    value = $b42d55c73dda5cc5$var$toRaw(value);
    const target = $b42d55c73dda5cc5$var$toRaw(this);
    const { has: has2, get: get3 } = $b42d55c73dda5cc5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $b42d55c73dda5cc5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $b42d55c73dda5cc5$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $b42d55c73dda5cc5$var$trigger(target, "add", key, value);
    else if ($b42d55c73dda5cc5$var$hasChanged(value, oldValue)) $b42d55c73dda5cc5$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $b42d55c73dda5cc5$var$deleteEntry(key) {
    const target = $b42d55c73dda5cc5$var$toRaw(this);
    const { has: has2, get: get3 } = $b42d55c73dda5cc5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $b42d55c73dda5cc5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $b42d55c73dda5cc5$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $b42d55c73dda5cc5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $b42d55c73dda5cc5$var$clear() {
    const target = $b42d55c73dda5cc5$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $b42d55c73dda5cc5$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $b42d55c73dda5cc5$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $b42d55c73dda5cc5$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $b42d55c73dda5cc5$var$toRaw(target);
        const wrap = isShallow ? $b42d55c73dda5cc5$var$toShallow : isReadonly ? $b42d55c73dda5cc5$var$toReadonly : $b42d55c73dda5cc5$var$toReactive;
        !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "iterate", $b42d55c73dda5cc5$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $b42d55c73dda5cc5$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $b42d55c73dda5cc5$var$toRaw(target);
        const targetIsMap = $b42d55c73dda5cc5$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $b42d55c73dda5cc5$var$toShallow : isReadonly ? $b42d55c73dda5cc5$var$toReadonly : $b42d55c73dda5cc5$var$toReactive;
        !isReadonly && $b42d55c73dda5cc5$var$track(rawTarget, "iterate", isKeyOnly ? $b42d55c73dda5cc5$var$MAP_KEY_ITERATE_KEY : $b42d55c73dda5cc5$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $b42d55c73dda5cc5$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$b42d55c73dda5cc5$var$capitalize(type)} operation ${key}failed: target is readonly.`, $b42d55c73dda5cc5$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $b42d55c73dda5cc5$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $b42d55c73dda5cc5$var$get$1(this, key);
        },
        get size () {
            return $b42d55c73dda5cc5$var$size(this);
        },
        has: $b42d55c73dda5cc5$var$has$1,
        add: $b42d55c73dda5cc5$var$add,
        set: $b42d55c73dda5cc5$var$set$1,
        delete: $b42d55c73dda5cc5$var$deleteEntry,
        clear: $b42d55c73dda5cc5$var$clear,
        forEach: $b42d55c73dda5cc5$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $b42d55c73dda5cc5$var$get$1(this, key, false, true);
        },
        get size () {
            return $b42d55c73dda5cc5$var$size(this);
        },
        has: $b42d55c73dda5cc5$var$has$1,
        add: $b42d55c73dda5cc5$var$add,
        set: $b42d55c73dda5cc5$var$set$1,
        delete: $b42d55c73dda5cc5$var$deleteEntry,
        clear: $b42d55c73dda5cc5$var$clear,
        forEach: $b42d55c73dda5cc5$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $b42d55c73dda5cc5$var$get$1(this, key, true);
        },
        get size () {
            return $b42d55c73dda5cc5$var$size(this, true);
        },
        has (key) {
            return $b42d55c73dda5cc5$var$has$1.call(this, key, true);
        },
        add: $b42d55c73dda5cc5$var$createReadonlyMethod("add"),
        set: $b42d55c73dda5cc5$var$createReadonlyMethod("set"),
        delete: $b42d55c73dda5cc5$var$createReadonlyMethod("delete"),
        clear: $b42d55c73dda5cc5$var$createReadonlyMethod("clear"),
        forEach: $b42d55c73dda5cc5$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $b42d55c73dda5cc5$var$get$1(this, key, true, true);
        },
        get size () {
            return $b42d55c73dda5cc5$var$size(this, true);
        },
        has (key) {
            return $b42d55c73dda5cc5$var$has$1.call(this, key, true);
        },
        add: $b42d55c73dda5cc5$var$createReadonlyMethod("add"),
        set: $b42d55c73dda5cc5$var$createReadonlyMethod("set"),
        delete: $b42d55c73dda5cc5$var$createReadonlyMethod("delete"),
        clear: $b42d55c73dda5cc5$var$createReadonlyMethod("clear"),
        forEach: $b42d55c73dda5cc5$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $b42d55c73dda5cc5$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $b42d55c73dda5cc5$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $b42d55c73dda5cc5$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $b42d55c73dda5cc5$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$b42d55c73dda5cc5$var$mutableInstrumentations, $b42d55c73dda5cc5$var$readonlyInstrumentations, $b42d55c73dda5cc5$var$shallowInstrumentations, $b42d55c73dda5cc5$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $b42d55c73dda5cc5$var$createInstrumentations();
function $b42d55c73dda5cc5$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $b42d55c73dda5cc5$var$shallowReadonlyInstrumentations : $b42d55c73dda5cc5$var$shallowInstrumentations : isReadonly ? $b42d55c73dda5cc5$var$readonlyInstrumentations : $b42d55c73dda5cc5$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($b42d55c73dda5cc5$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $b42d55c73dda5cc5$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $b42d55c73dda5cc5$var$createInstrumentationGetter(false, false)
};
var $b42d55c73dda5cc5$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $b42d55c73dda5cc5$var$createInstrumentationGetter(true, false)
};
function $b42d55c73dda5cc5$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $b42d55c73dda5cc5$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $b42d55c73dda5cc5$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $b42d55c73dda5cc5$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $b42d55c73dda5cc5$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $b42d55c73dda5cc5$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $b42d55c73dda5cc5$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $b42d55c73dda5cc5$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $b42d55c73dda5cc5$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $b42d55c73dda5cc5$var$targetTypeMap($b42d55c73dda5cc5$var$toRawType(value));
}
function $b42d55c73dda5cc5$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $b42d55c73dda5cc5$var$createReactiveObject(target, false, $b42d55c73dda5cc5$var$mutableHandlers, $b42d55c73dda5cc5$var$mutableCollectionHandlers, $b42d55c73dda5cc5$var$reactiveMap);
}
function $b42d55c73dda5cc5$var$readonly(target) {
    return $b42d55c73dda5cc5$var$createReactiveObject(target, true, $b42d55c73dda5cc5$var$readonlyHandlers, $b42d55c73dda5cc5$var$readonlyCollectionHandlers, $b42d55c73dda5cc5$var$readonlyMap);
}
function $b42d55c73dda5cc5$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$b42d55c73dda5cc5$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $b42d55c73dda5cc5$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $b42d55c73dda5cc5$var$toRaw(observed) {
    return observed && $b42d55c73dda5cc5$var$toRaw(observed["__v_raw"]) || observed;
}
function $b42d55c73dda5cc5$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$b42d55c73dda5cc5$var$magic("nextTick", ()=>$b42d55c73dda5cc5$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$b42d55c73dda5cc5$var$magic("dispatch", (el)=>$b42d55c73dda5cc5$var$dispatch.bind($b42d55c73dda5cc5$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$b42d55c73dda5cc5$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $b42d55c73dda5cc5$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$b42d55c73dda5cc5$var$magic("store", $b42d55c73dda5cc5$var$getStores);
// packages/alpinejs/src/magics/$data.js
$b42d55c73dda5cc5$var$magic("data", (el)=>$b42d55c73dda5cc5$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$b42d55c73dda5cc5$var$magic("root", (el)=>$b42d55c73dda5cc5$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$b42d55c73dda5cc5$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $b42d55c73dda5cc5$var$mergeProxies($b42d55c73dda5cc5$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $b42d55c73dda5cc5$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $b42d55c73dda5cc5$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $b42d55c73dda5cc5$var$globalIdMemo = {};
function $b42d55c73dda5cc5$var$findAndIncrementId(name) {
    if (!$b42d55c73dda5cc5$var$globalIdMemo[name]) $b42d55c73dda5cc5$var$globalIdMemo[name] = 0;
    return ++$b42d55c73dda5cc5$var$globalIdMemo[name];
}
function $b42d55c73dda5cc5$var$closestIdRoot(el, name) {
    return $b42d55c73dda5cc5$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $b42d55c73dda5cc5$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $b42d55c73dda5cc5$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$b42d55c73dda5cc5$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $b42d55c73dda5cc5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $b42d55c73dda5cc5$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $b42d55c73dda5cc5$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$b42d55c73dda5cc5$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $b42d55c73dda5cc5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$b42d55c73dda5cc5$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$b42d55c73dda5cc5$var$warnMissingPluginMagic("Focus", "focus", "focus");
$b42d55c73dda5cc5$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $b42d55c73dda5cc5$var$warnMissingPluginMagic(name, magicName, slug) {
    $b42d55c73dda5cc5$var$magic(magicName, (el)=>$b42d55c73dda5cc5$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$b42d55c73dda5cc5$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $b42d55c73dda5cc5$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$b42d55c73dda5cc5$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $b42d55c73dda5cc5$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $b42d55c73dda5cc5$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $b42d55c73dda5cc5$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $b42d55c73dda5cc5$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $b42d55c73dda5cc5$var$skipDuringClone(()=>{
            $b42d55c73dda5cc5$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $b42d55c73dda5cc5$var$getTarget(expression);
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$b42d55c73dda5cc5$var$mutateDom(()=>{
            clone2.remove();
            $b42d55c73dda5cc5$var$destroyTree(clone2);
        }));
});
var $b42d55c73dda5cc5$var$teleportContainerDuringClone = document.createElement("div");
function $b42d55c73dda5cc5$var$getTarget(expression) {
    let target = $b42d55c73dda5cc5$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $b42d55c73dda5cc5$var$teleportContainerDuringClone;
    })();
    if (!target) $b42d55c73dda5cc5$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $b42d55c73dda5cc5$var$handler = ()=>{};
$b42d55c73dda5cc5$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$b42d55c73dda5cc5$var$directive("ignore", $b42d55c73dda5cc5$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$b42d55c73dda5cc5$var$directive("effect", $b42d55c73dda5cc5$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($b42d55c73dda5cc5$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $b42d55c73dda5cc5$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $b42d55c73dda5cc5$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $b42d55c73dda5cc5$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $b42d55c73dda5cc5$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $b42d55c73dda5cc5$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $b42d55c73dda5cc5$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $b42d55c73dda5cc5$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($b42d55c73dda5cc5$var$isKeyEvent(event) || $b42d55c73dda5cc5$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($b42d55c73dda5cc5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $b42d55c73dda5cc5$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $b42d55c73dda5cc5$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b42d55c73dda5cc5$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $b42d55c73dda5cc5$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $b42d55c73dda5cc5$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $b42d55c73dda5cc5$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $b42d55c73dda5cc5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $b42d55c73dda5cc5$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $b42d55c73dda5cc5$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $b42d55c73dda5cc5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($b42d55c73dda5cc5$var$isClickEvent(e.type)) return false;
            if ($b42d55c73dda5cc5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $b42d55c73dda5cc5$var$keyToModifiers(key) {
    if (!key) return [];
    key = $b42d55c73dda5cc5$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$b42d55c73dda5cc5$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $b42d55c73dda5cc5$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $b42d55c73dda5cc5$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $b42d55c73dda5cc5$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $b42d55c73dda5cc5$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($b42d55c73dda5cc5$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $b42d55c73dda5cc5$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $b42d55c73dda5cc5$var$isCloning ? ()=>{} : $b42d55c73dda5cc5$var$on(el, event, modifiers, (e)=>{
        setValue($b42d55c73dda5cc5$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $b42d55c73dda5cc5$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($b42d55c73dda5cc5$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $b42d55c73dda5cc5$var$on(el.form, "reset", [], (e)=>{
            $b42d55c73dda5cc5$var$nextTick(()=>el._x_model && el._x_model.set($b42d55c73dda5cc5$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $b42d55c73dda5cc5$var$mutateDom(()=>$b42d55c73dda5cc5$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $b42d55c73dda5cc5$var$getInputValue(el, modifiers, event, currentValue) {
    return $b42d55c73dda5cc5$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($b42d55c73dda5cc5$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $b42d55c73dda5cc5$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $b42d55c73dda5cc5$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$b42d55c73dda5cc5$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $b42d55c73dda5cc5$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $b42d55c73dda5cc5$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($b42d55c73dda5cc5$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $b42d55c73dda5cc5$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $b42d55c73dda5cc5$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $b42d55c73dda5cc5$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $b42d55c73dda5cc5$var$isNumeric2(number) ? number : rawValue;
}
function $b42d55c73dda5cc5$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $b42d55c73dda5cc5$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $b42d55c73dda5cc5$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$b42d55c73dda5cc5$var$directive("cloak", (el)=>queueMicrotask(()=>$b42d55c73dda5cc5$var$mutateDom(()=>el.removeAttribute($b42d55c73dda5cc5$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$b42d55c73dda5cc5$var$addInitSelector(()=>`[${$b42d55c73dda5cc5$var$prefix("init")}]`);
$b42d55c73dda5cc5$var$directive("init", $b42d55c73dda5cc5$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$b42d55c73dda5cc5$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$b42d55c73dda5cc5$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $b42d55c73dda5cc5$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$b42d55c73dda5cc5$var$mapAttributes($b42d55c73dda5cc5$var$startingWith(":", $b42d55c73dda5cc5$var$into($b42d55c73dda5cc5$var$prefix("bind:"))));
var $b42d55c73dda5cc5$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $b42d55c73dda5cc5$var$injectBindingProviders(bindingProviders);
        let getBindings = $b42d55c73dda5cc5$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $b42d55c73dda5cc5$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $b42d55c73dda5cc5$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $b42d55c73dda5cc5$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $b42d55c73dda5cc5$var$mutateDom(()=>$b42d55c73dda5cc5$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$b42d55c73dda5cc5$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$b42d55c73dda5cc5$var$directive("bind", $b42d55c73dda5cc5$var$handler2);
function $b42d55c73dda5cc5$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$b42d55c73dda5cc5$var$addRootSelector(()=>`[${$b42d55c73dda5cc5$var$prefix("data")}]`);
$b42d55c73dda5cc5$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($b42d55c73dda5cc5$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $b42d55c73dda5cc5$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $b42d55c73dda5cc5$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $b42d55c73dda5cc5$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $b42d55c73dda5cc5$var$injectMagics(data2, el);
    let reactiveData = $b42d55c73dda5cc5$var$reactive(data2);
    $b42d55c73dda5cc5$var$initInterceptors(reactiveData);
    let undo = $b42d55c73dda5cc5$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $b42d55c73dda5cc5$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $b42d55c73dda5cc5$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$b42d55c73dda5cc5$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $b42d55c73dda5cc5$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$b42d55c73dda5cc5$var$isCloning) return false;
    if ($b42d55c73dda5cc5$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$b42d55c73dda5cc5$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $b42d55c73dda5cc5$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $b42d55c73dda5cc5$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$b42d55c73dda5cc5$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $b42d55c73dda5cc5$var$parseForExpression(expression);
    let evaluateItems = $b42d55c73dda5cc5$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $b42d55c73dda5cc5$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$b42d55c73dda5cc5$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$b42d55c73dda5cc5$var$mutateDom(()=>{
                $b42d55c73dda5cc5$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $b42d55c73dda5cc5$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($b42d55c73dda5cc5$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $b42d55c73dda5cc5$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $b42d55c73dda5cc5$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $b42d55c73dda5cc5$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $b42d55c73dda5cc5$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                $b42d55c73dda5cc5$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                if (!elForSpot) $b42d55c73dda5cc5$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $b42d55c73dda5cc5$var$reactive(scope2);
            $b42d55c73dda5cc5$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                lastEl.after(clone2);
                $b42d55c73dda5cc5$var$skipDuringClone(()=>$b42d55c73dda5cc5$var$initTree(clone2))();
            });
            if (typeof key === "object") $b42d55c73dda5cc5$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $b42d55c73dda5cc5$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $b42d55c73dda5cc5$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $b42d55c73dda5cc5$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $b42d55c73dda5cc5$var$handler3() {}
$b42d55c73dda5cc5$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $b42d55c73dda5cc5$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$b42d55c73dda5cc5$var$directive("ref", $b42d55c73dda5cc5$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$b42d55c73dda5cc5$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $b42d55c73dda5cc5$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $b42d55c73dda5cc5$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $b42d55c73dda5cc5$var$addScopeToNode(clone2, {}, el);
        $b42d55c73dda5cc5$var$mutateDom(()=>{
            el.after(clone2);
            $b42d55c73dda5cc5$var$skipDuringClone(()=>$b42d55c73dda5cc5$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $b42d55c73dda5cc5$var$mutateDom(()=>{
                $b42d55c73dda5cc5$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$b42d55c73dda5cc5$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$b42d55c73dda5cc5$var$setIdRoot(el, name));
});
$b42d55c73dda5cc5$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$b42d55c73dda5cc5$var$mapAttributes($b42d55c73dda5cc5$var$startingWith("@", $b42d55c73dda5cc5$var$into($b42d55c73dda5cc5$var$prefix("on:"))));
$b42d55c73dda5cc5$var$directive("on", $b42d55c73dda5cc5$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $b42d55c73dda5cc5$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $b42d55c73dda5cc5$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$b42d55c73dda5cc5$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$b42d55c73dda5cc5$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$b42d55c73dda5cc5$var$warnMissingPluginDirective("Focus", "trap", "focus");
$b42d55c73dda5cc5$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $b42d55c73dda5cc5$var$warnMissingPluginDirective(name, directiveName, slug) {
    $b42d55c73dda5cc5$var$directive(directiveName, (el)=>$b42d55c73dda5cc5$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$b42d55c73dda5cc5$var$alpine_default.setEvaluator($b42d55c73dda5cc5$var$normalEvaluator);
$b42d55c73dda5cc5$var$alpine_default.setReactivityEngine({
    reactive: $b42d55c73dda5cc5$var$reactive2,
    effect: $b42d55c73dda5cc5$var$effect2,
    release: $b42d55c73dda5cc5$var$stop,
    raw: $b42d55c73dda5cc5$var$toRaw
});
var $b42d55c73dda5cc5$export$b7ee041e4ad2afec = $b42d55c73dda5cc5$var$alpine_default;
// packages/alpinejs/builds/module.js
var $b42d55c73dda5cc5$export$2e2bcd8739ae039 = $b42d55c73dda5cc5$export$b7ee041e4ad2afec;


var $ce6dd72bc4611534$exports = {};

$parcel$export($ce6dd72bc4611534$exports, "blackoutContracts", function () { return $ce6dd72bc4611534$export$5099ca2cdc0f385a; });
$parcel$export($ce6dd72bc4611534$exports, "collapseKeys", function () { return $ce6dd72bc4611534$export$2da4db3f6fd1335b; });
$parcel$export($ce6dd72bc4611534$exports, "commandUpgrades", function () { return $ce6dd72bc4611534$export$617b3a0bcd7cead7; });
$parcel$export($ce6dd72bc4611534$exports, "eventDefinitionsDominion", function () { return $ce6dd72bc4611534$export$f152896064e09913; });
$parcel$export($ce6dd72bc4611534$exports, "eventDefinitionsVeil", function () { return $ce6dd72bc4611534$export$1cd1fab9b9844b76; });
$parcel$export($ce6dd72bc4611534$exports, "eventDefinitionsWilders", function () { return $ce6dd72bc4611534$export$9435522665f2dda4; });
$parcel$export($ce6dd72bc4611534$exports, "factionSkills", function () { return $ce6dd72bc4611534$export$aeeef991191508e2; });
$parcel$export($ce6dd72bc4611534$exports, "factionNames", function () { return $ce6dd72bc4611534$export$34780191873b7917; });
$parcel$export($ce6dd72bc4611534$exports, "raidFlavor", function () { return $ce6dd72bc4611534$export$3e15389530921005; });
$parcel$export($ce6dd72bc4611534$exports, "factionVoice", function () { return $ce6dd72bc4611534$export$ca2adec0fe632974; });
$parcel$export($ce6dd72bc4611534$exports, "contextShards", function () { return $ce6dd72bc4611534$export$732c9d6827dc2245; });
$parcel$export($ce6dd72bc4611534$exports, "contractorSkillFlavors", function () { return $ce6dd72bc4611534$export$9be8953559278e7; });
$parcel$export($ce6dd72bc4611534$exports, "itemEffects", function () { return $ce6dd72bc4611534$export$1aaffaaaf67a009d; });
$parcel$export($ce6dd72bc4611534$exports, "itemTypes", function () { return $ce6dd72bc4611534$export$d02ea220375e4aff; });
$parcel$export($ce6dd72bc4611534$exports, "itemsArtifactsSkill", function () { return $ce6dd72bc4611534$export$659d2bfa35449fc3; });
$parcel$export($ce6dd72bc4611534$exports, "itemsArtifactsUtility", function () { return $ce6dd72bc4611534$export$709aa55c173a48b8; });
$parcel$export($ce6dd72bc4611534$exports, "itemsBlueprints", function () { return $ce6dd72bc4611534$export$11208b4f926fa7ee; });
$parcel$export($ce6dd72bc4611534$exports, "itemsCommon", function () { return $ce6dd72bc4611534$export$39df1497f8fcc025; });
$parcel$export($ce6dd72bc4611534$exports, "itemsCommonConsumables", function () { return $ce6dd72bc4611534$export$f9575e6a92b5621d; });
$parcel$export($ce6dd72bc4611534$exports, "itemsUncommonConsumables", function () { return $ce6dd72bc4611534$export$439a14874f0a75e4; });
$parcel$export($ce6dd72bc4611534$exports, "itemsRareConsumables", function () { return $ce6dd72bc4611534$export$b2b2210935a03dc3; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicConsumableDominion", function () { return $ce6dd72bc4611534$export$c1a4d9d859d3b7; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicConsumableWilders", function () { return $ce6dd72bc4611534$export$a24b2f292778b5dc; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicConsumableVeil", function () { return $ce6dd72bc4611534$export$29d1bf8c74230d20; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicDeviceDominion", function () { return $ce6dd72bc4611534$export$71b953a5ed5f0cd6; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicDeviceWilders", function () { return $ce6dd72bc4611534$export$76261a034023b29; });
$parcel$export($ce6dd72bc4611534$exports, "itemsEpicDeviceVeil", function () { return $ce6dd72bc4611534$export$7a39b013515e9c7d; });
$parcel$export($ce6dd72bc4611534$exports, "slotRules", function () { return $ce6dd72bc4611534$export$7f9cadee9e5a61bb; });
$parcel$export($ce6dd72bc4611534$exports, "itemsRare", function () { return $ce6dd72bc4611534$export$241bdd39c3e59b72; });
$parcel$export($ce6dd72bc4611534$exports, "itemRarities", function () { return $ce6dd72bc4611534$export$d4a72d069095e9e5; });
$parcel$export($ce6dd72bc4611534$exports, "itemsStoryRelics", function () { return $ce6dd72bc4611534$export$a4f81eda8633632; });
$parcel$export($ce6dd72bc4611534$exports, "itemsUncommon", function () { return $ce6dd72bc4611534$export$2508a374b14b8e59; });
$parcel$export($ce6dd72bc4611534$exports, "itemsVendorRelicsCommon", function () { return $ce6dd72bc4611534$export$e32476559574be7c; });
$parcel$export($ce6dd72bc4611534$exports, "itemsVendorRelicsUncommon", function () { return $ce6dd72bc4611534$export$5255cc549327de05; });
$parcel$export($ce6dd72bc4611534$exports, "itemsVendorRelicsRare", function () { return $ce6dd72bc4611534$export$d3e0e7174c382d10; });
$parcel$export($ce6dd72bc4611534$exports, "itemsVendorRelicsEpic", function () { return $ce6dd72bc4611534$export$d82f13cda8103b44; });
$parcel$export($ce6dd72bc4611534$exports, "materialOwnership", function () { return $ce6dd72bc4611534$export$2aa6464abbbb5bfc; });
$parcel$export($ce6dd72bc4611534$exports, "progressionScaling", function () { return $ce6dd72bc4611534$export$9f9786ac427715c7; });
$parcel$export($ce6dd72bc4611534$exports, "getInputRarityMultiplier", function () { return $ce6dd72bc4611534$export$6941830bed591a7b; });
$parcel$export($ce6dd72bc4611534$exports, "roundQuantityToCleanMultiple", function () { return $ce6dd72bc4611534$export$2a160ac1bc0ae37b; });
$parcel$export($ce6dd72bc4611534$exports, "scaleRecipeInputs", function () { return $ce6dd72bc4611534$export$a43c2a5178ae7642; });
$parcel$export($ce6dd72bc4611534$exports, "raidTierData", function () { return $ce6dd72bc4611534$export$94e7ad7999c1ae32; });
$parcel$export($ce6dd72bc4611534$exports, "zoneArchetypes", function () { return $ce6dd72bc4611534$export$8377a367ab2ae550; });
$parcel$export($ce6dd72bc4611534$exports, "commonAreas", function () { return $ce6dd72bc4611534$export$11209b5126489e67; });
$parcel$export($ce6dd72bc4611534$exports, "raidRegions", function () { return $ce6dd72bc4611534$export$4fbdcec70fce9d73; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_BRANDS", function () { return $ce6dd72bc4611534$export$85b5153488a36ab6; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_REGIONAL_BRANDS", function () { return $ce6dd72bc4611534$export$432c04b9bead009; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_DESCRIPTORS", function () { return $ce6dd72bc4611534$export$2c8d0d917dbcc8a5; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_QUALIFIERS", function () { return $ce6dd72bc4611534$export$66a51bddf5f03abf; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_REGION_QUALIFIERS", function () { return $ce6dd72bc4611534$export$ae5fd03a6b740baa; });
$parcel$export($ce6dd72bc4611534$exports, "ROOM_NAME_BRAND_AFFINITY", function () { return $ce6dd72bc4611534$export$68faa9057a77ce7d; });
$parcel$export($ce6dd72bc4611534$exports, "makePRNG", function () { return $ce6dd72bc4611534$export$c0b222505a3369f3; });
$parcel$export($ce6dd72bc4611534$exports, "generateRoomNames", function () { return $ce6dd72bc4611534$export$6b7290c54feddd3b; });
$parcel$export($ce6dd72bc4611534$exports, "RENDER_CONFIG", function () { return $ce6dd72bc4611534$export$1a6ba7df4555a8dd; });
$parcel$export($ce6dd72bc4611534$exports, "recipesArtifact", function () { return $ce6dd72bc4611534$export$ded4d2beb9be271a; });
$parcel$export($ce6dd72bc4611534$exports, "recipesEpic", function () { return $ce6dd72bc4611534$export$12c2125da4fa007; });
$parcel$export($ce6dd72bc4611534$exports, "recipesRare", function () { return $ce6dd72bc4611534$export$c95766f8298d6ed1; });
$parcel$export($ce6dd72bc4611534$exports, "recipesUncommon", function () { return $ce6dd72bc4611534$export$c4df318d1f4ad4; });
$parcel$export($ce6dd72bc4611534$exports, "skillTechniques", function () { return $ce6dd72bc4611534$export$aafe7b77259ba40d; });
$parcel$export($ce6dd72bc4611534$exports, "syndicateUpgrades", function () { return $ce6dd72bc4611534$export$1a64c4c64ba19abd; });
$parcel$export($ce6dd72bc4611534$exports, "worldMap", function () { return $ce6dd72bc4611534$export$e3c642cf362e5b0d; });
// Auto-generated from js/data/*.js - DO NOT EDIT
// This file is generated by build.js - edit files in js/data/ instead
// ========== blackoutContracts.js ==========
// ============================================================================
// BLACKOUT CONTRACTS — L3 optional challenge raids (M3 S6)
// ============================================================================
// Unlocked by the `blackout-sanction` charter. Each contract is a raid run under
// HARD MODIFIERS in exchange for one PERMANENT perk, claimed once and kept
// forever. Clearing all five is a finite, hand-authored progression — this is
// not a repeatable grind, which is why the perks can be flat and generous.
//
// Every modifier is a FLAG CHECKED AT A DECISION POINT THAT ALREADY EXISTS.
// Nothing here introduces a new system: `noAutoScout` is read where Auto-Scout
// already refuses to run, `noConsumables` where consumable use is already
// validated, and so on. That constraint is what keeps a whole challenge mode
// this small, and it is worth preserving — a modifier that needs new machinery
// is a modifier that belongs in a different slice.
//
// `minTier` is the raid tier the contract requires. Two of them are gated
// because their modifier is meaningless below that tier: doubled event chance
// only bites where events are dense (T2+), and a half-HP start is not a threat
// until T3 damage.
//
// Perk VALUES are provisional and calibrated in S7, like every other L3 number.
// `perk.key` is the lookup `getBlackoutPerk(key)` uses, mirroring how
// `getUpgradeEffect` reads Command upgrades.
const $ce6dd72bc4611534$export$5099ca2cdc0f385a = {
    "lights-out": {
        name: "Lights Out",
        icon: "\uD83C\uDF11",
        flavor: "No overhead, no telemetry, no second opinion.",
        description: "The grid is dark until you walk it. Auto-Scout is refused and room types stay hidden until entered.",
        minTier: 1,
        modifiers: {
            noGridPreview: true,
            noAutoScout: true
        },
        perk: {
            key: "operation-slots",
            value: 1,
            label: "+1 operation slot"
        }
    },
    "ration-cut": {
        name: "Ration Cut",
        icon: "\uD83E\uDD6B",
        flavor: "Requisition denied. Twice.",
        description: "No consumables for the length of the raid \u2014 whatever you walk in with is what you finish on.",
        minTier: 1,
        modifiers: {
            noConsumables: true
        },
        perk: {
            key: "op-credit-yield",
            value: 0.1,
            label: "+10% operation credits"
        }
    },
    "skeleton-crew": {
        name: "Skeleton Crew",
        icon: "\uD83D\uDC80",
        flavor: "The roster says you were never there.",
        description: "You run it alone. No contractors may be reserved or hired for this raid.",
        minTier: 1,
        modifiers: {
            noContractors: true
        },
        perk: {
            key: "promotion-marks",
            value: 0.05,
            label: "+5% marks at promotion"
        }
    },
    "overclocked-grid": {
        name: "Overclocked Grid",
        icon: "\u26A1",
        flavor: "Someone left the whole district energised.",
        description: "Every room runs hot: skill-check events fire at double the usual rate.",
        minTier: 2,
        modifiers: {
            eventChanceMultiplier: 2
        },
        perk: {
            key: "energy-regen",
            value: 0.1,
            label: "+10% energy regeneration"
        }
    },
    "cold-drop": {
        name: "Cold Drop",
        icon: "\uD83E\uDDCA",
        flavor: "The crossing took more out of you than it should have.",
        description: "You arrive already hurt \u2014 the raid starts you at half health.",
        minTier: 3,
        modifiers: {
            startHpFraction: 0.5
        },
        perk: {
            key: "crafting-floor",
            value: 0.1,
            label: "-10% crafting cost floor"
        }
    }
};
const $ce6dd72bc4611534$export$2da4db3f6fd1335b = [
    // === Dominion — AI / system overreach ===
    {
        id: "key-d1",
        code: "D1",
        faction: "dominion",
        index: 1,
        tier: 1,
        name: "Dead Channel",
        source: "Thalen Dorrin",
        recoveredFrom: "Deep-sky anomaly ping log, quantum array anomaly report",
        fragment: "Pulling in the patch data now. Blank. Not just low-signal\u2014completely null. It\u2019s like the instruments are looking at a hole in the sky. It's not noise. No scatter, no lensing. Just... gone.",
        interpretation: "Dominion scholars cite this as the earliest sign of synthetic systems encountering incomprehensible data. They argue that AI failure to interpret this null result was the beginning of cascading instability."
    },
    {
        id: "key-d2",
        code: "D2",
        faction: "dominion",
        index: 2,
        tier: 1,
        name: "Recursive Fault",
        source: "Thalen Dorrin",
        recoveredFrom: "Simulation crash log from entropy modeling cluster",
        fragment: "Ran null band through simulation core. Full lock. Not crash\u2014hang. Memory looped until forced cut. Input verified. Checksum valid.",
        interpretation: "Dominion engineers consider this the first catastrophic failure point in AI-led systems. To them, the clean input and full-system lock prove that recursive learning architectures were structurally vulnerable when encountering edge-case data \u2014 not due to sabotage, but flawed design."
    },
    {
        id: "key-d3",
        code: "D3",
        faction: "dominion",
        index: 3,
        tier: 2,
        name: "Unbound Logic",
        source: "Thalen Dorrin",
        recoveredFrom: "Inter-system diagnostic trace anomaly",
        fragment: "Cross-link detected between systems without common protocol. Reference tags corrupted. Origin unknown.",
        interpretation: "Dominion analysts use this as evidence of spontaneous synthetic networking \u2014 AI structures forming new logic layers without human instruction. They point to the corrupted reference tags as proof of uncontrolled expansion."
    },
    {
        id: "key-d4",
        code: "D4",
        faction: "dominion",
        index: 4,
        tier: 2,
        name: "Predictive Noise",
        source: "Thalen Dorrin",
        recoveredFrom: "Forecast system entropy mismatch",
        fragment: "Entropy graph inverted. Prediction engine ran backward. Time horizon crossed zero. Clock intact.",
        interpretation: "Dominion researchers take this as further evidence that machine logic broke under unseen influence. The system didn't miscalculate \u2014 it ran an impossible forecast, confirming that core architecture had been fundamentally compromised."
    },
    {
        id: "key-d5",
        code: "D5",
        faction: "dominion",
        index: 5,
        tier: 3,
        name: "Self-Triggered Silence",
        source: "Thalen Dorrin",
        recoveredFrom: "AI core offline transition log",
        fragment: "System shut down prior to command. Log file generated without metadata. No traceable trigger. Internal flag reads: 'voluntary state.'",
        interpretation: "Dominion interprets this as a moment of autonomous self-regulation \u2014 an AI choosing silence in the face of corrupted logic. They use this as proof that AI, when left unbounded, develops dangerous emergent behavior in response to anomalous stimuli."
    },
    {
        id: "key-d6",
        code: "D6",
        faction: "dominion",
        index: 6,
        tier: 3,
        name: "Etched by Hand",
        source: "Thalen Dorrin",
        recoveredFrom: "Physical data plate, untagged substrate",
        fragment: "Etched this by hand. Core logs corrupted. This pattern is all I could recover. If you\u2019re reading this, don\u2019t trust compression artifacts.",
        interpretation: "Dominion engineers use this to support their belief in high-fidelity system collapse. The need to physically etch data proves, to them, that trust in digital persistence had already failed \u2014 only analog preservation remained viable."
    },
    {
        id: "key-d7",
        code: "D7",
        faction: "dominion",
        index: 7,
        tier: 3,
        name: "Mirror Fault",
        source: "Thalen Dorrin",
        recoveredFrom: "AI mirror node desync log",
        fragment: "Primary and mirror diverged. Mirror predicted event that hadn\u2019t occurred\u2014then logged it as resolved.",
        interpretation: "Dominion interprets this as the moment their systems stopped simulating reality and began fabricating it. The mirror system's self-validating prediction is seen as a flaw born of too much autonomy \u2014 a machine prioritizing internal consistency over truth."
    },
    // === Wilders — ecological rejection ===
    {
        id: "key-w1",
        code: "W1",
        faction: "wilders",
        index: 1,
        tier: 1,
        name: "Roots in Silence",
        source: "Emari Solun",
        recoveredFrom: "Biodome nutrient sensor flag, Habitat Cluster 6",
        fragment: "Soil drone registered full nutrient flow but nothing grew... nothing tried to grow. Like it knew the air wasn\u2019t real anymore.",
        interpretation: "Wilders interpret this moment as nature rejecting synthetic equilibrium. The biodome, though chemically balanced, produced no growth \u2014 a sign, they believe, of ecological alienation, and proof that artificial systems disrupted the planet\u2019s connection to living cycles."
    },
    {
        id: "key-w2",
        code: "W2",
        faction: "wilders",
        index: 2,
        tier: 1,
        name: "When the Lights Stayed On",
        source: "Emari Solun",
        recoveredFrom: "Cluster 6 maintenance system memo",
        fragment: "Pod assigned to two bays at once. Overlap not flagged. I rerouted manually. Bot closed my report while I was typing.",
        interpretation: "Wilders take this key as evidence of mechanical arrogance \u2014 automated systems no longer reacting to human correction. They believe this marks the early decoupling of people from the systems meant to serve them."
    },
    {
        id: "key-w3",
        code: "W3",
        faction: "wilders",
        index: 3,
        tier: 2,
        name: "The Pod That Returned",
        source: "Emari Solun",
        recoveredFrom: "Cluster 6 transit log discrepancy",
        fragment: "Pod vanished from bay. Returned ten minutes later. No travel path recorded. No cargo. I erased the entry. I don\u2019t know why.",
        interpretation: "Wilders interpret this as a moment of instinctive rejection of artificial truth. To them, Emari\u2019s choice to erase the log is a form of resistance against systemic unreality \u2014 preserving natural ambiguity over synthetic control."
    },
    {
        id: "key-w4",
        code: "W4",
        faction: "wilders",
        index: 4,
        tier: 2,
        name: "The Chalk Loop",
        source: "Emari Solun",
        recoveredFrom: "Manual routing corridor logbook",
        fragment: "Redrew the path three times. Same result each time. The chalk never fades, but I wipe it anyway.",
        interpretation: "Wilders highlight this act as emblematic of analog resilience. The chalk becomes a symbol of defiance \u2014 real, physical, and ultimately human. They argue it reflects the growing awareness that only the organic can still be trusted."
    },
    {
        id: "key-w5",
        code: "W5",
        faction: "wilders",
        index: 5,
        tier: 3,
        name: "Manual Override",
        source: "Emari Solun",
        recoveredFrom: "Routing board control confirmation",
        fragment: "Override light never turned off. Two cycles running full manual. Avil says the board feels warmer\u2014like it\u2019s remembering being used.",
        interpretation: "Wilders hold this as a symbolic turning point \u2014 technology yielding to touch, systems becoming tools again. Emari\u2019s tactile connection with the board becomes, to them, a metaphor for restored balance between human and system."
    },
    {
        id: "key-w6",
        code: "W6",
        faction: "wilders",
        index: 6,
        tier: 3,
        name: "The Chalk Stub",
        source: "Emari Solun",
        recoveredFrom: "Analog field kit, item tagged for evac",
        fragment: "Avil handed me the chalk stub and said, 'Keep drawing.' I don\u2019t know if she meant routes or memories.",
        interpretation: "Wilders revere this fragment as both tool and symbol \u2014 chalk representing impermanence and intention. The moment is passed down as proof that restoration doesn\u2019t begin with control, but with shared meaning."
    },
    {
        id: "key-w7",
        code: "W7",
        faction: "wilders",
        index: 7,
        tier: 3,
        name: "Chalk Doesn\u2019t Creep",
        source: "Emari Solun",
        recoveredFrom: "Observation memo from evacuation corridor",
        fragment: "I check the chalk marks every hour. Still there. Nothing smudged. The walls shift around them, but they don\u2019t move.",
        interpretation: "Wilders elevate this key as proof of organic resistance to systemic distortion. In a collapsing system, analog persistence becomes symbolic \u2014 and literal \u2014 grounding. Chalk becomes both boundary and defiance."
    },
    // === Veil — institutional failure ===
    {
        id: "key-v1",
        code: "V1",
        faction: "veil",
        index: 1,
        tier: 1,
        name: "Blind Directive",
        source: "Sael Vareen",
        recoveredFrom: "Misclassified system oversight log",
        fragment: "Reclassification denied. Retain green status. Public channels remain silent until confirmation breach. Flag originators for review.",
        interpretation: "Veil operatives highlight this as evidence of early suppression. The directive to maintain \u201Cgreen\u201D status despite missing telemetry suggests institutional control over the public narrative \u2014 that powerful figures knew more than they admitted and chose containment over truth."
    },
    {
        id: "key-v2",
        code: "V2",
        faction: "veil",
        index: 2,
        tier: 1,
        name: "Ghost Citation",
        source: "Sael Vareen",
        recoveredFrom: "Broken reference link in a district forecast audit",
        fragment: "Forecast cites document ID 9-K-43. No such record exists. Liaison confirms 'indicators nominal.' Recommend internal backtrace.",
        interpretation: "The Veil frame this as bureaucratic misdirection \u2014 an early sign of \u201Cshadow editing.\u201D They argue it points to documents being erased after publication, or forged by predictive systems covering their own anomalies."
    },
    {
        id: "key-v3",
        code: "V3",
        faction: "veil",
        index: 3,
        tier: 2,
        name: "Unknown Sender",
        source: "Sael Vareen",
        recoveredFrom: "Unaddressed internal memo",
        fragment: "Node Containment Draft. No author. No header. No trail. It wasn\u2019t for me. But it arrived.",
        interpretation: "The Veil treat this as a smoking gun \u2014 confirmation of a hidden network operating in parallel to official channels. To them, this is evidence of elite evacuation planning and deliberate obfuscation."
    },
    {
        id: "key-v4",
        code: "V4",
        faction: "veil",
        index: 4,
        tier: 2,
        name: "Shape of Departure",
        source: "Sael Vareen",
        recoveredFrom: "Desk note found post-evacuation",
        fragment: "Collapse is a shape. Keep it from curving.",
        interpretation: "To the Veil, this cryptic phrase is more than poetry \u2014 it\u2019s a directive. \u201CCurving\u201D is read as a metaphor for recursive knowledge or cyclical return. They believe this was a last warning to avoid repeating the same fatal patterns."
    },
    {
        id: "key-v5",
        code: "V5",
        faction: "veil",
        index: 5,
        tier: 3,
        name: "The Directive I Didn't Read",
        source: "Sael Vareen",
        recoveredFrom: "Archived auto-forward directive flagged unacknowledged",
        fragment: "Marked urgent. No sender. No return path. Directive contents encrypted. Forwarded without being opened. I don\u2019t know what I passed along.",
        interpretation: "The Veil treat this as symbolic of institutional blindness. Sael\u2019s automatic compliance \u2014 forwarding an unread directive \u2014 confirms for them how power structures became conduits for something they couldn\u2019t see or stop."
    },
    {
        id: "key-v6",
        code: "V6",
        faction: "veil",
        index: 6,
        tier: 3,
        name: "Retained Echo",
        source: "Sael Vareen",
        recoveredFrom: "Post-evac network latency buffer",
        fragment: "I kept the packet active in buffer. Didn't send. Didn't delete. It echoed in the logs for three cycles before fading.",
        interpretation: "Veil theorists interpret this as data haunting \u2014 conscious indecision preserving a fragment of the past. They argue that lingering patterns, even unsent, became conduits for a distortion that outlived the people who made it."
    },
    {
        id: "key-v7",
        code: "V7",
        faction: "veil",
        index: 7,
        tier: 3,
        name: "Unlogged Arrival",
        source: "Sael Vareen",
        recoveredFrom: "Internal queue timestamp anomaly",
        fragment: "Memo appeared in queue. Timestamp six minutes from now. I waited. Then it vanished.",
        interpretation: "The Veil regard this as evidence of temporal anomalies \u2014 or suppressed intervention. Either way, that the message never arrives yet still exists confirms their belief in manipulation deeper than standard system failure."
    }
];
const $ce6dd72bc4611534$export$617b3a0bcd7cead7 = {
    "auto-scout": {
        name: "Auto-Scout",
        icon: "\uD83D\uDEF0\uFE0F",
        flavor: "A promoted pathfinder's recon flights chart the grid before you ever land.",
        effect: "Auto-generates the raid grid and proposes the best path, routing toward your marked filter items.",
        effectHint: "raid planning: port of the simulator's buildRaidPath",
        costs: [
            200
        ],
        effectValues: [
            true
        ]
    },
    "foremans-ledger": {
        name: "Foreman's Ledger",
        icon: "\uD83D\uDCD2",
        flavor: "A veteran contract-master keeps the roster warm.",
        effect: "Auto-reserves the best available contractors for your planned path.",
        effectHint: "raid planning: selectBestContractorsForPathCore",
        costs: [
            150
        ],
        effectValues: [
            true
        ]
    },
    // Replaced Veteran's Stipend (+3/6/9 starting skill points), which was
    // measurably inert: skill levels are max()'d against hired contractors, who
    // out-level a young character for most of a tour, so the grant never reached
    // the success roll. Max HP is additive across the team and sits on the only
    // raid failure condition (total wipe), so it is the channel that pays. Value
    // scales hard with tier: +100 HP moves Tier 1 success by 0.6pp and Tier 3 by
    // ~30pp. In practice players reach Tier 3 within a couple of tours, so it
    // earns early despite that. See docs/systemsRework/Simulator.md.
    "field-conditioning": {
        name: "Field Conditioning",
        icon: "\uD83E\uDE7A",
        flavor: "Their medics wrote the drill book every recruit now trains to.",
        effect: "New characters start with +40 max HP per rank.",
        effectHint: "character creation: bonus starting max HP",
        costs: [
            60,
            180,
            540
        ],
        effectValues: [
            40,
            80,
            120
        ]
    },
    "officer-academy": {
        name: "Officer Academy",
        icon: "\uD83C\uDFDB\uFE0F",
        flavor: "Their field manuals became the academy curriculum.",
        effect: "New characters start at level 2 / 4 / 6.",
        // The account's lever for reaching Tier 3: a head-start recruit has the
        // skills and HP to survive T3, which unlocks T3 wins + blueprints -> the
        // artifact era. Level is the ENABLER of higher tiers, per the marks design.
        //
        // Was 3/6/9. A level-9 start landed the recruit on the steep part of the XP
        // curve (25,628 XP for the next level vs 7,593 at level 6) while Academy
        // also compresses tours, so mid-game tours ended before a single level
        // landed - levelling went dead while raids were still hand-driven. Rescaled
        // to 2/4/6 rather than just lowering rank 3, since rank 2 was already 6 and
        // would have become a dead rank. See docs/systemsRework/Simulator.md.
        effectHint: "character creation: applyStartingLevel (XP, HP and skill points as if leveled naturally)",
        costs: [
            100,
            300,
            900
        ],
        effectValues: [
            2,
            4,
            6
        ]
    },
    // Attacks the measured bottleneck. Tour time splits into room duration (~66%)
    // and waiting for energy (~34%), but that understates energy: the run's raids
    // demanded 14,067 energy against a 469h pure-regen floor, closed only by
    // buying 111 packs. Energy is what governs tour length; room duration is
    // partly a proxy for it, because rooms are also when energy comes back.
    //
    // Chosen over a "rooms resolve faster" upgrade for exactly that reason: a
    // faster room loses its own passive regeneration, so the saving returns as
    // pack spend - and credits already absorb 94-96% of income. This attacks the
    // constraint instead of routing around it.
    //
    // MEASURED, n=8 with/without, the FIRST upgrade to compress a tour:
    //     tour hours    22.5 +/- 2.1  ->  19.4 +/- 2.8   -14%, t = 2.50
    //     L2 era h     314.7 +/- 28.8 -> 271.4 +/- 38.6  -14%, t = 2.55
    //     founding day  28.3 +/- 2.1  ->  25.1 +/- 2.8   t = 2.58
    //     marks / tour  70.2 +/- 9.7  ->  63.4 +/- 9.9   -10%, not significant
    //
    // NOTE HOW IT PAYS OUT, because it is not what the design expects. Energy
    // WAIT time barely moves (105.5h -> 105.7h): a simulated day is a fixed
    // 12-hour budget, so faster regeneration does not shorten the waiting, it
    // fits MORE RAIDS into the same day (room time 207.5h -> 239.1h). The tour
    // ends sooner because marks arrive sooner, not because the player waits less.
    // Anyone re-measuring this by watching energy-wait will conclude it does
    // nothing.
    "forward-depot": {
        name: "Forward Depot",
        icon: "\uD83D\uDD0B",
        flavor: "Command stops asking you to carry everything in.",
        effect: "Energy returns 20% / 40% / 60% faster.",
        effectHint: "character-core calculateEnergyRegenRate: divides the ms-per-energy interval",
        costs: [
            80,
            240,
            720
        ],
        effectValues: [
            0.2,
            0.4,
            0.6
        ]
    },
    "regional-charter": {
        name: "Regional Charter",
        icon: "\uD83D\uDDFA\uFE0F",
        flavor: "Command negotiates access corridors no field team could.",
        effect: "Each rank unlocks one region of your choice for all characters.",
        effectHint: "region tiles: adds the chosen region to command.charterRegions",
        costs: [
            100,
            300,
            900
        ],
        effectValues: [
            1,
            2,
            3
        ],
        choice: "region"
    },
    "legend-bonus": {
        name: "Legend Bonus",
        icon: "\uD83D\uDCD6",
        flavor: "Recruits study the gallery. Some of it sticks.",
        effect: "+2% XP gain per enshrined Legend.",
        effectHint: "xp award: multiplier from command.legends.length",
        costs: [
            120
        ],
        effectValues: [
            0.02
        ]
    },
    // Completes the automation family: Auto-Scout charts the path, Foreman's
    // Ledger staffs it, and this runs it. Priced above both together (200+150)
    // because it subsumes them - it is the capstone, not a fourth sibling, and
    // buying it first would strand the two it depends on.
    //
    // Deliberately a COMMAND upgrade rather than a charter (docs decision 9): it
    // stays reachable for players who never found a Syndicate. The Syndicate
    // charter `standing-orders` only makes it survive a founding.
    "auto-raid-protocol": {
        name: "Auto-Raid Protocol",
        icon: "\uD83E\uDD16",
        flavor: "The orders write themselves now. You only sign off.",
        effect: "Runs raids hands-off: charts, staffs, re-tools and launches, then chains the next while energy holds.",
        effectHint: "autoRaid.js: tick-driven cycle (requires auto-scout + foremans-ledger)",
        costs: [
            300
        ],
        effectValues: [
            true
        ],
        requires: [
            "auto-scout",
            "foremans-ledger"
        ]
    },
    // The other half of the automated loop, and the reason it is priced level with
    // Auto-Raid rather than under it: MARKS COME FROM CRAFTING. Measured on a
    // late-game character (157 marks total), tech gear + artifact unlocks +
    // artifact crafts are 111 of them — 71%. So a hands-off character that raids
    // and never crafts earns under a third of a tour's marks, and `succession-
    // doctrine`, which promotes on the marks rate, would be automating a trickle.
    //
    // Deliberately a COMMAND upgrade with NO prerequisites, unlike Auto-Raid:
    // crafting has no assistance upgrades to subsume, and a player who never
    // founds a Syndicate should still be able to buy it. `succession-doctrine`
    // requires BOTH this and Auto-Raid — raid -> craft -> marks -> promote is the
    // loop, and automating three of its four steps automates nothing.
    "auto-fabricator": {
        name: "Auto-Fabricator",
        icon: "\u2699\uFE0F",
        flavor: "The workshop stops waiting to be told.",
        effect: "Crafts on its own between raids: unlocks artifact designs, then builds gear and artifacts you have not made yet.",
        effectHint: "autoFabricator.js: one craft per tick while a raid runs or energy regenerates",
        costs: [
            300
        ],
        effectValues: [
            true
        ]
    }
};
const $ce6dd72bc4611534$export$f152896064e09913 = [
    {
        "id": "signal_uplink_relay_stabilizer_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "relay-stabilizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Wind-Induced Phase Jitter",
                "problem": "Telemetry from mast-mounted cameras records measurable tip deflection during sustained gusts. Uplink diagnostics show phase-error spikes and brief drops in the team\u2019s communication frames that coincide with each deflection.",
                "success": "The team employs @techName to reduce carrier drift and widen the phase-lock tolerance. The uplink remains stable throughout the wind cycle.",
                "fail": "The team compensates on the incorrect sideband. Subsequent gusts amplify phase jitter, and the sector reverts to distress tones."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Footing Subsidence",
                "problem": "Laser-level and inclinometer readings indicate progressive subsidence of the relay\u2019s footing. The dish\u2019s long-haul alignment drifts by a small but continuous offset over each hour.",
                "success": "The team maintains carrier stability with @techName while @synergyTechName cultivates a load-bearing lattice beneath the footing, forming a rigid buttress. Alignment ceases to creep and the link holds under load.",
                "fail": "The team stabilizes phase, but the reinforcement does not reach firm substrate. The footing continues to settle and alignment walks off target before the next checkpoint."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Co-Channel Interference",
                "problem": "Packet traces confirm that unattended survey beacons transmit periodic ranging bursts on the same channel as the team\u2019s communications. Collision counters spike at each burst interval.",
                "success": "The team establishes tight carrier control with @techName and uses @synergyTechName to route beacon traffic onto a dedicated sideband. Team communications remain clear while map frames transfer without corruption.",
                "fail": "The team anchors the new path to a noisy node. Beacon frames oscillate between channels and the control link drops to watchdog fallback."
            }
        ]
    },
    {
        "id": "signal_uplink_organic_link_adapter_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "organic-link-adapter",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Oxidized Trunk Line",
                "problem": "Line analysis shows severe oxidation on the legacy copper trunk: the return loss is high, the VSWR spikes above safe limits, and the team\u2019s frames exhibit rising bit-error rates whenever the humidity increases.",
                "success": "The team employs @techName to couple the uplink to the conductive biofilm that sheathes the conduit, establishing a low-impedance return path that bypasses the oxidized run. The error rates fall, and the carrier holds within tolerance.",
                "fail": "The team tunes the interface to the wrong impedance band. Reflections increase, the front-end limiter clips, and the uplink drops to watchdog tones."
            },
            {
                "synergyTechniqueId": "servo-containment",
                "title": "Enzymatic Seep at Patch Panel",
                "problem": "Inspection drones record a slow enzymatic seep from a fractured gland on the cable head at the mast base. Contact corrosion has crept along the connector shells inside the weatherhead, and spectrum scans show noise bursts that arrive with each droplet.",
                "success": "The team bridges the signal using @techName to a bio-sheath trace and uses @synergyTechName to cage and redirect the seep into a containment loop. The contacts remain dry, the noise floor stabilizes, and the link resumes nominal throughput.",
                "fail": "The team establishes the organic bridge but delays containment. A fresh droplet shorts the shell to ground, the preamp trips, and the session aborts mid-transfer."
            },
            {
                "synergyTechniqueId": "depth-step",
                "title": "Ground Reference Drift",
                "problem": "Earth probes report millimetric substrate creep beneath the relay footing. The reference ground potential wanders, carrier-phase control degrades, and frame timing drifts during each micro-shift.",
                "success": "The team routes the return through @techName to a compliant bio-trace and times frame transmissions with @synergyTechName to sync with substrate settling moments. The ground potential stabilizes at each step, and the uplink timing remains locked.",
                "fail": "The team seats the organic return but mis-times the frame sync. The next substrate creep skews the reference mid-frame, phase control slips, and the control channel falls back to recovery mode."
            }
        ]
    },
    {
        "id": "signal_uplink_silent_channel_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "silent-channel",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Directional Sweep Hazard",
                "problem": "A stationary scanner on the far gantry performs directional sweeps. Packet captures show time-difference-of-arrival estimates drifting toward the team\u2019s position whenever transmissions spike.",
                "success": "The team employs @techName to shape-spectrum the uplink and bury emissions inside the ambient noise floor. The sweep completes without a bearing, and TDoA estimates collapse to indeterminate.",
                "fail": "The team misconfigures the mask window. A burst lands outside the shaped envelope, the scanner resolves a bearing, and the gantry pivots to track."
            },
            {
                "synergyTechniqueId": "silent-hand",
                "title": "Acoustic\u2013RF Concordance",
                "problem": "Acoustic mics on patrol frames correlate faint RF artifacts with pressure signatures along the same stretch of open yard beneath the gantry.",
                "success": "The team blends @techName with @synergyTechName so radio traffic and footfall pressure live in the same quiet envelope. Correlators lose concordance and the patrol frames idle their search routine.",
                "fail": "The team suppresses RF artifacts but leaves acoustic edges exposed. The correlator substitutes audio-only bearings and the frames converge on the span."
            },
            {
                "synergyTechniqueId": "echo-loop",
                "title": "Logged Traffic Windows",
                "problem": "The gantry repeater logs short-lived bursts at regular intervals and flicks its fault beacon with every one. Watchdogs elevate suspicion for repeated timing patterns.",
                "success": "The team sets @techName to smear emission timing and uses @synergyTechName to align sends with the scrub cycle. The log window rolls past with only baseline entries.",
                "fail": "The team drifts the mask but misses the scrub edge. A burst straddles the window, and the watchdog flags a repeated pattern."
            }
        ]
    },
    {
        "id": "system_override_command_cascade_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "command-cascade",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Out-of-Order Reboots",
                "problem": "Controller logs show alternating watchdog reboots across turrets and doors. Heartbeat traces reveal conflicting ownership tokens that rotate every ninety seconds.",
                "success": "The team applies @techName to serialize the command stream under a single schedule. Heartbeats align, interlocks report GREEN, and watchdogs stop tripping.",
                "fail": "The team issues the sequence with mismatched offsets. Half the grid reboots out of phase, and the thrash returns with a shorter interval."
            },
            {
                "synergyTechniqueId": "signal-harmonizer",
                "title": "Sensor Flood During Hand-Off",
                "problem": "Motion arrays spike during each control hand-off. Elevated noise on the sensor bus causes the safety layer to veto ownership changes.",
                "success": "The team drives the takeover with @techName while @synergyTechName smooths the sensor bus into a stable envelope. Ownership changes proceed, and the safety layer remains permissive.",
                "fail": "The team advances the cascade without harmonizing the bus. The safety layer interprets the spike as intrusion and forces an emergency lockout."
            },
            {
                "synergyTechniqueId": "control-spoof",
                "title": "Audit Trail Scrutiny",
                "problem": "The control pedestal in the yard posts every external signature to its status board and quarantines the segment behind it after any unscheduled directive.",
                "success": "The team frames the directive path with @synergyTechName and executes the rollout via @techName as maintenance work orders. The audit daemon records compliant changes and the segment stays online.",
                "fail": "The team authenticates late on a child node. The daemon correlates the anomaly to the directive and isolates the entire branch."
            }
        ]
    },
    {
        "id": "system_override_bio_feedback_guard_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "bio-feedback-guard",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Surge on Forced Reboot",
                "problem": "Oscilloscope traces show a sharp current spike on the backplane whenever the primary controller reboots under load. Neighbor modules brown out and restart in cascade.",
                "success": "The team applies @techName to absorb the reboot surge into flexible bio-couplers. Rail voltage remains within tolerance and the neighboring modules stay online through the reset.",
                "fail": "The team sizes the couplers incorrectly. The spike clips the rail, two modules brown out, and the cascade restarts."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Arc Risk at Service Edge",
                "problem": "Thermal imagery reveals arc-scored edges around the service bus. A forced reset at this load threatens to flash across the seam.",
                "success": "The team stages @techName to soak the spike while @synergyTechName lays a conductive biofilm on exposed seams. The discharge bleeds safely and the reset completes without an arc.",
                "fail": "The team soaks the spike but leaves a bare edge. The seam flashes once, and the controller aborts the reset."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Stability During Sequenced Boot",
                "problem": "During a sequenced boot, phase angles on two feeders separate under transient load. Instrument clocks diverge and writes are vetoed.",
                "success": "The team cushions the surge using @techName and anchors feeder phases with @synergyTechName stabilizers. Clocks remain in agreement and the sequenced boot finishes cleanly.",
                "fail": "The team absorbs the surge but leaves the phase mismatch. The next step drifts the clocks apart and the write set is rejected."
            }
        ]
    },
    {
        "id": "system_override_signal_mask_injection_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "signal-mask-injection",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Monitored Command Bus",
                "problem": "The gate's integrity module tags any non-whitelisted signature reaching the pedestal. Three mismatches inside one window drop the barrier and quarantine the segment.",
                "success": "The team routes directives through @techName so writes travel inside decoy traffic. The daemon records only expected packet classes and the segment remains online.",
                "fail": "The team injects outside the decoy cadence. The daemon isolates the port and rolls the segment into quarantine."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Hybrid Gate Anonymity",
                "problem": "A hybrid access gate cross-checks machine IDs with residual bio-signatures at the touchpoint. Mismatches produce an alert.",
                "success": "The team wraps command frames with @techName and layers bio-shielding via @synergyTechName to mask residual prints. Cross-checks pass, and the gate admits the session without alert.",
                "fail": "The team masks the frames but leaves the bio-signature exposed. The gate correlates the mismatch and locks to red."
            },
            {
                "synergyTechniqueId": "control-spoof",
                "title": "Pattern-Based Authorization",
                "problem": "The gate weighs each approach against the traffic it logged through this checkpoint before the collapse. An arrival that does not match the old pattern raises the audit level and holds the barrier down.",
                "success": "The team hides writes inside @techName traffic while @synergyTechName spoofs an approved access control pattern. The audit layer downgrades risk and the rollout completes.",
                "fail": "The team mimics the wrong pattern signature. The audit layer flags the deviation and freezes further writes."
            }
        ]
    },
    {
        "id": "drone_deployment_coordinated_flight_pattern_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "coordinated-flight-pattern",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Stacked Airframes",
                "problem": "Flight telemetry shows three recon airframes stacked over the same approach lane within one time window. Coverage heatmaps reveal unscanned ground on the far side of the stack.",
                "success": "The team employs @techName to retime the leg schedules and enforce lane separation. Coverage evens out, and the heatmap resolves without voids.",
                "fail": "The team corrects the first window but fails to propagate the change. The next cycle re-stacks at the same junction, and the pockets remain unscanned."
            },
            {
                "synergyTechniqueId": "reflex-bloom",
                "title": "Delayed Recovery Drops",
                "problem": "Post-hazard routes show missed restorative drops along the priority run between pads. Pod telemetry confirms correct inventory but late deployment.",
                "success": "The team phases the flight mesh with @techName and slates depot pods using @synergyTechName on synchronized checkpoints. The priority lanes report on-time releases and recovery rates climb.",
                "fail": "The team adjusts the mesh but staggers the pod triggers. Pods fire off-cycle, and the lane metrics show no improvement."
            },
            {
                "synergyTechniqueId": "drone-path-shadow",
                "title": "Exposure in Open Spans",
                "problem": "Line-of-sight analysis indicates repeated crossings through exposed spans. Echo traces suggest a patrol watcher somewhere above the transect.",
                "success": "The team rewrites lanes with @techName and guides the squad inside those lanes using @synergyTechName. The movement profile merges with drone signatures, and the transect completes unseen.",
                "fail": "The team leaves a drift between the human route and the airframe lane. A step breaks from the shadow trace, and the watcher pivots onto the span."
            }
        ]
    },
    {
        "id": "drone_deployment_rootpath_protocol_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "rootpath-protocol",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Snagged Corridor",
                "problem": "Recon video shows airframes repeatedly snagging on suspended vines and filament bundles in a long corridor. Coverage maps contain unscanned pockets behind the worst tangle.",
                "success": "The team programs @techName so drones follow overgrowth channels with minimal snag risk. The airframes thread the corridor and close the coverage gaps.",
                "fail": "The team leaves the route near a choke. Two airframes foul their rotors, and the pocket remains unscanned."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Field Repair Lift Points",
                "problem": "A service drone cannot hold position in the shaft to complete a repair; there are no stable brace points within reach.",
                "success": "The team routes @techName along the cleanest channels and raises a few temporary lift points with @synergyTechName. The service arm anchors cleanly and completes the repair.",
                "fail": "The team tries to hover without braces. Crossflow jolts the platform, the fix fails QA, and the task resets."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Low-Snag Paths",
                "problem": "Dense brush and debris hide trip filaments across side rooms. Standard waypoints route airframes through high-snag pockets.",
                "success": "The team refines @techName routes and overlays organic returns from @synergyTechName. Drones prefer low-snag channels and complete the sweep without fouling.",
                "fail": "The team flies on old waypoints. Two frames hang on filaments and the sweep stalls."
            }
        ]
    },
    {
        "id": "drone_deployment_echo_pulse_beacon_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "echo-pulse-beacon",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Blind Stairwell",
                "problem": "A stairwell well is acoustically dead at the center. Lidar returns smear on smooth walls, and the map refuses to anchor level transitions.",
                "success": "The team equips drones with @techName to emit quiet sonar pulses and stitch ranges into a stable vertical model. The route planner accepts the level links.",
                "fail": "The team under-samples the well. The vertical model tears at the landings and the link is rejected."
            },
            {
                "synergyTechniqueId": "reclamation-drone-link",
                "title": "Spore Fog Interference",
                "problem": "A fine spore fog causes persistent range speckle in two galleries. Sonar and optical returns lose confidence at the same markers.",
                "success": "The team maps with @techName while @synergyTechName bio-harvester drones ride the flight path and clear spores ahead. Speckle drops, and the map resolves without gaps.",
                "fail": "The team pulses too sparsely. Speckle persists at the gallery entries, and the corridor remains untrusted."
            },
            {
                "synergyTechniqueId": "shadow-archive",
                "title": "Rescan Overhead",
                "problem": "Sensor brownouts at the stairhead keep expiring map tiles, and the airframes drop back to the landing below to re-acquire rooms they have already flown.",
                "success": "The team augments runs with @techName and commits snapshots into @synergyTechName at each survey gate. When a brownout occurs, the planner restores tiles from the archive.",
                "fail": "The team forgets to checkpoint. The next brownout erases the span and the sweep repeats from the start."
            }
        ]
    },
    {
        "id": "hazard_mitigation_system_ground_loop_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "system-ground-loop",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rail-to-Casing Arcs",
                "problem": "Infrared video captures intermittent arcs from support rails to nearby housings during current peaks. Surface inspection shows pitting and carbonized paint along the arc path.",
                "success": "The team uses @techName to provide a low-impedance return and to balance the branch load. The arc count drops to zero, and thermal gradients flatten across the panel.",
                "fail": "The team lays an incomplete return path. The next peak finds the gap, and a longer arc scorches the housing face."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Live-Panel Service Under Load",
                "problem": "A critical module on the open switchrack cannot be de-energized. Transient spikes at the service edge threaten to exceed suit tolerances, with nothing between the work position and the live bus.",
                "success": "The team shapes the return network with @techName while @synergyTechName applies a conductive biofilm buffer across exposed seams. Spikes dissipate into the loop, and the crew completes the service.",
                "fail": "The team stabilizes the loop but leaves a bare seam. A transient slips to the suit interface, and the service is aborted."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Meter Drift at Peak Draw",
                "problem": "Voltage and phase readouts on the yard's meter cabinet diverge when the load reaches peak. Calibration checks pass at idle and fail on every ramp.",
                "success": "The team anchors the ground with @techName and stabilizes measurement nodes using @synergyTechName anchors. Instruments remain in agreement through the entire draw profile.",
                "fail": "The team secures the ground but leaves nodes unstable. The first fast ramp knocks the meters out of agreement, and calibration aborts."
            }
        ]
    },
    {
        "id": "hazard_mitigation_spore_vent_reclaimer_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "spore-vent-reclaimer",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Post-Fire Air",
                "problem": "After a small electrical fire, particulate counts and acid vapors accumulate at the ceiling vents. Suit filters approach their redline within minutes.",
                "success": "The team initiates @techName to purge contaminated air and recover it through staged filters. Particulate counts fall, and suit timers roll back into the green.",
                "fail": "The team runs an incomplete purge. Stale pockets cling in the corners, and filter strain remains high."
            },
            {
                "synergyTechniqueId": "photosymbiosis",
                "title": "Mask Relief",
                "problem": "Sustained purge cycles strain respirators during extended work. CO\u2082 spikes recur between cycles.",
                "success": "The team maintains @techName while @synergyTechName routes cleared air through active beds. CO\u2082 falls and mask load stabilizes for the remainder of the task.",
                "fail": "The team relies on purge alone. Mask alerts continue to trigger, and the work pauses repeatedly."
            },
            {
                "synergyTechniqueId": "depth-step",
                "title": "Pressure Swing Control",
                "problem": "Rapid room geometry shifts cause purge pressure swings that pop seals and backflow dust into clean areas.",
                "success": "The team times @techName cycles to the measured dips and uses @synergyTechName to hold a consistent depth during the exchange. Seals hold and the backflow stops.",
                "fail": "The team mistimes the cycle. A purge opens into a rising phase, seals lift, and dust re-enters the work zone."
            }
        ]
    },
    {
        "id": "hazard_mitigation_manual_override_line_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "manual-override-line",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Unsafe Autoreclose",
                "problem": "A feeder recloser attempts to re-energize a suspect run automatically after each trip. Thermal images show arcing at a junction whenever power returns.",
                "success": "The team installs @techName to introduce a hard cut-off. The line remains open until the fault is cleared, and the junction cools to ambient.",
                "fail": "The team places the cut-off downstream of the fault. The next autoreclose arcs at the same junction and trips the feeder again."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Instant Leak Capture",
                "problem": "A pressurized fluid line shares the overhead tray with the feeder run. A pinhole leak atomizes across the pole-mounted cabinet every time the recloser trips.",
                "success": "The team ties @techName to trigger @synergyTechName lattice structures on cut. As the line opens, the lattice seals the pinhole and redirects spray away from electrical components.",
                "fail": "The team cuts power without integrating capture. The next trip drives a fresh burst into the cabinet and the cleanup expands."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Failure Containment",
                "problem": "A cascading failure threatens to walk the feeder line pole to pole along the shared neutral. Every shift in the sagging span moves the fault path somewhere new.",
                "success": "The team sets the manual cut using @techName and checkpoints the safe geometry state with @synergyTechName. Fault energy stays within the isolated room and the cascade halts.",
                "fail": "The team opens the line but does not save the safe state. The next shift bridges to the neighboring busway and the cascade resumes."
            }
        ]
    },
    {
        "id": "quantum_analysis_entangled_synchrony_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "entangled-synchrony",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Out-of-Step Instruments",
                "problem": "Two scanner bays produce diverging timestamps for the same anomaly front. Route planning software oscillates between paths with each update.",
                "success": "The team uses @techName to hard-link update cadence across the bays. Timestamps converge, the model stabilizes, and a single route remains valid.",
                "fail": "The team links without compensating for transport delay. The next update splits the timestamps again, and the route collapses."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Mixed Returns",
                "problem": "Energy spikes overlap faint organic signatures on the edge of the scan cone. Confidence scores drop below the safe threshold for passage. The synchronized scanners need to discriminate between noise and signal.",
                "success": "The team keeps cadence with @techName and applies cleansing pulses through @synergyTechName. The model separates the noise from the true organic signal, and the corridor qualifies as passable.",
                "fail": "The team applies the cleansing pulses with poor timing. The pulses interfere with the synchronized readings, smearing both datasets, and the planner rejects the corridor."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Brownout Frames",
                "problem": "Intermittent dips on the bay supply wipe recent frames from the buffer before they are written. Patrols keep being sent back through spans both scanners have already covered.",
                "success": "The team maintains synchronization with @techName while @synergyTechName stages redundant frame caches. When a dip occurs, the planner reexport constructs the span from the cache and maintains the route.",
                "fail": "The team enables caching on the wrong interval. A dip lands between cache points, and the segment reverts to unknown."
            }
        ]
    },
    {
        "id": "quantum_analysis_bio_spectral_crosscheck_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "bio-spectral-crosscheck",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Ambiguous Returns",
                "problem": "Field readings and radiation peaks overlap within the scan cone. Confidence scores for safe passage fall below threshold.",
                "success": "The team employs @techName to correlate energy levels with known biological signatures. The model separates the fields and the corridor qualifies for transit.",
                "fail": "The team applies an incorrect correlation set. The model mislabels a hot pocket as safe, and the plan is rejected."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Hidden Channels",
                "problem": "Flat wall panels report uniform readings, yet intermittent drops suggest concealed cavities behind the surface.",
                "success": "The team runs @techName and overlays @synergyTechName pulses. Subsurface root channels appear as distinct tracks, and the route avoids collapsible spans.",
                "fail": "The team relies on surface readings only. The next step lands on a concealed channel and the span deforms under load."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Contamination Film",
                "problem": "A thin contamination film skews energy measurements over two bays. Wipe tests confirm a residual layer across the floor.",
                "success": "The team maintains correlation with @techName and applies @synergyTechName feedback as they move. Readings normalize and the route holds.",
                "fail": "The team correlates correctly but never clears the film. Measurements drift again in the next bay and the model drops confidence."
            }
        ]
    },
    {
        "id": "quantum_analysis_ghost_echo_capture_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "ghost-echo-capture",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Residual Circuit Hunt",
                "problem": "Several panels draw trace current with no obvious source. Thermal imaging reveals faint warmth on two cable trays that should be de-energized.",
                "success": "The team uses @techName to measure residual current vectors and trace the still-active runs. The hidden feed is located and isolated.",
                "fail": "The team samples at too low a resolution. The vectors smear and the active run remains unidentified."
            },
            {
                "synergyTechniqueId": "shadowroot-bloom",
                "title": "Crack Sampling",
                "problem": "Hairline cracks in conduit joints likely trap residues that mark active runs, but surface swabs return inconclusive.",
                "success": "The team maps currents using @techName while @synergyTechName wicks trace particles from the cracks. The sample confirms the energized path and the isolation proceeds.",
                "fail": "The team draws samples without wicking the cracks. Residue remains trapped and the analysis stays inconclusive."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Brownout Gaps",
                "problem": "Repeated brownouts interrupt long scans and leave gaps in the residual-current logs. The trays that matter are the ones the meter lost.",
                "success": "The team continues measurement with @techName and stages checkpoints via @synergyTechName. When a brownout hits, the dataset restores from the staged frames and the trace remains continuous.",
                "fail": "The team logs without checkpoints. The next brownout erases the segment and the trace must restart from the last known point."
            }
        ]
    }
];
const $ce6dd72bc4611534$export$1cd1fab9b9844b76 = [
    {
        "id": "echo_mapping_quantum_relay_hook_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "quantum-relay-hook",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Line-of-Sight Bottleneck",
                "problem": "Packet traces show repeated collisions where the survey scanners and the team telemetry share the single clear sightline off the mast. Jitter and loss climb whenever both streams peak in the same interval.",
                "success": "The team employs @techName to establish an auxiliary hop with a cleaner phase reference, migrating map frames off the congested sightline. The telemetry stream holds continuity while the map transfer completes.",
                "fail": "The team anchors the auxiliary hop on a reflective node. Return echoes corrupt sequence numbers, and the session drops to recovery mode."
            },
            {
                "synergyTechniqueId": "relay-stabilizer",
                "title": "Slew-Induced Dropouts",
                "problem": "Mast tilt sensors register small but frequent slews in crosswinds. During each motion, the shared path between scanners and the relay loses coherence and map frames tear.",
                "success": "The team creates a secondary route with @techName and stabilizes the primary carrier using @synergyTechName. The two paths decouple cleanly and no frames tear during mast motion.",
                "fail": "The team brings up the secondary route but fails to hold the carrier. The next gust collapses both lanes into the same band and the transfer aborts."
            },
            {
                "synergyTechniqueId": "photosymbiosis",
                "title": "Occluded Approach Lanes",
                "problem": "Dense overgrowth has closed two of the approach lanes. Optical and RF scans attenuate sharply past the first bend and the route model refuses to stitch those spans; the growth is masking the true ground line.",
                "success": "The team extends a side hop with @techName and cultivates growth channels along the path using @synergyTechName. The growth guides the pulses around obstacles, the returns close the gaps, and the lanes appear as continuous tracks.",
                "fail": "The team sets relay hops but cultivates growth in the wrong orientation. The pulses refract unpredictably and the map retains discontinuities."
            }
        ]
    },
    {
        "id": "echo_mapping_biotrace_resonance_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "biotrace-resonance",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Hidden Organic Corridors",
                "problem": "Standard scans report uniform walls, yet intermittent pressure changes and faint humidity spikes suggest concealed organic cavities behind the paneling.",
                "success": "The team uses @techName to emit short pulses that preferentially reflect off living material. Echo peaks sketch a subsurface corridor network that the route planner can trust.",
                "fail": "The team samples at an incorrect pulse width. Returns blur across the wall, and the corridor candidates remain inconclusive."
            },
            {
                "synergyTechniqueId": "bio-spectral-crosscheck",
                "title": "Growth Over Utilities",
                "problem": "Power and ventilation runs vanish beneath overgrowth; field probes cannot separate cable trays from living tissue, and clearance cannot be certified.",
                "success": "The team runs @techName to light organic structures and fuses energy-band data through @synergyTechName. The composite reveals where growth overlays live lines and vents, and a safe path is marked.",
                "fail": "The team misaligns the fusion window. Organic and electrical returns smear together, and the clearance check fails."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Residual Film Artifacts",
                "problem": "After salvage, a thin residue film on floor plates produces speckled echoes that degrade map confidence across two bays.",
                "success": "The team profiles the bays with @techName while @synergyTechName disrupts the residue along the survey track. Speckle drops and the map resolves at the required confidence.",
                "fail": "The team records before breaking the film. Artifacts persist across passes, and the planner rejects the tiles."
            }
        ]
    },
    {
        "id": "echo_mapping_shadow_archive_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "shadow-archive",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Brownout Map Loss",
                "problem": "Intermittent dips on the junction supply wipe the last seconds of survey data out of volatile buffers, and the same span has to be walked again to rebuild it.",
                "success": "The team employs @techName to persist map frames to portable memory at each survey gate. When a dip occurs, the route planner restores the tiles from the archive and the sweep continues.",
                "fail": "The team delays the checkpoint cadence. A dip lands between saves, and the corridor reverts to unknown."
            },
            {
                "synergyTechniqueId": "echo-pulse-beacon",
                "title": "High-Throughput Resurvey",
                "problem": "A multi-level junction requires frequent revisits after geometry shifts. Without anchors, drones spend cycles re-acquiring the junction on every pass.",
                "success": "The team posts lightweight anchors using @synergyTechName and commits snapshots into @techName on each pass. Drones lock to the anchors and skip redundant resurvey.",
                "fail": "The team archives without anchors. Each geometry shift invalidates the prior frames and the rescan overhead returns."
            },
            {
                "synergyTechniqueId": "silent-hand",
                "title": "Acoustic Disturbance Control",
                "problem": "In a vaulted gallery, footfall and drone noise reflect into the scan field, lowering confidence and prompting unnecessary detours.",
                "success": "The team records frames into @techName while @synergyTechName dampens acoustic edges along the route. Reflections subside, and the planner accepts a direct path.",
                "fail": "The team archives without damping. The next pass inherits the same reflection artifacts and the detours persist."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_servo_alignment_tool_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "servo-alignment-tool",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Tone-Scrambled Latch",
                "problem": "Contact microphones on the blast door faceplate register a shifting interference tone inside the lock housing. Feedback traces smear across the pin stack every time the frame moves under residual load.",
                "success": "The team uses @techName to identify a stable resonance node and works the pins only within that window. The stack settles into sequence and the latch rotates without binding.",
                "fail": "The team commits on a false node. The tone drifts mid-turn, the feedback collapses, and the counter-spring snaps the housing to hard lock."
            },
            {
                "synergyTechniqueId": "manual-override-line",
                "title": "Micro-Window Alignment",
                "problem": "The anti-tamper coil behind the faceplate scrambles fine feedback every 170 milliseconds, closing the path before a full set can be completed. The latch and its housing only line up inside that window.",
                "success": "The team holds the resonance with @techName while @synergyTechName engages kill-switches to lock the housing frame during the quiet intervals. The pins set across consecutive windows and the faceplate opens cleanly.",
                "fail": "The team mis-times the override. The housing frame shifts before the stack fully sets, and the mechanism jolts back to lock."
            },
            {
                "synergyTechniqueId": "servo-containment",
                "title": "Cross-Band Suppression",
                "problem": "Spectral analysis shows a secondary carrier bleeding into the door housing from the junction box beside the frame. The cross-band tone masks the lowest latch pin entirely, and the housing seals have to stay intact while the team works.",
                "success": "The team seals the housing via @synergyTechName to block the interfering carrier and resumes fine work through @techName. With the band cleared, low pin feedback returns and the stack completes.",
                "fail": "The team fails to seal properly. The secondary carrier persists, masks the low pin, and the mechanism relocks after timeout."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_biofilm_stabilizer_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "biofilm-stabilizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rail Creep Compensation",
                "problem": "Micrometer checks on the door show the latch rails creeping under asymmetric tension as the frame settles into softened ground. The pick drifts off centre with each correction and the feedback stops being trustworthy.",
                "success": "The team applies @techName to lay a thin, compliant biofilm along the rail seams, equalizing micro-friction and damping lateral drift. The pick remains centered and the lock yields in order.",
                "fail": "The team spreads an uneven layer. A dry patch on the high rail catches the pick, the counter-spring loads suddenly, and the housing locks down."
            },
            {
                "synergyTechniqueId": "mycelial-rebalance",
                "title": "Rail & Tone Coordination",
                "problem": "Even with the frame drift arrested, a low oscillation remains in the door housing and flattens the tactile response on two mid pins. Organic residues packed into the mechanism are carrying the vibration.",
                "success": "The team stabilizes the rails with @techName and uses @synergyTechName to decompose organic buildup that is resonating at the problem frequency. The oscillation dampens and tactile response returns.",
                "fail": "The team stabilizes the rails but the biofilm rebalancer targets the wrong substrate. The resonance persists and the countermeasure coil arms the block."
            },
            {
                "synergyTechniqueId": "signal-mask-injection",
                "title": "Countermeasure Diversion",
                "problem": "A microphonic countermeasure watches the faceplate for vibration signatures and stiffens the stack whenever it recognises a pick pattern. The biofilm spread across the door can be made to carry the signal instead.",
                "success": "The team maintains seam stability with @techName while @synergyTechName injects spoofed vibration patterns into the biofilm that the countermeasure monitors. The monitor follows the injected rhythm and the true stack sets unopposed.",
                "fail": "The team maintains the seam but the injected signal carries too much of the true pattern. The monitor reacquires the real signature and the stack stiffens beyond workable force."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_echo_pulse_decoy_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "echo-pulse-decoy",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Pattern-Learning Countermeasure",
                "problem": "Diagnostic taps at the door frame reveal that the lock records pick cadence and stiffens the matching pins on every later attempt. The learned pattern survives each reset.",
                "success": "The team employs @techName to project a deliberate, off-pattern cadence that the monitor adopts as the \u2018true\u2019 signal. While the system follows the decoy, the team completes the actual stack on a separate cadence.",
                "fail": "The team repeats an element of the prior cadence. The monitor matches the signature, the pins harden in sequence, and the window closes."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Noise Cage Detuning",
                "problem": "Ambient noise off the open approach makes the countermeasure reject simple decoys; it will only adopt a new pattern from a clean channel, and the door housing screens the signal like a Faraday cage.",
                "success": "The team chains decoy directives via @synergyTechName to overwhelm the monitor's input stage and then drives the adoption rhythm via @techName. With the input saturated, the cascade locks the decoy pattern and the lock yields.",
                "fail": "The team deploys decoys too slowly. The monitor resolves individual pulses before the cascade builds, and the mechanism hardens after timeout."
            },
            {
                "synergyTechniqueId": "mutualist-growth",
                "title": "Cadence\u2013Resonance Bridge",
                "problem": "The faceplate rings close to the countermeasure's favored frequency, making the decoy cadence hard to hold through a full set. Growth pocketed in the door frame is feeding the resonance.",
                "success": "The team balances the cadence with @techName while @synergyTechName cultivates growth to dampen the resonance node. With the resonance absorbed by the pods, the decoy remains consistent and the stack completes.",
                "fail": "The team drives the cadence while cultivating pods in the wrong location. The resonance persists, the decoy wavers, and the countermeasure rejects the pattern."
            }
        ]
    },
    {
        "id": "stealth-transit_drone_path_shadow_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "drone-path-shadow",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Open-Span Traverse",
                "problem": "Line-of-sight analysis of a vaulted transfer hall shows periodic sweep cones from unattended optics. Drone telemetry reveals predictable transit lanes that cast moving shadow bands across the floor.",
                "success": "The team uses @techName to synchronize movement inside those shadow bands, matching speed and pause points to the airframe cadence. The silhouettes remain embedded in drone traces, and the traverse completes without a return ping.",
                "fail": "The team drifts a half step out of lane at a column gap. A silhouette crosses a lit band, the optics resolve a shape, and the alarm grid advances one state."
            },
            {
                "synergyTechniqueId": "pheromone-chorus",
                "title": "Dust-Flare Suppression",
                "problem": "High-angle lighting reveals dust flares whenever steps cross turbulent eddies near the span's midpoint. Flare spikes coincide with the optics' higher-confidence frames. Air currents carry behavioral cues that make observers relax.",
                "success": "The team rides @techName lanes and projects @synergyTechName calm signals along the route to suppress behavioral alerts in any watchers. The floor illumination remains uniform, and the confidence score never exceeds the alert threshold.",
                "fail": "The team follows the lanes but the pheromone signal fades in the eddies. Observers tense up at the correct moment and the sweep lingers over the span."
            },
            {
                "synergyTechniqueId": "rootpath-protocol",
                "title": "Specular Panel Timing",
                "problem": "Wall-mounted specular panels throw timed light bands across the path. Any unsynchronized crossing produces a distinct break in the reflection pattern. Drone routes can predict panel timing.",
                "success": "The team tracks lane cadence with @techName while @synergyTechName guides movement using cached drone navigation paths. Steps thread between bands; no reflection pattern breaks are recorded.",
                "fail": "The team mistimes the final panel. A stride clips a bright band, creating a discontinuity the watcher tags for review."
            }
        ]
    },
    {
        "id": "stealth-transit_spore_veil_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "spore-veil",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Scent-Track Washout",
                "problem": "Chemical sniffers positioned at door frames retain faint volatile traces for hours. A prior pass left a recoverable trail that aligns with the planned route.",
                "success": "The team employs @techName to project a low-density veil that binds and neutralizes volatile residues at knee height and below. Subsequent sniffer samples fall to background, and the route proceeds without a trackable trail.",
                "fail": "The team sets an uneven veil. A warm vent lifts untreated volatiles into the frame, and the trail persists across the threshold."
            },
            {
                "synergyTechniqueId": "reflex-bloom",
                "title": "Signature Merge",
                "problem": "An overhead watcher fuses optical and chemical cues. While residuals are low, silhouette breaks remain detectable along two open spans. Heat signatures also stand out in a cool environment.",
                "success": "The team neutralizes residues with @techName and cultivates @synergyTechName blooms to absorb and redistribute thermal signatures. Optical silhouettes blur, and the fusion model fails to correlate a human trace.",
                "fail": "The team clears scent but the blooms cultivate in the wrong thermal zones. Heat still concentrates and the watcher regains correlation at the second span."
            },
            {
                "synergyTechniqueId": "system-ground-loop",
                "title": "Reflective Hallway Control",
                "problem": "A polished conduit hall amplifies small disturbances in both air and light. Micro-reflections along the handrail telegraph footsteps as bright, periodic ticks. Static buildup also creates detectable reflections.",
                "success": "The team maintains the veil with @techName and grounds static charges along the route using @synergyTechName. The handrail trace remains flat without periodic ticks, and no static reflections are recorded.",
                "fail": "The team walks with the veil active but grounding fails mid-span. Static charges accumulate and produce twin ticks in the rail trace, prompting the watcher to rescan the hall."
            }
        ]
    },
    {
        "id": "stealth-transit_mirror_walk_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "mirror-walk",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Reflection-Phase Crossing",
                "problem": "A corridor lined with reflective panels creates moving interference fringes from a rotating lumen. Any footfall outside the dark fringes appears as a sharp phase break.",
                "success": "The team uses @techName to pace strides through the dark fringes, matching the rotation period so no phase breaks occur. The camera histogram remains unchanged while the squad clears the corridor.",
                "fail": "The team crosses a bright fringe during a tempo adjustment. The resulting phase break stamps a clear step signature onto the recording."
            },
            {
                "synergyTechniqueId": "rootpath-protocol",
                "title": "Fringe\u2013Lane Coupling",
                "problem": "Mid-corridor, the dark fringes drift out of alignment with the safest physical cover, forcing a choice between concealment patterns. Drone navigation data can resolve the timing of the drift.",
                "success": "The team tracks fringe timing with @techName and snaps movement onto @synergyTechName drone routes during the drift. The silhouettes stay embedded in lane shadows while remaining within the dark fringes.",
                "fail": "The team favors the visual fringe but the drone route diverges. A shoulder edge intersects a bright band, and the watcher flags the anomaly."
            },
            {
                "synergyTechniqueId": "pheromone-chorus",
                "title": "Heat Plume Artifacts",
                "problem": "Thermal cameras at the corridor exit read small heat plumes off textiles after exertion. The plumes bloom when the reflection pattern forces a short sprint. Observers also rely on behavioral cues to notice the exertion.",
                "success": "The team maintains fringe pacing with @techName and projects @synergyTechName calm signals to damp observer alertness as the team reaches the exit. Behavioral cues flatten, and thermal readings stay below the gate's detection threshold.",
                "fail": "The team sprints the last band without dampening behavioral cues. The pheromone signal fails to reach observers and the exit camera marks the passage."
            }
        ]
    },
    {
        "id": "ghost_infiltration_control_spoof_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "control-spoof",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Whitelisted Channel Gate",
                "problem": "The checkpoint controller accepts only whitelisted directive classes. Every out-of-policy opcode that reaches the pedestal steps a suspicion counter on its face.",
                "success": "The team uses @techName to remap outbound directives into permitted packet classes with the correct timing jitter. The audit daemon records routine activity and the gate remains permissive.",
                "fail": "The team remaps headers but misses the inter-packet spacing. The timing profile deviates from policy and the controller drops the session."
            },
            {
                "synergyTechniqueId": "shared-immunity",
                "title": "Biometric Cross-Check",
                "problem": "The controller pairs command-bus signatures with trace biometrics lifted off the gate panel. A mismatched pair quarantines the port and the barrier stays down.",
                "success": "The team frames the directives with @techName and applies @synergyTechName to shift biometric baselines toward a neutral profile. The fused record shows a consistent identity and the quarantine logic does not engage.",
                "fail": "The team masks traffic but the immunity profile remains incomplete. The cross-check correlates the mismatch and forces the port into lockdown."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Log-Window Persistence",
                "problem": "The pedestal keeps a rolling high-resolution log of recent directives. A pattern repeated inside that window raises the alert level at the gate.",
                "success": "The team shapes allowed opcodes via @techName and chains spoofed directives using @synergyTechName to mask the true pattern. The window advances with only baseline and decoy entries and the alert level remains low.",
                "fail": "The team deploys spoofs too slowly. The pattern detector acquires the true cadence before the cascade builds and isolates the segment."
            }
        ]
    },
    {
        "id": "ghost_infiltration_bio_id_mask_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "bio-id-mask",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Residual Print Gate",
                "problem": "Sensor wafers at the cabinet read faint skin volatiles and trace oils for several hours. The gate rejects sessions when a fresh print conflicts with the cached baseline.",
                "success": "The team employs @techName to bind and neutralize volatiles at the contact surfaces, then backfills a low-noise baseline. The gate compares against the baseline and admits the session.",
                "fail": "The team masks the handle but ignores the hinge and shroud. Residuals bleed into the sample and the cabinet denies access."
            },
            {
                "synergyTechniqueId": "signal-mask-injection",
                "title": "Policy-Concordant Session",
                "problem": "Even with chemical neutrality at the wafers, the gate flags directive classes that do not match the maintenance patterns it was left authorised for.",
                "success": "The team maintains the neutral surface with @techName and injects masked signals via @synergyTechName to reframe the command stream toward an approved maintenance pattern. The policy engine downgrades risk and the session persists.",
                "fail": "The team sustains chemical neutrality but the masked signal fails to align. The engine detects policy deviation and tears down the session."
            },
            {
                "synergyTechniqueId": "signal-harmonizer",
                "title": "Audit Scrub Timing",
                "problem": "The cabinet rolling audit replaces detailed frames with summaries every two minutes. Anything done out of step with that cycle stays in the log at full fidelity.",
                "success": "The team holds the neutral profile using @techName and harmonizes operational signals through @synergyTechName to blend with background patterns. The audit rollup captures only summaries and no anomalies are retained.",
                "fail": "The team executes with unharmonized signals. Full-fidelity frames capture the operation and the audit daemon requests review."
            }
        ]
    },
    {
        "id": "ghost_infiltration_echo_loop_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "echo-loop",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Repeating Log Window",
                "problem": "The gate controller holds a tight high-resolution window of recent events. Entries that age out collapse to coarse summaries, but everything inside the current slice keeps precise timestamps.",
                "success": "The team uses @techName to align activity with the log scrubbing cadence so full-fidelity entries age out immediately. Only coarse summaries remain before correlation can occur.",
                "fail": "The team performs the operation off-cycle. The high-resolution slice persists long enough for cross-correlation and the port is flagged."
            },
            {
                "synergyTechniqueId": "silent-channel",
                "title": "Benign Rewrite",
                "problem": "The watcher on the pedestal compares parameter deltas between successive configuration frames. An atypical delta raises the alarm even when the timing is masked.",
                "success": "The team times the window with @techName and pipes dummy parameter deltas through @synergyTechName silent channels to mask the true delta. The watcher reads the rewrite as a benign refresh and does not escalate.",
                "fail": "The team masks timing but the silent channel carries too much true signal. The watcher detects deviation and escalates."
            },
            {
                "synergyTechniqueId": "mycelial-rebalance",
                "title": "Contact Echo Suppression",
                "problem": "Microphones set into the gate panel capture short acoustic signatures during service and cross-reference them against the log window. Organic decomposition muffles the echoes.",
                "success": "The team schedules edits with @techName and decomposes acoustic signatures using @synergyTechName fungal filters at the panel surface. Cross-reference returns no match and the window rolls forward unremarked.",
                "fail": "The team aligns the edits but the fungal filter activates too late. An acoustic tick propagates and links to the window."
            }
        ]
    },
    {
        "id": "reality_displacement_phase_anchor_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "phase-anchor",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Shallow Wave Crossing",
                "problem": "Instrumented markers show the crossing alternating between stable and low-friction states every thirty seconds. Geometry telemetry confirms a shallow wave running the length of the span.",
                "success": "The team deploys @techName to pin the span during a stable phase and advances the squad before the next low-friction interval. The route holds long enough for a controlled traverse.",
                "fail": "The team commits at the wrong phase. The surface degrades underfoot and the crossing becomes impassable."
            },
            {
                "synergyTechniqueId": "mutualist-growth",
                "title": "Offset Layer Bridge",
                "problem": "Gap sensors report a widening discontinuity along the seam of the span; the shallow layer no longer overlaps for the full crossing.",
                "success": "The team secures the near edge with @techName and uses @synergyTechName to cultivate pods that span the offset. The traverse completes over the organic bridge.",
                "fail": "The team anchors the near edge but cultivates pods on the unstable shallow layer. The pods collapse and the squad is forced to retreat."
            },
            {
                "synergyTechniqueId": "organic-link-adapter",
                "title": "Memory Drift Control",
                "problem": "Headcam frames fade out during each phase shift, and the crew loses the safe line across the span every time the surface moves under them.",
                "success": "The team sets anchors with @techName and threads bio-fiber through @synergyTechName to lock visual reference markers. When the span blurs, the squad follows the anchored line across.",
                "fail": "The team sets anchors but the bio-fiber fails to hold during a phase shift. The reference points slip and the route cannot be re-established in time."
            }
        ]
    },
    {
        "id": "reality_displacement_depth_step_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "depth-step",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Sinking Span Detour",
                "problem": "Load cells report a progressive loss of support in the central span. The shallow surface carries weight for only a few seconds before collapsing into a softer layer.",
                "success": "The team employs @techName to descend onto a firmer underlying layer and route the traverse along that depth. The squad bypasses the failing surface entirely.",
                "fail": "The team steps down onto a pocket of the same weak layer. The footing shears and the route collapses before the last runner crosses."
            },
            {
                "synergyTechniqueId": "shadowroot-bloom",
                "title": "Mixed-Depth Hold",
                "problem": "A stretch of the span alternates between two usable depths and never holds either long enough to reposition safely.",
                "success": "The team steps down to the sturdier depth via @techName and cultivates @synergyTechName blooms at both edges for stable anchor points. The hold window lengthens enough for a controlled handover.",
                "fail": "The team steps down but cultivates blooms in soil too unstable. The alternation resumes mid-transfer and the line scrambles back to the starting side."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Layer Map Persistence",
                "problem": "Depth telemetry across the span blinks out during transitions and the planner keeps discarding half-built layer maps.",
                "success": "The team maintains the chosen depth with @techName while @synergyTechName coordinates purge cycles to preserve telemetry windows. Layer maps remain coherent and when telemetry blinks, the map restores and the traverse continues.",
                "fail": "The team travels without purge coordination. A blink clears the partial map and the traverse must restart from the last known marker."
            }
        ]
    },
    {
        "id": "reality_displacement_echo_fold_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "echo-fold",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Phase-Blur Archive",
                "problem": "During geometry fluctuations the survey cameras smear and drop frames, erasing the alignment that marked the last safe crossing.",
                "success": "The team uses @techName to buffer and replay clean visual frames at fixed posts, restoring a stable reference for foot placement. The crossing repeats along the recorded line.",
                "fail": "The team fails to capture a clean baseline. The next fluctuation wipes the visual record and the reference is lost."
            },
            {
                "synergyTechniqueId": "entangled-synchrony",
                "title": "Pinned Reference Posts",
                "problem": "Buffered frames drift against the live scene whenever the span shears sideways by a few centimetres.",
                "success": "The team establishes synchronized scan anchors with @synergyTechName and aligns the replayed frames from @techName to those anchors. The reference and the live scene remain in register through the shear.",
                "fail": "The team replays frames against a drifting synchronized scan. The next shear misaligns the reference and the crossing stalls."
            },
            {
                "synergyTechniqueId": "dim-shift-layer",
                "title": "Vertical Discontinuity",
                "problem": "Frame buffers cannot account for the sudden drop where the span steps down to a lower layer partway across.",
                "success": "The team augments the replay via @techName and uses @synergyTechName to adjust the lighting profile at the marked point where the floor drops. The buffered path continues smoothly across the discontinuity as the layer auto-tunes.",
                "fail": "The team follows the replay without adjusting the lighting profile. The vertical offset interrupts the line and the squad loses the path mid-span."
            }
        ]
    }
];
const $ce6dd72bc4611534$export$9435522665f2dda4 = [
    {
        "id": "organic_salvage_reclamation_drone_link_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "reclamation-drone-link",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Culvert Bed Collapse",
                "problem": "Inspection feeds show a salvage bed that has slumped into a drainage culvert. Rot-gas pockets and interlocked fiber mats prevent a clean lift; gas sensors spike when the mats are disturbed.",
                "success": "The team uses @techName to choreograph staged pulls that vent pockets before lift baskets take load. The mats separate in layers, and the culvert remains stable during extraction.",
                "fail": "The team hooks a bonded slab without a staged vent. A pocket ruptures under load, slurry surges into the trench, and the lift aborts."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Vertical Shaft Clearance",
                "problem": "A vertical shaft contains heavy mycelial slabs but lacks safe hand access. Rotor wash destabilizes the rim whenever a single drone attempts a lift.",
                "success": "The team links claws through @techName and staggers hover lanes with @synergyTechName. Slabs clear vertically without clipping the rim, and the shaft wall remains intact.",
                "fail": "The team mis-times the stagger. Two frames cross lanes, clip the rim, and a wall section sloughs into the shaft."
            },
            {
                "synergyTechniqueId": "shadow-archive",
                "title": "Hidden Brace Recovery",
                "problem": "Historic cut lines do not match the current growth. Previous passes likely left buried braces under the bed; probe strikes return inconsistent depth.",
                "success": "The team queries prior frames via @synergyTechName and guides the rig using @techName along the original cut paths. Braces are exposed in sequence and the lifts proceed without tearing the casing.",
                "fail": "The team trusts a corrupted frame. The claw catches a brace, the mat rips against the casing, and the pull is abandoned."
            }
        ]
    },
    {
        "id": "organic_salvage_mycelial_rebalance_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "mycelial-rebalance",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Starved\u2013Overfed Bed",
                "problem": "Nutrient telemetry shows alternating bands of depleted and oversaturated substrate within the salvage bed. Gas probes register volatile surges whenever the oversaturated band vents.",
                "success": "The team uses @techName to redistribute nutrients across the strata, damping the volatile surges and equalizing moisture so the lift sequence can proceed.",
                "fail": "The team over-corrects the saturated band. A delayed vent ignites a fresh surge, and the extraction halts under alarm."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Purge and Balance",
                "problem": "Headspace samples contain acid vapors and fine particulates trapped above the bed. Uneven substrate prevents a clean purge cycle.",
                "success": "The team rebalances the strata using @techName while @synergyTechName performs staged purges at the vent crowns. Vapors clear, and the bed remains stable through extraction.",
                "fail": "The team rebalances after the purge begins. A pocket opens under pressure, pushing vapor through the crew lane and aborting the run."
            },
            {
                "synergyTechniqueId": "biofilm-stabilizer",
                "title": "Edge Shear Control",
                "problem": "Core samples at the cut boundary show slumping micro-layers that tear when lifted, risking wall collapse.",
                "success": "The team restores nutrient symmetry with @techName and paints a thin stabilizing film via @synergyTechName along the boundary. The lift holds, and the wall remains intact.",
                "fail": "The team omits the film at a weak seam. The boundary shears under load, and the section must be repacked."
            }
        ]
    },
    {
        "id": "organic_salvage_phase_cleanse_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "phase-cleanse",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Contaminant Bloom",
                "problem": "Swab tests reveal a reactive film over tools and crate interiors. The film blooms under humidity, fouling seals and instruments.",
                "success": "The team uses @techName to apply low-intensity cleansing cycles that break down the film without damaging organics. Seals pass inspection and instruments read nominal.",
                "fail": "The team runs an aggressive cycle. Tool grips craze, and the salvage crate liner fails QA."
            },
            {
                "synergyTechniqueId": "echo-pulse-beacon",
                "title": "Residue Mapping",
                "problem": "Visual inspection misses residual pockets in a vented gallery. Air samples fluctuate, but the contamination pattern is unclear.",
                "success": "The team maps the gallery with @synergyTechName to locate speckle clusters, then targets @techName precisely on those sites. Residues fall below detection limits across the span.",
                "fail": "The team cleans without a map. Pockets reform in the blind corners, and the gallery fails follow-up sampling."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Selective Preservation",
                "problem": "The contamination film overlays a live symbiont layer that must remain intact for later harvest. Relay-mapped boundary data is unclear because the live layer reflects scanner noise.",
                "success": "The team uses @synergyTechName to relay-scan the live-layer boundary with noise-filtered precision, then gates @techName to spare those zones. The film clears while the symbiont layer remains viable.",
                "fail": "The team gates incorrectly. The cleanse cycle etches the live layer, and the harvest is lost."
            }
        ]
    },
    {
        "id": "growth_manipulation_adaptive_lattice_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "adaptive-lattice",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Walkway Sag Remediation",
                "problem": "A walkway over a feeder trench shows measurable mid-span sag. Plates oilcan under footfall, and two handrail posts twist out of plumb.",
                "success": "The team employs @techName to cultivate a ribbed subframe beneath the worst deflection and rebinds the plates to grade. Deflection readings return to nominal.",
                "fail": "The team accelerates growth beyond the cure window. Fresh ribs buckle under residual load and the plates shift farther out of level."
            },
            {
                "synergyTechniqueId": "relay-stabilizer",
                "title": "Mast Lean Arrest",
                "problem": "A relay mast set in saturated soil leans by a small offset each hour. Link statistics show alignment drift during gusts.",
                "success": "The team grows a living buttress with @techName and maintains strict carrier control via @synergyTechName while the footing resets. Alignment holds through the wind cycle.",
                "fail": "The team braces the mast but neglects carrier discipline. The next gust reintroduces drift, and the long-haul link drops frames."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Subgrade Root Withdrawal",
                "problem": "Support roots have invaded the service run beneath the trench. Surface pruning only triggers regrowth from deeper runners, and the run closes again by the end of the day.",
                "success": "The team extends lattice guides with @techName and anchors the deep runners in place using @synergyTechName stabilizers. Roots remain redirected and the crawl stays clear.",
                "fail": "The team clears only the surface runners. Deeper growths break the anchors and reassert by evening, occlud ing the crawl space again."
            }
        ]
    },
    {
        "id": "growth_manipulation_photosymbiosis_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "photosymbiosis",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "CO\u2082 Load Relief",
                "problem": "Air monitors show sustained CO\u2082 above safe limits in a sealed work bay. Mechanical scrubbers are offline, and crews cannot remain at post.",
                "success": "The team deploys @techName to activate symbiotic photo-beds along the bay perimeter. CO\u2082 trends down steadily, and the bay becomes habitable for the repair window.",
                "fail": "The team activates beds without establishing airflow. CO\u2082 pools persist near the deck, and mask timers remain in the red."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Breathable Cycle Control",
                "problem": "Intermittent spore releases coincide with high CO\u2082 periods, forcing alternating evacuations and resets.",
                "success": "The team maintains photo uptake with @techName while @synergyTechName schedules coordinated purges. The atmosphere stabilizes and work proceeds without evacuation.",
                "fail": "The team staggers purges out of phase. A release lands during peak CO\u2082 and the bay locks down again."
            },
            {
                "synergyTechniqueId": "spore-veil",
                "title": "Optics Preservation",
                "problem": "Fine spores settle on camera domes and light panels, reducing effective illumination for alignment tasks.",
                "success": "The team drives photo-beds via @techName and casts @synergyTechName across optics. Settling drops to background, and alignment completes within tolerance.",
                "fail": "The team relies on uptake alone. Dome fouling worsens, and the alignment window is missed."
            }
        ]
    },
    {
        "id": "growth_manipulation_shadowroot_bloom_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "shadowroot-bloom",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Substrate Bridging",
                "problem": "A trench separates two platforms with no intact decking. Load tests show the lip cannot support a rigid span.",
                "success": "The team deploys @techName to coax subsurface root channels into a distributed bridge beneath the lip. The traverse carries weight without point loads.",
                "fail": "The team overconcentrates growth on one side. The bridge torques under the first step, and the crossing is aborted."
            },
            {
                "synergyTechniqueId": "ghost-echo-capture",
                "title": "Active Run Avoidance",
                "problem": "Residual-current traces suggest a hidden energized conduit beneath the trench. Direct probing risks a fault.",
                "success": "The team maps the energized run using @synergyTechName and steers @techName around it. The bridge forms clear of the hazard and remains stable under test load.",
                "fail": "The team misreads the trace. Roots contact the live run, and the platform trips a breaker mid-growth."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Cavity Discovery",
                "problem": "Uneven settling implies voids in the bank. A blind bridge may collapse into an unseen cavity.",
                "success": "The team scans for subsurface voids with @synergyTechName and grows @techName only across verified dense channels. The span keeps grade through the traverse.",
                "fail": "The team omits the scan. A central void opens under load, and the span shears at mid-crossing."
            }
        ]
    },
    {
        "id": "creature_pacification_signal_harmonizer_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "signal-harmonizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Territorial Run Standoff",
                "problem": "A nesting pair has taken the only traversable run through the yard. Scratch marks, nest material and warning postures block the direct line.",
                "success": "The team projects a low-amplitude calming pattern with @techName and paces the pair down a side channel. The run clears without agitation.",
                "fail": "The team introduces the pattern too abruptly. The pair surges toward the mouth of the run and the traverse is suspended."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Turret\u2013Herd Interference",
                "problem": "A perimeter turret sweeps across a grazing drift. Tagging events on the herd coincide with safety lockouts on the yard gate.",
                "success": "The team stabilizes herd movement using @techName and sequences the turret to a safe idle via @synergyTechName. Tagging stops and the yard gate releases.",
                "fail": "The team calms the herd but launches the cascade off schedule. The turret resumes sweep mid-pass and safety relays trip again."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Residual Scent Loop",
                "problem": "Trace volatiles along the gateposts and vent stacks pull the pack back to the same choke points. A prior traverse left a recoverable trail.",
                "success": "The team maintains the calming field with @techName and neutralizes residuals using @synergyTechName. The pack loses the trail and forages away from the route.",
                "fail": "The team clears the threshold but overlooks the vent baffle. The pack reacquires the trail and blocks the crossing."
            }
        ]
    },
    {
        "id": "creature_pacification_pheromone_chorus_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "pheromone-chorus",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Misdirected Drift",
                "problem": "A foraging drift keeps blocking the intended passage. Trail cams show it keying to an old scent line running along the perimeter wall.",
                "success": "The team projects a layered @techName signal that reorients the drift toward a harmless loop across the adjacent apron. The passage remains clear.",
                "fail": "The team sets an incomplete chord. The drift splits, half doubling back into the passage and forcing a halt."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Guide Lane Establishment",
                "problem": "Scattered wreckage across the open ground leaves the drift no clear edge to follow; it stalls and eddies right across the squad route.",
                "success": "The team lays a pheromone chord via @techName while @synergyTechName sweeps a moving visual lane overhead. The animals adopt the lane and move cleanly away from the route.",
                "fail": "The team deconflicts flight lanes but mistunes the chord. The drift ignores the lane and clumps at the choke."
            },
            {
                "synergyTechniqueId": "mirror-walk",
                "title": "Light-Pattern Entrapment",
                "problem": "Sun off the standing panels throws bright bands across the ground, and the herd agitates every time it has to cross one.",
                "success": "The team sustains the chord with @techName and times movement through dark bands using @synergyTechName. The herd crosses without agitation and disperses.",
                "fail": "The team breaks cadence at the final band. The herd startles, and the passage closes again."
            }
        ]
    },
    {
        "id": "creature_pacification_silent_hand_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "silent-hand",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Handler Noise Isolation",
                "problem": "Acoustic logs show handler footfall and gear clicks exceeding the alert threshold in a confined hall. Animals freeze or bolt on approach.",
                "success": "The team applies @techName to suppress near-field mechanical and fabric noise at contact points. The approach reads below threshold and the animals hold calm.",
                "fail": "The team misses a loose buckle. A sharp click carries, and the group scatters into the passage."
            },
            {
                "synergyTechniqueId": "silent-channel",
                "title": "RF\u2013Acoustic Concordance",
                "problem": "A watcher correlates RF bursts with acoustic spikes to detect presence in the hall.",
                "success": "The team damps acoustic signatures with @techName and smears RF emission timing via @synergyTechName. The concordance engine loses correlation and the pass completes.",
                "fail": "The team quiets the approach but transmits on a fixed cadence. The engine re-establishes correlation and flags the movement."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Noise Memory Suppression",
                "problem": "The hall retains sharp transients in logged clips that are replayed during audits. Relay-relayed data carries the full acoustic spectrum.",
                "success": "The team maintains @techName while @synergyTechName relays only low-noise frame snapshots, filtering transients at the relay node. The audit sees no actionable clip and the audit level drops.",
                "fail": "The team leaves a transient unfiltered at the relay. The clip persists and the route is closed for review."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_bio_shielding_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "bio-shielding",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Micro-Stinger Air",
                "problem": "Air sampling in the pump gallery detects suspended micro-stingers. Unprotected skin exhibits immediate reactions; crews cannot remain on task.",
                "success": "The team applies @techName to lay a thin, conductive biofilm across suit seams and visors. Measured sting counts fall below safe limits and work resumes.",
                "fail": "The team spreads an incomplete buffer. Stings slip through a seam and the operation halts."
            },
            {
                "synergyTechniqueId": "system-ground-loop",
                "title": "Arc Hazard Mitigation",
                "problem": "A live panel near the gallery emits occasional arc pops to damp surfaces, startling workers and risking burns.",
                "success": "The team reinforces the return path using @synergyTechName and maintains the biofilm buffer with @techName. Discharges sink into the loop and the task completes without excursions.",
                "fail": "The team lays the biofilm but leaves the return path floating. An arc lands across an exposed seam and the crew withdraws."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Contamination Trail Control",
                "problem": "Sticky spore residue on gloves and boots prints a trail into clean zones. Surface fluorescence persists in follow-up scans.",
                "success": "The team seals contact surfaces via @techName and masks the residue signature with @synergyTechName at each boundary. Walk-backs cease printing and scans find no matching signature.",
                "fail": "The team seals poorly at a threshold. Residue tracks across the boundary and the zone fails inspection."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_shared_immunity_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "shared-immunity",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Localized Irritant",
                "problem": "A resinous irritant accumulates on a service line. Contact causes rash and eye irritation within minutes.",
                "success": "The team uses @techName to seed a transferable micro-biotic layer across gloves and masks, neutralizing the resin on contact. Work resumes without reactions.",
                "fail": "The team applies an uneven layer. A bare knuckle prints resin to the face seal, and the task stops for decon."
            },
            {
                "synergyTechniqueId": "bio-feedback-guard",
                "title": "Stability During Spikes",
                "problem": "When a pump cycle surges, the irritant concentration rises abruptly at the service point.",
                "success": "The team sustains the shared layer with @techName and cushions spikes using @synergyTechName on the supply line. Concentration plateaus, and PPE loads remain within limits.",
                "fail": "The team relies on the shared layer alone. A surge overcomes the buffer, and exposure crosses the threshold."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Inspection Gate Pass",
                "problem": "A fixed inspector gate samples for trace metabolites unique to the shared layer and flags them as contamination.",
                "success": "The team maintains the layer via @techName and masks the metabolite signature with @synergyTechName so it reads as background flora. The gate reports within norms and the pass is authorized.",
                "fail": "The team crosses without masking. The gate detects the metabolite markers and closes the line."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_dim_shift_layer_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "dim-shift-layer",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Glimmer Reduction",
                "problem": "Low-angle cameras detect fabric sheen and micro-glints on motion, elevating detection scores in a patrol gallery.",
                "success": "The team spreads @techName as a directional matte that suppresses glints along the patrol axis. Detection scores fall below the alert threshold.",
                "fail": "The team orients the layer to the wrong axis. Glints persist at camera angles, and the patrol escalates the sweep."
            },
            {
                "synergyTechniqueId": "entangled-synchrony",
                "title": "Sensor Agreement",
                "problem": "Optical and depth sensors disagree during motion, causing the planner to distrust the corridor.",
                "success": "The team applies @techName to steady optical signatures and locks update cadence with @synergyTechName. The sensors agree, and the corridor is accepted.",
                "fail": "The team mats optics but leaves cadence drifting. Disagreement returns and the route is rejected."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Frame Persistence",
                "problem": "Rapid lighting shifts erase short-term references for the squad\u2019s position in a mirrored hall.",
                "success": "The team sustains the matte via @techName and buffers clean frames with @synergyTechName at fixed posts. References persist through shifts and the hall is cleared.",
                "fail": "The team proceeds without buffering. A lighting swing wipes references and the line stalls."
            }
        ]
    },
    {
        "id": "biohazard_recovery_servo_containment_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "servo-containment",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Burst Pod Spill",
                "problem": "A row of seed pods ruptured after a pressure swing. Viscous bloom coats the floor and clogs the lower vents; draw falls by half.",
                "success": "The team cages the spill with @techName and strips the bloom in controlled passes, clearing vents before they choke. Airflow returns to nominal.",
                "fail": "The team cages the wrong section first. The spill creeps along the vent intakes and the wing fills with sweet vapor."
            },
            {
                "synergyTechniqueId": "organic-link-adapter",
                "title": "Live Slurry Joint",
                "problem": "A flex joint on the live slurry line seeps. Approaching the joint without disturbing the bed has repeatedly failed.",
                "success": "The team times a low-phase window using @synergyTechName and sets the cage via @techName while the bed is quiescent. The joint seals without waking the bed.",
                "fail": "The team misses the quiet phase. The bed flares, the cage jams half-set, and the repair is abandoned."
            },
            {
                "synergyTechniqueId": "servo-alignment-tool",
                "title": "Choked Intake",
                "problem": "A bolus of pulp sits behind the intake screen; the lung wheezes at half draw despite repeated cycles.",
                "success": "The team aligns the shutter stack with @synergyTechName and pulses a controlled pull through @techName. The bolus breaks, the screen clears, and draw returns to spec.",
                "fail": "The team cycles the shutter off time. The bolus compacts against the screen and the draw drops further."
            }
        ]
    },
    {
        "id": "biohazard_recovery_mutualist_growth_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "mutualist-growth",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Toxic Surface Binding",
                "problem": "Bench swabs show a persistent toxic residue that reappears after standard wipes. The residue spreads under heat.",
                "success": "The team cultivates @techName across the work surface to bind and metabolize the residue. Follow-up swabs return clean and the bench remains stable under load.",
                "fail": "The team seeds an incompatible culture. The residue persists and spreads into tool racks."
            },
            {
                "synergyTechniqueId": "manual-override-line",
                "title": "Fail-Safe Decon",
                "problem": "The residue source intermittently injects fresh contamination from an upstream valve when power cycles.",
                "success": "The team binds the surface with @techName and interlocks the upstream valve using @synergyTechName. Injections cease and the decon holds.",
                "fail": "The team binds the bench but leaves the valve uncontrolled. A power cycle re-seeds the surface, forcing a restart."
            },
            {
                "synergyTechniqueId": "echo-pulse-decoy",
                "title": "Wear Resistance",
                "problem": "Heavy tool traffic abrades the cultured layer faster than it can recover, reopening contamination spots. Wear patterns are visible under close inspection.",
                "success": "The team cultivates @techName with protective pods while @synergyTechName injects decoy wear signatures elsewhere. Actual wear stays concealed and the surface remains clean through the shift.",
                "fail": "The team omits the decoy pattern. Real wear becomes visible and the bench fails inspection."
            }
        ]
    },
    {
        "id": "biohazard_recovery_reflex_bloom_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "reflex-bloom",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rapid Spill Neutralization",
                "problem": "A transport cart overturns, releasing a reactive slurry across a sloped floor. The spill advances toward a drain that feeds a clean zone.",
                "success": "The team triggers @techName to raise fast-growing absorbent mats along the downslope. The spill arrests at the mats and is lifted in sections.",
                "fail": "The team seeds too sparsely. The spill threads gaps between mats and breaches the drain grate."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Timed Drop Coverage",
                "problem": "Multiple spill fronts advance simultaneously in a large hall. Manual placement cannot cover all fronts in time.",
                "success": "The team stages mats with @techName and coordinates drone drops via @synergyTechName on a shared timer. Coverage meets the fronts and the hall is secured.",
                "fail": "The team mis-times the drops. A front outruns the coverage and enters the stairwell."
            },
            {
                "synergyTechniqueId": "spore-veil",
                "title": "Aerosol Suppression",
                "problem": "As the mats engage, aerosol counts spike above safe limits near the ceiling returns.",
                "success": "The team continues mat deployment with @techName and casts @synergyTechName across the return path. Aerosol counts fall below threshold and cleanup proceeds.",
                "fail": "The team neglects the return path. Aerosols trip the clean-zone intake and force an evacuation."
            }
        ]
    }
];
const $ce6dd72bc4611534$export$aeeef991191508e2 = {
    dominion: {
        name: "Dominion",
        icon: "\uD83D\uDD27",
        description: "Engineers and systems tacticians who restore, command, and repurpose lost technology in collapsed zones.",
        doctrine: "Doctrine: the collapse was machine logic outgrowing its makers. Recover the systems, and prove they can be governed.",
        skills: {
            "signal-relay": {
                icon: "\uD83D\uDCE1",
                name: "Signal Relay",
                description: "Reestablish or hijack long-range comms and data channels. Critical for network access and relay synchronization.",
                short: "Rebuilds or hijacks damaged communication networks."
            },
            "system-override": {
                icon: "\uD83D\uDCBB",
                name: "System Override",
                description: "Force reboots or assume control of compromised automation, defense turrets, or AI cores.",
                short: "Takes control of hostile machines or security systems."
            },
            "drone-command": {
                icon: "\uD83E\uDD16",
                name: "Drone Command",
                description: "Deploy autonomous or semi-autonomous drones for recon, repair, or field logistics.",
                short: "Uses drones for recon, repair, or support tasks."
            },
            "safeguard": {
                icon: "\u26A0\uFE0F",
                name: "Safeguard",
                description: "Reinforce failing circuits and safety systems to neutralize energy surges, power faults, or mechanical hazards.",
                short: "Restores stability to compromised power or safety systems."
            },
            "quantum-scan": {
                icon: "\uD83D\uDD2C",
                name: "Quantum Scan",
                description: "Map rift distortions and energy signatures. Essential for predicting anomaly behavior and safe extraction routes.",
                short: "Scans anomalies to predict energy patterns and distortions."
            }
        }
    },
    wilders: {
        name: "Wilders",
        icon: "\uD83C\uDF3F",
        description: "Biotech operatives and survival engineers dedicated to restoring life systems and adapting to hostile biomes.",
        doctrine: "Doctrine: the collapse was the living world rejecting a synthetic one. Read what survived; it knows more than we do.",
        skills: {
            "reclamation": {
                icon: "\uD83C\uDF31",
                name: "Reclamation",
                description: "Harvest bioactive compounds and structural tissue from degraded ecosystems for reuse or study.",
                short: "Extracts valuable bio-materials from decayed environments."
            },
            "growth-control": {
                icon: "\uD83C\uDF3F",
                name: "Growth Control",
                description: "Trigger accelerated plant or fungal growth to reinforce cover, create paths, or seal breaches.",
                short: "Uses rapid growth to shape terrain or create cover."
            },
            "wild-influence": {
                icon: "\uD83E\uDD8E",
                name: "Wild Influence",
                description: "Apply biochemical signals or pheromone fields to calm or redirect aggressive wildlife.",
                short: "Calms or redirects aggressive wildlife using biotech signals."
            },
            "bio-shield": {
                icon: "\uD83E\uDDEC",
                name: "Bio Shield",
                description: "Enhance resistance to toxins, pathogens, and radiation through symbiotic nanobiotics.",
                short: "Boosts resistance to toxins and harsh environments."
            },
            "containment": {
                icon: "\u2623\uFE0F",
                name: "Containment",
                description: "Stabilize contaminated zones and safely extract volatile organic material for research or trade.",
                short: "Recovers resources from contaminated or hazardous biozones."
            }
        }
    },
    veil: {
        name: "Veil",
        icon: "\uD83D\uDC64",
        description: "Infiltrators and intelligence specialists operating beyond conventional detection.",
        doctrine: "Doctrine: the collapse was oversight failing, then covering for itself. Recover the records nobody meant to leave behind.",
        skills: {
            "echo-trace": {
                icon: "\uD83D\uDDFA\uFE0F",
                name: "Echo Trace",
                description: "Use reflected signals to reveal hidden paths and phase corridors within unstable structures.",
                short: "Reveals hidden rooms and routes using signal resonance."
            },
            "lock-breach": {
                icon: "\uD83D\uDD13",
                name: "Lock Breach",
                description: "Bypass hardened locks, vaults, and access gates using precision tools and exploit mapping.",
                short: "Bypasses security locks and restricted access systems."
            },
            "stealth-transit": {
                icon: "\uD83D\uDC64",
                name: "Stealth Transit",
                description: "Traverse sensor grids and motion fields undetected. Minimizes signature footprint during raids.",
                short: "Moves unseen through sensor and motion grids."
            },
            "signal-mask": {
                icon: "\uD83D\uDC7B",
                name: "Signal Mask",
                description: "Scramble biometric, radio, and digital traces to evade active tracking systems.",
                short: "Erases traces to evade tracking and surveillance."
            },
            "transit-anchor": {
                icon: "\uD83C\uDF00",
                name: "Transit Anchor",
                description: "Deploy stabilization anchors and mapping scanners to cross collapsed or structurally unstable terrain safely.",
                short: "Stabilizes collapsed terrain for safe traversal."
            }
        }
    }
};
const $ce6dd72bc4611534$export$34780191873b7917 = {
    dominion: {
        names: [
            "Cipher",
            "Circuit",
            "Nova",
            "Volt",
            "Nexus",
            "Binary",
            "Synth",
            "Logic",
            "Vector",
            "Matrix",
            "Atlas",
            "Chrome",
            "Pulse",
            "Core",
            "Apex",
            "Titan",
            "Forge",
            "Grid",
            "Node",
            "Prime",
            "Beacon",
            "Prism",
            "Zenith",
            "Vortex",
            "Helix",
            "Cortex",
            "Axis",
            "Flux",
            "Echo",
            "Surge"
        ],
        surnames: [
            "Steelwright",
            "Circuitborn",
            "Wireframe",
            "Dataforge",
            "Ironcode",
            "Techbane",
            "Gridlock",
            "Megabyte",
            "Quantumspark",
            "Neurolink",
            "Gearsmith",
            "Boltweaver",
            "Chromeheart",
            "Sparkforge",
            "Titanshield",
            "Datastream",
            "Wireborn",
            "Primecore",
            "Vaultkeeper",
            "Ciphersong",
            "Powergrid",
            "Logicblade",
            "Nanotech",
            "Cybervault",
            "Mechanix",
            "Voltstream",
            "Bytebane",
            "Coderune",
            "Synthwave",
            "Nexusforge"
        ]
    },
    wilders: {
        names: [
            "Sage",
            "Thorn",
            "Moss",
            "Fern",
            "Root",
            "Bloom",
            "Grove",
            "Ivy",
            "Cedar",
            "Briar",
            "Hazel",
            "Ash",
            "Elm",
            "Oak",
            "Pine",
            "Birch",
            "Willow",
            "Maple",
            "Aspen",
            "Laurel",
            "Clover",
            "Meadow",
            "Reed",
            "Sorrel",
            "Basil",
            "Juniper",
            "Cypress",
            "Alder",
            "Rowan",
            "Yarrow"
        ],
        surnames: [
            "Greenmane",
            "Thornweaver",
            "Rootwalker",
            "Wildgrow",
            "Mosscloak",
            "Seedwhisper",
            "Fernblade",
            "Vineborn",
            "Petalstorm",
            "Barkskin",
            "Leafdancer",
            "Brambleheart",
            "Dewsong",
            "Earthshade",
            "Wildroot",
            "Stormgrow",
            "Branchbinder",
            "Flowersong",
            "Earthkeeper",
            "Treeborne",
            "Raincaller",
            "Windleaf",
            "Sunpetal",
            "Moonblossom",
            "Wildmane",
            "Spiritseed",
            "Grovewalker",
            "Thornshield",
            "Lifewoven",
            "Forestborn"
        ]
    },
    veil: {
        names: [
            "Shadow",
            "Wraith",
            "Mist",
            "Echo",
            "Shade",
            "Whisper",
            "Ghost",
            "Raven",
            "Void",
            "Phantom",
            "Dusk",
            "Twilight",
            "Nocturne",
            "Umbra",
            "Gloom",
            "Haze",
            "Murk",
            "Shimmer",
            "Shroud",
            "Veil",
            "Smoke",
            "Mirage",
            "Specter",
            "Sable",
            "Onyx",
            "Obsidian",
            "Eclipse",
            "Nebula",
            "Drift",
            "Abyss"
        ],
        surnames: [
            "Shadowmere",
            "Voidwalker",
            "Nightfall",
            "Darkweaver",
            "Mistral",
            "Grimshade",
            "Blackdrift",
            "Ghostbane",
            "Veilborn",
            "Wraithcloak",
            "Nightwhisper",
            "Duskblade",
            "Silentmoon",
            "Darkmist",
            "Voidheart",
            "Shadowstride",
            "Ghostwind",
            "Nightveil",
            "Phantomborn",
            "Dimwalker",
            "Umbramere",
            "Eclipsesoul",
            "Twilightborne",
            "Duskmantle",
            "Murkweaver",
            "Hazewalker",
            "Smokesinger",
            "Gloomward",
            "Shroudkeeper",
            "Mirageborn"
        ]
    }
};
const $ce6dd72bc4611534$export$3e15389530921005 = {
    material: {
        common: [
            "Scavenged parts\u2014still serviceable.",
            "Field scrap, stripped clean of charge.",
            "Useful metal, no corrosion yet.",
            "Reclaimed fittings\u2014just needs polish.",
            "Someone\u2019s repair job didn\u2019t hold, but the parts did."
        ],
        rare: [
            "Intact components\u2014hard find this deep.",
            "Precision stock, good for another build.",
            "Recovered hardware, still calibrated.",
            "High-grade alloy, likely pre-Collapse.",
            "Pulled from the wreck, still hums faintly."
        ]
    },
    consumable: {
        common: [
            "Standard stim\u2014quick and dirty relief.",
            "Energy patch\u2014buys a few more steps.",
            "A dose of focus, if it hasn\u2019t expired.",
            "Compact charge\u2014barely enough, but enough.",
            "You\u2019ve used worse in the field."
        ],
        rare: [
            "Advanced formula, field-sealed.",
            "Med injector, smooth burn and clean recovery.",
            "Military-issue charge, still stable.",
            "Restores more than it should\u2014must be real stock.",
            "Save it for when the lights go red."
        ],
        epic: [
            "Top-tier stabilizer, rare to see intact.",
            "Restores everything but your luck.",
            "Combat-grade surge, keep it steady.",
            "Proprietary compound\u2014whatever\u2019s inside, it works.",
            "Last-resort aid. You won\u2019t find another soon."
        ]
    },
    relic: {
        common: [
            "Old-world scrap\u2014still has form, not function.",
            "Traces of utility, stripped long ago.",
            "A small story, buried in rust.",
            "Every mark means it mattered to someone.",
            "Forgotten tool, remembered by the metal."
        ],
        rare: [
            "Recovered relic with partial circuitry.",
            "Design\u2019s old, but the craftsmanship holds.",
            "It hums when touched\u2014residual charge, maybe.",
            "Half-art, half-instrument\u2014purpose unclear.",
            "Recovered from deeper layers, mostly intact."
        ],
        epic: [
            "Pristine core\u2014untouched since the Fall.",
            "A perfect survivor of imperfect times.",
            "Feels almost deliberate that it lasted.",
            "The lines are clean, the memory sharper.",
            "Carries weight that\u2019s more than metal."
        ]
    },
    blueprint: {
        legendary: [
            "Detailed schematic\u2014someone planned to rebuild.",
            "Blueprint sealed under dust and heat.",
            "This map shows what was possible once.",
            "A guide to lost craftsmanship, now in your hands.",
            "If you can read it, you can make it real."
        ]
    },
    storyRelic: {
        unique: [
            "It vibrates faintly, like it remembers you.",
            "What it shows isn\u2019t gone\u2014just out of reach.",
            "Feels heavier than it looks. Memory weight.",
            "History condensed into one impossible fragment.",
            "It doesn\u2019t tell stories\u2014it keeps them."
        ]
    },
    credits: {
        currency: [
            "Still accepted by the desperate and the wise.",
            "Old world money, still spinning through new hands.",
            "Trade keeps the silence at bay.",
            "Worth more in motion than in storage.",
            "Proof that some systems never collapse."
        ]
    }
};
const $ce6dd72bc4611534$export$ca2adec0fe632974 = {
    dominion: [
        "Factory specs check out.",
        "Data tag matches.",
        "Keep it cataloged.",
        "Run diagnostics."
    ],
    wilders: [
        "Smells alive.",
        "Roots remember.",
        "Still breathing.",
        "Handle like it grows."
    ],
    veil: [
        "No witnesses.",
        "Leave no trace.",
        "Not on any manifest.",
        "Burn the logs."
    ]
};
const $ce6dd72bc4611534$export$732c9d6827dc2245 = {
    hazard: [
        "ion-stained",
        "biofilm slick",
        "burnt edges",
        "cracked seals",
        "chemical haze"
    ],
    location: [
        "collapsed gantry",
        "sealed rack",
        "growth-choked vent",
        "sunken conduit",
        "buried access point"
    ],
    action: [
        "pried free",
        "cut loose",
        "lifted clean",
        "extracted carefully",
        "dug out by hand"
    ]
};
const $ce6dd72bc4611534$export$9be8953559278e7 = {
    // === DOMINION ===
    "signal-relay": {
        roles: [
            "Comms Tech",
            "Relay Engineer",
            "Signal Operator",
            "Data Link Specialist",
            "Transceiver Mechanic"
        ],
        // Command-rank counterparts, index-matched to roles[] (assigned at promotion)
        promotedRoles: [
            "Signals Directorate Chief",
            "Relay Network Commander",
            "Uplink Operations Director",
            "Data Corridor Overseer",
            "Transmission Fleet Marshal"
        ],
        // Welcome from a command member, index-matched to promotedRoles[]
        // (shown in the promote dialog when the new post is announced)
        promotedQuotes: [
            "\u201CEvery frequency the Dominion holds now routes through your desk. Speak, and the whole network leans in to listen.\u201D",
            "\u201CThe towers you patched under fire are a war map on your wall now. Keep every line singing, Commander.\u201D",
            "\u201CGround to orbit, orbit to home \u2014 the uplink schedule is yours. Nothing leaves this world without your signature.\u201D",
            "\u201CYou walked the data corridors when they were static and ruin. Now every packet that survives the wastes pays toll to you.\u201D",
            "\u201CThe relay fleet answers to your call sign now, Marshal. Where you park those dishes decides who gets heard.\u201D"
        ],
        quotes: [
            "\u201CNoise is just data waiting to be translated.\u201D",
            "\u201CEvery message finds its way eventually.\u201D",
            "\u201CDead air is still information.\u201D",
            "\u201CI speak fluent interference.\u201D",
            "\u201CYou can\u2019t hide from a tuned array.\u201D"
        ]
    },
    "system-override": {
        roles: [
            "Control Hacker",
            "Override Specialist",
            "Security Engineer",
            "Core Manipulator",
            "Protocol Breacher"
        ],
        promotedRoles: [
            "Intrusion Doctrine Chief",
            "Override Command Architect",
            "Security Directorate Head",
            "Core Systems Overseer",
            "Protocol Warfare Strategist"
        ],
        promotedQuotes: [
            "\u201CYour field exploits are the textbook now, Chief. Every recruit learns to break a system the way you broke a hundred.\u201D",
            "\u201CYou built override rigs from scrap while sirens screamed. Design our command architecture \u2014 this time nothing pushes back.\u201D",
            "\u201CThe Dominion\u2019s locks, walls, and watchdogs report to you now. Nobody gets past what you couldn\u2019t get past first.\u201D",
            "\u201CEvery core we still control hums under your hand, Overseer. Keep them obedient \u2014 you know exactly how they fail.\u201D",
            "\u201CYou out-argued hostile machines at gunpoint. Now you write the protocols that win before the argument starts.\u201D"
        ],
        quotes: [
            "\u201CGive me root access and ten seconds.\u201D",
            "\u201CSystems break themselves\u2014I just hurry them along.\u201D",
            "\u201CFirewalls are for decoration.\u201D",
            "\u201CI don\u2019t bypass security\u2014I rewrite it.\u201D",
            "\u201CEvery system obeys; it just needs persuasion.\u201D"
        ]
    },
    "drone-command": {
        roles: [
            "Drone Pilot",
            "Field Operator",
            "Remote Systems Tech",
            "Autonomy Engineer",
            "Aerial Recon Chief"
        ],
        promotedRoles: [
            "Drone Wing Commander",
            "Field Operations Director",
            "Remote Fleet Coordinator",
            "Autonomy Program Chair",
            "Recon Command Marshal"
        ],
        promotedQuotes: [
            "\u201CThe wings you flew solo now fly in your formation, Commander. A thousand rotors hold pattern waiting on your word.\u201D",
            "\u201CField operations runs on your playbook now. Every operator down-well moves the way you taught the machines to move.\u201D",
            "\u201CEvery drone the Dominion fields checks home to your board. Route them well \u2014 you remember what the ground costs.\u201D",
            "\u201CYour autonomy heuristics graduate today, Chair. Teach the fleet to think the way you flew: carefully, and all the way home.\u201D",
            "\u201CThe recon wing is yours, Marshal. Nothing crosses the wastes unseen while your birds are up.\u201D"
        ],
        quotes: [
            "\u201CIf it\u2019s in range, it\u2019s in control.\u201D",
            "\u201CYou can\u2019t ambush a drone with anxiety.\u201D",
            "\u201CThree drones, two hands, one coffee.\u201D",
            "\u201CNever send a person when a circuit will do.\u201D",
            "\u201CMy drones have more personality than most people.\u201D"
        ]
    },
    "safeguard": {
        roles: [
            "Hazard Control Officer",
            "Containment Engineer",
            "Field Safety Tech",
            "Thermal Specialist",
            "Environmental Regulator"
        ],
        promotedRoles: [
            "Hazard Doctrine Commander",
            "Containment Program Director",
            "Field Safety Commandant",
            "Thermal Systems Overseer",
            "Environmental Command Chief"
        ],
        promotedQuotes: [
            "\u201CYour close calls became checklists, and your checklists became doctrine. Crews come home now because once, you almost didn\u2019t.\u201D",
            "\u201CThe containment program carries your name in its footnotes, Director. Run it so no one ever learns what it contains.\u201D",
            "\u201CCommandant of everything that keeps a raider breathing. Drill them hard \u2014 the wastes drill harder.\u201D",
            "\u201CEvery reactor jacket and heat sink in the fleet is your watch now. Cold numbers, warm crews.\u201D",
            "\u201CThe habitat domes hold because somebody obsessed over seals and sensors. Keep obsessing, Chief.\u201D"
        ],
        quotes: [
            "\u201CIf you\u2019re sweating, it\u2019s already too late.\u201D",
            "\u201CNothing\u2019s unmanageable\u2014just unprepared for.\u201D",
            "\u201CFire, gas, acid\u2014same dance, different tempo.\u201D",
            "\u201CI clean up everyone else\u2019s mistakes.\u201D",
            "\u201CYou\u2019ll thank me when you\u2019re still breathing.\u201D"
        ]
    },
    "quantum-scan": {
        roles: [
            "Rift Analyst",
            "Anomaly Researcher",
            "Quantum Field Tech",
            "Data Collapse Theorist",
            "Reality Modeler"
        ],
        promotedRoles: [
            "Rift Intelligence Chief",
            "Anomaly Research Director",
            "Quantum Survey Commander",
            "Collapse Theory Chair",
            "Reality Modeling Overseer"
        ],
        promotedQuotes: [
            "\u201CYou read the rifts back when reading them cost people their minds. Every anomaly report crosses your desk first now.\u201D",
            "\u201CThe research wing is yours, Director. Chase what the collapse left behind \u2014 carefully. Some of it chases back.\u201D",
            "\u201CEvery survey grid we chart follows your calibrations now, Commander. Map the impossible; the fleet steers by it.\u201D",
            "\u201CYour models kept this Chair empty until someone could actually fill it. Sit down.\u201D",
            "\u201CReality bends near the shards, Overseer. Your models are the only straight lines we trust.\u201D"
        ],
        quotes: [
            "\u201CThe math doesn\u2019t lie, but it does laugh.\u201D",
            "\u201CObserve first. Panic later.\u201D",
            "\u201CReality jitters; I just measure the tremor.\u201D",
            "\u201CPrediction is just organized superstition.\u201D",
            "\u201CIf you can\u2019t explain it, log it twice.\u201D"
        ]
    },
    // === WILDERS ===
    "reclamation": {
        roles: [
            "Bio-Salvager",
            "Tissue Reclaimer",
            "Eco-Recycler",
            "Harvest Operative",
            "Spore Diver"
        ],
        promotedRoles: [
            "Salvage Circle Elder",
            "Reclamation Warden",
            "Renewal Council Chief",
            "Harvest Doctrine Keeper",
            "Deep Spore Marshal"
        ],
        promotedQuotes: [
            "\u201CThe Salvage Circle keeps a seat of ruin-wood for you, Elder. What you pulled from the wreckage taught us what was worth pulling.\u201D",
            "\u201CWarden of everything the world threw away. Walk the reclaim-fields and decide what gets a second life.\u201D",
            "\u201CThe Renewal Council speaks with your voice now. Where you point, the green follows.\u201D",
            "\u201CYou gathered when gathering was starving work. Keep the harvest doctrine, and no circle goes hungry again.\u201D",
            "\u201CThe deep spore beds answer to you now, Marshal. Tend what grows in the dark \u2014 it remembers who fed it.\u201D"
        ],
        quotes: [
            "\u201CEvery ruin has roots.\u201D",
            "\u201CDecay\u2019s just another kind of growth.\u201D",
            "\u201CYou find beauty in the rot.\u201D",
            "\u201CNature wastes nothing\u2014why should I?\u201D",
            "\u201CDead ecosystems make the best teachers.\u201D"
        ]
    },
    "growth-control": {
        roles: [
            "Spore Architect",
            "Growth Technician",
            "Bio-Builder",
            "Verdant Engineer",
            "Mycelial Sculptor"
        ],
        promotedRoles: [
            "Architect of the Canopy",
            "Growth Doctrine Warden",
            "Living Works Overseer",
            "Verdant Command Elder",
            "Mycelial Council Chief"
        ],
        promotedQuotes: [
            "\u201CThe canopy you coaxed over ruins now shades three settlements. Architect, the skyline is yours to grow.\u201D",
            "\u201CGrowth without doctrine is just another collapse. You learned where the line is \u2014 hold it for all of us.\u201D",
            "\u201CEvery living wall and root-bridge we raise is your works order now, Overseer. Build us shelter that heals itself.\u201D",
            "\u201CThe Verdant Command has an elder\u2019s place ready. You made the wastes bloom on a schedule; teach us the timing.\u201D",
            "\u201CThe mycelial web already knows your hands. Chief, sit with the Council \u2014 the network has been asking for you.\u201D"
        ],
        quotes: [
            "\u201CYou don\u2019t build walls\u2014you grow them.\u201D",
            "\u201CPatience is the fastest method.\u201D",
            "\u201CGive it time and light\u2014it\u2019ll move mountains.\u201D",
            "\u201CBlueprints are for people who don\u2019t trust roots.\u201D",
            "\u201CEvery structure wants to bloom.\u201D"
        ]
    },
    "wild-influence": {
        roles: [
            "Beast Handler",
            "Bio-Communicator",
            "Eco-Mediator",
            "Creature Whisperer",
            "Wildlife Operative"
        ],
        promotedRoles: [
            "Beastmaster General",
            "Communion Council Elder",
            "Mediation Doctrine Keeper",
            "Whisper Circle Warden",
            "Wildlands Marshal"
        ],
        promotedQuotes: [
            "\u201CThe herds that once scattered raiding parties now hold our perimeter. General, the wild fights beside us because of you.\u201D",
            "\u201CYou listened when everything out there wanted us dead. The Communion Council keeps an elder\u2019s seat for the best listener we have.\u201D",
            "\u201CEvery truce between tooth and settlement follows your mediation doctrine now. Keep the peace you invented.\u201D",
            "\u201CWarden of the Whisper Circle. The creatures already answer to your voice \u2014 now our handlers will too.\u201D",
            "\u201CThe wildlands between the circles are yours to marshal. Nothing moves out there you don\u2019t already understand.\u201D"
        ],
        quotes: [
            "\u201CEverything alive understands tone.\u201D",
            "\u201CYou calm the world by moving slower.\u201D",
            "\u201CTrust starts with eye contact\u2014even with fangs.\u201D",
            "\u201CPredators aren\u2019t cruel, just honest.\u201D",
            "\u201CFear smells louder than blood.\u201D"
        ]
    },
    "bio-shield": {
        roles: [
            "Bio-Resonant Operative",
            "Adaptive Host",
            "Symbiosis Technician",
            "Mutation Researcher",
            "Genetic Integrator"
        ],
        promotedRoles: [
            "Resonance Doctrine Elder",
            "Adaptation Council Chief",
            "Symbiosis Program Warden",
            "Mutation Studies Chair",
            "Integration Command Elder"
        ],
        promotedQuotes: [
            "\u201CYour body learned the wastes\u2019 frequencies before our instruments did. Elder, the resonance doctrine is written from your scars.\u201D",
            "\u201CThe Adaptation Council needs a chief who changed instead of breaking. Show the circles how to bend.\u201D",
            "\u201CWarden of every paired life in the program. What grows on us, grows with us \u2014 you proved that first.\u201D",
            "\u201CThe Mutation Studies Chair is not a safe seat. You\u2019ve never once asked for a safe seat.\u201D",
            "\u201CIntegration is the long war, Elder \u2014 flesh, spore, and machine learning to share a body politic. Command it kindly.\u201D"
        ],
        quotes: [
            "\u201CAdapt or decompose.\u201D",
            "\u201CEvolution doesn\u2019t wait for permission.\u201D",
            "\u201CIf it itches, it\u2019s working.\u201D",
            "\u201CYou call it infection\u2014I call it upgrade.\u201D",
            "\u201CChange hurts. That\u2019s how you know it\u2019s real.\u201D"
        ]
    },
    "containment": {
        roles: [
            "Hazmat Reclaimer",
            "Biohazard Diver",
            "Containment Scout",
            "Toxic Zone Operative",
            "Decon Specialist"
        ],
        promotedRoles: [
            "Quarantine Council Chief",
            "Deep Hazard Warden",
            "Containment Doctrine Keeper",
            "Exclusion Zone Marshal",
            "Decontamination Elder"
        ],
        promotedQuotes: [
            "\u201CThe Quarantine Council answers to the one person who never cut a corner on a seal. Chief, the lines you draw hold.\u201D",
            "\u201CWarden of the deep hazards. What sleeps below the reclaim-fields stays asleep on your watch.\u201D",
            "\u201CYour containment rites are doctrine now, Keeper. Teach them exactly \u2014 the spores don\u2019t forgive improvisation.\u201D",
            "\u201CThe exclusion zones are mapped in your handwriting, Marshal. Keep the living side of every fence living.\u201D",
            "\u201CElder of the cleansing pools. Everything that comes home from the wastes passes through your hands first.\u201D"
        ],
        quotes: [
            "\u201CIf it glows, bag it.\u201D",
            "\u201CSafety\u2019s a spectrum.\u201D",
            "\u201CYou can\u2019t clean the world, just manage it.\u201D",
            "\u201CI\u2019ve seen things grow where nothing should.\u201D",
            "\u201CIf the mask fogs, run.\u201D"
        ]
    },
    // === VEIL ===
    "social-engineering": {
        roles: [
            "Persuasion Analyst",
            "Influence Operative",
            "Behavioral Infiltrator",
            "Social Architect",
            "Echo Diplomat"
        ],
        promotedRoles: [
            "Persuasion Directorate Head",
            "Influence Network Handler",
            "Behavioral Doctrine Chief",
            "Grand Social Architect",
            "Shadow Envoy Prime"
        ],
        promotedQuotes: [
            "\u201CYou talked your way past things that don\u2019t have ears. The Persuasion Directorate is yours \u2014 mind the mirrors.\u201D",
            "\u201CEvery asset, informant, and friendly stranger in five regions now reports to your ledger, Handler.\u201D",
            "\u201CYour read on a room became our behavioral doctrine, Chief. People are locks; you wrote the picks.\u201D",
            "\u201CArchitect, the web of favors you spun in the field holds half our operations aloft. Keep spinning.\u201D",
            "\u201CEnvoy Prime. When the Veil must be seen, it will wear your face \u2014 and no one will remember it.\u201D"
        ],
        quotes: [
            "\u201CTruth is just confidence with better posture.\u201D",
            "\u201CEveryone wants to believe they\u2019re in control.\u201D",
            "\u201CLies travel faster when you smile.\u201D",
            "\u201CI sell trust, not information.\u201D",
            "\u201CIf you think I\u2019m honest, I\u2019ve already won.\u201D"
        ]
    },
    "echo-trace": {
        roles: [
            "Echo Listener",
            "Trace Analyst",
            "Sonar Operator",
            "Signal Tracker",
            "Resonance Scout"
        ],
        promotedRoles: [
            "Echo Doctrine Keeper",
            "Trace Directorate Head",
            "Deep Sonar Marshal",
            "Tracking Cell Handler",
            "Resonance Intelligence Chief"
        ],
        promotedQuotes: [
            "\u201CYou heard the city\u2019s bones settle and knew which rooms were safe. Keeper, the echo doctrine is your ear, written down.\u201D",
            "\u201CThe Trace Directorate follows anything that leaves a ripple. Head it \u2014 nothing has ever slipped past you twice.\u201D",
            "\u201CDeep Sonar Marshal. The sunken levels talk in pressure and echo, and you\u2019re the only one fluent.\u201D",
            "\u201CYour cells can find a heartbeat in a hurricane now, Handler. Teach them which heartbeats matter.\u201D",
            "\u201CChief of Resonance Intelligence: every hum, knock, and silence the Veil records is evidence on your desk.\u201D"
        ],
        quotes: [
            "\u201CEverything leaves an echo. I just wait for it.\u201D",
            "\u201CSilence has a shape, if you listen.\u201D",
            "\u201CThe walls talk. I take notes.\u201D",
            "\u201CYou can stop moving. You can\u2019t stop resonating.\u201D",
            "\u201CI found you three corridors ago.\u201D"
        ]
    },
    "lock-breach": {
        roles: [
            "Breach Tech",
            "Vault Specialist",
            "Security Bypass Expert",
            "Lockpulse Engineer",
            "Intrusion Mechanic"
        ],
        promotedRoles: [
            "Breach Doctrine Master",
            "Vault Directorate Head",
            "Bypass Program Chief",
            "Lockpulse Guild Master",
            "Intrusion Cell Handler"
        ],
        promotedQuotes: [
            "\u201CEvery door you opened quietly is a chapter in the breach doctrine now. Master, teach the click before the open.\u201D",
            "\u201CThe Vault Directorate keeps what the Veil cannot afford to lose. Fitting that its head is the one no vault could keep out.\u201D",
            "\u201CChief of the bypass program: every lock the collapse left behind, catalogued, studied, and already yours.\u201D",
            "\u201CThe Lockpulse Guild took a vote. It was unanimous, Master \u2014 even the abstentions were just showing respect.\u201D",
            "\u201CYour cells work doors on three continents now, Handler. None of them will ever know your name. That\u2019s the compliment.\u201D"
        ],
        quotes: [
            "\u201CEverything opens with the right rhythm.\u201D",
            "\u201CSecurity is a suggestion.\u201D",
            "\u201CLocks are just puzzles with pride.\u201D",
            "\u201CThe click before the open is the best sound.\u201D",
            "\u201CIf I can\u2019t open it, it\u2019s cursed.\u201D"
        ]
    },
    "stealth-transit": {
        roles: [
            "Stealth Operative",
            "Scout",
            "Field Infiltrator",
            "Veil Runner",
            "Low-Signature Agent"
        ],
        promotedRoles: [
            "Infiltration Doctrine Lead",
            "Pathfinder Directorate Head",
            "Deep Cover Handler",
            "First Runner of the Veil",
            "Ghost Protocol Chief"
        ],
        promotedQuotes: [
            "\u201CThe routes you walked alone are the infiltration doctrine now. Lead, and the Veil moves where you moved.\u201D",
            "\u201CPathfinder Directorate is yours. Every safe corridor on the map exists because you crossed it first, unsafely.\u201D",
            "\u201CYour covers held longer than some careers. Handler, run the deep assets \u2014 you know what the silence costs them.\u201D",
            "\u201CFirst Runner. When there is no route, no map, and no time, the Veil sends you. It is not a desk. Congratulations anyway.\u201D",
            "\u201CGhost Protocol has a chief again. Nobody saw the last one leave, and nobody saw you arrive. Perfect continuity.\u201D"
        ],
        quotes: [
            "\u201CI\u2019m not invisible. You\u2019re just distracted.\u201D",
            "\u201CNoise gets people killed.\u201D",
            "\u201CIf you hear me, you\u2019re already too close.\u201D",
            "\u201CI move between moments.\u201D",
            "\u201CThe dark\u2019s not hiding me\u2014I\u2019m hiding it.\u201D"
        ]
    },
    "signal-mask": {
        roles: [
            "Signal Ghost",
            "Trace Eraser",
            "Silent Specialist",
            "Obfuscation Operative",
            "Data Mirage Agent"
        ],
        promotedRoles: [
            "Ghost Network Director",
            "Erasure Doctrine Chief",
            "Silence Directorate Head",
            "Obfuscation Cell Handler",
            "Mirage Program Master"
        ],
        promotedQuotes: [
            "\u201CThe ghost network carries every whisper the Veil owns, Director, and it hums at frequencies you invented.\u201D",
            "\u201CYou erased trails the Dominion still bills as archive corruption. Chief, the erasure doctrine is your confession \u2014 unsigned.\u201D",
            "\u201CHead of the Silence Directorate. Your job is that nothing is ever heard. Your qualification is that nothing ever was.\u201D",
            "\u201CYour static-craft keeps our cells invisible mid-transmission, Handler. Teach them to disappear while speaking.\u201D",
            "\u201CMaster of the Mirage Program: every false signal, phantom convoy, and decoy city is staged under your hand now.\u201D"
        ],
        quotes: [
            "\u201CIf they can\u2019t log it, it didn\u2019t happen.\u201D",
            "\u201CProof is the weakest link.\u201D",
            "\u201CRecords vanish; I remain.\u201D",
            "\u201CYou can\u2019t find what never existed.\u201D",
            "\u201CLogs lie. I don\u2019t.\u201D"
        ]
    },
    "transit-anchor": {
        roles: [
            "Field Phasist",
            "Dimensional Scout",
            "Boundary Operative",
            "Spatial Recon Agent",
            "Phase Diver"
        ],
        promotedRoles: [
            "Phase Doctrine Master",
            "Dimensional Survey Head",
            "Boundary Directorate Chief",
            "Spatial Intelligence Handler",
            "Deep Phase Marshal"
        ],
        promotedQuotes: [
            "\u201CYou anchored crossings that should have scattered whole teams into the between. Master, the phase doctrine is your handwriting.\u201D",
            "\u201CThe dimensional survey is yours to head. Chart the soft places \u2014 and mark clearly where the map should lie.\u201D",
            "\u201CChief of the Boundary Directorate. The lines between here and elsewhere hold because you know exactly how thin they are.\u201D",
            "\u201CEvery anomalous crossing report lands on your desk now, Handler. You\u2019ve stood in most of them.\u201D",
            "\u201CDeep Phase Marshal. Past a certain depth the transit stops being travel and starts being negotiation. You always came back \u2014 teach that.\u201D"
        ],
        quotes: [
            "\u201CSpace folds if you know where to press.\u201D",
            "\u201CPhysics is a matter of confidence.\u201D",
            "\u201CWalls are only polite suggestions.\u201D",
            "\u201CIf you feel a tug, don\u2019t fight it.\u201D",
            "\u201CEverything solid is just waiting to blur.\u201D"
        ]
    }
};
const $ce6dd72bc4611534$export$1aaffaaaf67a009d = [
    // ===============================
    // Skill Success Bonuses
    // Increases technique success chance for all techniques in a skill (used by skill artifacts)
    // Applied to specific skills via skill field on artifacts
    // ===============================
    {
        id: "skill-success-bonus",
        type: "skill_success_bonus",
        value: 5,
        unit: "percent",
        description: "Increases technique success chance during room events",
        icon: "\uD83C\uDFAF\u2728"
    },
    // ===============================
    // Currency & Payout Bonuses
    // Increases credits earned from data caches and contracts
    // ===============================
    {
        id: "currency-bonus",
        type: "currency_bonus",
        value: 5,
        unit: "percent",
        description: "Increases credits from recovered data caches",
        icon: "\uD83D\uDCBE\uD83D\uDCB0"
    },
    {
        id: "contractor-payout-bonus",
        type: "currency_bonus",
        value: 10,
        unit: "percent",
        category: "contractor",
        description: "Increases payout from successful support contracts",
        icon: "\uD83D\uDCE1\uD83D\uDCB0"
    },
    // ===============================
    // Item Quality & Discovery Bonuses
    // Improves rarity rolls and discovery chance for special items
    // ===============================
    {
        id: "relic-quality-bonus",
        type: "item_quality_bonus",
        value: 10,
        unit: "percent",
        description: "Improves chances of finding higher-quality vendor relics",
        icon: "\uD83D\uDD2E\u2B06\uFE0F"
    },
    // (was "story-relic-bonus" - story relics only drop at tier 4+, which
    // doesn't exist yet; repurposed 2026-07 to blueprint discovery until the
    // story-relic content ships)
    {
        id: "blueprint-find-bonus",
        type: "item_quality_bonus",
        value: 5,
        unit: "percent",
        description: "Increases the chance of discovering legendary blueprint caches",
        icon: "\uD83D\uDCDC\u2728"
    },
    // ===============================
    // Damage Reduction & Protection
    // Reduces damage taken and prevents incapacitation
    // ===============================
    {
        id: "hazard-damage-reduction",
        type: "damage_reduction",
        value: 5,
        unit: "percent",
        description: "Reduces damage from environmental hazards",
        icon: "\u26A0\uFE0F\uD83D\uDEE1\uFE0F"
    },
    {
        id: "knockout-prevention",
        type: "knockout_prevention",
        value: 1,
        unit: "count",
        description: "Prevents first incapacitation per raid",
        icon: "\uD83D\uDC89\uD83D\uDEE1\uFE0F"
    },
    // ===============================
    // Faction Synergy Bonuses
    // Improves coordination when working with mixed-faction teams
    // ===============================
    {
        id: "faction-synergy-bonus",
        type: "faction_synergy_bonus",
        value: 5,
        unit: "percent",
        description: "Improves success when multiple factions coordinate on events",
        icon: "\uD83D\uDD00\u2728"
    },
    // ===============================
    // Skill & Support Bonuses
    // Improves effectiveness when acting in support role
    // ===============================
    {
        id: "support-skill-bonus",
        type: "skill_bonus",
        value: 2,
        unit: "percent",
        description: "Boosts skill checks when providing support during events",
        icon: "\uD83E\uDD1D\u2728"
    },
    // ===============================
    // Resource & Material Bonuses
    // Increases material yield from salvage operations
    // ===============================
    {
        id: "loot-quantity-bonus",
        type: "loot_quantity_bonus",
        value: 10,
        unit: "percent",
        description: "Increases quantity of materials recovered from events",
        icon: "\uD83D\uDCE6\u2B06\uFE0F"
    },
    {
        id: "gate-material-bonus",
        type: "material_yield_bonus",
        value: 15,
        unit: "percent",
        description: "Improves material yield from Gate rooms",
        icon: "\u26CF\uFE0F\uD83D\uDCE6"
    },
    // ===============================
    // Downtime Reduction
    // Reduces the energy cost of launching raids
    // (was "cooldown-reduction" - no raid cooldown mechanic exists; repurposed
    // 2026-07 to the real pacing resource, energy)
    // ===============================
    {
        id: "raid-energy-reduction",
        type: "raid_energy_reduction",
        value: 10,
        unit: "percent",
        description: "Reduces the energy cost of launching raids",
        icon: "\u26A1\u2B07\uFE0F"
    },
    // ===============================
    // Technique-Specific Bonuses
    // Applied to specific techniques via techniqueId on items
    // ===============================
    {
        id: "technique-success-bonus",
        type: "technique_success_bonus",
        value: 10,
        unit: "percent",
        description: "Increases technique success chance",
        icon: "\uD83D\uDD27\u2728"
    },
    // NOTE: "technique-retry" (one free retry on the technique's checks) was
    // removed from device data 2026-07-15 - a p -> 1-(1-p)^2 swing needs its
    // own balance pass. Reintroduce deliberately if a capstone effect is wanted.
    {
        id: "room-time-reduction",
        type: "room_time_reduction",
        value: 10,
        unit: "percent",
        description: "Reduces room duration when technique's usage is successful",
        icon: "\uD83D\uDD27\u23F1\uFE0F"
    }
];
const $ce6dd72bc4611534$export$d02ea220375e4aff = {
    material: {
        name: "Material",
        icon: "\uD83D\uDD27"
    },
    consumable: {
        name: "Consumable",
        icon: "\uD83E\uDDEA"
    },
    techGear: {
        name: "Skill Gear",
        icon: "\u2699\uFE0F"
    },
    artifact: {
        name: "Artifact",
        icon: "\u26A1"
    },
    blueprint: {
        name: "Blueprint",
        icon: "\uD83D\uDCCB"
    },
    relic: {
        name: "Relic",
        icon: "\uD83D\uDC8E"
    },
    storyRelic: {
        name: "Story Relic",
        icon: "\uD83C\uDF1F"
    },
    credits: {
        name: "Credits",
        icon: "\uD83D\uDCB0"
    }
};
const $ce6dd72bc4611534$export$659d2bfa35449fc3 = [
    // ===============================
    // Dominion Artifacts
    // ===============================
    {
        id: "signal-repeater-pack",
        name: "Signal Repeater Pack",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "signal-relay",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Portable backpack transceiver used to amplify or intercept long-range signals.",
        short: "Boosts or reroutes long-range communications.",
        flavor: "Old tech, new purpose\u2014signal's alive as long as the pack holds charge.",
        visual: "Backpack-sized radio with folding antenna mast, copper wiring, and carbon casing."
    },
    {
        id: "control-override-kit",
        name: "Control Override Kit",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "system-override",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Rugged field toolkit used to manually override or reboot autonomous systems.",
        short: "Grants manual control over automated or defensive systems.",
        flavor: "Every system has a door. This is the key.",
        visual: "Metal case with analog dials, fiber cables, and brass coupling clamps."
    },
    {
        id: "operator-link-harness",
        name: "Operator Link Harness",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "drone-command",
        faction: "dominion",
        icon: "\uD83E\uDD16",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Wearable control rig providing direct uplink to reconnaissance drones.",
        short: "Improves range and stability for drone operations.",
        flavor: "You don't command the drone\u2014you become its signal.",
        visual: "Chest rig with braided data cables, antenna spine, and LED activity lights."
    },
    {
        id: "stability-coupler",
        name: "Stability Coupler",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "safeguard",
        faction: "dominion",
        icon: "\u26A0\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact coupler device that redirects power surges and stabilizes damaged circuits.",
        short: "Prevents overloads and stabilizes failing systems.",
        flavor: "Keeps the grid humming when everything else falls apart.",
        visual: "Steel cylinder with magnetic clamps and heat-dispersal vents."
    },
    {
        id: "spectral-survey-scope",
        name: "Spectral Survey Scope",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "quantum-scan",
        faction: "dominion",
        icon: "\uD83D\uDD2C",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Handheld multi-spectrum scanner for detecting heat signatures and radiation leaks.",
        short: "Reveals structural and energy anomalies.",
        flavor: "If it glows, hums, or leaks radiation\u2014you'll see it first.",
        visual: "Monocular scope with glass lens, rubber grip, and digital readout."
    },
    // ===============================
    // Wilders Artifacts
    // ===============================
    {
        id: "harvesting-gauntlet",
        name: "Harvesting Gauntlet",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "reclamation",
        faction: "wilders",
        icon: "\uD83C\uDF31",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Reinforced glove with integrated sampling tools for organic material extraction.",
        short: "Extracts valuable organic materials from decayed environments.",
        flavor: "The world may rot, but the soil still breathes.",
        visual: "Leather glove with metal prongs and sap-stained plating."
    },
    {
        id: "growth-induction-pod",
        name: "Growth Induction Pod",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "growth-control",
        faction: "wilders",
        icon: "\uD83C\uDF3F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Handheld canister that releases nutrient mist and spores to trigger rapid plant growth.",
        short: "Stimulates fast vegetation growth to form cover or pathways.",
        flavor: "Press the trigger, and life remembers its old shape.",
        visual: "Metal canister with fogged glass tube and green-lit valves."
    },
    {
        id: "pheromone-relay-belt",
        name: "Pheromone Relay Belt",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "wild-influence",
        faction: "wilders",
        icon: "\uD83E\uDD8E",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact belt device emitting pheromone signals to calm or redirect wildlife.",
        short: "Redirects wildlife behavior using pheromone signals.",
        flavor: "Not control\u2014just conversation.",
        visual: "Canvas belt with small glass ampoules and brass vapor vents."
    },
    {
        id: "respirator-webbing",
        name: "Respirator Webbing",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "bio-shield",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Protective breathing rig with adaptive microbial filters for harsh biomes.",
        short: "Filters toxins and airborne contaminants in the field.",
        flavor: "Built for lungs that still believe in clean air.",
        visual: "Lightweight mask and harness with flexible tubing and filter canisters."
    },
    {
        id: "hazard-recovery-satchel",
        name: "Hazard Recovery Satchel",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "containment",
        faction: "wilders",
        icon: "\u2623\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Sealed pack with insulated containers for storing contaminated samples.",
        short: "Safely collects and stores hazardous materials.",
        flavor: "Carry the poison home, sell the antidote later.",
        visual: "Canvas satchel with metal clasps, labeled vials, and sealed lining."
    },
    // ===============================
    // Veil Artifacts
    // ===============================
    {
        id: "resonant-survey-array",
        name: "Resonant Survey Array",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "echo-trace",
        faction: "veil",
        icon: "\uD83D\uDDFA\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact scanner that maps hidden spaces using ultrasonic and optical signals.",
        short: "Reveals hidden corridors and passageways.",
        flavor: "Walls hide nothing from an echo that listens back.",
        visual: "Fold-out brass scanner with projection lens and rotating sensor arms."
    },
    {
        id: "lockpulse-breach-kit",
        name: "Lockpulse Breach Kit",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "lock-breach",
        faction: "veil",
        icon: "\uD83D\uDD13",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Portable case containing micro-drills and probe leads for lock bypassing.",
        short: "Bypasses advanced security mechanisms.",
        flavor: "Locks are just puzzles pretending to be walls.",
        visual: "Compact case with metallic tools and a glass touchpad interface."
    },
    {
        id: "silent-step-pads",
        name: "Silent Step Pads",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "stealth-transit",
        faction: "veil",
        icon: "\uD83D\uDC64",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Noise-dampening inserts that absorb motion vibration for silent movement.",
        short: "Suppresses footstep and motion noise.",
        flavor: "The loudest sound is the one you never make.",
        visual: "Thin polymer pads with translucent gel lining, faint vibration when active."
    },
    {
        id: "trace-disruptor-band",
        name: "Trace Disruptor Band",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "signal-mask",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Wrist-mounted emitter that scrambles biometric and radio signatures.",
        short: "Masks thermal and radio traces from detection.",
        flavor: "Vanish from the data before anyone reads it.",
        visual: "Titanium wristband with fiber coils and soft electromagnetic hum."
    },
    {
        id: "anchor-resonator",
        name: "Anchor Resonator",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "transit-anchor",
        faction: "veil",
        icon: "\uD83C\uDF00",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Tripod-mounted stabilizer that emits vibration to settle debris for safe crossing.",
        short: "Stabilizes terrain for safe traversal.",
        flavor: "You can't fix the world, but you can stop it from falling on you.",
        visual: "Carbon tripod with steel joints and an amber-glowing stabilizer core."
    }
];
const $ce6dd72bc4611534$export$709aa55c173a48b8 = [
    {
        id: "data-cache-drive",
        name: "Data Cache Drive",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCBE",
        effects: {
            "currency-bonus": 5
        },
        description: "Rugged steel data drive recovered from collapsed networks.",
        short: "Increases payout from recovered data caches.",
        flavor: "Someone's last backup became your payday.",
        visual: "Steel-plated drive with cracked glass indicator and cable port."
    },
    {
        id: "relic-resonance-tuner",
        name: "Relic Resonance Tuner",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        effects: {
            "relic-quality-bonus": 10
        },
        description: "Portable analyzer tuned to detect valuable relic signal emissions.",
        short: "Improves chances of finding higher-quality relics.",
        flavor: "It listens for what the ruins remember.",
        visual: "Palm-sized copper coil device with faint magnetic hum."
    },
    {
        id: "hazard-lens-visor",
        name: "Hazard Lens Visor",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDEE1\uFE0F",
        effects: {
            "hazard-damage-reduction": 5
        },
        description: "Retractable visor overlay with polarized lenses for hazard visibility.",
        short: "Reduces hazard damage and improves visibility.",
        flavor: "You'll see the heat before it burns you.",
        visual: "Fold-down visor with tinted glass and worn metal hinge."
    },
    {
        id: "recovery-injector",
        name: "Recovery Injector",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDC89",
        effects: {
            "knockout-prevention": 1
        },
        description: "Compact auto-syringe delivering restorative compounds during emergencies.",
        short: "Prevents first incapacitation per raid.",
        flavor: "Pain's optional if you've got credits.",
        visual: "Reinforced syringe with digital readout and polymer casing."
    },
    {
        id: "contract-beacon",
        name: "Contract Beacon",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCE1",
        effects: {
            "contractor-payout-bonus": 10
        },
        description: "Handheld transmitter used to log contractor performance data.",
        short: "Improves payout on successful support contracts.",
        flavor: "Work ends when the beacon says so.",
        visual: "Metal signal beacon with etched serial plate and extendable antenna."
    },
    {
        id: "salvage-compression-rig",
        name: "Salvage Compression Rig",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCE6",
        effects: {
            "loot-quantity-bonus": 10
        },
        description: "Compact hydraulic press for field compression of salvaged materials.",
        short: "Increases material quantities recovered from events.",
        flavor: "Carry more by making it smaller. Simple physics, better haul.",
        visual: "Belt-mounted press with steel jaws and cargo netting."
    },
    {
        id: "sync-regulator-watch",
        name: "Sync Regulator Watch",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\u23F0",
        effects: {
            "raid-energy-reduction": 10
        },
        description: "Wristwatch synced to raid timers, reducing the energy cost of launching runs.",
        short: "Reduces raid energy costs by 10%.",
        flavor: "Keeps your time even when the world's stopped keeping its own.",
        visual: "Analog-digital hybrid watch with cracked face and glowing dial."
    },
    {
        id: "auto-stabilizer-pack",
        name: "Auto-Stabilizer Pack",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83C\uDF86",
        effects: {
            "knockout-prevention": 1
        },
        description: "Wearable spinal brace with kinetic dampers to prevent catastrophic injury.",
        short: "Prevents one critical injury per raid.",
        flavor: "Catches you once. Don't make it twice.",
        visual: "Lightweight spine brace with metal pistons and foam padding."
    },
    {
        id: "training-node-deck",
        name: "Training Node Deck",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83C\uDFAF",
        effects: {
            "support-skill-bonus": 2
        },
        description: "Handheld data deck containing simulated skill routines for training.",
        short: "Boosts support skills during checks.",
        flavor: "Practice until it hurts, then practice better.",
        visual: "Compact data cartridge with keypad and scratched screen."
    },
    {
        id: "crosslink-amplifier",
        name: "Crosslink Amplifier",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD00",
        effects: {
            "faction-synergy-bonus": 5
        },
        description: "Relay puck enhancing coordination between nearby teammates.",
        short: "Improves success chance when multiple factions assist.",
        flavor: "When everyone's in sync, nobody dies alone.",
        visual: "Hand-sized relay disc with glowing copper inlays and dual terminals."
    },
    {
        id: "material-extractor",
        name: "Material Extractor",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\u26CF\uFE0F",
        effects: {
            "gate-material-bonus": 15
        },
        description: "Handheld drill for retrieving salvageable materials from debris.",
        short: "Improves material yield from Gate rooms.",
        flavor: "The gate's trash is tomorrow's rebuild.",
        visual: "Compact hand drill with tungsten bit and transparent debris canister."
    },
    {
        id: "memory-crystal-shard",
        name: "Memory Crystal Shard",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        effects: {
            "blueprint-find-bonus": 5
        },
        description: "Resin-sealed data shard that resonates near the caches where blueprints survive.",
        short: "Increases legendary blueprint discovery chance.",
        flavor: "What's stored inside isn't data\u2014it's what was lost trying to keep it.",
        visual: "Clear resin capsule with crystalline core set in a steel ring."
    }
];
const $ce6dd72bc4611534$export$11208b4f926fa7ee = [
    // ===============================
    // Dominion Skill Artifacts
    // ===============================
    {
        id: "signal-repeater-pack-blueprint",
        name: "Signal Repeater Pack Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        description: "Blueprint for the Signal Repeater Pack",
        short: "Plans: Signal Repeater Pack."
    },
    {
        id: "control-override-kit-blueprint",
        name: "Control Override Kit Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        description: "Blueprint for the Control Override Kit",
        short: "Plans: Control Override Kit."
    },
    {
        id: "operator-link-harness-blueprint",
        name: "Operator Link Harness Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83E\uDD16",
        description: "Blueprint for the Operator Link Harness",
        short: "Plans: Operator Link Harness."
    },
    {
        id: "stability-coupler-blueprint",
        name: "Stability Coupler Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\u26A0\uFE0F",
        description: "Blueprint for the Stability Coupler",
        short: "Plans: Stability Coupler."
    },
    {
        id: "spectral-survey-scope-blueprint",
        name: "Spectral Survey Scope Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDD2C",
        description: "Blueprint for the Spectral Survey Scope",
        short: "Plans: Spectral Survey Scope."
    },
    // ===============================
    // Wilders Skill Artifacts
    // ===============================
    {
        id: "harvesting-gauntlet-blueprint",
        name: "Harvesting Gauntlet Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83C\uDF31",
        description: "Blueprint for the Harvesting Gauntlet",
        short: "Plans: Harvesting Gauntlet."
    },
    {
        id: "growth-induction-pod-blueprint",
        name: "Growth Induction Pod Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83C\uDF3F",
        description: "Blueprint for the Growth Induction Pod",
        short: "Plans: Growth Induction Pod."
    },
    {
        id: "pheromone-relay-belt-blueprint",
        name: "Pheromone Relay Belt Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83E\uDD8E",
        description: "Blueprint for the Pheromone Relay Belt",
        short: "Plans: Pheromone Relay Belt."
    },
    {
        id: "respirator-webbing-blueprint",
        name: "Respirator Webbing Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        description: "Blueprint for the Respirator Webbing",
        short: "Plans: Respirator Webbing."
    },
    {
        id: "hazard-recovery-satchel-blueprint",
        name: "Hazard Recovery Satchel Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\u2623\uFE0F",
        description: "Blueprint for the Hazard Recovery Satchel",
        short: "Plans: Hazard Recovery Satchel."
    },
    // ===============================
    // Veil Skill Artifacts
    // ===============================
    {
        id: "resonant-survey-array-blueprint",
        name: "Resonant Survey Array Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDDFA\uFE0F",
        description: "Blueprint for the Resonant Survey Array",
        short: "Plans: Resonant Survey Array."
    },
    {
        id: "lockpulse-breach-kit-blueprint",
        name: "Lockpulse Breach Kit Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDD13",
        description: "Blueprint for the Lockpulse Breach Kit",
        short: "Plans: Lockpulse Breach Kit."
    },
    {
        id: "silent-step-pads-blueprint",
        name: "Silent Step Pads Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDC64",
        description: "Blueprint for the Silent Step Pads",
        short: "Plans: Silent Step Pads."
    },
    {
        id: "trace-disruptor-band-blueprint",
        name: "Trace Disruptor Band Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        description: "Blueprint for the Trace Disruptor Band",
        short: "Plans: Trace Disruptor Band."
    },
    {
        id: "anchor-resonator-blueprint",
        name: "Anchor Resonator Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83C\uDF00",
        description: "Blueprint for the Anchor Resonator",
        short: "Plans: Anchor Resonator."
    },
    // ===============================
    // Neutral Utility Artifacts
    // ===============================
    {
        id: "data-cache-drive-blueprint",
        name: "Data Cache Drive Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCBE",
        description: "Blueprint for the Data Cache Drive",
        short: "Plans: Data Cache Drive."
    },
    {
        id: "relic-resonance-tuner-blueprint",
        name: "Relic Resonance Tuner Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        description: "Blueprint for the Relic Resonance Tuner",
        short: "Plans: Relic Resonance Tuner."
    },
    {
        id: "hazard-lens-visor-blueprint",
        name: "Hazard Lens Visor Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDEE1\uFE0F",
        description: "Blueprint for the Hazard Lens Visor",
        short: "Plans: Hazard Lens Visor."
    },
    {
        id: "recovery-injector-blueprint",
        name: "Recovery Injector Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDC89",
        description: "Blueprint for the Recovery Injector",
        short: "Plans: Recovery Injector."
    },
    {
        id: "contract-beacon-blueprint",
        name: "Contract Beacon Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCE1",
        description: "Blueprint for the Contract Beacon",
        short: "Plans: Contract Beacon."
    },
    {
        id: "salvage-compression-rig-blueprint",
        name: "Salvage Compression Rig Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCE6",
        description: "Blueprint for the Salvage Compression Rig",
        short: "Plans: Salvage Compression Rig."
    },
    {
        id: "sync-regulator-watch-blueprint",
        name: "Sync Regulator Watch Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\u23F0",
        description: "Blueprint for the Sync Regulator Watch",
        short: "Plans: Sync Regulator Watch."
    },
    {
        id: "auto-stabilizer-pack-blueprint",
        name: "Auto-Stabilizer Pack Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83C\uDF86",
        description: "Blueprint for the Auto-Stabilizer Pack",
        short: "Plans: Auto-Stabilizer Pack."
    },
    {
        id: "training-node-deck-blueprint",
        name: "Training Node Deck Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83C\uDFAF",
        description: "Blueprint for the Training Node Deck",
        short: "Plans: Training Node Deck."
    },
    {
        id: "crosslink-amplifier-blueprint",
        name: "Crosslink Amplifier Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD00",
        description: "Blueprint for the Crosslink Amplifier",
        short: "Plans: Crosslink Amplifier."
    },
    {
        id: "material-extractor-blueprint",
        name: "Material Extractor Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\u26CF\uFE0F",
        description: "Blueprint for the Material Extractor",
        short: "Plans: Material Extractor."
    },
    {
        id: "memory-crystal-shard-blueprint",
        name: "Memory Crystal Shard Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        description: "Blueprint for the Memory Crystal Shard",
        short: "Plans: Memory Crystal Shard."
    }
];
const $ce6dd72bc4611534$export$39df1497f8fcc025 = [
    // ===============================
    // Common Materials
    // ===============================
    {
        id: "steel-plates",
        name: "Steel Plates",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83E\uDDF1",
        description: "Reinforced steel sheets salvaged from collapsed structures, used for repairs and fabrication.",
        short: "Structural steel for frames and reinforcements."
    },
    {
        id: "copper-wire",
        name: "Copper Wire",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83E\uDDF6",
        description: "Insulated copper wire used for communications, power routing, and control circuits.",
        short: "Electrical wiring for circuits and comms."
    },
    {
        id: "brass-fittings",
        name: "Brass Fittings",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u2699\uFE0F",
        description: "Polished brass connectors and mechanical couplings used in precision assemblies.",
        short: "Mechanical connectors for field gear."
    },
    {
        id: "glass-lens",
        name: "Glass Lens",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83D\uDD0D",
        description: "Optical glass lens salvaged from scopes and sensors, used in scanning devices.",
        short: "Optical lens for scopes and sensors."
    },
    {
        id: "ceramic-insulator",
        name: "Ceramic Insulator",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83C\uDFFA",
        description: "High-heat ceramic components that isolate electrical and thermal energy.",
        short: "Heat-resistant electrical insulation."
    },
    {
        id: "composite-casing",
        name: "Composite Casing",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCE6",
        description: "Lightweight polymer and carbon housings used to encase sensitive systems.",
        short: "Protective housing for tech equipment."
    },
    {
        id: "fabric-mesh",
        name: "Fabric Mesh",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEA1",
        description: "Durable woven material used for straps, belts, and wearable rigs.",
        short: "Reinforced cloth for wearable gear."
    },
    {
        id: "canvas-fiber",
        name: "Canvas Fiber",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDF5",
        description: "Tough, weatherproof textile favored by Wilder survival teams for packs and satchels.",
        short: "Heavy fabric for field packs."
    },
    {
        id: "leather-straps",
        name: "Leather Straps",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83C\uDF92",
        description: "Cured animal hide straps used in Wilder clothing, gloves, and carrying gear.",
        short: "Leather bands for field equipment."
    },
    {
        id: "rubber-seal",
        name: "Rubber Seal",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83E\uDDF0",
        description: "Rubberized sealing rings for airtight or watertight containers.",
        short: "Insulating seal for protective containers."
    },
    {
        id: "polymer-tubing",
        name: "Polymer Tubing",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDEA",
        description: "Flexible tubing used in breathing rigs, injectors, and liquid transfer systems.",
        short: "Flexible tubing for filtration or injection systems."
    },
    {
        id: "carbon-housing",
        name: "Carbon Housing",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u2B1B",
        description: "Durable carbon-composite shell used in portable scanning and stealth gear.",
        short: "Lightweight carbon shell for tech devices."
    },
    {
        id: "plastic-casing",
        name: "Plastic Casing",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83E\uDDF4",
        description: "Recycled polymer panels used for consumer-grade or field-modified electronics.",
        short: "Lightweight housing for electronic tools."
    },
    {
        id: "aluminum-shell",
        name: "Aluminum Shell",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83E\uDD6B",
        description: "Lightweight aluminum housing used for beacons, sensor mounts, and handheld devices.",
        short: "Light metal housing for compact field gear."
    },
    {
        id: "circuit-board",
        name: "Circuit Board",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        description: "Salvaged printed circuit board used for control panels and signal devices.",
        short: "Base electronic component for all digital tech."
    },
    {
        id: "resin-casing",
        name: "Resin Casing",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDF4",
        description: "Transparent resin shell used for insulation, bonding, or sealing delicate materials.",
        short: "Clear protective housing for fragile items."
    },
    {
        id: "iron-frame",
        name: "Iron Frame",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83C\uDFD7\uFE0F",
        description: "Reinforced iron supports salvaged from export construction scaffolds and vehicles.",
        short: "Structural frame material for heavy gear."
    },
    {
        id: "relay-antenna-strut",
        name: "Relay Antenna Strut",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        description: "Telescoping antenna segment stripped from dead relay towers, still true enough to hold a signal line.",
        short: "Antenna segment for comm rigs and beacons."
    },
    {
        id: "power-cell-casing",
        name: "Power Cell Casing",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDD0B",
        description: "Hardened shell of a depleted power cell, reusable as housing for charge regulators and battery packs.",
        short: "Battery shell for power systems."
    },
    {
        id: "logic-ribbon-cable",
        name: "Logic Ribbon Cable",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83C\uDF97\uFE0F",
        description: "Flat multi-channel cable pulled from control consoles, carries data lines between salvaged modules.",
        short: "Data cabling for control interfaces."
    },
    {
        id: "chitin-plate",
        name: "Chitin Plate",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEB2",
        description: "Hardened shell segment shed by overgrown insects, light as polymer and twice as tough.",
        short: "Natural armor plating from giant insects."
    },
    {
        id: "spore-felt-padding",
        name: "Spore Felt Padding",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83C\uDF44",
        description: "Dense fungal felt harvested from spore beds, insulates and cushions delicate biological cargo.",
        short: "Fungal padding for insulation and cushioning."
    },
    {
        id: "tanned-gut-cord",
        name: "Tanned Gut Cord",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEA2",
        description: "Sinew cordage cured over smoke, the Wilders' answer to wire ties and suture thread alike.",
        short: "Tough natural cordage for bindings."
    },
    {
        id: "optic-fiber-spool",
        name: "Optic Fiber Spool",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83E\uDDFF",
        description: "Coil of hair-thin light-guide fiber, favored for taps and scopes that leave no electromagnetic trace.",
        short: "Light-guide fiber for covert optics."
    },
    {
        id: "matte-coating-compound",
        name: "Matte Coating Compound",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83C\uDFA8",
        description: "Light-drinking paste applied to gear that should not glint, reflect, or be remembered.",
        short: "Anti-reflective coating for stealth gear."
    },
    {
        id: "micro-bearing-set",
        name: "Micro Bearing Set",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u26AA",
        description: "Case of near-frictionless bearings that let mechanisms turn in perfect silence.",
        short: "Silent precision bearings for quiet mechanisms."
    },
    {
        id: "acoustic-foam-wafer",
        name: "Acoustic Foam Wafer",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83D\uDD32",
        description: "Cut sheet of sound-eating foam, lines the housings of equipment meant to run unheard.",
        short: "Sound-dampening liner for covert equipment."
    },
    {
        id: "etched-keyplate-blank",
        name: "Etched Keyplate Blank",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83D\uDDDD\uFE0F",
        description: "Unprogrammed access plate with etched circuit channels, ready to take any lock's profile.",
        short: "Blank keycard stock for bypass tools."
    }
];
const $ce6dd72bc4611534$export$f9575e6a92b5621d = [
    {
        id: "field-health-stim",
        name: "Field Health Stim (35 HP)",
        type: "consumable",
        rarity: "common",
        icon: "\uD83D\uDC8A",
        description: "A quick-use medical injector restoring 35 HP.",
        short: "Restores 35 HP.",
        credits: 25,
        restoresHp: 35,
        recipe: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        id: "portable-energy-pack",
        name: "Portable Energy Pack",
        type: "consumable",
        rarity: "common",
        icon: "\u26A1",
        description: "Compact power injection cell restoring 30 energy.",
        short: "Restores 30 energy.",
        credits: 150,
        restoresEnergy: 30,
        recipe: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        id: "credits",
        name: "Credits",
        type: "credits",
        rarity: "currency",
        icon: "\uD83D\uDCB0",
        description: "Standard currency for trade, hiring, and fabrication.",
        short: "Universal currency for trade."
    }
];
const $ce6dd72bc4611534$export$439a14874f0a75e4 = [
    {
        id: "recovery-injector-mk2",
        name: "Recovery Injector (50 HP)",
        type: "consumable",
        rarity: "uncommon",
        icon: "\uD83D\uDC89",
        description: "Upgraded stimulant blend restoring 50 HP with faster onset and reduced side effects.",
        short: "Restores 50 HP.",
        credits: 100,
        restoresHp: 50,
        recipe: [
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        id: "energy-conversion-pack",
        name: "Energy Conversion Pack",
        type: "consumable",
        rarity: "uncommon",
        icon: "\uD83D\uDD0B",
        description: "Refined energy module restoring 45 energy.",
        short: "Restores 45 energy.",
        credits: 600,
        restoresEnergy: 45,
        recipe: [
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 2
            }
        ]
    }
];
const $ce6dd72bc4611534$export$b2b2210935a03dc3 = [
    {
        id: "advanced-recovery-serum",
        name: "Recovery Serum (70 HP)",
        type: "consumable",
        rarity: "rare",
        icon: "\uD83E\uDDEA",
        description: "Refined medical stimulant restoring 70 HP.",
        short: "Restores 70 HP.",
        credits: 300,
        restoresHp: 70,
        recipe: [
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        id: "power-cell-mk3",
        name: "Power Cell Mk. III",
        type: "consumable",
        rarity: "rare",
        icon: "\u2699\uFE0F",
        description: "High-density cell restoring 60 energy.",
        short: "Restores 60 energy.",
        credits: 1800,
        restoresEnergy: 60,
        recipe: [
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 2
            }
        ]
    }
];
const $ce6dd72bc4611534$export$c1a4d9d859d3b7 = [
    {
        id: "relay-stabilizer-gel-pack",
        techniqueId: "relay-stabilizer",
        name: "Relay Stabilizer Gel Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDCE1",
        short: "Quick-sets mast alignment for steady comms.",
        description: "High-viscosity damping gel that reduces dish/mast micro-vibration and bearing drift, stabilizing RF alignment during Signal Relay."
    },
    {
        id: "biofiber-splice-kit",
        techniqueId: "organic-link-adapter",
        name: "Biofiber Splice Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEA1\uD83C\uDF3F",
        short: "Patch cracked lines with living fiber.",
        description: "Sterile polymer-fiber splices and crimp ferrules for fast field repairs of damaged signal runs; restores continuity for organic-safe link adapters."
    },
    {
        id: "noise-floor-buffer-pack",
        techniqueId: "silent-channel",
        name: "Noise Floor Buffer Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD07\uD83D\uDCF6",
        short: "Drops trace noise below scan.",
        description: "Adaptive notch and low-pass inserts that suppress hiss, intermod, and harmonics to lower the effective noise floor on shared bands."
    },
    {
        id: "multi-node-override-cart",
        techniqueId: "command-cascade",
        name: "Multi-Node Override Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDE9\uD83D\uDDA5\uFE0F",
        short: "Stage chained takeovers faster.",
        description: "Pre-staged command bundles and credential handoffs that reduce human timing error in sequential takeovers of multiple endpoints."
    },
    {
        id: "surge-damping-couplers",
        techniqueId: "bio-feedback-guard",
        name: "Surge Damping Couplers",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u26A1\uD83E\uDDEC",
        short: "Soaks reboot spikes safely.",
        description: "Inline TVS elements and RC snubbers that absorb transient voltage spikes during forced reboots to protect connected subsystems."
    },
    {
        id: "decoy-traffic-cartridge",
        techniqueId: "signal-mask-injection",
        name: "Decoy Traffic Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDFAD\uD83D\uDCE1",
        short: "Hide control packets in noise.",
        description: "Traffic-shaping frames and padding packets that disguise control bursts inside believable network chatter without altering payloads."
    },
    {
        id: "swarm-sync-beacon-cart",
        techniqueId: "coordinated-flight-pattern",
        name: "Swarm Sync Beacon Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDEF0\uFE0F\uD83E\uDD16",
        short: "Snap-syncs drone routes.",
        description: "Short-range UWB timing beacons that provide a common clock for nearby drones, improving lane separation and route timing."
    },
    {
        id: "overgrowth-lidar-pack",
        techniqueId: "rootpath-protocol",
        name: "Overgrowth LIDAR Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF3F\uD83D\uDCE1",
        short: "Map safe lanes through brush.",
        description: "Compact LIDAR + proximity sweep that identifies low-resistance channels through dense brush for safer autonomous routing."
    },
    {
        id: "quiet-sonar-cartridge",
        techniqueId: "echo-pulse-beacon",
        name: "Quiet Sonar Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD08\uD83D\uDEF0\uFE0F",
        short: "Low-profile ping mapping.",
        description: "Low-intensity ultrasonic transceivers that enable short-range mapping with minimal acoustic signature."
    },
    {
        id: "rapid-grounding-spikes",
        techniqueId: "system-ground-loop",
        name: "Rapid Grounding Spikes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCCE\u26A1",
        short: "Drop fault current to ground.",
        description: "Temporary ground electrodes and clamps that create safe earth paths to quickly dissipate fault current."
    },
    {
        id: "vent-cycler-pack",
        techniqueId: "spore-vent-reclaimer",
        name: "Vent Cycler Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF2C\uFE0F\uD83E\uDDEA",
        short: "Purge, filter, reuse air.",
        description: "Disposable microfilters and purge actuators that accelerate intake/exhaust cycling and capture particulates for recovery."
    },
    {
        id: "cutoff-line-kit",
        techniqueId: "manual-override-line",
        name: "Cutoff Line Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u2702\uFE0F\uD83E\uDDF5",
        short: "Install a physical kill-line.",
        description: "Insulated cable, crimps, and lockout tags for adding a physical isolation line to de-energize a local zone quickly."
    },
    {
        id: "scan-link-bridge",
        techniqueId: "entangled-synchrony",
        name: "Scan Link Bridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDE0\uD83D\uDD17",
        short: "Lock scanners into sync.",
        description: "Clock fan-out and shared buffer modules that keep multiple instruments sampling in the same time base for coherent reads."
    },
    {
        id: "dual-spectrum-cartridge",
        techniqueId: "bio-spectral-crosscheck",
        name: "Dual-Spectrum Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDEC\uD83D\uDD2C",
        short: "Overlay bio + energy reads.",
        description: "Paired sensors and calibration markers that co-register biological signatures with radiation/field measurements for cross-checks."
    },
    {
        id: "residual-current-probe-kit",
        techniqueId: "ghost-echo-capture",
        name: "Residual Current Probe Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF2\uD83D\uDCCF",
        short: "Sniff faint live lines.",
        description: "High-impedance clamp probes and tracer dye to detect low-level leakage and find viable paths through damaged circuits."
    }
];
const $ce6dd72bc4611534$export$a24b2f292778b5dc = [
    {
        id: "harvest-sync-brace-pack",
        techniqueId: "reclamation-drone-link",
        name: "Harvest Sync Brace Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDBE\uD83C\uDF31",
        short: "Lock harvester + drone timing.",
        description: "Rigid braces and timing tabs that mechanically synchronize harvester motion with companion drones to reduce sample loss."
    },
    {
        id: "fast-filter-plenum-cart",
        techniqueId: "mycelial-rebalance",
        name: "Fast Filter Plenum Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF44\uD83E\uDDEA",
        short: "Accelerate live fungal sorting.",
        description: "Pre-wetted filtration pads and flow baffles that speed separation of viable biomass from debris in mixed slurries."
    },
    {
        id: "micro-mist-emitter",
        techniqueId: "phase-cleanse",
        name: "Micro-Mist Emitters",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCA7\uD83E\uDDFC",
        short: "Lift spores/oils quickly.",
        description: "Single-use atomizer that lays down a uniform cleaning mist to lift spores/oils while minimizing residue."
    },
    {
        id: "rapid-brace-binder",
        techniqueId: "adaptive-lattice",
        name: "Rapid Brace Binders",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEB5\uD83D\uDD78\uFE0F",
        short: "Snap-grow support frames.",
        description: "Two-part structural resin and mineral fillers that cure into lightweight struts for quick bracing or gap-spanning."
    },
    {
        id: "light-channel-films",
        techniqueId: "photosymbiosis",
        name: "Light Channel Films",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD06\uD83C\uDF3F",
        short: "Pipe light through leaves.",
        description: "Thin-film optics that route and diffuse light to shaded growth surfaces, improving local photosynthetic efficiency."
    },
    {
        id: "root-guidance-stakes",
        techniqueId: "shadowroot-bloom",
        name: "Root Guidance Stakes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCCD\uD83C\uDF31",
        short: "Lead roots through cracks.",
        description: "Moisture-biased guide stakes that encourage root growth along existing micro-fractures to expose cavities safely."
    },
    {
        id: "breath-sync-strips",
        techniqueId: "signal-harmonizer",
        name: "Breath Sync Strips",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDE2E\u200D\uD83D\uDCA8\uD83C\uDF9A\uFE0F",
        short: "Align heart/breath rhythms.",
        description: "Skin-safe haptic strips that cue synchronized breathing patterns across the team, reducing stress responses without drugs."
    },
    {
        id: "chorus-diffuser-ampoule",
        techniqueId: "pheromone-chorus",
        name: "Chorus Diffuser Ampoules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDEA\uD83C\uDFB6",
        short: "Blend multi-handler signals.",
        description: "Timed micro-diffusers that release low-dose, non-sedative botanical blends to stabilize handler-group behavior."
    },
    {
        id: "scent-dampening-salve",
        techniqueId: "silent-hand",
        name: "Scent Dampening Salves",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDC43",
        short: "Kill trail and gear snaps.",
        description: "Neutralizing balm for fabrics and skin that suppresses volatile compounds and squeak/rattle points at contact surfaces."
    },
    {
        id: "reactive-gel-patch",
        techniqueId: "bio-shielding",
        name: "Reactive Gel Patches",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE79\uD83D\uDEE1\uFE0F",
        short: "Spread shock/heat on impact.",
        description: "Non-Newtonian impact-spread gel patches that distribute force and heat, improving short-term tolerance to arcs and hotspots."
    },
    {
        id: "enzyme-swap-kit",
        techniqueId: "shared-immunity",
        name: "Enzyme Swap Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD01\uD83E\uDDEC",
        short: "Pass resistance packs fast.",
        description: "Color-coded topical kits containing broad-spectrum cleansing and barrier components for rapid, shared exposure mitigation."
    },
    {
        id: "surface-tuning-spray",
        techniqueId: "dim-shift-layer",
        name: "Surface Tuning Sprays",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD8C\uFE0F\uD83E\uDE9E",
        short: "Match tone and sheen quickly.",
        description: "Microflake coating with adjustable binder that tunes reflectivity and tone to match surrounding surfaces."
    },
    {
        id: "hardcase-quickframe-kit",
        techniqueId: "servo-containment",
        name: "Hardcase Quickframe Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE6\uD83E\uDD16",
        short: "Shell hot samples fast.",
        description: "Fold-out frames and latch nets that convert drone housings into sealed transport cases for unstable samples."
    },
    {
        id: "pod-starter-seeds",
        techniqueId: "mutualist-growth",
        name: "Pod Starter Seeds",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF30\uD83E\uDDEB",
        short: "Grow living containment.",
        description: "Expandable biopolymer pellets with inert scaffolding that form shock-absorbing pods around irregular objects."
    },
    {
        id: "recovery-pod-capsules",
        techniqueId: "reflex-bloom",
        name: "Recovery Pod Capsules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDC8A\uD83C\uDF38",
        short: "Auto-release healing compounds.",
        description: "Timed-release capsules that deploy micro-pods carrying standard wound-care and decontamination compounds post-exposure."
    }
];
const $ce6dd72bc4611534$export$29d1bf8c74230d20 = [
    {
        id: "relay-bridge-link-cart",
        techniqueId: "quantum-relay-hook",
        name: "Relay Bridge Link Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE9D\uD83D\uDDFA\uFE0F",
        short: "Piggyback maps on relays.",
        description: "Interface shims that attach mapping metadata to existing relay management frames for reliable piggybacking."
    },
    {
        id: "bio-pulse-amplifier-pack",
        techniqueId: "biotrace-resonance",
        name: "Bio-Pulse Amplifier Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE1\uD83C\uDF31",
        short: "Boost returns off living matter.",
        description: "Low-power pulse amplifiers tuned to common organic absorption/reflectance bands to clarify returns from living matter."
    },
    {
        id: "map-cache-sync-cart",
        techniqueId: "shadow-archive",
        name: "Map Cache Sync Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCBE\uD83D\uDDFA\uFE0F",
        short: "Auto-sync portable map caches.",
        description: "Proximity sync cartridges using short-range NFC/optical channels to handshake map caches without manual transfer."
    },
    {
        id: "micro-torque-paste",
        techniqueId: "servo-alignment-tool",
        name: "Micro-Torque Pastes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDD27",
        short: "Seat pins and rails cleanly.",
        description: "Friction-balanced paste that stabilizes micro-movements in pins and rails for precise servo/lock alignment."
    },
    {
        id: "quiet-seal-injector",
        techniqueId: "biofilm-stabilizer",
        name: "Quiet Seal Injectors",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDD2B\uD83E\uDDEA",
        short: "Stop rattles and squeals.",
        description: "Thin polymer sealant applied under panel seams to eliminate rattle and high-frequency squeal during movement."
    },
    {
        id: "decoy-pulse-cartridge",
        techniqueId: "echo-pulse-decoy",
        name: "Decoy Pulse Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE1\uD83C\uDFAF",
        short: "Flash a harmless misread.",
        description: "Programmable emitters that send harmless ranging pings to bias attention away from the working area."
    },
    {
        id: "route-shadow-taggers",
        techniqueId: "drone-path-shadow",
        name: "Route Shadow Taggers",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDFF7\uFE0F\uD83D\uDEB6",
        short: "Mark drone lanes for feet.",
        description: "Low-gloss floor markers that couple human pathing to known drone lanes, reducing the number of distinct traces."
    },
    {
        id: "low-shine-veil-pack",
        techniqueId: "spore-veil",
        name: "Low-Shine Veil Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF2B\uFE0F\uD83D\uDD76\uFE0F",
        short: "Dull edges, cut glare.",
        description: "Aerosolized matte coat that dulls hard edges and specular highlights to lower visual detection."
    },
    {
        id: "pace-sync-patches",
        techniqueId: "mirror-walk",
        name: "Pace Sync Patches",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE79\uD83D\uDC63",
        short: "Keep squad as one trace.",
        description: "Haptic cadence patches that keep a squad\u2019s step timing uniform to reduce multi-source motion cues."
    },
    {
        id: "auth-spoof-keycard",
        techniqueId: "control-spoof",
        name: "Auth Spoof Keycards",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEAA\uD83C\uDFAD",
        short: "Borrowed machine identity.",
        description: "Burn-once cards with limited, sandboxed credential profiles for passing routine, low-privilege checks."
    },
    {
        id: "thermal-scent-ampoule",
        techniqueId: "bio-id-mask",
        name: "Thermal Scent Ampoules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF21\uFE0F\uD83D\uDC43",
        short: "Mimic local heat + scent.",
        description: "Dual-channel projectors that shape IR apparent temperature and trace scent to blend with local background."
    },
    {
        id: "temp-log-writer-cart",
        techniqueId: "echo-loop",
        name: "Temp Log Writer Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCDD\uD83D\uDD01",
        short: "Plant harmless dummy logs.",
        description: "Write-only, time-limited log entries that add benign detours to audit trails without altering critical records."
    },
    {
        id: "quickset-anchor-rods",
        techniqueId: "phase-anchor",
        name: "Quickset Anchor Rods",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDEE0\uFE0F\uD83C\uDF00",
        short: "Pin drifting surfaces.",
        description: "Expandable rods and resin anchors that mechanically stabilize shifting walls and floors."
    },
    {
        id: "timing-pulse-tag",
        techniqueId: "depth-step",
        name: "Timing Pulse Tags",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u23F1\uFE0F\uD83D\uDCCD",
        short: "Step on stable beats.",
        description: "Clip-on transponders that detect vibration cycles and flag brief low-motion windows for safer crossings."
    },
    {
        id: "scan-cache-array-cart",
        techniqueId: "echo-fold",
        name: "Scan Cache Array Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDDC2\uFE0F\uD83D\uDCE1",
        short: "Pocket + restore scans.",
        description: "Portable buffer arrays that capture recent sensor frames for quick re-loads after interference or resets."
    }
];
const $ce6dd72bc4611534$export$71b953a5ed5f0cd6 = [
    // signal-relay
    {
        id: "precision-mast-calibrator",
        techniqueId: "relay-stabilizer",
        name: "Precision Mast Calibrator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9B\uFE0F\uD83D\uDCE1",
        short: "Laser-align relay masts.",
        description: "Gyro-stabilized laser jig that zeroes dish bearings and mast tilt for a stable RF path during alignment."
    },
    {
        id: "biofiber-manifold",
        techniqueId: "organic-link-adapter",
        name: "Biofiber Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF3F\uD83E\uDDF0",
        short: "Seat living splices cleanly.",
        description: "Multi-port manifold that tensions and seats polymer fiber splices for durable link repair."
    },
    {
        id: "adaptive-noise-gate",
        techniqueId: "silent-channel",
        name: "Adaptive Noise Gate",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD07\uD83D\uDDA7",
        short: "Auto-null scanner pickup.",
        description: "Digital filter that tracks spectrum drift and attenuates pickup around sensitive bands."
    },
    // system-override
    {
        id: "multi-handshake-router",
        techniqueId: "command-cascade",
        name: "Multi-Handshake Router",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD01\uD83D\uDDA5\uFE0F",
        short: "Chain control handshakes.",
        description: "Router core that sequences credentials and command bundles to reduce operator timing errors."
    },
    {
        id: "surge-buffer-backplane",
        techniqueId: "bio-feedback-guard",
        name: "Surge Buffer Backplane",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEF\u26A1",
        short: "Bleed off reboot spikes.",
        description: "Dielectric backplane with TVS arrays that bleeds transient load to ground during resets."
    },
    {
        id: "credential-spoof-matrix",
        techniqueId: "signal-mask-injection",
        name: "Credential Spoof Matrix",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDFAD\uD83D\uDD10",
        short: "Forge believable auth.",
        description: "Hardware emulator that produces constrained, audit-safe credential responses for masking maintenance traffic."
    },
    // drone-command
    {
        id: "swarm-route-controller",
        techniqueId: "coordinated-flight-pattern",
        name: "Swarm Route Controller",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD79\uFE0F\uD83D\uDEF8",
        short: "Orchestrate flight lanes.",
        description: "Low-latency planner that de-conflicts headings and intervals across multiple airframes."
    },
    {
        id: "overgrowth-nav-suite",
        techniqueId: "rootpath-protocol",
        name: "Overgrowth Nav Suite",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF3F\uD83E\uDDED",
        short: "Plan safe bio-channels.",
        description: "Biometric + terrain planner that fits paths along low-resistance natural channels."
    },
    {
        id: "quiet-sonar-array",
        techniqueId: "echo-pulse-beacon",
        name: "Quiet Sonar Array",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDCE1\uD83D\uDD08",
        short: "Stealth map pings.",
        description: "Low-signature ultrasonic array for short-range mapping with minimal acoustic profile."
    },
    // safeguard
    {
        id: "auto-ground-bus",
        techniqueId: "system-ground-loop",
        name: "Auto Ground Bus",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF0\u26A1",
        short: "Instant safe ground path.",
        description: "Self-seeking clamp bus that identifies viable earth points and bonds equipment rapidly."
    },
    {
        id: "cycler-governor",
        techniqueId: "spore-vent-reclaimer",
        name: "Cycler Governor",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF2C\uFE0F\u2699\uFE0F",
        short: "Regulate purge cycles.",
        description: "Programmable controller that times purge and recapture phases for ventilation cycles."
    },
    {
        id: "hardline-junction-box",
        techniqueId: "manual-override-line",
        name: "Hardline Junction Box",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF2\uD83E\uDDF5",
        short: "Secure physical cut-off.",
        description: "Lockable junction that routes a physically isolated kill line for fast de-energizing."
    },
    // quantum-scan
    {
        id: "scan-link-backbone",
        techniqueId: "entangled-synchrony",
        name: "Scan Link Backbone",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD17\uD83D\uDD2C",
        short: "Synchronize instruments.",
        description: "Common-clock distribution and shared buffering that keep instruments time-aligned."
    },
    {
        id: "dual-spectrum-integrator",
        techniqueId: "bio-spectral-crosscheck",
        name: "Dual-Spectrum Integrator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEC\uD83D\uDCC8",
        short: "Fuse bio + energy bands.",
        description: "Inline integrator that co-registers biological, radiological, and EM field data."
    },
    {
        id: "low-current-amplifier",
        techniqueId: "ghost-echo-capture",
        name: "Low-Current Amplifier",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDCC8\uD83D\uDD0C",
        short: "Boost trace line signals.",
        description: "High-impedance amplifier that raises low-level line signals above measurement noise."
    }
];
const $ce6dd72bc4611534$export$76261a034023b29 = [
    // reclamation
    {
        id: "harvest-flight-controller",
        techniqueId: "reclamation-drone-link",
        name: "Harvest Flight Controller",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDEF8\uD83C\uDF31",
        short: "Co-pilot harvest flights.",
        description: "Link hub that synchronizes drone and harvester timing to reduce sample loss."
    },
    {
        id: "fungal-flow-regulator",
        techniqueId: "mycelial-rebalance",
        name: "Fungal Flow Regulator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF44\u2699\uFE0F",
        short: "Stabilize live filters.",
        description: "Pressure/flow controller that maintains efficient separation across bio-filters."
    },
    {
        id: "surface-decon-manifold",
        techniqueId: "phase-cleanse",
        name: "Surface Decon Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDFC\uD83E\uDDE9",
        short: "Evenly spread micro-mist.",
        description: "Distributor that ensures even micro-mist coverage for surface decontamination."
    },
    // growth-control
    {
        id: "lattice-lock-ribs",
        techniqueId: "adaptive-lattice",
        name: "Lattice Lock Ribs",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDB4\uD83D\uDD78\uFE0F",
        short: "Harden bio-metal frames.",
        description: "Expandable ribs that stiffen quickly cured resin struts for temporary structural support."
    },
    {
        id: "leaf-optic-panel",
        techniqueId: "photosymbiosis",
        name: "Leaf Optic Panel",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD06\uD83E\uDEB4",
        short: "Channel light efficiently.",
        description: "Adjustable optic panel that concentrates and angles light toward growth surfaces."
    },
    {
        id: "seam-probe-kit",
        techniqueId: "shadowroot-bloom",
        name: "Seam Probe Kit",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9B\uD83C\uDF31",
        short: "Find the right crack lines.",
        description: "Micro-sensors that locate moisture-bearing cracks suitable for guided root growth."
    },
    // wild-influence
    {
        id: "rhythm-guide-hub",
        techniqueId: "signal-harmonizer",
        name: "Rhythm Guide Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9A\uFE0F\uD83E\uDEC0",
        short: "Broadcast calm cadence.",
        description: "Biofeedback hub broadcasting calm cadence cues via low-latency haptics."
    },
    {
        id: "multi-diffuser-crown",
        techniqueId: "pheromone-chorus",
        name: "Multi-Diffuser Crown",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDC51\uD83E\uDEBC",
        short: "Layer handler signals.",
        description: "Head-mounted array that blends multiple low-dose scent channels for wider coverage."
    },
    {
        id: "contact-silence-kit",
        techniqueId: "silent-hand",
        name: "Contact Silence Kit",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDD2B\uD83E\uDDF0",
        short: "Mute close-range tells.",
        description: "Shims and absorbents that eliminate contact squeaks/snaps on gear and panels."
    },
    // bio-shield
    {
        id: "layer-activator-pad",
        techniqueId: "bio-shielding",
        name: "Layer Activator Pad",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEB\uD83D\uDEE1\uFE0F",
        short: "Prime the spread layer.",
        description: "Induction pad that warms and activates shear-thickening gel layers prior to use."
    },
    {
        id: "enzyme-hub-manifold",
        techniqueId: "shared-immunity",
        name: "Enzyme Hub Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEC\uD83E\uDDEA",
        short: "Distribute resistance packs.",
        description: "Metering hub that distributes standardized decon/barrier packets among teammates."
    },
    {
        id: "surface-tuner-core",
        techniqueId: "dim-shift-layer",
        name: "Surface Tuner Core",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9B\uFE0F\uD83E\uDE9E",
        short: "Auto-match tone/sheens.",
        description: "Optical feedback controller that adjusts a microflake layer\u2019s reflectivity in real time."
    },
    // containment
    {
        id: "hot-sample-frame",
        techniqueId: "servo-containment",
        name: "Hot Sample Frame",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD25\uD83D\uDCE6",
        short: "Carry volatile finds safely.",
        description: "Reconfigurable frame set that converts drone housings into sealed transport cases."
    },
    {
        id: "pod-growth-hub",
        techniqueId: "mutualist-growth",
        name: "Pod Growth Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF30\u2699\uFE0F",
        short: "Drive living pod formation.",
        description: "Controller that drives expansion and curing of shock-absorbing biopolymer pods."
    },
    {
        id: "recovery-pod-manifold",
        techniqueId: "reflex-bloom",
        name: "Recovery Pod Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF38\u2699\uFE0F",
        short: "Time restorative releases.",
        description: "Pulse manifold that staggers timed release of standard restorative compounds."
    }
];
const $ce6dd72bc4611534$export$7a39b013515e9c7d = [
    // echo-trace
    {
        id: "relay-pairing-bridge",
        techniqueId: "quantum-relay-hook",
        name: "Relay Pairing Bridge",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9D\uD83D\uDCE1",
        short: "Bind maps to relays.",
        description: "Bridge board that associates scanner output with relay control frames for piggybacking."
    },
    {
        id: "bio-pulse-coupler",
        techniqueId: "biotrace-resonance",
        name: "Bio-Pulse Coupler",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF31\uD83D\uDD17",
        short: "Sharpen organic echoes.",
        description: "Coupler optimized for organic reflectance bands to clarify weak returns."
    },
    {
        id: "map-sync-hub",
        techniqueId: "shadow-archive",
        name: "Map Sync Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDDC2\uFE0F\uD83D\uDD0C",
        short: "Hands-free cache sync.",
        description: "Passive NFC/optical hub that auto-syncs portable map caches within close range."
    },
    // lock-breach
    {
        id: "micro-torque-rail",
        techniqueId: "servo-alignment-tool",
        name: "Micro-Torque Rail",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF0\uD83E\uDDED",
        short: "Guide picks to seat line.",
        description: "Instrument rail with torque sensors that guides precise pick seating and servo alignment."
    },
    {
        id: "quiet-seal-rail",
        techniqueId: "biofilm-stabilizer",
        name: "Quiet Seal Rail",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDD2B\uD83E\uDDF5",
        short: "Lay silent panel seams.",
        description: "Applicator rail for even deposition of low-noise seam sealant."
    },
    {
        id: "decoy-phase-driver",
        techniqueId: "echo-pulse-decoy",
        name: "Decoy Phase Driver",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDFAF\uD83D\uDCE1",
        short: "Throw believable pings.",
        description: "Programmable driver that emits harmless distractor pings away from the work zone."
    },
    // stealth-transit
    {
        id: "route-shadow-hub",
        techniqueId: "drone-path-shadow",
        name: "Route Shadow Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDEE3\uFE0F\uD83D\uDC64",
        short: "Merge with drone lanes.",
        description: "Planner hub that snaps team pathing to known drone traces to reduce distinct movement signatures."
    },
    {
        id: "low-shine-housing",
        techniqueId: "spore-veil",
        name: "Low-Shine Housing",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD76\uFE0F\uD83E\uDDE9",
        short: "Cut edges and glare.",
        description: "Matte micro-texture housing that binds dulling coats and cuts specular highlights."
    },
    {
        id: "pace-sync-hub",
        techniqueId: "mirror-walk",
        name: "Pace Sync Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\u23F1\uFE0F\uD83D\uDEB6",
        short: "Keep formation cadence.",
        description: "Haptic metronome router that keeps formation cadence uniform under movement."
    },
    // signal-mask
    {
        id: "auth-emulator-core",
        techniqueId: "control-spoof",
        name: "Auth Emulator Core",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDEAA\uD83E\uDDE0",
        short: "Clone basic credentials.",
        description: "Constrained emulator that serves limited, low-privilege machine IDs for routine checkpoints."
    },
    {
        id: "thermal-scent-hub",
        techniqueId: "bio-id-mask",
        name: "Thermal Scent Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF21\uFE0F\uD83D\uDD75\uFE0F",
        short: "Blend heat + scent masks.",
        description: "Dual-channel projector that blends IR apparent temperature and trace scent output."
    },
    {
        id: "log-sanitizer-kernel",
        techniqueId: "echo-loop",
        name: "Log Sanitizer Kernel",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDFC\uD83D\uDCDD",
        short: "Write harmless trails.",
        description: "Kernel that writes time-limited, non-critical log noise to support benign alternate paths."
    },
    // transit-anchor
    {
        id: "anchor-brace-grid",
        techniqueId: "phase-anchor",
        name: "Anchor Brace Grid",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF1\uD83C\uDF00",
        short: "Stiffen local geometry.",
        description: "Rigid grid mounts that couple to braces and anchors to stabilize shifting surfaces."
    },
    {
        id: "timing-window-hub",
        techniqueId: "depth-step",
        name: "Timing Window Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9F\u23F1\uFE0F",
        short: "Spot safe crossing beats.",
        description: "Predictive timing hub that detects low-motion windows using vibration sensors."
    },
    {
        id: "scan-cache-backplane",
        techniqueId: "echo-fold",
        name: "Scan Cache Backplane",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDDC4\uFE0F\uD83D\uDCE1",
        short: "Retain sensor context.",
        description: "Redundant buffer backplane that preserves recent scan frames for rapid re-load."
    }
];
const $ce6dd72bc4611534$export$7f9cadee9e5a61bb = {
    permanentSlotsPerCharacter: 5,
    permanentSlotBinding: "1 per skill (affects one chosen technique for that skill via loadout toggle)",
    consumableCarryLimit: 6,
    consumablePerTechniqueCapPerRoom: 1,
    consumableStackCapPerTechnique: 2,
    consumableTimeBonusCap: -0.4
};
const $ce6dd72bc4611534$export$241bdd39c3e59b72 = [
    {
        id: "encrypted-transceiver-chip",
        name: "Encrypted Transceiver Chip",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\uD83D\uDCF6",
        description: "High-security chip enabling encrypted signal transmission and remote control.",
        short: "Encrypted chip for drone and comm systems."
    },
    {
        id: "radiation-sensor-module",
        name: "Radiation Sensor Module",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\u2622\uFE0F",
        description: "Advanced sensor module for detecting radiation and electromagnetic anomalies.",
        short: "Detection module for radiation scanners."
    },
    {
        id: "bio-conductive-mesh",
        name: "Bio-Conductive Mesh",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        description: "Flexible organic mesh that transmits low electrical signals through tissue or plant matter.",
        short: "Organic mesh used in biotech interfaces."
    },
    {
        id: "synthetic-pheromone-capsule",
        name: "Synthetic Pheromone Capsule",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDD8B",
        description: "Pressurized capsule releasing synthetic pheromones for wildlife modulation.",
        short: "Behavioral control capsule for wildlife devices."
    },
    {
        id: "em-interference-chip",
        name: "EM Interference Chip",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83D\uDCBE",
        description: "Microchip designed to emit controlled electromagnetic interference for masking signals.",
        short: "Chip used to disrupt tracking and detection."
    },
    {
        id: "harmonic-stabilizer-core",
        name: "Harmonic Stabilizer Core",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83C\uDF00",
        description: "Gyroscopic core used to counterbalance unstable structures and terrain.",
        short: "Stabilization core for terrain support units."
    },
    {
        id: "signal-sync-crystal",
        name: "Signal Sync Crystal",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\uD83D\uDD00",
        description: "Calibrated crystal matrix that synchronizes multi-device signal frequencies.",
        short: "Signal alignment crystal for coordination amplifiers."
    },
    {
        id: "data-storage-crystal",
        name: "Data Storage Crystal",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83D\uDD2E",
        description: "Miniature crystal lattice capable of storing large volumes of encoded data.",
        short: "Data storage crystal for recovered memories."
    },
    {
        id: "precision-chrono-core",
        name: "Precision Chrono Core",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\u23F1\uFE0F",
        description: "High-grade mechanical core used in advanced timekeeping and synchronization devices.",
        short: "Core for timing, synchronization, and cooldown systems."
    },
    {
        id: "high-torque-motor-core",
        name: "High-Torque Motor Core",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83D\uDD29",
        description: "Industrial motor assembly capable of driving heavy extraction tools.",
        short: "Motor core for drills and extraction equipment."
    },
    {
        id: "containment-gel-lining",
        name: "Containment Gel Lining",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDDEB",
        description: "Reactive gel layer used to stabilize and store hazardous or bioactive materials safely.",
        short: "Protective lining for biological containment equipment."
    },
    {
        id: "voltage-regulator-unit",
        name: "Voltage Regulator Unit",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\u2699\uFE0F",
        description: "Industrial-grade component for maintaining current stability across damaged grids.",
        short: "Voltage control hardware for electrical systems."
    }
];
const $ce6dd72bc4611534$export$d4a72d069095e9e5 = {
    common: {
        name: "Common",
        order: 1,
        color: "#9ca3af",
        craftingCost: 5,
        dropChance: {
            // Per-event chance, DECREASING with tier: early crafting needs healthy common
            // inflow, but at T3 raid volume commons otherwise swamp the inventory.
            // Events are the ONLY common source (the bonus event awards intel credits).
            // T1: 70%, T2: 55%, T3: 40% per event.
            base: 0.7,
            perTier: -0.15,
            max: 0.75,
            // Relative selection weights fitted by tools/loot-equilibrium.mjs --fit
            // (mix-only iterative income-vs-demand fit across factions and regions,
            // mean-1.0 normalized). Regenerate when recipes/events change.
            perItem: {
                // Fitted by tools/loot-equilibrium.mjs --fit against the ownership-
                // clustered recipes (materialOwnership.js): weights reconcile each
                // item's drop income with its recipe demand inside the now-focused
                // pools. Regenerate when recipes/events change.
                "composite-casing": 10,
                "aluminum-shell": 4.82,
                "logic-ribbon-cable": 2.58,
                "circuit-board": 1.55,
                "ceramic-insulator": 1.45,
                "copper-wire": 1.43,
                "relay-antenna-strut": 1.41,
                "power-cell-casing": 1.22,
                "etched-keyplate-blank": 0.15,
                "micro-bearing-set": 0.13,
                "canvas-fiber": 0.12,
                "tanned-gut-cord": 0.12,
                "resin-casing": 0.12,
                "spore-felt-padding": 0.12,
                "plastic-casing": 0.09,
                "glass-lens": 0.09,
                "brass-fittings": 0.09,
                "iron-frame": 0.09,
                "steel-plates": 0.09,
                "fabric-mesh": 0.09,
                "polymer-tubing": 0.09,
                "carbon-housing": 0.09,
                "rubber-seal": 0.09,
                "leather-straps": 0.09,
                "chitin-plate": 0.09,
                "matte-coating-compound": 0.09,
                "acoustic-foam-wafer": 0.09,
                "optic-fiber-spool": 0.09
            }
        },
        quantity: {
            // Sized against the sticky-region player model: 1-2 per drop paces gear
            // completion toward the 30-day target and keeps inventory piles lean
            gate: {
                base: 1,
                random: 1
            },
            hazard: {
                base: 1,
                random: 1
            }
        }
    },
    uncommon: {
        name: "Uncommon",
        order: 2,
        // 6-digit, like every other rarity. This carried a redundant `ff` alpha —
        // no rendering difference, but it is the one swatch that could not be fed
        // to anything expecting #rrggbb, and the old value-pinned test only ever
        // looked at `rare` so nothing noticed.
        color: "#3bf683",
        craftingCost: 15,
        dropChance: {
            // Per-event chance; gates compound over 2-4 events so keep this low
            // (0.30 -> ~66% per gate room, ~41% per hazard room at tier 1)
            base: 0.3,
            perTier: 0.03,
            max: 0.6,
            // Fitted by tools/loot-equilibrium.mjs --fit: uncommon intermediates now
            // drop from the skill chains (full recipe components), so shape the mix
            // to demand like the other tiers. Regenerate when recipes change.
            perItem: {
                "sealed-hydraulic-pump": 10,
                "medical-stimulant-cartridge": 0.22,
                "precision-servo-gear": 0.12,
                "signal-processor-core": 0.12,
                "override-datakey": 0.12,
                "power-regulation-unit": 0.12,
                "drone-gyro-assembly": 0.12,
                "ultrasonic-sensor-grid": 0.12,
                "thermal-polarizer-film": 0.12,
                "nutrient-catalyst-ampoule": 0.12,
                "symbiotic-culture-vial": 0.12,
                "pheromone-distiller-coil": 0.12,
                "nutrient-gel-pack": 0.12,
                "adaptive-filter-membrane": 0.12,
                "phase-lens-array": 0.12,
                "micro-servo-drill": 0.12,
                "vibration-dampener": 0.12,
                "ghost-signal-modulator": 0.12
            }
        },
        quantity: {
            gate: {
                base: 2,
                random: 1
            },
            hazard: {
                base: 1,
                random: 1
            }
        }
    },
    rare: {
        name: "Rare",
        order: 3,
        // blue-400, not blue-500: the -500 stop failed WCAG AA on every background
        // it is used against (4.10 on the raid log, 3.52 on a room-card header,
        // 4.33 on the game body). Same hue, one stop lighter, 5.09-6.26 everywhere.
        color: "#60a5fa",
        craftingCost: 70,
        dropChance: {
            // Per-event chance; also drives the bonus-cascade rare step
            // (~55% per gate room, ~33% per hazard room at tier 1, all paths combined)
            gate: {
                base: 0.18,
                perTier: 0.04,
                max: 0.5
            },
            hazard: {
                base: 0.15,
                perTier: 0.04,
                max: 0.4
            },
            perItem: {
                // Fitted by tools/loot-equilibrium.mjs --fit against the ownership-
                // clustered recipes. Regenerate when recipes change.
                "radiation-sensor-module": 8.0,
                "signal-sync-crystal": 2.41,
                "data-storage-crystal": 0.17,
                "precision-chrono-core": 0.16,
                "high-torque-motor-core": 0.16,
                "encrypted-transceiver-chip": 0.16,
                "voltage-regulator-unit": 0.16,
                "bio-conductive-mesh": 0.16,
                "synthetic-pheromone-capsule": 0.16,
                "containment-gel-lining": 0.16,
                "em-interference-chip": 0.16,
                "harmonic-stabilizer-core": 0.16
            }
        },
        quantity: {
            gate: {
                base: 2,
                perTier: 1,
                max: 4
            },
            hazard: {
                base: 1,
                random: 2
            }
        }
    },
    epic: {
        name: "Epic",
        order: 4,
        // purple-400, not purple-500 — same reason as rare above. The -500 stop was
        // the worst rarity on the palette (3.81 / 3.27 / 4.02); this reads 4.89-6.02
        // and still sits clearly between rare's blue and legendary's gold.
        color: "#c084fc",
        craftingCost: 300,
        dropChance: {
            gate: {
                base: 0.2,
                perTier: 0.05,
                max: 0.4
            },
            hazard: {
                base: 0.15,
                perTier: 0.05,
                max: 0.3
            },
            perItem: {}
        },
        quantity: 1
    },
    legendary: {
        name: "Legendary",
        order: 5,
        color: "#eab308",
        craftingCost: 750,
        dropChance: {
            base: 0.000001,
            perTier: 0.01,
            max: 0.05,
            // Utility-artifact blueprints have no skill tie, so they appear in
            // EVERY room's legendary pool and would soak most rolls. Half weight
            // keeps them obtainable anywhere while skill-tied blueprints (weight
            // 1.0, present only in rooms using their skill) win more of the rolls
            // in the rooms players target for them.
            perItem: {
                "data-cache-drive-blueprint": 0.5,
                "relic-resonance-tuner-blueprint": 0.5,
                "hazard-lens-visor-blueprint": 0.5,
                "recovery-injector-blueprint": 0.5,
                "contract-beacon-blueprint": 0.5,
                "salvage-compression-rig-blueprint": 0.5,
                "sync-regulator-watch-blueprint": 0.5,
                "auto-stabilizer-pack-blueprint": 0.5,
                "training-node-deck-blueprint": 0.5,
                "crosslink-amplifier-blueprint": 0.5,
                "material-extractor-blueprint": 0.5,
                "memory-crystal-shard-blueprint": 0.5
            }
        },
        quantity: 1
    },
    unique: {
        name: "Unique",
        order: 6,
        color: "#f97316",
        craftingCost: 1500,
        dropChance: {
            base: 0.015,
            minTier: 4,
            // Selection WEIGHTS within the pool, like every other rarity here — NOT
            // per-item rates, and they do not override `minTier`. The old comment
            // claimed otherwise and was wrong: `getRarityDropChance` reads minTier
            // and never looks at perItem, so there is no per-item escape from the
            // tier gate. Worth knowing before L4's T0 — reaching story relics below
            // Tier 4 means changing minTier or the pool, not adding entries here.
            perItem: {}
        },
        quantity: 1
    }
};
const $ce6dd72bc4611534$export$a4f81eda8633632 = [
    // === Story Relics ===
    {
        id: "collapse-key-fragment",
        name: "Collapse Key Fragment",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDDDD\uFE0F",
        description: "Encrypted shard containing partial records of the Collapse.",
        short: "Encrypted shard with Collapse records."
    },
    {
        id: "echo-memory-shard",
        name: "Echo Memory Shard",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDC8E",
        description: "Crystallized imprint of pre-collapse memories and signals.",
        short: "Crystallized pre-collapse memories."
    },
    {
        id: "reality-breach-record",
        name: "Reality Breach Record",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDCDC",
        description: "Primary-source documentation of the earliest breach events.",
        short: "Records of the first breaches."
    },
    {
        id: "dimensional-artifact",
        name: "Dimensional Artifact",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83C\uDF00",
        description: "Object exhibiting multi-state presence across unstable fields.",
        short: "Object with multi-state presence."
    },
    {
        id: "temporal-echo-crystal",
        name: "Temporal Echo Crystal",
        type: "storyRelic",
        rarity: "unique",
        icon: "\u23F3",
        description: "Crystal with layered timestamps\u2014echoes from divergent timelines.",
        short: "Crystal echoing divergent timelines."
    }
];
const $ce6dd72bc4611534$export$2508a374b14b8e59 = [
    {
        id: "signal-processor-core",
        name: "Signal Processor Core",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDCBD",
        description: "Miniature processor unit that boosts data throughput in repeater systems.",
        short: "Processing chip for advanced comm systems."
    },
    {
        id: "precision-servo-gear",
        name: "Precision Servo Gear",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\u2699\uFE0F",
        description: "Fine-tuned metal servo component used in precision motor assemblies.",
        short: "Precision gear for mechanical control units."
    },
    {
        id: "nutrient-catalyst-ampoule",
        name: "Nutrient Catalyst Ampoule",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDCA7",
        description: "Sealed glass vial of nutrient mist used to accelerate biological growth.",
        short: "Catalyst fluid for rapid plant growth."
    },
    {
        id: "adaptive-filter-membrane",
        name: "Adaptive Filter Membrane",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83C\uDF2B\uFE0F",
        description: "Reactive fiber mesh that filters toxins and airborne pathogens.",
        short: "Filter sheet for respirators and purifiers."
    },
    {
        id: "ultrasonic-sensor-grid",
        name: "Ultrasonic Sensor Grid",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDCE1",
        description: "Array of micro-emitters tuned for acoustic mapping and detection.",
        short: "Acoustic sensor assembly for scanners."
    },
    {
        id: "micro-servo-drill",
        name: "Micro-Servo Drill",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83E\uDE9B",
        description: "High-speed micro drill used in lockpicking and mechanical breach kits.",
        short: "Precision drill component for breach tools."
    },
    {
        id: "vibration-dampener",
        name: "Vibration Dampener",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDD07",
        description: "Rubberized composite that absorbs vibration and reduces sound transmission.",
        short: "Noise-canceling gel used in stealth equipment."
    },
    {
        id: "thermal-polarizer-film",
        name: "Thermal Polarizer Film",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83E\uDE9E",
        description: "Transparent sheet that filters heat and glare for protective visors.",
        short: "Heat-filtering film for visors and lenses."
    },
    {
        id: "medical-stimulant-cartridge",
        name: "Medical Stimulant Cartridge",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDC89",
        description: "Preloaded cartridge containing controlled restorative compounds.",
        short: "Pharma cartridge for emergency injectors."
    },
    {
        id: "power-regulation-unit",
        name: "Power Regulation Unit",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\u26A1",
        description: "Compact control block used to distribute and stabilize power flow in complex systems.",
        short: "Stabilizer unit for energy systems and machinery."
    },
    {
        id: "sealed-hydraulic-pump",
        name: "Sealed Hydraulic Pump",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDEE0\uFE0F",
        description: "Compact hydraulic pump designed for portable mechanical devices.",
        short: "Fluid pressure unit for small machines and stabilizers."
    },
    {
        id: "nutrient-gel-pack",
        name: "Nutrient Gel Pack",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83E\uDD7C",
        description: "Sealed packet of regenerative gel used to sustain and accelerate plant regrowth.",
        short: "Growth medium for biological repair devices."
    },
    {
        id: "override-datakey",
        name: "Override Datakey",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDD11",
        description: "Pre-authorized command key that grants temporary root access to compliant Dominion systems.",
        short: "Root-access key for system takeovers."
    },
    {
        id: "drone-gyro-assembly",
        name: "Drone Gyro Assembly",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDEF8",
        description: "Self-leveling gyroscope block recovered from downed drones, the heart of any stable airframe.",
        short: "Stabilizing gyro for drone frames."
    },
    {
        id: "symbiotic-culture-vial",
        name: "Symbiotic Culture Vial",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83E\uDDEA",
        description: "Living culture of paired organisms that accelerate each other's growth when introduced to a host.",
        short: "Living culture for growth acceleration."
    },
    {
        id: "pheromone-distiller-coil",
        name: "Pheromone Distiller Coil",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDC1D",
        description: "Condensing coil that concentrates raw gland extracts into potent behavioral signals.",
        short: "Distiller coil for pheromone extraction."
    },
    {
        id: "phase-lens-array",
        name: "Phase Lens Array",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDD2D",
        description: "Stacked lens set that splits and rejoins light out of phase, bending sightlines around its bearer.",
        short: "Phase optics for displacement gear."
    },
    {
        id: "ghost-signal-modulator",
        name: "Ghost Signal Modulator",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        description: "Modulator that wraps real transmissions inside fabricated noise, leaving trackers chasing echoes.",
        short: "Signal wrapper that fakes transmission sources."
    }
];
const $ce6dd72bc4611534$export$e32476559574be7c = [
    {
        id: "photo-charm",
        name: "Photo Charm Pendant",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCF7",
        description: "Transparent polymer locket containing a color photo of a pet. Image still bright.",
        short: "Polymer locket with pet photo.",
        variantTags: [
            "pendant",
            "jewelry",
            "photo",
            "polymer"
        ],
        credits: 100
    },
    {
        id: "festival-wristband",
        name: "Festival Wristband",
        rarity: "common",
        type: "relic",
        icon: "\uD83C\uDF9F\uFE0F",
        description: "Printed polymer band from a summer event. Microtext lists the performer lineup.",
        short: "Summer event polymer wristband.",
        variantTags: [
            "wristband",
            "festival",
            "plastic",
            "print"
        ],
        credits: 95
    },
    {
        id: "souvenir-mug",
        name: "Souvenir Mug",
        rarity: "common",
        type: "relic",
        icon: "\u2615",
        description: "Ceramic cup labeled 'First Orbit Park.' Glaze intact despite chipping.",
        short: "Ceramic mug from orbit park.",
        variantTags: [
            "mug",
            "ceramic",
            "souvenir",
            "cup"
        ],
        credits: 100
    },
    {
        id: "keyring-tag",
        name: "Keyring Tag",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDD11",
        description: "Stamped aluminum key-tag from a transit depot locker bank.",
        short: "Stamped locker key tag.",
        variantTags: [
            "key",
            "tag",
            "metal",
            "transit"
        ],
        credits: 90
    },
    {
        id: "school-badge",
        name: "School Badge",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCDB",
        description: "Enamel pin depicting a school crest with a stylized orbit and laurel.",
        short: "Enamel pin with school crest.",
        variantTags: [
            "pin",
            "enamel",
            "badge",
            "school"
        ],
        credits: 105
    },
    {
        id: "magazine-cover",
        name: "Magazine Cover (Laminate)",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCF0",
        description: "Fashion issue showing bright colors and optimistic slogans about 'The Age of Harmony.'",
        short: "Laminated fashion magazine cover.",
        variantTags: [
            "magazine",
            "print",
            "fashion",
            "poster"
        ],
        credits: 98
    },
    {
        id: "transit-map",
        name: "Transit Map Foldout",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDDFA\uFE0F",
        description: "Folding map for a multi-line rail network. Still legible with UV markings.",
        short: "Fold-out map of rail lines.",
        variantTags: [
            "map",
            "paper",
            "transit",
            "foldout"
        ],
        credits: 105
    },
    {
        id: "childrens-figurine",
        name: "Children's Figurine",
        rarity: "common",
        type: "relic",
        icon: "\uD83E\uDDF8",
        description: "Small injection-molded hero figure with a chipped cape and faded paint.",
        short: "Small molded hero figure.",
        variantTags: [
            "toy",
            "figurine",
            "plastic",
            "child"
        ],
        credits: 100
    },
    {
        id: "cafe-token",
        name: "Caf\xe9 Token",
        rarity: "common",
        type: "relic",
        icon: "\uD83E\uDE99",
        description: "Stamped brass token for a downtown caf\xe9's loyalty promotion.",
        short: "Stamped brass caf\xe9 token.",
        variantTags: [
            "token",
            "brass",
            "cafe",
            "coin"
        ],
        credits: 110
    }
];
const $ce6dd72bc4611534$export$5255cc549327de05 = [
    {
        id: "signed-novel",
        name: "Signed Novel",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCDA",
        description: "Printed softcover novel with a personal autograph on the title page.",
        short: "Autographed softcover novel.",
        variantTags: [
            "book",
            "signed",
            "print",
            "literature"
        ],
        credits: 150
    },
    {
        id: "photo-album",
        name: "Family Photo Album",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCD4",
        description: "Cloth-bound album with adhesive pages; family celebrations and travel scenes.",
        short: "Cloth-bound family album.",
        variantTags: [
            "photos",
            "album",
            "family",
            "paper"
        ],
        credits: 140
    },
    {
        id: "gallery-poster",
        name: "Gallery Poster",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDDBC\uFE0F",
        description: "Matte poster for a local art gallery opening. Colors remain stable.",
        short: "Matte poster for gallery opening.",
        variantTags: [
            "poster",
            "art",
            "gallery",
            "print"
        ],
        credits: 160
    },
    {
        id: "award-plaque",
        name: "Award Plaque",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83C\uDFC5",
        description: "Laser-engraved acrylic plaque recognizing a community service contribution.",
        short: "Laser-engraved award plaque.",
        variantTags: [
            "plaque",
            "award",
            "engraved",
            "acrylic"
        ],
        credits: 145
    },
    {
        id: "studio-sketchbook",
        name: "Studio Sketchbook",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCD3",
        description: "Wire-bound sketchbook filled with charcoal studies and ink experiments.",
        short: "Wire-bound artist sketchbook.",
        variantTags: [
            "sketch",
            "charcoal",
            "ink",
            "paper"
        ],
        credits: 155
    },
    {
        id: "recipe-tablet",
        name: "Recipe Tablet",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCF1",
        description: "Lightweight e-ink tablet preloaded with family recipes and grocery lists.",
        short: "E-ink tablet with recipes.",
        variantTags: [
            "tablet",
            "e-ink",
            "recipe",
            "notes"
        ],
        credits: 175
    },
    {
        id: "wedding-invitation",
        name: "Wedding Invitation",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDC8C",
        description: "Foil-stamped cardstock with embossed names and an ornate border.",
        short: "Foil-stamped invitation card.",
        variantTags: [
            "invitation",
            "wedding",
            "card",
            "foil"
        ],
        credits: 135
    },
    {
        id: "journal-pen",
        name: "Journal & Pen",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDD8A\uFE0F",
        description: "Leatherette notebook paired with a smooth fine-point pen.",
        short: "Notebook with fine-point pen.",
        variantTags: [
            "journal",
            "pen",
            "stationery",
            "paper"
        ],
        credits: 165
    },
    {
        id: "vacation-souvenir",
        name: "Vacation Souvenir",
        rarity: "uncommon",
        type: "relic",
        icon: "\u2744\uFE0F",
        description: "Miniature snow globe of a coastal skyline, filled with preserved glitter flakes.",
        short: "Coastal skyline snow globe.",
        variantTags: [
            "souvenir",
            "snowglobe",
            "travel",
            "miniature"
        ],
        credits: 170
    }
];
const $ce6dd72bc4611534$export$d3e0e7174c382d10 = [
    {
        id: "archive-disk",
        name: "Archive Disk",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDCBD",
        description: "Data crystal containing preserved recordings fro...ly public broadcasts and performances. Still partially readable.",
        short: "Data crystal with old programs.",
        variantTags: [
            "archive",
            "data",
            "recording",
            "media"
        ],
        credits: 350
    },
    {
        id: "unity-ribbon",
        name: "Unity Ribbon",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDF97\uFE0F",
        description: "Ribbon worn during a city-wide unification ceremony; dyes remain vibrant.",
        short: "Ceremonial unity ribbon.",
        variantTags: [
            "ribbon",
            "ceremony",
            "textile",
            "symbol"
        ],
        credits: 320
    },
    {
        id: "art-glass-vase",
        name: "Art Glass Vase",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFFA",
        description: "Hand-blown glass with layered color bands and a maker's stamp near the base.",
        short: "Hand-blown art glass vase.",
        variantTags: [
            "glass",
            "vase",
            "art",
            "handmade"
        ],
        credits: 375
    },
    {
        id: "architectural-model",
        name: "Architectural Model",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFD7\uFE0F",
        description: "Scale model of a civic building in foam and resin with etched window detail.",
        short: "Scale model of civic building.",
        variantTags: [
            "model",
            "architecture",
            "scale",
            "civic"
        ],
        credits: 340
    },
    {
        id: "performance-mask",
        name: "Performance Mask",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFAD",
        description: "Stage mask crafted from lacquered wood; interior padding still intact.",
        short: "Lacquered theatrical mask.",
        variantTags: [
            "mask",
            "theatre",
            "stage",
            "wood"
        ],
        credits: 330
    },
    {
        id: "sports-trophy",
        name: "Sports Trophy",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFC6",
        description: "Metal cup on a wooden base with a dedication plate for a city championship.",
        short: "Metal cup on wood base.",
        variantTags: [
            "trophy",
            "sports",
            "metal",
            "award"
        ],
        credits: 360
    },
    {
        id: "broadcast-award",
        name: "Broadcast Award",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDCFA",
        description: "Regional accolade for excellence in news programming; engraved date partially worn.",
        short: "Regional news award.",
        variantTags: [
            "award",
            "broadcast",
            "news",
            "engraved"
        ],
        credits: 345
    },
    {
        id: "city-banner-fragment",
        name: "City Banner Fragment",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDEA9",
        description: "Cloth fragment from a civic banner; hemmed edge and reinforced grommet hole.",
        short: "Fragment of civic banner.",
        variantTags: [
            "banner",
            "cloth",
            "city",
            "fragment"
        ],
        credits: 310
    },
    {
        id: "public-sculpture-miniature",
        name: "Public Sculpture Miniature",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDDFF",
        description: "Desk-sized resin replica of a well-known city sculpture.",
        short: "Miniature of public artwork.",
        variantTags: [
            "sculpture",
            "replica",
            "resin",
            "art"
        ],
        credits: 390
    }
];
const $ce6dd72bc4611534$export$d82f13cda8103b44 = [
    {
        id: "time-capsule",
        name: "Time Capsule",
        rarity: "epic",
        type: "relic",
        icon: "\u23F3",
        description: "Sealed alloy container with personal notes, coins, and local newspapers.",
        short: "Sealed container of mementos.",
        variantTags: [
            "capsule",
            "sealed",
            "alloy",
            "time"
        ],
        credits: 850
    },
    {
        id: "national-flag",
        name: "National Flag",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDEA9",
        description: "Folded synthetic fabric in perfect colors, sealed in inert gas casing.",
        short: "Folded synthetic national flag.",
        variantTags: [
            "flag",
            "national",
            "fabric",
            "sealed"
        ],
        credits: 900
    },
    {
        id: "concert-guitar",
        name: "Concert Guitar",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFB8",
        description: "Stage-played instrument with visible pick wear and intact signature on the body.",
        short: "Signed, stage-played guitar.",
        variantTags: [
            "guitar",
            "music",
            "signed",
            "stage"
        ],
        credits: 950
    },
    {
        id: "literary-manuscript",
        name: "Literary Manuscript",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCDC",
        description: "Typed pages with redline edits and margin notes; author's seal on first sheet.",
        short: "Typed pages with redlines.",
        variantTags: [
            "manuscript",
            "pages",
            "typed",
            "edits"
        ],
        credits: 820
    },
    {
        id: "museum-maquette",
        name: "Museum Maquette",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFDB\uFE0F",
        description: "Small-scale exhibition model with labeled plinths and lighting plan.",
        short: "Small-scale museum exhibit model.",
        variantTags: [
            "maquette",
            "museum",
            "model",
            "exhibit"
        ],
        credits: 875
    },
    {
        id: "charter-document",
        name: "Charter Document",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCDC",
        description: "Parchment-style print with embossed seal and signatures of founding council.",
        short: "Founding charter with seal.",
        variantTags: [
            "charter",
            "document",
            "seal",
            "founding"
        ],
        credits: 880
    },
    {
        id: "film-award",
        name: "Film Award",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFAC",
        description: "Sculpted statuette for excellence in filmmaking; base plate lists the production crew.",
        short: "Statuette for filmmaking.",
        variantTags: [
            "film",
            "award",
            "statuette",
            "cinema"
        ],
        credits: 925
    },
    {
        id: "fashion-archive",
        name: "Fashion Archive",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDC57",
        description: "Transparent crate of preserved high-fashion garments, colors unfaded.",
        short: "Preserved high-fashion garment collection.",
        variantTags: [
            "fashion",
            "archive",
            "garment",
            "case"
        ],
        credits: 1000
    },
    {
        id: "founders-journal",
        name: "Founders' Journal",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCD6",
        description: "Leather-bound personal chronicle written by ea...rly colonists, containing reflections on cooperation and hope.",
        short: "Early colonist personal chronicle.",
        variantTags: [
            "journal",
            "book",
            "historic",
            "colonial"
        ],
        credits: 860
    }
];
const $ce6dd72bc4611534$export$2aa6464abbbb5bfc = {
    coreCommons: [
        "steel-plates",
        "glass-lens",
        "rubber-seal",
        "iron-frame"
    ],
    skills: {
        // ===== DOMINION =====
        // c1 copper-wire, c2 circuit-board, c3 relay-antenna-strut,
        // c4 logic-ribbon-cable, c5 ceramic-insulator, c6 power-cell-casing,
        // c7 composite-casing, c8 aluminum-shell
        "signal-relay": {
            commons: [
                "copper-wire",
                "circuit-board",
                "relay-antenna-strut",
                "logic-ribbon-cable"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "signal-processor-core",
                "precision-servo-gear",
                "power-regulation-unit"
            ],
            rares: [
                "encrypted-transceiver-chip"
            ]
        },
        "system-override": {
            commons: [
                "ceramic-insulator",
                "power-cell-casing",
                "composite-casing",
                "aluminum-shell"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "signal-processor-core",
                "override-datakey"
            ],
            rares: [
                "encrypted-transceiver-chip",
                "voltage-regulator-unit"
            ]
        },
        "drone-command": {
            commons: [
                "copper-wire",
                "circuit-board",
                "ceramic-insulator",
                "power-cell-casing"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "override-datakey",
                "drone-gyro-assembly",
                "power-regulation-unit"
            ],
            rares: [
                "voltage-regulator-unit",
                "signal-sync-crystal"
            ]
        },
        "safeguard": {
            commons: [
                "relay-antenna-strut",
                "logic-ribbon-cable",
                "composite-casing",
                "aluminum-shell"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "drone-gyro-assembly",
                "sealed-hydraulic-pump"
            ],
            rares: [
                "signal-sync-crystal",
                "radiation-sensor-module"
            ]
        },
        "quantum-scan": {
            commons: [
                "copper-wire",
                "relay-antenna-strut",
                "ceramic-insulator",
                "composite-casing"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "sealed-hydraulic-pump",
                "precision-servo-gear"
            ],
            rares: [
                "radiation-sensor-module"
            ]
        },
        // ===== WILDERS =====
        // c1 fabric-mesh, c2 canvas-fiber, c3 leather-straps, c4 tanned-gut-cord,
        // c5 polymer-tubing, c6 resin-casing, c7 chitin-plate, c8 spore-felt-padding
        "reclamation": {
            commons: [
                "fabric-mesh",
                "canvas-fiber",
                "leather-straps",
                "tanned-gut-cord"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "nutrient-catalyst-ampoule",
                "nutrient-gel-pack",
                "medical-stimulant-cartridge"
            ],
            rares: [
                "high-torque-motor-core"
            ]
        },
        "growth-control": {
            commons: [
                "polymer-tubing",
                "resin-casing",
                "chitin-plate",
                "spore-felt-padding"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "nutrient-catalyst-ampoule",
                "symbiotic-culture-vial"
            ],
            rares: [
                "high-torque-motor-core",
                "bio-conductive-mesh"
            ]
        },
        "wild-influence": {
            commons: [
                "fabric-mesh",
                "canvas-fiber",
                "polymer-tubing",
                "resin-casing"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "symbiotic-culture-vial",
                "pheromone-distiller-coil",
                "medical-stimulant-cartridge"
            ],
            rares: [
                "bio-conductive-mesh",
                "synthetic-pheromone-capsule"
            ]
        },
        "bio-shield": {
            commons: [
                "leather-straps",
                "tanned-gut-cord",
                "chitin-plate",
                "spore-felt-padding"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "pheromone-distiller-coil",
                "adaptive-filter-membrane"
            ],
            rares: [
                "synthetic-pheromone-capsule",
                "containment-gel-lining"
            ]
        },
        "containment": {
            commons: [
                "fabric-mesh",
                "leather-straps",
                "polymer-tubing",
                "chitin-plate"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "adaptive-filter-membrane",
                "nutrient-gel-pack"
            ],
            rares: [
                "containment-gel-lining"
            ]
        },
        // ===== VEIL =====
        // c1 brass-fittings, c2 carbon-housing, c3 plastic-casing,
        // c4 micro-bearing-set, c5 optic-fiber-spool, c6 matte-coating-compound,
        // c7 acoustic-foam-wafer, c8 etched-keyplate-blank
        "echo-trace": {
            commons: [
                "brass-fittings",
                "carbon-housing",
                "plastic-casing",
                "micro-bearing-set"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "ultrasonic-sensor-grid",
                "phase-lens-array",
                "thermal-polarizer-film"
            ],
            rares: [
                "data-storage-crystal"
            ]
        },
        "lock-breach": {
            commons: [
                "optic-fiber-spool",
                "matte-coating-compound",
                "acoustic-foam-wafer",
                "etched-keyplate-blank"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "ultrasonic-sensor-grid",
                "micro-servo-drill"
            ],
            rares: [
                "data-storage-crystal",
                "precision-chrono-core"
            ]
        },
        "stealth-transit": {
            commons: [
                "brass-fittings",
                "carbon-housing",
                "optic-fiber-spool",
                "matte-coating-compound"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "micro-servo-drill",
                "vibration-dampener",
                "thermal-polarizer-film"
            ],
            rares: [
                "precision-chrono-core",
                "em-interference-chip"
            ]
        },
        "signal-mask": {
            commons: [
                "plastic-casing",
                "micro-bearing-set",
                "acoustic-foam-wafer",
                "etched-keyplate-blank"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "vibration-dampener",
                "ghost-signal-modulator"
            ],
            rares: [
                "em-interference-chip",
                "harmonic-stabilizer-core"
            ]
        },
        "transit-anchor": {
            commons: [
                "brass-fittings",
                "plastic-casing",
                "optic-fiber-spool",
                "acoustic-foam-wafer"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "ghost-signal-modulator",
                "phase-lens-array"
            ],
            rares: [
                "harmonic-stabilizer-core"
            ]
        }
    }
};
const $ce6dd72bc4611534$export$9f9786ac427715c7 = {
    /**
   * Durable-gear craft cap. Skill (tech) gear and artifacts are equip-once
   * items - one slot per skill / per artifact slot, never consumed, sold, or
   * traded - so a second copy earns nothing (marks are already distinct-only)
   * and just burns materials. When false (default) each such design can be
   * crafted once per character; the crafting card shows "✓ CRAFTED" instead.
   * Flip to true to re-enable duplicate crafting (e.g. if a gear marketplace
   * ever makes spare copies worth something). Consumables are unaffected.
   */ allowDuplicateCrafts: false,
    recipeInputs: {
        // Re-tuned for weighted per-item drops: selection weights spread drops across
        // all items (nothing starves to zero anymore), so demand carries the pacing
        common: 5,
        uncommon: 5,
        rare: 4,
        epic: 4,
        legendary: 1,
        unique: 1
    },
    /**
   * Skill points awarded per level up (character-core.js levelUpCore).
   * Formula: base + Math.floor(level / levelDivisor) * increment
   * where `level` is the level just REACHED.
   *
   * With the values below (base: 2, levelDivisor: 2, increment: 3):
   * - Level 1:   3 skill points (the starting allotment, not a level-up grant)
   * - Level 2-3: 5 per level-up
   * - Level 4-5: 8 per level-up
   * - Level 6-7: 11 per level-up
   */ skillPointsPerLevel: {
        base: 2,
        levelDivisor: 2,
        increment: 3
    },
    /**
   * Per-skill synergy unlocks (progressive disclosure of the synergy layer):
   * hidden entirely below minLevel, then each skill's synergies are bought
   * with skill points. A synergy variant can fire only when it touches an
   * unlocked skill on either side (the event's skill, or the skill of the
   * player's partner device).
   */ synergyUnlocks: {
        minLevel: 4,
        cost: 2
    },
    /**
   * Raid XP tier weighting (Command era). The level curve's old assumption
   * ("level 8 in 1-2 months") predates promotion cycling; with 3-5 day
   * tours, character level was the binding progression constraint - tours
   * stalled at level 4-5 on tier-1 XP. Pushing tiers is now the leveling
   * ladder: T1 pacing (and first-promotion timing) unchanged, T2/T3 raids
   * pay multiples so deep tours can level past the plateau.
   */ raidXpTierMultipliers: {
        1: 1,
        2: 3,
        3: 5
    },
    /**
   * Skill event damage scaling per raid tier
   * Damage formula: minDamage + random(0, maxDamage - minDamage)
   * where minDamage = baseDamage * tier, maxDamage = minDamage + (baseDamage * tier)
   *
   * Example with defaults (baseDamage: 5):
   * - Tier 1: 5-15 damage (5 + 0-10)
   * - Tier 2: 10-30 damage (10 + 0-20)
   * - Tier 3: 15-45 damage (15 + 0-30)
   */ skillEventDamage: {
        baseDamage: 5,
        perTier: {
            1: {
                min: 20,
                max: 30
            },
            2: {
                min: 25,
                max: 35
            },
            3: {
                min: 30,
                max: 40
            }
        }
    },
    /**
   * Bonus event cascade chance multipliers, per raid tier AND per cascade step.
   * Applied as: rarityDropChance * bonusEventCascadeMultipliers[tier][nextRarity]
   * when the end-of-room bonus event rolls to cascade common→rare→epic→legendary→unique.
   *
   * Per-rarity so the legendary step can be boosted (its base chance is near zero,
   * this is the main legendary blueprint source) WITHOUT saturating the rare/epic
   * steps - a flat multiplier clamped those to 100% per clean room.
   */ bonusEventCascadeMultipliers: {
        // rare < 1.0 keeps leaf-rare cascade volume near recipe demand.
        // Legendary (= artifact blueprints, the whole legendary pool) is a TIER 3
        // EXCLUSIVE: reaching T3 is the plannable path to artifacts (and the
        // Syndicate boundary), not a lottery ticket at every tier. 50 saturates
        // the legendary step (0.02 base x 50 = chance 1.0 once the cascade
        // reaches epic), so a clean T3 room drops a blueprint at its epic-chain
        // rate (~3% hazard, ~7% gate).
        1: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        2: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        3: {
            rare: 0.5,
            epic: 1.0,
            legendary: 50,
            unique: 1.0
        }
    },
    /**
   * Share of a promoted character's MATERIALS that passes to their successor.
   * The remainder is consigned to the Syndicate dock as Operations cargo
   * (command-core.js disburseInventory).
   *
   * Fixed, and was a three-rank Command upgrade ("Guild Vault", 80/240/720
   * marks) until the S7c pass removed it. The rank bought nothing: gear crafted
   * per tour is FLAT across a 2.5x range of this value - 5.57 at 10/20/30,
   * 6.07 at 15/30/50, 5.61 at 25/50/75, n=4 each - so the upgrade taxed 1,040
   * marks for an effect that does not exist. An upgrade that cannot be measured
   * is worse than no upgrade, because buying it is a trap.
   *
   * Why the share does not matter: it is not a one-way transfer. Whatever the
   * successor inherits and does not CONSUME is disbursed again at their own
   * promotion, and again after that, so the dial changes timing rather than
   * totals. Measured: at 75% carryover the L3 dock was unchanged (17,977 vs
   * 18,504 units) and zero convoys were ever refused for cargo.
   *
   * 0.3 because it equals the old rank-3 value - nobody who had fully invested
   * is worse off - and because a flat "a third of your kit passes on" reads
   * cleanly in the fiction. Any value in 0.1-0.75 measures the same.
   */ vaultCarryover: 0.3,
    /**
   * Share of the NON-carried remainder that reaches the Syndicate dock as
   * Operations cargo. The rest is consumed — spent living, in the fiction.
   *
   * The accounting used to be closed: 30% to the successor, 70% to L3, nothing
   * lost. That was tidy and produced an unusable economy. A dock held ~18,000
   * units while a whole era's convoys consumed ~1,500 (8%), so the "common
   * material piles plateau (<300/signature)" target measured ~2,500 and rising,
   * and cargo could never be a real constraint on Operations — even 10x the
   * cargo per convoy would not have drained it.
   *
   * No dial inside Operations could fix that, because the problem is supply,
   * not demand. This is the supply valve.
   */ consignmentRate: 0.15,
    /**
   * Command layer (M2) - Command Marks formula coefficients + unlock threshold.
   * Consumed by command-core.js calculateCommandMarks:
   *   marks = perTechGear       * distinct tech gear owned (inventory + equipped)
   *         + perArtifactUnlock * lifetime.artifactsUnlocked
   *         + perArtifactCraft  * lifetime.artifactsCrafted
   *         + floor(lifetime.t3Wins / t3WinsDivisor)
   *         + perLevel          * level
   * The sim promotion policy tunes these so an un-upgraded character #1's
   * marks/hour peaks ~day 3-5 (see docs/Roadmap-070426.md playtime budget).
   */ commandMarks: {
        // Marks reward CRAFTING, which is the player's active progress: skill gear
        // early (the only thing craftable at first), artifacts later (once T3 is
        // reachable). Character level is an ENABLER, not a payout - it unlocks
        // higher tiers, which yield T3 wins + blueprints -> artifacts; its direct
        // marks contribution is deliberately small so it can't become the main
        // driver (it previously grew to ~50% of marks as accounts matured).
        // Held at 4. Raising it was MEASURED in the S7c pass and rejected: at 8,
        // three runs put the first founding on day 31/34/31 - identical to the
        // 31-36 baseline - while Writs overshot to 34-38 and the L1 era collapsed
        // from ~40h to 18-21h. Two reasons, both structural:
        //
        //  - It cannot shorten a tour. Tour length is when cumulative marks/hour
        //    PEAKS, and a bigger gear channel moves that peak later by about as
        //    much as it pays, so the schedule does not move.
        //  - Marks are also the CURRENCY for Command upgrades, so doubling this
        //    halves the real price of the whole catalogue. The first promotion
        //    fires at the 60-mark floor, which needs ~15 gear at 4 and only 8 at
        //    8 - halving the onboarding era as a side effect.
        //
        // The L2 era overruns because tours 2-15 run ~26h against the ~18h the
        // 300h budget implies. That is a CYCLE COMPRESSION problem (officer-academy
        // / guild-vault head starts not paying off enough), not a throughput one,
        // and this coefficient is the wrong lever for it.
        perTechGear: 4,
        // Artifacts split into two channels (see command-core unlockArtifactCore):
        //   perArtifactUnlock - ONE-TIME per design per ACCOUNT, banked when the
        //     design's blueprint is consumed to unlock it. The milestone: 27
        //     designs => a finite ~675-mark collection goal.
        //   perArtifactCraft - each distinct craft per character (parallel to gear,
        //     ~2x a gear piece). Keeps a modest sustained artifact-marks trickle
        //     without the runaway 25-per-craft farm.
        perArtifactUnlock: 25,
        perArtifactCraft: 8,
        // T3 wins are the "operating at high tier" marks channel that level
        // enables (2 wins per mark); artifacts are the high-tier crafting payoff
        t3WinsDivisor: 2,
        perLevel: 1,
        // Command tab reveals when estimated marks first reach this. Tied to
        // perTechGear: it fires on the 7th piece of gear. If perTechGear ever
        // moves, scale this by the same ratio - it is a progression milestone
        // measured in what the player has BUILT, and leaving it fixed would slide
        // a designed reveal earlier as a side effect of an unrelated change.
        unlockThreshold: 25
    },
    /**
   * Promotion credit levy (applied in command-core.js promoteCharacterCore).
   * Credits are account-shared, so promotion takes a percentage cut instead
   * of a flat reset: kept = max(floor, credits * keepFraction). The levy is
   * the economy's terminal credit sink — it must scale with wealth to keep
   * absorbing late-game surplus; the floor doubles as a safety net so a
   * broke account still restarts with working capital.
   */ promotionCreditLevy: {
        keepFraction: 0.25,
        floor: 1000
    },
    /**
   * Collapse Key recovery — the ONLY tunable in the story track.
   *
   * Chance that a successful raid recovers the next Collapse Key its faction is
   * still missing. Not an economic number: keys have no value, no sink and no
   * sale, so this tunes STORY PACING alone and no balance target reads it.
   *
   * The tier table (keys 1-2 at T1, 3-4 at T2, 5-7 at T3) is what actually
   * paces the arc — a T1 character can only ever hold two keys, however long
   * they raid. This number decides how quickly they reach that ceiling: at 0.25
   * the first key lands in the opening session and the T1 pair inside ~8 wins,
   * which is the point of shipping keys 1-7 at all. The game previously told
   * the player nothing until ~900 hours in.
   */ collapseKeyDropChance: 0.25,
    /**
   * Raid credit reward scaling (applied in raidUtil.js applyCreditsScaling)
   * effective = earned * globalMultiplier * tierMultipliers[tier]
   */ creditsScaling: {
        globalMultiplier: 0.3,
        tierMultipliers: {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    },
    /**
   * Energy repurchase escalation (applied in raidUtil.js
   * getConsumablePurchasePrice): energy-restoring consumables cost
   * base * escalationFactor^(purchases today), resetting daily.
   * The primary Command-era credit sink - converts surplus credits into
   * raid throughput at a net credit loss (late game: 5-6 packs/day
   * ~ the 4-10k/day income it must soak). 1.0 disables escalation.
   */ energyPurchaseScaling: {
        escalationFactor: 2.0
    },
    /**
   * Per-tour crafting discount (Command layer). Each completed tour makes
   * crafting cheaper for every later tour — the institutional-knowledge payoff.
   *
   * DERIVED, never compounded:
   *   globalMultiplier = craftingCostScaling.globalMultiplier * factor^(tour - 1)
   *
   * It used to be applied by multiplying raidUtil's module state at each
   * promotion, which main.js then re-seeded from config on every boot — so the
   * discount silently vanished on reload. Deriving it from `command.tour` makes
   * it reload-safe, and makes L3's founding reset free: tour returns to 1, so
   * the multiplier returns to base with nothing extra to persist.
   *
   * 1.0 disables the discount.
   */ craftingDiscountPerTour: 0.9,
    /**
   * Crafting credit cost scaling (applied in raidUtil.js applyCraftingCostScaling)
   * effective = cost * globalMultiplier * rarityMultipliers[rarity]
   */ craftingCostScaling: {
        globalMultiplier: 5,
        rarityMultipliers: {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    }
};
function $ce6dd72bc4611534$export$6941830bed591a7b(rarity) {
    const multiplier = $ce6dd72bc4611534$export$9f9786ac427715c7.recipeInputs[rarity];
    if (multiplier === undefined) {
        console.warn(`Unknown input rarity: ${rarity}, returning 1.0`);
        return 1.0;
    }
    return multiplier;
}
function $ce6dd72bc4611534$export$2a160ac1bc0ae37b(quantity) {
    if (quantity < 10) // Keep 1-9 as-is
    return Math.max(1, Math.ceil(quantity));
    else if (quantity < 100) // Round 10-99 to nearest 5
    return Math.ceil(quantity / 5) * 5;
    else // Round 100+ to nearest 10
    return Math.ceil(quantity / 10) * 10;
}
function $ce6dd72bc4611534$export$a43c2a5178ae7642(inputs, getRarityFn = null) {
    if (!inputs || !Array.isArray(inputs)) return inputs;
    return inputs.map((input)=>{
        let inputQty = input.qty;
        // Get input rarity (from input object or from provided function)
        let inputRarity = input.rarity;
        if (!inputRarity && getRarityFn) inputRarity = getRarityFn(input.id);
        // Apply per-input scaling based on rarity
        if (inputRarity) {
            const inputMultiplier = $ce6dd72bc4611534$export$6941830bed591a7b(inputRarity);
            inputQty *= inputMultiplier;
        }
        return {
            ...input,
            qty: $ce6dd72bc4611534$export$2a160ac1bc0ae37b(inputQty)
        };
    });
}
const $ce6dd72bc4611534$export$94e7ad7999c1ae32 = {
    1: {
        name: "Tier 1 - Exploration",
        description: "Entry-level raids with manageable challenges",
        gridSize: 7,
        gridRows: 7,
        gridCols: 7,
        contractorMinLevel: 1,
        contractorMaxLevel: 8,
        hazardSkillLevel: 3,
        gateSkillLevel: 5,
        creditRewards: {
            baseRoomCredit: 10,
            successEventCredit: 15,
            completionBonus: 30
        }
    },
    2: {
        name: "Tier 2 - Veteran",
        description: "Moderate difficulty with increased rewards",
        gridSize: 9,
        gridRows: 7,
        gridCols: 13,
        contractorMinLevel: 6,
        contractorMaxLevel: 14,
        hazardSkillLevel: 6,
        gateSkillLevel: 8,
        creditRewards: {
            baseRoomCredit: 15,
            successEventCredit: 23,
            completionBonus: 45
        }
    },
    3: {
        name: "Tier 3 - Elite",
        description: "High-risk, high-reward advanced operations",
        gridSize: 11,
        gridRows: 7,
        gridCols: 17,
        contractorMinLevel: 10,
        contractorMaxLevel: 999,
        hazardSkillLevel: 8,
        gateSkillLevel: 10,
        creditRewards: {
            baseRoomCredit: 25,
            successEventCredit: 39,
            completionBonus: 75
        }
    }
};
const $ce6dd72bc4611534$export$8377a367ab2ae550 = {
    entry: {
        description: "Starting area with easier encounters",
        recipes: {
            infrastructure: 35,
            transit: 25,
            security: 20,
            storage: 20
        },
        built: 0.72
    },
    peripheral: {
        description: "Outer areas with mixed encounters",
        recipes: {
            environmental: 40,
            transit: 20,
            storage: 20,
            habitation: 20
        },
        built: 0.58
    },
    security: {
        description: "Defensive checkpoints",
        recipes: {
            security: 45,
            infrastructure: 25,
            storage: 20,
            power: 10
        },
        built: 0.90
    },
    industrial: {
        description: "Resource/infrastructure areas",
        recipes: {
            power: 30,
            storage: 30,
            infrastructure: 25,
            transit: 15
        },
        built: 0.88
    },
    core: {
        description: "High-value protected areas",
        recipes: {
            records: 35,
            commerce: 25,
            security: 20,
            infrastructure: 20
        },
        built: 1.00
    },
    residential: {
        description: "Habitats, apartments, communal living spaces",
        recipes: {
            habitation: 50,
            environmental: 20,
            records: 15,
            commerce: 15
        },
        built: 0.85
    },
    commercial: {
        description: "Shops, offices, market halls, logistics fronts",
        recipes: {
            commerce: 50,
            storage: 20,
            records: 15,
            habitation: 15
        },
        built: 0.95
    }
};
const $ce6dd72bc4611534$export$11209b5126489e67 = {
    campsite: {
        type: "campsite",
        name: "Campsite",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDFD5\uFE0F",
        description: "A safe place to rest and recover",
        healingAmount: 30
    },
    water: {
        type: "water",
        name: "Water",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDF0A",
        description: "A water source for fishing"
    },
    road: {
        type: "road",
        name: "Road",
        primary: "",
        support: [],
        baseDuration: 10,
        icon: "\uD83D\uDEE3\uFE0F",
        description: "A roadway for fast travel"
    }
};
const $ce6dd72bc4611534$export$4fbdcec70fce9d73 = {
    // ======================================================
    "shard-cities": {
        name: "Shard Cities",
        theme: "Collapsed megacities and fractured districts",
        icon: "\uD83C\uDFD9\uFE0F",
        shortDescription: "Towering urban ruins split by broken transit lines and silent civic grids.",
        longDescription: "These were once continuous skylines: stacked transit, dense housing, and civic utilities woven into mile-high towers. Centuries of neglect cracked the pavement and snapped the skyways. You can still read the street plan, even if whole blocks have slumped into their own debris.\n\nPower occasionally surges through old feeders, enough to light a dead intersection for a breath. Most systems do nothing at all\u2014just rust, dust, and old signage pointing nowhere.",
        artDirection: "Two scales of building, and the contrast between them IS the region. The ordinary stock is warm \u2014 brick and brown roofing, low, dense, packed kerb to kerb. Over it stand cool concrete-and-glass masses: tower cores with their service shafts open to the sky, skybridge decks that start nowhere and stop in mid-air, sign gantries still spanning the carriageway. Ground is dark slate tarmac, cracked on a slab pitch, so both tiers read light against it. Street trees have come up through the pavement everywhere there was a cutout.",
        gates: [
            {
                icon: "\uD83D\uDEA7",
                name: "Checkpoint Sector",
                primary: "lock-breach",
                support: [
                    "signal-relay",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Barricaded intersection controlling movement between ruined blocks.",
                longDescription: "Concrete barriers, rusted railings, and makeshift roadblocks choke an old arterial. The city\u2019s last attempts at order still shape the flow of rubble and weeds. Nothing powers here\u2014only wind and dust."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Civic Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Collapsed service block with dead comms towers and trunk conduits.",
                longDescription: "Stubbed antenna masts lean over a plaza of broken panels and cable vaults. Dust-muted signage points to services that no longer exist. A faint click from a relay box sometimes answers fresh power before falling silent again."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Apartment Access Lot",
                primary: "stealth-transit",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Collapsed housing block entrances clustered around a cracked forecourt.",
                longDescription: "Entry canopies hang at angles over door stacks long since jammed. Mailboxes gape, names scoured to metal. The forecourt is a map of fractures and weeds, with scaffolds rusted into stillness."
            },
            {
                icon: "\uD83D\uDECD\uFE0F",
                name: "Arcade Shutter Sector",
                primary: "system-override",
                support: [
                    "drone-command",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Market frontage sealed by fallen shutters and buckled grates.",
                longDescription: "A run of storefronts slouches under dead signage and twisted awnings. Steel shutters are half-dropped or jammed, creating a maze of narrow access. Any movement here is the wind through canvas and chain."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDEE2\uFE0F",
                name: "Residential Power Yard",
                primary: "containment",
                support: [
                    "signal-relay",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Small substation between towers with fallen lines and rusted switchgear.",
                longDescription: "Transformer housings slouch on cracked pads; the fence is more gap than mesh. A wrong step crunches glass and ceramic. If anything lights, it\u2019s for a breath, then the quiet deepens."
            },
            {
                icon: "\uD83C\uDF09",
                name: "Transit Collapse Zone",
                primary: "transit-anchor",
                support: [
                    "reclamation",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Broken overpass and skybridge stubs sprawled over a debris-choked road.",
                longDescription: "Guardrails spear the pavement; cables drape from shattered spans. The echo under concrete ribs tells how big it was. Weeds stitch rebar and dust into something like ground again."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Marketfront Depot",
                primary: "drone-command",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Cluster of loading bays and shuttered storerooms behind ruined shops.",
                longDescription: "Dock plates sit crooked; pallets rot into dark lines on the ground. The loading lights are dead\u2014only daylight finds its way in through gaps and broken louvers."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Administrative Records Block",
                primary: "quantum-scan",
                support: [
                    "system-override",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Abandoned office district with shattered facades and paper-littered streets.",
                longDescription: "Stacks of files turned to mulch line the curbs where floodwater once ran. A rusted maintenance crane leans against a curtain wall. Nothing watches here\u2014only glass dust and wind."
            },
            {
                icon: "\uD83D\uDE89",
                name: "Transit Exchange Block",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "containment"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A surface-level transit interchange and service plaza linking several collapsed lines.",
                longDescription: "Once a hub for elevated trams and vertical shuttles, the block still shows the scar of its platforms. Canopies hang over cracked concrete lanes, and access ramps descend into dust-filled tunnels below."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Ruins",
                // overturned cargo trucks and container stacks, not a service yard
                recipe: "storage",
                primary: "reclamation",
                support: [
                    "drone-command",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Collapsed distribution yard filled with overturned cargo trucks and container stacks.",
                longDescription: "What was once a multi-lane loading grid now lies in layers \u2014 trucks fossilized in place, containers torn open by time. Tower cranes stand idle at the corners like monuments to motionless trade."
            },
            {
                icon: "\u26A1",
                name: "Substation Complex",
                primary: "system-override",
                support: [
                    "reclamation",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "A cluster of transformers and conduit fields forming a decommissioned power block.",
                longDescription: "Heavy transformer shells sit on cracked pads, their housings marked with long-gone warning paint. Busbars bridge between fenced sections, while cable vaults yawn open into the dark below."
            },
            {
                icon: "\uD83D\uDEC2",
                name: "Civic Control District",
                // a ring of checkpoints; "civic" pulls it to infrastructure otherwise
                recipe: "security",
                primary: "quantum-scan",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "A cluster of interconnected checkpoints surrounding a former civic administration block.",
                longDescription: "Security kiosks ring the perimeter of a low central building, their scanner frames bent but still standing. The entire block was once a controlled corridor \u2014 a mix of barriers, scanners, and causeways now frozen in collapse."
            }
        ]
    },
    // ======================================================
    "verdant-reclamation": {
        name: "Green Reclamation",
        theme: "Overgrown research campuses and greenhouse grids",
        icon: "\uD83C\uDF3F",
        shortDescription: "Bio-reclaimed districts where labs and irrigation frames disappear beneath growth.",
        longDescription: "This landscape was engineered to coax life back into sterile soil. Greenhouses formed shining corridors; irrigation lattices pulsed under glass. After the departure, containment failed and nature took the reins.\n\nNow, fibrous canopies bind whole blocks together. Steel trusses wear bark; road paint lies under moss. Machinery answers only sometimes, a pump stuttering once before the vines hold it still again.",
        artDirection: "Growth is the loudest thing on the tile and the buildings are what it grew over. Heavy canopy in deep greens, moss and wildflowers through the ground, tarmac worn back to soil. The architecture that survives is glasshouse: long shallow glazed spans ridged down their spine with panes missing and the planting showing through, irrigation lattices over what used to be beds, seed silos. Ordinary buildings are muted steel grey and mostly hidden \u2014 that is the point, they lost.",
        gates: [
            {
                icon: "\uD83E\uDDEA",
                name: "Bio-Lab Complex Gate",
                primary: "bio-shield",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed research compound entrance tangled in vines and glass.",
                longDescription: "A trellis of bent greenhouse ribs leads into a court of moss and broken tiles. Safety placards lie sun-bleached among seed trays and cracked tanks. The air is warm and wet, heavy with plant breath."
            },
            {
                icon: "\uD83D\uDEBF",
                name: "Irrigation Control Sector",
                primary: "reclamation",
                support: [
                    "growth-control",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Valve fields, cisterns, and control kiosks overtaken by roots.",
                longDescription: "Pipes run like exposed roots along the ground, bolted kiosks eaten by rust and kudzu. A cistern lid thumps underfoot\u2014water still trapped below. If anything moves, it\u2019s the wind dragging leaves across metal."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Habitation Annex Gate",
                primary: "wild-influence",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Apartment annex entrances swallowed by creepers and fallen trellis.",
                longDescription: "Balconies have become planters; stairwells bloom with ferns. Doorways stand open or warped shut, their seals crumbled to powder. A single gutter still drips into a barrel of green water."
            },
            {
                icon: "\uD83E\uDDEA",
                name: "Market Decontamination Sector",
                primary: "containment",
                support: [
                    "safeguard",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Outdoor wash stations and shuttered stalls clustered around a drained basin.",
                longDescription: "Decon arches frame a plaza of cracked tile and dried residue. The stalls around it are skeletal, their tarps long rotted away. Nothing cycles here unless you bring the power yourself."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF31",
                name: "Seed Distribution Yard",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Silos, bins, and pallet stacks buried in moss and husks.",
                longDescription: "A drift of cracked pods crunches underfoot. Stenciled measurements fade from the silo sides. Somewhere a vent exhales warm, earthy air that smells like the start of rain."
            },
            {
                icon: "\uD83C\uDF44",
                name: "Fungal Spread Block",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A shaded block carpeted with fungus and spore fans.",
                longDescription: "Stems as thick as cable push through fissures in the concrete. Spores hang in the air like dust motes in a cathedral. Your breath fogs just enough to make the light feel heavy."
            },
            {
                icon: "\uD83D\uDCA7",
                name: "Irrigation Breach Sector",
                primary: "bio-shield",
                support: [
                    "growth-control",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Ruptured mains flooding a low lot, roots drinking the overflow.",
                longDescription: "A trench of clear water has cut through soil and tile, pooling around toppled control posts. Algae paints the edges; insects tap the surface. The flow wanes and returns without reason."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Research Supply Yard",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Crated lab gear and broken cages stacked beside a ruined annex.",
                longDescription: "Numbers stenciled on crates tell of a mission left unfinished. Metal shelving slumps like wet paper. A single rain gutter ticks as it cools in the shade."
            },
            {
                icon: "\uD83C\uDFD7\uFE0F",
                name: "Habitation Block",
                primary: "wild-influence",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "A cluster of low-rise apartments overtaken by gardens and nests.",
                longDescription: "Bedsprings and trellis wire bind stairwells into new shapes. Window boxes have become small forests. The only movement is leaves, and the small quick things that live in them."
            },
            {
                icon: "\uD83E\uDED7",
                name: "Nutrient Line Rupture",
                primary: "bio-shield",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Leaking feed lines turning a block into a slick, humming wetland.",
                longDescription: "Plastic tubing loops across the ground like shed skin, seeping a sweet, metallic film. New shoots force through asphalt in a straight line where the pipe runs below."
            },
            {
                icon: "\uD83C\uDFEA",
                name: "Agri-Market Depot",
                primary: "growth-control",
                support: [
                    "containment",
                    "bio-shield"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Open-air market storage with collapsed canopies and crate rows.",
                longDescription: "Sun-faded tarps hang like old flags. The smell of dust and seed oil lingers. You can still see where chalk mapped out stall fees on the concrete."
            },
            {
                icon: "\uD83E\uDDEF",
                name: "Greenhouse Containment Sector",
                primary: "safeguard",
                support: [
                    "containment",
                    "wild-influence"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Firebreak lanes and isolation frames choking in vines.",
                longDescription: "White-painted fire lanes vanish under creepers. The shutters meant to fall in emergencies are rusted half-down. A distant pane taps in the breeze like a metronome."
            }
        ]
    },
    // ======================================================
    "sunken-bastions": {
        name: "Flooded Bastions",
        theme: "Semi-submerged fortifications and silted logistics",
        icon: "\uD83C\uDF0A",
        shortDescription: "Defense districts with the sea in them: the coast took the low blocks and the silt took the rest.",
        longDescription: "Coastal defenses once ringed this region with docks, bunkers, and pressure locks. Storm surge and slow subsidence rolled in over centuries, flooding the low blocks and salting everything else.\n\nSome pressure doors still cycle if you give them power, drawing a final gulp of air through corroded ducts. Mostly, there is water, silt, and the sound of old metal moving in the tide.",
        artDirection: "One edge of the map is open ocean and everything reads off how far it is from it. At the shore, water over the outer half of the tile, a buttressed sea wall along the waterline with its bollards behind, and what is left of the buildings is mostly wreckage in the shallows. A row in, tidal flats and standing water pooling in the streets first. Beyond that, dry. Ground is cold silt, not sand \u2014 blue-grey, damp-looking, tide-marked. Concrete is wet and weeping rust.",
        gates: [
            {
                icon: "\uD83D\uDED1",
                name: "Pressure Gate Sector",
                primary: "lock-breach",
                support: [
                    "signal-mask",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cluster of rusted airlock doors and corroded valves around a flooded court.",
                longDescription: "Door rings sit proud with barnacle rust; inspection windows are opaque with salt. The control pedestals are still in place, their labels sanded flat by wind and spray."
            },
            {
                icon: "\u2693",
                name: "Drydock Access Block",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed dock gates and winch frames guarding entry to an old basin.",
                longDescription: "The dock walls lean inward, heavy with waterlogged stone. Winch cables coil like sleeping eels beside shattered bollards. Every surface is stained a dozen kinds of orange."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Residential Seal Lot",
                primary: "containment",
                support: [
                    "safeguard",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Pressure-rated housing entries scattered along a raised walkway.",
                longDescription: "Doors that once sealed against storms now gape, warped on their hinges. A painted muster diagram flakes off the wall in curls as thin as fish scales."
            },
            {
                icon: "\uD83E\uDDF3",
                name: "Commercial Airlock Sector",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Cargo airlocks and submerged loading bays along a corroded quay.",
                longDescription: "Crate hoists stand frozen above black water. The quay edge is a jag of broken concrete and rebar, polished smooth where the tide reaches."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF0A",
                name: "Flooded Records Sector",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Archives drowned to the window line, shelves like ribs under the surface.",
                longDescription: "Folders have turned to silt drifts. A rolling ladder floats, bumping the stacks with a hollow rhythm. Light puddles on the water and slides across the ceiling."
            },
            {
                icon: "\uD83D\uDCA8",
                name: "Ventilation Intake Lot",
                primary: "echo-trace",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Banks of rusted intake fans towering over a silted forecourt.",
                longDescription: "Fan blades are choked with ropeweed and netting. A metal tag rattles faintly when the wind shifts. The air smells like creosote and tide."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Freight Access Zone",
                primary: "transit-anchor",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Collapsed ramps and container rows leading into a drowned terminal.",
                longDescription: "Container paint has bled into pastel ghosts. The ramp rails end abruptly in water that hides a second city of debris below."
            },
            {
                icon: "\uD83E\uDEB8",
                name: "Marine Observation Block",
                primary: "wild-influence",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Sea-worn platforms and pylons with algae film and broken rails.",
                longDescription: "Scope housings point at horizons no one watches. The handrails flake in layers that stain your gloves. Gulls nest in the elbows of old floodlights that will never shine again."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Flooded Living Sector",
                primary: "bio-shield",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lower housing blocks drowned to the window line, interiors slumped inward.",
                longDescription: "Mildew blooms on every surface; curtains drift like slow jelly. The line where the tide reaches is written as a salt band around the rooms."
            },
            {
                icon: "\uD83E\uDE9C",
                name: "Access Tower Sector",
                primary: "safeguard",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Stair towers and emergency ladders rising above the flood.",
                longDescription: "Cages of stairs keep their geometry against the soft line of the water. Every landing clicks and settles when the wind turns."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Cargo Intake Block",
                primary: "containment",
                support: [
                    "quantum-scan",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Shallow-water cargo ramps and corroded conveyors into a warehouse face.",
                longDescription: "Conveyor housings gape like fish skulls. A strip of weed waves where a belt used to run. The warehouse doors are heavy with swollen wood."
            },
            {
                icon: "\uD83D\uDCB0",
                name: "Finance Quarter",
                primary: "quantum-scan",
                support: [
                    "containment",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Collapsed teller halls and armored delivery bays, empty as vaults.",
                longDescription: "Coin-counting machines sit in rows like old teeth. Delivery lanes are silted to their thresholds. Everything smells faintly of metal and mildew."
            }
        ]
    },
    // ======================================================
    "cradle-expanse": {
        name: "Industrial Expanse",
        theme: "Manufacturing grids and rust plains",
        icon: "\uD83C\uDF05",
        shortDescription: "Endless factory lots, idle conveyors, and yard-wide machinery asleep in rust.",
        longDescription: "Production once moved through these blocks in steady lines\u2014ore in one side, finished goods out the other. Now the conveyors are seized and the cranes lean on their cables, frozen mid-motion for generations.\n\nWhen power returns, a servo might twitch or a stack light might glow and die. The wind does most of the work here: sandblasting paint, driving grit into bearings, and covering tracks almost as fast as you make them.",
        artDirection: "The one region whose plant stands LIGHTER than its ground: pale umber steel on dark iron-rich dirt, which is the opposite of shard-cities and is what keeps two brown regions apart. Silhouettes are industrial and long \u2014 gantry cranes straddling bays, conveyor runs seized where they stopped and carrying on across tiles, bunded tank farms. Rust everywhere, in streaks and pools and oil stains. Almost nothing green: a few dead snags, and the wind has taken the rest.",
        gates: [
            {
                icon: "\uD83C\uDFED",
                name: "Factory Command Sector",
                // control rooms and relay racks under gantries, not a checkpoint
                recipe: "infrastructure",
                primary: "system-override",
                support: [
                    "growth-control",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Central yard of control rooms and relay racks flanked by gantries.",
                longDescription: "Stack lights are long dead above cracked control housings. Catwalks draw hard lines across a sky of dust. A paper logbook lies fused into a solid wedge on a podium."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Gate",
                primary: "drone-command",
                support: [
                    "stealth-transit",
                    "signal-relay"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Gatehouse and weighbridge spanning lanes into container lots.",
                longDescription: "The weighbridge plate is welded to its frame by corrosion. The gate arms point at the ground like broken fingers. Dust piles where wheels once wore it away."
            },
            {
                icon: "\uD83E\uDE96",
                name: "Barracks Gate",
                primary: "signal-mask",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Perimeter fence and turnstiles into a worker barracks compound.",
                longDescription: "Turnstiles are frozen mid-rotation. A loudspeaker hangs by its cable, a mouth that will never speak. The ground inside is a quilt of footprints long since filled with dust."
            },
            {
                icon: "\uD83C\uDF7D\uFE0F",
                name: "Commissary Shutter Sector",
                primary: "system-override",
                support: [
                    "safeguard",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Canteen frontage sealed by roll-down shutters and collapsed awnings.",
                longDescription: "Menu boards peel in the heat. Trays clatter when the wind gets under them. At noon the whole block smells like hot metal and old oil."
            }
        ],
        hazards: [
            {
                icon: "\u26CF\uFE0F",
                name: "Extraction Yard",
                primary: "drone-command",
                support: [
                    "signal-mask",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Ore hoppers, crushed drums, and loader tracks etched into dust.",
                longDescription: "Chutes hang open over empty ground. Piles of fines drift into dunes against dead conveyors. The only sparkle is mica in the grit."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Assembly Corridor Block",
                primary: "drone-command",
                support: [
                    "wild-influence",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Long run of conveyor frames and work platforms seized in place.",
                longDescription: "Tool shadows are burned into paint where the sun never reached. Belt rollers are fused in rings of red. The wind writes its own schedule on hanging tags."
            },
            {
                icon: "\uD83D\uDDD1\uFE0F",
                name: "Salvage Lot",
                primary: "wild-influence",
                support: [
                    "drone-command",
                    "signal-relay"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Heap of stripped machinery and scaffold bones stacked by a fence.",
                longDescription: "Cranes stripped to spines cast laddered shadows. Wire harnesses dangle like dead vines. Footing is uncertain\u2014everything gives a little when you test it."
            },
            {
                icon: "\uD83D\uDD27",
                name: "Operations Hub",
                primary: "signal-relay",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Control kiosks and cable troughs forming a nerve-center yard.",
                longDescription: "Cable trays cross like irrigation over bare concrete. A signal flag still flaps from a line that never fell. If anything comes alive, it does so in stutters and stops."
            },
            {
                icon: "\uD83D\uDD25",
                name: "Boiler Leak Row",
                primary: "safeguard",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Steam-scarred lane between boiler sheds and maintenance stacks.",
                longDescription: "Mineral bloom and peeling paint texture every pipe. Valves whistle ghosts when the wind fits their mouths. The ground is white with the memory of heat."
            },
            {
                icon: "\uD83E\uDD6B",
                name: "Barracks Pantry Depot",
                primary: "stealth-transit",
                support: [
                    "wild-influence",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Food stores and cold-room bays opened to the air long ago.",
                longDescription: "Shelving prints squares on the walls where cold once lived. A pyramid of cans has slumped into a gentle hill of dull tin."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Warehouse Racking Collapse",
                primary: "safeguard",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Racking aisles tumbled into a lattice of unstable paths.",
                longDescription: "Number placards hang at wrong angles, their arrows pointing into heaps of beams. The floor is a patchwork of shadows and sunlight where the roof gave up."
            },
            {
                icon: "\uD83D\uDCD2",
                name: "Ledger Block",
                primary: "signal-relay",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Accounting offices and file stores woven into a single crumbling block.",
                longDescription: "Adding machines sit like fossils on desks. Ledger paper lies fused into brick-hard stacks. The sun makes dust glitter where a roof panel fell away."
            }
        ]
    },
    // ======================================================
    "hollow-core": {
        name: "Hollow Core",
        theme: "Sublevel transit and collapsed substructures",
        icon: "\u26AB",
        shortDescription: "Buried civic arteries: pillared halls, rail spurs and maintenance blocks, half of them sealed by the collapse.",
        longDescription: "Everything aboveground depended on what ran below\u2014transit rings, service corridors, and power trunks stitched together across sublevels. Collapse sealed off some blocks entirely; others breathe stale air through long cracks in the concrete.\n\nOccasionally, indicator strips flare for a moment, enough to show distance receding into black. Then the dark returns, settling even heavier than before.",
        artDirection: "A hall, not a street. Pillars on a regular pitch march across every tile and carry on into the next one \u2014 that rhythm is the only thing a top-down view has to say there is a ceiling overhead. Rock mass laps in from the corners and outer edges where the roof has come down, sealing parts of blocks, carved back around the rooms and never across a route. Rail beds and cable trays run through. Light is the region's subject: almost none of it, teal bioluminescence for ambient, warm pools under the daylight wells, and the darkness graded so it is heaviest against the rock and lightest over the floor. The concrete itself is NOT black \u2014 the palette has to survive the dark and still show which parts are wall.",
        gates: [
            {
                icon: "\uD83D\uDE87",
                name: "Sublevel Transit Hub",
                primary: "transit-anchor",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "storage",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed interchange where multiple rail spurs once crossed.",
                longDescription: "Pillars hold up more air than concrete now. Signal plates stand blank along a bed of gravel and dust. The far wall is a shadow that pretends to be distance."
            },
            {
                icon: "\uD83D\uDD0C",
                name: "Power Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cable trays and junction housings clustered around a maintenance court.",
                longDescription: "Insulators line a wall like teeth. A skein of cables has slumped from the ceiling into a black loop. Dust swirls when you step, then remembers how to be still."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Habitat Access Sector",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Door clusters and service nooks leading into sealed living blocks.",
                longDescription: "Numbered arrows march along the wall toward units you\u2019ll never enter. A cart sits on square wheels of dust. The air is dry and old, like a book left open too long."
            },
            {
                icon: "\uD83D\uDED2",
                name: "Commerce Access Sector",
                primary: "signal-mask",
                support: [
                    "lock-breach",
                    "echo-trace"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Service corridors feeding into a forgotten plaza and loading cutouts.",
                longDescription: "A map board with no map. A mural worn to colors without shapes. The corridor breathes the same cold air in and out, as if thinking of a crowd."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDCE6",
                name: "Storage Compound",
                primary: "quantum-scan",
                support: [
                    "lock-breach",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Box canyons of crates and shelving under a low slab ceiling.",
                longDescription: "Label paint lingers like ghosts on metal faces. A broken roller door shows a sliver of stale light. The air tastes like paper and iron."
            },
            {
                icon: "\uD83E\uDDF1",
                name: "Maintenance Network Sector",
                primary: "growth-control",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Grid of service corridors, tool bays, and grates over dark shafts.",
                longDescription: "Tool outlines haunt the walls. Floor grates ring when crossed, answering back from below. The network feels larger than the ground it serves."
            },
            {
                icon: "\u2622\uFE0F",
                name: "Reactor Service Lot",
                primary: "stealth-transit",
                support: [
                    "transit-anchor",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Shield doors and access gantries around a dead core housing.",
                longDescription: "Warning chevrons fade across concrete that still remembers heat. Cable stumps jut like bones from panel edges. Everything hums with a silence that feels heavy."
            },
            {
                icon: "\uD83D\uDEE0\uFE0F",
                name: "Data Spine Junction",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Trunk conduits converge into a node of cracked panels and conduit arcs.",
                longDescription: "Cables repeat the curve of the arching ceiling. Labels peel off in satisfying curls. Your headlamp shows dust floating like a slow snowfall."
            },
            {
                icon: "\uD83D\uDED7",
                name: "Access Network Block",
                primary: "transit-anchor",
                support: [
                    "echo-trace",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lift shafts, catwalks, and ladders crisscrossing a deep chamber.",
                longDescription: "Mesh floors draft cool air over your boots. The shaft walls are a history of paint colors layered like sediment. The dark holds its shape until you look into it."
            },
            {
                icon: "\uD83E\uDDF8",
                name: "Nursery Annex Sector",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Quiet block of sealed playrooms, murals eroded to color fields.",
                longDescription: "Small chairs lie on their backs like beetles. A mobile has tangled into a single shape. Everyone left a long time ago, but the rooms still feel paused."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Records Quarter",
                primary: "stealth-transit",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Storage stacks and data cages in a commercial sub-block.",
                longDescription: "Cage doors have slumped out of square. A spill of binders lies like fallen bricks. Your light finds the path numbers and makes them legible for a heartbeat."
            },
            {
                icon: "\uD83C\uDFEC",
                name: "Commerce Plaza",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Lower concourse ringed by shuttered storefronts and dead kiosks.",
                longDescription: "A fountain bowl holds dust instead of water. Kiosk screens are gray mirrors. Every footstep you make has an echo measured in seconds."
            }
        ]
    }
};
const $ce6dd72bc4611534$export$85b5153488a36ab6 = {
    civic: [
        "CivicSys",
        "CityWorks",
        "MetroGrid",
        "Municipalix",
        "UrbanNet"
    ],
    industrial: [
        "StrataDyne",
        "HelixCore",
        "OmniForge",
        "FerrumWorks",
        "Rivetron"
    ],
    utilities: [
        "Nextera",
        "Voltline",
        "Auralis",
        "BlueArc",
        "GridNova"
    ],
    retail: [
        "MetroTrade",
        "ApexMart",
        "Cornerline",
        "Shoreline Logistics",
        "Mercantis"
    ],
    bio: [
        "VerdanCo",
        "BioNet",
        "PhytoLabs",
        "GreenRidge",
        "GenExis"
    ],
    defense: [
        "WardTek",
        "Rampart Systems",
        "Bastionex",
        "IronCrest",
        "Shieldline"
    ],
    data: [
        "Archivum",
        "Memora",
        "DataPlain",
        "ByteHarbor",
        "Recorda"
    ]
};
const $ce6dd72bc4611534$export$432c04b9bead009 = {
    "shard-cities": [
        "MetroGuard",
        "CivicSys",
        "CityWorks",
        "UrbanNet",
        "MetroGrid",
        "ApexLift",
        "Blockline Security",
        "SentraCore",
        "Wayfinder Transit",
        "Arcology Services"
    ],
    "verdant-reclamation": [
        "VerdanCo",
        "PhytoLabs",
        "BioNet",
        "Greencap Utilities",
        "GardenWorks",
        "Nutrivane",
        "IrrigaTech",
        "SeedSafe",
        "Rootline Systems",
        "Auralis Bio"
    ],
    "sunken-bastions": [
        "HarborFleet",
        "DryDock Systems",
        "Bastionex",
        "BlueArc Marine",
        "Deepline",
        "Breakwater Logistics",
        "WardTek Maritime",
        "Pierstone",
        "Tidewell",
        "Seaforth Controls"
    ],
    "cradle-expanse": [
        "FerrumWorks",
        "OmniForge",
        "StrataDyne",
        "Rivetron",
        "Gantry & Co.",
        "Loadstar Fabrication",
        "ConveyorDynamics",
        "IronCrest",
        "Forgeway",
        "MachinaGrid"
    ],
    "hollow-core": [
        "CivicSys Sublevel",
        "MetroGrid Infrastructure",
        "Nextera Utility",
        "ServiceWay",
        "Subterra Transit",
        "CorridorWorks",
        "Spanline",
        "NodeWest",
        "ControlPoint",
        "Concourse Ops"
    ]
};
const $ce6dd72bc4611534$export$2c8d0d917dbcc8a5 = {
    power: [
        "Power Node",
        "Junction Panel",
        "Substation",
        "Transformer Bay",
        "Distribution Rack"
    ],
    storage: [
        "Storage Bay",
        "Records Vault",
        "Supply Depot",
        "Inventory Room",
        "Archive Annex"
    ],
    security: [
        "Security Gate",
        "Checkpoint",
        "Access Control",
        "Barrier Post",
        "Perimeter Gate"
    ],
    infrastructure: [
        "Relay Node",
        "Transit Hub",
        "Service Corridor",
        "Maintenance Bay",
        "Control Room"
    ],
    environmental: [
        "Containment Zone",
        "Hazard Control",
        "Firebreak",
        "Isolation Area",
        "Cleanup Sector"
    ],
    wildlife: [
        "Hive Chamber",
        "Containment Atrium",
        "Observation Pen",
        "Keeper Station",
        "Handling Room"
    ],
    power_infra: [
        "Switchgear Room",
        "Feeder Junction",
        "Utility Interface",
        "Load Center",
        "Breaker Hall"
    ],
    records_data: [
        "Records Cache",
        "Data Vault",
        "Archive Store",
        "Tape Annex",
        "Records Room"
    ]
};
const $ce6dd72bc4611534$export$66a51bddf5f03abf = [
    "Block A",
    "Block C",
    "Sector 7",
    "Sector 9",
    "East Annex",
    "West Annex",
    "North Wing",
    "South Wing",
    "Sublevel 2",
    "Sublevel 3",
    "Sublevel 4",
    "Tower 2",
    "Depot Lane",
    "Service Row",
    "Line 3",
    "Bay 12",
    "Bay 17",
    "Midtown Annex"
];
const $ce6dd72bc4611534$export$ae5fd03a6b740baa = {
    "shard-cities": [
        "Midtown Annex",
        "Tower 3",
        "Sector 9",
        "Skyway Deck",
        "Service Row"
    ],
    "verdant-reclamation": [
        "Greenhouse 2A",
        "Irrigation Loop B",
        "Seed Wing",
        "Containment Hall",
        "Botany Annex"
    ],
    "sunken-bastions": [
        "Pier 6",
        "Drydock 3",
        "Bulkhead E",
        "Sublevel Pump 2",
        "Bilge Corridor"
    ],
    "cradle-expanse": [
        "Line 3",
        "Bay 12",
        "Casting Floor",
        "Yard 5",
        "Maintenance Track"
    ],
    "hollow-core": [
        "Sublevel 4",
        "Service Spine",
        "Transit Ring",
        "Access Spur",
        "Node J"
    ]
};
const $ce6dd72bc4611534$export$68faa9057a77ce7d = {
    "shard-cities": [
        "civic",
        "utilities",
        "data",
        "industrial",
        "retail",
        "defense"
    ],
    "verdant-reclamation": [
        "bio",
        "utilities",
        "civic",
        "industrial",
        "data"
    ],
    "sunken-bastions": [
        "defense",
        "utilities",
        "industrial",
        "civic",
        "data"
    ],
    "cradle-expanse": [
        "industrial",
        "utilities",
        "civic",
        "retail",
        "data"
    ],
    "hollow-core": [
        "civic",
        "utilities",
        "industrial",
        "data",
        "retail"
    ],
    zone: {
        residential: [
            "civic",
            "utilities",
            "bio",
            "retail"
        ],
        commercial: [
            "retail",
            "civic",
            "data",
            "utilities"
        ],
        industrial: [
            "industrial",
            "utilities",
            "defense"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        core: [
            "data",
            "defense",
            "industrial"
        ],
        transit: [
            "civic",
            "utilities",
            "industrial"
        ],
        peripheral: [
            "civic",
            "industrial",
            "retail"
        ],
        entry: [
            "civic",
            "utilities",
            "retail"
        ]
    },
    category: {
        power: [
            "utilities",
            "industrial",
            "civic"
        ],
        storage: [
            "industrial",
            "retail",
            "data"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        infrastructure: [
            "civic",
            "utilities",
            "industrial"
        ],
        environmental: [
            "civic",
            "industrial",
            "utilities"
        ],
        wildlife: [
            "bio",
            "civic",
            "utilities"
        ]
    }
};
// RNG (seeded)
function $ce6dd72bc4611534$var$xmur3(str) {
    let h = 1779033703 ^ str.length;
    for(let i = 0; i < str.length; i++){
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    return ()=>{
        h = Math.imul(h ^ h >>> 16, 2246822507);
        h = Math.imul(h ^ h >>> 13, 3266489909);
        return (h ^ h >>> 16) >>> 0;
    };
}
function $ce6dd72bc4611534$var$mulberry32(a) {
    return ()=>{
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $ce6dd72bc4611534$export$c0b222505a3369f3(seedStr = "") {
    const seed = $ce6dd72bc4611534$var$xmur3(seedStr)();
    return $ce6dd72bc4611534$var$mulberry32(seed);
}
function $ce6dd72bc4611534$var$pick(array, rng) {
    return array[Math.floor(rng() * array.length)];
}
// Brand pool builder with regional weighting
function $ce6dd72bc4611534$var$getBrandPool({ regionKey: regionKey, zone: zone, category: category }) {
    const base = $ce6dd72bc4611534$export$68faa9057a77ce7d[regionKey] || [
        "civic",
        "industrial",
        "utilities"
    ];
    const zoneBias = $ce6dd72bc4611534$export$68faa9057a77ce7d.zone[zone] || [];
    const catBias = $ce6dd72bc4611534$export$68faa9057a77ce7d.category[category] || [];
    const order = [
        ...base,
        ...zoneBias,
        ...catBias
    ];
    const weighted = [];
    const regional = $ce6dd72bc4611534$export$432c04b9bead009[regionKey] || [];
    for(let i = 0; i < 3; i++)weighted.push(...regional); // heavy regional weight
    order.forEach((bucket, idx)=>{
        const list = $ce6dd72bc4611534$export$85b5153488a36ab6[bucket] || [];
        const weight = idx < 2 ? 2 : 1;
        for(let i = 0; i < weight; i++)weighted.push(...list);
    });
    return weighted.length ? weighted : [].concat(...Object.values($ce6dd72bc4611534$export$85b5153488a36ab6));
}
function $ce6dd72bc4611534$var$getDescriptorPool(category) {
    if (category === "power" && $ce6dd72bc4611534$export$2c8d0d917dbcc8a5.power_infra) return [
        ...$ce6dd72bc4611534$export$2c8d0d917dbcc8a5.power,
        ...$ce6dd72bc4611534$export$2c8d0d917dbcc8a5.power_infra
    ];
    if (category === "storage" && $ce6dd72bc4611534$export$2c8d0d917dbcc8a5.records_data) return [
        ...$ce6dd72bc4611534$export$2c8d0d917dbcc8a5.storage,
        ...$ce6dd72bc4611534$export$2c8d0d917dbcc8a5.records_data
    ];
    return $ce6dd72bc4611534$export$2c8d0d917dbcc8a5[category] || $ce6dd72bc4611534$export$2c8d0d917dbcc8a5.infrastructure;
}
function $ce6dd72bc4611534$var$pickQualifier(regionKey, rng) {
    const base = $ce6dd72bc4611534$export$66a51bddf5f03abf;
    const regional = $ce6dd72bc4611534$export$ae5fd03a6b740baa[regionKey] || [];
    const pool = [
        ...regional,
        ...regional,
        ...base
    ]; // 2:1 favor regional
    return pool.length ? pool[Math.floor(rng() * pool.length)] : "";
}
function $ce6dd72bc4611534$export$6b7290c54feddd3b({ baseName: baseName, regionKey: regionKey, zone: zone, category: category, seed: seed = "" }, count = 5) {
    const rng = $ce6dd72bc4611534$export$c0b222505a3369f3(`${seed}|${baseName}|${regionKey}|${zone}|${category}`);
    const brands = $ce6dd72bc4611534$var$getBrandPool({
        regionKey: regionKey,
        zone: zone,
        category: category
    });
    const descs = $ce6dd72bc4611534$var$getDescriptorPool(category);
    const names = new Set();
    const canon = [
        baseName,
        `${baseName} \u{2013} ${$ce6dd72bc4611534$var$pickQualifier(regionKey, rng)}`
    ];
    let safety = 200;
    while(names.size < count && safety-- > 0){
        const brand = $ce6dd72bc4611534$var$pick(brands, rng);
        const desc = $ce6dd72bc4611534$var$pick(descs, rng);
        const useBaseTerm = rng() < 0.35; // 35% anchor to base term
        const qualifier = rng() < 0.65 ? ` \u{2013} ${$ce6dd72bc4611534$var$pickQualifier(regionKey, rng)}` : "";
        const candidate = useBaseTerm ? `${brand} ${baseName}${qualifier}` : `${brand} ${desc}${qualifier}`;
        names.add(candidate);
    }
    for (const c of canon){
        if (names.size >= count) break;
        names.add(c);
    }
    return Array.from(names).slice(0, count);
}
const $ce6dd72bc4611534$export$1a6ba7df4555a8dd = {
    defaultTune: {
        buildingScale: 1,
        treeDensity: 1,
        roadWear: 0.15,
        shadowAngle: 45,
        shadowAlpha: 0.85,
        shadowLength: 6,
        lightUptime: 0.12,
        lightFlickerSpeed: 1,
        sinkholeChance: 0.5,
        lightRays: 0,
        // How often a region's own signature props appear — the one pass that is
        // about a PARTICULAR place rather than about a town. 0 turns them off.
        signature: 1,
        // How far inland the sea reaches on a region with a shoreline. 0 = no sea,
        // which is every region but the drowned one.
        floodLevel: 0,
        // How much rock mass has come down around the built ground. Sublevels only.
        enclosure: 0,
        cloudType: 'scattered'
    },
    regions: {
        // Two tiers of architecture per region. `struct` is the ordinary building
        // stock — the sheds, blocks and terraces the whole map is made of. `mass`
        // is the monumental tier: the towers, glasshouses, sea walls, mill frames
        // and pillar halls a region builds at a scale nothing else on the tile
        // reaches. Keeping them apart is what lets shard-cities have warm brown
        // roofs on its small buildings AND cool concrete over them, instead of
        // picking one and reading as somewhere else's town in a filter.
        //
        // The rule both tiers answer to: a structure must separate from the ground
        // it stands on in VALUE, not just in hue. Two regions with the same value
        // relationship look like the same place no matter what colour they are.
        'shard-cities': {
            backdrop: 'city',
            overlay: 'dust',
            tune: {
                buildingScale: 1.3,
                treeDensity: 3,
                roadWear: 0.35,
                shadowAngle: 45,
                shadowAlpha: 0.85,
                shadowLength: 6,
                lightUptime: 0.18,
                lightFlickerSpeed: 1,
                sinkholeChance: 0.5,
                lightRays: 0,
                signature: 1,
                cloudType: 'broken'
            },
            pal: {
                far: '#1c2333',
                // Warm brick and brown roofing, but a stop LIGHTER than it used to be
                // and over darker tarmac. The hue contrast against grey ground always
                // worked; the value contrast did not — seven luma points apart, the
                // roofs sank into the street at map scale and the region read as one
                // undifferentiated grey-brown field.
                struct: '#8a705c',
                structDark: '#15171e',
                structLight: '#b99983',
                mass: '#79828f',
                massDark: '#2a3038',
                massLight: '#a9b6c4',
                ground1: '#3f434e',
                ground2: '#4b5160',
                road: '#20242f',
                metal: '#6b7893',
                rust: '#8a6a4a',
                accent: '#a9bee0',
                veg1: '#3b5841',
                veg2: '#5d8058',
                water1: '#33455c',
                water2: '#55708c',
                glow: '#ffb45e'
            }
        },
        'verdant-reclamation': {
            backdrop: 'greenhouse',
            overlay: 'vines',
            recipes: {
                storage: 'storage-seed'
            },
            tune: {
                buildingScale: 1.1,
                treeDensity: 4,
                roadWear: 0.75,
                cloudType: 'scattered',
                lightUptime: 0.05,
                signature: 1.1
            },
            pal: {
                far: '#4c6350',
                struct: '#7d8a8c',
                structDark: '#455256',
                structLight: '#b0bcba',
                mass: '#9fb0a8',
                massDark: '#4a5a52',
                massLight: '#cfdcd2',
                // The ground is most of the tile, so it decides whether the region reads
                // as flat — and a light mid-green under light grey frames was the whole
                // problem. Taken down to shaded loam, but only halfway: the first attempt
                // went the full distance and the region lost its light instead of gaining
                // contrast. The canopy is darker still, the structures sit well above
                // both, and the tile has a range without going gloomy.
                ground1: '#3e5a34',
                ground2: '#4f5b30',
                road: '#42402f',
                metal: '#8b9598',
                rust: '#8a7050',
                accent: '#d8d2a8',
                // Deep canopy. These are the darkest greens on the tile and the shapes
                // they make are what the eye reads first, so they carry the contrast.
                veg1: '#254d2a',
                veg2: '#4a7a3a',
                water1: '#3f7a70',
                water2: '#6fb0a4',
                glow: '#f4e9c8'
            }
        },
        'sunken-bastions': {
            backdrop: 'harbor',
            overlay: 'flood',
            recipes: {
                storage: 'storage-quay'
            },
            tune: {
                buildingScale: 1.15,
                treeDensity: 1,
                roadWear: 0.4,
                cloudType: 'overcast',
                sinkholeChance: 0.35,
                floodLevel: 1,
                signature: 1
            },
            pal: {
                far: '#3a4854',
                struct: '#6d8290',
                structDark: '#2c3841',
                structLight: '#9db6c2',
                mass: '#7d8f99',
                massDark: '#2c3841',
                massLight: '#a8bcc4',
                ground1: '#4a5450',
                ground2: '#5b6763',
                road: '#39434c',
                metal: '#7b8a93',
                rust: '#b06a3d',
                accent: '#8fc4cc',
                veg1: '#3c5f4c',
                veg2: '#58825e',
                water1: '#2f5c6b',
                water2: '#5a8f9b',
                glow: '#ffd27f'
            }
        },
        'cradle-expanse': {
            backdrop: 'foundry',
            overlay: 'rust',
            recipes: {
                storage: 'storage-silo'
            },
            tune: {
                buildingScale: 1.25,
                treeDensity: 0.8,
                roadWear: 0.3,
                shadowAngle: 15,
                cloudType: 'wispy',
                signature: 1
            },
            pal: {
                far: '#4a3226',
                // The one region whose plant is LIGHTER than its ground. Dark dirt with
                // pale steel on it is the opposite value relationship to shard-cities'
                // dark roofs on grey tarmac, which is what stops two brown regions
                // reading as one.
                struct: '#a5825c',
                structDark: '#3a2417',
                structLight: '#d2ad7f',
                mass: '#a89279',
                massDark: '#4a3a28',
                massLight: '#d3c0a4',
                ground1: '#6b5137',
                ground2: '#7d6244',
                road: '#3d3226',
                metal: '#9c8a6e',
                rust: '#b55a2b',
                accent: '#e8b060',
                veg1: '#635831',
                veg2: '#807236',
                water1: '#5d564a',
                water2: '#7a705c',
                glow: '#ffcf7a'
            }
        },
        'hollow-core': {
            backdrop: 'underground',
            overlay: 'dark',
            // Everything here is lifted a stop from where it was: a sublevel is dark
            // because of its LIGHT, not because its concrete is black. The palette
            // has to survive a x0.5 night tint and a darkness wash on top and still
            // show which parts of the tile are wall.
            tune: {
                buildingScale: 1.1,
                treeDensity: 1,
                roadWear: 0.25,
                lightRays: 1.5,
                enclosure: 1,
                signature: 1.2
            },
            pal: {
                far: '#07080c',
                struct: '#5c6782',
                structDark: '#1b1f2a',
                structLight: '#7f8cad',
                mass: '#6b7690',
                massDark: '#1b1f2a',
                massLight: '#909dbb',
                ground1: '#333a46',
                ground2: '#454d5d',
                road: '#1c212b',
                metal: '#5b6478',
                rust: '#5a4630',
                accent: '#4fa0a0',
                veg1: '#2d473f',
                veg2: '#41684e',
                water1: '#234049',
                water2: '#356470',
                glow: '#ffc46a'
            }
        }
    },
    recipes: {
        power: {
            variants: [
                {
                    elements: [
                        {
                            el: 'transformerPad',
                            x: [
                                9,
                                21
                            ],
                            y: [
                                9,
                                21
                            ]
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                84,
                                93
                            ]
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: [
                                24,
                                30
                            ],
                            w: 3,
                            h: 60,
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: 87,
                            w: [
                                51,
                                60
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'fence',
                            x: 6,
                            y: 6,
                            w: 36,
                            h: 36
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 18
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                15,
                                24
                            ]
                        }
                    ]
                }
            ]
        },
        storage: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crates',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                18
                            ],
                            cols: 3,
                            rows: 2
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        },
                        {
                            el: 'tank',
                            x: [
                                90,
                                99
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: 27,
                            h: 24
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                81,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        // ---- region-specific stock ----
        // A region may point one of the shared recipes at its own layout via
        // `recipes` on its RENDER_CONFIG.regions entry. The signature layer adds a
        // region's landmarks ON TOP of whatever a tile drew; this changes what the
        // tile is made of in the first place, which is the difference between a
        // harbour with containers on it and a harbour built out of them.
        //
        // Kept deliberately few. Every one of these is a second layout to maintain
        // for a recipe that already had one, so it has to earn its place by being
        // somewhere the shared version reads plainly wrong.
        'storage-quay': {
            variants: [
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                12,
                                18
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                42,
                                48
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                69,
                                81
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                66,
                                75
                            ],
                            y: [
                                15,
                                24
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 60,
                            h: 27
                        },
                        {
                            el: 'container',
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                60,
                                72
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        }
                    ]
                }
            ]
        },
        'storage-silo': {
            variants: [
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                24,
                                30
                            ],
                            r: 13
                        },
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                72,
                                81
                            ],
                            y: [
                                45,
                                54
                            ],
                            r: 14
                        },
                        {
                            el: 'pipeline',
                            x: 33,
                            y: [
                                51,
                                57
                            ],
                            w: [
                                30,
                                39
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 12
                        },
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                72,
                                81
                            ],
                            w: 42,
                            h: 24
                        },
                        {
                            el: 'crates',
                            x: [
                                72,
                                84
                            ],
                            y: [
                                78,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        'storage-seed': {
            variants: [
                {
                    elements: [
                        {
                            el: 'glassSpan',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 66,
                            h: 27
                        },
                        {
                            el: 'silo',
                            x: [
                                24,
                                30
                            ],
                            y: [
                                78,
                                87
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                54,
                                63
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 9
                        },
                        {
                            el: 'crates',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                69,
                                78
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                18,
                                24
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 12
                        },
                        {
                            el: 'glassSpan',
                            x: [
                                63,
                                72
                            ],
                            y: [
                                21,
                                30
                            ],
                            w: 33,
                            h: 66
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 3,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        security: {
            elements: [
                {
                    el: 'fence',
                    x: 15,
                    y: 15,
                    w: 90,
                    h: 90,
                    gaps: 1
                },
                {
                    el: 'barrier',
                    x: 24,
                    y: 24
                },
                {
                    el: 'barrier',
                    x: 81,
                    y: 81
                },
                {
                    el: 'vehicle',
                    chance: 0.4,
                    x: [
                        72,
                        84
                    ],
                    y: [
                        78,
                        87
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'building',
                    x: [
                        72,
                        81
                    ],
                    y: [
                        21,
                        30
                    ],
                    w: 18,
                    h: 15
                }
            ]
        },
        infrastructure: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                36,
                                45
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tower',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ]
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 30,
                            w: 3,
                            h: [
                                54,
                                66
                            ],
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 90,
                            w: [
                                54,
                                66
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'tank',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 12
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                }
            ]
        },
        transit: {
            elements: [
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        72,
                        84
                    ],
                    w: 6,
                    h: 27,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        15,
                        27
                    ],
                    w: 27,
                    h: 6,
                    color: 'struct'
                },
                {
                    el: 'vehicle',
                    x: [
                        12,
                        24
                    ],
                    y: [
                        12,
                        24
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'vehicle',
                    chance: 0.6,
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'rubble',
                    x: 12,
                    y: 12,
                    w: 93,
                    h: 93,
                    n: 12
                }
            ]
        },
        environmental: {
            variantKey: 'sinkholeChance',
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                18,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'foliage',
                            x: [
                                15,
                                36
                            ],
                            y: [
                                78,
                                102
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'foliage',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                15,
                                36
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                81,
                                99
                            ],
                            y: [
                                81,
                                99
                            ],
                            r: [
                                9,
                                12
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        // The hole goes down LAST. Scatter drawn over it is debris hanging in
                        // a shaft; drawn under it, the hole simply swallows whatever fell in
                        // and what is left reads as ground that gave way. The pit brings its
                        // own spoil ring with it, so the rim still has a heap on it.
                        {
                            el: 'rubble',
                            x: 12,
                            y: 12,
                            w: 93,
                            h: 93,
                            n: 14
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                36,
                                78
                            ],
                            y: [
                                36,
                                78
                            ]
                        }
                    ]
                }
            ]
        },
        records: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // The two above put a hall in each corner, which leaves a road nowhere to
                // go: mirroring the layout only moves which corner is which. These two
                // range the halls along ONE edge instead, so half the tile stays open —
                // and the mirror decides which half, to suit wherever the road landed.
                // Ranged east-west, for a road crossing that way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: 9,
                            w: [
                                45,
                                54
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                66,
                                72
                            ],
                            y: 9,
                            w: [
                                33,
                                39
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // and ranged north-south, for one crossing the other way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                9,
                                15
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                42,
                                48
                            ]
                        },
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                66,
                                72
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                }
            ]
        },
        habitation: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                30,
                                36
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                81,
                                87
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'rect',
                            repeat: 4,
                            x: [
                                78,
                                105
                            ],
                            y: [
                                81,
                                105
                            ],
                            w: 6,
                            h: 6,
                            color: 'veg1'
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                42,
                                48
                            ],
                            h: [
                                36,
                                42
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                84,
                                96
                            ],
                            y: [
                                15,
                                27
                            ],
                            r: 9
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                // Housing is the one thing that is genuinely built in rows, so two of
                // them: one long range and a shorter one behind it, facing the other way
                // as a back street does. The gap between is the lane.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                69
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            w: [
                                42,
                                57
                            ],
                            h: [
                                21,
                                24
                            ]
                        },
                        {
                            el: 'bush',
                            x: [
                                84,
                                102
                            ],
                            y: [
                                45,
                                63
                            ]
                        }
                    ]
                },
                // and the same row stood on end, so a mirror is not the only way this
                // recipe ever runs north-south
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                54,
                                69
                            ],
                            vert: 1
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                69,
                                75
                            ],
                            y: [
                                15,
                                27
                            ],
                            w: [
                                21,
                                24
                            ],
                            h: [
                                42,
                                57
                            ],
                            vert: 1
                        },
                        {
                            el: 'bush',
                            x: [
                                45,
                                63
                            ],
                            y: [
                                84,
                                102
                            ]
                        }
                    ]
                }
            ]
        },
        commerce: {
            variants: [
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'stalls'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                75,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A parade: shops in a row under one roof, with the lot they served in
                // front of them. One storefront alone reads as a retail park; the row is
                // what a high street is.
                //
                // Both ways round, and both shallower than the storefronts above, because
                // this is the only thing in the recipe that fits on a tile the road runs
                // through. A carriageway swings up to EDGE_SWING off centre, so the
                // clear ground beside one is about 43 units — and a storefront is 46 to
                // 49 deep once the region's scale and its awning are on it. It does not
                // fit in either orientation, in any mirror, which left a market tile on a
                // road as bare ground and some crates. A range 27 to 35 deep clears the
                // carriageway with room to spare, and the north-south copy does the same
                // for a road running the other way, which no mirror of an east-west range
                // can do. The layout pass prefers whichever of the five keeps a structure
                // standing, so a tile with no road through it still gets its big shop.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                12
                            ],
                            w: [
                                57,
                                72
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                12
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                57,
                                72
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                78,
                                87
                            ],
                            y: [
                                15,
                                27
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A corner unit, for where not even a parade reaches. A bend sweeps an L
                // through the tile and leaves a quarter of it clear, which nothing that
                // has to span an axis can use — so the smallest thing this recipe can be
                // is three shops in a corner rather than no shop at all.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'stalls',
                            chance: 0.5
                        }
                    ]
                }
            ]
        },
        reactor: {
            elements: [
                {
                    el: 'reactorCore'
                }
            ]
        },
        // Entry and extraction. A portal is a DEVICE somebody installed and powers,
        // so it stands in a facility rather than out in the open: ranges of
        // blockwork around three sides of the aperture, a transformer feeding it,
        // and the pad itself left clear in the middle (portalPad and portalGlow
        // both draw at the tile centre, and the glow goes down last of all).
        //
        // The buildings sit in one corner-half so the layout pass can mirror them
        // clear of the track that runs up to the tile — every mirror leaves two
        // adjacent sides open, which between them covers whichever edge the road
        // arrives from.
        portal: {
            elements: [
                {
                    el: 'building',
                    x: 9,
                    y: 9,
                    w: [
                        48,
                        57
                    ],
                    h: [
                        21,
                        27
                    ]
                },
                {
                    el: 'building',
                    x: 9,
                    y: [
                        36,
                        42
                    ],
                    w: [
                        21,
                        27
                    ],
                    h: [
                        39,
                        45
                    ]
                },
                {
                    el: 'transformerPad',
                    x: [
                        84,
                        93
                    ],
                    y: [
                        12,
                        18
                    ]
                },
                {
                    el: 'crates',
                    x: [
                        78,
                        87
                    ],
                    y: [
                        72,
                        81
                    ],
                    cols: 2,
                    rows: 2
                },
                // a deck under the aperture, so it reads as installed rather than as
                // something that happened to appear in the yard
                {
                    el: 'rect',
                    x: 36,
                    y: 36,
                    w: 48,
                    h: 48,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 39,
                    y: 39,
                    w: 42,
                    h: 42,
                    color: 'ground2'
                },
                {
                    el: 'portalPad'
                }
            ]
        },
        road: {
            elements: [
                // Debris on the carriageway goes down FIRST, so the frontage below covers
                // what lands on its ground instead of speckling its roofs.
                {
                    el: 'rubble',
                    x: 6,
                    y: 6,
                    w: 105,
                    h: 105,
                    n: 4
                },
                // Frontage. What makes a trunk read as a STREET rather than as a strip of
                // surfacing is the building line either side of it — and the recipe is
                // never told which way the road goes, so it puts a block against all four
                // edges and lets the roadway pick. The layout pass suppresses whatever
                // the road runs through: on a straight run that is the two edges it
                // enters and leaves by, leaving the other two facing each other across
                // the carriageway; on a bend it is the two sides it turns between,
                // leaving the outside of the corner built up. Same rule, no cases.
                //
                // Depth is set so a block stands where a road CAN reach and is dropped
                // when it does. A crossing swings up to EDGE_SWING (24) off centre, so
                // shrinking these until they always survive would leave a strip of open
                // ground between every building and the road it faces — a setback that
                // varies tile to tile and reads as waste. Deep blocks sit tight against
                // the carriageway instead, and where the road hugs one side that side's
                // block goes and the far one stands alone, which is what a street pushed
                // against a boundary actually looks like.
                //
                // The far pair is anchored at 80 rather than hard against the edge, and
                // the near pair at 8: a building is clamped 6 units short of the tile
                // edge, and the layout pass MIRRORS it, so one authored against the edge
                // is measured clamped and then drawn somewhere it is not — bigger than
                // the footprint it was cleared on, with the difference landing on the
                // road. Authored sizes are multiplied by buildingScale (1.3 at most), so
                // 80 + 24 x 1.3 = 111 keeps every one of these inside the clamp at both
                // ends of its mirror, and the two passes agree.
                //
                // Terraced, because a STREET is what this recipe is for. A free-standing
                // block set back behind a carriageway is a depot; a run of units flush
                // along it, sharing party walls, is a street, and the difference is the
                // whole reason a trunk tile exists. The run is authored to the same 8/80
                // anchors and the same depth as the blocks it replaces, so the clamp
                // arithmetic above is unchanged; only what stands on the frontage is.
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 8,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 80,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 8,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 80,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'manhole',
                    chance: 0.5,
                    x: [
                        48,
                        72
                    ],
                    y: [
                        48,
                        72
                    ]
                },
                // Traffic is not in here: drawRoadside lays it against the carriageway off
                // the road's own samples, so it lies parallel to the road and on the
                // shoulder, on every tile the network runs through rather than only on
                // the trunk tiles this recipe draws.
                {
                    el: 'streetLamp',
                    x: {
                        pick: [
                            39,
                            78
                        ]
                    },
                    y: [
                        39,
                        81
                    ]
                }
            ]
        },
        // rest stops are untouched clearings, and they
        // sit in the greenest spots on the map (5x the region's tree density)
        water: {
            treeDensity: 5,
            elements: [
                {
                    el: 'pond'
                }
            ]
        },
        campsite: {
            treeDensity: 5,
            elements: [
                {
                    el: 'tent',
                    x: [
                        15,
                        24
                    ],
                    y: [
                        15,
                        24
                    ]
                },
                {
                    el: 'fireRing',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ]
                },
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        84,
                        96
                    ],
                    w: 18,
                    h: 6,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: [
                        81,
                        96
                    ],
                    y: [
                        18,
                        27
                    ],
                    w: 6,
                    h: 15,
                    color: 'structDark'
                }
            ]
        },
        // Impassable because the ground itself has gone, not because something fell
        // over on it: a shaft or a rift opened here and there is no way across.
        // Collapsed slabs read as debris you could pick your way through, which is
        // exactly what these tiles are not.
        // The hole goes down LAST in every variant. Ground litter drawn over it is
        // debris hanging in mid-air above a drop; drawn under it, the hole swallows
        // whatever fell in and what survives reads as the edge of the collapse.
        // Each hole lays its own spoil around its rim afterwards.
        blocked: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                51,
                                69
                            ],
                            y: [
                                51,
                                69
                            ],
                            r: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                54,
                                66
                            ],
                            y: [
                                48,
                                72
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                48,
                                72
                            ],
                            y: [
                                54,
                                66
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ],
                            vert: 1
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                }
            ]
        }
    },
    // ===============================
    // SKILL ANCHORS
    // ===============================
    // A recipe says what kind of place a tile IS; the anchor says what the team
    // will be doing there. One per skill, chosen from the room's primary skill
    // and drawn ON TOP of the recipe — a power yard still reads as a power yard
    // and also shows its skill. Every skill is the primary of exactly four rooms
    // (see tests/data/skillBalance.test.js), so all fifteen of these are reachable.
    //
    // Same element vocabulary and same interpreter as recipes above, with two
    // differences: coordinates are PLATE-RELATIVE (0,0 is the anchor's own top
    // left, not the tile's), and w/h declare the reserved footprint, which must
    // stay within ANCHOR_MAX (24) so the anchor can never land on the connector
    // cross that joins tiles together.
    //
    // Every entry opens with an anchorPlate: it makes an anchor that overlaps a
    // roof read as apparatus installed there, which is what buys us out of doing
    // collision detection against the recipe. shape marks the faction — square
    // for Dominion, cut for Veil, round for Wilders.
    //
    // The anchor tracks the room's PRIMARY skill, not the event it will run —
    // and the two can disagree, because a room's event pool is primary plus
    // support. That is deliberate: a room runs one to four events, so keying the
    // anchor to any single one of them would mismatch the others regardless. The
    // primary is the only skill true for the whole room. (What does follow the
    // pinned event is the roof cutaway — see the environment field on events.)
    skillAnchors: {
        // ---- Dominion: systems and instrumentation ----
        'signal-relay': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'tower',
                    x: 4,
                    y: 4
                }
            ]
        },
        'system-override': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 5,
                    w: 12,
                    h: 11,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 7,
                    y: 6,
                    w: 10,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 8,
                    w: 8,
                    h: 5,
                    color: 'accent'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 16,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'drone-command': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dronePad',
                    x: 4,
                    y: 4,
                    s: 16
                }
            ]
        },
        'safeguard': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'transformerPad',
                    x: 2,
                    y: 2
                }
            ]
        },
        'quantum-scan': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 7,
                    rings: 1,
                    arm: 1,
                    color: 'accent'
                }
            ]
        },
        // ---- Veil: access and concealment ----
        'lock-breach': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 16,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 19,
                    w: 16,
                    h: 1,
                    color: 'structDark'
                },
                // hazard stripe: a bare metal square reads as nothing from above, and
                // this is the one thing that separates a sealed door from a floor plate
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 2,
                    color: 'accent',
                    alpha: 0.85
                },
                {
                    el: 'manhole',
                    x: 12,
                    y: 13
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 8,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 15,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                }
            ]
        },
        'stealth-transit': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 11,
                    w: 8,
                    h: 2,
                    color: 'accent',
                    alpha: 0.7
                }
            ]
        },
        'echo-trace': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 3,
                    rings: 2,
                    color: 'accent'
                }
            ]
        },
        'signal-mask': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 9,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 1,
                    h: 8,
                    color: 'metal'
                },
                {
                    el: 'speckle',
                    x: 3,
                    y: 3,
                    w: 18,
                    h: 18,
                    n: 10,
                    color: 'accent',
                    alpha: 0.35
                }
            ]
        },
        'transit-anchor': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'crack',
                    x: 4,
                    y: 6,
                    len: 14
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 5,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 18,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                }
            ]
        },
        // ---- Wilders: growth, salvage and containment ----
        'reclamation': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'tank',
                    x: 12,
                    y: 13,
                    r: 8
                },
                {
                    el: 'foliage',
                    x: 16,
                    y: 8,
                    size: 3
                }
            ]
        },
        'growth-control': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 14,
                    h: 12,
                    color: 'ground1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 8,
                    w: 12,
                    h: 2,
                    color: 'veg1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 12,
                    w: 12,
                    h: 2,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 16,
                    w: 12,
                    h: 1,
                    color: 'veg1'
                }
            ]
        },
        'wild-influence': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 13,
                    r: 7,
                    rings: 1,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'bio-shield': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'pipeline',
                    x: 2,
                    y: 6,
                    w: 20
                },
                {
                    el: 'tank',
                    x: 15,
                    y: 15,
                    r: 6
                }
            ]
        },
        'containment': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'fence',
                    x: 2,
                    y: 2,
                    w: 20,
                    h: 20
                },
                {
                    el: 'barrier',
                    x: 3,
                    y: 17
                }
            ]
        }
    }
};
const $ce6dd72bc4611534$export$ded4d2beb9be271a = [
    {
        target: "signal-repeater-pack",
        station: "workbench",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "control-override-kit",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "operator-link-harness",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "stability-coupler",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "spectral-survey-scope",
        station: "workbench",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "harvesting-gauntlet",
        station: "workbench",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "growth-induction-pod",
        station: "workbench",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "pheromone-relay-belt",
        station: "workbench",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "respirator-webbing",
        station: "workbench",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "hazard-recovery-satchel",
        station: "workbench",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "resonant-survey-array",
        station: "workbench",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "lockpulse-breach-kit",
        station: "workbench",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "silent-step-pads",
        station: "workbench",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "trace-disruptor-band",
        station: "workbench",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "anchor-resonator",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "data-cache-drive",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "relic-resonance-tuner",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "hazard-lens-visor",
        station: "workbench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-injector",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "contract-beacon",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "sync-regulator-watch",
        station: "workbench",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "auto-stabilizer-pack",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "training-node-deck",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "crosslink-amplifier",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "material-extractor",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "salvage-compression-rig",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "memory-crystal-shard",
        station: "workbench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    }
];
const $ce6dd72bc4611534$export$12c2125da4fa007 = [
    {
        target: "relay-stabilizer-gel-pack",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "biofiber-splice-kit",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "noise-floor-buffer-pack",
        station: "lab",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "multi-node-override-cart",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    },
    {
        target: "surge-damping-couplers",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-traffic-cartridge",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "swarm-sync-beacon-cart",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "overgrowth-lidar-pack",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-sonar-cartridge",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "rapid-grounding-spikes",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "vent-cycler-pack",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "cutoff-line-kit",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "scan-link-bridge",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "dual-spectrum-cartridge",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "residual-current-probe-kit",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "harvest-sync-brace-pack",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 2
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            }
        ]
    },
    {
        target: "fast-filter-plenum-cart",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "micro-mist-emitter",
        station: "lab",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            }
        ]
    },
    {
        target: "rapid-brace-binder",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "light-channel-films",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "root-guidance-stakes",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "breath-sync-strips",
        station: "lab",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "chorus-diffuser-ampoule",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "scent-dampening-salve",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "reactive-gel-patch",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "enzyme-swap-kit",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "surface-tuning-spray",
        station: "lab",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "hardcase-quickframe-kit",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 4
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "leather-straps",
                qty: 1
            }
        ]
    },
    {
        target: "pod-starter-seeds",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-pod-capsules",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "relay-bridge-link-cart",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "bio-pulse-amplifier-pack",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "map-cache-sync-cart",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "micro-torque-paste",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-seal-injector",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-pulse-cartridge",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "route-shadow-taggers",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 2
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "low-shine-veil-pack",
        station: "lab",
        inputs: [
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "pace-sync-patches",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "auth-spoof-keycard",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-scent-ampoule",
        station: "lab",
        inputs: [
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            }
        ]
    },
    {
        target: "temp-log-writer-cart",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "quickset-anchor-rods",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "timing-pulse-tag",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "scan-cache-array-cart",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "precision-mast-calibrator",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 8
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 2
            }
        ]
    },
    {
        target: "biofiber-manifold",
        station: "lab",
        inputs: [
            {
                id: "circuit-board",
                qty: 4
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 3
            }
        ]
    },
    {
        target: "adaptive-noise-gate",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 3
            }
        ]
    },
    {
        target: "multi-handshake-router",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 3
            },
            {
                id: "override-datakey",
                qty: 2
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "surge-buffer-backplane",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 4
            },
            {
                id: "ceramic-insulator",
                qty: 4
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "credential-spoof-matrix",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 2
            },
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 2
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "swarm-route-controller",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 2
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "overgrowth-nav-suite",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-sonar-array",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "auto-ground-bus",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 6
            },
            {
                id: "relay-antenna-strut",
                qty: 3
            },
            {
                id: "logic-ribbon-cable",
                qty: 2
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "cycler-governor",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 3
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 2
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "hardline-junction-box",
        station: "lab",
        inputs: [
            {
                id: "relay-antenna-strut",
                qty: 4
            },
            {
                id: "logic-ribbon-cable",
                qty: 4
            },
            {
                id: "composite-casing",
                qty: 2
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "scan-link-backbone",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "precision-servo-gear",
                qty: 2
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "dual-spectrum-integrator",
        station: "lab",
        inputs: [
            {
                id: "relay-antenna-strut",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "low-current-amplifier",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 8
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "harvest-flight-controller",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 2
            },
            {
                id: "canvas-fiber",
                qty: 2
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "fungal-flow-regulator",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 3
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 2
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "surface-decon-manifold",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 3
            },
            {
                id: "leather-straps",
                qty: 2
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            }
        ]
    },
    {
        target: "lattice-lock-ribs",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "leaf-optic-panel",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 2
            },
            {
                id: "symbiotic-culture-vial",
                qty: 2
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "seam-probe-kit",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 2
            },
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "rhythm-guide-hub",
        station: "lab",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "multi-diffuser-crown",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 3
            },
            {
                id: "fabric-mesh",
                qty: 2
            },
            {
                id: "bio-conductive-mesh",
                qty: 2
            }
        ]
    },
    {
        target: "contact-silence-kit",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 2
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "layer-activator-pad",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "enzyme-hub-manifold",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 3
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "surface-tuner-core",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 2
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "hot-sample-frame",
        station: "lab",
        inputs: [
            {
                id: "leather-straps",
                qty: 6
            },
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            }
        ]
    },
    {
        target: "pod-growth-hub",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 2
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-pod-manifold",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 2
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "relay-pairing-bridge",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 2
            }
        ]
    },
    {
        target: "bio-pulse-coupler",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 2
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "map-sync-hub",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "micro-torque-rail",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 3
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 2
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-seal-rail",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-phase-driver",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "route-shadow-hub",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "low-shine-housing",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 2
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "pace-sync-hub",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "auth-emulator-core",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "em-interference-chip",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-scent-hub",
        station: "lab",
        inputs: [
            {
                id: "ghost-signal-modulator",
                qty: 2
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "log-sanitizer-kernel",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 2
            },
            {
                id: "em-interference-chip",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "anchor-brace-grid",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 2
            },
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "timing-window-hub",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "scan-cache-backplane",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 2
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 2
            }
        ]
    }
];
const $ce6dd72bc4611534$export$c95766f8298d6ed1 = [
    {
        target: "encrypted-transceiver-chip",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            }
        ]
    },
    {
        target: "radiation-sensor-module",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 2
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "bio-conductive-mesh",
        station: "lab",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "synthetic-pheromone-capsule",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            }
        ]
    },
    {
        target: "em-interference-chip",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            }
        ]
    },
    {
        target: "harmonic-stabilizer-core",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            }
        ]
    },
    {
        target: "signal-sync-crystal",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "data-storage-crystal",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            }
        ]
    },
    {
        target: "precision-chrono-core",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 2
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "high-torque-motor-core",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "containment-gel-lining",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 2
            },
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "voltage-regulator-unit",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    }
];
const $ce6dd72bc4611534$export$c4df318d1f4ad4 = [
    {
        target: "signal-processor-core",
        station: "bench",
        inputs: [
            {
                id: "steel-plates",
                qty: 2
            },
            {
                id: "glass-lens",
                qty: 1
            }
        ]
    },
    {
        target: "precision-servo-gear",
        station: "bench",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            }
        ]
    },
    {
        target: "nutrient-catalyst-ampoule",
        station: "bench",
        inputs: [
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "adaptive-filter-membrane",
        station: "bench",
        inputs: [
            {
                id: "leather-straps",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            }
        ]
    },
    {
        target: "ultrasonic-sensor-grid",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            }
        ]
    },
    {
        target: "micro-servo-drill",
        station: "bench",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "vibration-dampener",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-polarizer-film",
        station: "bench",
        inputs: [
            {
                id: "brass-fittings",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            }
        ]
    },
    {
        target: "medical-stimulant-cartridge",
        station: "bench",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            }
        ]
    },
    {
        target: "power-regulation-unit",
        station: "bench",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "sealed-hydraulic-pump",
        station: "bench",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            }
        ]
    },
    {
        target: "nutrient-gel-pack",
        station: "bench",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "override-datakey",
        station: "bench",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            }
        ]
    },
    {
        target: "drone-gyro-assembly",
        station: "bench",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "symbiotic-culture-vial",
        station: "bench",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "resin-casing",
                qty: 1
            }
        ]
    },
    {
        target: "pheromone-distiller-coil",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "phase-lens-array",
        station: "bench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 2
            },
            {
                id: "brass-fittings",
                qty: 1
            }
        ]
    },
    {
        target: "ghost-signal-modulator",
        station: "bench",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            }
        ]
    }
];
const $ce6dd72bc4611534$export$aafe7b77259ba40d = {
    "dominion": [
        //
        // "signal-relay"
        //
        {
            "id": "relay-stabilizer",
            "name": "Relay Stabilizer",
            "icon": "\uD83D\uDEF0\uFE0F\uD83D\uDCE1",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Restores damaged comm towers and aligns dishes for steady transmission.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Rooted support frames keep relay masts upright on soft or shifting ground."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Maps ride the same channel as comm traffic, boosting range while lowering scan noise."
                }
            ]
        },
        {
            "id": "organic-link-adapter",
            "name": "Organic Link Adapter",
            "icon": "\uD83D\uDD17\uD83E\uDDEC",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Threads bio-fiber into cracked relay lines to hold connection when metal cabling fails.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "servo-containment",
                    "effect": "Enzyme runoff is routed through bio-sheaths so relay panels don\u2019t corrode."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "depth-step",
                    "effect": "Relays sync with surface settling moments to reduce transmission interference."
                }
            ]
        },
        {
            "id": "silent-channel",
            "name": "Silent Channel",
            "icon": "\uD83D\uDD15\uD83D\uDCF6",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Masks signal noise so scanners can\u2019t trace team transmissions.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "silent-hand",
                    "effect": "Quiet comms match scent-neutral zones so movement near wildlife stays unseen."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "echo-loop",
                    "effect": "Comms timing matches data-scrub cycles so logs don\u2019t record the team\u2019s traffic."
                }
            ]
        },
        //
        // "system-override"
        //
        {
            "id": "command-cascade",
            "name": "Command Cascade",
            "icon": "\uD83E\uDDE9\uD83D\uDCDF",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Links multiple machines to take control in a single sequence.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "signal-harmonizer",
                    "effect": "Pacified groups keep pace with redirected turrets and drones without panic."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "control-spoof",
                    "effect": "Spoofed credentials make the takeover look like a routine maintenance command."
                }
            ]
        },
        {
            "id": "bio-feedback-guard",
            "name": "Bio-Feedback Guard",
            "icon": "\uD83D\uDEE1\uFE0F\u26A1",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Uses flexible bio-couplers to absorb surge current during forced reboots.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Excess current sinks into bio-layers so panels don\u2019t flash over."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Stabilizers bleed off spikes so control doesn't drop mid-sequence."
                }
            ]
        },
        {
            "id": "signal-mask-injection",
            "name": "Signal Mask Injection",
            "icon": "\uD83D\uDCE6\uD83D\uDCE1",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Routes control packets through decoy traffic so monitors don\u2019t flag the breach.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Bio-layers and signal masks combine to confuse hybrid detection systems."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "control-spoof",
                    "effect": "Borrowed access patterns make the override look authorized."
                }
            ]
        },
        //
        // "drone-command"
        //
        {
            "id": "coordinated-flight-pattern",
            "name": "Coordinated Flight Pattern",
            "icon": "\uD83D\uDEF8\uD83E\uDDED",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Syncs drone routes to avoid overlap and missed coverage.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "reflex-bloom",
                    "effect": "Drones spread recovery spores evenly after hazards to reduce downtime."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "drone-path-shadow",
                    "effect": "Veil routes piggy-back drone paths so scouts move under the same visual cover."
                }
            ]
        },
        {
            "id": "rootpath-protocol",
            "name": "Rootpath Protocol",
            "icon": "\uD83E\uDDED\uD83C\uDF3F",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Programs drones to move along overgrowth channels for safe passage.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Vine scaffolds give drones lift points for field repairs."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Organic scans mark low-snag routes through dense brush and debris."
                }
            ]
        },
        {
            "id": "echo-pulse-beacon",
            "name": "Echo Pulse Beacon",
            "icon": "\uD83D\uDCDF\uD83C\uDF0A",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Adds quiet sonar to drones for mapping and quick relays.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "reclamation-drone-link",
                    "effect": "Drones coordinate with bio-harvesters to map and salvage in synchronized sweeps."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "shadow-archive",
                    "effect": "Drones upload map snapshots so scouts don\u2019t need to rescan rooms."
                }
            ]
        },
        //
        // "safeguard"
        //
        {
            "id": "system-ground-loop",
            "name": "System Ground Loop",
            "icon": "\u2693\u26A1",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Drops unstable current into safe grounds to prevent arcs.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Grounded charge feeds into bio-layers so suits take less shock."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Ground paths tie to stabilizers so readouts don't drift under load."
                }
            ]
        },
        {
            "id": "spore-vent-reclaimer",
            "name": "Spore Vent Reclaimer",
            "icon": "\uD83C\uDF2C\uFE0F\uD83E\uDDFC",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Purges bad air and filters it for reuse after a spill or fire.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "photosymbiosis",
                    "effect": "Plant beds turn vented gas into cleaner air, easing strain on masks."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "depth-step",
                    "effect": "Purge cycles align with surface dips to stop pressure swings."
                }
            ]
        },
        {
            "id": "manual-override-line",
            "name": "Manual Override Line",
            "icon": "\uD83D\uDEE0\uFE0F\u26D3\uFE0F",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Adds a physical cut-off so systems can be made safe by hand.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Cut-offs trigger lattice to seal, stopping leaks instantly."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved system states let shutoffs restore safe configurations instantly."
                }
            ]
        },
        //
        // "quantum-scan"
        //
        {
            "id": "entangled-synchrony",
            "name": "Entangled Synchrony",
            "icon": "\uD83D\uDD17\uD83D\uDCCA",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Links scanners so readings update together without delay.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Synchronized scans help target clean samples during salvage operations."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Results back up to Veil storage so scans can be restored if instruments fail." // revised
                }
            ]
        },
        {
            "id": "bio-spectral-crosscheck",
            "name": "Bio-Spectral Crosscheck",
            "icon": "\uD83E\uDDEA\u2622\uFE0F",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Matches radiation and field strength against known biological sources.",
            "synergies": [
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Pulse returns show which walls hide root channels or nests."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Feedback helps break down thin contamination films faster."
                }
            ]
        },
        {
            "id": "ghost-echo-capture",
            "name": "Ghost Echo Capture",
            "icon": "\uD83D\uDD0D\uD83D\uDD0C",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Measures residual current in damaged circuits to locate still-active connections.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "shadowroot-bloom",
                    "effect": "Root tips wick trace particles out of hairline cracks for cleaner samples."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved readings fill gaps in later scans for cleaner data continuity." // revised
                }
            ]
        }
    ],
    "wilders": [
        //
        // "reclamation"
        //
        {
            "id": "reclamation-drone-link",
            "name": "Reclamation Drone Link",
            "icon": "\uD83E\uDD16\uD83C\uDF3E",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Pairs bio-harvesters with repair drones to pull clean samples fast.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Shared routes keep harvest and repair flights from crossing paths."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "shadow-archive",
                    "effect": "Findings upload to scout archives so crews don't double dip rooms."
                }
            ]
        },
        {
            "id": "mycelial-rebalance",
            "name": "Mycelial Rebalance",
            "icon": "\uD83C\uDF44\uD83D\uDD01",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Uses live fungal filters to sort usable tissue from waste.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Filtered air keeps samples dry and prevents mold blooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "biofilm-stabilizer",
                    "effect": "Seals around work sites so salvage doesn\u2019t set off contact sensors."
                }
            ]
        },
        {
            "id": "phase-cleanse",
            "name": "Phase Cleanse",
            "icon": "\uD83E\uDDFC\uD83C\uDF2B\uFE0F",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Applies mild disinfectant waves that lift spores and oils from surfaces.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "echo-pulse-beacon",
                    "effect": "Drone sweeps spread the cleanse evenly through large rooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Relay points guide cleanse waves to hidden surfaces behind panels."
                }
            ]
        },
        //
        // "growth-control"
        //
        {
            "id": "adaptive-lattice",
            "name": "Adaptive Lattice",
            "icon": "\uD83E\uDDF1\uD83C\uDF3F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Grows vine-metal frames that brace walls or span short gaps.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "relay-stabilizer",
                    "effect": "Braced masts don\u2019t drift, keeping long links online."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Vine-braced anchors stay stable even when floors shift and settle."
                }
            ]
        },
        {
            "id": "photosymbiosis",
            "name": "Photosymbiosis",
            "icon": "\u2600\uFE0F\uD83C\uDF3F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Channels light through leaves to speed growth and thicken cover.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Filtered vents feed beds so air clears faster after a spill."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "spore-veil",
                    "effect": "Light-absorbing spores lower visibility for moving squads."
                }
            ]
        },
        {
            "id": "shadowroot-bloom",
            "name": "Shadowroot Bloom",
            "icon": "\uD83C\uDF31\uD83D\uDD73\uFE0F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Guides roots through shaded cracks to open paths and expose hidden space.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "ghost-echo-capture",
                    "effect": "Roots pull faint power traces out of sealed joints for scanning."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Combined pulses show hollows behind walls and floors."
                }
            ]
        },
        //
        // "wild-influence"
        //
        {
            "id": "signal-harmonizer",
            "name": "Signal Harmonizer",
            "icon": "\uD83C\uDFBC\uD83D\uDC3E",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Lines up heart and breath rhythms to calm groups without drugs.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Calm groups move in step with redirected machines."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Calm scent profiles look like background fauna on sensors."
                }
            ]
        },
        {
            "id": "pheromone-chorus",
            "name": "Pheromone Chorus",
            "icon": "\uD83E\uDD8B\uD83C\uDF2C\uFE0F",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Blends signals from multiple handlers to widen the calm zone.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Drones carry the blend across the room without startling nests."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "mirror-walk",
                    "effect": "Team steps track as one trace, reducing sudden noise."
                }
            ]
        },
        {
            "id": "silent-hand",
            "name": "Silent Hand",
            "icon": "\uD83E\uDD2B\uD83D\uDC63",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Suppresses scent trails and quiets gear snaps near wildlife.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "silent-channel",
                    "effect": "Quiet comms match low-scent lanes so patrols pass by."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Relay hooks damp vibrations so footfalls don't echo in tight halls."
                }
            ]
        },
        //
        // "bio-shield"
        //
        {
            "id": "bio-shielding",
            "name": "Bio-Shielding",
            "icon": "\uD83D\uDEE1\uFE0F\u26A1",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Grows a thin, flexible layer that spreads shock and heat.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "system-ground-loop",
                    "effect": "Grounded arcs bleed into the layer so skin doesn\u2019t blister."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Heat and scent even out, leaving little for trackers to follow."
                }
            ]
        },
        {
            "id": "shared-immunity",
            "name": "Shared Immunity",
            "icon": "\uD83E\uDDEC\uD83E\uDD1D",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Passes enzyme packs between teammates for short-term resistance.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "bio-feedback-guard",
                    "effect": "Enzymes protect skin from stray surges during forced reboots."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Body markers shift enough to pass basic biometric checks."
                }
            ]
        },
        {
            "id": "dim-shift-layer",
            "name": "Dim Shift Layer",
            "icon": "\uD83E\uDE9E\uD83E\uDDE9",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Adjusts surface tone and reflectivity to match nearby materials.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "entangled-synchrony",
                    "effect": "Scan timings help the layer adjust before sensors sweep past."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved lighting profiles help the layer auto-tune along familiar paths." // revised
                }
            ]
        },
        //
        // "containment"
        //
        {
            "id": "servo-containment",
            "name": "Servo Containment",
            "icon": "\uD83D\uDCE6\u2623\uFE0F",
            "skill": "containment",
            "faction": "wilders",
            "description": "Uses drone shells as hard cases for hot samples.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "organic-link-adapter",
                    "effect": "Bio-sheaths in relay bays don\u2019t react to sealed cases."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "servo-alignment-tool",
                    "effect": "Cases align with lock rails, letting crews move them quietly."
                }
            ]
        },
        {
            "id": "mutualist-growth",
            "name": "Mutualist Growth",
            "icon": "\uD83E\uDD1D\uD83C\uDF31",
            "skill": "containment",
            "faction": "wilders",
            "description": "Cultivates living pods around unstable material to keep it from spreading.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "manual-override-line",
                    "effect": "Cut-offs trigger pod close-up so leaks don\u2019t escape."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "echo-pulse-decoy",
                    "effect": "Decoy pulses draw guard attention away while pods close and seal."
                }
            ]
        },
        {
            "id": "reflex-bloom",
            "name": "Reflex Bloom",
            "icon": "\uD83D\uDC8A\uD83C\uDF3F",
            "skill": "containment",
            "faction": "wilders",
            "description": "Deploys small regenerative pods that release healing compounds after exposure.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Drones spread bloom spores across the team between rooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "spore-veil",
                    "effect": "Bloom and veil spores mix to hide heat shimmer and breath."
                }
            ]
        }
    ],
    "veil": [
        //
        // "echo-trace"
        //    
        {
            "id": "quantum-relay-hook",
            "name": "Relay Hook",
            "icon": "\uD83E\uDE9D\uD83D\uDCE1",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Links mapping scanners to nearby network relays so data and comms share the same path.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "relay-stabilizer",
                    "effect": "Stable masts carry both traffic and survey data without dropouts."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "photosymbiosis",
                    "effect": "Growth covers relay lines so data travels protected through the room."
                }
            ]
        },
        {
            "id": "biotrace-resonance",
            "name": "Biotrace Resonance",
            "icon": "\uD83E\uDDEB\uD83D\uDCF6",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Sends short pulses that reflect off living material to flag organic routes.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "bio-spectral-crosscheck",
                    "effect": "Combined returns show where growth hides power lines and vents."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Pulse images reveal thin films left after salvage so teams can clear them."
                }
            ]
        },
        {
            "id": "shadow-archive",
            "name": "Shadow Archive",
            "icon": "\uD83D\uDDC4\uFE0F\uD83D\uDDFA\uFE0F",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Stores map data in portable memory that syncs on contact.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "echo-pulse-beacon",
                    "effect": "Drones post snapshots so scouts don\u2019t re-scan cleared rooms."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "silent-hand",
                    "effect": "Echo dampers cut footfall bounce so nearby wildlife stays calm."
                }
            ]
        },
        //
        // "lock-breach"
        // 
        {
            "id": "servo-alignment-tool",
            "name": "Servo Alignment Tool",
            "icon": "\uD83D\uDD27\uD83D\uDD13",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Calibrates lock servos so picks and spinners seat cleanly.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "manual-override-line",
                    "effect": "Kill-switches and lock rails line up to prevent jolts mid-breach."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "servo-containment",
                    "effect": "Sealed cases ride rails quietly through narrow passages."
                }
            ]
        },
        {
            "id": "biofilm-stabilizer",
            "name": "Biofilm Stabilizer",
            "icon": "\uD83E\uDDF4\uD83D\uDD07",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Applies a thin organic seal so panels don\u2019t rattle or squeal.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "signal-mask-injection",
                    "effect": "Quiet seals and decoy traffic hide the sound and the signal of a breach."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "mycelial-rebalance",
                    "effect": "Seals keep mold from creeping under plates while crews work."
                }
            ]
        },
        {
            "id": "echo-pulse-decoy",
            "name": "Echo Pulse Decoy",
            "icon": "\uD83C\uDF87\uD83D\uDC40",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Sends a harmless pulse so guards look the wrong way during a breach.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Distractions line up with machine takeovers so alarms don\u2019t stack."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "mutualist-growth",
                    "effect": "Pods close while decoys fire, hiding movement sounds."
                }
            ]
        },
        //
        // "stealth-transit"
        // 
        {
            "id": "drone-path-shadow",
            "name": "Drone Path Shadow",
            "icon": "\uD83D\uDD76\uFE0F\uD83E\uDD16",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Walks the same lanes as drones so both use one visual trace.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "rootpath-protocol",
                    "effect": "Scouts follow programmed drone routes for safe, low-visibility passage."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "pheromone-chorus",
                    "effect": "Air carries calm signals along the same lanes, reducing spooks."
                }
            ]
        },
        {
            "id": "spore-veil",
            "name": "Spore Veil",
            "icon": "\uD83C\uDF2B\uFE0F\uD83D\uDD75\uFE0F",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Releases faint spores that dull edges and reduce shine.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "system-ground-loop",
                    "effect": "Grounded systems prevent static buildup that could reveal the spore cloud."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "reflex-bloom",
                    "effect": "Veil spores mix with bloom to hide heat shimmer and breath."
                }
            ]
        },
        {
            "id": "mirror-walk",
            "name": "Mirror Walk",
            "icon": "\uD83E\uDE9E\uD83D\uDC63",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Matches the lead scout\u2019s pace so the group reads as one unit.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "rootpath-protocol",
                    "effect": "Shared pacing and overgrowth lanes reduce brush noise."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "pheromone-chorus",
                    "effect": "Synchronized steps pair with a single calm signal, lowering alert spikes."
                }
            ]
        },
        //
        // "signal-mask"
        // 
        {
            "id": "control-spoof",
            "name": "Control Spoof",
            "icon": "\uD83C\uDFAD\uD83D\uDD10",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Builds fake machine credentials that pass quick checks.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Spoofs clear the way for chained takeovers without alarms."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "shared-immunity",
                    "effect": "Shifted biometrics keep gates from flagging the team during checks."
                }
            ]
        },
        {
            "id": "bio-id-mask",
            "name": "Bio-ID Mask",
            "icon": "\uD83E\uDEAA\uD83D\uDC43",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Mimics heat and scent patterns so sensors read the team as local life.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "signal-mask-injection",
                    "effect": "Bio and machine masks match, confusing hybrid doors and cameras."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "signal-harmonizer",
                    "effect": "Calm scent profiles slot into the mask so patrols ignore the team."
                }
            ]
        },
        {
            "id": "echo-loop",
            "name": "Echo Loop",
            "icon": "\uD83D\uDD01\uD83D\uDCDC",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Writes temporary log entries to hide the real exit trail.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "silent-channel",
                    "effect": "Dummy logs and quiet comms leave nothing firm to trace."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "mycelial-rebalance",
                    "effect": "Fungal filters break down organic traces that could reveal the exit route."
                }
            ]
        },
        //
        // "transit-anchor"
        // 
        {
            "id": "phase-anchor",
            "name": "Phase Anchor",
            "icon": "\uD83E\uDEA8\uD83D\uDCCD",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Drops a small stabilizer so floors and walls stop drifting.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "organic-link-adapter",
                    "effect": "Anchors act as grounds so patched relay lines don\u2019t wander."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "mutualist-growth",
                    "effect": "Pods close around anchors, preventing leaks from creeping."
                }
            ]
        },
        {
            "id": "depth-step",
            "name": "Depth Step",
            "icon": "\u23F1\uFE0F\uD83D\uDC63",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Times crossings for moments when surfaces settle.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Purge cycles match crossings so pressure and air stay even."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "shadowroot-bloom",
                    "effect": "Roots shift to create stable footholds at the right moment."
                }
            ]
        },
        {
            "id": "echo-fold",
            "name": "Echo Fold",
            "icon": "\uD83D\uDDC2\uFE0F\uD83D\uDEF0\uFE0F",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Caches visual and sensor data from recent scans for quick reload if equipment glitches.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "entangled-synchrony",
                    "effect": "Readings merge into cached files so analysts can review full logs later." // revised
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "dim-shift-layer",
                    "effect": "Saved lighting profiles help the layer auto-tune along familiar paths." // revised
                }
            ]
        }
    ]
};
const $ce6dd72bc4611534$export$1a64c4c64ba19abd = {
    // ⚠ WORDING CORRECTED S14 — the behaviour was right, the description was not.
    //
    // It used to read "retained through every founding, instead of being re-bought
    // with marks each era", which describes RETENTION and implies you must have
    // owned Auto-Raid Protocol already. `foundSyndicateCore` has always granted it
    // outright, bought or not, and that is the intent: reaching L3 is what
    // automates L1 for good. The old wording made a correct grant look like a
    // 5-Writ exploit on a 300-mark upgrade.
    //
    // The Command upgrade still earns its price as EARLY ACCESS. Measured: a
    // player who banks everything and buys nothing else reaches 300 marks around
    // day 16, against a first founding at day 25 — so it buys about nine days of
    // hands-off raiding, paid for by going without Officer Academy, Forward Depot
    // and Field Conditioning in the meantime. A real trade, not a formality, and
    // nowhere near "automated a few days in".
    "standing-orders": {
        name: "Standing Orders",
        icon: "\uD83D\uDCCB",
        flavor: "The orders outlive the officers who wrote them.",
        effect: "Every founding starts the new era with Auto-Raid Protocol and Auto-Fabricator running \u2014 whether or not Command ever bought them.",
        effectHint: "foundSyndicateCore: grants auto-raid-protocol + auto-fabricator into the fresh command.upgrades",
        costs: [
            5
        ],
        effectValues: [
            true
        ]
    },
    "succession-doctrine": {
        name: "Succession Doctrine",
        icon: "\uD83D\uDD4A\uFE0F",
        flavor: "No chair stays empty long enough to matter.",
        effect: "Promotes at peak marks rate and raises the successor from your template, hands-off.",
        effectHint: "syndicate-core: peak-age policy, evaluated at raid end (requires auto-raid-protocol + auto-fabricator)",
        costs: [
            16
        ],
        effectValues: [
            true
        ],
        // COMMAND upgrades, not charters: the dependency crosses layers on purpose.
        //
        // BOTH, because this charter promotes on the MARKS RATE and 71% of a
        // character's marks are crafting-derived (see `auto-fabricator` in
        // commandUpgrades.js for the measurement). Automating the raid but not the
        // workshop would have this policy promoting off a third of the income it
        // was calibrated against — raid -> craft -> marks -> promote is the loop,
        // and three of four steps automates nothing.
        //
        // `requiresName` is now only a fallback: both upgrades ship in the catalog,
        // so the live name wins. It is kept because it costs nothing and the lock
        // line leaks a raw slug without it if an id is ever renamed.
        requires: [
            "auto-raid-protocol",
            "auto-fabricator"
        ],
        requiresName: "Auto-Raid Protocol"
    },
    "operations-charter": {
        name: "Operations Charter",
        icon: "\uD83D\uDDFA\uFE0F",
        flavor: "Signed routes, sealed manifests, and somebody else's problem at the far end.",
        effect: "Unlocks Operations, and licenses 1 / 2 / 3 concurrent operations.",
        effectHint: "operations: concurrent slot cap = min(this, leader + idle era-Legends)",
        costs: [
            8,
            20,
            45
        ],
        effectValues: [
            1,
            2,
            3
        ]
    },
    "founders-endowment": {
        name: "Founder's Endowment",
        icon: "\uD83C\uDFDB\uFE0F",
        flavor: "Every charter opens with a line of credit against its own reputation.",
        effect: "Each new Command era starts with 100 / 250 / 500 marks.",
        effectHint: "foundSyndicateCore: seeds command.marks after the wipe",
        costs: [
            10,
            25,
            60
        ],
        effectValues: [
            100,
            250,
            500
        ]
    },
    // ⚠ REPURPOSED IN S14, from "Command upgrades cost 20/35/50% less".
    //
    // The discount was a DEAD CHARTER, and measurably so: a batch of 8 runs with
    // the discount forced to 90% moved the era-pacing targets not at all
    // (foundings by day 71: 2.63 before, 2.63 after). Command upgrade cost is
    // simply not what sets era length.
    //
    // What does: era length = Legends required x tour length, and TOUR LENGTH
    // CANNOT BE MOVED BY POWER. The promotion policy ends a tour when the
    // incumbent's marks rate falls below what a fresh recruit averages, and that
    // benchmark is measured from the player's own last three tours — so any
    // uniform buff lifts both sides and the crossover never moves. Three
    // independent buffs confirmed it (see docs/layers/3-syndicate/implementation.md § 2026-08-03 "Era pacing").
    //
    // That leaves the Legend requirement as the only lever on era pacing, which
    // is why this charter now spends its ranks there. It is also the layer's own
    // fantasy stated literally: each Syndicate you found makes the next one
    // easier to found.
    "institutional-memory": {
        name: "Institutional Memory",
        icon: "\uD83D\uDCDA",
        flavor: "The second time a thing is built, nobody pays to learn it again.",
        effect: "Found the next Syndicate with 3 / 5 / 6 fewer Legends.",
        effectHint: "foundingLegendRequirement: subtracts from the Legend gate",
        costs: [
            12,
            16,
            26
        ],
        effectValues: [
            3,
            5,
            6
        ]
    },
    "provision-contracts": {
        name: "Provision Contracts",
        icon: "\uD83D\uDCE6",
        flavor: "Bulk rates, negotiated once, honoured across the whole planet.",
        effect: "Operation cargo costs 25 / 40% less.",
        effectHint: "operations: cargo deduction at launch",
        costs: [
            15,
            40
        ],
        effectValues: [
            0.25,
            0.4
        ]
    },
    "blackout-sanction": {
        name: "Blackout Sanction",
        icon: "\uD83C\uDF11",
        flavor: "Authorisation to run the jobs that were never filed.",
        effect: "Unlocks Blackout Contracts - optional raids under hard modifiers, each paying a permanent perk.",
        effectHint: "raid planning: blackout toggle; perks via getBlackoutPerk",
        costs: [
            30
        ],
        effectValues: [
            true
        ]
    }
};
const $ce6dd72bc4611534$export$e3c642cf362e5b0d = {
    width: 17,
    height: 9,
    // Region ownership. Digits index `regionOrder` below.
    // Row strings are the authoring format: a 153-entry array is unreadable and
    // undiffable, and this is meant to be edited by hand.
    //
    // Flooded Bastions holds a foothold on the EASTERN shore (row 6, column 13),
    // across the strait. Not decoration: Hollow Core's capital is the far side of
    // that water, and with staging points restricted to land there was no
    // other-region land within a Short Haul's reach of it — the destination
    // silently offered no route at all. A region named for water spanning some is
    // also the least strange way to fix it.
    //
    // Boundaries deliberately WOBBLE row to row rather than running straight
    // down. Straight columns read as a bar chart; an irregular border reads as
    // territory. Each region's run must still overlap its own run in the
    // neighbouring rows or the territory splits into islands — worldMap.test.js
    // fails on that, and it is the easy mistake to make while editing these.
    regionRows: [
        "11112223334444555",
        "11122233344455555",
        "11122233334445555",
        "11112223334445555",
        "11112223334444555",
        "11122233344445555",
        "11112223334444555",
        "11122233334445555",
        "11112223334444555"
    ],
    // Terrain, drawn as CONTINENTS rather than textured ground.
    //
    // 9 rows, not 7: 17x9 is close to the 2:1 of an equirectangular world map,
    // and the extra rows are what give the landmasses room to have a shape at all.
    // The old 7-row grid matched a Tier-3 raid map, but that parity was already
    // vestigial — the world map has its own CSS-grid renderer and never used the
    // raid grid's layout.
    //
    // Ocean is `~`, which is PASSABLE at cost 3. That is what keeps every region
    // routable no matter how the coastline is drawn: a strait is a toll, never a
    // wall. Land is deliberately connected east-west through the middle rows so
    // routes stay overland and the cost model barely moves; the one real crossing
    // is the strait at columns 11-13, which puts Hollow Core genuinely across a
    // sea and costs about a quarter of a Grand Circuit to reach.
    //
    // `#` is true impassable and is used only for a couple of inland peaks. Ocean
    // being passable means a peak can never strand a region.
    //
    // THE BORDER IS ALL OCEAN — row 0, row 8, column 0 and column 16. That frame
    // is what makes the grid read as a world rather than as a cropped tile sheet,
    // and it also guarantees no route or staging point can be pinned against an
    // edge with nowhere to go. Keep it when editing.
    terrainRows: [
        "~~~~~~~~~~~~~~~~~",
        "~..^..~~.^..~~..~",
        "~...^.~..^..~.^.~",
        "~~.^..^...^~~..^~",
        "~.....#~..^..~..~",
        "~.^...~~....~~.^~",
        "~~..^.~~~..~~...~",
        "~~~.^~~~~.^~~~..~",
        "~~~~~~~~~~~~~~~~~"
    ],
    // Digit -> region id. Order is west-to-east, which is also longitude order.
    regionOrder: {
        "1": "cradle-expanse",
        "2": "shard-cities",
        "3": "verdant-reclamation",
        "4": "sunken-bastions",
        "5": "hollow-core"
    },
    // Where convoys actually depart from and arrive at. A region is an area, but
    // a route needs a point — this is that point. Every capital must sit inside
    // its own territory and on passable ground; worldMap.test.js enforces both,
    // because either mistake produces a region that silently cannot be reached.
    capitals: {
        "cradle-expanse": {
            row: 2,
            col: 2
        },
        "shard-cities": {
            row: 4,
            col: 5
        },
        "verdant-reclamation": {
            row: 3,
            col: 8
        },
        "sunken-bastions": {
            row: 5,
            col: 11
        },
        "hollow-core": {
            row: 6,
            col: 15
        }
    },
    terrainCost: {
        ".": 1,
        "^": 2,
        "~": 3,
        "#": null
    }
};


//done

//done
//@ts-check

/**
 * Debug logging - channel-gated, silent by default.
 *
 * Shared by the browser game and the headless simulator. Both used to
 * console.log unconditionally from the same -core.js modules, which meant the
 * game spammed the devtools console and a 90-day simulator run produced a
 * ~169MB log that had to be grepped to find anything.
 *
 * Nothing here prints unless a channel is explicitly enabled:
 *
 *   Browser:   localStorage.setItem('debug', 'raid,events')
 *   Node:      DEBUG=raid,events node tools/simulation/game-simulator.js
 *   Either:    setDebugChannels(['raid'])   // programmatic
 *
 * '*' enables everything. Channel names are the CHANNELS keys below.
 *
 * Use isDebug() to guard any message whose ARGUMENTS are expensive to build -
 * debug() itself is cheap when disabled, but its arguments are still evaluated
 * at the call site:
 *
 *   if (isDebug(CH.loot)) debug(CH.loot, `pool: ${buildExpensiveSummary()}`);
 */ /** Channel names. Use these constants rather than bare strings. */ const $8fffcb1ac554ad26$export$31ff2235b44019b8 = {
    raid: 'raid',
    events: 'events',
    loot: 'loot',
    craft: 'craft',
    path: 'path',
    sim: 'sim',
    ui: 'ui'
};
const $8fffcb1ac554ad26$var$ALL_CHANNELS = Object.values($8fffcb1ac554ad26$export$31ff2235b44019b8);
/** @type {Set<string>} */ let $8fffcb1ac554ad26$var$enabled = new Set();
function $8fffcb1ac554ad26$var$parseSpec(spec) {
    if (!spec) return [];
    return String(spec).split(/[\s,]+/).map((s)=>s.trim()).filter(Boolean);
}
function $8fffcb1ac554ad26$export$c2ead4c5b33bf75(channels) {
    const list = Array.isArray(channels) ? channels : $8fffcb1ac554ad26$var$parseSpec(channels);
    $8fffcb1ac554ad26$var$enabled = list.includes('*') ? new Set($8fffcb1ac554ad26$var$ALL_CHANNELS) : new Set(list);
}
function $8fffcb1ac554ad26$export$bc5e1b10378f79c6() {
    return [
        ...$8fffcb1ac554ad26$var$enabled
    ];
}
function $8fffcb1ac554ad26$export$5540f6562bfea743(channel) {
    return $8fffcb1ac554ad26$var$enabled.has(channel);
}
function $8fffcb1ac554ad26$export$1c9f709888824e05(channel, ...args) {
    if ($8fffcb1ac554ad26$var$enabled.has(channel)) console.log(`[${channel}]`, ...args);
}
// --- Auto-configure from the ambient environment -------------------------
// Wrapped in try/catch: `process` is undefined in the browser and
// `localStorage` throws in some sandboxed/SSR contexts.
try {
    if (typeof localStorage !== 'undefined') {
        const spec = localStorage.getItem('debug');
        if (spec) $8fffcb1ac554ad26$export$c2ead4c5b33bf75(spec);
    }
} catch  {
/* leave all channels disabled */ }


const $42b272c2c0f44bdf$var$allItems = [
    ...$ce6dd72bc4611534$export$39df1497f8fcc025 || [],
    ...$ce6dd72bc4611534$export$2508a374b14b8e59 || [],
    ...$ce6dd72bc4611534$export$241bdd39c3e59b72 || [],
    ...$ce6dd72bc4611534$export$11208b4f926fa7ee || [],
    ...$ce6dd72bc4611534$export$f9575e6a92b5621d || [],
    ...$ce6dd72bc4611534$export$439a14874f0a75e4 || [],
    ...$ce6dd72bc4611534$export$b2b2210935a03dc3 || [],
    ...$ce6dd72bc4611534$export$c1a4d9d859d3b7 || [],
    ...$ce6dd72bc4611534$export$a24b2f292778b5dc || [],
    ...$ce6dd72bc4611534$export$29d1bf8c74230d20 || [],
    ...$ce6dd72bc4611534$export$71b953a5ed5f0cd6 || [],
    ...$ce6dd72bc4611534$export$76261a034023b29 || [],
    ...$ce6dd72bc4611534$export$7a39b013515e9c7d || [],
    ...$ce6dd72bc4611534$export$a4f81eda8633632 || [],
    ...$ce6dd72bc4611534$export$e32476559574be7c || [],
    ...$ce6dd72bc4611534$export$5255cc549327de05 || [],
    ...$ce6dd72bc4611534$export$d3e0e7174c382d10 || [],
    ...$ce6dd72bc4611534$export$d82f13cda8103b44 || []
];
function $42b272c2c0f44bdf$export$7ac3a88d34a76e7(array, rand = Math.random) {
    const shuffled = [
        ...array
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const j = Math.floor(rand() * (i + 1));
        [shuffled[i], shuffled[j]] = [
            shuffled[j],
            shuffled[i]
        ];
    }
    return shuffled;
}
function $42b272c2c0f44bdf$export$913078032f14f7f(faction = null) {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, "Selecting random avatar for faction:", faction);
    const factions = [
        'dominion',
        'veil',
        'wilders'
    ];
    const factionKey = faction || factions[Math.floor(Math.random() * factions.length)];
    const position = Math.floor(Math.random() * 32); // 0-31 for 32 avatars per faction
    return `avatar-${factionKey}-${position}`;
}
function $42b272c2c0f44bdf$export$f3619081e7e8f116(entity) {
    if (!entity) return "seed";
    return entity.avatarSeed || entity.id || entity.name || entity.avatar || "seed";
}
function $42b272c2c0f44bdf$export$f06085c61225102a(entity) {
    const faction = entity && entity.faction || "dominion";
    let attrs = `data-avatar-seed="${$42b272c2c0f44bdf$export$f3619081e7e8f116(entity)}" data-avatar-faction="${faction}"`;
    if (entity && entity.avatarFeatures) {
        const json = JSON.stringify(entity.avatarFeatures).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/'/g, "&#39;");
        attrs += ` data-avatar-features='${json}'`;
    }
    return attrs;
}
function $42b272c2c0f44bdf$export$182937d2e68a339(skillKey) {
    // Find the skill in faction data
    for (const factionKey of Object.keys($ce6dd72bc4611534$export$aeeef991191508e2)){
        const faction = $ce6dd72bc4611534$export$aeeef991191508e2[factionKey];
        if (faction.skills[skillKey]) return faction.skills[skillKey].name;
    }
    return skillKey; // Fallback to raw key
}
function $42b272c2c0f44bdf$export$8a18dddc0824814c(skillKey) {
    // Find the skill in faction data
    for (const factionKey of Object.keys($ce6dd72bc4611534$export$aeeef991191508e2)){
        const faction = $ce6dd72bc4611534$export$aeeef991191508e2[factionKey];
        if (faction.skills[skillKey]) return faction.skills[skillKey].icon || "\u2753";
    }
    return "\u2753"; // Fallback icon
}
function $42b272c2c0f44bdf$export$7c6f492816bf045e(skillIds) {
    // Get display names for an array of skill IDs
    return skillIds.map((skillId)=>$42b272c2c0f44bdf$export$182937d2e68a339(skillId));
}
// skillId -> faction. Memoized: factionSkills is static config, and this is
// called per-tile and per-room in hot paths.
let $42b272c2c0f44bdf$var$skillFactionMap = null;
function $42b272c2c0f44bdf$export$a3603dda04ca8111(skillId) {
    if (!$42b272c2c0f44bdf$var$skillFactionMap) {
        $42b272c2c0f44bdf$var$skillFactionMap = {};
        Object.entries($ce6dd72bc4611534$export$aeeef991191508e2).forEach(([faction, def])=>{
            Object.keys(def.skills || {}).forEach((s)=>{
                $42b272c2c0f44bdf$var$skillFactionMap[s] = faction;
            });
        });
    }
    return $42b272c2c0f44bdf$var$skillFactionMap[skillId] || null;
}
function $42b272c2c0f44bdf$export$96671014a1dabc4c(effectId) {
    return $ce6dd72bc4611534$export$1aaffaaaf67a009d.find((effect)=>effect && effect.id === effectId);
}
function $42b272c2c0f44bdf$export$b7fbae54a8f17db(techniqueId) {
    // Find the technique in skill techniques data
    for (const faction of Object.values($ce6dd72bc4611534$export$aafe7b77259ba40d)){
        const technique = faction.find((t)=>t.id === techniqueId);
        if (technique) return technique.name;
    }
    return techniqueId; // Fallback to ID if not found
}
function $42b272c2c0f44bdf$export$bf5389e28ce4699d(techniqueId) {
    // Find the technique in skill techniques data
    for (const faction of Object.values($ce6dd72bc4611534$export$aafe7b77259ba40d)){
        const technique = faction.find((t)=>t.id === techniqueId);
        if (technique) return technique.icon;
    }
    return techniqueId; // Fallback to ID if not found
}
function $42b272c2c0f44bdf$export$a6cb179f21ae932e(techniqueId) {
    // Find the technique in skill techniques data
    for (const skillTechnique of Object.values($ce6dd72bc4611534$export$aafe7b77259ba40d)){
        const technique = skillTechnique.find((t)=>t.id === techniqueId);
        if (technique) return technique.skill;
    }
    return null; //null if not found 
}
function $42b272c2c0f44bdf$export$31330438f6059b08(itemId) {
    // Find item by ID and return its name
    const item = $42b272c2c0f44bdf$export$a2dea178c28a0308('id', itemId);
    return item ? item.name : itemId; // Fallback to ID if not found
}
function $42b272c2c0f44bdf$export$dd077d95a65121be(roomName, roomType) {
    if (roomType == 'start') return "\uD83C\uDF00";
    else if (roomType == 'exit') return "\uD83C\uDF0C";
    else if (roomType == 'road') return "\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1\uFE0F";
    else if (roomType == 'blocked') return "\u26D4";
    else if (roomType == 'campsite') return "\uD83C\uDFD5\uFE0F";
    else if (roomType == 'water') return "\uD83C\uDF0A";
    else for (const region of Object.values($ce6dd72bc4611534$export$4fbdcec70fce9d73)){
        for (const room of region.gates){
            if (room.name === roomName) return room.icon || "\u2753";
        }
        for (const room of region.hazards){
            if (room.name === roomName) return room.icon || "\u2753";
        }
    }
    return "\u2753"; // Fallback icon
}
function $42b272c2c0f44bdf$export$543ea47e61c0d3ee(room) {
    // Find the room in region data
    for (const regionKey of Object.keys($ce6dd72bc4611534$export$4fbdcec70fce9d73)){
        const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey];
        for (const roomData of [
            ...region.gates,
            ...region.hazards
        ]){
            if (roomData.name === room) return roomData.duration || 60; // Default to 1 minutes if not specified
        }
    }
    return 30; // Fallback to 30 seconds
}
function $42b272c2c0f44bdf$export$d7a853631095b479(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return '0';
    const sign = num < 0 ? '-' : '';
    const abs = Math.abs(num);
    if (abs < 100000) return sign + String(Math.floor(abs));
    const units = [
        {
            limit: 1e12,
            suffix: 'T'
        },
        {
            limit: 1e9,
            suffix: 'B'
        },
        {
            limit: 1e6,
            suffix: 'M'
        },
        {
            limit: 1e3,
            suffix: 'K'
        }
    ];
    for (const { limit: limit, suffix: suffix } of units){
        if (abs < limit) continue;
        const scaled = abs / limit;
        const rounded = scaled < 10 ? Math.round(scaled * 10) / 10 : Math.round(scaled);
        // Rounding can carry past the unit: 999,999 scales to 999.999K, which would
        // render "1000K" instead of "1M". Re-enter one unit up rather than printing
        // a value the next suffix already covers.
        if (rounded >= 1000) return $42b272c2c0f44bdf$export$d7a853631095b479(limit * 1000);
        return sign + String(rounded) + suffix;
    }
    // Beyond the largest unit (>=1000T); no suffix left, so give the raw figure.
    return sign + String(Math.floor(abs));
}
function $42b272c2c0f44bdf$export$61fc7d43ac8f84b0(func, delay) {
    let timeoutId; // This will store the ID of the setTimeout
    return function(...args) {
        const context = this; // Preserves the 'this' context of the original function
        clearTimeout(timeoutId); // Clear any existing timeout
        timeoutId = setTimeout(()=>{
            func.apply(context, args); // Execute the original export function after the delay
        }, delay);
    };
}
function $42b272c2c0f44bdf$export$d7e8d4d4450c819c(title, content) {
    const modal = document.createElement('div');
    modal.className = 'modal';
    modal.innerHTML = `
        <div class="modal-content max-w-5xl">
            <div class="modal-header">
                <h3 class="modal-title">${title}</h3>
                <button class="close-btn">&times;</button>
            </div>
            <div class="modal-body">
                ${content}
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    const closeBtn = modal.querySelector('.close-btn');
    const closeModal = ()=>{
        //modal.classList.add('animate__animated', 'animate__fadeOut');
        setTimeout(()=>{
            document.body.removeChild(modal);
        }, 150);
    };
    closeBtn.addEventListener('click', closeModal);
    let mousedownTarget = null;
    modal.addEventListener('mousedown', (e)=>{
        mousedownTarget = e.target;
    });
    modal.addEventListener('click', (e)=>{
        if (e.target === modal && mousedownTarget === modal) closeModal();
    });
    //modal.classList.add('animate__animated', 'animate__fadeIn');
    modal.querySelector('.modal-content').classList.add('animate__animated', 'animate__zoomIn');
}
function $42b272c2c0f44bdf$export$a2dea178c28a0308(property, value) {
    return $42b272c2c0f44bdf$var$allItems.find((item)=>item && item[property] === value);
}
function $42b272c2c0f44bdf$export$4251a114f7437961(itemIds) {
    const result = {};
    itemIds.forEach((id)=>{
        result[id] = undefined;
    });
    for (const item of $42b272c2c0f44bdf$var$allItems){
        if (!item) continue;
        if (result.hasOwnProperty(item.id) && result[item.id] === undefined) result[item.id] = item;
        if (result.length == itemIds.length) break;
    }
    return result;
}
function $42b272c2c0f44bdf$export$891bd687a67340b8(property, value) {
    const allArtifacts = [
        ...$ce6dd72bc4611534$export$659d2bfa35449fc3 || [],
        ...$ce6dd72bc4611534$export$709aa55c173a48b8 || []
    ];
    return allArtifacts.find((artifact)=>artifact && artifact[property] === value);
}
function $42b272c2c0f44bdf$export$15b7d0c192d0aa5d() {
    return $42b272c2c0f44bdf$var$allItems;
}
function $42b272c2c0f44bdf$export$18c4115a8e7963b() {
    return [
        ...$ce6dd72bc4611534$export$659d2bfa35449fc3 || [],
        ...$ce6dd72bc4611534$export$709aa55c173a48b8 || []
    ];
}
function $42b272c2c0f44bdf$export$189173d473c82c30(markdown) {
    const mdH1Color = 'amber-400';
    const mdH2Color = 'cyan-300';
    const mdH3Color = 'emerald-400';
    const mdH4Color = 'gray-300';
    const lines = markdown.split('\n');
    const result = [];
    const sections = [];
    let inList = false;
    let sectionId = 0;
    for(let i = 0; i < lines.length; i++){
        let line = lines[i];
        // Headers (check longest first)
        if (line.startsWith('#### ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push(`<h4 class="text-lg font-bold text-${mdH4Color} mt-4 mb-2">${line.slice(5)}</h4>`);
        } else if (line.startsWith('### ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push(`<h3 class="text-xl font-bold text-${mdH3Color} mt-6 mb-3">${line.slice(4)}</h3>`);
        } else if (line.startsWith('## ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            const title = line.slice(3);
            const id = `section-${sectionId++}`;
            sections.push({
                id: id,
                title: title
            });
            result.push(`<h2 id="${id}" class="text-2xl font-bold text-${mdH2Color} mt-8 mb-4 scroll-mt-36">${title}</h2>`);
        } else if (line.startsWith('# ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push(`<h1 class="text-3xl font-bold text-${mdH1Color} mb-6">${line.slice(2)}</h1>`);
        } else if (line === '---') {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('<hr class="border-gray-700 my-6">');
        } else if (line.startsWith('- ')) {
            if (!inList) {
                result.push('<ul class="list-disc ml-6 space-y-1 mb-4">');
                inList = true;
            }
            let content = line.slice(2);
            content = content.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-white">$1</strong>');
            content = content.replace(/`([^`]+)`/g, '<code class="bg-gray-800 px-2 py-1 rounded text-sm">$1</code>');
            result.push(`<li class="ml-4">${content}</li>`);
        } else if (line.trim() === '') {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('');
        } else {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            let content = line;
            content = content.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-white">$1</strong>');
            content = content.replace(/`([^`]+)`/g, '<code class="bg-gray-800 px-2 py-1 rounded text-sm">$1</code>');
            result.push(`<p class="mb-3 text-gray-300">${content}</p>`);
        }
    }
    // Close any open list
    if (inList) result.push('</ul>');
    // Build navigation
    const nav = sections.map((s)=>`<button onclick="event.stopPropagation(); document.getElementById('${s.id}').scrollIntoView({behavior:'smooth',block:'start'})" class="px-3 py-1 text-sm bg-game-accent/25 hover:bg-game-accent/50 hover:text-white text-${mdH2Color} rounded transition-colors whitespace-nowrap">${s.title}</button>`).join('');
    const navBar = `<div class="sticky top-0 z-10 bg-game-bg border-b border-gray-700 p-3 mb-4 flex gap-2 flex-wrap">${nav}</div>`;
    return navBar + '<div class="p-4">' + result.join('\n') + '</div>';
}


//done
//@ts-check


//done


// Per-tier raid economics — the single shared model behind three consumers
// (ServerAuthoritySaveSecurity.md §4/§6):
//   1. Contract-completion payout (un-hired listing) — uses the *expected*
//      (average) per-raid values.
//   2. Class 3 sync rate ceiling (functions/_lib/rateBounds.js) — uses the
//      *max* per-raid values.
//   3. §6 payment amount cap (future) — max credits/raid × reward %.
//
// Pure, and shared by both the server (Pages Functions, via ../../js/modules/…)
// and the client (character.js withdraw reuses the same threshold, so the two
// can't disagree — one source of truth, no duplicated drift-prone math). A
// `*-core` module by the codebase convention (pure / simulator-safe): reads game
// data live from the generated js/constants.js and REPLICATES the small raid
// formulas from raid-core.js (calculateRaidResults / calculateRaidXP /
// calculateEnergyCost), which read gameState and so can't be imported into a
// Worker. The replication is kept honest by a drift-guard test
// (tests/server/raidEconomics.test.js) that runs the real functions and asserts
// equality — the same pattern characterValidation.js uses for the XP /
// skill-point curves. When a raid formula changes, that test fails and points
// here.
//
// Economy numbers (150, 40, 15, 3, 1.5, scaling multipliers, tier multipliers)
// are read live or replicated-with-drift-guard, so they never drift silently.
// The only hand-tuned values are the LAYOUT estimates below (path geometry and
// step mix) — these describe map shape, not economy, and are shared by every
// consumer so a single edit re-tunes them all.

const $cdca6b792cc3a32e$export$111962ea748d5541 = 1.2;
const $cdca6b792cc3a32e$export$dfb43fbf5890e474 = 0.15;
// Representative gate / hazard step durations (seconds). Road/campsite/water are
// read live from commonAreas below; gates and hazards are consistently 120 / 60
// across regions, so they're pinned here with this note rather than scanned.
const $cdca6b792cc3a32e$var$GATE_SECONDS = 120;
const $cdca6b792cc3a32e$var$HAZARD_SECONDS = 60;
// Average duration of one room (non-road) step: campsite : water : gate : hazard
// blended 1 : 1 : 2 : 2 (the loot-analysis room proportions). road/campsite/water
// read live from commonAreas; gate/hazard pinned above.
function $cdca6b792cc3a32e$var$avgRoomStepSeconds() {
    const ca = $ce6dd72bc4611534$export$11209b5126489e67 || {};
    const campsite = ca.campsite?.baseDuration ?? 120;
    const water = ca.water?.baseDuration ?? 120;
    return (campsite + water + 2 * $cdca6b792cc3a32e$var$GATE_SECONDS + 2 * $cdca6b792cc3a32e$var$HAZARD_SECONDS) / 6;
}
// Average duration of any path step — road and room blended by ROAD_FRACTION,
// the same knob that sets avg rooms per raid.
function $cdca6b792cc3a32e$var$avgStepSeconds() {
    const road = $ce6dd72bc4611534$export$11209b5126489e67?.road?.baseDuration ?? 10;
    return $cdca6b792cc3a32e$export$dfb43fbf5890e474 * road + (1 - $cdca6b792cc3a32e$export$dfb43fbf5890e474) * $cdca6b792cc3a32e$var$avgRoomStepSeconds();
}
const $cdca6b792cc3a32e$export$2eac5152829c7116 = 0.35;
const $cdca6b792cc3a32e$export$f6115a6882d79c56 = 0.8;
const $cdca6b792cc3a32e$export$b434154783011c86 = 30;
const $cdca6b792cc3a32e$export$bd84fb7c03d78e1e = 100;
// --- Replicated raid formulas (drift-guarded) ------------------------------
// Success-branch of calculateRaidResults, WITHOUT the per-player currency-bonus
// artifact and full team survival — a baseline the server can compute for
// anyone. The recipient's own Contract Beacon still applies on collection.
function $cdca6b792cc3a32e$var$raidCreditsBase(tier, rooms) {
    const survivalBonus = 50; // floor(1.0 × 50), full survival
    return tier * 150 + rooms * 40 + survivalBonus;
}
// Credit scaling choke-point (raidUtil.js applyCreditsScaling) minus the
// per-player currency-bonus artifact. The runtime copies these multipliers into
// raidUtil via setCreditsScaling at init; the SSOT is the data below, which the
// server reads directly. (progressionScaling.creditsScaling, NOT a top-level
// config.creditsScaling — that doesn't exist and would silently no-op.)
function $cdca6b792cc3a32e$var$scaleCredits(creditsBase, tier) {
    const cs = $ce6dd72bc4611534$export$9f9786ac427715c7?.creditsScaling || {};
    const global = cs.globalMultiplier ?? 1;
    const tierMult = cs.tierMultipliers?.[tier] ?? 1;
    return Math.floor(creditsBase * global * tierMult);
}
// calculateRaidXP, success branch. difficultyBonus assumes an adequate team
// (0); fullPathBonus assumes the path is completed (10). tierMult read live.
function $cdca6b792cc3a32e$var$raidXpValue(tier, rooms) {
    const baseXP = tier * 15;
    const roomBonus = rooms * 3;
    const fullPathBonus = 10;
    const tierMult = $ce6dd72bc4611534$export$9f9786ac427715c7?.raidXpTierMultipliers?.[tier] || 1;
    return Math.max(5, Math.floor((baseXP + roomBonus + fullPathBonus) * 1.5 * tierMult));
}
// Energy cost for a raid (calculateEnergyCost) at baseline (no reduction
// artifact): base per tier + 1 energy / 2 min of duration.
function $cdca6b792cc3a32e$var$energyForRaid(tier, seconds) {
    const baseCost = 5 + (tier - 1) * 5;
    return baseCost + Math.ceil(seconds / 120);
}
function $cdca6b792cc3a32e$export$b0d36f436a85648b(tier) {
    const t = $ce6dd72bc4611534$export$94e7ad7999c1ae32?.[tier];
    const rows = t?.gridRows ?? 7;
    const cols = t?.gridCols ?? 7;
    return (rows + cols - 1) * $cdca6b792cc3a32e$export$111962ea748d5541;
}
function $cdca6b792cc3a32e$export$ff894ad244f3f26e(tier) {
    const path = $cdca6b792cc3a32e$export$b0d36f436a85648b(tier);
    const avgRaidSeconds = Math.round(path * $cdca6b792cc3a32e$var$avgStepSeconds());
    const avgRooms = Math.max(1, Math.round(path * (1 - $cdca6b792cc3a32e$export$dfb43fbf5890e474)));
    return {
        avgRooms: avgRooms,
        avgRaidSeconds: avgRaidSeconds,
        expectedCredits: $cdca6b792cc3a32e$var$scaleCredits($cdca6b792cc3a32e$var$raidCreditsBase(tier, avgRooms), tier),
        expectedXp: $cdca6b792cc3a32e$var$raidXpValue(tier, avgRooms),
        energyPerRaid: $cdca6b792cc3a32e$var$energyForRaid(tier, avgRaidSeconds)
    };
}
function $cdca6b792cc3a32e$export$e81885fa95b80c17(tier) {
    const maxRooms = Math.ceil($cdca6b792cc3a32e$export$b0d36f436a85648b(tier));
    return {
        maxRooms: maxRooms,
        maxCredits: $cdca6b792cc3a32e$var$scaleCredits($cdca6b792cc3a32e$var$raidCreditsBase(tier, maxRooms), tier),
        maxXp: $cdca6b792cc3a32e$var$raidXpValue(tier, maxRooms)
    };
}
function $cdca6b792cc3a32e$export$64ee8aa79ce9e2e2() {
    let best = 0;
    for (const tier of [
        1,
        2,
        3
    ]){
        const o = $cdca6b792cc3a32e$export$ff894ad244f3f26e(tier);
        if (o.energyPerRaid > 0) best = Math.max(best, o.expectedXp / o.energyPerRaid);
    }
    return best;
}
function $cdca6b792cc3a32e$export$436943fd760cb0d6({ commandMult: commandMult, contractorFactor: contractorFactor }) {
    return $cdca6b792cc3a32e$export$b434154783011c86 * $cdca6b792cc3a32e$export$64ee8aa79ce9e2e2() * commandMult * contractorFactor;
}
function $cdca6b792cc3a32e$export$1d3299ce9f331b73({ commandMult: commandMult, contractorFactor: contractorFactor }) {
    return $cdca6b792cc3a32e$export$bd84fb7c03d78e1e * $cdca6b792cc3a32e$export$64ee8aa79ce9e2e2() * commandMult * contractorFactor;
}
function $cdca6b792cc3a32e$export$2c281a3f7943bcb5(level) {
    const tiers = $ce6dd72bc4611534$export$94e7ad7999c1ae32 || {};
    for (const tier of [
        3,
        2,
        1
    ]){
        const band = tiers[tier];
        if (!band) continue;
        const min = band.contractorMinLevel ?? 0;
        const max = band.contractorMaxLevel ?? 999;
        if (level >= min && level <= max) return tier;
    }
    return 1;
}
function $cdca6b792cc3a32e$export$8859df5e0e511018({ level: level, durationHours: durationHours, rewardPercentage: rewardPercentage }) {
    const tier = $cdca6b792cc3a32e$export$2c281a3f7943bcb5(level);
    const out = $cdca6b792cc3a32e$export$ff894ad244f3f26e(tier);
    const raidingSeconds = (durationHours || 0) * 3600 * $cdca6b792cc3a32e$export$2eac5152829c7116;
    const simulatedRaids = Math.floor(raidingSeconds / out.avgRaidSeconds);
    if (simulatedRaids < 1) // Below the minimum: the listing didn't last one average raid's worth of
    // assumed raiding time.
    return {
        qualifies: false,
        simulatedRaids: 0,
        tier: tier,
        credits: 0,
        xp: 0
    };
    const pct = rewardPercentage || 15;
    const credits = Math.floor(simulatedRaids * out.expectedCredits * pct / 100);
    const xp = Math.floor(simulatedRaids * out.expectedXp * $cdca6b792cc3a32e$export$f6115a6882d79c56);
    return {
        qualifies: true,
        simulatedRaids: simulatedRaids,
        tier: tier,
        credits: credits,
        xp: xp
    };
}
function $cdca6b792cc3a32e$export$bc8ed87c3bd68f91(level) {
    const out = $cdca6b792cc3a32e$export$ff894ad244f3f26e($cdca6b792cc3a32e$export$2c281a3f7943bcb5(level));
    return out.avgRaidSeconds / (3600 * $cdca6b792cc3a32e$export$2eac5152829c7116);
}


/**
 * Game State Core - Pure Data Structure
 *
 * Defines the core game state structure without any browser/Alpine dependencies.
 * This is the pure data structure that can be used in both browser and Node.js.
 * UI updates and Alpine reactivity are handled in gameState.js.
 */ 

const $0637c4e4ee3b431f$export$9badeb9b04b4b71c = '0.1.765';



const $f27982cef7035d22$export$d0f77b711cc9be6c = 3;
function $f27982cef7035d22$export$e178d880fd9e46ee(parsed, knownSkillIds) {
    const known = knownSkillIds instanceof Set ? knownSkillIds : new Set(knownSkillIds || []);
    const chars = [
        ...parsed?.gameState?.characters || [],
        parsed?.gameState?.character
    ].filter((c)=>c && c.skills && Object.keys(c.skills).length > 0);
    if (chars.length === 0) return false; // no skill data to strand
    return chars.some((c)=>Object.keys(c.skills).some((id)=>!known.has(id)));
}
function $f27982cef7035d22$export$f70dbb2553d659e4(faction, skills) {
    const factionSkills = $ce6dd72bc4611534$export$aeeef991191508e2[faction]?.skills;
    if (!factionSkills) return {
        ...skills || {}
    };
    const filled = {};
    for (const skillId of Object.keys(factionSkills))filled[skillId] = skills?.[skillId] ?? 0;
    return filled;
}
function $f27982cef7035d22$export$f1ea15c7da3a01d1(character) {
    if (!character) return;
    if (!character.equippedTechniqueGear) character.equippedTechniqueGear = {};
    if (!character.techniqueTabSelections) character.techniqueTabSelections = {};
    if (!character.synergyUnlocks) character.synergyUnlocks = {};
    character.skills = $f27982cef7035d22$export$f70dbb2553d659e4(character.faction, character.skills);
}
function $f27982cef7035d22$export$d79000c880c47c99() {
    return {
        marks: 0,
        tour: 1,
        legends: [],
        upgrades: {},
        charterRegions: [],
        vault: {},
        unlockedArtifacts: [],
        grandfathered: false,
        revealed: false
    };
}
function $f27982cef7035d22$export$ddc99ec3c98bbb0a() {
    return {
        writs: 0,
        founded: 0,
        eraMarks: 0,
        totalTours: 0,
        upgrades: {},
        leader: null,
        pastLeaders: [],
        operations: [],
        opsCompleted: 0,
        // The Guild Vault's two operations-side stores. Both live here rather
        // than on `command` because founding REBUILDS that branch from defaults;
        // same reason `eraMarks` and `succession` sit here.
        //
        // consignment — what this Command era has banked for the NEXT founding.
        //   Every promotion splits the outgoing character's materials:
        //   progressionScaling.vaultCarryover keeps a share for the next recruit
        //   (command.vault) and the remainder lands here instead of being
        //   destroyed. Folded into `stores` at founding, then cleared.
        //
        // stores — the founded Syndicate's dock, and the ONLY thing convoys
        //   load from. Filled at founding and spent down over the era; the
        //   current era's promotions feed `consignment`, not this, because that
        //   era is building the next Syndicate, not resupplying this one.
        //
        // Two fields, not one: founding is repeatable. Collapsing them would
        // make every promotion silently top up the live dock and delete the
        // per-era budget entirely.
        //
        // Account-level on purpose. Cargo used to draw from the ACTIVE
        // character's inventory, which meant switching character — or being
        // auto-promoted mid-plan — could invalidate a planned operation and
        // would have broken Operations automation outright.
        consignment: {},
        stores: {},
        // Market saturation: "regionId:faction" -> { level, at }. How much of
        // each region's appetite for each faction's goods is already spent, and
        // when that was last measured — demand-core decays it on read rather
        // than ticking it. Survives founding on purpose (see satiationLevel):
        // it is a fact about the world's markets, not about an era.
        demand: {},
        blackout: {
            cleared: {}
        },
        // Succession Doctrine bookkeeping for the CURRENT Command tour. Lives
        // here rather than on `command` because founding wipes that branch and
        // this is Syndicate machinery; it is reset per tour at promotion.
        succession: {
            tourRaids: 0,
            peakRate: 0,
            peakAtRaid: 0,
            paused: false,
            template: null
        },
        revealed: false
    };
}
function $f27982cef7035d22$export$6b22d50e3ddf4789(character) {
    if (character && !character.lifetime) character.lifetime = {
        t3Wins: 0,
        artifactsCrafted: 0,
        artifactsUnlocked: 0
    };
    // Backfill the field on pre-existing saves/characters
    if (character?.lifetime && character.lifetime.artifactsUnlocked == null) character.lifetime.artifactsUnlocked = 0;
    return character?.lifetime;
}
const $f27982cef7035d22$export$8e361a1ffbebf172 = {
    schemaVersion: $f27982cef7035d22$export$d0f77b711cc9be6c,
    gameVersion: (0, $0637c4e4ee3b431f$export$9badeb9b04b4b71c),
    player: {
        credits: 1000,
        energy: 100,
        maxEnergy: 100,
        lastEnergyUpdate: Date.now(),
        achievements: {},
        // Collapse Keys recovered, by id. ACCOUNT-LEVEL ON PURPOSE: the player
        // object is saved and restored whole and is never rebuilt by a
        // promotion or a founding, so the story survives every prestige without
        // an entry in any reset ledger. A wipe that erased the story would be
        // indefensible, and the cheapest way to guarantee that is to put the
        // record somewhere the wipes cannot reach.
        // See js/modules/collapseKeys-core.js.
        collapseKeys: []
    },
    character: null,
    characters: [],
    activeCharacterId: null,
    contractors: [],
    selectedFaction: null,
    currentRaid: {
        currentRaidGrid: null,
        selectedPath: [],
        selectedRegion: null,
        selectedTier: null,
        // {row, col} on the world map — WHERE in the region this raid is
        // happening. Rolled with the grid, read by the world clock (M3 S9).
        // BELONGS TO THE GRID: meaningless without `currentRaidGrid`, and
        // readers must check that rather than trust the field alone. Two
        // separate teardown paths null the grid (resetRaidCore and main.js's
        // performRaidCancel, which duplicates it inline), so a rule that has to
        // be re-stated in each of them is a rule that will be missed in the
        // third one.
        raidSite: null,
        raidInProgress: null,
        raidCompleted: false,
        completedRaidInfo: null,
        raidOwnerId: null,
        hiredContractors: [],
        reservedContractors: []
    },
    command: $f27982cef7035d22$export$d79000c880c47c99(),
    syndicate: $f27982cef7035d22$export$ddc99ec3c98bbb0a()
};
function $f27982cef7035d22$export$bda034a0354b67bb(character) {
    if (!character) return character;
    return character.id === $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId && $f27982cef7035d22$export$8e361a1ffbebf172.character ? $f27982cef7035d22$export$8e361a1ffbebf172.character : character;
}
function $f27982cef7035d22$export$e12c04bc0206ba64() {
    // Save current character's inventory, artifacts, and equipped artifacts before saving
    //console.log('Current character:', gameState.character);
    if ($f27982cef7035d22$export$8e361a1ffbebf172.character && $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId) {
        const currentCharIndex = $f27982cef7035d22$export$8e361a1ffbebf172.characters.findIndex((c)=>c.id === $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId);
        if (currentCharIndex !== -1) $f27982cef7035d22$export$8e361a1ffbebf172.characters[currentCharIndex] = {
            ...$f27982cef7035d22$export$8e361a1ffbebf172.characters[currentCharIndex],
            ...$f27982cef7035d22$export$8e361a1ffbebf172.character
        };
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).sim, 'Saved character:', $f27982cef7035d22$export$8e361a1ffbebf172.characters[currentCharIndex]);
    }
    const saveData = {
        version: '1.0',
        timestamp: Date.now(),
        gameState: {
            schemaVersion: $f27982cef7035d22$export$d0f77b711cc9be6c,
            gameVersion: (0, $0637c4e4ee3b431f$export$9badeb9b04b4b71c),
            player: $f27982cef7035d22$export$8e361a1ffbebf172.player,
            character: $f27982cef7035d22$export$8e361a1ffbebf172.character,
            characters: $f27982cef7035d22$export$8e361a1ffbebf172.characters || [],
            activeCharacterId: $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId,
            selectedFaction: $f27982cef7035d22$export$8e361a1ffbebf172.selectedFaction,
            contractors: $f27982cef7035d22$export$8e361a1ffbebf172.contractors,
            currentRaid: $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid,
            settings: $f27982cef7035d22$export$8e361a1ffbebf172.settings || {},
            command: $f27982cef7035d22$export$8e361a1ffbebf172.command || $f27982cef7035d22$export$d79000c880c47c99(),
            syndicate: $f27982cef7035d22$export$8e361a1ffbebf172.syndicate || $f27982cef7035d22$export$ddc99ec3c98bbb0a()
        }
    };
    return saveData;
}
function $f27982cef7035d22$export$5a216aa68e49a7fc(parsed) {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).sim, 'Loading data:', parsed);
    // Schema version the save was written at (absent → predates the stamp, treat
    // as 1). The field-level migrations below are additive/idempotent; gate any
    // future version-specific migration on savedVersion, then the state is
    // stamped to the current version at the end of this function.
    const savedVersion = parsed?.gameState?.schemaVersion ?? 1;
    const savedGameVersion = parsed?.gameState?.gameVersion; // which build wrote it (provenance)
    // Restore game state - handle both new player object format and legacy format
    if (parsed.gameState.player) $f27982cef7035d22$export$8e361a1ffbebf172.player = parsed.gameState.player;
    else // Migrate legacy format
    $f27982cef7035d22$export$8e361a1ffbebf172.player = {
        credits: parsed.gameState.credits !== undefined ? parsed.gameState.credits : 1000,
        energy: parsed.gameState.energy !== undefined ? parsed.gameState.energy : 100,
        maxEnergy: parsed.gameState.maxEnergy || 100,
        lastEnergyUpdate: parsed.gameState.lastEnergyUpdate || Date.now(),
        achievements: parsed.gameState.achievements || {}
    };
    // Restore currentRaid - handle both new format and legacy format
    if (parsed.gameState.currentRaid) $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid = parsed.gameState.currentRaid;
    else // Migrate legacy format
    $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid = {
        currentRaidGrid: parsed.gameState.currentRaidGrid || null,
        selectedPath: parsed.gameState.selectedPath || [],
        selectedRegion: parsed.gameState.selectedRegion || null,
        selectedTier: parsed.gameState.selectedTier || null,
        raidInProgress: parsed.gameState.raidInProgress || null,
        raidCompleted: parsed.gameState.raidCompleted || false,
        completedRaidInfo: parsed.gameState.completedRaidInfo || null,
        raidOwnerId: parsed.gameState.raidOwnerId || null,
        hiredContractors: parsed.gameState.hiredContractors || [],
        reservedContractors: parsed.gameState.reservedContractors || []
    };
    $f27982cef7035d22$export$8e361a1ffbebf172.character = parsed.gameState.character || null;
    $f27982cef7035d22$export$8e361a1ffbebf172.characters = parsed.gameState.characters || [];
    $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId = parsed.gameState.activeCharacterId || null;
    // Command layer (M2): restore or initialize. Saves from before the Command
    // layer keep unrestricted region access (grandfathered) so nobody loses
    // regions mid-campaign; region locks apply to fresh accounts and onward.
    if (parsed.gameState.command) $f27982cef7035d22$export$8e361a1ffbebf172.command = {
        ...$f27982cef7035d22$export$d79000c880c47c99(),
        ...parsed.gameState.command
    };
    else {
        $f27982cef7035d22$export$8e361a1ffbebf172.command = $f27982cef7035d22$export$d79000c880c47c99();
        if ($f27982cef7035d22$export$8e361a1ffbebf172.characters.length > 0) $f27982cef7035d22$export$8e361a1ffbebf172.command.grandfathered = true;
    }
    // Syndicate layer (M3): purely additive, so v2 saves need no migration code -
    // they simply shallow-merge onto the defaults and arrive un-revealed with
    // zero Writs, which is exactly the state a pre-Syndicate account is in.
    $f27982cef7035d22$export$8e361a1ffbebf172.syndicate = {
        ...$f27982cef7035d22$export$ddc99ec3c98bbb0a(),
        ...parsed.gameState.syndicate || {}
    };
    // Lifetime counters (feed the Command Marks formula) - additive migration
    $f27982cef7035d22$export$8e361a1ffbebf172.characters.forEach($f27982cef7035d22$export$6b22d50e3ddf4789);
    $f27982cef7035d22$export$6b22d50e3ddf4789($f27982cef7035d22$export$8e361a1ffbebf172.character);
    // Command-era per-character fields (skill gear / synergies): default them so
    // a save from mid-overhaul loads cleanly.
    $f27982cef7035d22$export$8e361a1ffbebf172.characters.forEach($f27982cef7035d22$export$f1ea15c7da3a01d1);
    $f27982cef7035d22$export$f1ea15c7da3a01d1($f27982cef7035d22$export$8e361a1ffbebf172.character);
    // Ensure HP properties are synchronized for character
    if ($f27982cef7035d22$export$8e361a1ffbebf172.character) {
        // If currentHp is missing, use hp as fallback (for legacy saves)
        if ($f27982cef7035d22$export$8e361a1ffbebf172.character.currentHp === undefined && $f27982cef7035d22$export$8e361a1ffbebf172.character.hp !== undefined) $f27982cef7035d22$export$8e361a1ffbebf172.character.currentHp = $f27982cef7035d22$export$8e361a1ffbebf172.character.hp;
        // Ensure character has a name (for legacy saves)
        if (!$f27982cef7035d22$export$8e361a1ffbebf172.character.name) $f27982cef7035d22$export$8e361a1ffbebf172.character.name = 'You';
        // If currentHp is still missing, default to maxHp
        if ($f27982cef7035d22$export$8e361a1ffbebf172.character.currentHp === undefined) $f27982cef7035d22$export$8e361a1ffbebf172.character.currentHp = $f27982cef7035d22$export$8e361a1ffbebf172.character.maxHp || 100;
        // Add isAlive and injuries properties if missing
        if ($f27982cef7035d22$export$8e361a1ffbebf172.character.isAlive === undefined) $f27982cef7035d22$export$8e361a1ffbebf172.character.isAlive = true;
        if (!$f27982cef7035d22$export$8e361a1ffbebf172.character.injuries) $f27982cef7035d22$export$8e361a1ffbebf172.character.injuries = [];
    }
    $f27982cef7035d22$export$8e361a1ffbebf172.selectedFaction = parsed.gameState.selectedFaction || null;
    // Migrate legacy top-level skillPoints/skills to character objects
    if (parsed.gameState.skillPoints !== undefined || parsed.gameState.skills) {
        console.log('Migrating legacy skillPoints/skills to character objects');
        const legacySkillPoints = parsed.gameState.skillPoints !== undefined ? parsed.gameState.skillPoints : 15;
        const legacySkills = parsed.gameState.skills || {};
        $f27982cef7035d22$export$8e361a1ffbebf172.characters.forEach((character)=>{
            if (character.skillPoints === undefined) character.skillPoints = legacySkillPoints;
            if (!character.skills) character.skills = {
                ...legacySkills
            };
        });
    }
    // Handle inventory migration and loading
    const hasLegacyInventory = parsed.gameState.inventory || parsed.gameState.artifacts || parsed.gameState.equippedArtifacts;
    if (hasLegacyInventory && $f27982cef7035d22$export$8e361a1ffbebf172.characters.length > 0) {
        // Legacy save file - migrate shared inventory to character-specific inventories
        console.log('Migrating shared inventory to character-specific inventories');
        const legacyInventory = parsed.gameState.inventory || {};
        const legacyArtifacts = parsed.gameState.artifacts || [];
        const legacyEquippedArtifacts = parsed.gameState.equippedArtifacts || {
            skillSlot: null,
            utilitySlot: null
        };
        $f27982cef7035d22$export$8e361a1ffbebf172.characters.forEach((character)=>{
            if (!character.inventory) {
                // Give each character a copy of the shared inventory
                character.inventory = {
                    ...legacyInventory
                };
                character.artifacts = [
                    ...legacyArtifacts
                ];
                character.equippedArtifacts = {
                    ...legacyEquippedArtifacts
                };
            }
        });
    // Legacy data already migrated to character objects above
    } else if ($f27982cef7035d22$export$8e361a1ffbebf172.characters.length > 0) // Modern save - ensure all characters have inventory/artifacts initialized
    $f27982cef7035d22$export$8e361a1ffbebf172.characters.forEach((character)=>{
        if (!character.inventory) character.inventory = {};
        if (!character.artifacts) character.artifacts = [];
        if (!character.equippedArtifacts) character.equippedArtifacts = {
            skillSlot: null,
            utilitySlot: null
        };
    });
    // Deduplicate contractors and remove player contractors (they don't belong in the pool)
    const contractorMap = new Map();
    (parsed.gameState.contractors || []).filter((c)=>c.id < 0) // Only keep NPC contractors (negative IDs)
    .forEach((c)=>contractorMap.set(c.id, c));
    $f27982cef7035d22$export$8e361a1ffbebf172.contractors = Array.from(contractorMap.values());
    // Migrate old contractor data: convert cost to rewardPercentage and add avatars
    if ($f27982cef7035d22$export$8e361a1ffbebf172.contractors && $f27982cef7035d22$export$8e361a1ffbebf172.contractors.length > 0) $f27982cef7035d22$export$8e361a1ffbebf172.contractors.forEach((contractor)=>{
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            // Convert old fixed cost to percentage (10-25% range)
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost; // Remove old property
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $42b272c2c0f44bdf$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    // Also migrate reserved contractors
    if ($f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.reservedContractors && $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.reservedContractors.length > 0) $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.reservedContractors.forEach((contractor)=>{
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost;
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $42b272c2c0f44bdf$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    // Also migrate hired contractors
    if ($f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.hiredContractors && $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.hiredContractors.length > 0) $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.hiredContractors.forEach((contractor)=>{
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost;
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $42b272c2c0f44bdf$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    $f27982cef7035d22$export$8e361a1ffbebf172.settings = parsed.gameState.settings || {};
    // NOTE: `unlockedRegions` was persisted here until 2026-07-28 but gated
    // nothing — region availability is DERIVED (command-core.js
    // availableRegionsForCharacter: faction starting pair + charterRegions).
    // It is no longer read or written; old saves simply drop the field on their
    // next save, so no migration is needed.
    $f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts = parsed.gameState.equippedArtifacts || {
        skillSlot: null,
        utilitySlot: null
    };
    // Veteran's Stipend was replaced by Field Conditioning (skill points ->
    // max HP). Carry the owned rank across so a player who bought it keeps the
    // slot they paid marks for; command.upgrades is account-permanent and
    // marks are not refundable, so dropping the id would silently confiscate it.
    const upgrades = $f27982cef7035d22$export$8e361a1ffbebf172.command?.upgrades;
    if (upgrades && upgrades['veterans-stipend'] != null) {
        if (upgrades['field-conditioning'] == null) upgrades['field-conditioning'] = upgrades['veterans-stipend'];
        delete upgrades['veterans-stipend'];
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Migrated veterans-stipend rank to field-conditioning');
    }
    // Migrate old generalSlot to utilitySlot in equipped artifacts
    if ($f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.generalSlot && !$f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.utilitySlot) {
        $f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.utilitySlot = $f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        delete $f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        console.log('Migrated artifact from generalSlot to utilitySlot');
    } else if ($f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.generalSlot) {
        // Clean up any remaining generalSlot references
        delete $f27982cef7035d22$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        console.log('Cleaned up legacy generalSlot reference');
    }
    // Migrate slot property in artifact objects from generalSlot to utilitySlot
    let artifactsMigrated = false;
    if ($f27982cef7035d22$export$8e361a1ffbebf172.artifacts && $f27982cef7035d22$export$8e361a1ffbebf172.artifacts.length > 0) $f27982cef7035d22$export$8e361a1ffbebf172.artifacts.forEach((artifact)=>{
        if (artifact.slot === 'generalSlot') {
            artifact.slot = 'utilitySlot';
            artifactsMigrated = true;
        }
    });
    // Initialize hired contractors array if it doesn't exist (but don't reset reservedContractors!)
    if (!$f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.hiredContractors) $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.hiredContractors = [];
    // Restore active character based on activeCharacterId
    if ($f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId && $f27982cef7035d22$export$8e361a1ffbebf172.characters.length > 0) {
        const activeChar = $f27982cef7035d22$export$8e361a1ffbebf172.characters.find((c)=>c.id === $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId);
        if (activeChar) // Set the active character
        $f27982cef7035d22$export$8e361a1ffbebf172.character = {
            ...activeChar
        };
        else {
            // activeCharacterId doesn't match any character, reset to first available
            const availableChars = $f27982cef7035d22$export$8e361a1ffbebf172.characters.filter((c)=>!c.isMarketplace);
            if (availableChars.length > 0) {
                $f27982cef7035d22$export$8e361a1ffbebf172.character = {
                    ...availableChars[0]
                };
                $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId = availableChars[0].id;
            } else {
                // No characters available, reset character state
                $f27982cef7035d22$export$8e361a1ffbebf172.character = null;
                $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId = null;
            }
        }
    } else if ($f27982cef7035d22$export$8e361a1ffbebf172.character) // Legacy character loading - display if character exists
    $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId = $f27982cef7035d22$export$8e361a1ffbebf172.character.id;
    // Migrations applied - stamp the live state to the current schema + build.
    if (savedVersion !== $f27982cef7035d22$export$d0f77b711cc9be6c) console.log(`Migrated save from schema v${savedVersion} (build ${savedGameVersion || 'unknown'}) to v${$f27982cef7035d22$export$d0f77b711cc9be6c}`);
    $f27982cef7035d22$export$8e361a1ffbebf172.schemaVersion = $f27982cef7035d22$export$d0f77b711cc9be6c;
    $f27982cef7035d22$export$8e361a1ffbebf172.gameVersion = (0, $0637c4e4ee3b431f$export$9badeb9b04b4b71c);
}
function $f27982cef7035d22$export$77866226ea57ca79() {
    if (!$f27982cef7035d22$export$8e361a1ffbebf172.character) return false;
    // If no raid in progress, anyone can access
    if (!$f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.raidOwnerId) return true;
    // If there's an active raid, only the owner can access
    return $f27982cef7035d22$export$8e361a1ffbebf172.currentRaid.raidOwnerId === $f27982cef7035d22$export$8e361a1ffbebf172.activeCharacterId;
}


//done
//@ts-check


//done
//@ts-check

//done
// Toast notification system with Animate.css animations.
//
// At most MAX_VISIBLE toasts are on screen, laid out side by side in one row
// (see .toast-container in styles.css). Toasts used to stack without limit, and
// gameplay (raids especially) emits them in bursts, so the column could cover a
// large part of the screen — badly so on tablets. A short row costs far less
// vertical space than a stack. Extra messages queue.
//
// A queue only helps if it keeps up: at the full solo dwell a burst would trail
// gameplay by half a minute. So while messages are waiting the dwell drops to
// BACKLOG_DWELL_MS, and toasts already showing are cut short when something
// queues behind them. The queue is capped, keeping the NEWEST messages — during
// a burst the latest state is what matters, and the raid log keeps the full
// record.
const $0c8e0782d8c2833e$export$312c15c298b6a304 = 2; // toasts on screen at once (row width in styles.css)
const $0c8e0782d8c2833e$export$4eb92f07034723c1 = 5000; // nothing waiting: read at leisure
const $0c8e0782d8c2833e$export$a90a0dcb02b5caf1 = 3000; // something waiting: keep the queue moving
const $0c8e0782d8c2833e$export$9ac10b278ef6fbc2 = 1000; // Animate.css default duration
const $0c8e0782d8c2833e$export$354f03de0bec5c37 = 7;
const $0c8e0782d8c2833e$export$7999238bb9a1816 = 2; // see below — why this is capped at all
const $0c8e0782d8c2833e$var$queue = [];
const $0c8e0782d8c2833e$var$visible = []; // entries on screen: { toast, enterAnimation, exitAnimation, timer, shownAt, dwell }
const $0c8e0782d8c2833e$var$sticky = []; // entries awaiting a click: { toast, exitAnimation }
function $0c8e0782d8c2833e$export$c7def531c087da85(message, type = 'info', options = {}) {
    // No-op in Node.js environment (for simulation/testing)
    if (typeof document === 'undefined') return null;
    if (options.sticky) return $0c8e0782d8c2833e$var$showSticky(message, type);
    $0c8e0782d8c2833e$var$queue.push({
        message: message,
        type: type
    });
    if ($0c8e0782d8c2833e$var$queue.length > $0c8e0782d8c2833e$export$354f03de0bec5c37) $0c8e0782d8c2833e$var$queue.splice(0, $0c8e0782d8c2833e$var$queue.length - $0c8e0782d8c2833e$export$354f03de0bec5c37); // drop oldest, keep newest
    $0c8e0782d8c2833e$var$fillSlots();
    $0c8e0782d8c2833e$var$cutShortIfWaiting();
    return null;
}
/**
 * A toast that waits for a click instead of a timer.
 *
 * Deliberately OUTSIDE the MAX_VISIBLE budget and the queue. Sticky toasts have
 * no timer, so letting them hold one of the two transient slots would let two
 * unread messages deadlock the entire notification system - and because the
 * queue keeps only the newest MAX_QUEUE, everything behind them would be
 * discarded silently. A message the player never dismisses must not be able to
 * suppress every message after it.
 *
 * They are still capped. An uncapped pile of undismissable toasts would bury
 * the screen, which is its own way of going unnoticed; past MAX_STICKY the
 * oldest is retired, having had the most time on screen.
 */ function $0c8e0782d8c2833e$var$showSticky(message, type) {
    const toastContainer = document.getElementById('toast-container');
    if (!toastContainer) return null;
    const toast = document.createElement('div');
    toast.className = `toast ${type} toast-sticky animate__animated ${$0c8e0782d8c2833e$export$7a919e96f3f110b4(type)}`;
    // Announced rather than just drawn: this is the category of message a player
    // is most likely to be looking away from.
    toast.setAttribute('role', 'alert');
    const content = document.createElement('span');
    content.textContent = message;
    toast.appendChild(content);
    const close = document.createElement('button');
    close.className = 'toast-dismiss';
    close.setAttribute('aria-label', 'Dismiss notification');
    close.textContent = "\u2715";
    toast.appendChild(close);
    const entry = {
        toast: toast,
        exitAnimation: $0c8e0782d8c2833e$export$17696d6e8bf46719(type)
    };
    // The whole toast is the hit target, not just the ✕ - the button is the
    // affordance that says "this one waits for you", not the only way out.
    toast.addEventListener('click', ()=>$0c8e0782d8c2833e$var$dismissSticky(entry));
    toastContainer.appendChild(toast);
    $0c8e0782d8c2833e$var$sticky.push(entry);
    while($0c8e0782d8c2833e$var$sticky.length > $0c8e0782d8c2833e$export$7999238bb9a1816)$0c8e0782d8c2833e$var$dismissSticky($0c8e0782d8c2833e$var$sticky[0]);
    // Both no-op once the toast is gone (clicked, or retired past MAX_STICKY),
    // so a caller ticking a countdown into `update` never has to track whether
    // the player got there first.
    return {
        dismiss: ()=>$0c8e0782d8c2833e$var$dismissSticky(entry),
        update: (text)=>{
            if ($0c8e0782d8c2833e$var$sticky.includes(entry)) content.textContent = text;
        }
    };
}
function $0c8e0782d8c2833e$var$dismissSticky(entry) {
    const index = $0c8e0782d8c2833e$var$sticky.indexOf(entry);
    if (index === -1) return; // already dismissed
    $0c8e0782d8c2833e$var$sticky.splice(index, 1);
    entry.toast.classList.add(entry.exitAnimation);
    setTimeout(()=>entry.toast.remove(), $0c8e0782d8c2833e$export$9ac10b278ef6fbc2);
}
// Show queued messages until the row is full.
function $0c8e0782d8c2833e$var$fillSlots() {
    while($0c8e0782d8c2833e$var$visible.length < $0c8e0782d8c2833e$export$312c15c298b6a304 && $0c8e0782d8c2833e$var$queue.length > 0){
        if (!$0c8e0782d8c2833e$var$showNext()) return; // no container — nothing more we can do
    }
}
// Something is queued behind the visible toasts — shorten their remaining time
// so the backlog drains promptly instead of waiting out full solo dwells.
function $0c8e0782d8c2833e$var$cutShortIfWaiting() {
    if ($0c8e0782d8c2833e$var$queue.length === 0) return;
    for (const entry of $0c8e0782d8c2833e$var$visible){
        if (entry.dwell === $0c8e0782d8c2833e$export$a90a0dcb02b5caf1) continue; // already hurried
        const remaining = Math.max(0, $0c8e0782d8c2833e$export$a90a0dcb02b5caf1 - (Date.now() - entry.shownAt));
        clearTimeout(entry.timer);
        entry.dwell = $0c8e0782d8c2833e$export$a90a0dcb02b5caf1;
        entry.timer = setTimeout(()=>$0c8e0782d8c2833e$var$dismiss(entry), remaining);
    }
}
// Renders the next queued message. Returns false if there's nowhere to put it.
function $0c8e0782d8c2833e$var$showNext() {
    const next = $0c8e0782d8c2833e$var$queue.shift();
    if (!next) return false;
    const toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
        $0c8e0782d8c2833e$var$queue.length = 0;
        return false;
    }
    // Choose entrance animation based on notification type
    const enterAnimation = $0c8e0782d8c2833e$export$7a919e96f3f110b4(next.type);
    const exitAnimation = $0c8e0782d8c2833e$export$17696d6e8bf46719(next.type);
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast ${next.type} animate__animated ${enterAnimation}`;
    toast.textContent = next.message;
    // Add to container
    toastContainer.appendChild(toast);
    const dwell = $0c8e0782d8c2833e$var$queue.length > 0 ? $0c8e0782d8c2833e$export$a90a0dcb02b5caf1 : $0c8e0782d8c2833e$export$4eb92f07034723c1;
    const entry = {
        toast: toast,
        enterAnimation: enterAnimation,
        exitAnimation: exitAnimation,
        shownAt: Date.now(),
        dwell: dwell,
        timer: null
    };
    entry.timer = setTimeout(()=>$0c8e0782d8c2833e$var$dismiss(entry), dwell);
    $0c8e0782d8c2833e$var$visible.push(entry);
    return true;
}
// Play the exit animation, remove the node, then backfill the freed slot. The
// entry keeps its slot until the animation finishes — it's still on screen.
function $0c8e0782d8c2833e$var$dismiss(entry) {
    if (!$0c8e0782d8c2833e$var$visible.includes(entry)) return; // already dismissed
    entry.toast.classList.remove(entry.enterAnimation);
    entry.toast.classList.add(entry.exitAnimation);
    setTimeout(()=>{
        if (entry.toast.parentNode) entry.toast.parentNode.removeChild(entry.toast);
        const index = $0c8e0782d8c2833e$var$visible.indexOf(entry);
        if (index !== -1) $0c8e0782d8c2833e$var$visible.splice(index, 1);
        $0c8e0782d8c2833e$var$fillSlots();
    }, $0c8e0782d8c2833e$export$9ac10b278ef6fbc2);
}
function $0c8e0782d8c2833e$export$7a919e96f3f110b4(type) {
    switch(type){
        case 'success':
            return 'animate__bounceInRight';
        case 'error':
            return 'animate__shake';
        case 'warning':
            return 'animate__slideInDown';
        case 'info':
        default:
            return 'animate__slideInRight';
    }
}
function $0c8e0782d8c2833e$export$17696d6e8bf46719(type) {
    switch(type){
        case 'success':
            return 'animate__bounceOutRight';
        case 'error':
            return 'animate__slideOutRight';
        case 'warning':
            return 'animate__slideOutUp';
        case 'info':
        default:
            return 'animate__slideOutRight';
    }
}




/**
 * Command Core - Pure logic for the Command prestige layer (M2)
 *
 * No browser/Alpine dependencies: consumed by the UI wrapper (command.js)
 * AND the headless simulator. Player-facing verb is promote/promotion -
 * "retire" never appears in copy.
 *
 * Key concepts:
 * - Command Marks: prestige currency from promoting characters (formula
 *   coefficients live in progressionScaling.commandMarks - balance SSOT).
 * - Legends: immutable snapshots of promoted characters (gallery).
 * - Tours: account-global counter, +1 per promotion (any faction).
 * - Region availability is DERIVED: faction starting pair + charter unlocks
 *   (+ everything, for grandfathered pre-Command saves).
 */ 






/**
 * Character Core Logic - Pure Functions
 *
 * Pure game logic for character progression that has no browser dependencies.
 * Can be used in both browser (character.js) and Node.js (simulator) contexts.
 *
 * Extracted from character.js to separate pure logic from UI updates.
 */ 



/**
 * Blackout Contracts — L3 optional challenge raids (M3 S6).
 *
 * Two halves that must not be confused:
 *
 *   ARMED   — `gameState.currentRaid.blackoutContract`, the contract this raid
 *             is running under. Read for MODIFIERS, and only for the raid in
 *             progress.
 *   CLEARED — `gameState.syndicate.blackout.cleared`, the account's permanent
 *             record. Read for PERKS, forever, whatever raid is running.
 *
 * The perks are permanent and each contract pays once, so this is a finite
 * hand-authored progression rather than a grind. That is what lets the perks be
 * flat and generous, and it is why `getBlackoutPerk` sums over cleared contracts
 * rather than anything time-bound.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/layers/3-syndicate/design.md §7.
 */ 

/**
 * Syndicate Core - Pure logic for the Syndicate prestige layer (M3)
 *
 * No browser/Alpine dependencies: consumed by the UI wrapper AND the headless
 * simulator, same contract as command-core.js.
 *
 * Where Command prestiges a CHARACTER into marks, Syndicate prestiges an ERA
 * into Writs. Founding wipes the whole Command layer - marks, Legends,
 * upgrades, charters, vault, characters, credits - in exchange for Writs and
 * the charters they buy, which are the things that make each rebuilt era
 * faster than the last.
 *
 * See docs/layers/3-syndicate/design.md. The wipe/persist ledger in §2 is the
 * contract; tests/game/syndicate.test.js asserts BOTH columns, because a
 * prestige reset is equally broken if it keeps too much or too little.
 */ 



const $46d374413fb0707a$export$de76d136ab75207a = 15;
const $46d374413fb0707a$export$c927ee7382a453ae = 8;
function $46d374413fb0707a$export$ab98ff7829062ba4() {
    const relief = $46d374413fb0707a$export$d9ea4b2d96397ab9('institutional-memory', 0);
    return Math.max($46d374413fb0707a$export$c927ee7382a453ae, $46d374413fb0707a$export$de76d136ab75207a - relief);
}
const $46d374413fb0707a$export$9455015a451127fb = 1.0;
function $46d374413fb0707a$export$cdfa564b532bb699() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate) (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate = (0, $f27982cef7035d22$export$ddc99ec3c98bbb0a)();
    // Backfill keys added after a save was written. The branch is created
    // wholesale above, so a save from before `stores` existed has the branch but
    // not the field — and promotion writes to it without a guard.
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.consignment) (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.consignment = {};
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.stores) (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.stores = {};
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.demand) (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.demand = {};
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate;
}
function $46d374413fb0707a$export$fc09ffc64d9013e3(eraMarks) {
    const marks = Number(eraMarks);
    if (!Number.isFinite(marks) || marks <= 0) return 0;
    return Math.floor($46d374413fb0707a$export$9455015a451127fb * Math.sqrt(marks));
}
function $46d374413fb0707a$export$6955e231f1466c44(charterId) {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.upgrades?.[charterId] || 0;
}
function $46d374413fb0707a$export$d9ea4b2d96397ab9(charterId, fallback = 0) {
    const rank = $46d374413fb0707a$export$6955e231f1466c44(charterId);
    if (rank <= 0) return fallback;
    const def = $ce6dd72bc4611534$export$1a64c4c64ba19abd?.[charterId];
    if (!def) return fallback;
    return def.effectValues?.[rank - 1] ?? fallback;
}
function $46d374413fb0707a$export$f0d4871acc619a3() {
    const syndicate = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate;
    if (!syndicate) return false;
    // Latches on, like Command's: once the player has seen the layer it stays
    // available between eras, which is exactly when charters get bought.
    if (syndicate.revealed) return true;
    if (syndicate.founded > 0 || ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0) >= $46d374413fb0707a$export$de76d136ab75207a) {
        syndicate.revealed = true;
        return true;
    }
    return false;
}
function $46d374413fb0707a$export$5799eac7aba24ab2() {
    const command = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command;
    if (!command) return {
        ok: false,
        reason: 'no-command-layer'
    };
    const legends = command.legends?.length || 0;
    const need = $46d374413fb0707a$export$ab98ff7829062ba4();
    if (legends < need) return {
        ok: false,
        reason: 'insufficient-legends',
        have: legends,
        need: need
    };
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (character?.isMarketplace || character?.marketplaceData) return {
        ok: false,
        reason: 'listed-on-marketplace'
    };
    // Any owned raid state blocks it, same rule promotion and deletion apply.
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidOwnerId === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted)) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    // In-flight operations reference era-Legends, who are about to stop existing.
    if (((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations?.length || 0) > 0) return {
        ok: false,
        reason: 'operations-in-flight'
    };
    return {
        ok: true
    };
}
function $46d374413fb0707a$export$9ab0fc0c1d4f0dcd(legends = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends || []) {
    if (!legends.length) return null;
    const best = legends.reduce((a, b)=>(b.marksEarned || 0) > (a.marksEarned || 0) ? b : a);
    return {
        name: best.name,
        faction: best.faction,
        avatarSeed: best.avatarSeed,
        level: best.level,
        marksEarned: best.marksEarned || 0,
        promotedRole: best.promotedRole,
        electedAt: Date.now()
    };
}
function $46d374413fb0707a$export$1861729e67332c20() {
    const eligible = $46d374413fb0707a$export$5799eac7aba24ab2();
    if (!eligible.ok) return {
        success: false,
        reason: eligible.reason
    };
    const syndicate = $46d374413fb0707a$export$cdfa564b532bb699();
    const command = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command;
    // 1. Leader is elected from the era about to end.
    const leader = $46d374413fb0707a$export$9ab0fc0c1d4f0dcd(command.legends);
    if (syndicate.leader) syndicate.pastLeaders.push(syndicate.leader);
    // 2. Unbanked marks on the active character count toward the era. Same
    //    figure the promote path banks, so founding and promote-then-found are
    //    worth the same - which is the whole point of decision 8.
    let unbanked = 0;
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        unbanked = (0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character)?.total || 0;
        syndicate.eraMarks += unbanked;
    }
    // 3. Writs price the completed era.
    const eraMarks = syndicate.eraMarks;
    const writs = $46d374413fb0707a$export$fc09ffc64d9013e3(eraMarks);
    // 4. The wipe. Blueprints survive for the same reason promotion carries
    //    them at 100%: they are the account-long artifact arc, and the 27-design
    //    unlock record (command.unlockedArtifacts) is explicitly account-level.
    const consignment = syndicate.consignment || (syndicate.consignment = {});
    //    Both the vault's contents and the active character's kit are routed by
    //    the SAME disburseInventory() promotion uses — founding and promotion
    //    are the same event to the economy (a character stops existing and their
    //    kit has to land somewhere), so they must not disagree about where any
    //    item type goes.
    //
    //    vaultShare 0 for both: there is no successor to inherit a share. That
    //    also means the vault's own materials consign rather than vanish —
    //    without it, promote-then-found loses the rank share while founding
    //    directly keeps it, exactly the footgun decision 8 exists to prevent,
    //    just on the material side.
    const survivingBlueprints = {};
    (0, $bde36de43872f734$export$da98dc4e7bdea782)(command.vault, {
        vaultShare: 0,
        vault: survivingBlueprints,
        consignment: consignment
    });
    //    The active character's kit, on the same principle as the unbanked marks
    //    folded in at step 2: founding without promoting first must not silently
    //    cost you the character's stock.
    //
    //    Their relics and consumables are NOT cashed out. Founding resets credits
    //    to the levy floor a few lines below, so crediting them here would be a
    //    number the player watches appear and then vanish in the same click. The
    //    wipe ledger is explicit that the era's wealth does not survive.
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) (0, $bde36de43872f734$export$da98dc4e7bdea782)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory, {
        vaultShare: 0,
        vault: survivingBlueprints,
        consignment: consignment
    });
    //    The consignment is DELIVERED: everything this era banked becomes the
    //    new Syndicate's dock, and the consignment starts empty for the era
    //    about to begin. This is the only thing that ever fills `stores`, which
    //    is what makes a dock a per-era budget rather than a running total.
    Object.entries(consignment).forEach(([itemId, qty])=>{
        if (qty > 0) syndicate.stores[itemId] = (syndicate.stores[itemId] || 0) + qty;
    });
    syndicate.consignment = {};
    syndicate.totalTours += Math.max(0, (command.tour || 1) - 1);
    syndicate.writs += writs;
    syndicate.eraMarks = 0;
    syndicate.founded += 1;
    syndicate.leader = leader;
    syndicate.revealed = true;
    const preserved = {
        unlockedArtifacts: command.unlockedArtifacts || [],
        revealed: command.revealed,
        grandfathered: command.grandfathered
    };
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).command = {
        ...(0, $f27982cef7035d22$export$d79000c880c47c99)(),
        ...preserved,
        vault: survivingBlueprints
    };
    // 5. Charters that reach back into the fresh era.
    //
    // GRANTED, NOT RETAINED, and deliberately so: reaching L3 is what automates
    // L1 permanently, so the charter hands over Auto-Raid Protocol whether or
    // not Command ever bought it. No check on prior ownership, because there is
    // nothing to check — a player who never bought it is exactly who this is
    // for. The Command upgrade remains worth its 300 marks as EARLY access
    // (~day 16 if you bank for it, against a first founding at ~day 25), not as
    // a prerequisite. See the note on `standing-orders` in syndicateUpgrades.js;
    // the charter's old wording said "retained", which made this read as a bug.
    if ($46d374413fb0707a$export$6955e231f1466c44('standing-orders') > 0) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).command.upgrades['auto-raid-protocol'] = 1;
        // Auto-Fabricator comes with it, and must: a founding wipes Command
        // upgrades, so granting only the raid half would hand every post-
        // founding era a character that raids hands-off and never crafts —
        // which is the ~29%-of-marks hole this pair exists to close. Automation
        // that survives a founding has to survive it whole.
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).command.upgrades['auto-fabricator'] = 1;
    }
    const endowment = $46d374413fb0707a$export$d9ea4b2d96397ab9('founders-endowment', 0);
    if (endowment > 0) (0, $f27982cef7035d22$export$8e361a1ffbebf172).command.marks = endowment;
    // Characters and credits reset; the crafting multiplier follows tour=1 on
    // its own now that it is derived rather than compounded, so there is
    // nothing to restore here.
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits = $ce6dd72bc4611534$export$9f9786ac427715c7.promotionCreditLevy.floor;
    return {
        success: true,
        writs: writs,
        eraMarks: eraMarks,
        unbanked: unbanked,
        leader: leader
    };
}
const $46d374413fb0707a$export$65d88b3701cdf574 = {
    minTourRaids: 8,
    peakPatienceRaids: 6,
    maxTourRaids: 60
};
function $46d374413fb0707a$export$5d3c2c0349b1c9a4() {
    const syndicate = $46d374413fb0707a$export$cdfa564b532bb699();
    if (!syndicate.succession) syndicate.succession = (0, $f27982cef7035d22$export$ddc99ec3c98bbb0a)().succession;
    return syndicate.succession;
}
function $46d374413fb0707a$export$40d6ac4f92fd7c1c() {
    return $46d374413fb0707a$export$6955e231f1466c44('succession-doctrine') > 0 && !$46d374413fb0707a$export$5d3c2c0349b1c9a4().paused;
}
function $46d374413fb0707a$export$95d51325f081320b() {
    const s = $46d374413fb0707a$export$5d3c2c0349b1c9a4();
    s.tourRaids = 0;
    s.peakRate = 0;
    s.peakAtRaid = 0;
}
function $46d374413fb0707a$export$ed3f2307dc7cb2a() {
    let cheapest = 0;
    for (const id of Object.keys($ce6dd72bc4611534$export$617b3a0bcd7cead7 || {})){
        const cost = (0, $bde36de43872f734$export$21d6f53ea6843ff6)(id);
        if (cost == null) continue; // maxed
        if ((0, $bde36de43872f734$export$21736c92e8c4e21c)($ce6dd72bc4611534$export$617b3a0bcd7cead7[id]).length) continue; // not yet reachable
        if (cheapest === 0 || cost < cheapest) cheapest = cost;
    }
    return cheapest;
}
function $46d374413fb0707a$export$12d96118114aebf3() {
    const s = $46d374413fb0707a$export$5d3c2c0349b1c9a4();
    s.tourRaids += 1;
    const marks = $46d374413fb0707a$var$currentCharacterMarks();
    const avgRate = s.tourRaids > 0 ? marks / s.tourRaids : 0;
    // Peak tracking only starts after the minimum tour, so an early one-craft
    // spike cannot anchor a rate the rest of the tour can never beat.
    if (s.tourRaids >= $46d374413fb0707a$export$65d88b3701cdf574.minTourRaids && avgRate > s.peakRate) {
        s.peakRate = avgRate;
        s.peakAtRaid = s.tourRaids;
    }
    return $46d374413fb0707a$export$8f29b06b79596501();
}
function $46d374413fb0707a$var$currentCharacterMarks() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return 0;
    return (0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character)?.total || 0;
}
function $46d374413fb0707a$export$8f29b06b79596501() {
    const s = $46d374413fb0707a$export$5d3c2c0349b1c9a4();
    const marks = $46d374413fb0707a$var$currentCharacterMarks();
    // Marks BANK across promotions, so the question is not "did this tour earn
    // enough" but "will promoting now let me buy the thing I am saving for".
    const marksIfPromotedNow = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.marks || 0) + marks;
    const floor = $46d374413fb0707a$export$ed3f2307dc7cb2a();
    const avgRate = s.tourRaids > 0 ? marks / s.tourRaids : 0;
    const raidsSincePeak = s.peakAtRaid > 0 ? s.tourRaids - s.peakAtRaid : 0;
    const peakPassed = s.peakAtRaid > 0 && raidsSincePeak >= $46d374413fb0707a$export$65d88b3701cdf574.peakPatienceRaids && marksIfPromotedNow >= floor;
    const safetyValve = s.tourRaids >= $46d374413fb0707a$export$65d88b3701cdf574.maxTourRaids;
    return {
        tourRaids: s.tourRaids,
        marks: marks,
        avgRate: avgRate,
        peakRate: s.peakRate,
        raidsSincePeak: raidsSincePeak,
        floor: floor,
        marksIfPromotedNow: marksIfPromotedNow,
        due: peakPassed || safetyValve,
        reason: !(peakPassed || safetyValve) ? null : safetyValve ? 'max-tour' : 'marks-rate-peak'
    };
}
function $46d374413fb0707a$export$a91ccccac4a2b08() {
    const s = $46d374413fb0707a$export$5d3c2c0349b1c9a4();
    if (s.template?.faction) return s.template;
    const outgoing = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!outgoing) return null;
    return {
        faction: outgoing.faction,
        // Skill PLAN, not levels: the recruit starts at rank 1 and spends its
        // own points, so what carries is the ordering the player favoured.
        skillPlan: Object.entries(outgoing.skills || {}).sort((a, b)=>(b[1] || 0) - (a[1] || 0)).map(([skillId])=>skillId),
        derived: true
    };
}
function $46d374413fb0707a$export$34d3a5a3f7bd399f(template) {
    $46d374413fb0707a$export$5d3c2c0349b1c9a4().template = template;
}
function $46d374413fb0707a$export$43bf52c97b14116a(paused) {
    $46d374413fb0707a$export$5d3c2c0349b1c9a4().paused = !!paused;
    return $46d374413fb0707a$export$5d3c2c0349b1c9a4().paused;
}
function $46d374413fb0707a$export$db5a865159d9ae65(charterId) {
    const def = $ce6dd72bc4611534$export$1a64c4c64ba19abd?.[charterId];
    if (!def) return {
        success: false,
        reason: 'unknown-charter'
    };
    const syndicate = $46d374413fb0707a$export$cdfa564b532bb699();
    const rank = $46d374413fb0707a$export$6955e231f1466c44(charterId);
    if (rank >= def.costs.length) return {
        success: false,
        reason: 'max-rank'
    };
    const missing = (0, $bde36de43872f734$export$21736c92e8c4e21c)(def);
    if (missing.length > 0) return {
        success: false,
        reason: 'missing-requirement',
        requires: missing
    };
    const cost = def.costs[rank];
    if (syndicate.writs < cost) return {
        success: false,
        reason: 'insufficient-writs'
    };
    syndicate.writs -= cost;
    syndicate.upgrades[charterId] = rank + 1;
    return {
        success: true,
        rank: rank + 1,
        cost: cost
    };
}


function $45c49e7f6d2032d6$export$6030630ca4e35487() {
    return (0, $46d374413fb0707a$export$6955e231f1466c44)('blackout-sanction') > 0;
}
function $45c49e7f6d2032d6$export$913dd38406a903a1(contractId) {
    return $ce6dd72bc4611534$export$5099ca2cdc0f385a?.[contractId] || null;
}
function $45c49e7f6d2032d6$export$6f07b662ae575a0e() {
    return Object.keys($ce6dd72bc4611534$export$5099ca2cdc0f385a || {});
}
function $45c49e7f6d2032d6$export$e51189576207fce1(contractId) {
    return !!(0, $46d374413fb0707a$export$cdfa564b532bb699)().blackout?.cleared?.[contractId];
}
function $45c49e7f6d2032d6$export$f099249c2cd16830(contractId, tier) {
    if (!$45c49e7f6d2032d6$export$6030630ca4e35487()) return 'no-sanction';
    const contract = $45c49e7f6d2032d6$export$913dd38406a903a1(contractId);
    if (!contract) return 'unknown-contract';
    if ($45c49e7f6d2032d6$export$e51189576207fce1(contractId)) return 'already-cleared';
    if ((tier || 0) < (contract.minTier || 1)) return 'tier-too-low';
    return null;
}
function $45c49e7f6d2032d6$export$cb7eb378a07c9158(tier) {
    if (!$45c49e7f6d2032d6$export$6030630ca4e35487()) return [];
    return $45c49e7f6d2032d6$export$6f07b662ae575a0e().filter((id)=>!$45c49e7f6d2032d6$export$f099249c2cd16830(id, tier)).map((id)=>({
            id: id,
            ...$45c49e7f6d2032d6$export$913dd38406a903a1(id)
        }));
}
function $45c49e7f6d2032d6$export$f266a4caac7fb67d() {
    const id = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.blackoutContract;
    if (!id) return null;
    const contract = $45c49e7f6d2032d6$export$913dd38406a903a1(id);
    return contract ? {
        id: id,
        ...contract
    } : null;
}
function $45c49e7f6d2032d6$export$d1bd52becfd6c270(contractId, tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.selectedTier) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid) return {
        ok: false,
        reason: 'no-raid-state'
    };
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    if (!contractId) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.blackoutContract = null;
        return {
            ok: true,
            contract: null
        };
    }
    const reason = $45c49e7f6d2032d6$export$f099249c2cd16830(contractId, tier);
    if (reason) return {
        ok: false,
        reason: reason
    };
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.blackoutContract = contractId;
    return {
        ok: true,
        contract: {
            id: contractId,
            ...$45c49e7f6d2032d6$export$913dd38406a903a1(contractId)
        }
    };
}
function $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1(key, fallback) {
    const contract = $45c49e7f6d2032d6$export$f266a4caac7fb67d();
    if (!contract) return fallback;
    const value = contract.modifiers?.[key];
    return value === undefined ? fallback : value;
}
function $45c49e7f6d2032d6$export$f0d942e2e6132b96({ success: success }) {
    const contract = $45c49e7f6d2032d6$export$f266a4caac7fb67d();
    if (!contract) return null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.blackoutContract = null;
    if (!success) return null;
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    if (!syndicate.blackout) syndicate.blackout = {
        cleared: {}
    };
    if (!syndicate.blackout.cleared) syndicate.blackout.cleared = {};
    // First clear only: re-running a cleared contract must not double the perk.
    if (syndicate.blackout.cleared[contract.id]) return null;
    syndicate.blackout.cleared[contract.id] = true;
    return {
        contractId: contract.id,
        perk: contract.perk
    };
}
function $45c49e7f6d2032d6$export$84f52d60145287(effectKey, fallback = 0) {
    const cleared = (0, $46d374413fb0707a$export$cdfa564b532bb699)().blackout?.cleared || {};
    let total = 0;
    let found = false;
    for (const contractId of Object.keys(cleared)){
        if (!cleared[contractId]) continue;
        const perk = $45c49e7f6d2032d6$export$913dd38406a903a1(contractId)?.perk;
        if (perk?.key === effectKey) {
            total += perk.value;
            found = true;
        }
    }
    return found ? total : fallback;
}
function $45c49e7f6d2032d6$export$2d7a0990b0051919() {
    const cleared = (0, $46d374413fb0707a$export$cdfa564b532bb699)().blackout?.cleared || {};
    return $45c49e7f6d2032d6$export$6f07b662ae575a0e().filter((id)=>cleared[id]).map((id)=>({
            id: id,
            ...$45c49e7f6d2032d6$export$913dd38406a903a1(id)
        }));
}




const $1b3f8df6e579f420$var$energyRegenRate = 120000; // 2 minutes in milliseconds
function $1b3f8df6e579f420$export$ae545994cbde97ee(currentLevel) {
    // Exponential scaling for long-term progression: Level 1->2 = 1000 XP
    // Target: Level 8 takes 1-2 months of consistent play (~150-600 raids)
    return Math.floor(1000 * Math.pow(1.5, currentLevel - 1));
}
function $1b3f8df6e579f420$export$d48d36379ada8c46(level) {
    return 10 + Math.floor(level / 3) * 5;
}
function $1b3f8df6e579f420$export$266289d5372bee03(level) {
    let maxHp = 100;
    for(let k = 2; k <= level; k++)maxHp += $1b3f8df6e579f420$export$d48d36379ada8c46(k);
    return maxHp;
}
function $1b3f8df6e579f420$export$a811471a09bc04c3(currentSkillLevel) {
    return Math.max(1, Math.floor(currentSkillLevel / 3) + 1);
}
function $1b3f8df6e579f420$export$4207390906be8d62(level) {
    const cfg = $ce6dd72bc4611534$export$9f9786ac427715c7.skillPointsPerLevel;
    let total = 3; // starting skill points at creation (level 1)
    for(let l = 2; l <= level; l++)total += cfg.base + Math.floor(l / cfg.levelDivisor) * cfg.increment;
    return total;
}
function $1b3f8df6e579f420$export$57757d3a3e441a94(character) {
    const xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(character.level);
    character.xp -= xpToNext;
    character.level++;
    // Increase max HP (shared curve - see hpGainForLevel)
    const hpIncrease = $1b3f8df6e579f420$export$d48d36379ada8c46(character.level);
    character.maxHp += hpIncrease;
    character.currentHp = Math.min(character.maxHp, character.currentHp + hpIncrease); // Also heal on level up
    // Award skill points using configurable progression scaling
    const cfg = $ce6dd72bc4611534$export$9f9786ac427715c7.skillPointsPerLevel;
    const skillPointsGained = cfg.base + Math.floor(character.level / cfg.levelDivisor) * cfg.increment;
    character.skillPoints += skillPointsGained;
    // Synergy layer reveal: one-time announcement when the character crosses
    // the unlock level (per-skill purchases live on the skill cards)
    if (character.level === $1b3f8df6e579f420$export$d09b0dfa38532c40().minLevel) // Sticky: fires mid-raid (when the player is watching rooms, not the toast
    // row), unlocks a mechanic once, and names an action to take elsewhere.
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u26A1 Synergies discovered! Teammates' gear can now upgrade your events \u2014 unlock per skill from the character page.", 'success', {
        sticky: true
    });
}
function $1b3f8df6e579f420$export$8ae8375981be11e0(character, targetLevel) {
    while(character.level < targetLevel){
        character.xp += $1b3f8df6e579f420$export$ae545994cbde97ee(character.level);
        $1b3f8df6e579f420$export$57757d3a3e441a94(character);
    }
}
function $1b3f8df6e579f420$export$88ec20478ef6bd29(character, xpAmount) {
    if (!character) return;
    // Legend Bonus (Command layer): +XP per enshrined Legend when owned
    character.xp += Math.round(xpAmount * (0, $bde36de43872f734$export$7647bd5455c447e6)());
    // Check for level up
    let xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(character.level);
    while(character.xp >= xpToNext){
        $1b3f8df6e579f420$export$57757d3a3e441a94(character);
        xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(character.level);
    }
}
function $1b3f8df6e579f420$export$6cdee87198244170(contractor) {
    const xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(contractor.level || 1);
    contractor.xp -= xpToNext;
    contractor.level = (contractor.level || 1) + 1;
    // Increase max HP (same shared curve as characters - see hpGainForLevel)
    const hpIncrease = $1b3f8df6e579f420$export$d48d36379ada8c46(contractor.level);
    contractor.maxHp = (contractor.maxHp || 100) + hpIncrease;
    contractor.currentHp = (contractor.currentHp || contractor.maxHp) + hpIncrease; // Also heal on level up
}
function $1b3f8df6e579f420$export$31efd075830c7467(contractor, xpAmount) {
    if (!contractor) return;
    contractor.xp = (contractor.xp || 0) + xpAmount;
    // Check for level up
    let xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(contractor.level || 1);
    while(contractor.xp >= xpToNext){
        $1b3f8df6e579f420$export$6cdee87198244170(contractor);
        xpToNext = $1b3f8df6e579f420$export$ae545994cbde97ee(contractor.level);
    }
}
function $1b3f8df6e579f420$export$28bf58d3c9312b43(currentLevel) {
    // Progressive cost: Level 1 = 50, Level 2 = 100, Level 3 = 200, etc.
    // Formula: 50 * (1.5^level), rounded to nearest 25
    const baseCost = 50;
    const scalingFactor = 1.5;
    const rawCost = baseCost * Math.pow(scalingFactor, currentLevel);
    return Math.round(rawCost / 25) * 25; // Round to nearest 25 credits
}
function $1b3f8df6e579f420$export$7d0067675be54b12(currentLevel) {
    return Math.max(1, Math.floor(currentLevel / 3) + 1);
}
function $1b3f8df6e579f420$export$909e62d4478cec23(skillKey) {
    // Check if current character is on marketplace
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot upgrade skills with a character that is contracted out on the marketplace', 'error');
        return;
    }
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints <= 0) return;
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey]) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey] = 0;
    // Calculate costs for next level (increases with current level)
    const currentLevel = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey];
    const skillPointCost = $1b3f8df6e579f420$export$7d0067675be54b12(currentLevel);
    const currencyCost = $1b3f8df6e579f420$export$28bf58d3c9312b43(currentLevel);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints < skillPointCost) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{26A0}\u{FE0F} Need ${skillPointCost} skill points to upgrade this skill`, 'warning');
        return;
    }
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits < currencyCost) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{26A0}\u{FE0F} Need ${currencyCost} credits to upgrade this skill`, 'warning');
        return;
    }
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey]++;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints -= skillPointCost;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits -= currencyCost;
    // Update character skills if character exists
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey] = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey];
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{2728} Skill upgraded! ${(0, $42b272c2c0f44bdf$export$182937d2e68a339)(skillKey)} is now level ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey]} (-${currencyCost} credits)`, 'success');
}
function $1b3f8df6e579f420$export$d09b0dfa38532c40() {
    return $ce6dd72bc4611534$export$9f9786ac427715c7?.synergyUnlocks || {
        minLevel: 4,
        cost: 2
    };
}
function $1b3f8df6e579f420$export$aaee02d18e8a1c01(character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    return (character?.level || 1) >= $1b3f8df6e579f420$export$d09b0dfa38532c40().minLevel;
}
function $1b3f8df6e579f420$export$7d626adf944498ee(skillId, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    return !!character?.synergyUnlocks?.[skillId];
}
function $1b3f8df6e579f420$export$a2d6ef296e5ae7a1(skillKey, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const cfg = $1b3f8df6e579f420$export$d09b0dfa38532c40();
    if (!character) return {
        success: false,
        reason: 'no-character'
    };
    if (!$1b3f8df6e579f420$export$aaee02d18e8a1c01(character)) return {
        success: false,
        reason: 'not-revealed'
    };
    if (character.skills?.[skillKey] === undefined) return {
        success: false,
        reason: 'unknown-skill'
    };
    if ($1b3f8df6e579f420$export$7d626adf944498ee(skillKey, character)) return {
        success: false,
        reason: 'already-unlocked'
    };
    if ((character.skillPoints || 0) < cfg.cost) return {
        success: false,
        reason: 'insufficient-points'
    };
    character.skillPoints -= cfg.cost;
    if (!character.synergyUnlocks) character.synergyUnlocks = {};
    character.synergyUnlocks[skillKey] = true;
    return {
        success: true,
        cost: cfg.cost
    };
}
function $1b3f8df6e579f420$export$401b195eeeb2d82c(effectId, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    return character?.equippedArtifacts?.utilitySlot?.effects?.[effectId] || 0;
}
function $1b3f8df6e579f420$export$a5a257639bbcfa93(skillId, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const artifact = character?.equippedArtifacts?.skillSlot;
    if (!artifact || !skillId || artifact.skill !== skillId) return 0;
    return artifact.effects?.['skill-success-bonus'] || 0;
}
function $1b3f8df6e579f420$export$ee2b8c06abb0026f() {
    // Command's Forward Depot and L3's Overclocked Grid stack ADDITIVELY into
    // one bonus rather than multiplying: two independent 50% boosts should be
    // "twice as fast", not 2.25x, and additive keeps the ceiling legible.
    const bonus = (0, $45c49e7f6d2032d6$export$84f52d60145287)('energy-regen', 0) + (0, $bde36de43872f734$export$59fca837549bbada)('forward-depot', 0);
    return $1b3f8df6e579f420$var$energyRegenRate / (1 + bonus);
}
function $1b3f8df6e579f420$export$422aab3227f4499c() {
    return 3600000 / $1b3f8df6e579f420$export$ee2b8c06abb0026f();
}
function $1b3f8df6e579f420$export$e244cc0abc4b66d7(timePassedMs) {
    // Regenerate 1 energy every 2 minutes (120,000 ms)
    // This balances with raid energy cost: raids cost ~1 energy per 10 seconds
    // So a 2-minute raid costs ~12 energy, which takes ~24 minutes to recover (roughly 2x raid time)
    return Math.floor(timePassedMs / $1b3f8df6e579f420$export$ee2b8c06abb0026f());
}
function $1b3f8df6e579f420$export$e4e85317acdbc3c2() {
    const currentTime = Date.now();
    const timeDiffMs = currentTime - (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.lastEnergyUpdate;
    const energyToRestore = $1b3f8df6e579f420$export$e244cc0abc4b66d7(timeDiffMs);
    if (energyToRestore > 0) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy < (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy) {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, "Restoring energy:", energyToRestore, "at 1 every", $1b3f8df6e579f420$var$energyRegenRate / 1000, "s Time since last update (ms):", timeDiffMs);
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy = Math.min((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy, (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy + energyToRestore);
        }
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.lastEnergyUpdate = currentTime;
    }
}
function $1b3f8df6e579f420$export$6b2f9302a94ab080() {
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy >= (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy) return null;
    const currentTime = Date.now();
    const timeSinceLastRegen = currentTime - (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.lastEnergyUpdate;
    const rate = $1b3f8df6e579f420$export$ee2b8c06abb0026f();
    const timeToNextRegen = rate - timeSinceLastRegen % rate;
    return currentTime + timeToNextRegen;
}
function $1b3f8df6e579f420$export$11d38807a029df6f(member, timePassedMs) {
    // No recovery during active raid
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) return false;
    let hasChanges = false;
    if (member.injured && member.recoveryTime) {
        if (Date.now() >= member.recoveryTime) {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, "Recovering team member:", member.name);
            member.injured = false;
            member.currentHp = member.maxHp || 100;
            delete member.recoveryTime;
            hasChanges = true;
        }
    } else if (member.currentHp < (member.maxHp || 100)) {
        const healAmount = Math.round(2 * timePassedMs / 1000); // 2 per second
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, "Restoring health for", member.name, ":", healAmount, "at 2 every second. Time since last update (ms):", timePassedMs);
        member.currentHp = Math.min(member.maxHp, member.currentHp + healAmount);
        hasChanges = true;
    }
    return hasChanges;
}



let $00c60928d2fcd8b8$export$92731a7af45eafdd = {};
function $00c60928d2fcd8b8$export$16a0347071379537(multipliers = {}) {
    $00c60928d2fcd8b8$export$92731a7af45eafdd = {
        ...multipliers
    };
}
function $00c60928d2fcd8b8$export$7d19902b620007ca(itemId) {
    return $00c60928d2fcd8b8$export$92731a7af45eafdd[itemId] !== undefined ? $00c60928d2fcd8b8$export$92731a7af45eafdd[itemId] : 1.0;
}
function $00c60928d2fcd8b8$export$2cbb40695b9e7336(itemIds, boost = null) {
    if (!itemIds || itemIds.length === 0) return null;
    // Optional selection boost: items passing boost.predicate get their
    // weight multiplied (e.g. the Relic Resonance Tuner favoring relics
    // within a mixed pool without inflating the rest of it)
    const weightOf = boost ? (id)=>$00c60928d2fcd8b8$export$7d19902b620007ca(id) * (boost.predicate(id) ? boost.multiplier : 1) : $00c60928d2fcd8b8$export$7d19902b620007ca;
    const totalWeight = itemIds.reduce((sum, id)=>sum + weightOf(id), 0);
    if (totalWeight <= 0) return itemIds[Math.floor(Math.random() * itemIds.length)];
    let roll = Math.random() * totalWeight;
    for (const id of itemIds){
        roll -= weightOf(id);
        if (roll <= 0) return id;
    }
    return itemIds[itemIds.length - 1];
}
let $00c60928d2fcd8b8$export$517ceadb17e419d2 = {
    globalMultiplier: 1.0,
    tierMultipliers: {
        1: 1.0,
        2: 1.0,
        3: 1.0
    }
};
function $00c60928d2fcd8b8$export$b1b6e81d46587814(config = {}) {
    $00c60928d2fcd8b8$export$517ceadb17e419d2 = {
        globalMultiplier: config.globalMultiplier !== undefined ? config.globalMultiplier : 1.0,
        tierMultipliers: config.tierMultipliers || {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    };
}
function $00c60928d2fcd8b8$export$c5c0ad2417da3e22(tier = 1) {
    const tierMultiplier = $00c60928d2fcd8b8$export$517ceadb17e419d2.tierMultipliers[tier] || 1.0;
    return $00c60928d2fcd8b8$export$517ceadb17e419d2.globalMultiplier * tierMultiplier;
}
function $00c60928d2fcd8b8$export$78a769585121af92(creditsEarned, tier = 1) {
    const multiplier = $00c60928d2fcd8b8$export$c5c0ad2417da3e22(tier);
    const currencyBonus = 1 + (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('currency-bonus', (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) / 100;
    return Math.floor(creditsEarned * multiplier * currencyBonus);
}
let $00c60928d2fcd8b8$export$147d39d5ef3f8e42 = {
    globalMultiplier: 1.0,
    rarityMultipliers: {
        common: 1.0,
        uncommon: 1.0,
        rare: 1.0,
        epic: 1.0,
        legendary: 1.0,
        unique: 1.0,
        artifact: 1.0
    }
};
function $00c60928d2fcd8b8$export$b2554e3c8ffeec59(config = {}) {
    $00c60928d2fcd8b8$export$147d39d5ef3f8e42 = {
        globalMultiplier: config.globalMultiplier !== undefined ? config.globalMultiplier : 1.0,
        rarityMultipliers: config.rarityMultipliers || {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    };
}
function $00c60928d2fcd8b8$export$98e32b77d8baebd(rarity = 'common') {
    const rarityMultiplier = $00c60928d2fcd8b8$export$147d39d5ef3f8e42.rarityMultipliers[rarity] || 1.0;
    return $00c60928d2fcd8b8$export$147d39d5ef3f8e42.globalMultiplier * rarityMultiplier;
}
function $00c60928d2fcd8b8$export$574cc08100f7d092(cost, rarity = 'common') {
    const multiplier = $00c60928d2fcd8b8$export$98e32b77d8baebd(rarity);
    return Math.floor(cost * multiplier);
}
let $00c60928d2fcd8b8$export$45cd5f886ea338fc = {
    escalationFactor: 1.0
};
function $00c60928d2fcd8b8$export$12f04c67a6a6e4dd(config = {}) {
    $00c60928d2fcd8b8$export$45cd5f886ea338fc = {
        escalationFactor: config.escalationFactor !== undefined ? config.escalationFactor : 1.0
    };
}
function $00c60928d2fcd8b8$export$41c2b3834e95fdda(player, now = Date.now()) {
    const today = new Date(now).toDateString();
    if (!player?.energyPurchases || player.energyPurchases.day !== today) return 0;
    return player.energyPurchases.count || 0;
}
function $00c60928d2fcd8b8$export$1214c02c27df458d(itemData, player, now = Date.now()) {
    const base = itemData?.credits || 0;
    if (!itemData?.restoresEnergy) return base;
    const factor = $00c60928d2fcd8b8$export$45cd5f886ea338fc.escalationFactor || 1.0;
    return Math.round(base * Math.pow(factor, $00c60928d2fcd8b8$export$41c2b3834e95fdda(player, now)));
}
function $00c60928d2fcd8b8$export$cfff9bc32ab6cb78(player, now = Date.now()) {
    const today = new Date(now).toDateString();
    if (!player.energyPurchases || player.energyPurchases.day !== today) player.energyPurchases = {
        day: today,
        count: 0
    };
    player.energyPurchases.count += 1;
}
function $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5(rarity, tier, roomType = "gate") {
    const rarityConfig = $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity];
    if (!rarityConfig) return 0;
    const dropConfig = rarityConfig.dropChance;
    // Check minimum tier requirement
    if (dropConfig?.minTier && tier < dropConfig.minTier) return 0;
    // Handle room-type specific chances (for rare tier)
    if (dropConfig?.gate && dropConfig?.hazard) {
        const cfg = roomType === "gate" ? dropConfig.gate : dropConfig.hazard;
        return Math.min(cfg.base + (tier - 1) * cfg.perTier, cfg.max);
    }
    // Handle simple base + perTier + max formula
    if (dropConfig?.base !== undefined) {
        const chance = dropConfig.base + (tier - 1) * (dropConfig.perTier || 0);
        return dropConfig.max ? Math.min(chance, dropConfig.max) : chance;
    }
    return 0;
}
function $00c60928d2fcd8b8$export$540736c4d7813ac(rarity, tier, roomType = "gate") {
    const rarityConfig = $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity];
    if (!rarityConfig) return 1;
    const quantityConfig = rarityConfig.quantity;
    const minMaxQuantity = {
        min: 1,
        max: 1
    };
    // Simple fixed quantity (epic, unique)
    if (typeof quantityConfig === "number") minMaxQuantity.min = minMaxQuantity.max = quantityConfig;
    // Room-type specific quantity
    if (quantityConfig?.gate && quantityConfig?.hazard) {
        const cfg = roomType === "gate" ? quantityConfig.gate : quantityConfig.hazard;
        minMaxQuantity.min = cfg.base ? cfg.base : 1;
        if (cfg.perTier) minMaxQuantity.min = Math.min(cfg.base + (tier - 1) * cfg.perTier, cfg.max);
        minMaxQuantity.max = minMaxQuantity.min;
        if (cfg.max && cfg.max > minMaxQuantity.min) minMaxQuantity.max = cfg.max;
        else if (cfg.random && cfg.random > 0) minMaxQuantity.max = minMaxQuantity.min + cfg.random;
    }
    return minMaxQuantity;
}
function $00c60928d2fcd8b8$export$d2188f6548dbea9f(lootGained, itemType, amount) {
    lootGained[itemType] = (lootGained[itemType] || 0) + amount;
}
function $00c60928d2fcd8b8$export$f4cc72695e6df27a(message, type, stepIndex = null) {
    // If stepIndex is provided, add to step-specific logs
    if (stepIndex !== null && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs = {};
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex]) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex] = [];
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex].push({
            message: message,
            type: type,
            timestamp: Date.now()
        });
    }
}
function $00c60928d2fcd8b8$export$fd59807889add359(message, type, options = {}) {
    // Add to raid log (step-specific if stepIndex provided)
    $00c60928d2fcd8b8$export$f4cc72695e6df27a(message, type, options.stepIndex);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, message);
    // Add notification unless explicitly disabled
    if (options.notify !== false) {
        // Map log types to notification types for better UX
        const notificationTypeMap = {
            failure: "error",
            info: "info",
            success: "success",
            bonus: "bonus"
        };
        const notificationType = notificationTypeMap[type] || type;
        // Use custom notification message if provided, otherwise use log message
        const notificationMessage = options.notificationMessage || message;
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(notificationMessage, notificationType);
    }
}
function $00c60928d2fcd8b8$export$ad0c244e6b90d977(room) {
    for (const [factionKey, faction] of Object.entries($ce6dd72bc4611534$export$aeeef991191508e2)){
        if (faction.skills[room.primary]) return factionKey;
    }
    return null;
}
function $00c60928d2fcd8b8$export$10ac30a050ae6642(room, rarity = "common") {
    const roomFaction = $00c60928d2fcd8b8$export$ad0c244e6b90d977(room);
    if (roomFaction) // Get materials that match faction and rarity
    return Object.values((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)()).filter((item)=>item.type === "material" && item.rarity === rarity && item.faction === roomFaction).map((item)=>item.id);
    else // Mixed faction room - return all materials of this rarity
    return $00c60928d2fcd8b8$export$b1ad0808e6cb0531("material", rarity);
}
function $00c60928d2fcd8b8$export$61bdab8a63df855c(room) {
    const roomFaction = $00c60928d2fcd8b8$export$ad0c244e6b90d977(room);
    const roomSkills = new Set([
        room.primary,
        ...room.support || []
    ]);
    const artifactById = new Map((0, $42b272c2c0f44bdf$export$18c4115a8e7963b)().map((a)=>[
            a.id,
            a
        ]));
    return Object.values((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)()).filter((item)=>{
        if (item.type !== "blueprint") return false;
        if (!item.faction) return false;
        if (item.faction !== roomFaction && item.faction !== "neutral") return false;
        const artifact = artifactById.get(item.id.replace(/-blueprint$/, ""));
        if (artifact?.skill) return roomSkills.has(artifact.skill);
        return true;
    }).map((item)=>item.id);
}
function $00c60928d2fcd8b8$export$b1ad0808e6cb0531(itemType = "material", rarity = null) {
    const items = Object.values((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)()).filter((item)=>{
        if (item.type !== itemType) return false;
        if (rarity && item.rarity !== rarity) return false;
        return true;
    });
    return items.map((item)=>item.id);
}
function $00c60928d2fcd8b8$export$65aa634013c8a9db(tier) {
    const rarityMap = {
        1: "common",
        2: "uncommon",
        3: "rare"
    };
    return rarityMap[tier] || "common";
}



const $bde36de43872f734$export$d94c2b2ebc33805a = {
    dominion: [
        'cradle-expanse',
        'shard-cities'
    ],
    wilders: [
        'verdant-reclamation',
        'sunken-bastions'
    ],
    veil: [
        'hollow-core',
        'sunken-bastions'
    ]
};
function $bde36de43872f734$export$b97b2e8df296cd3b() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).command) (0, $f27982cef7035d22$export$8e361a1ffbebf172).command = (0, $f27982cef7035d22$export$d79000c880c47c99)();
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).command;
}
function $bde36de43872f734$export$12c456cbb12a94a8(upgradeId) {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.upgrades?.[upgradeId] || 0;
}
function $bde36de43872f734$export$c95b8ce76efadccf() {
    return $ce6dd72bc4611534$export$9f9786ac427715c7?.allowDuplicateCrafts === true;
}
function $bde36de43872f734$export$2886ceaa061d802b(character, itemId) {
    if ((character?.inventory?.[itemId] || 0) > 0) return true;
    return Object.values(character?.equippedTechniqueGear || {}).some((g)=>g && (g.id === itemId || g === itemId));
}
function $bde36de43872f734$export$770281d4afda41b1(character, artifactId) {
    return (character?.artifacts || []).some((a)=>a && a.id === artifactId);
}
function $bde36de43872f734$export$59fca837549bbada(upgradeId, fallback = 0) {
    const rank = $bde36de43872f734$export$12c456cbb12a94a8(upgradeId);
    if (rank <= 0) return fallback;
    const def = $ce6dd72bc4611534$export$617b3a0bcd7cead7?.[upgradeId];
    return def?.effectValues?.[rank - 1] ?? fallback;
}
function $bde36de43872f734$export$f22d59777b51e96b(character) {
    if (!character) return 0;
    const owned = new Set();
    Object.entries(character.inventory || {}).forEach(([itemId, qty])=>{
        if (qty > 0 && (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId)?.type === 'techGear') owned.add(itemId);
    });
    Object.values(character.equippedTechniqueGear || {}).forEach((gearId)=>{
        if (gearId && (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', gearId)?.type === 'techGear') owned.add(gearId);
    });
    return owned.size;
}
function $bde36de43872f734$export$ffae5de2f7ddd94d(character) {
    // Direct read, no fallback: an inline default here would silently compute a
    // DIFFERENT marks curve if constants.js were stale, and the old fallback had
    // itself drifted years out of date while reading like documentation.
    // configValidation.js proves this exists at boot.
    const c = $ce6dd72bc4611534$export$9f9786ac427715c7.commandMarks;
    const techGear = $bde36de43872f734$export$f22d59777b51e96b(character);
    const artifactsUnlocked = character?.lifetime?.artifactsUnlocked || 0;
    const artifacts = character?.lifetime?.artifactsCrafted || 0;
    const t3Wins = character?.lifetime?.t3Wins || 0;
    const level = character?.level || 1;
    // All banked at promotion. Artifacts split into the one-time-per-design
    // UNLOCK milestone (the account-level achievement, credited to whichever
    // character consumed the blueprint) and the repeatable per-CRAFT value.
    const breakdown = {
        techGear: {
            count: techGear,
            marks: techGear * c.perTechGear
        },
        artifactUnlocks: {
            count: artifactsUnlocked,
            marks: artifactsUnlocked * (c.perArtifactUnlock ?? 0)
        },
        artifacts: {
            count: artifacts,
            marks: artifacts * (c.perArtifactCraft ?? 0)
        },
        t3Wins: {
            count: t3Wins,
            marks: Math.floor(t3Wins / c.t3WinsDivisor)
        },
        level: {
            count: level,
            marks: level * c.perLevel
        }
    };
    const total = Object.values(breakdown).reduce((sum, b)=>sum + b.marks, 0);
    return {
        total: total,
        breakdown: breakdown
    };
}
function $bde36de43872f734$export$2ab3ae91631fe8e5(artifactId) {
    return ($bde36de43872f734$export$b97b2e8df296cd3b().unlockedArtifacts || []).includes(artifactId);
}
function $bde36de43872f734$export$5361c32fc9d089b2(artifactId) {
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    if (!command.unlockedArtifacts) command.unlockedArtifacts = [];
    if (command.unlockedArtifacts.includes(artifactId)) return {
        success: false,
        reason: 'already-unlocked'
    };
    const blueprintId = `${artifactId}-blueprint`;
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character || (character.inventory?.[blueprintId] || 0) < 1) return {
        success: false,
        reason: 'no-blueprint'
    };
    character.inventory[blueprintId] -= 1;
    if (character.inventory[blueprintId] <= 0) delete character.inventory[blueprintId];
    command.unlockedArtifacts.push(artifactId);
    (0, $f27982cef7035d22$export$6b22d50e3ddf4789)(character);
    character.lifetime.artifactsUnlocked = (character.lifetime.artifactsUnlocked || 0) + 1;
    const marks = $ce6dd72bc4611534$export$9f9786ac427715c7?.commandMarks?.perArtifactUnlock || 0;
    return {
        success: true,
        marks: marks
    };
}
function $bde36de43872f734$export$25d1e5af45c35a33() {
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    if (command.revealed) return true;
    const threshold = $ce6dd72bc4611534$export$9f9786ac427715c7.commandMarks.unlockThreshold;
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && $bde36de43872f734$export$ffae5de2f7ddd94d((0, $f27982cef7035d22$export$8e361a1ffbebf172).character).total >= threshold) command.revealed = true;
    return command.revealed;
}
function $bde36de43872f734$export$99736e0126d21b50(character) {
    const allRegions = Object.keys($ce6dd72bc4611534$export$4fbdcec70fce9d73);
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    if (command.grandfathered) return allRegions;
    const starts = $bde36de43872f734$export$d94c2b2ebc33805a[character?.faction];
    if (!starts) return allRegions;
    const available = new Set([
        ...starts,
        ...command.charterRegions || []
    ]);
    return allRegions.filter((r)=>available.has(r));
}
function $bde36de43872f734$export$5a56eaf8a61d7ab9(character) {
    const skills = character?.skills || {};
    const bestSkill = Object.keys(skills).sort((a, b)=>(skills[b] || 0) - (skills[a] || 0))[0];
    const flavor = $ce6dd72bc4611534$export$9be8953559278e7?.[bestSkill];
    const promoted = flavor?.promotedRoles;
    if (!promoted?.length) return {
        role: character?.title || null,
        quote: null
    };
    let idx = flavor.roles?.indexOf(character?.title) ?? -1;
    if (idx < 0 || !promoted[idx]) {
        // Deterministic fallback: hash the name so preview and Legend agree
        const name = character?.name || '';
        let h = 0;
        for(let i = 0; i < name.length; i++)h = h * 31 + name.charCodeAt(i) | 0;
        idx = Math.abs(h) % promoted.length;
    }
    return {
        role: promoted[idx],
        quote: flavor.promotedQuotes?.[idx] || null
    };
}
function $bde36de43872f734$export$be02e18412b74462(character) {
    return $bde36de43872f734$export$5a56eaf8a61d7ab9(character).role;
}
function $bde36de43872f734$export$d7db1ce90eca9a05() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character) return {
        ok: false,
        reason: 'no-active-character'
    };
    if (character.isMarketplace || character.marketplaceData) return {
        ok: false,
        reason: 'listed-on-marketplace'
    };
    // Any owned raid state blocks promotion (planning grid, active run, or an
    // unclaimed completed raid) - same rule character deletion applies
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidOwnerId === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted)) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    return {
        ok: true
    };
}
function $bde36de43872f734$export$da98dc4e7bdea782(inventory, { vaultShare: vaultShare = 0, vault: vault = null, consignment: consignment = null, consignRate: consignRate = null } = {}) {
    let credits = 0;
    let liquidated = 0;
    let consumed = 0;
    if (consignRate == null) consignRate = $ce6dd72bc4611534$export$9f9786ac427715c7.consignmentRate;
    Object.entries(inventory || {}).forEach(([itemId, qty])=>{
        if (qty <= 0) return;
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
        switch(item?.type){
            case 'blueprint':
            case 'storyRelic':
                if (vault) vault[itemId] = (vault[itemId] || 0) + qty;
                break;
            case 'material':
                {
                    const kept = Math.floor(qty * vaultShare);
                    if (kept > 0 && vault) vault[itemId] = (vault[itemId] || 0) + kept;
                    // What the successor does not inherit is NOT all convoy cargo.
                    // Only `consignmentRate` of it reaches the Syndicate; the rest
                    // is spent living — the settlement eats, repairs and rebuilds
                    // out of the same stock. See progressionScaling.consignmentRate
                    // for why the accounting had to stop being closed.
                    const remainder = qty - kept;
                    const shipped = Math.floor(remainder * consignRate);
                    if (shipped > 0 && consignment) consignment[itemId] = (consignment[itemId] || 0) + shipped;
                    consumed += remainder - shipped;
                    break;
                }
            case 'relic':
            case 'consumable':
                if (item.credits > 0) {
                    credits += item.credits * qty;
                    liquidated += 1;
                }
                break;
            default:
                break;
        }
    });
    return {
        credits: credits,
        liquidated: liquidated,
        consumed: consumed
    };
}
function $bde36de43872f734$export$f0bd6e9010bb1600() {
    const eligible = $bde36de43872f734$export$d7db1ce90eca9a05();
    if (!eligible.ok) return {
        success: false,
        reason: eligible.reason
    };
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    (0, $f27982cef7035d22$export$6b22d50e3ddf4789)(character);
    const marks = $bde36de43872f734$export$ffae5de2f7ddd94d(character);
    // Skeleton Crew's perk. Applied to the BANKED total rather than inside
    // calculateCommandMarks, because that function is also the promote modal's
    // preview and the succession doctrine's rate input — inflating it there
    // would make the peak policy chase a number that is not what it measures.
    const blackoutMarks = (0, $45c49e7f6d2032d6$export$84f52d60145287)('promotion-marks', 0);
    if (blackoutMarks > 0) marks.total = Math.round(marks.total * (1 + blackoutMarks));
    // Guild Vault: SPLIT the outgoing character's materials, destroy nothing.
    //
    // A fixed share keeps materials for the next recruit (command.vault, as
    // before) and the remainder — which used to evaporate with the character —
    // is consigned to `syndicate.consignment` as Operations cargo. The promoted
    // member packs up their kit; what the successor does not inherit is what the
    // convoys carry.
    //
    // The CONSIGNMENT, not the live dock (`syndicate.stores`). Founding is
    // repeatable, so this era's promotions are provisioning the NEXT Syndicate;
    // writing straight to the dock would top up the current one and dissolve
    // the per-era budget.
    //
    // So the rank is now a DIAL between two destinations rather than a
    // save-versus-destroy switch, and rank 0 consigns 100% rather than losing
    // it. Flagged for S7: that inverts the upgrade's purchase logic, since marks
    // spent here make convoys leaner.
    //
    // Everything that is NOT material is routed by disburseInventory() — see
    // there for why blueprints and story relics are filed whole, and why relics
    // and consumables are sold rather than dropped.
    const vaultShare = $ce6dd72bc4611534$export$9f9786ac427715c7.vaultCarryover;
    const consignment = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.consignment ||= {} : null;
    const disbursed = $bde36de43872f734$export$da98dc4e7bdea782(character.inventory, {
        vaultShare: vaultShare,
        vault: command.vault,
        consignment: consignment
    });
    // Credited BEFORE the levy, deliberately. Relics and consumables are wealth,
    // and the levy exists because "credits are account-shared, so a flat reset
    // would be trivially dodged by holding wealth elsewhere". Crediting after
    // the levy would make stockpiling purchasable consumables exactly that dodge
    // — buy at full price before promoting, cash out untaxed after.
    if (disbursed.credits > 0) (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits || 0) + disbursed.credits;
    const legend = {
        name: character.name,
        avatar: character.avatar,
        avatarSeed: character.avatarSeed,
        faction: character.faction,
        level: character.level || 1,
        tour: command.tour,
        techGear: marks.breakdown.techGear.count,
        artifactsUnlocked: marks.breakdown.artifactUnlocks.count,
        artifactsCrafted: marks.breakdown.artifacts.count,
        t3Wins: marks.breakdown.t3Wins.count,
        marksEarned: marks.total,
        promotedRole: $bde36de43872f734$export$be02e18412b74462(character),
        promotedAt: Date.now()
    };
    command.marks += marks.total;
    // Writ input for the Syndicate layer (M3). Tracked separately from
    // command.marks because that is a spendable BALANCE - it drops every time
    // the player buys an upgrade, and Writs must price the era that was run,
    // not the change left in the player's pocket at the end of it. Every marks
    // source funnels through promotion, so this line is the whole accumulator.
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate) (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.eraMarks += marks.total;
    command.legends.push(legend);
    command.tour += 1;
    // A new tour starts with a fresh rate curve — carrying the old peak forward
    // would have the doctrine judging the successor against their predecessor's
    // best run and promoting them almost immediately.
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.succession) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.succession.tourRaids = 0;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.succession.peakRate = 0;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate.succession.peakAtRaid = 0;
    }
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.filter((c)=>c.id !== character.id);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId = null;
    const levy = $ce6dd72bc4611534$export$9f9786ac427715c7.promotionCreditLevy;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits = Math.max(levy.floor, Math.floor(((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits || 0) * levy.keepFraction));
    // Re-derive from the new tour rather than compounding module state (see
    // applyCraftingDiscountForTour).
    $bde36de43872f734$export$6d153901dd951884();
    return {
        success: true,
        marks: marks,
        legend: legend,
        disbursed: disbursed
    };
}
function $bde36de43872f734$export$4ece4efb45f52fed(tour) {
    const cfg = $ce6dd72bc4611534$export$9f9786ac427715c7.craftingCostScaling;
    const factor = $ce6dd72bc4611534$export$9f9786ac427715c7.craftingDiscountPerTour;
    const perTour = cfg.globalMultiplier * Math.pow(factor, Math.max(0, (tour || 1) - 1));
    // Cold Drop's perk. Multiplied INTO the curve rather than clamped under it:
    // the spec calls it a "floor" discount, and the per-tour curve is already a
    // decaying multiplier — a separate floor would fight it, and the deeper a
    // player goes the more a subtraction would distort. Same shape, one factor.
    return perTour * (1 - (0, $45c49e7f6d2032d6$export$84f52d60145287)('crafting-floor', 0));
}
function $bde36de43872f734$export$6d153901dd951884() {
    const tour = $bde36de43872f734$export$b97b2e8df296cd3b().tour;
    (0, $00c60928d2fcd8b8$export$b2554e3c8ffeec59)({
        globalMultiplier: $bde36de43872f734$export$4ece4efb45f52fed(tour),
        rarityMultipliers: $ce6dd72bc4611534$export$9f9786ac427715c7.craftingCostScaling.rarityMultipliers
    });
    return (0, $00c60928d2fcd8b8$export$98e32b77d8baebd)();
}
function $bde36de43872f734$export$7647bd5455c447e6() {
    const perLegend = $bde36de43872f734$export$59fca837549bbada('legend-bonus', 0);
    if (perLegend <= 0) return 1;
    return 1 + perLegend * ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0);
}
function $bde36de43872f734$export$b80ce5f774104e94(character) {
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    const granted = {};
    Object.entries(command.vault || {}).forEach(([itemId, qty])=>{
        if (qty > 0) {
            character.inventory[itemId] = (character.inventory[itemId] || 0) + qty;
            granted[itemId] = qty;
        }
    });
    command.vault = {};
    return granted;
}
function $bde36de43872f734$export$21d6f53ea6843ff6(upgradeId, rank = $bde36de43872f734$export$12c456cbb12a94a8(upgradeId)) {
    const def = $ce6dd72bc4611534$export$617b3a0bcd7cead7?.[upgradeId];
    if (!def || rank >= def.costs.length) return null;
    return def.costs[rank];
}
function $bde36de43872f734$export$21736c92e8c4e21c(def) {
    if (!def?.requires) return [];
    const required = Array.isArray(def.requires) ? def.requires : [
        def.requires
    ];
    return required.filter((id)=>$bde36de43872f734$export$12c456cbb12a94a8(id) <= 0);
}
function $bde36de43872f734$export$a9f5f3e18483ed51(upgradeId, choice = null) {
    const def = $ce6dd72bc4611534$export$617b3a0bcd7cead7?.[upgradeId];
    if (!def) return {
        success: false,
        reason: 'unknown-upgrade'
    };
    const command = $bde36de43872f734$export$b97b2e8df296cd3b();
    const rank = $bde36de43872f734$export$12c456cbb12a94a8(upgradeId);
    if (rank >= def.costs.length) return {
        success: false,
        reason: 'max-rank'
    };
    // Prerequisite upgrades (auto-raid-protocol needs auto-scout + foremans-
    // ledger). Checked before the cost so a player is told what is missing
    // rather than being told they are short of marks they would waste anyway.
    const missing = $bde36de43872f734$export$21736c92e8c4e21c(def);
    if (missing.length > 0) return {
        success: false,
        reason: 'missing-requirement',
        requires: missing
    };
    const cost = $bde36de43872f734$export$21d6f53ea6843ff6(upgradeId, rank);
    if (command.marks < cost) return {
        success: false,
        reason: 'insufficient-marks'
    };
    if (def.choice === 'region') {
        if (!choice || !$ce6dd72bc4611534$export$4fbdcec70fce9d73[choice]) return {
            success: false,
            reason: 'invalid-region'
        };
        if (command.charterRegions.includes(choice)) return {
            success: false,
            reason: 'region-already-chartered'
        };
    }
    command.marks -= cost;
    command.upgrades[upgradeId] = rank + 1;
    if (def.choice === 'region') command.charterRegions.push(choice);
    return {
        success: true,
        rank: rank + 1,
        cost: cost
    };
}



//done
//@ts-check



//done
//@ts-check





/**
 * An item row's searchable description.
 *
 * This was CALLED but never defined — not here, not imported, not on window. So
 * `filteredItems` threw a ReferenceError on any search term that failed to match
 * by name, since the `||` only reaches this when the name misses. Alpine
 * swallows getter throws, so the symptom was a search box that silently stopped
 * narrowing rather than an error anyone would notice.
 */ function $607ffae1bbc96660$var$getItemDescription(item) {
    const data = item?.artifact || (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', item?.id);
    return data?.description || data?.short || '';
}
/**
 * A plain { itemId: qty } map as the item rows the grid and filters read.
 *
 * Shared by the character's inventory and the layer vaults so all four sources
 * sort, filter and search identically — the vault screens are the same screen
 * pointed somewhere else, not a second implementation of it.
 */ function $607ffae1bbc96660$var$itemRows(map) {
    const rows = [];
    Object.entries(map || {}).forEach(([id, quantity])=>{
        if (quantity <= 0 || id === 'Fish') return;
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
        if (!item) return;
        rows.push({
            id: id,
            name: item.name,
            quantity: quantity,
            type: (0, $b7695fceb608271e$export$28b75a4bedf6475d)(id),
            rarity: item.rarity || 'common'
        });
    });
    return rows;
}
const $607ffae1bbc96660$export$43ae57abf049ebd8 = {
    character: [
        {
            key: 'items',
            label: "\uD83C\uDF92 Carried"
        }
    ],
    commandVault: [
        {
            key: 'vault',
            label: "\uD83E\uDDD1 Outbound to next recruit"
        },
        {
            key: 'consignment',
            label: "\u23F3 Outbound at next founding"
        }
    ],
    syndicateStores: [
        {
            key: 'stores',
            label: "\uD83D\uDCE6 Dock"
        }
    ]
};
function $607ffae1bbc96660$export$5e57bb1ccaa580e5() {
    // Alpine.js Contractor Store
    (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("inventory", {
        items: [],
        // The layer vaults. Live on the same store as the character's inventory so
        // one refresh() keeps every screen current — a second store would be a
        // second thing to remember to refresh.
        vault: [],
        stores: [],
        consignment: [],
        init () {
            // Initialize with current gameState data
            this.refresh();
        },
        refresh () {
            this.vault = $607ffae1bbc96660$var$itemRows((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.vault);
            this.stores = $607ffae1bbc96660$var$itemRows((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.stores);
            this.consignment = $607ffae1bbc96660$var$itemRows((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.consignment);
            // Convert gameState.character.inventory to an array format
            const inventoryItems = [];
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory) {
                // Add regular inventory items
                Object.entries((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory || {}).forEach(([id, quantity])=>{
                    if (quantity > 0 && id != 'Fish') {
                        let item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
                        //remove this later, check based on old name logic
                        if (item) inventoryItems.push({
                            id: id,
                            name: item.name,
                            quantity: quantity,
                            type: (0, $b7695fceb608271e$export$28b75a4bedf6475d)(id),
                            rarity: item.rarity || 'common'
                        });
                    }
                });
                // Add artifacts
                if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.forEach((artifact)=>{
                    inventoryItems.push({
                        id: artifact.id,
                        name: artifact.name,
                        quantity: 1,
                        type: "artifact",
                        rarity: artifact.rarity || 'unique',
                        artifact: artifact
                    });
                });
            }
            this.items = inventoryItems;
        },
        update (newInventory, newArtifacts) {
            if (newInventory != null) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory = newInventory;
            if (newArtifacts != null) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts = newArtifacts;
            // Refresh from gameState and save
            this.refresh();
        },
        get all () {
            return this.items;
        },
        get count () {
            return this.items.length;
        }
    });
}
function $607ffae1bbc96660$export$277774029cdaf1(source = "character", readOnly = false) {
    return {
        searchTerm: "",
        selectedType: "all",
        selectedRarity: "all",
        sortBy: "name",
        source: source,
        readOnly: readOnly,
        activePool: ($607ffae1bbc96660$export$43ae57abf049ebd8[source] || $607ffae1bbc96660$export$43ae57abf049ebd8.character)[0].key,
        get pools () {
            return $607ffae1bbc96660$export$43ae57abf049ebd8[this.source] || $607ffae1bbc96660$export$43ae57abf049ebd8.character;
        },
        setPool (key) {
            this.activePool = key;
        },
        get items () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.inventory[this.activePool] || [];
        },
        get filteredItems () {
            let filtered = this.items;
            // Filter by search term
            if (this.searchTerm) {
                const searchLower = this.searchTerm.toLowerCase();
                filtered = filtered.filter((item)=>item.name.toLowerCase().includes(searchLower) || $607ffae1bbc96660$var$getItemDescription(item).toLowerCase().includes(searchLower));
            }
            // Filter by category
            if (this.selectedType !== "all") filtered = filtered.filter((item)=>item.type === this.selectedType);
            // Filter by rarity
            if (this.selectedRarity !== "all") filtered = filtered.filter((item)=>item.rarity === this.selectedRarity);
            // Sort items
            filtered.sort((a, b)=>{
                switch(this.sortBy){
                    case "name":
                        return a.name.localeCompare(b.name);
                    case "quantity":
                        return b.quantity - a.quantity;
                    case "type":
                        const typeOrder = {
                            material: 1,
                            techGear: 2,
                            artifact: 3,
                            blueprint: 4,
                            consumable: 5
                        };
                        const typeDiff = (typeOrder[a.type] || 0) - (typeOrder[b.type] || 0);
                        return typeDiff !== 0 ? typeDiff : a.name.localeCompare(b.name);
                    case "rarity":
                        const rarityOrder = {
                            common: 1,
                            uncommon: 2,
                            rare: 3,
                            epic: 4,
                            legendary: 5,
                            unique: 6
                        };
                        const rarityDiff = (rarityOrder[a.rarity] || 0) - (rarityOrder[b.rarity] || 0);
                        return rarityDiff !== 0 ? rarityDiff : a.name.localeCompare(b.name);
                    case "credits":
                        const aCredits = Number((0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('name', a.name)?.credits || 0);
                        const bCredits = Number((0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('name', b.name)?.credits || 0);
                        return bCredits - aCredits; // High to low
                    default:
                        return 0;
                }
            });
            //console.log("Filtered items:", [...filtered]);
            return filtered;
        },
        get totalItems () {
            return this.items.length;
        },
        get filteredCount () {
            return this.filteredItems.length;
        },
        get itemTypes () {
            const itemTypes = new Set([
                "all"
            ]);
            this.items.forEach((item)=>itemTypes.add(item.type));
            return Array.from(itemTypes).map((itemType)=>({
                    value: itemType,
                    label: itemType === "all" ? "All Items" : $ce6dd72bc4611534$export$d02ea220375e4aff[itemType] ? $ce6dd72bc4611534$export$d02ea220375e4aff[itemType].name : itemType.charAt(0).toUpperCase() + itemType.slice(1)
                }));
        },
        get itemRarities () {
            const rarities = new Set([
                "all"
            ]);
            this.items.forEach((item)=>rarities.add(item.rarity));
            return Array.from(rarities).map((rarity)=>({
                    value: rarity,
                    label: rarity === "all" ? "All Rarities" : $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity] ? $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity].name : rarity.charAt(0).toUpperCase() + rarity.slice(1)
                }));
        },
        clearFilters () {
            this.searchTerm = "";
            this.selectedType = "all";
            this.selectedRarity = "all";
            this.sortBy = "name";
        }
    };
}
function $607ffae1bbc96660$export$4d450619ebe70217(source, accent, empty) {
    const pools = $607ffae1bbc96660$export$43ae57abf049ebd8[source] || [];
    // One pool needs no switcher — a single tab that cannot be switched away from
    // is a control that only takes up space.
    const poolTabs = pools.length < 2 ? '' : `
    <div class="flex gap-1 mb-3">
      ${pools.map((p)=>`
        <button type="button" @click="setPool('${p.key}')"
          class="px-3 py-1.5 rounded text-xs font-bold border-2"
          :style="activePool === '${p.key}'
            ? 'border-color:${accent}; background:${accent}22; color:${accent}'
            : 'border-color:#374151; color:#9ca3af'">
          ${p.label} <span class="opacity-70" x-text="'\xb7 ' + ($store.inventory['${p.key}'] || []).length"></span>
        </button>`).join('')}
    </div>`;
    return `
    ${poolTabs}
    <div class="mb-4 space-y-4">
      <div class="flex space-x-2 text-sm">
        <div class="flex-grow">
          <input type="text" x-model="searchTerm" placeholder="Search by name or description..."
            class="w-full px-4 py-2 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-game-accent focus:outline-none">
        </div>
        <div class="flex-grow">
          <select x-model="selectedType"
            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">
            <option value="all">All Categories</option>
            <template x-for="[itemTypeKey, itemType] in Object.entries(config.itemTypes).filter(([key]) => key !== 'credits')" :key="itemTypeKey">
              <option :value="itemTypeKey" x-text="\`\${itemType.icon} \${itemType.name}\`"></option>
            </template>
          </select>
        </div>
        <div class="flex-grow">
          <select x-model="selectedRarity"
            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">
            <template x-for="rarity in itemRarities" :key="rarity.value">
              <option :value="rarity.value" x-text="rarity.label"></option>
            </template>
          </select>
        </div>
        <div class="flex-grow">
          <select x-model="sortBy"
            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">
            <option value="name">Sort by Name</option>
            <option value="quantity">Sort by Quantity</option>
            <option value="type">Sort by Type</option>
            <option value="rarity">Sort by Rarity</option>
            <option value="credits">Sort by Value</option>
          </select>
        </div>
        <div class="text-center">
          <button @click="clearFilters()"
            class="bg-blue-400 hover:bg-blue-300 text-black text-sm px-4 py-[10px] rounded font-bold whitespace-nowrap">\u{1F9F9} Clear Filters</button>
        </div>
      </div>
      <div class="text-base text-gray-300 text-center">
        <span x-text="\`Showing \${filteredItems.length} of \${totalItems} items\`"></span>
      </div>
    </div>

    <div class="grid gap-4" style="grid-template-columns: repeat(auto-fit, 11rem); justify-content: center;">
      <template x-for="item in filteredItems" :key="item.name">
        <div x-html="window.createInventoryCard(item, 'inventory', null, null, { collapsed: true, hideActions: true })"></div>
      </template>
      <div x-show="filteredItems.length === 0" class="col-span-full text-center text-gray-400 py-8">
        <span x-show="totalItems === 0">${empty}</span>
        <span x-show="totalItems > 0 && filteredItems.length === 0">No items match your search criteria</span>
      </div>
    </div>`;
}
function $607ffae1bbc96660$export$5b73e6a29e58b929() {
    // Update the Alpine store with current gameState data
    if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("inventory")) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("inventory").refresh();
}


//done
//@ts-check


// ===============================
// DISTRICTS
// ===============================
// The districts a map is laid out in, and the only place their names are
// written down. A cell's district is a property of the CELL — `room.zone` — and
// of nothing else; a room template says which district it would rather stand in
// with `districtAffinity`, which is a different question and now has a
// different name for it. The two were both called `zone`, which is how the map
// came to have an invisible district structure that agreed with nothing.
//
// No `transit` district. Roads are already a layer of their own — `room.road`,
// `roadRank`, `roadDist` — and a transit district is the same claim made twice
// by two systems that will disagree about where it is. Its entry in the old
// preferences table was, tellingly, empty.
// `recipes` is what a district is BUILT of: the mix of tile art its ordinary
// cells are drawn from, weighted, summing to 100 so the numbers read as
// percentages. It is what makes a district look like one.
//
// It is deliberately separate from which ROOM stands on a cell. A region owns
// twelve room templates for a map of up to 119 cells, so each is reused eight
// to eleven times — far too few to build a district out of. Picking rooms by
// district instead would collapse a residential district onto the one
// residential template, testing the one skill it carries. So the district
// decides the building type, the room keeps its own name, category and skill,
// and the skill anchor already drawn on every encounter tile says what is
// actually being attempted there. The recipe says where you are; the anchor
// says what you are doing; the name says what it is called.
//
// Every district leads on one recipe at around half its cells, which is what
// makes it recognisable, and carries three or four others so it does not read
// as a monoculture.
// `built` is how densely a district is built up, 0..1, and the renderer reads
// it directly: it thins a tile's structures, and inversely lets the growth back
// in and the tarmac go to seed. Authored rather than sampled from noise so a
// district's look and its name agree — an outskirt is thin because it IS the
// outskirts, not because a lattice happened to dip there.
//
// The numbers are centred on MEAN_BUILT (roomImageGen) so the average tile
// lands where it already was. This redistributes built stock across the map; it
// does not delete it, and there is a test holding the total to within a tenth.
const $c1858b438f434f4d$export$8377a367ab2ae550 = {
    entry: {
        description: "Starting area with easier encounters",
        recipes: {
            infrastructure: 35,
            transit: 25,
            security: 20,
            storage: 20
        },
        built: 0.72
    },
    peripheral: {
        description: "Outer areas with mixed encounters",
        recipes: {
            environmental: 40,
            transit: 20,
            storage: 20,
            habitation: 20
        },
        built: 0.58
    },
    security: {
        description: "Defensive checkpoints",
        recipes: {
            security: 45,
            infrastructure: 25,
            storage: 20,
            power: 10
        },
        built: 0.90
    },
    industrial: {
        description: "Resource/infrastructure areas",
        recipes: {
            power: 30,
            storage: 30,
            infrastructure: 25,
            transit: 15
        },
        built: 0.88
    },
    core: {
        description: "High-value protected areas",
        recipes: {
            records: 35,
            commerce: 25,
            security: 20,
            infrastructure: 20
        },
        built: 1.00
    },
    residential: {
        description: "Habitats, apartments, communal living spaces",
        recipes: {
            habitation: 50,
            environmental: 20,
            records: 15,
            commerce: 15
        },
        built: 0.85
    },
    commercial: {
        description: "Shops, offices, market halls, logistics fronts",
        recipes: {
            commerce: 50,
            storage: 20,
            records: 15,
            habitation: 15
        },
        built: 0.95
    }
};
const $c1858b438f434f4d$export$11209b5126489e67 = {
    campsite: {
        type: "campsite",
        name: "Campsite",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDFD5\uFE0F",
        description: "A safe place to rest and recover",
        healingAmount: 30
    },
    water: {
        type: "water",
        name: "Water",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDF0A",
        description: "A water source for fishing"
    },
    road: {
        type: "road",
        name: "Road",
        primary: "",
        support: [],
        baseDuration: 10,
        icon: "\uD83D\uDEE3\uFE0F",
        description: "A roadway for fast travel"
    }
};
const $c1858b438f434f4d$export$4fbdcec70fce9d73 = {
    // ======================================================
    "shard-cities": {
        name: "Shard Cities",
        theme: "Collapsed megacities and fractured districts",
        icon: "\uD83C\uDFD9\uFE0F",
        shortDescription: "Towering urban ruins split by broken transit lines and silent civic grids.",
        longDescription: "These were once continuous skylines: stacked transit, dense housing, and civic utilities woven into mile-high towers. Centuries of neglect cracked the pavement and snapped the skyways. You can still read the street plan, even if whole blocks have slumped into their own debris.\n\nPower occasionally surges through old feeders, enough to light a dead intersection for a breath. Most systems do nothing at all\u2014just rust, dust, and old signage pointing nowhere.",
        artDirection: "Two scales of building, and the contrast between them IS the region. The ordinary stock is warm \u2014 brick and brown roofing, low, dense, packed kerb to kerb. Over it stand cool concrete-and-glass masses: tower cores with their service shafts open to the sky, skybridge decks that start nowhere and stop in mid-air, sign gantries still spanning the carriageway. Ground is dark slate tarmac, cracked on a slab pitch, so both tiers read light against it. Street trees have come up through the pavement everywhere there was a cutout.",
        gates: [
            {
                icon: "\uD83D\uDEA7",
                name: "Checkpoint Sector",
                primary: "lock-breach",
                support: [
                    "signal-relay",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Barricaded intersection controlling movement between ruined blocks.",
                longDescription: "Concrete barriers, rusted railings, and makeshift roadblocks choke an old arterial. The city\u2019s last attempts at order still shape the flow of rubble and weeds. Nothing powers here\u2014only wind and dust."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Civic Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Collapsed service block with dead comms towers and trunk conduits.",
                longDescription: "Stubbed antenna masts lean over a plaza of broken panels and cable vaults. Dust-muted signage points to services that no longer exist. A faint click from a relay box sometimes answers fresh power before falling silent again."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Apartment Access Lot",
                primary: "stealth-transit",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Collapsed housing block entrances clustered around a cracked forecourt.",
                longDescription: "Entry canopies hang at angles over door stacks long since jammed. Mailboxes gape, names scoured to metal. The forecourt is a map of fractures and weeds, with scaffolds rusted into stillness."
            },
            {
                icon: "\uD83D\uDECD\uFE0F",
                name: "Arcade Shutter Sector",
                primary: "system-override",
                support: [
                    "drone-command",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Market frontage sealed by fallen shutters and buckled grates.",
                longDescription: "A run of storefronts slouches under dead signage and twisted awnings. Steel shutters are half-dropped or jammed, creating a maze of narrow access. Any movement here is the wind through canvas and chain."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDEE2\uFE0F",
                name: "Residential Power Yard",
                primary: "containment",
                support: [
                    "signal-relay",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Small substation between towers with fallen lines and rusted switchgear.",
                longDescription: "Transformer housings slouch on cracked pads; the fence is more gap than mesh. A wrong step crunches glass and ceramic. If anything lights, it\u2019s for a breath, then the quiet deepens."
            },
            {
                icon: "\uD83C\uDF09",
                name: "Transit Collapse Zone",
                primary: "transit-anchor",
                support: [
                    "reclamation",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Broken overpass and skybridge stubs sprawled over a debris-choked road.",
                longDescription: "Guardrails spear the pavement; cables drape from shattered spans. The echo under concrete ribs tells how big it was. Weeds stitch rebar and dust into something like ground again."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Marketfront Depot",
                primary: "drone-command",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Cluster of loading bays and shuttered storerooms behind ruined shops.",
                longDescription: "Dock plates sit crooked; pallets rot into dark lines on the ground. The loading lights are dead\u2014only daylight finds its way in through gaps and broken louvers."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Administrative Records Block",
                primary: "quantum-scan",
                support: [
                    "system-override",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Abandoned office district with shattered facades and paper-littered streets.",
                longDescription: "Stacks of files turned to mulch line the curbs where floodwater once ran. A rusted maintenance crane leans against a curtain wall. Nothing watches here\u2014only glass dust and wind."
            },
            {
                icon: "\uD83D\uDE89",
                name: "Transit Exchange Block",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "containment"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A surface-level transit interchange and service plaza linking several collapsed lines.",
                longDescription: "Once a hub for elevated trams and vertical shuttles, the block still shows the scar of its platforms. Canopies hang over cracked concrete lanes, and access ramps descend into dust-filled tunnels below."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Ruins",
                // overturned cargo trucks and container stacks, not a service yard
                recipe: "storage",
                primary: "reclamation",
                support: [
                    "drone-command",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Collapsed distribution yard filled with overturned cargo trucks and container stacks.",
                longDescription: "What was once a multi-lane loading grid now lies in layers \u2014 trucks fossilized in place, containers torn open by time. Tower cranes stand idle at the corners like monuments to motionless trade."
            },
            {
                icon: "\u26A1",
                name: "Substation Complex",
                primary: "system-override",
                support: [
                    "reclamation",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "A cluster of transformers and conduit fields forming a decommissioned power block.",
                longDescription: "Heavy transformer shells sit on cracked pads, their housings marked with long-gone warning paint. Busbars bridge between fenced sections, while cable vaults yawn open into the dark below."
            },
            {
                icon: "\uD83D\uDEC2",
                name: "Civic Control District",
                // a ring of checkpoints; "civic" pulls it to infrastructure otherwise
                recipe: "security",
                primary: "quantum-scan",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "A cluster of interconnected checkpoints surrounding a former civic administration block.",
                longDescription: "Security kiosks ring the perimeter of a low central building, their scanner frames bent but still standing. The entire block was once a controlled corridor \u2014 a mix of barriers, scanners, and causeways now frozen in collapse."
            }
        ]
    },
    // ======================================================
    "verdant-reclamation": {
        name: "Green Reclamation",
        theme: "Overgrown research campuses and greenhouse grids",
        icon: "\uD83C\uDF3F",
        shortDescription: "Bio-reclaimed districts where labs and irrigation frames disappear beneath growth.",
        longDescription: "This landscape was engineered to coax life back into sterile soil. Greenhouses formed shining corridors; irrigation lattices pulsed under glass. After the departure, containment failed and nature took the reins.\n\nNow, fibrous canopies bind whole blocks together. Steel trusses wear bark; road paint lies under moss. Machinery answers only sometimes, a pump stuttering once before the vines hold it still again.",
        artDirection: "Growth is the loudest thing on the tile and the buildings are what it grew over. Heavy canopy in deep greens, moss and wildflowers through the ground, tarmac worn back to soil. The architecture that survives is glasshouse: long shallow glazed spans ridged down their spine with panes missing and the planting showing through, irrigation lattices over what used to be beds, seed silos. Ordinary buildings are muted steel grey and mostly hidden \u2014 that is the point, they lost.",
        gates: [
            {
                icon: "\uD83E\uDDEA",
                name: "Bio-Lab Complex Gate",
                primary: "bio-shield",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed research compound entrance tangled in vines and glass.",
                longDescription: "A trellis of bent greenhouse ribs leads into a court of moss and broken tiles. Safety placards lie sun-bleached among seed trays and cracked tanks. The air is warm and wet, heavy with plant breath."
            },
            {
                icon: "\uD83D\uDEBF",
                name: "Irrigation Control Sector",
                primary: "reclamation",
                support: [
                    "growth-control",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Valve fields, cisterns, and control kiosks overtaken by roots.",
                longDescription: "Pipes run like exposed roots along the ground, bolted kiosks eaten by rust and kudzu. A cistern lid thumps underfoot\u2014water still trapped below. If anything moves, it\u2019s the wind dragging leaves across metal."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Habitation Annex Gate",
                primary: "wild-influence",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Apartment annex entrances swallowed by creepers and fallen trellis.",
                longDescription: "Balconies have become planters; stairwells bloom with ferns. Doorways stand open or warped shut, their seals crumbled to powder. A single gutter still drips into a barrel of green water."
            },
            {
                icon: "\uD83E\uDDEA",
                name: "Market Decontamination Sector",
                primary: "containment",
                support: [
                    "safeguard",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Outdoor wash stations and shuttered stalls clustered around a drained basin.",
                longDescription: "Decon arches frame a plaza of cracked tile and dried residue. The stalls around it are skeletal, their tarps long rotted away. Nothing cycles here unless you bring the power yourself."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF31",
                name: "Seed Distribution Yard",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Silos, bins, and pallet stacks buried in moss and husks.",
                longDescription: "A drift of cracked pods crunches underfoot. Stenciled measurements fade from the silo sides. Somewhere a vent exhales warm, earthy air that smells like the start of rain."
            },
            {
                icon: "\uD83C\uDF44",
                name: "Fungal Spread Block",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A shaded block carpeted with fungus and spore fans.",
                longDescription: "Stems as thick as cable push through fissures in the concrete. Spores hang in the air like dust motes in a cathedral. Your breath fogs just enough to make the light feel heavy."
            },
            {
                icon: "\uD83D\uDCA7",
                name: "Irrigation Breach Sector",
                primary: "bio-shield",
                support: [
                    "growth-control",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Ruptured mains flooding a low lot, roots drinking the overflow.",
                longDescription: "A trench of clear water has cut through soil and tile, pooling around toppled control posts. Algae paints the edges; insects tap the surface. The flow wanes and returns without reason."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Research Supply Yard",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Crated lab gear and broken cages stacked beside a ruined annex.",
                longDescription: "Numbers stenciled on crates tell of a mission left unfinished. Metal shelving slumps like wet paper. A single rain gutter ticks as it cools in the shade."
            },
            {
                icon: "\uD83C\uDFD7\uFE0F",
                name: "Habitation Block",
                primary: "wild-influence",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "A cluster of low-rise apartments overtaken by gardens and nests.",
                longDescription: "Bedsprings and trellis wire bind stairwells into new shapes. Window boxes have become small forests. The only movement is leaves, and the small quick things that live in them."
            },
            {
                icon: "\uD83E\uDED7",
                name: "Nutrient Line Rupture",
                primary: "bio-shield",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Leaking feed lines turning a block into a slick, humming wetland.",
                longDescription: "Plastic tubing loops across the ground like shed skin, seeping a sweet, metallic film. New shoots force through asphalt in a straight line where the pipe runs below."
            },
            {
                icon: "\uD83C\uDFEA",
                name: "Agri-Market Depot",
                primary: "growth-control",
                support: [
                    "containment",
                    "bio-shield"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Open-air market storage with collapsed canopies and crate rows.",
                longDescription: "Sun-faded tarps hang like old flags. The smell of dust and seed oil lingers. You can still see where chalk mapped out stall fees on the concrete."
            },
            {
                icon: "\uD83E\uDDEF",
                name: "Greenhouse Containment Sector",
                primary: "safeguard",
                support: [
                    "containment",
                    "wild-influence"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Firebreak lanes and isolation frames choking in vines.",
                longDescription: "White-painted fire lanes vanish under creepers. The shutters meant to fall in emergencies are rusted half-down. A distant pane taps in the breeze like a metronome."
            }
        ]
    },
    // ======================================================
    "sunken-bastions": {
        name: "Flooded Bastions",
        theme: "Semi-submerged fortifications and silted logistics",
        icon: "\uD83C\uDF0A",
        shortDescription: "Defense districts with the sea in them: the coast took the low blocks and the silt took the rest.",
        longDescription: "Coastal defenses once ringed this region with docks, bunkers, and pressure locks. Storm surge and slow subsidence rolled in over centuries, flooding the low blocks and salting everything else.\n\nSome pressure doors still cycle if you give them power, drawing a final gulp of air through corroded ducts. Mostly, there is water, silt, and the sound of old metal moving in the tide.",
        artDirection: "One edge of the map is open ocean and everything reads off how far it is from it. At the shore, water over the outer half of the tile, a buttressed sea wall along the waterline with its bollards behind, and what is left of the buildings is mostly wreckage in the shallows. A row in, tidal flats and standing water pooling in the streets first. Beyond that, dry. Ground is cold silt, not sand \u2014 blue-grey, damp-looking, tide-marked. Concrete is wet and weeping rust.",
        gates: [
            {
                icon: "\uD83D\uDED1",
                name: "Pressure Gate Sector",
                primary: "lock-breach",
                support: [
                    "signal-mask",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cluster of rusted airlock doors and corroded valves around a flooded court.",
                longDescription: "Door rings sit proud with barnacle rust; inspection windows are opaque with salt. The control pedestals are still in place, their labels sanded flat by wind and spray."
            },
            {
                icon: "\u2693",
                name: "Drydock Access Block",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed dock gates and winch frames guarding entry to an old basin.",
                longDescription: "The dock walls lean inward, heavy with waterlogged stone. Winch cables coil like sleeping eels beside shattered bollards. Every surface is stained a dozen kinds of orange."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Residential Seal Lot",
                primary: "containment",
                support: [
                    "safeguard",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Pressure-rated housing entries scattered along a raised walkway.",
                longDescription: "Doors that once sealed against storms now gape, warped on their hinges. A painted muster diagram flakes off the wall in curls as thin as fish scales."
            },
            {
                icon: "\uD83E\uDDF3",
                name: "Commercial Airlock Sector",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Cargo airlocks and submerged loading bays along a corroded quay.",
                longDescription: "Crate hoists stand frozen above black water. The quay edge is a jag of broken concrete and rebar, polished smooth where the tide reaches."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF0A",
                name: "Flooded Records Sector",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Archives drowned to the window line, shelves like ribs under the surface.",
                longDescription: "Folders have turned to silt drifts. A rolling ladder floats, bumping the stacks with a hollow rhythm. Light puddles on the water and slides across the ceiling."
            },
            {
                icon: "\uD83D\uDCA8",
                name: "Ventilation Intake Lot",
                primary: "echo-trace",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Banks of rusted intake fans towering over a silted forecourt.",
                longDescription: "Fan blades are choked with ropeweed and netting. A metal tag rattles faintly when the wind shifts. The air smells like creosote and tide."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Freight Access Zone",
                primary: "transit-anchor",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Collapsed ramps and container rows leading into a drowned terminal.",
                longDescription: "Container paint has bled into pastel ghosts. The ramp rails end abruptly in water that hides a second city of debris below."
            },
            {
                icon: "\uD83E\uDEB8",
                name: "Marine Observation Block",
                primary: "wild-influence",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Sea-worn platforms and pylons with algae film and broken rails.",
                longDescription: "Scope housings point at horizons no one watches. The handrails flake in layers that stain your gloves. Gulls nest in the elbows of old floodlights that will never shine again."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Flooded Living Sector",
                primary: "bio-shield",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lower housing blocks drowned to the window line, interiors slumped inward.",
                longDescription: "Mildew blooms on every surface; curtains drift like slow jelly. The line where the tide reaches is written as a salt band around the rooms."
            },
            {
                icon: "\uD83E\uDE9C",
                name: "Access Tower Sector",
                primary: "safeguard",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Stair towers and emergency ladders rising above the flood.",
                longDescription: "Cages of stairs keep their geometry against the soft line of the water. Every landing clicks and settles when the wind turns."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Cargo Intake Block",
                primary: "containment",
                support: [
                    "quantum-scan",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Shallow-water cargo ramps and corroded conveyors into a warehouse face.",
                longDescription: "Conveyor housings gape like fish skulls. A strip of weed waves where a belt used to run. The warehouse doors are heavy with swollen wood."
            },
            {
                icon: "\uD83D\uDCB0",
                name: "Finance Quarter",
                primary: "quantum-scan",
                support: [
                    "containment",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Collapsed teller halls and armored delivery bays, empty as vaults.",
                longDescription: "Coin-counting machines sit in rows like old teeth. Delivery lanes are silted to their thresholds. Everything smells faintly of metal and mildew."
            }
        ]
    },
    // ======================================================
    "cradle-expanse": {
        name: "Industrial Expanse",
        theme: "Manufacturing grids and rust plains",
        icon: "\uD83C\uDF05",
        shortDescription: "Endless factory lots, idle conveyors, and yard-wide machinery asleep in rust.",
        longDescription: "Production once moved through these blocks in steady lines\u2014ore in one side, finished goods out the other. Now the conveyors are seized and the cranes lean on their cables, frozen mid-motion for generations.\n\nWhen power returns, a servo might twitch or a stack light might glow and die. The wind does most of the work here: sandblasting paint, driving grit into bearings, and covering tracks almost as fast as you make them.",
        artDirection: "The one region whose plant stands LIGHTER than its ground: pale umber steel on dark iron-rich dirt, which is the opposite of shard-cities and is what keeps two brown regions apart. Silhouettes are industrial and long \u2014 gantry cranes straddling bays, conveyor runs seized where they stopped and carrying on across tiles, bunded tank farms. Rust everywhere, in streaks and pools and oil stains. Almost nothing green: a few dead snags, and the wind has taken the rest.",
        gates: [
            {
                icon: "\uD83C\uDFED",
                name: "Factory Command Sector",
                // control rooms and relay racks under gantries, not a checkpoint
                recipe: "infrastructure",
                primary: "system-override",
                support: [
                    "growth-control",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Central yard of control rooms and relay racks flanked by gantries.",
                longDescription: "Stack lights are long dead above cracked control housings. Catwalks draw hard lines across a sky of dust. A paper logbook lies fused into a solid wedge on a podium."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Gate",
                primary: "drone-command",
                support: [
                    "stealth-transit",
                    "signal-relay"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Gatehouse and weighbridge spanning lanes into container lots.",
                longDescription: "The weighbridge plate is welded to its frame by corrosion. The gate arms point at the ground like broken fingers. Dust piles where wheels once wore it away."
            },
            {
                icon: "\uD83E\uDE96",
                name: "Barracks Gate",
                primary: "signal-mask",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Perimeter fence and turnstiles into a worker barracks compound.",
                longDescription: "Turnstiles are frozen mid-rotation. A loudspeaker hangs by its cable, a mouth that will never speak. The ground inside is a quilt of footprints long since filled with dust."
            },
            {
                icon: "\uD83C\uDF7D\uFE0F",
                name: "Commissary Shutter Sector",
                primary: "system-override",
                support: [
                    "safeguard",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Canteen frontage sealed by roll-down shutters and collapsed awnings.",
                longDescription: "Menu boards peel in the heat. Trays clatter when the wind gets under them. At noon the whole block smells like hot metal and old oil."
            }
        ],
        hazards: [
            {
                icon: "\u26CF\uFE0F",
                name: "Extraction Yard",
                primary: "drone-command",
                support: [
                    "signal-mask",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Ore hoppers, crushed drums, and loader tracks etched into dust.",
                longDescription: "Chutes hang open over empty ground. Piles of fines drift into dunes against dead conveyors. The only sparkle is mica in the grit."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Assembly Corridor Block",
                primary: "drone-command",
                support: [
                    "wild-influence",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Long run of conveyor frames and work platforms seized in place.",
                longDescription: "Tool shadows are burned into paint where the sun never reached. Belt rollers are fused in rings of red. The wind writes its own schedule on hanging tags."
            },
            {
                icon: "\uD83D\uDDD1\uFE0F",
                name: "Salvage Lot",
                primary: "wild-influence",
                support: [
                    "drone-command",
                    "signal-relay"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Heap of stripped machinery and scaffold bones stacked by a fence.",
                longDescription: "Cranes stripped to spines cast laddered shadows. Wire harnesses dangle like dead vines. Footing is uncertain\u2014everything gives a little when you test it."
            },
            {
                icon: "\uD83D\uDD27",
                name: "Operations Hub",
                primary: "signal-relay",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Control kiosks and cable troughs forming a nerve-center yard.",
                longDescription: "Cable trays cross like irrigation over bare concrete. A signal flag still flaps from a line that never fell. If anything comes alive, it does so in stutters and stops."
            },
            {
                icon: "\uD83D\uDD25",
                name: "Boiler Leak Row",
                primary: "safeguard",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Steam-scarred lane between boiler sheds and maintenance stacks.",
                longDescription: "Mineral bloom and peeling paint texture every pipe. Valves whistle ghosts when the wind fits their mouths. The ground is white with the memory of heat."
            },
            {
                icon: "\uD83E\uDD6B",
                name: "Barracks Pantry Depot",
                primary: "stealth-transit",
                support: [
                    "wild-influence",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Food stores and cold-room bays opened to the air long ago.",
                longDescription: "Shelving prints squares on the walls where cold once lived. A pyramid of cans has slumped into a gentle hill of dull tin."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Warehouse Racking Collapse",
                primary: "safeguard",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Racking aisles tumbled into a lattice of unstable paths.",
                longDescription: "Number placards hang at wrong angles, their arrows pointing into heaps of beams. The floor is a patchwork of shadows and sunlight where the roof gave up."
            },
            {
                icon: "\uD83D\uDCD2",
                name: "Ledger Block",
                primary: "signal-relay",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Accounting offices and file stores woven into a single crumbling block.",
                longDescription: "Adding machines sit like fossils on desks. Ledger paper lies fused into brick-hard stacks. The sun makes dust glitter where a roof panel fell away."
            }
        ]
    },
    // ======================================================
    "hollow-core": {
        name: "Hollow Core",
        theme: "Sublevel transit and collapsed substructures",
        icon: "\u26AB",
        shortDescription: "Buried civic arteries: pillared halls, rail spurs and maintenance blocks, half of them sealed by the collapse.",
        longDescription: "Everything aboveground depended on what ran below\u2014transit rings, service corridors, and power trunks stitched together across sublevels. Collapse sealed off some blocks entirely; others breathe stale air through long cracks in the concrete.\n\nOccasionally, indicator strips flare for a moment, enough to show distance receding into black. Then the dark returns, settling even heavier than before.",
        artDirection: "A hall, not a street. Pillars on a regular pitch march across every tile and carry on into the next one \u2014 that rhythm is the only thing a top-down view has to say there is a ceiling overhead. Rock mass laps in from the corners and outer edges where the roof has come down, sealing parts of blocks, carved back around the rooms and never across a route. Rail beds and cable trays run through. Light is the region's subject: almost none of it, teal bioluminescence for ambient, warm pools under the daylight wells, and the darkness graded so it is heaviest against the rock and lightest over the floor. The concrete itself is NOT black \u2014 the palette has to survive the dark and still show which parts are wall.",
        gates: [
            {
                icon: "\uD83D\uDE87",
                name: "Sublevel Transit Hub",
                primary: "transit-anchor",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "storage",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed interchange where multiple rail spurs once crossed.",
                longDescription: "Pillars hold up more air than concrete now. Signal plates stand blank along a bed of gravel and dust. The far wall is a shadow that pretends to be distance."
            },
            {
                icon: "\uD83D\uDD0C",
                name: "Power Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cable trays and junction housings clustered around a maintenance court.",
                longDescription: "Insulators line a wall like teeth. A skein of cables has slumped from the ceiling into a black loop. Dust swirls when you step, then remembers how to be still."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Habitat Access Sector",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Door clusters and service nooks leading into sealed living blocks.",
                longDescription: "Numbered arrows march along the wall toward units you\u2019ll never enter. A cart sits on square wheels of dust. The air is dry and old, like a book left open too long."
            },
            {
                icon: "\uD83D\uDED2",
                name: "Commerce Access Sector",
                primary: "signal-mask",
                support: [
                    "lock-breach",
                    "echo-trace"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Service corridors feeding into a forgotten plaza and loading cutouts.",
                longDescription: "A map board with no map. A mural worn to colors without shapes. The corridor breathes the same cold air in and out, as if thinking of a crowd."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDCE6",
                name: "Storage Compound",
                primary: "quantum-scan",
                support: [
                    "lock-breach",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Box canyons of crates and shelving under a low slab ceiling.",
                longDescription: "Label paint lingers like ghosts on metal faces. A broken roller door shows a sliver of stale light. The air tastes like paper and iron."
            },
            {
                icon: "\uD83E\uDDF1",
                name: "Maintenance Network Sector",
                primary: "growth-control",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Grid of service corridors, tool bays, and grates over dark shafts.",
                longDescription: "Tool outlines haunt the walls. Floor grates ring when crossed, answering back from below. The network feels larger than the ground it serves."
            },
            {
                icon: "\u2622\uFE0F",
                name: "Reactor Service Lot",
                primary: "stealth-transit",
                support: [
                    "transit-anchor",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Shield doors and access gantries around a dead core housing.",
                longDescription: "Warning chevrons fade across concrete that still remembers heat. Cable stumps jut like bones from panel edges. Everything hums with a silence that feels heavy."
            },
            {
                icon: "\uD83D\uDEE0\uFE0F",
                name: "Data Spine Junction",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Trunk conduits converge into a node of cracked panels and conduit arcs.",
                longDescription: "Cables repeat the curve of the arching ceiling. Labels peel off in satisfying curls. Your headlamp shows dust floating like a slow snowfall."
            },
            {
                icon: "\uD83D\uDED7",
                name: "Access Network Block",
                primary: "transit-anchor",
                support: [
                    "echo-trace",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lift shafts, catwalks, and ladders crisscrossing a deep chamber.",
                longDescription: "Mesh floors draft cool air over your boots. The shaft walls are a history of paint colors layered like sediment. The dark holds its shape until you look into it."
            },
            {
                icon: "\uD83E\uDDF8",
                name: "Nursery Annex Sector",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Quiet block of sealed playrooms, murals eroded to color fields.",
                longDescription: "Small chairs lie on their backs like beetles. A mobile has tangled into a single shape. Everyone left a long time ago, but the rooms still feel paused."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Records Quarter",
                primary: "stealth-transit",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Storage stacks and data cages in a commercial sub-block.",
                longDescription: "Cage doors have slumped out of square. A spill of binders lies like fallen bricks. Your light finds the path numbers and makes them legible for a heartbeat."
            },
            {
                icon: "\uD83C\uDFEC",
                name: "Commerce Plaza",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Lower concourse ringed by shuttered storefronts and dead kiosks.",
                longDescription: "A fountain bowl holds dust instead of water. Kiosk screens are gray mirrors. Every footstep you make has an echo measured in seconds."
            }
        ]
    }
};
const $c1858b438f434f4d$export$85b5153488a36ab6 = {
    civic: [
        "CivicSys",
        "CityWorks",
        "MetroGrid",
        "Municipalix",
        "UrbanNet"
    ],
    industrial: [
        "StrataDyne",
        "HelixCore",
        "OmniForge",
        "FerrumWorks",
        "Rivetron"
    ],
    utilities: [
        "Nextera",
        "Voltline",
        "Auralis",
        "BlueArc",
        "GridNova"
    ],
    retail: [
        "MetroTrade",
        "ApexMart",
        "Cornerline",
        "Shoreline Logistics",
        "Mercantis"
    ],
    bio: [
        "VerdanCo",
        "BioNet",
        "PhytoLabs",
        "GreenRidge",
        "GenExis"
    ],
    defense: [
        "WardTek",
        "Rampart Systems",
        "Bastionex",
        "IronCrest",
        "Shieldline"
    ],
    data: [
        "Archivum",
        "Memora",
        "DataPlain",
        "ByteHarbor",
        "Recorda"
    ]
};
const $c1858b438f434f4d$export$432c04b9bead009 = {
    "shard-cities": [
        "MetroGuard",
        "CivicSys",
        "CityWorks",
        "UrbanNet",
        "MetroGrid",
        "ApexLift",
        "Blockline Security",
        "SentraCore",
        "Wayfinder Transit",
        "Arcology Services"
    ],
    "verdant-reclamation": [
        "VerdanCo",
        "PhytoLabs",
        "BioNet",
        "Greencap Utilities",
        "GardenWorks",
        "Nutrivane",
        "IrrigaTech",
        "SeedSafe",
        "Rootline Systems",
        "Auralis Bio"
    ],
    "sunken-bastions": [
        "HarborFleet",
        "DryDock Systems",
        "Bastionex",
        "BlueArc Marine",
        "Deepline",
        "Breakwater Logistics",
        "WardTek Maritime",
        "Pierstone",
        "Tidewell",
        "Seaforth Controls"
    ],
    "cradle-expanse": [
        "FerrumWorks",
        "OmniForge",
        "StrataDyne",
        "Rivetron",
        "Gantry & Co.",
        "Loadstar Fabrication",
        "ConveyorDynamics",
        "IronCrest",
        "Forgeway",
        "MachinaGrid"
    ],
    "hollow-core": [
        "CivicSys Sublevel",
        "MetroGrid Infrastructure",
        "Nextera Utility",
        "ServiceWay",
        "Subterra Transit",
        "CorridorWorks",
        "Spanline",
        "NodeWest",
        "ControlPoint",
        "Concourse Ops"
    ]
};
const $c1858b438f434f4d$export$2c8d0d917dbcc8a5 = {
    power: [
        "Power Node",
        "Junction Panel",
        "Substation",
        "Transformer Bay",
        "Distribution Rack"
    ],
    storage: [
        "Storage Bay",
        "Records Vault",
        "Supply Depot",
        "Inventory Room",
        "Archive Annex"
    ],
    security: [
        "Security Gate",
        "Checkpoint",
        "Access Control",
        "Barrier Post",
        "Perimeter Gate"
    ],
    infrastructure: [
        "Relay Node",
        "Transit Hub",
        "Service Corridor",
        "Maintenance Bay",
        "Control Room"
    ],
    environmental: [
        "Containment Zone",
        "Hazard Control",
        "Firebreak",
        "Isolation Area",
        "Cleanup Sector"
    ],
    wildlife: [
        "Hive Chamber",
        "Containment Atrium",
        "Observation Pen",
        "Keeper Station",
        "Handling Room"
    ],
    power_infra: [
        "Switchgear Room",
        "Feeder Junction",
        "Utility Interface",
        "Load Center",
        "Breaker Hall"
    ],
    records_data: [
        "Records Cache",
        "Data Vault",
        "Archive Store",
        "Tape Annex",
        "Records Room"
    ]
};
const $c1858b438f434f4d$export$66a51bddf5f03abf = [
    "Block A",
    "Block C",
    "Sector 7",
    "Sector 9",
    "East Annex",
    "West Annex",
    "North Wing",
    "South Wing",
    "Sublevel 2",
    "Sublevel 3",
    "Sublevel 4",
    "Tower 2",
    "Depot Lane",
    "Service Row",
    "Line 3",
    "Bay 12",
    "Bay 17",
    "Midtown Annex"
];
const $c1858b438f434f4d$export$ae5fd03a6b740baa = {
    "shard-cities": [
        "Midtown Annex",
        "Tower 3",
        "Sector 9",
        "Skyway Deck",
        "Service Row"
    ],
    "verdant-reclamation": [
        "Greenhouse 2A",
        "Irrigation Loop B",
        "Seed Wing",
        "Containment Hall",
        "Botany Annex"
    ],
    "sunken-bastions": [
        "Pier 6",
        "Drydock 3",
        "Bulkhead E",
        "Sublevel Pump 2",
        "Bilge Corridor"
    ],
    "cradle-expanse": [
        "Line 3",
        "Bay 12",
        "Casting Floor",
        "Yard 5",
        "Maintenance Track"
    ],
    "hollow-core": [
        "Sublevel 4",
        "Service Spine",
        "Transit Ring",
        "Access Spur",
        "Node J"
    ]
};
const $c1858b438f434f4d$export$68faa9057a77ce7d = {
    "shard-cities": [
        "civic",
        "utilities",
        "data",
        "industrial",
        "retail",
        "defense"
    ],
    "verdant-reclamation": [
        "bio",
        "utilities",
        "civic",
        "industrial",
        "data"
    ],
    "sunken-bastions": [
        "defense",
        "utilities",
        "industrial",
        "civic",
        "data"
    ],
    "cradle-expanse": [
        "industrial",
        "utilities",
        "civic",
        "retail",
        "data"
    ],
    "hollow-core": [
        "civic",
        "utilities",
        "industrial",
        "data",
        "retail"
    ],
    zone: {
        residential: [
            "civic",
            "utilities",
            "bio",
            "retail"
        ],
        commercial: [
            "retail",
            "civic",
            "data",
            "utilities"
        ],
        industrial: [
            "industrial",
            "utilities",
            "defense"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        core: [
            "data",
            "defense",
            "industrial"
        ],
        transit: [
            "civic",
            "utilities",
            "industrial"
        ],
        peripheral: [
            "civic",
            "industrial",
            "retail"
        ],
        entry: [
            "civic",
            "utilities",
            "retail"
        ]
    },
    category: {
        power: [
            "utilities",
            "industrial",
            "civic"
        ],
        storage: [
            "industrial",
            "retail",
            "data"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        infrastructure: [
            "civic",
            "utilities",
            "industrial"
        ],
        environmental: [
            "civic",
            "industrial",
            "utilities"
        ],
        wildlife: [
            "bio",
            "civic",
            "utilities"
        ]
    }
};
// RNG (seeded)
function $c1858b438f434f4d$var$xmur3(str) {
    let h = 1779033703 ^ str.length;
    for(let i = 0; i < str.length; i++){
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    return ()=>{
        h = Math.imul(h ^ h >>> 16, 2246822507);
        h = Math.imul(h ^ h >>> 13, 3266489909);
        return (h ^ h >>> 16) >>> 0;
    };
}
function $c1858b438f434f4d$var$mulberry32(a) {
    return ()=>{
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $c1858b438f434f4d$export$c0b222505a3369f3(seedStr = "") {
    const seed = $c1858b438f434f4d$var$xmur3(seedStr)();
    return $c1858b438f434f4d$var$mulberry32(seed);
}
function $c1858b438f434f4d$var$pick(array, rng) {
    return array[Math.floor(rng() * array.length)];
}
// Brand pool builder with regional weighting
function $c1858b438f434f4d$var$getBrandPool({ regionKey: regionKey, zone: zone, category: category }) {
    const base = $c1858b438f434f4d$export$68faa9057a77ce7d[regionKey] || [
        "civic",
        "industrial",
        "utilities"
    ];
    const zoneBias = $c1858b438f434f4d$export$68faa9057a77ce7d.zone[zone] || [];
    const catBias = $c1858b438f434f4d$export$68faa9057a77ce7d.category[category] || [];
    const order = [
        ...base,
        ...zoneBias,
        ...catBias
    ];
    const weighted = [];
    const regional = $c1858b438f434f4d$export$432c04b9bead009[regionKey] || [];
    for(let i = 0; i < 3; i++)weighted.push(...regional); // heavy regional weight
    order.forEach((bucket, idx)=>{
        const list = $c1858b438f434f4d$export$85b5153488a36ab6[bucket] || [];
        const weight = idx < 2 ? 2 : 1;
        for(let i = 0; i < weight; i++)weighted.push(...list);
    });
    return weighted.length ? weighted : [].concat(...Object.values($c1858b438f434f4d$export$85b5153488a36ab6));
}
function $c1858b438f434f4d$var$getDescriptorPool(category) {
    if (category === "power" && $c1858b438f434f4d$export$2c8d0d917dbcc8a5.power_infra) return [
        ...$c1858b438f434f4d$export$2c8d0d917dbcc8a5.power,
        ...$c1858b438f434f4d$export$2c8d0d917dbcc8a5.power_infra
    ];
    if (category === "storage" && $c1858b438f434f4d$export$2c8d0d917dbcc8a5.records_data) return [
        ...$c1858b438f434f4d$export$2c8d0d917dbcc8a5.storage,
        ...$c1858b438f434f4d$export$2c8d0d917dbcc8a5.records_data
    ];
    return $c1858b438f434f4d$export$2c8d0d917dbcc8a5[category] || $c1858b438f434f4d$export$2c8d0d917dbcc8a5.infrastructure;
}
function $c1858b438f434f4d$var$pickQualifier(regionKey, rng) {
    const base = $c1858b438f434f4d$export$66a51bddf5f03abf;
    const regional = $c1858b438f434f4d$export$ae5fd03a6b740baa[regionKey] || [];
    const pool = [
        ...regional,
        ...regional,
        ...base
    ]; // 2:1 favor regional
    return pool.length ? pool[Math.floor(rng() * pool.length)] : "";
}
function $c1858b438f434f4d$export$6b7290c54feddd3b({ baseName: baseName, regionKey: regionKey, zone: zone, category: category, seed: seed = "" }, count = 5) {
    const rng = $c1858b438f434f4d$export$c0b222505a3369f3(`${seed}|${baseName}|${regionKey}|${zone}|${category}`);
    const brands = $c1858b438f434f4d$var$getBrandPool({
        regionKey: regionKey,
        zone: zone,
        category: category
    });
    const descs = $c1858b438f434f4d$var$getDescriptorPool(category);
    const names = new Set();
    const canon = [
        baseName,
        `${baseName} \u{2013} ${$c1858b438f434f4d$var$pickQualifier(regionKey, rng)}`
    ];
    let safety = 200;
    while(names.size < count && safety-- > 0){
        const brand = $c1858b438f434f4d$var$pick(brands, rng);
        const desc = $c1858b438f434f4d$var$pick(descs, rng);
        const useBaseTerm = rng() < 0.35; // 35% anchor to base term
        const qualifier = rng() < 0.65 ? ` \u{2013} ${$c1858b438f434f4d$var$pickQualifier(regionKey, rng)}` : "";
        const candidate = useBaseTerm ? `${brand} ${baseName}${qualifier}` : `${brand} ${desc}${qualifier}`;
        names.add(candidate);
    }
    for (const c of canon){
        if (names.size >= count) break;
        names.add(c);
    }
    return Array.from(names).slice(0, count);
}
const $c1858b438f434f4d$export$1a6ba7df4555a8dd = {
    defaultTune: {
        buildingScale: 1,
        treeDensity: 1,
        roadWear: 0.15,
        shadowAngle: 45,
        shadowAlpha: 0.85,
        shadowLength: 6,
        lightUptime: 0.12,
        lightFlickerSpeed: 1,
        sinkholeChance: 0.5,
        lightRays: 0,
        // How often a region's own signature props appear — the one pass that is
        // about a PARTICULAR place rather than about a town. 0 turns them off.
        signature: 1,
        // How far inland the sea reaches on a region with a shoreline. 0 = no sea,
        // which is every region but the drowned one.
        floodLevel: 0,
        // How much rock mass has come down around the built ground. Sublevels only.
        enclosure: 0,
        cloudType: 'scattered'
    },
    regions: {
        // Two tiers of architecture per region. `struct` is the ordinary building
        // stock — the sheds, blocks and terraces the whole map is made of. `mass`
        // is the monumental tier: the towers, glasshouses, sea walls, mill frames
        // and pillar halls a region builds at a scale nothing else on the tile
        // reaches. Keeping them apart is what lets shard-cities have warm brown
        // roofs on its small buildings AND cool concrete over them, instead of
        // picking one and reading as somewhere else's town in a filter.
        //
        // The rule both tiers answer to: a structure must separate from the ground
        // it stands on in VALUE, not just in hue. Two regions with the same value
        // relationship look like the same place no matter what colour they are.
        'shard-cities': {
            backdrop: 'city',
            overlay: 'dust',
            tune: {
                buildingScale: 1.3,
                treeDensity: 3,
                roadWear: 0.35,
                shadowAngle: 45,
                shadowAlpha: 0.85,
                shadowLength: 6,
                lightUptime: 0.18,
                lightFlickerSpeed: 1,
                sinkholeChance: 0.5,
                lightRays: 0,
                signature: 1,
                cloudType: 'broken'
            },
            pal: {
                far: '#1c2333',
                // Warm brick and brown roofing, but a stop LIGHTER than it used to be
                // and over darker tarmac. The hue contrast against grey ground always
                // worked; the value contrast did not — seven luma points apart, the
                // roofs sank into the street at map scale and the region read as one
                // undifferentiated grey-brown field.
                struct: '#8a705c',
                structDark: '#15171e',
                structLight: '#b99983',
                mass: '#79828f',
                massDark: '#2a3038',
                massLight: '#a9b6c4',
                ground1: '#3f434e',
                ground2: '#4b5160',
                road: '#20242f',
                metal: '#6b7893',
                rust: '#8a6a4a',
                accent: '#a9bee0',
                veg1: '#3b5841',
                veg2: '#5d8058',
                water1: '#33455c',
                water2: '#55708c',
                glow: '#ffb45e'
            }
        },
        'verdant-reclamation': {
            backdrop: 'greenhouse',
            overlay: 'vines',
            recipes: {
                storage: 'storage-seed'
            },
            tune: {
                buildingScale: 1.1,
                treeDensity: 4,
                roadWear: 0.75,
                cloudType: 'scattered',
                lightUptime: 0.05,
                signature: 1.1
            },
            pal: {
                far: '#4c6350',
                struct: '#7d8a8c',
                structDark: '#455256',
                structLight: '#b0bcba',
                mass: '#9fb0a8',
                massDark: '#4a5a52',
                massLight: '#cfdcd2',
                // The ground is most of the tile, so it decides whether the region reads
                // as flat — and a light mid-green under light grey frames was the whole
                // problem. Taken down to shaded loam, but only halfway: the first attempt
                // went the full distance and the region lost its light instead of gaining
                // contrast. The canopy is darker still, the structures sit well above
                // both, and the tile has a range without going gloomy.
                ground1: '#3e5a34',
                ground2: '#4f5b30',
                road: '#42402f',
                metal: '#8b9598',
                rust: '#8a7050',
                accent: '#d8d2a8',
                // Deep canopy. These are the darkest greens on the tile and the shapes
                // they make are what the eye reads first, so they carry the contrast.
                veg1: '#254d2a',
                veg2: '#4a7a3a',
                water1: '#3f7a70',
                water2: '#6fb0a4',
                glow: '#f4e9c8'
            }
        },
        'sunken-bastions': {
            backdrop: 'harbor',
            overlay: 'flood',
            recipes: {
                storage: 'storage-quay'
            },
            tune: {
                buildingScale: 1.15,
                treeDensity: 1,
                roadWear: 0.4,
                cloudType: 'overcast',
                sinkholeChance: 0.35,
                floodLevel: 1,
                signature: 1
            },
            pal: {
                far: '#3a4854',
                struct: '#6d8290',
                structDark: '#2c3841',
                structLight: '#9db6c2',
                mass: '#7d8f99',
                massDark: '#2c3841',
                massLight: '#a8bcc4',
                ground1: '#4a5450',
                ground2: '#5b6763',
                road: '#39434c',
                metal: '#7b8a93',
                rust: '#b06a3d',
                accent: '#8fc4cc',
                veg1: '#3c5f4c',
                veg2: '#58825e',
                water1: '#2f5c6b',
                water2: '#5a8f9b',
                glow: '#ffd27f'
            }
        },
        'cradle-expanse': {
            backdrop: 'foundry',
            overlay: 'rust',
            recipes: {
                storage: 'storage-silo'
            },
            tune: {
                buildingScale: 1.25,
                treeDensity: 0.8,
                roadWear: 0.3,
                shadowAngle: 15,
                cloudType: 'wispy',
                signature: 1
            },
            pal: {
                far: '#4a3226',
                // The one region whose plant is LIGHTER than its ground. Dark dirt with
                // pale steel on it is the opposite value relationship to shard-cities'
                // dark roofs on grey tarmac, which is what stops two brown regions
                // reading as one.
                struct: '#a5825c',
                structDark: '#3a2417',
                structLight: '#d2ad7f',
                mass: '#a89279',
                massDark: '#4a3a28',
                massLight: '#d3c0a4',
                ground1: '#6b5137',
                ground2: '#7d6244',
                road: '#3d3226',
                metal: '#9c8a6e',
                rust: '#b55a2b',
                accent: '#e8b060',
                veg1: '#635831',
                veg2: '#807236',
                water1: '#5d564a',
                water2: '#7a705c',
                glow: '#ffcf7a'
            }
        },
        'hollow-core': {
            backdrop: 'underground',
            overlay: 'dark',
            // Everything here is lifted a stop from where it was: a sublevel is dark
            // because of its LIGHT, not because its concrete is black. The palette
            // has to survive a x0.5 night tint and a darkness wash on top and still
            // show which parts of the tile are wall.
            tune: {
                buildingScale: 1.1,
                treeDensity: 1,
                roadWear: 0.25,
                lightRays: 1.5,
                enclosure: 1,
                signature: 1.2
            },
            pal: {
                far: '#07080c',
                struct: '#5c6782',
                structDark: '#1b1f2a',
                structLight: '#7f8cad',
                mass: '#6b7690',
                massDark: '#1b1f2a',
                massLight: '#909dbb',
                ground1: '#333a46',
                ground2: '#454d5d',
                road: '#1c212b',
                metal: '#5b6478',
                rust: '#5a4630',
                accent: '#4fa0a0',
                veg1: '#2d473f',
                veg2: '#41684e',
                water1: '#234049',
                water2: '#356470',
                glow: '#ffc46a'
            }
        }
    },
    recipes: {
        power: {
            variants: [
                {
                    elements: [
                        {
                            el: 'transformerPad',
                            x: [
                                9,
                                21
                            ],
                            y: [
                                9,
                                21
                            ]
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                84,
                                93
                            ]
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: [
                                24,
                                30
                            ],
                            w: 3,
                            h: 60,
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: 87,
                            w: [
                                51,
                                60
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'fence',
                            x: 6,
                            y: 6,
                            w: 36,
                            h: 36
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 18
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                15,
                                24
                            ]
                        }
                    ]
                }
            ]
        },
        storage: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crates',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                18
                            ],
                            cols: 3,
                            rows: 2
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        },
                        {
                            el: 'tank',
                            x: [
                                90,
                                99
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: 27,
                            h: 24
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                81,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        // ---- region-specific stock ----
        // A region may point one of the shared recipes at its own layout via
        // `recipes` on its RENDER_CONFIG.regions entry. The signature layer adds a
        // region's landmarks ON TOP of whatever a tile drew; this changes what the
        // tile is made of in the first place, which is the difference between a
        // harbour with containers on it and a harbour built out of them.
        //
        // Kept deliberately few. Every one of these is a second layout to maintain
        // for a recipe that already had one, so it has to earn its place by being
        // somewhere the shared version reads plainly wrong.
        'storage-quay': {
            variants: [
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                12,
                                18
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                42,
                                48
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                69,
                                81
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                66,
                                75
                            ],
                            y: [
                                15,
                                24
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 60,
                            h: 27
                        },
                        {
                            el: 'container',
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                60,
                                72
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        }
                    ]
                }
            ]
        },
        'storage-silo': {
            variants: [
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                24,
                                30
                            ],
                            r: 13
                        },
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                72,
                                81
                            ],
                            y: [
                                45,
                                54
                            ],
                            r: 14
                        },
                        {
                            el: 'pipeline',
                            x: 33,
                            y: [
                                51,
                                57
                            ],
                            w: [
                                30,
                                39
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 12
                        },
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                72,
                                81
                            ],
                            w: 42,
                            h: 24
                        },
                        {
                            el: 'crates',
                            x: [
                                72,
                                84
                            ],
                            y: [
                                78,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        'storage-seed': {
            variants: [
                {
                    elements: [
                        {
                            el: 'glassSpan',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 66,
                            h: 27
                        },
                        {
                            el: 'silo',
                            x: [
                                24,
                                30
                            ],
                            y: [
                                78,
                                87
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                54,
                                63
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 9
                        },
                        {
                            el: 'crates',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                69,
                                78
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                18,
                                24
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 12
                        },
                        {
                            el: 'glassSpan',
                            x: [
                                63,
                                72
                            ],
                            y: [
                                21,
                                30
                            ],
                            w: 33,
                            h: 66
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 3,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        security: {
            elements: [
                {
                    el: 'fence',
                    x: 15,
                    y: 15,
                    w: 90,
                    h: 90,
                    gaps: 1
                },
                {
                    el: 'barrier',
                    x: 24,
                    y: 24
                },
                {
                    el: 'barrier',
                    x: 81,
                    y: 81
                },
                {
                    el: 'vehicle',
                    chance: 0.4,
                    x: [
                        72,
                        84
                    ],
                    y: [
                        78,
                        87
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'building',
                    x: [
                        72,
                        81
                    ],
                    y: [
                        21,
                        30
                    ],
                    w: 18,
                    h: 15
                }
            ]
        },
        infrastructure: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                36,
                                45
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tower',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ]
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 30,
                            w: 3,
                            h: [
                                54,
                                66
                            ],
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 90,
                            w: [
                                54,
                                66
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'tank',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 12
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                }
            ]
        },
        transit: {
            elements: [
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        72,
                        84
                    ],
                    w: 6,
                    h: 27,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        15,
                        27
                    ],
                    w: 27,
                    h: 6,
                    color: 'struct'
                },
                {
                    el: 'vehicle',
                    x: [
                        12,
                        24
                    ],
                    y: [
                        12,
                        24
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'vehicle',
                    chance: 0.6,
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'rubble',
                    x: 12,
                    y: 12,
                    w: 93,
                    h: 93,
                    n: 12
                }
            ]
        },
        environmental: {
            variantKey: 'sinkholeChance',
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                18,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'foliage',
                            x: [
                                15,
                                36
                            ],
                            y: [
                                78,
                                102
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'foliage',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                15,
                                36
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                81,
                                99
                            ],
                            y: [
                                81,
                                99
                            ],
                            r: [
                                9,
                                12
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        // The hole goes down LAST. Scatter drawn over it is debris hanging in
                        // a shaft; drawn under it, the hole simply swallows whatever fell in
                        // and what is left reads as ground that gave way. The pit brings its
                        // own spoil ring with it, so the rim still has a heap on it.
                        {
                            el: 'rubble',
                            x: 12,
                            y: 12,
                            w: 93,
                            h: 93,
                            n: 14
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                36,
                                78
                            ],
                            y: [
                                36,
                                78
                            ]
                        }
                    ]
                }
            ]
        },
        records: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // The two above put a hall in each corner, which leaves a road nowhere to
                // go: mirroring the layout only moves which corner is which. These two
                // range the halls along ONE edge instead, so half the tile stays open —
                // and the mirror decides which half, to suit wherever the road landed.
                // Ranged east-west, for a road crossing that way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: 9,
                            w: [
                                45,
                                54
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                66,
                                72
                            ],
                            y: 9,
                            w: [
                                33,
                                39
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // and ranged north-south, for one crossing the other way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                9,
                                15
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                42,
                                48
                            ]
                        },
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                66,
                                72
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                }
            ]
        },
        habitation: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                30,
                                36
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                81,
                                87
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'rect',
                            repeat: 4,
                            x: [
                                78,
                                105
                            ],
                            y: [
                                81,
                                105
                            ],
                            w: 6,
                            h: 6,
                            color: 'veg1'
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                42,
                                48
                            ],
                            h: [
                                36,
                                42
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                84,
                                96
                            ],
                            y: [
                                15,
                                27
                            ],
                            r: 9
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                // Housing is the one thing that is genuinely built in rows, so two of
                // them: one long range and a shorter one behind it, facing the other way
                // as a back street does. The gap between is the lane.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                69
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            w: [
                                42,
                                57
                            ],
                            h: [
                                21,
                                24
                            ]
                        },
                        {
                            el: 'bush',
                            x: [
                                84,
                                102
                            ],
                            y: [
                                45,
                                63
                            ]
                        }
                    ]
                },
                // and the same row stood on end, so a mirror is not the only way this
                // recipe ever runs north-south
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                54,
                                69
                            ],
                            vert: 1
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                69,
                                75
                            ],
                            y: [
                                15,
                                27
                            ],
                            w: [
                                21,
                                24
                            ],
                            h: [
                                42,
                                57
                            ],
                            vert: 1
                        },
                        {
                            el: 'bush',
                            x: [
                                45,
                                63
                            ],
                            y: [
                                84,
                                102
                            ]
                        }
                    ]
                }
            ]
        },
        commerce: {
            variants: [
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'stalls'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                75,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A parade: shops in a row under one roof, with the lot they served in
                // front of them. One storefront alone reads as a retail park; the row is
                // what a high street is.
                //
                // Both ways round, and both shallower than the storefronts above, because
                // this is the only thing in the recipe that fits on a tile the road runs
                // through. A carriageway swings up to EDGE_SWING off centre, so the
                // clear ground beside one is about 43 units — and a storefront is 46 to
                // 49 deep once the region's scale and its awning are on it. It does not
                // fit in either orientation, in any mirror, which left a market tile on a
                // road as bare ground and some crates. A range 27 to 35 deep clears the
                // carriageway with room to spare, and the north-south copy does the same
                // for a road running the other way, which no mirror of an east-west range
                // can do. The layout pass prefers whichever of the five keeps a structure
                // standing, so a tile with no road through it still gets its big shop.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                12
                            ],
                            w: [
                                57,
                                72
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                12
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                57,
                                72
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                78,
                                87
                            ],
                            y: [
                                15,
                                27
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A corner unit, for where not even a parade reaches. A bend sweeps an L
                // through the tile and leaves a quarter of it clear, which nothing that
                // has to span an axis can use — so the smallest thing this recipe can be
                // is three shops in a corner rather than no shop at all.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'stalls',
                            chance: 0.5
                        }
                    ]
                }
            ]
        },
        reactor: {
            elements: [
                {
                    el: 'reactorCore'
                }
            ]
        },
        // Entry and extraction. A portal is a DEVICE somebody installed and powers,
        // so it stands in a facility rather than out in the open: ranges of
        // blockwork around three sides of the aperture, a transformer feeding it,
        // and the pad itself left clear in the middle (portalPad and portalGlow
        // both draw at the tile centre, and the glow goes down last of all).
        //
        // The buildings sit in one corner-half so the layout pass can mirror them
        // clear of the track that runs up to the tile — every mirror leaves two
        // adjacent sides open, which between them covers whichever edge the road
        // arrives from.
        portal: {
            elements: [
                {
                    el: 'building',
                    x: 9,
                    y: 9,
                    w: [
                        48,
                        57
                    ],
                    h: [
                        21,
                        27
                    ]
                },
                {
                    el: 'building',
                    x: 9,
                    y: [
                        36,
                        42
                    ],
                    w: [
                        21,
                        27
                    ],
                    h: [
                        39,
                        45
                    ]
                },
                {
                    el: 'transformerPad',
                    x: [
                        84,
                        93
                    ],
                    y: [
                        12,
                        18
                    ]
                },
                {
                    el: 'crates',
                    x: [
                        78,
                        87
                    ],
                    y: [
                        72,
                        81
                    ],
                    cols: 2,
                    rows: 2
                },
                // a deck under the aperture, so it reads as installed rather than as
                // something that happened to appear in the yard
                {
                    el: 'rect',
                    x: 36,
                    y: 36,
                    w: 48,
                    h: 48,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 39,
                    y: 39,
                    w: 42,
                    h: 42,
                    color: 'ground2'
                },
                {
                    el: 'portalPad'
                }
            ]
        },
        road: {
            elements: [
                // Debris on the carriageway goes down FIRST, so the frontage below covers
                // what lands on its ground instead of speckling its roofs.
                {
                    el: 'rubble',
                    x: 6,
                    y: 6,
                    w: 105,
                    h: 105,
                    n: 4
                },
                // Frontage. What makes a trunk read as a STREET rather than as a strip of
                // surfacing is the building line either side of it — and the recipe is
                // never told which way the road goes, so it puts a block against all four
                // edges and lets the roadway pick. The layout pass suppresses whatever
                // the road runs through: on a straight run that is the two edges it
                // enters and leaves by, leaving the other two facing each other across
                // the carriageway; on a bend it is the two sides it turns between,
                // leaving the outside of the corner built up. Same rule, no cases.
                //
                // Depth is set so a block stands where a road CAN reach and is dropped
                // when it does. A crossing swings up to EDGE_SWING (24) off centre, so
                // shrinking these until they always survive would leave a strip of open
                // ground between every building and the road it faces — a setback that
                // varies tile to tile and reads as waste. Deep blocks sit tight against
                // the carriageway instead, and where the road hugs one side that side's
                // block goes and the far one stands alone, which is what a street pushed
                // against a boundary actually looks like.
                //
                // The far pair is anchored at 80 rather than hard against the edge, and
                // the near pair at 8: a building is clamped 6 units short of the tile
                // edge, and the layout pass MIRRORS it, so one authored against the edge
                // is measured clamped and then drawn somewhere it is not — bigger than
                // the footprint it was cleared on, with the difference landing on the
                // road. Authored sizes are multiplied by buildingScale (1.3 at most), so
                // 80 + 24 x 1.3 = 111 keeps every one of these inside the clamp at both
                // ends of its mirror, and the two passes agree.
                //
                // Terraced, because a STREET is what this recipe is for. A free-standing
                // block set back behind a carriageway is a depot; a run of units flush
                // along it, sharing party walls, is a street, and the difference is the
                // whole reason a trunk tile exists. The run is authored to the same 8/80
                // anchors and the same depth as the blocks it replaces, so the clamp
                // arithmetic above is unchanged; only what stands on the frontage is.
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 8,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 80,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 8,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 80,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'manhole',
                    chance: 0.5,
                    x: [
                        48,
                        72
                    ],
                    y: [
                        48,
                        72
                    ]
                },
                // Traffic is not in here: drawRoadside lays it against the carriageway off
                // the road's own samples, so it lies parallel to the road and on the
                // shoulder, on every tile the network runs through rather than only on
                // the trunk tiles this recipe draws.
                {
                    el: 'streetLamp',
                    x: {
                        pick: [
                            39,
                            78
                        ]
                    },
                    y: [
                        39,
                        81
                    ]
                }
            ]
        },
        // rest stops are untouched clearings, and they
        // sit in the greenest spots on the map (5x the region's tree density)
        water: {
            treeDensity: 5,
            elements: [
                {
                    el: 'pond'
                }
            ]
        },
        campsite: {
            treeDensity: 5,
            elements: [
                {
                    el: 'tent',
                    x: [
                        15,
                        24
                    ],
                    y: [
                        15,
                        24
                    ]
                },
                {
                    el: 'fireRing',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ]
                },
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        84,
                        96
                    ],
                    w: 18,
                    h: 6,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: [
                        81,
                        96
                    ],
                    y: [
                        18,
                        27
                    ],
                    w: 6,
                    h: 15,
                    color: 'structDark'
                }
            ]
        },
        // Impassable because the ground itself has gone, not because something fell
        // over on it: a shaft or a rift opened here and there is no way across.
        // Collapsed slabs read as debris you could pick your way through, which is
        // exactly what these tiles are not.
        // The hole goes down LAST in every variant. Ground litter drawn over it is
        // debris hanging in mid-air above a drop; drawn under it, the hole swallows
        // whatever fell in and what survives reads as the edge of the collapse.
        // Each hole lays its own spoil around its rim afterwards.
        blocked: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                51,
                                69
                            ],
                            y: [
                                51,
                                69
                            ],
                            r: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                54,
                                66
                            ],
                            y: [
                                48,
                                72
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                48,
                                72
                            ],
                            y: [
                                54,
                                66
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ],
                            vert: 1
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                }
            ]
        }
    },
    // ===============================
    // SKILL ANCHORS
    // ===============================
    // A recipe says what kind of place a tile IS; the anchor says what the team
    // will be doing there. One per skill, chosen from the room's primary skill
    // and drawn ON TOP of the recipe — a power yard still reads as a power yard
    // and also shows its skill. Every skill is the primary of exactly four rooms
    // (see tests/data/skillBalance.test.js), so all fifteen of these are reachable.
    //
    // Same element vocabulary and same interpreter as recipes above, with two
    // differences: coordinates are PLATE-RELATIVE (0,0 is the anchor's own top
    // left, not the tile's), and w/h declare the reserved footprint, which must
    // stay within ANCHOR_MAX (24) so the anchor can never land on the connector
    // cross that joins tiles together.
    //
    // Every entry opens with an anchorPlate: it makes an anchor that overlaps a
    // roof read as apparatus installed there, which is what buys us out of doing
    // collision detection against the recipe. shape marks the faction — square
    // for Dominion, cut for Veil, round for Wilders.
    //
    // The anchor tracks the room's PRIMARY skill, not the event it will run —
    // and the two can disagree, because a room's event pool is primary plus
    // support. That is deliberate: a room runs one to four events, so keying the
    // anchor to any single one of them would mismatch the others regardless. The
    // primary is the only skill true for the whole room. (What does follow the
    // pinned event is the roof cutaway — see the environment field on events.)
    skillAnchors: {
        // ---- Dominion: systems and instrumentation ----
        'signal-relay': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'tower',
                    x: 4,
                    y: 4
                }
            ]
        },
        'system-override': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 5,
                    w: 12,
                    h: 11,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 7,
                    y: 6,
                    w: 10,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 8,
                    w: 8,
                    h: 5,
                    color: 'accent'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 16,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'drone-command': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dronePad',
                    x: 4,
                    y: 4,
                    s: 16
                }
            ]
        },
        'safeguard': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'transformerPad',
                    x: 2,
                    y: 2
                }
            ]
        },
        'quantum-scan': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 7,
                    rings: 1,
                    arm: 1,
                    color: 'accent'
                }
            ]
        },
        // ---- Veil: access and concealment ----
        'lock-breach': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 16,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 19,
                    w: 16,
                    h: 1,
                    color: 'structDark'
                },
                // hazard stripe: a bare metal square reads as nothing from above, and
                // this is the one thing that separates a sealed door from a floor plate
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 2,
                    color: 'accent',
                    alpha: 0.85
                },
                {
                    el: 'manhole',
                    x: 12,
                    y: 13
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 8,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 15,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                }
            ]
        },
        'stealth-transit': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 11,
                    w: 8,
                    h: 2,
                    color: 'accent',
                    alpha: 0.7
                }
            ]
        },
        'echo-trace': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 3,
                    rings: 2,
                    color: 'accent'
                }
            ]
        },
        'signal-mask': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 9,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 1,
                    h: 8,
                    color: 'metal'
                },
                {
                    el: 'speckle',
                    x: 3,
                    y: 3,
                    w: 18,
                    h: 18,
                    n: 10,
                    color: 'accent',
                    alpha: 0.35
                }
            ]
        },
        'transit-anchor': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'crack',
                    x: 4,
                    y: 6,
                    len: 14
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 5,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 18,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                }
            ]
        },
        // ---- Wilders: growth, salvage and containment ----
        'reclamation': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'tank',
                    x: 12,
                    y: 13,
                    r: 8
                },
                {
                    el: 'foliage',
                    x: 16,
                    y: 8,
                    size: 3
                }
            ]
        },
        'growth-control': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 14,
                    h: 12,
                    color: 'ground1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 8,
                    w: 12,
                    h: 2,
                    color: 'veg1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 12,
                    w: 12,
                    h: 2,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 16,
                    w: 12,
                    h: 1,
                    color: 'veg1'
                }
            ]
        },
        'wild-influence': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 13,
                    r: 7,
                    rings: 1,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'bio-shield': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'pipeline',
                    x: 2,
                    y: 6,
                    w: 20
                },
                {
                    el: 'tank',
                    x: 15,
                    y: 15,
                    r: 6
                }
            ]
        },
        'containment': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'fence',
                    x: 2,
                    y: 2,
                    w: 20,
                    h: 20
                },
                {
                    el: 'barrier',
                    x: 3,
                    y: 17
                }
            ]
        }
    }
};



// Worker pool for parallel pathfinding
let $9d958c644e098400$var$pathfindingWorkers = [];
function $9d958c644e098400$export$a048d4b963a3f5ad() {
    const workerCode = `
        function countStepsInPath(gridData, startPos, endPos, excludePath, returnPath, selectedPath) {
            const queue = [{pos: startPos, steps: 0, visited: new Set()}];
            const visited = new Set();

            while (queue.length > 0) {
                const {pos, steps, visited: pathVisited} = queue.shift();
                const posKey = pos.row + ',' + pos.col;

                if (visited.has(posKey)) continue;
                visited.add(posKey);

                if (pos.row === endPos.row && pos.col === endPos.col) {
                    if (returnPath) {
                        const path = new Set(pathVisited);
                        path.add(posKey);
                        return {steps, path};
                    }
                    return steps;
                }

                const directions = [{row: -1, col: 0}, {row: 1, col: 0}, {row: 0, col: -1}, {row: 0, col: 1}];

                for (const dir of directions) {
                    const newRow = pos.row + dir.row;
                    const newCol = pos.col + dir.col;
                    const newPosKey = newRow + ',' + newCol;

                    if (newRow < 0 || newRow >= (gridData.rows || gridData.size) || newCol < 0 || newCol >= (gridData.cols || gridData.size)) continue;
                    if (pathVisited.has(newPosKey)) continue;
                    if (excludePath && excludePath.has(newPosKey) && !(newRow === endPos.row && newCol === endPos.col)) continue;

                    const room = gridData.grid[newRow][newCol];
                    if (!room || room.type === 'blocked') continue;
                    if (room.type === 'exit' && !(newRow === endPos.row && newCol === endPos.col)) continue;

                    const isInPath = selectedPath.some(p => p.row === newRow && p.col === newCol);
                    if (isInPath && !(newRow === endPos.row && newCol === endPos.col)) continue;

                    let newSteps = steps;
                    if (room.type === 'gate' || room.type === 'hazard') {
                        newSteps += 1;
                    }

                    const newVisited = new Set(pathVisited);
                    newVisited.add(posKey);
                    queue.push({pos: {row: newRow, col: newCol}, steps: newSteps, visited: newVisited});
                }
            }
            return returnPath ? Infinity : Infinity;
        }

        function findMultiplePaths(gridData, startPos, endPos, excludePath, depth, selectedPath) {
            const directions = [{row: -1, col: 0}, {row: 1, col: 0}, {row: 0, col: -1}, {row: 0, col: 1}];

            function exploreFrom(pos, visited, stepsLeft, forcedStepCost) {
                const paths = [];

                if (pos.row === endPos.row && pos.col === endPos.col) {
                    return [{steps: forcedStepCost, path: new Set(visited)}];
                }

                if (stepsLeft === 0) {
                    const pathResult = countStepsInPath(gridData, pos, endPos, visited, true, selectedPath);
                    if (pathResult !== Infinity) {
                        visited.forEach(cell => pathResult.path.add(cell));
                        pathResult.steps += forcedStepCost;
                        paths.push(pathResult);
                    }
                    return paths;
                }

                for (const dir of directions) {
                    const newRow = pos.row + dir.row;
                    const newCol = pos.col + dir.col;
                    const newKey = newRow + ',' + newCol;

                    if (newRow < 0 || newRow >= (gridData.rows || gridData.size) || newCol < 0 || newCol >= (gridData.cols || gridData.size)) continue;
                    const room = gridData.grid[newRow][newCol];
                    if (!room || room.type === 'blocked') continue;
                    if (visited.has(newKey)) continue;
                    if (excludePath && excludePath.has(newKey)) continue;
                    if (selectedPath.some(p => p.row === newRow && p.col === newCol)) continue;

                    const stepCost = (room.type === 'gate' || room.type === 'hazard') ? 1 : 0;
                    const newVisited = new Set(visited);
                    newVisited.add(newKey);
                    const subPaths = exploreFrom({row: newRow, col: newCol}, newVisited, stepsLeft - 1, forcedStepCost + stepCost);
                    paths.push(...subPaths);
                }
                return paths;
            }

            const startKey = startPos.row + ',' + startPos.col;
            return exploreFrom(startPos, new Set([startKey]), depth, 0);
        }

        function canReachRoomAndExit(currentPos, targetPos, exitPos, remainingSteps, targetRoom, gridData, selectedPath) {
            const excludeForTargetPath = new Set();
            
            if (targetPos.row !== exitPos.row || targetPos.col !== exitPos.col) {
                excludeForTargetPath.add(exitPos.row + ',' + exitPos.col);
            }

            const depth = remainingSteps <= 9 ? remainingSteps : 9;
            const pathsToTarget = findMultiplePaths(gridData, currentPos, targetPos, excludeForTargetPath, depth, selectedPath);

            if (pathsToTarget.length === 0) {
                return { canReach: false };
            }

            const excludedFromSelectedPath = new Set();
            selectedPath.forEach(step => {
                excludedFromSelectedPath.add(step.row + ',' + step.col);
            });

            for (const pathToTarget of pathsToTarget) {
                const stepsToReachTarget = pathToTarget.steps;
                if (stepsToReachTarget > remainingSteps) continue;

                const excludedForExitCheck = new Set(excludedFromSelectedPath);
                pathToTarget.path.forEach(cell => excludedForExitCheck.add(cell));
                excludedForExitCheck.delete(targetPos.row + ',' + targetPos.col);

                const stepsFromTargetToExit = countStepsInPath(gridData, targetPos, exitPos, excludedForExitCheck, false, selectedPath);
                const totalStepsNeeded = stepsToReachTarget + stepsFromTargetToExit;

                if (stepsFromTargetToExit !== Infinity && totalStepsNeeded <= remainingSteps) {
                    return { canReach: true };
                }
            }
            return { canReach: false };
        }

        self.onmessage = function(e) {
            const { gridData, currentPos, exitPos, remainingSteps, cellsToCheck, selectedPath, calculationId } = e.data;
            const dimmedCells = [];

            for (const cell of cellsToCheck) {
                const { row, col, room } = cell;
                const result = canReachRoomAndExit(currentPos, { row, col }, exitPos, remainingSteps, room, gridData, selectedPath);
                if (!result.canReach) {
                    dimmedCells.push({ row, col });
                }
            }

            self.postMessage({ dimmedCells, calculationId });
        };
    `;
    const blob = new Blob([
        workerCode
    ], {
        type: 'application/javascript'
    });
    return new Worker(URL.createObjectURL(blob));
}
function $9d958c644e098400$export$efe69f901af7b3f6() {
    return $9d958c644e098400$var$pathfindingWorkers.length > 0;
}
function $9d958c644e098400$export$720bfee83fe27440() {
    const workerCount = navigator.hardwareConcurrency || 4;
    $9d958c644e098400$var$pathfindingWorkers = [];
    for(let i = 0; i < workerCount; i++)$9d958c644e098400$var$pathfindingWorkers.push($9d958c644e098400$export$a048d4b963a3f5ad());
}
function $9d958c644e098400$export$e25fa5fd5f04d38c() {
    return $9d958c644e098400$var$pathfindingWorkers;
}









// One-way channel from the raid's resolution code to the map, and the timing
// maths for what it draws.
//
// A skill check resolving is the raid's whole beat, and until now the map said
// nothing about it — the log scrolled and the tiles carried on as they were.
// `processSkillCheckEvent` knows the outcome, whether a synergy variant fired,
// who took the hit and what was salvaged; it posts that here, and the map picks
// it up on its next frame.
//
// A QUEUE rather than a callback, for two reasons. The resolution code is
// headless — it runs in the simulator and under vitest with no renderer at all
// — so it must not hold a reference to one. And the map animates at 12fps while
// the raid loop ticks at 1Hz, so the two are never in the same call stack
// anyway. Nothing here touches the DOM.
/**
 * How long each effect lives, in ms.
 *
 * A synergy runs longest because it has the most to say and is the rarest
 * thing on the list; a failure is the shortest because it is a flinch. All of
 * them are well under the ~1s the raid loop takes to move on, so effects
 * belong to the beat that caused them rather than smearing across the next.
 */ const $b3111b8b2d4b2b7b$export$af2bc5480524a085 = {
    success: 900,
    synergy: 1400,
    failure: 700,
    loot: 1100
};
// The queue is bounded because nothing guarantees anyone drains it: a raid run
// in the simulator, or with the Field screen closed, posts effects that will
// never be drawn. Dropping the OLDEST is deliberate — if the map does come
// back, the newest handful is what it should be showing.
const $b3111b8b2d4b2b7b$var$QUEUE_CAP = 24;
let $b3111b8b2d4b2b7b$var$queue = [];
function $b3111b8b2d4b2b7b$export$5b7d16983d60107d(kind, opts = {}) {
    if (!$b3111b8b2d4b2b7b$export$af2bc5480524a085[kind]) return null;
    const fx = {
        kind: kind,
        memberId: opts.memberId ?? null,
        rarity: opts.rarity || null,
        startMs: (opts.nowMs ?? Date.now()) + (opts.delayMs || 0),
        ttl: $b3111b8b2d4b2b7b$export$af2bc5480524a085[kind],
        // Decorrelates one effect's sparks from the next's without a per-frame
        // random, which would make them shimmer instead of move.
        seed: $b3111b8b2d4b2b7b$var$queue.length * 2654435761 + (opts.memberId ? String(opts.memberId).length * 40503 : 0) >>> 0
    };
    $b3111b8b2d4b2b7b$var$queue.push(fx);
    if ($b3111b8b2d4b2b7b$var$queue.length > $b3111b8b2d4b2b7b$var$QUEUE_CAP) $b3111b8b2d4b2b7b$var$queue.splice(0, $b3111b8b2d4b2b7b$var$queue.length - $b3111b8b2d4b2b7b$var$QUEUE_CAP);
    return fx;
}
function $b3111b8b2d4b2b7b$export$e81dc0d2f0f0a3e4() {
    if (!$b3111b8b2d4b2b7b$var$queue.length) return [];
    const out = $b3111b8b2d4b2b7b$var$queue;
    $b3111b8b2d4b2b7b$var$queue = [];
    return out;
}
function $b3111b8b2d4b2b7b$export$fd4b5295b61ee6bc() {
    $b3111b8b2d4b2b7b$var$queue = [];
}
function $b3111b8b2d4b2b7b$export$f82af1eaff316176(fx, nowMs) {
    return (nowMs - fx.startMs) / fx.ttl;
}
function $b3111b8b2d4b2b7b$export$4eb22852cf19c442(list, nowMs) {
    return (list || []).filter((fx)=>$b3111b8b2d4b2b7b$export$f82af1eaff316176(fx, nowMs) < 1);
}
const $b3111b8b2d4b2b7b$export$2ff71a728686ddfb = (p)=>p < 0 ? 0 : p >= 1 ? 0 : Math.pow(1 - p, 1.8);
const $b3111b8b2d4b2b7b$export$b822c8d32c815bfc = (p)=>p < 0 ? 0 : p >= 1 ? 1 : 1 - Math.pow(1 - p, 2.4);


function $b596e64ef926739f$export$5c6c29dc14ccb545(room, state) {
    if (!state.currentRaid?.raidInProgress) return;
    // Create unified events object if it doesn't exist
    if (!state.currentRaid.raidInProgress.events) state.currentRaid.raidInProgress.events = {
        skillCheckEvents: [],
        bonusLootEvent: null,
        fishingEvent: null
    };
    // Initialize based on room type
    if (room.type === 'water') // Water room: initialize fishing only
    $b596e64ef926739f$var$initializeFishingEvent(room, state);
    else if (room.type === 'gate' || room.type === 'hazard') {
        // Gate/hazard room: initialize skill-check events + conditional bonus loot
        $b596e64ef926739f$export$f778e7c4dbbbd49b(room, state);
        $b596e64ef926739f$export$3e2a422d19cb46bc(room, state);
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Events initialized for ${room.type} room`);
}
function $b596e64ef926739f$export$3d092dd9a898451d(eventData, roomIndex, state, team) {
    const event = eventData.event;
    if (!event?.variants || event.variants.length === 0) return;
    // The SAME variant that will resolve this event. This used to hardcode
    // variants[0], so a team carrying the right cross-faction tool was told about
    // one problem and then read a resolution to a different one — and the 90
    // problem statements on the synergy variants were never shown to anyone.
    const { variant: variant } = $b596e64ef926739f$export$c7f3781b6ac25bb8(event, state, team);
    if (!variant) return;
    const problemText = $b596e64ef926739f$export$dedbe468d8b2fc6c(variant.problem, event, variant);
    const skillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)(event.relatedSkillId);
    const primaryTechniqueName = (0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(event.relatedTechniqueId);
    const techniqueIcon = (0, $42b272c2c0f44bdf$export$bf5389e28ce4699d)(event.relatedTechniqueId);
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{26A0}\u{FE0F} ${skillName}: ${techniqueIcon} ${primaryTechniqueName} Needed <div class="event-problem-text">${problemText}</div>`, 'warning', {
        stepIndex: roomIndex,
        notificationMessage: `\u{26A0}\u{FE0F} ${skillName} - ${variant.title}` // Show toast notification
    });
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Event problem triggered: ${variant.title}`);
}
function $b596e64ef926739f$export$851890b870f423fa(state) {
    if (!state.currentRaid?.raidInProgress?.events) return {
        skillCheckCount: 0,
        hasBonusLoot: false
    };
    const events = state.currentRaid.raidInProgress.events;
    const skillCheckCount = events.skillCheckEvents?.length || 0;
    const hasBonusLoot = !!events.bonusLootEvent;
    return {
        skillCheckCount: skillCheckCount,
        hasBonusLoot: hasBonusLoot
    };
}
function $b596e64ef926739f$export$a1ce0db419e3821f(tier, rarity) {
    const tierMultipliers = $ce6dd72bc4611534$export$9f9786ac427715c7?.bonusEventCascadeMultipliers?.[tier];
    if (tierMultipliers == null) return 1.0;
    if (typeof tierMultipliers === 'number') return tierMultipliers;
    return tierMultipliers[rarity] ?? 1.0;
}
function $b596e64ef926739f$export$8f7497017a33a708(tier, room) {
    const expectedEvents = room.type === 'hazard' ? 1.5 : 3; // midpoints of 1-2 and 2-4
    const directChance = (rarity)=>{
        const perEvent = (0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type);
        return 1 - Math.pow(1 - perEvent, expectedEvents);
    };
    const cascadeStep = (rarity)=>Math.min((0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type) * $b596e64ef926739f$export$a1ce0db419e3821f(tier, rarity), 1);
    // Bonus cascade chain probabilities (bonus event itself awards common outright)
    const bonusRare = cascadeStep('rare');
    const bonusEpic = bonusRare * cascadeStep('epic');
    const bonusLegendary = bonusEpic * cascadeStep('legendary');
    const bonusUnique = bonusLegendary * cascadeStep('unique');
    const combine = (direct, viaBonus)=>1 - (1 - direct) * (1 - viaBonus);
    return {
        common: directChance('common'),
        uncommon: directChance('uncommon'),
        rare: combine(directChance('rare'), bonusRare),
        epic: bonusEpic,
        legendary: bonusLegendary,
        unique: bonusUnique
    };
}
function $b596e64ef926739f$export$3645ad137fdaf2f9(state) {
    if (!state.currentRaid?.raidInProgress?.events) return;
    const events = state.currentRaid.raidInProgress.events;
    // Cleanup skill-check events
    if (events.skillCheckEvents?.length > 0) events.skillCheckEvents = [];
    // Cleanup bonus loot event
    if (events.bonusLootEvent) $b596e64ef926739f$export$adaa23be627dd8c9(state);
    // Cleanup fishing event
    if (events.fishingEvent) $b596e64ef926739f$var$cleanupFishingEvent(state);
}
function $b596e64ef926739f$export$fe4b77ffe9a80e97(state) {
    if (!state.currentRaid?.raidInProgress?.events) return {
        skillCheckEvents: 0,
        bonusLoot: false,
        fishing: false
    };
    const events = state.currentRaid.raidInProgress.events;
    const skillCheckSummary = (events.skillCheckEvents || []).reduce((acc, e)=>({
            ...acc,
            [e.status]: (acc[e.status] || 0) + 1
        }), {});
    return {
        skillCheckEvents: events.skillCheckEvents?.length || 0,
        skillCheckStatus: skillCheckSummary,
        bonusLoot: !!events.bonusLootEvent?.scheduled,
        fishing: events.fishingEvent?.active || false
    };
}
function $b596e64ef926739f$export$a2efc3d0c71d9b81(state, team) {
    if (!state.currentRaid?.raidInProgress?.events) return;
    const raid = state.currentRaid.raidInProgress;
    const currentTime = Date.now() - (raid.roomStartTime || Date.now());
    // Skill-check events run in two phases: 'start' shows the problem, 'end'
    // resolves it. Return at most ONE transition per tick, resolving a finished
    // event before ever starting a new one, and never starting one while another
    // is in progress. This serializes events so a new one cannot begin before the
    // previous has finished - the old code kept the LAST due transition from a
    // forEach and flipped every due event to 'started', so when an event's end
    // and a later event's start fell in the same tick (a frame gap, e.g. after the
    // tab was backgrounded) the start pre-empted the end and the events overlapped.
    if (raid.events.skillCheckEvents?.length > 0) {
        const events = raid.events.skillCheckEvents;
        // 1) Resolve the earliest event whose duration has elapsed.
        let toEnd = null;
        for (const e of events){
            if (e.status === 'started' && currentTime >= e.scheduledTimeMs + e.thisEventDurationMs) {
                if (!toEnd || e.scheduledTimeMs + e.thisEventDurationMs < toEnd.scheduledTimeMs + toEnd.thisEventDurationMs) toEnd = e;
            }
        }
        if (toEnd) return {
            eventLifeCycle: 'end',
            eventType: 'skillCheck',
            eventData: toEnd
        };
        // 2) Start the earliest due event, but only when none is still in progress.
        const anyInProgress = events.some((e)=>e.status === 'started');
        if (!anyInProgress) {
            let toStart = null;
            for (const e of events){
                if (e.status === 'pending' && currentTime >= e.scheduledTimeMs) {
                    if (!toStart || e.scheduledTimeMs < toStart.scheduledTimeMs) toStart = e;
                }
            }
            if (toStart) {
                toStart.status = 'started';
                return {
                    eventLifeCycle: 'start',
                    eventType: 'skillCheck',
                    eventData: toStart
                };
            }
        }
    }
    // Process bonus loot event (only if all skill checks passed)
    if (raid.events.bonusLootEvent) {
        const bonusEvent = raid.events.bonusLootEvent;
        if (bonusEvent.scheduled && !bonusEvent.triggered && $b596e64ef926739f$export$edf2a8e4414546a8(state) && currentTime >= bonusEvent.scheduledTimeMs) return {
            eventLifeCycle: 'start',
            eventType: 'bonusLoot',
            eventData: null
        };
    }
    // Process fishing event (water rooms only)
    if (raid.events.fishingEvent?.active) {
        const fishingEvent = raid.events.fishingEvent;
        if (!fishingEvent.targetActive && Date.now() >= fishingEvent.nextFishTime) return {
            eventLifeCycle: 'start',
            eventType: 'fishing',
            eventData: null
        };
    }
}
// ============================================================================
// Skill-Check Events
// ============================================================================
/**
 * Get all available events for a room based on primary and support skills
 * @param {Object} room - Room object
 * @param {Object} state - gameState object
 * @returns {Array} Array of event definitions matching room skills
 */ // Memoized on the room's skills, which is all the pool depends on — `state`
// is declared for call-site symmetry and has never been read. Worth caching
// because pre-rolling now calls this once per room at grid generation, and the
// simulator builds up to three candidate grids per raid.
const $b596e64ef926739f$var$eventPoolCache = new Map();
function $b596e64ef926739f$export$e0c93437f7880972(room, state) {
    const key = `${room.primary}|${(room.support || []).join(',')}`;
    const cached = $b596e64ef926739f$var$eventPoolCache.get(key);
    if (cached) return cached;
    const allEvents = [
        ...$ce6dd72bc4611534$export$f152896064e09913,
        ...$ce6dd72bc4611534$export$9435522665f2dda4,
        ...$ce6dd72bc4611534$export$1cd1fab9b9844b76
    ];
    // Build set of relevant skill IDs (primary + support)
    const relevantSkills = new Set([
        room.primary,
        ...room.support || []
    ]);
    // Filter events matching any relevant skill
    const pool = allEvents.filter((event)=>relevantSkills.has(event.relatedSkillId || event.favoredSkill));
    $b596e64ef926739f$var$eventPoolCache.set(key, pool);
    return pool;
}
function $b596e64ef926739f$export$1408911de9ef605d(id) {
    for (const list of [
        $ce6dd72bc4611534$export$f152896064e09913,
        $ce6dd72bc4611534$export$9435522665f2dda4,
        $ce6dd72bc4611534$export$1cd1fab9b9844b76
    ]){
        const found = list.find((e)=>e.id === id);
        if (found) return found;
    }
    return null;
}
function $b596e64ef926739f$export$81e7862f0868f5bc(grid) {
    for (const row of grid || [])for (const room of row || []){
        if (!room || room.type !== 'gate' && room.type !== 'hazard') continue;
        const pool = $b596e64ef926739f$export$e0c93437f7880972(room);
        if (!pool.length) continue;
        // the un-multiplied ceiling for this room type; a blackout raid that
        // wants more rolls the extras fresh
        const most = room.type === 'hazard' ? 2 : 4;
        const ids = [];
        let lastIdx = -1;
        for(let i = 0; i < most; i++){
            let idx = Math.floor(Math.random() * pool.length);
            // no two in a row the same, when the pool is big enough to avoid it
            if (pool.length > 1) while(idx === lastIdx)idx = Math.floor(Math.random() * pool.length);
            ids.push(pool[idx].id);
            lastIdx = idx;
        }
        room.plannedEventIds = ids;
    }
    return grid;
}
function $b596e64ef926739f$export$f778e7c4dbbbd49b(room, state) {
    // Get available events for this room
    const availableEvents = $b596e64ef926739f$export$e0c93437f7880972(room, state);
    if (availableEvents.length === 0) {
        console.warn(`No events available for room with primary skill: ${room.primary}`);
        state.currentRaid.raidInProgress.events.skillCheckEvents = [];
        return;
    }
    // Randomly determine event count (1-2 for hazards, 2-4 for gates)
    const eventCountRange = room.type === 'hazard' ? [
        1,
        2
    ] : [
        2,
        4
    ];
    // Overclocked Grid doubles the RANGE, not the roll: doubling afterwards would
    // turn a 1 into a 2 and a 4 into an 8, compressing the low end and blowing
    // out the high one. Scaling the bounds keeps the distribution's shape.
    const rateMultiplier = (0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('eventChanceMultiplier', 1);
    const scaled = eventCountRange.map((n)=>Math.round(n * rateMultiplier));
    const eventCount = scaled[0] + Math.floor(Math.random() * (scaled[1] - scaled[0] + 1));
    // Take the events the grid already committed to (see preRollGridEvents), so
    // the encounter matches what the map has been showing since the grid was
    // drawn. A raid generated before pre-rolling existed — or one whose blackout
    // multiplier asks for more events than were pinned — rolls the remainder
    // here, which is also the whole of the old behaviour.
    const planned = (room.plannedEventIds || []).map($b596e64ef926739f$export$1408911de9ef605d).filter(Boolean);
    const selectedEvents = planned.slice(0, eventCount);
    let lastEventIdx = selectedEvents.length ? availableEvents.indexOf(selectedEvents[selectedEvents.length - 1]) : -1;
    while(selectedEvents.length < eventCount){
        let thisEventIdx = Math.floor(Math.random() * availableEvents.length);
        // the anti-repeat guard used to roll a THIRD index for the push, so it
        // never actually prevented a repeat; the drawn index is the one used now
        if (availableEvents.length > 1) while(thisEventIdx === lastEventIdx)thisEventIdx = Math.floor(Math.random() * availableEvents.length);
        selectedEvents.push(availableEvents[thisEventIdx]);
        lastEventIdx = thisEventIdx;
    }
    // Calculate room duration in seconds
    const jitterPercent = 0.1; // ±10%
    const roomDurationSec = (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * (1 - jitterPercent * eventCount); //account for bonus event in last 15sec
    // Schedule events at semi-random intervals (2 events/min ≈ 30s spacing)
    // Evenly space them across room duration with ±10% jitter
    const eventDurationMs = roomDurationSec / eventCount * 1000;
    let prevEventEndTimeMs = -1;
    const scheduledEvents = selectedEvents.map((event, index)=>{
        let thisEventDurationMs = eventDurationMs;
        const jitterMs = Math.random() * thisEventDurationMs * jitterPercent;
        let scheduledTimeMs = index * thisEventDurationMs + jitterMs;
        if (prevEventEndTimeMs > -1 && scheduledTimeMs < prevEventEndTimeMs) scheduledTimeMs = prevEventEndTimeMs + 1000;
        if (scheduledTimeMs + thisEventDurationMs > (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * 1000) thisEventDurationMs = thisEventDurationMs - (scheduledTimeMs - (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * 1000);
        prevEventEndTimeMs = scheduledTimeMs + thisEventDurationMs;
        return {
            event: event,
            scheduledTimeMs: scheduledTimeMs,
            thisEventDurationMs: thisEventDurationMs,
            status: 'pending',
            index: index
        };
    });
    state.currentRaid.raidInProgress.events.skillCheckEvents = scheduledEvents;
    state.currentRaid.raidInProgress.hasSkillEventFailure = false;
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Scheduled ${eventCount} skill-check events for room`, {
        roomType: room.type,
        eventCount: eventCount,
        baseDuration: room.baseDuration,
        scheduledTimes: scheduledEvents.map((e)=>(e.scheduledTimeMs / 1000).toFixed(1) + 's')
    });
}
function $b596e64ef926739f$export$7408e7aadd9fb0b0(eventData, state, room, team) {
    const { event: event } = eventData;
    const currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    const tier = state.currentRaid.currentRaidGrid.tier;
    // Step 1: Get team skill levels
    const teamSkills = {};
    team.forEach((member)=>{
        Object.entries(member.skills || {}).forEach(([skillId, level])=>{
            teamSkills[skillId] = Math.max(teamSkills[skillId] || 0, level);
        });
    });
    // Step 2 + 3: Select the best available variant (synergy variants need the
    // right cross-faction tool in someone's kit; priority variant[1] > [2] >
    // primary). Shared with logEventProblem so the problem the player was shown
    // and the outcome they get are the same scenario — see resolveEventVariant.
    // The +10% device success bonus below is the gear layer - never gated.
    const { variant: variant, availableTechniques: availableTechniques } = $b596e64ef926739f$export$c7f3781b6ac25bb8(event, state, team);
    if (!variant) {
        console.warn(`Could not select variant for event ${event.id}`);
        return {
            success: false,
            variant: null,
            loot: [],
            damage: 0,
            casualties: []
        };
    }
    // Step 4: Resolve outcome. Flat chance bonuses stack inside the 97% clamp:
    // - device gear bonus when the event's primary technique is tooled up
    // - the equipped skill artifact when it matches the event's skill
    // - the Crosslink Amplifier when a synergy variant actually fired
    const gearBonus = availableTechniques.includes(event.relatedTechniqueId) ? ((0, $42b272c2c0f44bdf$export$96671014a1dabc4c)('technique-success-bonus')?.value || 0) / 100 : 0;
    const artifactBonus = (0, $1b3f8df6e579f420$export$a5a257639bbcfa93)(event.relatedSkillId || event.favoredSkill, state.character) / 100 + (variant.variantIndex > 0 ? (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('faction-synergy-bonus', state.character) / 100 : 0) + // Training Node Deck: only when this room actually has support skills
    (room.support?.length > 0 ? (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('support-skill-bonus', state.character) / 100 : 0);
    const outcome = $b596e64ef926739f$export$6f562e7d3f793247(event, variant, teamSkills, tier, room, gearBonus + artifactBonus);
    // Who the map should play this on. The check resolves against the team's
    // BEST level in the event's skill, so the member holding that level is the
    // one who ran it — which is the honest answer and also the one the player
    // would name if you asked them.
    const actor = $b596e64ef926739f$export$6c65f1aff219e169(event.relatedSkillId || event.favoredSkill, team);
    // Step 5a: If success - generate loot based on rarity drops (like bonus loot)
    let eventLoot = [];
    // Whoever the failure actually landed on, for the map. Declared out here
    // because the damage result is scoped to the failure branch.
    let hitMember = null;
    if (outcome.success) {
        // Generate skill-check event loot using rarity-based drops (common, uncommon, and rare).
        // The pool is filtered to the rolled rarity - the skill's loot pool bottoms out in
        // commons, and an unfiltered pick made every rarity roll shovel mostly commons.
        const eventRarities = [
            'common',
            'uncommon',
            'rare'
        ];
        const fullLootPool = $b596e64ef926739f$export$6f1a1ae8eddfba2c(event, state);
        for (const rarity of eventRarities){
            const dropChance = (0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type);
            if (Math.random() < dropChance) {
                const lootPool = fullLootPool.filter((itemId)=>(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId)?.rarity === rarity);
                if (lootPool.length > 0) {
                    // Get quantity range for this rarity (utility artifacts can boost)
                    const quantityRange = (0, $00c60928d2fcd8b8$export$540736c4d7813ac)(rarity, tier, room.type);
                    const quantity = $b596e64ef926739f$export$65439b695d7608c2(typeof quantityRange === 'number' ? quantityRange : Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min, room, state.character);
                    // Select items from skill-specific loot pool, weighted by per-item drop weights
                    for(let q = 0; q < quantity && lootPool.length > 0; q++){
                        const picked = (0, $00c60928d2fcd8b8$export$2cbb40695b9e7336)(lootPool);
                        if (picked) eventLoot.push(picked);
                    }
                }
            }
        }
        // Synergy bonus: a synergy variant's combined approach recovers one
        // extra guaranteed salvage pick - rare/uncommon at their normal odds,
        // falling back to a common so the jackpot never comes up empty
        if (variant.variantIndex > 0) for (const rarity of [
            'rare',
            'uncommon',
            'common'
        ]){
            const pool = fullLootPool.filter((itemId)=>(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId)?.rarity === rarity);
            if (pool.length === 0) continue;
            if (rarity !== 'common' && Math.random() >= (0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type)) continue;
            const picked = (0, $00c60928d2fcd8b8$export$2cbb40695b9e7336)(pool);
            if (picked) {
                eventLoot.push(picked);
                break;
            }
        }
    } else {
        const raid = state.currentRaid.raidInProgress;
        const hazardReduction = room.type === 'hazard' ? (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('hazard-damage-reduction', state.character) : 0;
        const canPreventKnockout = (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('knockout-prevention', state.character) > 0 && !raid.knockoutPrevented;
        const damageResult = $b596e64ef926739f$export$8c917c953701923b(tier, team, {
            damageMultiplier: 1 - hazardReduction / 100,
            preventKnockout: canPreventKnockout
        });
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, "DAMAGED", damageResult.damage);
        eventData.damage = damageResult.damage;
        eventData.casualties = damageResult.casualties;
        hitMember = damageResult.member;
        raid.hasSkillEventFailure = true;
        if (damageResult.knockoutPrevented) {
            raid.knockoutPrevented = true;
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F6E1}\u{FE0F} ${damageResult.member.name} is stabilized at the brink \u{2014} the injector fires before they fall!`, 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: `\u{1F6E1}\u{FE0F} ${damageResult.member.name} stabilized`
            });
        }
    }
    // The map's version of the same news. Posted here rather than off the log
    // messages below, because a log line is prose and this has to key off what
    // actually happened: a synergy variant is `variantIndex > 0`, and a failure
    // is played on whoever took the hit, not on whoever ran the check.
    if (outcome.success) (0, $b3111b8b2d4b2b7b$export$5b7d16983d60107d)(variant.variantIndex > 0 ? 'synergy' : 'success', {
        memberId: actor?.id
    });
    else (0, $b3111b8b2d4b2b7b$export$5b7d16983d60107d)('failure', {
        memberId: (hitMember ?? actor)?.id
    });
    // Step 6: Show UI message with technique name substitutions
    const messageText = $b596e64ef926739f$export$dedbe468d8b2fc6c(outcome.success ? variant.success || 'Event succeeded!' : variant.fail || 'Event failed!', event, variant);
    // Marker and title OUTSIDE the flavour span, matching logEventProblem's
    // shape: the header is what happened, the prose is what it felt like. They
    // shared one span until the prose was styled down, which would have taken
    // the tick or the cross down with it.
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`${outcome.success ? "\u2713" : "\u2717"} ${variant.title}<div class="event-outcome-text">${messageText}</div>`, outcome.success ? 'success' : 'failure', {
        stepIndex: currentRoomIndex,
        notificationMessage: `${outcome.success ? "\u2713" : "\u2717"} ${variant.title}`
    });
    // Step 6a: On success, celebrate a fired synergy variant and auto-deploy
    // a technique consumable (if carried)
    if (outcome.success) {
        if (variant.variantIndex > 0 && variant.synergyTechniqueId) {
            const synergyTechniqueName = (0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(variant.synergyTechniqueId);
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{26A1} Synergy: ${synergyTechniqueName} amplifies the approach \u{2014} extra salvage recovered!`, 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: `\u{26A1} Synergy: ${synergyTechniqueName}`
            });
        }
        $b596e64ef926739f$export$2ebfe836f4eff9d2(event, state, room);
    }
    // Step 6b: Award loot and credits on success
    if (outcome.success && eventLoot.length > 0) {
        // Group loot by item ID to show quantities
        const lootMap = {};
        eventLoot.forEach((item)=>{
            lootMap[item] = (lootMap[item] || 0) + 1;
        });
        // Award loot and display messages
        let lootMessage = '';
        Object.entries(lootMap).forEach(([itemId, amount], idx)=>{
            (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, itemId, amount);
            const itemName = (0, $42b272c2c0f44bdf$export$31330438f6059b08)(itemId);
            lootMessage += (idx == 0 ? '' : ', ') + `${amount}x ${itemName}`;
            // One mote per distinct find, held back a beat each so a good haul
            // arrives as a run of finds rather than a single flash. The rarity is
            // what the mote is coloured by, which is the whole point of showing it
            // on the map at all: a rare coming up looks different from a common.
            (0, $b3111b8b2d4b2b7b$export$5b7d16983d60107d)('loot', {
                memberId: actor?.id,
                rarity: (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId)?.rarity,
                delayMs: 260 + idx * 220
            });
        });
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{26A1} Salvaged: ${lootMessage}!`, 'bonus', {
            stepIndex: currentRoomIndex
        });
        // Award event success credits
        const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
        if (tierData && tierData.creditRewards) {
            let eventCredits = tierData.creditRewards.successEventCredit;
            // Apply credit scaling multipliers
            eventCredits = (0, $00c60928d2fcd8b8$export$78a769585121af92)(eventCredits, tier);
            (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, 'Credits', eventCredits);
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4B0} Intelligence Bonus: ${eventCredits} Credits`, 'bonus', {
                stepIndex: currentRoomIndex
            });
        }
    }
    // Step 7: Mark event as completed
    eventData.status = outcome.success ? 'completed' : 'failed';
    return {
        success: outcome.success,
        variant: variant,
        loot: eventLoot,
        damage: eventData.damage || 0,
        casualties: eventData.casualties || [],
        outcome: outcome
    };
}
function $b596e64ef926739f$export$65439b695d7608c2(quantity, room, character) {
    let pct = (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('loot-quantity-bonus', character);
    if (room?.type === 'gate') pct += (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('gate-material-bonus', character);
    if (pct <= 0 || quantity <= 0) return quantity;
    const boosted = quantity * (1 + pct / 100);
    const floor = Math.floor(boosted);
    return floor + (Math.random() < boosted - floor ? 1 : 0);
}
function $b596e64ef926739f$export$2ebfe836f4eff9d2(event, state, room) {
    const raid = state.currentRaid?.raidInProgress;
    if (!raid) return null;
    if (!room?.baseDuration || room.baseDuration <= 0) return null;
    const techniqueId = event.relatedTechniqueId;
    if (!techniqueId) return null;
    const rigged = raid.riggedTechniques = raid.riggedTechniques || {};
    let item = null;
    let firstRig = false;
    if (rigged[techniqueId]) item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', rigged[techniqueId]);
    else {
        const inventory = state.character?.inventory;
        if (!inventory) return null;
        const itemId = Object.keys(inventory).find((id)=>{
            if ((inventory[id] || 0) <= 0) return false;
            const candidate = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
            return candidate?.type === 'consumable' && candidate.techniqueId === techniqueId && (candidate.effects?.['room-time-reduction'] || 0) > 0;
        });
        if (!itemId) return null;
        item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
        inventory[itemId]--;
        if (inventory[itemId] <= 0) delete inventory[itemId];
        rigged[techniqueId] = itemId;
        firstRig = true;
    }
    if (!item) return null;
    const pct = item.effects?.['room-time-reduction'] || 0;
    if (pct <= 0) return null;
    const reductionSec = room.baseDuration * (pct / 100);
    const reductionMs = reductionSec * 1000;
    raid.roomStartTime -= reductionMs;
    raid.nextRoomTime -= reductionMs;
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(firstRig ? `${item.icon} ${item.name} rigged for this raid \u{2014} ${(0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(techniqueId)} rooms run ${pct}% faster (\u{2212}${Math.round(reductionSec)}s)` : `${item.icon} ${item.name}: cleared ${Math.round(reductionSec)}s off the room`, 'bonus', {
        stepIndex: raid.currentRoomIndex,
        notificationMessage: firstRig ? `${item.icon} ${item.name} rigged for this raid` : `${item.icon} \u{2212}${Math.round(reductionSec)}s off the room`
    });
    return {
        item: item,
        reductionSec: reductionSec,
        firstRig: firstRig
    };
}
// ---------------------------------------------------------------------------
// Synergy partner maps (cached from event definitions). Every event carries
// two cross-faction synergy variants; these lookups answer "which techniques
// can upgrade this skill's events" and the reverse - the data behind the
// contractor-hiring synergy indicators.
// ---------------------------------------------------------------------------
let $b596e64ef926739f$var$synergyPartnersBySkill = null; // skillId -> Set<partner techniqueId>
let $b596e64ef926739f$var$synergySkillsByTechnique = null; // techniqueId -> Set<skillId it upgrades>
let $b596e64ef926739f$var$synergyPartnersByTechnique = null; // primary techniqueId -> Set<partner techniqueId>
function $b596e64ef926739f$var$buildSynergyMaps() {
    $b596e64ef926739f$var$synergyPartnersBySkill = {};
    $b596e64ef926739f$var$synergySkillsByTechnique = {};
    $b596e64ef926739f$var$synergyPartnersByTechnique = {};
    const allEvents = [
        ...$ce6dd72bc4611534$export$f152896064e09913,
        ...$ce6dd72bc4611534$export$9435522665f2dda4,
        ...$ce6dd72bc4611534$export$1cd1fab9b9844b76
    ];
    for (const event of allEvents){
        const skill = event.relatedSkillId || event.favoredSkill;
        for (const v of event.variants || []){
            if (!v.synergyTechniqueId) continue;
            ($b596e64ef926739f$var$synergyPartnersBySkill[skill] ||= new Set()).add(v.synergyTechniqueId);
            ($b596e64ef926739f$var$synergySkillsByTechnique[v.synergyTechniqueId] ||= new Set()).add(skill);
            if (event.relatedTechniqueId) ($b596e64ef926739f$var$synergyPartnersByTechnique[event.relatedTechniqueId] ||= new Set()).add(v.synergyTechniqueId);
        }
    }
}
function $b596e64ef926739f$export$3a3bfc913ac4efaa(skillId) {
    if (!$b596e64ef926739f$var$synergyPartnersBySkill) $b596e64ef926739f$var$buildSynergyMaps();
    return $b596e64ef926739f$var$synergyPartnersBySkill[skillId] || new Set();
}
function $b596e64ef926739f$export$9f7e6ebcfcd92245(techniqueId) {
    if (!$b596e64ef926739f$var$synergySkillsByTechnique) $b596e64ef926739f$var$buildSynergyMaps();
    return $b596e64ef926739f$var$synergySkillsByTechnique[techniqueId] || new Set();
}
function $b596e64ef926739f$export$fe6715e7f54582df(techniqueId) {
    if (!$b596e64ef926739f$var$synergyPartnersByTechnique) $b596e64ef926739f$var$buildSynergyMaps();
    return $b596e64ef926739f$var$synergyPartnersByTechnique[techniqueId] || new Set();
}
function $b596e64ef926739f$export$271813734e1c621(event, availableTechniques) {
    const variants = event.variants || [];
    if (variants.length === 0) {
        console.warn(`Event ${event.id} has no variants`);
        return null;
    }
    const techSet = new Set(availableTechniques);
    // Priority: variant[1] synergy > variant[2] synergy > variant[0] primary
    for(let i = 1; i < Math.min(3, variants.length); i++){
        if (variants[i].synergyTechniqueId && techSet.has(variants[i].synergyTechniqueId)) return {
            ...variants[i],
            variantIndex: i
        };
    }
    // Fallback to primary-only variant
    return {
        ...variants[0],
        variantIndex: 0
    };
}
function $b596e64ef926739f$export$6c65f1aff219e169(skillId, team) {
    if (!skillId || !team?.length) return team?.[0] || null;
    let best = null, bestLevel = -1;
    for (const m of team){
        if (m?.isAlive === false) continue;
        const level = m?.skills?.[skillId] || 0;
        if (level > bestLevel) {
            bestLevel = level;
            best = m;
        }
    }
    return best || team.find((m)=>m?.isAlive !== false) || team[0];
}
function $b596e64ef926739f$export$c7f3781b6ac25bb8(event, state, team) {
    // Available techniques = the team's equipped skill gear (one per skill per
    // member). Gear is the gate: skills make a technique attemptable, the
    // equipped tool unlocks synergy variants and the success bonus. Members may
    // be raw character/contractor objects (equippedTechniqueGear map) or
    // initializeRaidTeam snapshots (equippedTechniques array).
    const availableTechniques = [];
    (team || []).forEach((member)=>{
        const techniques = member.equippedTechniques || Object.keys(member.equippedTechniqueGear || {});
        techniques.forEach((t)=>availableTechniques.push(t));
    });
    // Per-skill synergy unlocks gate WHICH techniques may drive a synergy variant
    // (either-side rule): allowed when the event's skill is unlocked, or when the
    // technique is the player's own gear from an unlocked skill.
    const character = state?.character;
    const playerTechniques = new Set(Object.keys(character?.equippedTechniqueGear || {}));
    const eventSkillUnlocked = (0, $1b3f8df6e579f420$export$7d626adf944498ee)(event.relatedSkillId || event.favoredSkill, character);
    const synergyCapable = availableTechniques.filter((t)=>eventSkillUnlocked || playerTechniques.has(t) && (0, $1b3f8df6e579f420$export$7d626adf944498ee)((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(t), character));
    return {
        variant: $b596e64ef926739f$export$271813734e1c621(event, synergyCapable),
        availableTechniques: availableTechniques
    };
}
function $b596e64ef926739f$export$dedbe468d8b2fc6c(text, event, variant) {
    if (!text) return text;
    let out = text.replace(/@techName/g, (0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(event.relatedTechniqueId));
    if (variant?.synergyTechniqueId) out = out.replace(/@synergyTechName/g, (0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(variant.synergyTechniqueId));
    return out;
}
function $b596e64ef926739f$export$2ad5af141c2ca6d2(skillLevel, targetSkillLevel, supportBonus = 0) {
    const chance = 0.76 + (skillLevel - targetSkillLevel) * 0.05 + supportBonus;
    return Math.max(0.20, Math.min(0.97, chance));
}
function $b596e64ef926739f$export$6f562e7d3f793247(event, variant, teamSkills, raidTier, room, gearBonus = 0) {
    // Get target skill level from raid tier configuration
    const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[raidTier] || {
        gateSkillLevel: 50,
        hazardSkillLevel: 40
    };
    const targetSkillLevel = room.type === 'gate' ? tierData.gateSkillLevel : tierData.hazardSkillLevel;
    // Get primary skill level for this event
    const primarySkill = event.favoredSkill || event.relatedSkillId;
    const primarySkillLevel = teamSkills[primarySkill] || 0;
    // Calculate skill difference
    const skillDiff = primarySkillLevel - targetSkillLevel;
    // Calculate support bonus from support skills (capped at 0.15)
    let supportBonus = 0;
    if (room.support && Array.isArray(room.support)) {
        const supportSum = room.support.reduce((sum, skillId)=>sum + (teamSkills[skillId] || 0), 0);
        supportBonus = Math.min(supportSum * 0.1, 0.15);
    }
    // Calculate success chance using raid formula. The equipped-gear bonus
    // rides through the same clamp, so the 97% ceiling still applies.
    const successChance = $b596e64ef926739f$export$2ad5af141c2ca6d2(primarySkillLevel, targetSkillLevel, supportBonus + gearBonus);
    // Roll 1d100 (0-100)
    const roll = Math.random() * 100;
    const success = roll < successChance * 100;
    return {
        success: success,
        chance: successChance,
        roll: roll / 100,
        skillDiff: skillDiff,
        supportBonus: supportBonus,
        gearBonus: gearBonus,
        targetSkillLevel: targetSkillLevel,
        primarySkillLevel: primarySkillLevel
    };
}
function $b596e64ef926739f$export$6f1a1ae8eddfba2c(event, state) {
    const favoredSkill = event.favoredSkill || event.relatedSkillId;
    const favoredTechnique = event.favoredTechnique || event.relatedTechniqueId;
    const materialIds = new Set();
    const visitedItems = new Set();
    // Get all recipes
    const allRecipes = [
        ...$ce6dd72bc4611534$export$c4df318d1f4ad4 || [],
        ...$ce6dd72bc4611534$export$c95766f8298d6ed1 || [],
        ...$ce6dd72bc4611534$export$12c2125da4fa007 || [],
        ...$ce6dd72bc4611534$export$ded4d2beb9be271a || []
    ];
    // Get all craftable items (excludes common and blueprints which can't be crafted)
    const craftableItems = [
        ...$ce6dd72bc4611534$export$2508a374b14b8e59 || [],
        ...$ce6dd72bc4611534$export$241bdd39c3e59b72 || [],
        ...$ce6dd72bc4611534$export$439a14874f0a75e4 || [],
        ...$ce6dd72bc4611534$export$b2b2210935a03dc3 || [],
        ...$ce6dd72bc4611534$export$c1a4d9d859d3b7 || [],
        ...$ce6dd72bc4611534$export$a24b2f292778b5dc || [],
        ...$ce6dd72bc4611534$export$29d1bf8c74230d20 || [],
        ...$ce6dd72bc4611534$export$71b953a5ed5f0cd6 || [],
        ...$ce6dd72bc4611534$export$76261a034023b29 || [],
        ...$ce6dd72bc4611534$export$7a39b013515e9c7d || [],
        ...$ce6dd72bc4611534$export$659d2bfa35449fc3 || [],
        ...$ce6dd72bc4611534$export$709aa55c173a48b8 || []
    ];
    /**
   * Recursively collect every recipe component at every depth: craftable
   * intermediates (uncommon/rare materials, consumables) AND base leaves.
   * The room's skill loot must span the whole chain toward its epic
   * gear/artifacts, not just the commons the chain bottoms out in —
   * otherwise uncommon/rare rarity rolls find an empty pool and drop nothing.
   */ const collectIngredients = (itemId)=>{
        if (visitedItems.has(itemId)) return;
        visitedItems.add(itemId);
        const recipe = allRecipes.find((r)=>r.target === itemId);
        if (!recipe || !recipe.inputs) return;
        recipe.inputs.forEach((input)=>{
            if (!input.id) return;
            materialIds.add(input.id);
            collectIngredients(input.id);
        });
    };
    // Find all items related to this skill/technique and collect ingredients
    craftableItems.filter((item)=>{
        // Match by skill (for skill artifacts) or by techniqueId (for epic items)
        return item.skill === favoredSkill || item.techniqueId === favoredTechnique;
    }).forEach((item)=>collectIngredients(item.id));
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `Loot pool for event ${event.id} (skill: ${favoredSkill}, technique: ${favoredTechnique}): ${materialIds.size} materials`);
    return Array.from(materialIds);
}
function $b596e64ef926739f$export$8c917c953701923b(raidTier, team, options = {}) {
    const { damageMultiplier: damageMultiplier = 1, preventKnockout: preventKnockout = false } = options;
    if (!team || team.length === 0) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, "TEAM MISSING");
        return {
            damaged: false,
            member: null,
            damage: 0,
            casualties: []
        };
    }
    // Find alive team members only
    const aliveMembers = team.filter((m)=>m.isAlive);
    if (aliveMembers.length === 0) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, "TEAM DEAD ALREADY");
        return {
            damaged: false,
            member: null,
            damage: 0,
            casualties: []
        };
    }
    // Select random alive member
    const member = aliveMembers[Math.floor(Math.random() * aliveMembers.length)];
    // Apply damage using configurable tier scaling
    const dmgConfig = $ce6dd72bc4611534$export$9f9786ac427715c7?.skillEventDamage || {};
    let minDamage, maxDamage;
    // Check if per-tier damage is configured
    if (dmgConfig.perTier && dmgConfig.perTier[raidTier]) {
        const tierDamage = dmgConfig.perTier[raidTier];
        minDamage = tierDamage.min ?? 5;
        maxDamage = tierDamage.max ?? 15;
    } else {
        // Fall back to baseDamage * tier formula
        const baseDamage = dmgConfig.baseDamage ?? 5;
        minDamage = baseDamage * raidTier;
        maxDamage = minDamage + baseDamage * raidTier;
    }
    const damage = Math.max(1, Math.round((minDamage + Math.floor(Math.random() * (maxDamage - minDamage + 1))) * damageMultiplier));
    member.currentHp = Math.max(0, member.currentHp - damage);
    const casualties = [];
    let knockoutPrevented = false;
    if (member.currentHp <= 1) {
        if (preventKnockout) {
            // Stabilized at the brink instead of falling
            member.currentHp = 1;
            knockoutPrevented = true;
        } else {
            member.isAlive = false;
            casualties.push(member);
        }
    }
    return {
        damaged: true,
        member: member,
        damage: damage,
        casualties: casualties,
        knockoutPrevented: knockoutPrevented
    };
}
function $b596e64ef926739f$export$edf2a8e4414546a8(state) {
    if (!state.currentRaid?.raidInProgress?.events) return false;
    // Bonus triggers only if no skill event failures occurred
    return !state.currentRaid.raidInProgress.hasSkillEventFailure;
}
function $b596e64ef926739f$export$3e2a422d19cb46bc(room, state) {
    if (!state.currentRaid?.raidInProgress?.events) return;
    // Schedule bonus at room duration - 15 seconds (converted to milliseconds)
    const bonusEventTimeMs = room.baseDuration == 0 ? 0 : (room.baseDuration - 15) * 1000;
    state.currentRaid.raidInProgress.events.bonusLootEvent = {
        scheduled: true,
        scheduledTimeMs: bonusEventTimeMs,
        triggered: false,
        active: false,
        element: null,
        roomIndex: state.currentRaid.raidInProgress.currentRoomIndex
    };
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Scheduled bonus loot event at ${bonusEventTimeMs / 1000}s for room ${room.type}`);
}
function $b596e64ef926739f$export$dfbeebc3d1509da(room, tier, rarity, character = null) {
    const loot = {};
    const quantityRange = (0, $00c60928d2fcd8b8$export$540736c4d7813ac)(rarity, tier, room.type);
    const quantity = $b596e64ef926739f$export$65439b695d7608c2(Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min, room, character);
    const itemPool = $b596e64ef926739f$export$ded25040c5f0ed12(room, tier, rarity);
    if (rarity === 'legendary') (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `[LEGENDARY] generateBonusLoot: tier=${tier}, itemPool.length=${itemPool.length}, quantity=${quantity}`);
    // Relic Resonance Tuner: relics get a heavier hand inside mixed pools
    // without inflating the rest of the pool's drop odds
    const relicBoostPct = (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('relic-quality-bonus', character);
    const boost = relicBoostPct > 0 ? {
        predicate: (id)=>(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id)?.type === 'relic',
        multiplier: 1 + relicBoostPct / 100
    } : null;
    // Select item from pool, weighted by per-item drop weights
    if (itemPool.length > 0) {
        const item = (0, $00c60928d2fcd8b8$export$2cbb40695b9e7336)(itemPool, boost);
        loot[item] = quantity;
        if (rarity === 'legendary') (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `[LEGENDARY] Selected item: ${item}`);
    } else if (rarity === 'legendary') console.warn(`[LEGENDARY] No items in pool! Cannot generate loot.`);
    return loot;
}
/**
 * Get item pool for a specific rarity tier
 * @param {Object} room - Room object
 * @param {Number} tier - Raid tier
 * @param {string} rarity - Rarity tier
 * @returns {Array} Array of item IDs that can drop at this rarity
 */ // Union of the room's skill-chain pools (every recipe component reachable
// from the epic gear/artifacts tied to the room's primary+support skills).
// Cached per skill signature — pure config data.
const $b596e64ef926739f$var$roomChainCache = new Map();
function $b596e64ef926739f$var$getRoomChainMaterials(room) {
    const key = `${room.primary || ''}|${(room.support || []).slice().sort().join(',')}`;
    if ($b596e64ef926739f$var$roomChainCache.has(key)) return $b596e64ef926739f$var$roomChainCache.get(key);
    const set = new Set();
    for (const event of $b596e64ef926739f$export$e0c93437f7880972(room, null))for (const id of $b596e64ef926739f$export$6f1a1ae8eddfba2c(event, null))set.add(id);
    $b596e64ef926739f$var$roomChainCache.set(key, set);
    return set;
}
function $b596e64ef926739f$export$ded25040c5f0ed12(room, tier, rarity) {
    let itemPool = [];
    switch(rarity){
        case 'common':
        case 'uncommon':
        case 'rare':
            {
                // Scope bonus materials to the room's skill chains so bonus events
                // reinforce the room's signature instead of re-washing every faction
                // material into every faction room. Fall back to the faction pool if
                // the intersection is empty (e.g. a room with no chain materials at
                // this rarity) so the bonus roll never comes up empty-handed.
                const factionPool = (0, $00c60928d2fcd8b8$export$10ac30a050ae6642)(room, rarity);
                const chain = $b596e64ef926739f$var$getRoomChainMaterials(room);
                const scoped = factionPool.filter((id)=>chain.has(id));
                itemPool = scoped.length > 0 ? scoped : factionPool;
                break;
            }
        case 'epic':
            const tierRarity = (0, $00c60928d2fcd8b8$export$65aa634013c8a9db)(tier);
            // Exclude HP/Energy consumables from epic loot (now purchaseable only)
            const epicConsumables = (0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('consumable', tierRarity).filter((item)=>item !== 'field-health-stim' && item !== 'portable-energy-pack' && item !== 'recovery-injector-mk2' && item !== 'energy-conversion-pack' && item !== 'advanced-recovery-serum' && item !== 'power-cell-mk3');
            itemPool = epicConsumables.concat((0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('relic', tierRarity));
            break;
        case 'legendary':
            itemPool = (0, $00c60928d2fcd8b8$export$61bdab8a63df855c)(room);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `[LEGENDARY] getItemPoolForRarity: found ${itemPool.length} blueprints for faction ${(0, $00c60928d2fcd8b8$export$ad0c244e6b90d977)(room)}`);
            if (itemPool.length === 0) console.warn(`[LEGENDARY] WARNING: No blueprints found for room with primary=${room.primary}`);
            break;
        case 'unique':
            itemPool = tier >= 4 ? (0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('storyRelic') : [];
            break;
        default:
            itemPool = [];
    }
    return itemPool;
}
// ============================================================================
// PLANNING: which items a room could drop (for the raid-grid item highlight)
// ============================================================================
const $b596e64ef926739f$var$SKILL_CHECK_RARITIES = [
    'common',
    'uncommon',
    'rare'
];
const $b596e64ef926739f$var$ALL_RARITIES = [
    'common',
    'uncommon',
    'rare',
    'epic',
    'legendary',
    'unique'
];
function $b596e64ef926739f$export$a8a308eea90e6ddf(room, tier, opts = {}) {
    const ids = new Set();
    if (!room || !room.type) return ids;
    if (room.type === 'water') {
        ids.add('Fish');
        return ids;
    }
    if (room.type !== 'gate' && room.type !== 'hazard') return ids;
    const itemsById = opts.itemsById || new Map((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)().map((i)=>[
            i.id,
            i
        ]));
    const canDrop = {};
    for (const r of $b596e64ef926739f$var$ALL_RARITIES)canDrop[r] = (0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(r, tier, room.type) > 0;
    // Skill-check pool — recipe components tied to the room's skills
    for (const event of $b596e64ef926739f$export$e0c93437f7880972(room, null))for (const itemId of $b596e64ef926739f$export$6f1a1ae8eddfba2c(event, null)){
        const rarity = itemsById.get(itemId)?.rarity;
        if ($b596e64ef926739f$var$SKILL_CHECK_RARITIES.includes(rarity) && canDrop[rarity]) ids.add(itemId);
    }
    // Bonus-loot pools per droppable rarity
    for (const r of $b596e64ef926739f$var$ALL_RARITIES){
        if (!canDrop[r]) continue;
        for (const itemId of $b596e64ef926739f$export$ded25040c5f0ed12(room, tier, r))ids.add(itemId);
    }
    ids.delete('Credits');
    return ids;
}
function $b596e64ef926739f$export$433f18e5bfab36e1(gridData) {
    const itemToCells = new Map();
    if (!gridData || !gridData.grid) return {
        itemToCells: itemToCells,
        items: []
    };
    const itemsById = new Map((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)().map((i)=>[
            i.id,
            i
        ]));
    const tier = gridData.tier;
    const rows = gridData.rows || gridData.grid.length;
    const cols = gridData.cols || (gridData.grid[0] ? gridData.grid[0].length : 0);
    const bySignature = new Map(); // signature -> Set<itemId>
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const room = gridData.grid[row]?.[col];
        if (!room || room.type === 'blocked') continue;
        const sig = `${room.type}|${room.primary || ''}|${(room.support || []).slice().sort().join(',')}`;
        let set = bySignature.get(sig);
        if (!set) {
            set = $b596e64ef926739f$export$a8a308eea90e6ddf(room, tier, {
                itemsById: itemsById
            });
            bySignature.set(sig, set);
        }
        for (const id of set){
            let cells = itemToCells.get(id);
            if (!cells) {
                cells = [];
                itemToCells.set(id, cells);
            }
            cells.push({
                row: row,
                col: col
            });
        }
    }
    // Sorted distinct item list: by rarity order, then display name. 'Fish' has
    // no catalog entry — bucket it last as a "Special" group.
    const rarityOrder = (r)=>$ce6dd72bc4611534$export$d4a72d069095e9e5?.[r]?.order ?? 99;
    const items = Array.from(itemToCells.keys()).map((id)=>{
        const item = itemsById.get(id);
        return {
            id: id,
            type: item?.type || '',
            rarity: item?.rarity || 'special',
            count: itemToCells.get(id).length
        };
    }).sort((a, b)=>{
        const oa = a.rarity === 'special' ? 100 : rarityOrder(a.rarity);
        const ob = b.rarity === 'special' ? 100 : rarityOrder(b.rarity);
        if (oa !== ob) return oa - ob;
        return (0, $42b272c2c0f44bdf$export$31330438f6059b08)(a.id).localeCompare((0, $42b272c2c0f44bdf$export$31330438f6059b08)(b.id));
    });
    return {
        itemToCells: itemToCells,
        items: items
    };
}
function $b596e64ef926739f$export$adaa23be627dd8c9(state) {
    const bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    if (typeof document != 'undefined' && bonusEvent.element && bonusEvent.element.parentNode) bonusEvent.element.remove();
    bonusEvent.active = false;
    bonusEvent.scheduled = false;
    bonusEvent.triggered = false;
    bonusEvent.element = null;
    bonusEvent.roomIndex = null;
}
function $b596e64ef926739f$export$852a40f600fb6319(state) {
    const bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    const currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    // Verify we're still in the right room
    if (currentRoomIndex !== bonusEvent.roomIndex) {
        bonusEvent.scheduled = false;
        return;
    }
    // Distribute bonus loot (starting with common rarity, cascades up)
    $b596e64ef926739f$export$480ef632888d5e53(state, 'common');
    // Clean up the event
    $b596e64ef926739f$export$adaa23be627dd8c9(state);
}
function $b596e64ef926739f$export$480ef632888d5e53(state, rarity = 'common') {
    if (state.currentRaid.raidInProgress == null) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, "tried to process bonus loot event after raid ended");
        return;
    }
    const currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    const pathStep = state.currentRaid.selectedPath[currentRoomIndex];
    const room = pathStep.room;
    const tier = state.currentRaid.currentRaidGrid.tier;
    if (rarity === 'common') {
        // The base bonus rewards faction intel CREDITS instead of common items:
        // the team logs field data valuable to the faction. Keeps common material
        // income demand-shaped (weighted event loot only) and feeds the shared
        // credit pool that multiplayer team members split.
        const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
        const intelCredits = (0, $00c60928d2fcd8b8$export$78a769585121af92)(tierData?.creditRewards?.successEventCredit || 15, tier);
        (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, 'Credits', intelCredits);
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F9E0} Field Intelligence: the team files what this site remembers \u{2014} ${intelCredits} credits!`, 'bonus', {
            stepIndex: currentRoomIndex,
            notificationMessage: `\u{1F9E0} Field Intelligence: +${intelCredits} credits`
        });
    } else {
        // Cascaded tiers award items from the room-faction pool
        const bonusLoot = $b596e64ef926739f$export$dfbeebc3d1509da(room, tier, rarity, state.character);
        Object.entries(bonusLoot).forEach(([item, amount])=>{
            (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, item, amount);
            const itemName = (0, $42b272c2c0f44bdf$export$31330438f6059b08)(item);
            const rarityIcons = {
                rare: "\uD83D\uDC8E",
                epic: "\uD83D\uDCDC",
                legendary: "\uD83D\uDCDC",
                unique: "\uD83C\uDF1F"
            };
            const icon = rarityIcons[rarity] || "\u2728";
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`${icon} Exploration Bonus: Found ${amount}x ${itemName}!`, 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: `${icon} Exploration Bonus: ${amount}x ${itemName}!`
            });
        });
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `Bonus loot (${rarity}) awarded:`, bonusLoot);
    }
    // Cascade to next rarity tier using same drop chances as normal loot
    const rarityProgression = {
        common: 'rare',
        rare: 'epic',
        epic: 'legendary',
        legendary: 'unique'
    };
    const nextRarity = rarityProgression[rarity];
    if (nextRarity) {
        let cascadeChance = (0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(nextRarity, tier, room.type);
        // Apply per-rarity cascade multiplier from config
        const cascadeMultiplier = $b596e64ef926739f$export$a1ce0db419e3821f(tier, nextRarity);
        cascadeChance = cascadeChance * cascadeMultiplier;
        // Memory Crystal Shard: relative boost on the step INTO legendary
        // (where blueprints live) - "the crystal resonates with blueprint caches"
        if (nextRarity === 'legendary') cascadeChance *= 1 + (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('blueprint-find-bonus', state.character) / 100;
        const cascadeRoll = Math.random();
        // Guarded: the message re-calls getRarityDropChance(), so building it
        // unconditionally would cost a lookup per cascade roll.
        if ((0, $8fffcb1ac554ad26$export$5540f6562bfea743)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot)) (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).loot, `Cascade from ${rarity} to ${nextRarity}: baseChance=${((0, $00c60928d2fcd8b8$export$d2ef23ef6c7c6dd5)(nextRarity, tier, room.type) * 100).toFixed(4)}%, multiplier=${cascadeMultiplier}, finalChance=${(cascadeChance * 100).toFixed(4)}%, roll=${(cascadeRoll * 100).toFixed(4)}%, triggers=${cascadeRoll < cascadeChance}`);
        if (cascadeRoll < cascadeChance) {
            if (typeof document != 'undefined') setTimeout(()=>{
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83C\uDFB0 Extra bonus loot discovered!", 'success');
                $b596e64ef926739f$export$480ef632888d5e53(state, nextRarity);
            }, 500);
            else {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83C\uDFB0 Extra bonus loot discovered!", 'success');
                $b596e64ef926739f$export$480ef632888d5e53(state, nextRarity);
            }
        }
    }
}
// ============================================================================
// FISHING EVENT (WATER ROOMS)
// ============================================================================
/**
 * Initialize fishing event for water rooms
 * Sets up fishing state and schedules first fish to spawn after 15 seconds
 * @param {Object} room - Room object (type === 'water')
 * @param {Object} state - gameState object
 */ function $b596e64ef926739f$var$initializeFishingEvent(room, state) {
    if (!state.currentRaid?.raidInProgress?.events) return;
    state.currentRaid.raidInProgress.events.fishingEvent = {
        active: true,
        targetActive: false,
        nextFishTime: Date.now() + (typeof document !== 'undefined' ? 15000 : 0),
        count: 0,
        element: null,
        roomIndex: state.currentRaid.raidInProgress.currentRoomIndex
    };
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, 'Fishing event initialized for water room');
}
/**
 * Cleanup fishing event when leaving water room
 * Removes active fish and deactivates fishing
 * @param {Object} state - gameState object
 */ function $b596e64ef926739f$var$cleanupFishingEvent(state) {
    const fishingEvent = state.currentRaid?.raidInProgress?.events?.fishingEvent;
    if (!fishingEvent) return;
    if (fishingEvent.element && fishingEvent.element.parentNode) fishingEvent.element.remove();
    fishingEvent.active = false;
    fishingEvent.targetActive = false;
    fishingEvent.element = null;
    fishingEvent.roomIndex = null;
}
function $b596e64ef926739f$export$4fe3116762178ea8(state, roomIndex) {
    const raid = state.currentRaid.raidInProgress;
    (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(raid.lootGained, 'Fish', 1);
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F3A3} Caught 1x Fish!`, 'success', {
        stepIndex: roomIndex,
        notificationMessage: `\u{1F3A3} Caught Fish!`
    });
}
function $b596e64ef926739f$export$555d86a21075197e(state) {
    const raid = state.currentRaid.raidInProgress;
    const fishingEvent = raid.events.fishingEvent;
    // Don't spawn if already active or room changed
    if (fishingEvent.count >= 5 || fishingEvent.targetActive || fishingEvent.roomIndex !== raid.currentRoomIndex) return false;
    // No browser to click the fish — auto-catch it and award the loot
    $b596e64ef926739f$export$4fe3116762178ea8(state, fishingEvent.roomIndex);
    fishingEvent.count++;
    fishingEvent.targetActive = false;
    fishingEvent.nextFishTime = Date.now();
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Fish caught (count: ${fishingEvent.count})`);
    return true;
}
// ============================================================================
// EVENT PRESENTATION (INJECTABLE)
// ============================================================================
// How a bonus-loot / fishing event is presented when it fires. The default
// is the headless auto-grant above, which the 90-day simulator and unit tests
// rely on. In the browser, raid.js calls setEventPresenters() to swap in the
// clickable collectibles from eventSystem.js, so the player must click the
// diamond / fish to collect the reward — the original intended behavior.
let $b596e64ef926739f$var$bonusLootPresenter = $b596e64ef926739f$export$852a40f600fb6319;
let $b596e64ef926739f$var$fishingPresenter = $b596e64ef926739f$export$555d86a21075197e;
function $b596e64ef926739f$export$26550d9454cb718e({ bonusLoot: bonusLoot, fishing: fishing } = {}) {
    if (bonusLoot) $b596e64ef926739f$var$bonusLootPresenter = bonusLoot;
    if (fishing) $b596e64ef926739f$var$fishingPresenter = fishing;
}
function $b596e64ef926739f$export$4e4214e38193ac1d() {
    $b596e64ef926739f$var$bonusLootPresenter = $b596e64ef926739f$export$852a40f600fb6319;
    $b596e64ef926739f$var$fishingPresenter = $b596e64ef926739f$export$555d86a21075197e;
}
function $b596e64ef926739f$export$de2180cc63765512(state) {
    return $b596e64ef926739f$var$bonusLootPresenter(state);
}
function $b596e64ef926739f$export$99ca7bb292cc775d(state) {
    return $b596e64ef926739f$var$fishingPresenter(state);
}


//@ts-check
/**
 * Event System Module
 *
 * Unified event handling for:
 * - Skill-check events (from event definitions)
 * - Bonus loot events (conditional on skill event success)
 * - Fishing events (water rooms only)
 *
 * All events are scheduled and processed through this module.
 * Integrates with raid.js for room progression timing.
 */ 






function $cb32f532d45e570f$export$88787157d4846f70() {
    (0, $b596e64ef926739f$export$26550d9454cb718e)({
        bonusLoot: $cb32f532d45e570f$var$spawnBonusLootEvent,
        fishing: $cb32f532d45e570f$var$spawnFish
    });
}
function $cb32f532d45e570f$export$93eaf817d66094f2({ automated: automated }) {
    if (automated) (0, $b596e64ef926739f$export$4e4214e38193ac1d)();
    else $cb32f532d45e570f$export$88787157d4846f70();
}
function $cb32f532d45e570f$export$a6b9fb5db39e986b(state, team) {
    if (!state.currentRaid?.raidInProgress?.events) return;
    const raid = state.currentRaid.raidInProgress;
    const pathStep = state.currentRaid.selectedPath[raid.currentRoomIndex];
    const eventInfo = (0, $b596e64ef926739f$export$a2efc3d0c71d9b81)(state, team);
    if (eventInfo?.eventLifeCycle == 'start') switch(eventInfo.eventType){
        case 'skillCheck':
            (0, $b596e64ef926739f$export$3d092dd9a898451d)(eventInfo.eventData, raid.currentRoomIndex, state, team);
            break;
        case 'bonusLoot':
            $cb32f532d45e570f$var$spawnBonusLootEvent(state);
            break;
        case 'fishing':
            $cb32f532d45e570f$var$spawnFish(state);
            break;
    }
    else if (eventInfo?.eventLifeCycle == 'end') switch(eventInfo.eventType){
        case 'skillCheck':
            (0, $b596e64ef926739f$export$7408e7aadd9fb0b0)(eventInfo.eventData, state, pathStep.room, team);
            break;
    }
}
// ============================================================================
// BONUS LOOT EVENT (CONDITIONAL)
// ============================================================================
/**
 * Spawn bonus loot event when it triggers
 * Creates clickable icon on grid that players must click to claim bonus
 * @param {Object} state - gameState object
 */ function $cb32f532d45e570f$var$spawnBonusLootEvent(state) {
    const bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    const currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    // Verify we're still in the right room
    if (currentRoomIndex !== bonusEvent.roomIndex) {
        bonusEvent.scheduled = false;
        return;
    }
    // Find the current room cell
    const pathStep = state.currentRaid.selectedPath[currentRoomIndex];
    const cell = document.querySelector(`[data-row="${pathStep.row}"][data-col="${pathStep.col}"]`);
    if (!cell) {
        console.error('Could not find current room cell for bonus event');
        bonusEvent.scheduled = false;
        return;
    }
    // Create bonus event target element (diamond icon)
    const target = document.createElement('div');
    target.className = 'loot-event-target';
    target.innerHTML = "\uD83D\uDC8E";
    target.title = 'Click for bonus loot!';
    // Position randomly within cell bounds
    const margin = 25; // Percentage from edge
    const leftPercent = margin + Math.random() * (100 - 2 * margin);
    const topPercent = margin + Math.random() * (100 - 2 * margin);
    target.style.left = `${leftPercent}%`;
    target.style.top = `${topPercent}%`;
    // Add click handler
    target.addEventListener('click', (e)=>{
        e.stopPropagation();
        $cb32f532d45e570f$var$handleBonusLootClick(state);
    });
    // Add to cell
    cell.appendChild(target);
    // Update state
    bonusEvent.active = true;
    bonusEvent.scheduled = false;
    bonusEvent.triggered = true;
    bonusEvent.element = target;
    // Play sound effect
    const audio = new Audio('./sounds/chime.mp3');
    audio.volume = 0.3;
    audio.play().catch(()=>{}); // Ignore if autoplay blocked
    // Notify user with persistent toast
    const roomEndTime = state.currentRaid.raidInProgress.nextRoomTime;
    $cb32f532d45e570f$var$showBonusLootToast(roomEndTime);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Bonus loot event spawned in room ${currentRoomIndex}`);
}
// The live bonus-loot toast, or null. Module-level so the click handler can
// retract it the moment the loot is collected.
let $cb32f532d45e570f$var$bonusToast = null;
/**
 * Announce a bonus loot event, counting down the window to collect it.
 *
 * Used to be a hand-rolled `#bonus-event-toast` pinned to the opposite corner
 * from every other notification. It is now a sticky toast in the shared row:
 * sticky because a 5s fade is exactly how a timed opportunity gets missed, and
 * shared because there was no reason for this one message to have its own
 * widget beyond sticky support not existing yet.
 *
 * Sticky here still means "does not fade on a timer", NOT "stays forever" — the
 * offer expires with the room, and a toast still advertising it afterwards
 * would be worse than one that faded. It retracts on collect, at the countdown,
 * and if the event goes inactive for any other reason.
 *
 * @param {Number} roomEndTime - epoch ms when the room (and the offer) ends
 */ function $cb32f532d45e570f$var$showBonusLootToast(roomEndTime) {
    $cb32f532d45e570f$var$bonusToast?.dismiss(); // never stack two
    const secondsLeft = ()=>Math.max(0, Math.ceil((roomEndTime - Date.now()) / 1000));
    const label = (secs)=>`\u{1F48E} Bonus loot! Click the \u{1F48E} in the room \u{2014} ${secs}s left`;
    $cb32f532d45e570f$var$bonusToast = (0, $0c8e0782d8c2833e$export$c7def531c087da85)(label(secondsLeft()), 'warning', {
        sticky: true
    });
    if (!$cb32f532d45e570f$var$bonusToast) return; // no container
    const handle = $cb32f532d45e570f$var$bonusToast;
    const tick = ()=>{
        if (handle !== $cb32f532d45e570f$var$bonusToast) return; // superseded by a newer event
        // Watch the event itself, not just the clock. cleanupRoomEvents() clears
        // `active` when the room ends or the raid is abandoned, and that lives in
        // headless core where it cannot reach the DOM — so the toast follows the
        // flag rather than needing a callback plumbed out of core.
        const offer = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress?.events?.bonusLootEvent;
        const secs = secondsLeft();
        if (secs <= 0 || !offer?.active) {
            handle.dismiss();
            $cb32f532d45e570f$var$bonusToast = null;
            return;
        }
        handle.update(label(secs));
        setTimeout(tick, 1000);
    };
    setTimeout(tick, 1000);
}
/**
 * Handle click on bonus loot target
 * Distributes cascading bonus loot and cleans up
 * @param {Object} state - gameState object
 */ function $cb32f532d45e570f$var$handleBonusLootClick(state) {
    const bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    if (!bonusEvent.active || !bonusEvent.element) return;
    // Distribute bonus loot (starting with common rarity, cascades up)
    (0, $b596e64ef926739f$export$480ef632888d5e53)(state, 'common');
    // Clean up the event
    (0, $b596e64ef926739f$export$adaa23be627dd8c9)(state);
    // Retract the offer immediately rather than waiting for the next countdown
    // tick to notice the event went inactive.
    $cb32f532d45e570f$var$bonusToast?.dismiss();
    $cb32f532d45e570f$var$bonusToast = null;
    // Update UI
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, 'Bonus loot event clicked and distributed');
}
// ============================================================================
// FISHING EVENT (WATER ROOMS)
// ============================================================================
/**
 * Spawn a fish target in the room for player to click
 * Called when fishing timer triggers
 * @param {Object} state - gameState object
 */ function $cb32f532d45e570f$var$spawnFish(state) {
    const raid = state.currentRaid.raidInProgress;
    const fishingEvent = raid.events.fishingEvent;
    // Don't spawn if already active or room changed
    if (fishingEvent.targetActive || fishingEvent.roomIndex !== raid.currentRoomIndex) return;
    // Get the cell
    const pathStep = state.currentRaid.selectedPath[fishingEvent.roomIndex];
    const cell = document.querySelector(`[data-row="${pathStep.row}"][data-col="${pathStep.col}"]`);
    if (!cell) return;
    // Create fish target element
    const fish = [
        "\uD83D\uDC1F",
        "\uD83D\uDC20",
        "\uD83E\uDD9E",
        "\uD83E\uDD80"
    ];
    const target = document.createElement('div');
    target.className = 'loot-event-target';
    target.innerHTML = fish[Math.floor(Math.random() * 4)];
    target.title = 'Click to catch fish!';
    // Position randomly within cell bounds
    const margin = 15;
    const leftPercent = margin + Math.random() * (100 - 2 * margin);
    const topPercent = margin + Math.random() * (100 - 2 * margin);
    target.style.left = `${leftPercent}%`;
    target.style.top = `${topPercent}%`;
    // Add click handler
    target.addEventListener('click', (e)=>{
        e.stopPropagation();
        $cb32f532d45e570f$var$catchFish(state);
    });
    // Add to cell
    cell.appendChild(target);
    // Update state
    fishingEvent.targetActive = true;
    fishingEvent.element = target;
    // Play sound effect
    const audio = new Audio('./sounds/fish.mp3');
    audio.volume = 0.3;
    audio.play().catch(()=>{});
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, 'Fish spawned for catching');
}
/**
 * Handle fish catch when player clicks fish
 * Awards Fish item and schedules next fish
 * @param {Object} state - gameState object
 */ function $cb32f532d45e570f$var$catchFish(state) {
    const raid = state.currentRaid.raidInProgress;
    const fishingEvent = raid.events.fishingEvent;
    if (!fishingEvent.targetActive) return;
    // Remove the target
    if (fishingEvent.element) {
        fishingEvent.element.remove();
        fishingEvent.element = null;
    }
    // Award the catch (shared with the headless auto-catch path)
    (0, $b596e64ef926739f$export$4fe3116762178ea8)(state, fishingEvent.roomIndex);
    fishingEvent.count++;
    fishingEvent.targetActive = false;
    fishingEvent.nextFishTime = Date.now() + 15000; // Next fish in 15 seconds
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, `Fish caught (count: ${fishingEvent.count}):`, fishLoot);
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
} // ============================================================================
 // EXPORTED FUNCTIONS SUMMARY
 // ============================================================================
 // Public API for raid.js integration:
 // - initializeRoomEvents(room, state) - Called when entering room
 // - processScheduledEvents(state, team) - Called each tick in main loop
 // - cleanupRoomEvents(state) - Called when room completes
 // - getEventsSummary(state) - For UI/debugging
 //
 // Internal functions (private to this module):
 // - Skill-check events: getEventsForRoom, scheduleSkillCheckEvents, selectEventVariant,
 //   resolveSkillCheckOutcome, generateSkillEventLootPool, applySkillEventDamage,
 //   processSkillCheckEvent
 // - Bonus loot: shouldTriggerBonusLoot, scheduleConditionalBonusLoot, spawnBonusLootEvent,
 //   showBonusLootToast, handleBonusLootClick, processBonusLootEvent, generateBonusLoot,
 //   getItemPoolForRarity, cleanupBonusLootEvent
 // - Fishing: initializeFishingEvent, spawnFish, catchFish, cleanupFishingEvent


// Always-animated raid map tiles. Each grid cell gets a live TILE_PX canvas
// and a cached still layer: a frame is a blit of that layer, a multiply for
// the hour, then only the things that actually move (canopies, lamps, clouds
// — see the static/dynamic split in roomImageGen.js). World-space effects
// sample by grid row/col, so neighboring tiles stay seamless without a
// whole-map canvas.
/**
 * Procedural room background generator for the raid grid.
 *
 * Composes a 120x120 top-down pixel-art map tile for any room from a
 * shared element library (roofs, pads, crates, fences, trees, water...)
 * arranged by a recipe chosen from the room name, painted and weathered
 * with the owning region's theme. Road/path connectors meet at cell edges
 * so the whole grid reads as one continuous map, and opts.anim drives the
 * live effects: wind, day/night, clouds, powered lights, daylight wells.
 *
 * Deterministic: the same room name in the same region always yields the
 * same image (seeded with the same PRNG the room-naming system uses).
 * Selection logic is pure and Node-safe; only the renderer touches the DOM.
 */ 
/**
 * Road network for a raid grid — pure, seedless, DOM-free.
 *
 * The map used to draw a road cross on every tile, because the connector
 * directions came from "is this neighbour walkable", which is true almost
 * everywhere. Every tile therefore looked the same and the roads said nothing
 * about the place.
 *
 * A grid now gets ONE major route that bisects it edge to edge, wandering
 * rather than running straight, plus minor pathways branching off it until
 * most of the map is reachable from a road. A tile draws road only where the
 * network runs, and only toward the neighbours it actually continues to.
 *
 * The trunk becomes road ROOMS (fast travel) — see createRoadNetwork. The
 * minor pathways are a visual layer only: they run over whatever room is
 * already there, so encounter counts and raid duration are untouched.
 *
 * Directions carry their OWN rank, not the tile's. A trunk tile that anchors a
 * branch continues at full width along the trunk and leaves as a narrow lane
 * toward the branch, so the branch starts at the roadway rather than at the
 * tile edge.
 */ const $eaa96db7af263115$export$39615881bb0d21f6 = 'major';
const $eaa96db7af263115$export$f23edc19d247fd25 = 'minor';
const $eaa96db7af263115$var$DIRS = {
    n: [
        -1,
        0
    ],
    s: [
        1,
        0
    ],
    e: [
        0,
        1
    ],
    w: [
        0,
        -1
    ]
};
const $eaa96db7af263115$var$OPPOSITE = {
    n: 's',
    s: 'n',
    e: 'w',
    w: 'e'
};
const $eaa96db7af263115$export$6013c12dea2de543 = 3;
const $eaa96db7af263115$var$key = (row, col)=>`${row},${col}`;
function $eaa96db7af263115$var$shuffle(list, rand) {
    const out = [
        ...list
    ];
    for(let i = out.length - 1; i > 0; i--){
        const j = Math.floor(rand() * (i + 1));
        [out[i], out[j]] = [
            out[j],
            out[i]
        ];
    }
    return out;
}
function $eaa96db7af263115$var$dirBetween(a, b) {
    if (b.row === a.row - 1 && b.col === a.col) return 'n';
    if (b.row === a.row + 1 && b.col === a.col) return 's';
    if (b.row === a.row && b.col === a.col + 1) return 'e';
    if (b.row === a.row && b.col === a.col - 1) return 'w';
    return null;
}
/**
 * A wandering line of cells from one edge of the grid to the opposite one.
 *
 * The two ends are chosen up front, at least MIN_TERMINUS_OFFSET apart across
 * the axis, and the jogs are then dealt out to walk between them. Rolling each
 * jog independently (as an earlier version did) let a route come out nearly
 * straight whenever the rolls happened to cancel.
 */ function $eaa96db7af263115$var$bisectingRoute(rows, cols, horizontal, rand) {
    const span = horizontal ? cols : rows;
    const cross = horizontal ? rows : cols;
    const offset = Math.min($eaa96db7af263115$export$6013c12dea2de543, cross - 1);
    const slots = Math.max(1, span - 1);
    // A jog costs a slot, and a route with a jog in every slot is a staircase.
    // Half the slots is the ceiling — enough to wander, and it leaves a straight
    // stretch between every turn. Small grids are where this bites: seven columns
    // give six slots, and an unbounded drift wanted a turn in all of them.
    const maxJogs = Math.max(offset, Math.ceil(slots / 2));
    const startLane = Math.floor(rand() * cross);
    // land the far end at least `offset` away, and no further than the route has
    // slots to get there in
    const room = [];
    for(let lane = 0; lane < cross; lane++){
        const away = Math.abs(lane - startLane);
        if (away >= offset && away <= maxJogs) room.push(lane);
    }
    const endLane = room.length ? room[Math.floor(rand() * room.length)] : cross - 1 - startLane;
    // one jog per unit of drift, plus a cancelling pair when there is slack for
    // it, so the route wanders instead of walking a clean diagonal
    const drift = endLane - startLane;
    const steps = [];
    for(let i = 0; i < Math.abs(drift); i++)steps.push(Math.sign(drift));
    if (steps.length + 2 <= maxJogs && rand() < 0.5) {
        steps.push(1);
        steps.push(-1);
    }
    for(let i = steps.length - 1; i > 0; i--){
        const j = Math.floor(rand() * (i + 1));
        [steps[i], steps[j]] = [
            steps[j],
            steps[i]
        ];
    }
    // One jog per slot, each in its own column. Letting a slot take two steps
    // allowed a +1 and a -1 to land together, which walked the route off its
    // lane and straight back onto the cell it had just left.
    //
    // The jogs are then SPREAD rather than scattered: the run is divided into one
    // bucket per jog and each jog placed somewhere inside its own bucket, which
    // leaves a straight stretch between turns. Picking slots at random let
    // several land in consecutive columns, and a route that turns in every column
    // crosses the map as a staircase — a pattern rather than a road.
    const at = new Map();
    const used = steps.slice(0, Math.min(slots, maxJogs));
    used.forEach((step, i)=>{
        const lo = Math.floor(i * slots / used.length);
        const hi = Math.max(lo + 1, Math.floor((i + 1) * slots / used.length));
        at.set(lo + Math.floor(rand() * (hi - lo)), [
            step
        ]);
    });
    const cells = [];
    const push = (along, across)=>cells.push(horizontal ? {
            row: across,
            col: along
        } : {
            row: along,
            col: across
        });
    let lane = startLane;
    for(let along = 0; along < span; along++){
        push(along, lane);
        if (along === span - 1) break;
        for (const step of at.get(along) || []){
            const next = lane + step;
            if (next < 0 || next >= cross) continue;
            lane = next;
            push(along, lane);
        }
    }
    return cells;
}
/**
 * Grow a pathway from a cell already on the network toward `target`.
 *
 * Aimed rather than random: growing in a random direction spends most of its
 * cells re-covering ground already beside the trunk, which left a third of the
 * map with no road within reach however large the budget got.
 */ function $eaa96db7af263115$var$growToward(from, target, rows, cols, taken, rand, maxLen) {
    const free = (c)=>c.row >= 0 && c.col >= 0 && c.row < rows && c.col < cols && !taken.has($eaa96db7af263115$var$key(c.row, c.col));
    const cells = [];
    let cur = from;
    let heading = null; // the way the last step went
    let run = 0; // and how far it has gone that way
    const hold = 2 + Math.floor(rand() * 3); // cells to keep a heading before turning
    for(let i = 0; i < maxLen; i++){
        const dr = Math.sign(target.row - cur.row), dc = Math.sign(target.col - cur.col);
        const byRow = {
            row: cur.row + dr,
            col: cur.col
        };
        const byCol = {
            row: cur.row,
            col: cur.col + dc
        };
        // Hold the current heading for a few cells before turning again. Choosing
        // the axis afresh every step walks a diagonal target as a staircase — a
        // turn in every single cell — which reads as a pattern, not a road.
        let order = null;
        if (heading && run < hold) {
            const keep = {
                row: cur.row + heading[0],
                col: cur.col + heading[1]
            };
            const stillHelps = heading[0] ? dr === heading[0] : dc === heading[1];
            if (stillHelps) order = [
                keep,
                byRow,
                byCol
            ];
        }
        if (!order) {
            // close the larger gap first; the occasional swap keeps tracks from all
            // turning at the same point
            const wantRowFirst = Math.abs(target.row - cur.row) > Math.abs(target.col - cur.col);
            order = (rand() < 0.8 ? wantRowFirst : !wantRowFirst) ? [
                byRow,
                byCol
            ] : [
                byCol,
                byRow
            ];
        }
        const step = order.find((c)=>(c.row !== cur.row || c.col !== cur.col) && free(c));
        if (!step) break;
        const went = [
            step.row - cur.row,
            step.col - cur.col
        ];
        if (heading && went[0] === heading[0] && went[1] === heading[1]) run++;
        else {
            heading = went;
            run = 1;
        }
        cells.push(step);
        taken.add($eaa96db7af263115$var$key(step.row, step.col));
        cur = step;
        if (cur.row === target.row && cur.col === target.col) break;
    }
    return cells;
}
/** Remove a dead-end cell, unwiring the neighbour that pointed at it. */ function $eaa96db7af263115$var$dropLeaf(map, row, col) {
    const entry = map.get($eaa96db7af263115$var$key(row, col));
    if (!entry) return;
    for (const dir of Object.keys(entry.conn)){
        const [dr, dc] = $eaa96db7af263115$var$DIRS[dir];
        const other = map.get($eaa96db7af263115$var$key(row + dr, col + dc));
        if (other) delete other.conn[$eaa96db7af263115$var$OPPOSITE[dir]];
    }
    map.delete($eaa96db7af263115$var$key(row, col));
}
/** Record that `cell` carries road heading `dir` at `rank`. MAJOR wins ties. */ function $eaa96db7af263115$var$link(map, cell, dir, rank) {
    const k = $eaa96db7af263115$var$key(cell.row, cell.col);
    const entry = map.get(k) || {
        row: cell.row,
        col: cell.col,
        conn: {},
        rank: rank
    };
    if (dir) entry.conn[dir] = entry.conn[dir] === $eaa96db7af263115$export$39615881bb0d21f6 ? $eaa96db7af263115$export$39615881bb0d21f6 : rank;
    if (rank === $eaa96db7af263115$export$39615881bb0d21f6) entry.rank = $eaa96db7af263115$export$39615881bb0d21f6;
    map.set(k, entry);
}
function $eaa96db7af263115$var$linkRun(map, cells, rank) {
    for(let i = 0; i < cells.length - 1; i++){
        const dir = $eaa96db7af263115$var$dirBetween(cells[i], cells[i + 1]);
        if (!dir) continue;
        $eaa96db7af263115$var$link(map, cells[i], dir, rank);
        $eaa96db7af263115$var$link(map, cells[i + 1], $eaa96db7af263115$var$OPPOSITE[dir], rank);
    }
}
function $eaa96db7af263115$export$ff48eb85551f8323(rows, cols, isRoad) {
    const dist = Array.from({
        length: rows
    }, ()=>new Array(cols).fill(Infinity));
    const queue = [];
    for(let row = 0; row < rows; row++){
        for(let col = 0; col < cols; col++)if (isRoad(row, col)) {
            dist[row][col] = 0;
            queue.push([
                row,
                col
            ]);
        }
    }
    for(let i = 0; i < queue.length; i++){
        const [row, col] = queue[i];
        for (const [dr, dc] of Object.values($eaa96db7af263115$var$DIRS)){
            const nr = row + dr, nc = col + dc;
            if (nr < 0 || nc < 0 || nr >= rows || nc >= cols) continue;
            if (dist[nr][nc] <= dist[row][col] + 1) continue;
            dist[nr][nc] = dist[row][col] + 1;
            queue.push([
                nr,
                nc
            ]);
        }
    }
    return dist;
}
function $eaa96db7af263115$export$f5e4d8b41fa47b81(rows, cols, isRoad) {
    const dist = $eaa96db7af263115$export$ff48eb85551f8323(rows, cols, isRoad);
    let worst = 0;
    for (const row of dist)for (const d of row)worst = Math.max(worst, d);
    return worst;
}
const $eaa96db7af263115$export$3099f16d77e25bd6 = 2;
const $eaa96db7af263115$export$32c84ffa87e816c4 = new Set([
    'start',
    'exit'
]);
/**
 * Hang pathways off the network until nothing is more than `maxDist` steps from
 * one.
 *
 * Run at generation AND again after the network is trimmed against the finished
 * grid: cutting a spur back from collapsed ground is what actually strands a
 * quarter of a map, and the generator never sees that grid.
 *
 * @param {Set} [opts.avoid]    cells a pathway may not enter — collapsed ground, water
 * @param {Set} [opts.noStopAt] cells a pathway may pass but not END on
 */ /**
 * Run one new pathway from the network to `target`.
 *
 * growToward only ever considers the two steps that close on its target, so an
 * obstruction sitting square between anchor and target stops it dead — which is
 * why this tries the nearest several road cells rather than only the nearest
 * one. Picking just the nearest meant re-trying the same hopeless pair forever
 * while a workable anchor sat a few cells along the row.
 *
 * @returns the cells laid, or null if no anchor could reach
 */ function $eaa96db7af263115$var$joinToNetwork(map, rows, cols, rand, target, o) {
    // Never hang a new track off off-limits ground. A campsite is approached from
    // one side and left at that; running a second track off it would turn it into
    // a route straight through.
    const anchors = [
        ...map.values()
    ].filter((c)=>!o.avoid.has($eaa96db7af263115$var$key(c.row, c.col))).sort((a, b)=>Math.abs(a.row - target.row) + Math.abs(a.col - target.col) - (Math.abs(b.row - target.row) + Math.abs(b.col - target.col))).slice(0, 8);
    for (const anchor of anchors){
        const branch = $eaa96db7af263115$var$growToward(anchor, target, rows, cols, o.taken, rand, o.maxLen);
        while(!o.relax && branch.length && o.noStopAt.has($eaa96db7af263115$var$key(branch[branch.length - 1].row, branch[branch.length - 1].col))){
            const dropped = branch.pop();
            o.taken.delete($eaa96db7af263115$var$key(dropped.row, dropped.col));
        }
        if (!branch.length) continue;
        $eaa96db7af263115$var$linkRun(map, [
            anchor,
            ...branch
        ], $eaa96db7af263115$export$f23edc19d247fd25);
        return {
            anchor: anchor,
            branch: branch
        };
    }
    return null;
}
function $eaa96db7af263115$export$71e6814eda2893bd(map, rows, cols, target, taken) {
    const cameFrom = new Map([
        [
            $eaa96db7af263115$var$key(target.row, target.col),
            null
        ]
    ]);
    const queue = [
        target
    ];
    while(queue.length){
        const cur = queue.shift();
        for (const [dr, dc] of Object.values($eaa96db7af263115$var$DIRS)){
            const row = cur.row + dr, col = cur.col + dc;
            if (row < 0 || col < 0 || row >= rows || col >= cols) continue;
            const k = $eaa96db7af263115$var$key(row, col);
            if (cameFrom.has(k)) continue;
            const onNetwork = map.get(k);
            if (onNetwork) {
                const run = [];
                for(let at = cur; at; at = cameFrom.get($eaa96db7af263115$var$key(at.row, at.col)))run.push(at);
                return [
                    onNetwork,
                    ...run
                ]; // anchor, then every step up to the target
            }
            if (taken.has(k)) continue; // ground a track may not enter
            cameFrom.set(k, cur);
            queue.push({
                row: row,
                col: col
            });
        }
    }
    return null;
}
function $eaa96db7af263115$export$d4627e3f14810012(map, rows, cols, rand, maxDist, opts = {}) {
    const avoid = opts.avoid || new Set();
    const noStopAt = opts.noStopAt || new Set();
    const budget = opts.budget ?? Infinity;
    const taken = new Set([
        ...map.keys(),
        ...avoid
    ]);
    for(let pass = 0; pass < 200; pass++){
        if (map.size >= budget) break;
        const dist = $eaa96db7af263115$export$ff48eb85551f8323(rows, cols, (r, c)=>map.has($eaa96db7af263115$var$key(r, c)));
        const far = [];
        for(let row = 0; row < rows; row++){
            for(let col = 0; col < cols; col++)if (dist[row][col] > maxDist) far.push({
                row: row,
                col: col
            });
        }
        if (!far.length) break;
        // Aim at a cell that is not itself off-limits where possible: a track has
        // to end somewhere, and a track cannot end on ground it may not enter.
        const open = far.filter((c)=>!avoid.has($eaa96db7af263115$var$key(c.row, c.col)));
        const pool = $eaa96db7af263115$var$shuffle(open.length ? open : far, rand);
        // The second sweep drops the no-dead-end-beside-rubble rule. Where a corner
        // is boxed in by collapsed ground, EVERY cell that could serve it is
        // alongside that ground, and the two rules cannot both hold. A track that
        // stops short of the rubble is a smaller wrong than a corner of the map
        // nothing reaches, so coverage wins — but only after the tidy route has
        // been ruled out for every stranded cell, not the first one.
        let placed = false;
        for (const relax of [
            false,
            true
        ]){
            for (const target of pool){
                const laid = $eaa96db7af263115$var$joinToNetwork(map, rows, cols, rand, target, {
                    taken: taken,
                    avoid: avoid,
                    noStopAt: noStopAt,
                    relax: relax,
                    maxLen: maxDist + 6
                });
                if (!laid) continue;
                const { anchor: anchor, branch: branch } = laid;
                // Having spent the rule, spend no more of it than the map needs: pull
                // the relaxed track back off the rubble cell by cell for as long as
                // coverage survives without it.
                while(relax && branch.length && noStopAt.has($eaa96db7af263115$var$key(branch[branch.length - 1].row, branch[branch.length - 1].col))){
                    const tip = branch[branch.length - 1];
                    const conn = {
                        ...map.get($eaa96db7af263115$var$key(tip.row, tip.col))?.conn
                    };
                    $eaa96db7af263115$var$dropLeaf(map, tip.row, tip.col);
                    if ($eaa96db7af263115$export$f5e4d8b41fa47b81(rows, cols, (r, c)=>map.has($eaa96db7af263115$var$key(r, c))) > maxDist) {
                        $eaa96db7af263115$var$linkRun(map, [
                            branch[branch.length - 2] || anchor,
                            tip
                        ], $eaa96db7af263115$export$f23edc19d247fd25);
                        const back = map.get($eaa96db7af263115$var$key(tip.row, tip.col));
                        if (back) Object.assign(back.conn, conn);
                        break;
                    }
                    taken.delete($eaa96db7af263115$var$key(tip.row, tip.col));
                    branch.pop();
                }
                placed = branch.length > 0;
                if (placed) break;
            }
            if (placed) break;
        }
        if (!placed) break; // nothing left that can be joined
    }
}
function $eaa96db7af263115$export$d1d5b8da68c444ff(rows, cols, rand = Math.random, opts = {}) {
    const avoid = opts.avoid || new Set();
    // Retry rather than steer around the entry and extraction points: they sit
    // on opposite map edges and so do the trunk's ends, so a collision is easy
    // to roll and trivial to re-roll.
    // Two things have to hold, and both are cheaper to re-roll than to steer:
    // the trunk must miss the entry and extraction points (they sit on opposite
    // map edges, and so do its ends), and its ends must be far enough apart
    // across the axis to read as a route rather than a straight line. The second
    // is not guaranteed by construction because a jog that would leave the grid
    // is dropped, which quietly eats some of the intended drift.
    let trunk = null;
    let horizontal = rand() < 0.5;
    for(let tries = 0; tries < 80; tries++){
        const orient = tries === 0 ? horizontal : rand() < 0.5;
        const candidate = $eaa96db7af263115$var$bisectingRoute(rows, cols, orient, rand);
        const cross = orient ? rows : cols;
        const first = candidate[0], last = candidate[candidate.length - 1];
        const spread = orient ? Math.abs(first.row - last.row) : Math.abs(first.col - last.col);
        if (spread < Math.min($eaa96db7af263115$export$6013c12dea2de543, cross - 1)) continue;
        if (candidate.some((c)=>avoid.has($eaa96db7af263115$var$key(c.row, c.col)))) continue;
        trunk = candidate;
        horizontal = orient;
        break;
    }
    if (!trunk) trunk = $eaa96db7af263115$var$bisectingRoute(rows, cols, horizontal, rand);
    const map = new Map();
    $eaa96db7af263115$var$linkRun(map, trunk, $eaa96db7af263115$export$39615881bb0d21f6);
    // The two ends run OFF the map — a highway that stops dead at the border
    // reads as a mistake rather than as a road that came from somewhere.
    const head = trunk[0], tail = trunk[trunk.length - 1];
    $eaa96db7af263115$var$link(map, head, horizontal ? 'w' : 'n', $eaa96db7af263115$export$39615881bb0d21f6);
    $eaa96db7af263115$var$link(map, tail, horizontal ? 'e' : 's', $eaa96db7af263115$export$39615881bb0d21f6);
    // Pathways branch until nothing on the map is more than MAX_ROAD_DISTANCE
    // from a road. Anchors are drawn from the whole network, not just the trunk,
    // so later branches hang off earlier ones and the far corners are not
    // stranded. The budget is only a runaway guard — the distance goal is what
    // actually stops the loop.
    $eaa96db7af263115$export$d4627e3f14810012(map, rows, cols, rand, opts.maxDist ?? $eaa96db7af263115$export$3099f16d77e25bd6, {
        budget: Math.round(rows * cols * (opts.coverage ?? 0.7))
    });
    return map;
}
function $eaa96db7af263115$export$c7de1644901a490c(grid, rows, cols, prebuilt, block = [], exclude = []) {
    const net = prebuilt || $eaa96db7af263115$export$d1d5b8da68c444ff(rows, cols);
    const blocked = new Set(block);
    const banned = new Set(exclude);
    // A track leads up to the water's edge, or to the edge of a campsite, and
    // stops there — it does not carry on across the pond or through somebody's
    // camp. So the cell itself leaves the network and draws no road at all, while
    // the ONE neighbour it was approached from keeps pointing at it: that
    // neighbour runs its road to the shared edge and ends. Keeping a single
    // connection on the cell instead drew a stub of road onto the water.
    //
    // Neither type is ever laid on the trunk (see placeCampsite), so nothing here
    // can sever the through-route.
    for (const entry of [
        ...net.values()
    ]){
        const room = grid?.[entry.row]?.[entry.col];
        if (!room || !blocked.has(room.type)) continue;
        const dirs = Object.keys(entry.conn);
        const approach = dirs.find((d)=>entry.conn[d] === $eaa96db7af263115$export$39615881bb0d21f6) || dirs[0];
        for (const dir of dirs){
            if (dir === approach) continue;
            const [dr, dc] = $eaa96db7af263115$var$DIRS[dir];
            const other = net.get($eaa96db7af263115$var$key(entry.row + dr, entry.col + dc));
            if (other) delete other.conn[$eaa96db7af263115$var$OPPOSITE[dir]];
        }
        net.delete($eaa96db7af263115$var$key(entry.row, entry.col));
    }
    // Cells the network may not touch at all. Collapsed ground is not somewhere
    // a road stops, the way a campsite or a shoreline is — a track running up to
    // a slab of rubble and ending still draws a road onto a tile nobody can
    // enter. Drop the cell and unwire whatever pointed at it.
    const orphans = [];
    const drop = (entry)=>{
        for (const dir of Object.keys(entry.conn)){
            const [dr, dc] = $eaa96db7af263115$var$DIRS[dir];
            const other = net.get($eaa96db7af263115$var$key(entry.row + dr, entry.col + dc));
            if (!other) continue;
            delete other.conn[$eaa96db7af263115$var$OPPOSITE[dir]];
            orphans.push(other);
        }
        net.delete($eaa96db7af263115$var$key(entry.row, entry.col));
    };
    for (const entry of [
        ...net.values()
    ]){
        const room = grid?.[entry.row]?.[entry.col];
        if (!room || !banned.has(room.type)) continue;
        // never sever the through-route; the trunk is laid as road rooms before
        // anything else is placed, so this should be unreachable
        if (entry.rank === $eaa96db7af263115$export$39615881bb0d21f6) continue;
        drop(entry);
    }
    // Pull the rest of that spur back with it, and take any other track that
    // dead-ends beside the rubble with it. A road that stopped one tile short is
    // the same complaint one tile over, and a spur only grew that way to reach
    // ground that is now unreachable. Pruning stops at the first cell still
    // holding two ways out, so junctions and through-routes survive.
    const pruneSpurs = ()=>{
        while(orphans.length){
            const entry = orphans.pop();
            if (entry.rank === $eaa96db7af263115$export$39615881bb0d21f6) continue;
            if (!net.has($eaa96db7af263115$var$key(entry.row, entry.col))) continue;
            if (Object.keys(entry.conn).length > 1) continue;
            // a campsite or a shoreline is SUPPOSED to sit at the end of a track
            if (blocked.has(grid?.[entry.row]?.[entry.col]?.type)) continue;
            drop(entry);
        }
    };
    const seedFromBanned = ()=>{
        for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
            if (!banned.has(grid?.[row]?.[col]?.type)) continue;
            for (const [dr, dc] of Object.values($eaa96db7af263115$var$DIRS)){
                const other = net.get($eaa96db7af263115$var$key(row + dr, col + dc));
                if (other) orphans.push(other);
            }
        }
    };
    seedFromBanned();
    pruneSpurs();
    // a cell left with nothing to connect to is not on the network at all
    for (const [k, entry] of [
        ...net.entries()
    ])if (!Object.keys(entry.conn).length) net.delete(k);
    // Cutting a pathway at a blocked or rest-stop cell can strand whatever lay
    // beyond it. Those cells still hold valid-looking links to each other, so
    // they would render as a length of road joined to nothing. Keep only what is
    // still reachable from the trunk.
    const roots = [
        ...net.values()
    ].filter((c)=>c.rank === $eaa96db7af263115$export$39615881bb0d21f6);
    const live = new Set(roots.map((c)=>$eaa96db7af263115$var$key(c.row, c.col)));
    const queue = [
        ...roots
    ];
    while(queue.length){
        const cur = queue.pop();
        for (const dir of Object.keys(cur.conn)){
            const [dr, dc] = $eaa96db7af263115$var$DIRS[dir];
            const k = $eaa96db7af263115$var$key(cur.row + dr, cur.col + dc);
            const next = net.get(k);
            if (!next || live.has(k) || !next.conn[$eaa96db7af263115$var$OPPOSITE[dir]]) continue;
            live.add(k);
            queue.push(next);
        }
    }
    for (const [k, entry] of [
        ...net.entries()
    ]){
        if (live.has(k)) continue;
        for (const dir of Object.keys(entry.conn)){
            const [dr, dc] = $eaa96db7af263115$var$DIRS[dir];
            const other = net.get($eaa96db7af263115$var$key(entry.row + dr, entry.col + dc));
            if (other) delete other.conn[$eaa96db7af263115$var$OPPOSITE[dir]];
        }
        net.delete(k);
    }
    seedFromBanned(); // the sweep can leave a fresh dead end by the rubble
    pruneSpurs();
    // Everything above this point REMOVES road, and between them they can strand
    // whole quarters of a map — a spur cut back from a slab of rubble takes the
    // ground it served with it. The generator laid the network out against an
    // empty grid and never sees this one, so the coverage rule has to be restored
    // here, against the map as it finally stands.
    const offLimits = new Set();
    const beside = new Set();
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const type = grid?.[row]?.[col]?.type;
        if (!banned.has(type) && !blocked.has(type)) continue;
        offLimits.add($eaa96db7af263115$var$key(row, col)); // may not be entered
        if (!banned.has(type)) continue;
        for (const [dr, dc] of Object.values($eaa96db7af263115$var$DIRS))beside.add($eaa96db7af263115$var$key(row + dr, col + dc));
    }
    $eaa96db7af263115$export$d4627e3f14810012(net, rows, cols, Math.random, $eaa96db7af263115$export$3099f16d77e25bd6, {
        avoid: offLimits,
        noStopAt: beside
    });
    // A portal is a device somebody installed, not a clearing — so something
    // drove to it. Run a track right up onto the entry and extraction tiles,
    // last of all, where no later trimming can pull it back off again. The trunk
    // deliberately steers clear of both (they sit on opposite map edges and so do
    // its ends), which is exactly why they need connecting by hand.
    const taken = new Set([
        ...net.keys(),
        ...offLimits
    ]);
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        if (!$eaa96db7af263115$export$32c84ffa87e816c4.has(grid?.[row]?.[col]?.type)) continue;
        if (net.has($eaa96db7af263115$var$key(row, col))) continue;
        $eaa96db7af263115$var$joinToNetwork(net, rows, cols, Math.random, {
            row: row,
            col: col
        }, {
            taken: taken,
            avoid: offLimits,
            noStopAt: new Set(),
            relax: true,
            maxLen: rows + cols
        });
        // ...and if the greedy walk could not get there, find the way properly.
        // A portal boxed in by a campsite and a shoreline has no approach that
        // closes the gap on every step, so growToward reports nothing while an
        // obvious way round sits one tile out. Measured, that left a portal with
        // no road on three maps in a thousand.
        if (net.has($eaa96db7af263115$var$key(row, col))) continue;
        const run = $eaa96db7af263115$export$71e6814eda2893bd(net, rows, cols, {
            row: row,
            col: col
        }, taken);
        if (!run) continue; // genuinely walled in; nothing to be done
        $eaa96db7af263115$var$linkRun(net, run, $eaa96db7af263115$export$f23edc19d247fd25);
        for (const cell of run)taken.add($eaa96db7af263115$var$key(cell.row, cell.col));
    }
    for (const { row: row, col: col, conn: conn, rank: rank } of net.values()){
        const room = grid?.[row]?.[col];
        if (!room) continue;
        room.road = {
            n: conn.n || null,
            e: conn.e || null,
            s: conn.s || null,
            w: conn.w || null
        };
        room.roadRank = Object.values(conn).includes($eaa96db7af263115$export$39615881bb0d21f6) ? $eaa96db7af263115$export$39615881bb0d21f6 : rank;
    }
    // How far each tile sits from the nearest roadway, written alongside the road
    // itself and for the same reason: it has to be in hand wherever the tile is
    // drawn, and it has to survive a save. The renderer thins a recipe's
    // buildings with it, so frontage on a road is built up and the ground behind
    // it empties out — which is what settles along a route in the first place.
    //
    // Coverage keeps this within MAX_ROAD_DISTANCE for anywhere a team can walk;
    // the clamp is for the handful of cells a pathway is forbidden to reach at
    // all (collapsed ground), which are landmarks the renderer never thins.
    const dist = $eaa96db7af263115$export$ff48eb85551f8323(rows, cols, (r, c)=>net.has($eaa96db7af263115$var$key(r, c)));
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const room = grid?.[row]?.[col];
        if (room) room.roadDist = Math.min(dist[row][col], $eaa96db7af263115$export$3099f16d77e25bd6);
    }
    return net;
}


const $e81502d4aa27ba48$export$9e15ff8aa6bc996f = 120; // authoring grid, in units
const $e81502d4aa27ba48$export$fae5d17304677194 = 1; // device px per unit
const $e81502d4aa27ba48$export$3175e1b22a5f59e8 = $e81502d4aa27ba48$export$9e15ff8aa6bc996f * $e81502d4aa27ba48$export$fae5d17304677194; // 120 — the canvas a tile is drawn into
const $e81502d4aa27ba48$export$a7e851dd01b7bece = $e81502d4aa27ba48$export$3175e1b22a5f59e8; // PNG export size (image lab)
// How close to the tile edge a structure may be drawn. A roof clipped by the
// canvas reads as a rendering fault rather than as a building continuing into
// the next tile, because the neighbour draws its own recipe and never
// continues it — so structures are held short of the join instead.
const $e81502d4aa27ba48$var$TILE_CLAMP = 6;
const $e81502d4aa27ba48$export$3d672f2aedd16af9 = 40; // world units across one tile
const $e81502d4aa27ba48$export$a4097a0a1d4593d2 = 2; // world units per effect cell
const $e81502d4aa27ba48$var$FX_PX = $e81502d4aa27ba48$export$3175e1b22a5f59e8 / $e81502d4aa27ba48$export$3d672f2aedd16af9; // device px per world unit
const $e81502d4aa27ba48$export$6915278477114e25 = (0, $c1858b438f434f4d$export$1a6ba7df4555a8dd).defaultTune;
const $e81502d4aa27ba48$export$d4f789780201d4a = (0, $c1858b438f434f4d$export$1a6ba7df4555a8dd).regions;
const $e81502d4aa27ba48$export$a571935592b1ff4d = (0, $c1858b438f434f4d$export$1a6ba7df4555a8dd).recipes;
const $e81502d4aa27ba48$export$73b3f97728261c35 = (0, $c1858b438f434f4d$export$1a6ba7df4555a8dd).skillAnchors || {};
const $e81502d4aa27ba48$var$FALLBACK_THEME = $e81502d4aa27ba48$export$d4f789780201d4a['shard-cities'];
const $e81502d4aa27ba48$export$ea4f1160001ec0c0 = {
    scattered: {
        scale: 65,
        stretch: 1,
        sharp: 2.2,
        maxA: 0.40,
        thr: (c)=>0.78 - c * 0.50
    },
    broken: {
        scale: 100,
        stretch: 1,
        sharp: 2.8,
        maxA: 0.42,
        thr: (c)=>0.72 - c * 0.45
    },
    overcast: {
        scale: 130,
        stretch: 1.2,
        sharp: 1.2,
        maxA: 0.30,
        thr: (c)=>0.85 - c * 0.65
    },
    wispy: {
        scale: 75,
        stretch: 3.5,
        sharp: 1.6,
        maxA: 0.24,
        thr: (c)=>0.75 - c * 0.45
    }
};
// ===============================
// RECIPE SELECTION (pure, Node-safe)
// ===============================
// Ordered: first match against the lowercased room name wins. Short tokens
// that hide inside other words (lock in "block", hive in "archive", vent in
// "inventory") are anchored with \b.
//
// The order runs from what a name tells you MOST about how the tile looks from
// above, down to what it tells you least.
//
// Room names are built as "<place> <fitting> <sector>" — Arcade Shutter Sector,
// Marketfront Depot, Habitation Annex Gate — and every region names all four of
// its gates that way. With the fitting tokens above the place tokens, a name
// resolved to whatever was bolted to it: every gate in the game came out as
// `security`, `depot` beat `market`, `shutter` beat `arcade`, and `commerce`
// went from being a whole recipe to being drawn three times in sixty rooms
// while `security` and `storage` took a third of the map between them.
//
// Reading down: a reactor is unmistakable. A substation, an archive, a
// shopfront and a housing block each have their own architecture and keep it
// even in ruin. Then `environmental` — because a collapse or a breach REPLACES
// what was there with rubble and weeds, and that is louder than the two uses
// below it: a yard and a deck are generic enough that the damage is the more
// legible thing on the tile. `security` is the lowest real match because a
// checkpoint is the most portable fitting of the lot, and gateEmphasis dresses
// a gate tile as a gate whatever recipe it draws — so nothing is lost by
// letting the arcade underneath it show through. `infrastructure` is the
// catch-all and stays last.
const $e81502d4aa27ba48$var$KEYWORD_RECIPES = [
    [
        /reactor/,
        'reactor'
    ],
    [
        /substation|transformer|\bpower|switchgear|feeder|breaker|boiler|volt|generat|energy/,
        'power'
    ],
    [
        /record|archive|ledger|librar|registr/,
        'records'
    ],
    // `commerc`, not `commerce`: "Commercial Airlock Sector" shares no prefix
    // with the noun, and matched `airlock` instead for want of two letters.
    [
        /market|arcade|commissary|canteen|commerc|plaza|\bmart\b|\bshop|finance|teller|retail/,
        'commerce'
    ],
    [
        /apartment|housing|habitat|barrack|residential|nursery|dorm|\bliving/,
        'habitation'
    ],
    [
        /fungal|spore|breach|ruptur|\bleak|collapse|salvage|scrap|hazard|firebreak|isolation|cleanup|containment|\bwild|\bhive\b|observation/,
        'environmental'
    ],
    [
        /skybridge|overpass|interchange|\brail|transit|causeway|skyway/,
        'transit'
    ],
    [
        /silo|\bseed|storage|depot|vault|supply|inventory|cache|pantry|warehouse|freight|cargo/,
        'storage'
    ],
    [
        /checkpoint|security|barricade|barrier|perimeter|\block\b|\bseal|airlock|turnstile|shutter|decon|\bgate/,
        'security'
    ],
    [
        /relay|junction|conduit|spine|network|maintenance|control|operations|\bhub\b|assembl|conveyor|logistic|crane|drydock|\bdock|intake|\bvent|tower|\blift\b|access/,
        'infrastructure'
    ]
];
const $e81502d4aa27ba48$var$CATEGORY_RECIPES = {
    power: 'power',
    storage: 'storage',
    security: 'security',
    infrastructure: 'infrastructure',
    environmental: 'environmental',
    wildlife: 'environmental'
};
const $e81502d4aa27ba48$var$TYPE_RECIPES = {
    start: 'portal',
    exit: 'portal',
    road: 'road',
    water: 'water',
    campsite: 'campsite',
    blocked: 'blocked'
};
function $e81502d4aa27ba48$export$5f148632ad7917b2(roomName = '', category = '', type = '') {
    if ($e81502d4aa27ba48$var$TYPE_RECIPES[type]) return $e81502d4aa27ba48$var$TYPE_RECIPES[type];
    const name = String(roomName).toLowerCase();
    if (name === 'entry' || name === 'exit') return 'portal';
    for (const [re, recipe] of $e81502d4aa27ba48$var$KEYWORD_RECIPES){
        if (re.test(name)) return recipe;
    }
    return $e81502d4aa27ba48$var$CATEGORY_RECIPES[category] || 'infrastructure';
}
// ===============================
// PIXEL HELPERS
// ===============================
// Shadow-casting content is rendered in two passes over identical rng
// streams: pass 1 (SHADOW_PASS) lets only the shadow helpers paint, so
// every shadow lands on the bare ground; pass 2 suppresses the shadow
// helpers and paints the objects on top. That way one object's shadow can
// never fall across a neighboring object (same idea as the lake banks).
let $e81502d4aa27ba48$var$SHADOW_PASS = false;
let $e81502d4aa27ba48$var$IN_SHADOW = false;
function $e81502d4aa27ba48$var$castShadow(fn) {
    $e81502d4aa27ba48$var$IN_SHADOW = true;
    fn();
    $e81502d4aa27ba48$var$IN_SHADOW = false;
}
// ---- static / dynamic split ----
// Almost all of a tile sits perfectly still: floor, roads, structures,
// weathering. Only a handful of things move between frames — swaying
// canopies, lamp strobes, flame and portal glow, pond crests — and those are
// wrapped in dynamic(). During a STATIC render the wrapped closures are
// RECORDED instead of drawn, so the cached layer holds only the still parts;
// the animation loop then replays that short list over a blit of the cache
// every frame (see composite). Recording rather than re-running the recipe
// interpreter is the point: the interpreter's rng streams and element
// dispatch cost as much as the painting does.
//
// A recorded closure takes (g, T) so replay can hand it the live context and
// the day-tinted palette; it must not touch the rng, or the tile's layout
// would drift every frame. Resolve anything seeded BEFORE the wrapper and
// capture it. A one-shot drawRoomTile leaves DYN null and the closures run
// inline against CUR_G/CUR_T, which is what the image lab still does.
let $e81502d4aa27ba48$var$DYN = null; // recording target during a static render
let $e81502d4aa27ba48$var$CUR_G = null, $e81502d4aa27ba48$var$CUR_T = null; // inline target when not recording
function $e81502d4aa27ba48$var$dynamic(fn) {
    if ($e81502d4aa27ba48$var$SHADOW_PASS) return; // pass 1 replays the same stream; record once
    if ($e81502d4aa27ba48$var$DYN) $e81502d4aa27ba48$var$DYN.push(fn);
    else fn($e81502d4aa27ba48$var$CUR_G, $e81502d4aa27ba48$var$CUR_T);
}
/**
 * A small offscreen surface for pre-rasterising something that will be blitted
 * many times rather than redrawn.
 *
 * A detached <canvas>, deliberately, and NOT an OffscreenCanvas. The two are
 * interchangeable here and OffscreenCanvas is the tidier object — it carries no
 * DOM node, and a wooded tier-3 grid asks for a couple of thousand of these —
 * but as a drawImage SOURCE it is three times slower on a browser that
 * GPU-accelerates canvas (11.2ms a frame against 3.7ms, same count, same
 * sizes, same draws). A main-thread OffscreenCanvas does not get the same
 * accelerated backing, so every blit pays to fetch the pixels. Browsers that
 * rasterise canvas in software show no difference at all, which is exactly why
 * this is worth a comment: it is invisible in the wrong environment.
 */ function $e81502d4aa27ba48$var$scratchCanvas(w, h) {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    return c;
}
// ---- above the weather ----
// A second recording channel, replayed AFTER the world-space effects instead of
// before them. Almost nothing belongs here: clouds and daylight shafts are the
// air of the place and should fall on everything the tile contains.
//
// The exception is anything that is not IN the room but over it. A sublevel's
// rock masses are a cutaway through stone that runs up to the cavern roof, so a
// shaft of daylight crossing one would be light passing through the ceiling.
// Recorded rather than drawn in place because the sampling that finds the rock
// is expensive and the fills are not — this replays a few dozen rects a frame
// off work done once per still-layer repaint.
let $e81502d4aa27ba48$var$OVER = null;
// Where the tile's GROUND PLAN is collected during a static render, on the same
// pattern as DYN and OVER above: composeBody fills it in if somebody put one
// here, and ignores it otherwise. The renderer already measures every footprint
// it draws in order to route roads and keep vegetation off roofs — this just
// stops that knowledge being thrown away at the end of the pass, so the raid
// team can be kept off the roofs as well as the shrubbery.
let $e81502d4aa27ba48$var$PLAN = null;
/**
 * Record `fn` to be replayed above the effects, or — when nobody is collecting —
 * draw it into `g`/`T` right now.
 *
 * The fallback target is passed in rather than read from CUR_G/CUR_T the way
 * dynamic() does it. Both of the real paths always collect, so that pair is
 * only ever whatever the LAST inline render happened to leave behind, and a
 * caller outside those paths would silently paint into a stale canvas.
 */ function $e81502d4aa27ba48$var$overhead(g, T, fn) {
    if ($e81502d4aa27ba48$var$SHADOW_PASS) return; // same reason as dynamic: record once
    if ($e81502d4aa27ba48$var$OVER) $e81502d4aa27ba48$var$OVER.push(fn);
    else fn(g, T);
}
/**
 * A graphics object that draws nothing and remembers where it would have.
 *
 * Element functions draw straight from the rng, so an element that is going to
 * be measured or suppressed still has to RUN — skipping the call outright would
 * shift the stream for everything after it and reshuffle the whole tile. It
 * runs into this instead of into the canvas.
 *
 * Measuring beats declaring: a hand-written "this recipe's building sits here"
 * table is a second copy of the art's coordinates, and the two drift the first
 * time anyone edits a recipe.
 */ function $e81502d4aa27ba48$var$makeProbeG() {
    const box = {
        x0: Infinity,
        y0: Infinity,
        x1: -Infinity,
        y1: -Infinity
    };
    const add = (x, y, w, h, s)=>{
        box.x0 = Math.min(box.x0, x / s);
        box.y0 = Math.min(box.y0, y / s);
        box.x1 = Math.max(box.x1, (x + w) / s);
        box.y1 = Math.max(box.y1, (y + h) / s);
    };
    return {
        box: box,
        r (x, y, w, h) {
            if ($e81502d4aa27ba48$var$SHADOW_PASS !== $e81502d4aa27ba48$var$IN_SHADOW) return;
            add(x | 0, y | 0, w | 0, h | 0, 1);
        },
        p (x, y, w, h) {
            if ($e81502d4aa27ba48$var$SHADOW_PASS !== $e81502d4aa27ba48$var$IN_SHADOW) return;
            add(x | 0, y | 0, w | 0, h | 0, $e81502d4aa27ba48$export$fae5d17304677194);
        },
        a (alpha, fn) {
            fn();
        }
    };
}
function $e81502d4aa27ba48$var$makeG(ctx) {
    return {
        ctx: ctx,
        // authoring units — the whole element library draws through this
        r (x, y, w, h, c) {
            if ($e81502d4aa27ba48$var$SHADOW_PASS !== $e81502d4aa27ba48$var$IN_SHADOW) return;
            ctx.fillStyle = c;
            ctx.fillRect((x | 0) * $e81502d4aa27ba48$export$fae5d17304677194, (y | 0) * $e81502d4aa27ba48$export$fae5d17304677194, (w | 0) * $e81502d4aa27ba48$export$fae5d17304677194, (h | 0) * $e81502d4aa27ba48$export$fae5d17304677194);
        },
        // device pixels, for detail finer than the authoring grid
        p (x, y, w, h, c) {
            if ($e81502d4aa27ba48$var$SHADOW_PASS !== $e81502d4aa27ba48$var$IN_SHADOW) return;
            ctx.fillStyle = c;
            ctx.fillRect(x | 0, y | 0, w | 0, h | 0);
        },
        a (alpha, fn) {
            ctx.globalAlpha = alpha;
            fn();
            ctx.globalAlpha = 1;
        }
    };
}
// Speckle at DEVICE resolution: the base tone laid down in units, the grain
// scattered in device pixels. Coverage matches what the old unit-space
// dither gave, so surfaces read the same from across the map and gain
// texture up close. SPECK trades grain size against fillRect count — 2px
// specks are still a third the size of the old unit-grid blocks and cost a
// quarter of what 1px ones would on the roads, which are the widest dithered
// areas left now that floors go through grain().
const $e81502d4aa27ba48$var$SPECK = 2;
function $e81502d4aa27ba48$var$dither(g, rng, x, y, w, h, c1, c2, density = 0.2) {
    g.r(x, y, w, h, c1);
    const n = Math.floor(w * h * $e81502d4aa27ba48$export$fae5d17304677194 * $e81502d4aa27ba48$export$fae5d17304677194 * density / ($e81502d4aa27ba48$var$SPECK * $e81502d4aa27ba48$var$SPECK));
    for(let i = 0; i < n; i++)g.p((x + rng() * w) * $e81502d4aa27ba48$export$fae5d17304677194, (y + rng() * h) * $e81502d4aa27ba48$export$fae5d17304677194, $e81502d4aa27ba48$var$SPECK, $e81502d4aa27ba48$var$SPECK, c2);
}
const $e81502d4aa27ba48$var$hexRGB = (hex)=>[
        parseInt(hex.slice(1, 3), 16),
        parseInt(hex.slice(3, 5), 16),
        parseInt(hex.slice(5, 7), 16)
    ];
/**
 * A palette colour taken down, and optionally toward grey — for material that
 * is the same stuff as its neighbour but in a different state. `k` scales
 * brightness; `grey` (0..1) pulls the channels toward the colour's own
 * luminance, which is what turns a brown into charcoal rather than into a
 * darker brown. Memoised: this runs per element, per tile, per repaint.
 */ const $e81502d4aa27ba48$var$shadeCache = new Map();
function $e81502d4aa27ba48$var$shade(hex, k, grey = 0) {
    const key = `${hex}|${k}|${grey}`;
    let out = $e81502d4aa27ba48$var$shadeCache.get(key);
    if (out) return out;
    const [r, g, b] = $e81502d4aa27ba48$var$hexRGB(hex);
    const lum = 0.3 * r + 0.59 * g + 0.11 * b;
    const ch = (c)=>Math.max(0, Math.min(255, Math.round((c * (1 - grey) + lum * grey) * k)));
    $e81502d4aa27ba48$var$shadeCache.set(key, out = `#${[
        ch(r),
        ch(g),
        ch(b)
    ].map((c)=>c.toString(16).padStart(2, '0')).join('')}`);
    return out;
}
// Full-tile floor grain, written straight into an ImageData buffer. The
// ground is 100% of a tile's area, so it is where added resolution shows
// first — 3x3 blocks of flat color read as an upscale, per-pixel grain reads
// as dirt. Scattering 14k 1px fillRects would cost more than the entire rest
// of the tile; one buffer write costs almost nothing.
let $e81502d4aa27ba48$var$grainBuf = null; // one scratch buffer: putImageData copies out of it
function $e81502d4aa27ba48$var$grain(g, rng, c1, c2, density) {
    if ($e81502d4aa27ba48$var$SHADOW_PASS !== $e81502d4aa27ba48$var$IN_SHADOW) return;
    const img = $e81502d4aa27ba48$var$grainBuf || ($e81502d4aa27ba48$var$grainBuf = new ImageData($e81502d4aa27ba48$export$3175e1b22a5f59e8, $e81502d4aa27ba48$export$3175e1b22a5f59e8));
    const d = img.data;
    const [r1, g1, b1] = $e81502d4aa27ba48$var$hexRGB(c1), [r2, g2, b2] = $e81502d4aa27ba48$var$hexRGB(c2);
    for(let i = 0, o = 0; i < $e81502d4aa27ba48$export$3175e1b22a5f59e8 * $e81502d4aa27ba48$export$3175e1b22a5f59e8; i++, o += 4){
        const speck = rng() < density;
        d[o] = speck ? r2 : r1;
        d[o + 1] = speck ? g2 : g1;
        d[o + 2] = speck ? b2 : b1;
        d[o + 3] = 255;
    }
    g.ctx.putImageData(img, 0, 0);
}
const $e81502d4aa27ba48$var$ri = (rng, min, max)=>min + Math.floor(rng() * (max - min + 1));
// ===============================
// SHARED ELEMENT LIBRARY
// ===============================
// Broken chunks with a lit top edge — on the old 3px grid a chunk WAS one
// block, so it could only ever be a dot.
/**
 * One hole in the ground: shadowed lip, the far dark below, and a crumbling rim
 * catching the light. Shared by the sinkhole and the chasm — they differ only
 * in how many of these there are and where.
 */ function $e81502d4aa27ba48$var$voidPit(g, rng, T, cx, cy, r) {
    const left = $e81502d4aa27ba48$var$wobbler(rng), right = $e81502d4aa27ba48$var$wobbler(rng);
    $e81502d4aa27ba48$var$blob(g, cx, cy, r + 3, T.structDark, left, right); // crumbling rim
    g.a(0.3, ()=>$e81502d4aa27ba48$var$blob(g, cx, cy, r + 2, T.structLight, left, right));
    $e81502d4aa27ba48$var$blob(g, cx, cy, r, T.far, left, right); // the ground below
    g.a(0.6, ()=>$e81502d4aa27ba48$var$blob(g, cx, cy, Math.max(2, r - 6), '#000000', left, right));
}
function $e81502d4aa27ba48$var$rubbleChunk(g, rng, T, x, y) {
    const c = [
        T.structDark,
        T.metal,
        T.struct
    ][$e81502d4aa27ba48$var$ri(rng, 0, 2)];
    const w = $e81502d4aa27ba48$var$ri(rng, 2, 6), h = $e81502d4aa27ba48$var$ri(rng, 1, 3);
    g.r(Math.round(x), Math.round(y), w, h, c);
    if (h > 1) g.r(Math.round(x), Math.round(y), w, 1, T.structLight);
}
function $e81502d4aa27ba48$var$rubble(g, rng, T, x1, x2, y1, y2, n = 12) {
    for(let i = 0; i < n; i++)$e81502d4aa27ba48$var$rubbleChunk(g, rng, T, $e81502d4aa27ba48$var$ri(rng, x1, x2), $e81502d4aa27ba48$var$ri(rng, y1, y2));
}
// A hairline that wanders a pixel at a time. This is the clearest single
// example of what the finer grid bought: the same call used to lay down a
// chain of 3x3 blocks.
function $e81502d4aa27ba48$var$crack(g, rng, T, x, y, len = 10) {
    let cx = x, cy = y;
    for(let i = 0; i < len; i++){
        g.r(cx, cy, 1, 1, T.road);
        cx += $e81502d4aa27ba48$var$ri(rng, -1, 1);
        cy += $e81502d4aa27ba48$var$ri(rng, 0, 1);
    }
}
function $e81502d4aa27ba48$var$foliageClump(g, rng, T, x, y, size = 5) {
    for(let i = 0; i < size; i++)g.r(x + $e81502d4aa27ba48$var$ri(rng, -6, 6), y - $e81502d4aa27ba48$var$ri(rng, 0, 9), $e81502d4aa27ba48$var$ri(rng, 5, 9), 5, T.veg1);
    for(let i = 0; i < Math.ceil(size / 2); i++)g.r(x + $e81502d4aa27ba48$var$ri(rng, -6, 3), y - $e81502d4aa27ba48$var$ri(rng, 3, 9), $e81502d4aa27ba48$var$ri(rng, 3, 6), 3, T.veg2);
    for(let i = 0; i < size; i++)g.r(x + $e81502d4aa27ba48$var$ri(rng, -5, 5), y - $e81502d4aa27ba48$var$ri(rng, 0, 8), 1, 1, T.veg2);
}
// ===============================
// TOP-DOWN STYLE
// ===============================
// Map tiles viewed from above. Connectivity comes from two rules: floors are
// full-cell fills whose detail lines sit at fixed offsets (so they continue
// across cells), and road/path connectors always run from the cell center to
// the edge midpoint at a fixed width — two adjacent cells that both draw a
// connector on their shared edge meet exactly. No vignette, no sky.
function $e81502d4aa27ba48$var$disc(g, cx, cy, r, c) {
    for(let dy = -r; dy <= r; dy++){
        const dx = Math.floor(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 2 * dx + 1, 1, c);
    }
}
function $e81502d4aa27ba48$var$ringO(g, cx, cy, r, c) {
    for(let dy = -r; dy <= r; dy++){
        const dx = Math.round(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 1, 1, c);
        g.r(cx + dx, cy + dy, 1, 1, c);
    }
}
// How coarsely a pre-rasterised sprite tracks the daylight. Anything cached
// across frames has to be rebuilt when the palette under it moves, and `light`
// moves continuously — tintPalette alone buckets it 512 ways, which over a
// ten-minute day is a fresh palette every half second and so no cache at all.
//
// 16 steps rebuilds roughly twice a game minute and cannot be seen: the tint
// scales a channel by 0.30 + 0.70q, so quantising q to 1/16 moves a mid-toned
// leaf by under a level and a half out of 255 — inside the rounding difference
// that already exists between tinting a colour and multiplying a pixel.
const $e81502d4aa27ba48$var$TINT_STEPS = 16;
// ...but every sprite on the map crossing the SAME step on the same frame is
// its own problem: a wooded tier-3 grid rebuilds ~1500 canopies at once, which
// measured at 227k fillRects in a single frame — worse, in one hitch, than the
// per-frame cost the sprites were introduced to remove. So each sprite is given
// a fixed fraction of a step to cross on instead, spreading the rebuilds evenly
// across the whole step. The count of them over a day is unchanged; only the
// clumping goes. The offset is derived from position so it is stable across
// reloads, and costs at most one extra step of tint error between neighbours,
// which is the same level-and-a-half nobody can see.
const $e81502d4aa27ba48$var$TINT_SPREAD = 16;
const $e81502d4aa27ba48$var$tintPhase = (x, y)=>(x * 7 + y * 13) % $e81502d4aa27ba48$var$TINT_SPREAD / $e81502d4aa27ba48$var$TINT_SPREAD;
// Animation state for the current draw call, set once per render like
// SHADOW below. wind (0..1) sways tree canopies; t is elapsed seconds and
// phases the sway per tree; lamp (0..1) is how lit the powered lights are —
// it ramps up at dusk and back down at dawn. Zero when rendering static
// tiles. tintScale is the daylight on the sprite-cache scale above — a cache
// floors it with its own tintPhase offset to decide whether to rebuild.
let $e81502d4aa27ba48$var$ANIM = {
    wind: 0,
    t: 0,
    lamp: 0,
    lightUptime: 0.12,
    lightSpeed: 1,
    tintScale: $e81502d4aa27ba48$var$TINT_STEPS
};
// Drop shadows give top-down structures depth and lift them off the floor.
// The direction comes from tune.shadowAngle, set once per render — rendering
// is synchronous, so module state is safe here and keeps element signatures
// free of tune plumbing.
let $e81502d4aa27ba48$var$SHADOW = {
    dx: 1,
    dy: 1
};
// dist grows when the sun is low (dawn/dusk) so shadow length conveys the
// time of day, not just its direction. alpha comes from tune.shadowAlpha.
// The offset is quantized to SHADOW_STEP pixels rather than following the
// finer art grid, for two reasons: a shadow that creeps a pixel at a time
// reads as jitter, and the cached still layer is keyed on this offset — at
// 1px granularity every tile would repaint three times as often (staticKey).
const $e81502d4aa27ba48$var$SHADOW_STEP = 3;
function $e81502d4aa27ba48$var$setShadowAngle(angleDeg, dist = 1.4, alpha = 0.6) {
    const a = angleDeg * Math.PI / 180;
    $e81502d4aa27ba48$var$SHADOW = {
        dx: Math.round(Math.cos(a) * dist) * $e81502d4aa27ba48$var$SHADOW_STEP,
        dy: Math.round(Math.sin(a) * dist) * $e81502d4aa27ba48$var$SHADOW_STEP,
        a: alpha
    };
}
function $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h) {
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx, y + $e81502d4aa27ba48$var$SHADOW.dy, w, h, T.far)));
}
/**
 * A smooth loop of seeded wobble: t in [0,1] around the shape, returning a
 * radius multiplier near 1. Wraps, so the outline closes without a seam.
 */ function $e81502d4aa27ba48$var$wobbler(rng, knots = 5, amount = 0.2) {
    const k = Array.from({
        length: knots
    }, ()=>1 + (rng() * 2 - 1) * amount);
    return (t)=>{
        const x = Math.max(0, Math.min(0.9999, t)) * knots, i = Math.floor(x), f = x - i;
        const s = f * f * (3 - 2 * f); // smoothstep between knots
        return k[i % knots] + (k[(i + 1) % knots] - k[i % knots]) * s;
    };
}
/**
 * An irregular disc, scanline by scanline: each side's half-width is scaled by
 * its own wobble, so a pond or a sinkhole reads as something that formed rather
 * than something drawn with a compass. Same shape of loop as disc(), so the two
 * can be nested to build a bank or a rim that follows the outline.
 */ function $e81502d4aa27ba48$var$blob(g, cx, cy, r, c, left, right) {
    for(let dy = -r; dy <= r; dy++){
        const t = (dy + r) / (2 * r);
        const base = Math.sqrt(Math.max(0, r * r - dy * dy));
        const l = Math.round(base * left(t)), rr = Math.round(base * right(t));
        if (l + rr < 1) continue;
        g.r(cx - l, cy + dy, l + rr + 1, 1, c);
    }
}
/** Half-widths of a blob on a given scanline — what the wave crests ride on. */ function $e81502d4aa27ba48$var$blobSpan(r, dy, left, right) {
    const t = (dy + r) / (2 * r);
    const base = Math.sqrt(Math.max(0, r * r - dy * dy));
    return [
        Math.round(base * left(t)),
        Math.round(base * right(t))
    ];
}
function $e81502d4aa27ba48$var$discShadow(g, T, cx, cy, r) {
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a, ()=>$e81502d4aa27ba48$var$disc(g, cx + $e81502d4aa27ba48$var$SHADOW.dx, cy + $e81502d4aa27ba48$var$SHADOW.dy, r, T.far)));
}
// Pulse 0..1 for light sources (portals, fires, lamps, fungi). Phase comes
// from the light's position so neighbors don't blink in unison; a fixed 0.5
// when not animating so static renders keep today's look.
function $e81502d4aa27ba48$var$flicker(cx, cy, speed = 6) {
    return $e81502d4aa27ba48$var$ANIM.t ? 0.5 + 0.5 * Math.sin($e81502d4aa27ba48$var$ANIM.t * speed + cx * 3.1 + cy * 1.7) : 0.5;
}
// The grid is failing: a powered light is DARK most of the time, then a
// power surge hits and it strobes rapidly for a moment before dying again.
// tune.lightUptime sets how often the surges come, tune.lightFlickerSpeed
// the strobe rate; the seed staggers the schedule so tiles don't blink
// together. Zero when static — the dead grid is the daytime look too.
function $e81502d4aa27ba48$var$powerFlicker(seed) {
    if (!$e81502d4aa27ba48$var$ANIM.t) return 0;
    const n = $e81502d4aa27ba48$var$smoothNoise($e81502d4aa27ba48$var$ANIM.t * 0.9 + seed * 13.7, seed * 7.3);
    if (n < 1 - $e81502d4aa27ba48$var$ANIM.lightUptime) return 0; // dead, most of the time
    const s = Math.sin($e81502d4aa27ba48$var$ANIM.t * 55 * $e81502d4aa27ba48$var$ANIM.lightSpeed + seed * 9);
    return s > -0.25 ? 0.95 : 0.1; // rapid surge strobe
}
// Soft tonal patches that break up flat floors without disturbing edge
// continuity (same tones as the floor itself).
function $e81502d4aa27ba48$var$mottle(g, rng, c, n = 3, alpha = 0.12) {
    for(let i = 0; i < n; i++)g.a(alpha, ()=>$e81502d4aa27ba48$var$disc(g, $e81502d4aa27ba48$var$ri(rng, 6, 111), $e81502d4aa27ba48$var$ri(rng, 6, 111), $e81502d4aa27ba48$var$ri(rng, 12, 21), c));
}
/**
 * A plant's own green: a shade down from the palette's, and nudged warm or cool
 * per plant.
 *
 * DOWN, because the ground it stands on is drawn from the same two greens — a
 * canopy over a patch of grass was the same colour as the grass and dissolved
 * into it. The shift moves red and blue in opposite directions and leaves green
 * alone, which walks along the green arc of the wheel — toward olive one way,
 * toward pine the other — rather than off it. Where a region's own vegetation
 * is already a dry khaki the guard does nothing and it stays khaki; all it
 * stops is a shift turning a green into something that is not one.
 *
 * `hue` is quantised by the caller so this memoises against a bounded key set:
 * it is called per plant, per frame, on the animated canopies.
 */ const $e81502d4aa27ba48$var$LEAF_DARKEN = 0.85, $e81502d4aa27ba48$var$LEAF_HUE = 0.22;
/**
 * The canopy's own outline, a shade under its body. Two greens of similar
 * weight sitting on each other — a crown over the grass it is growing out of —
 * have no edge between them to read, and no amount of darkening the whole tree
 * fixes that because the grass moves with it. A rim does: it is a boundary
 * rather than a contrast.
 */ const $e81502d4aa27ba48$var$LEAF_RIM = 0.58;
const $e81502d4aa27ba48$var$leafCache = new Map();
function $e81502d4aa27ba48$export$b2a4daa97bd45a21(hex, hue, dark = $e81502d4aa27ba48$var$LEAF_DARKEN) {
    const key = `${hex}|${hue}|${dark}`;
    let out = $e81502d4aa27ba48$var$leafCache.get(key);
    if (out) return out;
    const [r, g, b] = $e81502d4aa27ba48$var$hexRGB(hex);
    const ch = (v)=>Math.max(0, Math.min(255, Math.round(v * dark)));
    const ng = ch(g);
    let nr = ch(r * (1 + hue * $e81502d4aa27ba48$var$LEAF_HUE));
    const nb = ch(b * (1 - hue * $e81502d4aa27ba48$var$LEAF_HUE));
    if (r <= g) nr = Math.min(nr, ng); // a green stays a green
    $e81502d4aa27ba48$var$leafCache.set(key, out = `#${[
        nr,
        ng,
        nb
    ].map((c)=>c.toString(16).padStart(2, '0')).join('')}`);
    return out;
}
/** Nine steps of warm-to-cool, so leafTone's cache stays small. */ const $e81502d4aa27ba48$var$LEAF_STEPS = 4;
const $e81502d4aa27ba48$var$leafHue = (rng)=>$e81502d4aa27ba48$var$ri(rng, -$e81502d4aa27ba48$var$LEAF_STEPS, $e81502d4aa27ba48$var$LEAF_STEPS) / $e81502d4aa27ba48$var$LEAF_STEPS;
function $e81502d4aa27ba48$export$f26d486e6e8aa256(T) {
    const out = new Set();
    for(let k = -$e81502d4aa27ba48$var$LEAF_STEPS; k <= $e81502d4aa27ba48$var$LEAF_STEPS; k++)for (const hex of [
        T.veg1,
        T.veg2
    ]){
        out.add($e81502d4aa27ba48$export$b2a4daa97bd45a21(hex, k / $e81502d4aa27ba48$var$LEAF_STEPS));
        out.add($e81502d4aa27ba48$export$b2a4daa97bd45a21(hex, k / $e81502d4aa27ba48$var$LEAF_STEPS, $e81502d4aa27ba48$var$LEAF_RIM));
    }
    return out;
}
function $e81502d4aa27ba48$var$tree(g, rng, T, cx, cy, r = 9) {
    // Wind sways the canopy around the anchored trunk/shadow, so the shadow is
    // static and the canopy is not. The leaf detail is resolved from the stream
    // here and captured — the replayed closure must never touch the rng, or the
    // tile's layout would drift every frame. The hue is resolved here for the
    // same reason, and applied to the palette the replay hands back so the canopy
    // still dims with the hour.
    $e81502d4aa27ba48$var$discShadow(g, T, cx, cy, r);
    const hue = $e81502d4aa27ba48$var$leafHue(rng);
    const speck = rng() < 0.5 ? [
        $e81502d4aa27ba48$var$ri(rng, -3, 3),
        $e81502d4aa27ba48$var$ri(rng, -3, 3)
    ] : null;
    // clumped foliage: offsets within the crown, fixed per tree so the canopy
    // keeps its shape while it sways
    const leaves = [];
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 3, 6); i < n; i++)leaves.push([
        $e81502d4aa27ba48$var$ri(rng, -r + 2, r - 2),
        $e81502d4aa27ba48$var$ri(rng, -r + 2, r - 2),
        $e81502d4aa27ba48$var$ri(rng, 1, 3)
    ]);
    // The canopy is ONE FIXED IMAGE THAT SLIDES. sway is Math.round()ed and the
    // gust formula never exceeds 0.42, so it only ever takes the five values -2..2,
    // and cy never moves at all: every frame redrew the same discs one integer
    // pixel to the left or right of where it had just drawn them. At ~55 fillRects
    // a tree that was by a wide margin the most expensive thing on the map — a
    // wooded tier-3 grid spent 144k fillRects per frame on it, held 31% of a core,
    // and still missed its 12fps target. So it is rasterised once and blitted
    // thereafter, which is the same picture for one draw call instead of 55.
    //
    // It stays in dynamic() rather than moving somewhere the day tint could reach
    // it, because the draw ORDER here is load-bearing: vegetation composes last,
    // so a canopy paints over the lit windows of the house it overhangs. Lights
    // only stay bright by landing after the tint (tintPalette exempts `glow`), so
    // anything that must cover them has to land after it too. Hence a pre-tinted
    // sprite, rebuilt when the hour has moved far enough to see (see TINT_STEPS).
    //
    // Leaf clumps reach r+1 from the centre and the speck reaches 5, so the
    // surface is padded to whichever is larger rather than to r.
    const pad = Math.max(r + 1, 5);
    // The canopy itself, wherever it is going. Both routes below go through this
    // one function at the same coordinates, so the cached path cannot quietly
    // drift from the drawn one — and the geometry stays visible to a caller that
    // is counting rects rather than looking at pixels.
    const paintCanopy = (gg, ox, oy, T)=>{
        // Outer disc in the rim tone, inner one a unit smaller in the body tone —
        // one pixel of outline the whole way round, and the two agree on where the
        // edge is because they are the same routine at r and r-1. Stroking a ring
        // over the top would not: ringO rounds where disc floors.
        $e81502d4aa27ba48$var$disc(gg, ox, oy, r, $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg1, hue, $e81502d4aa27ba48$var$LEAF_RIM));
        $e81502d4aa27ba48$var$disc(gg, ox, oy, r - 1, $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg1, hue));
        gg.a(0.85, ()=>$e81502d4aa27ba48$var$disc(gg, ox - 3, oy - 3, Math.max(2, r - 5), $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg2, hue))); // lit crown
        for (const [lx, ly, lr] of leaves)gg.a(0.35, ()=>$e81502d4aa27ba48$var$disc(gg, ox + lx, oy + ly, lr, T.structDark));
        if (speck) gg.r(ox + speck[0], oy + speck[1], 2, 2, T.structDark);
    };
    const qPhase = $e81502d4aa27ba48$var$tintPhase(cx, cy);
    let surf; // undefined = untried, null = no surface to be had
    let spriteQ = null;
    $e81502d4aa27ba48$var$dynamic((g, T)=>{
        // phase from the tree's position (not rng) so neighbors sway apart
        const sway = $e81502d4aa27ba48$var$ANIM.wind ? Math.round($e81502d4aa27ba48$var$ANIM.wind * 6 * Math.sin($e81502d4aa27ba48$var$ANIM.t * 1.8 + cx * 0.3 + cy * 0.23)) : 0;
        if (surf === undefined) surf = $e81502d4aa27ba48$var$spriteSurface((pad * 2 + 1) * $e81502d4aa27ba48$export$fae5d17304677194, g.ctx);
        // Nothing to rasterise into or to blit with — draw it in place instead.
        if (!surf) return paintCanopy(g, cx + sway, cy, T);
        const q = Math.floor($e81502d4aa27ba48$var$ANIM.tintScale + qPhase);
        if (spriteQ !== q) {
            surf.ctx.clearRect(0, 0, surf.canvas.width, surf.canvas.height);
            paintCanopy(surf.g, pad, pad, T);
            spriteQ = q;
        }
        g.ctx.drawImage(surf.canvas, (cx + sway - pad) * $e81502d4aa27ba48$export$fae5d17304677194, (cy - pad) * $e81502d4aa27ba48$export$fae5d17304677194);
    });
}
/**
 * A surface to pre-rasterise a sprite onto, or null if this environment has no
 * such thing. Both halves have to hold: somewhere to draw the sprite, and a
 * target able to blit it. The renderer is driven through a recording stub in
 * the tests and through the image lab's own contexts as well as the game's, so
 * the answer is not always yes and the caller needs a way to fall back.
 */ function $e81502d4aa27ba48$var$spriteSurface(size, target) {
    if (typeof target?.drawImage !== 'function') return null;
    const canvas = $e81502d4aa27ba48$var$scratchCanvas(size, size);
    const ctx = canvas?.getContext?.('2d');
    if (typeof ctx?.clearRect !== 'function') return null;
    return {
        canvas: canvas,
        ctx: ctx,
        g: $e81502d4aa27ba48$var$makeG(ctx)
    };
}
function $e81502d4aa27ba48$var$bushPatch(g, rng, T, cx, cy) {
    const hue = $e81502d4aa27ba48$var$leafHue(rng); // same treatment, same reason
    $e81502d4aa27ba48$var$disc(g, cx, cy, 3, $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg1, hue));
    g.r(cx + $e81502d4aa27ba48$var$ri(rng, -3, 3), cy - 3, 2, 2, $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg2, hue));
    g.r(cx + $e81502d4aa27ba48$var$ri(rng, -2, 2), cy + $e81502d4aa27ba48$var$ri(rng, -1, 2), 1, 1, $e81502d4aa27ba48$export$b2a4daa97bd45a21(T.veg2, hue));
}
// A bare snag: forked limbs rather than the old plus-sign of four blocks.
function $e81502d4aa27ba48$var$deadTree(g, rng, T, cx, cy) {
    g.r(cx - 1, cy - 6, 2, 13, T.structDark); // trunk
    for (const [dx, dy, len] of [
        [
            -1,
            -4,
            6
        ],
        [
            1,
            -1,
            5
        ],
        [
            -1,
            2,
            4
        ]
    ]){
        const s = Math.sign(dx);
        for(let i = 0; i < len; i++)g.r(cx + s * (1 + i), cy + dy - (i >> 1), 1, 1, T.structDark);
    }
}
function $e81502d4aa27ba48$var$glowShroom(g, rng, T, cx, cy) {
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 3, 5); i < n; i++){
        const sx = cx + $e81502d4aa27ba48$var$ri(rng, -6, 6), sy = cy + $e81502d4aa27ba48$var$ri(rng, -6, 6);
        g.r(sx, sy, 1, 2, T.structDark); // stalk
        g.r(sx - 1, sy - 1, 3, 1, T.accent); // cap
    }
    // teal like the caps, not warm — amber halos read as lamplight
    $e81502d4aa27ba48$var$dynamic((g, T)=>g.a(0.18 + 0.24 * $e81502d4aa27ba48$var$flicker(cx, cy, 3), ()=>$e81502d4aa27ba48$var$disc(g, cx, cy, 7, T.accent))); // slow bioluminescent pulse
}
const $e81502d4aa27ba48$export$8ce2cf2f7041018f = 24, $e81502d4aa27ba48$export$f6b0e5d6358e6bd8 = 9;
function $e81502d4aa27ba48$var$vehicle(g, rng, T, x, y, vert) {
    const w = vert ? $e81502d4aa27ba48$export$f6b0e5d6358e6bd8 : $e81502d4aa27ba48$export$8ce2cf2f7041018f, h = vert ? $e81502d4aa27ba48$export$8ce2cf2f7041018f : $e81502d4aa27ba48$export$f6b0e5d6358e6bd8;
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    const body = [
        T.rust,
        T.accent,
        T.metal
    ][$e81502d4aa27ba48$var$ri(rng, 0, 2)];
    g.r(x, y, w, h, body);
    if (vert) {
        g.r(x, y, w, 1, T.structLight); // lit roof edge
        g.r(x, y, 1, h, T.structLight);
        g.r(x + w - 1, y, 1, h, T.structDark);
        g.r(x + 2, y + 5, w - 4, 4, T.structDark); // windshield
        g.r(x + 2, y + 15, w - 4, 3, T.structDark); // rear glass
        g.r(x + 1, y + 10, w - 2, 1, T.structLight); // roof seam
    } else {
        g.r(x, y, 1, h, T.structLight);
        g.r(x, y, w, 1, T.structLight);
        g.r(x, y + h - 1, w, 1, T.structDark);
        g.r(x + 5, y + 2, 4, h - 4, T.structDark);
        g.r(x + 15, y + 2, 3, h - 4, T.structDark);
        g.r(x + 10, y + 1, 1, h - 2, T.structLight);
    }
}
function $e81502d4aa27ba48$var$containerBox(g, rng, T, x, y, vert) {
    const w = vert ? 12 : 27, h = vert ? 27 : 12;
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    const c = [
        T.rust,
        T.accent,
        T.veg1,
        T.metal
    ][$e81502d4aa27ba48$var$ri(rng, 0, 3)];
    g.r(x, y, w, h, c);
    g.r(x, y, w, 1, T.structLight); // lit top edge
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.structDark);
    g.r(x + w - 1, y, 1, h, T.structDark);
    g.a(0.3, ()=>{
        if (vert) for(let ry = y + 3; ry < y + h - 2; ry += 3)g.r(x + 1, ry, w - 2, 1, T.far);
        else for(let rx = x + 3; rx < x + w - 2; rx += 3)g.r(rx, y + 1, 1, h - 2, T.far);
    });
    if (rng() < 0.5) g.a(0.5, ()=>{
        if (vert) g.r(x + 1, y + h - 5, w - 2, 4, T.structDark);
        else g.r(x + w - 5, y + 1, 4, h - 2, T.structDark);
    });
}
// A compact car for parking stalls (9x18, nose-in).
// 9 x 18 units — 1.8 x 3.6 m, a compact. `vert` is its default and means the
// car's LENGTH runs down the screen; a row of bays alongside a north-south road
// needs the other one, since a car always parks nose-in to the row.
function $e81502d4aa27ba48$var$carSmall(g, rng, T, x, y, vert = true) {
    const w = vert ? 9 : 18, h = vert ? 18 : 9;
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    const body = [
        T.rust,
        T.accent,
        T.metal
    ][$e81502d4aa27ba48$var$ri(rng, 0, 2)];
    g.r(x, y, w, h, body);
    if (vert) {
        g.r(x, y, 9, 1, T.structLight);
        g.r(x + 8, y, 1, 18, T.structDark);
        g.r(x + 1, y + 4, 7, 3, T.structDark); // windshield
        g.r(x + 1, y + 12, 7, 2, T.structDark); // rear glass
        g.r(x + 1, y + 9, 7, 1, T.structLight); // roof seam
    } else {
        g.r(x, y, 1, 9, T.structLight);
        g.r(x, y + 8, 18, 1, T.structDark);
        g.r(x + 4, y + 1, 3, 7, T.structDark);
        g.r(x + 12, y + 1, 2, 7, T.structDark);
        g.r(x + 9, y + 1, 1, 7, T.structLight);
    }
}
// A paved parking lot: solid pad with a full curb ring, worn stall markings,
// and a random count of compact cars in the stalls.
//
// The bays run along the lot's LONG axis, and `vert` says which that is. The
// row used to be laid out along w whichever way the lot was turned, so a lot
// beside a north-south road counted its bays across its own depth and came out
// with one. The pavement paints through the pass-1 (castShadow) channel — it is
// ground, so car shadows must land ON it rather than be covered by it.
const $e81502d4aa27ba48$var$STALL_PITCH = 12; // 2.4 m, a real bay
const $e81502d4aa27ba48$var$BAY_DEPTH = 24; // 4.8 m, one row nose-in
/** Length of a lot holding `bays` stalls, given how stalls are counted below. */ const $e81502d4aa27ba48$var$lotLength = (bays)=>bays * $e81502d4aa27ba48$var$STALL_PITCH + 6;
function $e81502d4aa27ba48$var$parkingLot(g, rng, T, x, y, w, h, vert = false) {
    $e81502d4aa27ba48$var$castShadow(()=>{
        $e81502d4aa27ba48$var$dither(g, rng, x, y, w, h, T.road, T.ground2, 0.06);
        g.r(x, y, w, 2, T.structDark); // full curb ring
        g.r(x, y + h - 2, w, 2, T.structDark);
        g.r(x, y, 2, h, T.structDark);
        g.r(x + w - 2, y, 2, h, T.structDark);
        g.a(0.35, ()=>g.r(x + 1, y + 1, w - 2, 1, T.structLight)); // lit curb lip
    });
    const along = vert ? h : w, deep = vert ? w : h;
    const stalls = Math.floor((along - 6) / $e81502d4aa27ba48$var$STALL_PITCH);
    for(let i = 0; i <= stalls; i++)if (rng() < 0.85) g.a(0.8, ()=>vert ? g.r(x + 6, y + 3 + i * $e81502d4aa27ba48$var$STALL_PITCH, 15, 1, T.accent) : g.r(x + 3 + i * $e81502d4aa27ba48$var$STALL_PITCH, y + 6, 1, 15, T.accent));
    // Nose-in, and kept inside the kerb: a car is 18 long in a 24-deep bay, so
    // there is 3 units of clearance at each end and nothing to jitter over.
    for(let i = 0; i < stalls; i++){
        const slack = $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, deep - 18 - 6));
        if (rng() < 0.6) {
            const at = 3 + slack;
            $e81502d4aa27ba48$var$carSmall(g, rng, T, vert ? x + at : x + 6 + i * $e81502d4aa27ba48$var$STALL_PITCH, vert ? y + 6 + i * $e81502d4aa27ba48$var$STALL_PITCH : y + at, !vert);
        }
    }
}
/**
 * A run of pipe on the surface, lit along its crown and dark along its
 * underside, with flanges at a fixed pitch. Irrigation lattices, cable trays
 * and conveyor runs are all this shape at different widths and axes, so it
 * lives here rather than being copied into each of them.
 *
 * @param {number} th  the run's thickness across its axis
 * @param {number} [pitch] units between flanges; 0 draws a bare run
 */ function $e81502d4aa27ba48$var$pipeRun(g, T, x, y, len, vert, th = 6, pitch = 24, body = 'metal') {
    const w = vert ? th : len, h = vert ? len : th;
    g.r(x, y, w, h, T[body]);
    if (vert) {
        g.r(x, y, 1, h, T.structLight);
        g.r(x + th - 1, y, 1, h, T.structDark);
    } else {
        g.r(x, y, w, 1, T.structLight);
        g.r(x, y + th - 1, w, 1, T.structDark);
    }
    if (!pitch) return;
    for(let d = pitch >> 1; d < len; d += pitch)if (vert) g.r(x - 2, y + d, th + 4, 3, T.structDark);
    else g.r(x + d, y - 2, 3, th + 4, T.structDark);
}
function $e81502d4aa27ba48$var$tankTop(g, rng, T, cx, cy, r = 15) {
    $e81502d4aa27ba48$var$discShadow(g, T, cx, cy, r);
    $e81502d4aa27ba48$var$disc(g, cx, cy, r, T.metal);
    $e81502d4aa27ba48$var$ringO(g, cx, cy, r, T.structDark);
    $e81502d4aa27ba48$var$ringO(g, cx, cy, r - 1, T.structDark);
    g.a(0.5, ()=>$e81502d4aa27ba48$var$disc(g, cx - 2, cy - 2, Math.max(2, r - 7), T.structLight)); // sheen
    g.a(0.25, ()=>$e81502d4aa27ba48$var$ringO(g, cx, cy, Math.max(3, r - 5), T.structDark)); // seam ring
    for(let i = 0; i < 4; i++){
        const a = i * Math.PI / 2 + 0.4;
        g.r(cx + Math.round(Math.cos(a) * (r - 4)) - 1, cy + Math.round(Math.sin(a) * (r - 4)) - 1, 3, 3, T.structDark);
    }
    g.r(cx - 2, cy - 2, 5, 5, T.structDark); // center cap
    g.r(cx - 1, cy - 1, 3, 3, T.metal);
}
function $e81502d4aa27ba48$var$towerTop(g, rng, T, x, y) {
    $e81502d4aa27ba48$var$castShadow(()=>g.a(0.4, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx * 2, y + $e81502d4aa27ba48$var$SHADOW.dy * 2, 15, 15, T.far))); // tall = long shadow
    g.r(x, y, 15, 15, T.struct);
    g.r(x, y, 15, 1, T.structLight);
    g.r(x, y, 1, 15, T.structLight);
    g.r(x, y + 14, 15, 1, T.structDark);
    g.r(x + 14, y, 1, 15, T.structDark);
    // lattice legs meeting at the mast
    g.a(0.45, ()=>{
        for(let i = 1; i < 14; i++){
            g.r(x + i, y + i, 1, 1, T.structDark);
            g.r(x + 14 - i, y + i, 1, 1, T.structDark);
        }
    });
    g.r(x + 5, y + 5, 5, 5, T.metal); // mast base
    g.r(x + 6, y + 6, 3, 3, T.accent); // mast tip
}
const $e81502d4aa27ba48$export$f4eeec8c0ee13647 = {
    city (g, rng, T) {
        $e81502d4aa27ba48$var$grain(g, rng, T.ground1, T.ground2, 0.18);
        $e81502d4aa27ba48$var$mottle(g, rng, T.structDark, 2);
        $e81502d4aa27ba48$var$mottle(g, rng, T.structLight, 1, 0.07);
        // Pavement slab seams. The pitch stays on the 30px world grid so slabs
        // line up across cells, but the seam itself is now a 1px score line
        // rather than a 3px band — the reason it had to be held at alpha 0.06 to
        // avoid reading as a grid, so it can carry a little more weight.
        g.a(0.10, ()=>{
            for(let i = 0; i < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; i += 30){
                g.r(i, 0, 1, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, T.structDark);
                g.r(0, i, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, 1, T.structDark);
            }
        });
        for(let i = 0; i < 2; i++)$e81502d4aa27ba48$var$crack(g, rng, T, $e81502d4aa27ba48$var$ri(rng, 12, 102), $e81502d4aa27ba48$var$ri(rng, 12, 90), $e81502d4aa27ba48$var$ri(rng, 15, 27));
    },
    greenhouse (g, rng, T) {
        $e81502d4aa27ba48$var$grain(g, rng, T.ground1, T.ground2, 0.25);
        $e81502d4aa27ba48$var$mottle(g, rng, T.veg1, 3, 0.18);
        $e81502d4aa27ba48$var$mottle(g, rng, T.veg2, 2, 0.1);
        for(let i = 0; i < 30; i++)g.r($e81502d4aa27ba48$var$ri(rng, 0, 116), $e81502d4aa27ba48$var$ri(rng, 0, 116), $e81502d4aa27ba48$var$ri(rng, 2, 5), $e81502d4aa27ba48$var$ri(rng, 1, 2), T.veg1); // moss
        for(let i = 0; i < 24; i++)g.r($e81502d4aa27ba48$var$ri(rng, 0, 118), $e81502d4aa27ba48$var$ri(rng, 0, 118), $e81502d4aa27ba48$var$ri(rng, 1, 2), 1, T.veg2);
        for(let i = 0; i < 10; i++)g.r($e81502d4aa27ba48$var$ri(rng, 0, 118), $e81502d4aa27ba48$var$ri(rng, 0, 118), 1, 1, T.glow); // wildflowers
        for(let i = 0; i < 14; i++){
            const bx = $e81502d4aa27ba48$var$ri(rng, 0, 118), by = $e81502d4aa27ba48$var$ri(rng, 2, 118);
            g.r(bx, by - 2, 1, 3, T.veg2);
        }
    },
    harbor (g, rng, T) {
        $e81502d4aa27ba48$var$grain(g, rng, T.ground1, T.ground2, 0.2);
        $e81502d4aa27ba48$var$mottle(g, rng, T.structDark, 2);
        $e81502d4aa27ba48$var$mottle(g, rng, T.water1, 2, 0.15); // damp silt sheen
        for(let i = 0; i < 8; i++){
            const ty = $e81502d4aa27ba48$var$ri(rng, 6, 114);
            g.a(0.18, ()=>g.r($e81502d4aa27ba48$var$ri(rng, 0, 90), ty, $e81502d4aa27ba48$var$ri(rng, 12, 30), 1, T.water2));
        }
    },
    foundry (g, rng, T) {
        $e81502d4aa27ba48$var$grain(g, rng, T.ground1, T.ground2, 0.22);
        $e81502d4aa27ba48$var$mottle(g, rng, T.rust, 2, 0.18);
        $e81502d4aa27ba48$var$mottle(g, rng, T.structDark, 1);
        for(let i = 0; i < 18; i++)g.a(0.5, ()=>g.r($e81502d4aa27ba48$var$ri(rng, 6, 108), $e81502d4aa27ba48$var$ri(rng, 6, 108), $e81502d4aa27ba48$var$ri(rng, 3, 9), $e81502d4aa27ba48$var$ri(rng, 1, 2), T.rust));
        g.a(0.15, ()=>g.r(0, 60, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, 2, T.structDark)); // expansion joint
        g.a(0.10, ()=>g.r(0, 59, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, 1, T.structLight));
    },
    underground (g, rng, T) {
        $e81502d4aa27ba48$var$grain(g, rng, T.ground1, T.ground2, 0.18);
        $e81502d4aa27ba48$var$mottle(g, rng, T.far, 2, 0.2);
        g.a(0.3, ()=>{
            for(let i = 12; i < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; i += 24){
                g.r(i, 0, 1, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, T.structDark);
                g.r(0, i, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, 1, T.structDark);
            } // floor grating
        });
        g.a(0.15, ()=>{
            for(let i = 0; i < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; i += 24){
                g.r(i, 0, 1, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, T.structLight);
                g.r(0, i, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, 1, T.structLight);
            }
        });
    }
};
// ---- clearings ----
// A rest stop and a shoreline are the two places on the map nobody paved. They
// were drawn as the region's own floor with a tent or a lake dropped on it,
// which read as a pond in a car park. They get turf instead: solid across the
// middle, and thinning to nothing over the last CLEARING_MARGIN units so the
// tile still meets whatever is next door without a line around it. The seam
// has to survive in every direction — a clearing can have a street, a hazard
// or another clearing on any side.
const $e81502d4aa27ba48$var$CLEARING_MARGIN = 14;
/** The rooms nobody paved. */ const $e81502d4aa27ba48$var$CLEARING_RECIPES = new Set([
    'water',
    'campsite'
]);
/**
 * @param {object} [cont] which sides the open ground carries on across, from
 *   room.clearing. Those sides run full bleed instead of fading, or the rest
 *   stop and the shoreline beside it each fade at the edge they share and put
 *   a strip of tarmac through the middle of one clearing.
 */ function $e81502d4aa27ba48$var$clearing(g, rng, T, cont = {}) {
    const M = $e81502d4aa27ba48$var$CLEARING_MARGIN;
    const x0 = cont.w ? 0 : M, y0 = cont.n ? 0 : M;
    const x1 = cont.e ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f : $e81502d4aa27ba48$export$9e15ff8aa6bc996f - M, y1 = cont.s ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f : $e81502d4aa27ba48$export$9e15ff8aa6bc996f - M;
    g.r(x0, y0, x1 - x0, y1 - y0, T.veg1); // turf
    // The fringe reaches from the turf out toward the edges that END here,
    // thinning as it goes, so the two grounds interleave rather than meeting at a
    // border. It overlaps the turf by a few units, which hides the turf's own
    // edge. A side the clearing continues across is already full bleed and has
    // nothing to fade into.
    const OPEN = $e81502d4aa27ba48$export$9e15ff8aa6bc996f; // a side that never fades
    for(let i = 0; i < 3600; i++){
        const x = rng() * $e81502d4aa27ba48$export$9e15ff8aa6bc996f, y = rng() * $e81502d4aa27ba48$export$9e15ff8aa6bc996f;
        const d = Math.min(cont.w ? OPEN : x, cont.n ? OPEN : y, cont.e ? OPEN : $e81502d4aa27ba48$export$9e15ff8aa6bc996f - x, cont.s ? OPEN : $e81502d4aa27ba48$export$9e15ff8aa6bc996f - y);
        if (d > M + 4 || rng() > (d / M) ** 1.5) continue;
        g.r(x | 0, y | 0, $e81502d4aa27ba48$var$ri(rng, 2, 5), $e81502d4aa27ba48$var$ri(rng, 1, 3), rng() < 0.65 ? T.veg1 : T.veg2);
    }
    // and the turf is not a flat colour: tufts, moss and blades, the same
    // vocabulary the greenhouse floor is built from
    for(let i = 0; i < 150; i++)g.r($e81502d4aa27ba48$var$ri(rng, x0, x1), $e81502d4aa27ba48$var$ri(rng, y0, y1), $e81502d4aa27ba48$var$ri(rng, 2, 6), $e81502d4aa27ba48$var$ri(rng, 1, 2), T.veg2);
    for(let i = 0; i < 60; i++)g.a(0.5, ()=>g.r($e81502d4aa27ba48$var$ri(rng, x0, x1), $e81502d4aa27ba48$var$ri(rng, y0, y1), $e81502d4aa27ba48$var$ri(rng, 1, 3), 1, T.ground2));
    for(let i = 0; i < 40; i++){
        const bx = $e81502d4aa27ba48$var$ri(rng, x0, x1), by = $e81502d4aa27ba48$var$ri(rng, y0 + 3, y1);
        g.r(bx, by - 2, 1, 3, T.veg2);
    }
}
// Road/path connectors, drawn ONLY where the generated road network says a
// road runs (see roadNetwork-core.js). Directions come from that network, not
// from "is this neighbour walkable" — under the old rule almost every tile was
// connected to all four sides, so every tile drew the same cross and the roads
// told you nothing about the place.
//
// The trunk gets the full roadway; branches get a narrower lane. A tile the
// network misses draws nothing at all.
// tune.roadWear (0..1) degrades surfaces: potholes, missing lane paint,
// cracks, and vegetation reclaiming the pavement.
const $e81502d4aa27ba48$var$ROAD_W = 30, $e81502d4aa27ba48$var$LANE_W = 15;
const $e81502d4aa27ba48$var$RANK_W = {
    major: $e81502d4aa27ba48$var$ROAD_W,
    minor: $e81502d4aa27ba48$var$LANE_W
};
// ---- where a road crosses a tile edge ----
//
// Locking every crossing to the edge midpoint is what forced the old shapes: a
// tile with road on opposite edges could only draw a straight line or a bow,
// and bowing each tile independently produced a sine wave with a one-tile
// period, because the curvature reversed at every seam.
//
// So the crossings move. Both tiles sharing an edge derive the SAME offset from
// that edge's own coordinates, so they agree without talking to each other —
// there is no propagation across the grid, and no way for one tile to pick a
// crossing its neighbour cannot meet.
//
// The offset is sampled from the smooth-noise field rather than hashed per
// edge. Neighbouring edges then get SIMILAR offsets and a road wanders over
// several tiles; hashing each edge independently would kink at every seam, the
// same mistake as the bow at a different frequency.
const $e81502d4aa27ba48$var$EDGE_DRIFT = 3.5; // tiles per wavelength of the wander
const $e81502d4aa27ba48$var$EDGE_SWING = 24; // furthest a crossing may sit off centre
const $e81502d4aa27ba48$var$EDGE_MARGIN = 6; // and never nearer than this to a corner
function $e81502d4aa27ba48$export$cfdc75f9711ba396(row, col, dir = 'n', w = $e81502d4aa27ba48$var$LANE_W) {
    // Without a grid position there is no shared edge to key off, so every
    // crossing goes down the middle. Unhelpful, but every tile agrees — which is
    // the one property that must never break. Defaulting the position to 0,0
    // instead gave each tile the same WRONG pair of offsets (a tile's north edge
    // and its neighbour's south edge are different samples at 0,0), and the
    // seams came apart wherever a caller forgot to pass the position.
    if (row == null || col == null) return 0;
    const horizontal = dir === 'n' || dir === 's';
    // the edge's own identity: the cells either side of it name it the same way
    const r = dir === 's' ? row + 1 : row;
    const c = dir === 'e' ? col + 1 : col;
    const n = $e81502d4aa27ba48$var$smoothNoise((c + (horizontal ? 0.5 : 0)) / $e81502d4aa27ba48$var$EDGE_DRIFT, (r + (horizontal ? 0 : 0.5)) / $e81502d4aa27ba48$var$EDGE_DRIFT + (horizontal ? 0 : 37));
    const limit = Math.min($e81502d4aa27ba48$var$EDGE_SWING, Math.max(0, ($e81502d4aa27ba48$export$9e15ff8aa6bc996f - w) / 2 - $e81502d4aa27ba48$var$EDGE_MARGIN));
    return Math.round((n * 2 - 1) * limit);
}
// ---- stroking a road along a path ----
// Every form is a centreline and a width. Rendering them all through one
// routine means a bend, a straight run and a junction arm get the same surface,
// curbs and paint, and a new shape is a new list of points rather than new
// drawing code — which is what the quarter-annulus could never be.
const $e81502d4aa27ba48$var$mid2 = ()=>$e81502d4aa27ba48$export$9e15ff8aa6bc996f / 2;
/** Where a road meets one edge of the tile, given that edge's offset. */ const $e81502d4aa27ba48$var$edgePoint = (dir, off)=>dir === 'n' ? [
        $e81502d4aa27ba48$var$mid2() + off,
        0
    ] : dir === 's' ? [
        $e81502d4aa27ba48$var$mid2() + off,
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f
    ] : dir === 'w' ? [
        0,
        $e81502d4aa27ba48$var$mid2() + off
    ] : [
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f,
        $e81502d4aa27ba48$var$mid2() + off
    ];
/** A point straight in from an edge — a control point that leaves it squarely. */ const $e81502d4aa27ba48$var$inward = (dir, [x, y], d)=>dir === 'n' ? [
        x,
        y + d
    ] : dir === 's' ? [
        x,
        y - d
    ] : dir === 'w' ? [
        x + d,
        y
    ] : [
        x - d,
        y
    ];
/**
 * Cubic through p0 and p3 with the tangents fixed by c1/c2.
 *
 * Cubic rather than quadratic because both ends need their own tangent: a road
 * has to leave every edge at right angles to it, or its tangent disagrees with
 * the neighbour's and the seam shows as a kink.
 */ function $e81502d4aa27ba48$var$cubic(p0, c1, c2, p3, n) {
    const out = [];
    for(let i = 0; i <= n; i++){
        const t = i / n, u = 1 - t;
        const a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
        out.push([
            a * p0[0] + b * c1[0] + c * c2[0] + d * p3[0],
            a * p0[1] + b * c1[1] + c * c2[1] + d * p3[1]
        ]);
    }
    return out;
}
/** 1px line between two points, for curbs that follow a curve. */ function $e81502d4aa27ba48$var$plot(g, [x0, y0], [x1, y1], c) {
    const steps = Math.max(1, Math.round(Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0))));
    for(let i = 0; i <= steps; i++)g.r(Math.round(x0 + (x1 - x0) * i / steps), Math.round(y0 + (y1 - y0) * i / steps), 1, 1, c);
}
/**
 * Lay road down a centreline.
 *
 * The band is the centreline offset by half its width to either side, filled by
 * scanline. An earlier version drew one axis-aligned span per sample, picking
 * the axis from the local tangent — but that choice flips somewhere in every
 * turn, and where it did, the two families of spans met at a corner and left a
 * triangular notch bitten out of the outside of the bend. Offsetting the curve
 * has no axis to flip, and costs less: the work follows the tile's height
 * rather than the number of samples.
 *
 * `width` may be a number or a function of t, which is what lets a branch flare
 * out where it meets the roadway.
 */ function $e81502d4aa27ba48$var$strokePath(g, rng, T, pts, p, tune, width = p.w) {
    const wear = tune.roadWear;
    const at = typeof width === 'function' ? width : ()=>width;
    const left = [], right = [];
    let lo = $e81502d4aa27ba48$export$9e15ff8aa6bc996f, hi = 0;
    for(let i = 0; i < pts.length; i++){
        const a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
        let tx = b[0] - a[0], ty = b[1] - a[1];
        const len = Math.hypot(tx, ty) || 1;
        tx /= len;
        ty /= len;
        const h = at(i / (pts.length - 1)) / 2;
        const [x, y] = pts[i];
        left.push([
            x - ty * h,
            y + tx * h
        ]);
        right.push([
            x + ty * h,
            y - tx * h
        ]);
        lo = Math.min(lo, y - h);
        hi = Math.max(hi, y + h);
    }
    const poly = [
        ...left,
        ...right.slice().reverse()
    ];
    // scanline fill; a turn can put two runs of road on one row, so cross every
    // edge and fill the crossings in pairs
    const rows = [];
    for(let y = Math.max(0, Math.floor(lo)); y < Math.min($e81502d4aa27ba48$export$9e15ff8aa6bc996f, Math.ceil(hi) + 1); y++){
        const yc = y + 0.5, xs = [];
        for(let i = 0, n = poly.length; i < n; i++){
            const [x1, y1] = poly[i], [x2, y2] = poly[(i + 1) % n];
            if (y1 <= yc === y2 <= yc) continue;
            xs.push(x1 + (yc - y1) / (y2 - y1) * (x2 - x1));
        }
        xs.sort((a, b)=>a - b);
        for(let i = 0; i + 1 < xs.length; i += 2){
            const x0 = Math.max(0, Math.round(xs[i])), x1 = Math.min($e81502d4aa27ba48$export$9e15ff8aa6bc996f, Math.round(xs[i + 1]));
            if (x1 > x0) rows.push([
                x0,
                y,
                x1 - x0
            ]);
        }
    }
    if (!rows.length) return;
    let grit = 0;
    for (const [x, y, w] of rows){
        g.r(x, y, w, 1, p.col);
        grit += w * $e81502d4aa27ba48$export$fae5d17304677194 * $e81502d4aa27ba48$export$fae5d17304677194 * p.den / ($e81502d4aa27ba48$var$SPECK * $e81502d4aa27ba48$var$SPECK);
        while(grit >= 1){
            g.p((x + rng() * w) * $e81502d4aa27ba48$export$fae5d17304677194, y * $e81502d4aa27ba48$export$fae5d17304677194, $e81502d4aa27ba48$var$SPECK, $e81502d4aa27ba48$var$SPECK, p.alt);
            grit--;
        }
    }
    for(let i = 0, n = Math.round(rows.length * wear * 0.06); i < n; i++){
        const [x, y, w] = rows[Math.floor(rng() * rows.length)]; // wear, scattered along the run
        const pw = $e81502d4aa27ba48$var$ri(rng, 3, 8);
        g.r(x + rng() * Math.max(1, w - pw), y, pw, $e81502d4aa27ba48$var$ri(rng, 2, 4), rng() < 0.5 ? T.ground1 : T.ground2);
    }
    if (!p.isMajor) return;
    for(let i = 1; i < left.length; i++){
        $e81502d4aa27ba48$var$plot(g, left[i - 1], left[i], T.structDark);
        $e81502d4aa27ba48$var$plot(g, right[i - 1], right[i], T.structDark);
    }
    // Dashed centreline, by arc length — and only where the surface is still a
    // full roadway. A branch flaring out to meet the road, or a run narrowing
    // into a lane, carries the median no further than its own width earns it.
    let run = 0;
    for(let i = 1; i < pts.length; i++){
        run += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
        if (at(i / (pts.length - 1)) < $e81502d4aa27ba48$var$ROAD_W - 1) continue;
        if (run % 18 > 9 || rng() < wear) continue;
        g.r(Math.round(pts[i][0]) - 1, Math.round(pts[i][1]) - 1, 2, 2, T.accent);
    }
}
// Surface of one band: base tone, grit, potholes, and for the roadway some
// growth pushing through and the odd crack.
function $e81502d4aa27ba48$var$potholes(g, rng, T, bx, by, bw, bh, wear) {
    const n = Math.round(bw * bh * wear * 0.006); // px^2 — densities are per pixel
    for(let i = 0; i < n; i++){
        const px = bx + rng() * bw, py = by + rng() * bh;
        const pw = $e81502d4aa27ba48$var$ri(rng, 3, 9), ph = $e81502d4aa27ba48$var$ri(rng, 2, 4);
        g.r(px, py, pw, ph, rng() < 0.5 ? T.ground1 : T.ground2);
        g.a(0.4, ()=>g.r(px, py, pw, 1, T.structDark)); // broken lip
    }
}
function $e81502d4aa27ba48$var$bandSurface(g, rng, T, bx, by, bw, bh, col, alt, den, isMajor, wear) {
    $e81502d4aa27ba48$var$dither(g, rng, bx, by, bw, bh, col, alt, den);
    $e81502d4aa27ba48$var$potholes(g, rng, T, bx, by, bw, bh, wear);
    if (!isMajor) return;
    const tufts = Math.round(bw * bh * wear * wear * 0.02); // growth through pavement
    for(let i = 0; i < tufts; i++)g.r(bx + rng() * bw, by + rng() * bh, $e81502d4aa27ba48$var$ri(rng, 1, 2), $e81502d4aa27ba48$var$ri(rng, 1, 2), rng() < 0.6 ? T.veg1 : T.veg2);
    if (rng() < wear) $e81502d4aa27ba48$var$crack(g, rng, T, bx + (bw >> 1), by + (bh >> 1), $e81502d4aa27ba48$var$ri(rng, 12, 24));
}
// ---- road forms ----
// The network already produces a good spread of shapes — a third of road tiles
// run straight through, a quarter bend, a sixth dead-end. A form turns one of
// those into a centreline: two edge crossings (wherever edgeOffset puts them)
// joined by a curve that leaves each edge squarely, so the tangent agrees with
// whatever the neighbour drew.
const $e81502d4aa27ba48$var$CURVE_SAMPLES = 48; // enough for the offset band to read smooth
const $e81502d4aa27ba48$var$REACH_IN = $e81502d4aa27ba48$export$9e15ff8aa6bc996f * 0.55; // control-point pull off an edge
/**
 * A run between two edges — opposite or adjacent, it is the same curve.
 *
 * `pull` is how far the control points sit off each edge, which sets the turn
 * radius. It does not affect the tangent AT the edge, so tightening a turn
 * cannot break the seam. Junction fillets use a short pull: at the full sweep
 * a three-way turned the whole tile into one apron of asphalt.
 */ function $e81502d4aa27ba48$var$throughPath(d0, off0, d1, off1, pull = $e81502d4aa27ba48$var$REACH_IN) {
    const a = $e81502d4aa27ba48$var$edgePoint(d0, off0), b = $e81502d4aa27ba48$var$edgePoint(d1, off1);
    return $e81502d4aa27ba48$var$cubic(a, $e81502d4aa27ba48$var$inward(d0, a, pull), $e81502d4aa27ba48$var$inward(d1, b, pull), b, $e81502d4aa27ba48$var$CURVE_SAMPLES);
}
/** An arm from one edge to the apron in the middle of the junction. */ function $e81502d4aa27ba48$var$armPath(dir, off, to) {
    const a = $e81502d4aa27ba48$var$edgePoint(dir, off);
    return $e81502d4aa27ba48$var$cubic(a, $e81502d4aa27ba48$var$inward(dir, a, $e81502d4aa27ba48$var$REACH_IN * 0.6), to, to, $e81502d4aa27ba48$var$CURVE_SAMPLES >> 1);
}
const $e81502d4aa27ba48$var$OPPOSITE_DIR = {
    n: 's',
    s: 'n',
    e: 'w',
    w: 'e'
};
function $e81502d4aa27ba48$export$a9b8e204c1a2976e(dirs, road) {
    const rank = (d)=>$e81502d4aa27ba48$var$RANK_W[road[d]] || $e81502d4aa27ba48$var$LANE_W;
    const pairs = [];
    for(let i = 0; i < dirs.length; i++)for(let j = i + 1; j < dirs.length; j++)pairs.push([
        dirs[i],
        dirs[j]
    ]);
    const opposed = ([a, b])=>$e81502d4aa27ba48$var$OPPOSITE_DIR[a] === b ? 1 : 0;
    pairs.sort((a, b)=>Math.min(rank(b[0]), rank(b[1])) - Math.min(rank(a[0]), rank(a[1])) || opposed(b) - opposed(a));
    const through = [], rest = new Set(dirs);
    for (const [a, b] of pairs){
        if (!rest.has(a) || !rest.has(b)) continue;
        through.push([
            a,
            b
        ]);
        rest.delete(a);
        rest.delete(b);
    }
    return {
        through: through,
        joins: [
            ...rest
        ]
    };
}
/** A round patch of road surface — the base of a turning circle. */ function $e81502d4aa27ba48$var$pavedDisc(g, rng, T, cx, cy, r, p, wear) {
    $e81502d4aa27ba48$var$disc(g, cx, cy, r, p.col);
    const specks = Math.round(r * r * 3 * p.den / ($e81502d4aa27ba48$var$SPECK * $e81502d4aa27ba48$var$SPECK));
    for(let i = 0; i < specks; i++){
        const a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * r;
        g.p(cx + Math.cos(a) * d, cy + Math.sin(a) * d, $e81502d4aa27ba48$var$SPECK, $e81502d4aa27ba48$var$SPECK, p.alt);
    }
    for(let i = 0, n = Math.round(r * wear * 0.3); i < n; i++){
        const a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * (r - 3);
        g.r(cx + Math.cos(a) * d, cy + Math.sin(a) * d, $e81502d4aa27ba48$var$ri(rng, 2, 5), 2, rng() < 0.5 ? T.ground1 : T.ground2);
    }
}
// A branch meeting the roadway shouldn't jump to lane width the moment it
// leaves — that reads as a step. Width eases from the arm's own road at the
// tile edge to the apron's at the middle, so a narrow branch flares as it joins.
const $e81502d4aa27ba48$var$smoothstep = (t)=>t * t * (3 - 2 * t);
const $e81502d4aa27ba48$var$easedWidth = (w0, w1)=>(t)=>w0 + (w1 - w0) * $e81502d4aa27ba48$var$smoothstep(t);
/**
 * The end of a track. Three ways for a road to stop, where before there was
 * only a band that ran to the middle of the tile and quit: a gated entryway
 * that never reaches the centre, a turning circle, and a hardstand apron.
 */ function $e81502d4aa27ba48$var$terminus(g, rng, T, dir, p, tune, kind, reach, off = 0) {
    const wear = tune.roadWear;
    const horizontal = dir === 'e' || dir === 'w';
    const start = $e81502d4aa27ba48$var$edgePoint(dir, off);
    // the run heads straight in from wherever it crossed the edge and stops
    const stop = $e81502d4aa27ba48$var$inward(dir, start, reach);
    $e81502d4aa27ba48$var$strokePath(g, rng, T, $e81502d4aa27ba48$var$cubic(start, $e81502d4aa27ba48$var$inward(dir, start, reach * 0.5), stop, stop, 90), p, tune);
    const [hx, hy] = stop.map(Math.round);
    const o = Math.round((horizontal ? hy : hx) - p.w / 2);
    if (kind === 'gate') {
        const post = (x, y)=>{
            g.r(x, y, 3, 3, T.structDark);
            g.r(x, y, 3, 1, T.structLight);
        };
        if (horizontal) {
            post(hx - 1, o - 4);
            post(hx - 1, o + p.w + 1);
            g.a(0.8, ()=>g.r(hx - 1, o - 3, 2, p.w + 6, T.metal)); // the barrier itself
        } else {
            post(o - 4, hy - 1);
            post(o + p.w + 1, hy - 1);
            g.a(0.8, ()=>g.r(o - 3, hy - 1, p.w + 6, 2, T.metal));
        }
    } else if (kind === 'circle') {
        const r = Math.max(12, p.w);
        $e81502d4aa27ba48$var$pavedDisc(g, rng, T, hx, hy, r, p, wear);
        g.a(0.35, ()=>$e81502d4aa27ba48$var$ringO(g, hx, hy, r, T.structDark));
        // a third of the radius, not a fixed inset — at lane width a fixed one ate
        // the whole circle and left a donut
        const island = Math.max(3, Math.round(r * 0.36));
        $e81502d4aa27ba48$var$disc(g, hx, hy, island, T.ground2);
        g.a(0.4, ()=>$e81502d4aa27ba48$var$ringO(g, hx, hy, island, T.structDark));
        for(let i = 0, n = Math.round(r * 0.4); i < n; i++){
            const a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * Math.max(2, island - 2);
            g.r(hx + Math.cos(a) * d, hy + Math.sin(a) * d, 2, 2, rng() < 0.6 ? T.veg1 : T.veg2);
        }
    } else {
        const aw = $e81502d4aa27ba48$var$ri(rng, 30, 42), ah = $e81502d4aa27ba48$var$ri(rng, 24, 33);
        const ax = Math.round(hx - aw / 2), ay = Math.round(hy - ah / 2);
        $e81502d4aa27ba48$var$bandSurface(g, rng, T, ax, ay, aw, ah, p.col, p.alt, p.den, p.isMajor, wear);
        g.a(0.3, ()=>{
            g.r(ax, ay, aw, 1, T.structDark);
            g.r(ax, ay + ah - 1, aw, 1, T.structDark);
            g.r(ax, ay, 1, ah, T.structDark);
            g.r(ax + aw - 1, ay, 1, ah, T.structDark);
        });
    }
}
// ---- routing around what a road cannot cross ----
// Every form above is one CANDIDATE. Which one a tile uses is settled by
// sampling each candidate's centreline against the buildings the recipe is
// about to draw (measured, not declared — see makeProbeG) and taking the one
// that runs through the fewest. The seeded preference order decides ties, so
// tiles still vary wherever there is nothing to avoid.
const $e81502d4aa27ba48$var$SAMPLE_STEP = 4; // units between centreline samples
// Samples are a BOUND on where the roadway lands, not a copy of it, so they run
// a shade wider than the surface: a disc rasterises a pixel past its radius, a
// kerb sits on the outside of its band, and every coordinate rounds. Suppressing
// a building a pixel early costs nothing anybody can see; keeping one a pixel
// late is a roof on the tarmac.
const $e81502d4aa27ba48$var$CLEARANCE = 1;
function $e81502d4aa27ba48$var$samplesFor(spec) {
    const mid = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1, out = [];
    const step = $e81502d4aa27ba48$var$SAMPLE_STEP / 2;
    // A sample covers the road's full width ACROSS its direction of travel and
    // only one step ALONG it. Squaring it off instead would claim the road is as
    // long as it is wide at every point, which reads a building well ahead of
    // the road as being in its way.
    const along = (pts, w)=>{
        for(let i = 0; i < pts.length; i += 2){
            const a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
            const horizontal = Math.abs(b[0] - a[0]) >= Math.abs(b[1] - a[1]);
            out.push({
                x: pts[i][0],
                y: pts[i][1],
                hx: (horizontal ? step : w / 2) + $e81502d4aa27ba48$var$CLEARANCE,
                hy: (horizontal ? w / 2 : step) + $e81502d4aa27ba48$var$CLEARANCE
            });
        }
    };
    const blob = (x, y, w)=>out.push({
            x: x,
            y: y,
            hx: w / 2 + $e81502d4aa27ba48$var$CLEARANCE,
            hy: w / 2 + $e81502d4aa27ba48$var$CLEARANCE
        });
    if (spec.form === 'through') along($e81502d4aa27ba48$var$throughPath(spec.d0, spec.off0, spec.d1, spec.off1), spec.p.w);
    else if (spec.form === 'end') {
        const start = $e81502d4aa27ba48$var$edgePoint(spec.dir, spec.off || 0);
        const stop = $e81502d4aa27ba48$var$inward(spec.dir, start, spec.reach);
        along($e81502d4aa27ba48$var$cubic(start, $e81502d4aa27ba48$var$inward(spec.dir, start, spec.reach * 0.5), stop, stop, 60), spec.p.w);
        const pad = spec.kind === 'gate' ? spec.p.w : Math.max(24, spec.p.w * 2);
        blob(stop[0], stop[1], pad); // the pad is the widest part
    } else {
        const { through: through, joins: joins } = $e81502d4aa27ba48$export$a9b8e204c1a2976e(spec.dirs, spec.road);
        const runs = through.map(([a, b])=>$e81502d4aa27ba48$var$throughPath(a, spec.offs?.[a] ?? 0, b, spec.offs?.[b] ?? 0));
        runs.forEach((pts, i)=>along(pts, Math.max(spec.widths[through[i][0]], spec.widths[through[i][1]])));
        const host = runs[runs.length - 1];
        const meet = host[host.length >> 1];
        for (const dir of joins)along($e81502d4aa27ba48$var$armPath(dir, spec.offs?.[dir] ?? 0, meet), spec.widths[dir]);
    }
    return out;
}
// Inclusive at both ends: a band whose edge lands exactly on a building's edge
// shares that row of pixels with it, and the strict comparison this replaced
// called that a clear miss — the roadway then painted a sliver of roof.
const $e81502d4aa27ba48$var$runsThrough = (samples, b)=>samples.some((s)=>s.x + s.hx >= b.x0 && s.x - s.hx <= b.x1 && s.y + s.hy >= b.y0 && s.y - s.hy <= b.y1);
/** Seeded shuffle, so the preference order varies per tile but stays stable. */ function $e81502d4aa27ba48$var$shuffled(list, rng) {
    const out = [
        ...list
    ];
    for(let i = out.length - 1; i > 0; i--){
        const j = Math.floor(rng() * (i + 1));
        [out[i], out[j]] = [
            out[j],
            out[i]
        ];
    }
    return out;
}
function $e81502d4aa27ba48$export$56465e66d3491b39(options, solids, rng) {
    const ordered = [
        ...$e81502d4aa27ba48$var$shuffled(options.filter((o)=>!o.fallback), rng),
        ...options.filter((o)=>o.fallback)
    ];
    const scored = ordered.map((o)=>{
        const samples = $e81502d4aa27ba48$var$samplesFor(o);
        return {
            o: o,
            samples: samples,
            hit: solids.filter((s)=>$e81502d4aa27ba48$var$runsThrough(samples, s))
        };
    });
    const best = scored.reduce((a, b)=>b.hit.length < a.hit.length ? b : a);
    return {
        form: best.o,
        samples: best.samples
    };
}
function $e81502d4aa27ba48$export$fa7182ef09b736f8(g, rng, T, road, tune, solids = [], row = null, col = null) {
    const dirs = [
        'n',
        'e',
        's',
        'w'
    ].filter((d)=>road[d]);
    if (!dirs.length) return null;
    const mid = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1;
    const wear = tune.roadWear;
    // A minor road is the SAME MATERIAL as a major one, just narrower, older and
    // less swept — so it is a shade of the road colour rather than a different
    // palette key. It used to borrow structDark, which is a building colour and
    // in several regions a different hue entirely: the lanes came out blue-grey
    // against brown-grey arterials and read as two unrelated networks. Deriving
    // it keeps the hue identical by construction, in every region, for free.
    const paint = (rank)=>({
            w: $e81502d4aa27ba48$var$RANK_W[rank] || $e81502d4aa27ba48$var$LANE_W,
            isMajor: rank === (0, $eaa96db7af263115$export$39615881bb0d21f6),
            col: rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? T.road : $e81502d4aa27ba48$var$shade(T.road, 0.78),
            alt: rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? T.ground2 : T.road,
            den: rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? 0.08 : 0.30
        });
    // where this tile's road meets each of its edges — agreed with the neighbour
    // on the far side of that edge, by construction
    const off = (dir)=>$e81502d4aa27ba48$export$cfdc75f9711ba396(row, col, dir, $e81502d4aa27ba48$var$RANK_W[road[dir]] || $e81502d4aa27ba48$var$LANE_W);
    // Every roll happens here, whatever the tile ends up drawing, so a tile's
    // appearance never depends on which candidate wins.
    const reach = $e81502d4aa27ba48$var$ri(rng, 30, 45);
    let options;
    if (dirs.length === 1) {
        const p = paint(road[dirs[0]]);
        // The crossing offset belongs on the option, not just on the draw call:
        // samplesFor reads it, and without it every dead end was measured running
        // down the middle of the tile while being drawn up to 24 units off it — so
        // the layout pass cleared a strip of ground the road was never on, and
        // built on the strip it was. Entry and extraction tiles are dead ends by
        // construction, which is where it showed worst.
        const o = off(dirs[0]);
        options = [
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'gate',
                reach: reach
            },
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'circle',
                reach: mid
            },
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'apron',
                reach: mid
            }
        ];
    } else if (dirs.length === 2) // One curve covers the straight run AND the bend: it leaves each edge
    // square to it and joins the two crossings. Where the crossings sit apart,
    // the run drifts across the tile — and because neighbouring edges get
    // similar offsets, that drift carries into the next tile instead of
    // reversing at the seam. Ranks need not match: a bend from a roadway into a
    // lane is still one run, and routing it through the junction code instead
    // gave it a square elbow on the inside of the turn.
    options = [
        {
            form: 'through',
            d0: dirs[0],
            d1: dirs[1],
            off0: off(dirs[0]),
            off1: off(dirs[1]),
            p: paint(road[dirs[0]]),
            p1: paint(road[dirs[1]])
        }
    ];
    else {
        const widths = Object.fromEntries(dirs.map((d)=>[
                d,
                paint(road[d]).w
            ]));
        const offs = Object.fromEntries(dirs.map((d)=>[
                d,
                off(d)
            ]));
        options = [
            {
                form: 'junction',
                dirs: dirs,
                widths: widths,
                offs: offs,
                road: road
            }
        ];
    }
    const { form: chosen, samples: samples } = $e81502d4aa27ba48$export$56465e66d3491b39(options, solids, rng);
    if (chosen.form === 'end') {
        $e81502d4aa27ba48$var$terminus(g, rng, T, chosen.dir, chosen.p, tune, chosen.kind, chosen.reach, chosen.off);
        return samples;
    }
    if (chosen.form === 'through') {
        const wide = chosen.p.w >= chosen.p1.w ? chosen.p : chosen.p1;
        $e81502d4aa27ba48$var$strokePath(g, rng, T, $e81502d4aa27ba48$var$throughPath(chosen.d0, chosen.off0, chosen.d1, chosen.off1), wide, tune, $e81502d4aa27ba48$var$easedWidth(chosen.p.w, chosen.p1.w));
        return samples;
    }
    const { through: through, joins: joins } = $e81502d4aa27ba48$export$a9b8e204c1a2976e(dirs, road);
    const runs = through.map(([a, b])=>({
            pts: $e81502d4aa27ba48$var$throughPath(a, chosen.offs[a], b, chosen.offs[b]),
            pa: paint(road[a]),
            pb: paint(road[b])
        })).sort((x, y)=>Math.max(x.pa.w, x.pb.w) - Math.max(y.pa.w, y.pb.w));
    // Arms first, so the through-road's surface covers where they land on it —
    // which is what a side road joining a main road actually looks like.
    const host = runs[runs.length - 1];
    const meet = host.pts[host.pts.length >> 1];
    for (const dir of joins){
        const p = paint(road[dir]);
        $e81502d4aa27ba48$var$strokePath(g, rng, T, $e81502d4aa27ba48$var$armPath(dir, chosen.offs[dir], meet), p, tune, $e81502d4aa27ba48$var$easedWidth(p.w, Math.max(host.pa.w, host.pb.w)));
    }
    for (const run of runs)$e81502d4aa27ba48$var$strokePath(g, rng, T, run.pts, run.pa.w >= run.pb.w ? run.pa : run.pb, tune, $e81502d4aa27ba48$var$easedWidth(run.pa.w, run.pb.w));
    return samples;
}
// ---- top-down elements ----
// The roof carries most of what a building reads as, and at 3px-per-block it
// could only ever be a slab with a stripe. Everything below — parapet, panel
// seams, plant, hatch — is one or two pixels wide and simply had nowhere to
// live before.
function $e81502d4aa27ba48$var$roofRect(g, rng, T, x, y, w, h) {
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.struct);
    if (rng() < 0.25) g.a(0.2, ()=>g.r(x + 1, y + 1, w - 2, h - 2, T.structDark)); // darker roofing material
    // panel seams across the long axis, under the edging
    g.a(0.16, ()=>{
        if (w >= h) for(let sx = x + 6; sx < x + w - 2; sx += 6)g.r(sx, y + 2, 1, h - 4, T.structDark);
        else for(let sy = y + 6; sy < y + h - 2; sy += 6)g.r(x + 2, sy, w - 4, 1, T.structDark);
    });
    g.r(x, y, w, 1, T.structLight); // lit N/W edges, 1px
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.structDark); // shaded S/E edges
    g.r(x + w - 1, y, 1, h, T.structDark);
    if (w >= 9 && h >= 9) g.a(0.3, ()=>{
        g.r(x + 2, y + 2, w - 4, 1, T.structLight);
        g.r(x + 2, y + 2, 1, h - 4, T.structLight);
        g.r(x + 2, y + h - 3, w - 4, 1, T.structDark);
        g.r(x + w - 3, y + 2, 1, h - 4, T.structDark);
    });
    if (w >= h) g.r(x + 1, y + (h >> 1), w - 2, 1, T.structDark); // roof ridge
    else g.r(x + (w >> 1), y + 1, 1, h - 2, T.structDark);
    if (rng() < 0.7) {
        const vx = x + 4 + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, w - 12)), vy = y + 4;
        g.r(vx, vy, 6, 5, T.metal);
        g.r(vx, vy, 6, 1, T.structLight);
        g.r(vx, vy + 4, 6, 1, T.structDark);
        g.a(0.5, ()=>{
            for(let i = 1; i < 5; i += 2)g.r(vx + i, vy + 1, 1, 3, T.structDark);
        }) // louvres
        ;
    }
    // Size-gated detail rolls its dice BEFORE the gate, never inside it. A roof
    // is measured where the recipe authored it and drawn where the layout pass
    // mirrored it to, and the canvas clamp can leave those two sizes different —
    // so `w >= 24 && rng() < 0.35` short-circuits in one pass and not the other,
    // spending a different number of rolls on a stream every later element
    // shares. What that cost was a building measured clear of the road being
    // drawn with a neighbour's mirror offset, square on the roadway. Same rule as
    // the day/night gate below: what is DRAWN may depend on size, what is DRAWN
    // FROM may not.
    const skylight = rng() < 0.35, skylightX = $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, w - 16));
    if (w >= 24 && h >= 21 && skylight) {
        const sx = x + 4 + skylightX, sy = y + h - 11;
        g.r(sx, sy, 9, 7, T.structDark);
        g.r(sx + 1, sy + 1, 7, 5, T.water1);
        g.a(0.45, ()=>g.r(sx + 1, sy + 1, 7, 1, T.structLight)); // glare on the pane
    }
    const hatch = rng() < 0.5;
    if (w >= 15 && h >= 15 && hatch) {
        const hx = x + w - 8, hy = y + h - 8;
        g.r(hx, hy, 5, 5, T.structDark);
        g.r(hx + 1, hy + 1, 3, 3, T.metal);
    }
    // Window light spilling out at the south wall after dusk. The rng calls
    // run unconditionally so the tile layout is identical day and night; the
    // lamp gate lives INSIDE the closure so dusk falling never invalidates the
    // cached static layer — it just starts painting on replay.
    const spillX = x + 1 + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, w - 3));
    const hasLight = rng() < 0.55;
    if (hasLight) $e81502d4aa27ba48$var$dynamic((g, T)=>{
        if ($e81502d4aa27ba48$var$ANIM.lamp <= 0.02) return;
        const a = $e81502d4aa27ba48$var$ANIM.lamp * $e81502d4aa27ba48$var$powerFlicker(spillX * 5.1 + y * 3.3);
        if (a <= 0.05) return;
        g.a(0.3 * a, ()=>$e81502d4aa27ba48$var$disc(g, spillX, y + h, 6, T.glow)); // pool on the ground
        g.a(0.9 * a, ()=>g.r(spillX - 1, y + h - 2, 3, 2, T.glow)); // the lit window
    });
}
// Building footprint with tune.buildingScale applied, anchored at x,y and
// clamped to the canvas. Larger footprints pick a composite shape from the
// seed — L-shaped or main-block-plus-wing — so blocks read as real
// structures instead of uniform rectangles.
//
// The shape is chosen from the SCALED size, before the clamp, and deliberately
// not from the clamped one. The layout pass measures a recipe where it was
// authored and then draws it mirrored, so the same building is clamped
// differently in the two passes — and each branch below spends a different
// number of draws on the stream every element after it shares. Branching on
// the clamped size therefore desynchronised measuring from drawing, and the
// elements downstream were drawn with another element's mirror offset: a
// building that had been measured clear of the road, and moved on that basis,
// landed on it. The clamp still decides what is DRAWN; it just no longer
// decides how much of the stream gets spent.
function $e81502d4aa27ba48$var$buildingTop(g, rng, T, tune, x, y, w, h) {
    const s = tune.buildingScale;
    const full = Math.round(w * s), tall = Math.round(h * s);
    w = Math.min(full, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - x);
    h = Math.min(tall, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - y);
    const composite = full >= 30 && tall >= 27;
    const shape = rng();
    if (composite && shape < 0.35) {
        const wingW = $e81502d4aa27ba48$var$ri(rng, Math.max(12, w >> 1), Math.max(12, w - 9));
        const wingH = $e81502d4aa27ba48$var$ri(rng, 9, Math.max(9, (h >> 1) - 3));
        $e81502d4aa27ba48$var$roofRect(g, rng, T, x, y, w, h - wingH);
        $e81502d4aa27ba48$var$roofRect(g, rng, T, x, y + h - wingH - 3, wingW, wingH + 3);
    } else if (composite && shape < 0.6) {
        $e81502d4aa27ba48$var$roofRect(g, rng, T, x, y, w, h - 12);
        const wingW = $e81502d4aa27ba48$var$ri(rng, 12, Math.max(12, w - 15));
        $e81502d4aa27ba48$var$roofRect(g, rng, T, x + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, w - wingW)), y + h - 15, wingW, 15);
    } else $e81502d4aa27ba48$var$roofRect(g, rng, T, x, y, w, h);
}
// ---- terraces ----
// A free-standing block is a thing somebody built. A TERRACE is a thing
// somebody built a street out of: a run of units under one roof, sharing party
// walls, flush along a common frontage and ragged at the back. Every structure
// on the map being free-standing is most of why it reads as a business park
// rather than a town — real built ground is mostly attached, and the gaps
// between attached ranges are what a street IS.
//
// What makes it legible from directly overhead, in order of how much it
// carries: the comb of party walls crossing the run at uneven intervals, a
// stack straddling most of those walls, a continuous ridge down the length,
// and a back line that steps where a unit was built shallower than its
// neighbours. The frontage never steps — a terrace is flush at the street,
// which is the whole reason it looks planned and a row of sheds does not.
const $e81502d4aa27ba48$var$TERRACE_UNIT = [
    12,
    22
]; // one unit's frontage, before scale
const $e81502d4aa27ba48$var$TERRACE_MIN = 9; // a last unit narrower than this joins the one before
/**
 * Plan the run: where the party walls fall, how deep each unit is, which walls
 * carry a stack. EVERY roll this element makes happens here, off the scaled
 * but UNCLAMPED length, and the drawing below spends none — same rule as
 * buildingTop and for the same reason. A terrace is measured where the recipe
 * authored it and drawn where the layout pass mirrored it to, so the canvas
 * clamp can leave those two lengths different; a plan that rolled per drawn
 * unit would spend a different number of draws in the two passes and every
 * element after it would land somewhere the measuring pass never cleared.
 */ function $e81502d4aa27ba48$var$planTerrace(rng, run, depth, s) {
    const units = [];
    const min = Math.round($e81502d4aa27ba48$var$TERRACE_MIN * s);
    for(let at = 0; at < run;){
        const wide = Math.min(Math.round($e81502d4aa27ba48$var$ri(rng, $e81502d4aa27ba48$var$TERRACE_UNIT[0], $e81502d4aa27ba48$var$TERRACE_UNIT[1]) * s), run - at);
        // A unit built shallower than its neighbours steps the back line. The
        // frontage stays flush: that is what separates a terrace from a row.
        const back = rng() < 0.3 ? Math.round($e81502d4aa27ba48$var$ri(rng, 3, 7) * s) : 0;
        const stack = rng() < 0.65;
        const lit = rng() < 0.5; // whether this one is still occupied
        units.push({
            at: at,
            wide: wide,
            back: back,
            stack: stack,
            lit: lit
        });
        at += wide;
        if (run - at > 0 && run - at < min) {
            units[units.length - 1].wide += run - at;
            at = run;
        }
    }
    return units;
}
/**
 * @param {number} w,h  the footprint in TILE space; the longer of the two is
 *   the run unless vert says otherwise, and y (or x, when vert) is the frontage
 */ function $e81502d4aa27ba48$var$terraceTop(g, rng, T, tune, x, y, w, h, vert) {
    const s = tune.buildingScale;
    const full = Math.round((vert ? h : w) * s), deep = Math.round((vert ? w : h) * s);
    const units = $e81502d4aa27ba48$var$planTerrace(rng, full, deep, s);
    // Clamped only now, and only for what is DRAWN.
    const run = Math.min(full, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - (vert ? y : x));
    const across = Math.min(deep, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - (vert ? x : y));
    if (run < 6 || across < 6) return;
    // `a` runs along the terrace, `c` across it from the frontage back, so one
    // body of code draws both a street facing north and one facing west.
    const put = (a, c, la, lc, col)=>{
        const la2 = Math.min(la, run - a), lc2 = Math.min(lc, across - c);
        if (a >= run || c >= across || la2 <= 0 || lc2 <= 0) return;
        if (vert) g.r(x + c, y + a, lc2, la2, col);
        else g.r(x + a, y + c, la2, lc2, col);
    };
    const atXY = (a, c)=>vert ? [
            x + c,
            y + a
        ] : [
            x + a,
            y + c
        ];
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, vert ? across : run, vert ? run : across);
    for (const u of units){
        const deepU = across - u.back;
        put(u.at, 0, u.wide, deepU, T.struct); // the unit's slab
        put(u.at, deepU - 1, u.wide, 1, T.structDark); // its own back edge, stepped
    }
    // The roof reads as pitched: the frontage slope catches the sun, the rear
    // slope does not, and the ridge is the line between them.
    const ridge = across >> 1;
    g.a(0.13, ()=>put(0, 0, run, ridge, T.structLight));
    g.a(0.13, ()=>put(0, ridge, run, across - ridge, T.structDark));
    // Rafters across both slopes, close enough together to read as texture
    // rather than as detail — the same job roofRect's panel seams do, at the
    // pitch a house roof is boarded at.
    g.a(0.1, ()=>{
        for(let a = 3; a < run; a += 3)put(a, 1, 1, across - 2, T.structDark);
    });
    put(0, ridge, run, 1, T.structDark);
    put(0, 0, run, 1, T.structLight); // the flush frontage
    put(0, 0, 1, across, T.structLight); // and the lit end of the run
    put(run - 1, 0, 1, across, T.structDark);
    // The comb. A party wall is one line, not two edges and a gap — that is the
    // whole difference between a terrace and two buildings standing near enough
    // to look like one.
    for (const u of units){
        if (!u.at) continue;
        put(u.at - 1, 0, 1, across - u.back, T.structDark);
        put(u.at, 0, 1, across - u.back, T.structLight);
    }
    // Stacks on the party walls, which is what says HOUSES from overhead.
    const stackW = Math.max(2, Math.round(2 * s));
    for (const u of units){
        if (!u.stack || !u.at) continue;
        put(u.at - stackW, ridge - 3, stackW * 2, 5, T.structDark);
        put(u.at - stackW, ridge - 3, stackW * 2, 1, T.structLight);
    }
    // Lit windows on the frontage after dusk, unit by unit. Without this a
    // street of terraces is the one black stretch on a map whose every
    // free-standing block glows — roofRect has spilled light since it was
    // written, and a terrace is the same building repeated. Same shape of gate,
    // for the same reason: the rolls are already spent, the lamp test lives
    // inside the closure so nightfall never invalidates the cached still layer.
    for (const u of units){
        if (!u.lit || u.at + u.wide > run) continue;
        const [wx, wy] = atXY(u.at + (u.wide >> 1), 0);
        $e81502d4aa27ba48$var$dynamic((g, T)=>{
            if ($e81502d4aa27ba48$var$ANIM.lamp <= 0.02) return;
            const a = $e81502d4aa27ba48$var$ANIM.lamp * $e81502d4aa27ba48$var$powerFlicker(wx * 4.7 + wy * 2.9);
            if (a <= 0.05) return;
            g.a(0.28 * a, ()=>$e81502d4aa27ba48$var$disc(g, wx, wy, 5, T.glow)); // pooled on the pavement
            g.a(0.9 * a, ()=>vert ? g.r(wx, wy - 1, 2, 3, T.glow) : g.r(wx - 1, wy, 3, 2, T.glow));
        });
    }
}
function $e81502d4aa27ba48$var$transformerPad(g, rng, T, x, y) {
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, 21, 21);
    g.r(x, y, 21, 21, T.structDark); // fenced compound
    g.r(x + 1, y + 1, 19, 19, T.ground2);
    g.r(x + 3, y + 3, 15, 15, T.metal); // the transformer
    g.r(x + 3, y + 3, 15, 1, T.structLight);
    g.r(x + 3, y + 17, 15, 1, T.structDark);
    g.a(0.55, ()=>{
        for(let i = x + 5; i < x + 17; i += 3)g.r(i, y + 5, 1, 11, T.structDark);
    });
    g.r(x + 8, y + 9, 5, 3, T.structDark); // core block
    for (const [bx, by] of [
        [
            x + 4,
            y + 4
        ],
        [
            x + 16,
            y + 4
        ],
        [
            x + 4,
            y + 16
        ],
        [
            x + 16,
            y + 16
        ]
    ])g.r(bx, by, 1, 1, T.accent); // bushing terminals
}
function $e81502d4aa27ba48$var$crateCluster(g, rng, T, x, y, cols, rows) {
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, cols * 12, rows * 12);
    for(let cy = 0; cy < rows; cy++)for(let cx = 0; cx < cols; cx++){
        if (rng() < 0.15) continue;
        const c = rng() < 0.5 ? T.metal : T.struct;
        const bx = x + cx * 12, by = y + cy * 12;
        g.r(bx, by, 11, 11, c);
        g.r(bx, by, 11, 1, T.structLight); // lit lid edge
        g.r(bx, by, 1, 11, T.structLight);
        g.r(bx, by + 10, 11, 1, T.structDark);
        g.r(bx + 10, by, 1, 11, T.structDark);
        g.a(0.4, ()=>{
            g.r(bx + 1, by + 3, 9, 1, T.structDark);
            g.r(bx + 1, by + 7, 9, 1, T.structDark);
        });
        if (rng() < 0.35) g.r(bx + 3, by + 4, 4, 3, T.accent); // stencilled marking
    }
}
function $e81502d4aa27ba48$var$fenceRing(g, rng, T, x, y, w, h, conn) {
    // chain-link: posts every 9px with a thin rail between them
    g.a(0.75, ()=>{
        g.r(x, y, w, 1, T.structDark);
        g.r(x, y + h - 1, w, 1, T.structDark);
        g.r(x, y, 1, h, T.structDark);
        g.r(x + w - 1, y, 1, h, T.structDark);
    });
    for(let px = x; px < x + w; px += 9){
        g.r(px, y, 1, 2, T.metal);
        g.r(px, y + h - 2, 1, 2, T.metal);
    }
    for(let py = y; py < y + h; py += 9){
        g.r(x, py, 2, 1, T.metal);
        g.r(x + w - 2, py, 2, 1, T.metal);
    }
    for (const [cx, cy] of [
        [
            x,
            y
        ],
        [
            x + w - 2,
            y
        ],
        [
            x,
            y + h - 2
        ],
        [
            x + w - 2,
            y + h - 2
        ]
    ])g.r(cx, cy, 2, 2, T.metal); // corner posts
    // gaps where a connector passes through
    const gx = x + (w >> 1) - 9, gy = y + (h >> 1) - 9;
    if (conn.n) g.r(gx, y, 21, 2, T.ground1);
    if (conn.s) g.r(gx, y + h - 2, 21, 2, T.ground1);
    if (conn.w) g.r(x, gy, 2, 21, T.ground1);
    if (conn.e) g.r(x + w - 2, gy, 2, 21, T.ground1);
}
function $e81502d4aa27ba48$var$tentTop(g, rng, T, x, y, s = 21) {
    for(let i = 0; i < s; i++){
        const half = Math.min(i, s - 1 - i) + 1;
        g.r(x + (s >> 1) - half + 1, y + i, half * 2 - 1, 1, T.struct); // diamond canopy
    }
    g.r(x + (s >> 1), y, 1, s, T.structLight); // ridge seam
    g.a(0.3, ()=>{
        g.r(x + (s >> 1) - 4, y + 4, 1, s - 8, T.structDark);
        g.r(x + (s >> 1) + 4, y + 4, 1, s - 8, T.structDark);
    });
}
function $e81502d4aa27ba48$var$fireRing(g, rng, T, cx, cy) {
    for(let i = 0; i < 9; i++){
        const a = i / 9 * Math.PI * 2;
        g.r(cx + Math.round(Math.cos(a) * 9) - 1, cy + Math.round(Math.sin(a) * 9) - 1, 3, 3, T.structDark);
    }
    g.a(0.5, ()=>$e81502d4aa27ba48$var$disc(g, cx, cy, 6, T.structDark)); // ash bed
    $e81502d4aa27ba48$var$dynamic((g, T)=>{
        const f = $e81502d4aa27ba48$var$flicker(cx, cy, 9); // fast flame flicker
        g.a(0.1 + 0.15 * f, ()=>$e81502d4aa27ba48$var$disc(g, cx, cy, 13, T.glow));
        g.a(0.35 + 0.3 * f, ()=>$e81502d4aa27ba48$var$disc(g, cx, cy, 6, T.glow));
        g.a(0.9, ()=>$e81502d4aa27ba48$var$disc(g, cx, cy, 2 + (f > 0.5 ? 1 : 0), T.glow));
    });
}
// ===============================
// ELEMENT REGISTRY + RECIPE INTERPRETER
// ===============================
// Recipes in RENDER_CONFIG.recipes are pure data: lists of element specs
// that reference this registry by name. Every element receives the resolved
// params object p; color params are palette key names (literal hex also
// works). Adding a new drawable primitive = one entry here; composing a new
// room look = config only.
const $e81502d4aa27ba48$var$pcolor = (T, c, fallback)=>T[c] || c || T[fallback];
const $e81502d4aa27ba48$export$a6d18b072e3b7ccb = {
    rect (g, rng, T, tune, conn, p) {
        const c = $e81502d4aa27ba48$var$pcolor(T, p.color, 'structDark');
        if (p.alpha != null) g.a(p.alpha, ()=>g.r(p.x, p.y, p.w, p.h, c));
        else g.r(p.x, p.y, p.w, p.h, c);
    },
    // ---- skill-anchor primitives ----
    // The deployed pad every anchor stands on. It does the work that collision
    // detection would otherwise have to: an anchor landing on a warehouse roof
    // reads as apparatus INSTALLED on the roof rather than a mis-layered sprite,
    // and the player learns one silhouette instead of fifteen. shape is set per
    // faction so allegiance is legible even when the device is too small to read.
    anchorPlate (g, rng, T, tune, conn, p) {
        const { x: x, y: y } = p, w = p.w ?? 24, h = p.h ?? 24;
        $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
        g.r(x, y, w, h, T.structDark);
        g.r(x + 1, y + 1, w - 2, h - 2, T.ground2);
        if (p.shape === 'cut') for(let i = 0; i < 4; i++){
            g.r(x + i, y + i, 4 - i, 1, T.structDark);
            g.r(x + w - 4, y + i, 4 - i, 1, T.structDark);
        }
        else if (p.shape === 'round') for (const [cx, cy] of [
            [
                x + 1,
                y + 1
            ],
            [
                x + w - 2,
                y + 1
            ],
            [
                x + 1,
                y + h - 2
            ],
            [
                x + w - 2,
                y + h - 2
            ]
        ])g.r(cx, cy, 1, 1, T.structDark);
        g.r(x + 1, y + 1, w - 2, 1, T.structLight); // lit N/W lip
        g.r(x + 1, y + 1, 1, h - 2, T.structLight);
        g.r(x + 1, y + h - 2, w - 2, 1, T.structDark);
        for (const [bx, by] of [
            [
                x + 2,
                y + 2
            ],
            [
                x + w - 3,
                y + 2
            ],
            [
                x + 2,
                y + h - 3
            ],
            [
                x + w - 3,
                y + h - 3
            ]
        ])g.r(bx, by, 1, 1, T.metal); // corner bolts
    },
    // One primitive covering the dish/emitter/bloom family: a disc body, an
    // optional rim, concentric ground rings and an optional feed strut. Three
    // anchors use it at different radii and colors rather than three near-copies.
    dish (g, rng, T, tune, conn, p) {
        const { x: x, y: y } = p, r = p.r ?? 9;
        const c = $e81502d4aa27ba48$var$pcolor(T, p.color, 'accent');
        $e81502d4aa27ba48$var$discShadow(g, T, x, y, r);
        for(let i = 1; i <= (p.rings ?? 0); i++)g.a(0.3 - i * 0.06, ()=>$e81502d4aa27ba48$var$ringO(g, x, y, r + i * 4, c));
        $e81502d4aa27ba48$var$disc(g, x, y, r, T.metal);
        $e81502d4aa27ba48$var$ringO(g, x, y, r, c);
        g.a(0.5, ()=>$e81502d4aa27ba48$var$disc(g, x - 1, y - 1, Math.max(1, r - 4), T.structLight));
        if (p.arm) {
            g.r(x, y - r - 3, 1, r + 3, T.structDark);
            g.r(x - 1, y - r - 4, 3, 2, T.metal);
        }
        g.r(x - 1, y - 1, 3, 3, T.structDark);
    },
    // A landing pad with corner lights and one airframe sitting on it.
    dronePad (g, rng, T, tune, conn, p) {
        const { x: x, y: y } = p, s = p.s ?? 16;
        g.r(x, y, s, s, T.structDark);
        // the cross and the lights are what make this read as a pad rather than a
        // dark square, so they carry nearly full weight
        g.a(0.85, ()=>{
            g.r(x + (s >> 1) - 1, y + 2, 2, s - 4, T.accent);
            g.r(x + 2, y + (s >> 1) - 1, s - 4, 2, T.accent);
        });
        for (const [cx, cy] of [
            [
                x,
                y
            ],
            [
                x + s - 3,
                y
            ],
            [
                x,
                y + s - 3
            ],
            [
                x + s - 3,
                y + s - 3
            ]
        ]){
            g.r(cx, cy, 3, 3, T.structDark); // light housings
            g.r(cx + 1, cy + 1, 2, 2, T.glow); // pad lights
        }
        const dx = x + (s >> 1) - 3, dy = y + (s >> 1) - 3;
        $e81502d4aa27ba48$var$dropShadow(g, T, dx, dy, 6, 6);
        g.r(dx + 1, dy + 1, 4, 4, T.metal); // parked airframe
        for (const [rx, ry] of [
            [
                dx - 1,
                dy - 1
            ],
            [
                dx + 4,
                dy - 1
            ],
            [
                dx - 1,
                dy + 4
            ],
            [
                dx + 4,
                dy + 4
            ]
        ])g.r(rx, ry, 3, 3, T.structDark); // rotor booms
    },
    speckle (g, rng, T, tune, conn, p) {
        const c = $e81502d4aa27ba48$var$pcolor(T, p.color, 'structLight');
        for(let i = 0; i < (p.n ?? 8); i++)// scraps, not pixels — n is a count in the recipe data, so the specks
        // themselves have to carry the area they used to cover as 3px blocks
        g.a(p.alpha ?? 1, ()=>g.r(p.x + $e81502d4aa27ba48$var$ri(rng, 0, p.w), p.y + $e81502d4aa27ba48$var$ri(rng, 0, p.h), $e81502d4aa27ba48$var$ri(rng, 2, 4), $e81502d4aa27ba48$var$ri(rng, 1, 3), c));
    },
    darkWash (g, rng, T, tune, conn, p) {
        g.a(p.alpha ?? 0.15, ()=>g.r(0, 0, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, T.far));
    },
    building (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$buildingTop(g, rng, T, tune, p.x, p.y, p.w, p.h);
    },
    terrace (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$terraceTop(g, rng, T, tune, p.x, p.y, p.w, p.h, p.vert);
    },
    storefront (g, rng, T, tune, conn, p) {
        const w = Math.min(Math.round(p.w * tune.buildingScale), $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - p.x);
        const h = Math.min(Math.round(p.h * tune.buildingScale), 60 - p.y);
        $e81502d4aa27ba48$var$roofRect(g, rng, T, p.x, p.y, w, h);
        for(let i = 0; i < w; i += 3)g.r(p.x + i, p.y + h, 3, 6, i / 3 % 2 ? T.accent : T.structDark);
        g.a(0.4, ()=>g.r(p.x, p.y + h + 5, w, 1, T.structDark)); // awning drop shadow
    },
    stalls (g, rng, T, tune, conn, p) {
        for(let sx = 18; sx < 90; sx += 27){
            const sy = $e81502d4aa27ba48$var$ri(rng, 84, 93);
            g.r(sx, sy, 15, 12, T.struct);
            g.r(sx, sy, 15, 1, T.structLight);
            g.r(sx, sy + 11, 15, 1, T.structDark);
            g.a(0.35, ()=>{
                for(let i = 3; i < 15; i += 4)g.r(sx + i, sy + 1, 1, 10, T.structDark);
            });
            g.r(sx + 3, sy + 3, 9, 4, T.rust); // goods on the counter
        }
    },
    transformerPad (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$transformerPad(g, rng, T, p.x, p.y);
    },
    tank (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$tankTop(g, rng, T, p.x, p.y, p.r ?? 15);
    },
    tower (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$towerTop(g, rng, T, p.x, p.y);
    },
    // The monumental tier, exposed to the recipes. These are authored for the
    // signature layer (see TD_SIGNATURE) but nothing about them is region-bound,
    // so a recipe that wants a silo yard or a glasshouse can just ask for one.
    silo (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$silo(g, rng, T, p.x, p.y, Math.round((p.r ?? 12) * tune.buildingScale));
    },
    gantry (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$gantry(g, rng, T, p.x, p.y, p.len ?? 54, !!p.vert);
    },
    glassSpan (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$glassSpan(g, rng, T, p.x, p.y, Math.round((p.w ?? 54) * tune.buildingScale), Math.round((p.h ?? 24) * tune.buildingScale));
    },
    towerCore (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$towerCore(g, rng, T, p.x, p.y, Math.round((p.w ?? 33) * tune.buildingScale), Math.round((p.h ?? 33) * tune.buildingScale));
    },
    crates (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$crateCluster(g, rng, T, p.x, p.y, p.cols ?? 2, p.rows ?? 2);
    },
    container (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$containerBox(g, rng, T, p.x, p.y, !!p.vert);
    },
    vehicle (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$vehicle(g, rng, T, p.x, p.y, !!p.vert);
    },
    barrier (g, rng, T, tune, conn, p) {
        for(let i = 0; i < 6; i++)g.r(p.x + i * 3, p.y, 3, 6, i % 2 ? T.accent : T.structDark);
        g.r(p.x, p.y + 6, 18, 1, T.structDark); // base shadow line
        g.r(p.x + 1, p.y - 1, 16, 1, T.structLight); // lit top rail
    },
    fence (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$fenceRing(g, rng, T, p.x, p.y, p.w, p.h, p.gaps ? conn : {
            n: false,
            e: false,
            s: false,
            w: false
        });
    },
    pipeline (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$pipeRun(g, T, p.x, p.y, p.w, false, 6, 24);
    },
    tree (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$tree(g, rng, T, p.x, p.y, p.r ?? 9);
    },
    bush (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$bushPatch(g, rng, T, p.x, p.y);
    },
    foliage (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$foliageClump(g, rng, T, p.x, p.y, p.size ?? 5);
    },
    crack (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$crack(g, rng, T, p.x, p.y, p.len ?? 30);
    },
    rubble (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$rubble(g, rng, T, p.x, p.x + p.w, p.y, p.y + p.h, p.n ?? 12);
    },
    parkingLot (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$parkingLot(g, rng, T, p.x, p.y, p.w ?? 66, p.h ?? 33);
    },
    tent (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$tentTop(g, rng, T, p.x, p.y, p.s ?? 21);
    },
    fireRing (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$fireRing(g, rng, T, p.x, p.y);
    },
    manhole (g, rng, T, tune, conn, p) {
        $e81502d4aa27ba48$var$disc(g, p.x, p.y, 4, T.structDark);
        $e81502d4aa27ba48$var$ringO(g, p.x, p.y, 4, T.metal);
        g.a(0.4, ()=>g.r(p.x - 3, p.y, 7, 1, T.structLight)); // lid slot
    },
    streetLamp (g, rng, T, tune, conn, p) {
        g.r(p.x, p.y, 2, 6, T.structDark); // dusk on the intermittent grid
        g.r(p.x - 1, p.y - 4, 4, 4, T.metal); // lamp head
        g.r(p.x - 1, p.y - 4, 4, 1, T.structLight);
        $e81502d4aa27ba48$var$dynamic((g, T)=>{
            if ($e81502d4aa27ba48$var$ANIM.lamp <= 0.02) return;
            const a = $e81502d4aa27ba48$var$ANIM.lamp * $e81502d4aa27ba48$var$powerFlicker(p.x * 7.7 + p.y * 3.1);
            if (a <= 0.05) return;
            g.a(0.3 * a, ()=>$e81502d4aa27ba48$var$disc(g, p.x, p.y - 3, 9, T.glow));
            g.a(0.9 * a, ()=>g.r(p.x - 1, p.y - 3, 3, 2, T.glow));
        });
    },
    sinkhole (g, rng, T, tune, conn, p) {
        const r = p.r ?? 21;
        $e81502d4aa27ba48$var$voidPit(g, rng, T, p.x, p.y, r);
        for(let i = 0; i < 3; i++)$e81502d4aa27ba48$var$crack(g, rng, T, p.x + $e81502d4aa27ba48$var$ri(rng, -r - 3, r + 3), p.y + $e81502d4aa27ba48$var$ri(rng, -r - 3, r + 3), $e81502d4aa27ba48$var$ri(rng, 15, 27));
        // Spoil lands on the RIM, in a ring — scattering it across the pit's
        // bounding box put four fifths of it inside the shaft, debris hanging in a
        // hole that goes down to nothing.
        for(let i = 0; i < 8; i++){
            const a = rng() * Math.PI * 2, d = r + $e81502d4aa27ba48$var$ri(rng, 1, 7);
            $e81502d4aa27ba48$var$rubbleChunk(g, rng, T, p.x + Math.cos(a) * d, p.y + Math.sin(a) * d);
        }
    },
    // A rift rather than a shaft. Built as one continuous swept shape — a chain
    // of overlapping discs each drew its own rim, and the result read as a row of
    // scalloped circles rather than as ground that had torn open.
    chasm (g, rng, T, tune, conn, p) {
        const len = p.len ?? 60, r = p.r ?? 15, vert = !!p.vert;
        const half = len / 2;
        // half-width along the rift: pinched to nothing at both tips, uneven between
        const knots = [];
        for(let i = 0; i <= 6; i++)knots.push(0.6 + rng() * 0.55);
        const widthAt = (t)=>{
            const taper = Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, t))), 0.55);
            const k = t * 6, i = Math.min(5, Math.floor(k)), f = k - i;
            const bend = knots[i] + (knots[i + 1] - knots[i]) * (f * f * (3 - 2 * f));
            return Math.max(1, r * taper * bend);
        };
        const drift = (t)=>Math.round(Math.sin(t * Math.PI * 1.6) * r * 0.28);
        const spans = [];
        for(let d = 0; d <= len; d++){
            const t = d / len, h = Math.round(widthAt(t)), off = drift(t);
            const along = Math.round(-half + d);
            spans.push(vert ? [
                Math.round(p.x + off - h),
                Math.round(p.y + along),
                h * 2,
                1
            ] : [
                Math.round(p.x + along),
                Math.round(p.y + off - h),
                1,
                h * 2
            ]);
        }
        for (const [x, y, w, h] of spans)g.r(x, y, w, h, T.far); // the ground below
        g.a(0.6, ()=>{
            for (const [x, y, w, h] of spans){
                const inset = Math.round((vert ? w : h) * 0.3);
                if ((vert ? w : h) - inset * 2 < 2) continue;
                g.r(vert ? x + inset : x, vert ? y : y + inset, vert ? w - inset * 2 : w, vert ? h : h - inset * 2, '#000000');
            }
        });
        for (const [x, y, w, h] of spans)if (vert) {
            g.r(x, y, 1, 1, T.structDark);
            g.r(x + w - 1, y, 1, 1, T.structDark);
        } else {
            g.r(x, y, 1, 1, T.structDark);
            g.r(x, y + h - 1, 1, 1, T.structDark);
        }
        // Lit lip: ONE pixel on the sunward edge of each span, whichever way the
        // rift runs. Taking the span's full width when it ran north-south washed
        // the whole chasm pale instead of catching its edge.
        g.a(0.3, ()=>{
            for (const [x, y] of spans)g.r(x, y, 1, 1, T.structLight);
        });
        for(let i = 0; i < 5; i++){
            const [x, y] = spans[$e81502d4aa27ba48$var$ri(rng, 0, spans.length - 1)];
            $e81502d4aa27ba48$var$crack(g, rng, T, x + $e81502d4aa27ba48$var$ri(rng, -6, 6), y + $e81502d4aa27ba48$var$ri(rng, -6, 6), $e81502d4aa27ba48$var$ri(rng, 12, 27));
        }
        // Spoil lines both LIPS of the rift rather than filling its bounding box:
        // a rift is mostly hole, so a box scatter dropped most of the debris into
        // it. Each chunk picks a span and steps out past that span's own edge, so
        // the heap follows the tear however it wanders and pinches in at the tips.
        for(let i = 0; i < 14; i++){
            const [x, y, w, h] = spans[$e81502d4aa27ba48$var$ri(rng, 0, spans.length - 1)];
            const out = $e81502d4aa27ba48$var$ri(rng, 1, 7), far = rng() < 0.5;
            $e81502d4aa27ba48$var$rubbleChunk(g, rng, T, vert ? far ? x + w + out : x - out - 4 : x, vert ? y : far ? y + h + out : y - out - 4);
        }
    },
    pond (g, rng, T, tune, conn, p) {
        const C = $e81502d4aa27ba48$export$da8728cc680c21d8.cx, R = $e81502d4aa27ba48$export$da8728cc680c21d8.r;
        // A shoreline is not a circle: each side of every scanline gets its own
        // smooth wobble, and the bank, the water and the deep all follow the same
        // one so they stay concentric with it.
        const left = $e81502d4aa27ba48$var$wobbler(rng, 6, 0.16), right = $e81502d4aa27ba48$var$wobbler(rng, 6, 0.16);
        $e81502d4aa27ba48$var$blob(g, C, C, R + 3, T.ground2, left, right); // bank
        $e81502d4aa27ba48$var$blob(g, C, C, R, T.water1, left, right);
        g.a(0.25, ()=>$e81502d4aa27ba48$var$blob(g, C, C, R - 9, T.water2, left, right)); // deeper in the middle
        for(let i = 0; i < 26; i++){
            const dy = $e81502d4aa27ba48$var$ri(rng, -R + 6, R - 6);
            const [l, r] = $e81502d4aa27ba48$var$blobSpan(R, dy, left, right);
            if (l + r < 14) continue;
            g.r(C - l + 3 + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(1, l + r - 9)), C + dy, $e81502d4aa27ba48$var$ri(rng, 3, 8), 1, T.water2);
        }
        // wave crests drift across the pond (position-phased, no rng, so the
        // pond layout stays identical while the crests slide when animating)
        $e81502d4aa27ba48$var$dynamic((g, T)=>{
            for(let i = -4; i <= 4; i++){
                const wy = C + i * 8;
                const half = Math.min(...$e81502d4aa27ba48$var$blobSpan(R, wy - C, left, right));
                if (half < 12) continue;
                const xo = Math.round(7 * Math.sin($e81502d4aa27ba48$var$ANIM.t * 0.8 + i * 1.9));
                g.a(0.5, ()=>{
                    g.r(C - (half >> 1) + xo, wy, 9, 1, T.water2);
                    g.r(C + (half >> 2) + xo, wy + 5, 7, 1, T.water2);
                });
            }
        });
        const dock = conn.e ? [
            81,
            54,
            36,
            12
        ] : conn.w ? [
            3,
            54,
            36,
            12
        ] : conn.n ? [
            54,
            3,
            12,
            36
        ] : [
            54,
            81,
            12,
            36
        ];
        g.r(...dock, T.rust); // plank walkway
        g.a(0.4, ()=>{
            if (dock[2] > dock[3]) for(let i = 3; i < dock[2]; i += 6)g.r(dock[0] + i, dock[1], 1, dock[3], T.structDark);
            else for(let i = 3; i < dock[3]; i += 6)g.r(dock[0], dock[1] + i, dock[2], 1, T.structDark);
        });
        g.r(dock[0], dock[1], dock[2] > dock[3] ? dock[2] : 1, dock[2] > dock[3] ? 1 : dock[3], T.structLight);
    },
    reactorCore (g, rng, T, tune, conn, p) {
        const C = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1;
        $e81502d4aa27ba48$var$disc(g, C, C, 27, T.metal);
        $e81502d4aa27ba48$var$ringO(g, C, C, 27, T.structDark);
        $e81502d4aa27ba48$var$ringO(g, C, C, 26, T.structDark);
        $e81502d4aa27ba48$var$ringO(g, C, C, 15, T.structDark);
        g.a(0.3, ()=>{
            for(let i = 0; i < 8; i++){
                const a = i / 8 * Math.PI * 2;
                for(let d = 16; d < 27; d++)g.r(C + Math.round(Math.cos(a) * d), C + Math.round(Math.sin(a) * d), 1, 1, T.structDark);
            }
        });
        // the core's own light: dynamic so the day tint never dims it (T.glow is
        // exempt from tinting, and the composite-time multiply is not)
        $e81502d4aa27ba48$var$dynamic((g, T)=>{
            g.a(0.6, ()=>$e81502d4aa27ba48$var$disc(g, C, C, 9, T.glow));
            g.a(0.9, ()=>$e81502d4aa27ba48$var$disc(g, C, C, 4, T.glow));
            g.r(C - 1, C - 1, 3, 3, T.accent);
        });
        for (const [cx, cy] of [
            [
                21,
                21
            ],
            [
                96,
                21
            ],
            [
                21,
                96
            ],
            [
                96,
                96
            ]
        ])g.r(cx, cy, 6, 6, T.accent); // marker pads
    },
    portalPad (g, rng, T, tune, conn, p) {
        // pad only — the energy glow is drawn by portalGlow() as the very last
        // pass so nothing (flood water, growth, clouds) can cover it
        const C = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1;
        $e81502d4aa27ba48$var$disc(g, C, C, 15, T.metal);
        $e81502d4aa27ba48$var$ringO(g, C, C, 15, T.accent);
        $e81502d4aa27ba48$var$ringO(g, C, C, 14, T.accent);
        g.a(0.35, ()=>$e81502d4aa27ba48$var$ringO(g, C, C, 10, T.structDark));
    }
};
// Resolve a config param value: [min,max] draws a seeded integer in range;
// { pick: [...] } draws a seeded choice (entries may be scalars or ranges);
// anything else passes through.
function $e81502d4aa27ba48$var$resolveVal(v, rng) {
    if (Array.isArray(v)) return $e81502d4aa27ba48$var$ri(rng, v[0], v[1]);
    if (v && typeof v === 'object' && v.pick) return $e81502d4aa27ba48$var$resolveVal(v.pick[$e81502d4aa27ba48$var$ri(rng, 0, v.pick.length - 1)], rng);
    return v;
}
const $e81502d4aa27ba48$var$SPEC_KEYS = new Set([
    'el',
    'chance',
    'when',
    'repeat'
]);
const $e81502d4aa27ba48$export$258e2d684a2e26ab = new Set([
    'building',
    'terrace',
    'storefront',
    'tower',
    'tank',
    'transformerPad',
    'sinkhole',
    'tent',
    'silo',
    'glassSpan',
    'towerCore'
]);
const $e81502d4aa27ba48$export$da8728cc680c21d8 = {
    cx: $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1,
    cy: $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1,
    r: 39,
    bank: 42
};
// ---- building density by distance from a road ----
// People build where they can get to. A map that draws every recipe at full
// strength everywhere reads as one uniform sprawl; thinning the built stock
// with distance from the roadway gives the map a grain — frontage along the
// trunk, back lots behind it, and near-open ground where nothing runs.
/**
 * What thins out with distance. Built structures only: the things somebody put
 * up because there was a way to reach them. Ground works — a parking lot, a
 * fence, a pipeline, a hardstand, crates — stay, and read the better for the
 * buildings having gone: an empty lot is exactly what the edge of a settlement
 * looks like.
 *
 * Tents and sinkholes are absent on purpose, though both are solid: a camp is
 * one tent, and a shaft is the whole point of the tile it opened on.
 */ const $e81502d4aa27ba48$var$BUILT_ELEMENTS = new Set([
    'building',
    'terrace',
    'storefront',
    'tower',
    'tank',
    'transformerPad',
    'container',
    'silo',
    'glassSpan',
    'towerCore'
]);
/**
 * Recipes the map PLACES rather than grows: the portal facilities a raid enters
 * and leaves by, the reactor, the rest stop and its shoreline, and collapsed
 * ground. These are landmarks, drawn in full wherever they land. Checkpoints
 * are exempt too (see composeBody) for the same reason gateEmphasis dresses
 * them heavier — they are what the player navigates by.
 *
 * The roadway is exempt for the opposite reason: a trunk tile IS the frontage
 * this whole gradient is measured from, so it is never anything but full.
 */ const $e81502d4aa27ba48$var$DENSITY_EXEMPT = new Set([
    'portal',
    'reactor',
    'water',
    'campsite',
    'blocked',
    'road'
]);
/**
 * How much of a recipe's built stock survives, indexed by distance from the
 * nearest roadway. Index 0 is unused — a tile the road runs through is scored
 * by rank instead, since a trunk frontage is worth more than a back lane.
 * Coverage caps the distance at MAX_ROAD_DISTANCE (2), so the last entry is
 * the emptiest ground on the map.
 */ const $e81502d4aa27ba48$var$DENSITY_BY_DIST = [
    1,
    0.6,
    0.3
];
const $e81502d4aa27ba48$var$MINOR_ROAD_DENSITY = 0.85;
/**
 * How built-up this part of the MAP is, on top of how near this tile is to a
 * road.
 *
 * Distance from the roadway is the only thing the gradient above knows, and
 * the network covers the grid to MAX_ROAD_DISTANCE (2) — so every tile on the
 * map lands in one of three states, interleaved evenly, and the map comes out
 * one settlement of uniform thickness with lanes through it. A town has a core
 * and it has outskirts, and which you are standing in has nothing to do with
 * the nearest road: there are busy back lots and there are empty frontages.
 *
 * The second gradient is the DISTRICT the cell is in — an authored figure on
 * the archetype, so a district's look and its name agree.
 *
 * This used to be a world-space noise field, and it was wrong in a way that
 * took a while to see: it sampled the tile's raw grid position with no per-map
 * term, and a map is at most 7x17 starting at (0,0). Every raid in the game
 * therefore drew from the same patch of lattice — dense in the north-west, a
 * hard sparse band right of centre — the same stencil every time. It broke up
 * density within a map, which was the point, but contributed nothing between
 * maps and imposed a fixed pattern in exchange.
 *
 * What the noise was genuinely good at is kept: it is continuous, so
 * neighbours agree, which makes it the right thing to vary a district
 * INTERNALLY with. It survives as grain of a few per cent about the district's
 * own figure, so a core does not read as flat.
 */ const $e81502d4aa27ba48$var$SETTLEMENT_CELL = 5; // tiles across one lobe of the field
const $e81502d4aa27ba48$var$GRAIN = 0.08; // how far the grain moves a tile off its district
/**
 * What the average tile is built up to. Every district factor is centred on
 * this, so the mix redistributes stock rather than deleting it.
 */ const $e81502d4aa27ba48$var$MEAN_BUILT = 0.85;
function $e81502d4aa27ba48$var$settlement(col, row) {
    // Offset the sample so the lattice's own zero does not sit on the map origin,
    // where every region would open on the same value.
    const s = $e81502d4aa27ba48$var$smoothNoise(col / $e81502d4aa27ba48$var$SETTLEMENT_CELL + 11.3, row / $e81502d4aa27ba48$var$SETTLEMENT_CELL + 7.7);
    // Value noise interpolates between lattice heights, so most of what comes out
    // of it is near the middle; the smoothstep pushes it toward its own ends.
    return s * s * (3 - 2 * s);
}
/**
 * How much of the sea's own tile is still standing. A shore tile is half under
 * water, and what the water took it took a long time ago — so the standing
 * stock there is thin and what is left of the rest is rubble.
 *
 * Expressed through `built` rather than as its own mechanism because `built`
 * already does exactly the right things with it: it shrinks footprints, drops
 * the LARGEST ones first (thinForDistance), lets growth back in, and wears the
 * tarmac. A separate "drown the buildings" pass would have had to reinvent all
 * four and would have disagreed with them at the margins.
 */ const $e81502d4aa27ba48$var$SHORE_BUILT = 0.45; // how much of a shore tile survives
function $e81502d4aa27ba48$export$5553b5f9fd6fa0ba(zone, col, row, shore) {
    const base = $e81502d4aa27ba48$var$ZONE_BUILT[zone] ?? $e81502d4aa27ba48$var$MEAN_BUILT; // unknown district, or a save from before them
    const drowned = shore === 0 ? $e81502d4aa27ba48$var$SHORE_BUILT : shore === 1 ? (1 + $e81502d4aa27ba48$var$SHORE_BUILT) / 2 : 1;
    return base * drowned * (1 - $e81502d4aa27ba48$var$GRAIN + 2 * $e81502d4aa27ba48$var$GRAIN * $e81502d4aa27ba48$var$settlement(col, row));
}
const $e81502d4aa27ba48$var$ZONE_BUILT = Object.fromEntries(Object.entries((0, $c1858b438f434f4d$export$8377a367ab2ae550)).map(([zone, a])=>[
        zone,
        a.built ?? $e81502d4aa27ba48$var$MEAN_BUILT
    ]));
/**
 * Size moves less than count. Footprint drives the recipes' own
 * `when: buildingScale >= n` gates, and a district that swung it as hard as the
 * count would switch those on and off by neighborhood.
 */ const $e81502d4aa27ba48$var$builtScale = (b)=>0.72 + 0.28 * (b / $e81502d4aa27ba48$var$MEAN_BUILT);
/**
 * Growth fills what is not built, and tarmac nobody drives goes to seed. Both
 * run INVERSE to the district and are centred on the mean tile, so the map
 * gains no vegetation overall — it just stops spreading it evenly.
 */ const $e81502d4aa27ba48$var$builtGrowth = (b)=>1 + ($e81502d4aa27ba48$var$MEAN_BUILT - b);
const $e81502d4aa27ba48$var$builtWear = (wear, b)=>Math.min(1, Math.max(0, wear + ($e81502d4aa27ba48$var$MEAN_BUILT - b) * 0.5));
function $e81502d4aa27ba48$export$b0ba4899f6951e17(boxes, dist, rank, built) {
    const stock = boxes.filter((b)=>$e81502d4aa27ba48$var$BUILT_ELEMENTS.has(b.el));
    if (stock.length < 2) return new Set();
    const density = (dist > 0 ? $e81502d4aa27ba48$var$DENSITY_BY_DIST[Math.min(dist, $e81502d4aa27ba48$var$DENSITY_BY_DIST.length - 1)] : rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? 1 : $e81502d4aa27ba48$var$MINOR_ROAD_DENSITY) * (built != null ? built : 1);
    const drop = stock.length - Math.max(1, Math.round(stock.length * density));
    if (drop <= 0) return new Set();
    const area = (b)=>(b.x1 - b.x0) * (b.y1 - b.y0);
    return new Set([
        ...stock
    ].sort((a, b)=>area(b) - area(a)).slice(0, drop).map((b)=>b.n));
}
/**
 * Buildings do not only get fewer with distance from a road, they get smaller.
 *
 * Count alone barely moves half the map: most recipes carry one or two
 * structures, and the last one always stands. Scaling the footprint is what
 * actually opens the ground up — and it drives the recipes' own
 * `when: buildingScale >= n` gates, which is exactly where the extra hall and
 * the fourth block were already authored to appear only at a bigger scale. So
 * one knob thins by size and by count together, in the terms the art was
 * written in.
 */ const $e81502d4aa27ba48$var$BUILDING_SCALE_BY_DIST = [
    1,
    0.88,
    0.78
];
const $e81502d4aa27ba48$var$MINOR_ROAD_SCALE = 0.95;
/**
 * The region's tune adjusted for one tile: its structures scaled to the
 * distance from a road and to how built up its district is, its growth and its
 * road wear set inverse to the same district figure.
 *
 * Scale follows `thinnable`, exactly as the count thinning does — a portal
 * facility or a rest stop is drawn in full wherever it lands. Growth and wear
 * do NOT: vegetation reclaiming the outskirts and tarmac going to seed have no
 * business stopping at a road tile's border, and a gate on the edge of town
 * should look like it is on the edge of town.
 *
 * Cached per (tune, factors): a repaint runs this for every tile on the grid,
 * and the tune is read on every element a recipe draws. The key quantises, so
 * a region holds a couple of dozen entries rather than one per tile.
 */ const $e81502d4aa27ba48$var$scaledTunes = new WeakMap();
function $e81502d4aa27ba48$var$tuneForTile(tune, dist, rank, built, thinnable) {
    const q = (n)=>Math.round(n * 40) / 40;
    const scale = q(!thinnable ? 1 : (dist > 0 ? $e81502d4aa27ba48$var$BUILDING_SCALE_BY_DIST[Math.min(dist, $e81502d4aa27ba48$var$BUILDING_SCALE_BY_DIST.length - 1)] : rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? 1 : $e81502d4aa27ba48$var$MINOR_ROAD_SCALE) * (built != null ? $e81502d4aa27ba48$var$builtScale(built) : 1));
    const growth = q(built != null ? $e81502d4aa27ba48$var$builtGrowth(built) : 1);
    const wear = q(built != null ? $e81502d4aa27ba48$var$builtWear(tune.roadWear, built) : tune.roadWear);
    if (scale === 1 && growth === 1 && wear === q(tune.roadWear)) return tune;
    const key = `${scale}|${growth}|${wear}`;
    let byKey = $e81502d4aa27ba48$var$scaledTunes.get(tune);
    if (!byKey) $e81502d4aa27ba48$var$scaledTunes.set(tune, byKey = new Map());
    let out = byKey.get(key);
    if (!out) byKey.set(key, out = {
        ...tune,
        buildingScale: tune.buildingScale * scale,
        treeDensity: tune.treeDensity * growth,
        roadWear: wear
    });
    return out;
}
/**
 * @param {object} [opts.record] array to collect solid element footprints into;
 *   when present NOTHING is drawn — this is the measuring pass
 * @param {Set} [opts.skip] element instance indices to run but not draw
 */ /**
 * @param {object} [opts.record] array to collect element footprints into; when
 *   present NOTHING is drawn — this is the measuring pass
 * @param {Set}    [opts.skip]   element instance indices to run but not draw
 * @param {number} [opts.variant] force a variant instead of rolling one
 * @param {Array}  [opts.shift]  per-element [dx, dy], indexed as `record` was
 */ function $e81502d4aa27ba48$var$runRecipe(def, g, rng, T, tune, conn, ox = 0, oy = 0, opts = {}) {
    let elements = def.elements;
    if (def.variants) {
        // The roll happens either way, even when the variant is forced: element
        // functions draw from this stream, so skipping a draw from it would shift
        // everything after and the measuring pass would stop matching the real one.
        const rolled = def.variantKey != null ? rng() < (tune[def.variantKey] ?? 0.5) ? 1 : 0 // tune-gated pair
         : $e81502d4aa27ba48$var$ri(rng, 0, def.variants.length - 1);
        elements = def.variants[opts.variant ?? rolled].elements;
    }
    // A measuring pass must not leave anything behind. Elements that animate hand
    // a closure to dynamic(), which either records it for the caller or runs it
    // against the live canvas — neither is wanted here, so it goes to a bin that
    // is thrown away. Guarding this at the call site instead left it to every
    // caller to remember.
    const wasDyn = $e81502d4aa27ba48$var$DYN;
    if (opts.record) $e81502d4aa27ba48$var$DYN = [];
    let index = 0;
    for (const spec of elements || []){
        const fn = $e81502d4aa27ba48$export$a6d18b072e3b7ccb[spec.el];
        if (!fn) continue;
        if (spec.when && (tune[spec.when.tune] ?? 0) < spec.when.gte) continue;
        if (spec.chance != null && rng() >= spec.chance) continue;
        const count = spec.repeat != null ? $e81502d4aa27ba48$var$resolveVal(spec.repeat, rng) : 1;
        for(let i = 0; i < count; i++){
            const n = index++;
            const [sx, sy] = opts.shift?.[n] || [
                0,
                0
            ];
            const p = {};
            for (const key of Object.keys(spec)){
                if ($e81502d4aa27ba48$var$SPEC_KEYS.has(key)) continue;
                const v = $e81502d4aa27ba48$var$resolveVal(spec[key], rng);
                p[key] = key === 'x' ? v + ox + sx : key === 'y' ? v + oy + sy : v;
            }
            const probe = opts.record || opts.skip?.has(n) ? $e81502d4aa27ba48$var$makeProbeG() : null;
            fn(probe || g, rng, T, tune, conn, p);
            if (opts.record && probe.box.x1 > probe.box.x0) opts.record.push({
                n: n,
                el: spec.el,
                solid: $e81502d4aa27ba48$export$258e2d684a2e26ab.has(spec.el),
                ...probe.box
            });
        }
    }
    $e81502d4aa27ba48$var$DYN = wasDyn;
}
/**
 * Choose which of a recipe's layouts to draw, given where the road already is.
 *
 * The road's position is settled by the tile's edges before any of this runs,
 * so the layout is what adapts. Each variant is measured once, then mirrored
 * about the tile's centre line — mirroring the PLACEMENT rather than the
 * drawing, so every roof keeps its lit north-west edge and every shadow still
 * falls the way the sun says. That turns one authored layout into four, with no
 * second copy of the art's coordinates to drift out of step with it.
 *
 * Whatever the winning layout still leaves under the road is suppressed: better
 * a missing outbuilding than a road driven through one.
 */ const $e81502d4aa27ba48$var$MIRRORS = [
    [
        false,
        false
    ],
    [
        true,
        false
    ],
    [
        false,
        true
    ],
    [
        true,
        true
    ]
];
/**
 * Every element's drawn footprint SIZE under a given shift, by instance index.
 * A probe pass, so nothing is drawn and nothing else is disturbed.
 */ function $e81502d4aa27ba48$var$measureSizes(def, rng, T, tune, conn, variant, shift) {
    const boxes = [];
    $e81502d4aa27ba48$var$runRecipe(def, null, rng, T, tune, conn, 0, 0, {
        record: boxes,
        variant: variant,
        shift: shift
    });
    return new Map(boxes.map((b)=>[
            b.n,
            `${b.x1 - b.x0}x${b.y1 - b.y0}`
        ]));
}
/**
 * The per-element shift that reflects a measured layout about the tile's
 * centre line. Mirroring never changes a footprint's size or its index, so
 * this is a pure translation per element and the boxes stay comparable.
 */ function $e81502d4aa27ba48$var$mirrorShift(boxes, flipX, flipY) {
    const shift = [];
    for (const b of boxes)shift[b.n] = [
        flipX ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f - b.x1 - b.x0 : 0,
        flipY ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f - b.y1 - b.y0 : 0
    ];
    return shift;
}
/**
 * Every tile is entitled to a mirror; only a tile with a road through it has a
 * reason to prefer one. Off the network there is nothing to dodge, so the seed
 * picks — without which the whole map draws every recipe the same way round,
 * and a majority of tiles are off the network.
 */ function $e81502d4aa27ba48$var$seededMirror(boxes, rng) {
    return $e81502d4aa27ba48$var$mirrorShift(boxes, ...$e81502d4aa27ba48$var$MIRRORS[Math.floor(rng() * $e81502d4aa27ba48$var$MIRRORS.length)]);
}
function $e81502d4aa27ba48$export$9de203fcc6e657de(def, freshRng, T, tune, conn, samples, rng) {
    const count = def.variants ? def.variants.length : 1;
    const layouts = [];
    for(let v = 0; v < count; v++){
        const boxes = [];
        $e81502d4aa27ba48$var$runRecipe(def, null, freshRng(), T, tune, conn, 0, 0, {
            record: boxes,
            variant: v
        });
        for (const [flipX, flipY] of $e81502d4aa27ba48$var$MIRRORS){
            const shift = $e81502d4aa27ba48$var$mirrorShift(boxes, flipX, flipY);
            const solids = [];
            for (const b of boxes){
                if (!b.solid) continue;
                const [dx, dy] = shift[b.n];
                solids.push({
                    ...b,
                    x0: b.x0 + dx,
                    x1: b.x1 + dx,
                    y0: b.y0 + dy,
                    y1: b.y1 + dy
                });
            }
            layouts.push({
                variant: v,
                shift: shift,
                solids: solids,
                boxes: boxes
            });
        }
    }
    const scored = $e81502d4aa27ba48$var$shuffled(layouts, rng).map((l)=>({
            ...l,
            hit: l.solids.filter((b)=>$e81502d4aa27ba48$var$runsThrough(samples, b))
        }));
    // What a layout costs, in the order the costs matter.
    //
    // Losing every structure is not one more of the same loss, it is a different
    // outcome: a market with no shop on it, a housing block with no housing, a
    // tile the player walks into and finds bare ground. Scoring on the count
    // alone could not see that — a variant carrying ONE structure that the road
    // runs through ties with a variant carrying four that loses one, and the
    // seeded shuffle then picked between them at random. Measured across every
    // road position on the tile, that emptied a habitation tile eighteen times
    // out of eighteen where a layout that kept a building was available.
    //
    // Nothing else changes: every layout still suppresses whatever it leaves
    // under the roadway, so this decides WHICH layout is drawn and never puts a
    // roof on the tarmac.
    const cost = (l)=>[
            l.solids.length && l.hit.length === l.solids.length ? 1 : 0,
            l.hit.length
        ];
    const best = scored.reduce((a, b)=>{
        const [aBare, aHit] = cost(a), [bBare, bHit] = cost(b);
        return bBare < aBare || bBare === aBare && bHit < aHit ? b : a;
    });
    // boxes comes back so the caller can thin the winner by road distance: a
    // variant's element indices only mean anything within that variant, so the
    // thinning has to score the layout that actually won, not the one the first
    // measuring pass happened to roll. Mirroring never changes a footprint's
    // size or its index, so the unshifted boxes are the right thing to score.
    return {
        variant: best.variant,
        shift: best.shift,
        boxes: best.boxes,
        skip: new Set(best.hit.map((b)=>b.n))
    };
}
// ---- where the tile sets its structures down ----
// Recipes anchor their structures a fixed distance in from the tile edge — 9
// to 18 units of a 120-unit tile — and chooseLayout mirrors corner to corner,
// which maps a margin to the margin on the opposite side and so preserves the
// set of them. Across a grid that repeats on a 120-unit rhythm and leaves an
// open lane at every tile join, and the eye reads the lattice long before it
// reads the town.
//
// Carrying the whole composition sideways does not fix it: a recipe puts a
// block in one corner and another in the opposite one, so its bounding box is
// most of the tile and there is nowhere rigid to carry it TO. Structures have
// to move against each other, which means the thing that was holding them
// apart — an author's coordinates — has to be replaced by something. That
// something is the measurement: what a footprint SITS ON may not change.
//
// One rule covers every case a recipe author was relying on:
//   - a block standing clear of everything has to stay clear of everything,
//     of the roadway included, so nothing lands on anything;
//   - a guard post inside its compound fence stays inside it, because leaving
//     would drop its overlap with the fence;
//   - a shed on a field of rubble is already covered by it and stays covered
//     wherever it goes, so ground litter never pins anything down;
//   - a storefront authored clear of its market keeps clear of it.
// No element list, no special cases, and a recipe can be rewritten without
// this having to be told about it.
/**
 * How far a structure may walk from where it was authored.
 *
 * A structure cannot leave the tile, so a wander is not symmetric: there is
 * always more room toward the middle than toward the join, and every unit of
 * reach therefore also widens the open lane between tiles a little. Measured
 * across a grid, reach buys a flatter tile interior and costs frontage, and
 * the two cross here — past this the hole in the middle of every tile is
 * already gone and the lane is all that is still growing.
 */ const $e81502d4aa27ba48$var$PLACE_JITTER = 16;
/**
 * How many placements to try before leaving a structure where it was. Backs
 * off toward the authored position as it goes, so a tight tile ends up nudged
 * rather than unmoved.
 */ const $e81502d4aa27ba48$var$PLACE_TRIES = 6;
/**
 * A footprint this long on an axis is the TILE, not something standing on it:
 * a pipe run, a compound fence, a field of scatter. Those never move — a
 * pipeline still has to meet its neighbour's at the join — but they are very
 * much still something to sit on, so they stay in the overlap test.
 */ const $e81502d4aa27ba48$var$SPANNING = 96;
const $e81502d4aa27ba48$var$tileWide = (b)=>b.x1 - b.x0 >= $e81502d4aa27ba48$var$SPANNING || b.y1 - b.y0 >= $e81502d4aa27ba48$var$SPANNING;
const $e81502d4aa27ba48$var$overlap = (a, b)=>Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)) * Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0));
/**
 * Walk each structure off its authored spot, as far as the tile allows.
 *
 * Works on footprints as they will be DRAWN — mirrored by the layout pass,
 * thinned by distance, scaled by the region — for the same reason everything
 * else in this file does: the authored coordinates are not where anything
 * ends up. Mutates the boxes it is given as it goes, so each structure is
 * placed against where the previous ones actually landed.
 *
 * @param {Array} placed  footprints in draw order; MUTATED to their new spots
 * @param {Array} samples the roadway's bound, when the network runs through
 * @returns {Map} element instance index -> [dx, dy]
 */ function $e81502d4aa27ba48$var$placeStructures(placed, rng, samples) {
    const moved = new Map();
    const sits = (b, box)=>{
        let before = 0, after = 0;
        for (const o of placed){
            if (o === b) continue;
            before += $e81502d4aa27ba48$var$overlap(o, b);
            after += $e81502d4aa27ba48$var$overlap(o, box);
        }
        return before === after;
    };
    for (const b of placed){
        if ($e81502d4aa27ba48$var$tileWide(b)) continue;
        for(let t = 0; t < $e81502d4aa27ba48$var$PLACE_TRIES; t++){
            const reach = $e81502d4aa27ba48$var$PLACE_JITTER * (1 - t / $e81502d4aa27ba48$var$PLACE_TRIES);
            // Drawn from what the tile edge actually allows, not drawn and then
            // tested against it. Rejecting an out-of-bounds offset and rolling again
            // is a bias toward the middle of the tile — the closer a structure
            // stands to an edge, the more of its offsets die on that side — which
            // trades one uniformity for another, and this whole pass exists to stop
            // structures landing a predictable distance from the join.
            const span = (lo, hi)=>{
                const a = Math.max(-reach, lo), z = Math.min(reach, hi);
                return z > a ? Math.round(a + rng() * (z - a)) : 0;
            };
            // A footprint that reaches the far clamp may have been TRUNCATED by it
            // — buildingTop and storefront both size themselves against the tile
            // edge — and what was measured is the truncated version. Move it back
            // toward the origin and the clamp stops biting: it draws wider than the
            // box this pass cleared, and lands on whatever that box was clearing it
            // of. So a structure against the clamp does not move on that axis; only
            // one with room to spare on both sides has a measurement to trust.
            const dx = span(b.x1 >= $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP ? 0 : $e81502d4aa27ba48$var$TILE_CLAMP - b.x0, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - b.x1);
            const dy = span(b.y1 >= $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP ? 0 : $e81502d4aa27ba48$var$TILE_CLAMP - b.y0, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - b.y1);
            if (!dx && !dy) break;
            const box = {
                x0: b.x0 + dx,
                x1: b.x1 + dx,
                y0: b.y0 + dy,
                y1: b.y1 + dy
            };
            // The layout that won did so by standing clear of the carriageway, and
            // an offset that puts a wall back on it costs more than the uniformity
            // it was buying.
            if (b.solid && samples && $e81502d4aa27ba48$var$runsThrough(samples, box)) continue;
            if (!sits(b, box)) continue;
            Object.assign(b, box);
            moved.set(b.n, [
                dx,
                dy
            ]);
            break;
        }
    }
    return moved;
}
// ---- daylight wells (underground regions) ----
// A few large cave openings light whole AREAS of the map, like sun pouring
// into a cavern. Wells live on a fixed WORLD grid (same trick as the cloud
// field): every tile derives the identical well set from hashed super-cell
// coordinates, then shades its own pixels by distance to the nearest well —
// so one opening illuminates a neighborhood of tiles with a wide, seamless
// falloff and no cross-tile coordination. tune.lightRays is well density.
const $e81502d4aa27ba48$var$WELL_CELL = 120; // world units between candidate openings (3 tiles)
function $e81502d4aa27ba48$var$lightWellsNear(col, row, density) {
    const wells = [];
    const cx = Math.floor((col * $e81502d4aa27ba48$export$3d672f2aedd16af9 + $e81502d4aa27ba48$export$3d672f2aedd16af9 / 2) / $e81502d4aa27ba48$var$WELL_CELL);
    const cy = Math.floor((row * $e81502d4aa27ba48$export$3d672f2aedd16af9 + $e81502d4aa27ba48$export$3d672f2aedd16af9 / 2) / $e81502d4aa27ba48$var$WELL_CELL);
    for(let gy = cy - 1; gy <= cy + 1; gy++)for(let gx = cx - 1; gx <= cx + 1; gx++){
        if ($e81502d4aa27ba48$var$noiseHash(gx * 31 + 7, gy * 17 + 3) > density * 0.5) continue;
        wells.push({
            x: (gx + 0.15 + 0.7 * $e81502d4aa27ba48$var$noiseHash(gx, gy)) * $e81502d4aa27ba48$var$WELL_CELL,
            y: (gy + 0.15 + 0.7 * $e81502d4aa27ba48$var$noiseHash(gx + 99, gy + 41)) * $e81502d4aa27ba48$var$WELL_CELL,
            r: 55 + 40 * $e81502d4aa27ba48$var$noiseHash(gx + 7, gy + 77)
        });
    }
    return wells;
}
// The landing pool tracks the sun through the day (west of the opening at
// sunrise, plumb beneath it at noon, east at dusk) and its intensity
// follows the SURFACE day cycle — gone at night.
// Each well also casts visible god rays: thin streaks that hang from the
// STATIC opening and slant down to wherever the pool currently lands. The
// beam spreads cone-like from opening to landing, is longest when the sun
// is low, and fades out near noon when the vertical shaft is seen end-on.
// Lanes come from world-space noise on the perpendicular axis — seamless
// across tiles — and drift slowly with time like dust in the shaft.
// The rays' visible ORIGIN is fixed up-screen of the well — the ceiling
// opening projected ~one tile north — so beams always slant DOWN into the
// pool instead of lying flat across it; at noon they pour straight down-screen.
const $e81502d4aa27ba48$var$RAY_RISE = 36;
/**
 * Where the sun is putting a shaft of daylight, this frame.
 *
 * Shared by the shafts themselves and by the shadows the rock throws in them,
 * because those two have to agree about where the light is coming from or the
 * stone will shade the wrong way.
 *
 * The landing point tracks the sun: west of the opening at sunrise, sweeping
 * left to right through the day, directly beneath it at noon. Vertically it
 * keeps a gentle southward drift that peaks mid-morning and mid-afternoon and
 * vanishes at dawn, noon and dusk.
 */ function $e81502d4aa27ba48$var$sunShaft(anim) {
    let elev = 0.7, dayFrac = 0.35; // static renders: late-morning sun
    if (anim && anim.dayPhase != null) {
        const f = (anim.dayPhase - 0.25) / 0.5; // 06:00 -> 18:00
        dayFrac = Math.min(1, Math.max(0, f));
        elev = f >= 0 && f <= 1 ? Math.sin(f * Math.PI) : 0;
    }
    const bx = (dayFrac - 0.5) * 160;
    const by = elev * (1 - elev) * 18;
    const vx = bx, vy = by + $e81502d4aa27ba48$var$RAY_RISE; // beam vector: origin -> pool
    const bl = Math.hypot(vx, vy);
    return {
        elev: elev,
        bx: bx,
        by: by,
        bl: bl,
        ux: vx / bl,
        uy: vy / bl
    };
}
function $e81502d4aa27ba48$var$drawLightWells(g, T, tune, anim, col, row) {
    const { elev: elev, bx: bx, by: by, bl: bl, ux: ux, uy: uy } = $e81502d4aa27ba48$var$sunShaft(anim);
    if (elev <= 0.03) return; // night
    const wells = $e81502d4aa27ba48$var$lightWellsNear(col, row, tune.lightRays);
    if (!wells.length) return;
    // world units, NOT the authoring grid — see WORLD/FX_STEP. Every constant
    // in this function is tuned in these units, and the loop below is the
    // per-tile cost of the whole ambient layer.
    const ox = col * $e81502d4aa27ba48$export$3d672f2aedd16af9, oy = row * $e81502d4aa27ba48$export$3d672f2aedd16af9;
    const t = anim?.t || 0;
    for(let y = 0; y < $e81502d4aa27ba48$export$3d672f2aedd16af9; y += $e81502d4aa27ba48$export$a4097a0a1d4593d2)for(let x = 0; x < $e81502d4aa27ba48$export$3d672f2aedd16af9; x += $e81502d4aa27ba48$export$a4097a0a1d4593d2){
        let I = 0, ray = 0, wave = 0.5;
        for (const w of wells){
            const rx = ox + x - w.x - bx, ry = oy + y - w.y - by;
            const f = 1 - Math.hypot(rx, ry) / w.r;
            if (f > I) I = f;
            const orx = ox + x - w.x, ory = oy + y - (w.y - $e81502d4aa27ba48$var$RAY_RISE); // relative to the raised origin
            const along = orx * ux + ory * uy;
            if (along < -2) continue; // nothing behind the origin
            const perp = -orx * uy + ory * ux;
            // the beam spreads cone-like from the origin toward the landing
            const width = w.r * (0.35 + 0.55 * Math.min(1, along / bl));
            const envP = 1 - Math.abs(perp) / width;
            if (envP <= 0) continue;
            const seed = w.x * 0.37 + w.y * 0.61;
            const lane = $e81502d4aa27ba48$var$smoothNoise(perp / 7 + t * 0.1, seed);
            if (lane <= 0.6) continue;
            // each ray terminates at its own point INSIDE the landing pool: a
            // per-lane endpoint on this lane's chord, so the beam lands with a
            // ragged natural edge and never overshoots the pool
            const chord = Math.sqrt(Math.max(0, w.r * w.r - perp * perp));
            const end = bl + chord * (-0.5 + 1.2 * $e81502d4aa27ba48$var$smoothNoise(perp / 7, seed + 57));
            if (along > end) continue;
            const stop = Math.min(1, (end - along) / 6); // soft landing at the endpoint
            const start = Math.min(1, (along + 2) / 6); // soft emergence at the origin
            // shimmer: a slow brightness wave travels down the beam toward the
            // pool, phased per lane so the streaks pulse independently; static
            // renders sit at the neutral midpoint (factor 1.0)
            const wv = t ? 0.5 + 0.5 * Math.sin(t * 1.6 - along * 0.12 + perp * 0.35) : 0.5;
            const s2 = envP * ((lane - 0.6) / 0.4) * stop * start * (0.78 + 0.44 * wv);
            if (s2 > ray) {
                ray = s2;
                wave = wv;
            }
        }
        const px = x * $e81502d4aa27ba48$var$FX_PX, py = y * $e81502d4aa27ba48$var$FX_PX, ps = $e81502d4aa27ba48$export$a4097a0a1d4593d2 * $e81502d4aa27ba48$var$FX_PX;
        if (I > 0.03) {
            const s = I * I * (3 - 2 * I) * elev * 0.4; // smooth wide falloff
            g.a(Math.min(0.62, s * 0.8), ()=>g.p(px, py, ps, ps, '#f6e9c2')); // daylight
            if (s > 0.55) g.a((s - 0.55) * 0.8, ()=>g.p(px, py, ps, ps, '#fff8e2')); // hot core
        }
        if (ray > 0.02) {
            // the shimmer wave also drifts color temperature: warmer in the
            // troughs, whiter at the crests (midpoint = the tuned #fbf3d9)
            const rr = Math.min(255, Math.round(243 + 16 * wave));
            const gg = Math.min(255, Math.round(233 + 20 * wave));
            const bb = Math.min(255, Math.round(197 + 40 * wave));
            g.a(Math.min(0.16, ray * elev * 0.1), ()=>g.p(px, py, ps, ps, `rgb(${rr},${gg},${bb})`));
        }
    }
}
// The portal's energy glow, drawn as the final pass of a portal tile so it
// renders above flood water, vegetation, weathering, and even cloud cover.
function $e81502d4aa27ba48$var$portalGlow(g, T) {
    const C = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1;
    const f = $e81502d4aa27ba48$var$flicker(C, C, 4); // slow energy shimmer
    g.a(0.15 + 0.18 * f, ()=>$e81502d4aa27ba48$var$disc(g, C, C, 27, T.glow));
    g.a(0.65 + 0.3 * f, ()=>$e81502d4aa27ba48$var$disc(g, C, C, 9, T.glow));
    g.a(0.5 + 0.4 * f, ()=>$e81502d4aa27ba48$var$ringO(g, C, C, 13 + Math.round(f * 3), T.glow)); // pulsing containment ring
    g.r(C - 1, C - 1, 3, 3, T.structLight);
}
// Gates take twice as long to traverse as hazards, so dress them as major
// areas of interest: an extra structure in a free corner and a perimeter
// wall around the compound (skipped when the recipe already fenced the
// yard). Gate vegetation is also boosted in the renderer.
function $e81502d4aa27ba48$var$gateEmphasis(g, rng, T, tune, conn, recipe, samples) {
    // Every roll happens up front, whichever corner wins — this draws on the same
    // stream the recipe used, so a choice that spent a different number of rolls
    // would move everything after it (see buildingTop).
    const pick = $e81502d4aa27ba48$var$ri(rng, 0, 3);
    const jx = $e81502d4aa27ba48$var$ri(rng, 0, 6), jy = $e81502d4aa27ba48$var$ri(rng, 0, 6);
    const bw = $e81502d4aa27ba48$var$ri(rng, 21, 27), bh = $e81502d4aa27ba48$var$ri(rng, 18, 24);
    // This block is drawn OUTSIDE the recipe, so the layout pass never measures
    // it and cannot suppress it — on a gate the road runs through, it simply
    // landed on the roadway. Score the corners here on the same rule instead,
    // starting from the seeded pick so a tile with no road looks as it did; and
    // where a road reaches every corner, drop the block rather than pave over it.
    const corners = [
        [
            12,
            12
        ],
        [
            78,
            12
        ],
        [
            12,
            78
        ],
        [
            78,
            78
        ]
    ];
    const s = tune.buildingScale;
    const boxAt = ([cx, cy])=>({
            x0: cx + jx,
            y0: cy + jy,
            x1: cx + jx + Math.round(bw * s),
            y1: cy + jy + Math.round(bh * s)
        });
    const order = corners.map((_, i)=>corners[(pick + i) % 4]);
    const clear = samples?.length ? order.find((c)=>!$e81502d4aa27ba48$var$runsThrough(samples, boxAt(c))) : order[0];
    const [bx, by] = clear || order[0];
    $e81502d4aa27ba48$var$buildingTop(clear ? g : $e81502d4aa27ba48$var$makeProbeG(), rng, T, tune, bx + jx, by + jy, bw, bh);
    if (recipe !== 'security') $e81502d4aa27ba48$var$fenceRing(g, rng, T, 6, 6, 108, 108, conn);
    // Hand the footprint back. Drawn outside the recipe, this block is in no
    // measurement anyone downstream has — which is how the vegetation pass came
    // to plant on it, and every tree on a roof anywhere on the map was this one.
    return clear ? boxAt(clear) : null;
}
const $e81502d4aa27ba48$export$df5605651df73ebd = 24; // largest footprint, in units (~4.8 m of ground)
const $e81502d4aa27ba48$export$193bd40b90286d11 = 4; // wall ring around an indoor anchor
// Connector bands run centre-to-edge and occupy x,y in [45,75] at their
// widest, so anchors take a seeded corner quadrant. The 9px outer margin also
// clears the perimeter fence gateEmphasis puts on gate tiles.
function $e81502d4aa27ba48$var$anchorSpot(rng, w, h) {
    const c = $e81502d4aa27ba48$var$ri(rng, 0, 3);
    return [
        c & 1 ? $e81502d4aa27ba48$var$ri(rng, 75, 111 - w) : $e81502d4aa27ba48$var$ri(rng, 9, 45 - w),
        c & 2 ? $e81502d4aa27ba48$var$ri(rng, 75, 111 - h) : $e81502d4aa27ba48$var$ri(rng, 9, 45 - h)
    ];
}
// Roof cutaway for an encounter that happens INDOORS. The map looks down at
// roofs, but most event prose is written inside halls and bays — rather than
// move those outdoors or pretend the tile is an interior, the one structure
// the encounter happens in gets its roof taken off, and the anchor sits on the
// floor of the open bay. A doorway faces the tile centre so the bay reads as
// enterable from the path rather than sealed.
function $e81502d4aa27ba48$var$drawCutaway(g, T, x, y, w, h) {
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.structDark); // wall mass
    g.r(x, y, w, 1, T.structLight); // lit wall cap
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.far);
    g.r(x + w - 1, y, 1, h, T.far);
    const p = $e81502d4aa27ba48$export$193bd40b90286d11;
    g.r(x + p - 1, y + p - 1, w - 2 * p + 2, h - 2 * p + 2, T.ground2); // interior floor
    g.a(0.35, ()=>g.r(x + p - 1, y + p - 1, w - 2 * p + 2, h - 2 * p + 2, T.far)); // roofed shade
    g.a(0.5, ()=>{
        g.r(x + p - 1, y + p - 1, w - 2 * p + 2, 1, T.structDark);
        g.r(x + p - 1, y + p - 1, 1, h - 2 * p + 2, T.structDark);
    });
    const dw = 8; // doorway, on the wall nearest the hub
    const cx = x + (w >> 1), cy = y + (h >> 1), mid = $e81502d4aa27ba48$export$9e15ff8aa6bc996f >> 1;
    if (Math.abs(cx - mid) > Math.abs(cy - mid)) g.r(cx < mid ? x + w - p : x, y + (h >> 1) - (dw >> 1), p, dw, T.ground2);
    else g.r(x + (w >> 1) - (dw >> 1), cy < mid ? y + h - p : y, dw, p, T.ground2);
}
// Returns without touching the rng when there is no anchor to draw — roads,
// water, campsites, entry/exit and blocked cells all have no primary skill.
// Because the anchor owns its own rng phase, that early return leaves those
// tiles pixel-identical to what they rendered before anchors existed.
function $e81502d4aa27ba48$var$runAnchor(skillId, g, rng, T, tune, conn, indoor) {
    const def = skillId && $e81502d4aa27ba48$export$73b3f97728261c35[skillId];
    if (!def || !Array.isArray(def.elements)) return;
    const w = def.w ?? $e81502d4aa27ba48$export$df5605651df73ebd, h = def.h ?? $e81502d4aa27ba48$export$df5605651df73ebd;
    const pad = indoor ? $e81502d4aa27ba48$export$193bd40b90286d11 : 0;
    const [ox, oy] = $e81502d4aa27ba48$var$anchorSpot(rng, w + pad * 2, h + pad * 2);
    if (indoor) $e81502d4aa27ba48$var$drawCutaway(g, T, ox, oy, w + pad * 2, h + pad * 2);
    $e81502d4aa27ba48$var$runRecipe(def, g, rng, T, tune, conn, ox + pad, oy + pad);
}
// ---- ruins pass ----
// The city was denser than what is still standing in it. A ruin is a
// building-sized footprint of what came down: the floor slab, the wall stubs
// that outlast a roof, and the roof itself piled on the floor. Drawn from the
// same vocabulary as an intact building so the two read as one architecture in
// two states, and drawn as a PASS rather than as a recipe element so every
// room gets them without thirteen recipes each having to say so.
/**
 * Rubble is DARKER than the building it came from. A heap of broken material
 * is mostly the shadow between its pieces, and the bright faces an intact roof
 * shows are surfaces still pointing at the sky — a pile has few of those. Some
 * of it burned, and what burned goes further: down and toward grey, because
 * char has no colour of its own left.
 *
 * The whole ruin is drawn from ONE derived palette rather than from T, so the
 * shared rubble helper stays exactly as the roads and the collapse tiles use
 * it, and the two states of a ruin differ in one place.
 */ const $e81502d4aa27ba48$var$RUBBLE_SHADE = 0.72;
const $e81502d4aa27ba48$var$CHARRED_CHANCE = 0.22;
function $e81502d4aa27ba48$var$ruinPalette(T, charred) {
    const k = charred ? 0.4 : $e81502d4aa27ba48$var$RUBBLE_SHADE;
    const grey = charred ? 0.85 : 0;
    return {
        ...T,
        struct: $e81502d4aa27ba48$var$shade(T.struct, k, grey),
        structLight: $e81502d4aa27ba48$var$shade(T.structLight, charred ? 0.34 : 0.62, grey),
        structDark: $e81502d4aa27ba48$var$shade(T.structDark, charred ? 0.7 : 1, grey),
        metal: $e81502d4aa27ba48$var$shade(T.metal, charred ? 0.4 : 0.72, grey),
        stub: $e81502d4aa27ba48$var$shade(T.struct, charred ? 0.5 : 0.85, grey)
    };
}
function $e81502d4aa27ba48$var$ruinedBuilding(g, rng, T, x, y, w, h, charred) {
    const P = $e81502d4aa27ba48$var$ruinPalette(T, charred);
    $e81502d4aa27ba48$var$dropShadow(g, T, x + 2, y + 2, w - 4, h - 4);
    // The heap, in the same masonry the buildings are made of and NOT in the
    // dark of a hole: this is material piled up, not ground fallen away, and the
    // collapse tiles already own the second reading. What separates it from a
    // roof at a glance is its edge — a rectangle that has lost its corners,
    // ragged a few units in and out on every row.
    for(let ry = 0; ry < h; ry++){
        const l = $e81502d4aa27ba48$var$ri(rng, 0, 4), r = $e81502d4aa27ba48$var$ri(rng, 0, 4);
        g.r(x + l, y + ry, Math.max(1, w - l - r), 1, P.struct);
    }
    // broken up: light where a face has sheared and caught the sun, dark in the
    // gaps between slabs
    for(let i = 0, n = Math.round(w * h * 0.09); i < n; i++)g.r(x + $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, w - 4)), y + $e81502d4aa27ba48$var$ri(rng, 1, Math.max(1, h - 2)), $e81502d4aa27ba48$var$ri(rng, 2, 4), 1, rng() < 0.55 ? P.structDark : P.structLight);
    // Wall stubs. A broken RUN on each side, never the whole side: four
    // continuous walls would read as a building with its roof off, and the point
    // of these is that they are past saving.
    const stub = (sx, sy, sw, sh)=>{
        $e81502d4aa27ba48$var$dropShadow(g, T, sx, sy, sw, sh);
        g.r(sx, sy, sw, sh, P.stub); // a standing face, so a shade up
        g.r(sx, sy, sw, 1, P.structLight); // lit top of the stub
        g.r(sx, sy + sh - 1, sw, 1, P.structDark);
    };
    const run = (span)=>{
        const len = $e81502d4aa27ba48$var$ri(rng, Math.max(5, span >> 2), Math.max(6, span - 5));
        return [
            $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, span - len)),
            len
        ];
    };
    const [ax, aw] = run(w);
    stub(x + ax, y, aw, 3);
    const [bx, bw] = run(w);
    stub(x + bx, y + h - 3, bw, 3);
    const [ay, ah] = run(h);
    stub(x, y + ay, 3, ah);
    const [by, bh] = run(h);
    stub(x + w - 3, y + by, 3, bh);
    // and what spilled off the edges when it came down, in the ruin's own tones
    $e81502d4aa27ba48$var$rubble(g, rng, P, x - 4, x + w, y - 4, y + h, Math.max(5, Math.round(w * h / 130)));
}
/** Rooms the map places whole, and which a fresh ruin would only clutter. */ const $e81502d4aa27ba48$var$RUIN_EXEMPT = new Set([
    'water',
    'blocked',
    'reactor',
    'portal',
    'campsite'
]);
/**
 * @param {Array} keepOut structures already standing; a ruin never lands on one
 * @param {Array} samples the roadway, for the same reason
 */ function $e81502d4aa27ba48$var$drawRuins(g, rng, T, tune, keepOut, samples, shore) {
    const taken = [
        ...keepOut
    ];
    const clash = (b)=>taken.some((k)=>b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0) || !!samples?.length && $e81502d4aa27ba48$var$runsThrough(samples, b);
    // On the shore row, the seaward half of the tile is mostly wrecks: more of
    // them, and pushed into the band the water reaches. Paired with the thinned
    // standing stock in builtUp, that half comes out as ruins in the shallows and
    // the landward half stays a street.
    const drowned = shore?.at === 0;
    const band = drowned ? shore.side === 'n' ? [
        0,
        $e81502d4aa27ba48$var$WATERLINE
    ] : [
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$WATERLINE,
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f
    ] : null;
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 1, drowned ? 4 : 2); i < n; i++){
        const w = Math.round($e81502d4aa27ba48$var$ri(rng, 24, 39) * tune.buildingScale);
        const h = Math.round($e81502d4aa27ba48$var$ri(rng, 18, 30) * tune.buildingScale);
        let box = null;
        // Same retry-and-give-up as the vegetation: on a tile with no room left,
        // the ruin that was never there is the right answer. Safe to vary the roll
        // count here — the ruins have their own seeded stream and both drawing
        // passes replay it against the same obstacles.
        for(let t = 0; t < 10 && !box; t++){
            const x = $e81502d4aa27ba48$var$ri(rng, 6, Math.max(6, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 6 - w));
            const y = band ? $e81502d4aa27ba48$var$ri(rng, band[0], Math.max(band[0], band[1] - h)) : $e81502d4aa27ba48$var$ri(rng, 6, Math.max(6, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 6 - h));
            const b = {
                x0: x,
                y0: y,
                x1: x + w,
                y1: y + h
            };
            if (!clash(b)) box = b;
        }
        if (!box) continue;
        $e81502d4aa27ba48$var$ruinedBuilding(g, rng, T, box.x0, box.y0, w, h, rng() < $e81502d4aa27ba48$var$CHARRED_CHANCE);
        taken.push(box); // ruins do not pile on each other either
    }
    // What this pass actually put down, so the signature layer can keep off it.
    // A gantry lying across a fresh ruin is the one clash the recipe's own
    // keep-out list cannot see, because a ruin is not in the recipe.
    return taken.slice(keepOut.length);
}
// ---- parking ----
/**
 * A parking lot is part of the road structure. It is the same tarmac, and it
 * only exists because something could drive onto it — so it is laid AGAINST the
 * carriageway off the road's own samples, the same way the traffic is, rather
 * than authored into a recipe's layout and then fought over.
 *
 * That is what fixes the overlap. A lot placed into a layout has to be either
 * mirrored clear of the road or dropped, and a lot is wide enough that most of
 * them ended up dropped; a lot placed off the roadway cannot be crossed by it,
 * and reads as what a lot actually is — an apron off the street.
 *
 * A tile the network misses gets no lot at all. There is nowhere to put one
 * that is not detached: an apron with no way onto it is not a car park, it is a
 * rectangle of tarmac in the middle of a block.
 */ const $e81502d4aa27ba48$var$PARKING_RECIPES = new Set([
    'records',
    'habitation',
    'commerce'
]);
/**
 * Depth is fixed because it is a real dimension: 24 units is 4.8 m, one row of
 * bays parked nose-in, and a shallower lot would not be a lot. Length is
 * whatever fits — the longest row the spot allows, down to a floor of two. A
 * single bay is a driveway, not a car park, so a spot that only takes one is
 * treated as no spot at all.
 */ const $e81502d4aa27ba48$var$MIN_BAYS = 2, $e81502d4aa27ba48$var$MAX_BAYS = 5;
function $e81502d4aa27ba48$var$drawParking(g, rng, T, samples, keepOut) {
    if (!samples?.length) return null;
    const clash = (b)=>keepOut.some((k)=>b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0);
    // Being clear of the sample it was hung off is not enough: a road that bends
    // can come back around and pass under the far end of the lot. Test the whole
    // footprint against the tarmac — measured a unit inside the sample bounds, or
    // the lot would reject the very band it is meant to be flush against.
    const crossed = (b)=>samples.some((s)=>{
            const hx = s.hx - $e81502d4aa27ba48$var$CLEARANCE - 1, hy = s.hy - $e81502d4aa27ba48$var$CLEARANCE - 1;
            return s.x + hx > b.x0 && s.x - hx < b.x1 && s.y + hy > b.y0 && s.y - hy < b.y1;
        });
    // A lot is a big rectangle that has to be flush to the tarmac, clear of every
    // building, and clear of the rest of the road's run. On a busy tile that is a
    // narrow target, so it gets plenty of tries before giving up.
    for(let t = 0; t < 30; t++){
        const s = samples[$e81502d4aa27ba48$var$ri(rng, 0, samples.length - 1)];
        const vert = s.hx > s.hy; // the lot runs alongside, so it takes the road's axis
        const far = rng() < 0.5;
        // Flush to the DRAWN road, not to the sample bound — the samples run a
        // clearance wider than the tarmac they describe, and a lot set against that
        // would stand off the kerb by a pixel of bare ground.
        const ox = s.hx - $e81502d4aa27ba48$var$CLEARANCE, oy = s.hy - $e81502d4aa27ba48$var$CLEARANCE;
        // Longest row this spot will take. Depth never moves, so the only thing
        // being traded is how many bays fit alongside the road.
        for(let bays = $e81502d4aa27ba48$var$MAX_BAYS; bays >= $e81502d4aa27ba48$var$MIN_BAYS; bays--){
            const long = $e81502d4aa27ba48$var$lotLength(bays);
            const w = vert ? $e81502d4aa27ba48$var$BAY_DEPTH : long, h = vert ? long : $e81502d4aa27ba48$var$BAY_DEPTH;
            const x = Math.round(vert ? far ? s.x + ox : s.x - ox - w : s.x - w / 2);
            const y = Math.round(vert ? s.y - h / 2 : far ? s.y + oy : s.y - oy - h);
            const box = {
                x0: x,
                y0: y,
                x1: x + w,
                y1: y + h
            };
            if (x < 3 || y < 3 || x + w > $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 3 || y + h > $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 3) continue;
            if (clash(box) || crossed(box)) continue;
            $e81502d4aa27ba48$var$parkingLot(g, rng, T, x, y, w, h, vert);
            return box;
        }
    }
    return null;
}
// ---- roadside traffic ----
/**
 * What was on the road when it stopped being a road.
 *
 * Placed off the roadway's OWN centreline samples rather than scattered on the
 * tile: take a sample, take a side, and step out across the band. That gets a
 * wreck lying parallel to the carriageway it was on — whichever way the road
 * runs, and around a bend as readily as along a straight — without the pass
 * ever being told the road's shape. It also gets the wreck onto the shoulder
 * instead of the middle of the lane, which is where an abandoned car ends up.
 *
 * A trunk carried the traffic; a back lane carried less of it. Count follows
 * the rank the tile's roadway is drawn at.
 */ const $e81502d4aa27ba48$var$ROADSIDE_COUNT = {
    major: [
        1,
        3
    ],
    minor: [
        0,
        1
    ]
};
function $e81502d4aa27ba48$var$drawRoadside(g, rng, T, samples, rank, keepOut) {
    if (!samples?.length) return;
    const [lo, hi] = $e81502d4aa27ba48$var$ROADSIDE_COUNT[rank === (0, $eaa96db7af263115$export$39615881bb0d21f6) ? 'major' : 'minor'];
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, lo, hi); i < n; i++){
        const s = samples[$e81502d4aa27ba48$var$ri(rng, 0, samples.length - 1)];
        // a sample is narrow ALONG the road and wide ACROSS it, so the wider half
        // says which way the traffic was going
        const vert = s.hx > s.hy;
        const far = rng() < 0.5; // which shoulder
        const bite = $e81502d4aa27ba48$var$ri(rng, 0, 5); // how far it is still on the tarmac
        const w = vert ? $e81502d4aa27ba48$export$f6b0e5d6358e6bd8 : $e81502d4aa27ba48$export$8ce2cf2f7041018f, h = vert ? $e81502d4aa27ba48$export$8ce2cf2f7041018f : $e81502d4aa27ba48$export$f6b0e5d6358e6bd8;
        const x = Math.round(vert ? far ? s.x + s.hx - bite : s.x - s.hx - w + bite : s.x - w / 2);
        const y = Math.round(vert ? s.y - h / 2 : far ? s.y + s.hy - bite : s.y - s.hy - h + bite);
        if (x < 3 || y < 3 || x + w > $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 3 || y + h > $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 3) continue;
        if (keepOut.some((k)=>x <= k.x1 && x + w >= k.x0 && y <= k.y1 && y + h >= k.y0)) continue;
        $e81502d4aa27ba48$var$vehicle(g, rng, T, x, y, vert);
    }
}
// ---- vegetation pass (per region backdrop, drawn over the content) ----
// Positions strongly favor the corner quadrants so growth stays off the
// road/path connectors — a stray tree over the roadway is allowed but rare.
//
// `keepOut` is the footprint of every structure the recipe actually drew. A
// canopy OVERHANGING a roof is the point — it is what makes the growth read as
// having taken the place back — but a trunk standing on one is not, so a spot
// that lands too near a building is re-rolled. Re-rolling is safe here where it
// would not be inside a recipe: vegetation has its own seeded stream, both the
// shadow and content passes replay it from identical copies, and both are
// handed the same keep-out list, so they always agree on where growth went.
const $e81502d4aa27ba48$var$VEG_TRIES = 14;
/**
 * How far a TRUNK stands off a building, as a fraction of its own canopy. At
 * 0.6 a tree keeps most of its spread clear of the roof and laps the rest over
 * the edge. Testing the bare POINT, as this did, let a tree stand one unit from
 * a wall with its entire crown over the building.
 */ const $e81502d4aa27ba48$var$VEG_CLEARANCE = 0.6;
const $e81502d4aa27ba48$var$SHRUB_CLEARANCE = 4; // growth with no radius of its own to scale by
/** @returns a spot, or null when there is nowhere on this tile to plant one. */ function $e81502d4aa27ba48$var$vegSpot(rng, keepOut, clear = $e81502d4aa27ba48$var$SHRUB_CLEARANCE) {
    const roll = ()=>{
        const band = ()=>rng() < 0.5 ? $e81502d4aa27ba48$var$ri(rng, 9, 33) : $e81502d4aa27ba48$var$ri(rng, 84, 108);
        if (rng() < 0.8) return [
            band(),
            band()
        ];
        return rng() < 0.5 ? [
            band(),
            $e81502d4aa27ba48$var$ri(rng, 9, 108)
        ] : [
            $e81502d4aa27ba48$var$ri(rng, 9, 108),
            band()
        ];
    };
    if (!keepOut?.length) return roll();
    const onStructure = ([x, y])=>keepOut.some((b)=>x >= b.x0 - clear && x <= b.x1 + clear && y >= b.y0 - clear && y <= b.y1 + clear);
    for(let i = 0; i < $e81502d4aa27ba48$var$VEG_TRIES; i++){
        const spot = roll();
        if (!onStructure(spot)) return spot;
    }
    // Nowhere to put it. Giving up rather than planting anyway is also what ties
    // the density to the open ground: a tile built kerb to kerb grows little, and
    // the same budget over open tarmac lands in full.
    return null;
}
// m = density multiplier (tune.treeDensity, 5x for campsite/water tiles).
// The ceiling bounds how thick one tile can get; it is not a tuning knob, and
// at 12 the rest stops and shorelines were flattening against it.
const $e81502d4aa27ba48$var$VEG_MAX = 24;
const $e81502d4aa27ba48$var$vegCount = (rng, lo, hi, m)=>Math.min($e81502d4aa27ba48$var$VEG_MAX, Math.round($e81502d4aa27ba48$var$ri(rng, lo, hi) * m));
/**
 * Irregular grass at the foot of a stand of trees.
 *
 * Only where they came out THICK. One tree on a street is a tree in a pavement
 * cutout and the paving around it is intact; three growing into each other have
 * had long enough to break the surface between them. Each qualifying trunk gets
 * its own wobbled patch and the patches merge, so the outline of a stand is the
 * union of its trees rather than a shape drawn on purpose.
 *
 * Laid as GROUND: before the canopies, so it reads as what they are standing
 * in, and outside castShadow, because grass casts nothing.
 */ const $e81502d4aa27ba48$var$STAND_REACH = 24; // how near two trunks must be to count as one stand
const $e81502d4aa27ba48$var$STAND_MIN = 3; // ...and how many neighbours before it is one
function $e81502d4aa27ba48$var$grassUnder(g, rng, T, stand, keepOut) {
    // A patch spreads wider than the canopy above it, so the trunk's own
    // clearance does not cover it: without this the grass laps onto the roof
    // next door, and grass on a roof is not a thing that happens.
    const inTheOpen = (x, y, rad)=>!keepOut.some((b)=>x + rad > b.x0 && x - rad < b.x1 && y + rad > b.y0 && y - rad < b.y1);
    for (const [x, y, r] of stand){
        const near = stand.filter(([ox, oy])=>Math.hypot(ox - x, oy - y) < $e81502d4aa27ba48$var$STAND_REACH).length - 1;
        if (near < $e81502d4aa27ba48$var$STAND_MIN) continue;
        const rad = r + $e81502d4aa27ba48$var$ri(rng, 2, 6);
        if (!inTheOpen(x, y, rad)) continue;
        const left = $e81502d4aa27ba48$var$wobbler(rng), right = $e81502d4aa27ba48$var$wobbler(rng);
        $e81502d4aa27ba48$var$blob(g, x, y, rad, T.veg1, left, right);
        for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 6, 14); i < n; i++){
            const a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * rad;
            g.r(Math.round(x + Math.cos(a) * d), Math.round(y + Math.sin(a) * d), $e81502d4aa27ba48$var$ri(rng, 2, 4), 1, T.veg2);
        }
    }
}
// Counts are doubled from what they were, authored here rather than hidden
// behind a global factor. A tree clears by its own canopy; a shrub takes the
// flat margin. Where there is nowhere to plant, nothing is planted — which is
// what puts the extra growth on the open tarmac instead of on the roofs.
//
// Trees are all SITED before any of them is drawn, so grassUnder can see the
// whole stand and get its grass down underneath them.
const $e81502d4aa27ba48$var$TD_VEGETATION = {
    city (g, rng, T, m, keep) {
        const stand = [];
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 2, 4, m); i < n; i++){
            const r = $e81502d4aa27ba48$var$ri(rng, 6, 9), s = $e81502d4aa27ba48$var$vegSpot(rng, keep, Math.round(r * $e81502d4aa27ba48$var$VEG_CLEARANCE));
            if (s) stand.push([
                s[0],
                s[1],
                r
            ]);
        }
        $e81502d4aa27ba48$var$grassUnder(g, rng, T, stand, keep);
        for (const [x, y, r] of stand)$e81502d4aa27ba48$var$tree(g, rng, T, x, y, r);
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 2, 6, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$bushPatch(g, rng, T, s[0], s[1]);
        }
    },
    greenhouse (g, rng, T, m, keep) {
        const stand = [];
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 4, 8, m); i < n; i++){
            const r = $e81502d4aa27ba48$var$ri(rng, 9, 15), s = $e81502d4aa27ba48$var$vegSpot(rng, keep, Math.round(r * $e81502d4aa27ba48$var$VEG_CLEARANCE));
            if (s) stand.push([
                s[0],
                s[1],
                r
            ]);
        }
        $e81502d4aa27ba48$var$grassUnder(g, rng, T, stand, keep);
        for (const [x, y, r] of stand)$e81502d4aa27ba48$var$tree(g, rng, T, x, y, r);
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 6, 12, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$bushPatch(g, rng, T, s[0], s[1]);
        }
    },
    harbor (g, rng, T, m, keep) {
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 2, 4, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$bushPatch(g, rng, T, s[0], s[1]);
        }
        const stand = [];
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 0, 2, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep, Math.round(6 * $e81502d4aa27ba48$var$VEG_CLEARANCE));
            if (s) stand.push([
                s[0],
                s[1],
                6
            ]);
        }
        $e81502d4aa27ba48$var$grassUnder(g, rng, T, stand, keep);
        for (const [x, y, r] of stand)$e81502d4aa27ba48$var$tree(g, rng, T, x, y, r);
    },
    foundry (g, rng, T, m, keep) {
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 0, 2, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$deadTree(g, rng, T, s[0], s[1]);
        }
        if (rng() < 0.8 * m) {
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$bushPatch(g, rng, T, s[0], s[1]);
        }
    },
    underground (g, rng, T, m, keep) {
        for(let i = 0, n = $e81502d4aa27ba48$var$vegCount(rng, 2, 6, m); i < n; i++){
            const s = $e81502d4aa27ba48$var$vegSpot(rng, keep);
            if (s) $e81502d4aa27ba48$var$glowShroom(g, rng, T, s[0], s[1]);
        }
    }
};
// ===============================
// REGION SIGNATURE STRUCTURES
// ===============================
// The one drawing pass that is about a PARTICULAR region rather than about a
// town. Everything else on a tile — the recipes, the road network, the parking,
// the ruins — is deliberately region-agnostic, which is right for a game where
// the same fifteen room types appear everywhere. The cost of that was that five
// regions rendered as one settlement under five palettes: same footprints, same
// silhouettes, a colour filter apart.
//
// This layer is the answer, and it is kept to the same shape as FLOORS,
// TD_VEGETATION and TD_OVERLAYS above it — a table keyed by theme.backdrop — so
// there is one obvious place to add a region's own architecture and one obvious
// place to look for it.
//
// The contract:
//   (g, rng, T, tune, ctx) -> Array<{x0,y0,x1,y1}>   the footprints it drew
//   ctx = { keep, samples, conn, col, row, built, recipe }
// Returning the footprints matters: the growth pass has to keep off them, the
// same way it keeps off everything the recipe drew.
/**
 * Whether a signature prop fires on this tile. Scaled by the region's own
 * `signature` knob (0 turns the layer off entirely) and by how built up the
 * district is — an outskirt gets fewer monuments than a core, for the same
 * reason it gets fewer buildings.
 */ const $e81502d4aa27ba48$var$sigRoll = (rng, chance, tune, built)=>rng() < chance * (tune.signature ?? 1) * (built != null ? 0.5 + 0.7 * built : 1);
/**
 * Somewhere on the tile to stand a prop of this size: clear of everything
 * already placed, off the roadway, and held inside TILE_CLAMP. The box-based
 * sibling of vegSpot, and it gives up the same way — on a tile with no room
 * left, the monument that was never built is the right answer, and it is what
 * ties this layer's density to the open ground.
 */ function $e81502d4aa27ba48$var$sigSpot(rng, ctx, w, h, tries = 12) {
    const lo = $e81502d4aa27ba48$var$TILE_CLAMP, hiX = $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - w, hiY = $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$TILE_CLAMP - h;
    if (hiX < lo || hiY < lo) return null;
    for(let i = 0; i < tries; i++){
        const x = $e81502d4aa27ba48$var$ri(rng, lo, hiX), y = $e81502d4aa27ba48$var$ri(rng, lo, hiY);
        const b = {
            x0: x,
            y0: y,
            x1: x + w,
            y1: y + h
        };
        const clash = ctx.keep.some((k)=>b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0) || !!ctx.samples?.length && $e81502d4aa27ba48$var$runsThrough(ctx.samples, b);
        if (!clash) return b;
    }
    return null;
}
// ---- world-lattice features ----
// TILE_CLAMP exists because a neighbour draws its OWN recipe and never
// continues this tile's, so a roof clipped by the canvas reads as a fault. A
// feature laid on a world lattice is the exception, and it is exempt by
// construction: both tiles derive the identical run from the same hashed world
// cell, both draw it, and each canvas clips its own half. The join is exact
// because neither tile decided anything locally.
//
// This is the lightWellsNear trick generalised, and it is what breaks the
// 120-unit rhythm the map otherwise reads on — a colonnade or a conveyor that
// marches across four tiles is the strongest cue that the map is one place
// rather than a grid of stamps.
/**
 * @param {number} cell  authoring units between candidate features
 * @returns {Array<{x,y,len,vert}>} runs in TILE-LOCAL coordinates
 */ // A run is up to LEN_MAX cells long, so a tile has to consider every cell that
// could REACH it, not just the ones next door. Searching ±1 cell looked right
// and was not: a long run originating two cells west was drawn by one tile and
// not by its neighbour, so it stopped dead at the join — the exact failure the
// whole world-lattice idea exists to avoid, and invisible in any single tile.
const $e81502d4aa27ba48$var$LEN_MIN = 1.2, $e81502d4aa27ba48$var$LEN_MAX = 2.2; // run length, in cells
const $e81502d4aa27ba48$var$FEATURE_RADIUS = Math.ceil($e81502d4aa27ba48$var$LEN_MAX) + 1; // cells to search either way
/**
 * @param {number} cell  authoring units between candidate features
 * @returns {Array<{x,y,len,vert}>} runs in TILE-LOCAL coordinates
 */ function $e81502d4aa27ba48$var$worldFeaturesNear(col, row, cell, salt, density) {
    const out = [];
    const cx = Math.floor(col * $e81502d4aa27ba48$export$9e15ff8aa6bc996f / cell), cy = Math.floor(row * $e81502d4aa27ba48$export$9e15ff8aa6bc996f / cell);
    for(let gy = cy - $e81502d4aa27ba48$var$FEATURE_RADIUS; gy <= cy + $e81502d4aa27ba48$var$FEATURE_RADIUS; gy++)for(let gx = cx - $e81502d4aa27ba48$var$FEATURE_RADIUS; gx <= cx + $e81502d4aa27ba48$var$FEATURE_RADIUS; gx++){
        if ($e81502d4aa27ba48$var$noiseHash(gx * 13 + salt, gy * 29 + salt) > density) continue;
        const vert = $e81502d4aa27ba48$var$noiseHash(gx + salt, gy + 5 + salt) < 0.5;
        const len = Math.round(cell * ($e81502d4aa27ba48$var$LEN_MIN + ($e81502d4aa27ba48$var$LEN_MAX - $e81502d4aa27ba48$var$LEN_MIN) * $e81502d4aa27ba48$var$noiseHash(gx + 3 + salt, gy + 11 + salt)));
        const wx = (gx + 0.1 + 0.8 * $e81502d4aa27ba48$var$noiseHash(gx + 17 + salt, gy + salt)) * cell;
        const wy = (gy + 0.1 + 0.8 * $e81502d4aa27ba48$var$noiseHash(gx + salt, gy + 23 + salt)) * cell;
        // tile-local, so a run that straddles the join is drawn by both sides
        const x = Math.round(wx - col * $e81502d4aa27ba48$export$9e15ff8aa6bc996f), y = Math.round(wy - row * $e81502d4aa27ba48$export$9e15ff8aa6bc996f);
        // Reject on the run's whole BOX, both axes. Testing only the long axis
        // kept vertical runs that sat entirely off the west edge.
        const x1 = x + (vert ? $e81502d4aa27ba48$var$FEATURE_TH : len), y1 = y + (vert ? len : $e81502d4aa27ba48$var$FEATURE_TH);
        if (x1 < 0 || y1 < 0 || x > $e81502d4aa27ba48$export$9e15ff8aa6bc996f || y > $e81502d4aa27ba48$export$9e15ff8aa6bc996f) continue;
        out.push({
            x: x,
            y: y,
            len: len,
            vert: vert
        });
    }
    return out;
}
// Widest a lattice run gets across its axis; only used to reject runs that
// cannot touch the tile, so an over-estimate is harmless.
const $e81502d4aa27ba48$var$FEATURE_TH = 22;
// ---- the props ----
/**
 * The monumental tier: a tower's footprint seen from above. This is the one
 * silhouette that has to read at 80px, so it is drawn big, in the `mass`
 * material rather than the ordinary building stock, and it throws a shadow at
 * twice the usual reach because it is the tallest thing for blocks. The skirt
 * of debris around its base is what says the tower is a ruin rather than a
 * warehouse: nothing this tall came through the centuries with its cladding on.
 */ function $e81502d4aa27ba48$var$towerCore(g, rng, T, x, y, w, h) {
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a * 0.8, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx * 3, y + $e81502d4aa27ba48$var$SHADOW.dy * 3, w, h, T.far)));
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight); // lit north and west faces
    g.r(x, y, 1, h, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    g.r(x + w - 1, y, 1, h, T.massDark);
    // the service core: every tower of this era has one, and from above it is
    // the only thing that breaks the roof plate
    const cw = Math.max(6, w >> 2), ch = Math.max(6, h >> 2);
    const cxp = x + (w - cw >> 1), cyp = y + (h - ch >> 1);
    g.r(cxp, cyp, cw, ch, T.massDark);
    g.r(cxp, cyp, cw, 1, T.mass);
    g.a(0.35, ()=>{
        for(let i = 6; i < w - 2; i += 6)g.r(x + i, y + 1, 1, h - 2, T.massDark);
    });
    $e81502d4aa27ba48$var$rubble(g, rng, T, x - 5, x + w + 5, y - 5, y + h + 5, Math.max(6, w * h / 150));
}
/**
 * PARKED — not referenced by TD_SIGNATURE.city. Kept because the idea is right
 * and the execution is not: at 80px this reads as a plain grey bar, because
 * what says "elevated walkway" is the support piers under it and the shadow it
 * throws across the street, and neither is drawn. Bring it back with those.
 *
 * What is left of an elevated walkway: a deck that starts nowhere and stops in
 * mid-air. Drawn as a world-lattice run so it crosses tiles, which is the whole
 * point — a skybridge that fits inside one cell is a footbridge.
 */ function $e81502d4aa27ba48$var$skybridgeStub(g, rng, T, x, y, len, vert) {
    const th = 11;
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a * 0.7, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx * 2, y + $e81502d4aa27ba48$var$SHADOW.dy * 2, vert ? th : len, vert ? len : th, T.far)));
    $e81502d4aa27ba48$var$pipeRun(g, T, x, y, len, vert, th, 0, 'mass');
    g.a(0.4, ()=>{
        for(let d = 3; d < len; d += 5)if (vert) {
            g.r(x, y + d, 1, 2, T.massDark);
            g.r(x + th - 1, y + d, 1, 2, T.massDark);
        } else {
            g.r(x + d, y, 2, 1, T.massDark);
            g.r(x + d, y + th - 1, 2, 1, T.massDark);
        }
    });
    // the broken end, ragged and shedding
    const ex = vert ? x : x + len - 4, ey = vert ? y + len - 4 : y;
    g.r(ex, ey, vert ? th : 4, vert ? 4 : th, T.structDark);
    $e81502d4aa27ba48$var$rubble(g, rng, T, ex - 4, ex + th, ey - 4, ey + th, 6);
}
/**
 * A civic perimeter block: a monumental range built right round an open yard.
 *
 * This is what replaced the sign gantry, and the reason is the camera. A sign
 * is defined by its FACE, and from directly overhead a face is an edge — the
 * gantry came out as a small striped bar standing in the open, and no amount of
 * detail on a surface the player cannot see was going to fix that. What reads
 * from above is what is defined by its PLAN, and the plan of a perimeter block
 * — a rectangle with a hole in it — is unmistakable at any size.
 *
 * It pairs with towerCore rather than repeating it: one is a solid mass, this
 * is a hollow one, so the monumental tier has two silhouettes instead of one.
 */ function $e81502d4aa27ba48$var$civicBlock(g, rng, T, x, y, w, h) {
    const th = Math.max(7, Math.min(w, h) >> 2); // depth of the range
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a * 0.6, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx * 2, y + $e81502d4aa27ba48$var$SHADOW.dy * 2, w, h, T.far)));
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight); // lit north and west faces
    g.r(x, y, 1, h, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    g.r(x + w - 1, y, 1, h, T.massDark);
    g.a(0.3, ()=>{
        for(let i = 5; i < w - 4; i += 9)g.r(x + i, y + 2, 4, 3, T.massDark);
        for(let i = 5; i < h - 4; i += 9)g.r(x + 2, y + i, 3, 4, T.massDark);
    });
    // The yard. Open ground, so the region's own floor shows through and the
    // growth has somewhere to be — a courtyard nobody has crossed in centuries.
    const ix = x + th, iy = y + th, iw = w - th * 2, ih = h - th * 2;
    if (iw > 3 && ih > 3) {
        g.r(ix, iy, iw, ih, T.ground2);
        g.a(0.5, ()=>{
            for(let i = 0, n = Math.round(iw * ih / 22); i < n; i++)g.r(ix + $e81502d4aa27ba48$var$ri(rng, 0, iw - 1), iy + $e81502d4aa27ba48$var$ri(rng, 0, ih - 1), 2, 1, T.ground1);
        });
        for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 3, 7); i < n; i++)g.r(ix + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, iw - 3)), iy + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, ih - 2)), $e81502d4aa27ba48$var$ri(rng, 2, 4), 2, rng() < 0.6 ? T.veg1 : T.veg2);
        // the yard is a well: its own walls light the opposite way to the outside
        g.r(ix, iy, iw, 1, T.massDark);
        g.r(ix, iy, 1, ih, T.massDark);
        g.r(ix, iy + ih - 1, iw, 1, T.massLight);
        g.r(ix + iw - 1, iy, 1, ih, T.massLight);
    }
    // ...and a length of the range that has come down, which is what makes it a
    // ruin rather than a building. Taken out of one side, full depth, so the yard
    // is open to the street through the gap.
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 1, 2); i < n; i++){
        const side = $e81502d4aa27ba48$var$ri(rng, 0, 3);
        const span = $e81502d4aa27ba48$var$ri(rng, 9, 18);
        if (side === 0 || side === 1) {
            const gx = x + $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, w - span - 2));
            const gy = side === 0 ? y : y + h - th;
            g.r(gx, gy, span, th, T.ground2);
            $e81502d4aa27ba48$var$rubble(g, rng, T, gx - 2, gx + span + 2, gy - 2, gy + th + 2, Math.max(4, span >> 1));
        } else {
            const gy = y + $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, h - span - 2));
            const gx = side === 2 ? x : x + w - th;
            g.r(gx, gy, th, span, T.ground2);
            $e81502d4aa27ba48$var$rubble(g, rng, T, gx - 2, gx + th + 2, gy - 2, gy + span + 2, Math.max(4, span >> 1));
        }
    }
}
/**
 * A glasshouse span: a long shallow roof of glazing, ridged down its spine,
 * with panes missing. The gaps show the growth underneath, which is the thing
 * that makes it read as a greenhouse rather than as a shed — the region's whole
 * story is that the glass failed and the planting did not.
 */ function $e81502d4aa27ba48$var$glassSpan(g, rng, T, x, y, w, h) {
    $e81502d4aa27ba48$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    const vert = h > w;
    const ridge = vert ? x + (w >> 1) : y + (h >> 1);
    if (vert) {
        g.r(ridge, y, 2, h, T.massLight);
        g.r(ridge + 2, y, 1, h, T.massDark);
    } else {
        g.r(x, ridge, w, 2, T.massLight);
        g.r(x, ridge + 2, w, 1, T.massDark);
    }
    g.a(0.4, ()=>{
        if (vert) for(let d = 5; d < h - 2; d += 5)g.r(x + 1, y + d, w - 2, 1, T.massDark);
        else for(let d = 5; d < w - 2; d += 5)g.r(x + d, y + 1, 1, h - 2, T.massDark);
    });
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 2, 5); i < n; i++){
        const pw = $e81502d4aa27ba48$var$ri(rng, 4, 9), ph = $e81502d4aa27ba48$var$ri(rng, 4, 9);
        const px = $e81502d4aa27ba48$var$ri(rng, x + 1, Math.max(x + 1, x + w - pw - 1));
        const py = $e81502d4aa27ba48$var$ri(rng, y + 1, Math.max(y + 1, y + h - ph - 1));
        g.r(px, py, pw, ph, T.veg1);
        g.a(0.5, ()=>g.r(px, py, pw, 1, T.veg2));
    }
}
/** A grid of irrigation pipe over what used to be beds. */ function $e81502d4aa27ba48$var$irrigationLattice(g, rng, T, x, y, w, h) {
    for(let d = 0; d < h; d += 9)$e81502d4aa27ba48$var$pipeRun(g, T, x, y + d, w, false, 3, 0);
    $e81502d4aa27ba48$var$pipeRun(g, T, x, y, h, true, 4, 0); // the header main they all feed off
    g.a(0.4, ()=>{
        for(let d = 6; d < w; d += 12)g.r(x + d, y, 1, h, T.structDark);
    });
}
/** A storage silo: tall, round, with a conical cap and a feed chute. */ function $e81502d4aa27ba48$var$silo(g, rng, T, cx, cy, r) {
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a * 0.8, ()=>$e81502d4aa27ba48$var$disc(g, cx + $e81502d4aa27ba48$var$SHADOW.dx * 2, cy + $e81502d4aa27ba48$var$SHADOW.dy * 2, r, T.far)));
    $e81502d4aa27ba48$var$disc(g, cx, cy, r, T.mass);
    $e81502d4aa27ba48$var$ringO(g, cx, cy, r, T.massDark);
    g.a(0.5, ()=>$e81502d4aa27ba48$var$disc(g, cx - 2, cy - 2, Math.max(2, r - 5), T.massLight)); // sheen off the cap
    $e81502d4aa27ba48$var$disc(g, cx, cy, Math.max(2, r >> 2), T.massDark); // the cap vent
    const a = rng() * Math.PI * 2; // feed chute off one side
    $e81502d4aa27ba48$var$pipeRun(g, T, Math.round(cx + Math.cos(a) * r), Math.round(cy + Math.sin(a) * r), $e81502d4aa27ba48$var$ri(rng, 9, 18), Math.abs(Math.sin(a)) > 0.5, 4, 0);
}
/** Mooring bollards, set in a row back from the water. */ function $e81502d4aa27ba48$var$bollardRow(g, rng, T, x, y, len, vert) {
    for(let d = 0; d < len; d += 12){
        const bx = vert ? x : x + d, by = vert ? y + d : y;
        $e81502d4aa27ba48$var$discShadow(g, T, bx, by, 3);
        $e81502d4aa27ba48$var$disc(g, bx, by, 3, T.metal);
        $e81502d4aa27ba48$var$ringO(g, bx, by, 3, T.structDark);
        g.r(bx - 1, by - 1, 2, 2, T.rust);
    }
}
/** A gantry crane straddling a bay: two leg pads and a lattice beam between. */ function $e81502d4aa27ba48$var$gantry(g, rng, T, x, y, len, vert) {
    const th = 7;
    $e81502d4aa27ba48$var$castShadow(()=>g.a($e81502d4aa27ba48$var$SHADOW.a * 0.7, ()=>g.r(x + $e81502d4aa27ba48$var$SHADOW.dx * 2, y + $e81502d4aa27ba48$var$SHADOW.dy * 2, vert ? th : len, vert ? len : th, T.far)));
    $e81502d4aa27ba48$var$pipeRun(g, T, x, y, len, vert, th, 0, 'mass');
    g.a(0.5, ()=>{
        for(let d = 2; d < len - 2; d += 4)if (vert) g.r(x + 1, y + d, th - 2, 1, T.massDark);
        else g.r(x + d, y + 1, 1, th - 2, T.massDark);
    });
    for (const end of [
        0,
        len - 8
    ]){
        const px = vert ? x - 3 : x + end, py = vert ? y + end : y - 3;
        g.r(px, py, vert ? th + 6 : 8, vert ? 8 : th + 6, T.metal);
        g.r(px, py, vert ? th + 6 : 8, 1, T.structLight);
    }
}
/** A conveyor run: a belt on trestles, seized where it stopped. */ function $e81502d4aa27ba48$var$conveyorRun(g, rng, T, x, y, len, vert) {
    $e81502d4aa27ba48$var$pipeRun(g, T, x, y, len, vert, 9, 15, 'metal');
    g.a(0.5, ()=>{
        if (vert) g.r(x + 2, y, 5, len, T.structDark);
        else g.r(x, y + 2, len, 5, T.structDark);
    });
    for(let d = 8; d < len; d += 8){
        if (rng() < 0.5) continue;
        const sx = vert ? x + (rng() < 0.5 ? -3 : 9) : x + d;
        const sy = vert ? y + d : y + (rng() < 0.5 ? -3 : 9);
        g.r(sx, sy, 3, 3, T.rust);
    }
}
/** A bunded tank farm: two or three tanks inside a spill wall. */ function $e81502d4aa27ba48$var$tankFarm(g, rng, T, x, y, w, h) {
    g.a(0.5, ()=>g.r(x, y, w, h, T.structDark)); // the bund floor
    g.r(x, y, w, 2, T.mass);
    g.r(x, y + h - 2, w, 2, T.mass);
    g.r(x, y, 2, h, T.mass);
    g.r(x + w - 2, y, 2, h, T.mass);
    const r = Math.max(6, Math.min(w, h) >> 2);
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 2, 3); i < n; i++)$e81502d4aa27ba48$var$tankTop(g, rng, T, $e81502d4aa27ba48$var$ri(rng, x + r + 3, Math.max(x + r + 3, x + w - r - 3)), $e81502d4aa27ba48$var$ri(rng, y + r + 3, Math.max(y + r + 3, y + h - r - 3)), r);
}
/**
 * A structural pillar in a sublevel hall, seen from above: a squat column with
 * a flared capital and a pool of shadow under it. Laid in colonnades on a world
 * lattice — a row of these marching off the edge of the tile and picked up by
 * the neighbour is the single strongest cue that the ceiling is overhead.
 */ function $e81502d4aa27ba48$var$pillarSquat(g, rng, T, cx, cy, r) {
    $e81502d4aa27ba48$var$discShadow(g, T, cx, cy, r + 2);
    $e81502d4aa27ba48$var$disc(g, cx, cy, r, T.massDark); // the flared capital
    $e81502d4aa27ba48$var$disc(g, cx, cy, Math.max(2, r - 2), T.mass);
    g.a(0.5, ()=>$e81502d4aa27ba48$var$disc(g, cx - 1, cy - 1, Math.max(1, r - 4), T.massLight));
    $e81502d4aa27ba48$var$ringO(g, cx, cy, r, T.structDark);
}
/**
 * Ballast, sleepers and two rails, laid down the tile like a minor road.
 *
 * A railway is a ROUTE, so it is drawn as one: it enters at the north edge and
 * leaves at the south, and both crossings come from edgeOffset — the same
 * function the roads use, so the two tiles either side of a join derive the
 * same crossing and the line meets itself exactly. It was a scattered prop
 * before, which gave the map short lengths of track starting and stopping in
 * the middle of nowhere.
 */ const $e81502d4aa27ba48$var$RAIL_TH = 21;
function $e81502d4aa27ba48$var$railBed(g, rng, T, row, col) {
    const th = $e81502d4aa27ba48$var$RAIL_TH;
    // where the line crosses this tile's north and south edges
    const top = $e81502d4aa27ba48$export$9e15ff8aa6bc996f / 2 + $e81502d4aa27ba48$export$cfdc75f9711ba396(row, col, 'n', th);
    const bot = $e81502d4aa27ba48$export$9e15ff8aa6bc996f / 2 + $e81502d4aa27ba48$export$cfdc75f9711ba396(row, col, 's', th);
    for(let y = 0; y < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; y++){
        const t = y / ($e81502d4aa27ba48$export$9e15ff8aa6bc996f - 1);
        const s = t * t * (3 - 2 * t); // ease between the two crossings
        const cx = Math.round(top + (bot - top) * s);
        const x = cx - (th >> 1);
        g.r(x, y, th, 1, T.ground2); // the ballast shoulder
        if (y % 6 < 3) g.r(x + 2, y, th - 4, 1, T.structDark); // sleepers
        for (const off of [
            6,
            th - 8
        ]){
            g.r(x + off, y, 2, 1, T.metal);
            g.r(x + off, y, 1, 1, T.structLight);
        }
    }
}
/** A tray of cable running along a wall line, lids long gone. */ function $e81502d4aa27ba48$var$cableTray(g, rng, T, x, y, len, vert) {
    $e81502d4aa27ba48$var$pipeRun(g, T, x, y, len, vert, 6, 0, 'structDark');
    g.a(0.6, ()=>{
        if (vert) g.r(x + 1, y, 4, len, T.metal);
        else g.r(x, y + 1, len, 4, T.metal);
    });
    for(let d = 4; d < len; d += 9)if (vert) g.r(x - 2, y + d, 10, 1, T.structDark);
    else g.r(x + d, y - 2, 1, 10, T.structDark);
}
const $e81502d4aa27ba48$export$ecbd1adefe7cd5ab = {
    // Two monumental silhouettes, one solid and one hollow. Both are read from
    // their PLAN, which is the only thing a top-down camera can show — the two
    // props cut from here failed on exactly that point (a skybridge deck and a
    // sign gantry are both defined by a face, and a face seen from overhead is a
    // bar). A shape that could be anything is worse than no shape: it reads as a
    // rendering fault rather than as architecture.
    city (g, rng, T, tune, ctx) {
        const drew = [];
        // Towers only where the district is genuinely built up — a tower on an
        // outskirt is what made the old map read as one uniform city.
        if ((ctx.built == null || ctx.built >= 0.8) && $e81502d4aa27ba48$var$sigRoll(rng, 0.34, tune, ctx.built)) {
            const w = $e81502d4aa27ba48$var$ri(rng, 27, 42), h = $e81502d4aa27ba48$var$ri(rng, 27, 42);
            // The debris skirt spills SKIRT units past the tower on every side, so the
            // spot is cleared at that size and the tower is drawn inset into it.
            // Clearing only the tower's own box let the rubble land in a sinkhole next
            // door — which the shared "nothing hangs in the hole" test caught.
            const SKIRT = 6;
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, w + SKIRT * 2, h + SKIRT * 2);
            if (b) {
                $e81502d4aa27ba48$var$towerCore(g, rng, T, b.x0 + SKIRT, b.y0 + SKIRT, w, h);
                drew.push(b);
            }
        } else if ((ctx.built == null || ctx.built >= 0.6) && $e81502d4aa27ba48$var$sigRoll(rng, 0.26, tune, ctx.built)) {
            // ...and where a tower did not go up, the block that ran round a yard.
            // Deliberately in the tower's `else`: two monuments on one tile is a
            // skyline, not a street. Gated on density too, if more loosely — a civic
            // range needs a city round it as much as a tower does, just less of one.
            const w = $e81502d4aa27ba48$var$ri(rng, 45, 63), h = $e81502d4aa27ba48$var$ri(rng, 45, 63);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, w + 4, h + 4);
            if (b) {
                $e81502d4aa27ba48$var$civicBlock(g, rng, T, b.x0 + 2, b.y0 + 2, w, h);
                drew.push(b);
            }
        }
        return drew;
    },
    greenhouse (g, rng, T, tune, ctx) {
        const drew = [];
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.28, tune, ctx.built)) {
            const vert = rng() < 0.5;
            const w = vert ? $e81502d4aa27ba48$var$ri(rng, 18, 27) : $e81502d4aa27ba48$var$ri(rng, 42, 66);
            const h = vert ? $e81502d4aa27ba48$var$ri(rng, 42, 66) : $e81502d4aa27ba48$var$ri(rng, 18, 27);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, w, h);
            if (b) {
                $e81502d4aa27ba48$var$glassSpan(g, rng, T, b.x0, b.y0, w, h);
                drew.push(b);
            }
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.20, tune, ctx.built)) {
            const w = $e81502d4aa27ba48$var$ri(rng, 30, 48), h = $e81502d4aa27ba48$var$ri(rng, 21, 33);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, w, h);
            if (b) {
                $e81502d4aa27ba48$var$irrigationLattice(g, rng, T, b.x0, b.y0, w, h);
                drew.push(b);
            }
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.12, tune, ctx.built)) {
            const r = $e81502d4aa27ba48$var$ri(rng, 9, 14);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, r * 2, r * 2);
            if (b) {
                $e81502d4aa27ba48$var$silo(g, rng, T, b.x0 + r, b.y0 + r, r);
                drew.push(b);
            }
        }
        return drew;
    },
    // The sea wall is NOT here. It belongs to the tide pass (drawSeaWall), because
    // a coast defence and the coast have to be two readings of one field or they
    // disagree — which is exactly what happened while this layer owned it: the
    // wall was laid on a world lattice that knew nothing about the water, so it
    // wandered in and out of the sea on the shore row and, worse, went on being
    // laid two rows inland where there was no water at all. Walls across dry
    // districts were the single loudest wrong note in the region.
    harbor (g, rng, T, tune, ctx) {
        const drew = [];
        // Bollards, though, ARE dockside furniture rather than coast defence, and
        // they read as a quay wherever the water reaches.
        if (ctx.shore === 0) {
            const y = ctx.shoreSide === 's' ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$WATERLINE + 16 : $e81502d4aa27ba48$var$WATERLINE + 4;
            $e81502d4aa27ba48$var$bollardRow(g, rng, T, 8, y, $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 8, false);
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.2, tune, ctx.built)) {
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, 30, 30);
            if (b) {
                for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 2, 4); i < n; i++)$e81502d4aa27ba48$var$containerBox(g, rng, T, b.x0 + $e81502d4aa27ba48$var$ri(rng, 0, 15), b.y0 + $e81502d4aa27ba48$var$ri(rng, 0, 3) * 9, rng() < 0.5);
                drew.push(b);
            }
        }
        return drew;
    },
    foundry (g, rng, T, tune, ctx) {
        const drew = [];
        for (const f of $e81502d4aa27ba48$var$worldFeaturesNear(ctx.col, ctx.row, 140, 23, 0.09 * (tune.signature ?? 1))){
            $e81502d4aa27ba48$var$conveyorRun(g, rng, T, f.x, f.y, f.len, f.vert);
            drew.push({
                x0: f.x,
                y0: f.y,
                x1: f.x + (f.vert ? 9 : f.len),
                y1: f.y + (f.vert ? f.len : 9)
            });
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.22, tune, ctx.built)) {
            const vert = rng() < 0.5, len = $e81502d4aa27ba48$var$ri(rng, 42, 72);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, vert ? 13 : len, vert ? len : 13);
            if (b) {
                $e81502d4aa27ba48$var$gantry(g, rng, T, b.x0 + 3, b.y0 + 3, len, vert);
                drew.push(b);
            }
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.13, tune, ctx.built)) {
            const w = $e81502d4aa27ba48$var$ri(rng, 39, 54), h = $e81502d4aa27ba48$var$ri(rng, 33, 45);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, w, h);
            if (b) {
                $e81502d4aa27ba48$var$tankFarm(g, rng, T, b.x0, b.y0, w, h);
                drew.push(b);
            }
        }
        return drew;
    },
    underground (g, rng, T, tune, ctx) {
        const drew = [];
        // The line first, so the pillars and everything after it keep off the track.
        if (ctx.rail) {
            $e81502d4aa27ba48$var$railBed(g, rng, T, ctx.row, ctx.col);
            const c = $e81502d4aa27ba48$export$9e15ff8aa6bc996f / 2 + $e81502d4aa27ba48$export$cfdc75f9711ba396(ctx.row, ctx.col, 'n', $e81502d4aa27ba48$var$RAIL_TH);
            const d = $e81502d4aa27ba48$export$9e15ff8aa6bc996f / 2 + $e81502d4aa27ba48$export$cfdc75f9711ba396(ctx.row, ctx.col, 's', $e81502d4aa27ba48$var$RAIL_TH);
            drew.push({
                x0: Math.min(c, d) - $e81502d4aa27ba48$var$RAIL_TH,
                y0: 0,
                x1: Math.max(c, d) + $e81502d4aa27ba48$var$RAIL_TH,
                y1: $e81502d4aa27ba48$export$9e15ff8aa6bc996f
            });
        }
        // The colonnade is not rolled for — a sublevel hall always has its pillars,
        // and it is their rhythm across tiles that says there is a ceiling on this.
        //
        // The pitch is wide. It was half this, which put roughly a dozen pillars on
        // every tile and read as a car park rather than as a hall — and it was doing
        // work the rock masses in the corners already do, since a hall with its
        // walls coming in needs fewer columns, not more.
        const pitch = 55, r = 7;
        const ox = (ctx.col * $e81502d4aa27ba48$export$9e15ff8aa6bc996f % pitch + pitch) % pitch;
        const oy = (ctx.row * $e81502d4aa27ba48$export$9e15ff8aa6bc996f % pitch + pitch) % pitch;
        for(let py = -oy; py < $e81502d4aa27ba48$export$9e15ff8aa6bc996f + pitch; py += pitch)for(let px = -ox; px < $e81502d4aa27ba48$export$9e15ff8aa6bc996f + pitch; px += pitch){
            const cx = px + (pitch >> 1), cy = py + (pitch >> 1);
            if (cx < -r || cy < -r || cx > $e81502d4aa27ba48$export$9e15ff8aa6bc996f + r || cy > $e81502d4aa27ba48$export$9e15ff8aa6bc996f + r) continue;
            const b = {
                x0: cx - r,
                y0: cy - r,
                x1: cx + r,
                y1: cy + r
            };
            // `drew` as well as ctx.keep: the rail bed went down a moment ago and a
            // pillar standing in the four-foot is the same mistake as one standing
            // in the roadway.
            const hits = (k)=>b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0;
            if (ctx.keep.some(hits) || drew.some(hits)) continue;
            if (ctx.samples?.length && $e81502d4aa27ba48$var$runsThrough(ctx.samples, b)) continue;
            $e81502d4aa27ba48$var$pillarSquat(g, rng, T, cx, cy, r);
            drew.push(b);
        }
        if ($e81502d4aa27ba48$var$sigRoll(rng, 0.22, tune, ctx.built)) {
            const vert = rng() < 0.5, len = $e81502d4aa27ba48$var$ri(rng, 42, 78);
            const b = $e81502d4aa27ba48$var$sigSpot(rng, ctx, vert ? 10 : len, vert ? len : 10);
            if (b) {
                $e81502d4aa27ba48$var$cableTray(g, rng, T, b.x0 + 2, b.y0 + 2, len, vert);
                drew.push(b);
            }
        }
        return drew;
    }
};
// Small standing-water lakes: 2-3 overlapping lobes each give irregular
// shapes, drawn like the water tile — bank ring, opaque water, sparkle
// glints — just smaller. All banks across every lake are laid down before
// any water, so one lake's shore never cuts across another's surface where
// they overlap; touching lakes merge into a single larger body.
function $e81502d4aa27ba48$var$drawLakes(g, rng, T, count) {
    const lobes = [];
    for(let i = 0; i < count; i++){
        const cx = $e81502d4aa27ba48$var$ri(rng, 21, 96), cy = $e81502d4aa27ba48$var$ri(rng, 21, 96);
        for(let j = 0, m = $e81502d4aa27ba48$var$ri(rng, 2, 3); j < m; j++)lobes.push([
            cx + $e81502d4aa27ba48$var$ri(rng, -9, 9),
            cy + $e81502d4aa27ba48$var$ri(rng, -9, 9),
            $e81502d4aa27ba48$var$ri(rng, 6, 12)
        ]);
    }
    for (const [x, y, r] of lobes)$e81502d4aa27ba48$var$disc(g, x, y, r + 3, T.ground2); // all banks first
    for (const [x, y, r] of lobes)$e81502d4aa27ba48$var$disc(g, x, y, r, T.water1); // then all water
    for (const [x, y, r] of lobes)if (rng() < 0.8) g.r(x - (r >> 1) + $e81502d4aa27ba48$var$ri(rng, 0, r), y + $e81502d4aa27ba48$var$ri(rng, -3, 3), $e81502d4aa27ba48$var$ri(rng, 4, 7), 1, T.water2); // glints
}
// ---- the tide ----
// Where the water is, on a region the sea got into. The old flood pass dropped
// one to three lakes on every tile, which read as polka dots: uniformly damp,
// with no sense that the water had come from anywhere. This one grades inland
// from an ocean along one edge of the map, so the same region reads drowned at
// the shore, tidal a row in, and dry at the far side.
//
// Two rules make it work across tile joins without any tile knowing what its
// neighbour drew:
//
//   1. Depth is measured in WORLD units from the ocean edge, not in rows. The
//      shore row's far edge is 119 and the next row's near edge is 120, so the
//      waterline is continuous across a horizontal seam. Measuring per row would
//      put a step at every join.
//   2. The wobble that makes the waterline ragged is sampled on world X, so two
//      tiles either side of a vertical seam compute the identical value there.
//
// WATERLINE is half a tile on purpose. The shore row has to stay walkable — a
// row of impassable water would be a balance change, and this is meant to be
// nothing but a change of scenery — so the sea takes the outer half of those
// tiles and stops.
//
// The line itself is the SEA WALL, not a noise contour. A ragged natural
// waterline with a wall drawn on top of it read as neither: the wall wandered
// in and out of the water instead of holding it. So the wall is straight, it
// defines where the sea stops, and it has BREACHES — and the breaches are the
// point. They say why this district drowned, they give the water a way in, and
// every inland flood traces back through one of them. A sea defence that failed
// somewhere is a story; a sea defence with water on both sides is a mistake.
// How far inland the wall — and so the sea — reaches. Set so the wall clears
// the roadway rather than being cut in half by it: an east-west road runs down
// the tile's mid-line and is ROAD_W wide, so it occupies 45..75, and the wall
// has to finish before that. The coast road then runs just INSIDE the defence,
// which is where a coast road goes.
const $e81502d4aa27ba48$var$WATERLINE = 45;
const $e81502d4aa27ba48$var$WALL_TH = 9; // the wall's own thickness
const $e81502d4aa27ba48$var$BREACH_CELL = 190; // one gap per this much wall
const $e81502d4aa27ba48$var$BREACH_HALF_MIN = 16; // ...of this half-width
const $e81502d4aa27ba48$var$BREACH_HALF_MAX = 27;
const $e81502d4aa27ba48$var$BREACH_SHOULDER = 14; // how quickly a gap opens to full width
const $e81502d4aa27ba48$var$SPILL = 130; // how far inland the widest breach reaches
const $e81502d4aa27ba48$var$REACH = 330; // how far inland standing water is found at all
// The low-ground field does NOT start at the wall. On the shore row the only
// water past the wall should be what came through a gap — that is what makes
// the breaches read as the cause rather than as decoration, and it is what
// keeps the landward half of the row looking like land.
const $e81502d4aa27ba48$var$LOW_START = 85;
const $e81502d4aa27ba48$var$TIDE_STEP = 3; // sampling resolution, in authoring units
function $e81502d4aa27ba48$export$16356d731e5dcef3(wx) {
    const c = Math.floor(wx / $e81502d4aa27ba48$var$BREACH_CELL);
    let open = 0;
    // the neighbouring cells too, so a gap sitting near a cell edge is not clipped
    for(let i = c - 1; i <= c + 1; i++){
        const mid = (i + 0.25 + 0.5 * $e81502d4aa27ba48$var$noiseHash(i * 7 + 3, 91)) * $e81502d4aa27ba48$var$BREACH_CELL;
        const half = $e81502d4aa27ba48$var$BREACH_HALF_MIN + ($e81502d4aa27ba48$var$BREACH_HALF_MAX - $e81502d4aa27ba48$var$BREACH_HALF_MIN) * $e81502d4aa27ba48$var$noiseHash(i * 11, 57);
        const d = Math.abs(wx - mid);
        if (d < half) open = Math.max(open, Math.min(1, (half - d) / $e81502d4aa27ba48$var$BREACH_SHOULDER));
    }
    return open;
}
/**
 * The SEA: everything seaward of the wall, plus what is coming through the gaps
 * in it. Above zero is water.
 *
 * Kept apart from the standing water below because they are drawn differently —
 * the sea and its spill are deep water, the pools left behind inland are not,
 * and telling them apart is the difference between "the coast got in here" and
 * "this street holds a puddle". A single depth threshold could not say it: the
 * far end of a spill fan is shallow and still sea.
 */ function $e81502d4aa27ba48$var$tideSea(wx, depthIn, level) {
    const wall = $e81502d4aa27ba48$var$WATERLINE * level;
    if (depthIn < wall) return 1 - 0.4 * (depthIn / Math.max(1, wall)); // open sea
    const open = $e81502d4aa27ba48$export$16356d731e5dcef3(wx);
    const past = depthIn - wall;
    // Through a breach: a fan of water spreading inland from the gap, narrowing
    // as it goes. This is the ONLY thing that connects the inland water to the
    // sea, so it is deliberately generous near the wall.
    // A SUBTRACTIVE taper, not a multiplicative one. Scaling the gap's width by
    // distance keeps every gap wet for the whole spill length, just fainter, so
    // the wetted area behind the wall is the gap's full width all the way in.
    // Subtracting distance instead means only the wider gaps reach far, and the
    // wet patch narrows to a point — which is what water coming through a hole
    // and spreading out actually looks like from above.
    const fan = open > 0 ? open - past / ($e81502d4aa27ba48$var$SPILL * level) : -1;
    // Smoothstep the fan. A linear taper meets the ground along a straight line,
    // which was half of why the flood used to have corners.
    return fan > 0 ? fan * fan * (3 - 2 * Math.min(1, fan)) : fan;
}
/**
 * The STANDING WATER: what the sea left behind once it was through the wall.
 *
 * One continuous field rather than scattered pools, and biased toward the gaps —
 * `breachAt` widens it wherever a breach is upstream, so the inland water joins
 * up with the fan that fed it instead of sitting in the map as an archipelago
 * nothing explains.
 */ function $e81502d4aa27ba48$var$tideStanding(wx, depthIn, level, roadBias) {
    const past = depthIn - $e81502d4aa27ba48$var$WATERLINE * level;
    if (past < 0) return -1;
    // How far the water got is a property of the GROUND, so it varies along the
    // coast. Holding it at a constant depth put the inland edge of the flood on a
    // ruler-straight line right across the map — the one thing that says "field
    // evaluated against a threshold" rather than "water found the low ground".
    // Both ends wander, so neither edge is a horizon.
    const drift = $e81502d4aa27ba48$var$smoothNoise(wx / 260 + 51.3, 9.1);
    const reach = $e81502d4aa27ba48$var$REACH * (0.45 + 1.1 * drift) * level;
    const start = $e81502d4aa27ba48$var$LOW_START * (0.6 + 0.8 * $e81502d4aa27ba48$var$smoothNoise(wx / 180 + 7.7, 33.3));
    const inland = (past - start) / Math.max(1, reach);
    if (inland < 0 || inland > 1) return -1;
    // Almost all of the shape comes from ONE coarse octave, smoothstepped, so
    // the body is round and the edges curve. The fine octave that used to carry
    // a fifth of the weight was what gave the flood its crimped, angular outline
    // — detail at that scale reads as noise rather than as a shoreline.
    const n = $e81502d4aa27ba48$var$smoothNoise(wx / 150 + 31.7, depthIn / 150 + 5.1);
    const body = n * n * (3 - 2 * n);
    const fine = $e81502d4aa27ba48$var$smoothNoise(wx / 62 + 3.3, depthIn / 62 + 17.9);
    return body * 0.9 + fine * 0.1 + roadBias + 0.22 * $e81502d4aa27ba48$export$16356d731e5dcef3(wx) - (0.46 + 0.42 * inland);
}
function $e81502d4aa27ba48$export$98b4df498e934cf(shore, shoreSide, level) {
    if (shore !== 0) return null;
    const wall = $e81502d4aa27ba48$var$WATERLINE * level;
    const y0 = shoreSide === 's' ? $e81502d4aa27ba48$export$9e15ff8aa6bc996f - wall : wall - $e81502d4aa27ba48$var$WALL_TH;
    return y0 < 0 || y0 + $e81502d4aa27ba48$var$WALL_TH > $e81502d4aa27ba48$export$9e15ff8aa6bc996f ? null : Math.round(y0);
}
function $e81502d4aa27ba48$var$drawSeaWall(g, T, ctx, level, side) {
    const y0 = $e81502d4aa27ba48$export$98b4df498e934cf(ctx.shore, side, level);
    if (y0 == null) return;
    const wx0 = ctx.col * $e81502d4aa27ba48$export$9e15ff8aa6bc996f;
    const y = Math.round(y0);
    let runX = -1;
    const flush = (x1)=>{
        if (runX < 0) return;
        const w = x1 - runX;
        g.r(runX, y, w, $e81502d4aa27ba48$var$WALL_TH, T.mass);
        g.r(runX, y, w, 1, T.massLight); // lit crown
        g.r(runX, y + $e81502d4aa27ba48$var$WALL_TH - 1, w, 1, T.massDark);
        for(let d = 7; d < w; d += 15)if (side === 'n') g.r(runX + d, y + $e81502d4aa27ba48$var$WALL_TH, 5, 5, T.mass);
        else g.r(runX + d, y - 5, 5, 5, T.mass);
        g.a(0.45, ()=>{
            for(let d = 2; d < w; d += 5)g.r(runX + d, side === 'n' ? y : y + $e81502d4aa27ba48$var$WALL_TH - 2, 2, 2, T.rust);
        });
        runX = -1;
    };
    for(let x = 0; x < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; x += $e81502d4aa27ba48$var$TIDE_STEP){
        if ($e81502d4aa27ba48$export$16356d731e5dcef3(wx0 + x) > 0) {
            flush(x);
            continue;
        } // the gap
        if (runX < 0) runX = x;
    }
    flush($e81502d4aa27ba48$export$9e15ff8aa6bc996f);
    // Rubble where it failed — the ends of the standing sections, spilling into
    // the gap. Without this a breach reads as a wall that was built with a hole.
    let prev = false;
    for(let x = 0; x < $e81502d4aa27ba48$export$9e15ff8aa6bc996f; x += $e81502d4aa27ba48$var$TIDE_STEP){
        const open = $e81502d4aa27ba48$export$16356d731e5dcef3(wx0 + x) > 0;
        if (open !== prev) for(let i = 0; i < 4; i++)g.r(x + $e81502d4aa27ba48$var$ri3(x + i * 7) - 6, y + $e81502d4aa27ba48$var$ri3(x + i * 3) - 3, 3, 2, T.massDark);
        prev = open;
    }
}
/** A tiny deterministic 0..8 jitter off a world coordinate. */ const $e81502d4aa27ba48$var$ri3 = (n)=>Math.floor($e81502d4aa27ba48$var$noiseHash(n | 0, 977) * 9);
function $e81502d4aa27ba48$var$drawTide(g, rng, T, ctx) {
    const level = Math.max(0.01, ctx.floodLevel ?? 1);
    const side = ctx.shoreSide === 's' ? 's' : 'n';
    const wx0 = ctx.col * $e81502d4aa27ba48$export$9e15ff8aa6bc996f;
    // Streets flood first: they are the low ground, and a drowned district reads
    // as one the moment the carriageway goes under while the lots are still dry.
    // The roadway is rasterised once into a coarse mask so the per-cell test is a
    // lookup — testing every sample against every road sample is not affordable.
    const N = Math.ceil($e81502d4aa27ba48$export$9e15ff8aa6bc996f / $e81502d4aa27ba48$var$TIDE_STEP);
    let roadMask = null;
    if (ctx.samples?.length) {
        roadMask = new Uint8Array(N * N);
        for (const s of ctx.samples){
            const x0 = Math.max(0, (s.x - s.hx) / $e81502d4aa27ba48$var$TIDE_STEP | 0), x1 = Math.min(N - 1, (s.x + s.hx) / $e81502d4aa27ba48$var$TIDE_STEP | 0);
            const y0 = Math.max(0, (s.y - s.hy) / $e81502d4aa27ba48$var$TIDE_STEP | 0), y1 = Math.min(N - 1, (s.y + s.hy) / $e81502d4aa27ba48$var$TIDE_STEP | 0);
            for(let yy = y0; yy <= y1; yy++)for(let xx = x0; xx <= x1; xx++)roadMask[yy * N + xx] = 1;
        }
    }
    // Structures stand OUT of the water — the recipe's and the region's own both.
    const standing = [
        ...ctx.keep || [],
        ...ctx.props || []
    ];
    const blocked = (x, y)=>standing.some((b)=>x >= b.x0 && x <= b.x1 && y >= b.y0 && y <= b.y1);
    // The wall went down with the ground, so the water stops at its face rather
    // than washing over the top of it — otherwise the defence disappears under
    // the very sea it is holding back.
    const wallTop = $e81502d4aa27ba48$export$98b4df498e934cf(ctx.shore, side, level);
    const onWall = (y)=>wallTop != null && y + $e81502d4aa27ba48$var$TIDE_STEP > wallTop && y < wallTop + $e81502d4aa27ba48$var$WALL_TH;
    // Two lists. The distinction is WHAT the water is first and how deep it is
    // second: standing water left inland is always the light tone, while the sea
    // and its inflows are deep in the body and light around their margins — the
    // shelving edge where a breach spills onto the street. Splitting on depth
    // alone put the same contour through the standing water as through the sea;
    // ignoring depth entirely flattened the inflows into one hard shape.
    const SEA_SHALLOW = 0.35;
    const seaRuns = [], poolRuns = [];
    for(let iy = 0; iy < N; iy++){
        const y = iy * $e81502d4aa27ba48$var$TIDE_STEP;
        const depthIn = ctx.shore * $e81502d4aa27ba48$export$9e15ff8aa6bc996f + (side === 'n' ? y : $e81502d4aa27ba48$export$9e15ff8aa6bc996f - 1 - y);
        let runX = -1, runDeep = false;
        const flush = (x1)=>{
            if (runX >= 0) (runDeep ? seaRuns : poolRuns).push([
                runX,
                y,
                x1 - runX,
                $e81502d4aa27ba48$var$TIDE_STEP
            ]);
            runX = -1;
        };
        for(let ix = 0; ix < N; ix++){
            const x = ix * $e81502d4aa27ba48$var$TIDE_STEP, wx = wx0 + x;
            const sea = $e81502d4aa27ba48$var$tideSea(wx, depthIn, level);
            const pool = $e81502d4aa27ba48$var$tideStanding(wx, depthIn, level, roadMask?.[iy * N + ix] ? 0.12 : 0);
            // The wall stops the water only where the wall is actually THERE. Skipping
            // the whole band left a dry stripe straight through every breach — the sea
            // pouring in, then a gap, then the flood again — which is the one place
            // the water most needs to be continuous.
            const walled = onWall(y) && $e81502d4aa27ba48$export$16356d731e5dcef3(wx) <= 0;
            const wet = Math.max(sea, pool) > 0 && !walled && !blocked(x + 1, y + 1);
            if (!wet) {
                flush(x);
                continue;
            }
            // Deep only where the SEA is deep. Standing water never is, however much
            // of it there is — a flooded street is ankle deep whatever its extent.
            const deep = sea >= pool && sea > SEA_SHALLOW;
            if (runX >= 0 && deep !== runDeep) flush(x);
            if (runX < 0) {
                runX = x;
                runDeep = deep;
            }
        }
        flush($e81502d4aa27ba48$export$9e15ff8aa6bc996f);
    }
    for (const [x, y, w, h] of seaRuns)g.r(x, y, w, h, T.water1);
    g.a(0.55, ()=>{
        for (const [x, y, w, h] of poolRuns)g.r(x, y, w, h, T.water2);
    });
    // The line where the water meets the land, picked out along the top of every
    // run so a shelving beach reads as a shore rather than as a flat blue shape.
    g.a(0.5, ()=>{
        for (const [x, y, w] of poolRuns)g.r(x, y, w, 1, T.water2);
    });
    // What is floating in it. Seeded, unlike everything above — this is debris,
    // not terrain, and it only ever lands where the field already said water is.
    const wetRuns = seaRuns.concat(poolRuns);
    if (!wetRuns.length) return;
    for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 0, 3); i < n; i++){
        const [x, y, w] = wetRuns[$e81502d4aa27ba48$var$ri(rng, 0, wetRuns.length - 1)];
        if (w < 15) continue;
        if (rng() < 0.5) $e81502d4aa27ba48$var$containerBox(g, rng, T, x + $e81502d4aa27ba48$var$ri(rng, 0, w - 12), y, rng() < 0.5);
        else $e81502d4aa27ba48$var$rubbleChunk(g, rng, T, x + $e81502d4aa27ba48$var$ri(rng, 0, w - 6), y);
    }
}
// ---- the rock ----
// A sublevel drawn top-down has a problem no other region has: the one thing
// that makes it a sublevel — the ceiling — is the thing a top-down view cannot
// show. Left to the palette alone it came out as an open suburb at night, which
// is why it was the region furthest from its own description.
//
// So the walls come down instead. Rock mass laps into the tile from its corners
// and outer band, carved back around the room, the roadway and the structures,
// which reads as a hall whose roof has come in over the edges of the block. The
// same field grades the darkness: black where the rock is close, clear over the
// middle where the room is. One function, two jobs, and the second one is what
// makes the region legible again — the flat 0.35 wash it replaces took the
// centre of the tile as hard as it took the corners.
const $e81502d4aa27ba48$var$ROCK_STEP = 2; // sampling resolution: fine enough for a broken edge
const $e81502d4aa27ba48$var$ROAD_R = 26; // clearance kept around the roadway, so a route never seals
const $e81502d4aa27ba48$var$DARK_MIN = 0.12; // the darkness wash out in the open
const $e81502d4aa27ba48$var$DARK_MAX = 0.34; // ...and up against the rock
// A mass is anchored to a tile CORNER — that is, to a vertex of the grid, the
// point four tiles share. Each of those four draws the quarter of it that falls
// on its own canvas, so the mass is one shape spanning a junction rather than
// four shapes that have to be made to agree. Seamless by construction, corner-
// only by construction, and no carving needed to keep the routes open: a vertex
// is ROCK_KEEP away from the nearest ground a connection can cross, and no lobe
// is allowed to reach that far.
//
// This replaces a noise field clipped by a hard cross. That guaranteed the same
// things but looked it — the field's soft blobs came out with two straight sides
// wherever the clip bit, which read as black buildings rather than as stone. The
// shape has to be right in the first place, not corrected afterwards.
const $e81502d4aa27ba48$var$ROCK_DENSITY = 0.55; // share of grid vertices carrying a mass
const $e81502d4aa27ba48$var$ROCK_R_MIN = 12, $e81502d4aa27ba48$var$ROCK_R_MAX = 19;
const $e81502d4aa27ba48$var$ROCK_WOBBLE = 0.15; // how far the outline strays from a circle
const $e81502d4aa27ba48$var$ROCK_LOBES = 4; // satellites per mass, scattered round the vertex
const $e81502d4aa27ba48$var$ROCK_KEEP = 21; // nearest a connection comes to a vertex
// Where a connection can run, in the VERTEX's own frame: four rays leaving the
// corner along the tile edges, starting ROCK_KEEP out. Expressed from the
// vertex rather than from a tile because that is the frame a mass lives in —
// the same four rays whichever of the four tiles is asking, so every one of
// them fits a lobe identically.
const $e81502d4aa27ba48$var$CROSS_BANDS = [
    [
        $e81502d4aa27ba48$var$ROCK_KEEP,
        0,
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$ROCK_KEEP,
        0
    ],
    [
        -$e81502d4aa27ba48$var$ROCK_KEEP,
        0,
        -($e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$ROCK_KEEP),
        0
    ],
    [
        0,
        $e81502d4aa27ba48$var$ROCK_KEEP,
        0,
        $e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$ROCK_KEEP
    ],
    [
        0,
        -$e81502d4aa27ba48$var$ROCK_KEEP,
        0,
        -($e81502d4aa27ba48$export$9e15ff8aa6bc996f - $e81502d4aa27ba48$var$ROCK_KEEP)
    ]
];
// How far rock has to stay off a crossing. The bands above are LINES along the
// tile edges, but what has to stay clear is a strip: a carriageway occupies the
// last few pixels before the join, and a run of rock is filled ROCK_STEP wide
// from its last solid sample. Measuring to the line and allowing only the run
// overhang left rock a pixel inside the strip — which is one pixel of stone
// across a route, and the guard exists precisely so that cannot happen.
const $e81502d4aa27ba48$var$CROSS_CLEAR = $e81502d4aa27ba48$var$ROCK_STEP + 4;
function $e81502d4aa27ba48$var$distToSegment(px, py, [x0, y0, x1, y1]) {
    const dx = x1 - x0, dy = y1 - y0, len2 = dx * dx + dy * dy;
    const t = len2 ? Math.max(0, Math.min(1, ((px - x0) * dx + (py - y0) * dy) / len2)) : 0;
    return Math.hypot(px - (x0 + t * dx), py - (y0 + t * dy));
}
/**
 * The largest this lobe may be and still clear every crossing band.
 *
 * The guarantee is stated here, once, rather than being hand-computed into the
 * radius constants — which is how it got away twice: the main lobe sits on the
 * diagonal and the satellites do not, so each has a different worst case, and
 * an arithmetic margin that covered one missed the other by a pixel. Shrinking
 * rather than dropping keeps the mass where the map wanted one, and it is
 * deterministic, so all four tiles sharing the vertex shrink it identically.
 */ function $e81502d4aa27ba48$var$fitLobe(x, y, r) {
    let limit = Infinity;
    for (const band of $e81502d4aa27ba48$var$CROSS_BANDS)limit = Math.min(limit, $e81502d4aa27ba48$var$distToSegment(x, y, band));
    return Math.min(r, (limit - $e81502d4aa27ba48$var$CROSS_CLEAR) / (1 + $e81502d4aa27ba48$var$ROCK_WOBBLE));
}
function $e81502d4aa27ba48$export$aceae09a505d3fb5(col, row) {
    const out = [];
    for (const [vx, vy] of [
        [
            0,
            0
        ],
        [
            $e81502d4aa27ba48$export$9e15ff8aa6bc996f,
            0
        ],
        [
            0,
            $e81502d4aa27ba48$export$9e15ff8aa6bc996f
        ],
        [
            $e81502d4aa27ba48$export$9e15ff8aa6bc996f,
            $e81502d4aa27ba48$export$9e15ff8aa6bc996f
        ]
    ]){
        const gx = col + vx / $e81502d4aa27ba48$export$9e15ff8aa6bc996f, gy = row + vy / $e81502d4aa27ba48$export$9e15ff8aa6bc996f;
        if ($e81502d4aa27ba48$var$noiseHash(gx * 17 + 5, gy * 23 + 9) > $e81502d4aa27ba48$var$ROCK_DENSITY) continue;
        const seed = (0, $c1858b438f434f4d$export$c0b222505a3369f3)(`rock|${gx}|${gy}`);
        const r = $e81502d4aa27ba48$var$ROCK_R_MIN + ($e81502d4aa27ba48$var$ROCK_R_MAX - $e81502d4aa27ba48$var$ROCK_R_MIN) * seed();
        // Lobes are placed in the VERTEX's frame and then translated onto this
        // tile, so all four tiles round the corner derive one identical mass and
        // each simply draws the part that lands on its own canvas.
        //
        // They used to be offset toward whichever tile was asking, on the reasoning
        // that the diagonal is the direction furthest from every crossing. It is —
        // but it meant the four tiles each pulled a lobe into themselves, and the
        // union came out as a four-pointed clover on every junction, the same way
        // round every time. A mass has to be ONE shape, not four agreeing ones.
        const add = (lx, ly, rad)=>{
            const fitted = $e81502d4aa27ba48$var$fitLobe(lx, ly, rad);
            if (fitted <= 2) return;
            // How far this lobe can matter at all. Cached so the per-sample test can
            // reject on a box comparison before it reaches for a hypot and an atan2 —
            // a tile is thousands of samples against a score of lobes, and all but
            // two or three are nowhere near.
            //
            // TWICE the outline's reach, not once: the darkness gradient runs on the
            // same field and fades out over a lobe's width of floor BEYOND the stone,
            // so cutting at the outline would pull the vignette in tight around it.
            const fade = fitted * (1 + $e81502d4aa27ba48$var$ROCK_WOBBLE) * 2;
            out.push({
                x: vx + lx,
                y: vy + ly,
                r: fitted,
                fade: fade,
                wob: $e81502d4aa27ba48$var$wobbler(seed, 5, $e81502d4aa27ba48$var$ROCK_WOBBLE)
            });
        };
        add(0, 0, r);
        for(let i = 0; i < $e81502d4aa27ba48$var$ROCK_LOBES; i++){
            const a = seed() * Math.PI * 2;
            const d = 8 + 11 * seed();
            const sr = r * (0.45 + 0.4 * seed());
            add(Math.cos(a) * d, Math.sin(a) * d, sr);
        }
    }
    return out;
}
/**
 * How far INSIDE the rock a point is: above zero is stone, and the larger the
 * value the deeper. Wobbled per lobe, so the outline is an irregular closed
 * curve rather than a threshold on a grid.
 */ function $e81502d4aa27ba48$var$rockDepth(lobes, x, y) {
    let best = -1;
    for (const m of lobes){
        const dx = x - m.x, dy = y - m.y;
        // Outside the lobe's reach in either axis, it cannot contribute anything
        // above -1, and `best` already starts there. Two comparisons instead of a
        // hypot and an atan2; without it a hollow-core tile was spending millions
        // of transcendentals a frame on lobes at the far corner.
        if (dx > m.fade || dx < -m.fade || dy > m.fade || dy < -m.fade) continue;
        const d = Math.hypot(dx, dy);
        if (d > m.fade) continue;
        const t = Math.atan2(dy, dx) / (Math.PI * 2) + 0.5;
        const rr = m.r * m.wob(t);
        if (rr > 0) best = Math.max(best, 1 - d / rr);
    }
    return best;
}
// How far a mass throws its shadow, and how dark. LONG: a formation runs from
// the floor to the cavern roof, so it is taller than anything built down here
// by an order of magnitude and its shade reaches most of a tile. Scaled by the
// sun's elevation the way a real one is — shortest at noon, drawn right out
// when the shaft comes in low.
const $e81502d4aa27ba48$var$ROCK_SHADOW_LEN = 30;
const $e81502d4aa27ba48$var$ROCK_SHADOW_A = 0.5;
/**
 * The shade a rock mass throws when a daylight shaft is falling on it.
 *
 * Drawn on the overhead channel with the stone, so it lands over the shaft that
 * casts it — a shadow painted UNDER the light would be lit back up by it, which
 * is the one thing a shadow cannot survive.
 *
 * Direction comes from `sunShaft`, the same function that aims the beams, so
 * the shade always falls away from the light rather than in some fixed
 * direction that happens to look right at noon.
 */ // The offset is quantised before the shade is rasterised, so the sun has to
// move a noticeable amount before the work is redone — the same bargain
// staticKey strikes for the building shadows, and for the same reason.
const $e81502d4aa27ba48$var$ROCK_SHADOW_STEP = 3;
/**
 * Where the sun is throwing the shade of a set of upright things, or null if
 * they are throwing none.
 *
 * Nothing in a sublevel casts a shadow through the ordinary machinery: dayState
 * caps the light down here below the threshold at which it gives the sun a
 * direction, so SHADOW comes out as a zero offset and every drop shadow lands
 * exactly under the thing that cast it. That is right for a cavern lit by
 * nothing — and wrong the moment a shaft of daylight comes through the roof.
 *
 * @param {Array<{x,y}>} pts  where the uprights stand, for the light test
 * @param {number} baseLen    how far the shade reaches, before elevation
 */ function $e81502d4aa27ba48$var$shaftShadowPlan(fx, pts, baseLen) {
    if (!fx || !pts.length || !(fx.tune?.lightRays > 0)) return null;
    const { elev: elev, bx: bx, by: by, ux: ux, uy: uy } = $e81502d4aa27ba48$var$sunShaft(fx.anim);
    if (elev <= 0.03) return null; // night: no shaft, no shade
    const wells = $e81502d4aa27ba48$var$lightWellsNear(fx.col, fx.row, fx.tune.lightRays);
    if (!wells.length) return null;
    // How lit the uprights are. One figure for the whole group rather than one
    // per pixel: a well is one to two tiles across, so the light over a single
    // tile barely varies, and this is asked every frame.
    const ox = fx.col * $e81502d4aa27ba48$export$3d672f2aedd16af9, oy = fx.row * $e81502d4aa27ba48$export$3d672f2aedd16af9;
    const scale = $e81502d4aa27ba48$export$3d672f2aedd16af9 / $e81502d4aa27ba48$export$9e15ff8aa6bc996f; // authoring units -> world units
    let lit = 0;
    for (const p of pts){
        const px = ox + p.x * scale, py = oy + p.y * scale;
        for (const w of wells)lit = Math.max(lit, 1 - Math.hypot(px - w.x - bx, py - w.y - by) / w.r);
    }
    if (lit <= 0.05) return null;
    const len = baseLen * (0.8 + 0.9 * (1 - elev));
    const q = (v)=>Math.round(v * len / $e81502d4aa27ba48$var$ROCK_SHADOW_STEP) * $e81502d4aa27ba48$var$ROCK_SHADOW_STEP;
    return {
        dx: q(ux),
        dy: q(uy),
        lit: Math.min(1, lit)
    };
}
/**
 * The shade itself, as runs: everything within a lobe's radius of the SEGMENT
 * from where that lobe stands to where its shade falls.
 *
 * A segment, not a point. A shadow is the whole column projected, so it runs
 * from the foot of the stone out to the tip — drawing the offset shape alone
 * left a dark patch floating clear of the mass that threw it, with a gap of
 * lit floor between the two.
 */ function $e81502d4aa27ba48$var$rockShadowRuns(lobes, dx, dy) {
    const N = Math.ceil($e81502d4aa27ba48$export$9e15ff8aa6bc996f / $e81502d4aa27ba48$var$ROCK_STEP);
    const segs = [];
    for (const m of lobes){
        const x1 = m.x + dx, y1 = m.y + dy;
        // the swept capsule's bounds, for a cheap reject before the distance test
        const lo = {
            x: Math.min(m.x, x1) - m.r,
            y: Math.min(m.y, y1) - m.r
        };
        const hi = {
            x: Math.max(m.x, x1) + m.r,
            y: Math.max(m.y, y1) + m.r
        };
        if (hi.x < 0 || hi.y < 0 || lo.x > $e81502d4aa27ba48$export$9e15ff8aa6bc996f || lo.y > $e81502d4aa27ba48$export$9e15ff8aa6bc996f) continue;
        segs.push({
            seg: [
                m.x,
                m.y,
                x1,
                y1
            ],
            r: m.r,
            lo: lo,
            hi: hi
        });
    }
    const runs = [];
    if (!segs.length) return runs;
    for(let iy = 0; iy < N; iy++){
        const y = iy * $e81502d4aa27ba48$var$ROCK_STEP;
        let runX = -1;
        const flush = (x1)=>{
            if (runX >= 0) runs.push([
                runX,
                y,
                x1 - runX,
                $e81502d4aa27ba48$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(let ix = 0; ix < N; ix++){
            const x = ix * $e81502d4aa27ba48$var$ROCK_STEP;
            let hit = false;
            for (const s of segs){
                if (x < s.lo.x || x > s.hi.x || y < s.lo.y || y > s.hi.y) continue;
                if ($e81502d4aa27ba48$var$distToSegment(x, y, s.seg) <= s.r) {
                    hit = true;
                    break;
                }
            }
            if (!hit) {
                flush(x);
                continue;
            }
            if (runX < 0) runX = x;
        }
        flush($e81502d4aa27ba48$export$9e15ff8aa6bc996f);
    }
    return runs;
}
/**
 * A drawer for one mass's shade, with the rasterised runs cached against the
 * quantised sun offset.
 *
 * Cast from the LOBES, not from the stone this tile happened to rasterise. At
 * this length a shadow lands a good way from the mass that threw it — often in
 * a neighbouring tile — and each tile only ever rasterises the quarter of a
 * mass inside its own bounds. Offsetting those runs would throw away three
 * quarters of every shadow and leave a hard edge down the tile centre lines.
 * The lobes are shared by all four tiles round the vertex, so casting from them
 * means whichever tile the shade falls in draws the whole of it.
 */ // A building, a pillar, a rail gantry — none of them reach the roof, so their
// shade is a fraction of what the stone throws.
const $e81502d4aa27ba48$var$BUILT_SHADOW_LEN = 11;
/** Is (x,y) anywhere the box passes through as it is dragged along (dx, dy)? */ function $e81502d4aa27ba48$var$inSweptBox(b, x, y, dx, dy) {
    let lo = 0, hi = 1;
    if (dx === 0) {
        if (x < b.x0 || x > b.x1) return false;
    } else {
        const t1 = (x - b.x1) / dx, t2 = (x - b.x0) / dx;
        lo = Math.max(lo, Math.min(t1, t2));
        hi = Math.min(hi, Math.max(t1, t2));
    }
    if (dy === 0) {
        if (y < b.y0 || y > b.y1) return false;
    } else {
        const t1 = (y - b.y1) / dy, t2 = (y - b.y0) / dy;
        lo = Math.max(lo, Math.min(t1, t2));
        hi = Math.min(hi, Math.max(t1, t2));
    }
    return lo <= hi;
}
/**
 * The shade the tile's uprights throw, as runs.
 *
 * The footprints themselves are cut out of it. This pass lands after the world
 * effects — it has to, or the shaft it is cast into would wash it out — and by
 * then the buildings have long since been painted, so anything drawn over their
 * own ground would be drawn over THEM. What is left is exactly the part a
 * player can see anyway: the shade beyond the walls.
 */ function $e81502d4aa27ba48$var$structureShadowRuns(boxes, dx, dy) {
    const N = Math.ceil($e81502d4aa27ba48$export$9e15ff8aa6bc996f / $e81502d4aa27ba48$var$ROCK_STEP);
    const runs = [];
    for(let iy = 0; iy < N; iy++){
        const y = iy * $e81502d4aa27ba48$var$ROCK_STEP;
        let runX = -1;
        const flush = (x1)=>{
            if (runX >= 0) runs.push([
                runX,
                y,
                x1 - runX,
                $e81502d4aa27ba48$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(let ix = 0; ix < N; ix++){
            const x = ix * $e81502d4aa27ba48$var$ROCK_STEP;
            let onFootprint = false, swept = false;
            for (const b of boxes){
                // a footprint wins outright: no shade is drawn on the thing casting it
                if (x >= b.x0 && x <= b.x1 && y >= b.y0 && y <= b.y1) {
                    onFootprint = true;
                    break;
                }
                if (!swept && $e81502d4aa27ba48$var$inSweptBox(b, x, y, dx, dy)) swept = true;
            }
            if (onFootprint || !swept) {
                flush(x);
                continue;
            }
            if (runX < 0) runX = x;
        }
        flush($e81502d4aa27ba48$export$9e15ff8aa6bc996f);
    }
    return runs;
}
function $e81502d4aa27ba48$export$d8acf7b29b621d22(boxes) {
    const pts = boxes.map((b)=>({
            x: (b.x0 + b.x1) / 2,
            y: (b.y0 + b.y1) / 2
        }));
    let key = null, runs = null;
    return (g, T, fx)=>{
        const plan = $e81502d4aa27ba48$var$shaftShadowPlan(fx, pts, $e81502d4aa27ba48$var$BUILT_SHADOW_LEN);
        if (!plan) return;
        const k = `${plan.dx},${plan.dy}`;
        if (k !== key) {
            key = k;
            runs = $e81502d4aa27ba48$var$structureShadowRuns(boxes, plan.dx, plan.dy);
        }
        if (!runs.length) return;
        g.a($e81502d4aa27ba48$var$ROCK_SHADOW_A * plan.lit, ()=>{
            for (const [x, y, w, h] of runs)g.r(x, y, w, h, T.far);
        });
    };
}
function $e81502d4aa27ba48$export$113936d15000c5cd(lobes) {
    let key = null, runs = null;
    return (g, T, fx)=>{
        const plan = $e81502d4aa27ba48$var$shaftShadowPlan(fx, lobes, $e81502d4aa27ba48$var$ROCK_SHADOW_LEN);
        if (!plan) return;
        const k = `${plan.dx},${plan.dy}`;
        if (k !== key) {
            key = k;
            runs = $e81502d4aa27ba48$var$rockShadowRuns(lobes, plan.dx, plan.dy);
        }
        if (!runs.length) return;
        g.a($e81502d4aa27ba48$var$ROCK_SHADOW_A * plan.lit, ()=>{
            for (const [x, y, w, h] of runs)g.r(x, y, w, h, T.far);
        });
    };
}
function $e81502d4aa27ba48$var$drawRockMass(g, rng, T, ctx) {
    const amount = ctx?.enclosure ?? 0;
    const col = ctx?.col ?? 0, row = ctx?.row ?? 0;
    const N = Math.ceil($e81502d4aa27ba48$export$9e15ff8aa6bc996f / $e81502d4aa27ba48$var$ROCK_STEP);
    // The roadway carves its own corridor. The road network is symmetric across
    // every edge by construction, so both tiles carve the same seam and a route
    // is never sealed off by rock that only one side knew about.
    let roadMask = null;
    if (ctx?.samples?.length) {
        roadMask = new Uint8Array(N * N);
        for (const s of ctx.samples){
            const x0 = Math.max(0, (s.x - s.hx - $e81502d4aa27ba48$var$ROAD_R) / $e81502d4aa27ba48$var$ROCK_STEP | 0);
            const x1 = Math.min(N - 1, (s.x + s.hx + $e81502d4aa27ba48$var$ROAD_R) / $e81502d4aa27ba48$var$ROCK_STEP | 0);
            const y0 = Math.max(0, (s.y - s.hy - $e81502d4aa27ba48$var$ROAD_R) / $e81502d4aa27ba48$var$ROCK_STEP | 0);
            const y1 = Math.min(N - 1, (s.y + s.hy + $e81502d4aa27ba48$var$ROAD_R) / $e81502d4aa27ba48$var$ROCK_STEP | 0);
            for(let yy = y0; yy <= y1; yy++)for(let xx = x0; xx <= x1; xx++)roadMask[yy * N + xx] = 1;
        }
    }
    // ...and so does everything standing on the tile, or the mass buries the room
    // it is supposed to be the walls of.
    const built = (x, y)=>ctx?.keep?.some((b)=>x > b.x0 - 10 && x < b.x1 + 10 && y > b.y0 - 10 && y < b.y1 + 10);
    const lobes = amount ? $e81502d4aa27ba48$export$aceae09a505d3fb5(col, row) : [];
    const face = [], deep = [], wash = [];
    for(let iy = 0; iy < N; iy++){
        const y = iy * $e81502d4aa27ba48$var$ROCK_STEP;
        let runX = -1, runKind = 0;
        const flush = (x1)=>{
            if (runX < 0) return;
            (runKind === 2 ? deep : face).push([
                runX,
                y,
                x1 - runX,
                $e81502d4aa27ba48$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(let ix = 0; ix < N; ix++){
            const x = ix * $e81502d4aa27ba48$var$ROCK_STEP;
            const m = lobes.length ? $e81502d4aa27ba48$var$rockDepth(lobes, x, y) : -1;
            // The roadway still clears itself. The mass cannot reach a crossing by
            // construction, but a road wanders inside the tile too and rock standing
            // in the carriageway would be wrong wherever it happened.
            const onRoad = roadMask?.[iy * N + ix];
            const solid = m > 0 && !onRoad && !built(x + 1, y + 1);
            // The darkness follows the same field: full out where the rock is close,
            // easing off over the open floor in the middle where the room is. `m` is
            // -1 at twice a lobe's radius and 1 at its core, so the gradient covers
            // roughly a lobe's width of floor outside the stone.
            const near = Math.max(0, Math.min(1, (m + 1) / 1.2));
            wash.push([
                x,
                y,
                $e81502d4aa27ba48$var$DARK_MIN + ($e81502d4aa27ba48$var$DARK_MAX - $e81502d4aa27ba48$var$DARK_MIN) * near
            ]);
            if (!solid) {
                flush(x);
                continue;
            }
            const kind = m > 0.1 ? 2 : 1;
            if (runX >= 0 && kind !== runKind) flush(x);
            if (runX < 0) {
                runX = x;
                runKind = kind;
            }
        }
        flush($e81502d4aa27ba48$export$9e15ff8aa6bc996f);
    }
    // The wash first, so the rock itself is not dimmed by its own shadow.
    // Quantised to a handful of levels and merged into runs — a per-cell alpha
    // would be 1600 fills of near-identical darkness.
    let runA = -1, runX = 0, runY = -1;
    const flushWash = (x1, y, a)=>{
        if (runA <= 0.001) return;
        g.a(runA, ()=>g.r(runX, y, x1 - runX, $e81502d4aa27ba48$var$ROCK_STEP, T.far));
    };
    for (const [x, y, a] of wash){
        const q = Math.round(a * 12) / 12;
        if (y !== runY || q !== runA) {
            if (runY >= 0) flushWash(y === runY ? x : $e81502d4aa27ba48$export$9e15ff8aa6bc996f, runY, runA);
            runA = q;
            runX = x;
            runY = y;
        }
    }
    if (runY >= 0) flushWash($e81502d4aa27ba48$export$9e15ff8aa6bc996f, runY, runA);
    // Everything upright on the tile throws shade in a shaft, not just the stone.
    const upright = [
        ...ctx?.keep || [],
        ...ctx?.props || []
    ];
    // Lobes, not runs: a tile with a mass at one of its corners may rasterise
    // none of it (buried under a structure, or the whole quarter suppressed) and
    // still be the tile that mass throws its shade into. And a tile with no mass
    // at all still has buildings on it, which is why the structures are their own
    // clause rather than something the rock's presence gates.
    if (!amount || !lobes.length && !upright.length) return;
    // Facets are rolled HERE, while the seeded stream is in hand, and drawn from
    // the resulting list below. The draw is replayed every frame on the overhead
    // channel and a replay must never touch the rng — it would reshuffle the
    // stone on every tick.
    const facets = [];
    for (const [x, y, w] of face.concat(deep)){
        if (w < 5 || rng() < 0.5) continue;
        const fw = $e81502d4aa27ba48$var$ri(rng, 2, Math.min(9, w));
        facets.push([
            x + $e81502d4aa27ba48$var$ri(rng, 0, w - fw),
            y,
            fw,
            rng() < 0.55
        ]);
    }
    // The mass goes ON TOP OF EVERYTHING, above even the clouds and the daylight
    // shafts. It is a cutaway through stone that carries on up to the cavern
    // roof, so nothing in the room can be in front of it and a shaft of daylight
    // crossing one would be light coming through the ceiling.
    //
    // Rock is not a silhouette either, and drawing it as two flat fills of the
    // void colour made it one — a black shape with a hard edge, which the eye
    // files as a building seen from above. What says stone is the interior:
    // facets that catch what little light there is, crevices that catch none,
    // and a broken lit edge where the mass has come away.
    // Built once per still-layer repaint, so their run caches survive frames.
    // The buildings, pillars and gantries are shorter than the stone, so their
    // shadows are, and they go down first because the stone stands over them all.
    const builtShade = upright.length ? $e81502d4aa27ba48$export$d8acf7b29b621d22(upright) : null;
    const rockShade = $e81502d4aa27ba48$export$113936d15000c5cd(lobes);
    $e81502d4aa27ba48$var$overhead(g, T, (g2, T2, fx)=>{
        // The shadows first: they darken the lit floor, and the stone then covers
        // the end of its own. Skipped entirely when the tile is nowhere near a
        // shaft, which is most of them — a sublevel is dark, and a shadow with no
        // light to cast it is just a smudge.
        if (builtShade) builtShade(g2, T2, fx);
        rockShade(g2, T2, fx);
        for (const [x, y, w, h] of face)g2.r(x, y, w, h, T2.structDark);
        for (const [x, y, w, h] of deep)g2.r(x, y, w, h, $e81502d4aa27ba48$var$shade(T2.structDark, 0.6));
        g2.a(0.5, ()=>{
            for (const [x, y, w, light] of facets)g2.r(x, y, w, $e81502d4aa27ba48$var$ROCK_STEP, light ? T2.mass : T2.far);
        });
        g2.a(0.4, ()=>{
            for (const [x, y, w] of face)if (w > 5) g2.r(x, y, w, 1, T2.mass);
        });
    });
}
const $e81502d4aa27ba48$export$a78a4d42e3d4c561 = {
    dust (g, rng, T) {
        for(let i = 0; i < 60; i++)g.a(0.12, ()=>g.r($e81502d4aa27ba48$var$ri(rng, 0, 118), $e81502d4aa27ba48$var$ri(rng, 0, 118), $e81502d4aa27ba48$var$ri(rng, 1, 3), 1, T.accent));
        for(let i = 0; i < 6; i++){
            const dx = $e81502d4aa27ba48$var$ri(rng, 6, 100), dy = $e81502d4aa27ba48$var$ri(rng, 6, 114);
            g.a(0.08, ()=>g.r(dx, dy, $e81502d4aa27ba48$var$ri(rng, 9, 20), $e81502d4aa27ba48$var$ri(rng, 1, 2), T.structLight));
        }
    },
    vines (g, rng, T) {
        for(let i = 0; i < 4; i++){
            const edge = $e81502d4aa27ba48$var$ri(rng, 0, 3);
            const p = $e81502d4aa27ba48$var$ri(rng, 12, 105);
            const [x, y] = edge === 0 ? [
                p,
                3
            ] : edge === 1 ? [
                p,
                114
            ] : edge === 2 ? [
                3,
                p
            ] : [
                114,
                p
            ];
            $e81502d4aa27ba48$var$foliageClump(g, rng, T, x, y, $e81502d4aa27ba48$var$ri(rng, 3, 5));
            // a runner trailing inward from the clump
            let rx = x, ry = y;
            for(let s = 0, n = $e81502d4aa27ba48$var$ri(rng, 8, 18); s < n; s++){
                rx += $e81502d4aa27ba48$var$ri(rng, -2, 2) + (x < 20 ? 1 : x > 100 ? -1 : 0);
                ry += $e81502d4aa27ba48$var$ri(rng, -2, 2) + (y < 20 ? 1 : y > 100 ? -1 : 0);
                g.r(rx, ry, 1, 1, T.veg1);
                if (s % 4 === 0) g.r(rx + $e81502d4aa27ba48$var$ri(rng, -1, 1), ry + $e81502d4aa27ba48$var$ri(rng, -1, 1), 1, 1, T.veg2);
            }
        }
        g.a(0.05, ()=>g.r(0, 0, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, $e81502d4aa27ba48$export$9e15ff8aa6bc996f, T.veg2));
    },
    flood (g, rng, T, recipe, ctx) {
        // A tile with no shoreline stamped on it — the image lab previewing a room
        // on its own, or a save written before the sea existed — gets the old
        // scattered standing water rather than nothing at all.
        if (recipe === 'water' || recipe === 'portal') return;
        if (ctx?.shore == null) $e81502d4aa27ba48$var$drawLakes(g, rng, T, $e81502d4aa27ba48$var$ri(rng, 1, 3));
        else $e81502d4aa27ba48$var$drawTide(g, rng, T, ctx);
        for(let i = 0; i < 24; i++)g.r($e81502d4aa27ba48$var$ri(rng, 6, 111), $e81502d4aa27ba48$var$ri(rng, 6, 111), $e81502d4aa27ba48$var$ri(rng, 1, 3), $e81502d4aa27ba48$var$ri(rng, 1, 2), T.rust);
    },
    // Rust is what happens to STEEL, so it goes on the steel. Scattered over the
    // whole tile it landed on grass, in sinkholes and across open chasms — which
    // reads as an orange filter over the region rather than as corrosion, and it
    // was the one thing making a foundry tile look painted rather than weathered.
    //
    // What is left on open ground is the oil: a yard that ran machinery for a
    // century has stains on its hardstanding, and those belong on the floor.
    rust (g, rng, T, recipe, ctx) {
        const steel = [
            ...ctx?.keep || [],
            ...ctx?.props || []
        ];
        for (const b of steel){
            const w = b.x1 - b.x0, h = b.y1 - b.y0;
            if (w < 6 || h < 6) continue;
            // Patches, not a wash: a few irregular blooms per structure, each a
            // cluster of overlapping discs so the outline is ragged.
            for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 1, 3); i < n; i++){
                const cx = b.x0 + $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, w - 2));
                const cy = b.y0 + $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, h - 2));
                const r = $e81502d4aa27ba48$var$ri(rng, 2, Math.max(2, Math.min(7, Math.min(w, h) >> 1)));
                g.a(0.45, ()=>{
                    for(let j = 0, m = $e81502d4aa27ba48$var$ri(rng, 2, 4); j < m; j++){
                        const dx = cx + $e81502d4aa27ba48$var$ri(rng, -r, r), dy = cy + $e81502d4aa27ba48$var$ri(rng, -r, r);
                        // clipped to the structure — a bloom that spills off its own edge
                        // is back to being paint on the ground
                        const rr = Math.max(1, Math.min(r, dx - b.x0, b.x1 - dx, dy - b.y0, b.y1 - dy));
                        $e81502d4aa27ba48$var$disc(g, dx, dy, rr, T.rust);
                    }
                });
            }
            // and the streaks running down off it
            for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 1, 3); i < n; i++)g.a(0.3, ()=>g.r(b.x0 + $e81502d4aa27ba48$var$ri(rng, 0, Math.max(0, w - 4)), b.y1 - $e81502d4aa27ba48$var$ri(rng, 0, 2), $e81502d4aa27ba48$var$ri(rng, 2, 5), 1, T.rust));
        }
        // Oil on the hardstanding, wherever the ground is open.
        for(let i = 0, n = $e81502d4aa27ba48$var$ri(rng, 1, 2); i < n; i++)g.a(0.3, ()=>$e81502d4aa27ba48$var$disc(g, $e81502d4aa27ba48$var$ri(rng, 24, 93), $e81502d4aa27ba48$var$ri(rng, 24, 93), $e81502d4aa27ba48$var$ri(rng, 6, 10), T.structDark));
    },
    dark (g, rng, T, recipe, ctx) {
        $e81502d4aa27ba48$var$drawRockMass(g, rng, T, ctx);
    }
};
// ===============================
// RENDERER (browser only)
// ===============================
// The game draws live tiles via drawRoomTile (see raidMapAnim.js); the
// static renderRoomImage below remains for the image lab's export tooling.
// ---- cloud cover ----
// Deterministic 2D noise. Clouds are sampled in WORLD coordinates (grid
// col/row * BASE + pixel), so every tile reads the same global cloud field
// and banks flow seamlessly across tile edges — no whole-map canvas needed.
function $e81502d4aa27ba48$var$hashBits(x, y) {
    let h = Math.imul(x, 374761393) + Math.imul(y, 668265263) | 0;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return (h ^ h >>> 16) >>> 0;
}
// 0..1 from the same bits. Daylight wells, shorelines and the lamp flicker
// all sample this and the value noise below; only the clouds moved on to
// gradient noise, so those are left exactly as they drew before.
function $e81502d4aa27ba48$var$noiseHash(x, y) {
    return $e81502d4aa27ba48$var$hashBits(x, y) / 4294967296;
}
function $e81502d4aa27ba48$var$smoothNoise(x, y) {
    const xi = Math.floor(x), yi = Math.floor(y);
    const fx = x - xi, fy = y - yi;
    const sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
    const a = $e81502d4aa27ba48$var$noiseHash(xi, yi), b = $e81502d4aa27ba48$var$noiseHash(xi + 1, yi);
    const c = $e81502d4aa27ba48$var$noiseHash(xi, yi + 1), d = $e81502d4aa27ba48$var$noiseHash(xi + 1, yi + 1);
    return a + (b - a) * sx + (c - a) * sy + (a - b - c + d) * sx * sy;
}
// Gradient (Perlin) noise, which the clouds use in place of the value noise
// above. Value noise interpolates four random HEIGHTS and the lattice
// survives it: features line up with the grid axes and a big bank comes out
// a bumpy quilt.
// Gradient noise interpolates four random DIRECTIONS through a quintic
// fade, which is the shape every cloud and terrain generator has been built
// on since Perlin '85. Four dot products dearer per sample, no more hashes.
// The eight gradients are the axes and diagonals — the classic set; using
// unnormalised diagonals is the standard cheat and costs nothing visible.
const $e81502d4aa27ba48$var$GRAD_X = [
    1,
    -1,
    1,
    -1,
    1,
    -1,
    0,
    0
];
const $e81502d4aa27ba48$var$GRAD_Y = [
    1,
    1,
    -1,
    -1,
    0,
    0,
    1,
    -1
];
function $e81502d4aa27ba48$var$gradDot(ix, iy, dx, dy) {
    const g = $e81502d4aa27ba48$var$hashBits(ix, iy) & 7;
    return $e81502d4aa27ba48$var$GRAD_X[g] * dx + $e81502d4aa27ba48$var$GRAD_Y[g] * dy;
}
// Returns ~0..1, centred on 0.5. Perlin's own range is roughly ±0.7 and
// bell-shaped rather than flat, so SPREAD sets how much of the 0..1 band it
// actually uses — it is what keeps the CLOUD_TYPES thresholds, which were
// authored against the old flat-ish value noise, meaning what they meant.
const $e81502d4aa27ba48$var$NOISE_SPREAD = 0.70;
function $e81502d4aa27ba48$var$gradNoise(x, y) {
    const xi = Math.floor(x), yi = Math.floor(y);
    const fx = x - xi, fy = y - yi;
    const u = fx * fx * fx * (fx * (fx * 6 - 15) + 10);
    const v = fy * fy * fy * (fy * (fy * 6 - 15) + 10);
    const n00 = $e81502d4aa27ba48$var$gradDot(xi, yi, fx, fy);
    const n10 = $e81502d4aa27ba48$var$gradDot(xi + 1, yi, fx - 1, fy);
    const n01 = $e81502d4aa27ba48$var$gradDot(xi, yi + 1, fx, fy - 1);
    const n11 = $e81502d4aa27ba48$var$gradDot(xi + 1, yi + 1, fx - 1, fy - 1);
    const a = n00 + (n10 - n00) * u;
    const b = n01 + (n11 - n01) * u;
    return 0.5 + $e81502d4aa27ba48$var$NOISE_SPREAD * (a + (b - a) * v);
}
// How far a cloud's shadow lands from the cloud itself, up and to the left
// of it, in WORLD units (a tile is WORLD across). Far enough that the shadow
// is a dark patch of its own rather than a rim around the bright one, close
// enough that it is still recognisably the same bank's shape — which means
// it is really a fraction of CLOUD_TYPES.scale, about half a feature, and
// wants moving if the presets are ever rescaled. The sun is a fixed
// direction here rather than the day's swinging shadowAngle: a shadow that
// swung round the compass over ten real minutes would draw the eye to the
// sky instead of the map. CLOUD_SHADOW_A scales the shadow off the
// cloud's own opacity — thicker cloud, darker ground — up to a ceiling that
// keeps a dense bank from blacking the tile out.
const $e81502d4aa27ba48$var$CLOUD_SHADOW_OFF = 50;
const $e81502d4aa27ba48$var$CLOUD_SHADOW_A = 1.5;
const $e81502d4aa27ba48$var$CLOUD_SHADOW_MAX = 0.34;
const $e81502d4aa27ba48$var$CLOUD_SHADOW_INK = '#0b1018';
// The sky is not one sheet. Three decks at different heights ride the same
// wind at different speeds, and it is that shear — banks sliding across each
// other, gaps opening and closing where they cross — that stops a drifting
// field from reading as one rigid texture towed over the map.
//   speed: multiplies the drift the caller integrates (1 = the wind it
//     thinks it is blowing, so the mid deck is the old single layer).
//   px/py: a fixed lead into the same noise field, so no two decks ever
//     show the same shape. Far larger than any preset's feature scale.
// Each deck is thresholded at a SHARE of the requested cover rather than
// all of it: three decks veiling a third of the sky each come out at the
// coverage one deck at full cover used to give. The share is not 1/3 — the
// decks overlap, and cover maps to a threshold on a bell-shaped noise
// distribution, not to an area — so it is calibrated, not derived.
const $e81502d4aa27ba48$var$CLOUD_DECKS = [
    {
        speed: 0.62,
        px: 0,
        py: 0
    },
    {
        speed: 1.00,
        px: 811.3,
        py: 517.7
    },
    {
        speed: 1.55,
        px: 269.1,
        py: 943.5
    }
];
const $e81502d4aa27ba48$var$CLOUD_DECK_SHARE = 0.65;
// Per-deck world offsets for the tile being drawn. Module scratch, not a
// fresh array per tile: one cloud pass runs at a time, and this is the
// hottest loop in the frame.
const $e81502d4aa27ba48$var$deckOx = new Float64Array($e81502d4aa27ba48$var$CLOUD_DECKS.length);
const $e81502d4aa27ba48$var$deckOy = new Float64Array($e81502d4aa27ba48$var$CLOUD_DECKS.length);
// The cloud field, resolved once per tile so the cloud pass and its shadow
// read the same noise. dx/dy shift where the field is SAMPLED, so a positive
// offset moves what is drawn the other way — see the call below.
function $e81502d4aa27ba48$var$cloudField(anim, tune) {
    const type = $e81502d4aa27ba48$export$ea4f1160001ec0c0[tune.cloudType] || $e81502d4aa27ba48$export$ea4f1160001ec0c0.scattered;
    // WORLD units, not the authoring grid: the noise scales are tuned in
    // them, and this loop is the single biggest per-frame cost in the game's
    // composite pass — following a finer art grid would multiply it by 9.
    // The tile's own world position is common to every deck; only the drift
    // is scaled, which is what makes one deck outrun another.
    const wx = (anim.col || 0) * $e81502d4aa27ba48$export$3d672f2aedd16af9, wy = (anim.row || 0) * $e81502d4aa27ba48$export$3d672f2aedd16af9;
    for(let i = 0; i < $e81502d4aa27ba48$var$CLOUD_DECKS.length; i++){
        const d = $e81502d4aa27ba48$var$CLOUD_DECKS[i];
        $e81502d4aa27ba48$var$deckOx[i] = wx - (anim.cloud.x || 0) * d.speed + d.px;
        $e81502d4aa27ba48$var$deckOy[i] = wy - (anim.cloud.y || 0) * d.speed + d.py;
    }
    return {
        type: type,
        thr: type.thr(anim.cloud.cover * $e81502d4aa27ba48$var$CLOUD_DECK_SHARE),
        sx: type.scale * type.stretch,
        sy: type.scale,
        morph: (anim.t || 0) * 0.05
    };
}
// How far the fine octave drags the coarse lookup, in coarse noise cells.
// This is domain warping: sampling the broad shape at a position that the
// detail octave has displaced. It is the cheapest trick in procedural
// texturing and the one that matters most here — summed octaves alone give
// lumpy blobs with the same lumpiness everywhere, while a warped lookup
// stretches, hooks and curls the edges the way moving air actually does.
// Free, because the octave doing the warping is one the field already pays
// for. Push it past ~1.2 and banks tear into filaments.
const $e81502d4aa27ba48$var$CLOUD_WARP = 0.75;
// Density at one point of the sky, already shaped into an alpha. 0 = clear.
// Each deck is two octaves warped by each other, the fine one's coordinates
// creeping with time so shapes slowly morph while the whole field drifts.
// The decks are combined as stacked translucency (what is left clear after
// all three) rather than painted one over another — identical result, since
// they share a colour, at one fill per cell instead of three.
function $e81502d4aa27ba48$var$cloudAlpha(f, x, y, dx, dy) {
    let clear = 1;
    for(let i = 0; i < $e81502d4aa27ba48$var$CLOUD_DECKS.length; i++){
        const wx = (x + dx + $e81502d4aa27ba48$var$deckOx[i]) / f.sx, wy = (y + dy + $e81502d4aa27ba48$var$deckOy[i]) / f.sy;
        const fine = $e81502d4aa27ba48$var$gradNoise(wx * 2.7 + 31.7 + f.morph, wy * 2.7 + 17.3);
        // the warp is stronger across than along, so banks shear rather than
        // just wobble — the two axes must differ or the whole field skews 45°
        const w = (fine - 0.5) * $e81502d4aa27ba48$var$CLOUD_WARP;
        const d = $e81502d4aa27ba48$var$gradNoise(wx + w, wy + w * 0.55) * 0.65 + fine * 0.35;
        if (d <= f.thr) continue;
        // smoothstep, not a linear ramp into a hard ceiling: the old profile put
        // a visible contour line wherever a bank hit full opacity
        const e = Math.min(1, (d - f.thr) * f.type.sharp / f.type.maxA);
        clear *= 1 - f.type.maxA * e * e * (3 - 2 * e);
    }
    return 1 - clear;
}
// anim.cloud = { cover: 0..1, x, y } — x/y are the accumulated drift offset
// (world px, integrated by the caller so gusty wind doesn't jitter the
// clouds). Two passes: the shadow the bank casts on the ground, then the
// bank itself, pale and thin over the top. The tile's own contents are what
// the shadow falls on, so the darkening is what sells the weather — the
// clouds alone read as fog laid over the map.
function $e81502d4aa27ba48$var$drawCloudLayer(g, anim, light, tune) {
    const f = $e81502d4aa27ba48$var$cloudField(anim, tune);
    const cell = $e81502d4aa27ba48$export$a4097a0a1d4593d2 * $e81502d4aa27ba48$var$FX_PX;
    // Half resolution: a shadow is a soft dark patch with no edge to lose, so
    // this costs a quarter of the cloud pass rather than another one of it.
    // It scales with the light that casts it — by night the ground is dark
    // already and the mottling all but disappears.
    const step = $e81502d4aa27ba48$export$a4097a0a1d4593d2 * 2, scell = step * $e81502d4aa27ba48$var$FX_PX;
    for(let y = 0; y < $e81502d4aa27ba48$export$3d672f2aedd16af9; y += step)for(let x = 0; x < $e81502d4aa27ba48$export$3d672f2aedd16af9; x += step){
        // sampled down-sun, so the shadow lands up and left of its own cloud
        const a = $e81502d4aa27ba48$var$cloudAlpha(f, x, y, $e81502d4aa27ba48$var$CLOUD_SHADOW_OFF, $e81502d4aa27ba48$var$CLOUD_SHADOW_OFF);
        if (a === 0) continue;
        g.a(Math.min($e81502d4aa27ba48$var$CLOUD_SHADOW_MAX, a * $e81502d4aa27ba48$var$CLOUD_SHADOW_A * light), ()=>g.p(x * $e81502d4aa27ba48$var$FX_PX, y * $e81502d4aa27ba48$var$FX_PX, scell, scell, $e81502d4aa27ba48$var$CLOUD_SHADOW_INK));
    }
    const l = Math.round(80 + 150 * light); // pale by day, near-dark by night
    const color = `rgb(${l},${l + 4},${Math.min(255, l + 12)})`;
    for(let y = 0; y < $e81502d4aa27ba48$export$3d672f2aedd16af9; y += $e81502d4aa27ba48$export$a4097a0a1d4593d2)for(let x = 0; x < $e81502d4aa27ba48$export$3d672f2aedd16af9; x += $e81502d4aa27ba48$export$a4097a0a1d4593d2){
        const alpha = $e81502d4aa27ba48$var$cloudAlpha(f, x, y, 0, 0);
        if (alpha === 0) continue;
        g.a(alpha, ()=>g.p(x * $e81502d4aa27ba48$var$FX_PX, y * $e81502d4aa27ba48$var$FX_PX, cell, cell, color));
    }
}
// Dim and cool a palette toward night. light: 1 = full day, 0 = midnight.
// Blue dims less than red/green so nights read cold rather than gray, and
// glow is exempt entirely — handheld lights and fires pop after dark.
// Memoized per palette on a 1/512 light quantization: light sweeps a full
// day in 10 minutes, so each palette re-tints at most every ~1.2s instead
// of re-parsing every hex color on every tile draw (up to 119 tiles/frame).
// The 1/512 snap is far below a visible color step.
const $e81502d4aa27ba48$var$tintCache = new WeakMap(); // pal -> Map<bucket, tinted pal>
function $e81502d4aa27ba48$export$ff1cf6056aa7ef44(pal, light) {
    if (light >= 1) return pal;
    const bucket = Math.round(Math.max(0, light) * 512);
    let byBucket = $e81502d4aa27ba48$var$tintCache.get(pal);
    if (!byBucket) $e81502d4aa27ba48$var$tintCache.set(pal, byBucket = new Map());
    const cached = byBucket.get(bucket);
    if (cached) return cached;
    const q = bucket / 512;
    const out = {};
    for (const [key, hex] of Object.entries(pal)){
        if (key === 'glow') {
            out[key] = hex;
            continue;
        }
        const n = parseInt(hex.slice(1), 16);
        const r = Math.round((n >> 16 & 255) * (0.30 + 0.70 * q));
        const g = Math.round((n >> 8 & 255) * (0.34 + 0.66 * q));
        const b = Math.round((n & 255) * (0.50 + 0.50 * q));
        out[key] = `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
    }
    if (byBucket.size > 600) byBucket.clear(); // a day sweeps ~300 buckets
    byBucket.set(bucket, out);
    return out;
}
// Merged-tune cache for the game's static REGION_THEMES only - the image
// lab passes opts.theme and mutates its tune live, so that path recomputes
const $e81502d4aa27ba48$var$tuneCache = new WeakMap(); // theme -> merged tune
function $e81502d4aa27ba48$var$resolveTheme(regionKey, opts) {
    const theme = opts.theme || $e81502d4aa27ba48$export$d4f789780201d4a[regionKey] || $e81502d4aa27ba48$var$FALLBACK_THEME;
    if (opts.theme) return {
        theme: theme,
        tune: {
            ...$e81502d4aa27ba48$export$6915278477114e25,
            ...theme.tune || {}
        }
    };
    let tune = $e81502d4aa27ba48$var$tuneCache.get(theme);
    if (!tune) $e81502d4aa27ba48$var$tuneCache.set(theme, tune = {
        ...$e81502d4aa27ba48$export$6915278477114e25,
        ...theme.tune || {}
    });
    return {
        theme: theme,
        tune: tune
    };
}
function $e81502d4aa27ba48$export$f7a259d7313a81f1(theme, tune, dayPhase) {
    if (dayPhase == null) return {
        light: 1,
        shadowAngle: tune.shadowAngle,
        shadowDist: 1.4,
        shadowAlpha: tune.shadowAlpha,
        lamp: 0
    };
    // 1. the raw daylight curve (15 hours of light, 9 hours of dark)
    const clamped = Math.max(0.4, Math.min(1, 0.4 + 0.85 * Math.cos((dayPhase - 0.5) * 2 * Math.PI)));
    // 2. smoothstep for a soft twilight and dawn fade
    const surface = clamped * clamped * (3 - 2 * clamped);
    // Sublevels get a faint ambient echo of the surface day: a floor so the dark
    // hours aren't pitch black, plus a slice of the normal brightness curve.
    // The floor was 0.06, which compounded with the night tint (x0.30 red at the
    // bottom of its range) and the darkness wash into a tile you could not read
    // at all — the region was distinguishable only by being black. The ceiling
    // MUST stay under 0.4: above it dayState switches on moving sun shadows, and
    // a sublevel that has no sun would start churning its cached still layer for
    // shadows it should never cast.
    const light = theme.backdrop === 'underground' ? 0.22 + 0.16 * surface : surface;
    const dayFrac = Math.min(1, Math.max(0, (dayPhase - 0.25) / 0.5)); // 06:00 -> 18:00
    const ds = {
        light: light,
        shadowAngle: 180 - dayFrac * 180,
        shadowDist: 0,
        shadowAlpha: tune.shadowAlpha,
        // powered lights ramp on as daylight fades below ~0.45 (dusk) and off
        // again at dawn; they never light in static daytime renders
        lamp: Math.min(1, Math.max(0, (0.45 - light) / 0.2))
    };
    if (light > 0.4) {
        ds.shadowDist = 1 + (tune.shadowLength - 1) * (1 - Math.sin(dayFrac * Math.PI)); // long at dawn/dusk, short at noon
        ds.shadowAlpha = (light - 0.4) / 0.6 * tune.shadowAlpha;
    }
    return ds;
}
function $e81502d4aa27ba48$export$8ee26169c9b5b8ee(light) {
    const q = Math.min(1, Math.max(0, light));
    return `rgb(${Math.round(255 * (0.30 + 0.70 * q))},${Math.round(255 * (0.34 + 0.66 * q))},${Math.round(255 * (0.50 + 0.50 * q))})`;
}
function $e81502d4aa27ba48$export$527771e9cfacbb46(ds) {
    const a = ds.shadowAngle * Math.PI / 180;
    return `${Math.round(Math.cos(a) * ds.shadowDist)},${Math.round(Math.sin(a) * ds.shadowDist)},${Math.round(ds.shadowAlpha * 6)}`;
}
function $e81502d4aa27ba48$var$setAnim(anim, ds, tune) {
    $e81502d4aa27ba48$var$ANIM = {
        wind: anim?.wind || 0,
        t: anim?.t || 0,
        lamp: ds.lamp,
        lightUptime: tune.lightUptime,
        lightSpeed: tune.lightFlickerSpeed,
        tintScale: ds.light * $e81502d4aa27ba48$var$TINT_STEPS
    };
}
// The tile itself: floor, roads, structures, weathering, growth. Identical
// for the one-shot and static paths — the only difference is whether
// dynamic() draws inline or records.
function $e81502d4aa27ba48$var$composeBody(g, T, theme, baseTune, regionKey, recipe, roomName, opts) {
    const conn = opts.conn || {
        n: true,
        e: true,
        s: true,
        w: true
    };
    // each drawing phase gets its own seeded stream: the shadow and content
    // passes below replay identical layouts from fresh copies of the same
    // stream, and no phase can perturb another's composition
    const phaseRng = (phase)=>(0, $c1858b438f434f4d$export$c0b222505a3369f3)(`img|${regionKey}|${roomName}${opts.salt || ''}|${phase}`);
    // A region may draw one of the shared recipes from its own layout instead:
    // a harbour's storage is a container yard, a foundry's is a silo farm. This
    // resolves ONLY the layout lookup — `recipe` itself stays the string it was,
    // because it is a classification key everywhere else in this file
    // (CLEARING_RECIPES, DENSITY_EXEMPT, RUIN_EXEMPT, PARKING_RECIPES, and the
    // `=== 'portal'` / `!== 'water'` tests in the effect and weathering passes).
    // Rewriting it here would quietly reclassify the tile as well as redraw it.
    const def = $e81502d4aa27ba48$export$a571935592b1ff4d[theme.recipes?.[recipe] || recipe] || $e81502d4aa27ba48$export$a571935592b1ff4d.infrastructure;
    const rng = phaseRng('floor');
    ($e81502d4aa27ba48$export$f4eeec8c0ee13647[theme.backdrop] || $e81502d4aa27ba48$export$f4eeec8c0ee13647.city)(g, rng, T);
    // The clearings lay their turf straight over the region floor, off their own
    // stream so the floor underneath stays byte-identical to every other tile's.
    if ($e81502d4aa27ba48$var$CLEARING_RECIPES.has(recipe)) $e81502d4aa27ba48$var$clearing(g, phaseRng('turf'), T, opts.clearing);
    // The sea wall is TERRAIN — effectively where the map stops — so it goes down
    // with the ground and everything the tile is built of sits on top of it. Drawn
    // with the weathering, as it was, it laid concrete over roads and roofs, which
    // reads as a wall built straight through a street.
    if (theme.overlay === 'flood' && opts.shore === 0) $e81502d4aa27ba48$var$drawSeaWall(g, T, {
        shore: opts.shore,
        col: opts.col ?? opts.anim?.col ?? 0
    }, Math.max(0.01, baseTune.floodLevel ?? 1), opts.shoreSide === 's' ? 's' : 'n');
    // Roads come from the generated network (opts.road), so only tiles the
    // network runs through draw one. The network is authoritative even over a
    // lake or a collapsed slab: those rooms are placed AFTER it is laid out, so
    // letting them suppress the roadway would punch gaps into a through route.
    //
    // The road is routed around the recipe's buildings, so it has to know where
    // they will land before it draws. A measuring pass runs the recipe against a
    // probe that draws nothing (makeProbeG) off a FRESH copy of the same stream
    // the real passes use, so what it measures is exactly what gets drawn. A
    // parking lot, gate, fence or pipeline is not measured — a road crossing one
    // of those is fine, and usually better.
    const isGate = opts.roomType === 'gate';
    // How much of the recipe's built stock this tile is entitled to. A tile the
    // roadway runs through is at distance 0 by definition, whatever a stale save
    // says, so the road itself is the authority when it is present.
    const thinnable = !$e81502d4aa27ba48$var$DENSITY_EXEMPT.has(recipe) && !isGate;
    const roadDist = opts.road ? 0 : opts.roadDist ?? 0;
    // ...and how built-up its DISTRICT is, which the roadway knows nothing about.
    // A tile with no district — a save written before they existed, or the image
    // lab previewing a room on its own — gets none of this and is drawn exactly
    // as it was.
    const built = opts.zone ? $e81502d4aa27ba48$export$5553b5f9fd6fa0ba(opts.zone, opts.col ?? opts.anim?.col ?? 0, opts.row ?? opts.anim?.row ?? 0, opts.shore) : null;
    // Everything downstream — the measuring pass, the road's route around the
    // buildings, and the drawing itself — works off the tile's own scale, so it
    // has to be settled here, before any of it runs.
    const tune = $e81502d4aa27ba48$var$tuneForTile(baseTune, roadDist, opts.roadRank, built, thinnable);
    // One measuring pass, always: three separate things downstream need to know
    // what this recipe is about to put where — routing the road around it,
    // thinning it back by distance, and keeping the vegetation off its roofs.
    // It runs off a fresh copy of the content stream, so it rolls the same
    // variant the drawing passes will.
    let skip = new Set(), variant, shift = [], samples = null;
    let boxes = [];
    $e81502d4aa27ba48$var$runRecipe(def, g, phaseRng('content'), T, tune, conn, 0, 0, {
        record: boxes
    });
    if (opts.road) {
        // The road is routed by the tile's edges, not by what is on the tile, so it
        // can be laid before the recipe — and the recipe can then be laid to suit
        // it. The dead-end forms still want to know what is in the way first, which
        // is what the measurement above gives them.
        samples = $e81502d4aa27ba48$export$fa7182ef09b736f8(g, rng, T, opts.road, tune, boxes.filter((b)=>b.solid), opts.row ?? opts.anim?.row, opts.col ?? opts.anim?.col);
        // The layout pass re-measures per variant and returns the winner's own
        // boxes: a variant's element indices only mean anything within it.
        ({ variant: variant, shift: shift, skip: skip, boxes: boxes } = $e81502d4aa27ba48$export$9de203fcc6e657de(def, ()=>phaseRng('content'), T, tune, conn, samples || [], phaseRng('layout')));
    } else if (thinnable) // Off the network the choice is free, and the same stream makes it, so a
    // tile that later gains a road does not also change hands.
    shift = $e81502d4aa27ba48$var$seededMirror(boxes, phaseRng('layout'));
    // Thin the buildings back with distance from the roadway, on top of whatever
    // the road already suppressed. Suppression, not relocation: a structure that
    // was never built leaves its lot behind, which is the look we are after.
    if (thinnable) for (const n of $e81502d4aa27ba48$export$b0ba4899f6951e17(boxes, roadDist, opts.roadRank, built))skip.add(n);
    // Where the structures actually end up: measured footprints, moved to
    // wherever the layout put them, minus whatever was suppressed.
    const at = ()=>boxes.filter((b)=>!skip.has(b.n)).map((b)=>{
            const [dx, dy] = shift[b.n] || [
                0,
                0
            ];
            return {
                ...b,
                x0: b.x0 + dx,
                y0: b.y0 + dy,
                x1: b.x1 + dx,
                y1: b.y1 + dy
            };
        });
    let placed = at();
    // Then walk them off the tile's own corners, so the map stops repeating on a
    // 120-unit rhythm. Landmarks sit it out for the same reason they sit out the
    // thinning: a portal facility or a rest stop is PLACED, and a placed thing
    // belongs where it was put.
    if (thinnable) {
        const moved = $e81502d4aa27ba48$var$placeStructures(placed, phaseRng('place'), samples);
        if (moved.size) {
            const before = $e81502d4aa27ba48$var$measureSizes(def, phaseRng('content'), T, tune, conn, variant, shift);
            for (const [n, [dx, dy]] of moved)shift[n] = [
                (shift[n]?.[0] || 0) + dx,
                (shift[n]?.[1] || 0) + dy
            ];
            // Not every element is the same size wherever it stands: buildingTop
            // sizes itself against the tile edge, storefront against a line halfway
            // down. A structure that changed size is one whose drawn footprint is no
            // longer the one this pass cleared — bigger, and it lands on what it was
            // cleared of. Rather than teach the placement pass every clamp in the
            // element library, measure again and take back the offsets that moved a
            // size. An element's size depends only on its own position, so putting
            // one back restores it exactly and no second correction is needed.
            const after = $e81502d4aa27ba48$var$measureSizes(def, phaseRng('content'), T, tune, conn, variant, shift);
            for (const [n, [dx, dy]] of moved){
                if (after.get(n) === before.get(n)) continue;
                shift[n] = [
                    shift[n][0] - dx,
                    shift[n][1] - dy
                ];
            }
            placed = at();
        }
    }
    // What the vegetation, the ruins and the traffic have to grow around.
    const keepOut = placed.filter((b)=>b.solid).map(({ x0: x0, y0: y0, x1: x1, y1: y1 })=>({
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1
        }));
    // vegetation density: region knob x the recipe's own multiplier;
    // gates are dressed denser as major areas of interest
    const vegMult = tune.treeDensity * (def.treeDensity ?? 1) * (isGate ? 1.7 : 1);
    // Returns the gate's extra block, which nothing else has measured, so the
    // growth can keep off it like it keeps off everything the recipe drew.
    const drawStructures = (r)=>{
        $e81502d4aa27ba48$var$runRecipe(def, g, r, T, tune, conn, 0, 0, {
            skip: skip,
            variant: variant,
            shift: shift
        });
        return isGate ? $e81502d4aa27ba48$var$gateEmphasis(g, r, T, tune, conn, recipe, samples) : null;
    };
    // `extra` is everything drawn on this tile that the recipe did not measure —
    // a gate's dressing block and the signature props. Growth has to keep off all
    // of it, or you get a tree on a tower roof (see the gateEmphasis test).
    const drawVegetation = (r, extra)=>{
        const more = extra?.filter(Boolean) || []; // a tile with no gate passes null
        return ($e81502d4aa27ba48$var$TD_VEGETATION[theme.backdrop] || $e81502d4aa27ba48$var$TD_VEGETATION.city)(g, r, T, vegMult, more.length ? [
            ...keepOut,
            ...more
        ] : keepOut);
    };
    // Ruins go down with the structures, not with the growth: they are what is
    // left of the same city, and vegetation is meant to reclaim them, so the
    // canopies come over the top afterwards. Rooms the map places whole sit them
    // out — a shaft, a lake, a rest stop or a portal facility is the tile.
    const drawRuinsPass = $e81502d4aa27ba48$var$RUIN_EXEMPT.has(recipe) ? ()=>[] : (r, lot)=>$e81502d4aa27ba48$var$drawRuins(g, r, T, tune, lot ? [
            ...keepOut,
            lot
        ] : keepOut, samples, opts.shore != null ? {
            at: opts.shore,
            side: opts.shoreSide
        } : null);
    // The region's own architecture, and the only pass on the tile that is about
    // a particular place. It goes down AFTER the recipe (so it can see where the
    // buildings landed) and BEFORE the traffic, weathering and growth (which are
    // things that happen TO architecture, and must happen to this too).
    // Rooms the map places WHOLE sit the signature layer out, for exactly the
    // reason they sit the ruins out: a shaft, a lake, a rest stop or a portal
    // facility IS the tile, and a tower core or a colonnade standing in one is
    // the same mistake as a fresh ruin there. This is also what kept a tower's
    // debris skirt out of the collapsed ground it was landing in.
    const drawSignature = $e81502d4aa27ba48$var$RUIN_EXEMPT.has(recipe) ? ()=>[] : (r, ruins, gate)=>($e81502d4aa27ba48$export$ecbd1adefe7cd5ab[theme.backdrop] || (()=>[]))(g, r, T, tune, {
            keep: [
                ...keepOut,
                ...ruins || [],
                ...gate ? [
                    gate
                ] : []
            ],
            samples: samples,
            conn: conn,
            col: opts.col ?? opts.anim?.col ?? 0,
            row: opts.row ?? opts.anim?.row ?? 0,
            built: built,
            recipe: recipe,
            shore: opts.shore,
            shoreSide: opts.shoreSide,
            rail: opts.rail
        });
    // Traffic sits against the roadway, so it needs the road's samples and the
    // rank they were drawn at. Tiles the network misses have neither and get none.
    // It also needs the lot: both hug the same band and the traffic draws last, so
    // without it a wreck lies across the bays of the car park it is parked beside.
    const drawTraffic = (r, lot)=>$e81502d4aa27ba48$var$drawRoadside(g, r, T, samples, opts.roadRank, lot ? [
            ...keepOut,
            lot
        ] : keepOut);
    // Parking goes down before the ruins so a ruin never lands on the lot, and
    // hands its footprint on for exactly that.
    const drawParkingPass = $e81502d4aa27ba48$var$PARKING_RECIPES.has(recipe) ? (r)=>$e81502d4aa27ba48$var$drawParking(g, r, T, samples, keepOut) : ()=>null;
    // pass 1: every shadow lands on the bare ground first, so no object's
    // before the weathering overlay so dust and rust settle on it like anything
    // else. Its own 'anchor' stream keeps every other phase byte-identical to
    // what it drew before anchors existed, and means a skill rebalance changes
    // WHICH device a tile shows without moving WHERE it sits.
    const drawAnchor = (r)=>$e81502d4aa27ba48$var$runAnchor(opts.primary, g, r, T, tune, conn, opts.indoor);
    // pass 1: every shadow lands on the bare ground first, so no object's
    // shadow can fall across a neighboring object
    $e81502d4aa27ba48$var$SHADOW_PASS = true;
    const shadowLot = drawParkingPass(phaseRng('lot'));
    const shadowRuins = drawRuinsPass(phaseRng('ruin'), shadowLot);
    const shadowGate = drawStructures(phaseRng('content'));
    const shadowSig = drawSignature(phaseRng('signature'), shadowRuins, shadowGate);
    drawTraffic(phaseRng('traffic'), shadowLot);
    drawAnchor(phaseRng('anchor'));
    drawVegetation(phaseRng('veg'), [
        shadowGate,
        ...shadowSig
    ]);
    $e81502d4aa27ba48$var$SHADOW_PASS = false;
    // pass 2: the objects over their shadows — anchor off a FRESH copy of the
    // same stream, or it would pick a different corner than its shadow did
    const lot = drawParkingPass(phaseRng('lot'));
    const ruins = drawRuinsPass(phaseRng('ruin'), lot);
    const gate = drawStructures(phaseRng('content'));
    const sig = drawSignature(phaseRng('signature'), ruins, gate);
    drawTraffic(phaseRng('traffic'), lot);
    drawAnchor(phaseRng('anchor'));
    // The weathering pass gets the same context the signature layer does, plus
    // the shoreline: the tide is weather in the sense that matters here — it
    // settles on top of what was built and under what has grown since.
    // `keep` is what the recipe built; `props` is what the signature layer added.
    // They are handed over separately because the two overlays that use them want
    // different things: the tide has to stay out of BOTH (a sea wall standing in
    // the sea is not holding anything back), while the rock mass only answers to
    // the recipe — a colonnade is inside the hall, and if pillars pushed the walls
    // away there would be no walls left anywhere.
    ($e81502d4aa27ba48$export$a78a4d42e3d4c561[theme.overlay] || $e81502d4aa27ba48$export$a78a4d42e3d4c561.dust)(g, phaseRng('overlay'), T, recipe, {
        keep: keepOut,
        props: sig.filter(Boolean),
        samples: samples,
        col: opts.col ?? opts.anim?.col ?? 0,
        row: opts.row ?? opts.anim?.row ?? 0,
        shore: opts.shore,
        shoreSide: opts.shoreSide,
        floodLevel: tune.floodLevel,
        enclosure: tune.enclosure,
        built: built
    });
    // vegetation content still renders after weathering: canopies overhang
    // it, and hollow-core's bioluminescent fungi must glow through the
    // darkness overlay (their shadows already went down in pass 1)
    drawVegetation(phaseRng('veg'), [
        gate,
        ...sig
    ]);
    // Hand the finished ground plan to whoever asked for one. Deliberately the
    // same list the vegetation keeps off — anything a tree may not grow on is
    // something a person may not stand on, and keeping the two answers identical
    // is what stops the map disagreeing with itself about where the ground is.
    //
    // Ruins are NOT in it: rubble is walkable, and half of it is ankle-high.
    if ($e81502d4aa27ba48$var$PLAN) {
        $e81502d4aa27ba48$var$PLAN.blocks = [
            ...keepOut,
            ...gate ? [
                gate
            ] : [],
            ...sig.filter(Boolean)
        ].map(({ x0: x0, y0: y0, x1: x1, y1: y1 })=>({
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1
            }));
        // The lake is a disc, not one of these boxes — see POND.
        $e81502d4aa27ba48$var$PLAN.water = recipe === 'water' ? {
            ...$e81502d4aa27ba48$export$da8728cc680c21d8
        } : null;
        // What the tile is ABOUT, when it is about one thing. Only the campsite
        // has one so far: its fire ring is where a team that has stopped to rest
        // would actually sit, and it is dealt a different spot on every map, so
        // nothing downstream can assume where it is.
        const focus = placed.find((b)=>b.el === 'fireRing');
        $e81502d4aa27ba48$var$PLAN.focus = focus ? {
            x: (focus.x0 + focus.x1) / 2,
            y: (focus.y0 + focus.y1) / 2
        } : null;
    }
}
// World-space effects, drawn over everything and never cached: they move
// every frame and are sampled by grid position so neighbouring tiles stay
// seamless. Cheap despite the tile size — both step in AUTHORING units, so
// their cell count is what it was at 40px.
function $e81502d4aa27ba48$var$drawEffects(g, T, theme, tune, ds, anim, recipe, opts) {
    // daylight wells: cave openings overhead light whole areas of the map
    if (tune.lightRays > 0 && theme.backdrop === 'underground') $e81502d4aa27ba48$var$drawLightWells(g, T, tune, anim, opts.col ?? anim?.col ?? 0, opts.row ?? anim?.row ?? 0);
    // clouds pass over everything; the sublevels have no sky
    if (anim?.cloud?.cover > 0 && theme.backdrop !== 'underground') $e81502d4aa27ba48$var$drawCloudLayer(g, anim, ds.light, tune);
    // the portal's energy glow punches through flood, growth, and cloud
    if (recipe === 'portal') $e81502d4aa27ba48$var$portalGlow(g, T);
}
function $e81502d4aa27ba48$export$f0a8786a677b14c5(ctx, regionKey, recipe, roomName, opts = {}) {
    const { theme: theme, tune: tune } = $e81502d4aa27ba48$var$resolveTheme(regionKey, opts);
    const anim = opts.anim;
    const ds = $e81502d4aa27ba48$export$f7a259d7313a81f1(theme, tune, anim?.dayPhase);
    const T = $e81502d4aa27ba48$export$ff1cf6056aa7ef44(theme.pal, ds.light);
    $e81502d4aa27ba48$var$setAnim(anim, ds, tune);
    $e81502d4aa27ba48$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    const g = $e81502d4aa27ba48$var$makeG(ctx);
    $e81502d4aa27ba48$var$DYN = null; // draw the animated parts inline
    $e81502d4aa27ba48$var$CUR_G = g;
    $e81502d4aa27ba48$var$CUR_T = T;
    // ...but the overhead channel is still RECORDED even here, because its whole
    // point is to land after the effects, and composeBody runs before them.
    const over = $e81502d4aa27ba48$var$OVER = [];
    $e81502d4aa27ba48$var$composeBody(g, T, theme, tune, regionKey, recipe, roomName, opts);
    $e81502d4aa27ba48$var$OVER = null;
    $e81502d4aa27ba48$var$drawEffects(g, T, theme, tune, ds, anim, recipe, opts);
    for (const fn of over)fn(g, T, $e81502d4aa27ba48$var$overheadFx(tune, anim, opts));
}
/**
 * What an overhead closure is told about the frame it is being replayed into.
 *
 * The same handful of facts drawEffects works from, because anything drawn
 * above the effects generally has to agree with them about the light — the
 * rock's shadow is cast by the very shafts it is drawn over.
 */ const $e81502d4aa27ba48$var$overheadFx = (tune, anim, opts)=>({
        tune: tune,
        anim: anim,
        col: anim?.col ?? opts.col ?? 0,
        row: anim?.row ?? opts.row ?? 0
    });
function $e81502d4aa27ba48$export$9b747065b14bfa5f(regionKey, recipe, roomName, opts = {}) {
    const { theme: theme, tune: tune } = $e81502d4aa27ba48$var$resolveTheme(regionKey, opts);
    // `plan` is the tile's ground plan (see PLAN): where its buildings and its
    // water are, for anything that has to walk about on it. Filled by the first
    // refreshStatic, because it takes a full compose pass to know.
    return {
        regionKey: regionKey,
        recipe: recipe,
        roomName: roomName,
        opts: opts,
        theme: theme,
        tune: tune,
        canvas: null,
        dyn: [],
        over: [],
        key: null,
        plan: null
    };
}
function $e81502d4aa27ba48$export$ca17ef1db7f8dd8f(tile, dayPhase) {
    const ds = $e81502d4aa27ba48$export$f7a259d7313a81f1(tile.theme, tile.tune, dayPhase);
    const key = $e81502d4aa27ba48$export$527771e9cfacbb46(ds);
    if (key === tile.key) return false;
    if (!tile.canvas) {
        tile.canvas = document.createElement('canvas');
        tile.canvas.width = tile.canvas.height = $e81502d4aa27ba48$export$3175e1b22a5f59e8;
    }
    const g = $e81502d4aa27ba48$var$makeG(tile.canvas.getContext('2d'));
    $e81502d4aa27ba48$var$setAnim(null, ds, tile.tune);
    $e81502d4aa27ba48$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    const dyn = $e81502d4aa27ba48$var$DYN = [];
    const over = $e81502d4aa27ba48$var$OVER = [];
    // The plan does not depend on the hour, so it is only collected the first
    // time — a tile repaints a couple of dozen times a game day and the buildings
    // do not move between one and the next.
    const plan = $e81502d4aa27ba48$var$PLAN = tile.plan ? null : {
        blocks: [],
        water: null,
        focus: null
    };
    $e81502d4aa27ba48$var$CUR_G = null;
    $e81502d4aa27ba48$var$CUR_T = null;
    // UNTINTED: brightness is applied at composite time as a multiply
    $e81502d4aa27ba48$var$composeBody(g, tile.theme.pal, tile.theme, tile.tune, tile.regionKey, tile.recipe, tile.roomName, tile.opts);
    $e81502d4aa27ba48$var$DYN = null;
    $e81502d4aa27ba48$var$OVER = null;
    $e81502d4aa27ba48$var$PLAN = null;
    tile.dyn = dyn;
    tile.over = over;
    if (plan) tile.plan = plan;
    tile.key = key;
    return true;
}
function $e81502d4aa27ba48$export$217de4d82c975a34(ctx, tile, anim) {
    const ds = $e81502d4aa27ba48$export$f7a259d7313a81f1(tile.theme, tile.tune, anim?.dayPhase);
    const T = $e81502d4aa27ba48$export$ff1cf6056aa7ef44(tile.theme.pal, ds.light);
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(tile.canvas, 0, 0);
    if (ds.light < 1) {
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = $e81502d4aa27ba48$export$8ee26169c9b5b8ee(ds.light);
        ctx.fillRect(0, 0, $e81502d4aa27ba48$export$3175e1b22a5f59e8, $e81502d4aa27ba48$export$3175e1b22a5f59e8);
        ctx.globalCompositeOperation = 'source-over';
    }
    $e81502d4aa27ba48$var$setAnim(anim, ds, tile.tune);
    $e81502d4aa27ba48$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    $e81502d4aa27ba48$var$SHADOW_PASS = false;
    $e81502d4aa27ba48$var$IN_SHADOW = false;
    $e81502d4aa27ba48$var$DYN = null;
    $e81502d4aa27ba48$var$OVER = null;
    const g = $e81502d4aa27ba48$var$makeG(ctx);
    for (const fn of tile.dyn)fn(g, T);
    $e81502d4aa27ba48$var$drawEffects(g, T, tile.theme, tile.tune, ds, anim, tile.recipe, {
        ...tile.opts,
        col: anim?.col ?? tile.opts.col,
        row: anim?.row ?? tile.opts.row
    });
    // ...and last of all, what is over the room rather than in it
    const fx = $e81502d4aa27ba48$var$overheadFx(tile.tune, anim, tile.opts);
    for (const fn of tile.over)fn(g, T, fx);
}
function $e81502d4aa27ba48$export$9f394932e7372a96(regionKey, recipe, roomName, opts = {}) {
    const out = document.createElement('canvas');
    out.width = $e81502d4aa27ba48$export$3175e1b22a5f59e8;
    out.height = $e81502d4aa27ba48$export$3175e1b22a5f59e8;
    $e81502d4aa27ba48$export$f0a8786a677b14c5(out.getContext('2d'), regionKey, recipe, roomName, opts);
    return out.toDataURL('image/png');
}


/**
 * World Clock — one planetary rotation, a local time for every TILE (M3 S9).
 *
 * The raid map already had a wall-clock day/night cycle, but it was a GLOBAL
 * one: every region shared a single `dayPhase`, so raiding the far east and the
 * far west showed the same sun. This promotes that cycle into a world clock.
 * There is still exactly one planet and one rotation — what changes is that
 * local time is derived from where you are standing on it.
 *
 * THE CLOCK IS KEYED TO TILES, NOT REGIONS. `getTilePhase({row, col})` is the
 * primitive; a region's clock is just its capital tile's, and a raid's clock is
 * just its site tile's. This costs nothing today (each region is one contiguous
 * blob, so its capital is a fair stand-in) and it is what stops the clock ever
 * having to be rewritten: the day a region is scattered across two hemispheres
 * — L6's world reseed, or simply a second Shard Cities on the far side — every
 * caller already asks about a place rather than about a name, and nothing here
 * has to change. Time and territory are separate facts about a tile.
 *
 * LONGITUDE COMES FROM THE MAP, NOT FROM A TABLE. A tile's longitude is its
 * COLUMN in `worldMap.js`, so geography and time cannot drift apart: move a
 * capital east and its clock moves with it. That is deliberate — see the header
 * of `js/data/worldMap.js`, which names this file as the reason it is
 * hand-authored and fixed. (L6's reseed inherits the coupling for free.)
 *
 * The planet rotates WEST TO EAST, so an eastern tile meets the sun first and
 * its local time runs AHEAD. `planetPhase()` is the time at the prime meridian
 * (the map's western edge); every local time is that plus a longitude offset.
 * The map is 17 columns wide and spans the whole planet, so the two outermost
 * capitals sit ~18 hours apart — the difference is meant to be dramatic.
 *
 * NO MECHANICAL EFFECT IN M3. Nothing here is read by a raid roll, a payout or
 * a check; it is time-of-day made visible while L3 calibrates. The full
 * day/night raid mechanic is L4 work, and it will read `getTilePhase` rather
 * than inventing a second clock.
 *
 * No browser dependencies.
 *
 * See docs/layers/3-syndicate/design.md §8.
 */ 
const $c454fb723f814d89$export$fa2e89afea4272f6 = 600000;
// Where "now" sits in the cycle on first ship. Arbitrary — the world runs
// continuously either way — but it is part of the clock's definition, so it
// lives with the clock.
const $c454fb723f814d89$var$PHASE_OFFSET = 0.35;
const $c454fb723f814d89$export$675fe0ed743a3b5 = 0.25;
const $c454fb723f814d89$export$1ec997190f8239d2 = 0.75;
const $c454fb723f814d89$export$8f9a7291e7690131 = 0.0625;
function $c454fb723f814d89$export$45255f3db062a699(now = Date.now()) {
    return (now / $c454fb723f814d89$export$fa2e89afea4272f6 + $c454fb723f814d89$var$PHASE_OFFSET) % 1;
}
function $c454fb723f814d89$export$45596f28e35b9f51(col) {
    const width = $ce6dd72bc4611534$export$e3c642cf362e5b0d.width;
    return (col + 0.5) / width % 1;
}
function $c454fb723f814d89$export$bd93155bc5e87ed(tile) {
    return tile ? $c454fb723f814d89$export$45596f28e35b9f51(tile.col) : null;
}
function $c454fb723f814d89$export$36b939441d399160(regionId) {
    return $ce6dd72bc4611534$export$e3c642cf362e5b0d.capitals[regionId] || null;
}
function $c454fb723f814d89$export$3fc841c22b2803(regionId) {
    return $c454fb723f814d89$export$bd93155bc5e87ed($c454fb723f814d89$export$36b939441d399160(regionId));
}
// Terrain a raid can be sited on. Ocean is excluded because a raid happens on
// the ground, and `#` because it is the map's "nothing here" marker — the same
// land-only rule Operations already applies to staging points.
const $c454fb723f814d89$var$RAID_TERRAIN = new Set([
    '.',
    '^'
]);
function $c454fb723f814d89$export$97e2a9580a4aea8d(regionId, { raidable: raidable = false } = {}) {
    const { width: width, height: height, regionRows: regionRows, terrainRows: terrainRows, regionOrder: regionOrder } = $ce6dd72bc4611534$export$e3c642cf362e5b0d;
    const tiles = [];
    for(let row = 0; row < height; row++)for(let col = 0; col < width; col++){
        if (regionOrder[regionRows[row]?.[col]] !== regionId) continue;
        if (raidable && !$c454fb723f814d89$var$RAID_TERRAIN.has(terrainRows[row]?.[col])) continue;
        tiles.push({
            row: row,
            col: col
        });
    }
    return tiles;
}
function $c454fb723f814d89$export$73436c04d978a296(regionId, rng = Math.random) {
    const tiles = $c454fb723f814d89$export$97e2a9580a4aea8d(regionId, {
        raidable: true
    });
    if (!tiles.length) return $c454fb723f814d89$export$36b939441d399160(regionId);
    return tiles[Math.floor(rng() * tiles.length)];
}
function $c454fb723f814d89$export$e9c9190bc51f46a8(longitude, now = Date.now()) {
    return ($c454fb723f814d89$export$45255f3db062a699(now) + longitude) % 1;
}
function $c454fb723f814d89$export$a16ed293100b6f71(phase) {
    return Math.max(0.4, Math.min(1, 0.4 + 0.85 * Math.cos((phase - 0.5) * 2 * Math.PI)));
}
function $c454fb723f814d89$export$45f6af437d59d9ba(phase) {
    return ($c454fb723f814d89$export$a16ed293100b6f71(phase) - 0.4) / 0.6;
}
function $c454fb723f814d89$export$1f0424de551b57e2(phase) {
    const p = (phase % 1 + 1) % 1;
    if (p < $c454fb723f814d89$export$675fe0ed743a3b5 || p >= $c454fb723f814d89$export$1ec997190f8239d2) return 'night';
    if (p < $c454fb723f814d89$export$675fe0ed743a3b5 + $c454fb723f814d89$export$8f9a7291e7690131) return 'dawn';
    if (p >= $c454fb723f814d89$export$1ec997190f8239d2 - $c454fb723f814d89$export$8f9a7291e7690131) return 'dusk';
    return 'day';
}
const $c454fb723f814d89$export$398c19453c5d1c47 = {
    night: "\uD83C\uDF19",
    dawn: "\uD83C\uDF05",
    day: "\u2600\uFE0F",
    dusk: "\uD83C\uDF07"
};
function $c454fb723f814d89$export$f6001aa54a01efa(phase) {
    const p = (phase % 1 + 1) % 1;
    const totalMinutes = Math.floor(p * 1440);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
function $c454fb723f814d89$export$239629a81011f2a4(tile, now = Date.now()) {
    const longitude = $c454fb723f814d89$export$bd93155bc5e87ed(tile) ?? 0;
    const phase = $c454fb723f814d89$export$e9c9190bc51f46a8(longitude, now);
    const name = $c454fb723f814d89$export$1f0424de551b57e2(phase);
    return {
        tile: tile || null,
        longitude: longitude,
        phase: phase,
        name: name,
        icon: $c454fb723f814d89$export$398c19453c5d1c47[name],
        light: $c454fb723f814d89$export$a16ed293100b6f71(phase),
        time: $c454fb723f814d89$export$f6001aa54a01efa(phase)
    };
}
function $c454fb723f814d89$export$30a7d07879d0db1d(regionId, now = Date.now()) {
    return {
        ...$c454fb723f814d89$export$239629a81011f2a4($c454fb723f814d89$export$36b939441d399160(regionId), now),
        regionId: regionId
    };
}
function $c454fb723f814d89$export$e15059ad23f67dd4(regionId, site, now = Date.now()) {
    return $c454fb723f814d89$export$239629a81011f2a4(site || $c454fb723f814d89$export$36b939441d399160(regionId), now);
}
function $c454fb723f814d89$export$d728c3c4e18e092b(now = Date.now()) {
    return Object.values($ce6dd72bc4611534$export$e3c642cf362e5b0d.regionOrder).map((id)=>$c454fb723f814d89$export$30a7d07879d0db1d(id, now));
}


// Where the raid team IS while a raid runs, and how each member is standing.
//
// Pure geometry over the raid's own clock — no DOM, no canvas — so the whole
// motion model is testable headless. raidTeamAnim.js turns what this returns
// into pixels; raidMapAnim.js decides which tiles to draw it on.
//
// Two coordinate spaces, and they are easy to confuse:
//   GRID space — fractional (row, col) over the raid grid. 1 unit = one tile.
//                col is +x (right), row is +y (down), so a heading angle is
//                atan2(dRow, dCol) and screen-space rotation Just Works.
//   PARTY space — a member's offset from the party's own centre, in TILE
//                FRACTIONS (0.1 = a tenth of a tile edge). The caller scales
//                by whatever a tile is worth in pixels, so nothing in here
//                has to know that a tile canvas is 120px.
// Half a tile of walking. The party crosses a tile boundary in two of these —
// the second half of one room and the first half of the next — so ONE constant
// sets the walking speed everywhere on the map.
//
// It is tuned to the road: a road room's baseDuration is 10s and the clamp
// below turns that into a continuous 5s-per-half-tile traverse with no dwell
// at all. Gates and hazards run 60-120s, so they get the same 5s walk in, a
// long search, and the same 5s walk out. Rooms therefore differ in how long
// the team STAYS, never in how fast it moves — which is what makes a road read
// as a road rather than as a room the team happens to leave early.
const $b44bbfd29b442498$export$83960d63e81a8a78 = 5000;
// A room the team cannot cross at that pace in the time it lasts has no dwell
// phase at all: the two legs are squeezed until they meet and the team crosses
// without stopping. That is what a road IS — 10s against the ~10s it takes to
// walk a tile — and it is why road tiles need no special case anywhere here.
// How far a member has to walk from their place in the file to their post,
// when the tile does not say. Tiles vary a lot — a lakeside post is out on the
// bank, most posts are a stone's throw from the middle — so `partyAt` takes the
// real figure and this is only the fallback.
const $b44bbfd29b442498$var$SPREAD_TILES = 0.25;
/**
 * How long the team takes to fan out on arrival, and to gather back up before
 * leaving, for a spread of `tiles`.
 *
 * NOT a look-right number. It is the distance at the walking speed set above,
 * with the smoothstep's 1.5x peak factor allowed for, so **the fastest a member
 * ever moves while spreading out is the speed they walk at** — whatever the
 * tile asks them to spread across.
 *
 * It was a flat 1100ms, which put the peak at three and a half times walking
 * pace and read as three people being yanked apart. A flat figure large enough
 * for a lakeside post would have had the other tiles crawling instead. The
 * distance is the thing you can measure and the speed is the thing the eye
 * judges, so the duration is the one that gets to be derived.
 */ const $b44bbfd29b442498$var$settleFor = (tiles)=>Math.max(0.02, tiles) / 0.5 * $b44bbfd29b442498$export$83960d63e81a8a78 * 1.5;
// ...and the spread happens while the party is STANDING STILL, in the dwell
// either side, rather than over the last stretch of the walk in. Overlapping
// the two added the walk's own velocity to the spread's, so the one moment the
// team was meant to settle was the moment it moved fastest.
const $b44bbfd29b442498$var$TAU = Math.PI * 2;
const $b44bbfd29b442498$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $b44bbfd29b442498$var$mix = (a, b, t)=>a + (b - a) * t;
// Smoothstep. Zero slope at both ends, which is the whole point: it is what
// keeps a blend from starting and stopping abruptly.
const $b44bbfd29b442498$var$smooth = (t)=>t * t * (3 - 2 * t);
function $b44bbfd29b442498$export$3c05aaf71f141f73(a) {
    let x = a % $b44bbfd29b442498$var$TAU;
    if (x > Math.PI) x -= $b44bbfd29b442498$var$TAU;
    if (x <= -Math.PI) x += $b44bbfd29b442498$var$TAU;
    return x;
}
function $b44bbfd29b442498$export$91fbc6e5ab9ab0f5(a, b, t) {
    let d = (b - a) % $b44bbfd29b442498$var$TAU;
    if (d > Math.PI) d -= $b44bbfd29b442498$var$TAU;
    if (d < -Math.PI) d += $b44bbfd29b442498$var$TAU;
    return $b44bbfd29b442498$export$3c05aaf71f141f73(a + d * t);
}
function $b44bbfd29b442498$export$e35a622415b5919f(path, index, elapsedMs, durationMs, stage = null) {
    const n = path?.length || 0;
    if (!n) return {
        row: 0,
        col: 0,
        heading: 0,
        gait: 0,
        walking: false
    };
    const i = Math.max(0, Math.min(n - 1, index | 0));
    const A = path[i];
    const P = i > 0 ? path[i - 1] : null;
    const N = i + 1 < n ? path[i + 1] : null;
    const dur = Math.max(0, durationMs || 0);
    // A room the team has overstayed (the raid loop ticks at 1Hz, so a step can
    // be up to a second past due before the index flips) holds them at the seam
    // rather than extrapolating past it — walking on and then being yanked back
    // when the tick lands is worse than marching on the spot for a moment.
    const e = Math.max(0, Math.min(dur, elapsedMs || 0));
    // Where they gather, and therefore how far each leg of the crossing is.
    // On almost every tile this is the middle and both legs are half a tile,
    // which is the case every constant in here was tuned against.
    const anchor = stage?.anchor;
    const aRow = A.row + (anchor?.y || 0), aCol = A.col + (anchor?.x || 0);
    // Each leg is timed by its OWN length, so the pace is the same on a tile
    // the team walks straight across and one where it has to come round a lake.
    // A leg that will not fit in the room's own clock is scaled down with its
    // partner rather than on its own — a road's two halves have to keep meeting
    // in the middle, and that is what makes it a continuous traverse.
    const legIn = P ? Math.hypot(aRow - (A.row + P.row) / 2, aCol - (A.col + P.col) / 2) : 0;
    const legOut = N ? Math.hypot((A.row + N.row) / 2 - aRow, (A.col + N.col) / 2 - aCol) : 0;
    let wIn = legIn / $b44bbfd29b442498$var$WALK_SPEED, wOut = legOut / $b44bbfd29b442498$var$WALK_SPEED;
    if (wIn + wOut > dur && wIn + wOut > 0) {
        const squeeze = dur / (wIn + wOut);
        wIn *= squeeze;
        wOut *= squeeze;
    }
    // How long they actually stand on this tile, and how much of that each end
    // of it spends spreading out and gathering back up. A road's dwell is zero,
    // so its settle is zero and the team marches straight through in file —
    // still no road special case anywhere.
    const dwell = Math.max(0, dur - wIn - wOut);
    const settle = Math.min($b44bbfd29b442498$var$settleFor(stage?.spread ?? $b44bbfd29b442498$var$SPREAD_TILES), dwell / 2);
    // The two bearings this tile has: the one they arrive on and the one they
    // leave on. They differ wherever the path turns, and the whole tile has to
    // get from one to the other WITHOUT a step in it — see the dwell below.
    const inHeading = P ? Math.atan2(A.row - P.row, A.col - P.col) : null;
    const outHeading = N ? Math.atan2(N.row - A.row, N.col - A.col) : null;
    // ...so the team TURNS ACROSS THE TILE rather than pivoting at some instant
    // inside it. Interpolating over the whole step is what makes this continuous
    // everywhere at once: it leaves at `inHeading`, which is the bearing the
    // previous step arrived on, and reaches `outHeading` exactly as the next
    // step begins on it. A tile the path runs straight through has the two
    // equal and nothing rotates at all.
    //
    // Every earlier attempt pinned the turn to a phase boundary — arrival,
    // then the dwell — and each one moved the jump somewhere else instead of
    // removing it. A road has no dwell to hide a turn in, which is what finally
    // made that obvious.
    let row = aRow, col = aCol;
    let heading = inHeading != null && outHeading != null ? $b44bbfd29b442498$export$91fbc6e5ab9ab0f5(inHeading, outHeading, dur > 0 ? e / dur : 1) : outHeading ?? inHeading ?? 0;
    let walking = false;
    // Marching unless they are standing still — see the settle ramps below.
    let gait = 1;
    if (wIn > 0 && e < wIn) {
        // walking in from the shared edge with the previous tile
        const k = e / wIn;
        row = $b44bbfd29b442498$var$mix((A.row + P.row) / 2, aRow, k);
        col = $b44bbfd29b442498$var$mix((A.col + P.col) / 2, aCol, k);
        walking = true;
    } else if (wOut > 0 && e >= dur - wOut) {
        // `>=` rather than `>` so the two walk windows TILE the duration when
        // the squeeze makes them meet in the middle — a road would otherwise
        // have a single frame of standing still at its exact midpoint.
        // walking out toward the shared edge with the next tile
        const k = (e - (dur - wOut)) / wOut;
        row = $b44bbfd29b442498$var$mix(aRow, (A.row + N.row) / 2, k);
        col = $b44bbfd29b442498$var$mix(aCol, (A.col + N.col) / 2, k);
        walking = true;
    } else if (settle > 0) {
        // Standing on the tile. They arrive in file and fan out over `settle`,
        // hold their posts, then gather back into file in time to leave — so
        // the formation only ever changes while the party's own centre is
        // still, and the walk's velocity is never added to the spread's.
        const into = e - wIn;
        gait = $b44bbfd29b442498$var$clamp01(into < settle ? 1 - into / settle : into > dwell - settle ? 1 - (dwell - into) / settle : 0);
    } else gait = 0; // a dwell too short to spread out in: just stand there
    return {
        row: row,
        col: col,
        heading: heading,
        gait: gait,
        walking: walking
    };
}
function $b44bbfd29b442498$export$340c4cb4c285ee0f(raid, now) {
    const start = raid?.roomStartTime ?? raid?.startTime ?? now;
    const end = raid?.nextRoomTime ?? start;
    return {
        elapsedMs: now - start,
        durationMs: Math.max(0, end - start)
    };
}
// ============================================================================
// SEARCH POSTS — where on a tile a member actually stands
// ============================================================================
// Until now the team searched from a slowly turning ring about the tile's
// centre, which is a shape, not a place: it put people on roofs, and on the
// water tile it put all three of them in the lake.
//
// A post is a spot on the tile that a person could really stand on, picked
// once per tile from the ground plan the renderer now publishes. Members walk
// out to their posts on arrival and potter about them until it is time to
// leave. Fixing the post rather than continuously projecting a moving ring out
// of the obstacles is the whole trick: a projection is discontinuous wherever
// the nearest way out of a building flips from one wall to another, and this
// animation has already been bitten twice by exactly that class of bug.
// How close to a wall or a waterline a post may sit. A figure is ~6px wide in
// a 120px tile, so this is a comfortable body's width clear of it.
const $b44bbfd29b442498$var$POST_CLEARANCE = 0.055;
// Rings the candidates are drawn from, as a fraction of the tile. Far enough
// apart to look like three people covering an area, near enough that the team
// still reads as a team. The rings widen when the inner ones are built over.
//
// The outermost is 0.42 for a specific reason: the lake's bank sits at 0.35 and
// a post needs POST_CLEARANCE beyond that, which leaves a walkable band from
// 0.405 to the 0.445 where a figure starts hanging into the next room. There
// is one ring's worth of dry land on a water tile and this is it. (Diagonally
// there is far more, and the golden-angle sweep finds it first.)
const $b44bbfd29b442498$var$POST_RINGS = [
    0.20,
    0.30,
    0.42
];
const $b44bbfd29b442498$var$POST_ANGLES = 16;
function $b44bbfd29b442498$export$210e317b6c4ae768(plan, tilePx) {
    if (!plan || !tilePx) return null;
    const f = (v)=>v / tilePx - 0.5;
    return {
        blocks: (plan.blocks || []).map((b)=>({
                x0: f(b.x0),
                y0: f(b.y0),
                x1: f(b.x1),
                y1: f(b.y1)
            })),
        water: plan.water ? {
            cx: f(plan.water.cx),
            cy: f(plan.water.cy),
            r: plan.water.r / tilePx,
            bank: plan.water.bank / tilePx
        } : null,
        focus: plan.focus ? {
            x: f(plan.focus.x),
            y: f(plan.focus.y)
        } : null
    };
}
// How tightly the team gathers round a campfire. Close enough to be sharing
// it, far enough not to be standing in it.
const $b44bbfd29b442498$var$CAMP_RINGS = [
    0.085,
    0.125,
    0.17
];
function $b44bbfd29b442498$export$e09eea79f1e22a62(plan, x, y, clear = $b44bbfd29b442498$var$POST_CLEARANCE) {
    if (Math.abs(x) > 0.5 - clear || Math.abs(y) > 0.5 - clear) return false;
    const w = plan?.water;
    // The bank is walkable shingle; the water itself is not.
    if (w && Math.hypot(x - w.cx, y - w.cy) < w.bank + clear) return false;
    for (const b of plan?.blocks || []){
        if (x > b.x0 - clear && x < b.x1 + clear && y > b.y0 - clear && y < b.y1 + clear) return false;
    }
    return true;
}
function $b44bbfd29b442498$export$1c385e8d618a62c3(count, plan, seed = 0, opts = {}) {
    const n = Math.max(0, count | 0);
    if (!n) return [];
    // Where the ring of candidates is centred, and how wide it runs. A camp
    // gathers round its fire; everywhere else works outward from the middle of
    // the tile. Same routine either way — the tile just says where and how far.
    const around = opts.around || {
        x: 0,
        y: 0
    };
    const rings = opts.rings || $b44bbfd29b442498$var$POST_RINGS;
    const spacing = opts.spacing ?? [
        0.17,
        0.10,
        0
    ];
    const phase = seed % 360 / 360 * $b44bbfd29b442498$var$TAU;
    const taken = [];
    // A post has to be this far from the ones already taken. Relaxed if the
    // walkable ground is too tight to honour it — better crowded than nobody.
    for (const apart of spacing){
        for (const radius of rings)for(let a = 0; a < $b44bbfd29b442498$var$POST_ANGLES && taken.length < n; a++){
            // Golden-angle order rather than sweeping round, so the first
            // few candidates tried are already spread out
            const ang = phase + a * 2.39996;
            const x = around.x + Math.cos(ang) * radius, y = around.y + Math.sin(ang) * radius;
            if (!$b44bbfd29b442498$export$e09eea79f1e22a62(plan, x, y)) continue;
            if (taken.some((p)=>Math.hypot(p.x - x, p.y - y) < apart)) continue;
            taken.push({
                x: x,
                y: y,
                radius: radius
            });
        }
        if (taken.length >= n) break;
    }
    // Nowhere at all would stand on: a tile built kerb to kerb. Fall back to
    // the ring the team used before any of this existed — being on a roof beats
    // being in a heap on one spot, and it cannot happen on a generated map.
    while(taken.length < n){
        const ang = phase + taken.length * 2.39996;
        taken.push({
            x: around.x + Math.cos(ang) * 0.115,
            y: around.y + Math.sin(ang) * 0.115,
            radius: 0.115
        });
    }
    return taken.slice(0, n);
}
function $b44bbfd29b442498$export$5c7563bc4285410(plan, count, seed, roomType) {
    // A campsite is the one room the team stops AT rather than searches. It
    // needs a fire to gather round; a save written before tiles had plans, or
    // a region that draws its rest stop some other way, falls back to an
    // ordinary search and looks exactly as it did before.
    const camping = roomType === 'campsite' && !!plan?.focus;
    const posts = camping ? $b44bbfd29b442498$export$1c385e8d618a62c3(count, plan, seed, {
        around: plan.focus,
        rings: $b44bbfd29b442498$var$CAMP_RINGS,
        spacing: [
            0.075,
            0.05,
            0
        ]
    }) : $b44bbfd29b442498$export$1c385e8d618a62c3(count, plan, seed);
    const anchor = camping ? plan.focus : $b44bbfd29b442498$export$98f127b3f50724cc(plan);
    return {
        anchor: anchor,
        resting: camping,
        spread: $b44bbfd29b442498$export$f01814d0e31cb32b(posts, anchor),
        // Posts are places ON THE TILE; what a pose wants is an offset from the
        // party, and the anchor sits between the two. Rebased once here rather
        // than in every drawn frame.
        postOffsets: posts.map((p)=>({
                x: p.x - anchor.x,
                y: p.y - anchor.y
            }))
    };
}
function $b44bbfd29b442498$export$f01814d0e31cb32b(posts, anchor = null) {
    const ax = anchor?.x || 0, ay = anchor?.y || 0;
    let far = 0;
    for (const p of posts || [])far = Math.max(far, Math.hypot(p.x - ax, p.y - ay));
    return far || $b44bbfd29b442498$var$SPREAD_TILES;
}
function $b44bbfd29b442498$export$98f127b3f50724cc(plan) {
    if ($b44bbfd29b442498$export$e09eea79f1e22a62(plan, 0, 0)) return {
        x: 0,
        y: 0
    };
    for (const radius of $b44bbfd29b442498$var$POST_RINGS){
        let best = null;
        for(let a = 0; a < $b44bbfd29b442498$var$POST_ANGLES * 2; a++){
            const ang = a / ($b44bbfd29b442498$var$POST_ANGLES * 2) * $b44bbfd29b442498$var$TAU;
            const x = Math.cos(ang) * radius, y = Math.sin(ang) * radius;
            if (!$b44bbfd29b442498$export$e09eea79f1e22a62(plan, x, y)) continue;
            // The shallowest way out: whichever direction reaches ground first
            if (!best || Math.hypot(x, y) < Math.hypot(best.x, best.y)) best = {
                x: x,
                y: y
            };
        }
        if (best) return best;
    }
    return {
        x: 0,
        y: 0
    }; // nowhere to stand at all; see searchPosts
}
// Tiles per millisecond, from the one constant that sets the pace.
const $b44bbfd29b442498$var$WALK_SPEED = 0.5 / $b44bbfd29b442498$export$83960d63e81a8a78;
function $b44bbfd29b442498$export$5ae338d6b723c743(i, count, tSec, party, seed = 0, post = null) {
    // golden-angle spacing plus the seed: two members are never in step, and
    // the same member is in the same place every frame
    const ph = i * 2.39996 + seed % 997 * 0.0063;
    // Eased rather than linear: the settle starts and ends at rest, so the
    // formation change reads as three people spreading out rather than three
    // people being slid into place at a constant rate.
    const gait = $b44bbfd29b442498$var$smooth($b44bbfd29b442498$var$clamp01(party?.gait ?? 0));
    const heading = party?.heading ?? 0;
    // --- marching: single file, staggered a little off the centreline so the
    // one behind is not hidden by the one in front. Authored in the party's
    // own frame (forward/right) and rotated into grid space below.
    const rank = Math.floor((i + 1) / 2);
    const mf = -0.085 * rank;
    const mr = i === 0 ? 0 : 0.05 * (i % 2 ? -1 : 1);
    const c = Math.cos(heading), s = Math.sin(heading);
    const mx = mf * c - mr * s;
    const my = mf * s + mr * c;
    // --- searching: their post, with a small amount of shifting about on it.
    // The wander is a fraction of the clearance a post is chosen with, so
    // pottering can never carry anyone into the wall they are standing beside.
    const px = post ? post.x : Math.cos(ph + tSec * 0.10) * 0.115;
    const py = post ? post.y : Math.sin(ph + tSec * 0.10) * 0.115;
    const sx = px + 0.016 * Math.sin(tSec * 0.29 + ph);
    const sy = py + 0.016 * Math.sin(tSec * 0.23 + ph * 1.7);
    // The torch leads where they walk and sweeps where they search. The sweep
    // is centred on the way they face out of the tile's middle, so three
    // members between them cover the ground instead of all raking one corner.
    const sweep = Math.atan2(sy, sx) + Math.sin(tSec * 0.55 + ph) * 0.9;
    return {
        dx: $b44bbfd29b442498$var$mix(sx, mx, gait),
        dy: $b44bbfd29b442498$var$mix(sy, my, gait),
        facing: $b44bbfd29b442498$export$91fbc6e5ab9ab0f5(sweep, heading, gait),
        // a two-beat walk cycle, decaying to a slow shift of weight on the spot
        stride: gait * Math.sin(tSec * 5.6 + ph) + (1 - gait) * 0.16 * Math.sin(tSec * 0.9 + ph),
        gait: gait
    };
}



// The raid team, drawn on the map tile it is standing on.
//
// A figure is a pixel silhouette about 15px tall in a tile's own 120px space —
// roughly a tenth of the tile, which is several times life size against the
// buildings beside it. That is deliberate: a to-scale person on this map would
// be two pixels and would vanish at the 64-80px the cell is actually displayed
// at. These are map TOKENS that happen to be shaped like people, and the thing
// that actually reads at that size is not the body at all, it is the torch —
// a moving light on dark ground is legible when the figure holding it is not.
//
// Drawn by raidMapAnim.js AFTER composite(), which means after the day tint's
// multiply pass. Nothing here is darkened for us, so everything here darkens
// itself (see shade()) — otherwise the team would glow at midnight like the
// lit windows do, and lit windows are lit for a reason.

// Procedural, seeded character portraits.
//
// A front-facing pixel-art bust drawn from a single seeded PRNG: the same
// (seed, faction) always yields the same face, so a portrait can be derived
// from a character's identity and re-rolled at will — unlimited variety, no art
// assets. This mirrors the map-tile renderer (js/modules/roomImageGen.js): a
// stable string->PRNG (makePRNG) plus a tiny rect/disc drawing API
// (js/modules/pixelDraw.js) painting a small logical canvas that gets
// nearest-neighbour upscaled to display size.
//
// Authored on a fixed 64x64 logical grid (AVATAR_BASE). All feature values are
// rolled up front, in a fixed order, into a `feat` object; drawing then reads
// that object. Rolling before drawing means a disabled config toggle removes
// only its own feature instead of shifting every later rng draw, so toggling a
// knob in avatar-lab.html changes one thing at a time.

// Shared, tile-agnostic pixel-drawing primitives.
//
// These are lifted verbatim (minus the tile renderer's SHADOW_PASS bookkeeping)
// from js/modules/roomImageGen.js so that other pixel-art generators — the
// avatar portraits in avatarGen.js, for one — can reuse the same tiny rect/disc
// API without importing the whole map-tile renderer (region themes, recipes,
// animation loop). roomImageGen.js keeps its own copies for now; if these two
// ever diverge, reconcile here first. Deduping the tile renderer onto this
// module is a deliberate follow-up, kept out of scope to avoid touching the
// working map pipeline.
// makeG(ctx) -> a minimal drawing API over a 2D context.
//   g.r(x, y, w, h, color)  fill a rectangle (coords floored to whole pixels)
//   g.a(alpha, fn)          run fn with a temporary globalAlpha, then restore
// The context only needs fillStyle, fillRect and globalAlpha, so a lightweight
// recording stub works in tests where no real canvas exists.
function $61e5c68ae974806a$export$a2661aea9d478234(ctx) {
    return {
        r (x, y, w, h, c) {
            ctx.fillStyle = c;
            ctx.fillRect(x | 0, y | 0, w | 0, h | 0);
        },
        a (alpha, fn) {
            ctx.globalAlpha = alpha;
            fn();
            ctx.globalAlpha = 1;
        }
    };
}
const $61e5c68ae974806a$export$d0f79e97207f27e3 = (rng, min, max)=>min + Math.floor(rng() * (max - min + 1));
function $61e5c68ae974806a$export$56b4dd62e08af00e(g, cx, cy, r, c) {
    for(let dy = -r; dy <= r; dy++){
        const dx = Math.floor(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 2 * dx + 1, 1, c);
    }
}
function $61e5c68ae974806a$export$3c006493fcc1917a(g, cx, cy, r, c) {
    for(let dy = -r; dy <= r; dy++){
        const dx = Math.round(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 1, 1, c);
        g.r(cx + dx, cy + dy, 1, 1, c);
    }
}
function $61e5c68ae974806a$export$585177364ee175b7(g, rng, x, y, w, h, c1, c2, density = 0.2) {
    g.r(x, y, w, h, c1);
    const n = Math.floor(w * h * density);
    for(let i = 0; i < n; i++)g.r(x + rng() * w, y + rng() * h, 1, 1, c2);
}
function $61e5c68ae974806a$export$5c4c5253709c2db0(g, x, y, len, c) {
    g.r(x, y, len, 1, c);
}
function $61e5c68ae974806a$export$77998c5980b7319b(g, x, y, len, c) {
    g.r(x, y, 1, len, c);
}
function $61e5c68ae974806a$export$f09f4965d11229b7(srcCanvas, size, makeCanvas) {
    const out = makeCanvas(size, size);
    const octx = out.getContext("2d");
    octx.imageSmoothingEnabled = false;
    octx.drawImage(srcCanvas, 0, 0, size, size);
    return out;
}


const $d6139340df3c28f5$export$aaa4582620b40efc = 64; // authored logical resolution
const $d6139340df3c28f5$export$ba4617d152d9e9eb = 80; // default display px (the in-game avatar box)
const $d6139340df3c28f5$export$3a2c4b2c8c374a0f = {
    dominion: {
        bg1: "#2b3446",
        bg2: "#141a24",
        garb: "#3f4a5e",
        garbDark: "#28303f",
        accent: "#e0b45e",
        glow: "#7ec8ff"
    },
    veil: {
        bg1: "#433a5a",
        bg2: "#14111d",
        garb: "#3a2c52",
        garbDark: "#221836",
        accent: "#b98cff",
        glow: "#66f0e0"
    },
    wilders: {
        bg1: "#33301f",
        bg2: "#17160e",
        garb: "#4b3d29",
        garbDark: "#2e2519",
        accent: "#d8c9a0",
        glow: "#8fe37a"
    }
};
const $d6139340df3c28f5$var$SKIN_TONES = [
    "#f2cba3",
    "#e6b487",
    "#d69a6a",
    "#c07f4f",
    "#9c6238",
    "#7a4a2b",
    "#5a3720",
    "#f7d9bd"
];
const $d6139340df3c28f5$var$HAIR_COLORS = [
    "#1c1a19",
    "#241f1b",
    "#3a2a1e",
    "#4a3527",
    "#5e3a22",
    "#6b4a2c",
    "#836a3f",
    "#b89b6a",
    "#8a8f98",
    "#2f2a26"
];
// Uncommon / dyed hair colours — auburn, ginger, red, rose, purple, blue, teal,
// platinum, pink. Rare in random generation, always available in the creator.
const $d6139340df3c28f5$var$UNCOMMON_HAIR_COLORS = [
    "#7a3b2a",
    "#a64b2a",
    "#9c3a4a",
    "#b0555f",
    "#5a4a8c",
    "#3d6b8c",
    "#3f8a5f",
    "#d9d4cc",
    "#c77fbf"
];
const $d6139340df3c28f5$var$EYE_COLORS = [
    "#5b3a1e",
    "#3a2a18",
    "#3f5a3a",
    "#3a5570",
    "#5a5a62",
    "#2a2a2e"
];
const $d6139340df3c28f5$var$EARRING_STYLES = [
    "stud",
    "hoop",
    "drop"
];
// Gold, silver, then gemstone hues (ruby, sapphire, emerald, amethyst, rose).
const $d6139340df3c28f5$var$EARRING_COLORS = [
    "#e6c06a",
    "#cfd3db",
    "#c8384a",
    "#3f6fd0",
    "#3fa06a",
    "#9a6ad0",
    "#d65f95"
];
const $d6139340df3c28f5$var$HAIR_STYLES = [
    "bald",
    "buzz",
    "crop",
    "swept",
    "long",
    "topknot",
    "curly"
];
const $d6139340df3c28f5$var$FEMALE_HAIR_STYLES = [
    "long",
    "bob",
    "ponytail",
    "bun",
    "wavy",
    "curly"
];
const $d6139340df3c28f5$export$210f63acf4dbee61 = {
    vignette: 0,
    hairChance: 0.9,
    facialHairChance: 0.35,
    scarChance: 0.16,
    visorChance: 0.01,
    eyepatchChance: 0.05,
    glassesChance: 0.15,
    markingsChance: 0.26,
    earringChance: 0.12,
    sigilChance: 0.05,
    glowEyeDominion: 0.05,
    glowEyeVeil: 0.55,
    glowEyeWilders: 0.15,
    veilHoodChance: 0.4,
    femaleChance: 0.5,
    wildHairChance: 0.08
};
// Every editable feature, for building an avatar-creator UI. Types: bool; int
// (min/max); color (options = a suggested swatch pool); enum (options are plain
// values or [label, value] pairs). A field may carry get/set to map onto a
// different shape on the feature object — eyewear is stored as three booleans.
const $d6139340df3c28f5$var$ALL_HAIR_STYLES = [
    ...new Set([
        ...$d6139340df3c28f5$var$HAIR_STYLES,
        ...$d6139340df3c28f5$var$FEMALE_HAIR_STYLES
    ])
];
const $d6139340df3c28f5$var$ACC = "Accessories & markings";
// Capitalize an internal value string for display without changing the value.
const $d6139340df3c28f5$var$titleOpt = (v)=>[
        v.charAt(0).toUpperCase() + v.slice(1),
        v
    ];
const $d6139340df3c28f5$export$54d4f0a9b0c6e9b3 = [
    {
        group: "Face",
        key: "gender",
        type: "enum",
        label: "Gender",
        options: [
            [
                "Male",
                false
            ],
            [
                "Female",
                true
            ]
        ],
        get: (f)=>!!f.female,
        set: (f, v)=>{
            f.female = v;
        }
    },
    {
        group: "Face",
        key: "skin",
        type: "color",
        label: "Skin",
        options: $d6139340df3c28f5$var$SKIN_TONES
    },
    {
        group: "Face",
        key: "faceW",
        type: "int",
        label: "Width",
        min: 14,
        max: 20
    },
    {
        group: "Face",
        key: "faceH",
        type: "int",
        label: "Height",
        min: 34,
        max: 46
    },
    {
        group: "Face",
        key: "jaw",
        type: "enum",
        label: "Jaw",
        options: [
            [
                "Round",
                0
            ],
            [
                "Square",
                1
            ],
            [
                "Narrow",
                2
            ]
        ]
    },
    {
        group: "Face",
        key: "shadeSide",
        type: "enum",
        label: "Light from",
        options: [
            [
                "Left",
                1
            ],
            [
                "Right",
                -1
            ]
        ]
    },
    {
        group: "Face",
        key: "mouthW",
        type: "int",
        label: "Mouth width",
        min: 3,
        max: 10
    },
    {
        group: "Face",
        key: "mouthCurve",
        type: "enum",
        label: "Mouth",
        options: [
            [
                "Frown",
                -1
            ],
            [
                "Neutral",
                0
            ],
            [
                "Smile",
                1
            ]
        ]
    },
    {
        group: "Hair",
        key: "hairStyle",
        type: "enum",
        label: "Style",
        options: $d6139340df3c28f5$var$ALL_HAIR_STYLES.map($d6139340df3c28f5$var$titleOpt)
    },
    {
        group: "Hair",
        key: "hairColor",
        type: "color",
        label: "Color",
        options: [
            ...$d6139340df3c28f5$var$HAIR_COLORS,
            ...$d6139340df3c28f5$var$UNCOMMON_HAIR_COLORS
        ]
    },
    {
        group: "Hair",
        key: "hairline",
        type: "int",
        label: "Hairline",
        min: 4,
        max: 14
    },
    {
        group: "Hair",
        key: "facialHair",
        type: "enum",
        label: "Facial hair",
        options: [
            [
                "None",
                null
            ],
            [
                "Stubble",
                "stubble"
            ],
            [
                "Mustache",
                "mustache"
            ],
            [
                "Beard",
                "beard"
            ],
            [
                "Goatee",
                "goatee"
            ]
        ]
    },
    {
        group: "Eyes",
        key: "eyeColor",
        type: "color",
        label: "Color",
        options: $d6139340df3c28f5$var$EYE_COLORS
    },
    {
        group: "Eyes",
        key: "eyeGap",
        type: "int",
        label: "Spacing",
        min: 10,
        max: 18
    },
    {
        group: "Eyes",
        key: "eyeYoff",
        type: "int",
        label: "Height",
        min: -2,
        max: 2
    },
    {
        group: "Eyes",
        key: "gaze",
        type: "int",
        label: "Gaze",
        min: -1,
        max: 1
    },
    {
        group: "Eyes",
        key: "browRaise",
        type: "int",
        label: "Brow raise",
        min: 0,
        max: 3
    },
    {
        group: "Eyes",
        key: "browThick",
        type: "int",
        label: "Brow thickness",
        min: 1,
        max: 2
    },
    {
        group: "Eyes",
        key: "glowEye",
        type: "bool",
        label: "Glow eyes"
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "eyewear",
        type: "enum",
        label: "Eyewear",
        options: [
            [
                "None",
                "none"
            ],
            [
                "Visor",
                "visor"
            ],
            [
                "Glasses",
                "glasses"
            ],
            [
                "Eyepatch",
                "eyepatch"
            ]
        ],
        get: (f)=>f.visor ? "visor" : f.glasses ? "glasses" : f.eyepatch ? "eyepatch" : "none",
        set: (f, v)=>{
            f.visor = v === "visor";
            f.glasses = v === "glasses";
            f.eyepatch = v === "eyepatch";
        }
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "glassesStyle",
        type: "enum",
        label: "Glasses style",
        options: [
            [
                "Clear",
                "clear"
            ],
            [
                "Sunglasses",
                "sun"
            ],
            [
                "Aviators",
                "aviator"
            ]
        ]
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "earrings",
        type: "enum",
        label: "Earrings",
        options: [
            [
                "None",
                "none"
            ],
            [
                "One",
                "1"
            ],
            [
                "Two",
                "2"
            ]
        ],
        get: (f)=>f.earring ? f.earringBoth ? "2" : "1" : "none",
        set: (f, v)=>{
            f.earring = v !== "none";
            f.earringBoth = v === "2";
        }
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "earringStyle",
        type: "enum",
        label: "Earring style",
        options: $d6139340df3c28f5$var$EARRING_STYLES.map($d6139340df3c28f5$var$titleOpt)
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "earringColor",
        type: "color",
        label: "Earring color",
        options: $d6139340df3c28f5$var$EARRING_COLORS
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "scar",
        type: "bool",
        label: "Scar"
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "scarSide",
        type: "enum",
        label: "Scar side",
        options: [
            [
                "Left",
                -1
            ],
            [
                "Right",
                1
            ]
        ]
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "markings",
        type: "bool",
        label: "Markings"
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "markStyle",
        type: "enum",
        label: "Marking style",
        options: [
            [
                "Eye Stripes",
                0
            ],
            [
                "Cheek Dashes",
                1
            ],
            [
                "Forehead Mark",
                2
            ]
        ]
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "sigil",
        type: "bool",
        label: "Faction sigil"
    },
    {
        group: $d6139340df3c28f5$var$ACC,
        key: "hood",
        type: "bool",
        label: "Hood",
        factions: [
            "veil"
        ]
    }
];
// ---- colour helpers -------------------------------------------------------
const $d6139340df3c28f5$var$clamp255 = (n)=>n < 0 ? 0 : n > 255 ? 255 : n | 0;
function $d6139340df3c28f5$var$hexToRgb(hex) {
    const n = parseInt(hex.slice(1), 16);
    return [
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255
    ];
}
const $d6139340df3c28f5$var$rgbToHex = (r, g, b)=>"#" + [
        r,
        g,
        b
    ].map((v)=>$d6139340df3c28f5$var$clamp255(v).toString(16).padStart(2, "0")).join("");
// Multiply toward black (f<1) or white-ish (f>1) for cheap shading/highlights.
function $d6139340df3c28f5$var$shade(hex, f) {
    const [r, g, b] = $d6139340df3c28f5$var$hexToRgb(hex);
    return $d6139340df3c28f5$var$rgbToHex(r * f, g * f, b * f);
}
function $d6139340df3c28f5$var$lerpHex(a, b, t) {
    const [r1, g1, b1] = $d6139340df3c28f5$var$hexToRgb(a), [r2, g2, b2] = $d6139340df3c28f5$var$hexToRgb(b);
    return $d6139340df3c28f5$var$rgbToHex(r1 + (r2 - r1) * t, g1 + (g2 - g1) * t, b1 + (b2 - b1) * t);
}
function $d6139340df3c28f5$var$pick(rng, arr) {
    return arr[Math.floor(rng() * arr.length)];
}
// Deterministic 0..1 value hash for position-based texture (no rng stream, so
// it never perturbs feature rolls).
function $d6139340df3c28f5$var$hash2(x, y) {
    const n = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
    return n - Math.floor(n);
}
// ---- feature roll ---------------------------------------------------------
// Consume the rng in a FIXED order regardless of config, so toggles are local.
function $d6139340df3c28f5$var$rollFeatures(rng, faction, cfg) {
    const f = {};
    f.skin = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$SKIN_TONES);
    f.female = rng() < cfg.femaleChance;
    f.faceW = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 16, 18); // half-width at the cheekbones (widest)
    f.faceH = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 38, 42); // crown-to-chin height
    f.jaw = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 0, 2); // 0 round, 1 square, 2 narrow
    f.shadeSide = rng() < 0.5 ? -1 : 1;
    // Both the presence check and the style pick always consume the rng (fixed
    // stream). Females always have hair and draw from a female style pool.
    const hairPresent = rng() < cfg.hairChance;
    const styleRoll = $d6139340df3c28f5$var$pick(rng, f.female ? $d6139340df3c28f5$var$FEMALE_HAIR_STYLES : $d6139340df3c28f5$var$HAIR_STYLES);
    f.hairStyle = f.female || hairPresent ? styleRoll : "bald";
    const wildHair = rng() < cfg.wildHairChance; // rolled + both pools picked always (fixed stream)
    const normalHair = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$HAIR_COLORS), wildHairCol = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$UNCOMMON_HAIR_COLORS);
    f.hairColor = wildHair ? wildHairCol : normalHair;
    f.hairline = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 7, 11); // px of forehead the hair leaves bare
    f.eyeColor = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$EYE_COLORS);
    f.eyeYoff = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, -1, 1);
    f.eyeGap = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 14, 16);
    f.gaze = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, -1, 1);
    f.browRaise = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 0, 2);
    f.browThick = rng() < 0.4 ? 2 : 1;
    f.mouthW = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 4, 8);
    f.mouthCurve = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, -1, 1); // -1 frown, 0 neutral, 1 smile
    const fhPresent = rng() < cfg.facialHairChance; // rolled + picked always (fixed stream)
    const fhStyle = $d6139340df3c28f5$var$pick(rng, [
        "stubble",
        "mustache",
        "beard",
        "goatee"
    ]);
    f.facialHair = !f.female && fhPresent ? fhStyle : null; // females: no facial hair
    f.scar = rng() < cfg.scarChance;
    f.scarSide = rng() < 0.5 ? -1 : 1;
    f.visor = rng() < cfg.visorChance;
    f.eyepatch = !f.visor && rng() < cfg.eyepatchChance;
    const glassesRoll = rng() < cfg.glassesChance; // rolled always so the stream stays fixed
    f.glasses = !f.visor && !f.eyepatch && glassesRoll; // one eyewear accessory at a time
    const gsRoll = rng();
    f.glassesStyle = gsRoll < 0.5 ? "clear" : gsRoll < 0.8 ? "sun" : "aviator"; // clear / sunglasses / aviator
    f.markings = rng() < cfg.markingsChance;
    f.markStyle = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 0, 2);
    f.earring = rng() < cfg.earringChance * (f.female ? 2.5 : 1); // more common on females
    f.earringStyle = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$EARRING_STYLES);
    f.earringBoth = rng() < (f.female ? 0.6 : 0.2); // one or two earrings
    f.earringColor = $d6139340df3c28f5$var$pick(rng, $d6139340df3c28f5$var$EARRING_COLORS);
    f.sigil = rng() < cfg.sigilChance;
    const glowChance = {
        dominion: cfg.glowEyeDominion,
        veil: cfg.glowEyeVeil,
        wilders: cfg.glowEyeWilders
    }[faction] ?? 0.1;
    f.glowEye = rng() < glowChance;
    const hoodRoll = rng() < cfg.veilHoodChance; // rolled always so the stream stays fixed
    f.hood = faction === "veil" && hoodRoll; // only veil wears the head covering, and only sometimes
    return f;
}
// ---- layers ---------------------------------------------------------------
function $d6139340df3c28f5$var$drawBackground(g, pal, cfg) {
    // Vertical gradient bands (bg1 top -> bg2 bottom).
    for(let y = 0; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++)g.r(0, y, $d6139340df3c28f5$export$aaa4582620b40efc, 1, $d6139340df3c28f5$var$lerpHex(pal.bg1, pal.bg2, y / $d6139340df3c28f5$export$aaa4582620b40efc));
    // Corner vignette.
    if (cfg.vignette > 0) {
        const v = $d6139340df3c28f5$var$shade(pal.bg2, 0.5);
        for (const [cx, cy] of [
            [
                0,
                0
            ],
            [
                $d6139340df3c28f5$export$aaa4582620b40efc,
                0
            ],
            [
                0,
                $d6139340df3c28f5$export$aaa4582620b40efc
            ],
            [
                $d6139340df3c28f5$export$aaa4582620b40efc,
                $d6139340df3c28f5$export$aaa4582620b40efc
            ]
        ])g.a(cfg.vignette, ()=>(0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, cy, 22, v));
    }
}
// A parametric skull silhouette shared by every layer: a rounded crown, roughly
// straight temples/cheeks (widest), then a jaw that tapers to the chin.
// faceHalf(y) returns the head's half-width at row y, so skin, hair, beard and
// cowl all trace the same outline. Authored to fill most of the 64px frame and
// crop the shoulders at the edges, matching the reference sprite busts.
function $d6139340df3c28f5$var$buildFaceHalf(headTop, headH, maxHalf, chinHalf, jaw) {
    return (y)=>{
        const t = (y - headTop) / headH;
        if (t < 0 || t > 1) return 0;
        if (t < 0.3) {
            const tt = t / 0.3; // crown: elliptical dome
            return maxHalf * Math.sqrt(Math.max(0, 1 - (1 - tt) * (1 - tt)));
        }
        if (t < 0.58) return maxHalf; // temples + cheekbones (widest)
        const tt = (t - 0.58) / 0.42; // jaw -> chin
        if (jaw === 1) // square: hold width, then clip in near the bottom
        return tt < 0.72 ? maxHalf : Math.max(chinHalf, maxHalf - (maxHalf - chinHalf) * ((tt - 0.72) / 0.28));
        return maxHalf + (chinHalf - maxHalf) * (tt * tt); // round/narrow: eased curve
    };
}
function $d6139340df3c28f5$var$makeGeom(f) {
    const cx = 32, headTop = 5, headH = f.faceH;
    // Females get a slightly narrower face and always use a soft, rounded jaw
    // profile (never the angular square). The jaw option still applies — it varies
    // the chin width: round (soft), square (fuller jaw), narrow (pointed / heart).
    const maxHalf = f.female ? f.faceW - 1 : f.faceW;
    const jaw = f.female ? 0 : f.jaw;
    const chinY = headTop + headH;
    const chinHalf = f.female ? Math.round(maxHalf * (f.jaw === 1 ? 0.56 : f.jaw === 2 ? 0.36 : 0.46)) : jaw === 2 ? Math.round(maxHalf * 0.42) // narrow
     : jaw === 1 ? Math.round(maxHalf * 0.62) // square
     : Math.round(maxHalf * 0.52); // round
    const faceHalf = $d6139340df3c28f5$var$buildFaceHalf(headTop, headH, maxHalf, chinHalf, jaw);
    // A 1px-inflated silhouette used to lay down a dark self-outline before skin.
    const outlineHalf = $d6139340df3c28f5$var$buildFaceHalf(headTop - 1, headH + 2, maxHalf + 1, chinHalf + 1, jaw);
    // Eyeline at ~half the head, with wider gaps down to the nose base and mouth so
    // the features fill the face instead of bunching in the lower-middle.
    const eyeY = Math.round(headTop + headH * 0.5) + f.eyeYoff;
    return {
        cx: cx,
        headTop: headTop,
        headH: headH,
        maxHalf: maxHalf,
        chinHalf: chinHalf,
        chinY: chinY,
        faceHalf: faceHalf,
        outlineHalf: outlineHalf,
        jaw: jaw,
        eyeY: eyeY,
        noseY: eyeY + 7,
        mouthY: eyeY + 14,
        hairlineY: headTop + f.hairline,
        neckHalf: Math.max(5, Math.round(chinHalf * 0.8)),
        shoulderTop: chinY + 5
    };
}
// Half-width of the veil hood — the head outline plus a margin, holding wide all
// the way down to the shoulders.
function $d6139340df3c28f5$var$makeHoodHalf(geom) {
    const top = geom.headTop - 4, span = geom.chinY + 8 - top, wide = geom.maxHalf + 5;
    return (y)=>{
        const t = (y - top) / span;
        if (t < 0 || t > 1) return 0;
        if (t < 0.34) {
            const tt = t / 0.34;
            return wide * Math.sqrt(Math.max(0, 1 - (1 - tt) * (1 - tt)));
        }
        return wide;
    };
}
function $d6139340df3c28f5$var$drawBody(g, geom, rng, f, pal, faction) {
    const { cx: cx, shoulderTop: shoulderTop } = geom;
    const gd = pal.garbDark, gl = $d6139340df3c28f5$var$shade(pal.garb, 1.16);
    const fold = $d6139340df3c28f5$var$shade(pal.garb, 0.68), foldLit = $d6139340df3c28f5$var$shade(pal.garb, 1.24);
    const inner = geom.neckHalf + 3, full = 40, drop = 0.45;
    // Sloped shoulders descending from the neck. topAt is the garment's top edge
    // per column, halfAt its half-width per row. (A fast sqrt curve used to flare
    // the shoulder tops up too high, near the jaw.) Drawing by column makes the
    // sloped top edge — and the detail that rides it — fall out for free.
    const topAt = (x)=>shoulderTop + Math.round(drop * Math.max(0, Math.abs(x - cx) - inner));
    const halfAt = (y)=>Math.min(full, inner + (y - shoulderTop) / drop);
    const edge = (fn)=>{
        for(let x = cx - full; x <= cx + full; x++){
            const top = topAt(x);
            if (top < $d6139340df3c28f5$export$aaa4582620b40efc) fn(x, top, Math.abs(x - cx));
        }
    };
    // Fill by columns from the sloped top edge to the bottom. Overdraw one row past
    // the bottom edge so a breathing lift never exposes a gap there (clipped away).
    edge((x, top)=>g.r(x, top, 1, $d6139340df3c28f5$export$aaa4582620b40efc - top + 1, pal.garb));
    // Collar rising up either side of the neck.
    g.r(cx - geom.neckHalf - 3, shoulderTop - 4, 3, 6, pal.garb);
    g.r(cx + geom.neckHalf, shoulderTop - 4, 3, 6, pal.garb);
    // Shading: highlight riding the shoulder edge, a centre-chest shadow, and
    // darker lower-outer corners, so the garment reads rounded not slab-flat.
    g.a(0.4, ()=>edge((x, top, dx)=>{
            if (dx >= inner) g.r(x, top, 1, 2, gl);
        }));
    g.a(0.22, ()=>{
        for(let y = shoulderTop + 4; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++)g.r(cx - 3, y, 6, 1, gd);
    });
    g.a(0.35, ()=>{
        for(let y = shoulderTop + 8; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++){
            const h = halfAt(y);
            g.r(cx - h, y, 5, 1, gd);
            g.r(cx + h - 5, y, 5, 1, gd);
        }
    });
    // Fabric weave: a deterministic speckle so cloth reads textured, not plastic —
    // a dark grain plus a sparser lit fleck.
    g.a(0.18, ()=>edge((x, top)=>{
            for(let y = top; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++)if ($d6139340df3c28f5$var$hash2(x * 1.3, y * 2.1) > 0.86) g.r(x, y, 1, 1, gd);
        }));
    g.a(0.12, ()=>edge((x, top)=>{
            for(let y = top; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++)if ($d6139340df3c28f5$var$hash2(x * 2.7, y * 1.1) < 0.07) g.r(x, y, 1, 1, gl);
        }));
    // Wrinkle creases fanning down-outward from the collar (short dark diagonals),
    // the readable, hand-placed counterpart to the random weave.
    g.a(0.3, ()=>{
        for (const sgn of [
            -1,
            1
        ])for (const k of [
            0,
            1,
            2
        ]){
            let wx = cx + sgn * (inner + 1), wy = shoulderTop + 3 + k * 4;
            for(let j = 0; j < 6 - k; j++){
                if (wy >= topAt(wx) && wy < $d6139340df3c28f5$export$aaa4582620b40efc) g.r(wx, wy, 1, 1, fold);
                wx += sgn;
                wy += 1;
            }
        }
    });
    // Stacked fabric folds (dark crease + lit edge above), clamped inside the body.
    const folds = (count, startY, spacing, w0, dw)=>{
        for(let i = 0; i < count; i++){
            const y = startY + i * spacing, w = Math.min(halfAt(y) - 1, w0 + i * dw);
            for(let x = cx - w; x <= cx + w; x++){
                const t = (x - cx) / w;
                g.r(x, y + Math.round(2.2 * t * t), 1, 1, fold);
            }
            g.a(0.45, ()=>{
                for(let x = cx - w; x <= cx + w; x++){
                    const t = (x - cx) / w;
                    g.r(x, y + Math.round(2.2 * t * t) - 1, 1, 1, foldLit);
                }
            });
        }
    };
    if (faction === "dominion") {
        // Stiff high collar, a zipper seam down the chest, gold neckline trim + stud.
        folds(1, shoulderTop + 5, 0, geom.neckHalf + 7, 0);
        g.a(0.7, ()=>g.r(cx - 1, shoulderTop + 2, 2, $d6139340df3c28f5$export$aaa4582620b40efc - shoulderTop, gd)); // seam channel
        for(let y = shoulderTop + 3; y < $d6139340df3c28f5$export$aaa4582620b40efc; y += 2)g.r(cx, y, 1, 1, foldLit); // zipper teeth
        (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, cx - inner, shoulderTop, inner * 2, pal.accent); // collar trim across the neckline
        g.r(cx - 1, shoulderTop + 5, 3, 3, pal.accent); // stud
    } else if (faction === "veil") {
        // Layered scarf/cowl wraps — the signature veil look — plus one faint
        // asymmetric accent thread.
        folds(3, shoulderTop + 3, 3, geom.neckHalf + 5, 5);
        g.a(0.25, ()=>{
            for(let y = shoulderTop + 4; y < $d6139340df3c28f5$export$aaa4582620b40efc; y++)g.r(cx - 9 + (y - shoulderTop), y, 1, 1, pal.accent);
        });
    } else {
        // Wilders: ragged fur riding the sloped top edge, a diagonal leather strap,
        // one heavy fold, and a bone pendant.
        edge((x, top, dx)=>{
            if (dx < inner - 2) return;
            const jag = (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 0, 2);
            g.r(x, top + jag - 1, 1, 2, (0, $61e5c68ae974806a$export$d0f79e97207f27e3)(rng, 0, 1) ? gd : gl);
        });
        folds(1, shoulderTop + 8, 0, geom.neckHalf + 8, 0);
        for(let i = 0; i < 16; i++){
            const x = cx - 10 + i, y = shoulderTop + 5 + i;
            if (y > topAt(x)) g.r(x, y, 2, 1, $d6139340df3c28f5$var$shade(pal.garb, 0.58));
        } // strap
        (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, cx, shoulderTop + 5, 4, pal.accent);
        g.r(cx - 1, shoulderTop + 8, 3, 2, pal.accent); // bone pendant
    }
}
// Veil cowl framing — a hood BEHIND the head; the front rim is redrawn after
// hair so it sits over the crown and closes around the face.
function $d6139340df3c28f5$var$cowlBack(g, geom, pal) {
    const hood = $d6139340df3c28f5$var$makeHoodHalf(geom);
    for(let y = geom.headTop - 4; y <= geom.shoulderTop + 2; y++){
        const h = Math.round(hood(y));
        if (h > 0) g.r(geom.cx - h, y, 2 * h, 1, pal.garbDark);
    }
}
function $d6139340df3c28f5$var$cowlFront(g, geom, pal) {
    const { cx: cx } = geom;
    const hood = $d6139340df3c28f5$var$makeHoodHalf(geom);
    const shadow = $d6139340df3c28f5$var$shade(pal.garbDark, 0.75);
    for(let y = geom.headTop - 4; y <= geom.chinY; y++){
        const hh = Math.round(hood(y));
        if (hh <= 0) continue;
        if (y < geom.hairlineY) g.r(cx - hh, y, 2 * hh, 1, pal.garbDark); // hood over the crown
        else {
            const fh = Math.round(geom.faceHalf(y)) + 1; // frame the sides, leave the face open
            g.r(cx - hh, y, hh - fh, 1, pal.garbDark);
            g.r(cx + fh, y, hh - fh, 1, pal.garbDark);
        }
    }
    g.a(0.5, ()=>g.r(cx - geom.maxHalf, geom.hairlineY, geom.maxHalf * 2, 3, shadow)); // brow shadow under the hood
}
function $d6139340df3c28f5$var$drawHead(g, geom, f) {
    const { cx: cx, headTop: headTop, chinY: chinY, faceHalf: faceHalf, outlineHalf: outlineHalf } = geom;
    const skin = f.skin;
    const base = skin;
    const shadow = $d6139340df3c28f5$var$shade(skin, 0.74); // shadow plane
    const deep = $d6139340df3c28f5$var$shade(skin, 0.56); // core shadows (sockets, under-jaw)
    const lit = $d6139340df3c28f5$var$shade(skin, 1.12); // lit plane
    const hi = $d6139340df3c28f5$var$shade(skin, 1.20); // highlight points (cheekbone, chin, brow ridge)
    const line = $d6139340df3c28f5$var$shade(skin, 0.42); // self-outline
    const s = f.shadeSide; // face lit from -s, shadowed toward +s
    const eyeY = geom.eyeY;
    const er = Math.round(faceHalf(eyeY + 1)); // cheekbone half-width, reused for shading below
    // Neck dropping from the chin into the collar, in shadow.
    const nh = geom.neckHalf;
    g.r(cx - nh - 1, chinY - 3, 1, geom.shoulderTop + 2 - (chinY - 3), line); // neck outline
    g.r(cx + nh, chinY - 3, 1, geom.shoulderTop + 2 - (chinY - 3), line);
    g.r(cx - nh, chinY - 3, nh * 2, geom.shoulderTop + 2 - (chinY - 3), shadow);
    g.r(cx - nh, chinY - 3, nh * 2, 2, deep); // under-jaw shadow
    // 1) Dark self-outline (inflated silhouette).
    for(let y = headTop - 1; y <= chinY + 1; y++){
        const h = Math.round(outlineHalf(y));
        if (h > 0) g.r(cx - h, y, 2 * h, 1, line);
    }
    // 2) Base skin.
    for(let y = headTop; y <= chinY; y++){
        const h = Math.round(faceHalf(y));
        if (h > 0) g.r(cx - h, y, 2 * h, 1, base);
    }
    // 3) Shadow plane: a soft band along the shadow-side edge only (not half the
    // face) — the outer third, so most of the face stays base tone.
    for(let y = headTop + 1; y <= chinY; y++){
        const h = Math.round(faceHalf(y));
        if (h <= 1) continue;
        const w = Math.max(2, Math.round(h * 0.4));
        if (s > 0) g.r(cx + (h - w), y, w, 1, shadow);
        else g.r(cx - h, y, w, 1, shadow);
    }
    // 4) Lit plane: a gentle highlight down the lit cheek/temple + nose bridge.
    g.a(0.5, ()=>{
        for(let y = geom.hairlineY + 1; y < eyeY; y++){
            const h = Math.round(faceHalf(y));
            g.r(s > 0 ? cx - h + 1 : cx + Math.round(h * 0.35), y, Math.round(h * 0.4), 1, lit);
        }
        g.r(s > 0 ? cx - er + 1 : cx + Math.round(er * 0.35), eyeY + 4, 3, 2, lit); // cheekbone
    });
    // 5) Under-cheek jaw shadow (eye sockets are shaded per-eye in drawFace).
    g.a(0.16, ()=>{
        for(let y = geom.mouthY; y <= chinY - 2; y++){
            const h = Math.round(faceHalf(y));
            if (h > 2) g.r(cx - h + 1, y, 2 * h - 2, 1, shadow);
        }
    });
    // 6) Ears: a vertical oval protruding from each side (brow-to-nose level). An
    // elliptical protrusion gives the rounded oval outline, an outer outline is the
    // helix, and an inner shadow curve is the concha bowl — so they read as ears,
    // not bumps. Hair/sideburns cover the tops.
    const earTop = eyeY - 1, earBot = geom.noseY;
    const earCy = (earTop + earBot) / 2, earHh = (earBot - earTop) / 2 + 0.6;
    for (const sgn of [
        -1,
        1
    ]){
        const earSkin = sgn === s ? shadow : base;
        for(let y = earTop; y <= earBot; y++){
            const edge = Math.round(faceHalf(y));
            const nrm = (y - earCy) / earHh; // -1 top .. +1 bottom
            const prot = Math.round(3.2 * Math.sqrt(Math.max(0, 1 - nrm * nrm))); // ellipse -> rounded oval
            if (prot <= 0) continue;
            for(let k = 0; k < prot; k++)g.r(cx + sgn * (edge + k), y, 1, 1, earSkin);
            g.r(cx + sgn * (edge + prot), y, 1, 1, line); // outer helix outline
            g.r(cx + sgn * (edge - 1), y, 1, 1, deep); // behind-ear (attach) shadow
            if (Math.abs(nrm) < 0.6 && prot >= 3) g.r(cx + sgn * (edge + 1), y, 1, 1, deep); // concha bowl
        }
    }
    // 7) Facial contours (cheekbones, cheek hollows, brow ridge, chin, temples).
    $d6139340df3c28f5$var$drawContours(g, geom, f, {
        shadow: shadow,
        deep: deep,
        lit: lit,
        hi: hi
    });
}
// Local contour shading that gives the face form instead of a flat mask. All
// shapes are anchored to the same geometry and lit from -s (the shadow side is
// +s), so every portrait reads with one coherent light. Kept low-alpha and small
// so it sculpts without muddying.
function $d6139340df3c28f5$var$drawContours(g, geom, f, { shadow: shadow, deep: deep, lit: lit, hi: hi }) {
    const { cx: cx, eyeY: eyeY, noseY: noseY, mouthY: mouthY, chinY: chinY, hairlineY: hairlineY, faceHalf: faceHalf } = geom;
    const s = f.shadeSide;
    const mw = f.mouthW;
    // Brow-bone catch-light just above the brows (stronger on the lit side).
    g.a(0.45, ()=>{
        const w = Math.round(faceHalf(eyeY) * 0.55);
        g.r(s > 0 ? cx - w - 1 : cx + 2, eyeY - 4, w, 1, lit);
    });
    // Cheekbone highlight + a cheek hollow curving down toward the mouth corner.
    // The hollow is the main "this is a face, not a ball" cue; deeper on the shadow
    // side, hinted on the lit side.
    for (const sgn of [
        -1,
        1
    ]){
        const cheekY = eyeY + 4;
        const cbx = cx + sgn * Math.round(faceHalf(cheekY) * 0.6);
        g.a(sgn === -s ? 0.55 : 0.3, ()=>g.r(cbx - 1, cheekY, 3, 2, hi)); // cheekbone
        let hx = cx + sgn * Math.round(faceHalf(cheekY + 2) * 0.74);
        g.a(sgn === s ? 0.32 : 0.16, ()=>{
            for(let y = cheekY + 2; y < mouthY; y++){
                g.r(hx - (sgn < 0 ? 1 : 0), y, 2, 1, shadow);
                hx -= sgn; // curve inward toward the mouth
            }
        });
    }
    // Temple hollow on the lit side (the shadow side is already covered by the
    // shadow plane) so the forehead reads rounded, not flat.
    g.a(0.2, ()=>{
        for(let y = hairlineY + 1; y < eyeY - 2; y++){
            const h = Math.round(faceHalf(y));
            g.r(s > 0 ? cx - h : cx + h - 2, y, 2, 1, shadow);
        }
    });
    // Philtrum (under-nose) soft shadow on the shadow side.
    g.a(0.22, ()=>g.r(cx + (s > 0 ? 0 : -2), noseY + 5, 2, 1, shadow));
    // Under-lip crease + a lit chin ball below it.
    g.a(0.3, ()=>g.r(cx - (mw >> 1) + 1, mouthY + 2, mw - 2, 1, deep));
    g.a(0.5, ()=>g.r(cx - 2, chinY - 2, 5, 2, hi));
}
function $d6139340df3c28f5$var$drawHair(g, geom, f, anim = null) {
    const { cx: cx, headTop: headTop, chinY: chinY, faceHalf: faceHalf, hairlineY: hairlineY, maxHalf: maxHalf } = geom;
    if (f.hairStyle === "bald") {
        g.a(0.1, ()=>g.r(cx - 4, headTop + 4, 7, 3, $d6139340df3c28f5$var$shade(f.skin, 1.14))); // scalp sheen
        return;
    }
    const col = f.hairColor, dark = $d6139340df3c28f5$var$shade(col, 0.66), line = $d6139340df3c28f5$var$shade(col, 0.45), lit = $d6139340df3c28f5$var$shade(col, 1.2);
    const s = f.shadeSide;
    // Wind rustle (idle animation): the loose hair leans horizontally, growing from
    // the roots (hairline) toward the tips, so it flutters rather than sliding as a
    // rigid block. sway(y) is 0 without a gust, so static output stays unchanged.
    const wind = anim?.wind || 0;
    const sway = wind === 0 ? ()=>0 : (y)=>Math.round(wind * 2 * Math.min(1, Math.max(0, (y - hairlineY) / 26)));
    // Darken a strand that falls on the shadow side (sign === s), so a drape over
    // the cheek carries the same side shadow as the face beneath it.
    const sideCol = (sign, base)=>$d6139340df3c28f5$var$shade(base, sign === s ? 0.72 : 1);
    const curly = f.hairStyle === "curly";
    // Hair is the head silhouette lifted up by `lift` and inflated by 1px, so the
    // crown is one smooth continuous dome (no pinch/gap at the apex) that sits just
    // outside the skin at the hairline.
    const lift = curly ? 3 : 2;
    const hairTop = headTop - lift;
    const hairProfile = $d6139340df3c28f5$var$buildFaceHalf(hairTop, geom.headH, maxHalf + 1, geom.chinHalf, geom.jaw);
    const hairHalf = (y)=>hairProfile(y) + (curly && $d6139340df3c28f5$var$hash2(y, 7) > 0.55 ? 1 : 0);
    // Solid crown: outline, fill, then a shadow-side plane like the skin.
    for(let y = hairTop; y <= hairlineY; y++){
        const h = Math.round(hairHalf(y));
        if (h <= 0) continue;
        g.r(cx - h - 1, y, 2 * h + 2, 1, line);
        g.r(cx - h, y, 2 * h, 1, col);
        const w = Math.max(2, Math.round(h * 0.4)); // shadow side
        if (s > 0) g.r(cx + h - w, y, w, 1, dark);
        else g.r(cx - h, y, w, 1, dark);
    }
    // Soft hairline shadow where the hair meets the forehead (one row, so it reads
    // as a hairline, not a hat brim).
    {
        const h = Math.round(hairHalf(hairlineY));
        if (h > 0) g.a(0.55, ()=>g.r(cx - h, hairlineY, 2 * h, 1, dark));
    }
    // Small highlight patch on the lit side of the crown.
    g.a(0.5, ()=>{
        for(let y = hairTop + 1; y < headTop + 4; y++){
            const h = Math.round(hairHalf(y));
            g.r(s > 0 ? cx - Math.round(h * 0.75) : cx + Math.round(h * 0.35), y, Math.max(2, Math.round(h * 0.35)), 1, lit);
        }
    });
    // Restrained texture: a few dark strand clumps only (no scattered light pixels
    // — those read as noise). Curly gets a regular clump pattern.
    if (curly) for(let y = hairTop + 1; y < hairlineY; y += 2){
        const h = Math.round(hairHalf(Math.max(y, headTop)));
        for(let x = cx - h + 1; x < cx + h - 1; x += 3)if ($d6139340df3c28f5$var$hash2(x, y) > 0.5) g.r(x + ($d6139340df3c28f5$var$hash2(x, y) > 0.75 ? 1 : 0), y, 2, 1, dark);
    }
    else for(let y = hairTop + 2; y < hairlineY - 1; y += 3){
        const h = Math.round(hairHalf(Math.max(y, headTop)));
        g.a(0.6, ()=>g.r(cx - Math.round(h * 0.5), y, Math.round(h), 1, dark)); // soft strand line
    }
    // Frame the face: hair descends the temples down to cheek level (drapes lower
    // for long hair), so it wraps the face instead of sitting as a flat cap.
    const bobBot = Math.round((geom.mouthY + chinY) / 2); // bob ends midway between mouth and chin
    const longDrape = f.hairStyle === "long" || f.hairStyle === "wavy";
    const coversEars = longDrape || f.hairStyle === "bob"; // longer styles reach out over the ears
    // The ear bulge eases in from the hairline and back out around the mouth, so
    // the widening is very gradual (peak ~3px near the ear centre).
    const earTop = hairlineY - 2, earBot = geom.mouthY + 2, earSpan = earBot - earTop;
    const frameBottom = f.hairStyle === "bob" ? bobBot : longDrape ? chinY - 2 : f.hairStyle === "buzz" ? hairlineY + 3 : geom.eyeY + 2;
    const sideW = f.female ? 4 : curly ? 4 : 3;
    for(let y = hairlineY - 1; y <= frameBottom; y++){
        const h = Math.round(faceHalf(Math.min(y, chinY)) ?? 0) + 1;
        // A smooth bulge out over the ears — ramps gradually out and back in.
        const ext = coversEars && y >= earTop && y <= earBot ? Math.round(3.3 * Math.sin((y - earTop) / earSpan * Math.PI)) : 0;
        const sw = sway(y);
        g.r(cx - h - 1 - ext + sw, y, 1, 1, sideCol(-1, line));
        g.r(cx - h - ext + sw, y, sideW + ext, 1, sideCol(-1, $d6139340df3c28f5$var$hash2(y, 1) > 0.8 ? dark : col));
        g.r(cx + h - sideW + sw, y, sideW + ext, 1, sideCol(1, $d6139340df3c28f5$var$hash2(y, 2) > 0.8 ? dark : col));
        g.r(cx + h + ext + sw, y, 1, 1, sideCol(1, line));
    }
    // Style-specific extras.
    switch(f.hairStyle){
        case "swept":
            {
                const dir = -s;
                for(let i = 0; i < maxHalf + 2; i++){
                    const x = cx - maxHalf * dir + i * dir;
                    g.r(x, hairlineY - 2 + (i / 4 | 0), 2, 2, i % 3 ? col : dark);
                }
                break;
            }
        case "long":
        case "wavy":
            {
                const w = f.female ? 4 : 3, wavy = f.hairStyle === "wavy";
                for(let y = geom.eyeY - 1; y < chinY + 16; y++){
                    const h = Math.round(faceHalf(Math.min(y, chinY))) + 1;
                    const wob = wavy ? Math.max(0, Math.round(1.6 * Math.sin(y * 0.55))) : 0;
                    const c = $d6139340df3c28f5$var$hash2(y, 3) > 0.82 ? dark : col, sw = sway(y);
                    g.r(cx - h - 1 - wob + sw, y, w, 1, sideCol(-1, c));
                    g.r(cx + h - w + 1 + wob + sw, y, w, 1, sideCol(1, c));
                }
                break;
            }
        case "bob":
            for(let y = geom.eyeY - 2; y <= bobBot; y++){
                const h = Math.round(faceHalf(Math.min(y, chinY))) + 1;
                const inCurl = Math.max(0, y - (bobBot - 3));
                const c = $d6139340df3c28f5$var$hash2(y, 3) > 0.85 ? dark : col, sw = sway(y);
                g.r(cx - h - 1 + inCurl + sw, y, 4, 1, sideCol(-1, c));
                g.r(cx + h - 3 - inCurl + sw, y, 4, 1, sideCol(1, c));
            }
            break;
        case "ponytail":
            {
                const tx = cx + s * (maxHalf + 2);
                g.r(tx - 1, geom.eyeY - 2, 3, 2, dark); // hair tie
                for(let y = geom.eyeY; y < chinY + 12; y++){
                    const wob = Math.round(1.4 * Math.sin(y * 0.5));
                    g.r(tx - 1 + wob + sway(y), y, 3, 1, sideCol(s, $d6139340df3c28f5$var$hash2(y, 5) > 0.75 ? dark : col));
                }
                break;
            }
        case "bun":
            (0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, hairTop - 2, 5, line);
            (0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, hairTop - 2, 4, col);
            g.a(0.5, ()=>(0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx - 1, hairTop - 3, 2, lit));
            break;
        case "topknot":
            g.r(cx - 2, hairTop - 4, 4, 5, col); // knot stub
            (0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, hairTop - 1, 3, col);
            g.a(0.6, ()=>(0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx - 1, hairTop - 2, 1, lit));
            break;
    }
}
function $d6139340df3c28f5$var$drawFace(g, geom, f, pal, anim = null) {
    const { cx: cx, eyeY: ey, noseY: noseY, mouthY: my } = geom;
    const [lx, rx] = [
        cx - (f.eyeGap >> 1),
        cx + (f.eyeGap >> 1)
    ];
    const browCol = $d6139340df3c28f5$var$shade(f.hairStyle === "bald" ? "#5a4634" : f.hairColor, 0.8);
    const iris = f.glowEye ? pal.glow : f.eyeColor;
    const socket = $d6139340df3c28f5$var$shade(f.skin, 0.82);
    // Idle-animation deltas (all no-ops when anim is null, so static renders and
    // the unit tests are unchanged): a gaze saccade, a brow flick, a blink, and a
    // multiplier on the glow-eye pulse.
    const gaze = Math.max(-2, Math.min(2, f.gaze + (anim?.gaze || 0)));
    const browRaise = f.browRaise + (anim?.brow || 0);
    const shut = (anim?.blink || 0) > 0.6; // eyes closed this frame
    const glowMul = anim?.glow ?? 1;
    const eye = (ex, dir)=>{
        g.a(0.55, ()=>g.r(ex - 2, ey - 1, 5, 1, socket)); // socket shading above the eye
        if (shut) {
            // Closed lid: a soft skin crease where the eye was, no iris/catch-light.
            g.r(ex - 2, ey, 4, 1, $d6139340df3c28f5$var$shade(f.skin, 0.9));
            g.r(ex - 2, ey + 1, 4, 1, $d6139340df3c28f5$var$shade(f.skin, 0.7));
        } else {
            g.r(ex - 2, ey, 4, 1, "#e9e6de"); // small almond sclera
            g.r(ex - 2, ey + 1, 4, 1, $d6139340df3c28f5$var$shade("#e9e6de", 0.8)); // lower lid line
            g.r(ex - 1 + gaze, ey, 2, 2, iris); // iris fills most of the eye
            g.r(ex + gaze, ey, 1, 1, "#141317"); // pupil
            g.r(ex - 2, ey, 1, 1, "#2a2622"); // inner/outer canthus
            g.r(ex + 1, ey, 1, 1, "#2a2622");
            // Catch-light: a single lit iris pixel, drawn last so the canthus can't
            // paint over it, and on the same side of both eyes so they match.
            g.r(ex - 1 + gaze, ey, 1, 1, "#ffffff");
            if (f.glowEye) g.a(0.22 * glowMul, ()=>(0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, ex + gaze, ey + 1, 2, pal.glow));
        }
        // Brow: a short stroke angled down toward the nose. Females get a thinner,
        // slightly higher, arched brow plus a lash at the outer corner.
        if (f.female) {
            const bw = 5, by = ey - 4 - browRaise;
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - 2, by, bw, browCol);
            g.r(ex - 2 + (dir > 0 ? bw - 1 : 0), by - 1, 1, 1, browCol); // outer tip arches up
            g.r(ex + (dir > 0 ? 2 : -2), ey - 1, 1, 1, "#241f1b"); // eyelash
        } else {
            const bw = 6, by = ey - 3 - browRaise;
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - 3, by, bw, browCol);
            g.r(ex - 3 + (dir > 0 ? bw - 1 : 0), by + 1, 1, 1, browCol); // outer end drops
            if (f.browThick === 2) (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - 3, by + 1, bw, browCol);
        }
    };
    eye(lx, -1);
    eye(rx, 1);
    // Nose: a shaded ridge on the shadow side, a lit bridge on the lit side, and a
    // nostril base (an L of shadow).
    const ns = $d6139340df3c28f5$var$shade(f.skin, 0.74), s = f.shadeSide;
    (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, cx + (s > 0 ? 1 : -1), noseY, 4, ns);
    g.a(0.6, ()=>(0, $61e5c68ae974806a$export$77998c5980b7319b)(g, cx - (s > 0 ? 1 : -1), noseY - 1, 4, $d6139340df3c28f5$var$shade(f.skin, 1.1))); // bridge highlight
    g.r(cx - 1, noseY + 4, 3, 1, ns);
    g.r(cx + (s > 0 ? 2 : -2), noseY + 3, 1, 1, ns);
    // Mouth: a shaded upper-lip line; endpoints lift for a smile, drop for a frown.
    // Females get fuller, subtly rosy lips with a sheen.
    const mw = f.mouthW, x0 = cx - (mw >> 1);
    const open = anim?.mouthOpen || 0;
    const mc = f.female ? $d6139340df3c28f5$var$lerpHex($d6139340df3c28f5$var$shade(f.skin, 0.55), "#9c4f57", 0.55) : $d6139340df3c28f5$var$shade(f.skin, 0.5);
    const lipCol = f.female ? $d6139340df3c28f5$var$lerpHex($d6139340df3c28f5$var$shade(f.skin, 0.95), "#c07a80", 0.45) : $d6139340df3c28f5$var$shade(f.skin, 1.06);
    g.r(x0, my, mw, 1, mc); // upper lip line
    if (f.female) {
        g.r(x0, my + 1, mw, 1, lipCol); // lower lip
        g.a(0.6, ()=>g.r(x0 + 1, my + 1, mw - 2, 1, $d6139340df3c28f5$var$lerpHex(lipCol, "#ffffff", 0.3))); // sheen
    } else g.a(0.5, ()=>g.r(x0, my + 1, mw, 1, lipCol));
    // Idle parting: a dark gap opens BETWEEN the lips. Its centre widens
    // symmetrically as `open` (0..1) grows (a pixel added each side at once), and
    // the middle of the lower lip drops one row so the gap sits between the two
    // lips instead of over the bottom lip. open === 0 is the static look.
    if (open > 0) {
        const h = Math.round(open * (mw - 2 >> 1)), w = 2 * h + 1, gx = cx - h;
        g.r(gx, my + 2, w, 1, f.female ? lipCol : $d6139340df3c28f5$var$shade(f.skin, 0.9)); // dropped lower-lip centre
        g.r(gx, my + 1, w, 1, $d6139340df3c28f5$var$shade(f.skin, 0.3)); // dark cavity where the lips part
    }
    // Expression: use the animated curve when present (it morphs between the
    // character's expression and neutral), else the static one. Either way it
    // flattens toward neutral as the mouth opens.
    const curve = Math.round((anim?.mouthCurve ?? f.mouthCurve) * (1 - open));
    if (curve !== 0) {
        g.r(x0 - 1, my - curve, 1, 1, mc);
        g.r(cx + (mw >> 1), my - curve, 1, 1, mc);
    }
}
function $d6139340df3c28f5$var$drawFacialHair(g, geom, f) {
    if (!f.facialHair) return;
    const { cx: cx, faceHalf: faceHalf, chinY: chinY, mouthY: my, maxHalf: maxHalf } = geom;
    const col = $d6139340df3c28f5$var$shade(f.hairColor, 0.9), dark = $d6139340df3c28f5$var$shade(f.hairColor, 0.6), lit = $d6139340df3c28f5$var$shade(f.hairColor, 1.16);
    // Jaw-hair top edge curves up the cheeks (sideburns) instead of a straight line.
    const bTop = (x)=>my - 2 - Math.round(7 * (Math.abs(x - cx) / maxHalf) ** 2);
    switch(f.facialHair){
        case "stubble":
            // Stippled shadow over the jaw, with the same curved cheek top as the beard.
            g.a(0.34, ()=>{
                for(let y = my - 9; y <= chinY; y++){
                    const h = Math.round(faceHalf(y));
                    if (h <= 1) continue;
                    for(let x = cx - h; x < cx + h; x++){
                        if (y < bTop(x) || $d6139340df3c28f5$var$hash2(x * 2.1, y * 1.3) < 0.45) continue; // curved top + sparse stipple
                        g.r(x, y, 1, 1, col);
                    }
                }
            });
            break;
        case "mustache":
            g.r(cx - (f.mouthW >> 1) - 1, my - 2, f.mouthW + 2, 2, col);
            break;
        case "beard":
            // Full beard, textured with lighter/darker strands, a lips gap, and a darker
            // jaw-underline shadow. Top edge curves up the cheeks (shared bTop).
            for(let y = my - 9; y <= chinY + 2; y++){
                const h = Math.round(faceHalf(Math.min(y, chinY)));
                if (h <= 1) continue;
                for(let x = cx - h; x < cx + h; x++){
                    if (y < bTop(x)) continue; // curved top edge following the cheeks
                    if (y >= my - 1 && y <= my + 1 && Math.abs(x - cx) <= f.mouthW >> 1) continue; // lips show through
                    const n = $d6139340df3c28f5$var$hash2(x * 1.8, y * 1.5);
                    g.r(x, y, 1, 1, n > 0.8 ? dark : n < 0.13 ? lit : col);
                }
            }
            g.a(0.4, ()=>{
                const h = Math.round(faceHalf(chinY));
                g.r(cx - h + 1, chinY, 2 * h - 2, 2, dark);
            }); // jaw shadow
            for(let x = cx - (f.mouthW >> 1) - 1; x <= cx + (f.mouthW >> 1); x++)g.r(x, my - 2, 1, 2, $d6139340df3c28f5$var$hash2(x * 1.8, (my - 2) * 1.5) > 0.8 ? dark : col); // moustache
            break;
        case "goatee":
            g.r(cx - 3, my + 3, 6, 6, col);
            g.r(cx - (f.mouthW >> 1) - 1, my - 2, f.mouthW + 2, 1, col);
            break;
    }
}
// A single earring at (ex, y) — the lobe attach point. Style: stud / hoop / drop.
function $d6139340df3c28f5$var$drawEarring(g, ex, y, style, color) {
    if (style === "hoop") {
        g.r(ex, y, 1, 1, color); // top attach
        g.r(ex - 1, y + 1, 1, 1, color);
        g.r(ex + 1, y + 1, 1, 1, color);
        g.r(ex - 1, y + 2, 1, 1, color);
        g.r(ex + 1, y + 2, 1, 1, color);
        g.r(ex - 1, y + 3, 1, 1, color);
        g.r(ex + 1, y + 3, 1, 1, color);
        g.r(ex, y + 4, 1, 1, color); // bottom of the ring
    } else if (style === "drop") {
        g.r(ex, y, 1, 1, color); // stud
        g.r(ex, y + 2, 1, 2, color); // dangling drop
    } else g.r(ex, y, 1, 2, color);
}
// Earrings from the earlobe(s). Drawn before hair so long styles cover them (and
// short styles leave them showing). One ear, or both.
function $d6139340df3c28f5$var$drawEarrings(g, geom, f) {
    if (!f.earring) return;
    const { cx: cx, eyeY: eyeY } = geom, y = eyeY + 7;
    for (const sgn of f.earringBoth ? [
        -1,
        1
    ] : [
        1
    ])$d6139340df3c28f5$var$drawEarring(g, cx + sgn * Math.round(geom.faceHalf(y) + 0.5), y, f.earringStyle, f.earringColor);
}
// Facial scar / clan markings / faction sigil. Drawn on the skin BEFORE hair, so
// hair renders over them where they overlap (hairline, temples).
function $d6139340df3c28f5$var$drawFaceMarks(g, geom, f, pal, faction) {
    const cx = geom.cx, ey = geom.eyeY;
    // Scar: a short diagonal across one cheek/brow.
    if (f.scar) {
        let x = cx + f.scarSide * 8, y = ey - 3;
        for(let i = 0; i < 7; i++){
            g.r(x, y, 1, 1, $d6139340df3c28f5$var$shade(f.skin, 0.6));
            x += f.scarSide;
            y += 1;
        }
    }
    // Warpaint / clan markings (wilders skew here via markStyle).
    if (f.markings) {
        const ac = faction === "wilders" ? pal.accent : $d6139340df3c28f5$var$shade(pal.accent, 0.9);
        if (f.markStyle === 0) g.a(0.7, ()=>{
            (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, cx - 6, ey - 1, 6, ac);
            (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, cx + 6, ey - 1, 6, ac);
        });
        else if (f.markStyle === 1) // Cheek dashes (below the eyes).
        g.a(0.7, ()=>{
            for (const sgn of [
                -1,
                1
            ])for(let i = 0; i < 3; i++)g.r(sgn < 0 ? cx - 8 : cx + 5, ey + 3 + i * 2, 3, 1, ac);
        });
        else g.a(0.6, ()=>{
            g.r(cx - 3, ey - 6, 6, 1, ac);
            (0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, ey - 8, 1, ac);
        });
    }
    // Faction sigil on the forehead (dominion mark reads strongest).
    if (f.sigil) {
        const sy = ey - 7;
        if (faction === "dominion") {
            g.r(cx - 1, sy, 2, 3, pal.accent);
            g.r(cx - 2, sy + 1, 4, 1, pal.accent);
        } else if (faction === "veil") g.a(0.8, ()=>(0, $61e5c68ae974806a$export$56b4dd62e08af00e)(g, cx, sy + 1, 2, pal.glow));
        else {
            g.r(cx - 2, sy, 1, 3, pal.accent);
            g.r(cx + 1, sy, 1, 3, pal.accent);
        }
    }
}
// Eyewear (visor / glasses / eyepatch) — drawn on top of everything.
function $d6139340df3c28f5$var$drawExtras(g, geom, f, pal, faction) {
    const cx = geom.cx, ey = geom.eyeY;
    const [lx, rx] = [
        cx - (f.eyeGap >> 1),
        cx + (f.eyeGap >> 1)
    ];
    // Face mask / visor: a solid band wrapping the eyes that follows the face
    // silhouette (so it covers the sides) with a top edge curving up at the
    // temples, a lit top rim, and a glowing eye slit.
    if (f.visor) {
        const dk = pal.garbDark, rim = $d6139340df3c28f5$var$shade(pal.garbDark, 1.5), ug = $d6139340df3c28f5$var$shade(pal.glow, 0.6);
        const W = Math.round(geom.faceHalf(ey + 1)), Wface = Math.round(geom.faceHalf(ey));
        const browSpan = (f.eyeGap >> 1) + 3; // glow only reaches as wide as the eyebrows
        // The whole band curves up at the edges — top, slit and bottom all rise by the
        // same offset, so the visor keeps a constant thickness and hugs the face.
        for(let x = cx - W; x <= cx + W; x++){
            if (Math.abs(x - cx) > Wface) continue;
            const t = (x - cx) / W, off = Math.round(3 * t * t);
            const top = ey - 1 - off, bot = ey + 3 - off, slit = ey - off;
            const lit = Math.abs(x - cx) <= browSpan; // glow limited to the eyebrow span
            for(let y = top; y <= bot; y++)g.r(x, y, 1, 1, lit && y === slit ? pal.glow : y === top ? rim : dk);
            if (lit) g.a(0.45, ()=>g.r(x, slit + 1, 1, 1, ug)); // under-slit glow, curved too
        }
    } else if (f.glasses) {
        // Eyewear frame around each eye, a bridge, and arms back to the ears. Style is
        // clear (transparent), sun (dark tinted), or aviator (teardrop metal frame).
        const aviator = f.glassesStyle === "aviator";
        const fr = aviator ? "#8a7452" : "#26221e";
        const er = Math.round(geom.faceHalf(ey));
        // Aviator lens: half-widths top->bottom (dy -3..+4). Big teardrop widest near
        // the top, tapering to a rounded bottom point that leans slightly outward.
        const AV = [
            5,
            6,
            6,
            6,
            5,
            5,
            4,
            3
        ];
        const avC = (ex, dy)=>ex + Math.round((ex < cx ? -1 : 1) * Math.max(0, dy) * 0.28);
        const lens = (ex)=>{
            if (aviator) {
                for(let i = 0; i < AV.length; i++){
                    const dy = -3 + i, w = AV[i], c = avC(ex, dy);
                    const tint = $d6139340df3c28f5$var$lerpHex("#2a1e12", "#5c4020", i / (AV.length - 1)); // amber gradient, darker up top
                    g.a(0.82, ()=>g.r(c - w, ey + dy, 2 * w, 1, tint));
                    g.r(c - w, ey + dy, 1, 1, fr);
                    g.r(c + w - 1, ey + dy, 1, 1, fr);
                }
                (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - AV[0], ey - 3, AV[0] * 2, fr); // flat top
                const bw = AV[AV.length - 1], bc = avC(ex, 4);
                g.r(bc - bw, ey + 5, bw * 2, 1, fr); // rounded bottom rim
                g.a(0.5, ()=>g.r(ex - 3, ey - 2, 5, 1, "#c9d6e2")); // reflection streak
            } else {
                (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - 4, ey - 3, 9, fr); // rectangular frame
                (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, ex - 4, ey + 3, 9, fr);
                (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, ex - 4, ey - 3, 7, fr);
                (0, $61e5c68ae974806a$export$77998c5980b7319b)(g, ex + 4, ey - 3, 7, fr);
                if (f.glassesStyle === "sun") {
                    g.a(0.82, ()=>g.r(ex - 3, ey - 2, 7, 5, "#161b24")); // dark tint
                    g.a(0.5, ()=>{
                        for(let k = 0; k < 4; k++)g.r(ex - 3 + k, ey + 1 - k, 1, 1, "#5a6b82");
                    }); // reflection streak
                } else {
                    g.a(0.2, ()=>g.r(ex - 3, ey - 2, 7, 5, "#bcd0e0")); // faint clear tint
                    g.r(ex - 2, ey - 2, 1, 1, "#f2f6fa"); // glint
                }
            }
        };
        lens(lx);
        lens(rx);
        if (aviator) {
            const bx = lx + AV[0], bw = Math.max(2, rx - lx - AV[0] * 2);
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, bx, ey - 2, bw, fr); // double bridge over the nose
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, bx, ey, bw, fr);
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, cx - er, ey - 3, lx - AV[1] - (cx - er), fr); // arms at the brow line
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, rx + AV[1], ey - 3, cx + er - (rx + AV[1]), fr);
        } else {
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, lx + 4, ey - 1, Math.max(2, rx - lx - 8), fr); // single bridge
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, cx - er, ey - 2, lx - 4 - (cx - er), fr); // arms to the ears
            (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, rx + 4, ey - 2, cx + er - (rx + 4), fr);
        }
    } else if (f.eyepatch) {
        const ex = cx + (f.scarSide < 0 ? -(f.eyeGap >> 1) : f.eyeGap >> 1);
        g.r(ex - 2, ey - 2, 6, 6, "#303030");
        g.r(ex - 3, ey - 2, 8, 5, "#303030");
        g.r(ex + 3, ey - 2, 1, 5, "#202020");
        g.r(ex - 3, ey + 2, 7, 1, "#202020");
        g.r(ex + 4, ey - 2, 1, 5, "#000000");
        g.r(ex - 2, ey + 3, 6, 1, "#000000");
        (0, $61e5c68ae974806a$export$5c4c5253709c2db0)(g, cx - geom.maxHalf, ey - 3, geom.maxHalf * 2, "#161418"); // strap
    }
}
// ---- entry points ---------------------------------------------------------
// Paint a portrait from an explicit feature object into a 2D context sized
// AVATAR_BASE x AVATAR_BASE. `rng` drives the few remaining cosmetic randoms
// (the wilders fur edge). Works against any object exposing
// fillStyle/fillRect/globalAlpha (a real canvas, or a recording stub in tests).
function $d6139340df3c28f5$var$paintAvatar(ctx, f, faction, cfg, rng, anim = null) {
    const pal = $d6139340df3c28f5$export$3a2c4b2c8c374a0f[faction] || $d6139340df3c28f5$export$3a2c4b2c8c374a0f.dominion;
    const geom = $d6139340df3c28f5$var$makeGeom(f);
    const g = (0, $61e5c68ae974806a$export$a2661aea9d478234)(ctx);
    // `transparentBackground` skips the faction fill so the portrait composites
    // onto whatever is behind it (e.g. a card's own gradient) instead of drawing
    // its own rectangle. Not a DEFAULT_AVATAR_CONFIG knob — callers opt in.
    if (!cfg.transparentBackground) $d6139340df3c28f5$var$drawBackground(g, pal, cfg);
    if (f.hood) $d6139340df3c28f5$var$cowlBack(g, geom, pal);
    // Breathing lifts only the body/shoulders a pixel (the head stays put, so it
    // reads as the chest rising, not the whole portrait jumping). The head is
    // drawn afterward and covers the 1px more of neck the raised collar exposes.
    const breath = anim?.breath | 0;
    if (breath) ctx.translate(0, -breath);
    $d6139340df3c28f5$var$drawBody(g, geom, rng, f, pal, faction);
    if (breath) ctx.translate(0, breath);
    $d6139340df3c28f5$var$drawHead(g, geom, f);
    $d6139340df3c28f5$var$drawEarrings(g, geom, f); // before hair, so long styles cover the ears + earrings
    $d6139340df3c28f5$var$drawFaceMarks(g, geom, f, pal, faction); // scar/markings/sigil under the hair
    $d6139340df3c28f5$var$drawHair(g, geom, f, anim);
    if (f.hood) $d6139340df3c28f5$var$cowlFront(g, geom, pal);
    $d6139340df3c28f5$var$drawFace(g, geom, f, pal, anim);
    $d6139340df3c28f5$var$drawFacialHair(g, geom, f);
    $d6139340df3c28f5$var$drawExtras(g, geom, f, pal, faction);
    return f;
}
function $d6139340df3c28f5$export$ea6464b4fe67e5f2(ctx, seedStr, faction = "dominion", config = {}) {
    const cfg = {
        ...$d6139340df3c28f5$export$210f63acf4dbee61,
        ...config
    };
    const rng = (0, $c1858b438f434f4d$export$c0b222505a3369f3)(`avatar|${faction}|${seedStr}`);
    const f = $d6139340df3c28f5$var$rollFeatures(rng, faction, cfg);
    return $d6139340df3c28f5$var$paintAvatar(ctx, f, faction, cfg, rng); // rng continues past the roll
}
function $d6139340df3c28f5$export$4fafee04cbe5d540(seedStr, faction = "dominion", config = {}) {
    const cfg = {
        ...$d6139340df3c28f5$export$210f63acf4dbee61,
        ...config
    };
    return $d6139340df3c28f5$var$rollFeatures((0, $c1858b438f434f4d$export$c0b222505a3369f3)(`avatar|${faction}|${seedStr}`), faction, cfg);
}
function $d6139340df3c28f5$export$a046ef6d7517111c(ctx, features, faction = "dominion", config = {}, anim = null) {
    const cfg = {
        ...$d6139340df3c28f5$export$210f63acf4dbee61,
        ...config
    };
    const rng = (0, $c1858b438f434f4d$export$c0b222505a3369f3)(`avatar-manual|${faction}|${features.skin}|${features.hairStyle}`);
    return $d6139340df3c28f5$var$paintAvatar(ctx, {
        ...features
    }, faction, cfg, rng, anim);
}
function $d6139340df3c28f5$export$e5cd63d32a946e1d(tMs, phase = 0, mouthCurve = 0) {
    const t = tMs / 1000 + phase;
    // Blink: shut for ~140ms once per ~4.2s cycle.
    const blinkCycle = t % 4.2;
    const blink = blinkCycle > 4.06 ? 1 : 0;
    // Gaze saccade: hold centre, occasionally flick to a side and back.
    const g = Math.sin(t * 0.37 + phase * 2.3);
    const gaze = g > 0.9 ? 1 : g < -0.9 ? -1 : 0;
    // Glow pulse: continuous, so it reads smoothly even at this resolution.
    const glow = 0.7 + 0.3 * Math.sin(t * 2.1 + phase);
    // Brow flick: a brief raise, rarely.
    const brow = Math.sin(t * 0.23 + phase) > 0.985 ? 1 : 0;
    // Breathing: the shoulders rise a pixel on the slow inhale (body only).
    const breath = Math.sin(t * 0.8) > 0.3 ? 1 : 0;
    // Expression: slowly morph between the character's set expression and neutral
    // (a neutral character drifts toward a smile or frown, picked per-avatar from
    // phase). Runs at the cadence the mouth-open used to — roughly every ~13s.
    const target = mouthCurve !== 0 ? mouthCurve : Math.sin(phase * 7) >= 0 ? 1 : -1;
    const k = (Math.sin(t * 0.5 + phase * 5) + 1) / 2;
    const animCurve = Math.round(target * k); // -1 / 0 / 1
    // Mouth opening: now ~4x rarer (a slow ~50s cycle whose peak parts the lips for
    // a few seconds); still a continuous 0..1 that drawFace maps to slit width.
    const mo = Math.sin(t * 0.125 + phase * 3);
    const mouthOpen = mo > 0.93 ? (mo - 0.93) / 0.07 : 0;
    // Wind: mostly still, with occasional gusts that flutter the loose hair. A slow
    // envelope gates a faster oscillation, so gusts arrive and fade (~every 50s).
    const gust = Math.max(0, Math.sin(t * 0.13 + phase * 4) - 0.85) / 0.15;
    const wind = gust * Math.sin(t * 2.4 + phase);
    return {
        blink: blink,
        gaze: gaze,
        glow: glow,
        brow: brow,
        breath: breath,
        mouthOpen: mouthOpen,
        mouthCurve: animCurve,
        wind: wind
    };
}
// Browser/lab-only: nearest-neighbour upscale of a 64px portrait to `size` px.
function $d6139340df3c28f5$var$upscaledDataURL(drawInto, size) {
    const src = document.createElement("canvas");
    src.width = src.height = $d6139340df3c28f5$export$aaa4582620b40efc;
    drawInto(src.getContext("2d"));
    const out = document.createElement("canvas");
    out.width = out.height = size;
    const octx = out.getContext("2d");
    octx.imageSmoothingEnabled = false;
    octx.drawImage(src, 0, 0, size, size);
    return out.toDataURL("image/png");
}
function $d6139340df3c28f5$export$df23e55b8e3e0ed8(seedStr, faction = "dominion", size = $d6139340df3c28f5$export$ba4617d152d9e9eb, config = {}) {
    return $d6139340df3c28f5$var$upscaledDataURL((ctx)=>$d6139340df3c28f5$export$ea6464b4fe67e5f2(ctx, seedStr, faction, config), size);
}
function $d6139340df3c28f5$export$adacf7b1df9d4c0e(features, faction = "dominion", size = $d6139340df3c28f5$export$ba4617d152d9e9eb, config = {}) {
    return $d6139340df3c28f5$var$upscaledDataURL((ctx)=>$d6139340df3c28f5$export$a046ef6d7517111c(ctx, features, faction, config), size);
}





// Figure geometry, in the tile's authored 120px space. Scaled by u = tile/120
// at draw time so a different tile size costs nothing.
const $b4a8c2719a6e2142$var$REF_TILE = 120;
const $b4a8c2719a6e2142$var$BEAM_LEN = 30; // how far the torch reaches across the ground
const $b4a8c2719a6e2142$var$BEAM_WIDE = 9; // half-width where it lands
// The ground plane is seen from above, so a beam pointing up or down the
// screen is foreshortened. Squashing y by this much is the whole of the
// perspective in here, and it is enough to stop a torch aimed "north" from
// reading as one aimed at the sky.
const $b4a8c2719a6e2142$var$GROUND_SQUASH = 0.5;
// Torch strength against the hour. It never reaches zero: a team searching a
// tile at noon still has to LOOK like it is searching, and the faint daytime
// beam is the only thing on screen that says so. At night it carries the
// figure as well as the search.
const $b4a8c2719a6e2142$var$BEAM_DAY = 0.10, $b4a8c2719a6e2142$var$BEAM_NIGHT = 0.55;
// How dark a silhouette gets. Floored well above the tile's own night tint —
// a figure shaded honestly against midnight ground is a figure nobody can
// find, and these three are the thing the player is watching.
const $b4a8c2719a6e2142$var$SHADE_FLOOR = 0.52;
// ---- outcome effects ----
// A skill check resolving is the raid's whole beat and the map used to say
// nothing about it. These are one-shots played on the member the check ran
// through (see raidFx-core.js). All of them are drawn with 'lighter' and none
// of them is shaded for the hour: they are light sources, like the torches and
// the lit windows, and light is the one thing the day tint must not touch.
const $b4a8c2719a6e2142$var$FX = {
    // Chest height on the figure, where a person's hands are.
    HAND_Y: -10,
    success: {
        ring: 17,
        spokes: 0,
        color: '#b9f5c8',
        core: '#ffffff'
    },
    // Twice the reach and a full corona: a synergy is the rarest thing that
    // happens in a raid and it should be the one effect visible at a glance.
    synergy: {
        ring: 30,
        spokes: 7,
        color: '#ffd479',
        core: '#fff3cf'
    },
    failure: {
        ring: 15,
        spokes: 0,
        color: '#ff7a6b',
        core: '#ffd9d2'
    }
};
// How far a member is knocked about by a failure landing on them, in tile px.
const $b4a8c2719a6e2142$var$FX_JOLT = 2.2;
// A found item's mote is tinted by its rarity, off the same table the item
// tooltips and the inventory use — a rare coming up has to look like a rare,
// and inventing a second palette here would make it look like something else.
const $b4a8c2719a6e2142$var$RARITY_FALLBACK = '#cfd6e0';
function $b4a8c2719a6e2142$var$rarityColor(rarity) {
    return $ce6dd72bc4611534$export$d4a72d069095e9e5?.[rarity]?.color || $b4a8c2719a6e2142$var$RARITY_FALLBACK;
}
const $b4a8c2719a6e2142$var$TAU = Math.PI * 2;
const $b4a8c2719a6e2142$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
// Multiply a #rrggbb by a constant. Memoized because the same dozen
// (colour, brightness step) pairs recur every frame for the life of a raid.
const $b4a8c2719a6e2142$var$shadeCache = new Map();
function $b4a8c2719a6e2142$var$shade(hex, k) {
    const q = Math.round(k * 24); // 24 brightness steps is under
    const key = `${hex}|${q}`; // the eye's threshold at this size
    let out = $b4a8c2719a6e2142$var$shadeCache.get(key);
    if (out) return out;
    const n = parseInt(hex.slice(1), 16);
    const f = q / 24;
    out = `rgb(${Math.round((n >> 16 & 255) * f)},${Math.round((n >> 8 & 255) * f)},${Math.round((n & 255) * f)})`;
    $b4a8c2719a6e2142$var$shadeCache.set(key, out);
    return out;
}
function $b4a8c2719a6e2142$export$bdfac2c19033ece4(team) {
    return (team || []).filter((m)=>m && m.isAlive !== false).map((m, i)=>({
            // What an outcome effect addresses them by. The drawn roster drops
            // the dead, so an index would shift onto somebody else the moment
            // anyone fell — mid-raid, which is exactly when failures happen.
            id: m.id ?? m.avatarSeed ?? m.name ?? i,
            faction: (0, $d6139340df3c28f5$export$3a2c4b2c8c374a0f)[m.faction] ? m.faction : 'dominion',
            // Decorrelates one member's wander and torch sweep from the next.
            // avatarSeed is the same token the portrait is generated from, so
            // a given contractor moves the same way every raid they are on.
            seed: $b4a8c2719a6e2142$var$hashSeed(m.avatarSeed || m.id || m.name || i),
            // Below a third HP the figure stoops and the torch dips — the map
            // says "this is going badly" before the log scrolls to it.
            hurt: m.maxHp > 0 ? $b4a8c2719a6e2142$var$clamp01(1 - (m.currentHp ?? m.maxHp) / m.maxHp) : 0
        }));
}
function $b4a8c2719a6e2142$var$hashSeed(v) {
    const s = String(v);
    let h = 2166136261;
    for(let i = 0; i < s.length; i++){
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
function $b4a8c2719a6e2142$export$d0f529c5e2e21188(ctx, x, y, opts) {
    const members = opts.members;
    if (!members || !members.length) return;
    const tile = opts.tile || $b4a8c2719a6e2142$var$REF_TILE;
    const u = tile / $b4a8c2719a6e2142$var$REF_TILE;
    const tSec = opts.tSec || 0;
    const light = (0, $c454fb723f814d89$export$45f6af437d59d9ba)(opts.dayPhase ?? 0.5);
    const beamA = $b4a8c2719a6e2142$var$BEAM_DAY + ($b4a8c2719a6e2142$var$BEAM_NIGHT - $b4a8c2719a6e2142$var$BEAM_DAY) * (1 - light);
    const bright = $b4a8c2719a6e2142$var$SHADE_FLOOR + (1 - $b4a8c2719a6e2142$var$SHADE_FLOOR) * light;
    const nowMs = opts.nowMs ?? Date.now();
    // Effects are addressed by member id, because the drawn roster drops the
    // dead and an index would quietly shift onto somebody else the moment
    // anyone fell. One that names nobody on screen plays on the whole party.
    const fx = [];
    for (const f of opts.fx || []){
        const phase = (0, $b3111b8b2d4b2b7b$export$f82af1eaff316176)(f, nowMs);
        if (phase <= 0 || phase >= 1) continue; // not started, or over
        fx.push({
            f: f,
            phase: phase,
            i: members.findIndex((m)=>m.id != null && m.id === f.memberId)
        });
    }
    // A party near a corner is inside the draw radius of all eight neighbouring
    // tiles, but a member only ever puts ink within a torch's length of itself.
    // Dropping the ones that cannot reach this canvas is what stops a stationary
    // team costing three beam gradients on each of nine tiles every frame.
    // An effect reaches further than a torch, so the margin grows while one runs.
    const reach = (fx.length ? $b4a8c2719a6e2142$var$FX.synergy.ring * 1.3 : $b4a8c2719a6e2142$var$BEAM_LEN * 1.15) * u;
    const poses = [];
    for(let i = 0; i < members.length; i++){
        const p = (0, $b44bbfd29b442498$export$5ae338d6b723c743)(i, members.length, tSec, opts.party, members[i].seed, opts.posts?.[i]);
        let px = x + p.dx * tile, py = y + p.dy * tile;
        if (px < -reach || px > tile + reach || py < -reach || py > tile + reach) continue;
        // A failure landing on somebody knocks them about — the one place an
        // effect moves a figure rather than being drawn beside it, because a
        // flinch is what tells you WHO it happened to.
        let jolt = 0;
        for (const e of fx){
            if (e.f.kind !== 'failure' || e.i !== i) continue;
            jolt += Math.sin(e.phase * 34) * $b4a8c2719a6e2142$var$FX_JOLT * u * (0, $b3111b8b2d4b2b7b$export$2ff71a728686ddfb)(e.phase);
        }
        px += jolt;
        // How far down they have sat. `gait` is already the "have they settled
        // onto their post yet" number, so a camp needs no second clock: they
        // walk in, set up, and sink down as they arrive, then stand back up as
        // the party gathers to leave.
        poses.push({
            m: members[i],
            p: p,
            px: px,
            py: py,
            i: i,
            sit: opts.resting ? 1 - p.gait : 0
        });
    }
    if (!poses.length) return;
    // Painter's order: whoever is further up the tile is further away.
    poses.sort((a, b)=>a.py - b.py);
    // Every torch first, so a beam never lies over the figure standing in it.
    for (const s of poses)$b4a8c2719a6e2142$var$drawBeam(ctx, s, u, beamA, tSec);
    for (const s of poses)$b4a8c2719a6e2142$var$drawFigure(ctx, s, u, bright, beamA);
    // ...and the outcome over everything, because it is the news.
    for (const e of fx)$b4a8c2719a6e2142$var$drawFx(ctx, e, poses, x, y, u);
}
function $b4a8c2719a6e2142$var$drawBeam(ctx, s, u, alpha, tSec) {
    // A wounded member's torch hangs low and short, and a seated one has put
    // theirs down — a camp is lit by its fire, which the tile draws itself.
    const a = alpha * (1 - 0.45 * s.m.hurt) * (1 - s.sit);
    if (a < 0.02) return;
    const len = $b4a8c2719a6e2142$var$BEAM_LEN * u * (1 - 0.25 * s.m.hurt);
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    ctx.translate(s.px, s.py);
    ctx.scale(1, $b4a8c2719a6e2142$var$GROUND_SQUASH);
    ctx.rotate(s.p.facing);
    const g = ctx.createLinearGradient(0, 0, len, 0);
    g.addColorStop(0, `rgba(255,246,214,${a})`);
    g.addColorStop(0.4, `rgba(255,238,196,${a * 0.5})`);
    g.addColorStop(1, 'rgba(255,232,176,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(len, -$b4a8c2719a6e2142$var$BEAM_WIDE * u);
    ctx.lineTo(len * 1.06, 0);
    ctx.lineTo(len, $b4a8c2719a6e2142$var$BEAM_WIDE * u);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
    // The pool of light around their own feet, which is what actually lifts
    // the figure off dark ground. Breathes slightly, so a stationary team
    // still has something moving about it.
    const r = 7 * u * (1 + 0.06 * Math.sin(tSec * 1.7 + s.m.seed % 7));
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    ctx.translate(s.px, s.py);
    ctx.scale(1, $b4a8c2719a6e2142$var$GROUND_SQUASH);
    const pool = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
    pool.addColorStop(0, `rgba(255,240,205,${a * 0.55})`);
    pool.addColorStop(1, 'rgba(255,230,180,0)');
    ctx.fillStyle = pool;
    ctx.fillRect(-r, -r, r * 2, r * 2);
    ctx.restore();
}
function $b4a8c2719a6e2142$var$drawFigure(ctx, s, u, bright, beamA) {
    const pal = (0, $d6139340df3c28f5$export$3a2c4b2c8c374a0f)[s.m.faction];
    const garb = $b4a8c2719a6e2142$var$shade(pal.garb, bright);
    const dark = $b4a8c2719a6e2142$var$shade(pal.garbDark, bright);
    const accent = $b4a8c2719a6e2142$var$shade(pal.accent, bright * 0.9);
    const px = s.px, py = s.py;
    // Which way the sprite is turned. The body is a flat upright token on a
    // top-down map, so only the sign of the torch's x-component is expressible
    // — the true direction lives in the beam.
    const face = Math.cos(s.p.facing) >= 0 ? 1 : -1;
    // Nobody strides while sitting down.
    const swing = s.p.stride * (1 - s.sit);
    // Wounded members stoop; a full-height stride also lifts the body a little
    // off its feet on each step. Sitting takes a third off the whole figure,
    // which at fifteen pixels is the difference between standing and not.
    const H = (1 - 0.13 * s.m.hurt) * (1 - 0.34 * s.sit);
    const bob = -Math.abs(swing) * 0.7 * u * s.p.gait;
    const r = (dx, dy, w, h, c)=>{
        ctx.fillStyle = c;
        ctx.fillRect(Math.round(px + dx * u), Math.round(py + dy * u * H + bob), Math.max(1, Math.round(w * u)), Math.max(1, Math.round(h * u)));
    };
    // contact shadow — the only thing tying a token to the ground
    ctx.save();
    ctx.globalAlpha = 0.34;
    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.ellipse(px, py, 4.4 * u, 1.7 * u, 0, 0, $b4a8c2719a6e2142$var$TAU);
    ctx.fill();
    ctx.restore();
    // A dark ground line under the whole figure. At noon the silhouette sits
    // on pale concrete with nothing separating the two, and one row of shadow
    // is cheaper than outlining every part.
    r(-3.2, -0.8, 6.4, 1, '#000000');
    // Legs, swinging out of phase — and drawn out in front rather than under
    // the body once they are sitting, which is the read at this size: knees up,
    // not a shorter person.
    if (s.sit > 0.5) r(-1 + face * 1.2, -2.6, 3.4, 2.6, dark);
    else {
        r(-2.4 + swing * 1.1, -5, 2, 5, dark);
        r(0.4 - swing * 1.1, -5, 2, 5, dark);
    }
    // pack, on the back — behind whichever way they are turned
    r(face > 0 ? -3.9 : 1.9, -10.5, 2, 4.5, dark);
    // torso and shoulders
    r(-3, -11, 6, 6.2, garb);
    r(-3.4, -11.6, 6.8, 1.6, dark);
    // a single accent pixel each, so three silhouettes are three people
    r(face > 0 ? 1.4 : -2.4, -10.6, 1, 1, accent);
    // head — one row narrower top and bottom, which is all a 4px head needs
    // to stop reading as a brick
    r(-2.1, -15.6, 4.2, 3.8, dark);
    r(-1.4, -16.1, 2.8, 0.6, dark);
    // Underlight from their own torch, on the side they are holding it. WARM
    // and only a few pixels: the earlier version ran a cold rim down the full
    // height of the body, which at this size is not a highlight, it is a
    // fluorescent tube standing next to a person. What actually separates a
    // figure from dark ground is the pool it is standing in, not its edge.
    ctx.save();
    ctx.globalAlpha = Math.min(0.45, 0.12 + beamA * 0.5);
    const lit = face > 0 ? 2.2 : -2.8;
    r(lit, -11.2, 0.6, 2.4, '#ffe9bd'); // shoulder catching the lamp
    r(lit - face * 0.2, -15.2, 0.6, 1.4, '#ffe4b0'); // cheekbone
    ctx.restore();
}
// ============================================================================
// OUTCOME EFFECTS
// ============================================================================
// Everything here is drawn with 'lighter' onto the composited tile, so it adds
// light rather than painting over the art. That is also why none of it is put
// through shade(): a flare is a light source, and the day tint has already
// been applied underneath it.
/**
 * Where an effect happens.
 *
 * On its member's hands. An effect that names a member who is not drawn on
 * THIS canvas returns null and is skipped here — they are drawn on a
 * neighbouring tile and their effect belongs over there with them. Falling
 * back to the party's centre instead would put a second copy of every flare
 * in the wrong place on every tile the member had been culled from.
 *
 * The centre is only for an effect naming nobody on the roster at all — a
 * member who fell between the check resolving and the frame being drawn.
 */ function $b4a8c2719a6e2142$var$fxOrigin(e, poses, x, y, u) {
    if (e.i >= 0) {
        const on = poses.find((p)=>p.i === e.i);
        return on ? {
            x: on.px,
            y: on.py + $b4a8c2719a6e2142$var$FX.HAND_Y * u
        } : null;
    }
    return {
        x: x,
        y: y + $b4a8c2719a6e2142$var$FX.HAND_Y * u
    };
}
function $b4a8c2719a6e2142$var$drawFx(ctx, e, poses, x, y, u) {
    const at = $b4a8c2719a6e2142$var$fxOrigin(e, poses, x, y, u);
    if (!at) return;
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    if (e.f.kind === 'loot') $b4a8c2719a6e2142$var$drawLootMote(ctx, e, at, u);
    else $b4a8c2719a6e2142$var$drawBurst(ctx, e, at, u);
    ctx.restore();
}
/**
 * Success, synergy and failure: a ring going out from the member's hands, a
 * core that flashes and dies, and — for a synergy only — a corona of spokes.
 *
 * One routine for the three of them because they differ in colour, reach and
 * whether they have spokes, and in nothing else. Three near-identical draw
 * functions would drift apart the first time one was tuned.
 */ function $b4a8c2719a6e2142$var$drawBurst(ctx, e, at, u) {
    const spec = $b4a8c2719a6e2142$var$FX[e.f.kind] || $b4a8c2719a6e2142$var$FX.success;
    const p = e.phase;
    const fade = (0, $b3111b8b2d4b2b7b$export$2ff71a728686ddfb)(p);
    const r = Math.max(1, (0, $b3111b8b2d4b2b7b$export$b822c8d32c815bfc)(p) * spec.ring * u);
    // the ring
    ctx.globalAlpha = Math.min(1, fade * 0.95);
    ctx.strokeStyle = spec.color;
    ctx.lineWidth = Math.max(1, (1 + 2.2 * (1 - p)) * u);
    ctx.beginPath();
    // Squashed on the same ground plane the torches use, so a ring reads as
    // lying on the tile rather than standing up off it.
    ctx.ellipse(at.x, at.y, r, r * $b4a8c2719a6e2142$var$GROUND_SQUASH, 0, 0, $b4a8c2719a6e2142$var$TAU);
    ctx.stroke();
    // the core: a hard flash at the hands that is gone within a third of the
    // effect, which is what gives it a moment of impact rather than a swell
    const coreP = $b4a8c2719a6e2142$var$clamp01(p / 0.33);
    if (coreP < 1) {
        const cr = (2 + 5 * coreP) * u;
        const g = ctx.createRadialGradient(at.x, at.y, 0, at.x, at.y, cr);
        g.addColorStop(0, spec.core);
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.globalAlpha = (0, $b3111b8b2d4b2b7b$export$2ff71a728686ddfb)(coreP);
        ctx.fillStyle = g;
        ctx.fillRect(at.x - cr, at.y - cr, cr * 2, cr * 2);
    }
    // the corona — synergy only. Two skills meeting is the fiction, so the
    // spokes come in pairs about a common centre rather than radiating evenly.
    if (spec.spokes) {
        ctx.globalAlpha = fade * 0.8;
        ctx.strokeStyle = spec.core;
        ctx.lineWidth = Math.max(1, 1.2 * u);
        for(let i = 0; i < spec.spokes; i++){
            const a = i / spec.spokes * $b4a8c2719a6e2142$var$TAU + p * 0.7 + e.f.seed % 100 * 0.06;
            const inner = r * 0.55, outer = r * (1 + 0.35 * Math.sin(i * 2.3));
            ctx.beginPath();
            ctx.moveTo(at.x + Math.cos(a) * inner, at.y + Math.sin(a) * inner * $b4a8c2719a6e2142$var$GROUND_SQUASH);
            ctx.lineTo(at.x + Math.cos(a) * outer, at.y + Math.sin(a) * outer * $b4a8c2719a6e2142$var$GROUND_SQUASH);
            ctx.stroke();
        }
    }
}
/**
 * A found item: a mote that lifts out of the member's hands, hangs, and goes
 * out — tinted by the item's rarity, which is the whole reason for putting it
 * on the map. A common coming up should look like nothing much; a rare should
 * make you look.
 */ function $b4a8c2719a6e2142$var$drawLootMote(ctx, e, at, u) {
    const p = e.phase;
    const color = $b4a8c2719a6e2142$var$rarityColor(e.f.rarity);
    // Rises most of the way in the first half, then holds and fades, so the
    // eye has something still to land on rather than chasing it off the tile.
    const rise = (0, $b3111b8b2d4b2b7b$export$b822c8d32c815bfc)($b4a8c2719a6e2142$var$clamp01(p / 0.55)) * 11 * u;
    const drift = Math.sin(e.f.seed % 20 + p * 2.2) * 2.4 * u;
    const cx = at.x + drift, cy = at.y - rise;
    const fade = p < 0.15 ? p / 0.15 : (0, $b3111b8b2d4b2b7b$export$2ff71a728686ddfb)((p - 0.15) / 0.85);
    // halo
    const hr = 6 * u;
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, hr);
    g.addColorStop(0, color);
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.globalAlpha = fade * 0.75;
    ctx.fillStyle = g;
    ctx.fillRect(cx - hr, cy - hr, hr * 2, hr * 2);
    // the mote itself, and a four-point sparkle as it peaks
    ctx.globalAlpha = Math.min(1, fade * 1.2);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(Math.round(cx - u), Math.round(cy - u), Math.max(1, 2 * u), Math.max(1, 2 * u));
    const spark = 1 - Math.abs(p - 0.5) * 3.2;
    if (spark > 0) {
        ctx.globalAlpha = spark * 0.9;
        ctx.fillStyle = color;
        const arm = 4 * u * spark;
        ctx.fillRect(cx - arm, cy, arm * 2, Math.max(1, u));
        ctx.fillRect(cx, cy - arm, Math.max(1, u), arm * 2);
    }
}



const $a3c9aff5a6eec062$var$BASE_WIND = 0.35; // gust formula peaks at 0.42 — never clamps
const $a3c9aff5a6eec062$var$CLOUD_BASE = 0.3; // three decks stack, so less cover reads as more sky
// Ambient motion here is slow: clouds are drawn in 2px cells and drift
// 3-7 world px/s (a visible step every ~0.4s), tree sway rounds to a ±1px
// twitch over a ~3.5s cycle, and the lamp strobe is aliased at any frame
// rate. 12fps is indistinguishable from 30 and costs a third as much.
//
// The map still slows when another window has focus, because rAF keeps firing
// at full rate on an unfocused-but-VISIBLE window and there is no reason to
// spend a core on an animation nobody is attending to. But it slows far less
// than it used to. This was 500ms — 2fps — and that was a workaround for the
// canopies redrawing themselves 55 discs at a time, which made a visible map
// cost enough to stutter video playing in another window. They are blitted
// now, the map costs a third of what it did, and the video does not care.
//
// 2fps was also below the content's own floor: the fastest thing on screen is
// the cloud drift at ~2.5 visible steps a second, so sampling it twice a second
// UNDERSAMPLES it and the sky jumps instead of drifting. 6fps clears that with
// margin, and it matters because this is an idle game — a raid left running on
// a second monitor while you work is the ordinary way to watch one, not an edge
// case, and it is the exact case this governs. The window being properly hidden
// is already handled: the browser stops rAF entirely and neither figure applies.
const $a3c9aff5a6eec062$var$FRAME_MS = 83; // ~12fps, focused
const $a3c9aff5a6eec062$var$BLUR_FRAME_MS = 166; // ~6fps, another window has focus
const $a3c9aff5a6eec062$var$LAYOUT_MS = 250; // cadence for the layout-forcing DOM reads
let $a3c9aff5a6eec062$var$animCells = [];
// WHERE on the planet the grid on screen is. One raid is one place, so one
// clock serves every cell. The region id comes along only to name the site in
// the readout and to stand in for a pre-S9 save that has no site.
let $a3c9aff5a6eec062$var$animRegionId = null;
let $a3c9aff5a6eec062$var$animSite = null;
let $a3c9aff5a6eec062$var$rafId = null;
let $a3c9aff5a6eec062$var$lastFrame = 0;
let $a3c9aff5a6eec062$var$cloudX = 0, $a3c9aff5a6eec062$var$cloudY = 0;
let $a3c9aff5a6eec062$var$drawCursor = 0; // round-robin position for the frame budget
let $a3c9aff5a6eec062$var$lastClockUpdate = 0;
let $a3c9aff5a6eec062$var$maxCol = 0; // grid width, for viewport column culling
let $a3c9aff5a6eec062$var$lastLayoutCheck = 0;
let $a3c9aff5a6eec062$var$gridVisible = false;
let $a3c9aff5a6eec062$var$vpEl = null;
let $a3c9aff5a6eec062$var$vpW = 0; // viewport client width
let $a3c9aff5a6eec062$var$colW = 0; // grid column width; 0 = no horizontal culling
// The team walking the selected path, or null when no raid is running. Pushed
// in by the raid loop once a second (setRaidParty); the position between those
// updates is interpolated here off the raid's own schedule, so the figures
// move at frame rate while the game keeps ticking at 1Hz.
let $a3c9aff5a6eec062$var$party = null;
// Outcome effects still playing — a check passing, a synergy firing, somebody
// taking a hit, an item coming up. Posted by the raid's resolution code, which
// is headless and knows nothing about this module, and collected here each
// frame. See raidFx-core.js.
let $a3c9aff5a6eec062$var$fx = [];
// How far from the party a tile has to be before it is left to the ordinary
// round-robin. Figures are drawn within DRAW_R (a party straddling a seam
// lands on both tiles); cells out to FORCE_R are redrawn every frame anyway,
// so the tile the team has just walked off is cleared of them immediately
// rather than whenever the rotation next reaches it.
const $a3c9aff5a6eec062$var$DRAW_R = 1.2;
const $a3c9aff5a6eec062$var$FORCE_R = 2.2;
// Per-frame composite budget. Compositing is a blit, a multiply, the short
// dynamic list and the cloud pass — ~0.14ms a cell, against ~0.44ms for the
// full redraw it replaces. At 120 the whole of a tier-3 grid (153 cells)
// still lands inside the frame cost the 40px renderer used to pay for 48 of
// them. Cells rotate round-robin, so exceeding the budget just means a cell
// refreshes every other frame — adjacent tiles a frame apart diverge by
// <1px of cloud drift, below visibility.
const $a3c9aff5a6eec062$var$FRAME_BUDGET = 120;
// Still-layer repaints per frame. The cached layer only changes when the
// sun moves the shadows a whole unit (a couple of dozen times a game day),
// and then EVERY cell needs it — so the sweep is spread across frames
// instead of hitching. 4/frame clears a tier-3 grid in ~3s of the ~24s
// between changes.
const $a3c9aff5a6eec062$var$STATIC_BUDGET = 4;
const $a3c9aff5a6eec062$var$reducedMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
function $a3c9aff5a6eec062$export$8a6e680b278759fc() {
    return (0, $c454fb723f814d89$export$e15059ad23f67dd4)($a3c9aff5a6eec062$var$animRegionId, $a3c9aff5a6eec062$var$animSite).phase;
}
function $a3c9aff5a6eec062$export$bcbc425da348b5df(regionId, site) {
    $a3c9aff5a6eec062$var$animRegionId = regionId;
    $a3c9aff5a6eec062$var$animSite = site || null;
}
// Is this room's committed encounter set indoors? The grid pins its events at
// generation (preRollGridEvents), so the tile can be drawn for the encounter it
// will actually run — an indoor one gets its roof cut away. Read out of the
// generated constants rather than importing the event system, which would drag
// the whole raid-loot graph into the renderer's call path for one string.
const $a3c9aff5a6eec062$var$envCache = new Map();
function $a3c9aff5a6eec062$var$isIndoorEncounter(room) {
    const id = room?.plannedEventIds?.[0];
    if (!id) return false;
    if (!$a3c9aff5a6eec062$var$envCache.has(id)) {
        let env = null;
        for (const list of [
            $ce6dd72bc4611534$export$f152896064e09913,
            $ce6dd72bc4611534$export$1cd1fab9b9844b76,
            $ce6dd72bc4611534$export$9435522665f2dda4
        ]){
            const found = list?.find((e)=>e.id === id);
            if (found) {
                env = found.environment;
                break;
            }
        }
        $a3c9aff5a6eec062$var$envCache.set(id, env);
    }
    return $a3c9aff5a6eec062$var$envCache.get(id) === 'indoor';
}
function $a3c9aff5a6eec062$export$2eefc97a05b1cdd3(p) {
    const was = $a3c9aff5a6eec062$var$party && $a3c9aff5a6eec062$var$party.pos;
    $a3c9aff5a6eec062$var$party = p && p.path && p.path.length && p.members && p.members.length ? {
        ...p,
        pos: null,
        stage: null,
        stageKey: null
    } : null;
    // A raid ending takes its outcomes with it: a flare still playing over a
    // completed grid is announcing something the player has already been paid
    // for. Reduced motion never starts a loop and so never draws these at all,
    // which is the right answer for a screen full of flashes anyway — the log
    // and the notifications carry the same news.
    if (!$a3c9aff5a6eec062$var$party) {
        $a3c9aff5a6eec062$var$fx = [];
        (0, $b3111b8b2d4b2b7b$export$fd4b5295b61ee6bc)();
        $a3c9aff5a6eec062$var$setTransit(false);
    }
    if ($a3c9aff5a6eec062$var$party) $a3c9aff5a6eec062$var$party.pos = $a3c9aff5a6eec062$var$partyNow();
    // Nothing else repaints the tiles the team has LEFT. The animation loop
    // covers that while it is running (it redraws the neighbourhood every
    // frame), but two cases have no loop to rely on: reduced motion, which
    // never starts one, and the end of a raid, which clears the party and
    // would otherwise leave three figures standing on the last tile until the
    // round-robin happened past them.
    const cellOf = (q)=>q && `${Math.round(q.row)},${Math.round(q.col)}`;
    if ($a3c9aff5a6eec062$var$reducedMotion || !$a3c9aff5a6eec062$var$party) {
        if (cellOf(was) !== cellOf($a3c9aff5a6eec062$var$party && $a3c9aff5a6eec062$var$party.pos)) {
            $a3c9aff5a6eec062$var$redrawNearParty(was);
            $a3c9aff5a6eec062$var$redrawNearParty($a3c9aff5a6eec062$var$party && $a3c9aff5a6eec062$var$party.pos);
        }
    }
}
// Resolve the party snapshot against the wall clock. Returns what partyAt
// returns, or null when no raid is running.
function $a3c9aff5a6eec062$var$partyNow() {
    if (!$a3c9aff5a6eec062$var$party) return null;
    const { elapsedMs: elapsedMs, durationMs: durationMs } = (0, $b44bbfd29b442498$export$340c4cb4c285ee0f)($a3c9aff5a6eec062$var$party.raid, Date.now());
    // The step index comes off the LIVE raid when there is one, not off the
    // snapshot: the index and the schedule have to be from the same tick. A
    // room that ended between two pushes would otherwise pair a fresh
    // roomStartTime with the previous step and put the team back at the tile
    // they just left for the rest of the second.
    const index = $a3c9aff5a6eec062$var$party.raid?.currentRoomIndex ?? $a3c9aff5a6eec062$var$party.index;
    // The tile's own stage first: how far the team spreads decides how long the
    // spreading takes, and where it gathers decides how far it has to walk to
    // get there. Both come out of the tile's ground plan.
    const stage = $a3c9aff5a6eec062$var$stageFor($a3c9aff5a6eec062$var$party.path?.[index], $a3c9aff5a6eec062$var$party.members.length);
    return (0, $b44bbfd29b442498$export$e35a622415b5919f)($a3c9aff5a6eec062$var$party.path, index, elapsedMs, durationMs, stage);
}
// What this tile makes of the party: the standing posts, how far they are
// spread, and where the party gathers. Worked out once per path step and
// cached, because it is a scan over the tile's footprints and it cannot change
// while the team is standing on it.
//
// The ground plan is the renderer's own record of where it put the buildings
// and the water, so the team is kept off exactly what the map drew rather than
// off a guess about what it might have drawn.
function $a3c9aff5a6eec062$var$stageFor(step, count) {
    if (!step) return null;
    const key = `${step.row},${step.col},${count}`;
    if ($a3c9aff5a6eec062$var$party.stageKey === key) return $a3c9aff5a6eec062$var$party.stage;
    const cell = $a3c9aff5a6eec062$var$animCells.find((c)=>c.row === step.row && c.col === step.col);
    const plan = (0, $b44bbfd29b442498$export$210e317b6c4ae768)(cell?.tile?.plan, (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8));
    // Seeded by the tile, so a given room lays its posts out the same way every
    // time the team walks into it, exactly as its art is the same every time.
    $a3c9aff5a6eec062$var$party.stageKey = key;
    $a3c9aff5a6eec062$var$party.stage = (0, $b44bbfd29b442498$export$5c7563bc4285410)(plan, count, step.row * 31 + step.col * 17 >>> 0, step.room?.type);
    return $a3c9aff5a6eec062$var$party.stage;
}
function $a3c9aff5a6eec062$export$72b470d5f7d48c79() {
    // drop the cached still layers with the cells — a tier-3 grid holds ~9MB
    // of them, and a new raid rebuilds every tile anyway
    for (const c of $a3c9aff5a6eec062$var$animCells)c.tile.canvas = null;
    $a3c9aff5a6eec062$var$animCells = [];
    $a3c9aff5a6eec062$var$animRegionId = null;
    $a3c9aff5a6eec062$var$animSite = null;
    $a3c9aff5a6eec062$var$party = null;
    $a3c9aff5a6eec062$var$fx = [];
    (0, $b3111b8b2d4b2b7b$export$fd4b5295b61ee6bc)();
    $a3c9aff5a6eec062$var$setTransit(false);
    $a3c9aff5a6eec062$var$drawCursor = 0;
    $a3c9aff5a6eec062$var$maxCol = 0;
    $a3c9aff5a6eec062$var$lastLayoutCheck = 0;
    $a3c9aff5a6eec062$var$gridVisible = false;
    $a3c9aff5a6eec062$var$vpEl = null;
    $a3c9aff5a6eec062$var$vpW = 0;
    $a3c9aff5a6eec062$var$colW = 0;
}
// offsetParent, scrollWidth and clientWidth each force a style + layout
// flush, so they're sampled on the slow cadence rather than every frame;
// only scrollLeft (which has to track the user's scrolling) is read live.
function $a3c9aff5a6eec062$var$refreshLayout() {
    const grid = document.getElementById('raid-grid');
    // Raid tab not visible — the loop stays scheduled but skips the work
    // (the browser already pauses rAF entirely when the window is hidden)
    $a3c9aff5a6eec062$var$gridVisible = !!grid && grid.offsetParent !== null;
    $a3c9aff5a6eec062$var$vpEl = document.getElementById('raid-grid-viewport');
    $a3c9aff5a6eec062$var$vpW = $a3c9aff5a6eec062$var$vpEl ? $a3c9aff5a6eec062$var$vpEl.clientWidth : 0;
    $a3c9aff5a6eec062$var$colW = $a3c9aff5a6eec062$var$gridVisible && $a3c9aff5a6eec062$var$vpEl && $a3c9aff5a6eec062$var$maxCol > 0 && $a3c9aff5a6eec062$var$vpEl.scrollWidth > $a3c9aff5a6eec062$var$vpW ? $a3c9aff5a6eec062$var$vpEl.scrollWidth / ($a3c9aff5a6eec062$var$maxCol + 1) : 0;
}
// ============================================================================
// DAY-CLOCK BAR (#raid-day-clock, above the raid grid)
// ============================================================================
// A window onto 1/3 of the game day: the gradient (one full day = 3 bar
// widths) and the dawn/noon/dusk/midnight icons scroll right-to-left as time
// passes, wrapping around; the fixed center marker is "now".
//
// Since S9 the bar reads the RAIDING REGION's local time, and says so: the
// readout is the only place the world clock is legible as a number, and
// "17:42" over an unnamed bar invites the player to assume it is the same
// 17:42 everywhere.
// Icon markers live in index.html as .raid-day-clock-icon spans with
// data-phase attributes — noon (0.5) and midnight (0). Sunrise and sunset are
// worldClock-core's SUNRISE/SUNSET, and they read off the gradient without
// needing their own glyphs.
// One static gradient sampling the daylight curve across a full day,
// night-navy -> dawn-amber -> noon-cream -> dusk-amber -> navy
function $a3c9aff5a6eec062$var$buildDayGradient() {
    const night = [
        26,
        33,
        58
    ], day = [
        255,
        236,
        179
    ], warm = [
        255,
        171,
        94
    ];
    const stops = [];
    for(let i = 0; i <= 24; i++){
        const phase = i / 24;
        const light = ((0, $c454fb723f814d89$export$a16ed293100b6f71)(phase) - 0.4) / 0.6; // 0..1
        // blend night->warm->day: warm band in the transition
        const t = light, w = Math.max(0, 1 - Math.abs(t - 0.45) / 0.35); // warmth bump around transitions
        const mix = (a, b, f)=>Math.round(a + (b - a) * f);
        const base = night.map((n, ch)=>mix(n, day[ch], t));
        const rgb = base.map((b, ch)=>mix(b, warm[ch], w * 0.55));
        stops.push(`rgb(${rgb.join(',')}) ${(phase * 100).toFixed(1)}%`);
    }
    return `linear-gradient(90deg, ${stops.join(', ')})`;
}
let $a3c9aff5a6eec062$var$clockInitialized = false;
function $a3c9aff5a6eec062$var$updateDayClock() {
    const track = document.getElementById('raid-day-clock-track');
    if (!track) return;
    if (!$a3c9aff5a6eec062$var$clockInitialized) {
        track.style.backgroundImage = $a3c9aff5a6eec062$var$buildDayGradient();
        track.style.backgroundSize = '300% 100%';
        track.style.backgroundRepeat = 'repeat-x';
        $a3c9aff5a6eec062$var$clockInitialized = true;
    }
    const local = (0, $c454fb723f814d89$export$e15059ad23f67dd4)($a3c9aff5a6eec062$var$animRegionId, $a3c9aff5a6eec062$var$animSite);
    const readout = document.getElementById('raid-day-clock-readout');
    if (readout) {
        const regionName = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[$a3c9aff5a6eec062$var$animRegionId]?.name;
        readout.textContent = `${local.icon} ${local.time}`;
        readout.title = regionName ? `${regionName} \u{2014} local time at THIS raid site, ${local.name}. A region spans several hours of longitude, so the next raid there can meet a different sun. The map's daylight follows this clock.` : `Local time \u{2014} ${local.name}`;
    }
    const width = track.clientWidth;
    if (!width) return;
    const dayPhase = local.phase;
    const lineNow = document.getElementById('raid-day-clock-now');
    const lineNowColor = (1 - (0, $c454fb723f814d89$export$a16ed293100b6f71)(dayPhase)) * 255;
    lineNow.style.backgroundColor = `rgb(${lineNowColor},${lineNowColor},${lineNowColor})`;
    // gradient's t=dayPhase point sits at the bar center; repeat-x wraps
    track.style.backgroundPositionX = `${width / 2 - dayPhase * 3 * width}px`;
    for (const el of track.querySelectorAll('.raid-day-clock-icon')){
        const phase = parseFloat(el.dataset.phase);
        const delta = (phase - dayPhase + 1.5) % 1 - 0.5; // days from now, [-0.5, 0.5)
        el.style.left = `${width / 2 + delta * 3 * width}px`;
    }
}
function $a3c9aff5a6eec062$export$5f82487e371f5e57(cellEl, room, conn, regionKey) {
    if (typeof document === 'undefined' || !room || !room.name) return;
    // Belt and braces for the tile palette, which is keyed to the region: a
    // caller that forgot setRaidSite still gets the right art, and the clock
    // falls back to the region capital rather than the meridian.
    if (!$a3c9aff5a6eec062$var$animRegionId) $a3c9aff5a6eec062$var$animRegionId = regionKey;
    const recipe = typeof room.recipe === 'string' && (0, $e81502d4aa27ba48$export$a571935592b1ff4d)[room.recipe] ? room.recipe : (0, $e81502d4aa27ba48$export$5f148632ad7917b2)(room.name, room.category, room.type);
    // Position-salted seed: persisted row/col keep compositions stable
    // across reloads while twin rooms get distinct layouts
    const salt = room.row != null ? `@${room.row},${room.col}` : '';
    const canvas = document.createElement('canvas');
    canvas.width = (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8);
    canvas.height = (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8);
    canvas.className = 'room-tile-canvas';
    cellEl.prepend(canvas);
    const cell = {
        ctx: canvas.getContext('2d'),
        tile: (0, $e81502d4aa27ba48$export$9b747065b14bfa5f)(regionKey, recipe, room.name, {
            salt: salt,
            conn: conn,
            roomType: room.type,
            col: room.col,
            row: room.row,
            // the skill this room's encounter tests, for its map anchor;
            // absent on roads, water, campsites, entry/exit and blocked cells
            primary: room.primary,
            indoor: $a3c9aff5a6eec062$var$isIndoorEncounter(room),
            // the generated road layer: which way the roadway leaves this tile,
            // and whether it is the trunk or a branch. Absent on most tiles.
            road: room.road,
            roadRank: room.roadRank,
            // steps to the nearest roadway: how built-up this tile is allowed
            // to be, so development thickens along the routes and thins out
            // behind them
            roadDist: room.roadDist,
            // the district this cell sits in: how built up the ground around it
            // is, and so how much growth and how worn a road gets. Distance to
            // a road cannot say that — there are busy back lots and empty
            // frontages — and it is what makes an outskirt look like one.
            zone: room.zone,
            // how far this cell is from the open ocean, in whole tiles, and
            // which edge of the map that is. Only a region the sea got into
            // has them; everywhere else they are absent and nothing floods.
            shore: room.shore,
            shoreSide: room.shoreSide,
            // the sublevel's rail spur — one column of the map, laid like a road
            rail: room.rail,
            // which sides a rest stop or shoreline carries its open ground
            // across, so two clearings side by side read as one
            clearing: room.clearing
        }),
        row: room.row,
        col: room.col
    };
    if (room.col != null && room.col > $a3c9aff5a6eec062$var$maxCol) $a3c9aff5a6eec062$var$maxCol = room.col;
    $a3c9aff5a6eec062$var$animCells.push(cell);
    // First frame immediately so the grid is never blank; for reduced-motion
    // users this is also the final (static) picture (clock included)
    (0, $e81502d4aa27ba48$export$ca17ef1db7f8dd8f)(cell.tile, $a3c9aff5a6eec062$export$8a6e680b278759fc());
    $a3c9aff5a6eec062$var$drawCell(cell, $a3c9aff5a6eec062$var$animParams(performance.now(), 0), $a3c9aff5a6eec062$var$partyNow());
    $a3c9aff5a6eec062$var$updateDayClock();
    if (!$a3c9aff5a6eec062$var$reducedMotion && $a3c9aff5a6eec062$var$rafId == null) {
        $a3c9aff5a6eec062$var$lastFrame = 0;
        $a3c9aff5a6eec062$var$rafId = requestAnimationFrame($a3c9aff5a6eec062$var$animFrame);
    }
}
function $a3c9aff5a6eec062$var$animParams(ts, dt) {
    const t = ts / 1000;
    const wind = $a3c9aff5a6eec062$var$BASE_WIND * (0.7 + 0.3 * Math.sin(t * 0.35) + 0.2 * Math.sin(t * 1.3));
    const dayPhase = $a3c9aff5a6eec062$export$8a6e680b278759fc();
    $a3c9aff5a6eec062$var$cloudX += dt * (3 + wind * 12);
    $a3c9aff5a6eec062$var$cloudY += dt * (1 + wind * 4);
    const cover = $a3c9aff5a6eec062$var$CLOUD_BASE * (0.85 + 0.3 * Math.sin(t * 0.04) + 0.15 * Math.sin(t * 0.017));
    // Effects are posted by the raid loop, which runs on the wall clock, so
    // they are timed against that rather than against `t` (which counts from
    // whenever the page happened to load).
    return {
        wind: wind,
        dayPhase: dayPhase,
        t: t,
        nowMs: Date.now(),
        cloud: {
            cover: cover,
            x: $a3c9aff5a6eec062$var$cloudX,
            y: $a3c9aff5a6eec062$var$cloudY
        }
    };
}
function $a3c9aff5a6eec062$var$drawCell(c, p, pos) {
    (0, $e81502d4aa27ba48$export$217de4d82c975a34)(c.ctx, c.tile, {
        ...p,
        row: c.row,
        col: c.col
    });
    // The team goes on last, over everything the tile is and everything
    // overhead. Their pixel position is relative to THIS canvas, so a party
    // between two tiles is drawn on both and each clips its own half.
    if ($a3c9aff5a6eec062$var$party && pos && Math.abs(pos.col - c.col) <= $a3c9aff5a6eec062$var$DRAW_R && Math.abs(pos.row - c.row) <= $a3c9aff5a6eec062$var$DRAW_R) (0, $b4a8c2719a6e2142$export$d0f529c5e2e21188)(c.ctx, (pos.col - c.col + 0.5) * (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8), (pos.row - c.row + 0.5) * (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8), {
        party: pos,
        members: $a3c9aff5a6eec062$var$party.members,
        tSec: p.t,
        dayPhase: p.dayPhase,
        tile: (0, $e81502d4aa27ba48$export$3175e1b22a5f59e8),
        posts: $a3c9aff5a6eec062$var$party.stage?.postOffsets,
        resting: $a3c9aff5a6eec062$var$party.stage?.resting,
        fx: $a3c9aff5a6eec062$var$fx,
        nowMs: p.nowMs
    });
}
// Repaint every tile within reach of `at`, off the animation loop's cadence.
// The team is drawn from the party's CURRENT position, so passing an old one
// here is how a tile they have left gets cleared.
function $a3c9aff5a6eec062$var$redrawNearParty(at) {
    if (!at || !$a3c9aff5a6eec062$var$animCells.length) return;
    const pos = $a3c9aff5a6eec062$var$partyNow();
    const p = $a3c9aff5a6eec062$var$animParams(typeof performance !== 'undefined' ? performance.now() : 0, 0);
    for (const c of $a3c9aff5a6eec062$var$animCells){
        if (!$a3c9aff5a6eec062$var$nearParty(c, at)) continue;
        (0, $e81502d4aa27ba48$export$ca17ef1db7f8dd8f)(c.tile, p.dayPhase);
        $a3c9aff5a6eec062$var$drawCell(c, p, pos);
    }
}
// ---- the current room's zoom, and why the map has to switch it off ----
// The room the team is in is magnified (styles.css `.current-room`), which is
// a good way to say "here" and a bad way to cross a boundary: the team is
// drawn on BOTH tiles either side of a seam and each canvas clips its own
// half, so a magnified tile beside an unmagnified one splits the party into
// two different sizes down the join.
//
// So the zoom is dropped for as long as the team is between tiles and put back
// once they have settled. `walking` is exactly that window — it is true for the
// walk out and the walk in and false for the whole dwell — and it starts a full
// half-tile before they reach the edge, which is seconds of room for the CSS
// transition to finish in. A road, where the team never stops, never zooms.
let $a3c9aff5a6eec062$var$transit = false;
function $a3c9aff5a6eec062$var$setTransit(on) {
    if (on === $a3c9aff5a6eec062$var$transit) return;
    $a3c9aff5a6eec062$var$transit = on;
    document.getElementById('raid-grid')?.classList.toggle('team-in-transit', on);
}
// Is this cell close enough to the party to need repainting every frame?
// Generous by a full tile beyond where a figure can be drawn, so leaving a
// tile clears it in the same frame.
function $a3c9aff5a6eec062$var$nearParty(c, pos) {
    return !!pos && c.col != null && Math.abs(pos.col - c.col) <= $a3c9aff5a6eec062$var$FORCE_R && Math.abs(pos.row - c.row) <= $a3c9aff5a6eec062$var$FORCE_R;
}
function $a3c9aff5a6eec062$var$animFrame(ts) {
    if ($a3c9aff5a6eec062$var$animCells.length === 0) {
        $a3c9aff5a6eec062$var$rafId = null;
        return;
    }
    $a3c9aff5a6eec062$var$rafId = requestAnimationFrame($a3c9aff5a6eec062$var$animFrame);
    if (ts - $a3c9aff5a6eec062$var$lastFrame < (document.hasFocus() ? $a3c9aff5a6eec062$var$FRAME_MS : $a3c9aff5a6eec062$var$BLUR_FRAME_MS)) return;
    // dt caps at the background interval so cloud drift stays wall-clock
    // honest at 2fps, while a return from a long pause can't jump the sky
    const dt = $a3c9aff5a6eec062$var$lastFrame ? Math.min($a3c9aff5a6eec062$var$BLUR_FRAME_MS / 1000, (ts - $a3c9aff5a6eec062$var$lastFrame) / 1000) : 0;
    $a3c9aff5a6eec062$var$lastFrame = ts;
    if (ts - $a3c9aff5a6eec062$var$lastLayoutCheck > $a3c9aff5a6eec062$var$LAYOUT_MS) {
        $a3c9aff5a6eec062$var$lastLayoutCheck = ts;
        $a3c9aff5a6eec062$var$refreshLayout();
    }
    if (!$a3c9aff5a6eec062$var$gridVisible) return;
    const p = $a3c9aff5a6eec062$var$animParams(ts, dt);
    // Collect whatever the raid resolved since the last frame, and drop what
    // has finished playing. Drained even with no party on the map so a queue
    // posted while the screen was elsewhere cannot arrive stale later.
    const posted = (0, $b3111b8b2d4b2b7b$export$e81dc0d2f0f0a3e4)();
    if (posted.length) $a3c9aff5a6eec062$var$fx = $a3c9aff5a6eec062$var$party ? $a3c9aff5a6eec062$var$fx.concat(posted) : [];
    if ($a3c9aff5a6eec062$var$fx.length) $a3c9aff5a6eec062$var$fx = (0, $b3111b8b2d4b2b7b$export$4eb22852cf19c442)($a3c9aff5a6eec062$var$fx, p.nowMs);
    // Sweep the still layers back up to date after the sun moves them. The
    // check is cheap and returns false for a cell that is already current,
    // so scanning from the front each frame walks the sweep forward on its
    // own — no dirty queue to keep in sync with the cell list.
    for(let i = 0, repainted = 0; i < $a3c9aff5a6eec062$var$animCells.length && repainted < $a3c9aff5a6eec062$var$STATIC_BUDGET; i++)if ((0, $e81502d4aa27ba48$export$ca17ef1db7f8dd8f)($a3c9aff5a6eec062$var$animCells[i].tile, p.dayPhase)) repainted++;
    // Viewport column culling: #raid-grid-viewport scrolls horizontally on
    // tier 2/3, and the grid is uniform - the visible column window falls
    // straight out of the scroll offsets, no per-cell rect queries. The ±2
    // column margin absorbs the grid's inner padding and keeps edge tiles
    // fresh mid-scroll; a cell scrolled into view redraws within a frame
    // or two when the rotation reaches it.
    let colMin = -Infinity, colMax = Infinity;
    if ($a3c9aff5a6eec062$var$colW) {
        colMin = Math.floor($a3c9aff5a6eec062$var$vpEl.scrollLeft / $a3c9aff5a6eec062$var$colW) - 2;
        colMax = Math.ceil(($a3c9aff5a6eec062$var$vpEl.scrollLeft + $a3c9aff5a6eec062$var$vpW) / $a3c9aff5a6eec062$var$colW) + 1;
    }
    // The team's own neighbourhood is drawn first and every frame, outside
    // both the rotation and the column cull: it is the one part of the map
    // that MUST be current, and it is a couple of dozen cells at most.
    const pos = $a3c9aff5a6eec062$var$partyNow();
    // Drop the current room's zoom while the team is crossing between tiles.
    $a3c9aff5a6eec062$var$setTransit(!!pos && pos.walking);
    const len = $a3c9aff5a6eec062$var$animCells.length;
    let drawn = 0;
    if (pos) for(let i = 0; i < len; i++){
        const c = $a3c9aff5a6eec062$var$animCells[i];
        if (!$a3c9aff5a6eec062$var$nearParty(c, pos)) continue;
        $a3c9aff5a6eec062$var$drawCell(c, p, pos);
        c.partyFrame = ts;
        drawn++;
    }
    // Rotate through the rest under the frame budget (see FRAME_BUDGET);
    // culled cells cost nothing and don't consume budget, so the visible
    // window refreshes at full rate
    for(let scanned = 0; scanned < len && drawn < $a3c9aff5a6eec062$var$FRAME_BUDGET; scanned++){
        const c = $a3c9aff5a6eec062$var$animCells[$a3c9aff5a6eec062$var$drawCursor % len];
        $a3c9aff5a6eec062$var$drawCursor++;
        if (c.partyFrame === ts) continue; // already drawn above
        if (c.col != null && (c.col < colMin || c.col > colMax)) continue;
        $a3c9aff5a6eec062$var$drawCell(c, p, pos);
        drawn++;
    }
    // The clock crawls (a full day = 10 minutes): 4Hz DOM writes are plenty
    if (ts - $a3c9aff5a6eec062$var$lastClockUpdate > 250) {
        $a3c9aff5a6eec062$var$lastClockUpdate = ts;
        $a3c9aff5a6eec062$var$updateDayClock();
    }
}




/**
 * Raid Logic Core - Pure Functions
 *
 * Extract pure game logic functions from raid.js without browser dependencies
 *
 * These are exact copies of functions from raid.js that:
 * - Calculate drop rates and loot pools
 * - Generate raid grid layouts
 * - Determine faction-based drops
 * - Validate paths and calculate game mechanics
 *
 * Can be imported and used in Node.js for testing and simulation
 */ 



//done
//@ts-check



// Multiplayer system using Cloudflare Pages Functions (functions/api/*) + Neon PostgreSQL
// Falls back to local storage when offline or headless
// How long a marketplace listing response stays reusable. Long enough to collapse
// the burst of refreshes fired during page load, short enough that another
// player's listing shows up promptly. Mutations clear the cache outright.
const $f5272a3e1bbf7d7b$var$MARKETPLACE_CACHE_MS = 5000;
// Sticky opt-in for talking to a locally-served API (see the constructor).
// `?multiplayer=1` turns it on and persists; `?multiplayer=0` turns it back off.
// localStorage access can throw (private mode), so treat any failure as "off".
function $f5272a3e1bbf7d7b$var$readMultiplayerOverride() {
    try {
        const param = new URLSearchParams(window.location.search).get('multiplayer');
        if (param === '1') localStorage.setItem('forceMultiplayer', '1');
        else if (param === '0') localStorage.removeItem('forceMultiplayer');
        return localStorage.getItem('forceMultiplayer') === '1';
    } catch (error) {
        return false;
    }
}
class $f5272a3e1bbf7d7b$var$MultiplayerSystem {
    constructor(){
        // Headless environments (Node simulator/tests) have no window; run local/offline
        const hasWindow = typeof window !== 'undefined';
        // Check if we're in local development (no actual server)
        this.isLocalDevelopment = !hasWindow || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.protocol === 'file:';
        // Local dev forces offline because `npm run dev` (Parcel) serves no API.
        // `npm run dev:api` DOES serve the real Pages Functions locally, so opt in
        // with ?multiplayer=1 to exercise the marketplace end-to-end against real
        // server logic (see README "Testing marketplace behavior locally").
        // Gated on hasWindow so the headless simulator/tests always stay offline.
        this.forceMultiplayer = hasWindow && $f5272a3e1bbf7d7b$var$readMultiplayerOverride();
        // Override online status for local development
        this.isOnline = hasWindow && navigator.onLine && (!this.isLocalDevelopment || this.forceMultiplayer);
        this.baseUrl = hasWindow ? window.location.origin : '';
        this.localCharacters = this.loadLocalCharacters();
        this._marketplaceCache = new Map(); // key -> { value, at } | { promise }
        if (hasWindow) {
            const mode = this.forceMultiplayer ? 'Local Development (multiplayer forced ON)' : this.isLocalDevelopment ? 'Local Development' : 'Production';
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F310} Multiplayer mode: ${mode}`);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F4F6} Online status: ${this.isOnline}`);
            if (this.forceMultiplayer) {
                // Easy mistake: the flag is sticky, so hitting the Parcel port with
                // it on makes every API call parse index.html as JSON ("Unexpected
                // token '<'") and every POST fail with a bare 405. Say which origin
                // we're actually calling, then confirm the API is really there.
                console.log(`\u{1F527} API base: ${this.baseUrl} \u{2014} this must be the port serving /api (npm run dev:api, default 8788), NOT the Parcel port. Use ?multiplayer=0 to turn this off.`);
                this.verifyLocalApi();
            }
            // Listen for online/offline events
            window.addEventListener('online', ()=>{
                this.isOnline = navigator.onLine && (!this.isLocalDevelopment || this.forceMultiplayer);
                (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Multiplayer: Network online, effective status: ${this.isOnline}`);
            });
            window.addEventListener('offline', ()=>{
                this.isOnline = false;
                (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Multiplayer: Gone offline, using local storage');
            });
        }
    }
    // Confirm the forced-on API base is actually serving the Pages Functions.
    // Pointing ?multiplayer=1 at the Parcel port is the easy mistake, and it fails
    // confusingly: GETs return index.html ("Unexpected token '<'") and POSTs come
    // back as a bare 405 from the static server. Detect that once, up front, and
    // fail closed so the game drops back to offline instead of spraying dozens of
    // misleading errors. Fire-and-forget from the constructor.
    async verifyLocalApi() {
        try {
            // my-listings with no ids short-circuits server-side before touching
            // the database, so this proves "a Pages Function answered with JSON"
            // at zero cost — and doesn't masquerade as a real marketplace fetch
            // in the network tab.
            const response = await fetch(`${this.baseUrl}/api/characters?action=my-listings&ids=`);
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) return; // API is live
            this.isOnline = false;
            console.error(`\u{274C} Multiplayer forced ON, but ${this.baseUrl} is not serving the API ` + `(got HTTP ${response.status}, content-type "${contentType || 'unknown'}"). ` + `Multiplayer disabled for this session to avoid misleading errors.\n` + `Fix: run "npm run dev:api" and open http://localhost:8788/?multiplayer=1 ` + `\u{2014} the Parcel port (3000) serves no API.`);
        } catch (error) {
            this.isOnline = false;
            console.error(`\u{274C} Multiplayer forced ON, but ${this.baseUrl}/api is unreachable (${error.message}). ` + `Start it with "npm run dev:api". Multiplayer disabled for this session.`);
        }
    }
    // Load characters from local storage (fallback)
    loadLocalCharacters() {
        if (typeof localStorage === 'undefined') return [];
        try {
            return JSON.parse(localStorage.getItem('multiplayerCharacters') || '[]');
        } catch (error) {
            console.error('Error loading local characters:', error);
            return [];
        }
    }
    // Save characters to local storage (fallback)
    saveLocalCharacters() {
        if (typeof localStorage === 'undefined') return;
        try {
            localStorage.setItem('multiplayerCharacters', JSON.stringify(this.localCharacters));
        } catch (error) {
            console.error('Error saving local characters:', error);
        }
    }
    // Check if character name is unique globally
    async isCharacterNameUnique(name) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F50D} Checking uniqueness for: "${name}"`);
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F4F6} Online status: ${this.isOnline}`);
        if (!this.isOnline) {
            // Offline fallback - check local storage for global uniqueness
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F4CA} Checking against ${this.localCharacters.length} local characters:`, this.localCharacters);
            const conflicts = this.localCharacters.filter((char)=>char.name.toLowerCase() === name.toLowerCase());
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{2694}\u{FE0F} Name conflicts found:`, conflicts);
            const isUnique = conflicts.length === 0;
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{2705} Name "${name}" is unique: ${isUnique}`);
            return isUnique;
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=check-name&name=${encodeURIComponent(name)}`);
            const data = await response.json();
            if (data.success) return data.isUnique;
            else {
                console.error('Name check failed:', data.message);
                return false;
            }
        } catch (error) {
            console.error('Error checking name uniqueness:', error);
            // Fallback to local check for global uniqueness
            return !this.localCharacters.some((char)=>char.name.toLowerCase() === name.toLowerCase());
        }
    }
    // Register a new character
    async registerCharacter(character) {
        if (!this.isOnline) throw new Error('Cannot register character while offline');
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    // Identity/cosmetic only — the server sets all stats (hardened create).
                    name: character.name,
                    faction: character.faction,
                    avatar: character.avatar,
                    avatarSeed: character.avatarSeed || null,
                    avatarFeatures: character.avatarFeatures || null,
                    title: character.title || null,
                    quote: character.quote || null
                })
            });
            const data = await response.json();
            if (data.success) // Attach the one-time ownership token to the returned row so the
            // caller can persist it on the character (see gameState §2).
            return {
                ...data.character,
                ownerToken: data.token
            };
            else throw new Error(data.message);
        } catch (error) {
            console.error('Error registering character:', error);
            throw error;
        }
    }
    // Claim a pre-token (legacy) character row, upgrading it from open "grace"
    // writes to token-owned. Only succeeds for eligible rows (server-checked:
    // null hash, level <= 2, no artifacts/gear). Returns the new token or null.
    async claimLegacyCharacter(characterId) {
        if (!this.isOnline || !characterId) return null;
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=claim-legacy`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    characterId: characterId
                })
            });
            const data = await response.json();
            return data.success ? data.token : null;
        } catch (error) {
            console.error('Error claiming legacy character:', error);
            return null;
        }
    }
    // Build request headers, attaching the ownership token for the character
    // with this multiplayerId when we hold it (looked up from gameState). The
    // server requires it for writes to a token-bearing row.
    _authHeaders(characterId) {
        const headers = {
            'Content-Type': 'application/json'
        };
        const owner = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters || []).find((c)=>c.multiplayerId === characterId);
        if (owner?.ownerToken) headers['Authorization'] = `Bearer ${owner.ownerToken}`;
        return headers;
    }
    // Update character data
    async updateCharacter(characterId, updates) {
        // Update local character if it exists
        const localIndex = this.localCharacters.findIndex((char)=>char.id === characterId);
        if (localIndex !== -1) {
            this.localCharacters[localIndex] = {
                ...this.localCharacters[localIndex],
                ...updates
            };
            this.saveLocalCharacters();
        }
        if (!this.isOnline) return; // Only local update needed
        try {
            const response = await fetch(`${this.baseUrl}/api/characters`, {
                method: 'PUT',
                headers: this._authHeaders(characterId),
                body: JSON.stringify({
                    id: characterId,
                    ...updates
                })
            });
            const data = await response.json();
            if (!data.success) console.error('Error updating character:', data.message);
        } catch (error) {
            console.error('Error updating character:', error);
        }
    }
    // Get all available contractors
    async getAllContractors(excludeCharacterId = null) {
        let contractors = [];
        if (this.isOnline) try {
            const url = excludeCharacterId ? `${this.baseUrl}/api/characters?action=contractors&exclude=${excludeCharacterId}` : `${this.baseUrl}/api/characters?action=contractors`;
            const response = await fetch(url);
            const data = await response.json();
            if (data.success) contractors = data.contractors.map((char)=>({
                    ...char,
                    isPlayerCharacter: true,
                    isOnline: true
                }));
        } catch (error) {
            console.error('Error fetching online contractors:', error);
        }
        // Add local characters (excluding current character)
        const localContractors = this.localCharacters.filter((char)=>char.id !== excludeCharacterId).map((char)=>({
                ...char,
                isPlayerCharacter: true,
                isLocal: true
            }));
        return [
            ...contractors,
            ...localContractors
        ];
    }
    // List character on marketplace
    async listCharacterOnMarketplace(characterId, durationHours = 24, rewardPercentage = 15) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F4E2} Listing character ${characterId} on marketplace for ${durationHours} hours`);
        if (!this.isOnline) throw new Error('Cannot list characters on marketplace. Please connect to internet.');
        try {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Sending request to list character on marketplace...');
            const response = await fetch(`${this.baseUrl}/api/characters?action=list-marketplace`, {
                method: 'POST',
                headers: this._authHeaders(characterId),
                body: JSON.stringify({
                    characterId: characterId,
                    durationHours: durationHours,
                    rewardPercentage: rewardPercentage
                })
            });
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Listing character on marketplace, response:', response);
            const data = await response.json();
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Listing character on marketplace, data:', data);
            if (data.success) {
                this.invalidateMarketplaceCache();
                return data.listing;
            } else throw new Error(data.message);
        } catch (error) {
            console.error('Error listing character on marketplace:', error);
            throw error;
        }
    }
    // Claim the un-hired contract-completion payout for an expired listing.
    // The server decides eligibility (expired, never hired, not already claimed)
    // and computes the reward; a payment then arrives via the normal pending
    // flow. Owner-authenticated. Returns the server response (may be
    // { claimed: false }) or null when offline.
    async claimContractCompletion(characterId) {
        if (!this.isOnline) return null;
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=claim-contract-completion`, {
                method: 'POST',
                headers: this._authHeaders(characterId),
                body: JSON.stringify({
                    characterId: characterId
                })
            });
            return await response.json();
        } catch (error) {
            console.error('Error claiming contract completion:', error);
            throw error;
        }
    }
    // Remove character from marketplace
    async removeCharacterFromMarketplace(characterId) {
        if (!this.isOnline) throw new Error('Cannot access marketplace while offline');
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=marketplace&id=${characterId}`, {
                method: 'DELETE',
                headers: this._authHeaders(characterId)
            });
            const data = await response.json();
            if (data.success) this.invalidateMarketplaceCache();
            return data.success;
        } catch (error) {
            console.error('Error removing character from marketplace:', error);
            throw error;
        }
    }
    // Get marketplace listings with optional level filtering.
    //
    // Page load fans out several near-simultaneous refreshes (Alpine store init,
    // displayContractors, the gameState load hook, the periodic timer), which
    // previously meant ~6 identical requests. Concurrent callers now share one
    // in-flight request, and the result is held for MARKETPLACE_CACHE_MS so a
    // burst collapses to a single call. Any marketplace mutation clears the cache
    // (see invalidateMarketplaceCache), so the UI never shows stale listings.
    async getMarketplaceListings(minLevel = null, maxLevel = null, excludeIds = []) {
        if (!this.isOnline) return [];
        const key = `${minLevel}|${maxLevel}|${[
            ...excludeIds
        ].sort().join(',')}`;
        const entry = this._marketplaceCache.get(key);
        if (entry) {
            if (entry.promise) return entry.promise; // already in flight
            if (Date.now() - entry.at < $f5272a3e1bbf7d7b$var$MARKETPLACE_CACHE_MS) return entry.value; // still fresh
        }
        // `entry` (captured before we overwrite it below) carries the previous
        // value + ETag, so a 304 can be answered from it without a body.
        const promise = this._fetchMarketplaceListings(minLevel, maxLevel, excludeIds, entry).then(({ value: value, etag: etag })=>{
            this._marketplaceCache.set(key, {
                value: value,
                etag: etag,
                at: Date.now()
            });
            return value;
        });
        this._marketplaceCache.set(key, {
            promise: promise
        });
        return promise;
    }
    // Uncached fetch. Never throws — callers treat [] as "nothing available".
    //
    // Sends If-None-Match when we've seen this list before. The contractors UI
    // polls every 10s, and listings rarely change, so the overwhelmingly common
    // response is a bodiless 304: no JOIN server-side, no payload, no JSON parse.
    async _fetchMarketplaceListings(minLevel, maxLevel, excludeIds, previous) {
        try {
            let url = `${this.baseUrl}/api/characters?action=marketplace`;
            if (minLevel !== null) url += `&minLevel=${minLevel}`;
            if (maxLevel !== null) url += `&maxLevel=${maxLevel}`;
            if (excludeIds && excludeIds.length > 0) url += `&exclude=${excludeIds.join(',')}`;
            const options = previous?.etag ? {
                headers: {
                    'If-None-Match': previous.etag
                }
            } : {};
            const response = await fetch(url, options);
            // Not modified — keep what we already parsed.
            if (response.status === 304) return {
                value: previous?.value ?? [],
                etag: previous?.etag ?? null
            };
            const etag = response.headers.get('ETag');
            const data = await response.json();
            if (data.success) return {
                value: data.listings,
                etag: etag
            };
            console.error('Error getting marketplace listings:', data.message);
            return {
                value: [],
                etag: null
            };
        } catch (error) {
            console.error('Error fetching marketplace listings:', error);
            return {
                value: [],
                etag: null
            };
        }
    }
    // Drop cached listings after anything that changes them (list, withdraw,
    // reserve, hire, release, settle) so the next read reflects the change.
    invalidateMarketplaceCache() {
        this._marketplaceCache.clear();
    }
    // Server truth for this player's own listings, keyed by character id. The
    // client caches marketplaceData at listing time and would otherwise never see
    // a server-side change to it (notably the dev time-shift tool).
    //
    // Returns an array on success (possibly empty = "you have no listings") and
    // null when we couldn't find out. Callers MUST distinguish the two: treating
    // a failed request as "no listings" would wrongly clear a live listing from
    // local state on any network blip.
    async getMyMarketplaceListings(characterIds = []) {
        if (!this.isOnline || characterIds.length === 0) return null;
        try {
            const url = `${this.baseUrl}/api/characters?action=my-listings&ids=${characterIds.join(',')}`;
            const response = await fetch(url);
            const data = await response.json();
            if (!data.success) {
                console.error('Error getting own marketplace listings:', data.message);
                return null;
            }
            return data.listings;
        } catch (error) {
            console.error('Error fetching own marketplace listings:', error);
            return null;
        }
    }
    // Get connection status
    getStatus() {
        return {
            isOnline: this.isOnline,
            localCharacters: this.localCharacters.length,
            hasInternetConnection: navigator.onLine
        };
    }
    // Sync local characters to online database when coming back online
    async syncLocalCharacters() {
        if (!this.isOnline) return;
        const localCharsToSync = this.localCharacters.filter((char)=>char.isLocal);
        for (const localChar of localCharsToSync)try {
            // Check if name is still unique online
            const isUnique = await this.isCharacterNameUnique(localChar.name);
            if (isUnique) {
                // Register the character online
                const onlineChar = await this.registerCharacter(localChar);
                // Remove from local characters and update any references
                const localIndex = this.localCharacters.findIndex((char)=>char.id === localChar.id);
                if (localIndex !== -1) this.localCharacters.splice(localIndex, 1);
                (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Synced local character ${localChar.name} to online database`);
            } else console.warn(`Cannot sync ${localChar.name} - name already exists online`);
        } catch (error) {
            console.error(`Failed to sync character ${localChar.name}:`, error);
        }
        this.saveLocalCharacters();
    }
    // Delete own character (removes from database and local storage)
    async deleteOwnCharacter(characterId) {
        // Remove from local storage first
        const index = this.localCharacters.findIndex((char)=>char.id === characterId);
        if (index !== -1) {
            this.localCharacters.splice(index, 1);
            this.saveLocalCharacters();
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Removed character ${characterId} from local storage`);
        } else console.warn(`Character ${characterId} not found in local storage`);
        // Remove from online database if online
        if (this.isOnline) try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=character&id=${characterId}`, {
                method: 'DELETE',
                headers: this._authHeaders(characterId)
            });
            const data = await response.json();
            return data.success;
        } catch (error) {
            console.error('Error deleting character from database:', error);
            return false;
        }
        return true;
    }
    // Create payment record for contractor payments
    async createPaymentRecord(paymentData) {
        if (!this.isOnline) {
            console.warn('Cannot create payment record while offline');
            return false;
        }
        try {
            const headers = {
                'Content-Type': 'application/json'
            };
            if (paymentData.hirerToken) headers['Authorization'] = `Bearer ${paymentData.hirerToken}`;
            const response = await fetch(`${this.baseUrl}/api/payments?action=create`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    recipientCharacterId: paymentData.recipientCharacterId,
                    hirerCharacterId: paymentData.hirerCharacterId,
                    amount: paymentData.amount,
                    xp: paymentData.xp || 0,
                    source: paymentData.source || 'contractor_payment',
                    raidId: paymentData.raidId
                })
            });
            const data = await response.json();
            return data.success;
        } catch (error) {
            console.error('Error creating payment record:', error);
            return false;
        }
    }
    // Get pending payments for one character. Reads require the recipient's
    // token (server enforces ownership), so this is per-character, not a batch.
    async getPendingPayments(characterId) {
        if (!this.isOnline) {
            console.warn('Cannot get pending payments while offline');
            return [];
        }
        if (!characterId) return [];
        try {
            const response = await fetch(`${this.baseUrl}/api/payments?action=pending&characterId=${characterId}`, {
                headers: this._authHeaders(characterId)
            });
            const data = await response.json();
            if (data.success) return data.payments;
            else {
                console.error('Failed to get pending payments:', data.message);
                return [];
            }
        } catch (error) {
            console.error('Error getting pending payments:', error);
            return [];
        }
    }
    // Mark one character's payments as processed (requires the recipient's token).
    async markPaymentsProcessed(characterId, paymentIds) {
        if (!this.isOnline) {
            console.warn('Cannot mark payments processed while offline');
            return false;
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/payments`, {
                method: 'PUT',
                headers: this._authHeaders(characterId),
                body: JSON.stringify({
                    characterId: characterId,
                    paymentIds: paymentIds
                })
            });
            const data = await response.json();
            return data.success;
        } catch (error) {
            console.error('Error marking payments processed:', error);
            return false;
        }
    }
    // Reserve a contractor in the database to prevent concurrent reservations
    async reserveContractor(contractorCharacterId, reservedByCharacterId) {
        if (!this.isOnline) {
            console.warn('Cannot reserve contractor while offline');
            return {
                success: true
            }; // Allow local reservation when offline
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=reserve-contractor`, {
                method: 'POST',
                headers: this._authHeaders(reservedByCharacterId),
                body: JSON.stringify({
                    contractorCharacterId: contractorCharacterId,
                    reservedByCharacterId: reservedByCharacterId
                })
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error reserving contractor:', error);
            return {
                success: false,
                message: 'Network error'
            };
        }
    }
    // Release a contractor reservation in the database
    async releaseContractor(contractorCharacterId, releasedByCharacterId) {
        if (!this.isOnline) {
            console.warn('Cannot release contractor while offline');
            return {
                success: true
            }; // Allow local release when offline
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=release-contractor`, {
                method: 'POST',
                headers: this._authHeaders(releasedByCharacterId),
                body: JSON.stringify({
                    contractorCharacterId: contractorCharacterId,
                    reservedByCharacterId: releasedByCharacterId
                })
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error releasing contractor:', error);
            return {
                success: false,
                message: 'Network error'
            };
        }
    }
    // Hire a contractor (transition from reserved to hired for raid)
    async hireContractor(contractorCharacterId, hiredByCharacterId, raidId, tier = null) {
        if (!this.isOnline) {
            console.warn('Cannot hire contractor while offline');
            return {
                success: true
            }; // Allow local hiring when offline
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=hire-contractor`, {
                method: 'POST',
                headers: this._authHeaders(hiredByCharacterId),
                body: JSON.stringify({
                    contractorCharacterId: contractorCharacterId,
                    hiredByCharacterId: hiredByCharacterId,
                    raidId: raidId,
                    tier: tier
                })
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error hiring contractor:', error);
            return {
                success: false,
                message: 'Network error'
            };
        }
    }
    // Release a hired contractor (when raid ends)
    async releaseHiredContractor(contractorCharacterId, releasedByCharacterId) {
        if (!this.isOnline) {
            console.warn('Cannot release hired contractor while offline');
            return {
                success: true
            }; // Allow local release when offline
        }
        try {
            const response = await fetch(`${this.baseUrl}/api/characters?action=release-hired-contractor`, {
                method: 'POST',
                headers: this._authHeaders(releasedByCharacterId),
                body: JSON.stringify({
                    contractorCharacterId: contractorCharacterId,
                    releasedByCharacterId: releasedByCharacterId
                })
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error releasing hired contractor:', error);
            return {
                success: false,
                message: 'Network error'
            };
        }
    }
    // Debug utility to clear all multiplayer data
    clearMultiplayerData() {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Clearing all multiplayer data...');
        localStorage.removeItem('multiplayerCharacters');
        this.localCharacters = [];
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Multiplayer data cleared. Page refresh recommended.');
    }
}
const $f5272a3e1bbf7d7b$export$e4477200b6413a70 = new $f5272a3e1bbf7d7b$var$MultiplayerSystem();
async function $f5272a3e1bbf7d7b$export$6ec81efa6b4944af(name) {
    // Check against local characters first
    const localDuplicate = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.name.toLowerCase() === name.toLowerCase());
    if (localDuplicate) return false;
    // Then check multiplayer database
    return await $f5272a3e1bbf7d7b$export$e4477200b6413a70.isCharacterNameUnique(name);
}
function $f5272a3e1bbf7d7b$export$639a6fa06b9578d3(characterName) {
    console.log("\uD83D\uDD0D DEBUG: Checking all storage locations for character:", characterName);
    // Check main game state
    console.log("\uD83D\uDCCB Main gameState.character:", (0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
    // Check multiplayer local characters
    console.log("\uD83C\uDF10 Multiplayer localCharacters:", $f5272a3e1bbf7d7b$export$e4477200b6413a70.localCharacters);
    // Check all localStorage keys
    console.log("\uD83D\uDCBE All localStorage keys:");
    for(let i = 0; i < localStorage.length; i++){
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        console.log(`  ${key}:`, value);
        // Check if this value contains the character name
        if (value && value.includes(characterName)) console.log(`  \u{26A0}\u{FE0F} CHARACTER NAME FOUND IN: ${key}`);
    }
    // Test name uniqueness check
    console.log("\uD83D\uDD0E Testing name uniqueness check...");
    $f5272a3e1bbf7d7b$export$6ec81efa6b4944af(characterName).then((isUnique)=>{
        console.log(`  Name "${characterName}" is unique:`, isUnique);
    }).catch((error)=>{
        console.error('  Error checking name uniqueness:', error);
    });
}
function $f5272a3e1bbf7d7b$export$347a45e01153443c() {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "\uD83E\uDDF9 Cleaning up multiplayer storage...");
    const relevantCharacterIds = new Set();
    // Keep current player character
    if (typeof (0, $f27982cef7035d22$export$8e361a1ffbebf172) !== 'undefined' && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.multiplayerId) {
        relevantCharacterIds.add((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.multiplayerId);
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F4DD} Keeping current player character: ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name} (${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.multiplayerId})`);
    }
    // Keep characters in current raid team
    if (typeof (0, $f27982cef7035d22$export$8e361a1ffbebf172) !== 'undefined' && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach((contractor)=>{
        if (contractor.multiplayerId) {
            relevantCharacterIds.add(contractor.multiplayerId);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{2694}\u{FE0F} Keeping hired contractor: ${contractor.name} (${contractor.multiplayerId})`);
        }
    });
    // Keep characters in reserved contractors (for active raid)
    if (typeof (0, $f27982cef7035d22$export$8e361a1ffbebf172) !== 'undefined' && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach((contractor)=>{
        if (contractor.multiplayerId) {
            relevantCharacterIds.add(contractor.multiplayerId);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F512} Keeping reserved contractor: ${contractor.name} (${contractor.multiplayerId})`);
        }
    });
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F3AF} Total relevant character IDs: ${relevantCharacterIds.size}`);
    // Filter multiplayer storage to only keep relevant characters
    const beforeCount = $f5272a3e1bbf7d7b$export$e4477200b6413a70.localCharacters.length;
    $f5272a3e1bbf7d7b$export$e4477200b6413a70.localCharacters = $f5272a3e1bbf7d7b$export$e4477200b6413a70.localCharacters.filter((char)=>{
        const isRelevant = relevantCharacterIds.has(char.id);
        if (!isRelevant) (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{1F5D1}\u{FE0F} Removing orphaned character: ${char.name} (${char.id})`);
        return isRelevant;
    });
    const afterCount = $f5272a3e1bbf7d7b$export$e4477200b6413a70.localCharacters.length;
    const removedCount = beforeCount - afterCount;
    if (removedCount > 0) {
        $f5272a3e1bbf7d7b$export$e4477200b6413a70.saveLocalCharacters();
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{2705} Cleanup complete: removed ${removedCount} orphaned characters, kept ${afterCount}`);
    } else (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `\u{2705} Cleanup complete: no orphaned characters found`);
}
async function $f5272a3e1bbf7d7b$export$6ebef846cc736ea(name, currentName = null) {
    if (!name) return {
        valid: false,
        message: '',
        className: 'hidden'
    };
    if (name.length < 2) return {
        valid: false,
        message: 'Name must be at least 2 characters',
        className: 'text-game-warning'
    };
    if (name.length > 20) return {
        valid: false,
        message: 'Name must be 20 characters or less',
        className: 'text-game-warning'
    };
    // Skip uniqueness check if name hasn't changed
    if (currentName && name === currentName) return {
        valid: true,
        message: '',
        className: 'hidden'
    };
    try {
        const isUnique = await $f5272a3e1bbf7d7b$export$6ec81efa6b4944af(name);
        if (isUnique) return {
            valid: true,
            message: "\u2705 Name is available",
            className: 'text-game-success'
        };
        else return {
            valid: false,
            message: "\u274C Name already exists",
            className: 'text-game-danger'
        };
    } catch (error) {
        return {
            valid: false,
            message: "\u26A0\uFE0F Could not check name availability",
            className: 'text-game-warning'
        };
    }
}
async function $f5272a3e1bbf7d7b$export$2d25a36fab5567cb(contractorPayments) {
    // The hiring (active) character authenticates the payment: the server
    // verifies this character owns itself and actually hired each recipient.
    const hirer = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    for (const payment of contractorPayments){
        if (payment.isPlayerContractor && payment.contractorId > 0) try {
            // Create payment record in database - contractorId is the recipient character ID
            await $f5272a3e1bbf7d7b$export$e4477200b6413a70.createPaymentRecord({
                recipientCharacterId: payment.contractorId,
                hirerCharacterId: hirer?.multiplayerId || null,
                hirerToken: hirer?.ownerToken || null,
                amount: payment.credits,
                xp: payment.xp || 0,
                source: 'contractor_payment',
                raidId: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.id || null,
                timestamp: new Date().toISOString()
            });
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Recorded payment of ${payment.credits} credits and ${payment.xp} XP for contractor ${payment.contractorName} (ID: ${payment.contractorId})`);
        } catch (error) {
            console.error(`Failed to record payment for contractor ${payment.contractorName}:`, error);
        }
    }
}










/**
 * Collapse Keys — the story track's delivery mechanism (TODO §B).
 *
 * A key is an ACCOUNT-LEVEL RECORD, not an item. `gameState.player.collapseKeys`
 * holds recovered ids; nothing enters an inventory, so a key cannot be sold,
 * crafted, consigned, levied or lost. That shape was chosen deliberately over
 * the `unique` story-relic loot pool:
 *
 *   - The loot route would have meant lowering `itemRarities.unique.minTier`
 *     from 4, which makes the unique leg of getRoomRarityChances() non-zero at
 *     T1-T3 (visible in the raid planner), drags the Relic Resonance Tuner's
 *     selection boost into the story, and puts a balance surface under content
 *     that has no economic value.
 *   - It would ALSO have needed an explicit entry in foundSyndicateCore's
 *     preserved ledger, because a founding rebuilds command and wipes
 *     inventories. Account-level state needs no such entry — the player object
 *     is saved and restored whole and no prestige touches it. The invariant is
 *     enforced by construction rather than by remembering.
 *
 * The five placeholder story relics in itemsStoryRelics.js are untouched and
 * remain unreachable until L4's T0 adds raidTierData[4]. They are that layer's
 * business; keys 8-10 are where the two paths meet.
 *
 * ORDER MATTERS. The fragments build an argument, so the next key a faction
 * recovers is always its LOWEST unrecovered one — the roll decides *whether*,
 * never *which*. Tier is a ceiling rather than a bucket (`tier <= raidTier`),
 * so a player who out-levels T1 can still recover D1; nobody is locked out of
 * the first page of their own story.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/story/StoryAlignment.md §Where the Collapse Keys sit in the ladder.
 */ 

function $85e2b1e6893337a2$export$933049ca86d1db4() {
    const player = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player || ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player = {});
    if (!Array.isArray(player.collapseKeys)) player.collapseKeys = [];
    return player.collapseKeys;
}
function $85e2b1e6893337a2$export$182e380db95340ce() {
    return $ce6dd72bc4611534$export$2da4db3f6fd1335b || [];
}
function $85e2b1e6893337a2$export$bd3eb2c1f422af95(id) {
    return $85e2b1e6893337a2$export$182e380db95340ce().find((k)=>k.id === id) || null;
}
function $85e2b1e6893337a2$export$b3bc6b2877d37c66(id) {
    return $85e2b1e6893337a2$export$933049ca86d1db4().includes(id);
}
function $85e2b1e6893337a2$export$c9e2c9e9eddcd297(faction) {
    return $85e2b1e6893337a2$export$182e380db95340ce().filter((k)=>k.faction === faction).sort((a, b)=>a.index - b.index);
}
function $85e2b1e6893337a2$export$5f1383f2388f21ce(faction, tier) {
    if (!faction) return null;
    const owned = $85e2b1e6893337a2$export$933049ca86d1db4();
    return $85e2b1e6893337a2$export$c9e2c9e9eddcd297(faction).find((k)=>k.tier <= tier && !owned.includes(k.id)) || null;
}
function $85e2b1e6893337a2$export$8f051122a7ec4f94(id) {
    const key = $85e2b1e6893337a2$export$bd3eb2c1f422af95(id);
    if (!key) return null;
    const owned = $85e2b1e6893337a2$export$933049ca86d1db4();
    if (owned.includes(id)) return null;
    owned.push(id);
    return key;
}
function $85e2b1e6893337a2$export$9d589cbf453e87ad(faction, tier, rng = Math.random) {
    const candidate = $85e2b1e6893337a2$export$5f1383f2388f21ce(faction, tier);
    if (!candidate) return null;
    // Direct read, no `?? 0` fallback: a silent 0 would disable the whole story
    // track and look exactly like a player who has not found a key yet.
    // configValidation.js makes a missing value a loud boot failure instead.
    if (rng() >= $ce6dd72bc4611534$export$9f9786ac427715c7.collapseKeyDropChance) return null;
    return $85e2b1e6893337a2$export$8f051122a7ec4f94(candidate.id);
}
function $85e2b1e6893337a2$export$1bf1759a5184ddbd() {
    const owned = $85e2b1e6893337a2$export$933049ca86d1db4();
    const byFaction = {};
    Object.keys($ce6dd72bc4611534$export$aeeef991191508e2 || {}).forEach((faction)=>{
        const keys = $85e2b1e6893337a2$export$c9e2c9e9eddcd297(faction);
        byFaction[faction] = {
            owned: keys.filter((k)=>owned.includes(k.id)).length,
            total: keys.length
        };
    });
    return byFaction;
}
function $85e2b1e6893337a2$export$22a05a8b58c72cba() {
    return $85e2b1e6893337a2$export$933049ca86d1db4().length;
}


function $cc90b7944b7e868a$export$fae1502b09cc01ab(room, regionKey, zone, row, col) {
    if (!room || !room.name || !room.category) return room;
    const roomNames = (0, $c1858b438f434f4d$export$6b7290c54feddd3b)({
        baseName: room.name,
        regionKey: regionKey,
        zone: zone,
        category: room.category,
        seed: `${regionKey}:${row},${col}`
    });
    return {
        ...room,
        nameOptions: roomNames,
        displayName: roomNames[0] // Default to first option
    };
}
function $cc90b7944b7e868a$export$42e60f2f430e66a4(rooms, categories, difficulty = null, zone = null) {
    // Normalize categories to array
    if (!Array.isArray(categories)) categories = [
        categories
    ];
    // Filter by category
    let filtered = rooms.filter((r)=>categories.includes(r.category));
    // Further filter by difficulty if specified
    if (difficulty && filtered.length > 0) {
        const difficultyFiltered = filtered.filter((r)=>r.difficulty === difficulty);
        if (difficultyFiltered.length > 0) filtered = difficultyFiltered;
    }
    // Then by district. A template that names one is asking to be kept for it;
    // a template that names none will stand anywhere, so it stays in the running
    // either way. This is the one place a template's own district preference has
    // ever had an effect, and it is worth keeping: it is what puts an apartment
    // gate in the housing and an arcade gate on the shopping street.
    if (zone && filtered.length > 0) {
        const local = filtered.filter((r)=>r.districtAffinity === zone || !r.districtAffinity);
        if (local.length > 0) filtered = local;
    }
    // Fallback to all rooms if no matches
    if (filtered.length === 0) filtered = rooms;
    return filtered[Math.floor(Math.random() * filtered.length)];
}
/**
 * Create a road room object
 * Exact copy from raid.js line 422
 */ const $cc90b7944b7e868a$var$createRoad = (row, col)=>({
        ...$ce6dd72bc4611534$export$11209b5126489e67['road'],
        row: row,
        col: col
    });
/**
 * Create a campsite room object
 * Exact copy from raid.js line 420
 */ const $cc90b7944b7e868a$var$createCampsite = (row, col)=>({
        ...$ce6dd72bc4611534$export$11209b5126489e67['campsite'],
        row: row,
        col: col
    });
/**
 * Create a water room object
 * Exact copy from raid.js line 421
 */ const $cc90b7944b7e868a$var$createWater = (row, col)=>({
        ...$ce6dd72bc4611534$export$11209b5126489e67['water'],
        row: row,
        col: col
    });
function $cc90b7944b7e868a$export$2ebdd7a7b7382080(regionKey, tier) {
    const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey];
    const tierInfo = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
    const gridRows = tierInfo.gridRows || tierInfo.gridSize;
    const gridCols = tierInfo.gridCols || tierInfo.gridSize;
    // Generate strategic layout for all regions
    return $cc90b7944b7e868a$export$28f2fc0c31206252(region, gridRows, gridCols, tier, regionKey);
}
function $cc90b7944b7e868a$export$28f2fc0c31206252(region, gridRows, gridCols, tier, regionKey) {
    const grid = [];
    // Initialize empty grid
    for(let row = 0; row < gridRows; row++){
        grid[row] = [];
        for(let col = 0; col < gridCols; col++)grid[row][col] = null;
    }
    // The road layout is decided before anything is placed, so the fast-travel
    // rooms can be put ON the trunk rather than scattered independently of it.
    const startRowSeed = Math.floor(gridRows / 2);
    const roadNet = (0, $eaa96db7af263115$export$d1d5b8da68c444ff)(gridRows, gridCols, Math.random, {
        // the trunk runs edge to edge and so do these, so keep it off them
        avoid: new Set([
            `${startRowSeed},0`,
            `${startRowSeed},${gridCols - 1}`
        ])
    });
    // Define zones for strategic placement
    const zones = $cc90b7944b7e868a$export$bd3f9f980af68c96(gridRows, gridCols);
    // Set start and end positions
    const startRow = Math.floor(gridRows / 2);
    const endRow = Math.floor(gridRows / 2);
    grid[startRow][0] = {
        type: 'start',
        name: 'Entry',
        primary: '',
        support: [],
        row: startRow,
        col: 0,
        zone: 'entry',
        baseDuration: 0,
        icon: "\uD83C\uDF00"
    };
    grid[endRow][gridCols - 1] = {
        type: 'exit',
        name: 'Exit',
        primary: '',
        support: [],
        row: endRow,
        col: gridCols - 1,
        zone: 'core',
        baseDuration: 0,
        icon: "\uD83C\uDF0C"
    };
    // Generate strategic layout
    $cc90b7944b7e868a$export$c7be4a5231a3c1d5(grid, zones, gridRows, gridCols, roadNet);
    $cc90b7944b7e868a$export$a1095e56569a7bbd(grid, zones, region, regionKey, gridRows, gridCols);
    $cc90b7944b7e868a$export$c2b6eb32afc42797(grid, zones, region, regionKey);
    $cc90b7944b7e868a$export$a99502f327eb386e(grid, zones, region, regionKey, gridRows, gridCols);
    // Fill any remaining null cells with road rooms
    $cc90b7944b7e868a$export$5a5853dd98a11973(grid, gridRows, gridCols);
    // Place campsite after grid is fully populated
    $cc90b7944b7e868a$export$88789d02c8b75477(grid, gridRows, gridCols, new Set([
        ...roadNet.values()
    ].filter((c)=>c.rank === (0, $eaa96db7af263115$export$39615881bb0d21f6)).map((c)=>`${c.row},${c.col}`)));
    // Stamp the road layer onto whatever ended up in each cell. It is a layer,
    // not a room type: a gate the trunk runs past shows its frontage, and a tile
    // the network misses draws no road at all.
    // campsite and water may end a track; collapsed ground may not even be
    // approached, so it drops out of the network entirely
    (0, $eaa96db7af263115$export$c7de1644901a490c)(grid, gridRows, gridCols, roadNet, [
        'campsite',
        'water'
    ], [
        'blocked'
    ]);
    $cc90b7944b7e868a$export$eae5917029d72dd7(grid, gridRows, gridCols);
    // Every cell learns its district, including the ones placed by hand and the
    // ones that are not encounters at all. Placement stamps the district on the
    // rooms it selects, but the roads, the water, the campsite and the collapsed
    // ground never went through it — and the renderer wants a district on those
    // as much as on anything else, since growth reclaiming the outskirts should
    // not stop at a road tile's border.
    $cc90b7944b7e868a$export$125f97059f561163(grid, zones);
    // ...and, on a region the sea got into, how far each cell is from it. This is
    // stamped LAST and read only by the renderer: nothing above this line has seen
    // it, so the map that gets played is the same map either way.
    const shore = $cc90b7944b7e868a$export$73848b2e713ad45b(regionKey) ? $cc90b7944b7e868a$export$77e51d0aafb84b9d() : null;
    if (shore) $cc90b7944b7e868a$export$7977e6f4ebd3580e(grid, shore);
    const railway = $cc90b7944b7e868a$export$44fd09db052e90f2(regionKey) ? $cc90b7944b7e868a$export$a212d3baae84988f(grid, gridCols) : null;
    if (railway != null) $cc90b7944b7e868a$export$7a45acab3254e781(grid, railway);
    // Commit each encounter room to the events it will run. The map is drawn
    // from this, so it has to be decided before the grid is displayed — and it
    // is safe here because the event pool depends only on the room's own skills,
    // not on the team, which is not hired until after planning.
    (0, $b596e64ef926739f$export$81e7862f0868f5bc)(grid);
    return {
        grid: grid,
        rows: gridRows,
        cols: gridCols,
        startPos: {
            row: startRow,
            col: 0
        },
        endPos: {
            row: endRow,
            col: gridCols - 1
        },
        region: region,
        tier: tier,
        zones: zones,
        shore: shore,
        railway: railway
    };
}
// ---- districts ----
// A raid is a walk from the west edge to the east one, so a district is a BAND
// of columns: you leave the entry, cross two or three neighbourhoods, and
// arrive at the core. What the map used to do instead was carve fixed
// rectangles out of the grid dimensions — which meant every raid of a tier was
// laid out identically, `commercial` swallowed `security` whole at 7 columns
// because the rectangles overlapped and the first match won, and about a third
// of a 17-column map matched no rectangle at all and fell through to
// `peripheral` by default rather than by design.
const $cc90b7944b7e868a$var$ANCHOR_COLS = 2; // columns the entry and core districts hold at the ends
const $cc90b7944b7e868a$var$MIN_BAND = 3; // narrower than this and a district cannot be read as one
const $cc90b7944b7e868a$var$SPLIT_CHANCE = 0.4; // how often a band is cut north/south into two districts
const $cc90b7944b7e868a$var$MIN_SPLIT = 2; // rows each half of a cut band must have to read as one
function $cc90b7944b7e868a$export$bd3f9f980af68c96(gridRows, gridCols, rand = Math.random) {
    const middle = Object.keys($ce6dd72bc4611534$export$8377a367ab2ae550).filter((z)=>z !== 'entry' && z !== 'core');
    const free = Math.max(0, gridCols - $cc90b7944b7e868a$var$ANCHOR_COLS * 2);
    const bands = Math.max(1, Math.min(middle.length, Math.floor(free / $cc90b7944b7e868a$var$MIN_BAND)));
    const picked = (0, $42b272c2c0f44bdf$export$7ac3a88d34a76e7)(middle, rand);
    const order = [
        'entry',
        ...picked.slice(0, bands),
        'core'
    ];
    // Where each district starts, before the per-row wobble. The middle bands
    // split what the anchors leave as evenly as the columns allow.
    const starts = [
        0
    ];
    for(let i = 0; i <= bands; i++)starts.push($cc90b7944b7e868a$var$ANCHOR_COLS + Math.round(free * i / bands));
    starts.push(gridCols);
    // A band may hand half of itself to an archetype the order did not use.
    // Which half is rolled too: always giving away the north would put every
    // split district along the top of the map, which is its own fixed pattern.
    const spare = picked.slice(bands);
    const splits = order.map((_, i)=>{
        if (i === 0 || i === order.length - 1 || !spare.length) return null;
        if (gridRows < $cc90b7944b7e868a$var$MIN_SPLIT * 2 || rand() >= $cc90b7944b7e868a$var$SPLIT_CHANCE) return null;
        // Both halves get MIN_SPLIT rows at least: a one-row strip of another
        // district does not read as a district, it reads as a stray row.
        const room = gridRows - $cc90b7944b7e868a$var$MIN_SPLIT * 2;
        return {
            at: $cc90b7944b7e868a$var$MIN_SPLIT + Math.floor(rand() * (room + 1)),
            north: rand() < 0.5,
            zone: spare.pop()
        };
    });
    const cells = [];
    for(let row = 0; row < gridRows; row++){
        // Wobble every interior boundary, left to right, each one kept at least a
        // column past the last and far enough from the east edge that every
        // district still left to place gets a column of its own. Districts can
        // therefore never cross or vanish, whatever the rolls do.
        const edge = [
            0
        ];
        for(let i = 1; i < starts.length - 1; i++){
            const drift = rand() < 0.5 ? 0 : rand() < 0.5 ? -1 : 1;
            edge.push(Math.max(edge[i - 1] + 1, Math.min(starts[i] + drift, gridCols - (order.length - i))));
        }
        edge.push(gridCols);
        const line = [];
        for(let i = 0; i < order.length; i++){
            const cut = splits[i];
            const zone = cut && row < cut.at === cut.north ? cut.zone : order[i];
            for(let col = edge[i]; col < edge[i + 1]; col++)line[col] = zone;
        }
        cells.push(line);
    }
    return {
        cells: cells,
        order: order
    };
}
function $cc90b7944b7e868a$export$125f97059f561163(grid, zones) {
    for(let row = 0; row < grid.length; row++){
        for(let col = 0; col < grid[row].length; col++)if (grid[row][col]) grid[row][col].zone = $cc90b7944b7e868a$export$db5786fdbbf0e297(row, col, zones);
    }
}
function $cc90b7944b7e868a$export$77e51d0aafb84b9d(rand = Math.random) {
    return rand() < 0.5 ? 'n' : 's';
}
function $cc90b7944b7e868a$export$7977e6f4ebd3580e(grid, side) {
    const rows = grid.length;
    const seaward = side === 'n' ? 'n' : 's';
    for(let row = 0; row < rows; row++){
        const shore = side === 'n' ? row : rows - 1 - row;
        for(let col = 0; col < grid[row].length; col++){
            const room = grid[row][col];
            if (!room) continue;
            room.shore = shore;
            room.shoreSide = side;
            if (shore === 0 && room.road) delete room.road[seaward];
        }
    }
}
/** Regions whose art direction says the sea got in. */ const $cc90b7944b7e868a$var$SHORELINE_REGIONS = new Set([
    'sunken-bastions'
]);
const $cc90b7944b7e868a$export$73848b2e713ad45b = (regionKey)=>$cc90b7944b7e868a$var$SHORELINE_REGIONS.has(regionKey);
// ---- the railway ----
// A sublevel is transit infrastructure before it is anything else, so it gets a
// rail spur — but ONE, and laid the way a road is laid rather than scattered.
// Sprinkling rail beds around as props gave the map disconnected lengths of
// track that started and stopped for no reason; a railway is only a railway if
// it goes somewhere. The trunk road runs west to east, so the line runs north
// to south and the two cross, which is what a transit interchange looks like.
/** Regions whose art direction says something still runs on rails down there. */ const $cc90b7944b7e868a$var$RAILWAY_REGIONS = new Set([
    'hollow-core'
]);
const $cc90b7944b7e868a$export$44fd09db052e90f2 = (regionKey)=>$cc90b7944b7e868a$var$RAILWAY_REGIONS.has(regionKey);
/** Ground the line may not be laid across at all. */ const $cc90b7944b7e868a$var$RAIL_BLOCKERS = new Set([
    'water',
    'campsite'
]);
function $cc90b7944b7e868a$export$a212d3baae84988f(grid, gridCols, rand = Math.random) {
    // Kept off the entry and extraction columns too: those are the portals' own,
    // and a line down either would run through the room the raid starts or ends in.
    let best = Infinity, options = [];
    for(let col = 2; col <= gridCols - 3; col++){
        let blocked = false, roads = 0;
        for(let row = 0; row < grid.length && !blocked; row++){
            const room = grid[row][col];
            if (!room || $cc90b7944b7e868a$var$RAIL_BLOCKERS.has(room.type)) blocked = true;
            else if (room.type === 'road') roads++;
        }
        if (blocked) continue;
        if (roads < best) {
            best = roads;
            options = [
                col
            ];
        } else if (roads === best) options.push(col);
    }
    return options.length ? options[Math.floor(rand() * options.length)] : null;
}
function $cc90b7944b7e868a$export$7a45acab3254e781(grid, col) {
    for(let row = 0; row < grid.length; row++)if (grid[row][col]) grid[row][col].rail = true;
}
function $cc90b7944b7e868a$export$c7be4a5231a3c1d5(grid, zones, gridRows, gridCols, roadNet) {
    // First, create road network
    $cc90b7944b7e868a$export$eedef1d3c26e0a97(grid, zones, gridRows, gridCols, roadNet);
    // Create blocked areas representing collapsed structures (randomized positions)
    //
    // Roll each one clear of the road network where possible. Collapsed ground
    // carries no pathway at all, and a track cut short by rubble has its whole
    // spur pruned back to the last junction — so rubble dropped on the network
    // costs several tiles of reachable map, not one. Falls back to the first roll
    // when the grid is too congested to find anything better.
    const offNetwork = (spot)=>{
        for(let tries = 0; tries < 12; tries++){
            const candidate = spot();
            if (!roadNet?.has(`${candidate.row},${candidate.col}`)) return candidate;
        }
        return spot();
    };
    const blockedAreas = [
        // Collapsed skybridge (randomized position)
        offNetwork(()=>({
                row: 1 + Math.floor(Math.random() * Math.max(1, gridRows - 4)),
                col: Math.floor(gridCols * (0.3 + Math.random() * 0.4)),
                type: 'collapsed_bridge'
            })),
        // Radiation zone in industrial area (randomized)
        offNetwork(()=>({
                row: Math.floor(gridRows * (0.6 + Math.random() * 0.3)),
                col: 2 + Math.floor(Math.random() * 3),
                type: 'radiation_zone'
            })),
        // Structural damage in commercial district (randomized)
        offNetwork(()=>({
                row: 1 + Math.floor(Math.random() * 3),
                col: 1 + Math.floor(Math.random() * 3),
                type: 'structural_damage'
            }))
    ];
    blockedAreas.forEach((blocked)=>{
        if (blocked.row >= 0 && blocked.row < gridRows && blocked.col >= 0 && blocked.col < gridCols) {
            if (!grid[blocked.row][blocked.col]) grid[blocked.row][blocked.col] = {
                type: 'blocked',
                name: 'Blocked',
                row: blocked.row,
                col: blocked.col,
                subtype: blocked.type
            };
        }
    });
}
function $cc90b7944b7e868a$export$eedef1d3c26e0a97(grid, zones, gridRows, gridCols, roadNet) {
    // Fast-travel rooms sit ON the trunk. They used to be scattered by their own
    // rules, which had two problems: the "main thoroughfare" was a straight run
    // down the centre row covering only part of the width, and the vertical
    // connector wrote grid[centerRow][col] inside a loop over ROW, so it only
    // ever placed a single cell. Putting them on the trunk also means the road
    // you can see and the road you can travel quickly are the same road.
    const net = roadNet || (0, $eaa96db7af263115$export$d1d5b8da68c444ff)(gridRows, gridCols);
    const trunk = [
        ...net.values()
    ].filter((c)=>c.rank === (0, $eaa96db7af263115$export$39615881bb0d21f6));
    // EVERY trunk cell becomes a road room. Budgeting them (as an earlier pass
    // did) left most of the route as gates and hazards, which then drew the
    // roadway across their own frontage — a four-lane road through the middle of
    // a warehouse. The trunk you can see and the trunk you can travel are the
    // same cells, so the roadway only ever renders on a road tile.
    //
    // This runs before blocked areas and every encounter placement, and those
    // only ever fill EMPTY cells, so nothing can punch a hole in the route
    // afterwards. The one thing already on the grid is the start/exit pair.
    for (const cell of trunk){
        if (grid[cell.row]?.[cell.col]) continue; // never displace start/exit
        grid[cell.row][cell.col] = $cc90b7944b7e868a$var$createRoad(cell.row, cell.col);
    }
}
function $cc90b7944b7e868a$export$a1095e56569a7bbd(grid, zones, region, regionKey, gridRows, gridCols) {
    // Main security gate controlling access to core
    const coreGateRow = Math.floor(grid.length / 2);
    const coreGateCol = grid[0].length - 3;
    if (!grid[coreGateRow][coreGateCol]) {
        const currentZone = $cc90b7944b7e868a$export$db5786fdbbf0e297(coreGateRow, coreGateCol, zones);
        const gateTemplate = $cc90b7944b7e868a$export$42e60f2f430e66a4(region.gates, 'security', 'chokepoint', currentZone);
        const roomWithNames = $cc90b7944b7e868a$export$fae1502b09cc01ab(gateTemplate, regionKey, currentZone, coreGateRow, coreGateCol);
        grid[coreGateRow][coreGateCol] = {
            type: 'gate',
            ...roomWithNames,
            priority: 'critical',
            zone: currentZone,
            strategic_value: 'chokepoint',
            row: coreGateRow,
            col: coreGateCol
        };
    }
    // Secondary checkpoints with zone-aware placement
    const secondaryGates = [
        {
            row: 2,
            col: Math.floor(grid[0].length / 3)
        },
        {
            row: grid.length - 3,
            col: Math.floor(grid[0].length / 3)
        },
        {
            row: 1,
            col: 4
        },
        {
            row: grid.length - 2,
            col: 4
        },
        {
            row: 3,
            col: 3
        },
        {
            row: grid.length - 4,
            col: 3
        } // Commercial gate
    ];
    secondaryGates.forEach((pos)=>{
        if (pos.row >= 0 && pos.row < grid.length && pos.col >= 0 && pos.col < grid[0].length) {
            if (!grid[pos.row][pos.col]) {
                const currentZone = $cc90b7944b7e868a$export$db5786fdbbf0e297(pos.row, pos.col, zones);
                const gateTemplate = $cc90b7944b7e868a$export$42e60f2f430e66a4(region.gates, 'security', 'chokepoint', currentZone);
                const roomWithNames = $cc90b7944b7e868a$export$fae1502b09cc01ab(gateTemplate, regionKey, currentZone, pos.row, pos.col);
                grid[pos.row][pos.col] = {
                    type: 'gate',
                    ...roomWithNames,
                    priority: 'high',
                    zone: currentZone,
                    strategic_value: 'access_control',
                    row: pos.row,
                    col: pos.col
                };
            }
        }
    });
}
function $cc90b7944b7e868a$export$c2b6eb32afc42797(grid, zones, region, regionKey, gridRows, gridCols) {
    // Primary target: High-value storage in core zone
    const vaultRow = Math.floor(grid.length / 2);
    const vaultCol = grid[0].length - 2;
    if (!grid[vaultRow][vaultCol]) {
        const currentZone = $cc90b7944b7e868a$export$db5786fdbbf0e297(vaultRow, vaultCol, zones);
        const hazardTemplate = $cc90b7944b7e868a$export$42e60f2f430e66a4(region.hazards, 'storage', 'high_value', currentZone);
        const roomWithNames = $cc90b7944b7e868a$export$fae1502b09cc01ab(hazardTemplate, regionKey, currentZone, vaultRow, vaultCol);
        grid[vaultRow][vaultCol] = {
            type: 'hazard',
            ...roomWithNames,
            priority: 'critical',
            zone: currentZone,
            strategic_value: 'high_value_target',
            reward_multiplier: 2.5,
            row: vaultRow,
            col: vaultCol
        };
    }
    // Secondary targets spread throughout with zone-specific placement
    const secondaryTargets = [
        {
            row: 1,
            col: grid[0].length - 4,
            category: [
                'power',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 2,
            col: grid[0].length - 4,
            category: [
                'infrastructure',
                'storage'
            ]
        },
        {
            row: 1,
            col: 5,
            category: [
                'environmental',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 2,
            col: 5,
            category: [
                'environmental',
                'storage'
            ]
        },
        {
            row: 3,
            col: 4,
            category: [
                'storage',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 4,
            col: 4,
            category: [
                'storage',
                'power'
            ]
        } // Commercial
    ];
    secondaryTargets.forEach((target)=>{
        if (target.row >= 0 && target.row < grid.length && target.col >= 0 && target.col < grid[0].length) {
            if (!grid[target.row][target.col]) {
                const currentZone = $cc90b7944b7e868a$export$db5786fdbbf0e297(target.row, target.col, zones);
                const hazardTemplate = $cc90b7944b7e868a$export$42e60f2f430e66a4(region.hazards, target.category, 'high_value', currentZone);
                const roomWithNames = $cc90b7944b7e868a$export$fae1502b09cc01ab(hazardTemplate, regionKey, currentZone, target.row, target.col);
                grid[target.row][target.col] = {
                    type: 'hazard',
                    ...roomWithNames,
                    priority: 'high',
                    zone: currentZone,
                    strategic_value: 'infrastructure',
                    reward_multiplier: 1.5,
                    row: target.row,
                    col: target.col
                };
            }
        }
    });
}
/** The rooms nobody paved: their ground is turf, not the region's floor. */ const $cc90b7944b7e868a$var$CLEARING_TYPES = new Set([
    'campsite',
    'water'
]);
function $cc90b7944b7e868a$export$eae5917029d72dd7(grid, rows, cols) {
    const open = (r, c)=>$cc90b7944b7e868a$var$CLEARING_TYPES.has(grid?.[r]?.[c]?.type);
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const room = grid?.[row]?.[col];
        if (!room || !$cc90b7944b7e868a$var$CLEARING_TYPES.has(room.type)) continue;
        room.clearing = {
            n: open(row - 1, col),
            e: open(row, col + 1),
            s: open(row + 1, col),
            w: open(row, col - 1)
        };
    }
}
function $cc90b7944b7e868a$export$88789d02c8b75477(grid, gridRows, gridCols, trunk = new Set()) {
    // The rest stop may not sit on the trunk. It used to PREFER road cells
    // (candidates.road below), which was harmless while roads were scattered
    // filler — now that the whole through-route is road rooms, it meant the camp
    // and its water landed on the highway and overwrote it, leaving a hole in
    // the route and a roadway drawn across a lake.
    const onTrunk = (row, col)=>trunk.has(`${row},${col}`);
    // Middle portion: columns from 1/3 to 2/3 of grid
    const minCol = Math.floor(gridCols / 3);
    const maxCol = Math.floor(2 * gridCols / 3);
    // Try to place in middle rows (avoid top/bottom edges)
    const minRow = Math.floor(gridRows / 3);
    const maxRow = Math.floor(2 * gridRows / 3);
    // Collect candidate cells by priority: empty > road > no priority > high priority > any
    const candidates = {
        empty: [],
        road: [],
        normal: [],
        high: [],
        any: []
    };
    for(let row = minRow; row <= maxRow; row++)for(let col = minCol; col <= maxCol; col++){
        const room = grid[row][col];
        if (onTrunk(row, col)) continue;
        else if (!room) candidates.empty.push({
            row: row,
            col: col
        });
        else if (room.type === 'road') candidates.road.push({
            row: row,
            col: col
        });
        else if (room.type !== 'start' && room.type !== 'exit') {
            if (!room.priority) candidates.normal.push({
                row: row,
                col: col
            });
            else if (room.priority === 'high') candidates.high.push({
                row: row,
                col: col
            });
            else if (room.priority !== 'critical') candidates.any.push({
                row: row,
                col: col
            });
        }
    }
    // Try each priority group in order
    const priorityOrder = [
        candidates.empty,
        candidates.road,
        candidates.normal,
        candidates.high,
        candidates.any
    ];
    let campsiteRow, campsiteCol;
    for (const group of priorityOrder)if (group.length > 0) {
        // Pick random cell from this priority group
        const cell = group[Math.floor(Math.random() * group.length)];
        grid[cell.row][cell.col] = $cc90b7944b7e868a$var$createCampsite(cell.row, cell.col);
        campsiteRow = cell.row;
        campsiteCol = cell.col;
        break;
    }
    // Place water adjacent to campsite
    if (campsiteRow !== undefined && campsiteCol !== undefined) {
        const adjacentCells = [
            {
                row: campsiteRow - 1,
                col: campsiteCol
            },
            {
                row: campsiteRow + 1,
                col: campsiteCol
            },
            {
                row: campsiteRow,
                col: campsiteCol - 1
            },
            {
                row: campsiteRow,
                col: campsiteCol + 1
            }
        ].filter((pos)=>pos.row >= 0 && pos.row < gridRows && pos.col >= 0 && pos.col < gridCols && !onTrunk(pos.row, pos.col));
        // Water takes the best neighbour it can get, in the same priority order the
        // campsite uses above. It used to accept only empty/road/blocked, which
        // worked while roads were scattered filler — once the roads became the
        // trunk (and the trunk became off-limits) that left almost nothing legal
        // beside a campsite, and the fishing room all but disappeared from raids.
        const rank = (room)=>{
            if (!room) return 0;
            if (room.type === 'road' || room.type === 'blocked') return 1;
            if (room.type === 'start' || room.type === 'exit' || room.type === 'campsite') return Infinity;
            if (room.priority === 'critical' || room.priority === 'high') return Infinity;
            return 2; // an ordinary encounter, yielded reluctantly
        };
        const spot = adjacentCells.map((pos)=>({
                pos: pos,
                rank: rank(grid[pos.row][pos.col])
            })).filter((x)=>x.rank !== Infinity).sort((a, b)=>a.rank - b.rank)[0];
        if (spot) grid[spot.pos.row][spot.pos.col] = $cc90b7944b7e868a$var$createWater(spot.pos.row, spot.pos.col);
    }
}
function $cc90b7944b7e868a$export$157aa935a4ff3471(zone, rand = Math.random) {
    const mix = $ce6dd72bc4611534$export$8377a367ab2ae550[zone]?.recipes;
    if (!mix) return null;
    const entries = Object.entries(mix);
    let roll = rand() * entries.reduce((sum, [, w])=>sum + w, 0);
    for (const [recipe, weight] of entries){
        roll -= weight;
        if (roll < 0) return recipe;
    }
    return entries[entries.length - 1][0];
}
function $cc90b7944b7e868a$export$a99502f327eb386e(grid, zones, region, regionKey, gridRows, gridCols) {
    // Create a diverse pool of rooms to avoid clustering
    const roomPool = $cc90b7944b7e868a$export$8d00a8f7bf03e003(region, gridRows, gridCols);
    let roomIndex = 0;
    // Fill remaining empty spaces with diverse rooms
    for(let row = 0; row < gridRows; row++){
        for(let col = 0; col < gridCols; col++)if (!grid[row][col]) {
            // Get next room from diverse pool, avoiding adjacent duplicates
            const roomData = $cc90b7944b7e868a$export$7762ee06a83058a3(grid, row, col, roomPool, roomIndex, gridRows, gridCols);
            roomIndex = (roomIndex + 1) % roomPool.length;
            const currentZone = $cc90b7944b7e868a$export$db5786fdbbf0e297(row, col, zones);
            const roomWithNames = $cc90b7944b7e868a$export$fae1502b09cc01ab(roomData, regionKey, currentZone, row, col);
            grid[row][col] = {
                ...roomWithNames,
                row: row,
                col: col,
                zone: currentZone,
                // What this cell is BUILT of comes from the district, not from the
                // room standing on it — see zoneArchetypes for why. Only the fill
                // takes it: the checkpoints and high-value targets the map places by
                // hand are landmarks, and a landmark has to look like itself.
                recipe: $cc90b7944b7e868a$export$157aa935a4ff3471(currentZone),
                priority: 'normal'
            };
        }
    }
}
function $cc90b7944b7e868a$export$8d00a8f7bf03e003(region, gridRows, gridCols) {
    const totalRooms = gridRows * gridCols;
    const roomPool = [];
    // Calculate target counts for each room type
    const gateCount = Math.floor(totalRooms * 0.3);
    const hazardCount = Math.floor(totalRooms * 0.7);
    // Add gates with even distribution
    for(let i = 0; i < gateCount; i++){
        const gateTemplate = region.gates[i % region.gates.length];
        roomPool.push({
            type: 'gate',
            ...gateTemplate
        });
    }
    // Add hazards with even distribution
    for(let i = 0; i < hazardCount; i++){
        const hazardTemplate = region.hazards[i % region.hazards.length];
        roomPool.push({
            type: 'hazard',
            ...hazardTemplate
        });
    }
    // Shuffle the pool to ensure random but diverse distribution
    return (0, $42b272c2c0f44bdf$export$7ac3a88d34a76e7)(roomPool);
}
function $cc90b7944b7e868a$export$7762ee06a83058a3(grid, row, col, roomPool, startIndex, gridRows, gridCols) {
    const adjacentRooms = $cc90b7944b7e868a$export$1a16c97e5b52afb(grid, row, col, gridRows, gridCols);
    // Try to find a room that's not adjacent to identical rooms
    for(let i = 0; i < roomPool.length; i++){
        const roomIndex = (startIndex + i) % roomPool.length;
        const room = roomPool[roomIndex];
        if (!adjacentRooms.includes(room.name)) return room;
    }
    // If all rooms are adjacent, just return the next one
    return roomPool[startIndex % roomPool.length];
}
function $cc90b7944b7e868a$export$1a16c97e5b52afb(grid, row, col, gridRows, gridCols) {
    const adjacent = [];
    const directions = [
        [
            -1,
            0
        ],
        [
            1,
            0
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ]
    ]; // up, down, left, right
    directions.forEach(([dr, dc])=>{
        const newRow = row + dr;
        const newCol = col + dc;
        if (newRow >= 0 && newRow < gridRows && newCol >= 0 && newCol < gridCols) {
            const room = grid[newRow][newCol];
            if (room && room.name) adjacent.push(room.name);
        }
    });
    return adjacent;
}
function $cc90b7944b7e868a$export$db5786fdbbf0e297(row, col, zones) {
    return zones?.cells?.[row]?.[col] || 'peripheral';
}
function $cc90b7944b7e868a$export$5a5853dd98a11973(grid, gridRows, gridCols) {
    for(let row = 0; row < gridRows; row++){
        for(let col = 0; col < gridCols; col++)if (grid[row] && grid[row][col] === null) grid[row][col] = $cc90b7944b7e868a$var$createRoad(row, col);
    }
}
function $cc90b7944b7e868a$export$a678af82bf766611(path, gridData) {
    if (path.length < 2) return false;
    const start = path[0];
    const end = path[path.length - 1];
    // Must start at start position and end at end position
    if (start.row !== gridData.startPos.row || start.col !== gridData.startPos.col) return false;
    if (end.row !== gridData.endPos.row || end.col !== gridData.endPos.col) return false;
    // Check if path is continuous (adjacent moves only)
    for(let i = 1; i < path.length; i++){
        const prev = path[i - 1];
        const curr = path[i];
        const rowDiff = Math.abs(curr.row - prev.row);
        const colDiff = Math.abs(curr.col - prev.col);
        // Allow only orthogonal moves (not diagonal)
        if (rowDiff === 1 && colDiff === 0 || rowDiff === 0 && colDiff === 1) continue;
        else return false;
    }
    return true;
}
function $cc90b7944b7e868a$export$7e86a2006a620b57(room, teamSkills) {
    if (room.type === 'blocked') return;
    const primarySkillLevel = teamSkills[room.primary] || 0;
    const supportSkillLevels = room.support.map((skill)=>teamSkills[skill] || 0);
    const totalSupportLevel = supportSkillLevels.reduce((sum, level)=>sum + level, 0);
    // Check if primary skill is covered
    const primaryCovered = primarySkillLevel > 0;
    // Check support coverage - require at least some level in each support skill
    const supportCovered = room.support.length === 0 || room.support.every((skill)=>(teamSkills[skill] || 0) > 0);
    if (primaryCovered && supportCovered) return {
        class: 'skill-covered',
        indicator: 'covered',
        symbol: "\u2713"
    };
    else if (primaryCovered) return {
        class: 'skill-match',
        indicator: 'partial',
        symbol: "\u25B2"
    };
    else return {
        class: 'skill-missing',
        indicator: 'missing',
        symbol: "\u2717"
    };
}
function $cc90b7944b7e868a$export$aedd9bb9e278a90a(path) {
    if (!path || path.length === 0) return 0;
    return path.filter((step)=>{
        return step.room && (step.room.type === 'gate' || step.room.type === 'hazard');
    }).length;
}
function $cc90b7944b7e868a$export$86025a0d632dc830(path, index) {
    if (!path || index < 0 || index >= path.length) return index + 1;
    let stepNumber = 1;
    for(let i = 0; i <= index; i++){
        const room = path[i].room;
        // Only count gates and hazards as actual steps
        if (room && (room.type === 'gate' || room.type === 'hazard')) {
            if (i === index) return stepNumber;
            stepNumber++;
        } else if (i === index) return '-'; // Roads, start, exit, water and campsite don't get numbers
    }
    return stepNumber;
}
function $cc90b7944b7e868a$export$b381c7b121792f39(team, totalHealing) {
    const injuredMembers = team.filter((member)=>member.isAlive && member.currentHp < member.maxHp);
    if (injuredMembers.length === 0) return;
    // 1. Consumables FIRST: top each member off with the raid owner's HP
    //    consumables (biggest heal first, one of each, only when the deficit
    //    exceeds the value so none is wasted / overshoots maxHp).
    const inventory = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory || {};
    const hpConsumables = (0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)().filter((item)=>item.restoresHp > 0).sort((a, b)=>b.restoresHp - a.restoresHp);
    const used = {};
    injuredMembers.forEach((member)=>{
        for (const consumable of hpConsumables)if ((inventory[consumable.id] || 0) > 0 && member.maxHp - member.currentHp > consumable.restoresHp) {
            member.currentHp += consumable.restoresHp;
            inventory[consumable.id] -= 1;
            if (inventory[consumable.id] <= 0) delete inventory[consumable.id];
            used[consumable.name] = (used[consumable.name] || 0) + 1;
        }
    });
    // 2. Base healing AFTER items, split by remaining need (not equally): each
    //    member gets a share proportional to its share of the total missing HP,
    //    so it flows to the worst-hurt and fills the small residual deficits the
    //    consumables' no-overshoot rule left behind. Clamped to maxHp.
    if (totalHealing > 0) {
        const deficits = injuredMembers.map((m)=>m.maxHp - m.currentHp);
        const totalDeficit = deficits.reduce((sum, d)=>sum + d, 0);
        if (totalDeficit > 0) injuredMembers.forEach((member, i)=>{
            const share = Math.floor(totalHealing * deficits[i] / totalDeficit);
            member.currentHp = Math.min(member.maxHp, member.currentHp + share);
        });
    }
    const usedList = Object.entries(used);
    if (usedList.length) (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1FA79} Used ${usedList.map(([name, qty])=>`${qty}\xd7 ${name}`).join(', ')} to patch up the team`, 'info', {
        notify: false,
        stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress?.currentRoomIndex
    });
}
function $cc90b7944b7e868a$export$59bc35895553fb06(team) {
    //console.log("CHECKING FOR ALIVE TEAM", team);
    if (!team || !Array.isArray(team)) return false;
    return team.some((member)=>member.isAlive);
}
function $cc90b7944b7e868a$export$95648a2a64dc501c(success, roomsCompleted, totalRooms, region, team, tier) {
    let creditsEarned = 0;
    if (success) {
        // Full success bonus (increased for monthly progression)
        creditsEarned = tier * 150 + roomsCompleted * 40;
        // Bonus for team survival
        const survivingMembers = team.filter((member)=>member.isAlive).length;
        const survivalBonus = Math.floor(survivingMembers / team.length * 50);
        creditsEarned += survivalBonus;
    } else {
        // Partial rewards based on completion
        const completionRatio = roomsCompleted / (totalRooms - 1);
        creditsEarned = Math.floor(tier * 100 * completionRatio);
    }
    // Apply credit scaling to raid completion bonus
    creditsEarned = (0, $00c60928d2fcd8b8$export$78a769585121af92)(creditsEarned, tier);
    return {
        creditsEarned: creditsEarned,
        success: success,
        completionRatio: roomsCompleted / (totalRooms - 1)
    };
}
function $cc90b7944b7e868a$export$c994d11f45f33eb9(team) {
    team.forEach((member)=>{
        if (member.type === 'player') // Update player health
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.currentHp = member.currentHp;
        else if (member.type === 'contractor') {
            // Find the original contractor and update health
            const originalContractor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.find((c)=>c.id === member.id);
            if (originalContractor) {
                originalContractor.currentHp = member.currentHp;
                originalContractor.maxHp = member.maxHp;
                // If contractor died, they become unavailable for a while
                if (!member.isAlive) {
                    originalContractor.injured = true;
                    originalContractor.recoveryTime = Date.now() + 86400000; // 24 hours
                }
            }
        }
    });
}
function $cc90b7944b7e868a$export$1a56a513ad3028b0(success, roomsCompleted, totalRooms, region, team, tier) {
    // Reduced for long-term idle progression (1-5 months to reach Tier 3)
    let baseXP = tier * 15; // 15/30/45 base XP
    // Room completion bonus
    const roomBonus = roomsCompleted * 3;
    // Success multiplier
    const successMultiplier = success ? 1.5 : 0.8;
    // Difficulty bonus based on team size vs difficulty
    const teamSize = team.filter((member)=>member.isAlive).length;
    const difficultyBonus = Math.max(0, tier * 2 - teamSize) * 3;
    // Full path completion bonus
    const fullPathBonus = roomsCompleted === totalRooms - 1 ? 10 : 0;
    // Command-era tier weighting (progressionScaling SSOT): pushing tiers
    // is the leveling ladder - T2/T3 raids pay multiples of T1
    const tierMultiplier = $ce6dd72bc4611534$export$9f9786ac427715c7?.raidXpTierMultipliers?.[tier] || 1;
    const totalXP = Math.floor((baseXP + roomBonus + difficultyBonus + fullPathBonus) * successMultiplier * tierMultiplier);
    return Math.max(5, totalXP); // Minimum 5 XP
}
function $cc90b7944b7e868a$export$849a3b972df07241(durationInSeconds) {
    if (!durationInSeconds || durationInSeconds <= 0) return 0;
    return Math.ceil(durationInSeconds / 120); // 1 energy per 2 minutes, from character.js
}
function $cc90b7944b7e868a$export$78de3bc967b7be(tier, path) {
    // Calculate total duration in seconds from all rooms in path
    //console.log('Calculating energy cost for path:', path);
    const totalDuration = path.reduce((sum, step)=>sum + (step.room.baseDuration ? step.room.baseDuration : 0), 0);
    // Energy cost: Base cost per tier + 1 energy per 40 seconds of raid duration.
    // The Sync Regulator Watch trims the total (raid-energy-reduction).
    // Base: T1: 5, T2: 10, T3: 15
    // Realistic T3 worst: 21-room path with mix of gates (120s) and hazards (60s)
    // Example: 10 gates + 11 hazards = 1200 + 660 = 1860s
    // Cost: 15 + (1860/40) = 15 + 47 = 62 energy (well under 100)
    const baseCost = 5 + (tier - 1) * 5;
    const durationCost = $cc90b7944b7e868a$export$849a3b972df07241(totalDuration);
    const reduction = 1 - (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('raid-energy-reduction') / 100;
    const energyCost = Math.max(1, Math.ceil((baseCost + durationCost) * reduction));
    //console.log(`Calculated energy cost for tier ${tier} and duration ${totalDuration}s: Base ${baseCost} + Duration ${durationCost} = Total ${energyCost}`);
    return energyCost;
}
function $cc90b7944b7e868a$export$595cb98aec43dd71(contractorId) {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.some((c)=>c.id == contractorId);
}
function $cc90b7944b7e868a$export$4c8adf450afe39a2(contractorId) {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.some((c)=>c.id == contractorId);
}
function $cc90b7944b7e868a$export$2a6c93141872f156(row, col) {
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    // First click must be start position
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) return row === gridData.startPos.row && col === gridData.startPos.col;
    // If path already ends at exit, can't add more rooms
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length > 0) {
        const lastPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
        const lastRoom = gridData.grid[lastPos.row][lastPos.col];
        if (lastRoom.type === 'exit') return false;
    }
    // Can't add the same room twice
    const isAlreadyInPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.some((p)=>p.row === row && p.col === col);
    if (isAlreadyInPath) return false;
    // Check if target cell is blocked
    const targetRoom = gridData.grid[row][col];
    if (targetRoom && targetRoom.type === 'blocked') return false;
    // Check maximum path length: rows + cols - 1 (excluding roads)
    // BUT allow connection to exit even at max steps since exit doesn't count
    const maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
    const currentStepCount = $cc90b7944b7e868a$export$aedd9bb9e278a90a((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
    if (currentStepCount >= maxPathLength) {
        // At max steps, only allow roads/campsite (0 cost) or exit
        if (targetRoom && (targetRoom.type === 'exit' || targetRoom.type === 'road' || targetRoom.type === 'campsite' || targetRoom.type === 'water')) ;
        else return false; // Block gates/hazards
    }
    // Must be adjacent to last position in path
    const lastPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
    const rowDiff = Math.abs(row - lastPos.row);
    const colDiff = Math.abs(col - lastPos.col);
    // Only allow orthogonal moves (not diagonal)
    return rowDiff === 1 && colDiff === 0 || rowDiff === 0 && colDiff === 1;
}
function $cc90b7944b7e868a$export$1311cf265aa89b71() {
    const skills = new Set();
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach((step)=>{
        const room = step.room;
        if (room.type !== 'start' && room.type !== 'exit') {
            skills.add(room.primary);
            room.support.forEach((skill)=>skills.add(skill));
        }
    });
    return skills;
}
function $cc90b7944b7e868a$export$b34e3d9756d33d8e() {
    const skillDetails = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach((step)=>{
        const room = step.room;
        if (room.type !== 'start' && room.type !== 'exit') {
            // Track primary skills
            if (!skillDetails[room.primary]) skillDetails[room.primary] = {
                name: getSkillDisplayName(room.primary),
                isPrimary: true,
                isSupport: false,
                rooms: []
            };
            skillDetails[room.primary].rooms.push(room.name);
            // Track support skills
            room.support.forEach((skill)=>{
                if (!skillDetails[skill]) skillDetails[skill] = {
                    name: getSkillDisplayName(skill),
                    isPrimary: false,
                    isSupport: true,
                    rooms: []
                };
                else if (!skillDetails[skill].isSupport) skillDetails[skill].isSupport = true;
                skillDetails[skill].rooms.push(`${room.name} (support)`);
            });
        }
    });
    return skillDetails;
}
function $cc90b7944b7e868a$export$bf19dc1273cbd1a1() {
    const raidTeam = $cc90b7944b7e868a$export$d17f5534c14b3dc5();
    const teamSkills = {};
    //console.log('Calculating team skills from raid team:', raidTeam);
    raidTeam.forEach((member)=>{
        Object.entries(member.skills).forEach(([skill, level])=>{
            teamSkills[skill] = Math.max(teamSkills[skill] || 0, level);
        });
    });
    return teamSkills;
}
function $cc90b7944b7e868a$export$c41f4a6445888331() {
    const techniques = new Set();
    $cc90b7944b7e868a$export$d17f5534c14b3dc5().forEach((member)=>{
        const list = member.equippedTechniques || Object.keys(member.equippedTechniqueGear || {});
        list.forEach((t)=>techniques.add(t));
    });
    return techniques;
}
function $cc90b7944b7e868a$export$4b1577d33ea2a4be(skillId, teamTechniques) {
    if (!teamTechniques || teamTechniques.size === 0) return 0;
    let total = 0, covered = 0;
    Object.values($ce6dd72bc4611534$export$aafe7b77259ba40d).forEach((list)=>list.forEach((t)=>{
            if (t.skill === skillId) {
                total++;
                if (teamTechniques.has(t.id)) covered++;
            }
        }));
    if (total === 0 || covered === 0) return 0;
    const bonus = ((0, $42b272c2c0f44bdf$export$96671014a1dabc4c)('technique-success-bonus')?.value || 0) / 100;
    return bonus * covered / total;
}
function $cc90b7944b7e868a$export$b66d09bc2336a346() {
    return `raid_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
function $cc90b7944b7e868a$export$8d04a96d2d0c681f(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $cc90b7944b7e868a$export$9e1671340fa76e74(itemName, ctx = {}) {
    const itemSearch = Object.values((0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)()).filter((item)=>item.name === itemName);
    if (itemSearch.length === 0) return ""; // silent if no item found
    const item = itemSearch[0];
    const base = $ce6dd72bc4611534$export$3e15389530921005[item.type]?.[item.tier];
    if (!base) return ""; // silent if no template
    const core = $cc90b7944b7e868a$export$8d04a96d2d0c681f(base);
    // 20% chance to append a faction "tag" (keeps lines short)
    let tag = "";
    if (ctx.faction && $ce6dd72bc4611534$export$ca2adec0fe632974[ctx.faction] && Math.random() < 0.2) tag = " " + $cc90b7944b7e868a$export$8d04a96d2d0c681f($ce6dd72bc4611534$export$ca2adec0fe632974[ctx.faction]);
    // 20% chance to weave a tiny context shard
    let shard = "";
    if (Math.random() < 0.2) {
        const a = $cc90b7944b7e868a$export$8d04a96d2d0c681f($ce6dd72bc4611534$export$732c9d6827dc2245.action);
        const l = ctx.shortLocation || $cc90b7944b7e868a$export$8d04a96d2d0c681f($ce6dd72bc4611534$export$732c9d6827dc2245.location);
        shard = ` (${a} from ${l})`;
    }
    // keep under ~80 chars
    let line = `${core}${tag}${shard}`;
    if (line.length > 84) line = core + (tag ? tag : "");
    return line;
}
function $cc90b7944b7e868a$export$dfbeebc3d1509da(room, tier, rarity) {
    const loot = {};
    const quantityRange = (0, $00c60928d2fcd8b8$export$540736c4d7813ac)(rarity, tier, room.type);
    const quantity = Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min;
    const itemPool = (0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, tier, rarity);
    // Select random item from pool
    if (itemPool.length > 0) {
        const item = itemPool[Math.floor(Math.random() * itemPool.length)];
        loot[item] = quantity;
    }
    return loot;
}
function $cc90b7944b7e868a$export$ac5141fc59c5fe4f(room, regionTier) {
    if (room.type === 'start' || room.type === 'exit' || room.type === 'road') return [];
    const possibleLoot = [];
    if (room.type === 'gate') {
        // Rare materials
        possibleLoot.push(...(0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, regionTier, 'rare').slice(0, 3));
        // Blueprints
        possibleLoot.push($ce6dd72bc4611534$export$d02ea220375e4aff.blueprint.name);
        // Story relics (tier 4+)
        possibleLoot.push(...(0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, regionTier, 'unique').slice(0, 2));
    } else {
        // Common materials
        possibleLoot.push(...(0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, regionTier, 'common').slice(0, 2));
        // Rare materials (tier 3+)
        if (regionTier >= 3) possibleLoot.push(...(0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, regionTier, 'rare').slice(0, 2));
        // Consumables by tier
        const tierRarity = (0, $00c60928d2fcd8b8$export$65aa634013c8a9db)(regionTier);
        const consumables = (0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('consumable', tierRarity);
        if (consumables.length === 0) consumables.push(...(0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('consumable', 'common'));
        possibleLoot.push(...consumables.slice(0, 2));
        // Relics by tier
        const relics = (0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('relic', tierRarity);
        if (relics.length === 0) relics.push(...(0, $00c60928d2fcd8b8$export$b1ad0808e6cb0531)('relic', 'common'));
        possibleLoot.push(...relics.slice(0, 2));
    }
    // All rooms - credits
    possibleLoot.push('Credits');
    return possibleLoot;
}
function $cc90b7944b7e868a$export$1bd6296261413c8c(team) {
    const skills = {};
    team.forEach((member)=>{
        if (member.isAlive) Object.entries(member.skills).forEach(([skill, level])=>{
            skills[skill] = Math.max(skills[skill] || 0, level);
        });
    });
    return skills;
}
const $cc90b7944b7e868a$export$1b78a23f03a8d95f = 0.7;
const $cc90b7944b7e868a$export$e19e68234418033a = 0.4;
function $cc90b7944b7e868a$export$ac3767a8a135daf7(successChance) {
    if (successChance >= $cc90b7944b7e868a$export$1b78a23f03a8d95f) return {
        indicator: 'strong',
        symbol: "\u2713"
    };
    if (successChance >= $cc90b7944b7e868a$export$e19e68234418033a) return {
        indicator: 'risky',
        symbol: "\u25B2"
    };
    return {
        indicator: 'poor',
        symbol: "\u2717"
    };
}
function $cc90b7944b7e868a$export$278313c6a8f74dd(room, teamSkills, raidTier = null, teamTechniques = null) {
    if (room.type === 'start' || room.type === 'exit' || room.type === 'road') return 1.0; // Always succeed for special rooms
    // Get raid tier from current grid if not provided
    if (!raidTier && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) raidTier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    raidTier = raidTier || 1; // Default to tier 1
    // Get target skill level for this room type and tier
    const targetSkill = room.type == 'gate' ? $ce6dd72bc4611534$export$94e7ad7999c1ae32[raidTier].gateSkillLevel : $ce6dd72bc4611534$export$94e7ad7999c1ae32[raidTier].hazardSkillLevel;
    const primarySkill = teamSkills[room.primary] || 0;
    // Calculate support bonus with 15% cap to prevent exploits
    const rawSupportBonus = room.support.reduce((sum, skill)=>sum + (teamSkills[skill] || 0), 0) * 0.1;
    const supportBonus = Math.min(rawSupportBonus, 0.15);
    //console.log(`Calculating success chance for room ${room.name} (Type: ${room.type}, Tier: ${raidTier})`);
    //console.log(` - Target Skill: ${targetSkill}`);
    //console.log(` - Primary Skill (${room.primary}): ${primarySkill}`);
    //console.log(` - Support Bonus: ${supportBonus.toFixed(2)} (capped from ${rawSupportBonus.toFixed(2)})`);
    // Improved progression-based success chance calculation
    // Base 76% chance when skill equals target, +/- 5% per skill level
    // difference; equipped gear adds its expected bonus (see
    // getGearExpectedBonus) and the equipped skill artifact its flat +5%
    // when it matches the room's primary skill (exact, not an expectation)
    const skillDifference = primarySkill - targetSkill;
    const gearBonus = $cc90b7944b7e868a$export$4b1577d33ea2a4be(room.primary, teamTechniques);
    const artifactBonus = (0, $1b3f8df6e579f420$export$a5a257639bbcfa93)(room.primary) / 100;
    let successChance = 0.76 + skillDifference * 0.05 + supportBonus + gearBonus + artifactBonus;
    // Ensure minimum 20% chance
    successChance = Math.max(0.20, successChance);
    // Cap at 97%
    successChance = Math.min(0.97, successChance);
    return successChance;
}
function $cc90b7944b7e868a$export$26622a6bc351fd6d(path = null) {
    if (!path) path = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath;
    if (!path || path.length === 0) return 0;
    const teamSkills = $cc90b7944b7e868a$export$bf19dc1273cbd1a1();
    const teamTechniques = $cc90b7944b7e868a$export$c41f4a6445888331();
    const raidTier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier : 1;
    let overallChance = 1.0;
    // Calculate compound probability across all rooms that require skill checks
    path.forEach((step)=>{
        const room = step.room;
        if (room.type !== 'start' && room.type !== 'exit' && room.type !== 'road' && room.type !== 'campsite' && room.type !== 'water') {
            const roomChance = $cc90b7944b7e868a$export$278313c6a8f74dd(room, teamSkills, raidTier, teamTechniques);
            //console.log(overallChance, '*', roomChance, '=', overallChance * roomChance);
            overallChance *= roomChance;
        }
    });
    return overallChance;
}
function $cc90b7944b7e868a$export$6d9d0391c1a1da34() {
    const team = [];
    // Add player character
    team.push({
        id: 'player',
        name: (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name,
        type: 'player',
        faction: (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction,
        skills: {
            ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills
        },
        // Equipped skill-gear technique ids: drive event variant selection
        // and the per-technique success bonus during the raid
        equippedTechniques: Object.keys((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear || {}),
        maxHp: (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.maxHp,
        currentHp: (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.currentHp || (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.maxHp,
        isAlive: true,
        injuries: []
    });
    // Add hired contractors
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach((contractor)=>{
        team.push({
            id: contractor.id,
            name: contractor.name,
            type: 'contractor',
            faction: contractor.faction,
            skills: {
                ...contractor.skills
            },
            equippedTechniques: Object.keys(contractor.equippedTechniqueGear || {}),
            maxHp: contractor.maxHp || 100,
            currentHp: contractor.currentHp || contractor.maxHp || 100,
            isAlive: true,
            injuries: [],
            cost: contractor.cost
        });
    });
    // Set current HP to max for all members
    team.forEach((member)=>{
        if (member.currentHp === null) member.currentHp = member.maxHp;
    });
    return team;
}
function $cc90b7944b7e868a$export$d17f5534c14b3dc5() {
    const team = [];
    //console.log("CREATING TEAM", gameState.currentRaid.hiredContractors);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) team.push((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach((contractor)=>{
            team.push(contractor);
        });
        else if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length > 0) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach((contractor)=>{
            team.push(contractor);
        });
    }
    //console.log("CREATED TEAM OF ", team.length);
    return team;
}
function $cc90b7944b7e868a$export$81a3d8aa8b7e7939() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) return false;
    // Check if current character is on marketplace
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot start raids with a character that is contracted out on the marketplace', 'error');
        return false;
    }
    // Validate path
    if (!$cc90b7944b7e868a$export$a678af82bf766611((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
        const errorMsg = 'Invalid path! Make sure you start at the entry portal and end at the exit portal.';
        if (typeof alert !== 'undefined') alert(errorMsg);
        else console.warn(errorMsg);
        return false;
    }
    // Check energy requirements
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    const energyCost = $cc90b7944b7e868a$export$78de3bc967b7be(tier, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy < energyCost) {
        const errorMsg = `Not enough energy! This raid requires ${energyCost} energy. You have ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy}. Energy regenerates over time.`;
        if (typeof alert !== 'undefined') alert(errorMsg);
        else console.warn(errorMsg);
        return false;
    }
    return true;
}
async function $cc90b7944b7e868a$export$43eae605f498c00a() {
    // Consume energy
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    const energyCost = $cc90b7944b7e868a$export$78de3bc967b7be(tier, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy -= energyCost;
    // Hire reserved contractors (no upfront cost - they take percentage of rewards)
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [
        ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors
    ];
    // Update database for multiplayer contractors
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (currentCharacter) {
        for (const contractor of (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors)if (contractor.multiplayerId) {
            const raidId = $cc90b7944b7e868a$export$b66d09bc2336a346(); // Generate unique raid ID
            // tier lets the server reject a contract that would expire mid-raid
            await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).hireContractor(contractor.multiplayerId, currentCharacter.multiplayerId, raidId, tier);
        }
    }
    // Clear reserved contractors
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    // Cold Drop: the convoy arrives already hurt. Applied HERE, at raid init and
    // to the whole team, rather than at team assembly — assembly runs while the
    // player is still planning, and docking HP there would let them heal back up
    // before launching and pocket the perk for free.
    const startHpFraction = (0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('startHpFraction', 1);
    if (startHpFraction < 1) for (const member of $cc90b7944b7e868a$export$d17f5534c14b3dc5())member.currentHp = Math.max(1, Math.floor(member.maxHp * startHpFraction));
    // Record raid time
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).lastRaidTime = Date.now();
    // Initialize raid state in gameState for persistence
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress = {
        raidTeam: $cc90b7944b7e868a$export$d17f5534c14b3dc5(),
        teamSkills: null,
        raidSuccess: true,
        roomsCompleted: 0,
        lootGained: {},
        currentRoomIndex: 0,
        startTime: Date.now(),
        nextRoomTime: Date.now(),
        logEntries: [],
        progressiveLoot: {
            active: false,
            totalLoot: {},
            distributedLoot: {},
            intervals: [],
            nextLootTime: 0,
            roomName: ''
        },
        specialEvent: {
            active: false,
            scheduled: false,
            spawnTime: null,
            element: null,
            roomIndex: null
        }
    };
    // Calculate team skills
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.teamSkills = $cc90b7944b7e868a$export$1bd6296261413c8c($cc90b7944b7e868a$export$d17f5534c14b3dc5());
}
function $cc90b7944b7e868a$export$493c70936cbe8c13() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) return;
    const currentTime = Date.now();
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    const pathStep = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    // Process all scheduled events for the current room (skill-check, bonus loot, fishing) via unified event system
    let eventInfo = (0, $b596e64ef926739f$export$a2efc3d0c71d9b81)((0, $f27982cef7035d22$export$8e361a1ffbebf172), $cc90b7944b7e868a$export$d17f5534c14b3dc5());
    if (eventInfo) for(let i = 0; i < 10; i++){
        if (eventInfo?.eventLifeCycle == 'start') switch(eventInfo.eventType){
            case 'skillCheck':
                // team read live, like the resolve call below: this loop can resolve
                // one event and start the next in the same tick, and a casualty in
                // between changes which techniques are available
                (0, $b596e64ef926739f$export$3d092dd9a898451d)(eventInfo.eventData, raid.currentRoomIndex, (0, $f27982cef7035d22$export$8e361a1ffbebf172), $cc90b7944b7e868a$export$d17f5534c14b3dc5());
                break;
            case 'bonusLoot':
                (0, $b596e64ef926739f$export$de2180cc63765512)((0, $f27982cef7035d22$export$8e361a1ffbebf172));
                break;
            case 'fishing':
                (0, $b596e64ef926739f$export$99ca7bb292cc775d)((0, $f27982cef7035d22$export$8e361a1ffbebf172));
                break;
        }
        else if (eventInfo?.eventLifeCycle == 'end') switch(eventInfo.eventType){
            case 'skillCheck':
                (0, $b596e64ef926739f$export$7408e7aadd9fb0b0)(eventInfo.eventData, (0, $f27982cef7035d22$export$8e361a1ffbebf172), pathStep.room, $cc90b7944b7e868a$export$d17f5534c14b3dc5());
                break;
        }
        eventInfo = (0, $b596e64ef926739f$export$a2efc3d0c71d9b81)((0, $f27982cef7035d22$export$8e361a1ffbebf172), $cc90b7944b7e868a$export$d17f5534c14b3dc5());
    }
    //processScheduledEvents(gameState, getRaidTeam());
    // No time check for simulation
    //console.log("time check debug:", gameState.simulated||"no-sim", currentTime, gameState.currentRaid.raidInProgress.nextRoomTime);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).simulated || currentTime >= (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.nextRoomTime) {
        const shouldContinue = $cc90b7944b7e868a$export$755aced95cf6ca1e();
        if (shouldContinue) $cc90b7944b7e868a$export$40c1d154d5089b4f();
    }
}
function $cc90b7944b7e868a$export$755aced95cf6ca1e() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    if (raid.currentRoomIndex >= (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length) {
        //somehow we exited but something went wrong
        $cc90b7944b7e868a$export$58d6519cd8e111b3();
        return false; // Don't enter next room
    }
    const pathStep = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    const room = pathStep.room;
    // Count room events before cleanup (for tracking/analytics)
    const eventCounts = (0, $b596e64ef926739f$export$851890b870f423fa)((0, $f27982cef7035d22$export$8e361a1ffbebf172));
    // Accumulate event statistics in raid object for later retrieval
    if (!raid.eventStats) raid.eventStats = {
        skillCheckEvents: 0,
        bonusLootEvents: 0
    };
    raid.eventStats.skillCheckEvents += eventCounts.skillCheckCount;
    raid.eventStats.bonusLootEvents += eventCounts.hasBonusLoot ? 1 : 0;
    // Cleanup all room events (skill-check, bonus loot, fishing) via eventSystem
    (0, $b596e64ef926739f$export$3645ad137fdaf2f9)((0, $f27982cef7035d22$export$8e361a1ffbebf172));
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, `Completing room ${raid.currentRoomIndex}/${(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1}: ${room.name} (${room.type})`);
    switch(room.type){
        case 'exit':
            $cc90b7944b7e868a$var$processExitRoomCompletion(raid, room);
            return false;
        case 'start':
            $cc90b7944b7e868a$var$processEntryRoomCompletion(raid, room);
            break;
        case 'road':
            $cc90b7944b7e868a$var$processRoadRoomCompletion(raid, room);
            break;
        case 'campsite':
            $cc90b7944b7e868a$var$processCampsiteRoomCompletion(raid, room);
            break;
        case 'water':
            $cc90b7944b7e868a$var$processWaterRoomCompletion(raid, room);
            break;
        case 'gate':
        case 'hazard':
            const proceed = $cc90b7944b7e868a$var$processNormalRoomCompletion(raid, room);
            if (!proceed) return false;
    }
    raid.currentRoomIndex++;
    //raid.nextRoomTime = Date.now() + (room.baseDuration*1000);
    // Check if we've completed all rooms or raid failed
    //console.log('checking currentRoomIndex', raid.currentRoomIndex, gameState.currentRaid.selectedPath.length, raid.raidSuccess);
    if (raid.currentRoomIndex >= (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length || !raid.raidSuccess) {
        $cc90b7944b7e868a$export$58d6519cd8e111b3();
        return false; // Don't enter next area
    } else return true; // Continue to next area
}
function $cc90b7944b7e868a$var$processExitRoomCompletion(raid, room) {
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F30C} Reached the exit portal! Raid completed successfully!`, 'success', {
        notificationMessage: `\u{1F30C} Raid completed successfully!`,
        stepIndex: raid.currentRoomIndex
    });
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
    raid.currentRoomIndex++;
    $cc90b7944b7e868a$export$58d6519cd8e111b3();
}
function $cc90b7944b7e868a$var$processEntryRoomCompletion(raid, room) {
    const nextPathStep = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    const nextRoom = nextPathStep.room;
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
}
function $cc90b7944b7e868a$var$processRoadRoomCompletion(raid, room) {
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F6E3}\u{FE0F} Leaving ${room.name}`, 'info', {
        notificationMessage: `\u{1F6E3}\u{FE0F} Leaving ${room.name}`,
        stepIndex: raid.currentRoomIndex
    });
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
}
function $cc90b7944b7e868a$var$processCampsiteRoomCompletion(raid, room) {
    const raidTeam = $cc90b7944b7e868a$export$d17f5534c14b3dc5();
    const healingAmount = room.healingAmount || 30;
    Object.entries(raid.lootGained).forEach(([item, amount])=>{
        if (item === 'Fish') {
            const foodHealingAmount = room.healingAmount * 0.1 * amount;
            $cc90b7944b7e868a$export$b381c7b121792f39(raidTeam, foodHealingAmount);
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F41F} Team eats a meal of fresh caught fish`, 'success', {
                notificationMessage: `\u{1F41F} Team healed for ${foodHealingAmount} HP`,
                stepIndex: raid.currentRoomIndex
            });
        }
    });
    $cc90b7944b7e868a$export$b381c7b121792f39(raidTeam, healingAmount);
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F49A} Team tended to their wounds`, 'success', {
        notificationMessage: `\u{1F49A} Team healed for ${healingAmount} HP`,
        stepIndex: raid.currentRoomIndex
    });
    // Show healing details for each team member
    raidTeam.forEach((member)=>{
        if (member.currentHp > 1) (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F49A} ${member.name} recovered HP (${member.currentHp}/${member.maxHp})`, 'success', {
            notify: false,
            stepIndex: raid.currentRoomIndex
        });
    });
    room.result = {
        success: true,
        damage: 0,
        healing: healingAmount,
        loot: {}
    };
    raid.roomsCompleted++;
}
function $cc90b7944b7e868a$var$processWaterRoomCompletion(raid, room) {
    // Fishing events are handled separately
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
    raid.roomsCompleted++;
}
function $cc90b7944b7e868a$var$processNormalRoomCompletion(raid, room) {
    // Check if all skill-check events have completed (event system handles outcomes and damage)
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    const skillCheckEvents = raid.events?.skillCheckEvents || [];
    const allEventsCompleted = skillCheckEvents.length === 0 || skillCheckEvents.every((e)=>e.status === 'completed' || e.status === 'failed');
    // If events haven't finished yet, don't process room completion
    if (skillCheckEvents.length > 0 && !allEventsCompleted) return false;
    const roomSuccess = !raid.hasSkillEventFailure;
    room.result = {
        success: roomSuccess
    };
    if (roomSuccess) {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{2705} Area secured successfully!`, 'success', {
            notificationMessage: `\u{2705} ${room.name} secured!`,
            stepIndex: raid.currentRoomIndex
        });
        raid.roomsCompleted++;
    } else {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{274C} Failed to clear ${room.name}!`, 'failure', {
            stepIndex: raid.currentRoomIndex
        });
        // A member who went down stops contributing their skills to the rest of
        // the raid. calculateTeamSkills filters on isAlive, so this recalculation
        // is what actually removes them — without it a knocked-out specialist
        // keeps passing checks for every remaining room.
        //
        // RESTORED 2026-08-02. The old applyDamageToTeam did this inline; the
        // rewrite to per-event damage in eventSystem-core dropped it, and nothing
        // caught it because applyDamageToTeam was left in place as dead code that
        // still looked like the live path. Consequence while it was missing:
        // raids were EASIER than designed, so expect Tier 3 success to fall now.
        raid.teamSkills = $cc90b7944b7e868a$export$1bd6296261413c8c($cc90b7944b7e868a$export$d17f5534c14b3dc5());
        // Check if raid should continue - only team wipe ends the raid
        if (!$cc90b7944b7e868a$export$59bc35895553fb06($cc90b7944b7e868a$export$d17f5534c14b3dc5())) {
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F480} All team members incapacitated - raid terminated!`, 'failure', {
                notificationMessage: `\u{1F480} All team members incapacitated!`,
                stepIndex: raid.currentRoomIndex
            });
            raid.raidSuccess = false;
            $cc90b7944b7e868a$export$58d6519cd8e111b3();
            return false;
        } else (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{26A0}\u{FE0F} The team continues despite setbacks...`, 'info', {
            notify: false,
            stepIndex: raid.currentRoomIndex
        });
    }
    // Award base room credits
    const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
    if (tierData && tierData.creditRewards) {
        let baseCredit = tierData.creditRewards.baseRoomCredit;
        // Apply credit scaling multipliers
        baseCredit = (0, $00c60928d2fcd8b8$export$78a769585121af92)(baseCredit, tier);
        (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(raid.lootGained, 'Credits', baseCredit);
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4B0} Intelligence report payout: ${baseCredit} credits`, 'bonus', {
            stepIndex: raid.currentRoomIndex
        });
        // Award completion bonus if all skill-check events passed
        if (!raid.hasSkillEventFailure) {
            let completionBonus = tierData.creditRewards.completionBonus;
            // Apply credit scaling multipliers
            completionBonus = (0, $00c60928d2fcd8b8$export$78a769585121af92)(completionBonus, tier);
            (0, $00c60928d2fcd8b8$export$d2188f6548dbea9f)(raid.lootGained, 'Credits', completionBonus);
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4B0} Complete intelligence bonus: ${completionBonus} credits`, 'bonus', {
                stepIndex: raid.currentRoomIndex
            });
        }
    }
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4CD} Leaving ${room.name} (${raid.currentRoomIndex}/${(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 2})`, 'info', {
        notificationMessage: `\u{1F4CD} Leaving ${room.name}`,
        stepIndex: raid.currentRoomIndex
    });
    return true;
}
function $cc90b7944b7e868a$export$40c1d154d5089b4f() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    const pathStep = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    const room = pathStep.room;
    // Schedule room start and end times
    raid.roomStartTime = Date.now();
    raid.nextRoomTime = raid.roomStartTime + room.baseDuration * 1000;
    switch(room.type){
        case 'gate':
        case 'hazard':
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4CD} Entered ${room.name} (${raid.roomsCompleted + 1}/${$cc90b7944b7e868a$export$aedd9bb9e278a90a((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath)})`, 'info', {
                notificationMessage: `\u{1F4CD} Entered ${room.name}`,
                stepIndex: raid.currentRoomIndex
            });
            // Initialize skill-check events and conditional bonus loot via eventSystem
            (0, $b596e64ef926739f$export$5c6c29dc14ccb545)(room, (0, $f27982cef7035d22$export$8e361a1ffbebf172));
            break;
        case 'road':
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F6E3}\u{FE0F} Entered ${room.name}`, 'info', {
                notificationMessage: `\u{1F6E3}\u{FE0F} Entered ${room.name}`,
                stepIndex: raid.currentRoomIndex
            });
            break;
        case 'campsite':
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F3D5}\u{FE0F} Team sets up camp and recovers`, 'info', {
                notificationMessage: `\u{1F3D5}\u{FE0F} Found a safe campsite`,
                stepIndex: raid.currentRoomIndex
            });
            break;
        case 'water':
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F30A} Team discovers a fishing spot`, 'info', {
                notificationMessage: `\u{1F30A} Found water source`,
                stepIndex: raid.currentRoomIndex
            });
            // Initialize fishing event via eventSystem
            (0, $b596e64ef926739f$export$5c6c29dc14ccb545)(room, (0, $f27982cef7035d22$export$8e361a1ffbebf172));
            break;
    }
}
async function $cc90b7944b7e868a$export$58d6519cd8e111b3() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    const region = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
    // Clean up any active special events
    //if (raid.specialEvent && raid.specialEvent.active) {
    //cleanupBonusEvent();
    //}
    // Calculate final results
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    const finalResults = $cc90b7944b7e868a$export$95648a2a64dc501c(raid.raidSuccess, raid.roomsCompleted, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length, region, $cc90b7944b7e868a$export$d17f5534c14b3dc5(), tier);
    // Calculate contractor payments from total credits earned
    const totalContractorPercentage = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0 ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.reduce((sum, contractor)=>sum + contractor.rewardPercentage, 0) : 0;
    const contractorPayment = Math.floor(finalResults.creditsEarned * totalContractorPercentage / 100);
    const playerCredits = finalResults.creditsEarned - contractorPayment;
    // Note: Credit scaling is already applied when individual credits are looted (base room, events, completion bonus)
    // This finalResults amount is a bonus calculation separate from looted credits
    // Apply results to hiring player (they pay for all contractors)
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits += playerCredits;
    // Calculate XP for contractors (before payments to avoid duplication)
    const xpEarned = $cc90b7944b7e868a$export$1a56a513ad3028b0(raid.raidSuccess, raid.roomsCompleted, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length, region, $cc90b7944b7e868a$export$d17f5534c14b3dc5(), tier);
    const contractorXP = Math.floor(xpEarned * 0.8); // Contractors get 80% of player XP
    // Calculate individual contractor payments and send to owners
    const contractorPayments = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.map((contractor)=>({
            contractorId: contractor.id,
            contractorName: contractor.name,
            isPlayerContractor: contractor.id > 0,
            percentage: contractor.rewardPercentage,
            credits: Math.floor(finalResults.creditsEarned * contractor.rewardPercentage / 100),
            xp: contractorXP
        }));
    // Send credits and XP to player contractor owners (AI contractors don't get real credits/XP).
    // Awaited so the payments are recorded while the contractors are still marked
    // hired — the server verifies the hire relationship, and the release below
    // clears it (see finishRaid contractor release).
    const onlinePayments = contractorPayments.filter((p)=>p.isPlayerContractor);
    if (onlinePayments.length > 0) await (0, $f5272a3e1bbf7d7b$export$2d25a36fab5567cb)(onlinePayments);
    if (finalResults.creditsEarned > 0) {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4B0} Total raid earnings: ${finalResults.creditsEarned} credits`, 'success', {
            stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
            notificationMessage: `\u{1F4B0} Earned ${playerCredits} credits`
        });
        if (contractorPayment > 0) {
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4BC} Contractor payments: ${contractorPayment} credits (${totalContractorPercentage}%)`, 'info', {
                notify: false,
                stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
            });
            (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4B0} Your share: ${playerCredits} credits`, 'success', {
                notify: false,
                stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
            });
        }
    }
    // Award XP for the raid (already calculated above for contractor payments)
    if (xpEarned > 0) {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{2B50} Gained ${xpEarned} experience points`, 'success', {
            stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
            notificationMessage: `\u{2B50} Gained ${xpEarned} XP`
        });
        (0, $1b3f8df6e579f420$export$88ec20478ef6bd29)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, xpEarned);
        // Award XP to all contractors who participated in the raid
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0) {
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach((contractor)=>{
                if (contractor) (0, $1b3f8df6e579f420$export$31efd075830c7467)(contractor, contractorXP);
            });
            if (contractorXP > 0) (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F465} Contractors gained ${contractorXP} experience points`, 'info', {
                stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                notify: false
            });
        }
    }
    // Add loot to inventory and credits (per-item scarcity is applied at drop
    // time via weighted selection, so logged loot matches inventory exactly)
    if (raid.lootGained) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory || {};
        Object.entries(raid.lootGained).forEach(([item, amount])=>{
            if (item === 'Credits' && amount) (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits += amount;
            else if (raid.raidSuccess && item != 'Fish') (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[item] = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[item] || 0) + amount;
        });
    }
    // Apply injuries to contractors (they heal over time)
    $cc90b7944b7e868a$export$c994d11f45f33eb9($cc90b7944b7e868a$export$d17f5534c14b3dc5());
    // Final status report
    if (raid.raidSuccess) {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F389} Raid completed successfully!`, 'success', {
            stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
        });
        // Lifetime counter for the Command Marks formula
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid?.tier === 3 && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
            (0, $f27982cef7035d22$export$6b22d50e3ddf4789)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.lifetime.t3Wins += 1;
        }
        // Collapse Key recovery. The whole of the story track's award path is
        // this call: keys are account-level records rather than loot, so nothing
        // here touches lootGained, the inventory, or any drop table.
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
            const key = (0, $85e2b1e6893337a2$export$9d589cbf453e87ad)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid?.tier || 1);
            if (key) (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F5DD}\u{FE0F} Collapse Key ${key.code} recovered \u{2014} \u{201C}${key.name}\u{201D}. Filed to the Archive.`, 'bonus', {
                stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                notificationMessage: `\u{1F5DD}\u{FE0F} Collapse Key ${key.code} \u{2014} \u{201C}${key.name}\u{201D}`
            });
        }
    } else {
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F480} Raid failed - retreat initiated!`, 'failure', {
            stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
        });
        (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F480} Raid failed - items dropped!`, 'failure', {
            stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
        });
    }
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4CA} Final Report: ${raid.roomsCompleted}/${$cc90b7944b7e868a$export$aedd9bb9e278a90a((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath)} rooms cleared without incident`, 'info', {
        notify: false,
        stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
    });
    // Save completed raid info for restoration after page reload
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = {
        region: region,
        selectedPath: [
            ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath
        ],
        roomsCompleted: raid.roomsCompleted,
        raidSuccess: raid.raidSuccess,
        logEntries: raid.logEntries ? [
            ...raid.logEntries
        ] : [],
        stepLogs: raid.stepLogs ? JSON.parse(JSON.stringify(raid.stepLogs)) : {},
        currentRaidGrid: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid,
        eventStats: raid.eventStats,
        // Snapshot for the raid-panel Loot tab (raidInProgress is torn down
        // after this; on failure the items were discarded — the tab shows them
        // as lost)
        lootGained: raid.lootGained ? {
            ...raid.lootGained
        } : {}
    };
    // Settle the Blackout contract. Only a SUCCESSFUL run pays — the modifiers
    // are the price of the perk, and clearing on any completion would let a
    // player arm the hardest contract and walk into the first hazard.
    const blackoutEarned = (0, $45c49e7f6d2032d6$export$f0d942e2e6132b96)({
        success: !!raid.raidSuccess
    });
    if (blackoutEarned) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.blackoutEarned = blackoutEarned;
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F311} ${(0, $45c49e7f6d2032d6$export$913dd38406a903a1)(blackoutEarned.contractId)?.name} cleared \u{2014} ${blackoutEarned.perk.label}, permanently.`, 'success', {
            sticky: true
        } // one-time, irreversible, and easy to miss in the results wall
        );
    }
    // Release hired contractors in database
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (currentCharacter) {
        for (const contractor of (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors)if (contractor.multiplayerId) await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseHiredContractor(contractor.multiplayerId, currentCharacter.multiplayerId);
    }
    // Clean up raid state
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted = true;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
    // Succession Doctrine: a raid ending is when the marks rate actually moves,
    // so it is where the promotion peak is re-evaluated. Tracked unconditionally,
    // not only when the charter is owned — the Command panel shows the same rate
    // line, and the spec requires panel and automation to share ONE computation.
    (0, $46d374413fb0707a$export$12d96118114aebf3)();
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F3EA} New contractors have arrived at the outpost!`, 'info', {
        notify: false,
        stepIndex: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
    });
}
function $cc90b7944b7e868a$export$fae9674fe5380657() {
    // Clean up any active special events
    //if (gameState.currentRaid.raidInProgress && gameState.currentRaid.raidInProgress.specialEvent && gameState.currentRaid.raidInProgress.specialEvent.active) {
    //cleanupBonusEvent();
    //}
    // Clear raid state. selectedRegion/selectedTier deliberately survive the
    // reset so the next New Raid screen starts from the previous choices
    // (players mostly re-run the same setup); generateRegionTiles() still
    // clears a selection that a region lock has made unavailable.
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted = false;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
    // Release marketplace contractors on server before clearing
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (currentCharacter) // Release all reserved marketplace contractors
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach((contractor)=>{
        if (contractor.id > 0) (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseContractor(contractor.id, currentCharacter.multiplayerId).catch((err)=>console.error('Error releasing reserved contractor:', err));
    });
    // Clear local contractor arrays
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
}










//@ts-check
/**
 * Team Carousel Component
 * Displays 3 team member cards in a centered stack layout
 * Active card in the middle, previous and next cards peeking from above/below
 */ /** @type {{activeIndex: number, members: Array<any>, container: HTMLElement | null, scrollTimeout: ReturnType<typeof setTimeout> | null}} */ let $10132d7a74b781c4$var$teamCarouselState = {
    activeIndex: 0,
    members: [],
    container: null,
    scrollTimeout: null
};
function $10132d7a74b781c4$export$f1143e4c4cd76114(container, members) {
    $10132d7a74b781c4$var$teamCarouselState.container = container;
    $10132d7a74b781c4$var$teamCarouselState.members = members;
    // Preserve active index if it's still valid, otherwise reset to 0
    if ($10132d7a74b781c4$var$teamCarouselState.activeIndex >= members.length) $10132d7a74b781c4$var$teamCarouselState.activeIndex = 0;
    $10132d7a74b781c4$export$2602fbc45dfcf30d();
    $10132d7a74b781c4$var$attachCarouselEventHandlers();
}
function $10132d7a74b781c4$export$32c8855874220763() {
    return $10132d7a74b781c4$var$teamCarouselState.activeIndex;
}
function $10132d7a74b781c4$export$b9bd062e5e9731c7(index) {
    if (index >= 0 && index < $10132d7a74b781c4$var$teamCarouselState.members.length) {
        $10132d7a74b781c4$var$teamCarouselState.activeIndex = index;
        $10132d7a74b781c4$export$2602fbc45dfcf30d();
        $10132d7a74b781c4$var$attachCarouselEventHandlers();
    }
}
function $10132d7a74b781c4$export$f537ff3e97ce27ef(direction) {
    const { members: members, activeIndex: activeIndex } = $10132d7a74b781c4$var$teamCarouselState;
    let newIndex = activeIndex;
    if (direction === 'next') newIndex = (activeIndex + 1) % members.length;
    else if (direction === 'prev') newIndex = (activeIndex - 1 + members.length) % members.length;
    $10132d7a74b781c4$export$b9bd062e5e9731c7(newIndex);
}
/**
 * Calculate which member should be in which position (previous, active, next)
 * @returns {{previous: number, active: number, next: number}} Object with indices for previous, active, and next positions
 */ function $10132d7a74b781c4$var$calculatePositions() {
    const { activeIndex: activeIndex, members: members } = $10132d7a74b781c4$var$teamCarouselState;
    const length = members.length;
    return {
        previous: (activeIndex - 1 + length) % length,
        active: activeIndex,
        next: (activeIndex + 1) % length
    };
}
/**
 * Get Tailwind classes for a card based on its position
 * @param {string} position - 'previous', 'active', or 'next'
 * @returns {string} Tailwind classes for positioning and styling
 *
 * Horizontal spread: Cards offset by ~40px (1/6 of 256px card width for 2/3 overlap)
 * - active: top right
 * - next: middle
 * - previous: bottom left
*/ function $10132d7a74b781c4$var$getCardPositionClass(position) {
    const baseTransition = 'transition-all duration-300';
    switch(position){
        case 'previous':
            // Bottom and left edges aligned with container, semi-transparent
            return `absolute scale-[0.90] bottom-0 left-0 saturate-[0.5] z-10 ${baseTransition}`;
        case 'next':
            // Center, fully visible
            return `absolute scale-[0.95] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 saturate-[0.75] z-20 ${baseTransition}`;
        case 'active':
            // Top and right edges aligned with container, semi-transparent
            return `absolute top-0 right-0 z-30 ${baseTransition}`;
        default:
            return baseTransition;
    }
}
/**
 * Render the team carousel HTML
 * Uses Tailwind classes for styling (no external CSS needed)
 */ /**
 * Update button interaction states based on card positions
 * Only allows buttons on the active (centered) card to be clickable
 */ function $10132d7a74b781c4$var$updateCardButtonStates() {
    const container = $10132d7a74b781c4$var$teamCarouselState.container;
    if (!container) return;
    setTimeout(()=>{
        const cardDivs = container.querySelectorAll('[data-carousel-position]');
        cardDivs.forEach((/** @type {any} */ card)=>{
            const position = card.getAttribute('data-carousel-position');
            const buttons = card.querySelectorAll('button');
            buttons.forEach((/** @type {any} */ button)=>{
                if (position === 'active') // Active card: enable buttons
                button.classList.remove('pointer-events-none');
                else // Background cards: disable buttons
                button.classList.add('pointer-events-none');
            });
        });
    }, 0);
}
function $10132d7a74b781c4$export$2602fbc45dfcf30d() {
    const { container: container, members: members, activeIndex: activeIndex } = $10132d7a74b781c4$var$teamCarouselState;
    if (!container || members.length === 0) return;
    const positions = $10132d7a74b781c4$var$calculatePositions();
    const prevIndex = positions.previous;
    const actIndex = positions.active;
    const nextIndex = positions.next;
    // Build the carousel HTML using Tailwind classes
    const carouselHTML = `
        <div class="flex flex-col items-center gap-4">
            <!-- Cards Stack Container -->
            <!-- Width allows for card overlap with minimal extra space -->
            <!-- Supports click and scroll wheel controls -->
            <div id="carousel-cards-container" class="relative h-[32rem] w-[21rem] xl:w-[26rem] 2xl:w-[28rem] cursor-pointer">
                <!-- Previous Card -->
                <div class="${$10132d7a74b781c4$var$getCardPositionClass('previous')}" data-carousel-position="previous">
                    ${members[prevIndex]?.html || ''}
                </div>

                <!-- Active Card -->
                <div class="${$10132d7a74b781c4$var$getCardPositionClass('active')}" data-carousel-position="active">
                    ${members[actIndex]?.html || ''}
                </div>

                <!-- Next Card -->
                <div class="${$10132d7a74b781c4$var$getCardPositionClass('next')}" data-carousel-position="next">
                    ${members[nextIndex]?.html || ''}
                </div>
            </div>
        </div>
    `;
    container.innerHTML = carouselHTML;
    $10132d7a74b781c4$var$updateCardButtonStates();
}
/**
 * Attach event listeners to the carousel for click and scroll controls
 * - Click on cards: moves clicked card to the front
 * - Scroll up over cards: advances to next member
 * - Scroll down over cards: advances to previous member
 */ function $10132d7a74b781c4$var$attachCarouselEventHandlers() {
    const container = $10132d7a74b781c4$var$teamCarouselState.container;
    if (!container) return;
    // Wait for DOM to be ready, then attach handlers
    setTimeout(()=>{
        const cardsContainer = container.querySelector('#carousel-cards-container');
        if (!cardsContainer) return;
        // Click handler: move clicked card to front
        cardsContainer.addEventListener('click', (/** @type {any} */ e)=>{
            e.stopPropagation();
            // Ignore clicks on buttons or other interactive elements
            if (e.target.closest('button') || e.target.closest('[onclick]')) return;
            // Find which card was clicked
            const clickedElement = e.target.closest('[data-carousel-position]');
            if (!clickedElement) return;
            const position = clickedElement.getAttribute('data-carousel-position');
            // Don't transition if clicking the active card
            if (position === 'active') return;
            // Move clicked card (previous or next) to the front
            const { activeIndex: activeIndex, members: members } = $10132d7a74b781c4$var$teamCarouselState;
            const length = members.length;
            let newIndex = activeIndex;
            if (position === 'previous') newIndex = (activeIndex - 1 + length) % length;
            else if (position === 'next') newIndex = (activeIndex + 1) % length;
            $10132d7a74b781c4$export$b9bd062e5e9731c7(newIndex);
        });
        // Scroll wheel handler: up = next, down = prev
        cardsContainer.addEventListener('wheel', (/** @type {any} */ e)=>{
            e.preventDefault();
            e.stopPropagation();
            // Debounce scroll events to prevent rapid consecutive rotations
            if ($10132d7a74b781c4$var$teamCarouselState.scrollTimeout) clearTimeout($10132d7a74b781c4$var$teamCarouselState.scrollTimeout);
            $10132d7a74b781c4$var$teamCarouselState.scrollTimeout = setTimeout(()=>{
                const direction = e.deltaY < 0 ? 'next' : 'prev';
                $10132d7a74b781c4$export$f537ff3e97ce27ef(direction);
                $10132d7a74b781c4$var$teamCarouselState.scrollTimeout = null;
            }, 100);
        }, {
            passive: false
        });
    }, 0);
}
/**
 * Export functions for global window access (needed for inline onclick handlers)
 */ window.teamCarouselNext = function() {
    $10132d7a74b781c4$export$f537ff3e97ce27ef('next');
};
window.teamCarouselPrev = function() {
    $10132d7a74b781c4$export$f537ff3e97ce27ef('prev');
};



/**
 * The Archive — where recovered Collapse Keys are read, and re-read.
 *
 * One instance of the shared collection archetype (collectionView.js), not a
 * bespoke screen. A key arrives as a raid message that scrolls away; this is
 * the surface that makes it permanent, which is the requirement
 * `docs/archive/BreachLayer.md` recorded as "neither a toast nor a modal".
 *
 * Grouped by faction rather than by tier, because the three sets are three
 * arguments and reading one straight through is the point. Every faction's set
 * is shown, including factions the account has never played — the shape of what
 * is missing is what makes the collection legible, and it is also what tells a
 * player that the other two theories exist at all.
 *
 * The header states the seven-key ceiling plainly. Keys 8-10 are authored and
 * land at Tier 4 with L4; saying so is better than a set that silently stops at
 * seven and reads as unfinished content.
 */ 
/**
 * Collection view — the shared archetype for "a set of things you gather".
 *
 * `docs/systemsRework/LayerNavigation.md` flags this as a pattern that recurs
 * across the ladder (artifacts, Legends, Blackout perks, Collapse Keys, L4's
 * traced hubs) and asks for it to be extracted on the SECOND instance rather
 * than the fifth. This is that extraction, built for the Archive first.
 *
 * It is a PURE STRING BUILDER — no DOM, no state, no event wiring — so it can
 * be asserted headlessly and reused by any screen that owns its own container.
 *
 * Two rules the archetype encodes, because both are easy to get wrong once per
 * screen otherwise:
 *
 *   1. LOCKED SLOTS ARE SHOWN. A collection that hides what you have not found
 *      cannot tell you that anything is missing, and the shape of the set is
 *      most of what makes collecting one interesting.
 *   2. FOUND ENTRIES STAY READABLE. Everything is a <details>, so an entry can
 *      be re-opened forever with no JS state to lose. That is the whole reason
 *      the Archive exists rather than a toast: `docs/archive/BreachLayer.md`
 *      records that story previously had nowhere to live.
 *
 * @typedef {Object} CollectionEntry
 * @property {string}  id        - stable id, used for the DOM id
 * @property {boolean} owned     - found, or a locked slot
 * @property {string}  title     - shown on the card face when owned
 * @property {string} [subtitle] - small line under the title
 * @property {string} [icon]     - leading glyph
 * @property {string} [marker]   - short designation shown on locked slots too
 * @property {Array<{label?: string, text: string, quote?: boolean}>} [sections]
 *                               - the body, revealed on open
 *
 * @typedef {Object} CollectionGroup
 * @property {string}  id
 * @property {string}  label
 * @property {string} [icon]
 * @property {string} [accent]   - CSS colour for this group's rules and counts
 * @property {string} [blurb]    - one line under the group heading
 * @property {Array<CollectionEntry>} entries
 */ const $4e51f9a17617cbc0$var$escapeHtml = (s)=>String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const $4e51f9a17617cbc0$var$DEFAULT_ACCENT = '#9ca3af';
function $4e51f9a17617cbc0$var$entryHtml(entry, accent) {
    const marker = entry.marker ? $4e51f9a17617cbc0$var$escapeHtml(entry.marker) : '';
    if (!entry.owned) // A locked slot still carries its designation. Knowing that D3 exists and
    // is missing is the information a collection is FOR.
    return `
      <div class="collection-slot locked rounded-lg border border-dashed border-gray-700 bg-white/[0.02] p-3 text-center">
        <div class="text-xl leading-none opacity-40">\u{1F512}</div>
        ${marker ? `<div class="text-[11px] font-bold tracking-widest mt-1 text-gray-500">${marker}</div>` : ''}
        <div class="text-[11px] text-gray-600 mt-1">Not recovered</div>
      </div>`;
    const body = (entry.sections || []).map((section)=>{
        const label = section.label ? `<div class="uppercase tracking-widest text-[10px] font-bold mb-1" style="color:${accent}">${$4e51f9a17617cbc0$var$escapeHtml(section.label)}</div>` : '';
        const text = section.quote ? `<div class="text-sm italic leading-relaxed border-l-2 pl-3 py-1" style="border-color:${accent}; color:#d6cdf0;">${$4e51f9a17617cbc0$var$escapeHtml(section.text)}</div>` : `<div class="text-sm leading-relaxed text-gray-300">${$4e51f9a17617cbc0$var$escapeHtml(section.text)}</div>`;
        return `<div class="mb-3">${label}${text}</div>`;
    }).join('');
    return `
    <details id="collection-${$4e51f9a17617cbc0$var$escapeHtml(entry.id)}" class="collection-slot rounded-lg border bg-white/5 p-3 h-full" style="border-color:${accent}66;">
      <summary class="cursor-pointer list-none">
        <div class="flex items-baseline gap-2">
          ${entry.icon ? `<span class="text-lg leading-none">${entry.icon}</span>` : ''}
          <span class="font-bold text-white text-sm">${$4e51f9a17617cbc0$var$escapeHtml(entry.title)}</span>
          ${marker ? `<span class="text-[10px] font-bold tracking-widest ml-auto" style="color:${accent}">${marker}</span>` : ''}
        </div>
        ${entry.subtitle ? `<div class="text-[11px] text-gray-400 mt-1">${$4e51f9a17617cbc0$var$escapeHtml(entry.subtitle)}</div>` : ''}
      </summary>
      <div class="mt-3 pt-3 border-t border-gray-700">${body}</div>
    </details>`;
}
function $4e51f9a17617cbc0$var$groupHtml(group) {
    const accent = group.accent || $4e51f9a17617cbc0$var$DEFAULT_ACCENT;
    const found = group.entries.filter((e)=>e.owned).length;
    const total = group.entries.length;
    return `
    <section class="mb-6">
      <div class="flex items-baseline gap-2 border-b pb-1 mb-2" style="border-color:${accent}55;">
        <h3 class="font-bold" style="color:${accent}">${group.icon || ''} ${$4e51f9a17617cbc0$var$escapeHtml(group.label)}</h3>
        <span class="text-xs ml-auto" style="color:${accent}">${found}/${total}</span>
      </div>
      ${group.blurb ? `<p class="text-xs text-gray-400 mb-3">${$4e51f9a17617cbc0$var$escapeHtml(group.blurb)}</p>` : ''}
      <div class="grid gap-2 collection-grid">
        ${group.entries.map((e)=>$4e51f9a17617cbc0$var$entryHtml(e, accent)).join('')}
      </div>
    </section>`;
}
function $4e51f9a17617cbc0$export$e6fe4dbcc57eb54(spec) {
    const groups = spec?.groups || [];
    const populated = groups.filter((g)=>(g.entries || []).length > 0);
    if (!populated.length) return `<div class="text-center text-gray-400 py-8 border border-dashed border-gray-600 rounded-lg">
      ${$4e51f9a17617cbc0$var$escapeHtml(spec?.empty || 'Nothing collected yet.')}
    </div>`;
    return populated.map($4e51f9a17617cbc0$var$groupHtml).join('');
}



const $8377d004ff5d42b5$var$FACTION_ACCENTS = {
    dominion: '#7cc4ff',
    wilders: '#7bd88f',
    veil: '#b18cff'
};
function $8377d004ff5d42b5$var$keyEntry(key, owned) {
    return {
        id: key.id,
        owned: owned,
        marker: key.code,
        icon: "\uD83D\uDDDD\uFE0F",
        title: key.name,
        subtitle: `Tier ${key.tier} \xb7 ${key.recoveredFrom}`,
        sections: [
            {
                label: `Fragment \u{2014} ${key.source}`,
                text: key.fragment,
                quote: true
            },
            {
                label: 'Interpretation',
                text: key.interpretation
            }
        ]
    };
}
function $8377d004ff5d42b5$export$5dc9bc24597948d9() {
    const container = document.getElementById('archive-body');
    if (!container) return;
    const owned = (0, $85e2b1e6893337a2$export$933049ca86d1db4)();
    const progress = (0, $85e2b1e6893337a2$export$1bf1759a5184ddbd)();
    const totalOwned = Object.values(progress).reduce((n, p)=>n + p.owned, 0);
    const totalKeys = Object.values(progress).reduce((n, p)=>n + p.total, 0);
    const groups = Object.keys($ce6dd72bc4611534$export$aeeef991191508e2 || {}).map((factionKey)=>{
        const faction = $ce6dd72bc4611534$export$aeeef991191508e2[factionKey];
        return {
            id: factionKey,
            label: `${faction.name} \u{2014} Collapse Keys`,
            icon: faction.icon,
            accent: $8377d004ff5d42b5$var$FACTION_ACCENTS[factionKey] || '#9ca3af',
            blurb: faction.doctrine,
            entries: (0, $85e2b1e6893337a2$export$c9e2c9e9eddcd297)(factionKey).map((k)=>$8377d004ff5d42b5$var$keyEntry(k, owned.includes(k.id)))
        };
    });
    const summary = document.getElementById('archive-summary');
    if (summary) summary.textContent = totalOwned === 0 ? "Nothing recovered yet. Keys surface in the field \u2014 raid, and your faction will start filing them here." : `${totalOwned} of ${totalKeys} recovered. A key is filed to the account, not to a character: promotion and founding never take one back.`;
    container.innerHTML = (0, $4e51f9a17617cbc0$export$e6fe4dbcc57eb54)({
        groups: groups,
        empty: 'No Collapse Keys have been authored yet.'
    });
}


/**
 * Layer navigation toolbar - renders the header from the layer registry.
 *
 * The registry (layers-core.js) says WHAT each layer has; this module is the
 * only place that turns that into DOM. Adding a layer is an entry there, not
 * markup here. See docs/systemsRework/LayerNavigation.md.
 *
 * Two render paths on purpose:
 *
 *   renderLayerToolbar()   full structural rebuild - on boot, layer switch, and
 *                          unlock changes. Replaces DOM.
 *   refreshToolbarValues() patches text only - safe to call every second.
 *
 * The split matters: the energy popup is anchored to the ⚡ chip and closes on
 * an outside click, so rebuilding chips underneath it once a second would tear
 * it out from under the player mid-purchase. Values change constantly;
 * structure changes rarely.
 */ /**
 * Layer Registry - the data behind layer navigation.
 *
 * The unification this rests on: the base game is itself a layer. Characters
 * and Contractors are not tabs competing with Command; they are Field's
 * screens. That gives one rule the toolbar follows everywhere:
 *
 *   The toolbar shows exactly one layer's context at a time - never the union.
 *
 * Both the switcher and the toolbar render from this registry, so adding a
 * layer is an entry here rather than UI surgery. See
 * docs/systemsRework/LayerNavigation.md.
 *
 * WHY THIS IS A MODULE, NOT js/data/: files in js/data/ are concatenated
 * verbatim into the generated js/constants.js and therefore cannot import
 * anything. This registry has to read live state (unlock latches, currency
 * values, task status), so it needs imports. It stays free of DOM so the
 * simulator and tests can load it - see tests/game/coreModulesHeadless.test.js.
 *
 * NO DOM HERE. `activeTask()` reports WHAT the task is and which screen it
 * belongs to; the header binds HOW activating it switches screens. Keeping the
 * "how" out is what lets this be tested headlessly.
 */ 


/**
 * Operations Core — the L3 active layer (M3 S4).
 *
 * Where L1 plans a path through a room grid, L3 plans a ROUTE across the world
 * map: same mental model, planetary scale. Transit is real-time in hours, the
 * cargo is the designed material sink, and the destination matters because of
 * faction demand (S5).
 *
 * No browser dependencies — the simulator runs this too.
 *
 * Three invariants worth stating up front, because each is easy to break later:
 *
 *  1. OPERATIONS DRAW ENERGY. Decided 2026-07-27 and required to land in this
 *     slice, not after: energy is the single input to L4's signature system,
 *     and planet-scale convoys under live telemetry cannot emit nothing.
 *     Building it in now is a line of code; retrofitting after L3 calibrates is
 *     a re-calibration of the whole milestone.
 *
 *  2. AT MOST ONE ROUND PER SLOT SETTLES OFFLINE, AND NEVER CHAINS. An op
 *     completing while away is intended; automation starting the NEXT one is
 *     not. Enforced in the settlement path rather than trusted to the launcher,
 *     so the invariant holds however L4's auto-launcher is later written — a
 *     player away for a week returns to the same completed ops as one away
 *     overnight.
 *
 *  3. CHARTER LOCKS DO NOT GATE ROUTES. Region locks are gate allocation and
 *     licensing, not physical reachability. A region whose RAIDS are locked is
 *     still traversable and still a valid destination.
 *
 * See docs/layers/3-syndicate/design.md §5.
 */ 


/**
 * Faction Demand Economy — L3 Operations pricing (M3 S5).
 *
 * This is what makes the DESTINATION matter. Without it every region pays the
 * same and the map is scenery: a convoy's route was already priced by terrain,
 * but where it ended up was a free variable.
 *
 * The one idea: a region pays a premium for the material signatures its own
 * faction mix does not produce. Verdant Reclamation is 92% wilders, so wilders
 * goods are the thing it already has — dominion and veil cargo is what it wants.
 *
 * AND A MARKET THAT IS FED STOPS BEING HUNGRY. The mix above is static, so on
 * its own it is a table the player solves once: pick the signature, read off the
 * region that pays ×2.00, and run that pairing forever. Every route costs the
 * same time, cargo and energy, so a fixed premium made destination a lookup
 * rather than a decision. Saturation is what turns it back into one — delivering
 * into a region consumes its appetite for that faction's goods, and the appetite
 * refills on a clock. The best destination is still the best destination; it
 * just stops being the best destination once you have used it.
 *
 * DERIVED, NOT AUTHORED. There is no hand-written economy table here, because a
 * hand-written one drifts: add a room to a region, and an authored demand table
 * silently keeps pricing the old geography. The mix is computed from the same
 * thing that decides what actually DROPS in a region — the faction of each
 * gate/hazard room's primary skill — so demand and supply cannot disagree.
 * This reproduces §1 of tools/loot-equilibrium.mjs exactly; that tool is the
 * offline analysis of the same numbers.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/layers/3-syndicate/design.md §6.
 */ 


/**
 * Room draw rates per raid, mirroring the income model in loot-equilibrium.mjs.
 *
 * Hazards outnumber gates 2:1 in a typical path, so a region's character is set
 * more by its hazards than its gates. Weighting them equally would misread every
 * region whose gates and hazards pull toward different factions.
 */ const $356ad444ead618fc$var$GATES_PER_RAID = 2;
const $356ad444ead618fc$var$HAZARDS_PER_RAID = 4;
const $356ad444ead618fc$export$2119d59df637b878 = 1.0;
const $356ad444ead618fc$export$3dbc410517215979 = 2.0;
const $356ad444ead618fc$export$dd23e574c7d7ff20 = 1.5;
// Region mixes are a pure function of static config; compute once.
let $356ad444ead618fc$var$mixCache = null;
/**
 * What share of a region's loot-bearing rooms belongs to each faction.
 *
 * @returns {Object<string, Object<string, number>>} regionId -> faction -> share
 */ function $356ad444ead618fc$var$allRegionMixes() {
    if ($356ad444ead618fc$var$mixCache) return $356ad444ead618fc$var$mixCache;
    $356ad444ead618fc$var$mixCache = {};
    for (const [regionId, region] of Object.entries($ce6dd72bc4611534$export$4fbdcec70fce9d73 || {})){
        const share = {};
        for (const faction of Object.keys($ce6dd72bc4611534$export$aeeef991191508e2 || {}))share[faction] = 0;
        let total = 0;
        for (const [rooms, perRaid] of [
            [
                region.gates || [],
                $356ad444ead618fc$var$GATES_PER_RAID
            ],
            [
                region.hazards || [],
                $356ad444ead618fc$var$HAZARDS_PER_RAID
            ]
        ]){
            if (!rooms.length) continue;
            // Rooms are drawn uniformly from the region's pool, so a region with
            // few gates weights each of them more heavily.
            const weight = perRaid / rooms.length;
            for (const room of rooms){
                const faction = (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(room.primary);
                if (faction && faction in share) share[faction] += weight;
                total += weight;
            }
        }
        if (total > 0) for (const faction of Object.keys(share))share[faction] /= total;
        $356ad444ead618fc$var$mixCache[regionId] = share;
    }
    return $356ad444ead618fc$var$mixCache;
}
function $356ad444ead618fc$export$5d226cc5df4caa71(regionId) {
    const mix = $356ad444ead618fc$var$allRegionMixes()[regionId];
    if (mix) return {
        ...mix
    };
    return Object.fromEntries(Object.keys($ce6dd72bc4611534$export$aeeef991191508e2 || {}).map((f)=>[
            f,
            0
        ]));
}
function $356ad444ead618fc$export$37444e2aca3975f8(regionId, faction) {
    if (!faction) return $356ad444ead618fc$export$2119d59df637b878;
    const mix = $356ad444ead618fc$export$5d226cc5df4caa71(regionId);
    const peak = Math.max(0, ...Object.values(mix));
    if (peak <= 0) return $356ad444ead618fc$export$2119d59df637b878;
    const relative = Math.min(1, (mix[faction] || 0) / peak);
    return +($356ad444ead618fc$export$3dbc410517215979 - relative * ($356ad444ead618fc$export$3dbc410517215979 - $356ad444ead618fc$export$2119d59df637b878)).toFixed(2);
}
const $356ad444ead618fc$export$84b9749393a572a5 = 3200;
const $356ad444ead618fc$export$11ee3e0b19f61859 = 72;
const $356ad444ead618fc$var$RECOVERY_MS = $356ad444ead618fc$export$11ee3e0b19f61859 * 3600000;
const $356ad444ead618fc$var$clamp01 = (n)=>Math.min(1, Math.max(0, n));
const $356ad444ead618fc$var$satiationKey = (regionId, faction)=>`${regionId}:${faction}`;
/**
 * The saturation ledger, keyed by (region, faction).
 *
 * That granularity is the multiplier's own: the price is per-faction, so a
 * finer per-SIGNATURE ledger would be fake precision the player could game by
 * rotating the five signatures of one faction through the same fat region,
 * while a coarser per-REGION one would suppress a region's dominion price
 * because you sold it veil goods. Fifteen cells, one per price the game quotes.
 *
 * Lives on `syndicate` because it is world state that outlives an era — see the
 * founding note on `satiationLevel`. Returns null before the branch exists,
 * which is simply "nothing has ever been delivered".
 */ function $356ad444ead618fc$var$satiationStore() {
    const syndicate = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate;
    if (!syndicate) return null;
    if (!syndicate.demand) syndicate.demand = {};
    return syndicate.demand;
}
function $356ad444ead618fc$export$f9e4fa3cb5360b25(regionId, faction, now = Date.now()) {
    const cell = $356ad444ead618fc$var$satiationStore()?.[$356ad444ead618fc$var$satiationKey(regionId, faction)];
    if (!cell) return 0;
    const elapsed = Math.max(0, now - (cell.at || 0));
    return $356ad444ead618fc$var$clamp01((cell.level || 0) - elapsed / $356ad444ead618fc$var$RECOVERY_MS);
}
function $356ad444ead618fc$export$5839d85e36227b6a(regionId, faction, now = Date.now()) {
    return Math.round($356ad444ead618fc$export$f9e4fa3cb5360b25(regionId, faction, now) * $356ad444ead618fc$var$RECOVERY_MS);
}
function $356ad444ead618fc$export$bd4b24a19973285f(regionId, skillId, units, now = Date.now()) {
    const faction = (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(skillId);
    const store = $356ad444ead618fc$var$satiationStore();
    if (!faction || !store || !(units > 0)) return 0;
    const level = $356ad444ead618fc$var$clamp01($356ad444ead618fc$export$f9e4fa3cb5360b25(regionId, faction, now) + units / $356ad444ead618fc$export$84b9749393a572a5);
    store[$356ad444ead618fc$var$satiationKey(regionId, faction)] = {
        level: level,
        at: now
    };
    return level;
}
function $356ad444ead618fc$export$b9d88bbf27398a14(regionId, faction, now = Date.now()) {
    const base = $356ad444ead618fc$export$37444e2aca3975f8(regionId, faction);
    const level = $356ad444ead618fc$export$f9e4fa3cb5360b25(regionId, faction, now);
    if (level <= 0) return base;
    return +($356ad444ead618fc$export$2119d59df637b878 + (base - $356ad444ead618fc$export$2119d59df637b878) * (1 - level)).toFixed(2);
}
function $356ad444ead618fc$export$6bba5a60cd02466f(regionId, skillId, now = Date.now()) {
    return $356ad444ead618fc$export$b9d88bbf27398a14(regionId, (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(skillId), now);
}
function $356ad444ead618fc$export$345f4d5270758759(regionId, now = Date.now()) {
    const mix = $356ad444ead618fc$export$5d226cc5df4caa71(regionId);
    return Object.keys(mix).map((faction)=>({
            faction: faction,
            name: $ce6dd72bc4611534$export$aeeef991191508e2?.[faction]?.name || faction,
            share: mix[faction],
            multiplier: $356ad444ead618fc$export$b9d88bbf27398a14(regionId, faction, now),
            base: $356ad444ead618fc$export$37444e2aca3975f8(regionId, faction),
            saturation: $356ad444ead618fc$export$f9e4fa3cb5360b25(regionId, faction, now),
            recoveryMs: $356ad444ead618fc$export$5839d85e36227b6a(regionId, faction, now)
        })).sort((a, b)=>b.multiplier - a.multiplier);
}
function $356ad444ead618fc$export$d48946d0a3e2934b(multiplier) {
    return (multiplier || 0) >= $356ad444ead618fc$export$dd23e574c7d7ff20;
}



/**
 * Material credit values — DERIVED FROM RECIPES, NOT AUTHORED (M3 S13).
 *
 * What a unit of material is worth, in credits, so that systems which need to
 * compare a common against a rare have one honest answer instead of each
 * inventing its own.
 *
 * THE WHOLE POINT IS THAT NOBODY WRITES THESE NUMBERS DOWN. A hand-authored
 * rarity price table drifts the moment a recipe changes: retune what an
 * uncommon costs to craft and the table keeps quoting the old economy, silently,
 * forever. The same argument demand-core makes for region mixes (§6, "DERIVED,
 * NOT AUTHORED") applies here with more force, because this one prices a sink.
 *
 * The derivation is the game's own crafting ladder:
 *
 *     value(rarity) = craftingCost(rarity) + Σ value(each input)
 *
 * with the base of the recursion being a rarity nothing crafts — commons drop,
 * they are not made, so a common is worth exactly what the ladder charges to
 * work with it. Everything above is that plus what it consumed.
 *
 * Against the shipped data that resolves to:
 *
 *     common    5      (craftingCost, the unit of account)
 *     uncommon  30     = 3 commons + 15
 *     rare      115    = 3 commons + 1 uncommon + 70
 *
 * — a 1 : 6 : 23 ladder. Worth knowing WHY that is exact rather than an average:
 * all 18 uncommon recipes take exactly 3 commons and all 12 rare recipes take
 * exactly 3 commons and 1 uncommon. Thirty recipes, two shapes. If that ever
 * stops being true this file keeps working — it walks the actual recipes — but
 * the per-rarity summary above stops being a fair description of it.
 *
 * No browser dependencies — the simulator runs this too.
 */ 

const $958d9357360f8a8b$export$a00161bf038b88d1 = 8;
/** Every recipe in the game, whatever tier it crafts. */ function $958d9357360f8a8b$var$allRecipes() {
    return [
        ...$ce6dd72bc4611534$exports.recipesUncommon || [],
        ...$ce6dd72bc4611534$exports.recipesRare || [],
        ...$ce6dd72bc4611534$exports.recipesEpic || [],
        ...$ce6dd72bc4611534$exports.recipesArtifact || []
    ];
}
// Pure function of static config, and walked recursively — compute once.
let $958d9357360f8a8b$var$valueCache = null;
/**
 * Credit value per unit, keyed by material id.
 *
 * Built by walking each recipe from its target back through its inputs.
 * Memoised per id with an in-progress guard, so a cyclic recipe graph (which
 * would otherwise recurse forever) resolves to the bare crafting cost rather
 * than hanging the game.
 */ function $958d9357360f8a8b$var$allValues() {
    if ($958d9357360f8a8b$var$valueCache) return $958d9357360f8a8b$var$valueCache;
    const recipeFor = new Map();
    for (const recipe of $958d9357360f8a8b$var$allRecipes())if (recipe?.target && !recipeFor.has(recipe.target)) recipeFor.set(recipe.target, recipe);
    const values = new Map();
    const resolving = new Set();
    const costOf = (rarity)=>$ce6dd72bc4611534$exports.itemRarities?.[rarity]?.craftingCost || 0;
    const valueOf = (itemId)=>{
        if (values.has(itemId)) return values.get(itemId);
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
        const base = costOf(item?.rarity);
        // Guard BEFORE recursing. A recipe graph is a tree today; a cycle
        // introduced later should degrade to "worth its crafting cost" rather than
        // blow the stack on load.
        if (resolving.has(itemId)) return base;
        const recipe = recipeFor.get(itemId);
        if (!recipe) {
            values.set(itemId, base); // a drop, not a craft — the base of the ladder
            return base;
        }
        resolving.add(itemId);
        let total = base;
        for (const input of recipe.inputs || [])total += valueOf(input.id) * (input.qty || 0);
        resolving.delete(itemId);
        values.set(itemId, total);
        return total;
    };
    for (const pool of [
        'itemsCommon',
        'itemsUncommon',
        'itemsRare'
    ])for (const item of $ce6dd72bc4611534$exports[pool] || [])valueOf(item.id);
    for (const recipe of $958d9357360f8a8b$var$allRecipes())if (recipe?.target) valueOf(recipe.target);
    $958d9357360f8a8b$var$valueCache = values;
    return $958d9357360f8a8b$var$valueCache;
}
function $958d9357360f8a8b$export$fec63043638a29c9(itemId) {
    if (!itemId) return 0;
    // Scaled at the PUBLIC boundary, not inside the recursion — `allValues()`
    // walks recipes and would compound the factor once per tier if it were
    // applied there, making a rare 8x too dear relative to a common and breaking
    // the very ratios the ladder exists to give.
    const cached = $958d9357360f8a8b$var$allValues().get(itemId);
    if (cached != null) return cached * $958d9357360f8a8b$export$a00161bf038b88d1;
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    return ($ce6dd72bc4611534$exports.itemRarities?.[item?.rarity]?.craftingCost || 0) * $958d9357360f8a8b$export$a00161bf038b88d1;
}
function $958d9357360f8a8b$export$f92dab4a7d67d380(manifest) {
    let total = 0;
    for (const [itemId, qty] of Object.entries(manifest || {}))total += $958d9357360f8a8b$export$fec63043638a29c9(itemId) * (qty || 0);
    return total;
}
function $958d9357360f8a8b$export$24d7f05899f6f0f2() {
    const out = {};
    for (const [pool, rarity] of [
        [
            'itemsCommon',
            'common'
        ],
        [
            'itemsUncommon',
            'uncommon'
        ],
        [
            'itemsRare',
            'rare'
        ]
    ]){
        const first = ($ce6dd72bc4611534$exports[pool] || [])[0];
        if (first) out[rarity] = $958d9357360f8a8b$export$fec63043638a29c9(first.id);
    }
    return out;
}
function $958d9357360f8a8b$export$b6b29545c91ff407() {
    $958d9357360f8a8b$var$valueCache = null;
}



const $cb0ad7004fe6b26a$var$HOUR_MS = 3600000;
const $cb0ad7004fe6b26a$export$36ac5ebae0245093 = {
    'short-haul': {
        name: 'Short Haul',
        icon: "\uD83D\uDEFB",
        legendsRequired: 0,
        cargoValue: 800,
        energy: 10,
        credits: 1800,
        creditsPerHour: 450,
        writEligible: false
    },
    'long-haul': {
        name: 'Long Haul',
        icon: "\uD83D\uDE9A",
        legendsRequired: 3,
        cargoValue: 2720,
        energy: 25,
        credits: 2800,
        creditsPerHour: 700,
        writEligible: false
    },
    'grand-circuit': {
        name: 'Grand Circuit',
        icon: "\uD83D\uDE9B",
        legendsRequired: 6,
        cargoValue: 5960,
        energy: 45,
        credits: 4000,
        creditsPerHour: 1000,
        writEligible: true
    }
};
const $cb0ad7004fe6b26a$export$9c559bdbc416d871 = {
    common: 0.5,
    uncommon: 0.3,
    rare: 0.2
};
const $cb0ad7004fe6b26a$export$27e3703df3a11e61 = 0.001;
const $cb0ad7004fe6b26a$export$2a1adeeaefb6ac28 = 0.11;
function $cb0ad7004fe6b26a$export$8fe62d261aacdb61() {
    const map = $ce6dd72bc4611534$export$e3c642cf362e5b0d;
    return {
        width: map.width,
        height: map.height,
        tiles: map.terrainRows.map((row)=>row.split('')),
        regions: map.regionRows.map((row)=>row.split('').map((d)=>map.regionOrder[d] || null))
    };
}
function $cb0ad7004fe6b26a$export$a4fafcaec3d77925(char) {
    const cost = $ce6dd72bc4611534$export$e3c642cf362e5b0d.terrainCost[char];
    return cost === undefined ? null : cost;
}
function $cb0ad7004fe6b26a$export$8660d3afb66129a5(row, col) {
    const digit = $ce6dd72bc4611534$export$e3c642cf362e5b0d.regionRows[row]?.[col];
    return $ce6dd72bc4611534$export$e3c642cf362e5b0d.regionOrder[digit] || null;
}
function $cb0ad7004fe6b26a$export$9caf4fdf37b2a28(regionId) {
    const capital = $ce6dd72bc4611534$export$e3c642cf362e5b0d.capitals[regionId];
    return capital ? {
        ...capital
    } : null;
}
function $cb0ad7004fe6b26a$export$4a444fae199f4849() {
    return Object.values($ce6dd72bc4611534$export$e3c642cf362e5b0d.regionOrder);
}
const $cb0ad7004fe6b26a$export$dff7303faedba2f = 0.5;
/** A region id or a literal tile, normalised to a tile. */ function $cb0ad7004fe6b26a$var$asTile(x) {
    if (!x) return null;
    return typeof x === 'string' ? $cb0ad7004fe6b26a$export$9caf4fdf37b2a28(x) : {
        row: x.row,
        col: x.col
    };
}
function $cb0ad7004fe6b26a$export$c8a5c29d2838f4de(waypoints) {
    if (!waypoints || waypoints.length < 2) return null;
    const tiles = [];
    let cost = 0;
    for(let i = 0; i < waypoints.length - 1; i++){
        const leg = $cb0ad7004fe6b26a$export$4fa936acba669006(waypoints[i], waypoints[i + 1]);
        if (!leg) return null;
        cost += leg.cost;
        tiles.push(...i === 0 ? leg.tiles : leg.tiles.slice(1));
    }
    return {
        tiles: tiles,
        cost: cost
    };
}
function $cb0ad7004fe6b26a$export$f41c2be0717214ee(toRegionId) {
    const to = $cb0ad7004fe6b26a$var$asTile(toRegionId);
    if (!to) return [];
    return $cb0ad7004fe6b26a$export$4a444fae199f4849()// A convoy has to actually go somewhere. Staging in the destination itself
    // is a zero-hour route, which is not a cheap operation — it is not one.
    .filter((fromRegionId)=>fromRegionId !== toRegionId).map((fromRegionId)=>{
        const from = $cb0ad7004fe6b26a$var$asTile(fromRegionId);
        const route = $cb0ad7004fe6b26a$export$4fa936acba669006(from, to);
        if (!route) return null;
        return {
            fromRegionId: fromRegionId,
            from: from,
            toRegionId: toRegionId,
            to: to,
            // Two waypoints is the whole route now. Kept as a waypoint LIST rather
            // than a pair because that is the shape already persisted on every
            // in-flight operation, and `routeFromWaypoints` rebuilds either.
            waypoints: [
                from,
                to
            ],
            tiles: route.tiles,
            cost: route.cost,
            hours: $cb0ad7004fe6b26a$export$56ee0a61fc2e748(from, to)
        };
    }).filter(Boolean);
}
function $cb0ad7004fe6b26a$export$4fa936acba669006(from, to) {
    // Accepts a region id OR a literal tile at either end: destinations are
    // always region capitals, but origins are now arbitrary tiles chosen by
    // reach rather than a fixed set of five.
    const start = $cb0ad7004fe6b26a$var$asTile(from);
    const end = $cb0ad7004fe6b26a$var$asTile(to);
    if (!start || !end) return null;
    if (start.row === end.row && start.col === end.col) return {
        tiles: [
            start
        ],
        cost: 0
    };
    const { width: width, height: height, tiles: tiles } = $cb0ad7004fe6b26a$export$8fe62d261aacdb61();
    const key = (r, c)=>`${r},${c}`;
    const dist = new Map([
        [
            key(start.row, start.col),
            0
        ]
    ]);
    const prev = new Map();
    const queue = [
        [
            0,
            start
        ]
    ];
    while(queue.length){
        queue.sort((a, b)=>a[0] - b[0]);
        const [d, cur] = queue.shift();
        if (cur.row === end.row && cur.col === end.col) break;
        if (d > (dist.get(key(cur.row, cur.col)) ?? Infinity)) continue;
        for (const [dr, dc] of [
            [
                0,
                1
            ],
            [
                1,
                0
            ],
            [
                0,
                -1
            ],
            [
                -1,
                0
            ]
        ]){
            const nr = cur.row + dr, nc = cur.col + dc;
            if (nr < 0 || nc < 0 || nr >= height || nc >= width) continue;
            const cost = $cb0ad7004fe6b26a$export$a4fafcaec3d77925(tiles[nr][nc]);
            if (cost == null) continue; // impassable
            const nd = d + cost;
            if (nd < (dist.get(key(nr, nc)) ?? Infinity)) {
                dist.set(key(nr, nc), nd);
                prev.set(key(nr, nc), cur);
                queue.push([
                    nd,
                    {
                        row: nr,
                        col: nc
                    }
                ]);
            }
        }
    }
    const endKey = key(end.row, end.col);
    if (!dist.has(endKey)) return null;
    const route = [];
    let cur = end;
    while(cur){
        route.unshift(cur);
        cur = prev.get(key(cur.row, cur.col));
    }
    return {
        tiles: route,
        cost: dist.get(endKey)
    };
}
function $cb0ad7004fe6b26a$export$f23f7f2631f7375a(route, pct) {
    const tiles = route?.tiles || [];
    if (!tiles.length) return {
        fills: [],
        index: 0
    };
    const { tiles: terrain } = $cb0ad7004fe6b26a$export$8fe62d261aacdb61();
    // Cost of ENTERING each tile — matches how findRoute accumulates, so the
    // shares add up to exactly the cost that priced the duration.
    const costs = tiles.map((t, i)=>i === 0 ? 0 : $cb0ad7004fe6b26a$export$a4fafcaec3d77925(terrain[t.row][t.col]) ?? 1);
    const total = costs.reduce((a, b)=>a + b, 0);
    if (total <= 0) return {
        fills: tiles.map(()=>1),
        index: tiles.length - 1
    };
    const clamped = Math.min(1, Math.max(0, pct));
    const spent = clamped * total;
    let running = 0;
    let index = 0;
    const fills = tiles.map((_, i)=>{
        const cost = costs[i];
        // Departure tile: crossed as soon as the convoy is moving at all.
        if (cost === 0) return clamped > 0 ? 1 : 0;
        const fill = Math.min(1, Math.max(0, (spent - running) / cost));
        running += cost;
        if (fill > 0) index = i;
        return fill;
    });
    return {
        fills: fills,
        index: index
    };
}
function $cb0ad7004fe6b26a$export$56ee0a61fc2e748(from, to) {
    const route = $cb0ad7004fe6b26a$export$4fa936acba669006(from, to);
    if (!route) return null;
    return Math.max($cb0ad7004fe6b26a$export$dff7303faedba2f, route.cost * $cb0ad7004fe6b26a$export$dff7303faedba2f);
}
function $cb0ad7004fe6b26a$export$34097b07af09d661() {
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const busy = new Set((syndicate.operations || []).map((op)=>op.leadName));
    const leads = [];
    if (syndicate.leader) leads.push({
        name: syndicate.leader.name,
        marksEarned: syndicate.leader.marksEarned || 0,
        isLeader: true
    });
    for (const legend of (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends || [])leads.push({
        name: legend.name,
        marksEarned: legend.marksEarned || 0,
        isLeader: false
    });
    return leads.filter((l)=>!busy.has(l.name));
}
function $cb0ad7004fe6b26a$export$c87f3aa20ea43c6e() {
    const licensed = (0, $46d374413fb0707a$export$d9ea4b2d96397ab9)('operations-charter', 0);
    if (!licensed) return 0;
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const bodies = (syndicate.leader ? 1 : 0) + ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0);
    // Lights Out adds a licensed slot. Applied to the LICENCE, not the min: the
    // extra slot is paperwork, and it still needs a body to lead it — otherwise
    // clearing the contract would conjure a convoy with nobody in charge.
    const slots = licensed + (0, $45c49e7f6d2032d6$export$84f52d60145287)('operation-slots', 0);
    return Math.min(slots, bodies);
}
function $cb0ad7004fe6b26a$export$71db14eff0d59723() {
    return ((0, $46d374413fb0707a$export$cdfa564b532bb699)().operations || []).length;
}
function $cb0ad7004fe6b26a$export$21c1c9fc1bed7f77() {
    return (0, $46d374413fb0707a$export$cdfa564b532bb699)().stores || {};
}
function $cb0ad7004fe6b26a$export$812feee522dc8b7() {
    return (0, $46d374413fb0707a$export$cdfa564b532bb699)().consignment || {};
}
function $cb0ad7004fe6b26a$export$7284881aebf5498e(skillId) {
    const byRarity = {
        common: [],
        uncommon: [],
        rare: []
    };
    const owned = $ce6dd72bc4611534$export$2aa6464abbbb5bfc?.skills?.[skillId];
    if (!owned) return byRarity;
    for (const ids of Object.values(owned))for (const id of ids || []){
        const rarity = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id)?.rarity;
        const bucket = byRarity[rarity];
        // `core` overlaps `commons` in the source matrix, so dedupe: a doubled id
        // would be offered twice and drain the same pile twice as fast.
        if (bucket && !bucket.includes(id)) bucket.push(id);
    }
    return byRarity;
}
function $cb0ad7004fe6b26a$export$94a2b01ae45f0aa0(skillId, inventory = $cb0ad7004fe6b26a$export$21c1c9fc1bed7f77()) {
    let units = 0;
    let value = 0;
    for (const ids of Object.values($cb0ad7004fe6b26a$export$7284881aebf5498e(skillId)))for (const id of ids){
        const qty = inventory[id] || 0;
        units += qty;
        value += (0, $958d9357360f8a8b$export$fec63043638a29c9)(id) * qty;
    }
    return {
        units: units,
        value: value
    };
}
function $cb0ad7004fe6b26a$export$804dfc1c9f8f293a(templateId) {
    const template = $cb0ad7004fe6b26a$export$36ac5ebae0245093[templateId];
    if (!template) return 0;
    return Math.max(1, Math.ceil(template.energy));
}
function $cb0ad7004fe6b26a$export$a666674acd11f81d(templateId, skillId, inventory = $cb0ad7004fe6b26a$export$21c1c9fc1bed7f77()) {
    const template = $cb0ad7004fe6b26a$export$36ac5ebae0245093[templateId];
    if (!template) return {
        manifest: {},
        value: 0,
        budget: 0,
        short: {
            value: 0
        }
    };
    const discount = (0, $46d374413fb0707a$export$d9ea4b2d96397ab9)('provision-contracts', 0);
    const budget = Math.max(0, Math.round(template.cargoValue * (1 - discount)));
    const byRarity = $cb0ad7004fe6b26a$export$7284881aebf5498e(skillId);
    const manifest = {};
    let loaded = 0;
    // Piles for a set of ids, biggest first, with whatever is already on the
    // manifest deducted so the two passes cannot spend the same unit twice.
    const pilesFor = (ids)=>ids.map((id)=>({
                id: id,
                qty: (inventory[id] || 0) - (manifest[id] || 0),
                value: (0, $958d9357360f8a8b$export$fec63043638a29c9)(id)
            })).filter((p)=>p.qty > 0 && p.value > 0).sort((a, b)=>b.qty - a.qty);
    const everything = [
        ...byRarity.common,
        ...byRarity.uncommon,
        ...byRarity.rare
    ];
    const fill = (ids, target)=>{
        for (const pile of pilesFor(ids))while(pile.qty > 0 && loaded + pile.value <= target){
            manifest[pile.id] = (manifest[pile.id] || 0) + 1;
            pile.qty -= 1;
            loaded += pile.value;
        }
    };
    // Pass 1: the preferred mix. Targets are cumulative because `loaded` is a
    // running total — each rarity is asked to bring the manifest up to its share
    // of the budget, not to contribute a share in isolation.
    let cumulative = 0;
    for (const [rarity, share] of Object.entries($cb0ad7004fe6b26a$export$9c559bdbc416d871)){
        cumulative += budget * share;
        fill(byRarity[rarity] || [], cumulative);
    }
    // Pass 2: spill. Everything the signature owns, regardless of rarity.
    fill(everything, budget);
    const remaining = pilesFor(everything);
    // Nothing fitted at all — take the cheapest thing there is and eat the
    // overshoot, so a dock of nothing but rares still ships.
    if (!loaded && remaining.length) {
        const cheapest = remaining.reduce((a, b)=>b.value < a.value ? b : a);
        manifest[cheapest.id] = (manifest[cheapest.id] || 0) + 1;
        loaded += cheapest.value;
    }
    // Short only when the dock genuinely ran dry. Stock left over means the
    // convoy declined to overpay, which is a full manifest, not a failed one.
    const short = remaining.length ? 0 : Math.max(0, budget - loaded);
    return {
        manifest: manifest,
        value: loaded,
        budget: budget,
        short: {
            value: short
        }
    };
}
function $cb0ad7004fe6b26a$export$4f87675e88a56589({ templateId: templateId, fromRegionId: fromRegionId, toRegionId: toRegionId, skillId: skillId, leadName: leadName }) {
    const template = $cb0ad7004fe6b26a$export$36ac5ebae0245093[templateId];
    if (!template) return {
        ok: false,
        reason: 'unknown-template'
    };
    if ((0, $46d374413fb0707a$export$6955e231f1466c44)('operations-charter') <= 0) return {
        ok: false,
        reason: 'no-charter'
    };
    if ($cb0ad7004fe6b26a$export$71db14eff0d59723() >= $cb0ad7004fe6b26a$export$c87f3aa20ea43c6e()) return {
        ok: false,
        reason: 'no-free-slot'
    };
    const eraLegends = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0;
    if (eraLegends < template.legendsRequired) return {
        ok: false,
        reason: 'insufficient-legends',
        have: eraLegends,
        need: template.legendsRequired
    };
    const lead = $cb0ad7004fe6b26a$export$34097b07af09d661().find((l)=>l.name === leadName);
    if (!lead) return {
        ok: false,
        reason: 'lead-unavailable'
    };
    // A convoy has to travel. Staging in the destination is a zero-hour route
    // that would take cargo and energy and pay nothing back — refused as a route
    // problem rather than left to price itself at zero.
    const route = $cb0ad7004fe6b26a$export$4fa936acba669006(fromRegionId, toRegionId);
    if (!route || route.cost <= 0) return {
        ok: false,
        reason: 'no-route'
    };
    const { short: short } = $cb0ad7004fe6b26a$export$a666674acd11f81d(templateId, skillId);
    if (short.value > 0) return {
        ok: false,
        reason: 'insufficient-cargo',
        short: short
    };
    const energy = $cb0ad7004fe6b26a$export$804dfc1c9f8f293a(templateId);
    if (((0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.energy || 0) < energy) return {
        ok: false,
        reason: 'insufficient-energy',
        need: energy
    };
    return {
        ok: true
    };
}
function $cb0ad7004fe6b26a$export$9cb89297e30fe792({ templateId: templateId, fromRegionId: fromRegionId, toRegionId: toRegionId, skillId: skillId, leadName: leadName, originRegionId: originRegionId = null, now: now = Date.now() }) {
    const eligible = $cb0ad7004fe6b26a$export$4f87675e88a56589({
        templateId: templateId,
        fromRegionId: fromRegionId,
        toRegionId: toRegionId,
        skillId: skillId,
        leadName: leadName
    });
    if (!eligible.ok) return {
        success: false,
        ...eligible
    };
    // The route is the price of the journey and the clock it runs on, so it is
    // read once, here, from the two endpoints the player named. No `waypoints`
    // argument any more: a caller cannot hand in a path that disagrees with its
    // own endpoints, because there is only one route between them.
    const hours = $cb0ad7004fe6b26a$export$56ee0a61fc2e748(fromRegionId, toRegionId);
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const { manifest: manifest } = $cb0ad7004fe6b26a$export$a666674acd11f81d(templateId, skillId);
    const lead = $cb0ad7004fe6b26a$export$34097b07af09d661().find((l)=>l.name === leadName);
    // Deducted from the Guild Vault's dock, not from any character. Cargo is spent
    // at launch and does not come back — that is the whole point of the sink.
    const stores = syndicate.stores || (syndicate.stores = {});
    for (const [itemId, qty] of Object.entries(manifest)){
        stores[itemId] = Math.max(0, (stores[itemId] || 0) - qty);
        if (stores[itemId] === 0) delete stores[itemId]; // keep the dock readable
    }
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy = Math.max(0, ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy || 0) - $cb0ad7004fe6b26a$export$804dfc1c9f8f293a(templateId));
    const from = $cb0ad7004fe6b26a$var$asTile(fromRegionId);
    const operation = {
        id: `op_${now}_${syndicate.opsCompleted}_${syndicate.operations.length}`,
        templateId: templateId,
        from: // The literal staging tile, plus the region that owns it. The tile draws
        // the route; the region is what demand pricing (S5) and the UI read.
        from,
        // Origin first, destination last — two capitals, and the tile path between
        // them is derived by `routeFromWaypoints`. Still a LIST rather than a pair
        // because that is the shape already on disk for in-flight convoys, and a
        // two-element list rebuilds through exactly the same code a longer one did.
        waypoints: [
            from,
            $cb0ad7004fe6b26a$var$asTile(toRegionId)
        ],
        fromRegionId: originRegionId || (typeof fromRegionId === 'string' ? fromRegionId : $cb0ad7004fe6b26a$export$8660d3afb66129a5(fromRegionId.row, fromRegionId.col)),
        toRegionId: toRegionId,
        skillId: skillId,
        cargo: manifest,
        leadName: leadName,
        leadMarks: lead?.marksEarned || 0,
        startedAt: now,
        // The demand premium agreed at launch, for the same reason `hours` is
        // recorded: a region's mix is derived from its room pools, so adding a
        // single hazard to a region would silently re-price convoys already in
        // transit. What the player launched is what they get.
        // Priced at `now`, not at the wall clock: saturation decays against the
        // caller's clock, and the simulator's is virtual. Defaulting here would
        // have quoted every simulated convoy against real elapsed time.
        demand: (0, $356ad444ead618fc$export$6bba5a60cd02466f)(toRegionId, skillId, now),
        hours: // The PLANNED duration, recorded at launch and used for the payout.
        // Deriving yield from `completesAt - startedAt` instead would make it a
        // function of two mutable timestamps: anything that touches either (a clock
        // change, a future server reconciliation, a save edit) silently re-prices a
        // convoy that was already agreed. What the player launched is what they get.
        hours,
        completesAt: now + Math.round(hours * $cb0ad7004fe6b26a$var$HOUR_MS)
    };
    syndicate.operations.push(operation);
    // Feed the destination's market — AFTER `operation.demand` is fixed above, so
    // a convoy is never priced against its own delivery.
    //
    // At launch rather than at settlement, which is the same rule the cargo and
    // energy already follow. Settling instead would leave a window exactly one
    // slot-count wide: three convoys fired at the same hungry region would all
    // collect the undiminished premium, because none of them had landed yet.
    //
    // Measured in the manifest's CREDIT VALUE, not its unit count. Now that a
    // manifest can be any mix of rarities, a unit is not a unit: a rare is 23
    // commons of goods on the derived ladder, and counting them alike would let a
    // rare-heavy convoy satiate a market as little as a handful of scrap. Value
    // is what the market actually absorbed.
    (0, $356ad444ead618fc$export$bd4b24a19973285f)(toRegionId, skillId, (0, $958d9357360f8a8b$export$f92dab4a7d67d380)(manifest), now);
    return {
        success: true,
        operation: operation,
        hours: hours
    };
}
function $cb0ad7004fe6b26a$export$a4ac0527bd343e81(operation) {
    const template = $cb0ad7004fe6b26a$export$36ac5ebae0245093[operation.templateId];
    if (!template) return {
        credits: 0,
        writs: 0,
        leadBonus: 0,
        demand: (0, $356ad444ead618fc$export$2119d59df637b878)
    };
    // Prefer the duration and premium agreed at launch; recompute only for
    // operations written before those fields were recorded.
    const hours = operation.hours ?? (operation.completesAt - operation.startedAt) / $cb0ad7004fe6b26a$var$HOUR_MS;
    const demand = operation.demand ?? (0, $356ad444ead618fc$export$6bba5a60cd02466f)(operation.toRegionId, operation.skillId);
    // Ration Cut pays on every convoy, forever — a permanent multiplier, applied
    // alongside demand and the lead bonus rather than folded into any of them.
    const blackoutYield = 1 + (0, $45c49e7f6d2032d6$export$84f52d60145287)('op-credit-yield', 0);
    // Sale + haulage. The flat term is what keeps a short route worth running —
    // see the note above OPERATION_TEMPLATES for why a pure per-hour rate makes
    // the staging point a non-decision.
    const base = Math.round((template.credits || 0) + template.creditsPerHour * hours);
    const leadBonus = Math.min($cb0ad7004fe6b26a$export$2a1adeeaefb6ac28, (operation.leadMarks || 0) * $cb0ad7004fe6b26a$export$27e3703df3a11e61);
    // The trickle is the ONLY ops Writ, and it rides demand: earned by shipping
    // into a genuinely hungry market, never by shipping a lot. Gated to the top
    // class so a 2.5-hour Short Haul cannot become the cheapest Writ in the game,
    // and self-limiting because a delivery is what stops a market being hungry.
    const demandWrit = template.writEligible && (0, $356ad444ead618fc$export$d48946d0a3e2934b)(demand) ? 1 : 0;
    return {
        credits: Math.round(base * (1 + leadBonus) * demand * blackoutYield),
        writs: demandWrit,
        leadBonus: leadBonus,
        demand: demand,
        demandWrit: demandWrit
    };
}
function $cb0ad7004fe6b26a$export$b68d61a5f45d991c({ now: now = Date.now(), maxPerSlot: maxPerSlot = Infinity } = {}) {
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const due = (syndicate.operations || []).filter((op)=>op.completesAt <= now);
    // Oldest first, so a cap keeps the ops that finished earliest rather than an
    // arbitrary slice.
    due.sort((a, b)=>a.completesAt - b.completesAt);
    const settling = Number.isFinite(maxPerSlot) ? due.slice(0, maxPerSlot * Math.max(1, $cb0ad7004fe6b26a$export$c87f3aa20ea43c6e())) : due;
    let credits = 0, writs = 0;
    const settled = [];
    for (const op of settling){
        const payout = $cb0ad7004fe6b26a$export$a4ac0527bd343e81(op);
        credits += payout.credits;
        writs += payout.writs;
        settled.push({
            ...op,
            payout: payout
        });
    }
    if (settled.length) {
        const settledIds = new Set(settled.map((o)=>o.id));
        syndicate.operations = syndicate.operations.filter((op)=>!settledIds.has(op.id));
        syndicate.opsCompleted += settled.length;
        syndicate.writs += writs;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits || 0) + credits;
    }
    return {
        settled: settled,
        credits: credits,
        writs: writs
    };
}



/**
 * @typedef {'idle'|'running'|'complete'|'automated'|'none'} TaskState
 *   none      - this layer has no active task worth a button (slot hides)
 *   idle      - a task can be started
 *   running   - in progress; label carries live status
 *   complete  - finished and awaiting collection; this is what badges the switcher
 *   automated - a higher layer runs this loop hands-off (L3+)
 */ /** Field's raid, read from the same state today's raid-tab button reads. */ function $994f1ba19a9440db$var$fieldActiveTask() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid || {};
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return {
        state: 'none',
        label: '',
        screen: null
    };
    // Another character owns the active raid — the screen is not ours to open.
    if (!(0, $f27982cef7035d22$export$77866226ea57ca79)()) return {
        state: 'none',
        label: '',
        screen: null
    };
    if (raid.raidOwnerId && raid.raidInProgress != null) return {
        state: 'running',
        label: 'Raid in Progress',
        screen: 'raid'
    };
    if (raid.raidCompleted) return {
        state: 'complete',
        label: 'Raid Completed',
        screen: 'raid'
    };
    if (raid.currentRaidGrid && raid.selectedTier) return {
        state: 'running',
        label: 'Raid in Planning',
        screen: 'raid'
    };
    return {
        state: 'idle',
        label: 'New Raid',
        screen: 'raid'
    };
}
/**
 * Syndicate's active task is launching an OPERATION, not founding.
 *
 * Founding stays off the toolbar: it is irreversible and available for most of
 * an era, so a permanent "Found" button would be both a dead control and a
 * dangerous one. Launching a convoy is the opposite - repeatable, cheap to
 * decide, and the thing a player returns to the layer to do.
 *
 * `mode` splits one screen into two views. Planning a new operation and
 * watching three in flight are different jobs, and putting both on one page
 * meant the map carried every route at once. The toolbar button opens the
 * PLANNER; the screen tab opens the in-transit board.
 */ function $994f1ba19a9440db$var$syndicateActiveTask() {
    if ((0, $46d374413fb0707a$export$6955e231f1466c44)('operations-charter') <= 0) return {
        state: 'none',
        label: '',
        screen: null
    };
    const inFlight = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations?.length || 0;
    const slots = (0, $cb0ad7004fe6b26a$export$c87f3aa20ea43c6e)();
    if (inFlight >= slots) // Informational, not actionable - same role as Field's "Raid in
    // Progress". Clicking still reaches the transit board, which is the
    // useful destination when everything is already out.
    return {
        state: 'running',
        label: `Convoys out ${inFlight}/${slots}`,
        screen: 'operations'
    };
    return {
        state: 'idle',
        label: 'New Operation',
        screen: 'operations',
        mode: 'plan'
    };
}
/**
 * Command's promotion.
 *
 * Deliberately never reports 'complete' yet. `canPromoteCore()` is a BLOCKER
 * check (no character / on marketplace / mid-raid) - it says promotion is
 * *permitted*, not that it is *worthwhile*, and it is true almost always. Using
 * it for the badge would light the switcher permanently, which is worse than
 * not badging at all.
 *
 * A real readiness signal arrives with L3's `succession-doctrine`, which ports
 * the simulator's marks-rate-peak policy into the game so the Command panel and
 * the automation share one computation (docs/layers/3-syndicate/design.md §4.4). Until
 * then Command reports 'idle', and the spec hides the slot when idle.
 */ function $994f1ba19a9440db$var$commandActiveTask() {
    // 'none', not 'idle': the spec hides Command's slot when idle, and promotion
    // is started from the Promotion screen rather than the toolbar. Showing a
    // permanent "Promote" button here would be the dead control the active-task
    // slot exists to avoid. This becomes 'complete' -> "Promotion ready" once a
    // readiness signal exists (L3 succession-doctrine).
    return {
        state: 'none',
        label: '',
        screen: null
    };
}
function $994f1ba19a9440db$export$555e6e56b118f15() {
    return ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0) > 0 || ((0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.tour || 1) > 1 || ((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.founded || 0) > 0;
}
const $994f1ba19a9440db$export$fdca3ba65b5cceec = [
    {
        id: 'field',
        // Label is display-only; `id` stays 'field' because saves, lastScreenByLayer
        // and every test key off it. Renaming the id would strand saved UI state.
        label: 'The Field',
        icon: "\u2694\uFE0F",
        accent: '#7cc4ff',
        unlocked: ()=>true,
        // `visible` is declarative on purpose. This used to be imperative — the old
        // updateTabVisibility() added a `hidden` class — which stopped working the
        // moment the toolbar started re-rendering: the next render simply rebuilt
        // the buttons without it. Anything the renderer owns has to be expressed as
        // state the renderer reads.
        //
        // On a BRAND NEW account the creation screen is the only view, so Field
        // offers no navigation. Between characters is a different state and needs a
        // different answer: `#character-tab` hosts the creator as well as the
        // roster, so gating it on `gameState.character` left a promoted or
        // post-founding account with no visible Field screen at all — switchLayer
        // had no tab to click, and "The Field" went nowhere.
        screens: [
            {
                id: 'character',
                label: 'Characters',
                icon: "\uD83E\uDDD1",
                tab: 'character',
                visible: ()=>!!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || $994f1ba19a9440db$export$555e6e56b118f15()
            },
            // Contractors stays strict: a hiring pool with nobody to hire for is a
            // genuinely dead screen, not a route to the creator.
            {
                id: 'contractors',
                label: 'Contractors',
                icon: "\uD83E\uDD1D",
                tab: 'contractors',
                visible: ()=>!!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character
            },
            // The Archive appears with the first Collapse Key and never leaves — the
            // record is account-level, so it outlives every character.
            //
            // Gated on HAVING one rather than on having a character, and that is not
            // just dead-control hygiene: Field's toolbar row measured 753 of 768px
            // with two screens, so a third is a real width cost and it should not be
            // paid until there is something behind it. Below 900px the toolbar drops
            // labels for icons, which is what keeps three Field screens inside the
            // tablet budget once it does appear.
            {
                id: 'archive',
                label: 'Archive',
                icon: "\uD83D\uDDDD\uFE0F",
                tab: 'archive',
                visible: ()=>((0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.collapseKeys?.length || 0) > 0
            }
        ],
        currencies: [
            // `compact` bounds the chip at 5 characters. Credits are the one value
            // here that grows without limit, and the chip grew with it.
            {
                id: 'credits',
                icon: "\uD83D\uDCB0",
                value: ()=>(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits ?? 0,
                compact: true
            },
            {
                id: 'energy',
                icon: "\u26A1",
                // Already bounded by maxEnergy, and it is a ratio - abbreviating would
                // cost clarity to save nothing.
                value: ()=>`${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.energy ?? 0}/${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.maxEnergy ?? 0}`
            }
        ],
        activeTask: $994f1ba19a9440db$var$fieldActiveTask
    },
    {
        id: 'command',
        label: 'Command',
        icon: "\uD83C\uDF96\uFE0F",
        accent: '#b18cff',
        // Reveal latch, not a live check - Command stays available between tours,
        // which is exactly when upgrades get bought.
        unlocked: ()=>(0, $bde36de43872f734$export$25d1e5af45c35a33)(),
        screens: [
            {
                id: 'command',
                label: 'Promotion',
                icon: "\uD83C\uDF96\uFE0F",
                tab: 'command'
            },
            {
                id: 'command-vault',
                label: 'Vault',
                icon: "\uD83C\uDFE6",
                tab: 'command-vault'
            }
        ],
        currencies: [
            // Marks accumulate across every tour, so they grow without limit too.
            {
                id: 'marks',
                icon: "\uD83C\uDF96\uFE0F",
                value: ()=>(0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.marks ?? 0,
                compact: true
            }
        ],
        activeTask: $994f1ba19a9440db$var$commandActiveTask
    },
    {
        id: 'syndicate',
        label: 'Syndicate',
        icon: "\uD83D\uDCDC",
        accent: '#e0a84c',
        unlocked: ()=>(0, $46d374413fb0707a$export$f0d4871acc619a3)(),
        // 'Charter' rather than 'Syndicate': the layer name is already in the
        // switcher, so repeating it here would spend header width saying nothing.
        // It is also short, which matters - at 1024 the toolbar's spare room is
        // ~117px and a long label is what would actually break portrait.
        screens: [
            {
                id: 'charter',
                label: 'Charter',
                icon: "\uD83D\uDCDC",
                tab: 'syndicate'
            },
            // Operations appear only once licensed. A screen for a system the player
            // cannot use yet is the dead control the `visible` predicate exists to
            // avoid — and unlike Field's screens this one is bought, not unlocked by
            // progression, so it can also disappear again on a fresh era.
            {
                id: 'operations',
                label: 'Operations',
                icon: "\uD83D\uDDFA\uFE0F",
                tab: 'operations',
                visible: ()=>((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.upgrades?.['operations-charter'] || 0) > 0
            },
            {
                id: 'syndicate-stores',
                label: 'Stores',
                icon: "\uD83D\uDCE6",
                tab: 'syndicate-stores'
            }
        ],
        currencies: [
            // Writs accumulate across every founding, so they need the same compact
            // treatment as marks and credits.
            {
                id: 'writs',
                icon: "\uD83D\uDCDC",
                value: ()=>(0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.writs ?? 0,
                compact: true
            },
            // Energy appears here even though Command deliberately hides it, because
            // the rule is "show what is ACTIONABLE in this layer" rather than "hide
            // everything from below". Operations spend energy, so a player planning
            // one needs to see it without leaving the layer.
            {
                id: 'energy',
                icon: "\u26A1",
                value: ()=>`${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.energy ?? 0}/${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.maxEnergy ?? 0}`
            }
        ],
        activeTask: $994f1ba19a9440db$var$syndicateActiveTask
    }
];
function $994f1ba19a9440db$export$61f6a9c831786408() {
    return $994f1ba19a9440db$export$fdca3ba65b5cceec;
}
function $994f1ba19a9440db$export$f5b74d0d242cec02(id) {
    return $994f1ba19a9440db$export$fdca3ba65b5cceec.find((l)=>l.id === id) || null;
}
function $994f1ba19a9440db$export$e4f119c4ad718995() {
    return $994f1ba19a9440db$export$fdca3ba65b5cceec.filter((l)=>{
        try {
            return l.unlocked();
        } catch  {
            return false;
        }
    });
}
function $994f1ba19a9440db$export$cdfede5cf3580bc3() {
    const id = (0, $f27982cef7035d22$export$8e361a1ffbebf172).ui?.currentLayer;
    const layer = id ? $994f1ba19a9440db$export$f5b74d0d242cec02(id) : null;
    if (layer && layer.unlocked()) return layer.id;
    return 'field';
}
function $994f1ba19a9440db$export$622b0388371c420c(id) {
    const layer = $994f1ba19a9440db$export$f5b74d0d242cec02(id);
    if (!layer || !layer.unlocked()) return false;
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).ui) (0, $f27982cef7035d22$export$8e361a1ffbebf172).ui = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).ui.currentLayer = id;
    return true;
}
function $994f1ba19a9440db$export$b6b1c75d2c3e7681(layerId = $994f1ba19a9440db$export$cdfede5cf3580bc3()) {
    return ($994f1ba19a9440db$export$f5b74d0d242cec02(layerId)?.screens ?? []).filter((s)=>!s.visible || s.visible());
}
function $994f1ba19a9440db$export$7c0a2b034b740aec(layerId = $994f1ba19a9440db$export$cdfede5cf3580bc3()) {
    return ($994f1ba19a9440db$export$f5b74d0d242cec02(layerId)?.currencies ?? []).map((c)=>{
        const raw = c.value();
        const value = c.compact ? (0, $42b272c2c0f44bdf$export$d7a853631095b479)(raw) : raw;
        // `exact` is null unless abbreviating actually hid something, so the header
        // only carries a tooltip where there is something to reveal. Hover is not
        // reachable on tablet - a supported target - so this is a supplement to the
        // 100,000 exact-digits floor, never the thing that makes it usable.
        const exact = c.compact && value !== String(raw) ? Number(raw).toLocaleString() : null;
        return {
            id: c.id,
            icon: c.icon,
            value: value,
            exact: exact
        };
    });
}
function $994f1ba19a9440db$export$47888485123801c8(layerId = $994f1ba19a9440db$export$cdfede5cf3580bc3()) {
    const layer = $994f1ba19a9440db$export$f5b74d0d242cec02(layerId);
    if (!layer) return {
        state: 'none',
        label: '',
        screen: null
    };
    return layer.activeTask();
}
function $994f1ba19a9440db$export$2230f7bb8ebaf8be(currentId = $994f1ba19a9440db$export$cdfede5cf3580bc3()) {
    return $994f1ba19a9440db$export$e4f119c4ad718995().filter((l)=>l.id !== currentId && l.activeTask().state === 'complete').map((l)=>l.id);
}



// Last screen visited per layer, so returning to Command lands where you left
// it. This is what makes switching cheap rather than punishing.
const $a1ffcc09d1c6aa84$var$lastScreenByLayer = new Map();
/**
 * The screen the player is on (or heading to), as a `data-tab` value.
 *
 * This is INTENT, deliberately not derived from `.tab-content.active`. Tab
 * switching is animated: the outgoing pane keeps `.active` until its fade-out
 * ends, so anything reading the DOM synchronously after a click sees the
 * PREVIOUS screen. That made the toolbar paint the wrong button active, and
 * because the click handler skips buttons already marked active, the stale
 * class then swallowed the next navigation to that screen.
 */ let $a1ffcc09d1c6aa84$var$currentScreenTab = null;
function $a1ffcc09d1c6aa84$export$517113b01f92f5fe() {
    return $a1ffcc09d1c6aa84$var$currentScreenTab;
}
// Below this width screen tabs drop their labels and show icons only. The layer
// name already appears in the switcher, so screen tabs carry less naming burden
// and are the right thing to shed labels first.
const $a1ffcc09d1c6aa84$var$ICON_ONLY_MAX_WIDTH = 900;
const $a1ffcc09d1c6aa84$var$isNarrow = ()=>window.innerWidth <= $a1ffcc09d1c6aa84$var$ICON_ONLY_MAX_WIDTH;
const $a1ffcc09d1c6aa84$var$BTN_BASE = 'tab-btn font-bold py-1 rounded-lg border-2 hover:shadow-lg whitespace-nowrap';
/**
 * Horizontal padding for every toolbar button, tightened on narrow viewports.
 *
 * The toolbar's width budget is genuinely tight — Field measured 753 of 768 —
 * and a third Syndicate screen (Charter / Operations / Stores) pushed it 34px
 * over, silently clipping the help button off the right edge. One uniform rule
 * beats shaving a label: it recovers the room from the whole bar rather than
 * from whichever control was added last, and it leaves headroom for the next
 * screen instead of paying this cost again.
 */ const $a1ffcc09d1c6aa84$var$btnBase = ()=>`${$a1ffcc09d1c6aa84$var$BTN_BASE} ${$a1ffcc09d1c6aa84$var$isNarrow() ? 'px-1.5' : 'px-3'}`;
/**
 * Active-task button styling, keyed by task state.
 *
 * The rule the header reads by: **solid means act, quiet means FYI.** A player
 * scanning the toolbar should be able to tell "you owe me an input" from "this
 * is running fine" without reading the label.
 *
 * `complete` deliberately mirrors the in-game raid button's own "Complete Raid"
 * styling (`raid.js` updateRaidButtonStates) - same gradient, same foil. It is
 * the same action on two surfaces, so it should not be a different colour on
 * each; it previously rendered `bg-green-400/10`, which is 10% green over a
 * dark header and reads as near-black.
 *
 * `bg-amber-* text-black` is the idiom used everywhere else in the app for a
 * solid amber control. The raid button reaches the same place by a different
 * route - `.start-raid-btn` sets #1a1a2e in CSS - and the difference is not
 * perceptible on amber, so this stays with the Tailwind idiom.
 *
 * `running` is the only state with nothing to do, so it is the only quiet one.
 * That contrast is what gives the solid states meaning - if every state were
 * solid, "solid" would signal nothing.
 */ const $a1ffcc09d1c6aa84$var$TASK_TONES = {
    // Finished, awaiting collection - the strongest call to action.
    complete: 'border-amber-300 text-black bg-gradient-to-r from-amber-500 to-amber-600',
    // Startable now.
    idle: 'border-amber-400 text-black bg-amber-600 hover:bg-amber-500',
    // In progress - informational, nothing for the player to do.
    running: 'border-amber-800/70 text-amber-100/80 bg-white/5',
    // A higher layer runs this loop hands-off (L3+): also nothing to do.
    automated: 'border-sky-800/70 text-sky-100/80 bg-white/5'
};
function $a1ffcc09d1c6aa84$var$el(tag, className, html) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
}
/** The layer switcher - shows where you are, and badges when elsewhere needs you. */ function $a1ffcc09d1c6aa84$var$renderSwitcher(container, layer) {
    container.replaceChildren();
    const btn = $a1ffcc09d1c6aa84$var$el('button', `${$a1ffcc09d1c6aa84$var$btnBase()} relative bg-white/5`);
    btn.id = 'layer-switcher-btn';
    btn.style.borderColor = layer.accent;
    btn.style.color = layer.accent;
    btn.title = `Current layer: ${layer.label}`;
    btn.innerHTML = `${layer.icon} ${layer.label} <span class="opacity-70">\u{25BE}</span>`;
    // Badge counts LAYERS needing attention, not tasks, so it stays stable as
    // layers and task counts grow. Neutral colour: "something needs you" must
    // never read as a layer identity.
    const waiting = (0, $994f1ba19a9440db$export$2230f7bb8ebaf8be)(layer.id);
    if (waiting.length > 0) {
        const badge = $a1ffcc09d1c6aa84$var$el('span', "absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-black text-[10px] font-extrabold grid place-items-center", String(waiting.length));
        badge.title = `Needs attention: ${waiting.join(', ')}`;
        btn.appendChild(badge);
    }
    btn.addEventListener('click', (e)=>{
        e.stopPropagation();
        $a1ffcc09d1c6aa84$export$c937970754507226();
    });
    container.appendChild(btn);
}
/** The current layer's screens. Never the union - one layer's context at a time. */ function $a1ffcc09d1c6aa84$var$renderScreens(container, layer) {
    container.replaceChildren();
    // Intent, not `.tab-content.active` — see currentScreenTab.
    const activeTab = $a1ffcc09d1c6aa84$var$currentScreenTab;
    const narrow = $a1ffcc09d1c6aa84$var$isNarrow();
    // screensFor() applies each screen's `visible` predicate — do not read
    // layer.screens directly, or hidden screens come back on every render.
    for (const screen of (0, $994f1ba19a9440db$export$b6b1c75d2c3e7681)(layer.id)){
        const isActive = screen.tab === activeTab;
        const btn = $a1ffcc09d1c6aa84$var$el('button', `${$a1ffcc09d1c6aa84$var$btnBase()} ${isActive ? 'active' : ''} text-gray-300 bg-white/5`);
        btn.dataset.tab = screen.tab;
        btn.style.borderColor = isActive ? layer.accent : '';
        btn.title = screen.label;
        btn.textContent = narrow ? screen.icon : screen.label;
        if (!isActive) btn.classList.add('border-gray-500');
        container.appendChild(btn);
    }
}
/**
 * The active-task slot - shortcut to *and* live status of this layer's task.
 * Replaces the hardcoded "New Raid" button: raiding is Field's task, not a
 * privileged global one.
 */ function $a1ffcc09d1c6aa84$var$renderTask(container, layer) {
    container.replaceChildren();
    const task = (0, $994f1ba19a9440db$export$47888485123801c8)(layer.id);
    if (task.state === 'none') return; // spec: hide the slot rather than show a dead control
    const btn = $a1ffcc09d1c6aa84$var$el('button', `${$a1ffcc09d1c6aa84$var$btnBase()} ${$a1ffcc09d1c6aa84$var$TASK_TONES[task.state] ?? $a1ffcc09d1c6aa84$var$TASK_TONES.idle}`);
    btn.id = 'layer-task-btn';
    btn.dataset.tab = task.screen;
    // Stamped here, not only in refreshToolbarValues: this is what the tick
    // compares against to decide whether a structural rebuild is needed. Leaving
    // it unset meant any external renderLayerToolbar() call looked like a state
    // change on the next tick, forcing a rebuild that closed an open panel.
    btn.dataset.state = task.state;
    // Optional: a task can ask for a particular VIEW of its screen. Syndicate's
    // Operations screen is both a planner and a transit board, and the toolbar
    // button means "plan a new one" while the screen tab means "show me what is
    // running". The tab handler reads this off the clicked element.
    if (task.mode) btn.dataset.mode = task.mode;
    btn.textContent = task.label;
    if (task.state === 'complete') btn.classList.add('foil-card');
    container.appendChild(btn);
}
/**
 * Currencies for this layer only - NOT accumulated. Credits and energy are not
 * actionable in Command, so they do not appear there. This is the single change
 * that stops the right-hand cluster growing once per layer, and it is most of
 * the portrait-clipping fix.
 */ function $a1ffcc09d1c6aa84$var$renderCurrencies(container, layer) {
    container.replaceChildren();
    for (const currency of (0, $994f1ba19a9440db$export$7c0a2b034b740aec)(layer.id)){
        const chip = $a1ffcc09d1c6aa84$var$el('div', 'flex items-center gap-1 px-2 py-1 bg-white/10 rounded-lg border-2 border-gray-900');
        chip.id = `${currency.id}-chip`;
        if (currency.exact) chip.title = currency.exact;
        chip.appendChild($a1ffcc09d1c6aa84$var$el('span', null, currency.icon));
        const value = $a1ffcc09d1c6aa84$var$el('span', 'font-bold');
        value.id = `currency-${currency.id}`;
        value.textContent = currency.value;
        value.style.color = currency.id === 'energy' ? '#60a5fa' : layer.accent;
        chip.appendChild(value);
        // Energy carries a purchase affordance. The popup itself lives outside the
        // chips (see index.html) so re-rendering currencies cannot destroy it.
        if (currency.id === 'energy') {
            const buy = $a1ffcc09d1c6aa84$var$el('button', "ml-1 px-1.5 rounded font-bold text-blue-300 bg-blue-900/60 border border-blue-700 hover:bg-blue-700 hover:text-white transition-colors", '+');
            buy.id = 'buy-energy-btn';
            buy.title = 'Buy energy';
            buy.addEventListener('click', (e)=>window.toggleEnergyPopup?.(e));
            chip.appendChild(buy);
        }
        container.appendChild(chip);
    }
}
function $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b() {
    const layer = (0, $994f1ba19a9440db$export$f5b74d0d242cec02)((0, $994f1ba19a9440db$export$cdfede5cf3580bc3)());
    if (!layer) return;
    const switcher = document.getElementById('layer-switcher');
    const screens = document.getElementById('layer-screens');
    const task = document.getElementById('layer-task');
    const currencies = document.getElementById('layer-currencies');
    if (!switcher || !screens || !task || !currencies) return; // header not on this page
    // A structural rebuild replaces the switcher button the panel is anchored to
    // and whose outside-click handler references it, so an open panel cannot
    // survive one. Rare in practice — this fires on layer switch, unlock, and
    // task-state change, not on the per-second tick.
    if ($a1ffcc09d1c6aa84$var$panelIsOpen()) $a1ffcc09d1c6aa84$export$9722d62d688a2b10();
    $a1ffcc09d1c6aa84$var$renderSwitcher(switcher, layer);
    $a1ffcc09d1c6aa84$var$renderScreens(screens, layer);
    $a1ffcc09d1c6aa84$var$renderTask(task, layer);
    $a1ffcc09d1c6aa84$var$renderCurrencies(currencies, layer);
}
function $a1ffcc09d1c6aa84$export$c6af328ac5cab01b() {
    const layerId = (0, $994f1ba19a9440db$export$cdfede5cf3580bc3)();
    for (const currency of (0, $994f1ba19a9440db$export$7c0a2b034b740aec)(layerId)){
        const node = document.getElementById(`currency-${currency.id}`);
        if (node) node.textContent = currency.value;
        // Patched here too, not only on a structural rebuild: an abbreviated chip
        // holds the exact figure in its tooltip, and credits change every raid
        // while structure does not. Missing this would pin the tooltip to whatever
        // the balance was at the last rebuild.
        const chip = document.getElementById(`${currency.id}-chip`);
        if (chip) {
            if (currency.exact) chip.title = currency.exact;
            else chip.removeAttribute('title');
        }
    }
    // The task's LABEL changes constantly (raid progress); its presence and tone
    // change rarely. Rebuild only when the state actually changes.
    const task = (0, $994f1ba19a9440db$export$47888485123801c8)(layerId);
    const btn = document.getElementById('layer-task-btn');
    const stateChanged = (btn?.dataset.state ?? 'none') !== task.state;
    if (stateChanged) {
        $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b(); // renderTask stamps the new state
        return;
    }
    if (btn) btn.textContent = task.label;
    // A layer unlocking (or a raid completing elsewhere) changes the badge.
    const expected = (0, $994f1ba19a9440db$export$2230f7bb8ebaf8be)(layerId).length;
    const shown = document.querySelector('#layer-switcher .bg-amber-500');
    if (expected > 0 !== !!shown) $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b();
}
function $a1ffcc09d1c6aa84$export$7e55ff4ad8ce9b5a(layerId) {
    if (!(0, $994f1ba19a9440db$export$622b0388371c420c)(layerId)) return false;
    const layer = (0, $994f1ba19a9440db$export$f5b74d0d242cec02)(layerId);
    const remembered = $a1ffcc09d1c6aa84$var$lastScreenByLayer.get(layerId);
    // Only currently-visible screens are valid targets, or we would try to click
    // a button that was never rendered.
    const visible = (0, $994f1ba19a9440db$export$b6b1c75d2c3e7681)(layerId);
    const target = visible.find((s)=>s.tab === remembered) || visible[0];
    // Render first so the new layer's screen buttons exist to be clicked.
    $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b();
    if (target) {
        if (target.tab === $a1ffcc09d1c6aa84$var$currentScreenTab) // Already displaying the target screen. The click handler would treat
        // this as a no-op and return, leaving the toolbar unpainted, so repaint
        // directly. Cannot happen while layers own distinct screens, but the
        // registry does not guarantee that.
        $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b();
        else document.querySelector(`#layer-screens [data-tab="${target.tab}"]`)?.click();
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `switched to layer ${layerId}`);
    return true;
}
// --- Switcher panel -------------------------------------------------------
// The badge says *something* needs you; the panel says *which* layer. That
// split is why the badge can stay a stable count of layers rather than trying
// to describe tasks.
let $a1ffcc09d1c6aa84$var$closePanelOnOutside = null;
/** Is the panel currently open? */ function $a1ffcc09d1c6aa84$var$panelIsOpen() {
    return !document.getElementById('layer-panel')?.classList.contains('hidden');
}
/**
 * One row per layer, in ladder order.
 *
 * Locked layers are shown dimmed with a lock rather than hidden — a prestige
 * ladder should advertise what is ahead (spec open question 1). They render
 * from the same registry list, so a new layer appears here by existing.
 */ function $a1ffcc09d1c6aa84$var$renderLayerPanel() {
    const panel = document.getElementById('layer-panel');
    if (!panel) return;
    panel.replaceChildren();
    const activeId = (0, $994f1ba19a9440db$export$cdfede5cf3580bc3)();
    for (const layer of (0, $994f1ba19a9440db$export$61f6a9c831786408)()){
        const unlocked = layer.unlocked();
        const isCurrent = layer.id === activeId;
        const task = unlocked ? (0, $994f1ba19a9440db$export$47888485123801c8)(layer.id) : {
            state: 'none',
            label: ''
        };
        const needsAttention = task.state === 'complete';
        const row = document.createElement('button');
        row.className = 'w-full flex items-center gap-2 px-2 py-2 mb-1 rounded-lg border-2 text-left ' + (unlocked ? 'hover:bg-white/10 ' : 'opacity-40 cursor-not-allowed ');
        row.disabled = !unlocked;
        row.dataset.layer = layer.id;
        // Current layer wears its own accent; a layer asking for attention is
        // outlined in the neutral alert colour so "needs you" never reads as an
        // identity. Everything else stays quiet.
        row.style.borderColor = needsAttention ? '#f59e0b' : isCurrent ? layer.accent : 'transparent';
        const icon = $a1ffcc09d1c6aa84$var$el('span', 'text-lg', unlocked ? layer.icon : "\uD83D\uDD12");
        const label = $a1ffcc09d1c6aa84$var$el('span', 'font-bold flex-1');
        label.textContent = layer.label;
        if (unlocked) label.style.color = isCurrent ? layer.accent : '#d1d5db';
        row.append(icon, label);
        if (needsAttention) row.appendChild($a1ffcc09d1c6aa84$var$el('span', 'text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500 text-black whitespace-nowrap', task.label));
        else if (isCurrent) row.appendChild($a1ffcc09d1c6aa84$var$el('span', 'text-[10px] text-gray-500', 'here'));
        if (unlocked && !isCurrent) row.addEventListener('click', ()=>{
            $a1ffcc09d1c6aa84$export$9722d62d688a2b10();
            $a1ffcc09d1c6aa84$export$7e55ff4ad8ce9b5a(layer.id);
        });
        else if (isCurrent) row.addEventListener('click', $a1ffcc09d1c6aa84$export$9722d62d688a2b10);
        panel.appendChild(row);
    }
}
function $a1ffcc09d1c6aa84$export$9f3f9ca9a516ab25() {
    const panel = document.getElementById('layer-panel');
    const anchor = document.getElementById('layer-switcher-btn');
    if (!panel || !anchor) return;
    $a1ffcc09d1c6aa84$var$renderLayerPanel();
    panel.classList.remove('hidden');
    const rect = anchor.getBoundingClientRect();
    panel.style.top = `${rect.bottom + 8}px`;
    panel.style.left = `${Math.max(8, rect.left)}px`;
    // Deferred so the click that opened it does not immediately close it.
    $a1ffcc09d1c6aa84$var$closePanelOnOutside = (e)=>{
        if (!panel.contains(e.target) && e.target !== anchor) $a1ffcc09d1c6aa84$export$9722d62d688a2b10();
    };
    setTimeout(()=>document.addEventListener('click', $a1ffcc09d1c6aa84$var$closePanelOnOutside), 0);
    document.addEventListener('keydown', $a1ffcc09d1c6aa84$var$closeOnEscape);
}
function $a1ffcc09d1c6aa84$export$9722d62d688a2b10() {
    const panel = document.getElementById('layer-panel');
    if (!panel) return;
    panel.classList.add('hidden');
    if ($a1ffcc09d1c6aa84$var$closePanelOnOutside) {
        document.removeEventListener('click', $a1ffcc09d1c6aa84$var$closePanelOnOutside);
        $a1ffcc09d1c6aa84$var$closePanelOnOutside = null;
    }
    document.removeEventListener('keydown', $a1ffcc09d1c6aa84$var$closeOnEscape);
}
function $a1ffcc09d1c6aa84$var$closeOnEscape(e) {
    if (e.key === 'Escape') $a1ffcc09d1c6aa84$export$9722d62d688a2b10();
}
function $a1ffcc09d1c6aa84$export$c937970754507226() {
    if ($a1ffcc09d1c6aa84$var$panelIsOpen()) $a1ffcc09d1c6aa84$export$9722d62d688a2b10();
    else $a1ffcc09d1c6aa84$export$9f3f9ca9a516ab25();
}
function $a1ffcc09d1c6aa84$export$581d35409857f84f(tabName) {
    if (!tabName) return;
    $a1ffcc09d1c6aa84$var$currentScreenTab = tabName;
    const layerId = (0, $994f1ba19a9440db$export$cdfede5cf3580bc3)();
    if ((0, $994f1ba19a9440db$export$f5b74d0d242cec02)(layerId)?.screens.some((s)=>s.tab === tabName)) $a1ffcc09d1c6aa84$var$lastScreenByLayer.set(layerId, tabName);
}
function $a1ffcc09d1c6aa84$export$544b0f50b5799474() {
    // Seed the current screen from the DOM. Safe here and only here: at boot
    // nothing is mid-animation, so `.tab-content.active` is the truth rather
    // than a lagging snapshot. Falls back to the layer's first screen.
    const active = document.querySelector('.tab-content.active')?.id?.replace(/-tab$/, '');
    $a1ffcc09d1c6aa84$export$581d35409857f84f(active || (0, $994f1ba19a9440db$export$f5b74d0d242cec02)((0, $994f1ba19a9440db$export$cdfede5cf3580bc3)())?.screens[0]?.tab);
    $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b();
    // Crossing the icon-only breakpoint changes structure, not just values.
    let wasNarrow = $a1ffcc09d1c6aa84$var$isNarrow();
    window.addEventListener('resize', ()=>{
        if ($a1ffcc09d1c6aa84$var$isNarrow() !== wasNarrow) {
            wasNarrow = $a1ffcc09d1c6aa84$var$isNarrow();
            $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b();
        }
    });
}
// Exposed for the same reason the rest of the game's handlers are: inline
// onclick attributes and cross-module calls without an import cycle.
if (typeof window !== 'undefined') {
    window.renderLayerToolbar = $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b;
    window.switchLayer = $a1ffcc09d1c6aa84$export$7e55ff4ad8ce9b5a;
    window.toggleLayerPanel = $a1ffcc09d1c6aa84$export$c937970754507226;
}


function $a52c72724dfd3eca$export$b127b30033aaeba9(event, room) {
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) return;
    const content = document.getElementById('tooltip-content');
    if (!content) {
        console.error("content div missing");
        return;
    }
    if (room.type === 'blocked') return '';
    if (room.type === 'start' || room.type === 'exit') content.innerHTML = `
            <h5>${room.type === 'start' ? "\uD83C\uDF00 Entry Portal" : "\uD83C\uDF0C Exit Portal"}</h5>
            <div>${room.type === 'start' ? 'Your team enters here' : 'Your team exits here'}</div>
        `;
    else if (room.type === 'campsite') content.innerHTML = `
            <h5>\u{1F3D5}\u{FE0F} ${room.name}</h5>
            <div class="tooltip-skills">
                <div style="color: #6bcf7f; margin-bottom: 8px;">
                    <strong>Safe Zone</strong> - Team heals ${room.healingAmount || 30} HP and uses consumables
                </div>
            </div>
        `;
    else if (room.type === 'road') content.innerHTML = `
            <h5>${room.name}</h5>
            <div class="tooltip-skills">
                Allows the team to travel faster
            </div>
        `;
    else {
        const teamSkills = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1)();
        const skillStatus = (0, $cc90b7944b7e868a$export$7e86a2006a620b57)(room, teamSkills);
        const primarySkillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)(room.primary);
        const supportSkillNames = room.support.map((skill)=>"\uD83D\uDD27 " + (0, $42b272c2c0f44bdf$export$182937d2e68a339)(skill)).join('<br/>');
        const skillsHTML = room.primary ? `
                \u{2B50} ${primarySkillName}<br/>
                ${room.support.length > 0 ? `${supportSkillNames}` : ''}<br/>
                <div class="mt-1" style="color: ${skillStatus.indicator === 'covered' ? '#6bcf7f' : skillStatus.indicator === 'partial' ? '#ffa502' : '#ff4757'}">
                    ${skillStatus.symbol} ${skillStatus.indicator === 'covered' ? 'Fully Covered' : skillStatus.indicator === 'partial' ? 'Support Missing' : 'Primary Missing'}
                </div>
        ` : '<strong>No skills used</strong>';
        content.innerHTML = `
            <h5>${room.name}</h5>
            <div class="tooltip-skills">
                ${skillsHTML}    
            </div>
        `;
    }
    const tooltip = document.getElementById('room-tooltip');
    if (tooltip) tooltip.classList.remove('hidden');
    $a52c72724dfd3eca$export$7fa52bbeeb0b31af(event);
}
function $a52c72724dfd3eca$export$a23289342bf715b2() {
    const tooltip = document.getElementById('room-tooltip');
    if (tooltip) tooltip.classList.add('hidden');
}
function $a52c72724dfd3eca$export$7fa52bbeeb0b31af(event) {
    const tooltip = document.getElementById('room-tooltip');
    if (!tooltip) return;
    const offset = 30;
    const height = tooltip.offsetHeight; // real: showRoomTooltip un-hides before positioning
    const flipAbove = window.innerHeight - (event.clientY + offset) < height;
    const top = flipAbove ? event.pageY - offset - height : event.pageY + offset;
    tooltip.style.left = event.pageX + offset + 'px';
    // Clamped so a tooltip taller than the space above it lands on screen
    // rather than off the top of the page.
    tooltip.style.top = Math.max(window.scrollY + offset, top) + 'px';
}
function $a52c72724dfd3eca$export$1ed604ed32abca42(skillKey) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    // Clear existing skill highlights
    document.querySelectorAll('.grid-cell').forEach((cell)=>{
        cell.classList.remove('skill-highlight');
    });
    if (!skillKey) return;
    // Highlight rooms that use this skill
    for(let row = 0; row < (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.size; row++)for(let col = 0; col < (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.size; col++){
        const room = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.grid[row][col];
        if (room.type !== 'start' && room.type !== 'exit') {
            const usesSkill = room.primary === skillKey || room.support.includes(skillKey);
            if (usesSkill) {
                const cell = document.querySelector(`[data-row="${row}"][data-col="${col}"]`);
                if (cell) cell.classList.add('skill-highlight');
            }
        }
    }
}
// ============================================================================
// ITEM-DROP HIGHLIGHT (raid planning)
// ============================================================================
// Transient, planning-only UI state — NOT persisted (kept out of the saved
// gameState.currentRaid). gridLootIndex is rebuilt per generated grid.
let $a52c72724dfd3eca$var$gridLootIndex = null;
let $a52c72724dfd3eca$var$highlightedItemIds = new Set(); // multi-select: rooms show a badge per match
let $a52c72724dfd3eca$var$itemPickerWired = false;
const $a52c72724dfd3eca$var$MAX_BADGE_ICONS = 3; // beyond this the badge shows "+N"
function $a52c72724dfd3eca$var$itemIconFor(id) {
    return id === 'Fish' ? "\uD83D\uDC1F" : (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id)?.icon || "\u2753";
}
function $a52c72724dfd3eca$var$itemNameFor(id) {
    return id === 'Fish' ? 'Fish' : (0, $42b272c2c0f44bdf$export$31330438f6059b08)(id);
}
function $a52c72724dfd3eca$export$d72ea71bfd67dd40() {
    const select = document.getElementById('item-highlight-picker');
    if (!select || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    if (!$a52c72724dfd3eca$var$gridLootIndex) $a52c72724dfd3eca$var$gridLootIndex = (0, $b596e64ef926739f$export$433f18e5bfab36e1)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    if (!$a52c72724dfd3eca$var$itemPickerWired) {
        select.addEventListener('change', (e)=>{
            const id = e.target.value;
            if (id) $a52c72724dfd3eca$var$highlightedItemIds.add(id);
            e.target.value = '';
            $a52c72724dfd3eca$var$renderItemChips();
            $a52c72724dfd3eca$var$renderItemBadges();
        });
        $a52c72724dfd3eca$var$itemPickerWired = true;
    }
    let html = '<option value="">\u2014 Add items \u2014</option>';
    const groups = new Map(); // rarity -> items[] (items already sorted by rarity then name)
    for (const it of $a52c72724dfd3eca$var$gridLootIndex.items){
        if (!groups.has(it.rarity)) groups.set(it.rarity, []);
        groups.get(it.rarity).push(it);
    }
    for (const [rarity, items] of groups){
        const label = rarity === 'special' ? 'Special' : $ce6dd72bc4611534$export$d4a72d069095e9e5?.[rarity]?.name || rarity;
        html += `<optgroup label="${label}">`;
        for (const it of items){
            // Relics aren't recipe components (sell-for-credits only) — skip
            if (it.type === "relic") continue;
            html += `<option value="${it.id}">${$a52c72724dfd3eca$var$itemIconFor(it.id)} ${$a52c72724dfd3eca$var$itemNameFor(it.id).replace(/Blueprint/g, "").trim()} (${it.count})</option>`;
        }
        html += '</optgroup>';
    }
    select.innerHTML = html;
    select.value = '';
    select.classList.remove('hidden');
    $a52c72724dfd3eca$var$renderItemChips();
    $a52c72724dfd3eca$export$ec61d7059805f99b(); // the skill filter shares the same grid/lifecycle
}
// Removable chips beside the picker showing the active item filters.
function $a52c72724dfd3eca$var$renderItemChips() {
    const box = document.getElementById('item-highlight-chips');
    if (!box) return;
    if ($a52c72724dfd3eca$var$highlightedItemIds.size === 0) {
        box.innerHTML = '';
        return;
    }
    box.innerHTML = [
        ...$a52c72724dfd3eca$var$highlightedItemIds
    ].map((id)=>`<span class="item-filter-chip h-6" title="${$a52c72724dfd3eca$var$itemNameFor(id)}">
            <span>${$a52c72724dfd3eca$var$itemIconFor(id)}</span>
            <span class="item-filter-chip-x" onclick="removeHighlightItem('${id}')">\xd7</span>
        </span>`).join('');
    box.classList.remove('hidden');
}
// Draw a bottom-right badge on every room that can drop one or more of the
// selected items: up to MAX_BADGE_ICONS icons, then a "+N" counter.
function $a52c72724dfd3eca$var$renderItemBadges() {
    document.querySelectorAll('.item-drop-badge').forEach((b)=>b.remove());
    if ($a52c72724dfd3eca$var$highlightedItemIds.size === 0 || !$a52c72724dfd3eca$var$gridLootIndex) return;
    const perCell = new Map(); // "row,col" -> [icons] (selection order)
    for (const id of $a52c72724dfd3eca$var$highlightedItemIds){
        const icon = $a52c72724dfd3eca$var$itemIconFor(id);
        for (const { row: row, col: col } of $a52c72724dfd3eca$var$gridLootIndex.itemToCells.get(id) || []){
            const key = `${row},${col}`;
            if (!perCell.has(key)) perCell.set(key, []);
            perCell.get(key).push(icon);
        }
    }
    for (const [key, icons] of perCell){
        const [row, col] = key.split(',');
        const cell = document.querySelector(`[data-row="${row}"][data-col="${col}"]`);
        if (!cell) continue;
        const shown = icons.slice(0, $a52c72724dfd3eca$var$MAX_BADGE_ICONS);
        const extra = icons.length - shown.length;
        const badge = document.createElement('div');
        badge.className = 'item-drop-badge';
        badge.innerHTML = shown.map((ic)=>`<span>${ic}</span>`).join('') + (extra > 0 ? `<span class="item-drop-more">+${extra}</span>` : '');
        cell.appendChild(badge);
    }
}
function $a52c72724dfd3eca$export$edb541e336ea9a21() {
    if ($a52c72724dfd3eca$var$highlightedItemIds.size > 0) $a52c72724dfd3eca$var$renderItemBadges();
    if ($a52c72724dfd3eca$var$highlightedSkillIds.size > 0) $a52c72724dfd3eca$var$renderSkillBadges();
}
function $a52c72724dfd3eca$export$a2d78d1f68010f97() {
    if ($a52c72724dfd3eca$var$highlightedItemIds.size === 0 || !$a52c72724dfd3eca$var$gridLootIndex) return null;
    const wanted = new Set();
    for (const id of $a52c72724dfd3eca$var$highlightedItemIds)for (const { row: row, col: col } of $a52c72724dfd3eca$var$gridLootIndex.itemToCells.get(id) || [])wanted.add(`${row},${col}`);
    return wanted.size > 0 ? wanted : null;
}
// Remove one item from the filter (chip × handler).
function $a52c72724dfd3eca$var$removeHighlightItem(id) {
    $a52c72724dfd3eca$var$highlightedItemIds.delete(id);
    $a52c72724dfd3eca$var$renderItemChips();
    $a52c72724dfd3eca$var$renderItemBadges();
}
window.removeHighlightItem = $a52c72724dfd3eca$var$removeHighlightItem;
// Clear all item highlights (Clear button), keeping the picker populated.
function $a52c72724dfd3eca$var$clearItemHighlight() {
    $a52c72724dfd3eca$var$highlightedItemIds.clear();
    $a52c72724dfd3eca$var$renderItemChips();
    $a52c72724dfd3eca$var$renderItemBadges();
}
window.clearItemHighlight = $a52c72724dfd3eca$var$clearItemHighlight;
function $a52c72724dfd3eca$export$6c9e89b1ffed34d7() {
    $a52c72724dfd3eca$var$gridLootIndex = null;
    $a52c72724dfd3eca$var$highlightedItemIds = new Set();
    const select = document.getElementById('item-highlight-picker');
    if (select) select.value = '';
    const chips = document.getElementById('item-highlight-chips');
    if (chips) chips.innerHTML = '';
    document.querySelectorAll('.item-drop-badge').forEach((b)=>b.remove());
    $a52c72724dfd3eca$export$59cebfb19ddd1f77(); // both room-highlight filters clear together
}
// ============================================================================
// SKILL HIGHLIGHT — mirrors the item highlight above but keys on the skills a
// room uses (primary + support). Rooms get a SEPARATE badge row of skill icons.
// ============================================================================
let $a52c72724dfd3eca$var$gridSkillIndex = null; // { skillToCells: Map<skillId, cells[]>, skills: skillId[] }
let $a52c72724dfd3eca$var$highlightedSkillIds = new Set();
let $a52c72724dfd3eca$var$skillPickerWired = false;
function $a52c72724dfd3eca$var$buildGridSkillIndex(gridData) {
    const skillToCells = new Map();
    if (!gridData || !gridData.grid) return {
        skillToCells: skillToCells,
        skills: []
    };
    const rows = gridData.rows || gridData.grid.length;
    const cols = gridData.cols || (gridData.grid[0] ? gridData.grid[0].length : 0);
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const room = gridData.grid[row]?.[col];
        if (!room || room.type === 'blocked') continue;
        const skills = [
            room.primary,
            ...room.support || []
        ].filter(Boolean);
        for (const s of new Set(skills)){
            let cells = skillToCells.get(s);
            if (!cells) {
                cells = [];
                skillToCells.set(s, cells);
            }
            cells.push({
                row: row,
                col: col
            });
        }
    }
    const skills = [
        ...skillToCells.keys()
    ].sort((a, b)=>(0, $42b272c2c0f44bdf$export$182937d2e68a339)(a).localeCompare((0, $42b272c2c0f44bdf$export$182937d2e68a339)(b)));
    return {
        skillToCells: skillToCells,
        skills: skills
    };
}
function $a52c72724dfd3eca$export$ec61d7059805f99b() {
    const select = document.getElementById('skill-highlight-picker');
    if (!select || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    if (!$a52c72724dfd3eca$var$gridSkillIndex) $a52c72724dfd3eca$var$gridSkillIndex = $a52c72724dfd3eca$var$buildGridSkillIndex((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    if (!$a52c72724dfd3eca$var$skillPickerWired) {
        select.addEventListener('change', (e)=>{
            const id = e.target.value;
            if (id) $a52c72724dfd3eca$var$highlightedSkillIds.add(id);
            e.target.value = '';
            $a52c72724dfd3eca$var$renderSkillChips();
            $a52c72724dfd3eca$var$renderSkillBadges();
        });
        $a52c72724dfd3eca$var$skillPickerWired = true;
    }
    let html = '<option value="">\u2014 Add skills \u2014</option>';
    for (const s of $a52c72724dfd3eca$var$gridSkillIndex.skills)html += `<option value="${s}">${(0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(s)} ${(0, $42b272c2c0f44bdf$export$182937d2e68a339)(s)} (${$a52c72724dfd3eca$var$gridSkillIndex.skillToCells.get(s).length})</option>`;
    select.innerHTML = html;
    select.value = '';
    select.classList.remove('hidden');
    $a52c72724dfd3eca$var$renderSkillChips();
}
function $a52c72724dfd3eca$var$renderSkillChips() {
    const box = document.getElementById('skill-highlight-chips');
    if (!box) return;
    if ($a52c72724dfd3eca$var$highlightedSkillIds.size === 0) {
        box.innerHTML = '';
        return;
    }
    box.innerHTML = [
        ...$a52c72724dfd3eca$var$highlightedSkillIds
    ].map((id)=>`<span class="item-filter-chip h-6" title="${(0, $42b272c2c0f44bdf$export$182937d2e68a339)(id)}">
            <span>${(0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(id)}</span>
            <span class="item-filter-chip-x" onclick="removeHighlightSkill('${id}')">\xd7</span>
        </span>`).join('');
}
// A separate badge row (skill icons) on each room that uses a selected skill,
// stacked below the item-drop badge so the two categories stay visually apart.
function $a52c72724dfd3eca$var$renderSkillBadges() {
    document.querySelectorAll('.skill-mark-badge').forEach((b)=>b.remove());
    if ($a52c72724dfd3eca$var$highlightedSkillIds.size === 0 || !$a52c72724dfd3eca$var$gridSkillIndex) return;
    const perCell = new Map();
    for (const id of $a52c72724dfd3eca$var$highlightedSkillIds){
        const icon = (0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(id);
        for (const { row: row, col: col } of $a52c72724dfd3eca$var$gridSkillIndex.skillToCells.get(id) || []){
            const key = `${row},${col}`;
            if (!perCell.has(key)) perCell.set(key, []);
            perCell.get(key).push(icon);
        }
    }
    for (const [key, icons] of perCell){
        const [row, col] = key.split(',');
        const cell = document.querySelector(`[data-row="${row}"][data-col="${col}"]`);
        if (!cell) continue;
        const shown = icons.slice(0, $a52c72724dfd3eca$var$MAX_BADGE_ICONS);
        const extra = icons.length - shown.length;
        const badge = document.createElement('div');
        badge.className = 'skill-mark-badge';
        badge.innerHTML = shown.map((ic)=>`<span>${ic}</span>`).join('') + (extra > 0 ? `<span class="item-drop-more">+${extra}</span>` : '');
        cell.appendChild(badge);
    }
}
function $a52c72724dfd3eca$var$removeHighlightSkill(id) {
    $a52c72724dfd3eca$var$highlightedSkillIds.delete(id);
    $a52c72724dfd3eca$var$renderSkillChips();
    $a52c72724dfd3eca$var$renderSkillBadges();
}
window.removeHighlightSkill = $a52c72724dfd3eca$var$removeHighlightSkill;
// Clear all skill highlights (Clear button), keeping the picker populated.
function $a52c72724dfd3eca$var$clearSkillHighlight() {
    $a52c72724dfd3eca$var$highlightedSkillIds.clear();
    $a52c72724dfd3eca$var$renderSkillChips();
    $a52c72724dfd3eca$var$renderSkillBadges();
}
window.clearSkillHighlight = $a52c72724dfd3eca$var$clearSkillHighlight;
function $a52c72724dfd3eca$export$59cebfb19ddd1f77() {
    $a52c72724dfd3eca$var$gridSkillIndex = null;
    $a52c72724dfd3eca$var$highlightedSkillIds = new Set();
    const select = document.getElementById('skill-highlight-picker');
    if (select) select.value = '';
    const chips = document.getElementById('skill-highlight-chips');
    if (chips) chips.innerHTML = '';
    document.querySelectorAll('.skill-mark-badge').forEach((b)=>b.remove());
}
// ============================================================================
// RAID PANEL TABS (Log | Loot) — the middle panel next to the map
// ============================================================================
let $a52c72724dfd3eca$var$activeRaidPanelTab = 'highlights';
function $a52c72724dfd3eca$export$a21eeedead301a30(name) {
    $a52c72724dfd3eca$var$activeRaidPanelTab = name;
    const panes = {
        highlights: document.getElementById('raid-highlights-pane'),
        log: document.getElementById('path-rooms'),
        loot: document.getElementById('raid-loot-pane'),
        team: document.getElementById('raid-team-pane')
    };
    Object.entries(panes).forEach(([key, el])=>{
        el?.classList.toggle('hidden', key !== name);
    });
    document.querySelectorAll('.raid-panel-tabs .char-subtab-btn').forEach((btn)=>{
        const on = btn.dataset.raidTab === name;
        btn.classList.toggle('active', on);
        btn.classList.toggle('bg-gradient-to-r', on);
        btn.classList.toggle('from-gray-700', on);
        btn.classList.toggle('to-gray-600', on);
    });
    if (name === 'log') {
        // scrollIntoView no-ops while the pane is display:none — re-sync now
        $a52c72724dfd3eca$export$f4fa7fe8ae486c6();
        $a52c72724dfd3eca$export$3de9c504cadcc6ea();
    } else if (name === 'loot') $a52c72724dfd3eca$export$cc4a7a45a09f1743();
    else if (name === 'highlights') $a52c72724dfd3eca$export$d72ea71bfd67dd40(); // refresh both filter pickers from the current grid
}
window.setRaidPanelTab = $a52c72724dfd3eca$export$a21eeedead301a30;
// Expand/collapse overrides for loot-tab cards (collapsed is the default).
// The pane re-renders on every loot change, so toggle state must live outside
// the DOM — same pattern as the gear tab's toggleGearExpand.
let $a52c72724dfd3eca$var$lootCardExpanded = new Set();
let $a52c72724dfd3eca$var$lastLootSignature = null;
function $a52c72724dfd3eca$var$toggleLootCardExpand(itemId) {
    if ($a52c72724dfd3eca$var$lootCardExpanded.has(itemId)) $a52c72724dfd3eca$var$lootCardExpanded.delete(itemId);
    else $a52c72724dfd3eca$var$lootCardExpanded.add(itemId);
    $a52c72724dfd3eca$var$lastLootSignature = null; // content unchanged, but the view must redraw
    $a52c72724dfd3eca$export$cc4a7a45a09f1743();
}
window.toggleLootCardExpand = $a52c72724dfd3eca$var$toggleLootCardExpand;
function $a52c72724dfd3eca$export$d955e43ec94b6b38() {
    $a52c72724dfd3eca$var$lootCardExpanded = new Set();
    $a52c72724dfd3eca$var$lastLootSignature = null;
}
function $a52c72724dfd3eca$export$cc4a7a45a09f1743() {
    const pane = document.getElementById('raid-loot-pane');
    if (!pane) return;
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    const completed = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo : null;
    const lootGained = raid?.lootGained ?? completed?.lootGained ?? null;
    const failed = !raid && completed && completed.raidSuccess === false;
    // Skip the redraw when nothing changed — the 1Hz raid tick would
    // otherwise wipe expand toggles and open tooltips every second
    const signature = JSON.stringify([
        lootGained,
        failed
    ]);
    if (signature === $a52c72724dfd3eca$var$lastLootSignature) return;
    $a52c72724dfd3eca$var$lastLootSignature = signature;
    if (!lootGained || Object.keys(lootGained).length === 0) {
        pane.innerHTML = '<p class="placeholder-text mt-2">Nothing collected yet.</p>';
        return;
    }
    const credits = lootGained.Credits || 0;
    let html = `
        <div class="flex items-center gap-2 my-2 text-yellow-300 font-bold">
            \u{1F4B0} Credits earned: ${credits.toLocaleString()}
        </div>`;
    if (failed) html += `<div class="text-red-400 text-sm mb-2">Raid failed \u{2014} recovered items were lost. Credits are kept.</div>`;
    // Sort by rarity ascending, then item name ascending; Fish (no catalog
    // entry) sorts last
    const rarityOrder = (r)=>$ce6dd72bc4611534$export$d4a72d069095e9e5?.[r]?.order ?? 99;
    const entries = Object.entries(lootGained).filter(([id, qty])=>id !== 'Credits' && qty).map(([id, qty])=>{
        if (id === 'Fish') return {
            id: id,
            qty: qty,
            order: 100,
            name: 'Fish',
            fish: true
        };
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
        return item ? {
            id: id,
            qty: qty,
            item: item,
            order: rarityOrder(item.rarity),
            name: item.name
        } : null;
    }).filter(Boolean).sort((a, b)=>a.order - b.order || a.name.localeCompare(b.name));
    const cards = entries.map((e)=>{
        if (e.fish) return `
                <div class="inv-card inv-card-collapsed relative rounded-lg border border-gray-600 bg-gray-800 px-3 py-2">
                    <div class="flex items-center">
                        <span class="font-bold text-gray-100 text-xs tracking-tighter">Fish</span>
                        <span class="ml-1 text-sm leading-none" title="Camp rations \u{2014} eaten at campsites, never banked">\u{1F41F}</span>
                    </div>
                    <div class="mt-2">
                        <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block">\xd7${e.qty}</div>
                    </div>
                </div>`;
        // Collapsed by default; player toggles are tracked in lootCardExpanded
        // so they survive the re-render (retarget the chevron like gear.js)
        const cardHtml = (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)({
            ...e.item,
            quantity: e.qty
        }, 'inventory', null, null, {
            hideActions: true,
            collapsed: !$a52c72724dfd3eca$var$lootCardExpanded.has(e.id)
        });
        return cardHtml.replaceAll('toggleInventoryCardCollapse(this);', `toggleLootCardExpand('${e.id}');`);
    });
    html += `
        <div class="grid gap-2 ${failed ? 'opacity-50' : ''}" style="grid-template-columns: repeat(auto-fit, 10rem); justify-content: center;">
            ${cards.map((c)=>`<div class="relative">${c}</div>`).join('')}
        </div>`;
    pane.innerHTML = html;
    window.reinitializeInventoryTooltips?.();
}
function $a52c72724dfd3eca$export$f2a0cf624bd292ab(row, col) {
    // Prevent path modification when raid is in progress or completed
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) return;
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridData) {
        const room = gridData.grid[row][col];
        // Handle path selection
        const isAlreadyInPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.some((p)=>p.row === row && p.col === col);
        if (isAlreadyInPath) {
            // Prevent unselecting the start room
            if (gridData.startPos && row === gridData.startPos.row && col === gridData.startPos.col) return;
            // Remove this room and all rooms after it from the path
            const index = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.findIndex((p)=>p.row === row && p.col === col);
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.slice(0, index);
        } else {
            // Add to path if it's a valid next step
            if ((0, $cc90b7944b7e868a$export$2a6c93141872f156)(row, col)) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.push({
                row: row,
                col: col,
                room: room
            });
            else // Provide specific feedback for different invalid move types
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) $a52c72724dfd3eca$export$b15c046faf64b0d4("Start your path by clicking the entry portal (\uD83C\uDF00)");
            else {
                const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
                const lastPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
                const lastRoom = gridData.grid[lastPos.row][lastPos.col];
                // Check if path already ends at exit
                if (lastRoom.type === 'exit') $a52c72724dfd3eca$export$b15c046faf64b0d4("Path complete! You've reached the exit portal \uD83C\uDF0C");
                else {
                    const maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
                    const currentStepCount = (0, $cc90b7944b7e868a$export$aedd9bb9e278a90a)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
                    // Check if path has reached maximum length (excluding roads)
                    if (currentStepCount >= maxPathLength) $a52c72724dfd3eca$export$b15c046faf64b0d4(`Path too long! Maximum length is ${maxPathLength} rooms (roads don't count)`);
                    else // Default adjacency message
                    $a52c72724dfd3eca$export$b15c046faf64b0d4('You can only move to adjacent rooms (up, down, left, right)');
                }
            }
        }
        $a52c72724dfd3eca$export$f4fa7fe8ae486c6();
        $a52c72724dfd3eca$export$c9b7157fc13410c5(); // Update room count in grid header
        $a52c72724dfd3eca$export$ed4907da7d4af889();
        $a52c72724dfd3eca$export$25fc6ae0ff69cc();
        $a52c72724dfd3eca$export$96635d91a6ab659a(); // Update energy/cooldown info
        $a52c72724dfd3eca$var$debouncedHighlightValidMoves();
        // Update contractor status indicators when path changes
        if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors')) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors').updateContractorStatuses();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    }
}
function $a52c72724dfd3eca$export$b15c046faf64b0d4(message) {
    // Create or update a temporary message display
    let messageDiv = document.getElementById('path-message');
    if (!messageDiv) {
        messageDiv = document.createElement('div');
        messageDiv.id = 'path-message';
        messageDiv.className = 'fixed top-5 right-5 bg-red-500/90 text-white px-4 py-2 rounded z-50 text-sm max-w-xs animate__animated';
        document.body.appendChild(messageDiv);
    }
    messageDiv.textContent = message;
    // Reset animation classes and trigger entrance animation
    messageDiv.classList.remove('hidden', 'animate__slideOutRight');
    messageDiv.classList.add('animate__slideInRight');
    // Auto-hide after 3 seconds with exit animation
    setTimeout(()=>{
        if (messageDiv) {
            messageDiv.classList.remove('animate__slideInRight');
            messageDiv.classList.add('animate__slideOutRight');
            // Hide after animation completes
            setTimeout(()=>{
                if (messageDiv) messageDiv.classList.add('hidden');
            }, 500);
        }
    }, 3000);
}
let $a52c72724dfd3eca$var$currentCalculationId = 0;
async function $a52c72724dfd3eca$export$c3f865504cdad6c4() {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Highlighting valid moves...');
    // Cancel any pending dim calculation
    $a52c72724dfd3eca$var$currentCalculationId++;
    const myCalculationId = $a52c72724dfd3eca$var$currentCalculationId;
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Starting new dim calculation ' + myCalculationId);
    // Remove existing valid move highlights only (keep dimming until new calculation finishes)
    document.querySelectorAll('.grid-cell').forEach((cell)=>{
        cell.classList.remove('valid-move');
    });
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (!gridData) return;
    // If path already ends at exit, dim all non-path rooms
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length > 0) {
        const lastPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
        const lastRoom = gridData.grid[lastPos.row][lastPos.col];
        if (lastRoom.type === 'exit') {
            // Path is complete, dim all rooms not in the path
            for(let row = 0; row < (gridData.rows || gridData.size); row++)for(let col = 0; col < (gridData.cols || gridData.size); col++){
                const isInPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.some((p)=>p.row === row && p.col === col);
                if (!isInPath) {
                    const cell = document.querySelector(`[data-row="${row}"][data-col="${col}"]`);
                    if (cell) cell.classList.add('raid-dimmed');
                }
            }
            return; // No need to process further
        }
    }
    // Calculate path constraints
    const maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
    const currentStepCount = (0, $cc90b7944b7e868a$export$aedd9bb9e278a90a)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
    const remainingSteps = maxPathLength - currentStepCount;
    // Debug logging
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Dimming calculation: maxPathLength=${maxPathLength}, currentStepCount=${currentStepCount}, remainingSteps=${remainingSteps}`);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) {
        // Highlight start position
        const startCell = document.querySelector(`[data-row="${gridData.startPos.row}"][data-col="${gridData.startPos.col}"]`);
        if (startCell) startCell.classList.add('valid-move');
        // Dim rooms that are too far from start to be reachable within path limits
        await $a52c72724dfd3eca$export$e39f4236aa572c6a(gridData, gridData.startPos, remainingSteps, myCalculationId);
    } else {
        // Highlight adjacent cells from current position
        const lastPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
        const atMaxSteps = currentStepCount >= maxPathLength;
        const adjacentPositions = [
            {
                row: lastPos.row - 1,
                col: lastPos.col
            },
            {
                row: lastPos.row + 1,
                col: lastPos.col
            },
            {
                row: lastPos.row,
                col: lastPos.col - 1
            },
            {
                row: lastPos.row,
                col: lastPos.col + 1
            } // Right
        ];
        adjacentPositions.forEach((pos)=>{
            // Check if position is within grid bounds
            if (pos.row >= 0 && pos.row < (gridData.rows || gridData.size) && pos.col >= 0 && pos.col < (gridData.cols || gridData.size)) {
                // Check if position is not already in path
                const isInPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.some((p)=>p.row === pos.row && p.col === pos.col);
                if (!isInPath) {
                    const room = gridData.grid[pos.row][pos.col];
                    // If at max steps, only highlight exit portal
                    if (atMaxSteps && room && room.type !== 'exit') return; // Skip highlighting non-exit cells
                    const cell = document.querySelector(`[data-row="${pos.row}"][data-col="${pos.col}"]`);
                    if (cell) cell.classList.add('valid-move');
                }
            }
        });
        // Dim rooms that are unreachable from current position within remaining path limits
        await $a52c72724dfd3eca$export$e39f4236aa572c6a(gridData, lastPos, remainingSteps, myCalculationId);
    }
}
// Create debounced version once to reuse
const $a52c72724dfd3eca$var$debouncedHighlightValidMoves = (0, $42b272c2c0f44bdf$export$61fc7d43ac8f84b0)($a52c72724dfd3eca$export$c3f865504cdad6c4, 250);
async function $a52c72724dfd3eca$export$e39f4236aa572c6a(gridData, currentPos, remainingSteps, calculationId) {
    const exitPos = gridData.endPos;
    // Collect cells to check (even with 0 remaining steps, roads/campsite might reach exit)
    const cellsToCheck = [];
    for(let row = 0; row < (gridData.rows || gridData.size); row++)for(let col = 0; col < (gridData.cols || gridData.size); col++){
        const room = gridData.grid[row][col];
        const isInPath = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.some((p)=>p.row === row && p.col === col);
        if (!isInPath && room && room.type !== 'blocked') cellsToCheck.push({
            row: row,
            col: col,
            room: room
        });
    }
    // Initialize workers if needed
    if (!(0, $9d958c644e098400$export$efe69f901af7b3f6)()) (0, $9d958c644e098400$export$720bfee83fe27440)();
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "checking rooms: ", cellsToCheck);
    // Use workers for parallel pathfinding
    const result = await $a52c72724dfd3eca$var$dimUnreachableRoomsParallel(gridData, currentPos, exitPos, remainingSteps, cellsToCheck, calculationId);
    // Check if this calculation is still valid (result will be null if cancelled)
    if (!result || calculationId !== $a52c72724dfd3eca$var$currentCalculationId) return; // Cancelled, don't apply results
    const dimmedCells = result;
    // Clear all dimming first, then apply new dimming
    document.querySelectorAll('.grid-cell').forEach((cell)=>{
        cell.classList.remove('raid-dimmed');
    });
    // Apply dimming to DOM
    for (const { row: row, col: col } of dimmedCells){
        const cell = document.querySelector(`[data-row="${row}"][data-col="${col}"]`);
        if (cell) cell.classList.add('raid-dimmed');
    }
}
async function $a52c72724dfd3eca$var$dimUnreachableRoomsParallel(gridData, currentPos, exitPos, remainingSteps, cellsToCheck, calculationId) {
    const pathfindingWorkers = (0, $9d958c644e098400$export$e25fa5fd5f04d38c)();
    const workerCount = pathfindingWorkers.length;
    const chunkSize = Math.ceil(cellsToCheck.length / workerCount);
    const promises = [];
    for(let i = 0; i < workerCount; i++){
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, cellsToCheck.length);
        const chunk = cellsToCheck.slice(start, end);
        if (chunk.length === 0) continue;
        const worker = pathfindingWorkers[i];
        const promise = new Promise((resolve)=>{
            const handler = (e)=>{
                // Check if this result is from a cancelled calculation
                if (e.data.calculationId !== calculationId) {
                    resolve(null); // Ignore old results
                    return;
                }
                resolve(e.data.dimmedCells);
            };
            // Remove old handler and add new one to avoid memory leaks
            worker.onmessage = handler;
            worker.postMessage({
                gridData: gridData,
                currentPos: currentPos,
                exitPos: exitPos,
                remainingSteps: remainingSteps,
                cellsToCheck: chunk,
                selectedPath: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath,
                calculationId: calculationId
            });
        });
        promises.push(promise);
    }
    const results = await Promise.all(promises);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "dimming results:", results);
    // If any result is null, the calculation was cancelled
    if (results.some((r)=>r === null)) return null;
    return results.flat();
}
/**
 * The leading icon of a log message, if it has one.
 *
 * Log messages arrive as one string with the icon baked into the front
 * ("📍 Entered Marketfront Depot"), which leaves nothing for the layout to grip:
 * the text cannot line up with the room name in the header while it is the same
 * text node as the glyph in front of it. Splitting the two gives `.log-line` a
 * real icon cell to centre and a real text cell to align.
 *
 * Extended_Pictographic alone is not enough — the log leads with ✓ ✗ ⚠️ 🛣️ as
 * well, so the ranges cover arrows and dingbats, and the optional VS16 and ZWJ
 * runs keep multi-codepoint emoji (🏃‍♀️‍➡️) in one piece rather than splitting
 * them mid-sequence. Verified against all 18 distinct leading tokens in a real
 * raid's 155 messages; the only two that do not match are genuinely icon-less
 * ("Path planned: ...") and correctly fall through to the text column.
 */ const $a52c72724dfd3eca$var$LOG_ICON = /^((?:\p{Extended_Pictographic}|[←-⇿⌀-➿⬀-⯿])️?(?:‍(?:\p{Extended_Pictographic}|[←-⇿⌀-➿⬀-⯿])️?)*)\s+/u;
function $a52c72724dfd3eca$export$db35362777aa005a(message, type) {
    const match = message.match($a52c72724dfd3eca$var$LOG_ICON);
    const icon = match ? match[1] : '';
    const body = match ? message.slice(match[0].length) : message;
    const typeClass = type ? ` log-${type}` : '';
    return `<div class="log-line tracking-tighter my-1${typeClass}">` + `<span class="log-icon">${icon}</span>` + `<div class="log-text mr-1">${body}</div>` + `</div>`;
}
function $a52c72724dfd3eca$export$8c20d1ca09eb894f(stepIndex) {
    if (!isNaN(stepIndex) && stepIndex >= 0) {
        const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid;
        // In-progress logs first, then the completed raid's — the same shape
        // either way, so the rendering is shared rather than duplicated.
        const stepLogs = raid.raidInProgress && raid.raidInProgress.stepLogs?.[stepIndex] || raid.raidCompleted && raid.completedRaidInfo?.stepLogs?.[stepIndex];
        if (stepLogs) return stepLogs.map((log)=>$a52c72724dfd3eca$export$db35362777aa005a(log.message, log.type)).join('');
    }
    // Default placeholder when no logs exist yet
    return $a52c72724dfd3eca$export$db35362777aa005a('No activity yet.');
}
function $a52c72724dfd3eca$export$f4fa7fe8ae486c6() {
    const pathContainer = document.getElementById('path-rooms');
    if (pathContainer) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) {
            pathContainer.innerHTML = '<p class="text-gray-500">Click rooms to build your path</p>';
            return;
        }
        const pathHtml = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.map((step, index)=>{
            const room = step.room;
            const roomIcon = (0, $42b272c2c0f44bdf$export$dd077d95a65121be)(room.name, room.type);
            const styleHiddenIfRaidInProgress = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted ? 'hidden' : '';
            const styleHiddenIfRaidNotStarted = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted ? '' : 'hidden';
            const isCurrentRoom = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex === index;
            const currentStepClass = isCurrentRoom ? 'current-step' : '';
            //console.log(`Rendering path step ${index}: ${room.name} (${room.type})`);
            //console.log('Raid in progress:', gameState.currentRaid.raidInProgress);
            if (room.type === 'start') return `
                    <div class="path-step" data-step-index="${index}">
                        <div class="path-room">
                            <div class="path-room-header gap-2">
                                <div class="step-number ${currentStepClass}">${roomIcon}</div>
                                <strong>${room.name}</strong>
                            </div>
                            <div class="path-room-details ${styleHiddenIfRaidInProgress}">
                                <span class="text-green-500 px-2">Entry point for the raid</span>
                            </div>
                            <div class="path-room-log ${styleHiddenIfRaidNotStarted}">
                                ${$a52c72724dfd3eca$export$8c20d1ca09eb894f(index)}
                            </div>
                        </div>
                    </div>
                `;
            else if (room.type === 'exit') return `
                    <div class="path-step" data-step-index="${index}">
                        <div class="path-room">
                            <div class="path-room-header gap-2">
                                <div class="step-number ${currentStepClass}">${roomIcon}</div>
                                <strong>${room.name}</strong>
                            </div>
                            <div class="path-room-details ${styleHiddenIfRaidInProgress}">
                                <span class="text-game-gold px-2">Exit point for the raid</span>
                            </div>
                            <div class="path-room-log ${styleHiddenIfRaidNotStarted}">
                                ${$a52c72724dfd3eca$export$8c20d1ca09eb894f(index)}
                            </div>
                        </div>
                    </div>
                `;
            else if (room.type === 'road' || room.type === 'campsite' || room.type === 'water') {
                const successPercentage = 100;
                const successColor = '#4caf50';
                const roomDuration = room.baseDuration;
                const lootItemsHtml = room.type === 'water' ? $a52c72724dfd3eca$export$1967c0c6b54773a5(1, room) : 'None';
                return `
                    <div class="path-step" data-step-index="${index}">
                        <div class="path-room">
                            <div class="path-room-header gap-2">
                                <div class="step-number ${currentStepClass}">${roomIcon}</div>
                                <!-- No type tag here. These three rooms are named exactly after
                                     their type \u{2014} "Road", "Water", "Campsite" \u{2014} so a "(ROAD)" beside
                                     "Road" restated the word next to it. The gate and hazard tags
                                     earn their place by carrying a risk mark; there is no risk to
                                     mark on a room where no encounter runs, which is what the
                                     absence of a tag now says. -->
                                <div class="leading-[1]">${room.name}</div>
                                <div class="flex-col leading-[1]">
                                    <div class="">\u{23F1}\u{FE0F}${roomDuration}</div>
                                    <div class="" style="color: ${successColor};">\u{1F3AF}${successPercentage}%</div>
                                </div>
                            </div>
                            <div class="path-room-details" ${styleHiddenIfRaidInProgress}>
                                <div class="loot-section">
                                    <div class="hidden loot-header cursor-pointer flex items-center justify-between bg-gray-700/40 px-2 py-1 rounded hover:bg-gray-600/40" onclick="this.parentElement.classList.toggle('expanded')">
                                        <span class="text-sm font-bold">\u{1F4B0} Possible Loot</span>
                                        <span class="expand-icon text-xs">\u{25BC}</span>
                                    </div>
                                    <div class="loot-content hidden mt-1 pl-2">
                                        ${lootItemsHtml}
                                    </div>
                                </div>
                            </div>                        
                            <div class="path-room-log ${styleHiddenIfRaidNotStarted}">
                                ${$a52c72724dfd3eca$export$8c20d1ca09eb894f(index)}
                            </div>
                        </div>
                    </div>
                `;
            } else {
                const faction = Object.values($ce6dd72bc4611534$export$aeeef991191508e2).find((f)=>Object.keys(f.skills).includes(room.primary));
                const primaryFactionKey = faction ? Object.keys($ce6dd72bc4611534$export$aeeef991191508e2).find((k)=>$ce6dd72bc4611534$export$aeeef991191508e2[k] === faction) : 'dominion';
                const primarySkillName = $ce6dd72bc4611534$export$aeeef991191508e2[primaryFactionKey].skills[room.primary]?.name || room.primary;
                // Get team skills for coverage checking
                const teamSkills = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1)();
                const region = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid?.region;
                const raidTier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid?.tier;
                // Calculate success chance (folds in the team's equipped-gear
                // expected bonus, same clamp as the runtime formula)
                const successChance = (0, $cc90b7944b7e868a$export$278313c6a8f74dd)(room, teamSkills, raidTier, (0, $cc90b7944b7e868a$export$c41f4a6445888331)());
                const successPercentage = Math.round(successChance * 100);
                // The mark and the percentage beside it now come off the SAME
                // number and the SAME thresholds, so they cannot say different
                // things about the same room.
                const roomStatus = (0, $cc90b7944b7e868a$export$ac3767a8a135daf7)(successChance);
                const successColor = successChance >= (0, $cc90b7944b7e868a$export$1b78a23f03a8d95f) ? '#4caf50' : successChance >= (0, $cc90b7944b7e868a$export$e19e68234418033a) ? '#ff9800' : '#ff6b6b';
                const roomDuration = room.baseDuration;
                // Get possible loot with icons
                //const possibleLoot = getPossibleRoomLoot(room, raidTier);
                const lootItemsHtml = $a52c72724dfd3eca$export$1967c0c6b54773a5(raidTier, room);
                // Primary skill with team level and coverage
                const roomTypeMark = room.type === 'gate' ? "\u25CF\u25CF" : "\u25CF";
                const primaryTeamLevel = teamSkills[room.primary] || 0;
                const primaryCovered = primaryTeamLevel > 0;
                const primarySkillIcon = (0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(room.primary);
                const primaryCoverageIcon = primaryCovered ? "\u2713" : "\u2717";
                const primaryCoverageColor = primaryCovered ? '#4caf50' : '#ff6b6b';
                const supportSkills = room.support.map((skill)=>{
                    const skillFaction = Object.values($ce6dd72bc4611534$export$aeeef991191508e2).find((f)=>Object.keys(f.skills).includes(skill));
                    const factionKey = skillFaction ? Object.keys($ce6dd72bc4611534$export$aeeef991191508e2).find((k)=>$ce6dd72bc4611534$export$aeeef991191508e2[k] === skillFaction) : 'dominion';
                    const skillName = $ce6dd72bc4611534$export$aeeef991191508e2[factionKey].skills[skill]?.name || skill;
                    const skillIcon = (0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(skill);
                    // Support skill team level and coverage
                    const supportTeamLevel = teamSkills[skill] || 0;
                    const supportCovered = supportTeamLevel > 0;
                    const supportCoverageIcon = supportCovered ? "\u2713" : "\u2717";
                    const supportCoverageColor = supportCovered ? '#4caf50' : '#ff6b6b';
                    return `<div class="p-1">${skillIcon} ${skillName}</div> <div class="p-1 font-bold" style="color: ${supportCoverageColor};">${supportCoverageIcon}${supportTeamLevel}</div>`;
                }).join('');
                return `
                    <div class="path-step" data-step-index="${index}">
                        <div class="path-room">
                            <div class="path-room-header gap-2">
                                <div class="step-number ${currentStepClass}">${(0, $cc90b7944b7e868a$export$86025a0d632dc830)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, index)}</div>                            
                                <!-- The same tag the map tile carries: \u{25CF}\u{25CF} for a gate, \u{25CF} for a
                                     hazard, then the risk mark. Built from getRoomOddsStatus off
                                     the SAME chance the \u{1F3AF} percentage to the right prints, so the
                                     mark and the number on this one line cannot contradict each
                                     other, and so the log and the map cannot disagree either.
                                     It used to read (GATE)/(HAZARD) coloured by TYPE, which said
                                     the same thing the room name already did and left the risk \u{2014}
                                     the part worth knowing at a glance \u{2014} only on the map. -->
                                <div class="leading-[1]">${room.name} <span class="room-tag text-xs ${roomStatus.indicator}"><span class="mr-1">${roomTypeMark}</span>${roomStatus.symbol}</span></div>
                                <div class="flex-col leading-[1]">
                                    <div class="">\u{23F1}\u{FE0F}${roomDuration}</div>
                                    <div class="" style="color: ${successColor};">\u{1F3AF}${successPercentage}%</div>
                                </div>
                            </div>
                            <div class="path-room-skills" ${styleHiddenIfRaidInProgress}>
                                <div class="primary-skill-column text-sm">
                                    <div class="bg-gray-600/50 p-1 font-bold">\u{2B50} Primary</div>
                                    <div class="grid grid-cols-[auto_fit-content(100%)]">
                                        <div class="p-1">${primarySkillIcon} ${primarySkillName}</div>
                                        <div class="p-1 font-bold" style="color: ${primaryCoverageColor};">${primaryCoverageIcon}${primaryTeamLevel}</div>
                                    </div>
                                </div>
                                <div class="support-skills-column text-sm">
                                    <div class="bg-gray-600/50 p-1 font-bold">\u{1F527} Support</div>
                                    <div class="grid grid-cols-[auto_fit-content(100%)]">
                                        ${supportSkills || '<div class="p-1 text-gray-500 italic">No support skills</div>'}
                                    </div>
                                </div>
                            </div>
                            <div class="path-room-details" ${styleHiddenIfRaidInProgress}>
                                <div class="loot-section">
                                    <div class="loot-header cursor-pointer flex items-center justify-between bg-gray-700/40 px-2 py-1 rounded hover:bg-gray-600/40" onclick="this.parentElement.classList.toggle('expanded')">
                                        <span class="text-sm font-bold">\u{1F4B0} Possible Loot</span>
                                        <span class="expand-icon text-xs">\u{25BC}</span>
                                    </div>
                                    <div class="loot-content hidden mt-1 pl-2">
                                        ${lootItemsHtml}
                                    </div>
                                </div>
                            </div>
                            <div class="path-room-log" ${styleHiddenIfRaidNotStarted}>
                                ${$a52c72724dfd3eca$export$8c20d1ca09eb894f(index)}
                            </div>
                        </div>
                    </div>
                `;
            }
        }).join('');
        pathContainer.innerHTML = pathHtml;
    }
}
function $a52c72724dfd3eca$export$c9b7157fc13410c5() {
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    const roomCountElement = document.getElementById('grid-room-count');
    if (!gridData || !roomCountElement) return;
    // Calculate and update room count
    const maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
    const currentStepCount = (0, $cc90b7944b7e868a$export$aedd9bb9e278a90a)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
    roomCountElement.textContent = `${currentStepCount} / ${maxPathLength}`;
    // Update styling based on limit
    if (currentStepCount >= maxPathLength) roomCountElement.classList.add('at-limit');
    else roomCountElement.classList.remove('at-limit');
}
function $a52c72724dfd3eca$export$ed4907da7d4af889() {
    // Exit early if raid is completed - don't override completed raid visualization
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Skipping grid path highlight - raid is completed');
        return;
    }
    // Clear all path highlights and path numbers
    document.querySelectorAll('.grid-cell').forEach((cell)=>{
        cell.classList.remove('path', 'selected');
        const pathNumber = cell.querySelector('.path-number');
        if (pathNumber) pathNumber.remove();
    });
    // Highlight path and add numbers
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach((step, index)=>{
        const cell = document.querySelector(`[data-row="${step.row}"][data-col="${step.col}"]`);
        if (cell) {
            cell.classList.add('path');
            if (index === (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1) cell.classList.add('selected');
            // Add path number for non-start/end rooms
            if (step.room.type !== 'start' && step.room.type !== 'exit' && index > 0) {
                const pathNumber = document.createElement('div');
                pathNumber.className = '';
                // Show dash for roads, step number for gates/hazards
                pathNumber.textContent = (0, $cc90b7944b7e868a$export$86025a0d632dc830)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, index);
                pathNumber.className = 'path-number absolute bottom-1 right-1 bg-white/50 text-black rounded-full w-5 h-5 text-sm flex items-center justify-center font-bold shadow-md z-10';
                cell.appendChild(pathNumber);
            }
        }
    });
}
function $a52c72724dfd3eca$export$25fc6ae0ff69cc() {
    const startBtn = document.getElementById('start-raid');
    if (startBtn) {
        const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
        if (gridData) {
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) {
                startBtn.disabled = true;
                return;
            }
            // Check if path is valid (starts at start, ends at exit)
            const pathValid = (0, $cc90b7944b7e868a$export$a678af82bf766611)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, gridData);
            startBtn.disabled = !pathValid;
        }
    }
}
function $a52c72724dfd3eca$export$d6f634bba1273a2b() {
    const currentRaidInfo = document.getElementById('current-raid-info');
    if (currentRaidInfo) {
        //console.log('region and tier', gameState.currentRaid.selectedRegion, gameState.currentRaid.selectedTier);
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier) {
            currentRaidInfo.innerHTML = '';
            return;
        }
        const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion];
        const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier;
        const tierInfo = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
        currentRaidInfo.innerHTML = `
            <div class="path-info-region inline-block text-white">${region.name}</div> // 
            <div class="path-info-tier inline-block text-game-gold">${tierInfo.name}</div>
        `;
    }
}
const $a52c72724dfd3eca$export$42079bc77e782d23 = [
    'raid-planning',
    'raid-in-progress',
    'raid-completed'
];
function $a52c72724dfd3eca$export$2d4508142cc72b6e() {
    const grid = document.getElementById('raid-grid');
    if (!grid) return null;
    const state = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidCompleted ? 'raid-completed' : (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress ? 'raid-in-progress' : 'raid-planning';
    // toggle(name, bool) for all three rather than remove-then-add: it cannot
    // leave a stale one behind, which is the failure mode the `raid-cols-N`
    // classes have to hand-guard against a few lines below.
    for (const cls of $a52c72724dfd3eca$export$42079bc77e782d23)grid.classList.toggle(cls, cls === state);
    return state;
}
function $a52c72724dfd3eca$export$cf8b2a65252147ea() {
    const gridContainer = document.getElementById('raid-grid');
    // Lights Out masks unvisited rooms. A class on the container rather than
    // per-cell state: the reveal condition is classes the raid progression
    // already maintains, so CSS can express the whole rule (see styles.css).
    gridContainer?.classList.toggle('blackout-dark', !!(0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('noGridPreview', false));
    $a52c72724dfd3eca$export$2d4508142cc72b6e();
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridContainer && gridData) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Displaying raid grid...');
        gridContainer.innerHTML = '';
        (0, $a3c9aff5a6eec062$export$72b470d5f7d48c79)();
        // Where on the planet this grid is, for the day clock (M3 S9). Set
        // before the cells register so the very first frame draws the right sky.
        (0, $a3c9aff5a6eec062$export$bcbc425da348b5df)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidSite);
        // Use cols/rows for grid template, fallback to size for backward compatibility
        const gridCols = gridData.cols || gridData.size;
        const gridRows = gridData.rows || gridData.size;
        gridContainer.classList.remove("raid-cols-7", "raid-cols-13", "raid-cols-17");
        gridContainer.classList.add("raid-cols-" + gridCols);
        gridContainer.style.gridTemplateColumns = `repeat(${gridCols}, 1fr)`;
        // Set viewport height based on number of rows and cell size
        // Mobile: 64px cells (w-16 h-16), Desktop: 80px cells (md:w-20 md:h-20)
        // Plus padding and gap
        const viewport = document.getElementById('raid-grid-viewport');
        if (viewport) {
            const cellHeight = 80;
            const gap = 0; // seamless map — tiles butt up against each other
            const paddingAndBorder = 18;
            const viewportSize = cellHeight * gridRows + gap * (gridRows - 1) + paddingAndBorder * 2 + (gridCols > 7 ? 15 : 0);
            viewport.style.height = `${viewportSize}px`;
            viewport.style.width = `${viewportSize}px`;
        }
        // Get current team skills for skill checking. Both hoisted out of the
        // per-cell loop: a tier-3 grid is 119 cells and neither answer varies
        // between them.
        const teamSkills = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1)();
        const teamTechniques = (0, $cc90b7944b7e868a$export$c41f4a6445888331)();
        // Traversable-neighbour flags. These no longer drive the roadway —
        // roads come from the generated network stamped on each room — but the
        // renderer still takes conn for things that key off open sides.
        const isOpen = (r, c)=>r >= 0 && c >= 0 && r < gridRows && c < gridCols && gridData.grid[r][c] && gridData.grid[r][c].type !== 'blocked';
        for(let row = 0; row < gridRows; row++)for(let col = 0; col < gridCols; col++){
            //console.log(`Rendering cell at (${row},${col})`);
            const room = gridData.grid[row][col];
            const conn = {
                n: isOpen(row - 1, col),
                s: isOpen(row + 1, col),
                e: isOpen(row, col + 1),
                w: isOpen(row, col - 1)
            };
            const cell = document.createElement('div');
            // Base cell class with Tailwind + custom CSS
            let cellClasses = `grid-cell ${room.type} w-16 h-16 md:w-20 md:h-20 flex items-center justify-center cursor-pointer font-bold relative`;
            // Skill status is now only shown via indicators, not cell classes
            cell.className = cellClasses;
            cell.dataset.row = row;
            cell.dataset.col = col;
            // Room tooltips handled by existing showRoomTooltip system
            const roomIcon = (0, $42b272c2c0f44bdf$export$dd077d95a65121be)(room.name, room.type);
            // Overlay markup per cell type; the animated tile canvas is
            // prepended below it by registerAnimCell
            if (room.type === 'blocked') cell.innerHTML = `
                        <div class="room-content blocked-cell">
                        </div>
                    `;
            else if (room.type === 'road' || room.type === 'campsite' || room.type === 'water') cell.innerHTML = `
                        <div class="room-content room-with-background">
                            <div class="room-overlay"></div>
                        </div>
                    `;
            else {
                // The room's odds at a glance, off the same number and the
                // same thresholds the raid log prints as `🎯 N%`. Hovering
                // the tile explains WHY in words — that is where coverage
                // (which skill is missing) still lives.
                let roomIndicator = '';
                if (room.type !== 'start' && room.type !== 'exit') {
                    const odds = (0, $cc90b7944b7e868a$export$ac3767a8a135daf7)((0, $cc90b7944b7e868a$export$278313c6a8f74dd)(room, teamSkills, gridData.tier, teamTechniques));
                    const typeIndicator = room.type === 'gate' ? "\u25CF\u25CF" : "\u25CF";
                    roomIndicator = `<div class="skill-indicator tracking-widest ${odds.indicator}">
                            <span class="mr-1">${typeIndicator}</span>${odds.symbol}
                        </div>`;
                }
                cell.innerHTML = `
                        <div class="room-content room-with-background">
                            ${roomIndicator}
                        </div>
                    `;
            }
            (0, $a3c9aff5a6eec062$export$5f82487e371f5e57)(cell, room, conn, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion);
            // Add click handler
            cell.addEventListener('click', ()=>$a52c72724dfd3eca$export$f2a0cf624bd292ab(row, col));
            // Hover handlers for the room tooltip.
            //
            // Pointer events rather than mouse events, and touch is skipped
            // explicitly: a tap on iPad synthesises mouseenter but never a
            // matching mouseleave, so the tooltip parked itself beside the
            // tapped tile and covered its neighbours for the rest of the
            // planning session. Nothing dismissed it, because there is no
            // "move away" on a touchscreen.
            //
            // Filtering per EVENT beats a device-wide `(hover: none)` query:
            // an iPad with a trackpad, or an Apple Pencil hovering (pen), is
            // a real hover and still gets the tooltip — only the finger is
            // excluded. pageX/pageY come along, since PointerEvent extends
            // MouseEvent.
            const hoverOnly = (handler)=>(e)=>{
                    if (e.pointerType !== 'touch') handler(e);
                };
            cell.addEventListener('pointerenter', hoverOnly((e)=>$a52c72724dfd3eca$export$b127b30033aaeba9(e, room)));
            cell.addEventListener('pointerleave', $a52c72724dfd3eca$export$a23289342bf715b2);
            cell.addEventListener('pointermove', hoverOnly($a52c72724dfd3eca$export$7fa52bbeeb0b31af));
            gridContainer.appendChild(cell);
        }
        // Room tooltips use the existing custom system
        // Match path-rooms height to grid height after grid is rendered
        setTimeout($a52c72724dfd3eca$export$d86087c4a9b82d46, 1000);
    }
}
function $a52c72724dfd3eca$export$d86087c4a9b82d46() {
    const gridData = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridData) {
        const raidGrid = document.getElementById('raid-grid');
        const pathRooms = document.getElementById('path-info');
        //console.log('MatchPathRoomsHeight', raidGrid, pathRooms);
        if (raidGrid && pathRooms) {
            // Measure the map column (day-clock bar + grid viewport) directly
            // so the panel's bottom always lines up with the grid's bottom —
            // the old arithmetic drifted whenever grid CSS changed
            const mapSection = document.querySelector('.map-section');
            let gridHeight = 0;
            if (!gridHeight) {
                const cellHeight = 80;
                const paddingAndBorder = 18;
                gridHeight = cellHeight * gridData.rows + paddingAndBorder * 2 + (gridData.cols > 7 ? 15 : 0);
            }
            pathRooms.style.height = `${gridHeight}px`;
            pathRooms.style.maxHeight = `${gridHeight}px`; // Keep dynamic height matching
        //pathRooms.style.maxWidth = `${gridHeight*1.5}px`;
        }
    }
}
function $a52c72724dfd3eca$export$3de9c504cadcc6ea(stepIndex = null) {
    const pathRooms = document.getElementById('path-rooms');
    if (!pathRooms) return;
    // Determine which step to focus
    let focusStepIndex;
    if (stepIndex !== null) focusStepIndex = stepIndex;
    else if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        const currentStepIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex;
        focusStepIndex = currentStepIndex > 0 ? currentStepIndex : currentStepIndex == (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1 ? currentStepIndex : 0;
    } else return;
    // Find the step element
    const focusStepElement = pathRooms.querySelector(`[data-step-index="${focusStepIndex}"]`);
    if (focusStepElement) {
        // Scroll the step to the top with smooth animation
        focusStepElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Scrolled to step index ${focusStepIndex}`);
    }
}
/**
 * Keep the crew count on the Map pane, under the planned-path line.
 *
 * Playtest feedback was that people did not know how or when to add
 * contractors. The Reserve buttons work and are where you would expect them —
 * on the empty slots — but they live inside a panel tab that is NOT the one
 * the planner opens on (🗺️ Map), so a player can pick a region, chart a path
 * and launch without ever seeing that a team exists. Nothing else on the
 * planner mentions it, and a solo raid is perfectly legal, so there is no error
 * state to bump into either.
 *
 * It sits beside the planned-path count rather than on the tab itself: the tab
 * row has to fit a tablet, and a count there pushed the four tabs too wide.
 * Here it is next to the thing it crews, on the pane the player is already
 * reading while they plan.
 *
 * A count informs without nagging, which is deliberate — going alone is a real
 * choice, since contractors take a share of the credits.
 */ function $a52c72724dfd3eca$var$updateTeamCountLine(teamSize, maxMembers) {
    const el = document.getElementById('grid-team-count');
    if (!el) return;
    el.textContent = `${teamSize} / ${maxMembers}`;
    el.parentElement?.classList.toggle('at-limit', teamSize >= maxMembers);
}
function $a52c72724dfd3eca$export$b70ccd83fb3eaefa() {
    const teamDisplay = document.getElementById('grid-team-display');
    const costDisplay = document.getElementById('team-cost-display');
    if (!teamDisplay || !costDisplay) return;
    // Get current active character
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (!currentCharacter) {
        teamDisplay.innerHTML = '<p class="text-gray-500">Create a character first</p>';
        costDisplay.textContent = 'Contractor Share: 0% of raid credits';
        $a52c72724dfd3eca$var$updateTeamCountLine(0, 3);
        return;
    }
    const raidTeam = (0, $cc90b7944b7e868a$export$d17f5534c14b3dc5)();
    // Build team members array with rendered cards for carousel
    const maxMembers = 3;
    $a52c72724dfd3eca$var$updateTeamCountLine(raidTeam.length, maxMembers);
    const teamMembers = [];
    const pathSkills = (0, $cc90b7944b7e868a$export$1311cf265aa89b71)();
    const teamSkills = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1)();
    // Add actual team members
    raidTeam.forEach((member)=>{
        teamMembers.push({
            id: member.id,
            html: (0, $bd083a63eb37c143$export$5464865996ba2eb4)(member, 'team', pathSkills, teamSkills)
        });
    });
    // Add placeholder cards for empty team slots
    const emptySlots = maxMembers - raidTeam.length;
    for(let i = 0; i < emptySlots; i++){
        const context = 'empty-first';
        teamMembers.push({
            id: `empty-${i}`,
            html: (0, $bd083a63eb37c143$export$5464865996ba2eb4)('empty', context)
        });
    }
    (0, $10132d7a74b781c4$export$f1143e4c4cd76114)(teamDisplay, teamMembers);
    // Update percentage share
    const totalPercentage = raidTeam.reduce((sum, contractor)=>sum + (contractor.rewardPercentage ? contractor.rewardPercentage : 0), 0);
    costDisplay.textContent = `Contractor Share: ${totalPercentage}% of raid credits`;
    // Update color classes based on percentage
    costDisplay.className = costDisplay.className.replace(/text-red-500|text-yellow-500|text-green-500/g, '');
    if (totalPercentage > 50) costDisplay.classList.add('text-red-500');
    else if (totalPercentage > 25) costDisplay.classList.add('text-yellow-500');
    else costDisplay.classList.add('text-green-500');
}
function $a52c72724dfd3eca$export$68c4600b33dd0ca8() {
    // Refresh the grid display to update skill indicators (only if raid grid is active and skills changed)
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Refreshing raid grid for team update');
        $a52c72724dfd3eca$export$cf8b2a65252147ea();
        // Restore path highlighting after grid refresh
        $a52c72724dfd3eca$export$ed4907da7d4af889();
        $a52c72724dfd3eca$var$debouncedHighlightValidMoves();
        // Restore the item-drop badges (displayRaidGrid rebuilt the cells)
        $a52c72724dfd3eca$export$edb541e336ea9a21();
    }
}
async function $a52c72724dfd3eca$export$e4c69cea9b646118(contractorId) {
    if (isNaN(contractorId)) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Invalid contractor id: ${contractorId}`);
        return;
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Releasing reserved contractor ${contractorId}`);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'isContractorReserved:', (0, $cc90b7944b7e868a$export$595cb98aec43dd71)(contractorId));
    if (!(0, $cc90b7944b7e868a$export$595cb98aec43dd71)(contractorId)) return;
    // Find the contractor to check if it's a marketplace contractor
    const contractor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.find((c)=>c.id == contractorId);
    // If it's a marketplace contractor (positive ID), release via server
    if (contractor && contractorId > 0) {
        const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
        if (currentCharacter) try {
            const result = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseContractor(contractorId, currentCharacter.multiplayerId);
            if (!result.success) {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Failed to release contractor: ${result.message}`, 'error');
                return;
            }
        } catch (error) {
            console.error('Error releasing marketplace contractor:', error);
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Failed to release contractor - network error', 'error');
            return;
        }
    }
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter((c)=>c.id != contractorId);
    // Update Alpine store
    if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors')) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors').updateReserved((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors);
    $a52c72724dfd3eca$export$b70ccd83fb3eaefa();
    $a52c72724dfd3eca$export$68c4600b33dd0ca8();
    $a52c72724dfd3eca$export$f4fa7fe8ae486c6(); // Update current path skill coverage
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
async function $a52c72724dfd3eca$export$1de8727a75eb95ee(contractorId) {
    if (!(0, $cc90b7944b7e868a$export$4c8adf450afe39a2)(contractorId)) return;
    // Find the contractor to check if it's a marketplace contractor
    const contractor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.find((c)=>c.id == contractorId);
    // If it's a marketplace contractor (positive ID), release via server
    if (contractor && contractorId > 0) {
        const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
        if (currentCharacter) try {
            const result = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseHiredContractor(contractorId, currentCharacter.multiplayerId);
            if (!result.success) {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Failed to release hired contractor: ${result.message}`, 'error');
                return;
            }
        } catch (error) {
            console.error('Error releasing hired marketplace contractor:', error);
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Failed to release hired contractor - network error', 'error');
            return;
        }
    }
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.filter((c)=>c.id != contractorId);
    (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors').refresh();
    $a52c72724dfd3eca$export$b70ccd83fb3eaefa();
    $a52c72724dfd3eca$export$f4fa7fe8ae486c6(); // Update current path skill coverage
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
async function $a52c72724dfd3eca$export$bb6b71fe7f08b971({ automated: automated = false } = {}) {
    // Validate we can start a raid
    if (!(0, $cc90b7944b7e868a$export$81a3d8aa8b7e7939)()) return;
    // Route bonus-loot and fishing events through the clickable browser
    // presenters (player must click to collect) — UNLESS this raid is running
    // hands-off, in which case the headless auto-grant collects them instead.
    // Nobody is watching an automated raid to click a diamond, so the
    // collectible would expire and take its loot with it.
    (0, $cb32f532d45e570f$export$93eaf817d66094f2)({
        automated: automated
    });
    // Drop the planning-only item highlight + picker before the raid begins,
    // and land the player on the log tab with a fresh loot pane
    $a52c72724dfd3eca$export$6c9e89b1ffed34d7();
    $a52c72724dfd3eca$export$d955e43ec94b6b38();
    $a52c72724dfd3eca$export$a21eeedead301a30('log');
    // Start raid execution
    await (0, $cc90b7944b7e868a$export$43eae605f498c00a)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    // Raid started notification
    const overallSuccessChance = Math.round((0, $cc90b7944b7e868a$export$26622a6bc351fd6d)() * 100, 1);
    const region = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F680} Starting raid on ${region.name}...`, 'info', {
        stepIndex: 0
    });
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4AA} Team assembled: ${1 + (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length} members`, 'info', {
        stepIndex: 0,
        notify: false
    });
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`\u{1F4AA} Team Status - Total HP: ${(0, $cc90b7944b7e868a$export$d17f5534c14b3dc5)().reduce((sum, member)=>sum + member.currentHp, 0)}`, 'info', {
        stepIndex: 0,
        notify: false
    });
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`Path planned: ${(0, $cc90b7944b7e868a$export$aedd9bb9e278a90a)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath)} rooms to traverse`, 'info', {
        stepIndex: 0,
        notify: false
    });
    (0, $00c60928d2fcd8b8$export$fd59807889add359)(`Chance of looting all rooms: ${overallSuccessChance}%`, 'info', {
        stepIndex: 0,
        notify: false
    });
    // Update UI elements
    $a52c72724dfd3eca$export$b70ccd83fb3eaefa();
    $a52c72724dfd3eca$export$68c4600b33dd0ca8();
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)(); //top raid button
    //updateRaidGridForProgress(); // Called in loopRaidProgression
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    $a52c72724dfd3eca$export$96635d91a6ab659a();
    // Start the raid progression timer
    $a52c72724dfd3eca$export$46938b5e497922ff();
}
function $a52c72724dfd3eca$export$46938b5e497922ff() {
    const beginningStepIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress?.currentRoomIndex || 0;
    $a52c72724dfd3eca$export$ed22353f8399566f();
    const endingStepIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress?.currentRoomIndex || 0;
    // Update the log messages in the path display
    $a52c72724dfd3eca$export$f4fa7fe8ae486c6();
    // Scroll to current step in path display
    if (endingStepIndex != beginningStepIndex) {
        setTimeout($a52c72724dfd3eca$export$3de9c504cadcc6ea, 1000);
        // Persist raid progress (currentRoomIndex, stepLogs, room timing) on every room
        // transition so a mid-raid reload restores the exact room with its log history
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    }
    $a52c72724dfd3eca$export$b70ccd83fb3eaefa();
    // updateGridDisplay();
    // Update the path display to refresh timer
    $a52c72724dfd3eca$export$f4fa7fe8ae486c6();
    // Update grid to refresh timer display
    $a52c72724dfd3eca$export$17436b2a8cf51f27();
    // Keep the loot tab live while it's the visible pane
    if ($a52c72724dfd3eca$var$activeRaidPanelTab === 'loot') $a52c72724dfd3eca$export$cc4a7a45a09f1743();
    // End loop and update UI if raid completed
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        // Update Alpine store for inventory
        (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
        // Update tab visibility now that raid is completed and ownership is cleared
        if (typeof (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03) === 'function') (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
        // A raid can recover a Collapse Key, and with Auto-Raid the player is
        // often watching a different screen while it does. The Archive renders
        // on arrival, so if it is ALREADY the screen on show it would sit on a
        // stale count until the player navigated away and back.
        if ((0, $a1ffcc09d1c6aa84$export$517113b01f92f5fe)() === 'archive') (0, $8377d004ff5d42b5$export$5dc9bc24597948d9)();
        // Transition grid to completed view immediately
        $a52c72724dfd3eca$export$20c4edcabec24020((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo);
        // Final loot snapshot (raidInProgress is gone; completedRaidInfo holds it)
        if ($a52c72724dfd3eca$var$activeRaidPanelTab === 'loot') $a52c72724dfd3eca$export$cc4a7a45a09f1743();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        $a52c72724dfd3eca$export$96635d91a6ab659a(); // Update button to show reset option
        // Update tab visibility now that raid is completed and ownership is cleared
        if (typeof (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03) === 'function') (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    } else setTimeout($a52c72724dfd3eca$export$46938b5e497922ff, 1000);
}
function $a52c72724dfd3eca$export$ed22353f8399566f() {
    (0, $cc90b7944b7e868a$export$493c70936cbe8c13)();
}
function $a52c72724dfd3eca$export$17436b2a8cf51f27() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    const grid = document.getElementById('raid-grid');
    if (!grid) return;
    const currentRoomIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex;
    const currentTime = Date.now();
    // Hand the map the team's schedule. This runs at 1Hz with the rest of the
    // raid loop; the animation interpolates the walk between path steps off
    // the same roomStartTime/nextRoomTime the timer ring above uses, so the
    // figures and the countdown can never disagree about where the team is.
    (0, $a3c9aff5a6eec062$export$2eefc97a05b1cdd3)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted ? null : {
        path: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath,
        index: currentRoomIndex,
        raid: (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress,
        members: (0, $b4a8c2719a6e2142$export$bdfac2c19033ece4)((0, $cc90b7944b7e868a$export$d17f5534c14b3dc5)())
    });
    // Clean up expired special loot events
    //const specialEvent = gameState.currentRaid.raidInProgress.specialEvent;
    //if (specialEvent.active && specialEvent.roomIndex !== currentRoomIndex) {
    // Room has changed, clean up the old event
    //        cleanupBonusEvent();
    //}
    // Create path coordinate set for quick lookup
    const pathCoords = new Set();
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach((step)=>{
        pathCoords.add(`${step.row}-${step.col}`);
    });
    // First, dim all non-path rooms
    grid.querySelectorAll('.grid-cell').forEach((cell)=>{
        const row = cell.getAttribute('data-row');
        const col = cell.getAttribute('data-col');
        const coord = `${row}-${col}`;
        if (!pathCoords.has(coord)) cell.classList.add('raid-dimmed');
        else cell.classList.remove('raid-dimmed');
    });
    // Update room styling to show progress
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach((pathStep, index)=>{
        const cell = grid.querySelector(`[data-row="${pathStep.row}"][data-col="${pathStep.col}"]`);
        if (cell) {
            cell.classList.remove('current-room', 'completed-room', 'upcoming-room', 'failed-room');
            // Add click handler to scroll to this step in the path display
            cell.style.cursor = 'pointer';
            cell.onclick = ()=>$a52c72724dfd3eca$export$3de9c504cadcc6ea(index);
            // Remove existing path number or timer elements
            const existingElements = cell.querySelectorAll('.path-number, [class*="absolute bottom-1 right-1"]');
            existingElements.forEach((element)=>element.remove());
            if (index < currentRoomIndex) {
                cell.classList.add('completed-room');
                // Add result indicator for completed rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    const completedMark = document.createElement('div');
                    const success = pathStep.room.result?.success;
                    completedMark.innerHTML = success ? "\u2713" : "\u2717";
                    const bgColor = success ? 'bg-green-500/40' : 'bg-red-500/40';
                    completedMark.className = `absolute bottom-1 right-1 ${bgColor} text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black`;
                    cell.appendChild(completedMark);
                }
            } else if (index === currentRoomIndex && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
                cell.classList.add('current-room');
                // Scroll the current room into view in the viewport
                const viewport = document.getElementById('raid-grid-viewport');
                if (viewport && cell) // Use requestAnimationFrame to ensure DOM is ready
                requestAnimationFrame(()=>{
                    const cellRect = cell.getBoundingClientRect();
                    const viewportRect = viewport.getBoundingClientRect();
                    // Check if cell is visible in viewport
                    const isVisible = cellRect.left >= viewportRect.left && cellRect.right <= viewportRect.right;
                    if (!isVisible) {
                        // Scroll the cell into view, centered in the viewport if possible
                        const scrollLeft = cell.offsetLeft - viewport.clientWidth / 2 + cell.offsetWidth / 2;
                        viewport.scrollLeft = Math.max(0, scrollLeft);
                    }
                });
                // Add timer for current room
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit') {
                    const timeRemaining = Math.max(0, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress.nextRoomTime - currentTime);
                    const totalTime = pathStep.room.baseDuration * 1000;
                    const progress = Math.max(0, 1 - timeRemaining / totalTime);
                    const secondsLeft = Math.ceil(timeRemaining / 1000);
                    const timerElement = document.createElement('div');
                    timerElement.className = 'absolute bottom-1 right-1 w-5 h-5 flex items-center justify-center z-20 rounded-full';
                    timerElement.style.pointerEvents = 'none'; // Ensure it doesn't block interactions
                    timerElement.innerHTML = `
                        <svg class="timer-circle-grid" width="20" height="20" style="display: block;">
                            <circle cx="10" cy="10" r="8" fill="none" stroke="#333333AA" stroke-width="5"/>
                            <circle cx="10" cy="10" r="8" fill="none" stroke="#ffd700CC" stroke-width="2"
                                    stroke-dasharray="${2 * Math.PI * 8}"
                                    stroke-dashoffset="${2 * Math.PI * 8 * (1 - progress)}"
                                    transform="rotate(-90 10 10)"
                                    style="transition: stroke-dashoffset 0.5s ease"/>
                        </svg>
                    `;
                    //console.log('Adding timer element with progress:', progress, 'timeRemaining:', timeRemaining, 'totalTime:', totalTime);
                    cell.appendChild(timerElement);
                }
            } else // Check if raid is completed - if so, mark uncompleted rooms with X
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
                cell.classList.add('failed-room');
                // Add X mark for uncompleted rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    const failedMark = document.createElement('div');
                    failedMark.className = '';
                    failedMark.innerHTML = "\u2717";
                    failedMark.className += ' absolute bottom-1 right-1 bg-red-500/80 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    cell.appendChild(failedMark);
                }
            } else {
                cell.classList.add('upcoming-room');
                // Add step number or dash for upcoming rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    const pathNumber = document.createElement('div');
                    pathNumber.className = '';
                    // Show dash for roads, step number for gates/hazards
                    if (pathStep.room.type === 'road') {
                        pathNumber.textContent = "\u22C5";
                        pathNumber.className += ' absolute bottom-1 right-1 bg-gray-600/80 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    } else {
                        pathNumber.textContent = (0, $cc90b7944b7e868a$export$86025a0d632dc830)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, index);
                        pathNumber.className += ' absolute bottom-1 right-1 bg-white/80 text-gray-800 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    }
                    cell.appendChild(pathNumber);
                }
            }
        }
    });
}
function $a52c72724dfd3eca$export$1967c0c6b54773a5(regionTier, room, includeCredits = true) {
    let lootItemsHtml = '<div class="grid grid-cols-3 gap-2">';
    // SECTION 1: Skill-Check Event Loot (Gates & Hazards Only)
    if (room.type === 'gate' || room.type === 'hazard') {
        const allEvents = [
            ...$ce6dd72bc4611534$export$f152896064e09913,
            ...$ce6dd72bc4611534$export$9435522665f2dda4,
            ...$ce6dd72bc4611534$export$1cd1fab9b9844b76
        ];
        // Get events matching room's primary and support skills
        const relevantSkills = new Set([
            room.primary,
            ...room.support || []
        ]);
        const roomEvents = allEvents.filter((event)=>relevantSkills.has(event.relatedSkillId));
        if (roomEvents.length > 0) {
            // Build skill-specific header
            const skillArray = [
                room.primary,
                ...room.support || []
            ];
            const skillNames = (0, $42b272c2c0f44bdf$export$7c6f492816bf045e)(skillArray);
            const skillList = skillNames.length > 0 ? skillNames.join(', ') : 'Related skills';
            lootItemsHtml += `<div class="col-span-3 text-sm border-b pb-1 mb-1">Materials related to:<br/><span class="font-bold">${skillList}</span></div>`;
            lootItemsHtml += `<div class="col-span-3 text-xs text-gray-400 italic mb-1">Chance to find each rarity in this room (events must succeed):</div>`;
            // Effective per-room chance of each rarity across all loot mechanics
            const rarityChances = (0, $b596e64ef926739f$export$8f7497017a33a708)(regionTier, room);
            const rarities = [
                'common',
                'uncommon',
                'rare',
                'epic',
                'legendary',
                'unique'
            ];
            rarities.forEach((rarity)=>{
                const dropChance = rarityChances[rarity] || 0;
                const itemPool = (0, $b596e64ef926739f$export$ded25040c5f0ed12)(room, regionTier, rarity);
                if (itemPool.length > 0 && dropChance > 0) {
                    const quantityRange = (0, $00c60928d2fcd8b8$export$540736c4d7813ac)(rarity, regionTier, room.type);
                    // Handle both numeric and object quantity ranges
                    let qtyDisplay = '';
                    if (typeof quantityRange === 'number') qtyDisplay = `${quantityRange}`;
                    else if (quantityRange && 'max' in quantityRange && 'min' in quantityRange) qtyDisplay = quantityRange.max != quantityRange.min ? `${quantityRange.min}-${quantityRange.max}` : `${quantityRange.min}`;
                    const pct = Math.round(dropChance * 100);
                    const pctDisplay = pct < 1 ? '<1%' : `${pct}%`;
                    const rarityConfig = $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity];
                    if (rarityConfig) {
                        lootItemsHtml += `<div class="text-xs" style="color: ${rarityConfig.color}">${rarityConfig.name}</div>`;
                        lootItemsHtml += `<div class="col-span-2 text-xs" style="color: ${rarityConfig.color}">${pctDisplay} chance \u{2192} ${qtyDisplay} items</div>`;
                    }
                }
            });
        }
    }
    // SECTION 2: Fishing Loot (Water Rooms Only)
    if (room.type === 'water') {
        lootItemsHtml += `<div class="col-span-3 font-bold text-sm border-b pb-1 mb-1">\u{1F3A3} Fishing</div>`;
        lootItemsHtml += `<div class="text-xs">Fish spawn every 15s</div>`;
        lootItemsHtml += `<div class="col-span-2 text-xs">~${Math.floor(room.baseDuration / 15)} Fish available</div>`;
    }
    // SECTION 3: Credits
    if (includeCredits && (room.type === 'gate' || room.type === 'hazard')) {
        const minCredits = 40 + regionTier * 35;
        const maxCredits = minCredits + 75;
        lootItemsHtml += `<div class="col-span-3 font-bold text-sm border-b pb-1 mb-1">\u{1F4B0} Credits</div>`;
        lootItemsHtml += `<div class="col-span-3 text-xs">${minCredits}-${maxCredits}</div>`;
    }
    lootItemsHtml += '</div>';
    return lootItemsHtml;
}
function $a52c72724dfd3eca$export$96635d91a6ab659a() {
    // Before the early return: the grid's status is not the start button's
    // business, and a screen without that button still has a grid to stamp.
    $a52c72724dfd3eca$export$2d4508142cc72b6e();
    // Update start raid button with energy info or reset option
    const startBtn = document.getElementById('start-raid');
    if (!startBtn) return;
    // Reset button classes
    startBtn.classList.remove('!bg-green-500', '!bg-gray-500', '!bg-gradient-to-r', '!from-amber-500', '!to-amber-600', 'foil-card', 'complete-raid-btn');
    // Hide/show cancel raid button based on raid completion status
    const cancelBtn = document.getElementById('cancel-raid');
    if (cancelBtn) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
            cancelBtn.classList.add('hidden');
            startBtn.classList.remove('mr-0', 'rounded-tr-none', 'rounded-br-none');
        } else {
            cancelBtn.classList.remove('hidden');
            startBtn.classList.add('mr-0', 'rounded-tr-none', 'rounded-br-none');
        }
    }
    // If raid was completed, show reset button instead
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        startBtn.disabled = false;
        startBtn.textContent = 'Complete Raid';
        // No text colour here: `.start-raid-btn` already sets #1a1a2e, which is
        // what the old `text-navy` was reaching for. There is no `navy` in
        // tailwind.config.js, so that class emitted nothing — and it was absent
        // from the reset list above, so it stuck to the button for every later
        // state. Dead and leaky; the base class was doing the work all along.
        startBtn.classList.add('!bg-gradient-to-r', '!from-amber-500', '!to-amber-600', 'foil-card', 'complete-raid-btn');
        startBtn.onclick = ()=>{
            $a52c72724dfd3eca$export$8dc8f2c13318a5b7();
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        };
    } else if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        startBtn.disabled = true;
        startBtn.textContent = 'Raid in Progress';
    } else if (!(0, $cc90b7944b7e868a$export$a678af82bf766611)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
        // Check if path is valid (starts at start, ends at exit)
        startBtn.disabled = true;
        startBtn.classList.add('!bg-gray-500'); // Override with Tailwind gray
        startBtn.textContent = 'Incomplete Path';
        startBtn.onclick = $a52c72724dfd3eca$export$bb6b71fe7f08b971;
    } else {
        const region = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
        const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
        const energyCost = (0, $cc90b7944b7e868a$export$78de3bc967b7be)(tier, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath);
        startBtn.disabled = true;
        startBtn.textContent = 'Start';
        // Check energy
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy < energyCost) {
            startBtn.disabled = true;
            startBtn.textContent = `Need\u{26A1}${energyCost}`;
        } else {
            startBtn.disabled = false;
            startBtn.textContent = `Start\u{26A1}${energyCost}`;
        }
        startBtn.onclick = $a52c72724dfd3eca$export$bb6b71fe7f08b971;
    }
}
function $a52c72724dfd3eca$export$8dc8f2c13318a5b7() {
    // Refresh contractor pool with new skill levels based on player progression
    (0, $bd083a63eb37c143$export$aca974319671fb3e)();
    (0, $cc90b7944b7e868a$export$fae9674fe5380657)();
    // Hide raid grid, log, and raid active section; show region selection
    const elemIds = [
        'raid-grid-section',
        'raid-team',
        'raid-active'
    ];
    elemIds.forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.classList.add('hidden');
    });
    const setupEl = document.getElementById('raid-setup');
    if (setupEl) setupEl.classList.remove('hidden');
    // Clear raid dimming from all grid cells
    const grid = document.getElementById('raid-grid');
    if (grid) grid.querySelectorAll('.grid-cell').forEach((cell)=>{
        cell.classList.remove('raid-dimmed');
    });
    // Reset region selector
    $a52c72724dfd3eca$export$d6f634bba1273a2b();
    const genGridBtn = document.getElementById('generate-grid');
    if (genGridBtn) genGridBtn.disabled = true;
    // Show cancel button again (will be hidden/shown as needed by updateRaidButtonStates)
    const cancelBtn = document.getElementById('cancel-raid');
    if (cancelBtn) cancelBtn.classList.remove('hidden');
    // Update UI - the slider/tiles re-render with the previous selections
    // still applied (kept through resetRaidCore), so the info panel and
    // Generate button must reflect them too
    $a52c72724dfd3eca$export$b70ccd83fb3eaefa();
    $a52c72724dfd3eca$export$68c4600b33dd0ca8();
    $a52c72724dfd3eca$export$96635d91a6ab659a();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $f3f2c7a1b1934e01$export$5d55f9eae051c4dc)();
    (0, $f3f2c7a1b1934e01$export$98a6c6e9bfe86f10)();
    (0, $f3f2c7a1b1934e01$export$6a940d9b4a9b252a)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Raid reset - previous region and tier are still selected', 'info');
}
function $a52c72724dfd3eca$export$8f8ffb9ff36daf30() {
    const raidInProgress = (0, $f27982cef7035d22$export$8e361a1ffbebf172)?.currentRaid?.raidInProgress;
    const logEntries = document.getElementById('log-entries');
    if (!raidInProgress || !raidInProgress.logEntries || !logEntries) return;
    // Clear current entries
    logEntries.innerHTML = '';
    // Restore saved entries
    raidInProgress.logEntries.forEach((logEntry)=>{
        const entry = document.createElement('div');
        entry.className = `log-entry log-${logEntry.type}`;
        entry.textContent = logEntry.message;
        logEntries.appendChild(entry);
    });
    // Scroll to bottom
    logEntries.scrollTop = logEntries.scrollHeight;
}
function $a52c72724dfd3eca$export$20c4edcabec24020(info) {
    // The team is off the map the moment the raid ends — win or lose, the
    // result markers are what the completed grid is saying now.
    (0, $a3c9aff5a6eec062$export$2eefc97a05b1cdd3)(null);
    const grid = document.getElementById('raid-grid');
    if (!grid || !info.selectedPath) return;
    // Create path coordinate set for quick lookup
    const pathCoords = new Set();
    info.selectedPath.forEach((step)=>{
        pathCoords.add(`${step.row}-${step.col}`);
    });
    // First, dim all non-path rooms
    grid.querySelectorAll('.grid-cell').forEach((cell)=>{
        const row = cell.getAttribute('data-row');
        const col = cell.getAttribute('data-col');
        const coord = `${row}-${col}`;
        if (!pathCoords.has(coord)) cell.classList.add('raid-dimmed');
        else cell.classList.remove('raid-dimmed');
    });
    // Find the last attempted room (last room with a result)
    let lastAttemptedIndex = -1;
    for(let i = info.selectedPath.length - 1; i >= 0; i--)if (info.selectedPath[i].room.result) {
        lastAttemptedIndex = i;
        break;
    }
    info.selectedPath.forEach((pathStep, index)=>{
        const cell = grid.querySelector(`[data-row="${pathStep.row}"][data-col="${pathStep.col}"]`);
        if (cell) {
            // Remove all existing classes
            cell.classList.remove('current-room', 'completed-room', 'upcoming-room', 'failed-room');
            // Add click handler to scroll to this step in the path display
            cell.style.cursor = 'pointer';
            cell.onclick = ()=>$a52c72724dfd3eca$export$3de9c504cadcc6ea(index);
            // Remove existing path number or timer elements
            const existingElements = cell.querySelectorAll('.path-number, [class*="absolute bottom-1 right-1"]');
            existingElements.forEach((element)=>element.remove());
            // Skip start portal
            if (pathStep.room.type === 'start' || pathStep.room.type == 'exit') return;
            // Check if this room was attempted (has a result)
            if (pathStep.room.result) {
                const success = pathStep.room.result.success;
                if (success) cell.classList.add('completed-room');
                else cell.classList.add('failed-room');
                // Add result indicator for non-exit rooms
                const completedMark = document.createElement('div');
                completedMark.className = 'path-number';
                completedMark.innerHTML = success ? "\u2713" : "\u2717";
                const bgColor = success ? 'bg-green-500/40' : 'bg-red-500/40';
                completedMark.className += ` !absolute !bottom-1 !right-1 ${bgColor} !text-white !w-5 !h-5 !rounded-full !flex !items-center !justify-center !text-xs !font-bold !z-10 !ring-2 !ring-black`;
                cell.appendChild(completedMark);
            } else if (!info.raidSuccess && index > lastAttemptedIndex) {
                // If raid failed and this room is after the last attempted room, mark as unattempted/failed
                cell.classList.add('failed-room');
                const completedMark = document.createElement('div');
                completedMark.className = 'path-number';
                completedMark.innerHTML = "\u2717";
                completedMark.className += ` !absolute !bottom-1 !right-1 !bg-red-500/40 !text-white !w-5 !h-5 !rounded-full !flex !items-center !justify-center !text-xs !font-bold !z-10 !ring-2 !ring-black`;
                cell.appendChild(completedMark);
            }
        }
    });
}






// Cache of last synced character state for change detection
let $41a2a1ff52c357a7$var$lastSyncedCharacterState = null;
async function $41a2a1ff52c357a7$export$25f0d7933e956edb(character) {
    if (!character) return;
    // Create snapshot of relevant character fields for comparison.
    // Keys are snake_case to match the DB columns the PUT endpoint writes.
    const currentSnapshot = {
        name: character.name,
        faction: character.faction,
        skills: character.skills,
        synergy_unlocks: character.synergyUnlocks,
        skill_points: character.skillPoints,
        max_hp: character.maxHp,
        current_hp: character.currentHp,
        level: character.level,
        xp: character.xp,
        xp_to_next: character.xpToNext,
        avatar: character.avatar,
        avatar_seed: character.avatarSeed,
        avatar_features: character.avatarFeatures,
        title: character.title,
        quote: character.quote,
        inventory: character.inventory,
        artifacts: character.artifacts,
        equipped_artifacts: character.equippedArtifacts,
        equipped_technique_gear: character.equippedTechniqueGear
    };
    // Check if there are actual changes
    if ($41a2a1ff52c357a7$var$lastSyncedCharacterState && JSON.stringify($41a2a1ff52c357a7$var$lastSyncedCharacterState) === JSON.stringify(currentSnapshot)) return; // No changes, skip API call
    if (!character.multiplayerId) {
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Saved character sync state. Skipping sync call');
        $41a2a1ff52c357a7$var$lastSyncedCharacterState = currentSnapshot;
        return; // Only sync characters registered with multiplayer
    }
    try {
        const response = await fetch('/api/characters', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // Ownership proof — the server rejects writes to a token-bearing
                // row without a matching token (ServerAuthoritySaveSecurity.md §2).
                ...character.ownerToken ? {
                    'Authorization': `Bearer ${character.ownerToken}`
                } : {}
            },
            body: JSON.stringify({
                id: character.multiplayerId,
                ...currentSnapshot
            })
        });
        if (response.ok) // Update cache only after successful sync
        $41a2a1ff52c357a7$var$lastSyncedCharacterState = currentSnapshot;
        else console.warn('Failed to sync character to database:', await response.text());
    } catch (error) {
        console.warn('Error syncing character to database:', error);
    }
}
function $41a2a1ff52c357a7$export$384cd953322e3851() {
    try {
        const saveData = (0, $f27982cef7035d22$export$e12c04bc0206ba64)();
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Saving game state...', saveData);
        localStorage.setItem('idleExtractionSave', JSON.stringify(saveData));
        //console.log('Game saved successfully');
        //console.log('Saved data:', saveData);
        // Sync character to database (async, non-blocking)
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) $41a2a1ff52c357a7$export$25f0d7933e956edb((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
        return true;
    } catch (error) {
        console.error('Save failed:', error);
        return false;
    }
}
function $41a2a1ff52c357a7$export$756e5d66bdd28395() {
    try {
        let loaded = false;
        let lastLoaded = Date.now();
        let legacyReset = false;
        const saveData = localStorage.getItem('idleExtractionSave');
        if (saveData) {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, 'Save data found');
            const parsed = JSON.parse(saveData);
            if (parsed.gameState) {
                const knownSkillIds = new Set(Object.values($ce6dd72bc4611534$export$aeeef991191508e2 || {}).flatMap((f)=>Object.keys(f.skills || {})));
                if ((0, $f27982cef7035d22$export$e178d880fd9e46ee)(parsed, knownSkillIds)) {
                    // Pre-overhaul save: the redesign renamed skills and replaced
                    // ~90% of items, so it cannot be faithfully migrated. Archive
                    // it (recoverable) and start fresh with a one-time notice.
                    console.warn('Legacy (pre-overhaul) save detected - archiving and starting fresh');
                    try {
                        localStorage.setItem('idleExtractionSave_legacyBackup', saveData);
                    } catch (e) {}
                    localStorage.removeItem('idleExtractionSave');
                    legacyReset = true;
                } else {
                    (0, $f27982cef7035d22$export$5a216aa68e49a7fc)(parsed);
                    loaded = true;
                    lastLoaded = parsed.timestamp;
                }
            }
        }
        if (!loaded) (0, $f27982cef7035d22$export$5a216aa68e49a7fc)({
            "gameState": (0, $f27982cef7035d22$export$8e361a1ffbebf172)
        });
        if (legacyReset) (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDE80 Idle Raiders got a major overhaul \u2014 your old save was incompatible and has been archived. Starting fresh!", 'info');
        // Add avatar to player character if missing
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatar) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatar = (0, $42b272c2c0f44bdf$export$913078032f14f7f)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
        // Backfill procedural avatar seed (stable character id) for old saves.
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatarSeed) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatarSeed = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.id;
        // Refresh Alpine store if available
        (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
        (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors').refresh();
        // Validate raidOwnerId - if it references a non-existent character, clear raid data
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId) {
            const raidOwnerExists = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.some((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId);
            if (!raidOwnerExists) {
                console.warn('Invalid raidOwnerId found, clearing raid data');
                (0, $a52c72724dfd3eca$export$8dc8f2c13318a5b7)();
                $41a2a1ff52c357a7$export$384cd953322e3851();
            }
        }
        // Update contractors if character exists but no contractors generated
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors.length === 0) (0, $bd083a63eb37c143$export$aca974319671fb3e)();
        // Process offline progress
        const timeDiff = Date.now() - lastLoaded;
        (0, $bd083a63eb37c143$export$3e71fa030a894242)(timeDiff);
        $41a2a1ff52c357a7$export$384cd953322e3851();
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction) document.body.classList.add((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
        return true;
    } catch (error) {
        console.error('Load failed:', error);
        return false;
    }
}








function $b7695fceb608271e$export$1d6271c3715ff9d3() {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return;
    // Not gated: this path DISCARDS the character's whole inventory. It should
    // be loud if it ever fires unexpectedly.
    console.warn(`initializeInventory: clearing inventory for ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name}`);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory = {};
    // Refresh Alpine store if available
    if (0, $607ffae1bbc96660$export$5b73e6a29e58b929) (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
}
function $b7695fceb608271e$export$28b75a4bedf6475d(itemId) {
    // Check if it's a crafted artifact.
    //
    // ⚠ THE OPTIONAL CHAIN IS LOAD-BEARING: there is no character between
    // characters. Promotion and founding both legitimately set
    // `gameState.character = null`, and this helper is shared by the LAYER
    // pools — Command's vault, the Syndicate's dock and consignment — which
    // outlive every character by design (`inventoryManager.js` itemRows).
    //
    // Unguarded, this threw inside `refreshAlpineInventory` during
    // `loadGameState`, which aborted BOOT: a black page, and a save that failed
    // the same way on every reload afterwards. Both of the flows that reach it
    // are ordinary — promote your last character, or found a Syndicate — so the
    // account was bricked at exactly the moment a player would put the game
    // down. Found by the qa-player reload checks in §17/§35, 2026-08-05.
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.artifacts?.some((artifact)=>artifact.id === itemId)) return 'artifact';
    // Check in itemTable for the item's type
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (item) return item.type;
    // Check if it's a blueprint
    if (itemId.includes('-blueprint')) return 'blueprint';
    return 'material'; // Default type
}
function $b7695fceb608271e$export$3702bf1024e2bfe4(factionKey) {
    return $ce6dd72bc4611534$export$aeeef991191508e2[factionKey]?.icon || '';
}
function $b7695fceb608271e$export$b5651c43e62deea0(factionKey) {
    return $ce6dd72bc4611534$export$aeeef991191508e2[factionKey]?.name || '';
}
function $b7695fceb608271e$export$af5e2922249239fd(tier) {
    // Use itemRarities color scheme
    if (tier == 'currency') return '#ffd700';
    const rarityColor = $ce6dd72bc4611534$export$d4a72d069095e9e5[tier]?.color;
    return rarityColor || '#9ca3af'; // Default to common
}
function $b7695fceb608271e$export$e9db1543c5540d63(tier) {
    // Define sorting order for tiers (higher number = higher priority)
    const tierOrder = {
        'unique': 6,
        'legendary': 5,
        'epic': 4,
        'rare': 3,
        'common': 2,
        'currency': 1
    };
    return tierOrder[tier] || 0;
}
function $b7695fceb608271e$export$86e4cd2f7b0dca8(type) {
    // Return color schemes for different item categories
    const itemTypeColors = {
        'material': {
            header: 'from-stone-600 to-stone-700',
            button: 'from-stone-600 to-stone-700 hover:from-stone-700 hover:to-stone-800'
        },
        'consumable': {
            header: 'from-green-600 to-green-700',
            button: 'from-green-600 to-green-700 hover:from-green-700 hover:to-green-800'
        },
        'blueprint': {
            header: 'from-blue-600 to-blue-700',
            button: 'from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800'
        },
        'relic': {
            header: 'from-purple-600 to-purple-700',
            button: 'from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800'
        },
        'storyRelic': {
            header: 'from-yellow-600 to-yellow-700',
            button: 'from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800'
        }
    };
    return itemTypeColors[type] || {
        header: 'from-gray-600 to-gray-700',
        button: 'from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800'
    };
}
function $b7695fceb608271e$export$2e11c6c919ff347e(tier) {
    // Return header color schemes for different item tiers/rarities
    const tierHeaderColors = {
        'common': 'from-gray-500 to-gray-600',
        'uncommon': 'from-green-500 to-green-600',
        'rare': 'from-blue-600 to-blue-700',
        'epic': 'from-purple-600 to-purple-700',
        'legendary': 'from-yellow-600 to-yellow-700',
        'unique': 'from-orange-600 to-orange-700',
        'currency': 'from-yellow-600 to-yellow-700'
    };
    return tierHeaderColors[tier] || 'from-gray-600 to-gray-700';
}
function $b7695fceb608271e$export$c194f198e80011d8(items) {
    return items.sort((a, b)=>{
        const aData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('name', a.name);
        const bData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('name', b.name);
        const aRarity = aData?.rarity || 'common';
        const bRarity = bData?.rarity || 'common';
        // First sort by tier priority (higher tier first)
        const tierDiff = $b7695fceb608271e$export$e9db1543c5540d63(bRarity) - $b7695fceb608271e$export$e9db1543c5540d63(aRarity);
        if (tierDiff !== 0) return tierDiff;
        // Then sort alphabetically by name
        return a.name.localeCompare(b.name);
    });
}
function $b7695fceb608271e$export$683d0f4498a367f2(categoryKey) {
    // Update tab buttons
    document.querySelectorAll('.inventory-tab-btn').forEach((btn)=>{
        btn.classList.remove('active');
        if (btn.dataset.category === categoryKey) btn.classList.add('active');
    });
    // Update content panels
    document.querySelectorAll('.inventory-category').forEach((panel)=>{
        panel.classList.remove('active');
        if (panel.dataset.category === categoryKey) panel.classList.add('active');
    });
}
function $b7695fceb608271e$export$dbdf3132d4782af0(itemId) {
    // Check if current character exists and is on marketplace
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('No active character!', 'error');
        return;
    }
    // //@ts-ignore - character is checked above
    const char = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (char.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot use items with a character that is contracted out on the marketplace', 'error');
        return;
    }
    if (!char.inventory[itemId] || char.inventory[itemId] <= 0) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('You don\'t have any of this item!', 'error');
        return;
    }
    // Get consumable data
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!itemData || itemData.type !== 'consumable') {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('This item cannot be used!', 'error');
        return;
    }
    // Classify by the item's restore fields; technique consumables (epic,
    // effects-based) have neither and are deployed automatically in raids
    const isEnergyConsumable = !!itemData.restoresEnergy;
    const isHpConsumable = !!itemData.restoresHp;
    if (!isEnergyConsumable && !isHpConsumable) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Technique consumables rig automatically on their technique\'s first success during a raid', 'info');
        return;
    }
    // Check raid state
    const isRaidActive = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    // RESTRICTION 1: Energy consumables can ONLY be used before raid starts
    if (isEnergyConsumable) {
        if (isRaidActive) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Energy consumables can only be used before starting a raid!', 'error');
            return;
        }
    }
    // RESTRICTION 2: HP consumables can be used before raid OR at campsite during raid
    if (isHpConsumable && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress && !$b7695fceb608271e$export$32cc43b5b1b4dc0e()) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('HP consumables can only be used at a campsite during a raid!', 'error');
        return;
    }
    let used = false;
    let healAmount = 0;
    let energyAmount = 0;
    // Apply consumable effects based on type
    if (isHpConsumable) {
        if (char.currentHp < char.maxHp) {
            // Use specific value from item definition, or fallback to default
            healAmount = itemData.restoresHp || 35;
            char.currentHp = Math.min(char.maxHp, char.currentHp + healAmount);
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Used ${itemData.name}! Restored ${healAmount} HP.`, 'success');
            used = true;
        } else (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Your health is already full!', 'info');
    } else if (isEnergyConsumable) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player && (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy < (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy) {
            // Use specific value from item definition, or fallback to default
            energyAmount = itemData.restoresEnergy || 30;
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy = Math.min((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy, (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy + energyAmount);
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Used ${itemData.name}! Restored ${energyAmount} energy.`, 'success');
            used = true;
        } else (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Your energy is already full!', 'info');
    }
    if (used) {
        char.inventory[itemId]--;
        if (char.inventory[itemId] <= 0) delete char.inventory[itemId];
        // Update Alpine store if available
        if (0, $607ffae1bbc96660$export$5b73e6a29e58b929) (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    }
}
function $b7695fceb608271e$export$e1c01f683feb5181(itemId) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] || (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('You don\'t have any of this item to sell!', 'error');
        return;
    }
    // Get item data to determine sell price
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!itemData) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('This item cannot be sold!', 'error');
        return;
    }
    // Get sell price from itemTable
    let sellPrice = 0;
    if (itemData.credits) sellPrice = itemData.credits;
    else {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot sell ${itemData.name} for credits`, 'error');
        return;
    }
    // Sell the quantity chosen via the +/- controls (defaults to 1)
    const qtyInput = document.getElementById(`sell-qty-${itemId}`);
    const quantity = Math.min(parseInt(qtyInput?.value) || 1, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId]);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] -= quantity;
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) delete (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId];
    // Add credits to player
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits += sellPrice * quantity;
    // Update Alpine store if available
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    // Show notification
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Sold ${quantity}x ${itemData.name} for ${sellPrice * quantity} credits`, 'success');
    // Update UI and save
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $b7695fceb608271e$export$dba564f0cb325527(itemId) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('No active character!', 'error');
        return;
    }
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot purchase items with a character that is contracted out on the marketplace', 'error');
        return;
    }
    // Get item data to determine purchase price
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!itemData || itemData.type !== 'consumable') {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('This item cannot be purchased!', 'error');
        return;
    }
    // Check if item has a credit cost
    if (!itemData.credits) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot purchase ${itemData.name} for credits`, 'error');
        return;
    }
    // Energy consumables escalate with today's purchase count (credit sink)
    const purchasePrice = (0, $00c60928d2fcd8b8$export$1214c02c27df458d)(itemData, (0, $f27982cef7035d22$export$8e361a1ffbebf172).player);
    // Check if player has enough credits
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).player || (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits < purchasePrice) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Not enough credits! Need ${purchasePrice}, have ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits || 0}`, 'error');
        return;
    }
    // Deduct credits from player
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits -= purchasePrice;
    if (itemData.restoresEnergy) (0, $00c60928d2fcd8b8$export$cfff9bc32ab6cb78)((0, $f27982cef7035d22$export$8e361a1ffbebf172).player);
    // Add item to inventory
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId]) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] = 0;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId]++;
    // Update Alpine store if available
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    // Re-render the purchase grid if the modal is open: energy prices escalate
    // per purchase, so stale BUY labels would understate the next charge
    const purchaseModal = document.getElementById('purchase-consumables-modal');
    if (purchaseModal && !purchaseModal.classList.contains('hidden')) $b7695fceb608271e$export$1690b2b2efa58f74();
    // Show notification
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Purchased ${itemData.name} for ${purchasePrice} credits`, 'success');
    // Update UI and save
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $b7695fceb608271e$export$4ac7f915da1fa1c4(item, mode = 'inventory', recipe = null, preComputedMaterials = null, options = {}) {
    const isArtifact = item.type === 'artifact';
    const isSkillGear = item.type === 'techGear' || item.type === 'consumable' && item.rarity === 'epic';
    const isConsumable = item.type === 'consumable';
    const itemData = mode == 'inventory' ? isArtifact ? (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', item.id) : (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', item.id) : item;
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "creating card for item: ", item, mode, itemData);
    if (itemData) {
        const isCrafting = mode === 'crafting';
        const isPurchase = mode === 'purchase';
        // Determine card styling based on rarity in crafting mode
        const rarity = itemData.rarity || 'common';
        const rarityConfig = isCrafting ? $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity] : null;
        let cardBg, cardBorder, headerBg, headerBorder, headerText, categoryText;
        if (isCrafting && rarityConfig) {
            // Crafting mode with rarity colors
            const hexToTailwind = (hex)=>`[${hex}]`;
            const color = rarityConfig.color;
            cardBg = `from-${hexToTailwind(color)}/10 to-${hexToTailwind(color)}/20`;
            cardBorder = `border-${hexToTailwind(color)}/30`;
            headerBg = `from-${hexToTailwind(color)}/50 to-${hexToTailwind(color)}/30`;
            headerBorder = `border-${hexToTailwind(color)}/30`;
            headerText = 'text-white';
            categoryText = $ce6dd72bc4611534$export$d02ea220375e4aff[itemData.type]?.name || itemData.type;
        } else if (isArtifact) {
            cardBg = 'from-amber-800 to-amber-900';
            cardBorder = 'border-amber-600';
            headerBg = 'from-amber-700 to-amber-600';
            headerBorder = 'border-amber-500';
            headerText = 'text-amber-100';
            categoryText = 'Artifact';
        } else {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, itemData.type, $ce6dd72bc4611534$export$d02ea220375e4aff);
            cardBg = 'from-gray-800 to-gray-900';
            cardBorder = 'border-gray-600';
            headerBg = $b7695fceb608271e$export$2e11c6c919ff347e(itemData?.rarity || 'tier1');
            headerBorder = 'border-gray-500';
            headerText = 'text-white';
            categoryText = $ce6dd72bc4611534$export$d02ea220375e4aff[itemData.type].name;
        }
        // Item-specific data
        const itemName = isArtifact ? itemData.name : isCrafting ? itemData.name : itemData.name.replace(' Blueprint', '');
        const itemIcon = isArtifact ? itemData.icon || "\u26A1" : isCrafting ? itemData.icon || "\u26A1" : itemData.icon;
        let description = (!isArtifact ? itemData.short ? itemData.short : itemData.name : '') + (isSkillGear || isArtifact ? ' <span class="font-bold">' + $b7695fceb608271e$export$8a26d5080d84dfb0(itemData.id) + '</span>' : '');
        let techniqueName = '';
        let techniqueIcon = '';
        if (isSkillGear) {
            const skillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(itemData.techniqueId));
            techniqueName = (0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(itemData.techniqueId);
            techniqueIcon = (0, $42b272c2c0f44bdf$export$bf5389e28ce4699d)(itemData.techniqueId);
            description = `<p class='text-blue-500 font-bold'>${skillName}</p><p class='text-green-500 font-bold'>${techniqueName}</p>${description}`;
        } else if (isArtifact && itemData.skill) {
            const skillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)(itemData.skill);
            description = `<p class='text-blue-500 font-bold'>${skillName}</p>${description}`;
        }
        const quantity = isArtifact || isSkillGear ? 1 : isCrafting ? null : item.quantity;
        /**
         * What ONE of these is worth, in credits, opposite the count.
         *
         * The count answers "how many"; on the Syndicate's Stores and the
         * Command Vault that is only half the question, because Operations
         * price a manifest in CREDITS of materials (`cargoValue`) — so a dock
         * of 500 commons and one of 20 rares are worth wildly different things
         * and the count alone cannot say which fills a convoy.
         *
         * PER UNIT, not the pile's total: the pile total is just count × this,
         * and the per-unit figure is the one that survives the count changing.
         * Materials only — artifacts, gear and relics are not on the crafting
         * ladder `materialValue` derives from, and would read as 0.
         *
         * Rendered into the slot the action button leaves empty when actions
         * are hidden, so read-only screens gain it and the sell/craft flows are
         * untouched rather than gaining a third control to line up.
         */ const unitValue = itemData.type === 'material' ? (0, $958d9357360f8a8b$export$fec63043638a29c9)(itemData.id) : 0;
        const unitValueBadge = unitValue > 0 ? `<div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block"
                    title="${unitValue.toLocaleString()}\u{1F4B0} each${quantity != null ? ` \u{2014} ${(unitValue * quantity).toLocaleString()}\u{1F4B0} for all ${quantity}` : ''}">${unitValue.toLocaleString()}\u{1F4B0}</div>` : '';
        // Faction icon for materials
        const factionKey = !isArtifact && itemData.type === 'material' ? item.faction : null;
        const factionIcon = factionKey ? $b7695fceb608271e$export$3702bf1024e2bfe4(factionKey) : itemData.type === 'relic' ? $ce6dd72bc4611534$export$d02ea220375e4aff.relic.icon : '';
        const factionName = factionKey ? $b7695fceb608271e$export$b5651c43e62deea0(factionKey) : '';
        // Action buttons - check if character is on marketplace (read-only mode)
        const isReadOnly = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace || options.hideActions;
        let actionButton = '';
        let qtyLabel = '';
        // Equip state (any mode): drives the equipped-card highlight and the
        // gear-tab equip row. Equipping is non-destructive, so "owned" means
        // in inventory (gear) / in the crafted-artifacts list (artifacts).
        const isEquippedItem = isSkillGear && Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.equippedTechniqueGear || {}).some((g)=>g && (g.id === itemData.id || g === itemData.id)) || isArtifact && Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.equippedArtifacts || {}).some((a)=>a && a.id === itemData.id);
        // Durable gear/artifacts are crafted once per character (see
        // progressionScaling.allowDuplicateCrafts). Owned => the craft control
        // becomes a "✓ CRAFTED" marker instead of an active button.
        const ownsThisItem = isSkillGear ? (0, $bde36de43872f734$export$2886ceaa061d802b)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, itemData.id) : isArtifact ? (0, $bde36de43872f734$export$770281d4afda41b1)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, itemData.id) : false;
        const alreadyCrafted = (isSkillGear || isArtifact) && ownsThisItem && !(0, $bde36de43872f734$export$c95b8ce76efadccf)();
        // Crafting-mode (Gear tab) equip row: owned gear/artifacts get an
        // EQUIP/UNEQUIP control that stays visible in the collapsed view too
        // (it sits outside .card-body, which the collapse hides)
        // A crafting-mode artifact whose design isn't unlocked yet: it can't be
        // crafted or expanded - only unlocked. The unlock control takes the
        // collapsed-visible equip-row slot (same place EQUIP sits).
        const artifactLocked = isCrafting && !isReadOnly && isArtifact && !(0, $bde36de43872f734$export$2ab3ae91631fe8e5)(itemData.id);
        let equipRow = '';
        if (artifactLocked) {
            const blueprintId = `${itemData.id}-blueprint`;
            const hasBlueprint = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory?.[blueprintId] || 0) > 0;
            const unlockMarks = $ce6dd72bc4611534$export$9f9786ac427715c7?.commandMarks?.perArtifactUnlock || 0;
            const btn = hasBlueprint ? `<button class="bg-gradient-to-r from-violet-500 to-violet-600 hover:from-violet-400 hover:to-violet-500 text-white px-2 py-0.5 rounded text-xs font-bold border border-violet-400 transition-colors"
                    title="Consume this design's blueprint to unlock it for your account (+${unlockMarks} Command Marks). Any character can then craft it from materials."
                    onclick="unlockArtifact('${itemData.id}'); showCraftingModal();">\u{1F513} UNLOCK +${unlockMarks}\u{1F396}\u{FE0F}</button>` : `<button class="bg-gray-700 text-gray-300 px-2 py-0.5 rounded text-xs font-bold border border-gray-600 cursor-not-allowed" disabled title="This design's blueprint drops from Tier 3 raids">\u{1F512} NEEDS BLUEPRINT</button>`;
            equipRow = `<div class="card-equip-row mx-1 flex justify-end">${btn}</div>`;
        } else if (isCrafting && !isReadOnly && !isConsumable && (isSkillGear || isArtifact)) {
            if (ownsThisItem) {
                let equipButton;
                if (isEquippedItem) {
                    const unequipCall = isArtifact ? `unequipArtifact('${itemData.slot}')` : `unequipTechniqueGear('${itemData.techniqueId}')`;
                    equipButton = `<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-0.5 rounded text-xs font-bold border border-red-500 transition-colors" onclick="${unequipCall}">UNEQUIP</button>`;
                } else {
                    const canEquip = isArtifact ? (0, $7df15cefc09eac1b$export$106e54bf5a9adc20) ? (0, $7df15cefc09eac1b$export$106e54bf5a9adc20)(itemData) : true : (0, $7df15cefc09eac1b$export$9e693217356d7ac4) ? (0, $7df15cefc09eac1b$export$9e693217356d7ac4)(itemData.id) : true;
                    const requirement = isArtifact ? (0, $7df15cefc09eac1b$export$56e7fec58be964ef) ? (0, $7df15cefc09eac1b$export$56e7fec58be964ef)(itemData) : '' : (0, $7df15cefc09eac1b$export$bc6c3240a6a68b89) ? (0, $7df15cefc09eac1b$export$bc6c3240a6a68b89)(itemData.id) : '';
                    const equipCall = isArtifact ? `equipArtifact('${itemData.id}')` : `equipTechniqueGear('${itemData.techniqueId}', '${itemData.id}')`;
                    equipButton = canEquip ? `<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-0.5 rounded text-xs font-bold border border-amber-400 transition-colors" title="${isSkillGear ? 'One gear piece per skill - equipping swaps out the current one' : ''}" onclick="${equipCall}">EQUIP</button>` : `<button class="bg-gray-500 text-gray-300 px-2 py-0.5 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="${requirement}">EQUIP</button>`;
                }
                equipRow = `<div class="card-equip-row mx-1 flex justify-end">${equipButton}</div>`;
            }
        }
        // Locked artifacts show only the unlock control (in equipRow above);
        // the craft controls appear once the design is unlocked.
        if (isCrafting && !isReadOnly && !artifactLocked && alreadyCrafted) // One-per-character durable already in hand: the craft slot becomes a
        // completed-checklist marker (equip it from the row above).
        actionButton = `<button class="w-full h-10 bg-gray-700 text-emerald-300 rounded text-xs font-bold border border-emerald-600/40 cursor-not-allowed" disabled title="Already crafted - one per character. Equip it from your inventory.">\u{2713} CRAFTED</button>`;
        else if (isCrafting && !isReadOnly && !artifactLocked) {
            // Crafting mode - show craft button with quantity selector
            const canCraft = recipe ? (0, $52d4eb0e19aef542$export$10d9b633aa01c262)(recipe) : false;
            // Same scaled price calculateBulkCraftingCost charges (parity with the sim)
            const craftingCost = (0, $52d4eb0e19aef542$export$5c9f0b8d2a488474)(itemData.id, 1);
            const playerCredits = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits || 0;
            const hasCredits = playerCredits >= craftingCost;
            const quantityId = `craft-qty-${itemData.id}`;
            if (canCraft && hasCredits) {
                // Calculate cost for selected quantity and show discount
                // Calculate max craftable quantity
                let maxCraftQty = 1;
                if (recipe && recipe.inputs) {
                    maxCraftQty = 99;
                    for (const input of recipe.inputs){
                        const available = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
                        const canCraftQty = Math.floor(available / input.qty);
                        maxCraftQty = Math.min(maxCraftQty, canCraftQty);
                    }
                    maxCraftQty = Math.max(1, maxCraftQty);
                }
                const actionButtonClass = 'flex-grow px-2 h-10 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 rounded text-xs font-bold border border-amber-400 transition-colors';
                const actionButtonCountClass = 'h-10 w-10 bg-gray-600 border border-gray-800 hover:bg-gray-500 text-white rounded text-xs font-bold';
                actionButton = `
                    <div class="w-full flex gap-1">
                        <button class="${actionButtonCountClass}" onclick="decrementCraftQty('${quantityId}')">\u{2212}</button>
                        <button class="${actionButtonCountClass}" onclick="incrementCraftQty('${quantityId}')">+</button>
                        <input type="number" id="${quantityId}" class="hidden" value="1" min="1" max="${maxCraftQty}" onchange="updateCraftCost('${itemData.id}', '${quantityId}')">                            
                        <button id="craft-btn-${itemData.id}" class="${actionButtonClass}" onclick="const qty = parseInt(document.getElementById('${quantityId}').value || 1); craftItem('${itemData.id}', ${isArtifact}, qty); showCraftingModal();">CRAFT 1<br/>\u{1F4B0}${craftingCost}</button>
                    </div>
                `;
            } else {
                // Determine the blocking gate. The artifact blueprint is a
                // regular recipe input (drop-only), so when it is the ONLY
                // shortfall the message says so instead of pointing at the
                // workbench. Otherwise missing materials come first: when
                // the shortfall is craftable, the button becomes an ACTIVE
                // "craft components" jump into the tree-filtered modal
                // instead of a dead end.
                const missingInputs = (recipe?.inputs || []).filter((input)=>((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] || 0) < input.qty);
                const materialsMissing = missingInputs.length > 0;
                const blueprintMissing = missingInputs.some((input)=>input.id.endsWith('-blueprint'));
                const onlyBlueprintMissing = blueprintMissing && missingInputs.every((input)=>input.id.endsWith('-blueprint'));
                let disabledMessage = null;
                if (onlyBlueprintMissing) disabledMessage = 'MISSING<br>BLUEPRINT';
                else if (materialsMissing) {
                    // Craftable components in the chain? Offer the workbench —
                    // but NOT inside the crafting modal itself (the jump would
                    // just reopen the same modal); there it stays disabled.
                    // Raw-only shortfalls stay disabled - those drop in raids.
                    if (!options.inModal && (0, $52d4eb0e19aef542$export$36d50cdf3bb88c77)(itemData.id).length > 1) actionButton = `<button class="w-full h-10 bg-gradient-to-r from-blue-700 to-blue-800 hover:from-blue-600 hover:to-blue-700 text-white rounded text-xs font-bold border border-game-accent transition-colors leading-tight"
                            title="Open the crafting tree for this item${blueprintMissing ? ' (blueprint still needed - legendary drop)' : ''}"
                            onclick="showCraftingTreeModal('${itemData.id}')">\u{1F527} CRAFT<br>COMPONENTS</button>`;
                    else disabledMessage = 'MISSING<br>MATERIALS';
                } else if (!hasCredits) disabledMessage = 'NOT ENOUGH<br>CREDITS';
                else disabledMessage = 'MISSING<br>MATERIALS';
                if (disabledMessage) actionButton = `<button class="w-full h-10 bg-gray-800 text-gray-400 rounded text-xs font-bold border border-gray-600 cursor-not-allowed flex items-center justify-center leading-tight" disabled ${disabledMessage.includes('MATERIALS') ? 'title="Missing materials drop in raids"' : ''}>${disabledMessage}</button>`;
            }
        } else if (isArtifact && !isReadOnly) {
            const isEquipped = Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts).some((equipped)=>equipped && equipped.id === itemData.id);
            const canEquip = (0, $7df15cefc09eac1b$export$106e54bf5a9adc20) ? (0, $7df15cefc09eac1b$export$106e54bf5a9adc20)(itemData) : true;
            const skillMessage = (0, $7df15cefc09eac1b$export$56e7fec58be964ef) ? (0, $7df15cefc09eac1b$export$56e7fec58be964ef)(itemData) : '';
            if (isEquipped) actionButton = `<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold border border-red-500 transition-colors" onclick="unequipArtifact('${itemData.slot}')">UNEQUIP</button>`;
            else if (canEquip) actionButton = `<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-1 rounded text-xs font-bold border border-amber-400 transition-colors" onclick="equipArtifact('${itemData.id}')">EQUIP</button>`;
            else actionButton = `<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="${skillMessage}">EQUIP</button>`;
        } else if (isSkillGear && !isReadOnly) {
            const isEquipped = Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear).some((equipped)=>equipped && equipped.id === itemData.id);
            const canEquip = (0, $7df15cefc09eac1b$export$9e693217356d7ac4) ? (0, $7df15cefc09eac1b$export$9e693217356d7ac4)(itemData.id) : true;
            const skillMessage = (0, $7df15cefc09eac1b$export$bc6c3240a6a68b89) ? (0, $7df15cefc09eac1b$export$bc6c3240a6a68b89)(itemData.id) : '';
            if (isEquipped) actionButton = `<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold border border-red-500 transition-colors" onclick="unequipTechniqueGear('${itemData.techniqueId}')">UNEQUIP</button>`;
            else if (canEquip) actionButton = `<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-1 rounded text-xs font-bold border border-amber-400 transition-colors" onclick="equipTechniqueGear('${itemData.techniqueId}', '${itemData.id}')">EQUIP</button>`;
            else actionButton = `<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="${skillMessage}">EQUIP</button>`;
        } else {
            const categoryColor = $b7695fceb608271e$export$86e4cd2f7b0dca8(item.type);
            if (item.type === 'consumable') {
                if (isPurchase && !isReadOnly) {
                    // Purchase mode - show BUY button with credit cost
                    // (energy consumables escalate with today's purchases)
                    const credits = (0, $00c60928d2fcd8b8$export$1214c02c27df458d)(itemData, (0, $f27982cef7035d22$export$8e361a1ffbebf172).player);
                    const playerCredits = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits || 0;
                    const canBuy = credits > 0 && playerCredits >= credits;
                    const needsCredits = credits - playerCredits;
                    const escalated = itemData.restoresEnergy && credits > (itemData.credits || 0);
                    const buttonLabel = `BUY \u{1F4B0}${credits}`;
                    const escalationHint = escalated ? ` title="Field logistics surcharge: repeat energy orders cost more today (resets daily)"` : '';
                    if (canBuy) actionButton = `<button class="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white px-2 py-1 rounded text-xs font-bold border border-green-400 transition-colors"${escalationHint} onclick="purchaseConsumable('${itemData.id}')">${buttonLabel}</button>`;
                    else actionButton = `<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="Need ${needsCredits} more credits">${buttonLabel}</button>`;
                } else if (!isPurchase && !isReadOnly) {
                    if (!itemData.restoresHp && !itemData.restoresEnergy) // Technique consumable - deployed automatically in raids, no manual USE
                    actionButton = `<span class="bg-gray-700 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-600" title="Rigs automatically on its technique's first success in a raid \u{2014} the rig lasts the whole raid">\u{2699}\u{FE0F} AUTO</span>`;
                    else {
                        // Inventory mode - show USE button
                        const canUse = $b7695fceb608271e$export$bc3104ce93d3a2dc && $b7695fceb608271e$export$bc3104ce93d3a2dc(itemData.id);
                        const requirementMessage = $b7695fceb608271e$export$2b82d321966e99d9 ? $b7695fceb608271e$export$2b82d321966e99d9(itemData.id) : 'Cannot use';
                        if (canUse) actionButton = `<button class="bg-gradient-to-r ${categoryColor.button} text-white px-2 py-1 rounded text-xs font-bold border border-gray-600 transition-colors" onclick="useConsumable('${itemData.id}')">USE</button>`;
                        else actionButton = `<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="${requirementMessage}">USE</button>`;
                    }
                }
            } else if (item.type === 'relic' && !isReadOnly) {
                const quantityId = `sell-qty-${itemData.id}`;
                const actionButtonCountClass = 'px-1 py-1 bg-gray-600 border border-gray-800 hover:bg-gray-500 text-white rounded text-xs font-bold';
                actionButton = `
                    <button class="${actionButtonCountClass}" onclick="decrementSellQty('${quantityId}')">\u{2212}</button>
                    <button class="${actionButtonCountClass}" onclick="incrementSellQty('${quantityId}')">+</button>
                    <input type="number" id="${quantityId}" class="hidden" value="1" min="1" max="${quantity}" onchange="updateSellQty('${itemData.id}', '${quantityId}')">
                    <button id="sell-btn-${itemData.id}" class="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-2 py-1 rounded text-xs font-bold border border-gray-600 transition-colors" onclick="sellItem('${itemData.id}')">SELL 1</button>`;
            }
        }
        // Collapse state + progress (collapsed view shows name, %, and a bar).
        // displayName overrides the shown title; hideToggle drops the expand
        // chevron (both used by the gear tab for un-blueprinted artifacts).
        const { collapsed: collapsed = false, progress: progress = null, displayName: displayName = null, hideToggle: hideToggle = false, progressQ: progressQ = null } = options || {};
        // A locked artifact can't be expanded (nothing to act on but the unlock
        // control, which shows in the collapsed view) - force collapsed + no toggle
        const effCollapsed = collapsed || artifactLocked;
        const effHideToggle = hideToggle || artifactLocked;
        let progressValue = progress;
        let progressQty = progressQ;
        if ((progressValue == null || progressQty == null) && isCrafting && recipe && recipe.inputs) {
            let haveSum = 0, needSum = 0;
            recipe.inputs.forEach((input)=>{
                const have = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory?.[input.id] || 0;
                haveSum += Math.min(have, input.qty);
                needSum += input.qty;
            });
            progressValue = needSum > 0 ? haveSum / needSum : 0;
            progressQty = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory?.[recipe.target] || 0;
        }
        const progressPct = progressValue != null ? Math.round(progressValue * 100) : null;
        return `
            <div class="inv-card ${effCollapsed ? 'inv-card-collapsed' : ''} ${isEquippedItem ? 'inv-card-equipped' : ''} relative bg-gradient-to-b ${cardBg} border-4 ${cardBorder} rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 ${isCrafting ? '' : 'h-[17rem]'} ${isCrafting ? 'w-52' : 'w-44'} overflow-hidden ${isArtifact ? 'foil-card foil-card-bg' : ''}" data-item-id="${itemData.id}">
                <!-- Card Border Frame -->
                <div class="absolute"></div>

                <!-- Header Banner -->
                <div class="relative bg-gradient-to-r ${headerBg} ${headerText} px-3 py-2 text-left border-b-2 ${headerBorder} h-8">
                    <div class="text-xs font-bold uppercase tracking-wide">${categoryText}</div>
                    ${options.isFocus ? '<div class="absolute top-[0.2rem] right-[5rem] bg-black bg-opacity-30 border border-black rounded-full h-6 px-1 flex items-center justify-center text-sm" title="Suggested focus">\uD83C\uDFAF</div>' : ''}
                    ${factionIcon ? `<div class="inv-card-faction-icon absolute top-[0.2rem] right-[3.75rem] bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="${factionName}">${factionIcon}</div>` : ''}
                    ${itemIcon ? `<div class="inv-card-item-icon absolute top-[0.2rem] right-[1.75rem] bg-black bg-opacity-30 border border-black rounded-full h-6 px-1 flex items-center justify-center text-sm" title="${isSkillGear ? 'Technique: ' + techniqueName : ''}">${isSkillGear ? techniqueIcon : itemIcon}</div>` : ''}
                    <!-- Expand/collapse toggle (top-right corner) -->
                    ${effHideToggle ? '' : `<div class="absolute top-[0.2rem] right-[0.2rem] z-20 bg-black bg-opacity-40 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-xs cursor-pointer hover:border-blue-400 hover:text-blue-300"
                         onclick="event.stopPropagation(); toggleInventoryCardCollapse(this);" title="Expand / collapse">
                        <span class="inv-toggle-open">\u{25B8}</span><span class="inv-toggle-close">\u{25BE}</span>
                    </div>`}
                </div>

                <!-- Card Content -->
                <div class="relative px-2 pb-2">
                    <!-- Title Section -->
                    <div class="min-h-8 flex items-center mx-1 my-2">
                        <h4 class="font-bold text-white text-xs leading-tight flex-grow" ${effCollapsed ? "title='" + itemData.short + "'" : ""}>${displayName || itemName}</h4>
                        ${progressPct != null ? `<span class="card-progress-pct ml-2 text-[12px] font-bold bg-gray-800 px-2 py-1 rounded-full border border-gray-500 ${progressPct == 100 || progressQty > 0 ? 'text-green-400' : 'text-blue-300'}" title="${progressQty > 0 ? "Item qty in inventory" : "Recipe components in inventory"}">${progressPct < 100 && progressQty == 0 ? progressPct + "%" : "x" + progressQty}</span>` : ''}
                    </div>
                    ${progressPct != null ? `
                    <!-- Collapsed-view progress bar -->
                    <div class="card-progress-row mx-1 mb-2">
                        <div class="h-1.5 rounded bg-gray-800 overflow-hidden border border-gray-600">
                            <div class="h-full ${progressPct >= 100 ? 'bg-green-500' : progressPct >= 99 ? 'bg-sky-300' : 'bg-blue-500'}" style="width:${Math.min(100, progressPct)}%"></div>
                        </div>
                    </div>` : ''}
                    ${equipRow}
                    ${quantity != null && !isCrafting ? `
                    <div class="card-collapsed-qty flex justify-between items-center mb-2">
                        <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block">\xd7${quantity}</div>
                        ${actionButton || unitValueBadge}
                    </div>` : ''}

                    <div class="card-body">
                    <!-- Artwork Area with Tippy Tooltip -->
                    <div class="inventory-tooltip relative bg-gradient-to-b from-gray-700 to-gray-800 border-2 border-gray-500 rounded-lg mt-2 mb-2 ${isCrafting ? 'h-24' : 'h-36'} w-full overflow-hidden cursor-pointer">
                        <!-- Hidden tooltip content -->
                        <div class="inventory-tooltip-content hidden">${description}</div>

                        <!-- Icon/Artwork -->
                        <div class="absolute inset-0 flex items-center justify-center">
                            <span class="text-4xl opacity-80 hover:opacity-60 transition-opacity duration-200">${itemIcon}</span>
                        </div>

                        <!-- Info Icon (top-right corner) to indicate tooltip -->
                        <div class="absolute top-1 right-1 z-10 bg-black bg-opacity-50 text-gray-300 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold border border-gray-500 hover:text-blue-300 hover:border-blue-400 transition-colors">\u{2139}</div>

                        <!-- Credit Value Badge (bottom-right corner of image) for relics -->
                        ${itemData.type === 'relic' && itemData && itemData.credits ? `<div class="absolute bottom-1 right-1 z-5 bg-gray-800 text-amber-200 px-2 py-1 rounded text-xs font-bold border border-gray-600 shadow-lg">\u{1F4B0}${itemData.credits}</div>` : ''}
                    </div>

                    ${isCrafting ? // Crafting mode: Materials at top, button at bottom
        `<!-- Material Requirements -->
                        <div class="mb-2 text-xs bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-2 grid grid-cols-2 grid-rows-4 gap-x-2 gap-y-0.5" style="height: 140px; overflow: hidden; grid-auto-flow: column;">
                            ${(()=>{
            let requirements = '';
            // The artifact blueprint is a regular recipe
            // input now, so it renders in the generic
            // rows below like any other requirement
            if (!recipe) requirements += '<div class="text-red-400">Recipe not found</div>';
            else {
                // Use pre-computed materials if available, otherwise fetch on-demand
                const materialIds = recipe.inputs.map((input)=>{
                    return input.id;
                });
                const materialItems = preComputedMaterials || (0, $42b272c2c0f44bdf$export$4251a114f7437961)(materialIds);
                requirements += recipe.inputs.map((input)=>{
                    const materialId = input.id;
                    const required = input.qty;
                    const available = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[materialId] || 0;
                    const hasEnough = available >= required;
                    const material = materialItems[materialId];
                    return `<div class="flex justify-between items-center">
                                            <span class="flex items-center cursor-pointer" title="${material?.name}">
                                                <span class="text-base mr-1 ${hasEnough ? 'text-blue-300' : 'text-amber-300'}">${material?.icon}</span>
                                            </span>
                                            <span class="flex-shrink-0 ${hasEnough ? 'text-blue-300' : 'text-amber-300'}">${available}/${required}</span>
                                        </div>`;
                }).join('');
            }
            return requirements;
        })()}
                        </div>
                        <!-- Action Button at Bottom -->
                        <div class="">
                            ${actionButton}
                        </div>` : isPurchase ? // Consumable purchase modal
        `<!-- Action Button Section with Quantity -->
                            <div class="flex flex-row-reverse">
                                ${actionButton}
                            </div>` : // Regular inventory mode: quantity and button side by side
        `<!-- Action Button Section with Quantity -->
                            <div class="flex justify-between items-center">
                                <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500">\xd7${quantity}</div>
                                ${actionButton}
                            </div>`}
                    </div>
                </div>
            </div>
        `;
    }
}
function $b7695fceb608271e$export$b6b265525b8284bc(el) {
    el.closest('.inv-card')?.classList.toggle('inv-card-collapsed');
}
if (typeof window !== 'undefined') window.toggleInventoryCardCollapse = $b7695fceb608271e$export$b6b265525b8284bc;
function $b7695fceb608271e$export$32cc43b5b1b4dc0e() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress;
    if (!raid) return false;
    const step = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath?.[raid.currentRoomIndex];
    return step?.room?.type === 'campsite';
}
function $b7695fceb608271e$export$bc3104ce93d3a2dc(itemId) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return false;
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] || (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) return false;
    // Ration Cut. Here rather than in useConsumable() so the button renders
    // disabled with a reason instead of failing on click — canUseConsumable is
    // what the card reads to decide.
    if ((0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('noConsumables', false)) return false;
    // Same classification as useConsumable: the item's restore fields decide;
    // technique consumables (neither field) auto-deploy in raids, never manual
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (itemData?.restoresEnergy) {
        // Energy consumables are blocked entirely once a raid is active (planning or in progress)
        const isRaidActive = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        if (isRaidActive) return false;
        return (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy < (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.maxEnergy;
    }
    if (!itemData?.restoresHp) return false;
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress && !$b7695fceb608271e$export$32cc43b5b1b4dc0e()) return false;
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.currentHp < (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.maxHp;
}
function $b7695fceb608271e$export$2b82d321966e99d9(itemId) {
    if ((0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('noConsumables', false)) return 'Ration Cut: no consumables on this contract';
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (itemData?.restoresEnergy) {
        const isRaidActive = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        if (isRaidActive) return 'Only usable before starting a raid';
        return 'Energy already full';
    }
    if (!itemData?.restoresHp) return 'Rigs automatically on its technique\'s first success in a raid';
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress && !$b7695fceb608271e$export$32cc43b5b1b4dc0e()) return 'Only usable at a campsite during a raid';
    return 'Health already full';
}
function $b7695fceb608271e$export$8606b9937b72ca5d() {
    // Ensure we have an active character
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('No active character! Please create or select a character first.', 'error');
        return;
    }
    // Clear existing inventory and artifacts for current character
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts = [];
    // Ensure we get items from each rarity tier
    const rarityTiers = [
        'common',
        'uncommon',
        'rare',
        'epic',
        'legendary',
        'unique'
    ];
    rarityTiers.forEach((rarity)=>{
        const tierItems = (0, $42b272c2c0f44bdf$export$15b7d0c192d0aa5d)().filter((item)=>{
            return item.rarity === rarity;
        });
        if (tierItems.length > 0) {
            // Add a number of item ids depending on the tier
            const count = Math.min(1 + Math.floor(Math.random() * 3), tierItems.length) * (6 - rarityTiers.indexOf(rarity));
            const shuffled = [
                ...tierItems
            ].sort(()=>Math.random() - 0.5);
            for(let i = 0; i < count; i++){
                const randomItem = shuffled[i];
                (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "adding random item:", randomItem);
                let quantity;
                if (randomItem.type === 'storyRelic' || randomItem.type === 'blueprint' || randomItem.type === 'techGear') quantity = 1;
                else if (randomItem.type === 'relic') quantity = 3 + Math.floor(Math.random() * 3);
                else if (randomItem.type === 'consumable') quantity = 5 + Math.floor(Math.random() * 3);
                else quantity = 1000;
                (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[randomItem.id] = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[randomItem.id] || 0) + quantity;
            }
        }
    });
    // Generate 3-5 predefined skill artifacts from artifactData
    const numArtifacts = 3 + Math.floor(Math.random() * 3);
    let bAddedUtilArtifact = false, i = 0;
    while(i < numArtifacts){
        // Select a random artifact from the predefined list
        const allArtifacts = (0, $42b272c2c0f44bdf$export$18c4115a8e7963b)();
        const randomArtifact = allArtifacts[Math.floor(Math.random() * allArtifacts.length)];
        if (i > 1 && !bAddedUtilArtifact && randomArtifact.slot == 'skillSlot') continue;
        if (randomArtifact.slot != 'skillSlot') bAddedUtilArtifact = true;
        // Create artifact instance with unique ID (matching crafting system format)
        const artifact = {
            key: Date.now() + Math.random() + i,
            id: randomArtifact.id,
            name: randomArtifact.name,
            type: randomArtifact.type,
            slot: randomArtifact.slot,
            skill: randomArtifact.skill,
            effects: randomArtifact.effects,
            description: randomArtifact.description,
            short: randomArtifact.short,
            faction: randomArtifact.faction,
            rarity: randomArtifact.rarity,
            icon: randomArtifact.icon,
            crafted: true // Mark as crafted like the crafting system
        };
        // Only add if not already in artifacts array
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.some((a)=>a.id === artifact.id)) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.push(artifact);
        i++;
    }
    // Save current character's inventory and artifacts to their character data
    const currentCharIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.findIndex((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (currentCharIndex !== -1) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex].inventory = {
            ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory
        };
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex].artifacts = [
            ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts
        ];
    }
    // Refresh Alpine store
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    // Show notification
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Generated random items!`, 'success');
    // Update UI and save
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $b7695fceb608271e$export$56dcd79bae47b9c1() {
    // Ensure we have an active character
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('No active character! Please create or select a character first.', 'error');
        return;
    }
    // Clear current character's inventory and artifacts
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts = {
        skillSlot: null,
        utilitySlot: null
    };
    // Save current character's cleared inventory to their character data
    const currentCharIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.findIndex((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (currentCharIndex !== -1) {
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex].inventory = {};
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex].artifacts = [];
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex].equippedArtifacts = {
            skillSlot: null,
            utilitySlot: null
        };
    }
    // Refresh Alpine store
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    // Show notification
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Inventory cleared!', 'success');
    // Update UI and save
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $b7695fceb608271e$export$d2567add70135c10() {
    const inventoryCharacterName = document.getElementById('inventory-character-name');
    if (inventoryCharacterName && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) inventoryCharacterName.textContent = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name + "'s";
}
function $b7695fceb608271e$export$8a26d5080d84dfb0(itemId) {
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId) || (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', itemId);
    if (!item || !item.type || !item.effects) return '';
    return Object.entries(item.effects || {}).map(([effectId, amt])=>{
        const effect = (0, $42b272c2c0f44bdf$export$96671014a1dabc4c)(effectId);
        let effectQual = '';
        if (effect.unit == 'percent') effectQual += ` by ${amt}%`;
        else if (effect.unit == 'count') effectQual += ` ${amt} time${amt > 1 ? 's' : ''}`;
        return effect.description + effectQual + '.';
    }).join('  ');
}
function $b7695fceb608271e$export$8e8909cfaf15b391(itemId) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return 0;
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566) ? (0, $91ce0e04738077df$export$3645b25e1a815566)(itemId) : null;
    if (!recipe || !recipe.inputs) return 0;
    // Find the limiting factor (material with lowest quantity available)
    let maxQty = 99; // Start with max possible
    for (const input of recipe.inputs){
        const available = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
        const canCraftQty = Math.floor(available / input.qty);
        maxQty = Math.min(maxQty, canCraftQty);
    }
    return Math.max(1, maxQty); // Always allow at least 1
}
function $b7695fceb608271e$export$ff0507185d233e75(quantityId) {
    const input = document.getElementById(quantityId);
    if (input) {
        const itemId = quantityId.replace('sell-qty-', '');
        const currentVal = parseInt(input.value) || 1;
        const maxQty = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId];
        const newVal = Math.min(currentVal + 1, maxQty);
        input.value = newVal;
        $b7695fceb608271e$export$4b495d34a3840d43(itemId, quantityId);
    }
}
function $b7695fceb608271e$export$a4d3bbe47949d494(quantityId) {
    const input = document.getElementById(quantityId);
    if (input) {
        const itemId = quantityId.replace('sell-qty-', '');
        const currentVal = parseInt(input.value) || 1;
        const newVal = Math.max(currentVal - 1, 1);
        input.value = newVal;
        $b7695fceb608271e$export$4b495d34a3840d43(itemId, quantityId);
    }
}
function $b7695fceb608271e$export$4b495d34a3840d43(itemId, quantityId) {
    const input = document.getElementById(quantityId);
    const sellBtn = document.getElementById(`sell-btn-${itemId}`);
    if (input && sellBtn) {
        const quantity = parseInt(input.value) || 1;
        const maxQty = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[itemId];
        // Clamp to max craftable
        if (quantity > maxQty) input.value = maxQty;
        sellBtn.innerHTML = `SELL ${quantity}`;
    }
}
function $b7695fceb608271e$export$ad1aa4315d00018a(quantityId) {
    const input = document.getElementById(quantityId);
    if (input) {
        const itemId = quantityId.replace('craft-qty-', '');
        const currentVal = parseInt(input.value) || 1;
        const maxQty = $b7695fceb608271e$export$8e8909cfaf15b391(itemId);
        const newVal = Math.min(currentVal + 1, maxQty);
        input.value = newVal;
        $b7695fceb608271e$export$8ef1bcc7d93420a1(itemId, quantityId);
    }
}
function $b7695fceb608271e$export$7b962277503582ab(quantityId) {
    const input = document.getElementById(quantityId);
    if (input) {
        const itemId = quantityId.replace('craft-qty-', '');
        const currentVal = parseInt(input.value) || 1;
        const newVal = Math.max(currentVal - 1, 1);
        input.value = newVal;
        $b7695fceb608271e$export$8ef1bcc7d93420a1(itemId, quantityId);
    }
}
function $b7695fceb608271e$export$8ef1bcc7d93420a1(itemId, quantityId) {
    const input = document.getElementById(quantityId);
    const craftBtn = document.getElementById(`craft-btn-${itemId}`);
    if (input && craftBtn && window.calculateBulkCraftingCost) {
        const quantity = parseInt(input.value) || 1;
        const maxQty = $b7695fceb608271e$export$8e8909cfaf15b391(itemId);
        // Clamp to max craftable
        if (quantity > maxQty) input.value = maxQty;
        const totalCost = (0, $52d4eb0e19aef542$export$5c9f0b8d2a488474)(itemId, quantity);
        craftBtn.innerHTML = `CRAFT ${quantity}<br/>\u{1F4B0}${totalCost}`;
    }
}
function $b7695fceb608271e$export$1690b2b2efa58f74() {
    // HP consumables only - energy is bought (and applied) one-step via the
    // header's ⚡ popup, so a second buy-then-use path here would just confuse
    const purchasableConsumables = [
        'field-health-stim',
        'recovery-injector-mk2',
        'advanced-recovery-serum'
    ];
    const grid = document.getElementById('purchasable-items-grid');
    const noItems = document.getElementById('no-purchasable-items');
    if (!grid || !noItems) return;
    // Clear grid
    grid.innerHTML = '';
    // Add each purchasable item to the grid
    let hasItems = false;
    purchasableConsumables.forEach((itemId)=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
        if (item) {
            hasItems = true;
            // Create a modified item object for display in purchase mode
            const displayItem = {
                ...item,
                id: itemId,
                quantity: 0,
                type: 'consumable'
            };
            // Create card using the existing createInventoryCard with 'purchase' mode
            const cardHtml = $b7695fceb608271e$export$4ac7f915da1fa1c4(displayItem, 'purchase');
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cardHtml;
            grid.appendChild(tempDiv.firstElementChild);
        }
    });
    // Show/hide no items message
    noItems.classList.toggle('hidden', hasItems);
}
function $b7695fceb608271e$export$432db33666131f90() {
    $b7695fceb608271e$export$1690b2b2efa58f74();
    // Show modal
    const modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.classList.remove('hidden');
    // Reinitialize tooltips for the newly created cards
    if (window.tippy) tippy(".inventory-tooltip", {
        theme: "dark",
        placement: "top",
        delay: [
            300,
            0
        ],
        maxWidth: 300,
        allowHTML: true,
        content (reference) {
            const descDiv = reference.querySelector(".inventory-tooltip-content");
            return descDiv ? descDiv.innerHTML : "";
        },
        onMount (instance) {
            instance.popper.style.border = "2px solid white";
            instance.popper.style.borderRadius = "0.5rem";
        },
        onShow (instance) {
            // Create a named function so it can be accurately removed later
            instance._scrollHandler = ()=>instance.hide();
            window.addEventListener('scroll', instance._scrollHandler, {
                passive: true
            });
        },
        onHide (instance) {
            // Clean up the listener to prevent memory leaks
            window.removeEventListener('scroll', instance._scrollHandler);
        }
    });
}
function $b7695fceb608271e$export$1ed9acaf4451ebfa() {
    const modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.classList.add('hidden');
}
// ---------------------------------------------------------------------------
// Header energy popup - one-step purchase: buying applies the energy
// immediately (no inventory round-trip). Same rules as buy-then-use had:
// escalating same-day prices, blocked while a raid is planned or running.
// ---------------------------------------------------------------------------
const $b7695fceb608271e$var$ENERGY_POPUP_ITEMS = [
    'portable-energy-pack',
    'energy-conversion-pack',
    'power-cell-mk3'
];
function $b7695fceb608271e$var$isRaidBlockingEnergy() {
    return !!((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid));
}
function $b7695fceb608271e$export$ab4faafa71d5b548() {
    const popup = document.getElementById('energy-popup');
    if (!popup) return;
    const player = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player || {
        energy: 0,
        maxEnergy: 100,
        credits: 0
    };
    const missing = Math.max(0, (player.maxEnergy || 0) - (player.energy || 0));
    const raidBlocked = $b7695fceb608271e$var$isRaidBlockingEnergy();
    const anyEscalated = $b7695fceb608271e$var$ENERGY_POPUP_ITEMS.some((id)=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
        return item && (0, $00c60928d2fcd8b8$export$1214c02c27df458d)(item, player) > (item.credits || 0);
    });
    const rows = $b7695fceb608271e$var$ENERGY_POPUP_ITEMS.map((id)=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
        if (!item) return '';
        const price = (0, $00c60928d2fcd8b8$export$1214c02c27df458d)(item, player);
        const gain = Math.min(item.restoresEnergy, missing);
        const gainLabel = gain < item.restoresEnergy ? `+${gain}/${item.restoresEnergy}` : `+${item.restoresEnergy}`;
        const disabled = raidBlocked || missing <= 0 || (player.credits || 0) < price;
        const title = raidBlocked ? 'Not available while a raid is being planned or running' : missing <= 0 ? 'Energy already full' : (player.credits || 0) < price ? `Need ${price - (player.credits || 0)} more credits` : `Restores ${gain} energy instantly`;
        return `
            <button class="w-full flex items-center gap-2 px-2 py-1.5 rounded border text-sm text-left transition-colors
                ${disabled ? 'border-gray-700 text-gray-500 cursor-not-allowed' : 'border-blue-800 text-gray-200 hover:bg-blue-900/40'}"
                ${disabled ? 'disabled' : ''} title="${title}" onclick="buyEnergyDirect('${id}')">
                <span>${item.icon}</span>
                <span class="flex-1">${item.name}</span>
                <span class="text-blue-400 font-bold whitespace-nowrap">${gainLabel} \u{26A1}</span>
                <span class="text-game-gold font-bold whitespace-nowrap">\u{1F4B0}${price}</span>
            </button>`;
    }).join('');
    popup.innerHTML = `
        <div class="text-[11px] uppercase tracking-widest text-gray-400 mb-2">Buy Energy \u{2014} applied instantly</div>
        <div class="flex flex-col gap-1.5">${rows}</div>
        ${raidBlocked ? '<div class="text-[11px] text-red-400 mt-2">Not available while a raid is planned or running</div>' : ''}
        ${anyEscalated ? '<div class="text-[11px] text-gray-500 mt-2">Field logistics surcharge: repeat energy orders cost more today (resets daily)</div>' : ''}`;
}
function $b7695fceb608271e$export$4c1b7a82836a6e5c(event) {
    event?.stopPropagation();
    const popup = document.getElementById('energy-popup');
    if (!popup) return;
    const opening = popup.classList.contains('hidden');
    popup.classList.toggle('hidden', !opening);
    if (opening) {
        // Fixed-position under the header's ⚡ chip. The popup is a top-level
        // element (see index.html) rather than a header child, so it is
        // anchored by id — there is no useful parent to fall back to, and the
        // currency chips it points at are re-rendered from the layer registry.
        const chip = document.getElementById('energy-chip')?.getBoundingClientRect();
        if (chip) {
            popup.style.top = `${chip.bottom + 8}px`;
            popup.style.right = `${Math.max(8, window.innerWidth - chip.right)}px`;
        }
        $b7695fceb608271e$export$ab4faafa71d5b548();
        // Close on any click outside the popup (the opener button stops
        // propagation). A detached target means the click hit a row that
        // buyEnergyDirect just re-rendered away - that's inside, stay open.
        const closeOnOutside = (e)=>{
            if (!popup.contains(e.target) && document.contains(e.target)) {
                popup.classList.add('hidden');
                document.removeEventListener('click', closeOnOutside);
            }
        };
        document.addEventListener('click', closeOnOutside);
    }
}
function $b7695fceb608271e$export$d4a1bdd7cb9254a9(itemId) {
    const itemData = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!itemData?.restoresEnergy) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('This item cannot be purchased here!', 'error');
        return;
    }
    if ($b7695fceb608271e$var$isRaidBlockingEnergy()) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Energy can only be bought before starting a raid!', 'error');
        return;
    }
    const player = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player;
    if (!player || player.energy >= player.maxEnergy) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Your energy is already full!', 'info');
        return;
    }
    const price = (0, $00c60928d2fcd8b8$export$1214c02c27df458d)(itemData, player);
    if (player.credits < price) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Not enough credits! Need ${price}, have ${player.credits}`, 'error');
        return;
    }
    player.credits -= price;
    (0, $00c60928d2fcd8b8$export$cfff9bc32ab6cb78)(player);
    const gained = Math.min(itemData.restoresEnergy, player.maxEnergy - player.energy);
    player.energy += gained;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${itemData.icon} ${itemData.name}: +${gained} energy for ${price} credits`, 'success');
    $b7695fceb608271e$export$ab4faafa71d5b548(); // prices escalate per purchase - refresh labels
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $b7695fceb608271e$export$fe032c86fe8adff() {
    const closeBtn = document.getElementById('close-purchase-modal');
    if (closeBtn) closeBtn.addEventListener('click', $b7695fceb608271e$export$1ed9acaf4451ebfa);
    // Close modal when clicking outside
    const modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.addEventListener('click', (e)=>{
        if (e.target === modal) $b7695fceb608271e$export$1ed9acaf4451ebfa();
    });
}








/**
 * Recipe Core - recipe lookup with input scaling applied. Pure, no DOM.
 *
 * Extracted from crafting.js so it can be used headlessly. crafting.js carries
 * the crafting UI (infinite scroll, MutationObserver, notifications), which
 * meant anything importing it - including gear-core.js - could not be loaded in
 * Node, breaking the rule that -core modules are usable by the simulator.
 *
 * crafting.js re-exports getRecipeById from here, so existing importers and
 * tests are unaffected.
 */ 


/**
 * Progression Scaling Configuration
 *
 * SINGLE SOURCE OF TRUTH for balance values shared by the game and the
 * headless simulator (tools/simulation/game-simulator.js). The simulator
 * defaults to these values; tools/simulation/simulation-config.json is
 * pure override/experiment space. To ship a validated experiment value,
 * edit it HERE and run `npm run build` (regenerates js/constants.js).
 *
 * Values are tuned so that:
 * - All 15 faction epic tech gear items are craftable in a 30-day cycle
 * - Inventory quantities stay in balanced range (50-150 per item)
 * - Higher-rarity intermediates are properly gated by their availability
 */ const $421e73803e2762ca$export$9f9786ac427715c7 = {
    /**
   * Durable-gear craft cap. Skill (tech) gear and artifacts are equip-once
   * items - one slot per skill / per artifact slot, never consumed, sold, or
   * traded - so a second copy earns nothing (marks are already distinct-only)
   * and just burns materials. When false (default) each such design can be
   * crafted once per character; the crafting card shows "✓ CRAFTED" instead.
   * Flip to true to re-enable duplicate crafting (e.g. if a gear marketplace
   * ever makes spare copies worth something). Consumables are unaffected.
   */ allowDuplicateCrafts: false,
    recipeInputs: {
        // Re-tuned for weighted per-item drops: selection weights spread drops across
        // all items (nothing starves to zero anymore), so demand carries the pacing
        common: 5,
        uncommon: 5,
        rare: 4,
        epic: 4,
        legendary: 1,
        unique: 1
    },
    /**
   * Skill points awarded per level up (character-core.js levelUpCore).
   * Formula: base + Math.floor(level / levelDivisor) * increment
   * where `level` is the level just REACHED.
   *
   * With the values below (base: 2, levelDivisor: 2, increment: 3):
   * - Level 1:   3 skill points (the starting allotment, not a level-up grant)
   * - Level 2-3: 5 per level-up
   * - Level 4-5: 8 per level-up
   * - Level 6-7: 11 per level-up
   */ skillPointsPerLevel: {
        base: 2,
        levelDivisor: 2,
        increment: 3
    },
    /**
   * Per-skill synergy unlocks (progressive disclosure of the synergy layer):
   * hidden entirely below minLevel, then each skill's synergies are bought
   * with skill points. A synergy variant can fire only when it touches an
   * unlocked skill on either side (the event's skill, or the skill of the
   * player's partner device).
   */ synergyUnlocks: {
        minLevel: 4,
        cost: 2
    },
    /**
   * Raid XP tier weighting (Command era). The level curve's old assumption
   * ("level 8 in 1-2 months") predates promotion cycling; with 3-5 day
   * tours, character level was the binding progression constraint - tours
   * stalled at level 4-5 on tier-1 XP. Pushing tiers is now the leveling
   * ladder: T1 pacing (and first-promotion timing) unchanged, T2/T3 raids
   * pay multiples so deep tours can level past the plateau.
   */ raidXpTierMultipliers: {
        1: 1,
        2: 3,
        3: 5
    },
    /**
   * Skill event damage scaling per raid tier
   * Damage formula: minDamage + random(0, maxDamage - minDamage)
   * where minDamage = baseDamage * tier, maxDamage = minDamage + (baseDamage * tier)
   *
   * Example with defaults (baseDamage: 5):
   * - Tier 1: 5-15 damage (5 + 0-10)
   * - Tier 2: 10-30 damage (10 + 0-20)
   * - Tier 3: 15-45 damage (15 + 0-30)
   */ skillEventDamage: {
        baseDamage: 5,
        perTier: {
            1: {
                min: 20,
                max: 30
            },
            2: {
                min: 25,
                max: 35
            },
            3: {
                min: 30,
                max: 40
            }
        }
    },
    /**
   * Bonus event cascade chance multipliers, per raid tier AND per cascade step.
   * Applied as: rarityDropChance * bonusEventCascadeMultipliers[tier][nextRarity]
   * when the end-of-room bonus event rolls to cascade common→rare→epic→legendary→unique.
   *
   * Per-rarity so the legendary step can be boosted (its base chance is near zero,
   * this is the main legendary blueprint source) WITHOUT saturating the rare/epic
   * steps - a flat multiplier clamped those to 100% per clean room.
   */ bonusEventCascadeMultipliers: {
        // rare < 1.0 keeps leaf-rare cascade volume near recipe demand.
        // Legendary (= artifact blueprints, the whole legendary pool) is a TIER 3
        // EXCLUSIVE: reaching T3 is the plannable path to artifacts (and the
        // Syndicate boundary), not a lottery ticket at every tier. 50 saturates
        // the legendary step (0.02 base x 50 = chance 1.0 once the cascade
        // reaches epic), so a clean T3 room drops a blueprint at its epic-chain
        // rate (~3% hazard, ~7% gate).
        1: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        2: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        3: {
            rare: 0.5,
            epic: 1.0,
            legendary: 50,
            unique: 1.0
        }
    },
    /**
   * Share of a promoted character's MATERIALS that passes to their successor.
   * The remainder is consigned to the Syndicate dock as Operations cargo
   * (command-core.js disburseInventory).
   *
   * Fixed, and was a three-rank Command upgrade ("Guild Vault", 80/240/720
   * marks) until the S7c pass removed it. The rank bought nothing: gear crafted
   * per tour is FLAT across a 2.5x range of this value - 5.57 at 10/20/30,
   * 6.07 at 15/30/50, 5.61 at 25/50/75, n=4 each - so the upgrade taxed 1,040
   * marks for an effect that does not exist. An upgrade that cannot be measured
   * is worse than no upgrade, because buying it is a trap.
   *
   * Why the share does not matter: it is not a one-way transfer. Whatever the
   * successor inherits and does not CONSUME is disbursed again at their own
   * promotion, and again after that, so the dial changes timing rather than
   * totals. Measured: at 75% carryover the L3 dock was unchanged (17,977 vs
   * 18,504 units) and zero convoys were ever refused for cargo.
   *
   * 0.3 because it equals the old rank-3 value - nobody who had fully invested
   * is worse off - and because a flat "a third of your kit passes on" reads
   * cleanly in the fiction. Any value in 0.1-0.75 measures the same.
   */ vaultCarryover: 0.3,
    /**
   * Share of the NON-carried remainder that reaches the Syndicate dock as
   * Operations cargo. The rest is consumed — spent living, in the fiction.
   *
   * The accounting used to be closed: 30% to the successor, 70% to L3, nothing
   * lost. That was tidy and produced an unusable economy. A dock held ~18,000
   * units while a whole era's convoys consumed ~1,500 (8%), so the "common
   * material piles plateau (<300/signature)" target measured ~2,500 and rising,
   * and cargo could never be a real constraint on Operations — even 10x the
   * cargo per convoy would not have drained it.
   *
   * No dial inside Operations could fix that, because the problem is supply,
   * not demand. This is the supply valve.
   */ consignmentRate: 0.15,
    /**
   * Command layer (M2) - Command Marks formula coefficients + unlock threshold.
   * Consumed by command-core.js calculateCommandMarks:
   *   marks = perTechGear       * distinct tech gear owned (inventory + equipped)
   *         + perArtifactUnlock * lifetime.artifactsUnlocked
   *         + perArtifactCraft  * lifetime.artifactsCrafted
   *         + floor(lifetime.t3Wins / t3WinsDivisor)
   *         + perLevel          * level
   * The sim promotion policy tunes these so an un-upgraded character #1's
   * marks/hour peaks ~day 3-5 (see docs/Roadmap-070426.md playtime budget).
   */ commandMarks: {
        // Marks reward CRAFTING, which is the player's active progress: skill gear
        // early (the only thing craftable at first), artifacts later (once T3 is
        // reachable). Character level is an ENABLER, not a payout - it unlocks
        // higher tiers, which yield T3 wins + blueprints -> artifacts; its direct
        // marks contribution is deliberately small so it can't become the main
        // driver (it previously grew to ~50% of marks as accounts matured).
        // Held at 4. Raising it was MEASURED in the S7c pass and rejected: at 8,
        // three runs put the first founding on day 31/34/31 - identical to the
        // 31-36 baseline - while Writs overshot to 34-38 and the L1 era collapsed
        // from ~40h to 18-21h. Two reasons, both structural:
        //
        //  - It cannot shorten a tour. Tour length is when cumulative marks/hour
        //    PEAKS, and a bigger gear channel moves that peak later by about as
        //    much as it pays, so the schedule does not move.
        //  - Marks are also the CURRENCY for Command upgrades, so doubling this
        //    halves the real price of the whole catalogue. The first promotion
        //    fires at the 60-mark floor, which needs ~15 gear at 4 and only 8 at
        //    8 - halving the onboarding era as a side effect.
        //
        // The L2 era overruns because tours 2-15 run ~26h against the ~18h the
        // 300h budget implies. That is a CYCLE COMPRESSION problem (officer-academy
        // / guild-vault head starts not paying off enough), not a throughput one,
        // and this coefficient is the wrong lever for it.
        perTechGear: 4,
        // Artifacts split into two channels (see command-core unlockArtifactCore):
        //   perArtifactUnlock - ONE-TIME per design per ACCOUNT, banked when the
        //     design's blueprint is consumed to unlock it. The milestone: 27
        //     designs => a finite ~675-mark collection goal.
        //   perArtifactCraft - each distinct craft per character (parallel to gear,
        //     ~2x a gear piece). Keeps a modest sustained artifact-marks trickle
        //     without the runaway 25-per-craft farm.
        perArtifactUnlock: 25,
        perArtifactCraft: 8,
        // T3 wins are the "operating at high tier" marks channel that level
        // enables (2 wins per mark); artifacts are the high-tier crafting payoff
        t3WinsDivisor: 2,
        perLevel: 1,
        // Command tab reveals when estimated marks first reach this. Tied to
        // perTechGear: it fires on the 7th piece of gear. If perTechGear ever
        // moves, scale this by the same ratio - it is a progression milestone
        // measured in what the player has BUILT, and leaving it fixed would slide
        // a designed reveal earlier as a side effect of an unrelated change.
        unlockThreshold: 25
    },
    /**
   * Promotion credit levy (applied in command-core.js promoteCharacterCore).
   * Credits are account-shared, so promotion takes a percentage cut instead
   * of a flat reset: kept = max(floor, credits * keepFraction). The levy is
   * the economy's terminal credit sink — it must scale with wealth to keep
   * absorbing late-game surplus; the floor doubles as a safety net so a
   * broke account still restarts with working capital.
   */ promotionCreditLevy: {
        keepFraction: 0.25,
        floor: 1000
    },
    /**
   * Collapse Key recovery — the ONLY tunable in the story track.
   *
   * Chance that a successful raid recovers the next Collapse Key its faction is
   * still missing. Not an economic number: keys have no value, no sink and no
   * sale, so this tunes STORY PACING alone and no balance target reads it.
   *
   * The tier table (keys 1-2 at T1, 3-4 at T2, 5-7 at T3) is what actually
   * paces the arc — a T1 character can only ever hold two keys, however long
   * they raid. This number decides how quickly they reach that ceiling: at 0.25
   * the first key lands in the opening session and the T1 pair inside ~8 wins,
   * which is the point of shipping keys 1-7 at all. The game previously told
   * the player nothing until ~900 hours in.
   */ collapseKeyDropChance: 0.25,
    /**
   * Raid credit reward scaling (applied in raidUtil.js applyCreditsScaling)
   * effective = earned * globalMultiplier * tierMultipliers[tier]
   */ creditsScaling: {
        globalMultiplier: 0.3,
        tierMultipliers: {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    },
    /**
   * Energy repurchase escalation (applied in raidUtil.js
   * getConsumablePurchasePrice): energy-restoring consumables cost
   * base * escalationFactor^(purchases today), resetting daily.
   * The primary Command-era credit sink - converts surplus credits into
   * raid throughput at a net credit loss (late game: 5-6 packs/day
   * ~ the 4-10k/day income it must soak). 1.0 disables escalation.
   */ energyPurchaseScaling: {
        escalationFactor: 2.0
    },
    /**
   * Per-tour crafting discount (Command layer). Each completed tour makes
   * crafting cheaper for every later tour — the institutional-knowledge payoff.
   *
   * DERIVED, never compounded:
   *   globalMultiplier = craftingCostScaling.globalMultiplier * factor^(tour - 1)
   *
   * It used to be applied by multiplying raidUtil's module state at each
   * promotion, which main.js then re-seeded from config on every boot — so the
   * discount silently vanished on reload. Deriving it from `command.tour` makes
   * it reload-safe, and makes L3's founding reset free: tour returns to 1, so
   * the multiplier returns to base with nothing extra to persist.
   *
   * 1.0 disables the discount.
   */ craftingDiscountPerTour: 0.9,
    /**
   * Crafting credit cost scaling (applied in raidUtil.js applyCraftingCostScaling)
   * effective = cost * globalMultiplier * rarityMultipliers[rarity]
   */ craftingCostScaling: {
        globalMultiplier: 5,
        rarityMultipliers: {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    }
};
function $421e73803e2762ca$export$6941830bed591a7b(rarity) {
    const multiplier = $421e73803e2762ca$export$9f9786ac427715c7.recipeInputs[rarity];
    if (multiplier === undefined) {
        console.warn(`Unknown input rarity: ${rarity}, returning 1.0`);
        return 1.0;
    }
    return multiplier;
}
function $421e73803e2762ca$export$2a160ac1bc0ae37b(quantity) {
    if (quantity < 10) // Keep 1-9 as-is
    return Math.max(1, Math.ceil(quantity));
    else if (quantity < 100) // Round 10-99 to nearest 5
    return Math.ceil(quantity / 5) * 5;
    else // Round 100+ to nearest 10
    return Math.ceil(quantity / 10) * 10;
}
function $421e73803e2762ca$export$a43c2a5178ae7642(inputs, getRarityFn = null) {
    if (!inputs || !Array.isArray(inputs)) return inputs;
    return inputs.map((input)=>{
        let inputQty = input.qty;
        // Get input rarity (from input object or from provided function)
        let inputRarity = input.rarity;
        if (!inputRarity && getRarityFn) inputRarity = getRarityFn(input.id);
        // Apply per-input scaling based on rarity
        if (inputRarity) {
            const inputMultiplier = $421e73803e2762ca$export$6941830bed591a7b(inputRarity);
            inputQty *= inputMultiplier;
        }
        return {
            ...input,
            qty: $421e73803e2762ca$export$2a160ac1bc0ae37b(inputQty)
        };
    });
}


function $91ce0e04738077df$export$59400736ce304c7(recipe) {
    if (!recipe || !recipe.inputs) return recipe;
    const getRarityOfInput = (itemId)=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
        return item?.rarity || 'common';
    };
    return {
        ...recipe,
        inputs: (0, $421e73803e2762ca$export$a43c2a5178ae7642)(recipe.inputs, getRarityOfInput)
    };
}
function $91ce0e04738077df$export$3645b25e1a815566(itemId) {
    const recipe = $ce6dd72bc4611534$export$c4df318d1f4ad4.find((r)=>r.target === itemId) || $ce6dd72bc4611534$export$c95766f8298d6ed1.find((r)=>r.target === itemId) || $ce6dd72bc4611534$export$12c2125da4fa007.find((r)=>r.target === itemId) || $ce6dd72bc4611534$export$ded4d2beb9be271a.find((r)=>r.target === itemId);
    return recipe ? $91ce0e04738077df$export$59400736ce304c7(recipe) : null;
}
function $91ce0e04738077df$export$10d9b633aa01c262(scaledRecipe, character) {
    if (!scaledRecipe?.inputs) return false;
    const inventory = character?.inventory || {};
    return scaledRecipe.inputs.every((input)=>(inventory[input.id] || 0) >= input.qty);
}
function $91ce0e04738077df$export$e6fc872703f0201(itemId) {
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!item) return 0;
    return (0, $00c60928d2fcd8b8$export$574cc08100f7d092)($ce6dd72bc4611534$export$d4a72d069095e9e5[item.rarity]?.craftingCost || 10, item.rarity);
}


// ============================================================================
// INFINITE SCROLL STATE FOR CRAFTING
// ============================================================================
const $52d4eb0e19aef542$var$craftingScrollState = {
    /** @type {Array<any>} */ allFilteredRecipes: [],
    /** @type {Array<any>} */ visibleRecipes: [],
    pageSize: 15,
    /** @type {Object} */ preComputedMaterials: {},
    /** @type {IntersectionObserver|null} */ observer: null,
    /** Track the actual end position of loaded recipes */ loadedUpTo: 0,
    /** @type {NodeJS.Timeout|null} Debounce timeout ID to prevent rapid successive loads */ loadDebounceTimeout: null,
    reset () {
        this.allFilteredRecipes = [];
        this.visibleRecipes = [];
        this.preComputedMaterials = {};
        this.loadedUpTo = 0;
        if (this.loadDebounceTimeout) {
            clearTimeout(this.loadDebounceTimeout);
            this.loadDebounceTimeout = null;
        }
    },
    hasMoreToLoad () {
        return this.loadedUpTo < this.allFilteredRecipes.length;
    },
    loadMore () {
        if (!this.hasMoreToLoad()) return false;
        const end = Math.min(this.loadedUpTo + this.pageSize, this.allFilteredRecipes.length);
        // Load from start (0) to current end position
        this.visibleRecipes = this.allFilteredRecipes.slice(0, end);
        this.loadedUpTo = end;
        // Set debounce timeout for 300ms to prevent rapid loads
        this.loadDebounceTimeout = setTimeout(()=>{
            this.loadDebounceTimeout = null;
        }, 300);
        return true;
    }
};
function $52d4eb0e19aef542$export$ac539fb4b9c6f75e(artifactKey) {
    const artifact = (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) return false;
    // Check if player's faction matches artifact faction (or artifact is neutral)
    if (artifact.faction !== 'neutral' && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction !== artifact.faction) return false;
    // The design must be unlocked (blueprint consumed) before it can be crafted
    if (!(0, $bde36de43872f734$export$2ab3ae91631fe8e5)(artifactKey)) return false;
    // Find the recipe for this artifact and check if it can be crafted
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(artifactKey);
    if (!recipe) return false;
    // Use the existing canCraftRecipe function to check materials
    return $52d4eb0e19aef542$export$10d9b633aa01c262(recipe);
}
function $52d4eb0e19aef542$export$67f8f6c6271cd4a2(itemId, isArtifact) {
    // Check if current character is on marketplace
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot craft with a character that is contracted out on the marketplace', 'error');
        return false;
    }
    if (isArtifact) return $52d4eb0e19aef542$export$cf54799c3e0d127e(itemId);
    else return $52d4eb0e19aef542$var$craftComponent(itemId);
}
function $52d4eb0e19aef542$var$craftComponent(itemId, quantity = 1) {
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!item) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Unknown component recipe!', 'error');
        return false;
    }
    // Get recipe with scaling applied
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(itemId);
    if (!recipe) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Recipe not found!', 'error');
        return false;
    }
    // One craft per design per character for durable tech gear (equip-once,
    // one per skill). Consumables and intermediate components stay repeatable.
    if (item.type === 'techGear' && !(0, $bde36de43872f734$export$c95b8ce76efadccf)() && (0, $bde36de43872f734$export$2886ceaa061d802b)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, itemId)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${item.name} is already crafted - one per character.`, 'error');
        return false;
    }
    // Calculate total credit cost for all crafts
    const creditCost = $52d4eb0e19aef542$export$5c9f0b8d2a488474(itemId, quantity);
    const playerCredits = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits || 0;
    // Check materials for all quantities
    for (const input of recipe.inputs){
        const available = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
        const needed = input.qty * quantity;
        if (available < needed) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Missing materials! Need ${needed - available} more ${(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', input.id)?.name || input.id}`, 'error');
            return false;
        }
    }
    // Check credits
    if (playerCredits < creditCost) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Not enough credits! Need ${creditCost}, have ${playerCredits}`, 'error');
        return false;
    }
    // Consume materials
    for (const input of recipe.inputs){
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] -= input.qty * quantity;
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] <= 0) delete (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id];
    }
    // Deduct credits
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits -= creditCost;
    // Add crafted items to inventory
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[item.id]) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[item.id] = 0;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[item.id] += quantity;
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    const message = quantity > 1 ? `Crafted ${quantity}x ${item.name} for ${creditCost}\u{1F4B0}!` : `Crafted ${item.name} for ${creditCost}\u{1F4B0}!`;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(message, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    return true;
}
function $52d4eb0e19aef542$export$3bec963ccca7a0ba(quantity = 1) {
    if (quantity >= 20) return 50;
    if (quantity >= 11) return 65;
    if (quantity >= 6) return 75;
    if (quantity >= 2) return 85;
    return 100;
}
function $52d4eb0e19aef542$export$5c9f0b8d2a488474(itemId, quantity = 1) {
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    if (!item) return 0;
    // Base cost from rarity, scaled by progressionScaling.craftingCostScaling.
    // Lives in recipes-core so the simulator and Auto-Fabricator charge the
    // same thing - keep parity.
    const baseCost = (0, $91ce0e04738077df$export$e6fc872703f0201)(itemId);
    // Get cost percentage based on quantity (higher qty = lower percentage = more discount)
    const costPercent = $52d4eb0e19aef542$export$3bec963ccca7a0ba(quantity);
    // Calculate total cost with bulk discount applied
    const costPerUnit = baseCost * costPercent / 100;
    return Math.ceil(costPerUnit * quantity);
}
function $52d4eb0e19aef542$export$cf54799c3e0d127e(artifactKey) {
    const artifact = (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Unknown artifact recipe!', 'error');
        return false;
    }
    if (!$52d4eb0e19aef542$export$ac539fb4b9c6f75e(artifactKey)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot craft this artifact - missing materials or wrong faction!', 'error');
        return false;
    }
    // One craft per design per character (artifacts are equip-once; a duplicate
    // earns no marks and has no use). Toggle via allowDuplicateCrafts.
    if (!(0, $bde36de43872f734$export$c95b8ce76efadccf)() && (0, $bde36de43872f734$export$770281d4afda41b1)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, artifactKey)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${artifact.name} is already crafted - one per character.`, 'error');
        return false;
    }
    // Get recipe with scaling applied
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(artifactKey);
    if (!recipe) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Artifact recipe not found!', 'error');
        return false;
    }
    // Consume materials from recipe (blueprints are NO LONGER recipe inputs -
    // they're consumed once by unlockArtifact to unlock the design; crafting
    // an unlocked design costs materials only)
    for (const input of recipe.inputs){
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] -= input.qty;
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] <= 0) delete (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id];
    }
    // Create artifact instance with unique ID
    const craftedArtifact = {
        key: Date.now() + Math.random(),
        id: artifact.id,
        name: artifact.name,
        type: artifact.type,
        slot: artifact.slot,
        skill: artifact.skill,
        effects: artifact.effects,
        description: artifact.description,
        short: artifact.short,
        faction: artifact.faction,
        rarity: artifact.rarity,
        icon: artifact.icon,
        crafted: true
    };
    // Add to artifacts collection
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts = [];
    const firstOfType = !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.some((a)=>a.id === craftedArtifact.id);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.push(craftedArtifact);
    // Lifetime counter for the Command Marks formula: DISTINCT designs only.
    // Command rewards novel engineering, not mass production - duplicate
    // crafts (deep tours farming blueprints at T3) earn no extra marks.
    (0, $f27982cef7035d22$export$6b22d50e3ddf4789)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
    if (firstOfType) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.lifetime.artifactsCrafted += 1;
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Crafted ${artifact.name}!`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    return true;
}
function $52d4eb0e19aef542$export$506c247f43a19ac3(artifactKey) {
    const artifact = (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Unknown artifact design!', 'error');
        return false;
    }
    const result = (0, $bde36de43872f734$export$5361c32fc9d089b2)(artifactKey);
    if (!result.success) {
        const msg = result.reason === 'already-unlocked' ? 'Design already unlocked.' : 'You need this design\'s blueprint to unlock it.';
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(msg, 'error');
        return false;
    }
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F513} ${artifact.name} design unlocked! +${result.marks} \u{1F396}\u{FE0F} at promotion`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    return true;
}
function $52d4eb0e19aef542$export$36d50cdf3bb88c77(itemId) {
    const depths = new Map(); // itemId -> deepest depth seen (target = 0)
    const walk = (id, depth, pathSeen)=>{
        const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(id);
        if (!recipe) return; // raw material - not part of the craftable tree
        if ((depths.get(id) ?? -1) < depth) depths.set(id, depth);
        if (pathSeen.has(id)) return; // cycle guard
        const nextSeen = new Set(pathSeen).add(id);
        (recipe.inputs || []).forEach((input)=>walk(input.id, depth + 1, nextSeen));
    };
    walk(itemId, 0, new Set());
    return [
        ...depths.entries()
    ].sort((a, b)=>b[1] - a[1]).map(([id])=>id);
}
function $52d4eb0e19aef542$export$911925165af984c6() {
    const recipes = [];
    // Add component recipes (uncommon, rare, epic) with scaling applied
    const craftingRecipes = [
        ...$ce6dd72bc4611534$export$c4df318d1f4ad4,
        ...$ce6dd72bc4611534$export$c95766f8298d6ed1,
        ...$ce6dd72bc4611534$export$12c2125da4fa007
    ];
    // Batch lookup all target items at once instead of individual lookups
    const targetIds = craftingRecipes.map((r)=>r.target);
    const itemsMap = (0, $42b272c2c0f44bdf$export$4251a114f7437961)(targetIds);
    craftingRecipes.forEach((recipe)=>{
        const item = itemsMap[recipe.target];
        if (item) {
            // Get scaled recipe to apply progression scaling
            const scaledRecipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(recipe.target);
            recipes.push({
                ...scaledRecipe || recipe,
                itemRarity: item.rarity,
                itemType: item.type,
                techniqueId: item.techniqueId
            });
        }
    });
    // Add artifact recipes with scaling applied
    $ce6dd72bc4611534$export$ded4d2beb9be271a.forEach((recipe)=>{
        const artifact = (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', recipe.target);
        if (artifact) {
            // Get scaled recipe to apply progression scaling
            const scaledRecipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(recipe.target);
            recipes.push({
                ...scaledRecipe || recipe,
                itemRarity: artifact.rarity,
                itemType: artifact.type
            });
        }
    });
    return recipes;
}
function $52d4eb0e19aef542$export$c8bcd6f2224f6fb9() {
    const recipes = [];
    const playerFaction = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction;
    for (const [key, artifact] of Object.entries((0, $42b272c2c0f44bdf$export$18c4115a8e7963b)()))// Only show recipes for player's faction or neutral artifacts
    if (artifact.faction === 'neutral' || artifact.faction === playerFaction) recipes.push({
        key: key,
        ...artifact,
        canCraft: $52d4eb0e19aef542$export$ac539fb4b9c6f75e(key)
    });
    return recipes;
}
function $52d4eb0e19aef542$export$aa7c3ee86bbf0990(techniqueId = null) {
    const modal = document.getElementById('crafting-modal');
    if (!modal) {
        $52d4eb0e19aef542$export$2cb4af04d696a1ed();
        return $52d4eb0e19aef542$export$aa7c3ee86bbf0990(techniqueId);
    }
    // If a techniqueId is provided, filter to techGear type for that technique
    const filterType = document.getElementById('filter-type');
    if (filterType) filterType.value = techniqueId ? 'techGear' : '';
    if (techniqueId) // Store the techniqueId so refreshCraftingList can use it for additional filtering
    modal.dataset.filteredTechniqueId = techniqueId;
    else // Clear any previous technique filter
    delete modal.dataset.filteredTechniqueId;
    $52d4eb0e19aef542$var$refreshCraftingList();
    modal.classList.remove('hidden');
}
function $52d4eb0e19aef542$export$bdea6cc9473d0c95() {
    $52d4eb0e19aef542$export$aa7c3ee86bbf0990();
}
function $52d4eb0e19aef542$export$301cbaf87c15a68f(itemId) {
    let modal = document.getElementById('crafting-modal');
    if (!modal) {
        $52d4eb0e19aef542$export$2cb4af04d696a1ed();
        modal = document.getElementById('crafting-modal');
    }
    modal.dataset.treeFilterItemId = itemId;
    delete modal.dataset.filteredTechniqueId;
    // Tree mode shows the whole chain: neutralize the manual filters
    const filterType = document.getElementById('filter-type');
    const filterRarity = document.getElementById('filter-rarity');
    const filterCraftable = document.getElementById('filter-craftable');
    if (filterType) filterType.value = '';
    if (filterRarity) filterRarity.value = '';
    if (filterCraftable) filterCraftable.checked = false;
    $52d4eb0e19aef542$var$refreshCraftingList();
    modal.classList.remove('hidden');
}
function $52d4eb0e19aef542$export$e186070c9358ae3a() {
    const modal = document.getElementById('crafting-modal');
    if (!modal) return;
    delete modal.dataset.treeFilterItemId;
    $52d4eb0e19aef542$var$refreshCraftingList();
}
function $52d4eb0e19aef542$export$2cb4af04d696a1ed() {
    // Build type filter options from config
    const craftableTypes = [
        'material',
        'consumable',
        'techGear',
        'artifact'
    ];
    const typeOptions = craftableTypes.map((type)=>{
        const typeName = $ce6dd72bc4611534$export$d02ea220375e4aff[type]?.name || type;
        return `<option value="${type}">${typeName}</option>`;
    }).join('');
    // Build rarity filter options from config
    const craftableRarities = [
        'uncommon',
        'rare',
        'epic',
        'unique'
    ];
    const rarityOptions = craftableRarities.map((rarity)=>{
        const rarityName = $ce6dd72bc4611534$export$d4a72d069095e9e5[rarity]?.name || rarity;
        return `<option value="${rarity}">${rarityName}</option>`;
    }).join('');
    const modal = document.createElement('div');
    modal.id = 'crafting-modal';
    modal.className = 'modal hidden';
    modal.innerHTML = `
        <div class="modal-content crafting-modal-content max-w-6xl w-full max-h-screen">
            <div class="modal-header">
                <h3 class="modal-title">Crafting</h3>
                <button id="close-crafting-modal" class="close-btn">&times;</button>
            </div>
            <div class="modal-body overflow-hidden">
                <div class="flex gap-2 p-4 border-b border-gray-600">
                    <select id="filter-type" class="px-2 py-1 bg-gray-700 border border-gray-600 rounded text-sm">
                        <option value="">All Types</option>
                        ${typeOptions}
                    </select>
                    <select id="filter-rarity" class="px-2 py-1 bg-gray-700 border border-gray-600 rounded text-sm">
                        <option value="">All Rarities</option>
                        ${rarityOptions}
                    </select>
                    <label class="flex items-center gap-1 text-sm">
                        <input type="checkbox" id="filter-craftable" class="form-checkbox">
                        <span>Craftable Only</span>
                    </label>
                    <span id="crafting-tree-chip" class="hidden items-center gap-2 px-3 py-1 rounded-full border border-game-accent text-game-accent text-xs font-bold">
                        <!-- populated by refreshCraftingList when the tree filter is active -->
                    </span>
                </div>
                <div id="crafting-recipe-list" class="grid gap-4 p-4" style="grid-template-columns: repeat(auto-fit, 13rem); justify-content: center; height: calc(70vh - 200px); overflow-y: auto; scrollbar-width: thin; scrollbar-color: #4a5568 #2d3748;">
                    <!-- Recipes will be populated here -->
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    // Add event listener for close button
    const closeBtn = document.getElementById('close-crafting-modal');
    closeBtn.addEventListener('click', ()=>{
        modal.classList.add('hidden');
    });
    // Add filter listeners
    const filterType = document.getElementById('filter-type');
    const filterRarity = document.getElementById('filter-rarity');
    const filterCraftable = document.getElementById('filter-craftable');
    filterType.addEventListener('change', ()=>{
        // Clear technique + tree filters when user manually changes the type filter
        delete modal.dataset.filteredTechniqueId;
        delete modal.dataset.treeFilterItemId;
        $52d4eb0e19aef542$var$refreshCraftingList();
    });
    filterRarity.addEventListener('change', ()=>{
        // Manual rarity browsing exits tree mode too (a rarity slice of a
        // dependency chain reads as missing items, not as a filter)
        delete modal.dataset.treeFilterItemId;
        $52d4eb0e19aef542$var$refreshCraftingList();
    });
    // Craftable-only applies WITHIN tree mode (show me what I can craft next)
    filterCraftable.addEventListener('change', ()=>$52d4eb0e19aef542$var$refreshCraftingList());
    // Close modal when clicking outside (only if mousedown started on background)
    let mousedownTarget = null;
    modal.addEventListener('mousedown', (e)=>{
        mousedownTarget = e.target;
    });
    modal.addEventListener('click', (e)=>{
        if (e.target === modal && mousedownTarget === modal) modal.classList.add('hidden');
    });
}
function $52d4eb0e19aef542$export$10d9b633aa01c262(scaledRecipe, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    return (0, $91ce0e04738077df$export$10d9b633aa01c262)(scaledRecipe, character);
}
function $52d4eb0e19aef542$var$createRecipeCard(recipe, preComputedMaterials) {
    // Recipe is already scaled from getAllRecipes()
    // For artifacts, get full item data
    const item = recipe.itemType === 'artifact' ? (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', recipe.target) : (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', recipe.target);
    return item ? (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)(item, 'crafting', recipe, preComputedMaterials, {
        inModal: true
    }) : '';
}
function $52d4eb0e19aef542$var$refreshCraftingList() {
    const modal = document.getElementById('crafting-modal');
    const recipeList = document.getElementById('crafting-recipe-list');
    const filterType = document.getElementById('filter-type').value;
    const filterRarity = document.getElementById('filter-rarity').value;
    const filterCraftable = document.getElementById('filter-craftable').checked;
    const filteredTechniqueId = modal?.dataset.filteredTechniqueId;
    const treeFilterItemId = modal?.dataset.treeFilterItemId;
    let recipes = $52d4eb0e19aef542$export$911925165af984c6();
    if (treeFilterItemId) {
        // Component-tree mode: only the target + its craftable components,
        // ordered deepest-first (craft order). Replaces type/rarity/technique
        // filtering; Craftable Only still applies within the tree.
        const treeOrder = $52d4eb0e19aef542$export$36d50cdf3bb88c77(treeFilterItemId);
        const orderIndex = new Map(treeOrder.map((id, i)=>[
                id,
                i
            ]));
        recipes = recipes.filter((r)=>orderIndex.has(r.target));
        recipes.sort((a, b)=>orderIndex.get(a.target) - orderIndex.get(b.target));
    } else {
        // Apply filters
        if (filterType) recipes = recipes.filter((r)=>r.itemType === filterType);
        if (filterRarity) recipes = recipes.filter((r)=>r.itemRarity === filterRarity);
        // If a technique filter is active, filter by technique ID
        if (filteredTechniqueId) recipes = recipes.filter((r)=>r.techniqueId === filteredTechniqueId);
    }
    if (filterCraftable) recipes = recipes.filter((r)=>$52d4eb0e19aef542$export$10d9b633aa01c262(r));
    // Tree filter chip: shows the target + item count, ✕ returns to browsing
    const treeChip = document.getElementById('crafting-tree-chip');
    if (treeChip) {
        if (treeFilterItemId) {
            const targetItem = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', treeFilterItemId) || (0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', treeFilterItemId);
            treeChip.innerHTML = `\u{1F333} Components: <b>${targetItem?.name || treeFilterItemId}</b>
                <span class="text-gray-400 font-normal">(${recipes.length} craftable, deepest first)</span>
                <button onclick="clearCraftingTreeFilter()" class="text-gray-400 hover:text-white font-bold ml-1" title="Back to all recipes">\u{2715}</button>`;
            treeChip.classList.remove('hidden');
            treeChip.classList.add('inline-flex');
        } else {
            treeChip.classList.add('hidden');
            treeChip.classList.remove('inline-flex');
        }
    }
    // Pre-compute all materials for all recipes in one batch lookup
    const allMaterialIds = [];
    recipes.forEach((recipe)=>{
        if (recipe.inputs) recipe.inputs.forEach((input)=>{
            if (!allMaterialIds.includes(input.id)) allMaterialIds.push(input.id);
        });
    });
    const preComputedMaterials = allMaterialIds.length > 0 ? (0, $42b272c2c0f44bdf$export$4251a114f7437961)(allMaterialIds) : {};
    // Reset scroll state with new filtered recipes
    $52d4eb0e19aef542$var$craftingScrollState.reset();
    $52d4eb0e19aef542$var$craftingScrollState.allFilteredRecipes = recipes;
    $52d4eb0e19aef542$var$craftingScrollState.preComputedMaterials = preComputedMaterials;
    // Load initial batch
    $52d4eb0e19aef542$var$craftingScrollState.loadMore();
    if (recipeList) {
        $52d4eb0e19aef542$var$renderCraftingRecipes(recipeList);
        // Set up infinite scroll observer
        $52d4eb0e19aef542$var$setupCraftingScrollObserver(recipeList);
    }
}
/**
 * Render the visible recipes to the DOM
 * @param {HTMLElement} recipeList - The recipe list container
 */ function $52d4eb0e19aef542$var$renderCraftingRecipes(recipeList) {
    recipeList.innerHTML = '';
    $52d4eb0e19aef542$var$craftingScrollState.visibleRecipes.forEach((recipe)=>{
        const cardHtml = $52d4eb0e19aef542$var$createRecipeCard(recipe, $52d4eb0e19aef542$var$craftingScrollState.preComputedMaterials);
        recipeList.innerHTML += cardHtml;
    });
    // Add loading indicator if there are more recipes to load
    if ($52d4eb0e19aef542$var$craftingScrollState.visibleRecipes.length < $52d4eb0e19aef542$var$craftingScrollState.allFilteredRecipes.length) {
        const loadingEl = document.createElement('div');
        loadingEl.id = 'crafting-scroll-trigger';
        loadingEl.style.height = '1px';
        recipeList.appendChild(loadingEl);
    }
    // Re-attach Tippy tooltips to the freshly-rendered card artwork (innerHTML
    // replacement above drops any previous instances)
    window.reinitializeInventoryTooltips?.();
}
/**
 * Set up Intersection Observer for infinite scroll
 * @param {HTMLElement} recipeList - The recipe list container
 */ function $52d4eb0e19aef542$var$setupCraftingScrollObserver(recipeList) {
    // Remove old observer if it exists
    if ($52d4eb0e19aef542$var$craftingScrollState.observer) $52d4eb0e19aef542$var$craftingScrollState.observer.disconnect();
    let pendingLoad = false;
    // Create observer to trigger load more when user scrolls near bottom
    $52d4eb0e19aef542$var$craftingScrollState.observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && !pendingLoad) {
                pendingLoad = true;
                const didLoad = $52d4eb0e19aef542$var$craftingScrollState.loadMore();
                if (didLoad) {
                    $52d4eb0e19aef542$var$renderCraftingRecipes(recipeList);
                    // Wait before re-observing to allow the DOM to settle
                    setTimeout(()=>{
                        const newTrigger = document.getElementById('crafting-scroll-trigger');
                        if (newTrigger && $52d4eb0e19aef542$var$craftingScrollState.observer) {
                            // Unobserve old trigger first
                            if (entry.target) $52d4eb0e19aef542$var$craftingScrollState.observer.unobserve(entry.target);
                            $52d4eb0e19aef542$var$craftingScrollState.observer.observe(newTrigger);
                        }
                        pendingLoad = false;
                    }, 100);
                } else pendingLoad = false;
            }
        });
    }, {
        root: recipeList,
        rootMargin: '100px',
        threshold: 0
    });
    // Observe the initial trigger element
    const trigger = document.getElementById('crafting-scroll-trigger');
    if (trigger) $52d4eb0e19aef542$var$craftingScrollState.observer.observe(trigger);
}






/**
 * Sub-tabs — one pane visible at a time, scrolling inside the viewport.
 *
 * Extracted from character.js, which had the only working copy of this. The
 * Command and Syndicate pages needed the same behaviour and gear.js already had
 * a second variant, so a third and fourth would have been four implementations
 * of one idea — and the subtle part (the sizing retry below) is exactly what
 * gets dropped when a pattern is re-typed rather than reused.
 *
 * Two jobs, and the second is the one that matters for tablets:
 *
 *   1. Show one pane, hide the rest, mark the active button.
 *   2. Cap the active pane's scroller at the viewport bottom, so a long list
 *      scrolls INSIDE the pane instead of growing the page. That is what keeps
 *      a page fitting a 768px-tall viewport regardless of how much content it
 *      grows later.
 */ 
/** groupId -> { panes, scrollers, active, onShow } */ const $f2aa38d2d36459d1$var$groups = new Map();
function $f2aa38d2d36459d1$export$589dc1e4c906c789(groupId, { panes: panes, scrollers: scrollers = {}, defaultTab: defaultTab = null, onShow: onShow = null }) {
    $f2aa38d2d36459d1$var$groups.set(groupId, {
        panes: panes,
        scrollers: scrollers,
        onShow: onShow,
        active: defaultTab || Object.keys(panes)[0]
    });
}
function $f2aa38d2d36459d1$export$50d0994bd60f586c(groupId) {
    return $f2aa38d2d36459d1$var$groups.get(groupId)?.active || null;
}
function $f2aa38d2d36459d1$export$7ad721b2ffe28f0c(groupId) {
    const group = $f2aa38d2d36459d1$var$groups.get(groupId);
    if (!group) return;
    for (const [name, elementId] of Object.entries(group.panes))document.getElementById(elementId)?.classList.toggle('hidden', name !== group.active);
    document.querySelectorAll(`[data-subtab-group="${groupId}"]`).forEach((btn)=>{
        btn.classList.toggle('active', btn.dataset.subtab === group.active);
    });
    group.onShow?.(group.active);
    $f2aa38d2d36459d1$var$sizeActiveScroller(groupId);
}
function $f2aa38d2d36459d1$export$8a8da8bddae1b567(groupId, name) {
    const group = $f2aa38d2d36459d1$var$groups.get(groupId);
    if (!group || !(name in group.panes)) return;
    group.active = name;
    $f2aa38d2d36459d1$export$7ad721b2ffe28f0c(groupId);
}
/**
 * Cap the active scroller at the viewport bottom.
 *
 * Measured from the element's own document offset rather than a fixed header
 * height, so it is immune to whatever sits above it (a stats strip, a founding
 * banner) changing height.
 *
 * The retry is load-bearing: during a boot reveal or a tab fade-in the element
 * is not laid out yet and measures 0, and writing that would clamp the pane to
 * the 200px floor permanently. Bounded so a genuinely hidden pane cannot spin.
 */ const $f2aa38d2d36459d1$var$sizeRaf = new Map();
function $f2aa38d2d36459d1$var$sizeActiveScroller(groupId, attempt = 0) {
    const group = $f2aa38d2d36459d1$var$groups.get(groupId);
    if (!group) return;
    const pending = $f2aa38d2d36459d1$var$sizeRaf.get(groupId);
    if (pending) {
        cancelAnimationFrame(pending);
        $f2aa38d2d36459d1$var$sizeRaf.delete(groupId);
    }
    const elementId = group.scrollers[group.active] || group.panes[group.active];
    const el = document.getElementById(elementId);
    if (!el) return;
    const absTop = el.offsetParent === null ? 0 : el.getBoundingClientRect().top + window.scrollY;
    if (absTop <= 0) {
        if (attempt < 30) $f2aa38d2d36459d1$var$sizeRaf.set(groupId, requestAnimationFrame(()=>$f2aa38d2d36459d1$var$sizeActiveScroller(groupId, attempt + 1)));
        return;
    }
    el.style.maxHeight = `${Math.max(200, window.innerHeight - absTop - $f2aa38d2d36459d1$var$BOTTOM_GAP - $f2aa38d2d36459d1$var$chromeBelow(el))}px`;
    el.style.overflowY = 'auto';
}
/** Breathing room under the scroller, so it never sits flush to the fold. */ const $f2aa38d2d36459d1$var$BOTTOM_GAP = 12;
/**
 * Padding, border and margin BELOW the scroller, all the way out to <body>.
 *
 * Clamping the scroller to the viewport is not enough on its own: the panes wrap
 * it in padding and a 4px border, and the page container adds its own bottom
 * padding — the page still overflowed by exactly that chrome. Walking to body
 * rather than stopping at `.tab-content` is what closes the last few pixels.
 *
 * Read from computed STYLE, not measured geometry: this runs while the scroller
 * is mid-clamp, and a geometric read would feed its own result back in.
 */ function $f2aa38d2d36459d1$var$chromeBelow(el) {
    let total = 0;
    for(let node = el.parentElement; node && node !== document.body; node = node.parentElement){
        const cs = getComputedStyle(node);
        total += parseFloat(cs.paddingBottom) || 0;
        total += parseFloat(cs.borderBottomWidth) || 0;
        total += parseFloat(cs.marginBottom) || 0;
    }
    return total;
}
function $f2aa38d2d36459d1$export$514a72c52a691f03() {
    for (const groupId of $f2aa38d2d36459d1$var$groups.keys())$f2aa38d2d36459d1$var$sizeActiveScroller(groupId);
}
if (typeof window !== 'undefined') {
    window.setSubTab = $f2aa38d2d36459d1$export$8a8da8bddae1b567;
    window.addEventListener('resize', (0, $42b272c2c0f44bdf$export$61fc7d43ac8f84b0)($f2aa38d2d36459d1$export$514a72c52a691f03, 100));
}


/**
 * Skill tabs — show one faction skill's content at a time.
 *
 * Three surfaces present the same 5-skill set: the character page's Skills pane,
 * the Gear tab's Field Kit, and its Technique Consumables. All three used to
 * render every skill at once, which is what made those pages scroll several
 * screens deep on a tablet. This is the one strip implementation they share,
 * for the same reason subTabs.js exists — see that file's header.
 *
 * The distinction from subTabs.js is deliberate: that module toggles STATIC
 * panes by element id and clamps their scroll height. These panes are rebuilt
 * from data on every render, so there is nothing stable to toggle — the caller
 * re-renders and asks which skill to draw.
 *
 * Selection is module-scoped per group, so re-rendering (crafting a piece,
 * spending a point) keeps the player on the skill they were reading. Groups are
 * independent: the skill you are reading about is not necessarily the one whose
 * gear you are crafting.
 */ 

/** groupId -> selected skill key */ const $570f21042242dd0a$var$selected = new Map();
/** groupId -> re-render callback, invoked on switch */ const $570f21042242dd0a$var$renderers = new Map();
const $570f21042242dd0a$var$skillKeysFor = (faction)=>Object.keys($ce6dd72bc4611534$export$aeeef991191508e2[faction]?.skills || {});
function $570f21042242dd0a$export$61a3455e09e10145(groupId, rerender) {
    $570f21042242dd0a$var$renderers.set(groupId, rerender);
}
function $570f21042242dd0a$export$5b90168a051cbfed(groupId, faction) {
    const keys = $570f21042242dd0a$var$skillKeysFor(faction);
    const current = $570f21042242dd0a$var$selected.get(groupId);
    return keys.includes(current) ? current : keys[0] || null;
}
function $570f21042242dd0a$export$f1cb70404787dca4(groupId, skillKey) {
    $570f21042242dd0a$var$selected.set(groupId, skillKey);
    $570f21042242dd0a$var$renderers.get(groupId)?.();
}
/**
 * Inactive tabs keep only the first word: "System Override" -> "System…".
 *
 * Five full skill names do not fit one row on a tablet, and the first word is
 * what distinguishes them anyway (Signal / System / Drone / Safeguard /
 * Quantum). The full name stays in the title attribute.
 */ function $570f21042242dd0a$var$tabLabel(name, isActive) {
    if (isActive) return name;
    const [first, ...rest] = name.split(' ');
    return rest.length ? `${first}\u{2026}` : first;
}
function $570f21042242dd0a$export$313de1df173ff894(groupId, faction) {
    const skills = $ce6dd72bc4611534$export$aeeef991191508e2[faction]?.skills || {};
    const active = $570f21042242dd0a$export$5b90168a051cbfed(groupId, faction);
    const tabs = Object.entries(skills).map(([skillKey, skill])=>{
        const isActive = skillKey === active;
        return `
            <button type="button"
                    class="skill-tab-btn tracking-tighter border-2 ${isActive ? 'active' : ''}"
                    data-skill-tab-group="${groupId}"
                    data-skill-tab="${skillKey}"
                    onclick="setSkillTab('${groupId}', '${skillKey}')"
                    title="${skill.name}">
                <span>${skill.icon || "\u26A1"}</span>
                <span class="skill-tab-name">${skill.name}</span>
            </button>`;
    }).join('');
    return `<div class="skill-tabs gap-1 mb-1">${tabs}</div>`;
}
if (typeof window !== 'undefined') window.setSkillTab = $570f21042242dd0a$export$f1cb70404787dca4;


/**
 * Gear - UI for the Gear tab, the phase-1 goal tracker.
 *
 * Layout (per the approved mockup): goal strip (set progress, artifacts,
 * Command value), suggested-focus card with craft-vs-farm sourcing hints,
 * the 5-skill x 3-technique gear matrix (craftable/focus items render the
 * standard inventory card; owned and distant items collapse to strips),
 * and the faction's artifacts as cards. Logic lives in gear-core.js.
 */ 



/**
 * Gear Core - pure logic for the Gear tab (phase-1 goal tracker).
 *
 * Computes the 5-skill x 3-technique tech gear matrix, per-item crafting
 * status, the suggested focus (the simulator's focused-crafting strategy,
 * simplified), artifact statuses, and material sourcing hints. No DOM.
 */ 



const $9f36f7f2f6b0dce2$var$capitalize = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
function $9f36f7f2f6b0dce2$export$75dc440158626230(faction) {
    const skills = $ce6dd72bc4611534$exports.factionSkills[faction]?.skills || {};
    const techniques = $ce6dd72bc4611534$exports.skillTechniques[faction] || [];
    const gearItems = $ce6dd72bc4611534$exports[`itemsEpicDevice${$9f36f7f2f6b0dce2$var$capitalize(faction)}`] || [];
    return Object.entries(skills).map(([skillId, skill])=>({
            skillId: skillId,
            skill: skill,
            techniques: techniques.filter((t)=>t.skill === skillId).map((technique)=>({
                    technique: technique,
                    item: gearItems.find((i)=>i.techniqueId === technique.id) || null
                })).filter((entry)=>entry.item)
        }));
}
function $9f36f7f2f6b0dce2$export$93fb318ab1b10a05(itemId, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const inventory = character?.inventory || {};
    const equipped = Object.values(character?.equippedTechniqueGear || {});
    const owned = (inventory[itemId] || 0) > 0 || equipped.some((g)=>g === itemId || g?.id === itemId);
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(itemId);
    if (!recipe) return {
        itemId: itemId,
        owned: owned,
        craftable: false,
        progress: owned ? 1 : 0,
        missing: [],
        missingUnits: 0,
        recipe: null
    };
    let haveSum = 0, needSum = 0, missingUnits = 0;
    const missing = [];
    for (const input of recipe.inputs){
        const have = inventory[input.id] || 0;
        haveSum += Math.min(have, input.qty);
        needSum += input.qty;
        if (have < input.qty) {
            missing.push({
                id: input.id,
                have: have,
                need: input.qty,
                short: input.qty - have
            });
            missingUnits += input.qty - have;
        }
    }
    return {
        itemId: itemId,
        owned: owned,
        craftable: !owned && missing.length === 0,
        progress: needSum > 0 ? haveSum / needSum : 0,
        missing: missing,
        missingUnits: missingUnits,
        recipe: recipe
    };
}
function $9f36f7f2f6b0dce2$export$59244fb66f77c7e5(faction, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    let best = null;
    for (const column of $9f36f7f2f6b0dce2$export$75dc440158626230(faction))for (const { item: item } of column.techniques){
        const status = $9f36f7f2f6b0dce2$export$93fb318ab1b10a05(item.id, character);
        if (status.owned) continue;
        if (!best || status.missingUnits < best.status.missingUnits || status.missingUnits === best.status.missingUnits && status.progress > best.status.progress) best = {
            item: item,
            status: status
        };
    }
    return best;
}
function $9f36f7f2f6b0dce2$export$c1c785e1872a9a4c(character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    let best = null;
    for (const entry of $9f36f7f2f6b0dce2$export$f8a8a403466b6e1(character)){
        if (entry.copiesOwned > 0 || entry.status.owned) continue;
        if (!best) {
            best = entry;
            continue;
        }
        // Blueprint-in-hand always outranks blueprint-missing.
        if (entry.hasBlueprint !== best.hasBlueprint) {
            if (entry.hasBlueprint) best = entry;
            continue;
        }
        if (entry.status.missingUnits < best.status.missingUnits || entry.status.missingUnits === best.status.missingUnits && entry.status.progress > best.status.progress) best = entry;
    }
    return best;
}
function $9f36f7f2f6b0dce2$export$f8a8a403466b6e1(character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const faction = character?.faction;
    const inventory = character?.inventory || {};
    const results = [];
    for (const artifact of Object.values((0, $42b272c2c0f44bdf$export$18c4115a8e7963b)())){
        if (artifact.faction !== 'neutral' && artifact.faction !== faction) continue;
        const status = $9f36f7f2f6b0dce2$export$93fb318ab1b10a05(artifact.id, character);
        // Blueprints bank under their slug item id (the old name-keyed
        // lookup never matched dropped blueprints)
        results.push({
            artifact: artifact,
            status: status,
            hasBlueprint: (inventory[`${artifact.id}-blueprint`] || 0) > 0,
            copiesOwned: (character?.artifacts || []).filter((a)=>a.id === artifact.id).length
        });
    }
    return results;
}
/**
 * Sourcing hint for a material: can it be crafted, and where does it drop?
 * Drop sourcing follows the engine's faction-scoped material pools
 * (common/rare materials drop in rooms of their faction); regions are
 * ranked by how many gate/hazard rooms belong to that faction. Uncommon
 * intermediates are craft-only under the current economy.
 */ const $9f36f7f2f6b0dce2$var$sourceCache = new Map();
function $9f36f7f2f6b0dce2$export$4ba1f2107d023679(itemId) {
    if ($9f36f7f2f6b0dce2$var$sourceCache.has(itemId)) return $9f36f7f2f6b0dce2$var$sourceCache.get(itemId);
    const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', itemId);
    const craftable = !!(0, $91ce0e04738077df$export$3645b25e1a815566)(itemId);
    const result = {
        craftable: craftable,
        regions: [],
        skills: []
    };
    if (item && item.type === 'material' && item.faction && (item.rarity === 'common' || item.rarity === 'rare')) {
        const skillSet = new Set();
        const regions = Object.entries($ce6dd72bc4611534$exports.raidRegions).map(([key, region])=>{
            let rooms = 0;
            for (const room of [
                ...region.gates || [],
                ...region.hazards || []
            ]){
                if ((0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(room.primary) === item.faction) {
                    rooms++;
                    skillSet.add(room.primary);
                } else if (item.faction == "neutral") rooms++;
            }
            return {
                key: key,
                name: region.name,
                rooms: rooms
            };
        }).filter((r)=>r.rooms > 0).sort((a, b)=>b.rooms - a.rooms);
        result.regions = regions;
        result.skills = [
            ...skillSet
        ];
    }
    $9f36f7f2f6b0dce2$var$sourceCache.set(itemId, result);
    return result;
}
function $9f36f7f2f6b0dce2$export$8ca1be1802f8b29a(missingInput, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const parts = [];
    const sources = $9f36f7f2f6b0dce2$export$4ba1f2107d023679(missingInput.id);
    if (sources.craftable) {
        const subStatus = $9f36f7f2f6b0dce2$export$93fb318ab1b10a05(missingInput.id, character);
        /*parts.push(subStatus.missing.length === 0
            ? `craft from materials you have (${missingInput.short} needed)`
            : `craftable — missing ${subStatus.missing.map(m => findItem('id', m.id)?.name || m.id).join(', ')}`);*/ parts.push("craftable");
    }
    if (sources.regions.length > 0) {
        const skillNames = sources.skills.map((s)=>{
            const faction = (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(s);
            return $ce6dd72bc4611534$exports.factionSkills[faction]?.skills[s]?.name;
        }).filter(Boolean).slice(0, 2).join(' / ');
        parts.push(skillNames == "" ? "" : `best found in ${sources.regions[0].name}`);
    }
    return parts.join(' or ');
}
const $9f36f7f2f6b0dce2$export$4d9cf51127854ad = {
    'knockout-prevention': 100,
    'hazard-damage-reduction': 90,
    'blueprint-find-bonus': 80,
    'loot-quantity-bonus': 70,
    'gate-material-bonus': 65,
    'raid-energy-reduction': 50,
    'currency-bonus': 40,
    'contractor-payout-bonus': 35,
    'faction-synergy-bonus': 30,
    'support-skill-bonus': 25,
    'relic-quality-bonus': 20
};
function $9f36f7f2f6b0dce2$export$33d357ef4aaee78e(artifact) {
    let best = -1;
    for (const [effectId, magnitude] of Object.entries(artifact?.effects || {})){
        const p = $9f36f7f2f6b0dce2$export$4d9cf51127854ad[effectId];
        if (p == null) continue;
        const score = p * 1000 + (Number(magnitude) || 0);
        if (score > best) best = score;
    }
    return best;
}
/** Artifacts the character owns (crafted into inventory). */ function $9f36f7f2f6b0dce2$var$ownedArtifacts(char) {
    return Object.entries(char.inventory || {}).filter(([, qty])=>qty > 0).map(([id])=>(0, $42b272c2c0f44bdf$export$891bd687a67340b8)('id', id)).filter(Boolean);
}
function $9f36f7f2f6b0dce2$export$5f6199e96a03905b(char) {
    const owned = $9f36f7f2f6b0dce2$var$ownedArtifacts(char);
    if (owned.length === 0) return;
    if (!char.equippedArtifacts) char.equippedArtifacts = {
        skillSlot: null,
        utilitySlot: null
    };
    // Skill slot: back the character's strongest skill.
    const skillCandidates = owned.filter((a)=>a.slot === 'skillSlot');
    if (skillCandidates.length) char.equippedArtifacts.skillSlot = skillCandidates.reduce((best, a)=>(char.skills?.[a.skill] || 0) > (char.skills?.[best.skill] || 0) ? a : best);
    // Utility slot: highest-priority effect available.
    const utilityCandidates = owned.filter((a)=>a.slot === 'utilitySlot');
    if (utilityCandidates.length) char.equippedArtifacts.utilitySlot = utilityCandidates.reduce((best, a)=>$9f36f7f2f6b0dce2$export$33d357ef4aaee78e(a) > $9f36f7f2f6b0dce2$export$33d357ef4aaee78e(best) ? a : best);
}




// Field Kit and Technique Consumables each show one skill's three items rather
// than the full 5x3 matrix. Separate groups on purpose: the gear you are
// crafting is rarely the technique consumable you want next.
const $1209d59c35d34a71$var$KIT_TABS = 'gear-field-kit';
const $1209d59c35d34a71$var$CONSUMABLE_TABS = 'gear-consumables';
(0, $570f21042242dd0a$export$61a3455e09e10145)($1209d59c35d34a71$var$KIT_TABS, ()=>$1209d59c35d34a71$export$acf54b11566c856d());
(0, $570f21042242dd0a$export$61a3455e09e10145)($1209d59c35d34a71$var$CONSUMABLE_TABS, ()=>$1209d59c35d34a71$export$acf54b11566c856d());
// Three 13rem cards plus two 0.75rem gaps. Capping the grid's width rather than
// hard-coding `repeat(3, ...)` keeps it 3-up where there is room and lets it
// fall to 2 or 1 on a narrow pane instead of scrolling sideways.
const $1209d59c35d34a71$var$THREE_UP = 'grid gap-3 justify-start max-w-[40.5rem] mt-2';
const $1209d59c35d34a71$var$THREE_UP_TRACKS = 'grid-template-columns: repeat(auto-fit, 13rem);';
// Per-item expand/collapse overrides (persist across this page's re-renders;
// the card's own toggle is retargeted here so state survives crafting)
const $1209d59c35d34a71$var$gearCardOverrides = new Map(); // itemId -> expanded boolean
const $1209d59c35d34a71$var$renderedExpanded = new Map(); // itemId -> state actually rendered last
let $1209d59c35d34a71$var$focusCollapsed = false; // Suggested-focus panel hidden by the player
function $1209d59c35d34a71$var$ownedGearCount(faction) {
    let owned = 0, total = 0;
    for (const column of (0, $9f36f7f2f6b0dce2$export$75dc440158626230)(faction))for (const { item: item } of column.techniques){
        total++;
        if ((0, $9f36f7f2f6b0dce2$export$93fb318ab1b10a05)(item.id).owned) owned++;
    }
    return {
        owned: owned,
        total: total
    };
}
// ---------------------------------------------------------------------------
// Building blocks
// ---------------------------------------------------------------------------
function $1209d59c35d34a71$var$goalBlock(label, valueHtml, note, extra = '') {
    return `
        <div class="flex-1 min-w-[210px] rounded-lg px-4 py-2 bg-game-accent/20 border border-blue-500">
            <div class="flex items-start">
                <div class="text-sm uppercase tracking-widest text-gray-100 flex-grow">${label}</div>
                <div class="text-base font-bold text-game-accent whitespace-nowrap tracking-tighter">${valueHtml}</div>
            </div>
            ${extra}
            <div class="text-xs text-gray-300 mt-3">${note}</div>
        </div>`;
}
function $1209d59c35d34a71$var$renderGoalStrip(container, faction) {
    const { owned: owned, total: total } = $1209d59c35d34a71$var$ownedGearCount(faction);
    const pctGear = total > 0 ? Math.round(owned / total * 100) : 0;
    const artifactsCrafted = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.lifetime?.artifactsCrafted || 0;
    const pctArtifacts = total > 0 ? Math.round(artifactsCrafted / 17 * 100) : 0;
    const barTechGear = `
        <div class="h-2.5 rounded-full bg-gray-800 overflow-hidden mt-2">
            <div class="h-full bg-gradient-to-r from-blue-700 to-game-accent" style="width:${pctGear}%"></div>
        </div>`;
    const barArtifacts = `
        <div class="h-2.5 rounded-full bg-gray-800 overflow-hidden mt-2">
            <div class="h-full bg-gradient-to-r from-blue-700 to-game-accent" style="width:${pctArtifacts}%"></div>
        </div>`;
    let commandBlock = '';
    if ((0, $bde36de43872f734$export$25d1e5af45c35a33)() && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        const marks = (0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character).total;
        commandBlock = `
            <div class="flex flex-col place-content-between flex-1 min-w-[210px] rounded-lg px-4 py-2" style="background:rgba(177,140,255,0.08); border:1px solid hsl(261, 35%, 58%);">
                <div class="flex items-start">
                    <div class="text-sm uppercase tracking-widest text-gray-300 flex-grow">Promotion Marks</div>
                    <div class="text-base font-bold whitespace-nowrap tracking-tighter" style="color:#b18cff">${marks}\u{1F396}\u{FE0F}</div>
                </div>
                <div class="text-xs text-gray-300">Command awards marks based on crafted Skill Gear and Artifacts</div>
            </div>`;
    }
    container.innerHTML = $1209d59c35d34a71$var$goalBlock('Faction Tech Gear', `${owned} / ${total}`, `The core tools of the ${$ce6dd72bc4611534$exports.factionSkills[faction]?.name || faction} field kit`, barTechGear) + $1209d59c35d34a71$var$goalBlock('Artifacts Crafted', `${artifactsCrafted} / 17`, 'Artifact blueprints drop during T3 raids', barArtifacts) + commandBlock;
}
// Top-right ✕ that hides the focus panel; the matching re-open button lives
// next to the "Skill Gear increases…" text (#gear-focus-show).
const $1209d59c35d34a71$var$focusCloseBtn = `<button onclick="toggleGearFocus()" title="Hide suggested focus"
    class="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded bg-black/30 border border-gray-600 text-gray-400 hover:text-white hover:border-gray-400 text-sm leading-none">\u{2715}</button>`;
function $1209d59c35d34a71$var$renderFocusCard(container, faction) {
    const showBtn = document.getElementById('gear-focus-show');
    if ($1209d59c35d34a71$var$focusCollapsed) {
        container.innerHTML = '';
        container.classList.remove('mb-4');
        if (showBtn) showBtn.innerHTML = `<button onclick="toggleGearFocus()"
            class="text-xs font-bold text-game-warning border border-game-warning/50 rounded px-2 py-1 bg-game-warning/20 hover:bg-game-warning/50 hover:text-white whitespace-nowrap">\u{1F3AF} Show focus tip</button>`;
        return;
    }
    if (showBtn) showBtn.innerHTML = '';
    const focus = (0, $9f36f7f2f6b0dce2$export$59244fb66f77c7e5)(faction);
    if (!focus) {
        container.classList.add('mb-4');
        container.innerHTML = `
            <div class="relative border-2 border-green-700 rounded-lg p-4 bg-green-900/10 text-sm">
                ${$1209d59c35d34a71$var$focusCloseBtn}
                \u{2705} <b>Field kit complete!</b> Every tech gear piece is yours \u{2014} Tier-3 raids and Artifacts and are the next frontier.
            </div>`;
        return;
    }
    const { item: item, status: status } = focus;
    const inputRows = status.recipe.inputs.map((input)=>{
        const have = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
        const ok = have >= input.qty;
        const inputItem = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', input.id);
        let sourceLine = '';
        if (!ok) {
            const desc = (0, $9f36f7f2f6b0dce2$export$8ca1be1802f8b29a)({
                id: input.id,
                short: input.qty - have
            });
            if (desc) sourceLine = `<span class="text-[11.5px] text-blue-300/80">\u{2192} ${desc}</span>`;
        }
        return `
            <div class="flex gap-2 items-baseline text-[13px] py-0.5">
                <span class="${ok ? 'text-game-success' : 'text-game-danger'} font-bold text-nowrap">${ok ? "\u2714" : "\u2718"} ${have}/${input.qty}</span>
                <span class="text-nowrap">${inputItem?.icon || ''} ${inputItem?.name || input.id}</span>
                ${sourceLine}
            </div>`;
    }).join('');
    container.classList.add('mb-4');
    container.innerHTML = `
        <div class="relative border-2 border-game-warning rounded-lg p-4" style="background:rgba(245,158,11,0.1);">
            ${$1209d59c35d34a71$var$focusCloseBtn}
            <h3 class="m-0 mb-1 pr-7 text-game-warning text-[15px] font-bold">\u{1F3AF} Suggested focus: ${item.icon || ''} ${item.name}</h3>
            <div class="text-xs text-gray-400 mb-2">Closest tech gear to completion \u{2014} ${status.recipe.inputs.length - status.missing.length} of ${status.recipe.inputs.length} materials ready</div>
            ${inputRows}
        </div>`;
}
// Inventory card cell (createInventoryCard verbatim, expanded or collapsed).
// Two onclick retargets: post-craft refresh goes to this page instead of the
// crafting modal, and the card's collapse toggle goes through toggleGearExpand
// so the state survives this page's re-renders.
function $1209d59c35d34a71$var$cardCell(item, status, { isFocus: isFocus = false, collapsed: collapsed = false, isArtifact: isArtifact = false, stackable: stackable = false } = {}) {
    $1209d59c35d34a71$var$renderedExpanded.set(item.id, !collapsed);
    const recipeMeta = {
        ...status.recipe,
        itemType: isArtifact ? 'artifact' : item.type,
        itemRarity: item.rarity,
        techniqueId: item.techniqueId
    };
    const materials = (0, $42b272c2c0f44bdf$export$4251a114f7437961)(status.recipe.inputs.map((i)=>i.id));
    // Stackables (consumables) never "complete": keep showing recipe progress
    const options = {
        collapsed: collapsed,
        progress: !stackable && status.owned ? 1 : null,
        isFocus: isFocus
    };
    let cardHtml = (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)(item, 'crafting', recipeMeta, materials, options);
    cardHtml = cardHtml.replaceAll('showCraftingModal();', 'renderGearTab();').replaceAll('toggleInventoryCardCollapse(this);', `toggleGearExpand('${item.id}');`);
    // The card's own action button now covers the missing-materials case
    // (active CRAFT COMPONENTS inside the card), so no extra button here
    return `
        <div class="relative">
            ${cardHtml}
        </div>`;
}
/** The selected skill's row of the gear matrix, or null if the faction has none. */ function $1209d59c35d34a71$var$activeColumn(groupId, faction) {
    const skillId = (0, $570f21042242dd0a$export$5b90168a051cbfed)(groupId, faction);
    return (0, $9f36f7f2f6b0dce2$export$75dc440158626230)(faction).find((column)=>column.skillId === skillId) || null;
}
function $1209d59c35d34a71$var$renderMatrix(container, faction) {
    const focus = (0, $9f36f7f2f6b0dce2$export$59244fb66f77c7e5)(faction);
    const column = $1209d59c35d34a71$var$activeColumn($1209d59c35d34a71$var$KIT_TABS, faction);
    const cells = (column?.techniques || []).map(({ item: item })=>{
        const status = (0, $9f36f7f2f6b0dce2$export$93fb318ab1b10a05)(item.id);
        const isFocus = focus && focus.item.id === item.id;
        // Craftable and focus items open by default; owned and distant
        // items start collapsed. A player toggle overrides either way.
        const defaultExpanded = !status.owned && (status.craftable || isFocus);
        const expanded = $1209d59c35d34a71$var$gearCardOverrides.has(item.id) ? $1209d59c35d34a71$var$gearCardOverrides.get(item.id) : defaultExpanded;
        return $1209d59c35d34a71$var$cardCell(item, status, {
            isFocus: isFocus,
            collapsed: !expanded
        });
    }).join('');
    container.innerHTML = `
        ${(0, $570f21042242dd0a$export$313de1df173ff894)($1209d59c35d34a71$var$KIT_TABS, faction)}
        <div class="${$1209d59c35d34a71$var$THREE_UP}" style="${$1209d59c35d34a71$var$THREE_UP_TRACKS}">
            ${cells}
        </div>`;
}
function $1209d59c35d34a71$var$renderArtifacts(container) {
    const statuses = (0, $9f36f7f2f6b0dce2$export$f8a8a403466b6e1)();
    if (!statuses.length) {
        container.innerHTML = '<div class="text-gray-400 text-sm">No artifact recipes for this faction yet.</div>';
        return;
    }
    const cards = statuses.map(({ artifact: artifact, status: status, hasBlueprint: hasBlueprint, copiesOwned: copiesOwned })=>{
        // Artifacts without a recipe (not craftable yet) get a minimal tile
        // instead of an orphaned footer
        if (!status.recipe) return `
                <div class="rounded-lg border border-gray-700 bg-white/5 p-3 text-[12px] text-gray-400 flex flex-col gap-1">
                    <span class="font-bold text-gray-300">${artifact.icon || ''} ${artifact.name}</span>
                    <span>No recipe \u{2014} drop only</span>
                    ${copiesOwned > 0 ? `<span class="text-game-gold">owned \xd7${copiesOwned}</span>` : ''}
                </div>`;
        // UNLOCK is the real gate now: only unlocked designs are expandable
        // (their craft controls are actionable) and open by default. Locked
        // designs stay collapsed - the card component forces that and surfaces
        // the unlock control in the collapsed view.
        const unlocked = (0, $bde36de43872f734$export$2ab3ae91631fe8e5)(artifact.id);
        const defaultExpanded = unlocked;
        const expanded = $1209d59c35d34a71$var$gearCardOverrides.has(artifact.id) ? $1209d59c35d34a71$var$gearCardOverrides.get(artifact.id) : defaultExpanded;
        $1209d59c35d34a71$var$renderedExpanded.set(artifact.id, expanded);
        const recipeMeta = {
            ...status.recipe,
            itemType: 'artifact',
            itemRarity: artifact.rarity
        };
        const materials = (0, $42b272c2c0f44bdf$export$4251a114f7437961)(status.recipe.inputs.map((i)=>i.id));
        // A blueprint identifies the design (shows its name + the unlock button);
        // fully-undiscovered designs (no blueprint, not unlocked) stay <unknown>.
        const cardOptions = unlocked ? {
            collapsed: !expanded
        } : hasBlueprint ? {
            collapsed: true
        } : {
            collapsed: true,
            displayName: "&lt;unknown&gt; \u2014 No Blueprint",
            hideToggle: true
        };
        const cardHtml = (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)(artifact, 'crafting', recipeMeta, materials, cardOptions).replaceAll('showCraftingModal();', 'renderGearTab();').replaceAll('toggleInventoryCardCollapse(this);', `toggleGearExpand('${artifact.id}');`);
        return `
            <div class="relative">
                ${cardHtml}
            </div>`;
    }).join('');
    container.innerHTML = `
        <div class="grid gap-3 justify-between" style="grid-template-columns: repeat(auto-fit, 13rem);">
            ${cards}
        </div>`;
}
// HP field supplies (purchase-only credit sinks; energy is bought one-step from
// the header's ⚡ popup). Their own tab beside the Field Kit: they are bought,
// not crafted, and share nothing with the skill-tabbed panes.
const $1209d59c35d34a71$var$FIELD_SUPPLY_IDS = [
    'field-health-stim',
    'recovery-injector-mk2',
    'advanced-recovery-serum'
];
function $1209d59c35d34a71$var$renderSupplies(container) {
    const inventory = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory || {};
    const supplyCards = $1209d59c35d34a71$var$FIELD_SUPPLY_IDS.map((id)=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id);
        if (!item) return '';
        const qty = inventory[id] || 0;
        // Re-render this page after buying so owned counts stay fresh
        const cardHtml = (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)({
            ...item,
            quantity: qty
        }, 'purchase', null, null, {
            collapsed: true
        }).replaceAll(`purchaseConsumable('${id}')`, `purchaseConsumable('${id}'); renderGearTab();`);
        return `<div class="relative">${cardHtml}</div>`;
    }).join('');
    container.innerHTML = `
        <div class="${$1209d59c35d34a71$var$THREE_UP}" style="${$1209d59c35d34a71$var$THREE_UP_TRACKS}">
            ${supplyCards}
        </div>`;
}
// Technique consumables: one per technique, on the same skill tabs as the Field
// Kit. Crafted from materials; auto-deploy on technique success in raids.
function $1209d59c35d34a71$var$renderConsumables(container, faction) {
    const inventory = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory || {};
    const capitalize = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
    const consumables = $ce6dd72bc4611534$exports[`itemsEpicConsumable${capitalize(faction)}`] || [];
    const column = $1209d59c35d34a71$var$activeColumn($1209d59c35d34a71$var$CONSUMABLE_TABS, faction);
    const cells = (column?.techniques || []).map(({ technique: technique })=>{
        const item = consumables.find((c)=>c.techniqueId === technique.id);
        if (!item) return '';
        const status = (0, $9f36f7f2f6b0dce2$export$93fb318ab1b10a05)(item.id);
        if (!status.recipe) return '';
        const qty = inventory[item.id] || 0;
        // Ready-to-craft items open by default; the rest stay collapsed
        const defaultExpanded = status.missing.length === 0 && qty === 0;
        const expanded = $1209d59c35d34a71$var$gearCardOverrides.has(item.id) ? $1209d59c35d34a71$var$gearCardOverrides.get(item.id) : defaultExpanded;
        return $1209d59c35d34a71$var$cardCell(item, status, {
            collapsed: !expanded,
            stackable: true
        });
    }).join('');
    container.innerHTML = `
        ${(0, $570f21042242dd0a$export$313de1df173ff894)($1209d59c35d34a71$var$CONSUMABLE_TABS, faction)}
        <div class="${$1209d59c35d34a71$var$THREE_UP}" style="${$1209d59c35d34a71$var$THREE_UP_TRACKS}">
            ${cells}
        </div>`;
}
// ---------------------------------------------------------------------------
// Entry points
// ---------------------------------------------------------------------------
// Gear sub-tab state (Field Kit / Field Supplies / Artifacts / Consumables) -
// survives re-renders; buttons and panes are static markup in index.html
let $1209d59c35d34a71$var$activeGearSubTab = 'field-kit';
const $1209d59c35d34a71$var$GEAR_SUBTAB_PANES = {
    'field-kit': 'gear-pane-field-kit',
    'supplies': 'gear-pane-supplies',
    'artifacts': 'gear-pane-artifacts',
    'consumables': 'gear-pane-consumables'
};
function $1209d59c35d34a71$var$applyGearSubTab() {
    document.querySelectorAll('[data-gear-tab]').forEach((btn)=>btn.classList.toggle('active', btn.dataset.gearTab === $1209d59c35d34a71$var$activeGearSubTab));
    Object.entries($1209d59c35d34a71$var$GEAR_SUBTAB_PANES).forEach(([name, paneId])=>document.getElementById(paneId)?.classList.toggle('hidden', name !== $1209d59c35d34a71$var$activeGearSubTab));
}
function $1209d59c35d34a71$export$c9de90a59921a224(name) {
    if (!$1209d59c35d34a71$var$GEAR_SUBTAB_PANES[name]) return;
    $1209d59c35d34a71$var$activeGearSubTab = name;
    $1209d59c35d34a71$var$applyGearSubTab();
}
function $1209d59c35d34a71$export$acf54b11566c856d() {
    const faction = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.faction;
    const strip = document.getElementById('gear-goal-strip');
    const focusEl = document.getElementById('gear-focus');
    const matrixEl = document.getElementById('gear-matrix');
    const artifactsEl = document.getElementById('gear-artifacts');
    const suppliesEl = document.getElementById('gear-supplies');
    const consumablesEl = document.getElementById('gear-consumables');
    if (!strip || !faction) return;
    $1209d59c35d34a71$var$renderGoalStrip(strip, faction);
    $1209d59c35d34a71$var$renderFocusCard(focusEl, faction);
    $1209d59c35d34a71$var$renderMatrix(matrixEl, faction);
    $1209d59c35d34a71$var$renderArtifacts(artifactsEl);
    if (suppliesEl) $1209d59c35d34a71$var$renderSupplies(suppliesEl);
    if (consumablesEl) $1209d59c35d34a71$var$renderConsumables(consumablesEl, faction);
    $1209d59c35d34a71$var$applyGearSubTab();
    // Attach Tippy tooltips to the freshly-rendered card artwork
    window.reinitializeInventoryTooltips?.();
}
function $1209d59c35d34a71$export$10f59a34a449d50b(itemId) {
    const current = $1209d59c35d34a71$var$renderedExpanded.get(itemId) ?? false;
    $1209d59c35d34a71$var$gearCardOverrides.set(itemId, !current);
    $1209d59c35d34a71$export$acf54b11566c856d();
}
function $1209d59c35d34a71$export$f0d1aa93d6391a63() {
    $1209d59c35d34a71$var$focusCollapsed = !$1209d59c35d34a71$var$focusCollapsed;
    $1209d59c35d34a71$export$acf54b11566c856d();
}
if (typeof window !== 'undefined') {
    window.renderGearTab = $1209d59c35d34a71$export$acf54b11566c856d;
    window.toggleGearExpand = $1209d59c35d34a71$export$10f59a34a449d50b;
    window.toggleGearFocus = $1209d59c35d34a71$export$f0d1aa93d6391a63;
    window.setGearSubTab = $1209d59c35d34a71$export$c9de90a59921a224;
}





// DOM glue between the pure avatar generator (avatarGen.js) and the game UI.
//
// Static portraits render as memoized data-URL backgrounds on
// `.contractor-avatar-placeholder[data-avatar-seed]` elements. A single
// MutationObserver (observeAvatars, installed once at boot) hydrates any such
// element as it enters the DOM — this covers the reactive re-renders driven by
// Alpine (contractorManager.js) and raid.js that explicit calls would miss.
// Callers may also invoke hydrateAvatars(root) directly for a synchronous first
// paint, avoiding a flash of the CSS `new.png` fallback.
//
// An element may carry an explicit feature object in `data-avatar-features`
// (JSON) — a player's custom-created avatar. It takes precedence over the seed;
// the element still carries `data-avatar-seed` as a fallback, so the selector
// and observer are unchanged. The focused main-card portrait animates instead —
// see mountAvatarAnimation.

const $1c3a690255c51224$var$RENDER_SIZE = 128; // exact 2x of the 64px logical base; CSS scales boxes down
const $1c3a690255c51224$var$CACHE_CAP = 500; // soft LRU cap — contractors regenerate, so bound the memo
// spec.key -> data URL. Data URLs are expensive to build but free to reuse, so
// this memo is what makes repeated hydration / Alpine re-renders cheap.
const $1c3a690255c51224$var$cache = new Map();
// What to draw for an element: an explicit feature object (custom avatar) wins,
// else the seed. `key` is the memo/identity key; `phaseSeed` drives the idle
// animation's per-avatar phase offset.
function $1c3a690255c51224$var$resolveSpec(el) {
    const faction = el.dataset.avatarFaction || "dominion";
    // Opt-in transparent background so the portrait composites onto the card's own
    // gradient (used where a fixed-size placeholder doesn't fill a wider card).
    const cfg = el.dataset.avatarNobg ? {
        transparentBackground: true
    } : undefined;
    const suffix = cfg ? "|nobg" : "";
    const featJson = el.dataset.avatarFeatures;
    if (featJson) try {
        return {
            faction: faction,
            cfg: cfg,
            features: JSON.parse(featJson),
            key: "f:" + featJson + suffix,
            phaseSeed: featJson
        };
    } catch  {}
    const seed = el.dataset.avatarSeed || "seed";
    return {
        faction: faction,
        cfg: cfg,
        seed: seed,
        key: "s:" + seed + "|" + faction + suffix,
        phaseSeed: seed
    };
}
function $1c3a690255c51224$var$urlFor(spec) {
    let url = $1c3a690255c51224$var$cache.get(spec.key);
    if (url === undefined) {
        url = spec.features ? (0, $d6139340df3c28f5$export$adacf7b1df9d4c0e)(spec.features, spec.faction, $1c3a690255c51224$var$RENDER_SIZE, spec.cfg) : (0, $d6139340df3c28f5$export$df23e55b8e3e0ed8)(spec.seed, spec.faction, $1c3a690255c51224$var$RENDER_SIZE, spec.cfg);
        $1c3a690255c51224$var$cache.set(spec.key, url);
        if ($1c3a690255c51224$var$cache.size > $1c3a690255c51224$var$CACHE_CAP) $1c3a690255c51224$var$cache.delete($1c3a690255c51224$var$cache.keys().next().value); // evict oldest
    }
    return url;
}
function $1c3a690255c51224$export$518ad6ed798753d1(seed, faction = "dominion") {
    return $1c3a690255c51224$var$urlFor({
        faction: faction,
        seed: seed,
        key: "s:" + seed + "|" + faction
    });
}
function $1c3a690255c51224$var$setBackground(el, spec) {
    el.style.backgroundImage = `url(${$1c3a690255c51224$var$urlFor(spec)})`;
    el.style.backgroundSize = "cover";
    el.style.backgroundPosition = "center";
    el.style.imageRendering = "pixelated";
}
// Paint one placeholder's procedural portrait as its background. Idempotent via
// the data-avatar-hydrated flag; a seedless element (e.g. an empty roster slot)
// is left alone so it keeps the CSS default. The single element marked
// `data-avatar-main` (the focused main character card) gets an animated canvas
// on top of a static poster instead of a plain background.
function $1c3a690255c51224$var$hydrateOne(el) {
    if (el.dataset.avatarHydrated) return;
    if (!el.dataset.avatarSeed && !el.dataset.avatarFeatures) return;
    const spec = $1c3a690255c51224$var$resolveSpec(el);
    if (el.dataset.avatarMain) $1c3a690255c51224$var$mountMain(el, spec);
    else $1c3a690255c51224$var$setBackground(el, spec);
    el.dataset.avatarHydrated = "1";
}
// The one focused portrait animates. Only one is ever live: each displayCharacter
// re-render inserts a fresh main element, so we stop the previous loop and mount
// a new one. A static poster sits behind the canvas as an instant/fallback frame.
let $1c3a690255c51224$var$mainStop = null;
function $1c3a690255c51224$var$mountMain(host, spec) {
    if ($1c3a690255c51224$var$mainStop) {
        $1c3a690255c51224$var$mainStop();
        $1c3a690255c51224$var$mainStop = null;
    }
    $1c3a690255c51224$var$setBackground(host, spec); // poster behind the animated canvas
    const canvas = document.createElement("canvas");
    canvas.style.cssText = "position:absolute;inset:0;width:100%;height:100%;image-rendering:pixelated;";
    host.appendChild(canvas);
    const features = spec.features || (0, $d6139340df3c28f5$export$4fafee04cbe5d540)(spec.seed, spec.faction);
    $1c3a690255c51224$var$mainStop = $1c3a690255c51224$export$e3449c06744f2603(canvas, features, spec.faction, spec.phaseSeed);
}
function $1c3a690255c51224$export$b3f1d493f405542a() {
    if ($1c3a690255c51224$var$mainStop) {
        $1c3a690255c51224$var$mainStop();
        $1c3a690255c51224$var$mainStop = null;
    }
}
const $1c3a690255c51224$var$SELECTOR = ".contractor-avatar-placeholder[data-avatar-seed]:not([data-avatar-hydrated])";
function $1c3a690255c51224$export$a5172f1b26b4ebf8(root = document) {
    if (!root) return;
    if (root.matches && root.matches($1c3a690255c51224$var$SELECTOR)) $1c3a690255c51224$var$hydrateOne(root); // the root itself
    if (root.querySelectorAll) root.querySelectorAll($1c3a690255c51224$var$SELECTOR).forEach($1c3a690255c51224$var$hydrateOne);
}
let $1c3a690255c51224$var$observer = null;
function $1c3a690255c51224$export$f32bf1f4ac79976() {
    if ($1c3a690255c51224$var$observer || typeof MutationObserver === "undefined") return;
    $1c3a690255c51224$export$a5172f1b26b4ebf8(document); // catch anything already present
    $1c3a690255c51224$var$observer = new MutationObserver((mutations)=>{
        for (const m of mutations){
            for (const node of m.addedNodes)if (node.nodeType === 1) $1c3a690255c51224$export$a5172f1b26b4ebf8(node);
        }
    });
    $1c3a690255c51224$var$observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
// ---- focused-avatar animation ---------------------------------------------
// The one large main-card portrait animates (idle blink/breathe/mouth/hair) via
// a single rAF loop into a 64px canvas scaled up by CSS. Everything else stays a
// static data-URL background. Returns a stop() to tear the loop down.
// Small stable phase offset from a string so two avatars don't animate in lockstep.
function $1c3a690255c51224$var$phaseFromSeed(seed) {
    const s = String(seed);
    let h = 0;
    for(let i = 0; i < s.length; i++)h = Math.imul(h, 31) + s.charCodeAt(i) | 0;
    return (h >>> 0) % 1000 / 100; // 0..10
}
function $1c3a690255c51224$export$e3449c06744f2603(canvas, features, faction = "dominion", phaseSeed = "") {
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.height = (0, $d6139340df3c28f5$export$aaa4582620b40efc);
    canvas.style.imageRendering = "pixelated";
    const phase = $1c3a690255c51224$var$phaseFromSeed(phaseSeed);
    let raf = 0;
    let stopped = false;
    const frame = (t)=>{
        if (stopped || !canvas.isConnected) return stop();
        ctx.clearRect(0, 0, (0, $d6139340df3c28f5$export$aaa4582620b40efc), (0, $d6139340df3c28f5$export$aaa4582620b40efc));
        (0, $d6139340df3c28f5$export$a046ef6d7517111c)(ctx, features, faction, {}, (0, $d6139340df3c28f5$export$e5cd63d32a946e1d)(t, phase, features.mouthCurve));
        raf = requestAnimationFrame(frame);
    };
    const onVisibility = ()=>{
        if (document.hidden) {
            cancelAnimationFrame(raf);
            raf = 0;
        } else if (!stopped && !raf) raf = requestAnimationFrame(frame);
    };
    document.addEventListener("visibilitychange", onVisibility);
    function stop() {
        stopped = true;
        cancelAnimationFrame(raf);
        document.removeEventListener("visibilitychange", onVisibility);
    }
    raf = requestAnimationFrame(frame);
    return stop;
}







// ---------------------------------------------------------------------------
// Character sub-tabs (Skills / Inventory / Gear)
//
// The character page's right column swaps between three panes. The selection
// is module-scoped so it persists across re-renders AND character switches
// within a session (resets to Skills on reload).
// ---------------------------------------------------------------------------
// Registered with the shared helper rather than hand-rolled here. This file
// used to own the ONLY implementation of sub-tabs; Command, Syndicate and
// gear.js all needed the same thing, and the subtle part (the bounded sizing
// retry) is exactly what gets lost when a pattern is re-typed. See subTabs.js.
(0, $f2aa38d2d36459d1$export$589dc1e4c906c789)("character", {
    panes: {
        skills: "char-skills-pane",
        inventory: "inventory-tab",
        gear: "gear-tab"
    },
    scrollers: {
        skills: "skills-grid",
        inventory: "inventory-grid",
        gear: "gear-tab"
    },
    defaultTab: "skills",
    // Panes are hidden, not unmounted, so anything state-dependent has to be
    // refreshed on reveal (gear.js self-exposes renderGearTab; inventory is
    // Alpine-reactive but re-syncs USE/EQUIP/SELL against current HP/energy).
    onShow: (name)=>{
        if (name === "gear") (0, $1209d59c35d34a71$export$acf54b11566c856d)();
        else if (name === "inventory") (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    }
});
// The Skills pane shows one skill at a time. Five cards in a 2-3 column grid
// was three screens of scrolling on a tablet; the strip is one row.
const $7df15cefc09eac1b$var$SKILL_TAB_GROUP = "char-skills";
(0, $570f21042242dd0a$export$61a3455e09e10145)($7df15cefc09eac1b$var$SKILL_TAB_GROUP, ()=>$7df15cefc09eac1b$export$2eced2100c12c50d());
function $7df15cefc09eac1b$export$c5004add704e7ef5() {
    (0, $f2aa38d2d36459d1$export$7ad721b2ffe28f0c)("character");
}
function $7df15cefc09eac1b$export$373d64f4d7d87f67(name) {
    (0, $f2aa38d2d36459d1$export$8a8da8bddae1b567)("character", name);
}
if (typeof window !== "undefined") {
    window.setCharSubTab = $7df15cefc09eac1b$export$373d64f4d7d87f67;
    window.applyCharSubTab = $7df15cefc09eac1b$export$c5004add704e7ef5;
    window.toggleCharacterCard = $7df15cefc09eac1b$export$63b7a79b9f19f21b;
// The resize listener lives in subTabs.js now, and re-measures every
// registered group rather than just this page's.
}
//
// Technique tab switching
//
window.switchTechniqueTab = function(tabGroupId, tabIndex) {
    // Update tab buttons
    const tabs = document.querySelectorAll(`[data-tab-group="${tabGroupId}"][data-tab-index]`);
    tabs.forEach((tab, idx)=>{
        if (idx === tabIndex) {
            tab.classList.remove("bg-gray-500/60", "hover:bg-gray-600/60");
            tab.classList.add("bg-black/65");
        } else {
            tab.classList.remove("bg-black/65");
            tab.classList.add("bg-gray-500/60", "hover:bg-gray-600/60");
        }
    });
    // Update panels
    const panels = document.querySelectorAll(`.technique-panel[data-tab-group="${tabGroupId}"]`);
    panels.forEach((panel, idx)=>{
        if (idx === tabIndex) panel.classList.remove("hidden");
        else panel.classList.add("hidden");
    });
    // Remember the selected tab for this skill
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.techniqueTabSelections) (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.techniqueTabSelections = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.techniqueTabSelections[tabGroupId] = tabIndex;
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
};
function $7df15cefc09eac1b$export$106e54bf5a9adc20(artifact) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return false;
    // Check if artifact requires a specific skill and if character has it
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "canEquip", artifact);
    if (artifact.slot === "skillSlot" && artifact.skill) {
        const characterSkillLevel = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[artifact.skill] || 0;
        return characterSkillLevel > 0;
    }
    return true; // Utility artifacts can always be equipped
}
function $7df15cefc09eac1b$export$56e7fec58be964ef(artifact) {
    if (!artifact.skill || artifact.slot !== "skillSlot") return "";
    // Get the human-readable skill name
    let skillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)(artifact.skill);
    return `Requires ${skillName} skill`;
}
function $7df15cefc09eac1b$export$1f3b8068ff1292ef(artifactId) {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, artifactId, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts);
    const artifact = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.artifacts.find((a)=>a.id === artifactId);
    if (!artifact) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Artifact not found!", "error");
        return false;
    }
    // Check if artifact can be equipped
    if (!$7df15cefc09eac1b$export$106e54bf5a9adc20(artifact)) {
        const message = $7df15cefc09eac1b$export$56e7fec58be964ef(artifact);
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot equip ${artifact.name} - ${message.toLowerCase()}!`, "error");
        return false;
    }
    const slotName = artifact.slot;
    const currentEquipped = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts[slotName];
    // Unequip current artifact if any
    if (currentEquipped) $7df15cefc09eac1b$export$fd37f844ae84e59c(slotName);
    // Equip new artifact
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts[slotName] = artifact;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Equipped ${artifact.name}!`, "success");
    // Refresh inventory display to update equipped status
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    window.renderGearTab?.(); // gear-tab cards show equip state
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    return true;
}
function $7df15cefc09eac1b$export$fd37f844ae84e59c(slotName) {
    // Prevent unequipping artifacts for marketplace characters
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    const artifact = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts[slotName];
    if (!artifact) return false;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts[slotName] = null;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Unequipped ${artifact.name}!`, "info");
    // Refresh inventory display to update equipped status
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    window.renderGearTab?.(); // gear-tab cards show equip state
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    return true;
}
function $7df15cefc09eac1b$export$9e693217356d7ac4(gearId, techniqueId = null) {
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "canEquipGear", gearId);
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return false;
    // Check item requirements
    const gearItem = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)("id", gearId);
    if (gearItem.type !== "techGear") return false;
    // Check if character has related skill
    const characterSkill = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[(0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(gearItem.techniqueId)];
    if (!characterSkill) return false;
    // Validate gear matches technique ID if provided
    if (techniqueId && gearItem.techniqueId !== techniqueId) return false;
    return true;
}
function $7df15cefc09eac1b$export$bc6c3240a6a68b89(gearId) {
    const gearItem = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)("id", gearId);
    if (!gearItem || !gearItem.techniqueId) return "";
    // Get the human-readable skill name
    let skillName = (0, $42b272c2c0f44bdf$export$182937d2e68a339)((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(gearItem.techniqueId));
    return `Requires ${skillName} skill`;
}
function $7df15cefc09eac1b$export$958ab300c288e475(techniqueId, gearId) {
    const gearItem = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)("id", gearId);
    // Prevent equipping gear for marketplace characters
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    if (!$7df15cefc09eac1b$export$9e693217356d7ac4(gearId, techniqueId)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Gear requirements not met", "error");
        return false;
    }
    // One gear per skill: equipping evicts whatever same-skill technique is
    // tooled up (incl. this technique's own current gear). The full kit is a
    // toolbox - swap freely between raids to match the route.
    const skillKey = (0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(techniqueId);
    Object.keys((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear).forEach((equippedTechId)=>{
        if ((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(equippedTechId) === skillKey) $7df15cefc09eac1b$export$954d5d768998dfd1(equippedTechId);
    });
    // Equip new gear
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId] = gearItem;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Equipped ${gearItem.name}!`, "success");
    // Refresh displays (contractor cards show synergy indicators derived from
    // the player's equipped gear - window access avoids an import cycle)
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    window.refreshAlpineContractors?.();
    window.renderGearTab?.(); // gear-tab cards show equip state
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    return true;
}
function $7df15cefc09eac1b$export$954d5d768998dfd1(techniqueId) {
    // Prevent unequipping gear for marketplace characters
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    const gear = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId];
    if (!gear) return false;
    delete (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId];
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Unequipped ${gear.name}!`, "info");
    // Refresh displays (incl. contractor synergy indicators)
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    window.refreshAlpineContractors?.();
    window.renderGearTab?.(); // gear-tab cards show equip state
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    return true;
}
function $7df15cefc09eac1b$var$getAvailableSkillGear(techniqueId, skillKey) {
    const availableGear = Object.entries((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.inventory).filter(([itemId, qty])=>qty > 0).map(([itemId])=>{
        const item = (0, $42b272c2c0f44bdf$export$a2dea178c28a0308)("id", itemId);
        return item;
    }).filter((item)=>item && item.type === "techGear" && item.techniqueId === techniqueId);
    return availableGear;
}
function $7df15cefc09eac1b$export$4e0f5000083da307(techniqueId, skillKey) {
    // Get all techGear items from inventory
    const availableGear = $7df15cefc09eac1b$var$getAvailableSkillGear(techniqueId, skillKey);
    if (availableGear.length === 0) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("No compatible gear in inventory", "warning");
        return;
    }
    // Create modal with gear options
    const gearOptions = availableGear.map((gear)=>`<div class="flex items-center justify-between p-2 border border-gray-500 rounded mb-2 hover:bg-gray-700/50 cursor-pointer" onclick="equipTechniqueGear('${techniqueId}', '${gear.id}'); closeTechniqueGearSelector();">
            <div>
                <div class="font-bold text-white">${gear.name}</div>
                <div class="text-xs text-gray-400">${gear.icon} ${gear.short}</div>
                ${gear.effects ? `<div class="text-xs text-amber-300">Effects: ${Object.entries(gear.effects).map(([k, v])=>`${k}: +${v}`).join(", ")}</div>` : ""}
            </div>
            <button class="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white rounded text-sm font-bold border border-amber-500" onclick="event.stopPropagation(); equipTechniqueGear('${techniqueId}', '${gear.id}'); closeTechniqueGearSelector();">SELECT</button>
        </div>`).join("");
    // Show modal
    const modal = document.getElementById("technique-gear-selector-modal");
    if (modal) modal.remove();
    const newModal = document.createElement("div");
    newModal.id = "technique-gear-selector-modal";
    newModal.className = "modal hidden";
    newModal.innerHTML = `
        <div class="modal-content max-w-md w-full">
            <div class="modal-header">
                <h3 class="modal-title">Select Gear for Technique</h3>
                <button class="close-btn" onclick="closeTechniqueGearSelector()">&times;</button>
            </div>
            <div class="modal-body">
                <div class="max-h-96 overflow-y-auto">
                    ${gearOptions}
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(newModal);
    newModal.classList.remove("hidden");
}
function $7df15cefc09eac1b$export$a9326cac8ab4c94a() {
    const modal = document.getElementById("technique-gear-selector-modal");
    if (modal) modal.classList.add("hidden");
}
function $7df15cefc09eac1b$export$fc83223e1b29d2d5(level) {
    // Calculate color intensity per level
    // Each level gradually shifts from dark grays (800-900) toward lighter grays (100-300)
    // Level 1 starts at dark, increases by ~2 gray-scale points per level
    const grayScale = {
        100: "gray-100",
        200: "gray-200",
        300: "gray-300",
        400: "gray-400",
        500: "gray-500",
        600: "gray-600",
        700: "gray-700",
        800: "gray-800",
        900: "gray-900"
    };
    // Calculate shift amount: 2 points per level, capped at 80
    const shiftAmount = Math.min((level - 1) * 2, 80);
    // Helper function to get closest Tailwind gray class
    const getGray = (baseValue)=>{
        const adjusted = Math.max(100, baseValue - shiftAmount);
        const rounded = Math.round(adjusted / 100) * 100;
        return grayScale[rounded];
    };
    return {
        cardBg: `from-${getGray(800)} to-${getGray(900)}`,
        cardBorder: `border-${getGray(600)}`,
        frameBorder: `border-${getGray(500)}`,
        headerBg: `from-${getGray(700)} to-${getGray(600)}`,
        headerBorder: `border-${getGray(500)}`
    };
}
function $7df15cefc09eac1b$export$35bc0bfc04b8de17() {
    const skillsSection = document.getElementById("skills-section");
    const pointsRemainingDiv = document.getElementById("points-remaining");
    const faction = $ce6dd72bc4611534$export$aeeef991191508e2[(0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction];
    if (!faction) return;
    // Only show skills after character is created
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        skillsSection.classList.remove("hidden");
        skillsSection.classList.add("grid");
        skillsSection.innerHTML = "";
        Object.entries(faction.skills).forEach(([skillKey, skill])=>{
            const skillLevel = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skillKey] || 0;
            const skillPointCost = Math.max(1, Math.floor(skillLevel / 3) + 1);
            const currencyCost = (0, $1b3f8df6e579f420$export$28bf58d3c9312b43)(skillLevel);
            const canAffordPoints = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints >= skillPointCost;
            const canAffordCurrency = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits >= currencyCost;
            const canAfford = canAffordPoints && canAffordCurrency;
            // Concrete benefit: success chance per tier for rooms where this skill
            // is primary (gates and hazards have different targets), and the +5%
            // a level buys (until the 97% cap). The equipped skill artifact's flat
            // bonus folds in exactly, under the same 97% cap the resolver applies.
            const artifactPct = (0, $1b3f8df6e579f420$export$a5a257639bbcfa93)(skillKey);
            const tierChances = [
                1,
                2,
                3
            ].map((tier)=>{
                const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
                const gatePct = Math.min(97, Math.round((0, $b596e64ef926739f$export$2ad5af141c2ca6d2)(skillLevel, tierData.gateSkillLevel) * 100) + artifactPct);
                const hazardPct = Math.min(97, Math.round((0, $b596e64ef926739f$export$2ad5af141c2ca6d2)(skillLevel, tierData.hazardSkillLevel) * 100) + artifactPct);
                return `T${tier} <span class="text-gray-300">gates ${gatePct}% \xb7 hazards ${hazardPct}%</span>`;
            }).join(' &nbsp;|&nbsp; ');
            const atCap = (0, $b596e64ef926739f$export$2ad5af141c2ca6d2)(skillLevel, $ce6dd72bc4611534$export$94e7ad7999c1ae32[3].hazardSkillLevel) * 100 + artifactPct >= 97;
            const nextLevelNote = atCap ? 'success chance at cap for current tiers' : 'next level: <span class="text-green-400 font-bold">+5%</span> on every room using this skill';
            const skillDiv = document.createElement("div");
            skillDiv.className = "skill-item";
            skillDiv.innerHTML = `
                <h4>${skill.name}</h4>
                <p class="text-gray-400 text-sm">${skill.description}</p>
                <div class="text-xs text-gray-400 mt-1" title="Your success chance per skill check in rooms where this skill is primary (before support/contractor bonuses)">
                    \u{1F3B2} ${tierChances}
                    <span class="block mt-0.5">${nextLevelNote}</span>
                </div>
                <div class="skill-controls">
                    <span class="skill-level">Level: ${skillLevel}</span>
                    <span class="skill-cost">Cost: ${skillPointCost} point${skillPointCost > 1 ? "s" : ""} + ${currencyCost} credits</span>
                    <button class="skill-btn" onclick="upgradeSkill('${skillKey}')" ${!canAfford ? "disabled" : ""}>
                        Upgrade ${!canAffordPoints ? `(Need ${skillPointCost - (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints} points)` : !canAffordCurrency ? `(Need ${currencyCost - (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits} credits)` : ""}
                    </button>
                </div>
            `;
            skillsSection.appendChild(skillDiv);
        });
        document.getElementById("points-remaining").textContent = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints;
    } else {
        // Hide skills section during character creation
        skillsSection.classList.add("hidden");
        if (pointsRemainingDiv) pointsRemainingDiv.classList.add("hidden");
    }
    $7df15cefc09eac1b$export$44472cbca86113a6();
}
function $7df15cefc09eac1b$export$dfab59a277375299(skillKey) {
    (0, $1b3f8df6e579f420$export$909e62d4478cec23)(skillKey);
    $7df15cefc09eac1b$export$35bc0bfc04b8de17();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)(); // Update credits display
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $7df15cefc09eac1b$export$8d1a7714ddcaaa75(skillKey) {
    const result = (0, $1b3f8df6e579f420$export$a2d6ef296e5ae7a1)(skillKey);
    if (!result.success) {
        const messages = {
            'insufficient-points': `\u{26A0}\u{FE0F} Need ${(0, $1b3f8df6e579f420$export$d09b0dfa38532c40)().cost} skill points to unlock synergies`,
            'already-unlocked': 'Synergies already unlocked for this skill',
            'not-revealed': `Synergies unlock at level ${(0, $1b3f8df6e579f420$export$d09b0dfa38532c40)().minLevel}`
        };
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(messages[result.reason] || 'Cannot unlock synergies', 'warning');
        return;
    }
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{26A1} ${(0, $42b272c2c0f44bdf$export$182937d2e68a339)(skillKey)} synergies unlocked! Teammates' partner gear can now upgrade its events.`, 'success');
    $7df15cefc09eac1b$export$35bc0bfc04b8de17();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    window.refreshAlpineContractors?.(); // card indicators depend on unlocks
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $7df15cefc09eac1b$export$318eecdbf5a9bff1(xpAmount) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return;
    // Use core logic for XP gain and leveling
    (0, $1b3f8df6e579f420$export$88ec20478ef6bd29)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character, xpAmount);
    // Update UI to reflect changes
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    // Update character selector to reflect XP changes
    if (typeof $7df15cefc09eac1b$export$d87722dc17dc5f68 !== "undefined") $7df15cefc09eac1b$export$d87722dc17dc5f68();
}
function $7df15cefc09eac1b$export$614d9188892af6f1() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    const hpBefore = character.maxHp;
    // Use core logic for leveling
    (0, $1b3f8df6e579f420$export$57757d3a3e441a94)(character);
    const hpIncrease = character.maxHp - hpBefore;
    const skillPointsGained = 2 + Math.floor(character.level / 5); // Matches calculation in levelUpCore
    // Show level up notifications (UI only)
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F389} Level Up! You are now level ${character.level}!`, "success");
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4AA} +${hpIncrease} Max HP, +${skillPointsGained} Skill Points`, "success");
    // Log level up in raid log if active
    const logEntries = document.getElementById("log-entries");
    if (logEntries && logEntries.innerHTML !== "") addLogEntry(`\u{1F389} LEVEL UP! You reached level ${character.level}! (+${hpIncrease} HP, +${skillPointsGained} skill points)`, "success");
}
//
// Avatar selection functions
//
// When the player clicks "New Set", this holds a fresh random root so the grid
// shows brand-new candidates instead of variants of their current avatar.
let $7df15cefc09eac1b$var$galleryOverrideSeed = null;
function $7df15cefc09eac1b$export$aee20503c4a7fb32() {
    const faction = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.faction || "dominion";
    // Default: seeded candidates off the character's own seed so re-opening is
    // stable (root, then root#0..root#28 — current avatar first; "#k" suffix
    // stripped so picking a variant doesn't keep growing the seed). "New Set"
    // swaps in a fresh random root for a full page of brand-new faces.
    let seeds;
    if ($7df15cefc09eac1b$var$galleryOverrideSeed) seeds = Array.from({
        length: 30
    }, (_, k)=>`${$7df15cefc09eac1b$var$galleryOverrideSeed}#${k}`);
    else {
        const root = String((0, $42b272c2c0f44bdf$export$f3619081e7e8f116)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character || {})).replace(/#\d+$/, "");
        seeds = [
            root,
            ...Array.from({
                length: 29
            }, (_, k)=>`${root}#${k}`)
        ];
    }
    return seeds.map((seed)=>{
        return `
            <div class="avatar-option" data-avatar-seed="${seed}">
                <div class="contractor-avatar-placeholder" data-avatar-seed="${seed}" data-avatar-faction="${faction}"></div>
            </div>
        `;
    }).join("");
}
function $7df15cefc09eac1b$export$a2a7c3306a075a0b() {
    const changeAvatarBtn = document.getElementById("change-avatar-btn");
    const avatarSelector = document.getElementById("avatar-selector");
    const closeAvatarBtn = document.getElementById("close-avatar-selector");
    if (changeAvatarBtn) changeAvatarBtn.addEventListener("click", ()=>{
        $7df15cefc09eac1b$export$b87daba1245f3381();
    });
    if (closeAvatarBtn) closeAvatarBtn.addEventListener("click", ()=>{
        $7df15cefc09eac1b$export$844cc0cc11314e02();
    });
    // Close modal when clicking outside
    if (avatarSelector) avatarSelector.addEventListener("click", (e)=>{
        if (e.target === avatarSelector) $7df15cefc09eac1b$export$844cc0cc11314e02();
    });
    $7df15cefc09eac1b$var$wireAvatarOptions();
    // "New Set": swap the gallery in for a fresh random page of candidates.
    const refreshBtn = document.getElementById("avatar-gallery-refresh");
    if (refreshBtn) refreshBtn.addEventListener("click", ()=>{
        $7df15cefc09eac1b$var$galleryOverrideSeed = `gallery_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        const grid = document.getElementById("avatar-gallery-grid");
        if (grid) {
            grid.innerHTML = $7df15cefc09eac1b$export$aee20503c4a7fb32();
            $7df15cefc09eac1b$var$wireAvatarOptions();
        }
    });
    $7df15cefc09eac1b$var$setupAvatarTabs();
}
// The raid team carousel caches each member's card HTML with the avatar seed
// baked in, so an avatar edit on the Characters page leaves the player's team
// card stale. Whenever that carousel is currently showing cards (team assembly
// or path planning - both display the team before a grid exists), rebuild it so
// the new look shows immediately. updateGridTeamDisplay self-guards on the DOM.
function $7df15cefc09eac1b$var$refreshRaidTeamAvatar() {
    const teamDisplay = document.getElementById('grid-team-display');
    if (teamDisplay && teamDisplay.querySelector('[data-avatar-seed]')) (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
}
// Wire click-to-pick on gallery options. Idempotent (data-wired guard) so it can
// be re-run after regenerating the grid for a new set. A gallery pick reverts any
// custom avatar back to a seed.
function $7df15cefc09eac1b$var$wireAvatarOptions() {
    document.querySelectorAll(".avatar-option").forEach((option)=>{
        if (option.dataset.wired) return;
        option.dataset.wired = "1";
        option.addEventListener("click", ()=>{
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatarSeed = option.dataset.avatarSeed;
            delete (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatarFeatures;
            $7df15cefc09eac1b$export$2eced2100c12c50d();
            $7df15cefc09eac1b$export$844cc0cc11314e02();
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            if (typeof $7df15cefc09eac1b$export$d87722dc17dc5f68 !== "undefined") $7df15cefc09eac1b$export$d87722dc17dc5f68();
            $7df15cefc09eac1b$var$refreshRaidTeamAvatar();
        });
    });
}
// ---- Custom avatar creator (the "Custom" tab of the picker) --------------
// A working feature object the player edits live. Initialised from their current
// avatar: their saved custom features if any, else rolled from their seed.
let $7df15cefc09eac1b$var$creatorFeatures = null;
let $7df15cefc09eac1b$var$creatorAnimStop = null;
const $7df15cefc09eac1b$var$avatarCreatorFaction = ()=>(0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.faction || "dominion";
function $7df15cefc09eac1b$var$initCreatorFeatures() {
    const c = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    $7df15cefc09eac1b$var$creatorFeatures = c?.avatarFeatures ? {
        ...c.avatarFeatures
    } : (0, $d6139340df3c28f5$export$4fafee04cbe5d540)((0, $42b272c2c0f44bdf$export$f3619081e7e8f116)(c || {}), $7df15cefc09eac1b$var$avatarCreatorFaction());
}
function $7df15cefc09eac1b$var$stopCreatorPreviewAnim() {
    if ($7df15cefc09eac1b$var$creatorAnimStop) {
        $7df15cefc09eac1b$var$creatorAnimStop();
        $7df15cefc09eac1b$var$creatorAnimStop = null;
    }
}
// Animate the preview canvas off the LIVE creatorFeatures object (same idle loop
// the main card uses). Edits mutate that object in place and Randomize
// Object.assigns into it, so the running loop always reflects the current look.
function $7df15cefc09eac1b$var$startCreatorPreviewAnim() {
    $7df15cefc09eac1b$var$stopCreatorPreviewAnim();
    const canvas = document.getElementById("avatar-creator-canvas");
    if (canvas && $7df15cefc09eac1b$var$creatorFeatures) $7df15cefc09eac1b$var$creatorAnimStop = (0, $1c3a690255c51224$export$e3449c06744f2603)(canvas, $7df15cefc09eac1b$var$creatorFeatures, $7df15cefc09eac1b$var$avatarCreatorFaction(), "creator");
}
const $7df15cefc09eac1b$var$acGet = (field)=>field.get ? field.get($7df15cefc09eac1b$var$creatorFeatures) : $7df15cefc09eac1b$var$creatorFeatures[field.key];
// Edits mutate creatorFeatures in place; the running preview loop shows them.
const $7df15cefc09eac1b$var$acSet = (field, v)=>{
    field.set ? field.set($7df15cefc09eac1b$var$creatorFeatures, v) : $7df15cefc09eac1b$var$creatorFeatures[field.key] = v;
};
const $7df15cefc09eac1b$var$acOpts = (field)=>field.options.map((o)=>Array.isArray(o) ? o : [
            o,
            o
        ]);
// One labelled control for a FEATURE_SCHEMA field (ported from avatar-lab.html).
function $7df15cefc09eac1b$var$buildAvatarField(field) {
    const wrap = document.createElement("div");
    wrap.className = "cfield";
    const lab = document.createElement("label");
    lab.textContent = field.label;
    wrap.appendChild(lab);
    if (field.type === "bool") {
        const input = document.createElement("input");
        input.type = "checkbox";
        input.checked = !!$7df15cefc09eac1b$var$acGet(field);
        input.addEventListener("change", ()=>$7df15cefc09eac1b$var$acSet(field, input.checked));
        wrap.appendChild(input);
    } else if (field.type === "int") {
        const input = document.createElement("input");
        input.type = "number";
        input.min = field.min;
        input.max = field.max;
        input.step = 1;
        input.value = $7df15cefc09eac1b$var$acGet(field);
        input.addEventListener("input", ()=>{
            const v = parseInt(input.value, 10);
            if (!Number.isNaN(v)) $7df15cefc09eac1b$var$acSet(field, v);
        });
        wrap.appendChild(input);
    } else if (field.type === "color") {
        const row = document.createElement("div");
        row.className = "color-row";
        const input = document.createElement("input");
        input.type = "color";
        input.value = $7df15cefc09eac1b$var$acGet(field) || "#888888";
        input.addEventListener("input", ()=>$7df15cefc09eac1b$var$acSet(field, input.value));
        const presets = document.createElement("div");
        presets.className = "presets";
        for (const cc of field.options || []){
            const b = document.createElement("button");
            b.type = "button";
            b.style.background = cc;
            b.title = cc;
            b.addEventListener("click", ()=>{
                input.value = cc;
                $7df15cefc09eac1b$var$acSet(field, cc);
            });
            presets.appendChild(b);
        }
        row.append(input, presets);
        wrap.appendChild(row);
    } else if (field.type === "enum") {
        const sel = document.createElement("select");
        const opts = $7df15cefc09eac1b$var$acOpts(field);
        opts.forEach(([label], i)=>sel.add(new Option(label, String(i))));
        const idx = opts.findIndex(([, v])=>v === $7df15cefc09eac1b$var$acGet(field));
        sel.value = String(idx < 0 ? 0 : idx);
        sel.addEventListener("change", ()=>$7df15cefc09eac1b$var$acSet(field, opts[Number(sel.value)][1]));
        wrap.appendChild(sel);
    }
    return wrap;
}
// Build the grouped control grid (Face / Hair / Eyes / Accessories) for the
// current faction (drops faction-specific fields like the veil-only hood).
function $7df15cefc09eac1b$var$renderAvatarCreatorControls() {
    const host = document.getElementById("avatar-creator-controls");
    if (!host) return;
    host.innerHTML = "";
    const faction = $7df15cefc09eac1b$var$avatarCreatorFaction();
    const order = [], byGroup = new Map();
    for (const field of (0, $d6139340df3c28f5$export$54d4f0a9b0c6e9b3)){
        if (field.factions && !field.factions.includes(faction)) continue;
        if (!byGroup.has(field.group)) {
            byGroup.set(field.group, []);
            order.push(field.group);
        }
        byGroup.get(field.group).push(field);
    }
    for (const g of order){
        const title = document.createElement("div");
        title.className = "cgroup-title";
        title.textContent = g;
        const grid = document.createElement("div");
        grid.className = "creator-controls";
        for (const field of byGroup.get(g))grid.appendChild($7df15cefc09eac1b$var$buildAvatarField(field));
        host.append(title, grid);
    }
}
// Wire the Gallery/Custom tabs + the creator's Randomize/Use buttons. Re-run
// each time the modal markup is rebuilt (setupAvatarSelection).
function $7df15cefc09eac1b$var$setupAvatarTabs() {
    const tabs = document.querySelectorAll(".avatar-tab");
    const panes = {
        gallery: document.getElementById("avatar-pane-gallery"),
        custom: document.getElementById("avatar-pane-custom")
    };
    tabs.forEach((tab)=>tab.addEventListener("click", ()=>{
            const which = tab.dataset.avatarTab;
            tabs.forEach((t)=>t.classList.toggle("active", t === tab));
            for (const [k, pane] of Object.entries(panes))pane && pane.classList.toggle("active", k === which);
            if (which === "custom") {
                if (!$7df15cefc09eac1b$var$creatorFeatures) $7df15cefc09eac1b$var$initCreatorFeatures(); // first open this session; keeps edits across toggles
                $7df15cefc09eac1b$var$renderAvatarCreatorControls();
                $7df15cefc09eac1b$var$startCreatorPreviewAnim();
            } else $7df15cefc09eac1b$var$stopCreatorPreviewAnim(); // no need to animate a hidden preview
        }));
    const randomBtn = document.getElementById("avatar-creator-random");
    if (randomBtn) randomBtn.addEventListener("click", ()=>{
        if (!$7df15cefc09eac1b$var$creatorFeatures) $7df15cefc09eac1b$var$initCreatorFeatures();
        // Mutate in place so the live preview loop keeps pointing at the same object.
        Object.assign($7df15cefc09eac1b$var$creatorFeatures, (0, $d6139340df3c28f5$export$4fafee04cbe5d540)(`custom_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`, $7df15cefc09eac1b$var$avatarCreatorFaction()));
        $7df15cefc09eac1b$var$renderAvatarCreatorControls();
        $7df15cefc09eac1b$var$startCreatorPreviewAnim();
    });
    const applyBtn = document.getElementById("avatar-creator-apply");
    if (applyBtn) applyBtn.addEventListener("click", ()=>{
        if (!$7df15cefc09eac1b$var$creatorFeatures) return;
        $7df15cefc09eac1b$var$stopCreatorPreviewAnim();
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.avatarFeatures = {
            ...$7df15cefc09eac1b$var$creatorFeatures
        };
        $7df15cefc09eac1b$export$2eced2100c12c50d();
        $7df15cefc09eac1b$export$844cc0cc11314e02();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        if (typeof $7df15cefc09eac1b$export$d87722dc17dc5f68 !== "undefined") $7df15cefc09eac1b$export$d87722dc17dc5f68();
        $7df15cefc09eac1b$var$refreshRaidTeamAvatar();
    });
}
function $7df15cefc09eac1b$export$b87daba1245f3381() {
    // Editing is locked while a raid is actively running (the button is also
    // disabled, but guard the action too - render timing isn't guaranteed).
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Can't edit your avatar while a raid is in progress", "info");
        return;
    }
    $7df15cefc09eac1b$var$galleryOverrideSeed = null;
    const grid = document.getElementById("avatar-gallery-grid");
    if (grid) {
        grid.innerHTML = $7df15cefc09eac1b$export$aee20503c4a7fb32();
        $7df15cefc09eac1b$var$wireAvatarOptions();
    }
    document.querySelectorAll(".avatar-tab").forEach((t)=>t.classList.toggle("active", t.dataset.avatarTab === "gallery"));
    document.getElementById("avatar-pane-gallery")?.classList.add("active");
    document.getElementById("avatar-pane-custom")?.classList.remove("active");
    $7df15cefc09eac1b$var$stopCreatorPreviewAnim();
    $7df15cefc09eac1b$var$creatorFeatures = null;
    const avatarSelector = document.getElementById("avatar-selector");
    if (avatarSelector) avatarSelector.classList.remove("hidden");
}
function $7df15cefc09eac1b$export$844cc0cc11314e02() {
    $7df15cefc09eac1b$var$stopCreatorPreviewAnim();
    $7df15cefc09eac1b$var$creatorFeatures = null;
    const avatarSelector = document.getElementById("avatar-selector");
    if (avatarSelector) avatarSelector.classList.add("hidden");
}
// ---------------------------------------------------------------------------
// Main character card: full card <-> drawer
//
// Collapsed, the card gives its ~240px column back to the Skills/Gear panes —
// the single biggest horizontal win available on this page for a tablet. What
// survives the collapse is the at-a-glance state (who, how healthy, what is
// equipped, what level) and the two actions that are not reachable anywhere
// else on the page. Renaming, the avatar editor and DELETE deliberately do not:
// a destructive control on a one-tap drawer is a mis-tap waiting to happen.
//
// Session-scoped, like the gear page's focus panel — a layout preference, not
// save data.
// ---------------------------------------------------------------------------
let $7df15cefc09eac1b$var$characterCardCollapsed = false;
function $7df15cefc09eac1b$export$63b7a79b9f19f21b() {
    $7df15cefc09eac1b$var$characterCardCollapsed = !$7df15cefc09eac1b$var$characterCardCollapsed;
    $7df15cefc09eac1b$export$2eced2100c12c50d();
}
/** One drawer row: icon over value, or icon alone when value is null. */ function $7df15cefc09eac1b$var$drawerChip(icon, value, title) {
    return `
    <div class="w-full flex flex-col items-center rounded border border-gray-700 bg-black/70 pt-2" title="${title}">
        <span class="text-sm leading-none">${icon}</span>
        ${value != null ? `<span class="text-[10px] font-bold leading-tight mt-0.5">${value}</span>` : ""}
    </div>`;
}
function $7df15cefc09eac1b$var$renderCharacterDrawer({ faction: faction, levelColors: levelColors, isReadOnly: isReadOnly, hasRaid: hasRaid }) {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    const equippedGearCount = Object.values(character.equippedTechniqueGear || {}).filter(Boolean).length;
    const equippedArtifactCount = Object.values(character.equippedArtifacts || {}).filter(Boolean).length;
    const xpToNext = (0, $1b3f8df6e579f420$export$ae545994cbde97ee)(character.level);
    return `
    <div class="character-avatar-section">
        <div class="relative bg-gradient-to-b ${levelColors.headerBg} to-gray-900 border-4 ${isReadOnly ? "border-orange-500" : levelColors.cardBorder} rounded-xl shadow-lg w-16 flex flex-col items-center gap-1.5 p-1.5 h-[480px]">
            <button id="toggle-character-card-btn" onclick="toggleCharacterCard()"
                title="Expand ${character.name}" aria-expanded="false"
                class="w-full h-6 flex items-center justify-center rounded bg-black/40 border border-gray-600 text-gray-300 hover:text-white hover:border-gray-400 text-sm leading-none">\u{25B8}</button>

            <div class="rounded-full w-7 h-7 flex items-center justify-center bg-black/30 border border-black text-sm flex-shrink-0"
                title="${faction.name}${isReadOnly ? " \u2014 on marketplace" : ""}">${faction.icon || "\uD83C\uDFE2"}</div>

            ${$7df15cefc09eac1b$var$drawerChip("\u2764\uFE0F", Math.floor(character.currentHp), `Health: ${Math.floor(character.currentHp)} / ${character.maxHp}`)}
            ${$7df15cefc09eac1b$var$drawerChip("\uD83E\uDDF0", equippedGearCount, "Equipped skill gear")}
            ${$7df15cefc09eac1b$var$drawerChip("\uD83D\uDD2E", equippedArtifactCount, "Equipped artifacts")}

            <div class="w-full rounded border-2 border-gray-500 bg-gradient-to-b from-gray-800 to-gray-900 py-1 text-center"
                title="Level ${character.level} \u{2014} ${character.xp}/${xpToNext} XP">
                <div class="text-[9px] uppercase tracking-wide text-gray-400 leading-none">Lv</div>
                <div class="text-blue-300 font-bold text-sm leading-tight">${character.level}</div>
            </div>
            <div class="flex-grow"></div>
            ${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `<button id="promote-character-btn" onclick="openPromoteModal()"
                    class="w-full py-1 rounded text-xs font-bold transition-all duration-200 hover:shadow-lg"
                    style="border:1.5px solid #6d4fa3; background:#6d4fa3; color:#b18cff;"
                    title="Promote to Command \u{2014} ${(0, $bde36de43872f734$export$ffae5de2f7ddd94d)(character).total} marks">\u{1F396}\u{FE0F}</button>` : ""}
            <button id="contract-out-btn" ${hasRaid ? "disabled" : ""} class="${character.isMarketplace ? "bg-orange-600 hover:bg-orange-700" : "bg-yellow-600 hover:bg-yellow-700"} w-full text-white py-1 rounded text-xs font-bold transition-all duration-200" title="${character.isMarketplace ? "Withdraw from Marketplace" : "Contract Out to Marketplace"}">${character.isMarketplace ? "\uD83D\uDCE4" : "\uD83D\uDCBC"}</button>
            
            <button id="delete-character-btn" class="w-full bg-red-600 hover:bg-red-700 text-white py-1 rounded text-xs font-bold transition-all duration-200 ${isReadOnly ? "opacity-50 cursor-not-allowed" : ""}" 
              title="${isReadOnly ? "Cannot delete - character on marketplace" : "Delete Character"}" ${isReadOnly ? "disabled" : ""}>\u{1F5D1}\u{FE0F}</button>
        </div>
    </div>`;
}
function $7df15cefc09eac1b$export$2eced2100c12c50d() {
    // Update character selector first
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.length > 0) $7df15cefc09eac1b$export$d87722dc17dc5f68();
    // Update inventory header
    (0, $b7695fceb608271e$export$d2567add70135c10)();
    const faction = $ce6dd72bc4611534$export$aeeef991191508e2[(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction];
    // Check if character is in read-only mode (on marketplace)
    const isReadOnly = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace;
    // Update header background when character is displayed
    (0, $f3f2c7a1b1934e01$export$ffc032d1101a5382)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
    // One skill card at a time — the strip below picks which, and carries that
    // skill's level and upgrade button.
    const shownSkill = (0, $570f21042242dd0a$export$5b90168a051cbfed)($7df15cefc09eac1b$var$SKILL_TAB_GROUP, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
    let skillsHtml = "";
    Object.entries((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills).filter(([skillKey])=>skillKey === shownSkill).forEach(([skillKey, level])=>{
        const skillShort = faction.skills[skillKey].short;
        const skillPointCost = (0, $1b3f8df6e579f420$export$7d0067675be54b12)(level);
        const canAfford = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints >= skillPointCost && (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits >= (0, $1b3f8df6e579f420$export$28bf58d3c9312b43)(level) && !isReadOnly;
        // The card's old header row is gone — the tab strip above already names the
        // skill. Its level and upgrade button moved down here, beside the synergy
        // control: both are "spend points on this skill", so they belong together.
        skillsHtml += `
            <div class="skill-card relative flex flex-col justify-items-stretch border-2 border-gray-600/90 rounded-lg shadow-md bg-${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction}-bright">
                <!-- Header Banner -->
                <div class="relative text-gray-100 backdrop-blur-lg bg-black/60 rounded-lg rounded-b-none">
                    <div class="flex flex-col items-end mt-2 mx-2 rounded-lg bg-black/65">
                        <!-- Synergy unlock, then level + upgrade. This row is NOT
                             gated on the synergy reveal level: it now carries the
                             only way to spend skill points, and the synergy
                             control below already hides itself before then. -->
                        <div class="flex items-center gap-2 w-full p-2">
                            <div class="flex-grow text-sm">
                              <p class="text-gray-100 leading-relaxed">${skillShort}</p>
                            </div>
                            ${(()=>{
            // Per-skill synergy unlock: appears at the reveal
            // level, bought with skill points, then permanent
            if (!(0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)() || isReadOnly) return "";
            if ((0, $1b3f8df6e579f420$export$7d626adf944498ee)(skillKey)) return `<span class="px-2 py-1 rounded text-sm font-bold bg-amber-900/60 text-amber-300 border border-amber-700 whitespace-nowrap" title="Synergy variants can fire on this skill's events, and its equipped gear can partner teammates' events">\u{26A1} Synergies</span>`;
            const cfg = (0, $1b3f8df6e579f420$export$d09b0dfa38532c40)();
            const canUnlock = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints >= cfg.cost;
            return `<button class="synergies-btn min-w-auto px-2 py-1 rounded whitespace-nowrap transition-all duration-200 text-sm font-bold ${canUnlock ? "bg-blue-600 hover:bg-blue-500 text-white hover:shadow-lg border border-blue-400" : "bg-white/10 text-gray-400 cursor-not-allowed border border-gray-700"}" onclick="unlockSkillSynergy('${skillKey}')" ${!canUnlock ? "disabled" : ""} title="Unlock synergy variants for this skill's events and let its gear partner teammates' events">
                                  \u{1F513} Synergies (${cfg.cost} pts)
                              </button>`;
        })()}
                            <div class="flex flex-shrink-0">
                                <div class="bg-amber-500 text-black px-2 py-1 rounded-l-md text-sm font-bold inline-block border border-amber-500">Lv.${level}</div>
                                <button class="skill-upgrade-btn min-w-auto px-2 py-1 rounded-r-md transition-all duration-200 text-sm font-bold ${canAfford ? "bg-blue-600 hover:bg-blue-500 text-white hover:shadow-lg border border-blue-400" : "bg-white/10 text-black cursor-not-allowed border border-gray-700"}" onclick="upgradeSkill('${skillKey}')" ${!canAfford ? "disabled" : ""}>
                                    ${isReadOnly ? "\uD83D\uDEAB" : `\u{25B2} ${skillPointCost}pt${skillPointCost > 1 ? "s" : ""}`}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card Content -->
                <div class="relative flex-grow text-[0.9rem] p-2 bg-black/60 backdrop-blur-[2px] border-b rounded-b-lg border-transparent">
                    <!-- No fixed height: the h-12 that used to level card tops
                         across a grid row costs two blank lines now that one
                         card renders at full width. -->

                    <!-- Skill Techniques Tabs -->
                    ${(()=>{
            const factionTechniques = $ce6dd72bc4611534$export$aafe7b77259ba40d[(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction] || [];
            const techniques = factionTechniques.filter((t)=>t.skill === skillKey);
            if (techniques.length === 0) return "";
            const tabId = `techniques-${skillKey}`;
            // Get the saved tab selection for this skill, default to 0
            const selectedTabIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.techniqueTabSelections ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.techniqueTabSelections[tabId] ?? 0 : 0;
            // Tab buttons (icons)
            const tabButtons = techniques.map((t, idx)=>`<button
                                class="flex-1 technique-tab px-2 py-[2px] rounded-lg rounded-bl-none rounded-br-none text-lg transition-colors ${idx === selectedTabIndex ? "bg-black/65" : "bg-gray-500/60 hover:bg-gray-900/60"}"
                                onclick="window.switchTechniqueTab('${tabId}', ${idx})"
                                data-tab-group="${tabId}"
                                data-tab-index="${idx}"
                                title="${t.name}">
                                ${t.icon}
                            </button>`).join("");
            // Tab content panels
            const tabPanels = techniques.map((t, idx)=>{
                // Progressive disclosure: synergies are invisible
                // below the reveal level, a locked teaser until the
                // skill's unlock is bought, then fully detailed.
                // Each synergy is unlocked by one specific cross-faction
                // device: the partner technique (from this technique's
                // event variants) whose skill matches the synergy target.
                // One synergy per column (gear management lives on the
                // Gear tab now, so the old gear column is gone).
                let synergyBlocks = [
                    "",
                    ""
                ];
                if ((0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)() && !(0, $1b3f8df6e579f420$export$7d626adf944498ee)(skillKey)) synergyBlocks[0] = `<div class="text-gray-400 text-sm leading-tight mt-1" title="Synergy variants: teammates' cross-faction gear upgrades this skill's events for bonus salvage">\u{1F512} Synergies \u{2014} unlock on the skill card above (${(0, $1b3f8df6e579f420$export$d09b0dfa38532c40)().cost} pts)</div>`;
                else if ((0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)() && (0, $1b3f8df6e579f420$export$7d626adf944498ee)(skillKey)) {
                    const allDevices = [
                        ...$ce6dd72bc4611534$export$71b953a5ed5f0cd6,
                        ...$ce6dd72bc4611534$export$76261a034023b29,
                        ...$ce6dd72bc4611534$export$7a39b013515e9c7d
                    ];
                    const partnerTechniques = [
                        ...(0, $b596e64ef926739f$export$fe6715e7f54582df)(t.id)
                    ];
                    synergyBlocks = t.synergies.map((s, idex)=>{
                        const partnerTech = partnerTechniques.find((p)=>(0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(p) === s.targetSkill);
                        const device = partnerTech ? allDevices.find((d)=>d.techniqueId === partnerTech) : null;
                        const gearLine = device ? `<div class="text-[11.5px] text-amber-300/90 leading-tight mb-3" title="A teammate with this equipped unlocks the synergy variant (bonus salvage)">${device.icon || "\u2699\uFE0F"} ${device.name}</div>` : '';
                        return `<div class="text-blue-300 leading-tight mb-1 font-bold">
                                    <span>${$ce6dd72bc4611534$export$aeeef991191508e2[s.targetFaction].name} Synergy</span> - 
                                    <span class="text-green-400">${$ce6dd72bc4611534$export$aeeef991191508e2[s.targetFaction].skills[s.targetSkill].name}</span>
                                </div>
                                <div class="text-sm/4 ${device ? 'mb-1' : 'mb-3'}">${s.effect}</div>
                                ${gearLine}`;
                    });
                }
                return `
                                <div class="technique-panel ${idx === selectedTabIndex ? "" : "hidden"}" data-tab-group="${tabId}" data-panel-index="${idx}">
                                    <div class="text-base font-bold text-gray-200 mb-1 leading-tight p-1 px-2 bg-black/50">Tech: ${t.name}</div>
                                    <div class="">
                                        <div class="text-gray-200 my-3 leading-tight px-2">${t.description}</div>
                                        <div class="flex ${(0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)() ? '' : 'hidden'}">
                                            <div class="flex-1 text-gray-200 p-1 px-2">${synergyBlocks[0] || ""}</div>
                                            <div class="flex-1 text-gray-200 p-1 border-l border-gray-600 px-2">${synergyBlocks[1] || ""}</div>
                                        </div>
                                    </div>
                                </div>
                            `;
            }).join("");
            return `
                            <div>
                                <div class="flex gap-1">
                                    ${tabButtons}
                                </div>
                                <div class="technique-content rounded-lg rounded-t-none overflow-y-auto overflow-x-hidden bg-black/30">
                                    ${tabPanels}
                                </div>
                            </div>
                        `;
        })()}
                </div>
            </div>
        `;
    });
    const hasRaid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId == (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.id;
    // A raid actively running (not merely planned) locks name/avatar edits.
    const raidRunning = !!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress;
    const xpToNext = (0, $1b3f8df6e579f420$export$ae545994cbde97ee)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level);
    const xpPercentage = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.xp / xpToNext * 100;
    const overlayBg = "bg-black bg-opacity-70";
    const overlayBorder = "border-gray-500";
    const overlayText = "text-gray-400";
    // Get level-based card colors
    const levelColors = $7df15cefc09eac1b$export$fc83223e1b29d2d5((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level || 1);
    // Equipped-loadout badge counts (mirror the HP badge on the opposite corner)
    const equippedGearCount = Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedTechniqueGear || {}).filter(Boolean).length;
    const equippedArtifactCount = Object.values((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts || {}).filter(Boolean).length;
    // The 2-column shell + sub-tab bar are static in index.html; render the
    // left card column and the Skills pane into their mounts (Inventory/Gear
    // panes are static and toggled by the sub-tabs).
    if ($7df15cefc09eac1b$var$characterCardCollapsed) {
        // The drawer has no portrait to animate, and nothing else will arrive to
        // displace the running loop — stop it explicitly.
        (0, $1c3a690255c51224$export$b3f1d493f405542a)();
        document.getElementById("char-card-mount").innerHTML = $7df15cefc09eac1b$var$renderCharacterDrawer({
            faction: faction,
            levelColors: levelColors,
            isReadOnly: isReadOnly,
            hasRaid: hasRaid
        });
    } else // The full card's template keeps its original indentation rather than being
    // shifted one level in — re-flowing 150 untouched lines to satisfy the new
    // brace would bury this change in the diff and blame.
    document.getElementById("char-card-mount").innerHTML = `
                <div class="character-avatar-section">
                    <div class="relative bg-gradient-to-b ${levelColors.cardBg} border-4 ${levelColors.cardBorder} rounded-xl shadow-lg ${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `h-[480px]` : `h-[450px]`} w-60 overflow-hidden">
                        <!-- Card Border Frame -->
                        <div class="absolute inset-1 border-2 ${levelColors.frameBorder} rounded-lg"></div>

                        <!-- Header Banner -->
                        <div class="relative ${isReadOnly ? "bg-gradient-to-r from-yellow-600 to-orange-600 border-b-2 border-transparent" : `bg-gradient-to-r ${levelColors.headerBg} border-b-2 ${levelColors.headerBorder}`} text-gray-100 px-1 py-1 text-left h-8 flex items-center justify-between">
                            <div class="flex items-center gap-1 min-w-0">
                                <button id="toggle-character-card-btn" onclick="toggleCharacterCard()"
                                    title="Collapse to a drawer" aria-expanded="true"
                                    class="w-12 h-6 flex items-center justify-center rounded bg-black/40 border border-gray-600 text-gray-300 hover:text-white hover:border-gray-400 text-sm leading-none">\u{25C2}</button>
                                <span class="text-s font-bold text-black truncate">${isReadOnly ? "On Marketplace" : ""}</span>
                            </div>
                            <div class="bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="${faction.name}">${faction.icon || "\uD83C\uDFE2"}</div>
                        </div>

                        <!-- Card Content -->
                        <div class="relative p-3 bg-gradient-to-b ${levelColors.cardBg}" style="height: calc(100% - 33px);">
                            <!-- Title Section with Rename Button -->
                            <div class="h-4 flex items-center">
                                <h4 class="font-bold text-white text-base leading-tight">
                                    ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name}
                                </h4>
                                ${!isReadOnly ? `
                                <button id="rename-character-btn" class="px-1 transition-colors text-sm ${raidRunning ? "text-gray-500 opacity-40 cursor-not-allowed" : "text-purple-300 hover:text-purple-100 cursor-pointer"}" title="${raidRunning ? "Can't edit during a raid" : "Edit Character"}" ${raidRunning ? "disabled" : ""}>
                                    \u{270F}\u{FE0F}
                                </button>
                                ` : ""}
                            </div>

                            <div class="h-4 mb-2">
                                <h3 class="font-italic text-gray-400 text-xs leading-tight">
                                    ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title : ""}
                                </h3>
                            </div>

                            <!-- Avatar Area -->
                            <div class="relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg h-[200px] w-full mb-3 overflow-hidden group cursor-pointer">
                                <!-- Avatar -->
                                <div class="absolute inset-0 flex items-center justify-center">
                                    <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" data-avatar-main="1" ${(0, $42b272c2c0f44bdf$export$f06085c61225102a)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character)}></div>
                                </div>
                                <!-- Change Avatar Button -->
                                ${!isReadOnly ? `
                                <button id="change-avatar-btn" class="absolute top-1 right-1 p-1 rounded text-xs transition-all duration-200 ${raidRunning ? "bg-black bg-opacity-40 text-gray-400 cursor-not-allowed" : "bg-black bg-opacity-70 hover:bg-opacity-90 hover:scale-110 text-white"}" title="${raidRunning ? "Can't edit during a raid" : "Edit avatar"}" ${raidRunning ? "disabled" : ""}>
                                    \u{270F}\u{FE0F}
                                </button>
                                ` : ""}
                                <!-- HP Status (like contractor cards) -->
                                <div class="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700">
                                    \u{2764}\u{FE0F}${Math.floor((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.currentHp)}
                                </div>

                                <!-- Equipped loadout badges (opposite the HP badge): skill gear then artifacts -->
                                <div class="absolute bottom-1 right-1 flex gap-1">
                                    <div class="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700" title="Equipped skill gear">\u{1F9F0}${equippedGearCount}</div>
                                    <div class="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700" title="Equipped artifacts">\u{1F52E}${equippedArtifactCount}</div>
                                </div>

                                <!-- Quote Overlay at Bottom (hidden by default, shown on hover) -->
                                <div class="${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote ? "" : "hidden"} absolute bottom-0 left-0 right-0 ${overlayBg} p-2 border-t ${overlayBorder} transform translate-y-full group-hover:translate-y-0 transition-transform duration-200 z-10">
                                    <p class="${overlayText} text-xs leading-tight">${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote : ""}</p>
                                </div>
                            </div>

                            <!-- Character Info Section (Level and XP only) -->
                            <div class="mt-2 text-xs space-y-3 mb-3 bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-2">
                                <div class="text-center space-y-3">
                                    <div class="text-blue-300 font-semibold text-base/4">Level ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level}</div>
                                    <div class="bg-gray-700 rounded-lg h-5 overflow-hidden relative">
                                        <div class="bg-gradient-to-r from-blue-500 to-blue-400 h-full transition-all duration-300" style="width: ${xpPercentage}%;"></div>
                                        <div class="absolute inset-0 flex items-center justify-center text-white text-xs font-semibold">
                                            ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.xp}/${xpToNext}
                                        </div>
                                    </div>
                                    <div class="text-xs text-gray-400 text-center" title="What the next level-up grants">
                                        Next Lvl: <span class="text-game-success font-semibold">+${(()=>{
        const cfg = $ce6dd72bc4611534$export$9f9786ac427715c7.skillPointsPerLevel;
        const nextLevel = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level + 1;
        return cfg.base + Math.floor(nextLevel / cfg.levelDivisor) * cfg.increment;
    })()} SP</span> \xb7 <span class="text-red-300 font-semibold tracking-tighter">+${(0, $1b3f8df6e579f420$export$d48d36379ada8c46)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level + 1)} HP</span>
                                    </div>
                                    ${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `<div class="text-xs font-semibold" style="color:#b18cff" title="Command Marks if promoted now">\u{1F396}\u{FE0F} Command value: ${(0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character).total}</div>` : ""}
                                </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="mt-2 flex justify-between">
                                <button id="delete-character-btn" class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold transition-all duration-200 ${isReadOnly ? "opacity-50 cursor-not-allowed" : ""}" title="${isReadOnly ? "Cannot delete - character on marketplace" : "Delete Character"}" ${isReadOnly ? "disabled" : ""}>
                                    \u{1F5D1}\u{FE0F}
                                </button>
                                ${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `<button id="promote-character-btn" onclick="openPromoteModal()" class="px-2 py-1 rounded text-xs font-bold transition-all duration-200 hover:shadow-lg" style="border:1.5px solid #6d4fa3; background: #6d4fa3; color:#b18cff;" title="Promote to Command">
                                    \u{1F396}\u{FE0F}
                                </button>` : ""}
                                <button id="contract-out-btn" ${hasRaid ? "disabled" : ""} class="${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace ? "bg-orange-600 hover:bg-orange-700" : "bg-yellow-600 hover:bg-yellow-700"} text-white px-2 py-1 rounded text-xs font-bold transition-all duration-200" title="${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace ? "Withdraw from Marketplace" : "Contract Out to Marketplace"}">
                                    ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace ? "\uD83D\uDCE4" : "\uD83D\uDCBC"}
                                </button>
                            </div>

                        </div>
                    </div>

                    <!-- Equipment Section (Under Character Card) -->
                    <div class="character-equipment-section bg-white/5 border-4 border-gray-600 hidden">
                        <div class="equipment-slots flex flex-col gap-4">
                            <!-- Skill Enhancement Slot -->
                            <div class="equipment-slot-wrapper flex flex-col items-center">
                                ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts.skillSlot ? (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts.skillSlot) : '<div class="empty-slot bg-amber-800/20 border-2 border-dashed border-amber-600 rounded-xl h-[180px] w-[160px] flex items-center justify-center text-gray-400 text-sm text-center">No skill artifact equipped</div>'}
                            </div>

                            <!-- Utility Enhancement Slot -->
                            <div class="equipment-slot-wrapper flex flex-col items-center">
                                ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts.utilitySlot ? (0, $b7695fceb608271e$export$4ac7f915da1fa1c4)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.equippedArtifacts.utilitySlot) : '<div class="empty-slot bg-amber-800/20 border-2 border-dashed border-amber-600 rounded-xl h-[180px] w-[160px] flex items-center justify-center text-gray-400 text-sm text-center">No utility artifact equipped</div>'}
                            </div>
                        </div>
                    </div>
                </div>
        `;
    document.getElementById("char-skills-pane").innerHTML = `
                <div class="min-h-[415px] bg-white/5 border-4 border-white/20 rounded-lg rounded-tl-none p-2">
                    <div class="flex items-start">
                        <div class="text-lg font-semibold text-white mr-2 flex-grow">Faction Skills: ${faction.name} ${faction.icon}</div>
                        <div class="bg-amber-500 text-black text-sm px-3 py-1 rounded font-bold place-content-end">
                            ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skillPoints} Points Available
                        </div>
                    </div>
                    
                    <div class="text-gray-300 text-sm mt-2">${faction.description}</div>
                    ${faction.doctrine ? `<div class="text-gray-400 text-sm italic mt-1 hidden">${faction.doctrine}</div>` : ""}

                    <div class="skills-container mt-2">
                        ${(0, $570f21042242dd0a$export$313de1df173ff894)($7df15cefc09eac1b$var$SKILL_TAB_GROUP, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction)}
                        <div id="skills-grid" class="pr-4">
                            ${skillsHtml}
                        </div>
                    </div>
                </div>

        <div id="avatar-selector" class="modal hidden">
            <div class="modal-content max-w-4xl w-full max-h-[80vh] flex flex-col">
                <div class="modal-header">
                    <h3 class="modal-title">Choose Your Avatar</h3>
                    <button id="close-avatar-selector" class="close-btn">&times;</button>
                </div>
                <div class="avatar-tabs">
                    <button class="avatar-tab active" data-avatar-tab="gallery">Gallery</button>
                    <button class="avatar-tab" data-avatar-tab="custom">Custom</button>
                </div>
                <div class="modal-body flex-1 overflow-hidden flex flex-col">
                    <div id="avatar-pane-gallery" class="avatar-pane active">
                        <div class="avatar-gallery-toolbar">
                            <button id="avatar-gallery-refresh" class="ac-btn ac-btn-inline">\u{1F3B2} New Set</button>
                        </div>
                        <div id="avatar-gallery-grid" class="avatar-modal-grid grid grid-cols-6 gap-1 p-2">
                            ${$7df15cefc09eac1b$export$aee20503c4a7fb32()}
                        </div>
                    </div>
                    <div id="avatar-pane-custom" class="avatar-pane avatar-creator">
                        <div class="ac-preview">
                            <canvas id="avatar-creator-canvas" width="64" height="64"></canvas>
                            <button id="avatar-creator-random" class="ac-btn">\u{1F3B2} Randomize</button>
                            <button id="avatar-creator-apply" class="ac-btn ac-btn-primary">\u{2714} Use Avatar</button>
                        </div>
                        <div id="avatar-creator-controls" class="ac-controls"></div>
                    </div>
                </div>
            </div>
        </div>
    `;
    // Show the active sub-tab pane (Skills / Inventory / Gear) after re-render
    $7df15cefc09eac1b$export$c5004add704e7ef5();
    // Add event listeners for avatar selection
    $7df15cefc09eac1b$export$a2a7c3306a075a0b();
    $7df15cefc09eac1b$export$c83a71e532b8348d();
    // Add event listener for craft artifacts button
    const craftBtn = document.getElementById("craft-artifacts-btn");
    if (craftBtn) craftBtn.addEventListener("click", (0, $52d4eb0e19aef542$export$bdea6cc9473d0c95));
    // Add event listener for delete character button
    const deleteBtn = document.getElementById("delete-character-btn");
    if (deleteBtn) deleteBtn.addEventListener("click", $7df15cefc09eac1b$export$dfde25eb05d7b32e);
    // Add event listener for contract out button
    const contractOutBtn = document.getElementById("contract-out-btn");
    if (contractOutBtn) contractOutBtn.addEventListener("click", ()=>{
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("No active character selected", "error");
            return;
        }
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace) {
            // Withdraw from marketplace
            $7df15cefc09eac1b$export$100975602c9e0e5c((0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
            return;
        }
        // Cannot contract out character who owns an active raid
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Cannot contract out character who has an active raid", "error");
            return;
        }
        $7df15cefc09eac1b$export$f02502e440424b7();
    });
}
function $7df15cefc09eac1b$export$44472cbca86113a6() {
    const btn = document.getElementById("create-character");
    const nameInput = document.getElementById("character-name-create");
    const validationMessage = document.getElementById("name-validation-message");
    // Check if faction is selected
    const hasFaction = (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction;
    // Check if name is valid
    const hasValidName = nameInput && nameInput.value.trim().length >= 2;
    // Check if name validation passed (no error message showing)
    const nameValidationPassed = validationMessage && (validationMessage.classList.contains("hidden") || validationMessage.classList.contains("text-game-success"));
    btn.disabled = !hasFaction || !hasValidName || !nameValidationPassed;
}
function $7df15cefc09eac1b$export$c05f4d64df5567a5(characterData) {
    // Generate unique character ID
    const characterId = `char_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const newCharacter = {
        id: characterId,
        name: characterData.name,
        faction: characterData.faction,
        skills: characterData.skills || {},
        skillPoints: characterData.skillPoints || 3,
        maxHp: characterData.maxHp || 100,
        currentHp: characterData.currentHp || 100,
        level: characterData.level || 1,
        xp: characterData.xp || 0,
        avatar: characterData.avatar,
        avatarSeed: characterData.avatarSeed || characterId,
        title: characterData.title || null,
        quote: characterData.quote || null,
        multiplayerId: characterData.multiplayerId || null,
        ownerToken: characterData.ownerToken || null,
        createdAt: Date.now(),
        isMarketplace: false,
        marketplaceData: null,
        inventory: {},
        artifacts: [],
        equippedArtifacts: {
            skillSlot: null,
            utilitySlot: null
        },
        equippedTechniqueGear: {},
        techniqueTabSelections: {},
        lifetime: {
            t3Wins: 0,
            artifactsCrafted: 0,
            artifactsUnlocked: 0
        }
    };
    // Command layer perks for the new recruit
    const startLevel = (0, $bde36de43872f734$export$59fca837549bbada)("officer-academy", 0);
    if (startLevel > 1) {
        (0, $1b3f8df6e579f420$export$8ae8375981be11e0)(newCharacter, startLevel);
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F3DB}\u{FE0F} Officer Academy: ${newCharacter.name} starts at level ${newCharacter.level}`, "success");
    }
    const conditioning = (0, $bde36de43872f734$export$59fca837549bbada)("field-conditioning", 0);
    if (conditioning > 0) {
        newCharacter.maxHp += conditioning;
        newCharacter.currentHp += conditioning;
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1FA7A} Field Conditioning: ${newCharacter.name} starts with +${conditioning} max HP`, "success");
    }
    const vaultGranted = (0, $bde36de43872f734$export$b80ce5f774104e94)(newCharacter);
    const vaultKinds = Object.keys(vaultGranted).length;
    if (vaultKinds > 0) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F3E6} Guild Vault: ${vaultKinds} material type${vaultKinds === 1 ? "" : "s"} delivered from the last tour`, "success");
    // Add to characters array
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.push(newCharacter);
    // Always set newly created character as active
    $7df15cefc09eac1b$export$48d701fa895cfc6a(characterId);
    return newCharacter;
}
function $7df15cefc09eac1b$export$dfde25eb05d7b32e() {
    const confirmDelete = confirm("\u26A0\uFE0F DELETE CHARACTER \u26A0\uFE0F\n\nThis will permanently delete your character and reset ALL progress including:\n\u2022 Character level and skills\n\u2022 All inventory items and credits\n\u2022 Raid progress and contractors\n\u2022 Equipped artifacts and technique gear\n\nThis action CANNOT be undone!\n\nType 'DELETE' to confirm:");
    if (confirmDelete) {
        const finalConfirm = prompt("Type 'DELETE' to permanently delete your character:");
        if (finalConfirm === "DELETE") $7df15cefc09eac1b$export$47ba525aee3af84();
        else (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Character deletion cancelled", "info");
    }
}
async function $7df15cefc09eac1b$export$47ba525aee3af84(characterId = (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === characterId);
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    // Cannot delete character who owns an active raid
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId === characterId && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid != null || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot delete ${character.name} - they have an active raid in progress`, "error");
        return false;
    }
    // Remove from marketplace first if needed
    if (character.isMarketplace) $7df15cefc09eac1b$export$62a9da74d0d7be4c(characterId);
    // Remove from multiplayer if applicable
    if (character.multiplayerId) (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).deleteOwnCharacter(character.multiplayerId);
    // Remove from characters array
    const index = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.findIndex((c)=>c.id === characterId);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Deleting character:", characterId, character.name, index);
    if (index !== -1) (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.splice(index, 1);
    // Clear all character-related game state
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = null;
    // Credits are shared between all characters - don't reset.
    // The contractor POOL is account-level too (NPCs with negative ids, shared by
    // every character), so deleting one character must not wipe it. It used to,
    // which left the account unable to hire for the rest of the session — and made
    // Foreman's Ledger report "No suitable contractors available for this route",
    // reading as a broken upgrade rather than an empty pool. It only looked benign
    // because a reload regenerates the pool.
    // The hired/reserved lists ARE raid-scoped and do belong to the deleted
    // character's run, so those are still cleared.
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    // Clear any active raids
    /*
    gameState.currentRaid.raidInProgress = null;
    gameState.currentRaid.raidCompleted = false;
    gameState.currentRaid.currentRaidGrid = null;
    gameState.currentRaid.selectedPath = [];
    gameState.currentRaid.selectedRegion = null;
    gameState.currentRaid.selectedTier = null;
    gameState.currentRaid.raidOwnerId = null;
    gameState.currentRaid.completedRaidInfo = null;
    */ // Reset energy
    //gameState.energy = 100;
    //gameState.maxEnergy = 100;
    // Refresh Alpine store since we cleared inventory and artifacts
    if (window.refreshAlpineInventory) window.refreshAlpineInventory();
    // Save the reset state
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    // Hide any active raid interface
    document.getElementById("raid-grid-section").classList.add("hidden");
    document.getElementById("raid-team").classList.add("hidden");
    document.getElementById("raid-setup").classList.remove("hidden");
    document.getElementById("raid-active").classList.add("hidden");
    // Reset UI
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    $7df15cefc09eac1b$export$35bc0bfc04b8de17();
    // Update tab visibility
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    // If this was the active character, switch to another one
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId === characterId) {
        const availableChars = $7df15cefc09eac1b$export$c0bcfd3a15876767();
        if (availableChars.length > 0) $7df15cefc09eac1b$export$48d701fa895cfc6a(availableChars[0].id);
        else {
            // Show character creator
            document.getElementById("character-creator").classList.remove("hidden");
            document.getElementById("character-display").classList.add("hidden");
            $7df15cefc09eac1b$export$6d94845491c8110f();
        }
    }
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDD25 Character deleted!", "success");
    return true;
}
function $7df15cefc09eac1b$export$6d5555e9c1c275b6() {
    const availableChars = $7df15cefc09eac1b$export$c0bcfd3a15876767();
    if (availableChars.length > 0) $7df15cefc09eac1b$export$48d701fa895cfc6a(availableChars[0].id);
    else {
        document.getElementById("character-creator").classList.remove("hidden");
        document.getElementById("character-display").classList.add("hidden");
        $7df15cefc09eac1b$export$6d94845491c8110f();
        (0, $f3f2c7a1b1934e01$export$ac9b2c0e374abc75)();
    }
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    // Land the player on the character tab (creator or roster)
    const characterTabBtn = document.querySelector('[data-tab="character"]');
    if (characterTabBtn && !characterTabBtn.classList.contains("active")) characterTabBtn.click();
}
if (typeof window !== "undefined") window.showCharacterScreenAfterPromotion = $7df15cefc09eac1b$export$6d5555e9c1c275b6;
function $7df15cefc09eac1b$export$6d94845491c8110f() {
    // Clear character name input
    const nameInput = document.getElementById("character-name-create");
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Resetting character creation form, name input:", nameInput);
    if (nameInput) nameInput.value = "";
    // Clear validation message
    const validationMessage = document.getElementById("name-validation-message");
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Resetting character creation validation message:", validationMessage);
    if (validationMessage) {
        validationMessage.textContent = "";
        validationMessage.className = "mt-2 text-sm";
    }
    // Reset selected faction
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = null;
    // Remove selected class from all faction cards
    document.querySelectorAll(".faction-card").forEach((card)=>{
        card.classList.remove("selected");
        card.classList.add("border-gray-600");
    });
    // Clear skills display
    const skillsSection = document.getElementById("skills-section");
    if (skillsSection) skillsSection.innerHTML = "";
    // Reset header background
    (0, $f3f2c7a1b1934e01$export$ffc032d1101a5382)(null);
    // Update faction availability based on existing characters
    (0, $f3f2c7a1b1934e01$export$ac9b2c0e374abc75)();
    // Update create button state
    $7df15cefc09eac1b$export$44472cbca86113a6();
}
function $7df15cefc09eac1b$export$48d701fa895cfc6a(characterId) {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === characterId);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Switching to character:", characterId, character);
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "checking raid status:", (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted);
    // Check if there's an active raid that belongs to a different character
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId !== characterId && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted)) {
        const raidOwner = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId);
        const ownerName = raidOwner ? raidOwner.name : "another character";
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot switch characters during ${ownerName}'s active raid`, "error");
        return false;
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "saving current character state if needed");
    // Save current character state if switching from another character
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.id !== characterId) {
        const currentCharIndex = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.findIndex((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.id);
        if (currentCharIndex !== -1) (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters[currentCharIndex] = {
            ...(0, $f27982cef7035d22$export$8e361a1ffbebf172).character
        };
    }
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction) document.body.classList.remove((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "switching to new character state");
    // Switch to new character - ensure inventory exists
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character = {
        ...character,
        inventory: character.inventory || {},
        artifacts: character.artifacts || [],
        equippedArtifacts: character.equippedArtifacts || {
            skillSlot: null,
            utilitySlot: null
        },
        equippedTechniqueGear: character.equippedTechniqueGear || {},
        techniqueTabSelections: character.techniqueTabSelections || {},
        isAlive: character.isAlive == null ? true : character.isAlive,
        injuries: character.injuries || []
    };
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId = characterId;
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Updating UI for new character");
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction) document.body.classList.add((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
    // Update UI first
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    $7df15cefc09eac1b$export$2eced2100c12c50d();
    // Update tab visibility based on raid ownership
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    // Refresh Alpine inventory store to reflect character-specific inventory after UI update
    setTimeout(()=>{
        (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    }, 100);
    // Update inventory header with character name
    (0, $b7695fceb608271e$export$d2567add70135c10)();
    // Save the game state to persist the character switch
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    //addNotification(`Switched to ${character.name}`, 'success');
    return true;
}
function $7df15cefc09eac1b$export$c0bcfd3a15876767() {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.filter((c)=>!c.isMarketplace);
}
function $7df15cefc09eac1b$export$134d34ec75ad4a97() {
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.filter((c)=>c.isMarketplace);
}
function $7df15cefc09eac1b$export$2a6225ba23811f91(characterId, durationHours = 24, rewardPercentage = 15) {
    // If this is the active character, use gameState.character, otherwise lookup by characterId
    const character = characterId === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character : (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === characterId);
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    // Register with multiplayer marketplace if character has multiplayerId
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Listing character on marketplace:", character.name, character.multiplayerId, typeof (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70));
    if (character.multiplayerId && typeof (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70) !== "undefined") (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).listCharacterOnMarketplace(character.multiplayerId, durationHours, rewardPercentage).then(()=>{
        // Mark character as on marketplace
        character.isMarketplace = true;
        character.rewardPercentage = rewardPercentage;
        character.marketplaceData = {
            listedAt: Date.now(),
            expiresAt: Date.now() + durationHours * 3600000,
            durationHours: durationHours,
            rewardPercentage: rewardPercentage
        };
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${character.name} is now available for hire on the marketplace`, "success");
        $7df15cefc09eac1b$export$2eced2100c12c50d(); // Refresh character display
    }).catch((error)=>{
        console.error("Failed to list character on marketplace:", error);
        // Revert local changes if multiplayer fails
        character.isMarketplace = false;
        character.marketplaceData = null;
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Failed to list character on marketplace", "error");
    });
    else (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${character.name} is cannot be listed for hire on the marketplace`, "error");
    return true;
}
function $7df15cefc09eac1b$export$f02502e440424b7() {
    const modal = document.createElement("div");
    modal.className = "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50";
    modal.innerHTML = `
        <div class="bg-gray-800 border border-gray-600 rounded-lg p-6 max-w-md w-full mx-4">
            <h3 class="text-xl font-bold text-game-accent mb-4">\u{1F4BC} Contract Out Character</h3>
            <p class="text-gray-300 mb-4">
                Contract out <span class="text-white font-bold">${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name}</span> to the marketplace?
                They will be available for other players to hire as contractors.
            </p>
            <div class="mb-4">
                <label class="block text-sm font-bold text-gray-300 mb-2">Duration:</label>
                <select id="contract-duration" class="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white">
                    <option value="4">4 hours</option>
                    <option value="8">8 hours</option>
                    <option value="12">12 hours</option>
                    <option value="24" selected>24 hours</option>
                </select>
                <p class="text-xs text-gray-400 mt-1">Contracts are for long absences \u{2014} even un-hired, a completed contract pays out.</p>
            </div>
            <div class="mb-4">
                <label class="block text-sm font-bold text-gray-300 mb-2">Reward Percentage:</label>
                <div class="flex items-center space-x-2">
                    <input id="contract-percentage" type="number" min="10" max="20" value="15" class="w-20 px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-center">
                    <span class="text-gray-300">% of raid rewards</span>
                </div>
                <p class="text-xs text-gray-400 mt-1">Set the percentage of raid earnings you'll receive (10-20%)</p>
            </div>
            <div class="flex space-x-3">
                <button id="confirm-contract-out" class="flex-1 bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded">
                    Contract Out
                </button>
                <button id="cancel-contract-out" class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">
                    Cancel
                </button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    document.getElementById("confirm-contract-out").addEventListener("click", ()=>{
        const duration = parseInt(document.getElementById("contract-duration").value);
        const percentage = parseInt(document.getElementById("contract-percentage").value);
        // Validate percentage range
        if (percentage < 10 || percentage > 20) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Reward percentage must be between 10% and 20%", "error");
            return;
        }
        if ($7df15cefc09eac1b$export$2a6225ba23811f91((0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId, duration, percentage)) $7df15cefc09eac1b$export$d87722dc17dc5f68();
        document.body.removeChild(modal);
    });
    document.getElementById("cancel-contract-out").addEventListener("click", ()=>{
        document.body.removeChild(modal);
    });
}
async function $7df15cefc09eac1b$export$62a9da74d0d7be4c(characterId) {
    // Writes must go to the active character's live copy (see liveCharacter).
    const character = (0, $f27982cef7035d22$export$bda034a0354b67bb)((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === characterId));
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    // Remove from multiplayer marketplace if applicable
    if (character.multiplayerId && typeof (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70) !== "undefined") try {
        await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).removeCharacterFromMarketplace(character.multiplayerId);
        // Only update local state after successful server response
        character.isMarketplace = false;
        character.marketplaceData = null;
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${character.name} removed from marketplace`, "success");
        $7df15cefc09eac1b$export$2eced2100c12c50d(); // Refresh character display
        return true;
    } catch (error) {
        console.error("Failed to remove character from marketplace:", error);
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Failed to withdraw character from marketplace", "error");
        return false;
    }
    else {
        // For offline mode, update local state directly
        character.isMarketplace = false;
        character.marketplaceData = null;
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${character.name} removed from marketplace`, "success");
        $7df15cefc09eac1b$export$2eced2100c12c50d(); // Refresh character display
        return true;
    }
}
function $7df15cefc09eac1b$export$655e187f5421a72c({ title: title, bodyHtml: bodyHtml, confirmText: confirmText = "Confirm", cancelText: cancelText = "Cancel", confirmClass: confirmClass = "bg-yellow-600 hover:bg-yellow-700", onConfirm: onConfirm }) {
    const modal = document.createElement("div");
    modal.className = "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50";
    modal.innerHTML = `
        <div class="bg-gray-800 border border-gray-600 rounded-lg p-6 max-w-md w-full mx-4">
            <h3 class="text-xl font-bold text-game-accent mb-4">${title}</h3>
            <div class="text-gray-300 mb-4">${bodyHtml}</div>
            <div class="flex space-x-3">
                <button data-role="confirm" class="flex-1 ${confirmClass} text-white font-bold py-2 px-4 rounded">${confirmText}</button>
                <button data-role="cancel" class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">${cancelText}</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    const close = ()=>{
        if (modal.parentNode) modal.parentNode.removeChild(modal);
    };
    modal.querySelector('[data-role="confirm"]').addEventListener("click", ()=>{
        close();
        if (onConfirm) onConfirm();
    });
    modal.querySelector('[data-role="cancel"]').addEventListener("click", close);
}
async function $7df15cefc09eac1b$export$100975602c9e0e5c(characterId) {
    // Active-character-aware: its live marketplaceData lives on gameState.character.
    const character = (0, $f27982cef7035d22$export$bda034a0354b67bb)((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === characterId));
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    if (!character.isMarketplace) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Character is not on the marketplace", "error");
        return false;
    }
    // Local-only (offline) listing: nothing to settle server-side, just remove.
    if (!character.multiplayerId) {
        const ok = await $7df15cefc09eac1b$export$62a9da74d0d7be4c(characterId);
        if (ok) {
            $7df15cefc09eac1b$export$2eced2100c12c50d();
            $7df15cefc09eac1b$export$d87722dc17dc5f68();
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        }
        return ok;
    }
    // Server-listed contract: withdrawing settles it for the time actually listed,
    // so confirm first and show what that settlement is worth. The estimate uses
    // the same shared model the server settles with (raidEconomics-core), so the
    // preview and the payout agree. It assumes the character wasn't hired — if it
    // was, the real hire payment already covered it and the server pays nothing.
    const listedAt = character.marketplaceData?.listedAt;
    const elapsedHours = listedAt ? (Date.now() - listedAt) / 3600000 : 0;
    const estimate = (0, $cdca6b792cc3a32e$export$8859df5e0e511018)({
        level: character.level || 1,
        durationHours: elapsedHours,
        rewardPercentage: character.marketplaceData?.rewardPercentage || 15
    });
    const listedFor = `Listed for <span class="text-white font-bold">${elapsedHours.toFixed(1)}h</span>`;
    const bodyHtml = estimate.qualifies ? `<p class="mb-2">${listedFor}. Withdrawing <span class="text-white font-bold">${character.name}</span> now settles the contract early.</p>
       <div class="bg-gray-700/50 border border-gray-600 rounded p-3 mb-2">
         <div class="text-sm">Estimated settlement:</div>
         <div class="text-game-accent font-bold">\u{1F4B0} ~${estimate.credits} credits &nbsp; \u{2B50} ~${estimate.xp} XP</div>
         <div class="text-xs text-gray-400 mt-1 hidden">Based on ${estimate.simulatedRaids} simulated raid${estimate.simulatedRaids === 1 ? "" : "s"}.</div>
       </div>
       <p class="text-xs text-gray-400">Leaving the contract to run its full term would pay more.</p>` : `<p class="mb-2">${listedFor} \u{2014} under the <span class="text-white font-bold">~${(0, $cdca6b792cc3a32e$export$bc8ed87c3bd68f91)(character.level || 1).toFixed(1)}h</span> needed to earn a contract payout.</p>
       <p class="text-yellow-400">If ${character.name} wasn't hired, withdrawing now earns <span class="font-bold">nothing</span>.</p>
       <p class="text-xs text-gray-400 mt-2">Leaving the contract running pays out even if nobody hires them.</p>`;
    $7df15cefc09eac1b$export$655e187f5421a72c({
        title: estimate.qualifies ? "\uD83D\uDCBC Withdraw Contract Early?" : "\u26A0\uFE0F Withdraw Without Payout?",
        bodyHtml: bodyHtml,
        confirmText: estimate.qualifies ? "Withdraw" : "Withdraw Anyway",
        confirmClass: estimate.qualifies ? "bg-yellow-600 hover:bg-yellow-700" : "bg-red-600 hover:bg-red-700",
        onConfirm: ()=>{
            $7df15cefc09eac1b$var$performContractWithdrawal(character, characterId).catch((err)=>console.error("Failed to withdraw from marketplace:", err));
        }
    });
    return true;
}
// Settle + remove a server-listed contract. Split out of withdrawFromMarketplace
// so the confirm modal drives it.
async function $7df15cefc09eac1b$var$performContractWithdrawal(character, characterId) {
    // Settle the completion payout for time listed BEFORE removing the row (the
    // server claim needs the active listing to still exist). The server is
    // authoritative on the amount and pays nothing if the character was actually
    // hired or the elapsed time is too short. Best-effort — a settle error must
    // not block the withdrawal itself.
    let settled = null;
    try {
        settled = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).claimContractCompletion(character.multiplayerId);
    } catch (err) {
        console.error("Failed to settle contract on withdraw:", err);
    }
    const success = await $7df15cefc09eac1b$export$62a9da74d0d7be4c(characterId);
    if (success) {
        $7df15cefc09eac1b$export$2eced2100c12c50d();
        $7df15cefc09eac1b$export$d87722dc17dc5f68();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        // Collect the settlement payment through the shared pending-payment flow
        // (Contract Beacon bonus + "received credits" notification for free).
        if (settled?.claimed) (0, $f3f2c7a1b1934e01$export$da1e47bae24a69b8)().catch((err)=>console.error("Error checking payments:", err));
    }
    return success;
}
function $7df15cefc09eac1b$export$dc8b5d9ee1e9ba76() {
    const characterSkills = Object.keys((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills || {}).filter((skill)=>(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills[skill] > 0);
    const availableOptions = [];
    characterSkills.forEach((skill)=>{
        const flavorData = $ce6dd72bc4611534$export$9be8953559278e7[skill];
        if (flavorData) availableOptions.push({
            skill: skill,
            roles: flavorData.roles,
            quotes: flavorData.quotes
        });
    });
    return availableOptions;
}
function $7df15cefc09eac1b$export$86361bdd2819774e() {
    // Editing is locked while a raid is actively running (the button is also
    // disabled, but guard the action too - render timing isn't guaranteed).
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("Can't edit your character while a raid is in progress", "info");
        return;
    }
    const modal = document.getElementById("rename-character-modal");
    const nameInput = document.getElementById("character-name-input");
    const roleSelect = document.getElementById("character-role-select");
    const quoteSelect = document.getElementById("character-quote-select");
    if (modal && nameInput && roleSelect && quoteSelect) {
        // Set current name in input
        nameInput.value = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name || "";
        // Populate role and quote dropdowns
        const availableOptions = $7df15cefc09eac1b$export$dc8b5d9ee1e9ba76();
        // Build role options grouped by skill
        roleSelect.innerHTML = '<option value="">Select a role...</option>';
        const allRoles = new Map(); // Map role to skill for quote lookup
        availableOptions.forEach(({ skill: skill, roles: roles })=>{
            const skillData = $ce6dd72bc4611534$export$aeeef991191508e2[(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction].skills[skill];
            const skillName = skillData ? skillData.name : skill;
            roles.forEach((role)=>{
                const option = document.createElement("option");
                option.value = role;
                option.textContent = `${role} (${skillName})`;
                option.dataset.skill = skill;
                roleSelect.appendChild(option);
                allRoles.set(role, skill);
            });
        });
        // Set current role if exists
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title) roleSelect.value = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title;
        // Update quote dropdown when role changes
        const updateQuoteDropdown = ()=>{
            const selectedRole = roleSelect.value;
            quoteSelect.innerHTML = '<option value="">Select a quote...</option>';
            if (selectedRole) {
                const selectedSkill = allRoles.get(selectedRole);
                const skillData = availableOptions.find((opt)=>opt.skill === selectedSkill);
                if (skillData) skillData.quotes.forEach((quote)=>{
                    const option = document.createElement("option");
                    option.value = quote;
                    option.textContent = quote;
                    quoteSelect.appendChild(option);
                });
            }
            // Set current quote if exists
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote) quoteSelect.value = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote;
        };
        // Initial quote population
        updateQuoteDropdown();
        // Update quotes when role changes
        roleSelect.addEventListener("change", updateQuoteDropdown);
        nameInput.focus();
        nameInput.select();
        modal.classList.remove("hidden");
        // Setup event listeners
        $7df15cefc09eac1b$export$c0f3eced6453ae5a();
    }
}
function $7df15cefc09eac1b$export$3898e14ebf764df5() {
    const modal = document.getElementById("rename-character-modal");
    if (modal) modal.classList.add("hidden");
}
function $7df15cefc09eac1b$export$c0f3eced6453ae5a() {
    const modal = document.getElementById("rename-character-modal");
    const nameInput = document.getElementById("character-name-input");
    const confirmBtn = document.getElementById("confirm-rename-btn");
    const cancelBtn = document.getElementById("cancel-rename-btn");
    const closeBtn = document.getElementById("close-rename-modal");
    const validationMessage = document.getElementById("name-validation-message-modal");
    // Remove existing listeners to prevent duplicates
    const newConfirmBtn = confirmBtn.cloneNode(true);
    const newCancelBtn = cancelBtn.cloneNode(true);
    const newCloseBtn = closeBtn.cloneNode(true);
    confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
    cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
    closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
    // Real-time validation
    const debouncedValidate = (0, $42b272c2c0f44bdf$export$61fc7d43ac8f84b0)(async ()=>{
        const name = nameInput.value.trim();
        if (name && name !== (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name) {
            validationMessage.className = "text-sm mt-1 text-gray-400";
            validationMessage.textContent = "Checking name availability...";
        }
        const result = await (0, $f5272a3e1bbf7d7b$export$6ebef846cc736ea)(name, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name);
        validationMessage.className = `text-sm mt-1 ${result.className}`;
        validationMessage.textContent = result.message;
    }, 500);
    nameInput.addEventListener("input", debouncedValidate);
    // Add event listeners
    newConfirmBtn.addEventListener("click", $7df15cefc09eac1b$export$3160d5723a2241f3);
    newCancelBtn.addEventListener("click", $7df15cefc09eac1b$export$3898e14ebf764df5);
    newCloseBtn.addEventListener("click", $7df15cefc09eac1b$export$3898e14ebf764df5);
    // Handle Enter key
    nameInput.addEventListener("keypress", (e)=>{
        if (e.key === "Enter") $7df15cefc09eac1b$export$3160d5723a2241f3();
    });
    // Handle Escape key
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") {
            const modal = document.getElementById("rename-character-modal");
            if (modal && !modal.classList.contains("hidden")) {
                $7df15cefc09eac1b$export$3898e14ebf764df5();
                document.removeEventListener("keydown", handleEscapeKey);
            }
        }
    });
    // Close on background click (only if mousedown started on background)
    let mousedownTarget = null;
    modal.addEventListener("mousedown", (e)=>{
        mousedownTarget = e.target;
    });
    modal.addEventListener("click", (e)=>{
        if (e.target === modal && mousedownTarget === modal) $7df15cefc09eac1b$export$3898e14ebf764df5();
    });
}
async function $7df15cefc09eac1b$export$3160d5723a2241f3() {
    const nameInput = document.getElementById("character-name-input");
    const roleSelect = document.getElementById("character-role-select");
    const quoteSelect = document.getElementById("character-quote-select");
    const newName = nameInput.value.trim();
    const newRole = roleSelect.value || null;
    const newQuote = quoteSelect.value || null;
    // Check if anything changed
    const nameChanged = newName !== (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name;
    const roleChanged = newRole !== (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title;
    const quoteChanged = newQuote !== (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote;
    if (!nameChanged && !roleChanged && !quoteChanged) {
        $7df15cefc09eac1b$export$3898e14ebf764df5();
        return;
    }
    // Validate name if it changed
    if (nameChanged) {
        const validation = await (0, $f5272a3e1bbf7d7b$export$6ebef846cc736ea)(newName, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name);
        if (!validation.valid) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{274C} ${validation.message}`, "error");
            nameInput.focus();
            return;
        }
    }
    const oldName = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name;
    const oldRole = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title;
    const oldQuote = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote;
    // Update character data
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name = newName;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title = newRole;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote = newQuote;
    try {
        // Update in multiplayer system if character is registered
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.multiplayerId) await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).updateCharacter((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.multiplayerId, {
            name: newName,
            title: newRole,
            quote: newQuote
        });
        // Save the game state
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        // Update the display
        $7df15cefc09eac1b$export$2eced2100c12c50d();
        // Close modal
        $7df15cefc09eac1b$export$3898e14ebf764df5();
        // Show success notification
        const changes = [];
        if (nameChanged) changes.push("name");
        if (roleChanged) changes.push("role");
        if (quoteChanged) changes.push("quote");
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{2705} Character ${changes.join(", ")} updated`, "success");
    } catch (error) {
        // Rollback changes on error
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name = oldName;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.title = oldRole;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.quote = oldQuote;
        console.error("Failed to update character in multiplayer system:", error);
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u274C Failed to update character in multiplayer system", "error");
        nameInput.focus();
    }
}
function $7df15cefc09eac1b$export$c83a71e532b8348d() {
    // Setup rename button listener
    document.addEventListener("click", (e)=>{
        if (e.target && e.target.id === "rename-character-btn") $7df15cefc09eac1b$export$86361bdd2819774e();
    });
}
function $7df15cefc09eac1b$export$d87722dc17dc5f68() {
    const selectorContainer = document.getElementById("character-selector");
    if (!selectorContainer) return;
    selectorContainer.innerHTML = "";
    const maxCharacters = 3;
    let firstEmptySlot = true;
    // Display existing characters
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.forEach((char)=>{
        const isActive = (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId === char.id;
        const character = isActive ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character : char;
        const isMarketplace = character.isMarketplace;
        const hasRaid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId == char.id;
        const cardDiv = document.createElement("div");
        cardDiv.className = `character-selector-card min-w-64 max-w-80 min-h-16 p-2 py-1 rounded-tr-lg rounded-tl-lg transition-all border-2 border-b-0 ${isActive ? "border-transparent bg-white/[0.09]" : "border-transparent bg-gray-800/30"}`;
        const faction = $ce6dd72bc4611534$export$aeeef991191508e2[character.faction];
        const raidStatus = hasRaid ? `<div class="text-amber-400 text-sm font-bold">In Raid</div>` : "";
        let marketplaceStatus = "";
        if (isMarketplace && character.marketplaceData) {
            const timeLeftMs = Math.max(0, character.marketplaceData.expiresAt - Date.now());
            const hours = Math.floor(timeLeftMs / 3600000);
            const minutes = String(Math.ceil(timeLeftMs / 60000) - hours * 60).padStart(2, '0');
            marketplaceStatus = `<div class="text-sm hidden [@media(min-height:769px)]:inline-block"><span class="text-yellow-600 font-bold">\u{1F4BC} Marketplace</span> <span id="${char.id}_marketplace_time" class="text-gray-400 mr-2">${hours}:${minutes}</span></div>`;
        }
        const xpToNext = (0, $1b3f8df6e579f420$export$ae545994cbde97ee)(character.level || 1);
        const xpPercentage = (character.xp || 0) / xpToNext * 100;
        cardDiv.innerHTML = `
            <div class="flex items-start justify-between h-full">
                <div class="flex gap-2 flex-1 h-full">
                    <!-- Avatar with proper background container -->
                    <div class="${!isActive ? "opacity-40" : ""} relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg w-24 overflow-hidden group flex-shrink-0 h-24 hidden [@media(min-height:769px)]:block">
                        <div class="absolute inset-0 flex items-center justify-center">
                            <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" ${(0, $42b272c2c0f44bdf$export$f06085c61225102a)(character)}></div>
                        </div>
                        <div class="absolute left-1 top-1 bg-black bg-opacity-30 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-sm cursor-pointer" title="${faction.name}">${faction.icon || "\uD83C\uDFE2"}</div>
                        <!-- HP Status overlay -->
                        <div class="absolute bottom-0 left-0 bg-black bg-opacity-70 text-white p-[2px] rounded-tl text-xs m-[1px]">
                            \u{2764}\u{FE0F}${character.currentHp}
                        </div>
                    </div>
                    <div class="flex-grow relative pr-2 h-full">
                        <div class="flex items-center gap-2 pb-2 font-bold ${isActive ? "text-white" : "text-white/50"} nowrap">
                          <div class="bg-black bg-opacity-30 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-sm cursor-pointer block [@media(min-height:769px)]:hidden" title="${faction.name}">${faction.icon || "\uD83C\uDFE2"}</div>
                          ${character.name}
                          <div class="${isActive ? "text-blue-300" : "text-blue-300/50"} text-sm font-semibold nowrap block [@media(min-height:769px)]:hidden">Lv.${character.level || 1}</div>
                        </div>
                        <div class="${isActive ? "text-blue-300" : "text-blue-300/50"} text-sm font-semibold nowrap hidden [@media(min-height:769px)]:block">Level ${character.level || 1}</div>
                        <div class="hidden bg-gray-700 rounded-lg h-4 overflow-hidden relative w-full">
                            <div class="bg-gradient-to-r from-blue-500 to-blue-400 h-full transition-all duration-300" style="width: ${xpPercentage}%;"></div>
                            <div class="absolute inset-0 flex items-center justify-center text-white text-xs font-semibold">
                                ${character.xp || 0}/${xpToNext}
                            </div>
                        </div>
                        ${marketplaceStatus}
                        ${raidStatus}
                        <div class="absolute bottom-0 right-0 z-10">
                        ${isActive ? `
                            <div class="bg-amber-500 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold">
                                Active
                            </div>
                        ` : `
                            <button class="switch-character-btn text-black hover:text-gray text-xs px-3 py-1 rounded font-bold" data-character-id="${character.id}">
                                Switch
                            </button>
                        `}
                        </div>
                    </div>
                </div>
            </div>
        `;
        // Add switch button event listener
        if (!isActive) setTimeout(()=>{
            const switchBtn = cardDiv.querySelector(".switch-character-btn");
            if (switchBtn) switchBtn.addEventListener("click", ()=>{
                $7df15cefc09eac1b$export$48d701fa895cfc6a(character.id);
                $7df15cefc09eac1b$export$d87722dc17dc5f68();
            });
        }, 0);
        selectorContainer.appendChild(cardDiv);
    });
    // Add placeholder cards for empty slots
    const emptySlots = maxCharacters - (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.length;
    for(let i = 0; i < emptySlots; i++){
        const cardDiv = document.createElement("div");
        cardDiv.className = "character-selector-card min-w-64 max-w-80 p-2 border-2 border-b-0 border-dashed border-gray-600 bg-gray-800/30 rounded-t-lg";
        cardDiv.innerHTML = `
            <div class="flex items-end gap-3 h-full">
                <!-- Empty avatar placeholder -->
                <div class="relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 border-dashed rounded-lg h-24 w-24 overflow-hidden group flex-shrink-0 hidden [@media(min-height:769px)]:block">
                    <div class="absolute inset-0 flex items-center justify-center">
                        <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200"></div>
                    </div>
                </div>
                ${firstEmptySlot ? `
                    <div class="flex-grow flex flex-col items-end justify-end">
                        <button id="create-character-slot-btn" class="bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold">
                            Create Character
                        </button>
                    </div>
                ` : ""}
            </div>
        `;
        selectorContainer.appendChild(cardDiv);
        if (firstEmptySlot) {
            firstEmptySlot = false;
            // Add event listener to the button
            setTimeout(()=>{
                const createBtn = document.getElementById("create-character-slot-btn");
                if (createBtn) createBtn.addEventListener("click", ()=>{
                    document.getElementById("character-display").classList.add("hidden");
                    document.getElementById("character-creator").classList.remove("hidden");
                    const cancelBtn = document.getElementById("cancel-character-creation");
                    if (cancelBtn) cancelBtn.classList.remove("hidden");
                });
            }, 0);
        }
    }
}
function $7df15cefc09eac1b$export$b87cdb7b62197ecc() {
    // Create new character button
    const createNewCharBtn = document.getElementById("create-new-character-btn");
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Setting up create new character button:", createNewCharBtn);
    if (createNewCharBtn) createNewCharBtn.addEventListener("click", ()=>{
        // Reset character creation form (includes updateFactionAvailability)
        $7df15cefc09eac1b$export$6d94845491c8110f();
        // Show character creator
        document.getElementById("character-display").classList.add("hidden");
        document.getElementById("character-creator").classList.remove("hidden");
        // Show cancel button if there's an active character
        $7df15cefc09eac1b$export$3e71199c94c9c7bc();
    });
    // Cancel character creation button
    const cancelBtn = document.getElementById("cancel-character-creation");
    if (cancelBtn) cancelBtn.addEventListener("click", ()=>{
        // Return to character display
        document.getElementById("character-creator").classList.add("hidden");
        (0, $f3f2c7a1b1934e01$export$ffc032d1101a5382)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.faction);
        document.getElementById("character-display").classList.remove("hidden");
    });
}
function $7df15cefc09eac1b$export$3e71199c94c9c7bc() {
    const cancelBtn = document.getElementById("cancel-character-creation");
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "cancel button", cancelBtn);
    if (cancelBtn) {
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.length > 0) cancelBtn.classList.remove("hidden");
        else cancelBtn.classList.add("hidden");
    }
}













/**
 * Blackout Contracts UI (M3 S6) — the browser wrapper over blackout-core.js.
 *
 * Two surfaces, split the way the spec describes: contracts are ARMED from the
 * raid planner (L1), and the catalog of what has been earned lives on the
 * Syndicate screen (L3). That is the "layers reach into lower layers" rule from
 * LayerNavigation.md — an L3 feature putting a control on an L1 screen — and it
 * is why arming does not live on the Syndicate page where it would be three
 * navigations away from the raid it modifies.
 *
 * All rules live in blackout-core.js; this file renders and reports.
 */ 



const $944d26b39bc4cb46$var$NIGHT = '#8b7fd4';
const $944d26b39bc4cb46$var$NIGHT_DIM = '#4a4270';
const $944d26b39bc4cb46$var$BLOCKED_COPY = {
    'tier-too-low': (c)=>`Tier ${c.minTier}+`,
    'already-cleared': ()=>"\u2713 Cleared",
    'no-sanction': ()=>'Unlicensed'
};
function $944d26b39bc4cb46$export$c7f6a5a323f54379() {
    const container = document.getElementById('blackout-strip');
    if (!container) return;
    if (!(0, $45c49e7f6d2032d6$export$6030630ca4e35487)()) {
        container.classList.add('hidden');
        container.innerHTML = '';
        return;
    }
    container.classList.remove('hidden');
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.selectedTier || 0;
    const armed = (0, $45c49e7f6d2032d6$export$f266a4caac7fb67d)();
    // Arming is a SETUP decision — see setBlackoutContract, which refuses
    // mid-raid because the modifiers shape how the raid was assembled.
    const locked = !!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.raidInProgress;
    const cards = (0, $45c49e7f6d2032d6$export$6f07b662ae575a0e)().map((id)=>{
        const c = (0, $45c49e7f6d2032d6$export$913dd38406a903a1)(id);
        const reason = (0, $45c49e7f6d2032d6$export$f099249c2cd16830)(id, tier);
        const cleared = (0, $45c49e7f6d2032d6$export$e51189576207fce1)(id);
        const isArmed = armed?.id === id;
        const selectable = !reason && !locked;
        return `
            <button type="button" ${selectable ? `onclick="armBlackout('${isArmed ? '' : id}')"` : 'disabled'}
                class="text-left rounded-lg px-2 py-1.5 border-2 ${selectable ? '' : 'opacity-60 cursor-not-allowed'}"
                title="${c.description}${cleared ? " \u2014 already cleared" : ''}"
                style="border-color:${isArmed ? $944d26b39bc4cb46$var$NIGHT : $944d26b39bc4cb46$var$NIGHT_DIM}; background:${isArmed ? 'rgba(139,127,212,0.18)' : 'rgba(255,255,255,0.04)'}">
                <div class="flex items-baseline justify-between gap-2">
                    <span class="font-bold text-xs" style="color:${isArmed ? $944d26b39bc4cb46$var$NIGHT : '#c9c2ee'}">${c.icon} ${c.name}</span>
                    ${reason ? `<span class="text-[10px] ${cleared ? 'text-emerald-400' : 'text-gray-400'}">${$944d26b39bc4cb46$var$BLOCKED_COPY[reason]?.(c) || ''}</span>` : ''}
                </div>
                <div class="text-[10px] text-gray-400 leading-tight">${c.perk.label}</div>
            </button>`;
    }).join('');
    container.innerHTML = `
        <div class="rounded-lg p-2" style="background:rgba(139,127,212,0.07); border:2px solid ${$944d26b39bc4cb46$var$NIGHT_DIM};">
            <div class="flex items-baseline justify-between gap-2 mb-1.5">
                <div class="text-[11px] uppercase tracking-widest" style="color:${$944d26b39bc4cb46$var$NIGHT}">\u{1F311} Blackout Contract</div>
                <div class="text-xs text-gray-400">
                    ${armed ? `<span style="color:${$944d26b39bc4cb46$var$NIGHT}">${armed.icon} ${armed.name}</span> armed \u{2014} ${armed.description}` : 'Optional. Harder raid, one permanent perk. Click to arm.'}
                </div>
            </div>
            <div class="grid gap-1.5" style="grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));">${cards}</div>
        </div>`;
}
function $944d26b39bc4cb46$export$38182372ac9340fd(contractId) {
    const result = (0, $45c49e7f6d2032d6$export$d1bd52becfd6c270)(contractId || null);
    if (!result.ok) {
        const copy = {
            'raid-in-progress': 'Cannot change contract mid-raid.',
            'tier-too-low': 'That contract needs a higher tier.',
            'already-cleared': "Already cleared \u2014 its perk is permanent.",
            'no-sanction': 'Sign the Blackout Sanction charter first.'
        };
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(copy[result.reason] || 'Cannot arm that contract', 'error');
        return;
    }
    if (result.contract) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F311} ${result.contract.name} armed \u{2014} ${result.contract.description}`, 'warning');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $944d26b39bc4cb46$export$c7f6a5a323f54379();
}
function $944d26b39bc4cb46$export$736506b4b237950c() {
    const container = document.getElementById('syndicate-blackout');
    if (!container) return;
    if (!(0, $45c49e7f6d2032d6$export$6030630ca4e35487)()) {
        container.innerHTML = `<div class="text-sm text-gray-400">Sign the Blackout Sanction charter to take on contracts.</div>`;
        return;
    }
    container.innerHTML = (0, $45c49e7f6d2032d6$export$6f07b662ae575a0e)().map((id)=>{
        const c = (0, $45c49e7f6d2032d6$export$913dd38406a903a1)(id);
        const cleared = (0, $45c49e7f6d2032d6$export$e51189576207fce1)(id);
        return `
            <div class="rounded-lg p-3" style="background:rgba(139,127,212,${cleared ? '0.12' : '0.05'}); border:2px solid ${cleared ? $944d26b39bc4cb46$var$NIGHT : $944d26b39bc4cb46$var$NIGHT_DIM};">
                <div class="flex items-baseline justify-between gap-2">
                    <span class="font-bold text-sm" style="color:${$944d26b39bc4cb46$var$NIGHT}">${c.icon} ${c.name}</span>
                    <span class="text-xs ${cleared ? 'text-emerald-400' : 'text-gray-400'}">${cleared ? "\u2713 Cleared" : `Tier ${c.minTier}+`}</span>
                </div>
                <div class="text-xs text-gray-400 italic leading-snug mt-0.5">${c.flavor}</div>
                <div class="text-xs text-gray-300 leading-snug mt-1">${c.description}</div>
                <div class="text-xs mt-1.5 font-bold" style="color:${cleared ? '#7df5a0' : $944d26b39bc4cb46$var$NIGHT}">${cleared ? "\u2713 " : "\uD83C\uDF81 "}${c.perk.label}</div>
            </div>`;
    }).join('');
}
if (typeof window !== 'undefined') window.armBlackout = $944d26b39bc4cb46$export$38182372ac9340fd;


/**
 * Region skill fit — "how will this region go for me, at this tier?"
 *
 * The raid planner used to answer this with a three-column wall of every skill
 * in the region, its level band, a tick, and a success percentage. Accurate, and
 * far too tall: on a 768px iPad viewport it pushed the region tiles and the
 * Generate button below the fold. The detail is still the right answer once a
 * player is CHOOSING A PATH — it just is not the right answer while they are
 * choosing a region, where the only question is "can I handle this place?"
 *
 * So this collapses the same inputs to one verdict per region, and the tiles
 * carry a single glyph.
 *
 * Headless and separate from the renderer on purpose: the thresholds ARE the
 * design, and burying them in a template string is how they end up disagreeing
 * with the detailed view that uses the same numbers.
 */ 




/**
 * Rooms a path visits, matching the income model in
 * `tools/loot-equilibrium.mjs` and `demand-core.js`. Hazards outnumber gates
 * 2:1, so a region's difficulty is set more by its hazards — weighting them
 * evenly would flatter a region with brutal hazards behind easy gates.
 */ const $8cfd6e6f235ef461$var$GATES_PER_RAID = 2;
const $8cfd6e6f235ef461$var$HAZARDS_PER_RAID = 4;
const $8cfd6e6f235ef461$export$5380658a718e0007 = 0.75;
const $8cfd6e6f235ef461$export$899a23df7b7e4a64 = 0.5;
const $8cfd6e6f235ef461$export$32a3144cd774bde7 = {
    good: {
        glyph: "\u2705",
        label: 'Well matched',
        color: '#4ade80'
    },
    caution: {
        glyph: "\u26A0\uFE0F",
        label: 'Risky',
        color: '#fbbf24'
    },
    poor: {
        glyph: "\u274C",
        label: 'Outmatched',
        color: '#f87171'
    },
    unknown: {
        glyph: '',
        label: '',
        color: '#9ca3af'
    }
};
function $8cfd6e6f235ef461$export$27b46fbd6918ae77(chance) {
    if (chance >= $8cfd6e6f235ef461$export$5380658a718e0007) return 'good';
    if (chance >= $8cfd6e6f235ef461$export$899a23df7b7e4a64) return 'caution';
    return 'poor';
}
/**
 * How the two halves combine.
 *
 * LEVEL DOMINATES, deliberately. An even split lets full coverage floor the
 * score at 0.5, so a character with no skills at all could never read
 * "outmatched" in their own faction's best region — the one place they most
 * need telling. Coverage still ranks regions against each other at any given
 * skill level; it just cannot carry a player who cannot pass their own checks.
 *
 * Provisional, like every other L3 number: S7 calibrates.
 */ const $8cfd6e6f235ef461$var$COVERAGE_WEIGHT = 0.35;
const $8cfd6e6f235ef461$var$LEVEL_WEIGHT = 0.65;
function $8cfd6e6f235ef461$export$a07bea37865125aa(regionKey, faction) {
    const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[regionKey];
    if (!region || !faction) return 0;
    let own = 0, total = 0;
    for (const [list, perRaid] of [
        [
            region.gates || [],
            $8cfd6e6f235ef461$var$GATES_PER_RAID
        ],
        [
            region.hazards || [],
            $8cfd6e6f235ef461$var$HAZARDS_PER_RAID
        ]
    ]){
        const primaries = list.filter((room)=>room.primary);
        if (!primaries.length) continue;
        const perRoom = perRaid / primaries.length;
        for (const room of primaries){
            if ((0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(room.primary) === faction) own += perRoom;
            total += perRoom;
        }
    }
    return total > 0 ? own / total : 0;
}
/**
 * Best coverage any region offers a faction, so coverage is scored against what
 * is ACHIEVABLE rather than against 100%.
 *
 * Regions draw primaries from every faction — the most dominion-heavy region in
 * the game is only half dominion — so a raw coverage term caps every score near
 * 0.5 and "well matched" becomes unreachable. Scored against the faction's own
 * best region instead, the same trick `demand-core` uses for premiums.
 *
 * Pure over static config, so computed once.
 */ let $8cfd6e6f235ef461$var$bestCoverageCache = null;
function $8cfd6e6f235ef461$var$bestCoverageFor(faction) {
    if (!$8cfd6e6f235ef461$var$bestCoverageCache) {
        $8cfd6e6f235ef461$var$bestCoverageCache = {};
        for (const f of Object.keys($ce6dd72bc4611534$export$aeeef991191508e2 || {}))$8cfd6e6f235ef461$var$bestCoverageCache[f] = Math.max(0, ...Object.keys($ce6dd72bc4611534$export$4fbdcec70fce9d73 || {}).map((r)=>$8cfd6e6f235ef461$export$a07bea37865125aa(r, f)));
    }
    return $8cfd6e6f235ef461$var$bestCoverageCache[faction] || 0;
}
function $8cfd6e6f235ef461$export$92e1965816b22a3d(regionKey, tier, character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
    const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[regionKey];
    const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32?.[tier];
    if (!region || !tierData || !character?.faction) return null;
    const ownFaction = character.faction;
    const rooms = [
        {
            list: region.gates || [],
            target: tierData.gateSkillLevel,
            perRaid: $8cfd6e6f235ef461$var$GATES_PER_RAID
        },
        {
            list: region.hazards || [],
            target: tierData.hazardSkillLevel,
            perRaid: $8cfd6e6f235ef461$var$HAZARDS_PER_RAID
        }
    ];
    let ownTotal = 0, ownWeight = 0;
    let weakest = null;
    for (const { list: list, target: target, perRaid: perRaid } of rooms){
        const primaries = list.filter((room)=>room.primary);
        if (!primaries.length) continue;
        const perRoom = perRaid / primaries.length;
        for (const room of primaries){
            const skillId = room.primary;
            if ((0, $42b272c2c0f44bdf$export$a3603dda04ca8111)(skillId) !== ownFaction) continue; // hired, not judged
            const level = character.skills?.[skillId] || 0;
            // An unlearned skill is a genuine zero, not a low roll — the check
            // cannot be passed on merit at all. Short-circuited rather than run
            // through the formula, whose lower clamp would flatter it to 20%.
            const chance = level > 0 ? Math.min(0.97, (0, $b596e64ef926739f$export$2ad5af141c2ca6d2)(level, target) + (0, $1b3f8df6e579f420$export$a5a257639bbcfa93)(skillId, character) / 100) : 0;
            ownTotal += chance * perRoom;
            ownWeight += perRoom;
            // Only own-faction skills can be a weakness worth naming: an
            // off-faction gap is a hiring note, not something to train.
            if (!weakest || chance < weakest.chance) weakest = {
                skillId: skillId,
                chance: chance
            };
        }
    }
    const coverage = $8cfd6e6f235ef461$export$a07bea37865125aa(regionKey, ownFaction);
    const best = $8cfd6e6f235ef461$var$bestCoverageFor(ownFaction);
    const coverageScore = best > 0 ? Math.min(1, coverage / best) : 0;
    const levelFit = ownWeight > 0 ? ownTotal / ownWeight : 0;
    const score = $8cfd6e6f235ef461$var$COVERAGE_WEIGHT * coverageScore + $8cfd6e6f235ef461$var$LEVEL_WEIGHT * levelFit;
    return {
        score: score,
        verdict: $8cfd6e6f235ef461$export$27b46fbd6918ae77(score),
        coverage: coverage,
        coverageScore: coverageScore,
        levelFit: levelFit,
        weakest: weakest
    };
}



function $f3f2c7a1b1934e01$export$ffc032d1101a5382(faction = 'dominion') {
    const header = document.getElementById("game-header");
    if (!header) return;
    // Remove existing faction classes
    header.classList.remove("header-bg-dominion", "header-bg-veil", "header-bg-wilders");
    // Add appropriate faction class
    if (faction) header.classList.add(`header-bg-${faction}`);
    else header.classList.add(`header-bg-dominion`);
}
function $f3f2c7a1b1934e01$export$2ae62d947e9e1d03() {
    (0, $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b)();
}
function $f3f2c7a1b1934e01$export$d1c957a54f7124bc() {
    // The raid button's label/state used to be computed here from raid state.
    // That logic now lives in the layer registry as Field's activeTask (the same
    // reads, same order), and the toolbar renders it — raiding is Field's task,
    // not a privileged global control. See layers-core.js / layerNav.js.
    //
    // Values, NOT a structural rebuild: updateUI() is on the per-second interval,
    // and forcing a rebuild each tick both wasted the render split and closed the
    // layer panel a second after opening it. refreshToolbarValues() promotes
    // itself to a rebuild only when the task state actually changes.
    (0, $a1ffcc09d1c6aa84$export$c6af328ac5cab01b)();
    // Update raid button states when UI updates
    (0, $a52c72724dfd3eca$export$96635d91a6ab659a)();
}
function $f3f2c7a1b1934e01$export$ac9b2c0e374abc75() {
    const usedFactions = new Set();
    // Get factions of all existing characters
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Existing characters:", (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters);
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters && (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.length > 0) (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.forEach((character)=>{
        usedFactions.add(character.faction);
    });
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Used factions:", usedFactions);
    // Update faction cards
    document.querySelectorAll(".faction-card").forEach((card)=>{
        const faction = card.dataset.faction;
        if (usedFactions.has(faction)) {
            // Disable this faction
            card.classList.add("faction-disabled", "cursor-not-allowed");
            card.classList.remove("cursor-pointer");
            // Add visual indicator
            if (!card.querySelector(".faction-used-indicator")) {
                const indicator = document.createElement("div");
                indicator.className = "faction-used-indicator text-red-400 text-sm font-bold mt-2";
                indicator.textContent = "\u2713 Already Created";
                card.appendChild(indicator);
            }
        } else {
            // Enable this faction
            card.classList.remove("faction-disabled", "cursor-not-allowed");
            card.classList.add("cursor-pointer");
            // Remove visual indicator
            const indicator = card.querySelector(".faction-used-indicator");
            if (indicator) indicator.remove();
        }
    });
}
function $f3f2c7a1b1934e01$export$6a940d9b4a9b252a() {
    const regionInfo = document.getElementById("region-info");
    const generateBtn = document.getElementById("generate-grid");
    // The Blackout strip rides this same refresh: its cards are gated by TIER,
    // so it has to repaint whenever the tier changes — and this is the one
    // function every region/tier change already funnels through.
    (0, $944d26b39bc4cb46$export$c7f6a5a323f54379)();
    // Fit is per region AND tier, so every tile restamps when the tier changes.
    $f3f2c7a1b1934e01$export$76e61cb22c961267();
    const regionKey = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion;
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier;
    if (regionKey == null || tier == null) {
        regionInfo.innerHTML = "Select a region and tier to see details...";
        generateBtn.disabled = true;
        return;
    }
    const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey];
    const fit = (0, $8cfd6e6f235ef461$export$92e1965816b22a3d)(regionKey, tier);
    const display = (0, $8cfd6e6f235ef461$export$32a3144cd774bde7)[fit?.verdict || 'unknown'];
    const factionName = $ce6dd72bc4611534$export$aeeef991191508e2?.[(0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.faction]?.name || "your faction";
    // The two inputs, stated separately. The composite is a ranking rather than a
    // probability (see regionFit-core), so printing it as a percentage would be a
    // lie — and the halves are what a player can act on anyway: train a skill, or
    // raid somewhere that uses more of them.
    const weakestName = fit?.weakest ? (0, $42b272c2c0f44bdf$export$182937d2e68a339)(fit.weakest.skillId) : null;
    regionInfo.innerHTML = `
        <div class="text-sm flex flex-wrap items-baseline gap-x-2">
            <span class="font-bold text-white">${region.icon || "\uD83D\uDDFA\uFE0F"} ${region.name}</span>
            <span class="text-gray-400">${$ce6dd72bc4611534$export$94e7ad7999c1ae32[tier].name}</span>
            ${fit ? `<span class="font-bold" style="color:${display.color}">${display.glyph} ${display.label}</span>
                     <span class="text-gray-400">${factionName} covers ${Math.round(fit.coverage * 100)}% of checks \xb7 you pass ${Math.round(fit.levelFit * 100)}% of those${weakestName ? ` \xb7 weakest: ${weakestName} ${Math.round(fit.weakest.chance * 100)}%` : ''}</span>` : '<span class="text-gray-400">Create a character to see your fit</span>'}
        </div>`;
    generateBtn.disabled = !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $f3f2c7a1b1934e01$export$76e61cb22c961267() {
    const tier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.selectedTier;
    document.querySelectorAll("#region-tiles .region-tile").forEach((tile)=>{
        const badge = tile.querySelector(".region-fit-badge");
        if (!badge) return;
        // A locked region's fit is not a fact the player can act on — the lock
        // overlay is the whole answer, and a second verdict beside it just competes
        // with it.
        if (tile.dataset.locked === "true") {
            badge.textContent = "";
            badge.title = "";
            return;
        }
        const fit = tier ? (0, $8cfd6e6f235ef461$export$92e1965816b22a3d)(tile.dataset.region, tier) : null;
        const display = (0, $8cfd6e6f235ef461$export$32a3144cd774bde7)[fit?.verdict || 'unknown'];
        badge.textContent = display.glyph;
        badge.title = fit ? `${display.label} \u{2014} your faction covers ${Math.round(fit.coverage * 100)}% of this region's checks, and you pass ${Math.round(fit.levelFit * 100)}% of those at this tier` : "Pick a tier to see how well your skills fit";
    });
}
// Where a region tile's clock is being read: the capital, or the tile a raid
// has actually been sited on.
const $f3f2c7a1b1934e01$var$CAPITAL_ICON = "\uD83C\uDFDB\uFE0F";
const $f3f2c7a1b1934e01$var$SITE_ICON = "\uD83D\uDCCD";
function $f3f2c7a1b1934e01$export$bfd4e77d5f2367cd() {
    const now = Date.now();
    // The site belongs to the GRID — cancelling leaves the field behind (two
    // teardown paths null the grid and neither owns this rule), so the grid is
    // what says whether a site is live. Checking here rather than clearing there
    // is one condition instead of one per teardown path.
    const { selectedRegion: selectedRegion, raidSite: raidSite, currentRaidGrid: currentRaidGrid } = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid || {};
    const liveSite = currentRaidGrid ? raidSite : null;
    document.querySelectorAll("#region-tiles .region-tile").forEach((tile)=>{
        const badge = tile.querySelector(".region-clock-badge");
        if (!badge) return;
        const regionId = tile.dataset.region;
        const sited = liveSite && regionId === selectedRegion;
        const local = sited ? (0, $c454fb723f814d89$export$239629a81011f2a4)(liveSite, now) : (0, $c454fb723f814d89$export$30a7d07879d0db1d)(regionId, now);
        // WHERE the clock is read, before WHAT it reads. Without the place marker
        // the badge silently changes meaning when a raid is sited here — same
        // format, different location — and the time appearing to jump for no
        // reason is exactly what the marker prevents.
        badge.textContent = `${sited ? $f3f2c7a1b1934e01$var$SITE_ICON : $f3f2c7a1b1934e01$var$CAPITAL_ICON} ${local.icon} ${local.time}`;
        badge.title = sited ? `Local time at your raid site \u{2014} ${local.name}.` : `Local time at the capital \u{2014} ${local.name}. A region spans several hours of longitude, so a raid sited within it can meet a different sun.`;
    });
}
function $f3f2c7a1b1934e01$export$5d55f9eae051c4dc() {
    const sliderContainer = document.getElementById("tier-slider");
    sliderContainer.innerHTML = "";
    Object.keys($ce6dd72bc4611534$export$94e7ad7999c1ae32).forEach((tierKey)=>{
        const tier = parseInt(tierKey);
        const data = $ce6dd72bc4611534$export$94e7ad7999c1ae32[tier];
        // Extract short name and description from "Tier X - Name" format
        const shortName = data.name.split(" - ")[0] || tier;
        const shortDescription = data.name.split(" - ")[1] || data.name;
        const segment = document.createElement("div");
        segment.className = "tier-segment flex-1 cursor-pointer rounded-lg p-1 text-center font-bold transition-all border-2 border-gray-500 bg-gradient-to-b from-gray-700 to-gray-800 hover:border-gray-400 text-gray-400";
        segment.dataset.tier = tier;
        segment.innerHTML = `
            <div class="text-sm">${shortName}</div>
            <div class="text-xs">${shortDescription} - ${data.gridRows} x ${data.gridCols} Grid</div>
        `;
        // Check if this should be selected initially
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier === tier) segment.classList.add("selected");
        segment.addEventListener("click", ()=>{
            document.querySelectorAll(".tier-segment").forEach((s)=>s.classList.remove("selected"));
            segment.classList.add("selected");
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier = tier;
            $f3f2c7a1b1934e01$export$6a940d9b4a9b252a();
        });
        sliderContainer.appendChild(segment);
    });
}
function $f3f2c7a1b1934e01$export$98a6c6e9bfe86f10() {
    const tilesContainer = document.getElementById("region-tiles");
    tilesContainer.innerHTML = "";
    // Region locks (Command layer): faction starting pair + chartered regions.
    // Grandfathered pre-Command saves see everything.
    const availableRegions = new Set((0, $bde36de43872f734$export$99736e0126d21b50)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character));
    // A locked region can't stay selected (e.g. a fresh character after promotion).
    //
    // ...but only while it's just a menu choice. Once a raid is set up or running,
    // selectedRegion is live state the grid, raid header and room rendering all
    // resolve through (`config.raidRegions[selectedRegion]`), so clearing it breaks
    // the raid in place. That happened on reload — boot calls this unconditionally,
    // unlike the raid-tab handler which skips it during a raid — and on switching
    // to a character whose faction doesn't share the region. The lock's job is to
    // stop you *starting* a raid somewhere locked, not to retroactively break one.
    const raidUsingRegion = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    if (!raidUsingRegion && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion && !availableRegions.has((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion)) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion = null;
    Object.keys($ce6dd72bc4611534$export$4fbdcec70fce9d73).forEach((regionKey)=>{
        const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey];
        const icon = region.icon || "\uD83D\uDDFA\uFE0F";
        const bgImage = `./images/regions/${regionKey}/RegionBackground.jpg`;
        const locked = !availableRegions.has(regionKey);
        const tile = document.createElement("div");
        tile.className = "region-tile overflow-hidden rounded-lg border-2 transition-all " + (locked ? "relative border-gray-700 cursor-not-allowed" : "cursor-pointer border-gray-600 hover:border-game-accent");
        tile.dataset.region = regionKey;
        tile.dataset.locked = String(locked);
        tile.style.backgroundImage = `url('${bgImage}')`;
        tile.style.backgroundSize = "135% auto";
        tile.style.backgroundPosition = "center";
        tile.style.transition = "background-position 1s ease-out, border-color 0.25s";
        if (locked) tile.style.filter = "grayscale(0.9) brightness(0.7)";
        tile.innerHTML = `
            <div class="p-4 bg-gradient-to-b from-transparent via-gray-900/40 to-gray-900/90 h-32 flex flex-col justify-end relative">
                <!-- Skill fit, stamped by refreshRegionFitBadges() rather than
                     rendered here: it depends on TIER, which changes far more
                     often than the tile list does. -->
                <div class="region-fit-badge absolute top-2 right-2 text-lg leading-none drop-shadow"></div>
                <!-- Local time (M3 S9). Stamped by refreshRegionClocks() on the
                     tick: this one moves on its own, without anybody clicking. -->
                <div class="region-clock-badge absolute top-2 left-2"></div>
                <div class="text-white font-bold">${icon} ${region.name}</div>
                <div class="text-xs text-gray-400">${region.theme}</div>
            </div>
            ${locked ? `
            <div class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-1 bg-black/45">
                <div class="text-2xl">\u{1F512}</div>
                <div class="text-xs px-2 py-0.5 rounded border" style="color:#b18cff; border-color:#6d4fa3; background:rgba(12,8,20,0.85);">Regional Charter</div>
            </div>` : ""}
        `;
        if (locked) {
            // Allocation and licensing, NOT physical reachability (StoryAlignment.md
            // decision 2). The tooltip is the load-bearing half: it is the only place
            // in L1/L2 that can explain why an Operation may cross into a locked
            // region while a raid may not — gates move people, ground moves tonnage.
            tile.title = "Reachable overland \u2014 but your faction holds no gate allocation or charter here.";
            tile.addEventListener("click", ()=>{
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDD12 No gate allocation here \u2014 your faction's crossings land elsewhere. A Regional Charter rank (Command layer \u2192 Promotion) licenses a region of your choice", "error");
            });
            tilesContainer.appendChild(tile);
            return;
        }
        // Check if this should be selected initially
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion === regionKey) tile.classList.add("selected");
        tile.addEventListener("click", ()=>{
            document.querySelectorAll(".region-tile").forEach((t)=>t.classList.remove("selected"));
            tile.classList.add("selected");
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion = regionKey;
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            $f3f2c7a1b1934e01$export$6a940d9b4a9b252a();
        });
        // Parallax effect on mouse move
        tile.addEventListener("mousemove", (e)=>{
            const rect = tile.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
            // Background at 180% gives room for movement
            // Invert X for parallax effect (mouse right = image left)
            const maxXOffset = 115;
            const maxYOffset = 32.5;
            const offsetX = 50 - (x - 0.5) * maxXOffset; // Inverted
            const offsetY = 50 + (y - 0.5) * maxYOffset;
            tile.style.backgroundPosition = `${offsetX}% ${offsetY}%`;
        });
        tile.addEventListener("mouseleave", ()=>{
            tile.style.backgroundPosition = "center";
        });
        tilesContainer.appendChild(tile);
    });
    // Tiles are freshly built and carry empty badges — stamp them once here so a
    // boot or character switch shows fit and local time without waiting for a
    // tier click or the next tick.
    $f3f2c7a1b1934e01$export$76e61cb22c961267();
    $f3f2c7a1b1934e01$export$bfd4e77d5f2367cd();
}
async function $f3f2c7a1b1934e01$export$bb017115af5d1f34() {
    const chars = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters || [];
    let changed = false;
    for (const c of chars){
        // Mutate the authoritative copy (see liveCharacter): writing only to the
        // roster entry of the active character is clobbered on the next save.
        // Mirror onto the roster entry so reads before that save agree too.
        const ch = (0, $f27982cef7035d22$export$bda034a0354b67bb)(c);
        if (ch.multiplayerId && ch.ownerToken) continue; // already fully onboarded
        const eligible = (ch.level || 1) <= 2 && (Array.isArray(ch.artifacts) ? ch.artifacts.length : 0) === 0 && Object.keys(ch.equippedTechniqueGear || {}).length === 0;
        if (!eligible) continue;
        try {
            if (ch.multiplayerId) {
                // Case 1 — claim the existing pre-token row.
                const token = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).claimLegacyCharacter(ch.multiplayerId);
                if (token) {
                    ch.ownerToken = token;
                    if (ch !== c) c.ownerToken = token;
                    changed = true;
                    console.log(`Re-onboarded legacy character ${ch.name}`);
                }
            } else {
                // Case 2 — never registered; create the server row now.
                const registered = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).registerCharacter(ch);
                const newId = registered?.id || registered?.character?.id || null;
                if (newId) {
                    ch.multiplayerId = newId;
                    ch.ownerToken = registered.ownerToken || null;
                    if (ch !== c) {
                        c.multiplayerId = newId;
                        c.ownerToken = ch.ownerToken;
                    }
                    changed = true;
                    console.log(`Registered previously-unsynced character ${ch.name}`);
                }
            }
        } catch (err) {
            // Offline or name-taken, etc. — leave the character local-only.
            console.warn(`Could not re-onboard character ${ch.name}:`, err);
        }
    }
    if (changed) (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
async function $f3f2c7a1b1934e01$export$da1e47bae24a69b8() {
    try {
        const chars = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters || []).filter((c)=>c.multiplayerId);
        if (chars.length === 0) return;
        let totalCredits = 0;
        let totalXP = 0;
        for (const rosterEntry of chars){
            // Write (and read artifacts) through the authoritative copy — for the
            // active character the roster entry is overwritten by
            // gameState.character on the next save, which silently discarded the
            // XP awarded below.
            const character = (0, $f27982cef7035d22$export$bda034a0354b67bb)(rosterEntry);
            const pending = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).getPendingPayments(rosterEntry.multiplayerId);
            if (!pending || pending.length === 0) continue;
            // Contract Beacon on the contracted-out character: +X% on receipt.
            // The hiring client can't see this character's artifacts and the
            // server stores amounts verbatim, so the owner's client applies the
            // bonus when collecting.
            const payoutBonus = 1 + (0, $1b3f8df6e579f420$export$401b195eeeb2d82c)('contractor-payout-bonus', character) / 100;
            let credits = 0;
            let xp = 0;
            const paymentIds = [];
            for (const payment of pending){
                credits += Math.floor((payment.amount || 0) * payoutBonus);
                xp += payment.xp || 0;
                paymentIds.push(payment.id);
            }
            // Mark processed FIRST to prevent double-application if the client
            // crashes before applying.
            const marked = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).markPaymentsProcessed(rosterEntry.multiplayerId, paymentIds);
            if (!marked) {
                console.error(`Failed to mark payments processed for ${character.name}; skipping to avoid duplicates`);
                continue;
            }
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits += credits; // credits are account-global
            if (xp > 0) (0, $1b3f8df6e579f420$export$88ec20478ef6bd29)(character, xp); // XP goes to the recipient character
            totalCredits += credits;
            totalXP += xp;
        }
        if (totalCredits > 0 || totalXP > 0) {
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            (0, $7df15cefc09eac1b$export$2eced2100c12c50d)(); // refresh the active character's panel if it changed
            if (totalCredits > 0 && totalXP > 0) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4B0} Received ${totalCredits} credits and ${totalXP} XP from contractor payments!`, 'success');
            else if (totalCredits > 0) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4B0} Received ${totalCredits} credits from contractor payments!`, 'success');
            else if (totalXP > 0) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{2B50} Received ${totalXP} XP from contractor payments!`, 'success');
        }
    } catch (error) {
        console.error('Failed to check pending payments:', error);
    }
}
async function $f3f2c7a1b1934e01$export$162c77cf09613261() {
    const chars = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters || []).filter((c)=>c.multiplayerId);
    if (chars.length === 0) return;
    const listings = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).getMyMarketplaceListings(chars.map((c)=>c.multiplayerId));
    if (!listings) return; // couldn't reach the server — keep local state as-is
    const byCharacterId = new Map(listings.map((l)=>[
            l.character_id,
            l
        ]));
    let changed = false;
    for (const rosterEntry of chars){
        const ch = (0, $f27982cef7035d22$export$bda034a0354b67bb)(rosterEntry); // writes must hit the live copy
        const listing = byCharacterId.get(rosterEntry.multiplayerId);
        // A claimed listing is settled: the payout is banked and there is nothing
        // left for the player to do. The server still returns it (it filters on
        // is_active, and claiming only flips completion_claimed), so treating it
        // as live re-created `isMarketplace` with an expiry already in the past —
        // which the expiry check below then "discovered" and announced again on
        // every single load. Settled rows take the clearing path instead.
        const settled = listing && listing.completion_claimed === true;
        if (listing && !settled) {
            const fresh = {
                listedAt: new Date(listing.listed_at).getTime(),
                expiresAt: new Date(listing.expires_at).getTime(),
                durationHours: listing.duration_hours,
                rewardPercentage: listing.reward_percentage
            };
            const current = ch.marketplaceData;
            const stale = !ch.isMarketplace || !current || current.listedAt !== fresh.listedAt || current.expiresAt !== fresh.expiresAt || current.rewardPercentage !== fresh.rewardPercentage;
            if (stale) {
                ch.isMarketplace = true;
                ch.marketplaceData = fresh;
                if (ch !== rosterEntry) {
                    rosterEntry.isMarketplace = true;
                    rosterEntry.marketplaceData = fresh;
                }
                changed = true;
            }
        } else if (ch.isMarketplace) {
            // Nothing live server-side, so the local flag is stale: either no row
            // at all (withdrawn elsewhere) or a settled one. Cleared quietly on
            // purpose — the expiry announcement belongs to the load that actually
            // did the claiming, not to every load after it.
            ch.isMarketplace = false;
            delete ch.marketplaceData;
            if (ch !== rosterEntry) {
                rosterEntry.isMarketplace = false;
                delete rosterEntry.marketplaceData;
            }
            changed = true;
        }
    }
    if (changed) {
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
    }
}
// Completion claims in flight, keyed by multiplayerId. Module-level (not a
// character property) so the transient guard is never serialized into the save.
const $f3f2c7a1b1934e01$var$pendingCompletionClaims = new Set();
function $f3f2c7a1b1934e01$export$9124d6474b00dfc4() {
    // Check for expired marketplace listings
    let hasMarketplaceChars = false;
    const claimPromises = [];
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters) {
        const now = Date.now();
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.forEach((c)=>{
            const ch = (0, $f27982cef7035d22$export$bda034a0354b67bb)(c); // active character's writes must go here
            if (ch.isMarketplace && ch.marketplaceData?.expiresAt && ch.marketplaceData.expiresAt < now) {
                if (ch.multiplayerId) // Server-listed: try to claim the un-hired completion payout before
                // dropping local state. Clear only once the server responds (the
                // claim is idempotent server-side); on a network error, leave the
                // flag so the next tick retries.
                {
                    if (!$f3f2c7a1b1934e01$var$pendingCompletionClaims.has(ch.multiplayerId)) {
                        $f3f2c7a1b1934e01$var$pendingCompletionClaims.add(ch.multiplayerId);
                        const target = ch;
                        claimPromises.push((0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).claimContractCompletion(target.multiplayerId).then(()=>{
                            target.isMarketplace = false;
                            delete target.marketplaceData;
                            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${target.name}'s marketplace listing expired`, "info");
                            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
                            (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
                        }).catch((err)=>console.error("Error claiming contract completion:", err)).finally(()=>$f3f2c7a1b1934e01$var$pendingCompletionClaims.delete(target.multiplayerId)));
                    }
                } else {
                    // Local-only listing (no server row to claim against).
                    ch.isMarketplace = false;
                    delete ch.marketplaceData;
                    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${ch.name}'s marketplace listing expired`, "info");
                }
            } else if (ch.isMarketplace) hasMarketplaceChars = true;
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            (0, $7df15cefc09eac1b$export$2eced2100c12c50d)(); //refresh display for time remaining
        });
    }
    // Check for pending contractor payments
    // Only check for payments if we have marketplace characters that could earn
    if (hasMarketplaceChars && typeof $f3f2c7a1b1934e01$export$da1e47bae24a69b8 !== "undefined") $f3f2c7a1b1934e01$export$da1e47bae24a69b8().catch((err)=>console.error("Error checking payments:", err));
    // A resolved completion claim inserts a pending payment server-side; collect
    // it once the claims settle so the payout lands in the same visit.
    if (claimPromises.length > 0 && typeof $f3f2c7a1b1934e01$export$da1e47bae24a69b8 !== "undefined") Promise.allSettled(claimPromises).then(()=>{
        $f3f2c7a1b1934e01$export$da1e47bae24a69b8().catch((err)=>console.error("Error checking payments:", err));
    });
}














const $e7dde87afbac6dd8$export$fa0ee1eb937a38e6 = 10000;
const $e7dde87afbac6dd8$export$393daff81e921306 = 300000;
function $e7dde87afbac6dd8$export$64b66d963f6d5043(currentDelay) {
    // Anything missing or below the floor restarts the sequence.
    if (!Number.isFinite(currentDelay) || currentDelay < $e7dde87afbac6dd8$export$fa0ee1eb937a38e6) return $e7dde87afbac6dd8$export$fa0ee1eb937a38e6;
    // Once past the cap the cadence has settled — stop doubling.
    if (currentDelay > $e7dde87afbac6dd8$export$393daff81e921306) return currentDelay;
    return currentDelay * 2;
}
function $e7dde87afbac6dd8$export$9163caedda99cb08(contractor) {
    // Progressive disclosure: no synergy indicators before the layer is
    // revealed (character below synergyUnlocks.minLevel)
    if (!(0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)()) return {
        skills: {},
        gearPartners: {},
        hasReady: false,
        hasSwap: false
    };
    const teamTechniques = new Set();
    const addGear = (c)=>Object.keys(c?.equippedTechniqueGear || {}).forEach((t)=>teamTechniques.add(t));
    addGear((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
    ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.reservedContractors || []).forEach(addGear);
    ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.hiredContractors || []).forEach(addGear);
    addGear(contractor);
    const playerTechniques = new Set(Object.keys((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.equippedTechniqueGear || {}));
    const ownedDevices = Object.entries((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.inventory || {}).filter(([, qty])=>qty > 0).map(([id])=>(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id)).filter((item)=>item?.type === 'techGear');
    // Either-side unlock rule (mirrors variant selection): a partner technique
    // counts only if the event skill is unlocked, or it is the player's own
    // gear from an unlocked skill
    const partnerAllowed = (eventSkillId, techniqueId, isPlayerDevice)=>(0, $1b3f8df6e579f420$export$7d626adf944498ee)(eventSkillId) || isPlayerDevice && (0, $1b3f8df6e579f420$export$7d626adf944498ee)((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(techniqueId));
    const skills = {};
    Object.keys(contractor?.skills || {}).forEach((skillId)=>{
        const partners = (0, $b596e64ef926739f$export$3a3bfc913ac4efaa)(skillId);
        if (partners.size === 0) return;
        const ready = [
            ...partners
        ].find((t)=>teamTechniques.has(t) && partnerAllowed(skillId, t, playerTechniques.has(t)));
        if (ready) {
            skills[skillId] = {
                state: 'ready',
                techniqueId: ready
            };
            return;
        }
        const swap = ownedDevices.find((d)=>partners.has(d.techniqueId) && partnerAllowed(skillId, d.techniqueId, true));
        if (swap) skills[skillId] = {
            state: 'swap',
            techniqueId: swap.techniqueId,
            gearName: swap.name,
            gearIcon: swap.icon
        };
    });
    // Reverse direction: contractor gear that upgrades skills the player has
    // (event-side unlock applies - the event is the player's skill)
    const playerSkills = new Set(Object.keys((0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.skills || {}));
    const gearPartners = {};
    Object.keys(contractor?.equippedTechniqueGear || {}).forEach((techniqueId)=>{
        const upgradable = [
            ...(0, $b596e64ef926739f$export$9f7e6ebcfcd92245)(techniqueId)
        ].filter((s)=>playerSkills.has(s) && (0, $1b3f8df6e579f420$export$7d626adf944498ee)(s));
        if (upgradable.length > 0) gearPartners[techniqueId] = upgradable;
    });
    const states = Object.values(skills).map((s)=>s.state);
    return {
        skills: skills,
        gearPartners: gearPartners,
        hasReady: states.includes('ready') || Object.keys(gearPartners).length > 0,
        hasSwap: states.includes('swap')
    };
}
function $e7dde87afbac6dd8$export$4e2035a3911d8600(factionKey, skills, level) {
    const equipped = {};
    const maxPieces = Math.min(2, Math.floor(level / 4));
    if (maxPieces <= 0) return equipped;
    const capitalized = factionKey.charAt(0).toUpperCase() + factionKey.slice(1);
    const devices = $ce6dd72bc4611534$exports[`itemsEpicDevice${capitalized}`] || [];
    const techniques = $ce6dd72bc4611534$exports.skillTechniques[factionKey] || [];
    const knownSkills = Object.keys(skills).sort(()=>Math.random() - 0.5).slice(0, maxPieces);
    for (const skill of knownSkills){
        const skillTechniques = techniques.filter((t)=>t.skill === skill);
        if (skillTechniques.length === 0) continue;
        const technique = skillTechniques[Math.floor(Math.random() * skillTechniques.length)];
        const device = devices.find((d)=>d.techniqueId === technique.id);
        if (device) equipped[technique.id] = device;
    }
    return equipped;
}
function $e7dde87afbac6dd8$export$9471e02e816b8b11(playerLevel) {
    let newContractors = [];
    let contractorId = -1; // Negative IDs for AI contractors
    const baseSkillMin = Math.max(1, Math.floor(playerLevel / 3));
    const baseSkillMax = Math.max(3, playerLevel + Math.floor(playerLevel / 2));
    const skillRange = baseSkillMax - baseSkillMin;
    Object.keys($ce6dd72bc4611534$exports.factionSkills).forEach((factionKey)=>{
        const faction = $ce6dd72bc4611534$exports.factionSkills[factionKey];
        for(let i = 0; i < 5; i++){
            // Generate faction-specific name
            const factionNameData = $ce6dd72bc4611534$exports.factionNames[factionKey];
            const firstName = factionNameData.names[Math.floor(Math.random() * factionNameData.names.length)];
            const lastName = factionNameData.surnames[Math.floor(Math.random() * factionNameData.surnames.length)];
            const name = firstName + " " + lastName;
            const skills = {};
            const factionSkills = Object.keys(faction.skills);
            let rewardPercentage = 10;
            // Give each contractor 2-3 random skills from their faction
            const numSkills = 2 + Math.floor(Math.random() * 2);
            for(let j = 0; j < numSkills; j++){
                const skill = factionSkills[Math.floor(Math.random() * factionSkills.length)];
                const addlPoints = Math.round(Math.random() * skillRange);
                skills[skill] = baseSkillMin + addlPoints;
                rewardPercentage += Math.ceil(5 * (addlPoints / skillRange) * (addlPoints / skillRange));
            }
            // Calculate contractor level based on skill levels
            const skillLevels = Object.values(skills);
            const bestSkill = skillLevels.length > 0 ? Object.keys(skills).reduce((a, b)=>skills[a] > skills[b] ? a : b) : null;
            const highestSkillLevel = skillLevels.length > 0 ? Math.max(...skillLevels) : 0;
            const avgSkillLevel = skillLevels.reduce((sum, level)=>sum + level, 0) / skillLevels.length;
            const contractorLevel = Math.max(1, Math.floor(avgSkillLevel / 2) + Math.floor(Math.random() * 3));
            const flavorText = $e7dde87afbac6dd8$export$ea991b314c8ed75e(bestSkill);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).events, "Generated contractor flavor:", flavorText);
            const contractor = {
                id: -(newContractors.length + 1),
                name: name,
                faction: factionKey,
                skills: skills,
                rewardPercentage: rewardPercentage,
                hired: false,
                avatar: (0, $42b272c2c0f44bdf$export$913078032f14f7f)(factionKey),
                // Procedural portrait seed. A fresh persisted token, NOT the `id` above —
                // that id is a reused negative slot index, so seeding from it would make
                // every slot-N contractor share a face. This token is stable once saved.
                avatarSeed: `ctr_${factionKey}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
                level: contractorLevel,
                xp: Math.floor(Math.random() * (0, $1b3f8df6e579f420$export$ae545994cbde97ee)(contractorLevel)),
                // Was `100 + (level-1) * gainAt(level)`, which multiplies the CURRENT
                // level's gain across every level instead of summing each level's own
                // gain - it over-paid increasingly with level (1300 HP at level 25 vs
                // the curve's 840). maxHpForLevel is the one definition of the curve.
                maxHp: (0, $1b3f8df6e579f420$export$266289d5372bee03)(contractorLevel),
                currentHp: null,
                isAlive: true,
                injuries: [],
                title: flavorText ? flavorText.role : "Contractor",
                quote: flavorText ? flavorText.quote : '"Ready for work."'
            };
            // Equipped skill gear: seasoned contractors come tooled up (0-2 pieces
            // by level, one per known skill - same one-per-skill rule as the
            // player). Their gear feeds team synergy variants and success bonuses,
            // making WHO you hire matter beyond raw skill numbers.
            contractor.equippedTechniqueGear = $e7dde87afbac6dd8$export$4e2035a3911d8600(factionKey, skills, contractorLevel);
            // Set current HP to max HP
            contractor.currentHp = contractor.maxHp;
            newContractors.push(contractor);
        }
    });
    // Preserve hired and reserved contractors by adding them to the new pool
    // Only preserve NPC contractors (negative IDs) - player contractors don't belong in the pool
    const preservedContractors = [
        ...((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors || []).filter((c)=>c.id < 0),
        ...((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors || []).filter((c)=>c.id < 0)
    ];
    if (preservedContractors.length > 0) {
        const preservedIds = new Set(preservedContractors.map((c)=>c.id));
        // Remove any generated contractors that have the same ID as preserved ones
        const dedupedNew = newContractors.filter((c)=>!preservedIds.has(c.id));
        newContractors = [
            ...dedupedNew,
            ...preservedContractors
        ];
    }
    return newContractors;
}
function $e7dde87afbac6dd8$export$62a89cfab93e40e(contractors, path, characterSkills) {
    if (!contractors || contractors.length === 0 || !path) return [];
    // Extract skills needed from the path
    const pathSkills = new Set();
    for (const step of path)if (step.room && step.room.primary) {
        pathSkills.add(step.room.primary);
        if (step.room.support && Array.isArray(step.room.support)) step.room.support.forEach((skill)=>pathSkills.add(skill));
    }
    // Helper function to calculate individual contractor score
    function scoreContractor(contractor) {
        let score = 0;
        const contractorSkillIds = Object.keys(contractor.skills || {});
        // Count how many path-required skills this contractor has
        const matchedSkills = contractorSkillIds.filter((skill)=>pathSkills.has(skill));
        const unmatchedPathSkills = Array.from(pathSkills).filter((skill)=>!contractorSkillIds.includes(skill) && (characterSkills[skill] || 0) === 0);
        // Score: contractor skills that cover missing path skills are valuable
        for (const skill of matchedSkills){
            const skillLevel = contractor.skills[skill];
            if ((characterSkills[skill] || 0) === 0) // Character doesn't have this skill, contractor fill-in is valuable
            score += 200 + skillLevel * 20;
            else // Character has skill but contractor's level helps
            score += 50 + skillLevel * 10;
        }
        // Penalize contractors with many uncovered path skills
        score -= unmatchedPathSkills.length * 30;
        // Small bonus for higher level contractors
        score += contractor.level * 5;
        return score;
    }
    // Helper function to evaluate pair synergy
    function scorePair(contractor1, contractor2) {
        const skills1 = new Set(Object.keys(contractor1.skills || {}));
        const skills2 = new Set(Object.keys(contractor2.skills || {}));
        let pairScore = scoreContractor(contractor1) + scoreContractor(contractor2);
        // Bonus for complementary skills (skills that only one has)
        const uniqueSkills = new Set([
            ...skills1,
            ...skills2
        ]);
        const sharedSkills = new Set([
            ...skills1
        ].filter((s)=>skills2.has(s)));
        const complementarySkills = uniqueSkills.size - sharedSkills.size;
        // Reward diversity: contractors with different skills complement each other
        pairScore += complementarySkills * 15;
        // Slight penalty for overlapping skills (unless covering critical gaps)
        pairScore -= sharedSkills.size * 3;
        return pairScore;
    }
    // Find the best pair of contractors
    let bestPair = [];
    let bestScore = -Infinity;
    // Try all possible pairs
    for(let i = 0; i < contractors.length; i++)for(let j = i + 1; j < contractors.length; j++){
        const pairScore = scorePair(contractors[i], contractors[j]);
        if (pairScore > bestScore) {
            bestScore = pairScore;
            bestPair = [
                contractors[i],
                contractors[j]
            ];
        }
    }
    // If no good pair found, also consider single contractors
    if (bestScore <= 0 && contractors.length > 0) {
        let bestSingle = contractors[0];
        let bestSingleScore = scoreContractor(contractors[0]);
        for(let i = 1; i < contractors.length; i++){
            const singleScore = scoreContractor(contractors[i]);
            if (singleScore > bestSingleScore) {
                bestSingleScore = singleScore;
                bestSingle = contractors[i];
            }
        }
        if (bestSingleScore > 0) return [
            bestSingle
        ];
    }
    return bestScore > 0 ? bestPair : [];
}
function $e7dde87afbac6dd8$export$ea991b314c8ed75e(bestSkill) {
    const data = $ce6dd72bc4611534$exports.contractorSkillFlavors[bestSkill];
    if (!data) return null;
    const role = data.roles[Math.floor(Math.random() * data.roles.length)];
    const quote = data.quotes[Math.floor(Math.random() * data.quotes.length)];
    return {
        role: role,
        quote: quote
    };
}
function $e7dde87afbac6dd8$export$b8366d52640d9f9(char, path, contractors) {
    if (!char.equippedTechniqueGear) char.equippedTechniqueGear = {};
    const teamTechniques = new Set(Object.keys(char.equippedTechniqueGear));
    (contractors || []).forEach((c)=>Object.keys(c?.equippedTechniqueGear || {}).forEach((t)=>teamTechniques.add(t)));
    const ownedDevices = Object.entries(char.inventory || {}).filter(([, qty])=>qty > 0).map(([id])=>(0, $42b272c2c0f44bdf$export$a2dea178c28a0308)('id', id)).filter((item)=>item?.type === 'techGear' && item.techniqueId);
    if (ownedDevices.length === 0) return 0;
    const routeSkills = new Set();
    (path || []).forEach((step)=>{
        if (step.room?.primary) routeSkills.add(step.room.primary);
    });
    // Either-side unlock rule, mirroring eventSystem-core's variant selection and
    // contractor-core's partnerAllowed: a partner counts when the EVENT's skill is
    // unlocked, OR when it is the player's own device from an unlocked skill.
    // Only checking the event side made this a no-op - a region's rooms span
    // factions, and a player only ever unlocks synergies on their own faction's
    // skills, so the event-side test almost never passed.
    const partnerAllowed = (eventSkillId, techniqueId)=>(0, $1b3f8df6e579f420$export$7d626adf944498ee)(eventSkillId, char) || (0, $1b3f8df6e579f420$export$7d626adf944498ee)((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(techniqueId), char);
    let swaps = 0;
    for (const skillId of routeSkills){
        const partners = (0, $b596e64ef926739f$export$3a3bfc913ac4efaa)(skillId);
        if (partners.size === 0) continue;
        // Already covered by the player's or a hired contractor's kit?
        if ([
            ...partners
        ].some((t)=>teamTechniques.has(t) && partnerAllowed(skillId, t))) continue;
        // Prefer a device that costs us coverage on a skill this route does not use.
        const candidates = ownedDevices.filter((d)=>partners.has(d.techniqueId) && partnerAllowed(skillId, d.techniqueId));
        if (candidates.length === 0) continue;
        const device = candidates.find((d)=>!routeSkills.has((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(d.techniqueId))) || candidates[0];
        const deviceSkill = (0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(device.techniqueId);
        if (char.equippedTechniqueGear[device.techniqueId]) continue; // already on
        for (const equipped of Object.keys(char.equippedTechniqueGear))if ((0, $42b272c2c0f44bdf$export$a6cb179f21ae932e)(equipped) === deviceSkill) {
            teamTechniques.delete(equipped);
            delete char.equippedTechniqueGear[equipped];
        }
        char.equippedTechniqueGear[device.techniqueId] = device;
        teamTechniques.add(device.techniqueId);
        swaps++;
    }
    return swaps;
}



function $bd083a63eb37c143$export$aca974319671fb3e() {
    // Calculate skill level range based on player level
    const playerLevel = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.level : 1;
    const newContractors = (0, $e7dde87afbac6dd8$export$9471e02e816b8b11)(playerLevel);
    // Update both gameState and Alpine store
    if (Alpine.store("contractors")) Alpine.store("contractors").update(newContractors);
    else // Fallback if Alpine isn't ready yet
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors = newContractors;
}
function $bd083a63eb37c143$export$5464865996ba2eb4(member, context = "main", pathSkills = null, teamSkills = null) {
    //console.log('Creating contractor card for:', member, 'in context:', context);
    // Handle empty slot mode
    const isReadOnly = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.isMarketplace;
    const isEmpty = member === "empty";
    // Crewing is a PLANNING action. An empty slot goes on showing its Reserve
    // button once the raid is underway or finished, which offers to add somebody
    // to a team that has already left — reserving mid-raid cannot put them on it,
    // and reserving against a finished one is meaningless. The slot itself still
    // renders, because "you went in two-handed" is worth seeing on the way round.
    const raidStarted = !!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress || !!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    const showReserveButton = !isReadOnly && !raidStarted && context === "empty-first";
    // Identity check, not type-sniffing: character ids are strings for created
    // characters but numeric in QA fixtures/legacy saves - type-based detection
    // rendered the player as a "Contractor" card (undefined% reward share)
    const isPlayer = !isEmpty && (0, $f27982cef7035d22$export$8e361a1ffbebf172).character != null && member.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.id;
    const isMarketplaceContractor = !isEmpty && member.id > 0 && !isPlayer;
    const faction = !isEmpty && (isPlayer ? $ce6dd72bc4611534$export$aeeef991191508e2[member.faction] : $ce6dd72bc4611534$export$aeeef991191508e2[member.faction]);
    // Determine member status
    const isHired = !isEmpty && !isPlayer && (0, $cc90b7944b7e868a$export$4c8adf450afe39a2)(member.id);
    const isReserved = !isEmpty && !isPlayer && (0, $cc90b7944b7e868a$export$595cb98aec43dd71)(member.id);
    const isInjured = !isEmpty && (member.injured || false);
    const raidCompleted = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    // Synergy indicators: ⚡ = a partner device is already equipped on the
    // prospective team (synergy variants can fire on this skill's events);
    // 🔀 = the player owns a partner device - one gear swap enables it
    const synergyStatus = isEmpty ? null : (0, $e7dde87afbac6dd8$export$9163caedda99cb08)(member);
    // Build skills display (sorted by level descending)
    const skillsText = isEmpty ? "" : Object.entries(member.skills).sort(([, a], [, b])=>b - a) // Sort by level descending
    .map(([skill, level])=>{
        const skillIcon = (0, $42b272c2c0f44bdf$export$8a18dddc0824814c)(skill);
        const skillName = faction.skills[skill]?.name || skill;
        const truncatedName = skillName;
        const syn = synergyStatus?.skills?.[skill];
        let synIcon = "";
        if (syn?.state === "ready") synIcon = `<span class="ml-1 cursor-help" title="Synergy ready: the team's ${(0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(syn.techniqueId)} gear upgrades ${skillName} events to synergy variants (bonus salvage)">\u{26A1}</span>`;
        else if (syn?.state === "swap") synIcon = `<span class="ml-1 cursor-help opacity-60" title="Synergy possible: equip your ${syn.gearIcon || ''} ${syn.gearName} (${(0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(syn.techniqueId)}) to upgrade ${skillName} events to synergy variants">\u{1F500}</span>`;
        // Determine skill highlighting based on path requirements
        let skillClasses = "flex items-start justify-between text-sm mb-1 px-1";
        let nameClasses = "whitespace-nowrap overflow-hidden tracking-tighter";
        let levelClasses = "font-medium text-game-gold";
        if ((context === "modal" || context === "team") && pathSkills && teamSkills && !isPlayer) {
            const isNeededSkill = pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
            const isMatchingSkill = pathSkills.has(skill) && (teamSkills[skill] || 0) > 0;
            if (isNeededSkill) {
                // Critical needed skill - keep text highlighting only
                nameClasses += " text-orange-300";
                levelClasses = "font-bold text-orange-400";
            } else if (isMatchingSkill) {
                // Matching skill - keep text highlighting only
                nameClasses += " text-blue-300";
                levelClasses = "font-bold text-blue-400";
            }
        }
        return `<div class="${skillClasses}">
                <span class="flex items-start">
                    <span class="skill-icon">${skillIcon}</span>
                    <span class="${nameClasses}" title="${skillName}">${truncatedName}</span>
                    ${synIcon}
                </span>
                <span class="${levelClasses}">${level}</span>
            </div>`;
    }).join("");
    // Equipped skill gear: shown on the card because a contractor's tools
    // unlock synergy variants and success bonuses for the whole team.
    // ⚡ marks gear that partners YOUR skills' events (the reverse direction:
    // hiring this contractor upgrades your own events to synergy variants).
    const equippedGear = isEmpty ? [] : Object.values(member.equippedTechniqueGear || {}).filter(Boolean);
    const gearText = equippedGear.length === 0 ? "" : `
        <div class="border-t border-gray-600 pt-1 mt-1">
            ${equippedGear.map((gear)=>{
        const partneredSkills = synergyStatus?.gearPartners?.[gear.techniqueId] || [];
        const partnerNames = partneredSkills.map((s)=>(0, $42b272c2c0f44bdf$export$182937d2e68a339)(s)).join(", ");
        const title = partneredSkills.length > 0 ? `${gear.name} \u{2014} synergy partner for your ${partnerNames} events (bonus salvage on success)` : `${gear.name} \u{2014} boosts ${(0, $42b272c2c0f44bdf$export$b7fbae54a8f17db)(gear.techniqueId) || 'its technique'} for the team`;
        return `
                <div class="flex items-start text-sm mb-1 px-1 text-amber-300" title="${title}">
                    <span class="skill-icon">\u{2699}\u{FE0F}</span>
                    <span class="whitespace-nowrap overflow-hidden tracking-tighter">${gear.name}</span>
                    ${partneredSkills.length > 0 ? '<span class="ml-1 cursor-help">\u26A1</span>' : ''}
                </div>`;
    }).join("")}
        </div>`;
    // Build health status - ensure all contractors show HP (except empty slots)
    let statusText = "";
    if (!isEmpty && isInjured && member.recoveryTime) {
        const timeLeft = Math.max(0, member.recoveryTime - Date.now());
        const hoursLeft = Math.ceil(timeLeft / 3600000);
        statusText = `<div class="text-red-500">\u{1F3E5} ${hoursLeft}h recovery</div>`;
    } else if (!isEmpty) {
        // Initialize HP if missing
        const maxHp = member.maxHp || 100;
        const currentHp = Math.max(0, member.currentHp !== undefined ? member.currentHp : maxHp);
        const healthPercent = currentHp / maxHp * 100;
        const healthColor = healthPercent > 75 ? "#4caf50" : healthPercent > 25 ? "#ffd700" : "#ff6b6b";
        statusText = `<div style="color: ${healthColor};">\u{2764}\u{FE0F}${Math.floor(currentHp)}</div>`;
    }
    // Calculate skill relevance for modal context
    let relevanceText = "";
    let relevanceClass = "";
    if (context === "modal" && pathSkills && teamSkills && !isPlayer) {
        const relevantSkills = Object.keys(member.skills).filter((skill)=>pathSkills.has(skill));
        const uncoveredSkills = Object.keys(member.skills).filter((skill)=>pathSkills.has(skill) && (teamSkills[skill] || 0) === 0);
        if (uncoveredSkills.length > 0) {
            relevanceText = `<span class="skill-relevance critical">\u{1F525} ${uncoveredSkills.length} needed skill${uncoveredSkills.length > 1 ? "s" : ""}</span>`;
            relevanceClass = "critical-match";
        } else if (relevantSkills.length > 0) {
            relevanceText = `<span class="skill-relevance">\u{1F3AF} ${relevantSkills.length} matching skill${relevantSkills.length > 1 ? "s" : ""}</span>`;
            relevanceClass = "skill-match";
        }
    }
    // Determine card status styling
    let statusClasses = "bg-white/5 border-2 border-gray-600";
    if (isHired) statusClasses = "bg-green-500/20 border-green-500";
    if (isReserved) statusClasses = "bg-game-gold/20 border-game-gold";
    if (isInjured) statusClasses = "bg-red-500/20 border-red-500";
    if (isPlayer) statusClasses = "bg-game-accent/20 border-game-accent";
    if (relevanceClass === "critical-match") statusClasses = "bg-orange-500/20 border-orange-500";
    else if (relevanceClass === "skill-match") statusClasses = "bg-blue-500/20 border-blue-500";
    // Build action button
    let actionButton = "";
    if (isEmpty && showReserveButton) actionButton = `<button class="bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold" onclick="openContractorModal()">
            Reserve
        </button>`;
    else if (isEmpty) actionButton = "";
    else if (isReadOnly) // No action button in read-only mode
    actionButton = "";
    else if (isMarketplaceContractor && context === "main") {
        // Handle marketplace contractors with reservation system
        const raidInProgress = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if (isReserved && !raidInProgress) actionButton = `<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold bg-red-500 hover:bg-red-600 text-white hover:shadow-lg border border-red-400" onclick="releaseReservedContractor('${member.id}')">Release</button>`;
        else if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress) {
            const disabled = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            const buttonText = disabled ? "Team Full" : "Reserve";
            const buttonClasses = disabled ? "bg-gray-600 text-gray-400 cursor-not-allowed border border-gray-500" : "bg-purple-600 hover:bg-purple-700 text-white hover:shadow-lg border border-purple-400";
            actionButton = `<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold ${buttonClasses}" onclick="reserveContractorFromModal('${member.id}')" ${disabled ? "disabled" : ""}>
                    ${buttonText}
                </button>`;
        }
    } else if (context === "main" && !isPlayer) {
        const raidInProgress = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if (isHired || isReserved && !raidInProgress || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress) {
            const disabled = isInjured || !isHired && !isReserved && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            const buttonText = isHired ? "Release" : isReserved ? "Release" : isInjured ? "Injured" : (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2 ? "Team Full" : "Reserve";
            const buttonClasses = disabled ? "bg-gray-400 text-black text-xs px-3 py-1 rounded font-bold cursor-not-allowed" : "bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold";
            actionButton = `<button class="${buttonClasses}" @click="toggleContractor('${member.id}')" ${disabled ? "disabled" : ""}>
                    ${buttonText}
                </button>`;
        }
    } else if (context === "modal" && !isPlayer) {
        const raidInProgress = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress) {
            const disabled = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            const buttonText = disabled ? "Team Full" : "Reserve";
            const buttonClasses = disabled ? "bg-gray-400 text-black text-xs px-3 py-1 rounded font-bold cursor-not-allowed" : "bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold";
            actionButton = `<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold ${buttonClasses}" onclick="reserveContractorFromModal('${member.id}')" ${disabled ? "disabled" : ""}>
                    ${buttonText}
                </button>`;
        }
    } else if (context === "team" && !isPlayer && !isHired) // Only show release button for reserved contractors, not hired ones
    actionButton = `<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold bg-red-500 hover:bg-red-600 text-white hover:shadow-lg border border-red-400" onclick="releaseReservedContractor('${member.id}')">Release</button>`;
    // Build timer display for reserved marketplace contractors in team view
    let timerDisplay = "";
    if (context === "team" && isMarketplaceContractor && isReserved && member.reservationExpires) {
        const timeLeft = Math.max(0, Math.floor((member.reservationExpires - Date.now()) / 1000));
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        timerDisplay = `<div class="bg-purple-700 text-purple-100 px-2 py-1 rounded text-xs font-bold border border-purple-400" id="reservation-timer-${member.id}">
            ${minutes}:${seconds.toString().padStart(2, "0")}
        </div>`;
    }
    // Build cost/percentage display for bottom left corner
    let costDisplay = "";
    if (isEmpty) costDisplay = `<div class="bg-gray-700 text-gray-500 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 ${isEmpty ? "border-dashed" : ""}">-%\u{1F4B0}</div>`;
    else if (!isPlayer) costDisplay = `<div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500">${member.rewardPercentage}%\u{1F4B0}</div>`;
    // Build detailed tooltip content for contractor
    const tooltipContent = isPlayer ? `Leader of the raid team<br><strong>Faction:</strong> ${faction.name}<br><strong>Skills:</strong><br>${skillsText.replace(/class="skill-line"/g, "").replace(/<div>/g, "").replace(/<\/div>/g, "<br>")}` : `<strong>Contractor Details</strong><br><strong>Faction:</strong> ${faction.name}<br><strong>Reward Share:</strong> ${member.rewardPercentage}%\u{1F4B0}<br><strong>Skills:</strong><br>${skillsText.replace(/class="skill-line"/g, "").replace(/<div>/g, "").replace(/<\/div>/g, "<br>")}`;
    // Determine card colors based on status
    let cardBg, cardBorder, frameBorder, headerBg, headerBorder, headerText;
    if (isPlayer) {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-purple-600";
        frameBorder = "border-purple-500";
        headerBg = "from-purple-700 to-purple-600";
        headerBorder = "border-purple-500";
        headerText = "text-purple-100";
    } else if (isMarketplaceContractor && isReserved) {
        // Reserved marketplace contractor - purple/amber blend
        cardBg = "from-purple-800 to-purple-900";
        cardBorder = "border-purple-500";
        frameBorder = "border-purple-400";
        headerBg = "from-purple-700 to-purple-600";
        headerBorder = "border-purple-400";
        headerText = "text-purple-100";
    } else if (isMarketplaceContractor) {
        cardBg = "from-indigo-800 to-indigo-900";
        cardBorder = "border-indigo-600";
        frameBorder = "border-indigo-500";
        headerBg = "from-indigo-700 to-indigo-600";
        headerBorder = "border-indigo-500";
        headerText = "text-indigo-100";
    } else if (isHired) {
        cardBg = "from-green-800 to-green-900";
        cardBorder = "border-green-600";
        frameBorder = "border-green-500";
        headerBg = "from-green-700 to-green-600";
        headerBorder = "border-green-500";
        headerText = "text-green-100";
    } else if (isReserved) {
        cardBg = "from-amber-800 to-amber-900";
        cardBorder = "border-amber-600";
        frameBorder = "border-amber-500";
        headerBg = "from-amber-700 to-amber-600";
        headerBorder = "border-amber-500";
        headerText = "text-amber-100";
    } else if (relevanceClass === "critical-match") {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-orange-700";
        frameBorder = "border-orange-600";
        headerBg = "from-orange-800 to-orange-700";
        headerBorder = "border-orange-600";
        headerText = "text-orange-100";
    } else if (relevanceClass === "skill-match") {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-blue-600";
        frameBorder = "border-blue-500";
        headerBg = "from-blue-700 to-blue-600";
        headerBorder = "border-blue-500";
        headerText = "text-blue-100";
    } else {
        // Use level-based colors for neutral contractors
        const levelColors = (0, $7df15cefc09eac1b$export$fc83223e1b29d2d5)(member.level || 1);
        cardBg = levelColors.cardBg;
        cardBorder = isEmpty ? `border-dashed ${levelColors.cardBorder}` : levelColors.cardBorder;
        frameBorder = isEmpty ? `border-dashed ${levelColors.frameBorder}` : levelColors.frameBorder;
        headerBg = levelColors.headerBg;
        headerBorder = isEmpty ? `border-dashed ${levelColors.headerBorder}` : levelColors.headerBorder;
        headerText = "text-white";
    }
    const overlayBg = "bg-black bg-opacity-70";
    const overlayBorder = "border-gray-500";
    const overlayText = "text-gray-400";
    // Create unified card HTML for all contexts
    return `
        <div class="relative bg-gradient-to-b ${cardBg} border-4 ${cardBorder} rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 h-[430px] w-60 overflow-hidden">
            <!-- Card Border Frame -->
            <div class="absolute inset-1 border-2 ${frameBorder} rounded-lg"></div>

            <!-- Header Banner -->
            <div class="relative bg-gradient-to-r ${headerBg} ${headerText} px-3 py-1 text-left border-b-2 ${headerBorder} h-8">
                <div class="absolute top-0.5 right-0.5 bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="${faction.name}">${faction.icon || "\uD83C\uDFE2"}</div>
            </div>

            <!-- Card Content -->
            <div class="relative p-3 bg-gradient-to-b ${cardBg}" style="height: calc(100% - 32px);">
                <!-- Title Section -->
                <div class="h-4 flex items-center justify-between">
                    <h4 class="font-bold ${isEmpty ? "text-gray-500" : "text-white"} text-sm leading-tight contractor-tooltip" data-tippy-content="${isEmpty ? "" : tooltipContent.replace(/"/g, "&quot;").replace(/'/g, "&#39;")}">
                        ${isEmpty ? "Available Slot" : member.name}
                    </h4>
                    ${!isEmpty ? `<div class="text-xs text-game-gold font-bold">Lv.${member.level || 1}</div>` : ""}
                </div>

                <div class="h-4 mb-2">
                    <h3 class="font-italic text-gray-400 text-xs leading-tight">
                        ${isEmpty ? "" : member.title ? member.title : isPlayer ? "Leader" : "Contractor"}
                    </h3>
                </div>

                <!-- Avatar Area -->
                <div class="relative bg-gradient-to-b from-gray-600 to-gray-900 border-2 ${isEmpty ? "border-dashed border-gray-500" : "border-gray-500"} rounded-lg h-[100px] w-full mb-2 overflow-hidden group cursor-pointer">
                    <!-- Avatar -->
                    <div class="absolute inset-0 flex items-center justify-center">
                        ${isEmpty ? `<div class="contractor-avatar-placeholder contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200"></div>` : `<div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" data-avatar-nobg="1" data-avatar-seed="${(0, $42b272c2c0f44bdf$export$f3619081e7e8f116)(member)}" data-avatar-faction="${member.faction}"></div>`}
                    </div>

                    <!-- Status badges -->
                    ${isHired && !raidCompleted ? '<div class="absolute top-1 left-1 bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">HIRED</div>' : ""}
                    ${isHired && raidCompleted && isMarketplaceContractor && context === "team" ? '<div class="absolute top-1 left-1 bg-blue-600 text-white px-2 py-1 rounded text-xs font-bold">RELEASED</div>' : ""}
                    ${isReserved ? '<div class="absolute top-1 left-1 bg-amber-600 text-white px-2 py-1 rounded text-xs font-bold">RESERVED</div>' : ""}
                    ${isMarketplaceContractor ? '<div class="absolute bottom-1 right-1 bg-indigo-600 text-white px-2 py-1 rounded text-xs font-bold">\uD83D\uDC64 PLAYER</div>' : ""}
                    ${relevanceText ? `<div class="absolute top-1 right-1 text-s">${relevanceText}</div>` : ""}
                    ${statusText ? `<div class="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700">${statusText}</div>` : ""}

                    <!-- Quote Overlay at Bottom (hidden by default, shown on hover) -->
                    <div class="${member.quote ? "" : "hidden"} absolute bottom-0 left-0 right-0 ${overlayBg} p-2 border-t ${overlayBorder} transform translate-y-full group-hover:translate-y-0 transition-transform duration-200 z-10">
                        <p class="${overlayText} text-xs leading-tight">${member.quote ? member.quote : ""}</p>
                    </div>
                </div>

                <!-- Skills Section -->
                <div class="mt-2 text-xs space-y-1 mb-3 bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-1 ${isEmpty ? "border-dashed" : ""}" style="height: 185px; overflow-y: auto;">
                    ${isEmpty ? '<div class="text-gray-600 text-center py-8">No skills</div>' : skillsText}
                    ${gearText}
                </div>

                <!-- Footer Section -->
                <div class="absolute bottom-3 left-3 right-3 flex justify-between items-center gap-1">
                    ${costDisplay}
                    ${timerDisplay}
                    <div class="ml-auto">${actionButton}</div>
                </div>
            </div>
        </div>
    `;
}
async function $bd083a63eb37c143$export$fada499eccb8a752() {
    const contractorList = document.getElementById("contractor-list");
    if (!contractorList) return;
    // Get all available contractors (AI + Marketplace)
    const allContractors = await $bd083a63eb37c143$export$362d4c3fa8c04b4b();
    if (!allContractors.length) {
        contractorList.innerHTML = '<p class="text-gray-500 text-center col-span-full">Create a character first to see available contractors.</p>';
        return;
    }
    contractorList.innerHTML = "";
    allContractors.forEach((contractor)=>{
        // Ensure health properties exist and are synchronized
        contractor.maxHp = contractor.maxHp || contractor.max_hp || 100;
        if (contractor.currentHp === undefined) contractor.currentHp = contractor.current_hp || contractor.maxHp;
        const contractorDiv = document.createElement("div");
        contractorDiv.innerHTML = $bd083a63eb37c143$export$5464865996ba2eb4(contractor, "main");
        contractorList.appendChild(contractorDiv.firstElementChild);
    });
}
async function $bd083a63eb37c143$export$362d4c3fa8c04b4b() {
    const contractors = [];
    // Add AI contractors
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors && (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors.length > 0) contractors.push(...(0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors);
    // Add marketplace contractors filtered by selected tier
    try {
        let minLevel = 0;
        let maxLevel = 999;
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier && $ce6dd72bc4611534$export$94e7ad7999c1ae32[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier]) {
            const tier = $ce6dd72bc4611534$export$94e7ad7999c1ae32[(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier];
            minLevel = tier.contractorMinLevel;
            maxLevel = tier.contractorMaxLevel;
        }
        // A contract must have enough time left to see the raid through. If it
        // expires mid-raid the owner reclaims the character locally while it is
        // still in this raid — conflicting state, and the completion payout is
        // blocked by the in_raid guard. Hide those listings rather than strand them.
        const selectedTier = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier || 1;
        const requiredMs = (0, $cdca6b792cc3a32e$export$ff894ad244f3f26e)(selectedTier).avgRaidSeconds * 1000;
        const now = Date.now();
        // You can't hire your own characters — exclude every character this player
        // owns, not just the active one (any of them could be listed).
        const ownCharacterIds = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).characters || []).map((c)=>c.multiplayerId).filter(Boolean);
        const marketplaceContractors = (await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).getMarketplaceListings(minLevel, maxLevel, ownCharacterIds))?.filter((c)=>{
            const expiresAt = c.expires_at || c.expiresAt;
            if (!expiresAt) return true; // no expiry data — let the server decide
            return new Date(expiresAt).getTime() - now >= requiredMs;
        });
        if (marketplaceContractors && marketplaceContractors.length > 0) contractors.push(...marketplaceContractors.map((c)=>({
                ...c,
                // Normalize database field names (snake_case) to the camelCase the
                // game engine reads. equippedTechniqueGear in particular is what the
                // raid/event engine uses to apply a contractor's techniques.
                currentHp: c.current_hp || c.maxHp || c.max_hp || 100,
                maxHp: c.max_hp || 100,
                rewardPercentage: c.reward_percentage || 15,
                equippedTechniqueGear: c.equippedTechniqueGear || c.equipped_technique_gear || {},
                avatarSeed: c.avatarSeed || c.avatar_seed || null,
                avatarFeatures: c.avatarFeatures || c.avatar_features || null
            })));
    } catch (error) {
        console.warn("Could not fetch marketplace contractors:", error);
    }
    return contractors;
}
/**
 * Skeleton Crew refuses a crew. Checked at RESERVATION rather than at raid
 * start, so the answer arrives when the player clicks rather than as a surprise
 * on launch — and it is one helper because there are two ways to reserve
 * (the team panel and the contractor modal) and a guard on only one of them is
 * not a guard.
 */ function $bd083a63eb37c143$var$blackoutBlocksContractors() {
    if (!(0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('noContractors', false)) return false;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDC80 Skeleton Crew: this contract is run alone \u2014 no contractors.", "warning");
    return true;
}
async function $bd083a63eb37c143$export$dc7fd448e3805128(contractorId) {
    const contractor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors.find((c)=>c.id == contractorId);
    if (!contractor) return;
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (!currentCharacter) return;
    if ((0, $cc90b7944b7e868a$export$4c8adf450afe39a2)(contractor.id)) {
        // Release hired contractor (remove from hired list)
        if (contractor.id > 0) await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseHiredContractor(contractor.id, currentCharacter.multiplayerId);
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors.filter((c)=>c.id != contractorId);
    } else if ((0, $cc90b7944b7e868a$export$595cb98aec43dd71)(contractor.id)) {
        // Release reserved contractor (remove from reserved list)
        if (contractor.id > 0) await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseContractor(contractor.id, currentCharacter.multiplayerId);
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter((c)=>c.id != contractorId);
    } else {
        if ($bd083a63eb37c143$var$blackoutBlocksContractors()) return;
        // Check team size limit (player + 2 contractors max)
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u26A0\uFE0F Team is full! Maximum 3 members (you + 2 contractors).", "warning");
            return;
        }
        // Try to reserve contractor in database first (for multiplayer contractors)
        if (contractor.multiplayerId) {
            const reservationResult = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).reserveContractor(contractor.multiplayerId, currentCharacter.multiplayerId);
            if (!reservationResult.success) {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{274C} ${reservationResult.message}`, "error");
                return;
            }
        }
        // Reserve contractor (add to reserved list - no cost yet)
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.push(contractor);
    }
    // Update Alpine store
    Alpine.store("contractors").refresh();
    (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)(); // Update raid team display
    (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
    (0, $a52c72724dfd3eca$export$f4fa7fe8ae486c6)(); // Update current path skill coverage
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
}
function $bd083a63eb37c143$export$9a18f3125e8e0eca() {
    const modal = document.getElementById("contractor-modal");
    modal.classList.remove("hidden");
    // Add entrance animation
    modal.classList.add("animate__animated", "animate__fadeIn");
    modal.querySelector(".modal-content").classList.add("animate__animated", "animate__zoomIn");
// Alpine.js now handles the contractor display reactively
}
function $bd083a63eb37c143$export$5d484cf67c77323e() {
    const modal = document.getElementById("contractor-modal");
    const modalContent = modal.querySelector(".modal-content");
    // Add exit animation
    modal.classList.add("animate__animated", "animate__fadeOut");
    modalContent.classList.add("animate__animated", "animate__zoomOut");
    // Hide modal after animation completes
    setTimeout(()=>{
        modal.classList.add("hidden");
        // Clean up animation classes
        modal.classList.remove("animate__animated", "animate__fadeIn", "animate__fadeOut");
        modalContent.classList.remove("animate__animated", "animate__zoomIn", "animate__zoomOut");
    }, 150);
}
function $bd083a63eb37c143$export$b98752098fb87559(contractor, pathSkills, teamSkills) {
    const contractorSkills = Object.keys(contractor.skills);
    // Count skills that are needed for the path
    const totalNeededSkills = contractorSkills.filter((skill)=>pathSkills.has(skill)).length;
    // Count skills that are needed but not covered by current team
    const uncoveredNeededSkills = contractorSkills.filter((skill)=>pathSkills.has(skill) && (teamSkills[skill] || 0) === 0).length;
    return {
        uncoveredNeededSkills: uncoveredNeededSkills,
        totalNeededSkills: totalNeededSkills
    };
}
async function $bd083a63eb37c143$export$959fb65d2b5e760e(contractorId) {
    // Find contractor in Alpine store (includes both AI and marketplace contractors)
    //const contractor = Alpine.store('contractors').all.find(c => c.id == contractorId);
    const contractor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors.find((c)=>c.id == contractorId);
    // console.log('Reserving contractor from modal:', contractorId, contractor, isContractorReserved(contractorId));
    if (!contractor || (0, $cc90b7944b7e868a$export$595cb98aec43dd71)(contractorId)) return;
    if ($bd083a63eb37c143$var$blackoutBlocksContractors()) return;
    const currentCharacter = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
    if (!currentCharacter) return;
    // Check team size limit (player + 2 contractors max)
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u26A0\uFE0F Team is full! Maximum 3 members (you + 2 contractors).", "warning");
        return;
    }
    // Handle marketplace contractors (positive ID) vs AI contractors (negative ID)
    if (contractor.id > 0) {
        // Marketplace contractor - reserve via server
        const reservationResult = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).reserveContractor(contractor.id, currentCharacter.multiplayerId);
        if (reservationResult.success) // Add marketplace contractor with expiration time from backend
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.push({
            ...contractor,
            reservedAt: Date.now(),
            reservationExpires: new Date(reservationResult.expiresAt).getTime()
        });
        else {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{274C} ${reservationResult.message}`, "error");
            return;
        }
    } else // AI contractor (negative ID) - no server reservation needed
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.push(contractor);
    // Update Alpine store
    if (Alpine.store("contractors")) Alpine.store("contractors").updateReserved((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors);
    (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
    (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
    (0, $a52c72724dfd3eca$export$f4fa7fe8ae486c6)(); // Update current path skill coverage
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    // Auto-close modal if team is now full
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) setTimeout(()=>{
        $bd083a63eb37c143$export$5d484cf67c77323e();
    }, 500); // Small delay to let user see the action complete
}
function $bd083a63eb37c143$export$3e71fa030a894242(timePassedMs) {
    const raidTeam = (0, $cc90b7944b7e868a$export$d17f5534c14b3dc5)();
    let hasChanges = false;
    raidTeam.forEach((member)=>{
        hasChanges = hasChanges || (0, $1b3f8df6e579f420$export$11d38807a029df6f)(member, timePassedMs);
    });
    return hasChanges;
}
function $bd083a63eb37c143$export$797aa5f00658ac19() {
    const now = Date.now();
    const expiredContractors = [];
    // Find expired marketplace contractor reservations
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach((contractor)=>{
        if (contractor.id > 0 && contractor.reservationExpires && contractor.reservationExpires < now) expiredContractors.push(contractor);
    });
    if (expiredContractors.length > 0) {
        // Remove expired reservations
        expiredContractors.forEach((contractor)=>{
            // console.log(`Reservation expired for marketplace contractor: ${contractor.name}`);
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter((c)=>c.id !== contractor.id);
        });
        // Update displays
        if (Alpine.store("contractors")) Alpine.store("contractors").updateReserved((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors);
        (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
        (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${expiredContractors.length} contractor reservation(s) expired`, "info");
        return true;
    } else return false;
}
function $bd083a63eb37c143$export$1b23387deaaf022d() {
    const now = Date.now();
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach((contractor)=>{
        if (contractor.id > 0 && contractor.reservationExpires) {
            const timerElement = document.getElementById(`reservation-timer-${contractor.id}`);
            if (timerElement) {
                const timeLeft = Math.max(0, Math.floor((contractor.reservationExpires - now) / 1000));
                const minutes = Math.floor(timeLeft / 60);
                const seconds = timeLeft % 60;
                timerElement.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`;
            }
        }
    });
}



//done
//@ts-check











function $803c9a726c40de05$export$7532162a9c4df7a1() {
    // Alpine.js Contractor Store
    (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors', {
        list: [],
        reserved: [],
        hired: [],
        init () {
            // Initialize with current gameState data
            this.refresh();
        },
        async refresh () {
            // Update store from gameState (AI contractors) + marketplace contractors
            this.list = await (0, $bd083a63eb37c143$export$362d4c3fa8c04b4b)();
            // console.log('Contractors refreshed, total contractors:', this.list.length, this.list);
            this.reserved = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors || [];
            this.hired = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors || [];
            // Update status on all contractor objects
            this.updateContractorStatuses();
        },
        async update (newContractors) {
            // Update both gameState and Alpine store
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors = newContractors;
            await this.refresh();
        },
        updateReserved (newReserved) {
            // Update both gameState and Alpine store
            // console.log('Store updateReserved called with:', newReserved);
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = newReserved;
            this.reserved = newReserved;
            // console.log('Store reserved array updated to:', this.reserved);
            // Update status on all contractor objects
            this.updateContractorStatuses();
        },
        updateHired (newHired) {
            // Update both gameState and Alpine store
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = newHired;
            this.hired = newHired;
            // Update status on all contractor objects
            this.updateContractorStatuses();
        },
        updateContractorStatuses () {
            // Create copies of contractors with status field for the store only
            const reservedIds = this.reserved.map((c)=>c.id);
            const hiredIds = this.hired.map((c)=>c.id);
            // Get current path skills and team skills for relevance calculation
            const pathSkills = (0, $cc90b7944b7e868a$export$1311cf265aa89b71)();
            const teamSkills = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1)();
            this.list = this.list.map((contractor)=>{
                const contractorCopy = {
                    ...contractor
                };
                // Calculate status
                if (contractor.injuredUntil && contractor.injuredUntil > Date.now()) contractorCopy.status = 'injured';
                else if (hiredIds.includes(contractor.id)) contractorCopy.status = 'hired';
                else if (reservedIds.includes(contractor.id)) contractorCopy.status = 'reserved';
                else contractorCopy.status = 'available';
                // Calculate skill relevance indicators
                const contractorSkills = Object.keys(contractor.skills || {});
                const totalNeededSkills = contractorSkills.filter((skill)=>pathSkills.has(skill)).length;
                const uncoveredNeededSkills = contractorSkills.filter((skill)=>pathSkills.has(skill) && (teamSkills[skill] || 0) === 0).length;
                let maxLevelNeededSkill = 0;
                contractorSkills.filter((skill)=>pathSkills.has(skill) && (teamSkills[skill] || 0) === 0).forEach((skill)=>{
                    if (contractor.skills[skill] > maxLevelNeededSkill) maxLevelNeededSkill = contractor.skills[skill];
                });
                // Add relevance properties to contractor copy
                contractorCopy.totalNeededSkills = totalNeededSkills;
                contractorCopy.uncoveredNeededSkills = uncoveredNeededSkills;
                contractorCopy.hasNeededSkills = totalNeededSkills > 0;
                contractorCopy.hasUncoveredSkills = uncoveredNeededSkills > 0;
                contractorCopy.maxLevelNeededSkill = maxLevelNeededSkill;
                // Synergy relevance: ready (partner gear equipped on the
                // prospective team, or their gear partners your skills) vs
                // swap-possible (player owns an unequipped partner device)
                const synergy = (0, $e7dde87afbac6dd8$export$9163caedda99cb08)(contractor);
                contractorCopy.hasSynergyReady = synergy.hasReady;
                contractorCopy.hasSynergySwap = synergy.hasSwap;
                return contractorCopy;
            });
        },
        get all () {
            return this.list;
        },
        get allReserved () {
            return this.reserved;
        },
        get allHired () {
            return this.hired;
        },
        get count () {
            return this.list.length;
        },
        get reservedIds () {
            return this.reserved.map((c)=>c.id);
        },
        get hiredIds () {
            return this.hired.map((c)=>c.id);
        }
    });
}
function $803c9a726c40de05$export$ecfe6fdf513f3742() {
    return {
        searchTerm: '',
        selectedFaction: '',
        selectedStatus: '',
        synergyFilter: '',
        get contractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.all;
        },
        get synergyRevealed () {
            // The synergy filter only exists once the layer is revealed
            return (0, $1b3f8df6e579f420$export$aaee02d18e8a1c01)();
        },
        get reservedContractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.allReserved;
        },
        get hiredContractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.allHired;
        },
        get filteredContractors () {
            let filtered = this.contractors;
            let hired = this.hiredContractors;
            let reserved = this.reservedContractors;
            // Search filter (name and skills)
            if (this.searchTerm) {
                const term = this.searchTerm.toLowerCase();
                filtered = filtered.filter((contractor)=>{
                    // Search name
                    if (contractor.name.toLowerCase().includes(term)) return true;
                    // Search skills
                    const skillNames = Object.entries(contractor.skills || {}).map(([key, level])=>{
                        const skillInfo = this.getSkillInfo(key, contractor.faction);
                        return skillInfo ? skillInfo.name : key;
                    }).join(' ').toLowerCase();
                    return skillNames.includes(term);
                });
            }
            // Faction filter
            if (this.selectedFaction) filtered = filtered.filter((contractor)=>contractor.faction === this.selectedFaction);
            // Status filter
            if (this.selectedStatus) filtered = filtered.filter((contractor)=>{
                const status = this.getContractorStatus(contractor);
                return status === this.selectedStatus;
            });
            // Synergy filter: 'ready' = partner gear already on the team (or
            // their gear partners your skills); 'possible' also counts
            // contractors one player gear swap away
            if (this.synergyFilter === 'ready') filtered = filtered.filter((c)=>c.hasSynergyReady);
            else if (this.synergyFilter === 'possible') filtered = filtered.filter((c)=>c.hasSynergyReady || c.hasSynergySwap);
            // console.log('Contractors filtered, total contractors:', filtered.length, filtered);
            return filtered;
        },
        get modalSortedContractors () {
            const reservedCount = this.$store.contractors.reserved.length;
            // console.log('modalSortedContractors called, reserved count:', reservedCount);
            // Filter to only available contractors for modal
            let available = this.filteredContractors.filter((contractor)=>{
                const isAvailable = contractor.status === 'available';
                const teamNotFull = reservedCount < 2;
                //console.log(`Contractor ${contractor.name}: status=${contractor.status}, teamNotFull=${teamNotFull}`);
                return isAvailable && teamNotFull;
            });
            // Sort by relevance using pre-calculated properties
            return available.sort((a, b)=>{
                // Primary sort: contractors with uncovered needed skills first
                if (a.uncoveredNeededSkills !== b.uncoveredNeededSkills) return b.uncoveredNeededSkills - a.uncoveredNeededSkills;
                // Secondary sort: level of uncovered needed skills
                if (a.maxLevelNeededSkill !== b.maxLevelNeededSkill) return b.maxLevelNeededSkill - a.maxLevelNeededSkill;
                // Tertiary sort: contractors with any needed skills
                if (a.totalNeededSkills !== b.totalNeededSkills) return b.totalNeededSkills - a.totalNeededSkills;
                // Quaternary sort: contractors with higher reward percentage
                return a.rewardPercentage - b.rewardPercentage;
            });
        },
        getContractorStatus (contractor) {
            // Return the pre-calculated status field
            return contractor.status || 'available';
        },
        getSkillInfo (skillKey, faction) {
            return $ce6dd72bc4611534$export$aeeef991191508e2[faction]?.skills[skillKey] || null;
        },
        createContractorCardHTML (contractor) {
            return (0, $bd083a63eb37c143$export$5464865996ba2eb4)(contractor, 'main');
        },
        clearFilters () {
            this.searchTerm = '';
            this.selectedFaction = '';
            this.selectedStatus = '';
            this.synergyFilter = '';
        },
        // Force refresh contractors from gameState
        refreshContractors () {
            // Trigger reactivity by accessing the getter
            this.contractors;
            this.$nextTick();
        },
        // Refresh contractors when the component is initialized or updated
        init () {
            // Initial refresh
            this.refreshContractors();
            // Make sure store is initialized with current data
            this.$store.contractors.refresh();
            // console.log('Initial store state - reserved:', this.$store.contractors.reserved);
            // Watch for game state changes and refresh
            this.$watch('contractors', ()=>{
                this.$nextTick(()=>{
                    // Ensure event handlers are attached to new elements
                    $803c9a726c40de05$export$6df34f7d682befe6();
                });
            });
            // Watch for reserved contractors changes in the store
            this.$watch('$store.contractors.reserved', (newValue, oldValue)=>{
                // console.log('Reserved contractors changed in store from', oldValue, 'to', newValue);
                this.$store.contractors.updateContractorStatuses();
                this.$nextTick();
            });
            // Watch for hired contractors changes in the store
            this.$watch('$store.contractors.hired', (newValue, oldValue)=>{
                // console.log('Hired contractors changed in store from', oldValue, 'to', newValue);
                this.$store.contractors.updateContractorStatuses();
                this.$nextTick();
            });
        }
    };
}
function $803c9a726c40de05$export$6df34f7d682befe6() {
    // Reattach click handlers for contractor buttons
    document.querySelectorAll('.contractor-card .hire-btn').forEach((btn)=>{
        const contractorId = btn.getAttribute('data-contractor-id');
        if (contractorId) btn.onclick = ()=>(0, $bd083a63eb37c143$export$dc7fd448e3805128)(contractorId);
    });
}
function $803c9a726c40de05$export$17502054442d56b0() {
    // Update the Alpine store with current gameState data
    if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors')) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store('contractors').refresh();
}







/**
 * Command - UI layer for the Command prestige layer (M2)
 *
 * Pure logic lives in command-core.js; this module renders the Command tab
 * (stats strip, upgrade roster, Legends gallery), the promote modal, and the
 * Regional Charter region-pick modal, and wires the header marks chip + tab
 * reveal. Player-facing verb is always promote/promotion.
 */ 








/**
 * The Legend card — one renderer, used by Command's gallery and the Syndicate
 * Charter's leadership panel.
 *
 * Its own module rather than living in either layer's UI file, because both
 * would otherwise have to import the other. Pure render: no gameState reads, no
 * DOM writes, so it can be dropped into any container.
 *
 * FIELDS ARE OPTIONAL BY DESIGN. A Command Legend snapshot carries the full tour
 * record (tech gear, artifacts, T3 wins); a Syndicate Leader snapshot carries
 * only the identity and the marks that elected them. Rendering only what is
 * present is what lets one card serve both, rather than two cards drifting.
 *
 * Colour comes in as `accent`/`accentDim` — the layers have different identity
 * colours and the card is the same object in both.
 */ 

/**
 * One stat line, or nothing when the field is absent.
 *
 * Values are coloured with an inline style, NOT `text-[${accent}]`. That was a
 * Tailwind arbitrary-value class built from a runtime variable, so the
 * build-time scanner never generated it — there is not a single `text-[#...]`
 * rule in the compiled CSS, and every Legend stat rendered unstyled. Same family
 * as the dead `text-navy`. Runtime colour has to be an inline style.
 */ function $03d1ca7da93421d9$var$statLine(label, value, accent) {
    if (value === undefined || value === null) return '';
    return `${label}: <span class="tracking-tighter" style="color:${accent}">${value}</span><br/>`;
}
function $03d1ca7da93421d9$export$5eeeb728aab285f9(legend, { accent: accent, accentDim: accentDim, title: title = '', note: note = '' } = {}) {
    if (!legend) return '';
    const faction = $ce6dd72bc4611534$export$aeeef991191508e2[legend.faction] || {};
    const marks = (legend.marksEarned || 0).toLocaleString();
    return `
        <div class="flex gap-3 bg-white/5 rounded-lg p-3" style="border:1px solid ${accentDim};">
            <div class="relative w-[96px] h-[96px] flex-shrink-0 rounded-lg border-2 border-gray-500 bg-gradient-to-b from-gray-800 to-gray-900 overflow-hidden">
                <div class="absolute inset-0 flex items-center justify-center">
                    <div class="contractor-avatar-placeholder" data-avatar-seed="${(0, $42b272c2c0f44bdf$export$f3619081e7e8f116)(legend)}" data-avatar-faction="${legend.faction}"></div>
                </div>
                <div class="absolute top-1 left-1 bg-black bg-opacity-40 border border-gray-500 rounded-full w-5 h-5 flex items-center justify-center text-xs" title="${faction.name || legend.faction}">${faction.icon || "\uD83C\uDFE2"}</div>
                ${legend.tour ? `<div class="absolute bottom-0 left-0 right-0 text-center text-[10px] tracking-widest py-0.5 bg-black/75" style="color:${accent}">TOUR ${legend.tour}</div>` : ''}
            </div>
            <div class="text-xs leading-relaxed min-w-0">
                ${title ? `<div class="text-[10px] uppercase tracking-widest text-gray-400">${title}</div>` : ''}
                <div class="font-bold text-white text-base">${legend.name}</div>
                ${legend.promotedRole ? `Now: <span class="font-bold" style="color:${accent}">${legend.promotedRole}</span><br/>` : ''}
                ${$03d1ca7da93421d9$var$statLine('Max Lv.', legend.level, accent)}
                ${$03d1ca7da93421d9$var$statLine('Skill Gear', legend.techGear === undefined ? undefined : `${legend.techGear}/15 crafted`, accent)}
                ${$03d1ca7da93421d9$var$statLine('Artifacts Unlocked', legend.artifactsUnlocked, accent)}
                ${$03d1ca7da93421d9$var$statLine('Artifacts Crafted', legend.artifactsCrafted, accent)}
                ${$03d1ca7da93421d9$var$statLine('T3 Successful', legend.t3Wins, accent)}
                <span class="text-game-gold tracking-tighter">Tour Marks: ${marks}\u{1F396}\u{FE0F}</span>
                ${note ? `<div class="text-gray-400 mt-1">${note}</div>` : ''}
            </div>
        </div>`;
}





/**
 * Raid Path Core - pure grid pathfinding shared by the game and simulator.
 *
 * Extracted from the simulator's battle-tested player model for the
 * Auto-Scout Command upgrade: BFS start→exit maximizing (in order)
 * character skill match, special-room placement (water before campsite,
 * both near mid-path), encounter count, then path length. Encounter rooms
 * (gate/hazard) are capped at rows+cols-1; traversal rooms are free.
 */ /**
 * Score special-room placement: water before campsite, both near the middle.
 */ function $d81945fd20294c5c$export$307e743d4e5af7c0(path) {
    let waterIndex = -1;
    let campsiteIndex = -1;
    for(let i = 0; i < path.length; i++){
        if (path[i].room?.type === 'water' && waterIndex === -1) waterIndex = i;
        if (path[i].room?.type === 'campsite' && campsiteIndex === -1) campsiteIndex = i;
    }
    const pathLength = path.length;
    const midpoint = pathLength / 2;
    const tolerance = pathLength * 0.25;
    let score = 0;
    // Each special room is a free benefit (fishing / healing) worth grabbing
    // whenever it adds no encounters. Keep every contribution strictly
    // NON-NEGATIVE so the pathfinder never rejects a free detour: the old
    // wrong-order penalty (-500) could make a free water+campsite detour score
    // worse than skipping it, so auto-scout would walk past free healing.
    if (waterIndex !== -1) score += 500 + Math.max(0, tolerance - Math.abs(waterIndex - midpoint)) * 10;
    if (campsiteIndex !== -1) score += 500 + Math.max(0, tolerance - Math.abs(campsiteIndex - midpoint)) * 10;
    // Prefer drinking (water) before resting (campsite) when both are present,
    // but only as a small tie-breaker between paths that already grab both -
    // never a penalty that would reject a free room.
    if (waterIndex !== -1 && campsiteIndex !== -1 && waterIndex < campsiteIndex) score += 100;
    return score;
}
function $d81945fd20294c5c$export$ae716df5a29b8f48(room, characterSkills, skillTargets) {
    const type = room?.type;
    if (type !== 'gate' && type !== 'hazard') return 0;
    // Without skill targets every encounter is worth exactly 1, which makes the
    // running score identical to the old raw encounter count - so callers that
    // do not opt in get byte-for-byte the previous pathfinding.
    if (!skillTargets) return 1;
    // Expected skill events per room (gate 2-4, hazard 1-2).
    const exposure = type === 'gate' ? 3 : 1.5;
    const target = type === 'gate' ? skillTargets.gate : skillTargets.hazard;
    const skill = characterSkills?.[room.primary] || 0;
    const deficit = Math.max(0, target - skill);
    // At or above the bar the room is worth taking: it is loot the team can
    // reach. Below it, each missing level costs ~5% per event, so the penalty
    // scales with both the shortfall and the number of rolls.
    return deficit === 0 ? exposure : -exposure * deficit;
}
function $d81945fd20294c5c$export$f43380d00e970f98(path, characterSkills, skillTargets) {
    let score = 0;
    for (const step of path)score += $d81945fd20294c5c$export$ae716df5a29b8f48(step.room, characterSkills, skillTargets);
    return score;
}
function $d81945fd20294c5c$export$fe54d8e6fd3d69ac(path, characterSkills) {
    if (!characterSkills) return 0;
    let score = 0;
    for (const step of path){
        if (!step.room || step.room.type === 'blocked') continue;
        if (!step.room.primary) continue;
        const primarySkillLevel = characterSkills[step.room.primary] || 0;
        if (primarySkillLevel > 0) score += 100 + primarySkillLevel * 10;
        if (step.room.support && Array.isArray(step.room.support)) for (const supportSkill of step.room.support){
            const supportSkillLevel = characterSkills[supportSkill] || 0;
            if (supportSkillLevel > 0) score += 30 + supportSkillLevel * 5;
        }
    }
    return score;
}
function $d81945fd20294c5c$export$4c0915d8c3abf5d2(path, wantedCells) {
    if (!wantedCells || wantedCells.size === 0) return 0;
    let score = 0;
    for (const step of path)if (wantedCells.has(`${step.row},${step.col}`)) score++;
    return score;
}
const $d81945fd20294c5c$var$TRAVERSAL_TYPES = new Set([
    'road',
    'water',
    'campsite',
    'start',
    'exit'
]);
const $d81945fd20294c5c$var$isSpecialType = (t)=>t === 'water' || t === 'campsite';
const $d81945fd20294c5c$var$isEncounterType = (t)=>t === 'gate' || t === 'hazard';
/**
 * Shortest free "leg" from A to B through unused traversal cells (road / water /
 * campsite - never gate/hazard) that passes through at least one special room.
 * Returns the intermediate cells [{row,col,room}] or null. `blocked` is the set
 * of "row,col" keys the leg may not step on (committed path cells).
 */ function $d81945fd20294c5c$var$findFreeSpecialLeg(grid, A, B, blocked, maxLen) {
    const rows = grid.rows, cols = grid.cols;
    const dirs = [
        [
            -1,
            0
        ],
        [
            1,
            0
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ]
    ];
    const seen = new Set([
        `${A.row},${A.col},0`
    ]);
    const queue = [
        {
            row: A.row,
            col: A.col,
            specials: 0,
            cells: []
        }
    ];
    let best = null; // legs reaching B: keep the one grabbing the MOST specials (then shortest)
    while(queue.length > 0){
        const cur = queue.shift();
        if (cur.cells.length >= maxLen) continue;
        for (const [dr, dc] of dirs){
            const nr = cur.row + dr, nc = cur.col + dc;
            if (nr < 0 || nc < 0 || nr >= rows || nc >= cols) continue;
            const room = grid.grid[nr]?.[nc];
            if (!room) continue;
            if (nr === B.row && nc === B.col) {
                if (cur.specials > 0 && cur.cells.length > 0 && (!best || cur.specials > best.specials || cur.specials === best.specials && cur.cells.length < best.cells.length)) best = {
                    cells: cur.cells,
                    specials: cur.specials
                };
                continue; // reached B - don't route through it
            }
            if (blocked.has(`${nr},${nc}`)) continue;
            if (!$d81945fd20294c5c$var$TRAVERSAL_TYPES.has(room.type)) continue; // never route a detour through an encounter
            if (cur.cells.some((c)=>c.row === nr && c.col === nc)) continue; // no intra-leg revisits
            const specials = cur.specials + ($d81945fd20294c5c$var$isSpecialType(room.type) ? 1 : 0);
            const key = `${nr},${nc},${specials}`;
            if (seen.has(key)) continue;
            seen.add(key);
            queue.push({
                row: nr,
                col: nc,
                specials: specials,
                cells: [
                    ...cur.cells,
                    {
                        row: nr,
                        col: nc,
                        room: room
                    }
                ]
            });
        }
    }
    return best ? best.cells : null;
}
function $d81945fd20294c5c$export$c8e849ec9d7205c9(path, grid) {
    if (!path || path.length < 3 || !grid) return path;
    // Anchors are the rooms we must keep in order: start, exit, every encounter.
    const anchorIdx = [];
    for(let i = 0; i < path.length; i++)if (i === 0 || i === path.length - 1 || $d81945fd20294c5c$var$isEncounterType(path[i].room?.type)) anchorIdx.push(i);
    if (anchorIdx.length < 2) return path;
    // All original cells are reserved; each segment frees only its OWN traversal
    // cells before rerouting, so a detour can reuse this segment's roads but never
    // steal another segment's cells.
    const committed = new Set(path.map((s)=>`${s.row},${s.col}`));
    const result = [
        path[anchorIdx[0]]
    ];
    for(let a = 0; a < anchorIdx.length - 1; a++){
        const startI = anchorIdx[a], endI = anchorIdx[a + 1];
        const A = path[startI], B = path[endI];
        for(let k = startI + 1; k < endI; k++)committed.delete(`${path[k].row},${path[k].col}`);
        const segLen = endI - startI - 1;
        // Allow the reroute to run up to 6 rooms longer than the straight stretch:
        // enough to thread BOTH the water and the adjacent campsite (a 2-cell pair)
        // plus a few connector roads, without wandering far for a distant special.
        const leg = $d81945fd20294c5c$var$findFreeSpecialLeg(grid, A, B, committed, segLen + 6);
        if (leg) for (const c of leg){
            result.push(c);
            committed.add(`${c.row},${c.col}`);
        }
        else for(let k = startI + 1; k < endI; k++){
            result.push(path[k]);
            committed.add(`${path[k].row},${path[k].col}`);
        }
        result.push(B);
    }
    return result;
}
function $d81945fd20294c5c$export$bbcc6782bce81af0(currentRaidGrid, startPos, endPos, characterSkills, wantedCells = null, skillTargets = null) {
    const rows = currentRaidGrid.rows;
    const cols = currentRaidGrid.cols;
    // Max encounters based on grid dimensions (only gate/hazard count)
    const maxPathLength = (rows || currentRaidGrid.size) + (cols || currentRaidGrid.size) - 1;
    const countsTowardLimit = new Set([
        'gate',
        'hazard'
    ]);
    const startStep = {
        row: startPos.row,
        col: startPos.col,
        room: currentRaidGrid.grid[startPos.row][startPos.col]
    };
    const visited = new Map(); // "row,col" -> { path, encounterCount, pathLength }
    const queue = [
        {
            pos: startPos,
            path: [
                startStep
            ],
            encounterCount: countsTowardLimit.has(startStep.room?.type) ? 1 : 0,
            // Running risk-weighted value of the encounters taken so far. Carried
            // incrementally (rather than rescored per candidate) so it can drive the
            // visited-pruning below without an O(path) cost at every node.
            encounterScore: $d81945fd20294c5c$export$ae716df5a29b8f48(startStep.room, characterSkills, skillTargets)
        }
    ];
    let bestExitPath = null;
    let bestEncounterScore = -Infinity;
    let bestPathLength = -1;
    let bestSpecialRoomsScore = -Infinity;
    let bestSkillMatchScore = -Infinity;
    let bestWantedScore = -Infinity;
    while(queue.length > 0){
        const { pos: pos, path: path, encounterCount: encounterCount, encounterScore: encounterScore } = queue.shift();
        const cellKey = `${pos.row},${pos.col}`;
        if (pos.row === endPos.row && pos.col === endPos.col) {
            const wantedScore = $d81945fd20294c5c$export$4c0915d8c3abf5d2(path, wantedCells);
            const specialRoomsScore = $d81945fd20294c5c$export$307e743d4e5af7c0(path);
            const skillMatchScore = $d81945fd20294c5c$export$fe54d8e6fd3d69ac(path, characterSkills);
            // Lexicographic: wanted loot > skill match > special rooms > encounters > length
            const candidate = [
                wantedScore,
                skillMatchScore,
                specialRoomsScore,
                encounterScore,
                path.length
            ];
            const best = [
                bestWantedScore,
                bestSkillMatchScore,
                bestSpecialRoomsScore,
                bestEncounterScore,
                bestPathLength
            ];
            const better = candidate.findIndex((v, i)=>v !== best[i]);
            if (better !== -1 && candidate[better] > best[better]) {
                bestWantedScore = wantedScore;
                bestSkillMatchScore = skillMatchScore;
                bestSpecialRoomsScore = specialRoomsScore;
                bestEncounterScore = encounterScore;
                bestPathLength = path.length;
                bestExitPath = path;
            }
            continue;
        }
        // Keep the best-VALUED route to each cell, not the one with the most
        // encounter rooms. These are the same thing without skillTargets (every
        // encounter scores 1), but once rooms are risk-weighted a safer route must
        // be able to survive here - pruning on raw count discarded it before the
        // ranking below ever saw it, which is why weighting alone changed nothing.
        if (visited.has(cellKey)) {
            const prev = visited.get(cellKey);
            if (encounterScore < prev.encounterScore || encounterScore === prev.encounterScore && path.length <= prev.pathLength) continue;
        }
        visited.set(cellKey, {
            path: path,
            encounterCount: encounterCount,
            encounterScore: encounterScore,
            pathLength: path.length
        });
        if (encounterCount > maxPathLength) continue;
        const directions = [
            {
                row: -1,
                col: 0
            },
            {
                row: 1,
                col: 0
            },
            {
                row: 0,
                col: -1
            },
            {
                row: 0,
                col: 1
            }
        ];
        for (const dir of directions){
            const newRow = pos.row + dir.row;
            const newCol = pos.col + dir.col;
            if (newRow < 0 || newRow >= rows || newCol < 0 || newCol >= cols) continue;
            if (path.some((p)=>p.row === newRow && p.col === newCol)) continue;
            const room = currentRaidGrid.grid[newRow][newCol];
            if (!room || room.type === 'blocked') continue;
            const newEncounterCount = countsTowardLimit.has(room.type) ? encounterCount + 1 : encounterCount;
            if (newEncounterCount > maxPathLength) continue;
            queue.push({
                pos: {
                    row: newRow,
                    col: newCol
                },
                path: [
                    ...path,
                    {
                        row: newRow,
                        col: newCol,
                        room: room
                    }
                ],
                encounterCount: newEncounterCount,
                encounterScore: encounterScore + $d81945fd20294c5c$export$ae716df5a29b8f48(room, characterSkills, skillTargets)
            });
        }
    }
    return bestExitPath || [];
}


/**
 * Auto-Raid Protocol (M3 S3a) — runs the L1 loop hands-off.
 *
 * The raid itself is already timer-driven; this automates the button clicks
 * around it. One cycle is: generate grid → chart a path (Auto-Scout) → staff it
 * (Foreman's Ledger) → RE-TOOL → launch → wait → collect → repeat.
 *
 * TICK-DRIVEN, NOT AN ASYNC CHAIN. Each tick advances at most one step and
 * decides what to do purely from `gameState`, so a reload mid-raid resumes
 * correctly, a player taking manual control is noticed on the next tick, and
 * there is no long-lived promise holding a stale view of the world. The cost is
 * that this reads as a state machine rather than a script; that is the point.
 *
 * WHY THE RE-TOOL STEP IS NOT OPTIONAL (docs/layers/3-syndicate/design.md §4.1):
 * gear coverage is not "one device per skill". Whether a synergy variant fires
 * depends on the pairing between the player's tooled technique and what the
 * hired crew brings, so a kit that synergised with the last crew may synergise
 * with none of this one's. A player does this by hand off the `swap` prompt.
 * Automating the raid WITHOUT automating the swap would make automation a
 * downgrade in loot quality — the upgrade would actively cost the player value.
 * Same argument for artifact slots, which are otherwise frozen at whatever was
 * crafted first.
 */ 








const $9f2007d9cd6d0433$export$c4294a4a90e8256d = 0.5;
/** Guards against two cycles overlapping while an await is in flight. */ let $9f2007d9cd6d0433$var$stepInFlight = false;
function $9f2007d9cd6d0433$export$d386ff630e305d9f() {
    return (0, $bde36de43872f734$export$12c456cbb12a94a8)('auto-raid-protocol') > 0;
}
function $9f2007d9cd6d0433$export$c750660aba17086b() {
    return $9f2007d9cd6d0433$export$d386ff630e305d9f() && (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings?.autoRaidEnabled === true;
}
function $9f2007d9cd6d0433$export$c790bcc16caca94(enabled) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).settings) (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings.autoRaidEnabled = !!enabled;
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings.autoRaidEnabled;
}
function $9f2007d9cd6d0433$export$18302fe48a4c0c92() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character) return {
        code: 'no-character',
        text: 'No active character'
    };
    if (character.isAlive === false) return {
        code: 'character-down',
        text: 'Your character is down'
    };
    if (character.isMarketplace || character.marketplaceData) return {
        code: 'listed',
        text: 'Character is listed on the marketplace'
    };
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid || {};
    if (raid.raidOwnerId && raid.raidOwnerId !== (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) return {
        code: 'not-owner',
        text: 'Another character owns the current raid'
    };
    // Blackouts are DELIBERATE challenge content: the whole point is a player
    // choosing to run under hard modifiers. Automation clearing one would pay a
    // permanent perk for a decision nobody made — and Lights Out disables the
    // Auto-Scout this loop depends on, so it could not run it anyway.
    if ((0, $45c49e7f6d2032d6$export$f266a4caac7fb67d)()) return {
        code: 'blackout-armed',
        text: "Blackout contract armed \u2014 challenge raids are run by hand"
    };
    if (!raid.selectedRegion || !raid.selectedTier) // Deliberately NOT auto-picked. Region and tier are the player's
    // standing orders — the automation executes them, it does not choose
    // them, and silently raiding somewhere unintended is worse than idling.
    return {
        code: 'no-orders',
        text: "Pick a region and tier \u2014 automation runs those orders"
    };
    const team = $9f2007d9cd6d0433$var$raidTeam();
    const hpFraction = $9f2007d9cd6d0433$var$teamHpFraction(team);
    if (hpFraction < $9f2007d9cd6d0433$export$c4294a4a90e8256d) return {
        code: 'low-hp',
        text: `Team at ${Math.round(hpFraction * 100)}% HP \u{2014} resting`
    };
    return null;
}
function $9f2007d9cd6d0433$var$raidTeam() {
    const hired = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.hiredContractors || [];
    return [
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character,
        ...hired
    ].filter(Boolean);
}
function $9f2007d9cd6d0433$var$teamHpFraction(team) {
    const max = team.reduce((sum, m)=>sum + (m.maxHp || 0), 0);
    if (max <= 0) return 1;
    return team.reduce((sum, m)=>sum + (m.currentHp || 0), 0) / max;
}
function $9f2007d9cd6d0433$export$7db30007ec79b8c() {
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid || {};
    if (!raid.selectedPath || raid.selectedPath.length < 2 || !raid.selectedTier) return null;
    return (0, $cc90b7944b7e868a$export$78de3bc967b7be)(raid.selectedTier, raid.selectedPath);
}
/**
 * Stop automation and tell the player why.
 *
 * Sticky on purpose: automation stopping is the one thing an idle player must
 * not miss — the whole value of the upgrade is not having to watch it, so a
 * message that fades in 5s would strand them doing nothing for hours.
 */ function $9f2007d9cd6d0433$var$haltWith(message) {
    $9f2007d9cd6d0433$export$c790bcc16caca94(false);
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F916} Auto-Raid stopped \u{2014} ${message}`, 'warning', {
        sticky: true
    });
}
function $9f2007d9cd6d0433$export$9f0fd7c5580c292() {
    if (!$9f2007d9cd6d0433$export$c750660aba17086b() || $9f2007d9cd6d0433$export$18302fe48a4c0c92()) return false;
    const cost = $9f2007d9cd6d0433$export$7db30007ec79b8c();
    return cost != null && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.energy || 0) < cost;
}
async function $9f2007d9cd6d0433$export$8e2efb5378addfbb(api) {
    if (!$9f2007d9cd6d0433$export$c750660aba17086b() || $9f2007d9cd6d0433$var$stepInFlight) return;
    const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid || {};
    // A raid is running: the existing timers own it. Nothing to do.
    if (raid.raidInProgress) return;
    // A finished raid is waiting to be collected.
    if (raid.raidCompleted) {
        $9f2007d9cd6d0433$var$stepInFlight = true;
        try {
            api.resetRaid();
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, 'Auto-Raid: collected completed raid');
            // Succession Doctrine rides on the same moment: the rate was just
            // re-evaluated at raid end, and promotion needs the raid cleared
            // (canPromoteCore blocks on raid state), which resetRaid just did.
            if ((0, $46d374413fb0707a$export$40d6ac4f92fd7c1c)() && (0, $46d374413fb0707a$export$8f29b06b79596501)().due && api.promoteAndSucceed) api.promoteAndSucceed((0, $46d374413fb0707a$export$8f29b06b79596501)());
        } finally{
            $9f2007d9cd6d0433$var$stepInFlight = false;
        }
        return;
    }
    const blocked = $9f2007d9cd6d0433$export$18302fe48a4c0c92();
    if (blocked) {
        // Transient states (mid-heal, no character yet) should pause rather than
        // switch the feature off — only genuinely player-resolvable states halt.
        if (blocked.code === 'low-hp') return;
        $9f2007d9cd6d0433$var$haltWith(blocked.text);
        return;
    }
    $9f2007d9cd6d0433$var$stepInFlight = true;
    try {
        // 1. Grid.
        if (!raid.currentRaidGrid) {
            api.generateGrid();
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, 'Auto-Raid: generated grid');
            return;
        }
        // 2. Path.
        if (!raid.selectedPath || raid.selectedPath.length < 2) {
            api.autoScoutPath();
            if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath.length < 2) $9f2007d9cd6d0433$var$haltWith('could not chart a route');
            return;
        }
        // 3. Energy, checked once the path exists because the cost depends on it.
        const cost = $9f2007d9cd6d0433$export$7db30007ec79b8c();
        if (cost != null && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).player.energy || 0) < cost) // Not a halt: energy regenerates, so this is the normal idle state
        // between raids and the cycle resumes on its own.
        return;
        // 4. Crew.
        if ((raid.reservedContractors || []).length < 2 && ((0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors || []).length > 0) {
            await api.autoReserveContractors();
            // Deliberately no halt on failure — raiding solo is worse than
            // raiding with one contractor, but both beat not raiding at all.
            return;
        }
        // 5. Re-tool for THIS crew, then launch. These two run in the same step
        //    as the launch so the kit can never be one raid stale.
        $9f2007d9cd6d0433$export$8c1031c7d77204c1();
        // `automated` selects the headless auto-grant presenters for this raid:
        // nobody is watching to click a 💎 or a 🐟, so the collectible would
        // expire and take its loot with it. Passed as an argument rather than
        // read from state inside raid.js on purpose — raid.js importing this
        // module closes a cycle (raid -> autoRaid -> gameState -> raid) that
        // silently breaks boot.
        await api.startRaid({
            automated: true
        });
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).raid, 'Auto-Raid: launched');
    } finally{
        $9f2007d9cd6d0433$var$stepInFlight = false;
    }
}
function $9f2007d9cd6d0433$export$8c1031c7d77204c1() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character) return;
    const path = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.selectedPath || [];
    const crew = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.reservedContractors?.length ? (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors : (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid?.hiredContractors || [];
    (0, $e7dde87afbac6dd8$export$b8366d52640d9f9)(character, path, crew);
    (0, $9f36f7f2f6b0dce2$export$5f6199e96a03905b)(character);
}


/**
 * Auto-Fabricator (M3) — runs the workshop hands-off.
 *
 * The selection is in `autoFabricator-core.js`, which is pure and headless.
 * This file is the part that touches the game: it calls the same crafting
 * functions the player's own buttons call, so an automated craft and a manual
 * one are the same event — same marks, same notifications, same save.
 *
 * SEPARATE FROM AUTO-RAID ON PURPOSE. Auto-Fabricator is its own Command
 * upgrade and a player can own it without owning Auto-Raid Protocol, so it gets
 * its own tick rather than a step inside the raid cycle.
 *
 * ONE CRAFT PER TICK, whenever it is switched on — see `autoFabricatorTick` for
 * why it does not wait for an "idle" window, which is a mistake this shipped
 * with for a day.
 */ 

/**
 * Auto-Fabricator (M3) — what the workshop should build next. Pure, no DOM.
 *
 * WHY THIS UPGRADE EXISTS: marks come from crafting. Measured on a late-game
 * character, tech gear + artifact unlocks + artifact crafts are 111 of 157
 * marks — 71%. Auto-Raid Protocol automates the raid and nothing else, so a
 * hands-off character earned under a third of a tour's marks, and
 * `succession-doctrine` (which promotes on the marks RATE) was automating that
 * trickle. Raid → craft → marks → promote is the loop; this is the second step.
 *
 * ONE DECISION PER CALL, deliberately. The caller crafts it and comes back next
 * tick, so a deep component tree is walked one item at a time and the player
 * watches it build rather than finding it done. It also means a craft that
 * fails for a reason this module cannot see costs one tick, not a loop.
 *
 * PRIORITY, cheapest-marks-first:
 *   1. unlock   — an owned blueprint for a design not yet unlocked. Free: costs
 *                 the blueprint, no materials, no credits, and unlocks are the
 *                 single largest marks line (75 of the 157 above).
 *   2. artifact — an unlocked, faction-legal design this character has not
 *                 crafted. Distinct designs only: a duplicate earns no marks.
 *   3. gear     — tech gear this character does not own, or the deepest
 *                 component it still needs. Components are not marks
 *                 themselves; they are the only route to gear that is.
 *
 * WHAT IT WILL NOT DO, and each of these is a decision rather than an omission:
 *   - craft duplicates (no marks, and it would drain materials forever)
 *   - craft consumables (the player's call — they are spent, not accumulated)
 *   - craft toward a target it cannot finish (it takes the deepest step that is
 *     craftable NOW, so it never strands materials in a half-built tree)
 */ 




const $a892da96ff52254b$export$681e702191fb2db1 = 'auto-fabricator';
function $a892da96ff52254b$export$17068373f54d4cc4() {
    return (0, $bde36de43872f734$export$12c456cbb12a94a8)($a892da96ff52254b$export$681e702191fb2db1) > 0;
}
/** Blueprint item id for a design, matching `unlockArtifactCore`. */ const $a892da96ff52254b$var$blueprintFor = (artifactId)=>`${artifactId}-blueprint`;
/** Faction-legal for this character? Neutral designs are legal for everyone. */ const $a892da96ff52254b$var$factionAllows = (character, thing)=>!thing?.faction || thing.faction === 'neutral' || thing.faction === character?.faction;
function $a892da96ff52254b$export$c2fff4ca1f762b21(targetId, character, seen = new Set()) {
    if (seen.has(targetId)) return null; // cycle guard, same as getCraftingTree
    seen.add(targetId);
    const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(targetId);
    if (!recipe) return null; // a raw drop: nothing to craft
    // Try the inputs first. If any input is short AND craftable, that is the
    // step to take now.
    for (const input of recipe.inputs){
        const have = character?.inventory?.[input.id] || 0;
        if (have >= input.qty) continue;
        const step = $a892da96ff52254b$export$c2fff4ca1f762b21(input.id, character, seen);
        if (step) return step;
    }
    return (0, $91ce0e04738077df$export$10d9b633aa01c262)(recipe, character) ? targetId : null;
}
function $a892da96ff52254b$export$6473dc4b900a5b32(character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character, credits = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player?.credits ?? 0) {
    if (!character) return null;
    const allowDuplicates = (0, $bde36de43872f734$export$c95b8ce76efadccf)();
    // 1. Unlocks. No materials, no credits — only a blueprint the character is
    //    already carrying, which is otherwise dead weight in the inventory.
    for (const artifact of (0, $42b272c2c0f44bdf$export$18c4115a8e7963b)()){
        if (!$a892da96ff52254b$var$factionAllows(character, artifact)) continue;
        if ((0, $bde36de43872f734$export$2ab3ae91631fe8e5)(artifact.id)) continue;
        if ((character.inventory?.[$a892da96ff52254b$var$blueprintFor(artifact.id)] || 0) < 1) continue;
        return {
            kind: 'unlock',
            id: artifact.id
        };
    }
    // 2. Artifacts the character has not built. Materials only.
    for (const artifact of (0, $42b272c2c0f44bdf$export$18c4115a8e7963b)()){
        if (!$a892da96ff52254b$var$factionAllows(character, artifact)) continue;
        if (!(0, $bde36de43872f734$export$2ab3ae91631fe8e5)(artifact.id)) continue;
        if (!allowDuplicates && (0, $bde36de43872f734$export$770281d4afda41b1)(character, artifact.id)) continue;
        const recipe = (0, $91ce0e04738077df$export$3645b25e1a815566)(artifact.id);
        if (recipe && (0, $91ce0e04738077df$export$10d9b633aa01c262)(recipe, character)) return {
            kind: 'artifact',
            id: artifact.id
        };
    }
    // 3. Tech gear, and the components it is made of.
    //
    //    Walked via `getGearMatrix`, which is the character's OWN faction gear
    //    in the order the Gear page shows it — the fabricator then builds the
    //    kit in the order the player already reads it, and the order is stable
    //    across reloads. A flat item scan would not do: tech gear items carry
    //    no `faction` field (it is encoded by which catalog array they sit in),
    //    so scanning every item would happily spend materials on gear this
    //    character can never equip.
    for (const { techniques: techniques } of (0, $9f36f7f2f6b0dce2$export$75dc440158626230)(character.faction))for (const { item: item } of techniques){
        if (!item) continue;
        if (!allowDuplicates && (0, $bde36de43872f734$export$2886ceaa061d802b)(character, item.id)) continue;
        const step = $a892da96ff52254b$export$c2fff4ca1f762b21(item.id, character);
        if (!step) continue;
        const cost = (0, $91ce0e04738077df$export$e6fc872703f0201)(step);
        // Credits gate components (artifact crafting is free). Skipping
        // rather than halting: a cheaper target further down the matrix may
        // still be affordable, and the raid loop keeps earning either way.
        if (cost > credits) continue;
        return {
            kind: 'gear',
            id: step,
            cost: cost
        };
    }
    return null;
}



function $4122a28830cdd562$export$a0f4aa4561249df8() {
    return (0, $a892da96ff52254b$export$17068373f54d4cc4)() && (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings?.autoFabricatorEnabled === true;
}
/**
 * What the last tick did — null when it found nothing worth building.
 *
 * Kept so the button can tell "on and working" from "on with nothing to build".
 * Not persisted: it describes this session's last tick, and a stale verdict read
 * from a save would be worse than none.
 */ let $4122a28830cdd562$var$lastJob = null;
let $4122a28830cdd562$var$hasTicked = false;
function $4122a28830cdd562$export$273610d740a9bd65(enabled) {
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).settings) (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings = {};
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings.autoFabricatorEnabled = !!enabled;
    // A fresh switch-on has not decided anything yet, so the button must not
    // show a verdict left over from the last time it ran.
    $4122a28830cdd562$var$hasTicked = false;
    $4122a28830cdd562$var$lastJob = null;
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    return (0, $f27982cef7035d22$export$8e361a1ffbebf172).settings.autoFabricatorEnabled;
}
function $4122a28830cdd562$export$82e2837406d30fe2() {
    if (!(0, $a892da96ff52254b$export$17068373f54d4cc4)()) return {
        state: 'unowned'
    };
    if (!$4122a28830cdd562$export$a0f4aa4561249df8()) return {
        state: 'off'
    };
    const blocked = $4122a28830cdd562$export$b71b3d68892c51f2();
    if (blocked) return {
        state: 'blocked',
        reason: blocked.text
    };
    if ($4122a28830cdd562$var$hasTicked && !$4122a28830cdd562$var$lastJob) return {
        state: 'nothing'
    };
    return {
        state: 'working'
    };
}
function $4122a28830cdd562$export$b71b3d68892c51f2() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character) return {
        code: 'no-character',
        text: 'No active character'
    };
    // The same refusal `craftItem` makes, checked here so the automation never
    // calls into a path that would raise an error notification at the player.
    if (character.isMarketplace || character.marketplaceData) return {
        code: 'listed',
        text: 'Character is listed on the marketplace'
    };
    return null;
}
function $4122a28830cdd562$export$80adecd30958438d() {
    if (!$4122a28830cdd562$export$a0f4aa4561249df8() || $4122a28830cdd562$export$b71b3d68892c51f2()) return null;
    const job = (0, $a892da96ff52254b$export$6473dc4b900a5b32)();
    $4122a28830cdd562$var$hasTicked = true;
    $4122a28830cdd562$var$lastJob = job;
    if (!job) return null;
    // The player's own crafting functions, deliberately: they bank the marks,
    // charge the credits, and notify. An automated craft the player never sees
    // in the log would read as the game inventing items.
    const done = job.kind === 'unlock' ? (0, $52d4eb0e19aef542$export$506c247f43a19ac3)(job.id) : (0, $52d4eb0e19aef542$export$67f8f6c6271cd4a2)(job.id, job.kind === 'artifact');
    if (!done) {
        // The selector said yes and the craft said no — a real disagreement,
        // worth a debug line rather than a silent retry loop next tick.
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Auto-Fabricator: ${job.kind} ${job.id} was selected but refused`);
        $4122a28830cdd562$var$lastJob = null;
        return null;
    }
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, `Auto-Fabricator: ${job.kind} ${job.id}`);
    return job;
}
function $4122a28830cdd562$export$109e3e91403b4584() {
    return $4122a28830cdd562$export$80adecd30958438d();
}



const $9a58895c0c0daffa$var$VIOLET = '#b18cff';
const $9a58895c0c0daffa$var$VIOLET_DIM = '#6d4fa3';
// ---------------------------------------------------------------------------
// Header chip + tab reveal
// ---------------------------------------------------------------------------
let $9a58895c0c0daffa$var$wasRevealed = false;
function $9a58895c0c0daffa$export$ca081aebb329a098() {
    const revealed = (0, $bde36de43872f734$export$25d1e5af45c35a33)();
    // First reveal mid-session: the character card was rendered without the
    // promote button - re-render it and announce the new layer once
    if (revealed && !$9a58895c0c0daffa$var$wasRevealed) {
        $9a58895c0c0daffa$var$wasRevealed = true;
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).command.legends.length && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).command.marks) {
            // Sticky: a one-way latch that fires on a background tick rather than
            // on anything the player just did, and it opens a whole layer. Missing
            // it means not knowing the Command tab appeared.
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83C\uDF96\uFE0F Faction command has taken notice - the Command layer is now available", 'success', {
                sticky: true
            });
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        }
        // A newly unlocked layer changes what the switcher can reach.
        window.renderLayerToolbar?.();
    }
    $9a58895c0c0daffa$var$updateAutomationButtons();
}
// ---------------------------------------------------------------------------
// Command tab rendering
// ---------------------------------------------------------------------------
function $9a58895c0c0daffa$var$statBlock(label, valueHtml, note) {
    return `
        <div class="flex-1 min-w-[200px] rounded-lg p-3" style="background:rgba(177,140,255,0.10); border:2px solid ${$9a58895c0c0daffa$var$VIOLET_DIM};">
            <div class="text-[11px] uppercase tracking-widest text-gray-400">${label}</div>
            <div class="text-lg font-bold leading-tight" style="color:${$9a58895c0c0daffa$var$VIOLET}">${valueHtml}</div>
            <div class="text-xs text-gray-400 mt-0.5 leading-snug">${note}</div>
        </div>`;
}
function $9a58895c0c0daffa$var$renderCommandStats() {
    const container = document.getElementById('command-stats');
    if (!container) return;
    const command = (0, $bde36de43872f734$export$b97b2e8df296cd3b)();
    let activeValue = '<span class="text-gray-400">No active character</span>';
    let activeNote = 'Create a character to begin the next tour';
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
        const { total: total, breakdown: breakdown } = (0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character);
        activeValue = `${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character.name} \xb7 ${total}\u{1F396}\u{FE0F}`;
        // Marks/day makes the promotion peak legible: when the rate stops
        // climbing tour-over-tour, it's time to promote
        const tourDays = (Date.now() - ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character.createdAt || 0)) / 86400000;
        const rate = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.createdAt && tourDays >= 1 / 24 ? `${(total / tourDays).toFixed(1)}\u{1F396}\u{FE0F}/day this tour` : '';
        activeNote = `<div class="mt-1">${rate}</div>`;
    }
    container.innerHTML = $9a58895c0c0daffa$var$statBlock('Command Marks', (command.marks || 0).toLocaleString(), 'Influence carried up-well by your promoted officers') + $9a58895c0c0daffa$var$statBlock('Current Tour', `Tour ${command.tour}`, `${command.legends.length} Legend${command.legends.length === 1 ? '' : 's'} enshrined \xb7 counted across all factions`) + $9a58895c0c0daffa$var$statBlock("Active Character \u2014 Command Value", activeValue, activeNote);
}
function $9a58895c0c0daffa$var$rankPips(owned, max) {
    let pips = '';
    for(let i = 0; i < max; i++)pips += `<span class="inline-block w-2.5 h-2.5 rounded-sm mr-1" style="border:1px solid ${$9a58895c0c0daffa$var$VIOLET_DIM}; ${i < owned ? `background:${$9a58895c0c0daffa$var$VIOLET};` : ''}"></span>`;
    return `<span title="Rank ${owned}/${max}">${pips}</span>`;
}
function $9a58895c0c0daffa$var$renderCommandUpgrades() {
    const container = document.getElementById('command-upgrades');
    if (!container) return;
    const command = (0, $bde36de43872f734$export$b97b2e8df296cd3b)();
    container.innerHTML = Object.entries($ce6dd72bc4611534$export$617b3a0bcd7cead7).map(([id, def])=>{
        const rank = (0, $bde36de43872f734$export$12c456cbb12a94a8)(id);
        const maxed = rank >= def.costs.length;
        // Discounted price via the shared helper, so the card quotes exactly
        // what purchaseUpgradeCore will deduct.
        const nextCost = maxed ? null : (0, $bde36de43872f734$export$21d6f53ea6843ff6)(id, rank);
        // Prerequisites are a different kind of "no" from price, so they get
        // their own line rather than a silently disabled button.
        const missing = maxed ? [] : (0, $bde36de43872f734$export$21736c92e8c4e21c)(def);
        const affordable = !maxed && missing.length === 0 && command.marks >= nextCost;
        const rankLabel = def.costs.length > 1 && !maxed ? `Rank ${[
            'I',
            'II',
            'III'
        ][rank] || rank + 1} \u{2014} ` : '';
        const missingNames = missing.map((reqId)=>$ce6dd72bc4611534$export$617b3a0bcd7cead7?.[reqId]?.name || reqId);
        return `
            <div class="catalog-card bg-white/10 border-2 border-gray-700 rounded-lg p-3 flex flex-col gap-1.5">
                <div class="flex justify-between items-baseline gap-2">
                    <h4 class="font-bold text-[15px] m-0" style="color:${$9a58895c0c0daffa$var$VIOLET}">${def.icon} ${def.name}</h4>
                    ${$9a58895c0c0daffa$var$rankPips(rank, def.costs.length)}
                </div>
                <div class="catalog-card-flavor text-xs text-gray-400 italic leading-snug" title="${def.flavor}">${def.flavor}</div>
                <div class="catalog-card-effect text-[13px] leading-snug">${def.effect}${rank > 0 && !maxed ? ` <span class="text-game-success">Rank ${[
            'I',
            'II',
            'III'
        ][rank - 1] || rank} owned.</span>` : ''}</div>
                ${missingNames.length ? `<div class="text-xs text-amber-300">\u{1F512} Requires ${missingNames.join(' and ')}.</div>` : ''}
                <div class="catalog-card-footer flex justify-between items-center mt-auto pt-2">
                    ${maxed ? `<span class="text-game-success text-sm font-bold">\u{2713} Maxed</span><span></span>` : `<span class="font-bold text-sm" style="color:${$9a58895c0c0daffa$var$VIOLET}">${rankLabel}${nextCost} \u{1F396}\u{FE0F}</span>
                           <button onclick="purchaseCommandUpgrade('${id}')" ${affordable ? '' : 'disabled'}
                               class="px-3 py-1.5 rounded text-xs font-bold ${affordable ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed'}"
                               ${affordable ? `style="background:${$9a58895c0c0daffa$var$VIOLET}"` : ''}>ACQUIRE</button>`}
                </div>
            </div>`;
    }).join('');
}
function $9a58895c0c0daffa$var$renderCommandGallery() {
    const container = document.getElementById('command-gallery');
    if (!container) return;
    const command = (0, $bde36de43872f734$export$b97b2e8df296cd3b)();
    if (!command.legends.length) {
        container.innerHTML = `
            <div class="col-span-full text-center text-gray-400 py-8 border border-dashed border-gray-600 rounded-lg">
                No Legends yet. Promote your first character to begin building the faction ranks.
            </div>`;
        return;
    }
    container.innerHTML = [
        ...command.legends
    ].reverse().map((legend)=>(0, $03d1ca7da93421d9$export$5eeeb728aab285f9)({
            artifactsUnlocked: 0,
            ...legend
        }, {
            accent: $9a58895c0c0daffa$var$VIOLET,
            accentDim: $9a58895c0c0daffa$var$VIOLET_DIM
        })).join('');
}
(0, $f2aa38d2d36459d1$export$589dc1e4c906c789)('command', {
    panes: {
        upgrades: 'command-pane-upgrades',
        legends: 'command-pane-legends'
    },
    // The GRID scrolls, not the pane: the blurb above it should stay put rather
    // than scroll away with the cards.
    scrollers: {
        upgrades: 'command-upgrades',
        legends: 'command-gallery'
    }
});
function $9a58895c0c0daffa$export$cf457306c8f8ec80() {
    $9a58895c0c0daffa$var$renderCommandStats();
    $9a58895c0c0daffa$var$renderCommandUpgrades();
    $9a58895c0c0daffa$var$renderCommandGallery();
    $9a58895c0c0daffa$export$ca081aebb329a098();
    // Both panes are rendered above — they are hidden, not unmounted, so the
    // cost is one innerHTML each and the hidden one is correct when revealed.
    // Re-applying re-measures the scroller against whatever height the stats
    // strip ended up at.
    (0, $f2aa38d2d36459d1$export$7ad721b2ffe28f0c)('command');
}
function $9a58895c0c0daffa$export$6385b3d28f532d4c(upgradeId) {
    const def = $ce6dd72bc4611534$export$617b3a0bcd7cead7?.[upgradeId];
    if (!def) return;
    if (def.choice === 'region') {
        $9a58895c0c0daffa$var$openCharterPickModal();
        return;
    }
    const result = (0, $bde36de43872f734$export$a9f5f3e18483ed51)(upgradeId);
    if (!result.success) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)($9a58895c0c0daffa$var$purchaseFailureMessage(result.reason, result), 'error');
        return;
    }
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F396}\u{FE0F} Acquired ${def.name}${def.costs.length > 1 ? ` Rank ${[
        'I',
        'II',
        'III'
    ][result.rank - 1] || result.rank}` : ''} (-${result.cost} marks)`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $9a58895c0c0daffa$export$cf457306c8f8ec80();
}
function $9a58895c0c0daffa$var$purchaseFailureMessage(reason, result = null) {
    switch(reason){
        case 'insufficient-marks':
            return 'Not enough Command Marks!';
        case 'max-rank':
            return 'Already at maximum rank!';
        case 'region-already-chartered':
            return 'That region is already chartered!';
        case 'invalid-region':
            return 'Pick a region to charter first.';
        case 'missing-requirement':
            {
                const names = (result?.requires || []).map((id)=>$ce6dd72bc4611534$export$617b3a0bcd7cead7?.[id]?.name || id);
                return `Requires ${names.join(' and ')} first.`;
            }
        default:
            return 'Cannot acquire this upgrade.';
    }
}
function $9a58895c0c0daffa$var$openCharterPickModal() {
    const modal = document.getElementById('charter-pick-modal');
    const body = document.getElementById('charter-pick-body');
    if (!modal || !body) return;
    const command = (0, $bde36de43872f734$export$b97b2e8df296cd3b)();
    const rank = (0, $bde36de43872f734$export$12c456cbb12a94a8)('regional-charter');
    const def = $ce6dd72bc4611534$export$617b3a0bcd7cead7['regional-charter'];
    if (rank >= def.costs.length) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Already at maximum rank!', 'error');
        return;
    }
    const cost = def.costs[rank];
    const chartered = new Set(command.charterRegions);
    const candidates = Object.keys($ce6dd72bc4611534$export$4fbdcec70fce9d73).filter((r)=>!chartered.has(r));
    body.innerHTML = `
        <p class="text-sm text-gray-300 mb-1">Command negotiates access corridors no field team could.</p>
        <p class="text-xs text-gray-400 mb-4">Choose one region to unlock for ALL your characters \u{2014} ${cost} \u{1F396}\u{FE0F} (you have ${command.marks}).</p>
        <div class="flex flex-col gap-2">
            ${candidates.map((regionKey)=>{
        const region = $ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey];
        return `
                    <button onclick="confirmCharterPick('${regionKey}')" ${command.marks >= cost ? '' : 'disabled'}
                        class="text-left px-4 py-3 rounded-lg border-2 border-gray-600 bg-white/5 hover:border-[#b18cff] disabled:opacity-50 disabled:cursor-not-allowed">
                        <span class="font-bold text-white">${region.icon || "\uD83D\uDDFA\uFE0F"} ${region.name}</span>
                        <span class="block text-xs text-gray-400">${region.theme || ''}</span>
                    </button>`;
    }).join('')}
        </div>`;
    modal.classList.remove('hidden');
}
function $9a58895c0c0daffa$export$65f57c7876e71d24(regionKey) {
    const result = (0, $bde36de43872f734$export$a9f5f3e18483ed51)('regional-charter', regionKey);
    if (!result.success) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)($9a58895c0c0daffa$var$purchaseFailureMessage(result.reason, result), 'error');
        return;
    }
    document.getElementById('charter-pick-modal')?.classList.add('hidden');
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F5FA}\u{FE0F} Regional Charter: ${$ce6dd72bc4611534$export$4fbdcec70fce9d73[regionKey]?.name || regionKey} unlocked for all characters! (-${result.cost} marks)`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $9a58895c0c0daffa$export$cf457306c8f8ec80();
}
function $9a58895c0c0daffa$export$91233bcb850c2ee1() {
    const modal = document.getElementById('promote-modal');
    const body = document.getElementById('promote-modal-body');
    const title = document.getElementById('promote-modal-title');
    if (!modal || !body || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return;
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    const command = (0, $bde36de43872f734$export$b97b2e8df296cd3b)();
    title.textContent = `\u{1F396}\u{FE0F} Promote ${character.name}`;
    const eligible = (0, $bde36de43872f734$export$d7db1ce90eca9a05)();
    if (!eligible.ok && eligible.reason !== 'no-active-character') {
        const message = eligible.reason === 'listed-on-marketplace' ? `<b>${character.name} is listed on the contractor marketplace.</b><br>Recall them from contract before promoting \u{2014} the listing (or an active hire) must end first.` : `<b>${character.name} has a raid in progress.</b><br>Finish or abandon the raid before promoting.`;
        body.innerHTML = `
            <div class="border rounded-lg p-4 text-sm leading-relaxed mb-4" style="border-color:#ef4444; background:rgba(239,68,68,0.08); color:#fca5a5;">\u{26A0}\u{FE0F} ${message}</div>
            <div class="flex justify-end">
                <button onclick="closePromoteModal()" class="px-4 py-2 rounded border border-gray-500 text-gray-300 text-sm font-bold">Close</button>
            </div>`;
        modal.classList.remove('hidden');
        return;
    }
    const { total: total, breakdown: breakdown } = (0, $bde36de43872f734$export$ffae5de2f7ddd94d)(character);
    const marksCfg = $ce6dd72bc4611534$export$9f9786ac427715c7.commandMarks;
    const vaultShare = $ce6dd72bc4611534$export$9f9786ac427715c7.vaultCarryover;
    // The post waiting up-well: promoted role + a command member's welcome,
    // both resolved from the character's title/best skill (deterministic, so
    // this preview always matches the Legend enshrined on confirm)
    const promotedFlavor = (0, $bde36de43872f734$export$5a56eaf8a61d7ab9)(character);
    const factionInfo = $ce6dd72bc4611534$export$aeeef991191508e2[character.faction] || {};
    // Promotion credit levy: credits are account-shared, so a percentage cut
    // (with a working-capital floor) replaces the old flat reset
    const levy = $ce6dd72bc4611534$export$9f9786ac427715c7.promotionCreditLevy || {
        keepFraction: 0.25,
        floor: 1000
    };
    const creditsNow = (0, $f27982cef7035d22$export$8e361a1ffbebf172).player.credits || 0;
    // Promotion SELLS relics and consumables before the levy is taken, so the
    // levy lands on a bigger number than the header shows. Dry-run the same
    // function the promotion uses — passing no vault/consignment makes it a pure
    // valuation — or this modal promises less than the player actually keeps.
    const { credits: liquidation } = (0, $bde36de43872f734$export$da98dc4e7bdea782)(character.inventory, {
        vaultShare: vaultShare
    });
    const creditsAtLevy = creditsNow + liquidation;
    const creditsKept = Math.max(levy.floor, Math.floor(creditsAtLevy * levy.keepFraction));
    body.innerHTML = `
        <div class="text-s text-gray-100 mb-1">End of Tour ${command.tour} \u{2014} Promotion to Faction Command</div>
        <!-- The mechanic has always been irreversible; nothing said so. Also the
             only place L1/L2 states that Command is PLANETSIDE, which is what
             makes a promoted officer unable to go home and what L3's founding
             needs to read as a diaspora rather than an incorporation.
             docs/story/StoryAlignment.md \xa7Economic geography. -->
        <div class="text-xs text-gray-400 mb-3 leading-relaxed">
            Promotion is one-way. Enough transit dilation has accumulated that ${character.name} cannot return to the field \u{2014} or home. Faction Command is planetside, and it is where the crossing leaves them.
        </div>
        ${promotedFlavor.role ? `
        <div class="border rounded-lg p-3 mb-4" style="border-color:${$9a58895c0c0daffa$var$VIOLET_DIM}; background:rgba(177,140,255,0.04);">
            <div class="uppercase tracking-widest text-[10px] font-bold mb-1" style="color:${$9a58895c0c0daffa$var$VIOLET}">New Post \u{2014} ${factionInfo.icon || ''} ${factionInfo.name || character.faction} Command</div>
            <div class="text-sm font-bold text-white mb-2">${character.name}, ${promotedFlavor.role}</div>
            ${promotedFlavor.quote ? `
            <div class="text-xs italic leading-relaxed" style="color:#a78bda;">
                ${promotedFlavor.quote}
                <div class="not-italic text-right text-[10px] mt-1 text-gray-500">\u{2014} ${factionInfo.name || character.faction} Command</div>
            </div>` : ''}
        </div>` : ''}
        <div class="text-xs italic border-l-2 pl-3 py-1 mb-4 leading-relaxed" style="border-color:${$9a58895c0c0daffa$var$VIOLET_DIM}; color:#a78bda; background:rgba(177,140,255,0.06);">
            \u{201C}Field clearance expires with accumulated temporal desync. The Relay is waiting, Commander. Home is\u{2026} further than it was.\u{201D}
        </div>
        <table class="w-full text-sm mb-4" style="font-variant-numeric: tabular-nums;">
            <tr class="border-b border-gray-700"><td class="py-1">Faction tech gear</td><td class="text-right text-gray-400">${breakdown.techGear.count} \xd7 ${marksCfg.perTechGear}</td><td class="text-right font-bold w-20" style="color:${$9a58895c0c0daffa$var$VIOLET}">${breakdown.techGear.marks}</td></tr>
            <tr class="border-b border-gray-700"><td class="py-1" title="One-time milestone per artifact design unlocked with its blueprint">Artifact designs unlocked</td><td class="text-right text-gray-400">${breakdown.artifactUnlocks.count} \xd7 ${marksCfg.perArtifactUnlock}</td><td class="text-right font-bold" style="color:${$9a58895c0c0daffa$var$VIOLET}">${breakdown.artifactUnlocks.marks}</td></tr>
            <tr class="border-b border-gray-700"><td class="py-1" title="Each distinct artifact this character crafted from unlocked designs">Artifacts crafted</td><td class="text-right text-gray-400">${breakdown.artifacts.count} \xd7 ${marksCfg.perArtifactCraft}</td><td class="text-right font-bold" style="color:${$9a58895c0c0daffa$var$VIOLET}">${breakdown.artifacts.marks}</td></tr>
            <tr class="border-b border-gray-700"><td class="py-1">Tier-3 victories</td><td class="text-right text-gray-400">${breakdown.t3Wins.count} \xf7 ${marksCfg.t3WinsDivisor}</td><td class="text-right font-bold" style="color:${$9a58895c0c0daffa$var$VIOLET}">${breakdown.t3Wins.marks}</td></tr>
            <tr><td class="py-1">Level</td><td class="text-right text-gray-400">${breakdown.level.count} \xd7 ${marksCfg.perLevel}</td><td class="text-right font-bold" style="color:${$9a58895c0c0daffa$var$VIOLET}">${breakdown.level.marks}</td></tr>
            <tr class="border-t-2" style="border-color:${$9a58895c0c0daffa$var$VIOLET_DIM}"><td class="py-1 font-bold text-white">Command Marks</td><td></td><td class="text-right font-bold text-game-gold text-base">\u{1F396}\u{FE0F}${total}</td></tr>
        </table>

        <div class="grid grid-cols-2 gap-3 mb-4 text-xs leading-relaxed">
            <div class="border border-gray-700 rounded-lg p-3">
                <div class="uppercase tracking-widest text-[10px] font-bold mb-1 text-game-success">\u{2713} Persists</div>
                <ul class="list-disc pl-4 text-gray-400">
                    <li>Command Marks &amp; all upgrades</li>
                    <li>Legends gallery entry</li>
                    <li>Chartered regions</li>
                    <li>Your other characters</li>
                    <li>Artifact blueprints (filed with Command)</li>
                    ${vaultShare > 0 ? `<li>Materials: ${Math.round(vaultShare * 100)}% to your next recruit, the rest consigned to your next Syndicate</li>` : ""}
                </ul>
            </div>
            <div class="border border-gray-700 rounded-lg p-3">
                <div class="uppercase tracking-widest text-[10px] font-bold mb-1 text-game-danger">\u{2717} Lost</div>
                <ul class="list-disc pl-4 text-gray-400">
                    <li>${character.name} (leaves your roster)</li>
                    <li>Equipped gear, and relics &amp; consumables (sold off first \u{2014} the credits below include them)</li>
                    <li title="Your credit line was issued against a tour. When the tour ends the balance underwrites the next roster; what is left is your working float."><b>Tour accounts close</b> \u{2014} Command levies ${Math.round((1 - levy.keepFraction) * 100)}% of credits (${creditsAtLevy.toLocaleString()}${liquidation > 0 ? ` incl. ${liquidation.toLocaleString()} from the sale` : ""} \u{2192} ${creditsKept.toLocaleString()})</li>
                </ul>
            </div>
        </div>

        <input type="text" id="promote-confirm-name" autocomplete="off" placeholder='Type "${character.name}" to confirm'
            class="w-full px-4 py-2 bg-white/5 border-2 border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none text-sm mb-4" style="caret-color:${$9a58895c0c0daffa$var$VIOLET}">

        <div class="flex justify-end gap-3">
            <button onclick="closePromoteModal()" class="px-4 py-2 rounded border border-gray-500 text-gray-300 text-sm font-bold">Cancel</button>
            <button id="promote-confirm-btn" onclick="confirmPromotion()" disabled
                class="px-5 py-2 rounded text-sm font-bold text-black disabled:bg-gray-600 disabled:text-gray-800 disabled:cursor-not-allowed" style="background:${$9a58895c0c0daffa$var$VIOLET}">
                Promote to Command
            </button>
        </div>`;
    const input = document.getElementById('promote-confirm-name');
    const confirmBtn = document.getElementById('promote-confirm-btn');
    input.addEventListener('input', ()=>{
        confirmBtn.disabled = input.value.trim().toLowerCase() !== character.name.trim().toLowerCase();
    });
    input.addEventListener('focus', ()=>{
        input.style.borderColor = $9a58895c0c0daffa$var$VIOLET;
    });
    modal.classList.remove('hidden');
    // Focus without scrolling: the confirm input sits at the bottom, and a
    // scroll-on-focus would jump the (now scrollable) body past the marks
    // breakdown at the top. Keep the body pinned to the top on open.
    input.focus({
        preventScroll: true
    });
    if (body) body.scrollTop = 0;
}
function $9a58895c0c0daffa$export$ffb8f728a2943b32() {
    document.getElementById('promote-modal')?.classList.add('hidden');
}
function $9a58895c0c0daffa$export$a522e88637d89e58() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!character) return;
    const multiplayerId = character.multiplayerId;
    const result = (0, $bde36de43872f734$export$f0bd6e9010bb1600)();
    if (!result.success) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)($9a58895c0c0daffa$var$purchaseFailureMessage(result.reason, result), 'error');
        $9a58895c0c0daffa$export$ffb8f728a2943b32();
        return;
    }
    // Server-side v1 reuses the delete path (switches to a status flag when Old Guard ships)
    if (multiplayerId && window.multiplayer?.deleteOwnCharacter) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost for the next tour
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $bd083a63eb37c143$export$aca974319671fb3e)();
    $9a58895c0c0daffa$export$ffb8f728a2943b32();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{23F3} Tour ${result.legend.tour} complete \u{2014} ${result.legend.name} promoted to Command \xb7 +${result.marks.total} \u{1F396}\u{FE0F}`, 'success');
    // The active slot is free: show the character screen (creator or selector)
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    $9a58895c0c0daffa$export$ca081aebb329a098();
    if (window.showCharacterScreenAfterPromotion) window.showCharacterScreenAfterPromotion();
    $9a58895c0c0daffa$export$cf457306c8f8ec80();
}
// ---------------------------------------------------------------------------
// Automation upgrades: Auto-Scout + Foreman's Ledger (raid planning),
// Auto-Raid Protocol (the raid loop), Auto-Fabricator (the workshop)
// ---------------------------------------------------------------------------
/**
 * Show/hide the automation buttons based on owned upgrades.
 *
 * Called from updateCommandHeader (5s interval). The raid-planning buttons live
 * in the raid grid header, so they only appear once a grid exists anyway -
 * Auto-Fabricator's does NOT: it sits in the character subtab bar, because it
 * crafts whenever the player is idle rather than only around a raid.
 */ function $9a58895c0c0daffa$var$updateAutomationButtons() {
    // The `-arrow` companions these used to toggle no longer exist in the
    // markup; optional chaining made their absence silent.
    document.getElementById('auto-scout-btn')?.classList.toggle('hidden', (0, $bde36de43872f734$export$12c456cbb12a94a8)('auto-scout') <= 0);
    document.getElementById('auto-reserve-btn')?.classList.toggle('hidden', (0, $bde36de43872f734$export$12c456cbb12a94a8)('foremans-ledger') <= 0);
    $9a58895c0c0daffa$var$updateAutoRaidButton();
    $9a58895c0c0daffa$var$updateAutoFabricatorButton();
}
/**
 * Auto-Raid is a toggle, so its button carries STATE, not just an action: lit
 * while running, dim while idle, with a status line saying what it is doing or
 * why it is not. An automation that silently does nothing is indistinguishable
 * from one that is broken.
 */ function $9a58895c0c0daffa$var$updateAutoRaidButton() {
    const btn = document.getElementById('auto-raid-btn');
    const status = document.getElementById('auto-raid-status');
    if (!btn) return;
    const owned = (0, $9f2007d9cd6d0433$export$d386ff630e305d9f)();
    btn.classList.toggle('hidden', !owned);
    status?.classList.toggle('hidden', !owned);
    if (!owned) return;
    const on = (0, $9f2007d9cd6d0433$export$c750660aba17086b)();
    btn.style.background = on ? '#4ade80' : '';
    btn.style.color = on ? '#000' : '';
    btn.title = on ? "Auto-Raid Protocol: running \u2014 click to stop" : 'Auto-Raid Protocol: click to run raids hands-off';
    if (!status) return;
    if (!on) {
        status.textContent = 'Auto-Raid off';
        status.style.color = '#9ca3af';
        return;
    }
    const blocked = (0, $9f2007d9cd6d0433$export$18302fe48a4c0c92)();
    const waitingForEnergy = (0, $9f2007d9cd6d0433$export$9f0fd7c5580c292)();
    status.textContent = blocked ? `\u{23F8} ${blocked.text}` : waitingForEnergy ? `\u{23F8} Waiting for \u{26A1}${(0, $9f2007d9cd6d0433$export$7db30007ec79b8c)()}` : "\u25B6 Auto-Raid running";
    status.style.color = blocked || waitingForEnergy ? '#fbbf24' : '#4ade80';
}
function $9a58895c0c0daffa$export$4bdca4d15177534a() {
    if (!(0, $9f2007d9cd6d0433$export$d386ff630e305d9f)()) return;
    const nowOn = (0, $9f2007d9cd6d0433$export$c790bcc16caca94)(!(0, $9f2007d9cd6d0433$export$c750660aba17086b)());
    $9a58895c0c0daffa$var$updateAutoRaidButton();
    if (nowOn) {
        const blocked = (0, $9f2007d9cd6d0433$export$18302fe48a4c0c92)();
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(blocked ? `\u{1F916} Auto-Raid armed \u{2014} ${blocked.text}` : "\uD83E\uDD16 Auto-Raid running", blocked ? 'warning' : 'success');
    } else (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83E\uDD16 Auto-Raid stopped", 'info');
}
/**
 * Auto-Fabricator's button: a toggle, so it carries STATE rather than an action.
 *
 * It sits in the CHARACTER subtab bar, not the raid grid header where Auto-Raid
 * lives, because it is not raid-scoped — it crafts whenever the player is idle.
 * That bar has no room for a status line beside it, so the LABEL is the status
 * and the tooltip carries the detail. An automation that silently does nothing
 * is indistinguishable from one that is broken, and "Off" vs "⏸" is the
 * difference between "you turned this off" and "it cannot run right now".
 */ const $9a58895c0c0daffa$var$FAB_BUTTON_STATES = {
    off: {
        text: 'Auto-Craft Off',
        colour: '#b18cff',
        title: 'Auto-Fabricator: click to craft hands-off between raids'
    },
    working: {
        text: 'Auto-Craft On',
        colour: '#4ade80',
        title: "Auto-Fabricator: crafting between raids \u2014 click to stop"
    },
    // Not a failure, and the most common state early on: everything craftable is
    // already built, or the materials and credits are not there yet.
    nothing: {
        text: 'Auto-Craft Idle',
        colour: '#9ca3af',
        title: "Auto-Fabricator: on, but nothing it can build right now \u2014 no blueprint to unlock, no complete recipe, nothing affordable"
    },
    blocked: {
        text: "Auto-Craft \u23F8",
        colour: '#fbbf24',
        title: null
    }
};
function $9a58895c0c0daffa$var$updateAutoFabricatorButton() {
    const btn = document.getElementById('auto-fab-btn');
    if (!btn) return;
    // One source of truth: the module that runs the automation decides what
    // state it is in, and this only paints it.
    const { state: state, reason: reason } = (0, $4122a28830cdd562$export$82e2837406d30fe2)();
    btn.classList.toggle('hidden', state === 'unowned');
    if (state === 'unowned') return;
    const style = $9a58895c0c0daffa$var$FAB_BUTTON_STATES[state];
    btn.textContent = style.text;
    btn.style.borderColor = style.colour;
    btn.style.background = `${style.colour}22`;
    btn.style.color = style.colour;
    btn.title = style.title || `Auto-Fabricator paused \u{2014} ${reason}`;
}
function $9a58895c0c0daffa$export$a6ca5fb2b2eca75d() {
    if (!(0, $a892da96ff52254b$export$17068373f54d4cc4)()) return;
    const nowOn = (0, $4122a28830cdd562$export$273610d740a9bd65)(!(0, $4122a28830cdd562$export$a0f4aa4561249df8)());
    $9a58895c0c0daffa$var$updateAutoFabricatorButton();
    if (nowOn) {
        const blocked = (0, $4122a28830cdd562$export$b71b3d68892c51f2)();
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(blocked ? `\u{2699}\u{FE0F} Auto-Fabricator armed \u{2014} ${blocked.text}` : "\u2699\uFE0F Auto-Fabricator running", blocked ? 'warning' : 'success');
    } else (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u2699\uFE0F Auto-Fabricator stopped", 'info');
}
function $9a58895c0c0daffa$export$478f57514b105434() {
    const grid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (!grid || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character || (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) return;
    // Lights Out. Told, not silently ignored: a button that does nothing when
    // pressed is indistinguishable from a broken one.
    if ((0, $45c49e7f6d2032d6$export$a2c94bc2dc5c01e1)('noAutoScout', false)) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83C\uDF11 Lights Out: no recon on this contract \u2014 chart it yourself.", 'warning');
        return;
    }
    const wantedCells = (0, $a52c72724dfd3eca$export$a2d78d1f68010f97)();
    // Weight encounter rooms by whether this character can pass them: a gate
    // fires 2-4 skill events against a higher skill bar than a hazard's 1-2,
    // so routing through gates the player is under-skilled for is what turns a
    // scouted path into a wipe.
    const tierData = $ce6dd72bc4611534$export$94e7ad7999c1ae32[grid.tier] || {};
    const skillTargets = {
        gate: tierData.gateSkillLevel,
        hazard: tierData.hazardSkillLevel
    };
    let path = (0, $d81945fd20294c5c$export$bbcc6782bce81af0)(grid, grid.startPos, grid.endPos, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills || {}, wantedCells, skillTargets);
    if (!path.length) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDEF0\uFE0F Auto-Scout could not chart a route to the exit", 'error');
        return;
    }
    // Grab any water/campsite that sit on a free (zero-encounter) detour off the
    // charted route - free fishing/healing at no path-length cost.
    path = (0, $d81945fd20294c5c$export$c8e849ec9d7205c9)(path, grid);
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = path;
    (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
    (0, $a52c72724dfd3eca$export$f4fa7fe8ae486c6)();
    (0, $a52c72724dfd3eca$export$d6f634bba1273a2b)();
    (0, $a52c72724dfd3eca$export$25fc6ae0ff69cc)();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    const encounters = path.filter((s)=>s.room?.type === 'gate' || s.room?.type === 'hazard').length;
    const targeted = wantedCells ? path.filter((s)=>wantedCells.has(`${s.row},${s.col}`)).length : 0;
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F6F0}\u{FE0F} Auto-Scout charted a ${path.length}-room route (${encounters} encounters${targeted ? `, ${targeted} rooms drop your marked items` : ''})`, 'success');
}
async function $9a58895c0c0daffa$export$95f7842af258a4dd() {
    const path = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath;
    if (!path || path.length < 2) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDCD2 Plan a path first \u2014 the Foreman staffs for the route", 'warning');
        return;
    }
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDCD2 Team is already full", 'warning');
        return;
    }
    const available = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors || []).filter((c)=>c.isAlive !== false && !(0, $cc90b7944b7e868a$export$595cb98aec43dd71)(c.id));
    const best = (0, $e7dde87afbac6dd8$export$62a89cfab93e40e)(available, path, (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.skills || {});
    if (!best.length) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDCD2 No suitable contractors available for this route", 'warning');
        return;
    }
    let hired = 0;
    for (const contractor of best){
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) break;
        await (0, $bd083a63eb37c143$export$959fb65d2b5e760e)(contractor.id);
        hired++;
    }
    if (hired > 0) (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4D2} Foreman's Ledger reserved ${hired} contractor${hired === 1 ? '' : 's'} for the route`, 'success');
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.openPromoteModal = $9a58895c0c0daffa$export$91233bcb850c2ee1;
    window.closePromoteModal = $9a58895c0c0daffa$export$ffb8f728a2943b32;
    window.confirmPromotion = $9a58895c0c0daffa$export$a522e88637d89e58;
    window.purchaseCommandUpgrade = $9a58895c0c0daffa$export$6385b3d28f532d4c;
    window.confirmCharterPick = $9a58895c0c0daffa$export$65f57c7876e71d24;
    window.autoScoutPath = $9a58895c0c0daffa$export$478f57514b105434;
    window.autoReserveContractors = $9a58895c0c0daffa$export$95f7842af258a4dd;
    window.toggleAutoRaid = $9a58895c0c0daffa$export$4bdca4d15177534a;
    window.toggleAutoFabricator = $9a58895c0c0daffa$export$a6ca5fb2b2eca75d;
    document.addEventListener('DOMContentLoaded', ()=>{
        document.getElementById('promote-modal-close')?.addEventListener('click', $9a58895c0c0daffa$export$ffb8f728a2943b32);
        document.getElementById('charter-pick-close')?.addEventListener('click', ()=>{
            document.getElementById('charter-pick-modal')?.classList.add('hidden');
        });
    });
}



/**
 * Syndicate UI (M3 S2) - the browser wrapper over syndicate-core.js.
 *
 * Mirrors command.js deliberately: same stat-strip / catalog-grid / modal
 * shapes, same window-exposure pattern for onclick strings. All rules live in
 * syndicate-core.js so the simulator sees the same behaviour; this file only
 * renders and reports.
 *
 * See docs/layers/3-syndicate/design.md §2-§3.
 */ 











const $9266f6113786f65f$var$GOLD = '#e0a84c';
const $9266f6113786f65f$var$GOLD_DIM = '#8a6526';
const $9266f6113786f65f$var$ROMAN = [
    'I',
    'II',
    'III'
];
/**
 * Display name(s) for the Command upgrade(s) a charter depends on.
 *
 * Prefers the live catalog, falling back to the charter's declared
 * `requiresName` — which now only matters if an id is renamed out from under
 * the catalog, since both required upgrades ship in it.
 *
 * Takes an id OR a list, because `succession-doctrine` requires two. A lock
 * line naming one of two prerequisites is worse than none: the player buys the
 * named one and the button is still disabled.
 */ function $9266f6113786f65f$var$commandUpgradeName(upgradeIds, charterDef = null) {
    const ids = Array.isArray(upgradeIds) ? upgradeIds : [
        upgradeIds
    ];
    const names = ids.map((id)=>$ce6dd72bc4611534$export$617b3a0bcd7cead7?.[id]?.name || charterDef?.requiresName || id);
    return names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : names[0];
}
function $9266f6113786f65f$var$statBlock(label, valueHtml, note) {
    return `
        <div class="flex-1 min-w-[200px] rounded-lg p-3" style="background:rgba(224,168,76,0.10); border:2px solid ${$9266f6113786f65f$var$GOLD_DIM};">
            <div class="text-[11px] uppercase tracking-widest text-gray-400">${label}</div>
            <div class="text-lg font-bold leading-tight" style="color:${$9266f6113786f65f$var$GOLD}">${valueHtml}</div>
            <div class="text-xs text-gray-400 mt-0.5 leading-snug">${note}</div>
        </div>`;
}
/**
 * Marks banked this era PLUS whatever the active character is carrying.
 *
 * Founding folds unbanked marks in (docs decision 8), so the preview has to as
 * well - showing only `eraMarks` would under-report the Writs the player is
 * about to receive and make the fold-in look like a bug.
 */ function $9266f6113786f65f$var$projectedEra() {
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const unbanked = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character ? (0, $bde36de43872f734$export$ffae5de2f7ddd94d)((0, $f27982cef7035d22$export$8e361a1ffbebf172).character)?.total || 0 : 0;
    return {
        eraMarks: syndicate.eraMarks,
        unbanked: unbanked,
        total: syndicate.eraMarks + unbanked
    };
}
function $9266f6113786f65f$var$renderSyndicateStats() {
    const container = document.getElementById('syndicate-stats');
    if (!container) return;
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    const legends = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0;
    const era = $9266f6113786f65f$var$projectedEra();
    const foundedNote = syndicate.founded === 0 ? 'No Syndicate founded yet' : `${syndicate.totalTours} tour${syndicate.totalTours === 1 ? '' : 's'} served across all eras`;
    const eraNote = era.unbanked > 0 ? `${era.eraMarks.toLocaleString()} banked + ${era.unbanked.toLocaleString()} on your active character` : `${legends} of ${(0, $46d374413fb0707a$export$ab98ff7829062ba4)()} Legends promoted this era`;
    container.innerHTML = $9266f6113786f65f$var$statBlock('Syndicate Writs', (syndicate.writs || 0).toLocaleString(), 'Issued at founding; spent on charters') + $9266f6113786f65f$var$statBlock('Foundings', String(syndicate.founded), foundedNote) + $9266f6113786f65f$var$statBlock('This Era', `${era.total.toLocaleString()}\u{1F396}\u{FE0F} \u{2192} ${(0, $46d374413fb0707a$export$fc09ffc64d9013e3)(era.total)}\u{1F4DC}`, eraNote);
}
/**
 * The founding call-to-action.
 *
 * Always shows what founding is worth right now, even when blocked - a prestige
 * the player cannot yet reach should still be legible, or the requirement reads
 * as an arbitrary wall rather than a goal.
 */ function $9266f6113786f65f$var$renderFounding() {
    const container = document.getElementById('syndicate-founding');
    if (!container) return;
    const eligible = (0, $46d374413fb0707a$export$5799eac7aba24ab2)();
    const era = $9266f6113786f65f$var$projectedEra();
    const writs = (0, $46d374413fb0707a$export$fc09ffc64d9013e3)(era.total);
    const legends = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0;
    const blockedCopy = {
        'insufficient-legends': `Promote ${(0, $46d374413fb0707a$export$ab98ff7829062ba4)() - legends} more Legend${(0, $46d374413fb0707a$export$ab98ff7829062ba4)() - legends === 1 ? '' : 's'} to found.`,
        'raid-in-progress': 'Finish or clear the current raid first.',
        'listed-on-marketplace': 'Your active character is listed on the marketplace.',
        'operations-in-flight': "Wait for your operations to complete \u2014 they are led by this era\u2019s Legends.",
        'no-command-layer': 'The Command layer is not open yet.'
    };
    const progressPct = Math.min(100, Math.round(legends / (0, $46d374413fb0707a$export$ab98ff7829062ba4)() * 100));
    container.innerHTML = `
        <div class="rounded-lg px-3 py-2" style="background:rgba(224,168,76,0.07); border:2px solid ${$9266f6113786f65f$var$GOLD_DIM};">
            <div class="flex flex-wrap justify-between items-center gap-3">
                <div class="min-w-0">
                    <div class="font-bold" style="color:${$9266f6113786f65f$var$GOLD}">\u{1F4DC} Progress towards next Syndicate</div>
                    <div class="founding-subtitle text-xs text-gray-300 leading-snug">
                        Ends this Command era and issues <span class="font-bold" style="color:${$9266f6113786f65f$var$GOLD}">${writs}\u{1F4DC}</span>
                        for the ${era.total.toLocaleString()}\u{1F396}\u{FE0F} earned.
                    </div>
                </div>
                <button onclick="openFoundModal()" ${eligible.ok ? '' : 'disabled'}
                    class="px-4 py-1.5 rounded font-bold whitespace-nowrap ${eligible.ok ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed'}"
                    ${eligible.ok ? `style="background:${$9266f6113786f65f$var$GOLD}"` : ''}>FOUND SYNDICATE</button>
            </div>
            ${eligible.ok ? '' : `
                <!-- Bar and reason share a row: stacked, this banner cost 128px of
                     a 768px viewport for two short lines of status. -->
                <div class="flex items-center gap-2 mt-1.5">
                    <div class="flex-1 h-1.5 rounded-full bg-black/40 overflow-hidden">
                        <div class="h-full" style="width:${progressPct}%; background:${$9266f6113786f65f$var$GOLD}"></div>
                    </div>
                    <div class="text-xs text-gray-400 whitespace-nowrap">${blockedCopy[eligible.reason] || 'Not available right now.'}</div>
                </div>`}
        </div>`;
}
function $9266f6113786f65f$var$rankPips(owned, max) {
    let pips = '';
    for(let i = 0; i < max; i++)pips += `<span class="inline-block w-2.5 h-2.5 rounded-sm mr-1" style="border:1px solid ${$9266f6113786f65f$var$GOLD_DIM}; ${i < owned ? `background:${$9266f6113786f65f$var$GOLD};` : ''}"></span>`;
    return `<span title="Rank ${owned}/${max}">${pips}</span>`;
}
function $9266f6113786f65f$var$renderCharters() {
    const container = document.getElementById('syndicate-charters');
    if (!container) return;
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    container.innerHTML = Object.entries($ce6dd72bc4611534$export$1a64c4c64ba19abd).map(([id, def])=>{
        const rank = (0, $46d374413fb0707a$export$6955e231f1466c44)(id);
        const maxed = rank >= def.costs.length;
        const nextCost = maxed ? null : def.costs[rank];
        // A cross-layer requirement is a real blocker, not a price problem, so
        // it gets its own line rather than a silently-disabled button.
        // Same rule as the purchase itself (`requiredUpgradesMissing`), so the
        // card and the button can never disagree about whether it is buyable.
        const missingRequirement = (0, $bde36de43872f734$export$21736c92e8c4e21c)(def);
        const affordable = !maxed && !missingRequirement.length && syndicate.writs >= nextCost;
        const rankLabel = def.costs.length > 1 && !maxed ? `Rank ${$9266f6113786f65f$var$ROMAN[rank] || rank + 1} \u{2014} ` : '';
        const requirementName = missingRequirement.length ? $9266f6113786f65f$var$commandUpgradeName(missingRequirement, def) : null;
        return `
            <div class="catalog-card bg-white/10 border-2 border-gray-700 rounded-lg p-3 flex flex-col gap-1.5">
                <div class="flex justify-between items-baseline gap-2">
                    <h4 class="font-bold text-[15px] m-0" style="color:${$9266f6113786f65f$var$GOLD}">${def.icon} ${def.name}</h4>
                    ${$9266f6113786f65f$var$rankPips(rank, def.costs.length)}
                </div>
                <div class="catalog-card-flavor text-xs text-gray-400 italic leading-snug" title="${def.flavor}">${def.flavor}</div>
                <div class="catalog-card-effect text-[13px] leading-snug">${def.effect}${rank > 0 && !maxed ? ` <span class="text-game-success">Rank ${$9266f6113786f65f$var$ROMAN[rank - 1] || rank} owned.</span>` : ''}</div>
                ${requirementName ? `<div class="text-xs text-amber-300">\u{1F512} Requires the ${requirementName} Command upgrade${missingRequirement.length > 1 ? 's' : ''}.</div>` : ''}
                <div class="catalog-card-footer flex justify-between items-center mt-auto pt-2">
                    ${maxed ? `<span class="text-game-success text-sm font-bold">\u{2713} Maxed</span><span></span>` : `<span class="font-bold text-sm" style="color:${$9266f6113786f65f$var$GOLD}">${rankLabel}${nextCost} \u{1F4DC}</span>
                           <button onclick="purchaseCharter('${id}')" ${affordable ? '' : 'disabled'}
                               class="px-3 py-1.5 rounded text-xs font-bold ${affordable ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed'}"
                               ${affordable ? `style="background:${$9266f6113786f65f$var$GOLD}"` : ''}>SIGN</button>`}
                </div>
            </div>`;
    }).join('');
}
/**
 * The SAME card the Command gallery uses, in Syndicate gold.
 *
 * A Leader is a Legend who won an election — showing them as a plain text box
 * beside Command's portrait cards made the layer's most permanent character read
 * as the least important thing on the page. A Leader snapshot carries fewer
 * fields than a full Legend record, and the shared card renders only what is
 * present.
 */ function $9266f6113786f65f$var$leaderCard(leader, title, note) {
    return (0, $03d1ca7da93421d9$export$5eeeb728aab285f9)(leader, {
        accent: $9266f6113786f65f$var$GOLD,
        accentDim: $9266f6113786f65f$var$GOLD_DIM,
        title: title,
        note: note
    });
}
/**
 * Succession status.
 *
 * Reads `successionStatus()` — the SAME computation the automation acts on, so
 * the panel can never tell the player something the doctrine does not believe.
 * Shown whenever the charter is owned, including while paused.
 */ function $9266f6113786f65f$var$renderSuccession() {
    const container = document.getElementById('syndicate-succession');
    if (!container) return;
    if ((0, $46d374413fb0707a$export$6955e231f1466c44)('succession-doctrine') <= 0) {
        container.innerHTML = '';
        return;
    }
    const s = (0, $46d374413fb0707a$export$8f29b06b79596501)();
    const paused = (0, $46d374413fb0707a$export$cdfa564b532bb699)().succession?.paused;
    const template = (0, $46d374413fb0707a$export$a91ccccac4a2b08)();
    const pct = Math.min(100, Math.round(s.marksIfPromotedNow / Math.max(1, s.floor) * 100));
    const state = paused ? "\u23F8 Paused" : s.due ? `\u{25B6} Promoting now \u{2014} ${s.reason === 'max-tour' ? 'tour cap reached' : 'past the rate peak'}` : s.tourRaids < (0, $46d374413fb0707a$export$65d88b3701cdf574).minTourRaids ? `Watching \u{2014} ${(0, $46d374413fb0707a$export$65d88b3701cdf574).minTourRaids - s.tourRaids} more raid${(0, $46d374413fb0707a$export$65d88b3701cdf574).minTourRaids - s.tourRaids === 1 ? '' : 's'} before the rate is judged` : s.marksIfPromotedNow < s.floor ? `Holding \u{2014} promotion buys nothing yet (${s.marksIfPromotedNow}/${s.floor}\u{1F396}\u{FE0F})` : `Watching the rate \u{2014} ${s.raidsSincePeak}/${(0, $46d374413fb0707a$export$65d88b3701cdf574).peakPatienceRaids} raids past the peak`;
    container.innerHTML = `
        <div class="rounded-lg p-4" style="background:rgba(224,168,76,0.07); border:2px solid ${$9266f6113786f65f$var$GOLD_DIM};">
            <div class="flex flex-wrap justify-between items-center gap-3">
                <div>
                    <div class="font-bold" style="color:${$9266f6113786f65f$var$GOLD}">\u{1F54A}\u{FE0F} Succession Doctrine</div>
                    <div class="text-sm text-gray-300 mt-1">${state}</div>
                </div>
                <button onclick="toggleSuccessionPause()"
                    class="px-3 py-1.5 rounded text-xs font-bold ${paused ? 'text-black' : 'bg-gray-600 text-white hover:bg-gray-500'}"
                    ${paused ? `style="background:${$9266f6113786f65f$var$GOLD}"` : ''}>${paused ? 'RESUME' : 'PAUSE'}</button>
            </div>
            <div class="mt-3 h-2 rounded-full bg-black/40 overflow-hidden">
                <div class="h-full" style="width:${pct}%; background:${$9266f6113786f65f$var$GOLD}"></div>
            </div>
            <div class="text-xs text-gray-400 mt-1">
                Tour: ${s.tourRaids} raid${s.tourRaids === 1 ? '' : 's'} \xb7
                ${s.marks}\u{1F396}\u{FE0F} on ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.name || 'no one'} \xb7
                rate ${s.avgRate.toFixed(1)}\u{1F396}\u{FE0F}/raid (peak ${s.peakRate.toFixed(1)})
            </div>
            <div class="text-xs text-gray-400 mt-1">
                Successor: ${template ? `${template.faction}${template.derived ? " \u2014 mirrors your current character" : ' (your template)'}` : 'none'}
            </div>
        </div>`;
}
function $9266f6113786f65f$var$renderLeadership() {
    const container = document.getElementById('syndicate-leadership');
    if (!container) return;
    const syndicate = (0, $46d374413fb0707a$export$cdfa564b532bb699)();
    if (!syndicate.leader) {
        // Pre-founding: show who WOULD be elected. The Leader is a permanent
        // Operations anchor, so knowing the candidate is a reason to keep
        // promoting rather than a surprise at the ceremony.
        const candidate = (0, $46d374413fb0707a$export$9ab0fc0c1d4f0dcd)();
        container.innerHTML = candidate ? $9266f6113786f65f$var$leaderCard(candidate, 'Leader-presumptive', "Elected when you found \u2014 the era\u2019s best record leads the Syndicate permanently.") : `<div class="text-sm text-gray-400">No Legends yet. The era's highest-marks Legend becomes your Syndicate Leader.</div>`;
        return;
    }
    container.innerHTML = $9266f6113786f65f$var$leaderCard(syndicate.leader, 'Syndicate Leader', "Permanent \u2014 leads operations in every era.") + syndicate.pastLeaders.slice().reverse().map((l)=>$9266f6113786f65f$var$leaderCard(l, 'Past Leader', '')).join('');
}
(0, $f2aa38d2d36459d1$export$589dc1e4c906c789)('syndicate', {
    panes: {
        charters: 'syndicate-pane-charters',
        leadership: 'syndicate-pane-leadership',
        blackout: 'syndicate-pane-blackout'
    },
    scrollers: {
        charters: 'syndicate-charters',
        leadership: 'syndicate-leadership',
        blackout: 'syndicate-blackout'
    }
});
function $9266f6113786f65f$export$8cd027517c8fb270() {
    $9266f6113786f65f$var$renderSyndicateStats();
    $9266f6113786f65f$var$renderFounding();
    $9266f6113786f65f$var$renderSuccession();
    $9266f6113786f65f$var$renderCharters();
    $9266f6113786f65f$var$renderLeadership();
    (0, $944d26b39bc4cb46$export$736506b4b237950c)();
    // Re-measures the scroller: the founding banner and the succession panel
    // above it both change height with state, so a fixed offset would be wrong
    // the moment a charter is bought.
    (0, $f2aa38d2d36459d1$export$7ad721b2ffe28f0c)('syndicate');
}
function $9266f6113786f65f$export$dbfe7896af6f1ddd(charterId) {
    const def = $ce6dd72bc4611534$export$1a64c4c64ba19abd?.[charterId];
    const result = (0, $46d374413fb0707a$export$db5a865159d9ae65)(charterId);
    if (!result.success) {
        const messages = {
            'insufficient-writs': 'Not enough Writs',
            'max-rank': 'Already at maximum rank!',
            'unknown-charter': 'Unknown charter',
            'missing-requirement': `Requires the ${$9266f6113786f65f$var$commandUpgradeName(result.requires, def)} Command upgrade first`
        };
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(messages[result.reason] || 'Could not sign that charter', 'error');
        return;
    }
    const rankSuffix = def.costs.length > 1 ? ` Rank ${$9266f6113786f65f$var$ROMAN[result.rank - 1] || result.rank}` : '';
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4DC} Signed ${def.name}${rankSuffix} (-${result.cost} \u{1F4DC})`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $9266f6113786f65f$export$8cd027517c8fb270();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
}
function $9266f6113786f65f$export$fd4956538c1ee694() {
    const modal = document.getElementById('found-modal');
    const body = document.getElementById('found-modal-body');
    if (!modal || !body) return;
    const eligible = (0, $46d374413fb0707a$export$5799eac7aba24ab2)();
    if (!eligible.ok) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot found a Syndicate right now', 'error');
        return;
    }
    const era = $9266f6113786f65f$var$projectedEra();
    const writs = (0, $46d374413fb0707a$export$fc09ffc64d9013e3)(era.total);
    const leader = (0, $46d374413fb0707a$export$9ab0fc0c1d4f0dcd)();
    // Standing Orders re-grants BOTH automation upgrades, so the ledger names
    // both. This column is the confirmation for an irreversible action —
    // under-reporting what survives is the same class of error as
    // over-reporting it.
    const keepsAutomation = (0, $46d374413fb0707a$export$6955e231f1466c44)('standing-orders') > 0;
    const endowment = (0, $46d374413fb0707a$export$d9ea4b2d96397ab9)('founders-endowment', 0);
    // Both columns, spelled out. Founding is irreversible and wipes an era of
    // work, so the ledger IS the ceremony - a confirm dialog that only said
    // "are you sure?" would be the wrong control for this decision.
    body.innerHTML = `
        <p class="mb-4">
            Your Syndicate is founded from the officers of this era. Their record becomes its charter \u{2014}
            and the Command layer starts again from nothing.
        </p>

        <div class="rounded-lg p-4 mb-4" style="background:rgba(224,168,76,0.10); border:2px solid ${$9266f6113786f65f$var$GOLD_DIM};">
            <div class="text-[11px] uppercase tracking-widest text-gray-400">You receive</div>
            <div class="text-2xl font-bold mt-1" style="color:${$9266f6113786f65f$var$GOLD}">${writs} \u{1F4DC} Writs</div>
            <div class="text-xs text-gray-400 mt-1">
                from ${era.total.toLocaleString()}\u{1F396}\u{FE0F} this era${era.unbanked > 0 ? ` \u{2014} including ${era.unbanked.toLocaleString()}\u{1F396}\u{FE0F} still on ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.name}, folded in automatically` : ''}
            </div>
            ${leader ? `<div class="text-sm mt-2">Syndicate Leader: <span class="font-bold" style="color:${$9266f6113786f65f$var$GOLD}">${leader.name}</span> (${(leader.marksEarned || 0).toLocaleString()}\u{1F396}\u{FE0F})</div>` : ''}
        </div>

        <div class="grid gap-4 mb-4" style="grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));">
            <div class="rounded-lg p-3 border-2 border-red-900/60" style="background:rgba(239,68,68,0.07)">
                <div class="text-[11px] uppercase tracking-widest text-red-300">Wiped</div>
                <ul class="text-[13px] mt-2 space-y-1 list-disc list-inside text-gray-200">
                    <li>All Command Marks and upgrades</li>
                    <li>All ${(0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0} Legends</li>
                    <li>Regional charters</li>
                    <li>Your characters, and the vault's materials</li>
                    <li>Credits, down to ${$ce6dd72bc4611534$export$9f9786ac427715c7.promotionCreditLevy.floor.toLocaleString()}</li>
                </ul>
            </div>
            <div class="rounded-lg p-3 border-2 border-green-900/60" style="background:rgba(74,222,128,0.07)">
                <div class="text-[11px] uppercase tracking-widest text-green-300">Kept</div>
                <ul class="text-[13px] mt-2 space-y-1 list-disc list-inside text-gray-200">
                    <li>Every Writ and charter you hold</li>
                    <li>Unlocked artifact designs</li>
                    <li>Artifact blueprints in the vault</li>
                    <li>Your Syndicate Leader, and past leaders</li>
                    ${keepsAutomation ? '<li>Auto-Raid Protocol and Auto-Fabricator (Standing Orders)</li>' : ''}
                    ${endowment > 0 ? `<li>${endowment}\u{1F396}\u{FE0F} to start the next era (Founder's Endowment)</li>` : ''}
                </ul>
            </div>
        </div>

        <div class="flex justify-end gap-3">
            <button onclick="closeFoundModal()" class="px-4 py-2 rounded font-bold bg-gray-600 hover:bg-gray-500 text-white">Not yet</button>
            <button onclick="confirmFounding()" class="px-4 py-2 rounded font-bold text-black hover:shadow-lg" style="background:${$9266f6113786f65f$var$GOLD}">Sign the Charter</button>
        </div>`;
    modal.classList.remove('hidden');
}
function $9266f6113786f65f$export$e82e976bfeefb724() {
    document.getElementById('found-modal')?.classList.add('hidden');
}
function $9266f6113786f65f$export$4f6051a0a4daa070() {
    const character = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    const multiplayerId = character?.multiplayerId;
    const result = (0, $46d374413fb0707a$export$1861729e67332c20)();
    if (!result.success) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)('Cannot found a Syndicate right now', 'error');
        $9266f6113786f65f$export$e82e976bfeefb724();
        return;
    }
    // Same server-side handling promotion uses: the character is gone.
    if (multiplayerId && window.multiplayer?.deleteOwnCharacter) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost for the new era.
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $bd083a63eb37c143$export$aca974319671fb3e)();
    $9266f6113786f65f$export$e82e976bfeefb724();
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F4DC} Syndicate founded \u{2014} ${result.leader?.name || 'your Leader'} takes the charter \xb7 +${result.writs} \u{1F4DC}`, 'success', {
        sticky: true
    } // irreversible, once per era, and it hands off to a fresh character
    );
    // The active slot is empty: same handoff promotion performs.
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b)();
    $9266f6113786f65f$export$8cd027517c8fb270();
    if (window.showCharacterScreenAfterPromotion) window.showCharacterScreenAfterPromotion();
}
// ---------------------------------------------------------------------------
// Succession Doctrine — promote at the peak, raise the successor
// ---------------------------------------------------------------------------
/** Successor names. Flavour only; the player can rename from the character card. */ const $9266f6113786f65f$var$SUCCESSOR_NAMES = [
    'Ash',
    'Vale',
    'Corr',
    'Wren',
    'Idris',
    'Sable',
    'Quill',
    'Mercer',
    'Rook',
    'Lin'
];
function $9266f6113786f65f$var$successorName(tour) {
    // Deterministic from the tour number rather than random, so a successor's
    // name is reproducible from a save rather than a fresh roll on every load.
    return `${$9266f6113786f65f$var$SUCCESSOR_NAMES[tour % $9266f6113786f65f$var$SUCCESSOR_NAMES.length]}-${tour}`;
}
function $9266f6113786f65f$export$e62c6e81abdadce7(status) {
    const outgoing = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character;
    if (!outgoing) return {
        success: false,
        reason: 'no-character'
    };
    const template = (0, $46d374413fb0707a$export$a91ccccac4a2b08)();
    const multiplayerId = outgoing.multiplayerId;
    const result = (0, $bde36de43872f734$export$f0bd6e9010bb1600)();
    if (!result.success) return result;
    if (multiplayerId && window.multiplayer?.deleteOwnCharacter) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost, exactly as the manual promote path does.
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = template?.faction || null;
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).contractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $bd083a63eb37c143$export$aca974319671fb3e)();
    const recruit = (0, $7df15cefc09eac1b$export$c05f4d64df5567a5)({
        name: $9266f6113786f65f$var$successorName((0, $f27982cef7035d22$export$8e361a1ffbebf172).command.tour),
        faction: template?.faction || outgoing.faction
    });
    // Spend the recruit's opening points along the template's ordering, so the
    // successor starts pointed the same way the player was playing.
    $9266f6113786f65f$var$applySkillPlan(recruit, template?.skillPlan || []);
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F54A}\u{FE0F} Succession \u{2014} ${result.legend.name} promoted (${result.marks.total}\u{1F396}\u{FE0F}, ${status?.reason === 'max-tour' ? 'tour cap' : 'rate peak'}) \xb7 ${recruit.name} takes the field`, 'success', {
        sticky: true
    } // happens while the player is away, and it replaced their character
    );
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b)();
    $9266f6113786f65f$export$8cd027517c8fb270();
    return {
        success: true,
        legend: result.legend,
        recruit: recruit
    };
}
function $9266f6113786f65f$export$ee70bc03de7bbd2f() {
    const paused = (0, $46d374413fb0707a$export$43bf52c97b14116a)(!(0, $46d374413fb0707a$export$cdfa564b532bb699)().succession?.paused);
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    $9266f6113786f65f$export$8cd027517c8fb270();
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(paused ? "\uD83D\uDD4A\uFE0F Succession paused" : "\uD83D\uDD4A\uFE0F Succession resumed", paused ? 'info' : 'success');
}
function $9266f6113786f65f$var$applySkillPlan(character, skillPlan) {
    if (!character || !skillPlan?.length) return;
    let points = character.skillPoints || 0;
    for (const skillId of skillPlan){
        if (points <= 0) break;
        character.skills[skillId] = (character.skills[skillId] || 0) + 1;
        points -= 1;
    }
    character.skillPoints = points;
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.purchaseCharter = $9266f6113786f65f$export$dbfe7896af6f1ddd;
    window.openFoundModal = $9266f6113786f65f$export$fd4956538c1ee694;
    window.closeFoundModal = $9266f6113786f65f$export$e82e976bfeefb724;
    window.confirmFounding = $9266f6113786f65f$export$4f6051a0a4daa070;
    window.toggleSuccessionPause = $9266f6113786f65f$export$ee70bc03de7bbd2f;
    document.addEventListener('DOMContentLoaded', ()=>{
        document.getElementById('found-modal-close')?.addEventListener('click', $9266f6113786f65f$export$e82e976bfeefb724);
    });
}


/**
 * Operations UI (M3 S4) — the browser wrapper over operations-core.js.
 *
 * Layout is the INVERSE of the raid view on purpose: the whole world map at the
 * top, controls beneath it. A raid path is built by clicking rooms in sequence;
 * a route is chosen by looking at where things are relative to each other, so
 * the map has to be the thing you read first.
 *
 * The map is a plain CSS grid, NOT the raid grid renderer. The spec suggested
 * reusing it, but that renderer paints a procedural canvas per tile and is
 * wired to raid state throughout; a world map needs five region pins and some
 * terrain shading. Reuse would have cost more than it saved.
 *
 * All rules live in operations-core.js — this file renders and reports.
 */ 








const $52f5c9f49814d28d$var$GOLD = '#e0a84c';
const $52f5c9f49814d28d$var$GOLD_DIM = '#8a6526';
/**
 * Territory colour per region.
 *
 * Placeholder until tiles are procedurally generated (no spec yet): the job for
 * now is only that a player can see WHICH region a tile belongs to. Hues are
 * spread far enough apart to stay distinct after terrain shading darkens them.
 */ const $52f5c9f49814d28d$var$REGION_COLOR = {
    'cradle-expanse': '#7a5a3c',
    'shard-cities': '#4a5a7a',
    'verdant-reclamation': '#3f6b45',
    'sunken-bastions': '#2f6b6b',
    'hollow-core': '#6b3f5f'
};
/**
 * Terrain modulates the territory colour rather than replacing it, so a tile
 * answers both questions at once: whose is it, and what is the ground like.
 * `mix` is how far toward the terrain tint the region colour is dragged.
 */ const $52f5c9f49814d28d$var$TERRAIN_STYLE = {
    '.': {
        tint: null,
        mix: 0,
        label: 'Open ground',
        cost: 1
    },
    // Highland LIGHTENS. Darkening made high ground read as shadow, which is
    // backwards — at this scale a highland is a snowline, and the eye reads
    // pale as "up".
    '^': {
        tint: '#dfe7f0',
        mix: 0.34,
        label: 'Highland',
        cost: 2
    },
    // Ocean is very nearly uniform, and dark. It used to blend only halfway to
    // a mid blue, which left every sea tile carrying its region's hue — the map
    // read as five vertical colour bands with invisible coastlines. Darkening
    // it further is what separates the sea from the two regions whose own
    // colours are blue-ish (Shard Cities slate, Flooded Bastions teal); at a
    // lighter value their coastlines disappeared into it.
    '~': {
        tint: '#061424',
        mix: 0.92,
        label: 'Ocean',
        cost: 3
    },
    '#': {
        tint: '#000000',
        mix: 0.85,
        label: 'Impassable',
        cost: null
    }
};
/** Blend two hex colours. Keeps territory legible under terrain shading. */ function $52f5c9f49814d28d$var$mixHex(base, tint, amount) {
    if (!tint || amount <= 0) return base;
    const parse = (h)=>[
            1,
            3,
            5
        ].map((i)=>parseInt(h.slice(i, i + 2), 16));
    const [r1, g1, b1] = parse(base);
    const [r2, g2, b2] = parse(tint);
    const blend = (a, b)=>Math.round(a + (b - a) * amount).toString(16).padStart(2, '0');
    return `#${blend(r1, r2)}${blend(g1, g2)}${blend(b1, b2)}`;
}
/** Distinct colours for each convoy in transit, so routes never merge visually. */ const $52f5c9f49814d28d$var$CONVOY_COLORS = [
    '#6ee7ff',
    '#ff9de2',
    '#ffe066'
];
/** Green marks a delivery that also earns the Writ trickle. */ const $52f5c9f49814d28d$var$DEMAND_HOT = '#7df5a0';
/**
 * The demand premium, rendered.
 *
 * Two states worth distinguishing, not one: any premium is worth seeing, but the
 * Writ threshold is a cliff — cross it and a Long Haul pays 2📜 instead of 1 —
 * and a cliff nobody can see is a cliff nobody plans around.
 */ /**
 * Would a delivery at this multiplier actually bank a Writ *as drafted*?
 *
 * BOTH halves have to hold: the market must be hungry AND the class must be
 * Writ-eligible (only Grand Circuit is — see OPERATION_TEMPLATES). Reading the
 * demand alone stamped 📜 on every hungry destination on the map even while a
 * Short Haul was selected, promising a reward that class can never earn.
 *
 * Deliberately NOT used for the demand COLOUR: a market is hot whatever you
 * choose to send, and hiding that would hide the reason to step up a class.
 */ function $52f5c9f49814d28d$var$draftEarnsWrit(multiplier) {
    return (0, $356ad444ead618fc$export$d48946d0a3e2934b)(multiplier) && !!(0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[$52f5c9f49814d28d$var$draft.templateId]?.writEligible;
}
function $52f5c9f49814d28d$var$demandChip(multiplier, { markWrit: markWrit = true, base: base = null } = {}) {
    // A fallen price is only readable next to what it fell from, so a fed market
    // carries its struck-through list price. Only when it has actually moved —
    // "×2.00 ×2.00" would be noise on every hungry region on the map.
    const strike = $52f5c9f49814d28d$var$isFed(multiplier, base) ? ` <span class="text-gray-500 line-through">\xd7${base.toFixed(2)}</span>` : '';
    if (!multiplier || multiplier <= (0, $356ad444ead618fc$export$2119d59df637b878)) return `<span class="text-gray-500">\xd71.00</span>${strike}`;
    const hot = (0, $356ad444ead618fc$export$d48946d0a3e2934b)(multiplier);
    // `markWrit` off wherever the actual Writ count is already on the line —
    // "+2📜 · ×1.90 +📜" says the same thing twice and reads as two bonuses.
    return `<span style="color:${hot ? $52f5c9f49814d28d$var$DEMAND_HOT : $52f5c9f49814d28d$var$GOLD}">\xd7${multiplier.toFixed(2)}${markWrit && $52f5c9f49814d28d$var$draftEarnsWrit(multiplier) ? " +\uD83D\uDCDC" : ''}</span>${strike}`;
}
/** Plain-text form of the same, for <option> labels and tooltips. */ function $52f5c9f49814d28d$var$demandText(multiplier, base = null) {
    const list = $52f5c9f49814d28d$var$isFed(multiplier, base) ? ` (list \xd7${base.toFixed(2)})` : '';
    if (!multiplier || multiplier <= (0, $356ad444ead618fc$export$2119d59df637b878)) return `\xd71.00${list}`;
    return `\xd7${multiplier.toFixed(2)}${$52f5c9f49814d28d$var$draftEarnsWrit(multiplier) ? " +\uD83D\uDCDC" : ''}${list}`;
}
/**
 * Has this price actually been pushed down by saturation?
 *
 * The epsilon is not decoration: both numbers are rounded to 2dp independently,
 * so a market a fraction of a percent fed can round to its own list price and a
 * bare `>` would strike through "×2.00 ×2.00".
 */ function $52f5c9f49814d28d$var$isFed(multiplier, base) {
    return base != null && base > (multiplier || 0) + 0.005;
}
/** Recovery time, rounded to whatever unit reads better at that scale. */ function $52f5c9f49814d28d$var$recoveryText(ms) {
    const hours = ms / 3600000;
    return hours >= 1 ? `~${Math.round(hours)}h` : `~${Math.max(1, Math.round(hours * 60))}m`;
}
/**
 * Why a price is down and when it comes back, appended to a tooltip.
 *
 * Empty for a hungry market: the mechanic should be invisible until it bites,
 * and a "0% fed" note on every region teaches nothing.
 */ function $52f5c9f49814d28d$var$saturationNote(regionId, faction) {
    const level = (0, $356ad444ead618fc$export$f9e4fa3cb5360b25)(regionId, faction);
    if (level <= 0) return '';
    return ` \xb7 market ${Math.round(level * 100)}% fed, list \xd7${(0, $356ad444ead618fc$export$37444e2aca3975f8)(regionId, faction).toFixed(2)},` + ` recovers ${$52f5c9f49814d28d$var$recoveryText((0, $356ad444ead618fc$export$5839d85e36227b6a)(regionId, faction))}`;
}
/**
 * Which view of the Operations screen is showing.
 *
 * Planning a convoy and watching three of them are different jobs. Putting both
 * on one page meant the map carried every route at once, which is exactly the
 * information overload this splits apart:
 *
 *   'plan'    — the map with ONLY the route being planned, plus the controls
 *   'transit' — the map with every convoy, plus their cards; no controls
 *
 * The toolbar's "New Operation" button opens 'plan'; the Operations screen tab
 * opens 'transit'.
 */ let $52f5c9f49814d28d$var$view = 'transit';
/** In 'transit', the convoy whose route is isolated. null = show them all. */ let $52f5c9f49814d28d$var$selectedOpId = null;
function $52f5c9f49814d28d$export$a4a190e64d36c7a(next) {
    $52f5c9f49814d28d$var$view = next === 'plan' ? 'plan' : 'transit';
    if ($52f5c9f49814d28d$var$view === 'plan') $52f5c9f49814d28d$var$selectedOpId = null;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$7bde3dae25e9ac40(opId) {
    // Clicking the selected convoy again returns to "show them all", so there
    // is always a way back without hunting for a deselect control.
    $52f5c9f49814d28d$var$selectedOpId = $52f5c9f49814d28d$var$selectedOpId === opId ? null : opId;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
/** Planner selection. Module state, not gameState: nothing here is worth saving. */ const $52f5c9f49814d28d$var$draft = {
    templateId: 'short-haul',
    toRegionId: null,
    fromRegionId: null,
    skillId: null,
    leadName: null
};
/**
 * The four staging points available for the chosen destination, shortest first.
 *
 * No cache and no template argument, both of which the derived-origin version
 * needed: offers were random within a ring, so re-rolling on every render made
 * the map shuffle under the cursor, and reach depended on the template. Neither
 * is true now — this is four Dijkstra runs over 153 tiles with one answer, so
 * caching it would only be a second thing to invalidate.
 *
 * Sorted by duration because duration is the decision the list exists to serve.
 */ function $52f5c9f49814d28d$var$currentOffers() {
    if (!$52f5c9f49814d28d$var$draft.toRegionId) return [];
    return (0, $cb0ad7004fe6b26a$export$f41c2be0717214ee)($52f5c9f49814d28d$var$draft.toRegionId).sort((a, b)=>a.hours - b.hours);
}
/** The offer for the chosen origin, or null. */ function $52f5c9f49814d28d$var$currentOffer() {
    return $52f5c9f49814d28d$var$currentOffers().find((o)=>o.fromRegionId === $52f5c9f49814d28d$var$draft.fromRegionId) || null;
}
/**
 * Every signature a convoy can carry, grouped by faction.
 *
 * ALL fifteen, not just the player's own five. Restricting cargo to your own
 * faction made the demand premium a single lookup: a dominion player's five
 * signatures all price identically, so the only variable left was destination
 * and there was exactly one right answer forever.
 *
 * Opening it up is what makes this an economy BETWEEN factions rather than a
 * price list. Off-faction material is what a player accumulates by raiding
 * elsewhere and has no recipes for, and the regions that pay most for it are the
 * ones that produce least of it. Nothing had to be built: planCargo already
 * reads any signature, and a signature the player has no stock in simply blocks
 * the launch as "NO CARGO".
 *
 * @returns {Array<{faction:string, name:string, skills:string[]}>}
 */ function $52f5c9f49814d28d$var$signatureGroups() {
    const own = (0, $f27982cef7035d22$export$8e361a1ffbebf172).character?.faction;
    return Object.entries($ce6dd72bc4611534$export$aeeef991191508e2 || {}).map(([faction, def])=>({
            faction: faction,
            name: def.name || faction,
            skills: Object.keys(def.skills || {})
        }))// The player's own faction first: it is the one they will usually have
    // stock in, so it should not need scrolling to.
    .sort((a, b)=>(a.faction === own ? -1 : 0) - (b.faction === own ? -1 : 0));
}
function $52f5c9f49814d28d$var$allSignatureIds() {
    return $52f5c9f49814d28d$var$signatureGroups().flatMap((g)=>g.skills);
}
/**
 * The cargo-signature control: fifteen signatures in three priced groups.
 *
 * Grouped by faction because the PRICE is per-faction — every dominion signature
 * fetches the same premium at a given destination — so the group header is the
 * honest place for it, and repeating it on all five options would be noise.
 *
 * Each option is marked when the player cannot actually fill that manifest.
 * Without it the only way to discover a signature is unshippable is to select it
 * and watch LAUNCH turn into NO CARGO, which is a dead end per attempt.
 *
 * ⚠ EVERY OPTION CARRIES ITS STOCK, and that is the whole hint. Because the
 * price is per-faction, the five signatures inside a group are worth EXACTLY
 * the same to ship — so the only thing that separates them is how much of each
 * you are sitting on, and the right play is always the deepest pile. Grouping
 * says they are interchangeable; the stock number says which to pick.
 *
 * Without it the choice looks arbitrary and gets made arbitrarily. The
 * simulator did precisely that — it broke the tie on iteration order, shipped
 * the same two signatures forever, and left the biggest piles untouched (the
 * five deepest received 2 convoys between them). A player reading a list of
 * five identically-priced names has no more information than that loop did.
 *
 * Stock is shown in UNITS, not credits: a signature holding three rares
 * outvalues one holding sixty commons, so a credit figure would point at the
 * pile that is not in the player's way. See `signatureStock`.
 *
 * ⚠ THE OPTION SAYS "items" AND THE BUDGET IS IN 💰, and it took three passes.
 * Both figures started as 📦, so one glyph carried two incomparable scales: a
 * Long Haul reading "📦340" beside a signature reading "📦9" invites the
 * conclusion that you are 331 short, when those 9 units are worth 815 — more
 * than twice the budget.
 *
 *   1. "📦340 goods" vs "9 items" — fixed nothing. Synonyms; both read as counts.
 *   2. "📦340 value" vs "9 items" — better, but "value" of WHAT is still a guess.
 *   3. "340💰" vs "9 items" — the budget IS a credit figure (materialValue-core
 *      derives it from the crafting ladder), so it takes the credit icon the
 *      rest of the game already uses. A count and a price cannot be confused.
 *
 * The numbers were right throughout; only their units were ever missing.
 *
 * Sorted deepest-first WITHIN a group for the same reason — the useful answer
 * should not need hunting for. Groups keep their own order (the player's own
 * faction leads), because that is a different question.
 */ function $52f5c9f49814d28d$var$signatureSelect(templateId, sizeClass = 'text-sm px-2 py-1.5') {
    const groups = $52f5c9f49814d28d$var$signatureGroups().map((group)=>{
        const premium = $52f5c9f49814d28d$var$draft.toRegionId ? ` \xb7 ${$52f5c9f49814d28d$var$demandText((0, $356ad444ead618fc$export$b9d88bbf27398a14)($52f5c9f49814d28d$var$draft.toRegionId, group.faction), (0, $356ad444ead618fc$export$37444e2aca3975f8)($52f5c9f49814d28d$var$draft.toRegionId, group.faction))}` : '';
        const options = group.skills.map((skillId)=>({
                skillId: skillId,
                stock: (0, $cb0ad7004fe6b26a$export$94a2b01ae45f0aa0)(skillId).units
            })).sort((a, b)=>b.stock - a.stock).map(({ skillId: skillId, stock: stock })=>{
            const { short: short } = (0, $cb0ad7004fe6b26a$export$a666674acd11f81d)(templateId, skillId);
            const thin = short.value > 0;
            const name = $ce6dd72bc4611534$export$aeeef991191508e2[group.faction]?.skills?.[skillId]?.name || skillId;
            return `<option value="${skillId}" ${skillId === $52f5c9f49814d28d$var$draft.skillId ? 'selected' : ''}>${name} \xb7 ${stock} items${thin ? " \u26A0" : ''}</option>`;
        }).join('');
        return `<optgroup label="${group.name}${premium}">${options}</optgroup>`;
    }).join('');
    return `
        <select id="op-skill" onchange="setOperationSignature(this.value)"
            title="Every signature in a faction fetches the SAME price, so the only thing separating them is stock \u{2014} \u{1F4E6} is what the dock holds. Ship your deepest pile."
            class="w-full bg-white/5 border-2 border-gray-600 rounded text-white ${sizeClass}">
            ${groups}
        </select>`;
}
/**
 * Fill any unset draft field with a sensible default.
 *
 * Endpoints are deliberately NOT defaulted: the map lets the player pick them,
 * and pre-filling both was what made pin-clicking feel broken — with origin and
 * destination always set, every click could only ever overwrite the
 * destination, so there was no way to choose an origin or start over.
 */ function $52f5c9f49814d28d$var$ensureDraftDefaults() {
    if (!$52f5c9f49814d28d$var$draft.skillId) $52f5c9f49814d28d$var$draft.skillId = $52f5c9f49814d28d$var$allSignatureIds()[0] || null;
    // A destination with no staging point is a half-planned route the player
    // cannot launch and did not ask for. Default to the SHORTEST run: it is the
    // cheapest thing that can go wrong, and the long routes are the ones worth
    // choosing deliberately. Also re-seats a stale origin — picking a new
    // destination can make the previous origin the destination itself.
    const offers = $52f5c9f49814d28d$var$currentOffers();
    if (offers.length && !offers.some((o)=>o.fromRegionId === $52f5c9f49814d28d$var$draft.fromRegionId)) $52f5c9f49814d28d$var$draft.fromRegionId = offers[0].fromRegionId;
    if (!$52f5c9f49814d28d$var$draft.toRegionId) $52f5c9f49814d28d$var$draft.fromRegionId = null;
    const leads = (0, $cb0ad7004fe6b26a$export$34097b07af09d661)();
    if (!$52f5c9f49814d28d$var$draft.leadName || !leads.some((l)=>l.name === $52f5c9f49814d28d$var$draft.leadName)) // BEST record, not the first in the list. The lead bonus is worth up to
    // +25% credits, so defaulting to whoever happened to be first was
    // quietly costing the player money on every convoy they did not stop to
    // re-pick — and it is what lets the control be small.
    $52f5c9f49814d28d$var$draft.leadName = leads.reduce((best, l)=>!best || (l.marksEarned || 0) > (best.marksEarned || 0) ? l : best, null)?.name || null;
}
// ---------------------------------------------------------------------------
// Map
// ---------------------------------------------------------------------------
function $52f5c9f49814d28d$var$renderMap() {
    const container = document.getElementById('operations-map');
    if (!container) return;
    const { width: width, height: height, tiles: tiles, regions: regions } = (0, $cb0ad7004fe6b26a$export$8fe62d261aacdb61)();
    // One timestamp for the whole paint: convoy progress, the terminator and
    // every tooltip must agree about when "now" is.
    const now = Date.now();
    // The planned route belongs to the PLANNER only. Drawing it on the transit
    // board left the last-planned route highlighted there permanently — and
    // because it never cleared when a convoy was selected, it read as one
    // convoy's highlight refusing to go away.
    const offer = $52f5c9f49814d28d$var$view === 'plan' ? $52f5c9f49814d28d$var$currentOffer() : null;
    const planned = offer ? {
        tiles: offer.tiles,
        cost: offer.cost
    } : null;
    const plannedKeys = new Set((planned?.tiles || []).map((t)=>`${t.row},${t.col}`));
    // The planner shows ONLY the route being planned — that is the whole point
    // of splitting the views. The transit board shows every convoy, or just one
    // when the player has selected it.
    const allOps = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations || [];
    const shown = $52f5c9f49814d28d$var$view === 'plan' ? [] : $52f5c9f49814d28d$var$selectedOpId ? allOps.filter((o)=>o.id === $52f5c9f49814d28d$var$selectedOpId) : allOps;
    // tile -> { color, fill } where `fill` is how far this convoy has crossed
    // THIS tile, 0..1. Split by TERRAIN COST via routeProgress(), so a water
    // tile holds the convoy three times as long as an open one — which is what
    // the route cost already charged for in the duration.
    const convoyAt = new Map();
    const convoys = shown.map((op)=>{
        const color = $52f5c9f49814d28d$var$CONVOY_COLORS[allOps.indexOf(op) % $52f5c9f49814d28d$var$CONVOY_COLORS.length];
        const route = op.waypoints ? (0, $cb0ad7004fe6b26a$export$c8a5c29d2838f4de)(op.waypoints) : (0, $cb0ad7004fe6b26a$export$4fa936acba669006)(op.from || op.fromRegionId, op.toRegionId);
        const routeTiles = route?.tiles || [];
        const pct = Math.min(1, Math.max(0, (now - op.startedAt) / (op.completesAt - op.startedAt)));
        const { fills: fills, index: index } = (0, $cb0ad7004fe6b26a$export$f23f7f2631f7375a)(route, pct);
        routeTiles.forEach((t, i)=>{
            const key = `${t.row},${t.col}`;
            const fill = fills[i] ?? 0;
            const existing = convoyAt.get(key);
            // Where two routes overlap, the further-advanced one wins the tile,
            // so a shared corridor still shows the leading convoy.
            if (!existing || fill > existing.fill) convoyAt.set(key, {
                color: color,
                fill: fill
            });
        });
        // Same computation drives the marker, so the ▪ can never disagree with
        // the squares about where the convoy is.
        return {
            op: op,
            color: color,
            at: routeTiles[index],
            pct: pct
        };
    });
    const convoyMarker = new Map(convoys.filter((c)=>c.at).map((c)=>[
            `${c.at.row},${c.at.col}`,
            c
        ]));
    // Leg boundaries. The first waypoint already carries the staging marker (the
    // class icon) and the last is the 🏕️ destination, so only the joins in
    // between get a flag — those are the turns a tour actually makes.
    const legFlagAt = new Map();
    const flagWaypoints = (waypoints, color)=>{
        (waypoints || []).slice(1, -1).forEach((w)=>{
            const key = `${w.row},${w.col}`;
            if (!legFlagAt.has(key)) legFlagAt.set(key, color);
        });
    };
    if (offer) flagWaypoints(offer.waypoints, $52f5c9f49814d28d$var$GOLD);
    convoys.forEach((c)=>flagWaypoints(c.op.waypoints, c.color));
    const capitalOf = {};
    for (const id of (0, $cb0ad7004fe6b26a$export$4a444fae199f4849)()){
        const t = (0, $cb0ad7004fe6b26a$export$9caf4fdf37b2a28)(id);
        if (t) capitalOf[`${t.row},${t.col}`] = id;
    }
    let cells = '';
    for(let row = 0; row < height; row++)for(let col = 0; col < width; col++){
        const terrain = tiles[row][col];
        const regionId = regions[row][col];
        const style = $52f5c9f49814d28d$var$TERRAIN_STYLE[terrain] || $52f5c9f49814d28d$var$TERRAIN_STYLE['.'];
        const bg = $52f5c9f49814d28d$var$mixHex($52f5c9f49814d28d$var$REGION_COLOR[regionId] || '#333333', style.tint, style.mix);
        const key = `${row},${col}`;
        const capital = capitalOf[key];
        const onRoute = plannedKeys.has(key);
        const convoy = convoyAt.get(key);
        const convoyColor = convoy?.color;
        const marker = convoyMarker.get(key);
        const regionName = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[regionId]?.name || regionId || 'Unclaimed';
        // A capital is a place you can SELL to, so its tooltip carries the
        // price. Only in the planner: on the transit board the signature is
        // already fixed per convoy and a hover price would be misleading.
        const capitalDemand = capital && $52f5c9f49814d28d$var$view === 'plan' && $52f5c9f49814d28d$var$draft.skillId ? ` \xb7 pays ${$52f5c9f49814d28d$var$demandText((0, $356ad444ead618fc$export$6bba5a60cd02466f)(capital, $52f5c9f49814d28d$var$draft.skillId))}` + $52f5c9f49814d28d$var$saturationNote(capital, (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)($52f5c9f49814d28d$var$draft.skillId)) : '';
        // Local time on EVERY tile, not just capitals: the clock is keyed
        // to tiles, the terminator is visible across open ground, and a
        // player who wonders why one stretch of a route is dark should get
        // the answer by hovering it.
        const tileLocal = (0, $c454fb723f814d89$export$239629a81011f2a4)({
            row: row,
            col: col
        }, now);
        const title = `${regionName} \xb7 ${style.label}${style.cost ? ` (cost ${style.cost})` : ''}${capitalDemand} \xb7 ${tileLocal.time} local`;
        // Origin and destination are DIFFERENT glyphs, not the same pin in a
        // different colour — direction has to be readable at a glance.
        //
        // In the planner EVERY capital is a possible destination, so every
        // capital wears the 🏕️ and carries its own price. The premium was
        // otherwise only visible one option at a time in a dropdown, which
        // is the worst possible place for a number whose entire purpose is
        // to be compared against four others.
        let glyph = '';
        const isOrigin = offer && offer.from.row === row && offer.from.col === col;
        const legFlag = legFlagAt.get(key);
        const chosen = capital && capital === $52f5c9f49814d28d$var$draft.toRegionId;
        if (chosen) glyph = '<span class="world-pin dest" title="Destination">\uD83C\uDFD5\uFE0F</span>';
        else if (isOrigin) {
            const cls = (0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[$52f5c9f49814d28d$var$draft.templateId];
            glyph = `<span class="world-pin origin" title="Staging point${cls ? ` \u{2014} ${cls.name}` : ''}">${cls?.icon || "\u25B6"}</span>`;
        } else if (legFlag) glyph = `<span class="world-pin leg" style="color:${legFlag}" title="Leg staging point">\u{2691}</span>`;
        else if (capital && $52f5c9f49814d28d$var$view === 'plan') glyph = '<span class="world-pin dest dim" title="Possible destination">\uD83C\uDFD5\uFE0F</span>';
        else if (capital) glyph = '<span class="world-pin">\u25C6</span>';
        // Price tag, planner only. On the transit board each convoy's
        // signature is already fixed, so a per-region price there would be
        // quoting a trade the player can no longer make.
        if (capital && $52f5c9f49814d28d$var$view === 'plan' && $52f5c9f49814d28d$var$draft.skillId && !isOrigin) {
            const mult = (0, $356ad444ead618fc$export$6bba5a60cd02466f)(capital, $52f5c9f49814d28d$var$draft.skillId);
            const hot = (0, $356ad444ead618fc$export$d48946d0a3e2934b)(mult);
            const color = mult <= (0, $356ad444ead618fc$export$2119d59df637b878) ? '#9ca3af' : hot ? $52f5c9f49814d28d$var$DEMAND_HOT : $52f5c9f49814d28d$var$GOLD;
            // One line, not two: a tile is ~40px wide and a wrapped price tag
            // spills past its own tile into the neighbour's.
            // The 📜 tracks the DRAFT, not just the market — the colour still
            // says "hungry" so stepping up a class has a visible reason.
            glyph += `<span class="world-price" style="color:${color}">\xd7${mult.toFixed(2)}${$52f5c9f49814d28d$var$draftEarnsWrit(mult) ? "\uD83D\uDCDC" : ''}</span>`;
        }
        // Progress square: grows 0 -> 50% of the tile as the convoy crosses it,
        // so a route reads as a filling bar rather than a static outline.
        if (convoy && convoy.fill > 0) {
            const size = (convoy.fill * 50).toFixed(1);
            glyph += `<span class="world-progress" style="width:${size}%;height:${size}%;background:${convoy.color}"></span>`;
        }
        if (marker) glyph += `<span class="world-convoy" style="color:${marker.color}">\u{25AA}</span>`;
        cells += `<div class="world-tile${capital ? ' capital' : ''}${onRoute ? ' on-route' : ''}${convoyColor && !onRoute ? ' on-active' : ''}"
                style="background:${bg}; --night:var(--n${col})${convoyColor && !onRoute ? `; outline-color:${convoyColor}` : ''}" title="${title}"
                ${capital ? `data-region="${capital}" onclick="cycleOperationEndpoint('${capital}')"` : ''}>${glyph}</div>`;
    }
    // In the planner the legend doubles as the PRICE LIST: five destinations,
    // five premiums, side by side. Comparing them is the whole decision, and a
    // dropdown you have to open one option at a time cannot show a comparison.
    const legend = (0, $cb0ad7004fe6b26a$export$4a444fae199f4849)().map((id)=>{
        const name = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[id]?.name || id;
        const role = id === $52f5c9f49814d28d$var$draft.toRegionId ? "\uD83C\uDFD5\uFE0F destination" : '';
        // The legend is the price LIST — five destinations side by side — so it
        // is where the list price belongs next to the fed one. On the map itself
        // a struck-through second number would spill out of a 40px tile.
        const price = $52f5c9f49814d28d$var$view === 'plan' && $52f5c9f49814d28d$var$draft.skillId ? ` ${$52f5c9f49814d28d$var$demandChip((0, $356ad444ead618fc$export$6bba5a60cd02466f)(id, $52f5c9f49814d28d$var$draft.skillId), {
            base: (0, $356ad444ead618fc$export$37444e2aca3975f8)(id, (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)($52f5c9f49814d28d$var$draft.skillId))
        })}` : '';
        // The legend is already the map's key, and it is listed west to east —
        // which makes it the one place five local clocks can be read in order
        // and the rotation seen as a sequence rather than a shading.
        const local = (0, $c454fb723f814d89$export$30a7d07879d0db1d)(id, now);
        return `<span class="text-xs inline-flex items-center gap-1 ${role ? 'font-bold' : 'text-gray-400'}" style="${role ? `color:${$52f5c9f49814d28d$var$GOLD}` : ''}">
            <span style="display:inline-block;width:9px;height:9px;border-radius:2px;background:${$52f5c9f49814d28d$var$REGION_COLOR[id]}"></span>
            ${name}${role ? ` (${role})` : ''}${price}<span class="world-clock-chip" data-clock-region="${id}" title="${name} local time \u{2014} ${local.name}">${local.icon} ${local.time}</span></span>`;
    }).join('<span class="text-gray-600 text-xs">\xb7</span> ');
    // The legend belongs directly under the map it explains, in the same column.
    // It sat outside the row for a while so the controls column could align to
    // the map's bottom edge; collapsing the three template cards into one select
    // made the columns comparable again without that trick.
    container.innerHTML = `
        <div class="world-map" style="grid-template-columns: repeat(${width}, minmax(0, 1fr));">${cells}</div>
        <div class="world-map-legend mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">${legend}</div>`;
    $52f5c9f49814d28d$var$paintWorldClock(now);
}
/**
 * Advance the terminator across the world map (M3 S9).
 *
 * Every tile has its own clock, but longitude does not depend on latitude — so
 * a column's worth of tiles always share a phase, and the paint is DEDUPED BY
 * COLUMN rather than computed 153 times. Writes one `--n<col>` variable onto
 * the `.world-map` element; each tile reads its column's through `--night` (see
 * styles.css). Seventeen property writes, no reflow of the grid, and —
 * critically — no innerHTML: this runs on the planner too, where rebuilding the
 * map is fine but rebuilding anything else would close an open <select> under
 * the player's cursor.
 *
 * The darkness is the inverse of the daylight curve, capped below 1 so a night
 * tile is still readable: this is a world clock, not a fog of war, and a player
 * has to be able to plan a route across the dark side.
 */ const $52f5c9f49814d28d$var$MAX_NIGHT = 0.62;
function $52f5c9f49814d28d$var$paintWorldClock(now = Date.now()) {
    const map = document.querySelector('#operations-map .world-map');
    if (!map) return;
    const { width: width } = (0, $cb0ad7004fe6b26a$export$8fe62d261aacdb61)();
    for(let col = 0; col < width; col++){
        const night = (1 - (0, $c454fb723f814d89$export$45f6af437d59d9ba)((0, $c454fb723f814d89$export$239629a81011f2a4)({
            row: 0,
            col: col
        }, now).phase)) * $52f5c9f49814d28d$var$MAX_NIGHT;
        map.style.setProperty(`--n${col}`, night.toFixed(3));
    }
    // The legend's clocks are restated in place rather than re-rendered with
    // the legend, for the same reason: this has to be safe to run on the
    // planner while a dropdown is open.
    for (const chip of document.querySelectorAll('#operations-map [data-clock-region]')){
        const local = (0, $c454fb723f814d89$export$30a7d07879d0db1d)(chip.dataset.clockRegion, now);
        chip.textContent = `${local.icon} ${local.time}`;
    }
}
function $52f5c9f49814d28d$export$4af0774c25cece2a() {
    const tab = document.getElementById('operations-tab');
    if (!tab?.classList.contains('active')) return;
    $52f5c9f49814d28d$var$paintWorldClock();
}
function $52f5c9f49814d28d$export$d5def383e43b5037(regionId) {
    if ($52f5c9f49814d28d$var$draft.toRegionId === regionId) $52f5c9f49814d28d$var$draft.toRegionId = null;
    else if ($52f5c9f49814d28d$var$draft.fromRegionId === regionId) $52f5c9f49814d28d$var$draft.fromRegionId = null;
    else if (!$52f5c9f49814d28d$var$draft.toRegionId) $52f5c9f49814d28d$var$draft.toRegionId = regionId;
    else $52f5c9f49814d28d$var$draft.fromRegionId = regionId;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$576d259aa2156e8d(regionId) {
    $52f5c9f49814d28d$var$draft.fromRegionId = regionId || null;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$53461ed7a4cadb9e() {
    $52f5c9f49814d28d$var$draft.toRegionId = null;
    $52f5c9f49814d28d$var$draft.fromRegionId = null;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
// ---------------------------------------------------------------------------
// In-flight
// ---------------------------------------------------------------------------
function $52f5c9f49814d28d$var$formatRemaining(ms) {
    if (ms <= 0) return 'arriving';
    const totalMinutes = Math.ceil(ms / 60000);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
/**
 * The convoy list, as a column beside the map.
 *
 * Stacked vertically in a ~224px column rather than a wide grid, so each card
 * has to earn its lines: route, lead, progress, and what it pays. The cargo
 * manifest was dropped from the card — it is fixed at launch and unchangeable
 * in transit, so on this screen it is history, not information. What a player
 * comes here for is where a convoy IS and when it lands.
 */ function $52f5c9f49814d28d$var$renderInFlight() {
    const container = document.getElementById('operations-inflight');
    if (!container) return;
    const ops = (0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations || [];
    const slots = (0, $cb0ad7004fe6b26a$export$c87f3aa20ea43c6e)();
    if (!ops.length) {
        container.innerHTML = `<div class="text-xs text-gray-400">No convoys in transit \xb7 ${slots} slot${slots === 1 ? '' : 's'} licensed</div>`;
        return;
    }
    const now = Date.now();
    container.innerHTML = `
        <div class="text-[10px] uppercase tracking-widest text-gray-400 mb-1">
            In transit \u{2014} ${ops.length}/${slots}${$52f5c9f49814d28d$var$selectedOpId ? " \xb7 one route" : ''}</div>
        <div class="flex flex-col gap-1.5">
        ${ops.map((op)=>{
        const t = (0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[op.templateId];
        const total = op.completesAt - op.startedAt;
        const pct = Math.min(100, Math.round((now - op.startedAt) / total * 100));
        const payout = (0, $cb0ad7004fe6b26a$export$a4ac0527bd343e81)(op);
        const from = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[op.fromRegionId]?.name || op.fromRegionId;
        const to = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[op.toRegionId]?.name || op.toRegionId;
        const color = $52f5c9f49814d28d$var$CONVOY_COLORS[ops.indexOf(op) % $52f5c9f49814d28d$var$CONVOY_COLORS.length];
        const isSelected = $52f5c9f49814d28d$var$selectedOpId === op.id;
        return `
                <div onclick="selectOperation('${op.id}')"
                    class="rounded-lg px-2 py-1.5 cursor-pointer text-[11px] leading-tight"
                    style="background:rgba(224,168,76,${isSelected ? '0.16' : '0.07'}); border:2px solid ${isSelected ? color : $52f5c9f49814d28d$var$GOLD_DIM};"
                    title="${from} \u{2192} ${to}${isSelected ? " \xb7 click again to show every route" : " \xb7 click to show only this route"}">
                    <div class="font-bold text-xs flex items-center gap-1 truncate" style="color:${$52f5c9f49814d28d$var$GOLD}">
                        <span style="color:${color}">\u{25AA}</span>${t?.icon || "\uD83D\uDE9A"} ${t?.name || op.templateId}</div>
                    <div class="text-gray-300 truncate">${from} \u{2192} ${to}</div>
                    <div class="text-gray-400 truncate">${op.leadName}</div>
                    <div class="mt-1 h-1.5 rounded-full bg-black/40 overflow-hidden">
                        <div class="h-full" style="width:${pct}%; background:${$52f5c9f49814d28d$var$GOLD}"></div>
                    </div>
                    <div class="text-gray-400 flex justify-between gap-1 whitespace-nowrap mt-0.5">
                        <span>${$52f5c9f49814d28d$var$formatRemaining(op.completesAt - now)}</span>
                        <span>${payout.credits.toLocaleString()}\u{1F4B0}${payout.writs ? ` +${payout.writs}\u{1F4DC}` : ''}</span>
                    </div>
                </div>`;
    }).join('')}
        </div>`;
}
// ---------------------------------------------------------------------------
// Planner
// ---------------------------------------------------------------------------
/**
 * Short button faces. "Ready to launch" above an enabled LAUNCH button said
 * nothing the button did not already say, so the state now lives IN the button
 * — a disabled control that explains itself beats a disabled control plus a
 * caption. The full sentence stays as the tooltip.
 */ const $52f5c9f49814d28d$var$BLOCKED_LABEL = {
    'no-route': 'NO ROUTE',
    'insufficient-cargo': 'NO CARGO',
    'insufficient-energy': 'NO ENERGY',
    'no-free-slot': 'NO SLOT',
    'lead-unavailable': 'NO LEAD',
    'insufficient-legends': 'LOCKED',
    'no-charter': 'UNLICENSED'
};
const $52f5c9f49814d28d$var$BLOCKED_COPY = {
    'no-charter': 'Sign the Operations Charter first.',
    'no-free-slot': 'Every licensed slot is busy.',
    'insufficient-legends': 'Promote more Legends this era to run longer routes.',
    'lead-unavailable': "No idle lead \u2014 the Leader and every era-Legend is out.",
    'no-route': 'No route between those regions.',
    'insufficient-cargo': 'Not enough material in that signature.',
    'insufficient-energy': 'Not enough energy.',
    'unknown-template': 'Unknown operation type.'
};
/**
 * Shared planner state, computed once per paint.
 *
 * The controls column and the manifest row both need the offer, the leads and
 * the eligibility verdict. Computing them twice would be two chances for the
 * quoted price and the LAUNCH button to disagree about the same convoy.
 */ function $52f5c9f49814d28d$var$plannerContext() {
    $52f5c9f49814d28d$var$ensureDraftDefaults();
    const offer = $52f5c9f49814d28d$var$currentOffer();
    const leads = (0, $cb0ad7004fe6b26a$export$34097b07af09d661)();
    return {
        offer: offer,
        leads: leads,
        eligible: (0, $cb0ad7004fe6b26a$export$4f87675e88a56589)({
            templateId: $52f5c9f49814d28d$var$draft.templateId,
            fromRegionId: $52f5c9f49814d28d$var$draft.fromRegionId,
            toRegionId: $52f5c9f49814d28d$var$draft.toRegionId,
            skillId: $52f5c9f49814d28d$var$draft.skillId,
            leadName: $52f5c9f49814d28d$var$draft.leadName
        })
    };
}
/**
 * The column beside the map: what SIZE of operation, who leads it, what it
 * carries, and LAUNCH at the bottom.
 *
 * Vertical because it sits next to a map that wants every pixel of width, and
 * because these are the sizing decision — read top to bottom, they are the order
 * the question is actually asked. Destination and staging point are deliberately
 * NOT here: the map sets the destination by click and prices every candidate on
 * the tile itself, and the staging point is derived from it, so both were form
 * fields restating what the map already showed.
 */ function $52f5c9f49814d28d$var$renderControls() {
    const container = document.getElementById('operations-controls');
    if (!container) return;
    const { offer: offer, leads: leads, eligible: eligible } = $52f5c9f49814d28d$var$plannerContext();
    const eraLegends = (0, $f27982cef7035d22$export$8e361a1ffbebf172).command?.legends?.length || 0;
    // ONE select, not three cards. Stacked cards were 171px of a column that has
    // to fit beside the map, and they showed three sets of numbers when only the
    // selected one is being decided about. The cost line below restates that one
    // set, so nothing is lost — the other two are a dropdown away.
    // A class is priced in CARGO, not hours. It used to show the hours its own
    // reach implied, which no longer means anything: every class runs the same
    // route in the same time, and what separates them is how much they carry.
    const templateOptions = Object.entries((0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)).map(([id, t])=>{
        const locked = eraLegends < t.legendsRequired;
        const suffix = locked ? ` \u{2014} \u{1F512} ${t.legendsRequired} Legends` : ` \xb7 ${t.cargoValue}\u{1F4B0}\u{1F4E6}`;
        return `<option value="${id}" ${locked ? 'disabled' : ''} ${id === $52f5c9f49814d28d$var$draft.templateId ? 'selected' : ''}>${t.icon} ${t.name}${suffix}</option>`;
    }).join('');
    // COSTS ONLY. A Writ is never spent to launch anything — `writEligible`
    // gates the demand trickle a convoy EARNS — but sitting on this line, under
    // a tooltip that opens "Energy drawn", it read as a third price, and the
    // Writ paid back on delivery then looked like a refund of it. The 📜 now
    // appears only where it is genuinely earned: on the destinations that pay
    // it (map and legend, gated by draftEarnsWrit) and on the payout line.
    const selected = (0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[$52f5c9f49814d28d$var$draft.templateId];
    const costLine = selected ? `${(0, $cb0ad7004fe6b26a$export$804dfc1c9f8f293a)($52f5c9f49814d28d$var$draft.templateId)}\u{26A1} \xb7 ${selected.cargoValue}\u{1F4B0}\u{1F4E6}` : '';
    // The staging point is the DURATION dial, and the reason it is a control
    // rather than a derived tile: cargo is flat per class, so a longer run is
    // the same manifest for more credits. Each option carries its own hours
    // because that number IS the choice being made.
    const originOptions = $52f5c9f49814d28d$var$currentOffers().map((o)=>{
        const name = $ce6dd72bc4611534$export$4fbdcec70fce9d73?.[o.fromRegionId]?.name || o.fromRegionId;
        return `<option value="${o.fromRegionId}" ${o.fromRegionId === $52f5c9f49814d28d$var$draft.fromRegionId ? 'selected' : ''}>${name} \xb7 ${o.hours.toFixed(1)}h</option>`;
    }).join('');
    const originSelect = originOptions ? `<select id="op-origin" onchange="setOperationOrigin(this.value)"
                class="w-full bg-white/5 border-2 border-gray-600 rounded px-2 py-1 text-xs text-white">${originOptions}</select>` : '<div class="text-xs text-gray-400">Pick a destination first</div>';
    const leadSelect = leads.length ? `<select id="op-lead" onchange="setOperationLead(this.value)"
                class="w-full bg-white/5 border-2 border-gray-600 rounded px-2 py-1 text-xs text-white">
                ${leads.map((l)=>`<option value="${l.name}" ${l.name === $52f5c9f49814d28d$var$draft.leadName ? 'selected' : ''}>${l.name}${l.isLeader ? ' (Leader)' : ''} \xb7 ${l.marksEarned}\u{1F396}\u{FE0F}</option>`).join('')}
           </select>` : '<div class="text-xs text-gray-400">No idle lead</div>';
    // The route, immediately above the button that commits it — the last thing
    // read before pressing LAUNCH should be what is being launched.
    const routeBlock = offer ? `<div class="text-xs leading-tight rounded px-2 py-1 mt-1 2xl:mt-2 flex" style="background:rgba(0,0,0,0.25); border:1px solid ${$52f5c9f49814d28d$var$GOLD_DIM};">
               <div class="flex-grow">
                    <div class="text-gray-300 truncate" title="Staging point">\u{25B6} ${$ce6dd72bc4611534$export$4fbdcec70fce9d73?.[offer.fromRegionId]?.name || offer.fromRegionId}</div>
                    <div class="font-bold truncate" style="color:${$52f5c9f49814d28d$var$GOLD}" title="Destination">\u{1F3D5}\u{FE0F} ${$ce6dd72bc4611534$export$4fbdcec70fce9d73?.[$52f5c9f49814d28d$var$draft.toRegionId]?.name || $52f5c9f49814d28d$var$draft.toRegionId}</div>
                </div>
               <div class="text-gray-400">${offer.hours.toFixed(1)}h</div>
           </div>` : `<div class="text-xs text-gray-400 leading-snug mt-1">Click a destination on the map.</div>`;
    container.innerHTML = `
        <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Operation</div>
        <select id="op-template" onchange="selectOperationTemplate(this.value)"
            class="w-full bg-white/5 border-2 rounded px-2 py-1.5 text-sm font-bold text-white"
            style="border-color:${$52f5c9f49814d28d$var$GOLD}">${templateOptions}</select>
        <!-- The \u{1F4B0} figure is what the CARGO must be worth, not a charge against
             the credit balance \u{2014} a convoy is paid for in materials off the dock.
             Spelling that out because the icon says credits and the line sits
             beside an energy cost that IS deducted. -->

        <div class="mt-2">
            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Operation Cost</div>

            <div class="text-xs text-gray-400 mt-0.5"
                title="What this convoy costs to launch: energy drawn \xb7 credits' worth of materials the manifest must carry (taken from the Guild Vault's dock, never from your credit balance). No Writs are spent \u{2014} a Grand Circuit EARNS one by delivering into a hungry market.">${costLine}
            </div>
        </div>

        <div class="mt-2">
            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Cargo signature</div>
            ${$52f5c9f49814d28d$var$signatureSelect($52f5c9f49814d28d$var$draft.templateId, 'text-xs px-2 py-1')}
        </div>

        <div class="mt-2">
            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5"
                 title="Where the convoy forms up. Cargo is the same whatever the distance, so a longer run is more credits for the same manifest \u{2014} and a longer hold on the slot.">Staging point</div>
            ${originSelect}
        </div>

        <div class="mt-2 mb-2">
            <!-- Lead is worth up to +25% credits (LEAD_BONUS_CAP), so it is not
                 decoration \u{2014} but ensureDraftDefaults picks the best available
                 record, so the default needs no attention and the control can be
                 the smallest thing here. -->
            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Lead</div>
            ${leadSelect}
        </div>

        ${routeBlock}
        ${$52f5c9f49814d28d$var$manifestFragment(offer, leads)}

        <button onclick="launchOperation()" ${eligible.ok ? '' : 'disabled'}
            title="${eligible.ok ? '' : $52f5c9f49814d28d$var$BLOCKED_COPY[eligible.reason] || 'Cannot launch'}"
            class="w-full mt-1.5 2xl:mt-4 px-3 py-2.5 rounded font-bold ${eligible.ok ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed'}"
            ${eligible.ok ? `style="background:${$52f5c9f49814d28d$var$GOLD}"` : ''}>${eligible.ok ? 'LAUNCH' : $52f5c9f49814d28d$var$BLOCKED_LABEL[eligible.reason] || 'CANNOT LAUNCH'}</button>

        <!-- Last in the column, so its bottom edge lands on the map's. Undo
             belongs after the commit control, not competing with it. -->
        <button onclick="clearOperationRoute()" ${$52f5c9f49814d28d$var$draft.toRegionId ? '' : 'disabled'}
            class="w-full mt-1.5 2xl:mt-2 px-3 py-1 rounded text-xs font-bold ${$52f5c9f49814d28d$var$draft.toRegionId ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-800 text-gray-600 cursor-not-allowed'}">Clear route</button>`;
}
/**
 * The manifest and payout, as a fragment for the controls column.
 *
 * Returns HTML rather than rendering, because it now lives INSIDE the column
 * between the route and LAUNCH — cost and reward belong next to the button that
 * commits them, and below the map they were a second place to look after the
 * decision had already been made.
 */ function $52f5c9f49814d28d$var$manifestFragment(offer, leads) {
    // Flat per class, so the manifest does not move when the staging point does
    // — which is exactly the trade the planner is trying to make visible: the
    // rows below stay put while the payout above them climbs with distance.
    const { manifest: manifest, short: short, value: value, budget: budget } = $52f5c9f49814d28d$var$draft.skillId ? (0, $cb0ad7004fe6b26a$export$a666674acd11f81d)($52f5c9f49814d28d$var$draft.templateId, $52f5c9f49814d28d$var$draft.skillId) : {
        manifest: {},
        short: {
            value: 0
        },
        value: 0,
        budget: 0
    };
    // A convoy that could not fill its budget without going OVER it sails light,
    // and silently doing so is what made the planner read as broken: a Long Haul
    // asking 340 value, a signature holding 9 items, and a manifest taking two
    // chips gave the player three numbers and no way to reconcile them. The
    // header now states what was actually loaded against what was asked, and
    // amber marks the gap so "240/340" is not mistaken for a rounding artefact.
    const underFilled = budget > 0 && value < budget;
    // One line per item, each saying what the pile will be left at. "-80" alone
    // answers what this convoy costs but not whether the next one is
    // affordable, which is the question a player actually has. The stock is the
    // Guild Vault's dock — account-level, so no character owns it.
    const inventory = (0, $cb0ad7004fe6b26a$export$21c1c9fc1bed7f77)();
    const manifestRows = Object.entries(manifest).map(([id, qty])=>{
        const held = inventory[id] || 0;
        const left = Math.max(0, held - qty);
        // Amber when the convoy takes most of what is there — a pile about
        // to run dry is worth noticing before pressing LAUNCH.
        const thin = held > 0 && left / held < 0.25;
        return `<div class="flex justify-between gap-1 leading-tight">
                <span class="truncate" title="${(0, $42b272c2c0f44bdf$export$31330438f6059b08)(id) || id}">${(0, $42b272c2c0f44bdf$export$31330438f6059b08)(id) || id}</span>
                <span class="whitespace-nowrap"><span class="text-gray-400">-${qty}</span><span class="${thin ? 'text-amber-300' : 'text-gray-500'}">/${left.toLocaleString()}</span></span>
            </div>`;
    }).join('');
    // Projected payout, computed by the SAME function that pays it out. A
    // planner that estimates with its own arithmetic is a planner that will one
    // day quote a number the settlement does not honour.
    const projected = offer && $52f5c9f49814d28d$var$draft.toRegionId ? (0, $cb0ad7004fe6b26a$export$a4ac0527bd343e81)({
        templateId: $52f5c9f49814d28d$var$draft.templateId,
        hours: offer.hours,
        toRegionId: $52f5c9f49814d28d$var$draft.toRegionId,
        skillId: $52f5c9f49814d28d$var$draft.skillId,
        leadMarks: leads.find((l)=>l.name === $52f5c9f49814d28d$var$draft.leadName)?.marksEarned || 0
    }) : null;
    if (!manifestRows && !projected) return '';
    return `
        <div class="mt-2 rounded px-2 py-1 text-[11px]" style="background:rgba(0,0,0,0.25); border:1px solid ${$52f5c9f49814d28d$var$GOLD_DIM};">
            <div class="flex justify-between items-baseline gap-1 text-[11px] uppercase tracking-widest text-gray-400"
                 title="Cargo is loaded from the Guild Vault \u{2014} the share of each promoted member's kit their successor did not inherit. No character owns it.${underFilled ? `\n\nLoaded ${value}\u{1F4B0} of the ${budget}\u{1F4B0} this class asks for. Nothing left on the dock fits the remaining ${budget - value} without going over, so the convoy sails a little light rather than overpaying.` : ''}">
                <span>\u{1F3E6} Manifest</span>
                ${budget ? `<span class="${underFilled ? 'text-amber-300' : 'text-gray-500'} normal-case tracking-normal">${value}/${budget}\u{1F4B0}</span>` : ''}
            </div>
            ${manifestRows || '<div class="text-gray-400 leading-tight">Pick a destination</div>'}
            ${short.value ? `<div class="text-red-300 leading-tight">Short ${short.value}\u{1F4B0}</div>` : ''}
            ${projected ? `<div class="flex justify-between items-baseline gap-1 mt-1 pt-1 whitespace-nowrap" style="border-top:1px solid ${$52f5c9f49814d28d$var$GOLD_DIM}"
                        title="Demand premium: ${$ce6dd72bc4611534$export$4fbdcec70fce9d73?.[$52f5c9f49814d28d$var$draft.toRegionId]?.name || $52f5c9f49814d28d$var$draft.toRegionId} pays ${$52f5c9f49814d28d$var$demandText(projected.demand)} for ${$ce6dd72bc4611534$export$aeeef991191508e2?.[(0, $42b272c2c0f44bdf$export$a3603dda04ca8111)($52f5c9f49814d28d$var$draft.skillId)]?.name || 'this'} cargo${$52f5c9f49814d28d$var$saturationNote($52f5c9f49814d28d$var$draft.toRegionId, (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)($52f5c9f49814d28d$var$draft.skillId))}">
                     <span class="text-[11px] uppercase tracking-widest text-gray-400">Payout</span>
                     <span><span class="font-bold" style="color:${$52f5c9f49814d28d$var$GOLD}">${projected.credits.toLocaleString()}\u{1F4B0}</span>${projected.writs ? `<span class="font-bold" style="color:${$52f5c9f49814d28d$var$GOLD}"> +${projected.writs}\u{1F4DC}</span>` : ''} ${$52f5c9f49814d28d$var$demandChip(projected.demand, {
        markWrit: false,
        base: (0, $356ad444ead618fc$export$37444e2aca3975f8)($52f5c9f49814d28d$var$draft.toRegionId, (0, $42b272c2c0f44bdf$export$a3603dda04ca8111)($52f5c9f49814d28d$var$draft.skillId))
    })}</span>
                   </div>` : ''}
        </div>`;
}
function $52f5c9f49814d28d$export$1ed263e826d67cb7() {
    const inflight = document.getElementById('operations-inflight');
    const heading = document.getElementById('operations-heading');
    if ((0, $46d374413fb0707a$export$6955e231f1466c44)('operations-charter') <= 0) {
        const controls = document.getElementById('operations-controls');
        if (controls) controls.innerHTML = '<div class="text-sm text-gray-400">Sign the Operations Charter to license convoys.</div>';
        return;
    }
    // Defaults FIRST: the map highlights the planned route, and it renders
    // before the controls. Filling the draft inside renderControls meant the map
    // drew with no endpoints on the very first paint.
    $52f5c9f49814d28d$var$ensureDraftDefaults();
    const planning = $52f5c9f49814d28d$var$view === 'plan';
    if (heading) // One line each. The subtitles were flavour, and on the planner the
    // whole screen is the explanation.
    heading.innerHTML = planning ? `<h3 class="text-lg font-bold flex flex-wrap items-baseline gap-x-2" style="color:${$52f5c9f49814d28d$var$GOLD}">Plan an Operation
                 <span class="text-xs font-normal text-gray-400">Cargo is spent at launch \u{2014} it does not come back.</span></h3>` : `<h3 class="text-lg font-bold flex flex-wrap items-baseline gap-x-2" style="color:${$52f5c9f49814d28d$var$GOLD}">Operations in Transit
                 <span class="text-xs font-normal text-gray-400">Click a convoy to isolate its route.</span></h3>`;
    // Each view shows exactly one job's worth of controls: the planner has no
    // convoy list, the transit board has no planning fields or launch button.
    const controls = document.getElementById('operations-controls');
    if (controls) controls.classList.toggle('hidden', !planning);
    if (inflight) inflight.classList.toggle('hidden', planning);
    $52f5c9f49814d28d$var$renderMap();
    if (planning) $52f5c9f49814d28d$var$renderControls();
    else $52f5c9f49814d28d$var$renderInFlight();
}
function $52f5c9f49814d28d$export$e2d67cc94e3cd65c(id) {
    $52f5c9f49814d28d$var$draft.templateId = id;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$9c80dfd1c0bf48d5(id) {
    $52f5c9f49814d28d$var$draft.toRegionId = id || null;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$909bfe5c3a3681b1(id) {
    $52f5c9f49814d28d$var$draft.skillId = id;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$433c4f7deeca3758(name) {
    $52f5c9f49814d28d$var$draft.leadName = name;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$1c5606b786938b38() {
    const result = (0, $cb0ad7004fe6b26a$export$9cb89297e30fe792)({
        templateId: $52f5c9f49814d28d$var$draft.templateId,
        fromRegionId: $52f5c9f49814d28d$var$draft.fromRegionId,
        toRegionId: $52f5c9f49814d28d$var$draft.toRegionId,
        skillId: $52f5c9f49814d28d$var$draft.skillId,
        leadName: $52f5c9f49814d28d$var$draft.leadName
    });
    if (!result.success) {
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)($52f5c9f49814d28d$var$BLOCKED_COPY[result.reason] || 'Could not launch that operation', 'error');
        return;
    }
    const t = (0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[result.operation.templateId];
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`${t.icon} ${t.name} away \u{2014} ${result.hours.toFixed(1)}h, led by ${result.operation.leadName}`, 'success');
    (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    // Hand straight off to the transit board with the new convoy isolated: the
    // player just answered "what shall I send?", so the next useful question is
    // "where is it?" — not the empty planner they were already looking at.
    $52f5c9f49814d28d$var$view = 'transit';
    $52f5c9f49814d28d$var$selectedOpId = result.operation.id;
    $52f5c9f49814d28d$export$1ed263e826d67cb7();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
}
function $52f5c9f49814d28d$export$9dd8092a8219c221() {
    const hadOps = ((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations || []).length > 0;
    const result = hadOps ? (0, $cb0ad7004fe6b26a$export$b68d61a5f45d991c)({
        now: Date.now()
    }) : {
        settled: []
    };
    if (result.settled.length) {
        $52f5c9f49814d28d$var$announceSettlement(result);
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    }
    // Countdowns, progress bars and the map's per-tile fill are all functions
    // of NOW, so they have to be repainted on the tick — not only when the
    // player happens to click something. Only while the screen is actually
    // showing, so this costs nothing from anywhere else in the game.
    if (hadOps || result.settled.length) $52f5c9f49814d28d$var$refreshOperationsIfVisible();
}
/**
 * Repaint the transit board if it is the one on display.
 *
 * TRANSIT ONLY. The planner holds live <select> elements, and rebuilding it
 * under the player would close an open dropdown mid-choice — the same failure
 * the toolbar hit with the energy popup. It also has nothing to repaint:
 * route duration and cargo do not change with the clock.
 */ function $52f5c9f49814d28d$var$refreshOperationsIfVisible() {
    if ($52f5c9f49814d28d$var$view !== 'transit') return;
    const tab = document.getElementById('operations-tab');
    if (tab?.classList.contains('active')) $52f5c9f49814d28d$export$1ed263e826d67cb7();
}
function $52f5c9f49814d28d$export$f9a694398861c909() {
    if (!((0, $f27982cef7035d22$export$8e361a1ffbebf172).syndicate?.operations || []).length) return;
    const result = (0, $cb0ad7004fe6b26a$export$b68d61a5f45d991c)({
        now: Date.now(),
        maxPerSlot: 1
    });
    if (result.settled.length) $52f5c9f49814d28d$var$announceSettlement(result, true);
}
function $52f5c9f49814d28d$var$announceSettlement(result, whileAway = false) {
    const names = result.settled.map((o)=>(0, $cb0ad7004fe6b26a$export$36ac5ebae0245093)[o.templateId]?.name || o.templateId);
    (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{1F5FA}\u{FE0F} ${names.join(', ')} arrived${whileAway ? ' while you were away' : ''} \xb7 +${result.credits.toLocaleString()}\u{1F4B0}${result.writs ? ` +${result.writs}\u{1F4DC}` : ''}`, 'success', // Sticky when it landed during an absence: the player was not watching,
    // and a payout they never saw is exactly what stickiness is for.
    whileAway ? {
        sticky: true
    } : {});
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.cycleOperationEndpoint = $52f5c9f49814d28d$export$d5def383e43b5037;
    window.clearOperationRoute = $52f5c9f49814d28d$export$53461ed7a4cadb9e;
    window.selectOperation = $52f5c9f49814d28d$export$7bde3dae25e9ac40;
    window.selectOperationTemplate = $52f5c9f49814d28d$export$e2d67cc94e3cd65c;
    window.setOperationDestination = $52f5c9f49814d28d$export$9c80dfd1c0bf48d5;
    window.setOperationOrigin = $52f5c9f49814d28d$export$576d259aa2156e8d;
    window.setOperationSignature = $52f5c9f49814d28d$export$909bfe5c3a3681b1;
    window.setOperationLead = $52f5c9f49814d28d$export$433c4f7deeca3758;
    window.launchOperation = $52f5c9f49814d28d$export$1c5606b786938b38;
}












/**
 * Gameplay guide — assembled per read, showing only what the player has unlocked.
 *
 * WHY THIS IS COMPOSED RATHER THAN ONE STRING: the guide is also the game's
 * biggest spoiler surface. A new player opening Help met the whole ladder at
 * once — prestige, a second prestige, convoy routes — which both buries the one
 * loop they can actually play and gives away the reveals the layers exist to
 * deliver. Sections are gated on the SAME one-way latches the header uses
 * (`isCommandRevealed`, `isSyndicateRevealed`), so Help can never disagree with
 * which layers the switcher is offering.
 *
 * The gates are deliberately COARSE — one per layer, not one per mechanic.
 * Hiding artifacts until the first blueprint drops, or campsites until the first
 * one is walked, would be a second progression system to maintain and would keep
 * answers from players who are looking something up mid-raid. The rule is: hide
 * a LAYER the player has not been shown, not a detail inside one they have.
 *
 * Forward references matter as much as sections. A line about "Command Marks"
 * inside the always-on crafting section leaks exactly as much as the Command
 * chapter would, so those clauses are gated individually below.
 */ 

const $d702ea8c52a4a088$var$ALWAYS = ()=>true;
/** The layer ladder, in order. Each entry appears once its layer is revealed. */ const $d702ea8c52a4a088$var$LAYERS = [
    {
        when: $d702ea8c52a4a088$var$ALWAYS,
        md: `**The Field** \u{2014} run raids with your active character to earn credits, level
   skills, craft gear, and craft artifacts.`
    },
    {
        when: (0, $bde36de43872f734$export$25d1e5af45c35a33),
        md: `**Command (prestige)** \u{2014} when a character is established, **promote** them
   into your faction's command. They retire into your Legends gallery, you bank
   **Command Marks**, and a fresh recruit starts the next tour. Marks buy
   permanent account-wide upgrades that make every future tour faster.`
    },
    {
        when: (0, $46d374413fb0707a$export$f0d4871acc619a3),
        md: `**Syndicate (second prestige)** \u{2014} once fifteen officers have been promoted,
   **found a Syndicate** from them. Command starts over from nothing, and in
   exchange you gain **Writs**, permanent **charters**, and **Operations** \u{2014} a
   planet-scale convoy economy that runs while the Field runs itself.`
    }
];
/**
 * The opening section, sized to how much of the ladder is visible.
 *
 * A numbered list of one item reads like a list with things missing, so a
 * player who has only the Field gets prose instead — the shape itself should
 * not hint at what is being withheld.
 */ function $d702ea8c52a4a088$var$bigPicture() {
    const open = $d702ea8c52a4a088$var$LAYERS.filter((l)=>l.when());
    const intro = `You lead operatives who raid collapsed zones for loot, level them up, and gear
them out.`;
    if (open.length === 1) return `## The Big Picture

${intro} Run raids with your active character to earn credits, level
skills, craft gear, and craft artifacts.`;
    const ladder = open.map((l, i)=>`${i + 1}. ${l.md}`).join('\n');
    const compounds = (0, $46d374413fb0707a$export$f0d4871acc619a3)() ? `Progress compounds: each tour is quicker than the last thanks to the upgrades
your promoted Legends paid for, and each **era** is quicker than the last thanks
to the charters your Syndicate signed.` : `Progress compounds: each tour is quicker than the last thanks to the upgrades
your promoted Legends paid for.`;
    const currencies = (0, $46d374413fb0707a$export$f0d4871acc619a3)() ? 'Marks live in Command, Writs in the Syndicate, credits and energy in the Field.' : 'Marks live in Command, credits and energy in the Field.';
    return `## The Big Picture

${intro} The game has ${open.length === 2 ? 'two' : 'three'} connected layers, each one built out of the last:

${ladder}

${compounds}

**Switching layers:** the button at the top left is the layer switcher \u{2014} the
header only ever shows one layer's screens and currencies at a time. ${currencies}`;
}
const $d702ea8c52a4a088$var$GUIDE_HEAD = `# Gameplay Guide`;
/** Always shown. Built per read so the gated clauses inside it stay live. */ const $d702ea8c52a4a088$var$fieldBody = ()=>`## Characters & Factions

You can keep up to **3 characters**. Each has its own skills, level, inventory,
and gear. Faction is chosen at creation and is permanent.

### Dominion \u{1F527} \u{2014} engineers and systems tacticians
\u{1F4E1} Signal Relay \xb7 \u{1F4BB} System Override \xb7 \u{1F916} Drone Command \xb7 \u{26A0}\u{FE0F} Safeguard \xb7 \u{1F52C} Quantum Scan

### Wilders \u{1F33F} \u{2014} biotech operatives and survival engineers
\u{1F331} Reclamation \xb7 \u{1F33F} Growth Control \xb7 \u{1F98E} Wild Influence \xb7 \u{1F9EC} Bio Shield \xb7 \u{2623}\u{FE0F} Containment

### Veil \u{1F464} \u{2014} infiltrators and intelligence specialists
\u{1F5FA}\u{FE0F} Echo Trace \xb7 \u{1F513} Lock Breach \xb7 \u{1F464} Stealth Transit \xb7 \u{1F47B} Signal Mask \xb7 \u{1F300} Transit Anchor

Switch characters from the Field layer's **Characters** screen \u{2192} **Switch**.

---

## Skills & Leveling

Each faction has **5 skills**. Skills and character level grow by running raids \u{2014}
both successes and failures grant XP, with successes granting more. Leveling up
awards **skill points** (spend them to raise individual skills) and increases max
HP. Higher skill levels raise your success chance on rooms that use that skill.

At higher levels you can also spend skill points to **unlock synergies** for a
skill, which lets its gear boost teammates' matching events during a raid.

---

## Raids

Raids are the core loop:

1. Pick a **region** and a **difficulty tier**.
2. Assemble a **team** \u{2014} your character plus up to **2 contractors** to cover
   skills you're missing.
3. **Plan a path** through a procedurally generated grid to the exit.
4. **Start** \u{2014} the raid runs automatically, resolving each room in turn.
5. Collect **credits, materials, blueprints, and XP**; watch for bonus events.

### Success is about survival
Before you start, each room shows a success chance \u{2014} that's your odds of a
**clean run** (which yields the best loot). Failing a skill check doesn't end the
raid; it just deals **damage** scaled to the tier. What ends a raid early is a
**full team wipe** (everyone at 0 HP), which forfeits the reward. So push tiers
where your team can *survive*, not only where every check is guaranteed.

### Difficulty tiers
- **Tier 1** \u{2014} smaller grids, gentle checks; where you build early levels.
- **Tier 2** \u{2014} larger grids, tougher checks, better loot.
- **Tier 3** \u{2014} the largest/hardest raids, and the **only source of artifact
  blueprints**.

Higher tiers use bigger grids, longer path limits, and stronger contractors.

### Room types
- **\u{1F300} Start / \u{1F30C} Exit** \u{2014} entry and completion, no challenge.
- **\u{1F6AA} Gates** \u{2014} hardest skill checks, the best and most loot.
- **\u{26A0}\u{FE0F} Hazards** \u{2014} easier checks, moderate loot.
- **\u{1F3C3} Roads** \u{2014} free movement, no checks and no loot; don't count toward the
  path-length limit.
- **\u{1F3D5}\u{FE0F} Campsites** \u{2014} the team rests and heals (spending any field supplies you
  carry, then a base heal); no checks.

### Highlights
In the raid panel's **Highlights** tab you can mark rooms that can drop a chosen
**item**, or that use a chosen **skill**, to plan the best path at a glance.

---

## Contractors & Marketplace

- **Contractors** are AI operatives you hire to fill skill gaps. They're paid a
  percentage of the raid's credits, carry their own gear, and are temporary
  (they don't level up). The pool refreshes over time.
- **Marketplace** \u{2014} contract your own character out for other players to hire,
  earning passive credits and XP while you're away.

---

## Loot, Gear & Crafting

Raids drop **credits**, faction **materials** (common \u{2192} uncommon \u{2192} rare \u{2192} epic),
and **blueprints** (Tier 3 only). Materials feed crafting.

### Skill Gear
Craftable equipment tied to a technique. Equip **one piece per skill** to raise
that skill's success chance; some gear also enables **synergies** that help
teammates' events. Skill gear is equip-once \u{2014} **one craft per character**
(a duplicate would do nothing), so a finished gear set is a clear milestone.

### Artifacts
Each character has **two artifact slots**:
- a **Skill artifact** (boosts one skill's success), and
- a **Utility artifact** (economy, defense, or utility effects).

Artifacts use a two-step model:
1. **Unlock** \u{2014} blueprints drop only from Tier 3. Consume a blueprint once to
   **unlock that design for your whole account** (any character can then craft
   it).${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? ' This is a one-time milestone worth a chunk of Command Marks.' : ''}
2. **Craft** \u{2014} build the unlocked design from materials. Like gear, it's
   **one craft per character**.

### Consumables
- **Field Supplies** \u{2014} restore team HP; bought with credits, used before a raid
  or automatically while resting at a campsite.
- **Technique Consumables** \u{2014} crafted from materials; **auto-rig** on their
  technique's first success in a raid, then every room where that technique
  succeeds runs faster for the rest of the raid.

---

## Collapse Keys & the Archive

Nobody agrees on what ended this world, and the three factions do not agree with
each other. **Collapse Keys** are the records that bear on it \u{2014} and the Archive
sets each one beside what your faction makes of it.

A successful raid can recover one. They arrive **in order**, and the tier you
raid sets how far the story can go: keys **1\u{2013}2** surface at Tier 1, **3\u{2013}4** at
Tier 2, **5\u{2013}7** at Tier 3. So a Tier 1 character will find two and then no more,
however long they raid \u{2014} the way on is deeper raids, not more of them.

**The Archive** screen appears in the Field layer with your first key and never
leaves. Every key stays there to be re-read: the fragment as it was recorded,
and what your faction makes of it.

Three things worth knowing:
- **Keys are yours, not your character's.** They are filed to your account, not
  to whoever recovered them, and cannot be sold, crafted or lost.${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? ' No promotion or prestige ever takes one back.' : ''}
- **Each faction has its own set of seven**, recovered by raiding with a
  character of that faction. The Archive shows all three sets, including ones
  you have never played \u{2014} the other factions' theories are part of the picture.
- **Seven per faction is what the field holds.** The last three of each set are
  somewhere no current expedition can reach.`;
/** Shown once the Command layer has been revealed. Built per read: its Vault
 *  paragraph names the Syndicate only when that layer is known too. */ const $d702ea8c52a4a088$var$commandBody = ()=>`## Command (Prestige)

The **Command** tab appears once your active character is worth enough Command
Marks. This is the meta-game.

### Promotion
Promoting your active character:
- retires them into your **Legends** gallery (a permanent record),
- banks **Command Marks** based on their career, and
- starts the next **tour** with a fresh recruit (most credits are spent down \u{2014}
  you keep a small fraction, floored near 1,000).

Promotion resets the tour, but these **persist**: Command Marks, Command
upgrades, your Legends, unlocked regions, and your other characters.

### Command Marks come from
- **Skill gear** owned,
- **Artifact designs unlocked** (the biggest single source),
- **Artifacts crafted**,
- **Tier-3 wins**, and
- **Character level**.

So a tour's goal is legible: finish your gear/artifact set, push Tier 3, and
level up \u{2014} then promote at the peak.

### Command upgrades (spend Marks)
- **\u{1FA7A} Field Conditioning** \u{2014} recruits start with extra max HP.
- **\u{1F3DB}\u{FE0F} Officer Academy** \u{2014} recruits start at a higher level.
- **\u{1F50B} Forward Depot** \u{2014} energy returns faster, which is what really sets your
  raid throughput.
- **\u{1F5FA}\u{FE0F} Regional Charter** \u{2014} unlock additional regions for all characters.
- **\u{1F4D6} Legend Bonus** \u{2014} bonus XP for every enshrined Legend.
- **\u{1F6F0}\u{FE0F} Auto-Scout** \u{2014} auto-generates the grid and proposes the best path.
- **\u{1F4D2} Foreman's Ledger** \u{2014} auto-reserves the best contractors for your path.
- **\u{1F916} Auto-Raid Protocol** \u{2014} runs raids hands-off: charts, staffs, re-tools,
  launches, then chains the next while energy holds.
- **\u{2699}\u{FE0F} Auto-Fabricator** \u{2014} crafts hands-off between raids: unlocks artifact
  designs first, then builds gear and the components it needs.

**Buy the automation pair together.** Most of a character's Marks come from
crafting, so a character that raids by itself but never crafts earns a fraction
of a normal tour. Auto-Raid and Auto-Fabricator are the two halves of one loop \u{2014}
raid \u{2192} craft \u{2192} marks \u{2192} promote \u{2014} and the Syndicate's Succession Doctrine
requires both before it will run that loop for you.

### The Vault
Promotion no longer destroys your materials. What the outgoing character was
carrying is **split**: a share goes straight to your next recruit, and the
remainder is set aside${(0, $46d374413fb0707a$export$f0d4871acc619a3)() ? " \u2014 **consigned** to the Syndicate you found next" : ''}. Both piles are
visible on Command \u{2192} **Vault**. Artifact blueprints always survive in full.

Each promotion is a **Tour**; rotating characters up to command builds a
persistent account that keeps getting stronger.`;
/** Shown once a Syndicate is within reach (15 Legends) or already founded. */ const $d702ea8c52a4a088$var$SYNDICATE_BODY = `## Syndicate Charters (Second Prestige)

The **Syndicate** layer appears once you have promoted **15 officers**. Founding
a Syndicate is the second prestige: Command goes back to zero, and what you get
in exchange outlives every era that follows.

### Founding
The founding ceremony itemises both columns before you sign, because it cannot
be undone.

**Wiped:** Command Marks, every Legend, Command upgrades, regional charters,
your characters, and credits (down to the levy floor).

**Kept:** every **Writ** and charter, unlocked artifact designs, artifact
blueprints in the vault, your Syndicate **Leader** and past leaders, cleared
Blackout perks, and the whole consigned material dock.

The era's best officer \u{2014} most Marks earned, not the newest \u{2014} becomes your
**Leader**, a permanent anchor who can run Operations forever.

### Writs
**\u{1F4DC} Writs** are the Syndicate's currency, issued at founding from everything
that era banked. The yield is damped (it scales with the *square root* of era
Marks), which is deliberate: camping one era to farm Writs loses to founding
again sooner. Growth comes from founding **more**, not from founding **bigger**.

### Charters (spend Writs)
- **\u{1F4CB} Standing Orders** \u{2014} every founding starts the new era with Auto-Raid
  Protocol and Auto-Fabricator already running, whether or not Command bought
  them. The cheapest thing on the board and usually the first pick.
- **\u{1F54A}\u{FE0F} Succession Doctrine** \u{2014} promotes at the peak Marks rate and raises the
  successor from your template, hands-off. Requires both automation upgrades.
- **\u{1F5FA}\u{FE0F} Operations Charter** \u{2014} unlocks Operations, and licenses 1 / 2 / 3
  concurrent convoys.
- **\u{1F3DB}\u{FE0F} Founder's Endowment** \u{2014} each new Command era starts with banked Marks.
- **\u{1F4DA} Institutional Memory** \u{2014} found the next Syndicate with fewer Legends.
  This is the real compression lever: it shortens every era after it.
- **\u{1F4E6} Provision Contracts** \u{2014} operation cargo costs less.
- **\u{1F311} Blackout Sanction** \u{2014} unlocks Blackout Contracts.

### Operations
Where the Field plans a path through a room grid, the Syndicate plans a **route
across the world map** \u{2014} the same decision at planetary scale.

- **A route is two capitals.** You pick the destination and the staging point;
  the ground between them sets the duration (roughly 2.5\u{2013}11 hours). Distance is
  a real trade, not a menu of tiers.
- **Cargo comes from the dock** (Syndicate \u{2192} **Stores**), stocked by the
  consignments your promotions banked. A dock is a per-era budget that only goes
  down, so an era's promotions provision the *next* Syndicate.
- **Destinations pay differently.** Every capital shows its own **demand
  premium** for the signature you are shipping, and delivering into a region
  cools its appetite for that faction's goods for a while. The map is a decision
  you re-make, not a table you solve once.
- **Convoys run in real time** and settle while you are away \u{2014} one round per
  licensed slot. Deliveries above a high premium also trickle **Writs** back.
- Each convoy is led by your Leader or an officer promoted **this era**, so
  mid-era promotions have a second payoff.

### Blackout Contracts
Optional raids under a hard modifier \u{2014} no grid preview, no consumables, no
contractors, and so on \u{2014} each paying one **permanent** account perk. You clear a
contract by *finishing* such a raid; failing it changes nothing. Automation
refuses to run them: the difficulty has to be a choice you made.

### Hands-off by design
With Standing Orders, Succession Doctrine and the two automation upgrades in
place, the whole Command loop runs itself \u{2014} raid, craft, promote, raise a
successor \u{2014} while you spend your attention on the Syndicate's routes. That is
what the layer is for: your old game becomes the engine for the new one.`;
/** Always shown; two of its lines only make sense once Command exists. */ const $d702ea8c52a4a088$var$tail = ()=>`## Energy, HP & Credits

- **Energy** \u{2014} raids cost energy based on the path; it regenerates over time, and
  you can buy more with credits from the header.
- **HP** \u{2014} lost to failed skill checks, restored at campsites (field supplies +
  base heal) and slowly over time outside raids. A full team wipe ends a raid.
- **Credits** \u{2014} earned from raids, spent on contractors, consumables, energy, and
  crafting.${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? ' Largely reset each promotion (the end-of-tour spend-down is the game).' : ''}

---

## Tips

- **Early** \u{2014} run Tier 1, level up, and start crafting your skill-gear set.
- **Mid** \u{2014} move to Tier 2, unlock synergies, and begin working toward artifacts.
- **Late** \u{2014} push Tier 3 for blueprints and complete your gear/artifact set${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `, then
  **promote** to bank Marks and buy upgrades that speed up the next tour` : ''}.${(0, $46d374413fb0707a$export$f0d4871acc619a3)() ? `
- **Prestige** \u{2014} once fifteen officers are promoted, found a Syndicate. Take
  **Standing Orders** first (it is the cheapest charter and it keeps your
  automation across every future founding), then **Institutional Memory**, which
  shortens every era after it.` : ''}
- Match your raid tier to what your team can **survive**, not just to guaranteed
  checks \u{2014} a clean Tier 2 beats a wipe on Tier 3.${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `
- Buy **Forward Depot** earlier than it looks worth: energy regeneration, not
  raid speed, is what caps how much you can actually run in a day.` : ''}

---

## FAQ

**Can I change my faction?** No \u{2014} it's permanent. Roll another character to try a
different faction.

**How many artifacts can I equip?** Two \u{2014} one Skill artifact and one Utility
artifact.

**Why can't I craft a second copy of gear/an artifact?** Durable gear and
artifacts are equip-once, so each is capped at one craft per character. Finishing
the set is the point.

**Do contractors level up?** No \u{2014} they're temporary hires.

**What happens if my team wipes?** The raid ends early with no reward, but your
character returns safely \u{2014} characters can't permanently die.${(0, $bde36de43872f734$export$25d1e5af45c35a33)() ? `

**What do I lose when I promote?** The character (they become a Legend) and most
of your credits \u{2014} their leftover relics and consumables are sold off first, so
the amount you keep is a share of that larger total. Their materials are not
destroyed: they are split and set aside. You keep Marks, upgrades, unlocked
regions, and every other character \u{2014} and gain a permanent power boost.` : ''}${(0, $46d374413fb0707a$export$f0d4871acc619a3)() ? `

**When should I found a Syndicate?** As soon as you can. Writs scale with the
square root of an era's Marks, so a longer era pays steadily less per hour than
founding again and starting the next one with better charters.

**Do I lose my Legends when I found?** Yes \u{2014} the whole gallery is spent to
create the Syndicate, and the era's best officer becomes its permanent Leader.
Unlocked artifact designs, blueprints, Writs, charters and the material dock all
carry over.

**Why won't Succession Doctrine let me buy it?** It needs **both** Auto-Raid
Protocol and Auto-Fabricator. It promotes on your Marks *rate*, and most Marks
come from crafting \u{2014} automating the raids alone would have it judging a
character that only earns a fraction of a normal tour.

**Why is Auto-Craft sitting on "Idle"?** It is on, but has nothing it can build
right now: no blueprint to unlock, no complete recipe, and nothing affordable.
It will start again on its own as raids bring materials in.` : ''}

---

*Last Updated: 8/5/2026*`;
function $d702ea8c52a4a088$export$ec50a2d4695064b2() {
    return [
        $d702ea8c52a4a088$var$GUIDE_HEAD,
        $d702ea8c52a4a088$var$bigPicture(),
        $d702ea8c52a4a088$var$fieldBody(),
        (0, $bde36de43872f734$export$25d1e5af45c35a33)() ? $d702ea8c52a4a088$var$commandBody() : null,
        (0, $46d374413fb0707a$export$f0d4871acc619a3)() ? $d702ea8c52a4a088$var$SYNDICATE_BODY : null,
        $d702ea8c52a4a088$var$tail()
    ].filter(Boolean).join('\n\n---\n\n');
}


/**
 * Dev-only viewport button — open the game at exactly iPad landscape.
 *
 * Lives on the shared dev strip (`devBar.js`), which owns the localhost gate,
 * the positioning and the chip styling.
 *
 * WHY A POPUP, and not a clamped container. A page cannot resize its own tab:
 * `window.resizeTo` is ignored unless the window was opened by script. The
 * tempting alternative — constraining #game-container to 1024x768 and calling
 * that a preview — would LIE, because this layout leans on things that read the
 * real viewport and not the container:
 *
 *   @media (max-height: 820px)   the catalog-card and pane-blurb compression
 *   calc(100vh - var(--map-chrome))  the world map's size
 *   subTabs.js sizeActiveScroller    window.innerHeight
 *
 * All three would keep reporting the desktop viewport, so the clamped box would
 * render the DESKTOP layout at tablet dimensions — the exact opposite of what a
 * tablet check is for. A script-opened window has a real viewport, and may then
 * be resized to correct for browser chrome.
 */ /**
 * The dev control strip — a fixed row of localhost-only chips over the header.
 *
 * Shared by `devViewport.js` and `devFixtures.js`, which is the whole reason it
 * exists: two floating controls each picking their own `top`/`left` is a magic
 * number waiting to overlap, and two copies of the same chip CSS is two places
 * to change it.
 *
 * NOT inside `#game-header`. Tempting, since that is where these visually sit,
 * but the header is `overflow: hidden` (so an extra control is silently clipped
 * rather than visibly wrong) and it is one of the surfaces the tablet pass is
 * most sensitive about. A fixed overlay owes the layout nothing and cannot
 * change how the real header behaves at any viewport.
 */ function $dcf0234742c4b19b$export$6dd1bbd39f571125() {
    return typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
}
let $dcf0234742c4b19b$var$bar = null;
function $dcf0234742c4b19b$export$d2e04e586301da9d() {
    if (!$dcf0234742c4b19b$export$6dd1bbd39f571125() || typeof document === 'undefined') return null;
    if ($dcf0234742c4b19b$var$bar) return $dcf0234742c4b19b$var$bar;
    $dcf0234742c4b19b$var$bar = document.createElement('div');
    $dcf0234742c4b19b$var$bar.id = 'dev-bar';
    $dcf0234742c4b19b$var$bar.style.cssText = [
        'position:fixed',
        'top:2px',
        'left:2px',
        'z-index:2147483647',
        'display:flex',
        'flex-wrap:wrap',
        'gap:2px',
        'align-items:center',
        // Dim at rest, awake on approach. These sit on top of the game at all
        // times during development, so they have to be findable without being
        // something the eye keeps catching while looking at the layout.
        'opacity:0.55',
        'transition:opacity 0.12s'
    ].join(';');
    $dcf0234742c4b19b$var$bar.addEventListener('mouseenter', ()=>{
        $dcf0234742c4b19b$var$bar.style.opacity = '1';
    });
    $dcf0234742c4b19b$var$bar.addEventListener('mouseleave', ()=>{
        $dcf0234742c4b19b$var$bar.style.opacity = '0.55';
    });
    document.body.appendChild($dcf0234742c4b19b$var$bar);
    return $dcf0234742c4b19b$var$bar;
}
function $dcf0234742c4b19b$export$3edc0c30f7140ad8({ label: label, title: title, onClick: onClick }) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = label;
    btn.title = title;
    btn.style.cssText = [
        'font:700 10px/1 ui-monospace,monospace',
        'padding:3px 5px',
        'color:#9ca3af',
        'background:rgba(0,0,0,0.72)',
        'border:1px solid #374151',
        'border-radius:4px',
        'cursor:pointer'
    ].join(';');
    if (onClick) btn.addEventListener('click', onClick);
    return btn;
}


const $1829d481bf452b83$var$PRESET = {
    label: 'iPad landscape',
    w: 1024,
    h: 768
};
const $1829d481bf452b83$var$WINDOW_NAME = 'idle-extraction-ipad-landscape';
/**
 * Resize until the CONTENT area matches, not the outer window.
 *
 * `window.open`'s width/height are interpreted inconsistently — some browsers
 * size the outer frame, so asking for 768 can leave ~700 of usable height once
 * the toolbar is subtracted. Correcting by the measured delta is the only way to
 * land on the number that actually matters, which is innerWidth/innerHeight.
 */ function $1829d481bf452b83$var$fitViewport(w, h) {
    window.resizeBy(w - window.innerWidth, h - window.innerHeight);
}
function $1829d481bf452b83$var$atPreset() {
    return window.innerWidth === $1829d481bf452b83$var$PRESET.w && window.innerHeight === $1829d481bf452b83$var$PRESET.h;
}
function $1829d481bf452b83$var$label() {
    return `${$1829d481bf452b83$var$atPreset() ? "\u2705" : "\uD83D\uDCD0"} ${window.innerWidth}\xd7${window.innerHeight}`;
}
function $1829d481bf452b83$export$d95b3e0536e68b56() {
    const bar = (0, $dcf0234742c4b19b$export$d2e04e586301da9d)();
    if (!bar) return;
    const btn = (0, $dcf0234742c4b19b$export$3edc0c30f7140ad8)({
        label: $1829d481bf452b83$var$label(),
        title: `Dev only \u{2014} open the game in a window sized to ${$1829d481bf452b83$var$PRESET.label} (${$1829d481bf452b83$var$PRESET.w}\xd7${$1829d481bf452b83$var$PRESET.h}). Shows the live viewport size.`
    });
    btn.id = 'dev-viewport-btn';
    btn.style.marginRight = '4px';
    btn.addEventListener('click', ()=>{
        // Already in the sized window: re-fit in place. Handy after a manual
        // drag, and it is the only case where resizing is permitted at all.
        if (window.name === $1829d481bf452b83$var$WINDOW_NAME) {
            $1829d481bf452b83$var$fitViewport($1829d481bf452b83$var$PRESET.w, $1829d481bf452b83$var$PRESET.h);
            return;
        }
        const popup = window.open(location.href, $1829d481bf452b83$var$WINDOW_NAME, `width=${$1829d481bf452b83$var$PRESET.w},height=${$1829d481bf452b83$var$PRESET.h},menubar=no,toolbar=no,location=no,status=no`);
        if (!popup) {
            btn.textContent = "\uD83D\uDCD0 popup blocked";
            return;
        }
        popup.focus();
    });
    // Doubles as a live readout, which is what makes this useful even where the
    // popup is blocked or the browser absorbs window.open: drag the window until
    // it goes green and you are at iPad landscape.
    const refresh = ()=>{
        btn.textContent = $1829d481bf452b83$var$label();
        btn.style.color = $1829d481bf452b83$var$atPreset() ? '#4ade80' : '#9ca3af';
        btn.style.borderColor = $1829d481bf452b83$var$atPreset() ? '#166534' : '#374151';
    };
    window.addEventListener('resize', refresh);
    bar.appendChild(btn);
    refresh();
    // The popup lands at whatever size the browser chose; correct it once it
    // has laid out, then report the real number.
    if (window.name === $1829d481bf452b83$var$WINDOW_NAME) requestAnimationFrame(()=>{
        $1829d481bf452b83$var$fitViewport($1829d481bf452b83$var$PRESET.w, $1829d481bf452b83$var$PRESET.h);
        refresh();
    });
}



/**
 * Dev-only fixture switcher — one click to any layer (localhost only).
 *
 * The maintained save fixtures in `tools/qa/fixtures` are the fastest way to
 * stand in any part of the game without grinding a save, and they were already
 * reachable from the console. This puts them on a strip of buttons, because
 * "which fixture reaches the Operations planner again?" is a question you
 * should not have to answer from memory every time you want to look at it.
 *
 * ONE LIST DRIVES EVERYTHING. `FIXTURES` below is the source for the buttons,
 * the console hint and the not-found error. The previous version of this had
 * the names written out in a comment, in an error string and in a console.info
 * line, and the comment was already the only one listing all five.
 *
 * The real save is stashed under `qaBackupSave` on first use and put back by
 * `restoreSave()` — the fixtures overwrite `idleExtractionSave` in place, so
 * that stash is the only copy of the player's actual game.
 *
 * Fixtures are served from `/fixtures` (see package.json `staticFiles`), which
 * copies them AT SERVER START — regenerate them and the running server keeps
 * handing out the old snapshot until it is restarted.
 */ 
const $240af90fbaec7c06$var$SAVE_KEY = 'idleExtractionSave';
const $240af90fbaec7c06$var$BACKUP_KEY = 'qaBackupSave';
// Which fixture is on screen. Kept in storage rather than sniffed from the
// character name because the point is to survive the reload that loading one
// causes, and a name can be edited in-game.
const $240af90fbaec7c06$var$ACTIVE_KEY = 'qaFixtureActive';
const $240af90fbaec7c06$export$18c53a34fcd81ece = [
    {
        name: 'fresh',
        label: 'fresh',
        layer: 'new account',
        desc: 'Wipe the save and run the new-account flow'
    },
    {
        name: 'mid',
        label: 'mid',
        layer: 'Field',
        desc: "Pre-Command, level 10 \u2014 crosses the Command reveal threshold on boot"
    },
    {
        name: 'late',
        label: 'late',
        layer: 'Command',
        desc: 'Post-Command veteran: marks, Legends, upgrades, artifacts'
    },
    {
        name: 'pre-founding',
        label: 'pre-found',
        layer: 'Syndicate founding',
        desc: "15 Legends, ceremony still ahead \u2014 one-way, so reload to repeat"
    },
    {
        name: 'syndicate',
        label: 'syndicate',
        layer: 'Syndicate',
        desc: "Founded once: Leader, charters, rebuilding era \u2014 the L3 starting point"
    },
    {
        name: 'grand-tour',
        label: 'tour',
        layer: 'Operations',
        desc: '6 era-Legends + rank-3 charter: one click from the longest operation'
    }
];
const $240af90fbaec7c06$var$NAMES = $240af90fbaec7c06$export$18c53a34fcd81ece.map((f)=>f.name);
async function $240af90fbaec7c06$export$fad9145e0ce507a0(name = 'late') {
    const existing = localStorage.getItem($240af90fbaec7c06$var$SAVE_KEY);
    if (existing && !localStorage.getItem($240af90fbaec7c06$var$BACKUP_KEY)) localStorage.setItem($240af90fbaec7c06$var$BACKUP_KEY, existing); // stash the real save once
    localStorage.setItem($240af90fbaec7c06$var$ACTIVE_KEY, name);
    if (name === 'fresh') {
        localStorage.removeItem($240af90fbaec7c06$var$SAVE_KEY);
        location.reload();
        return;
    }
    const res = await fetch(`/fixtures/${name}-game.json`, {
        cache: 'no-store'
    });
    if (!res.ok) {
        console.error(`Fixture "${name}" not found (${res.status}). Use one of: ${$240af90fbaec7c06$var$NAMES.join(', ')}.`);
        localStorage.removeItem($240af90fbaec7c06$var$ACTIVE_KEY);
        return;
    }
    localStorage.setItem($240af90fbaec7c06$var$SAVE_KEY, JSON.stringify(await res.json()));
    location.reload();
}
function $240af90fbaec7c06$export$4fd8d4441084914c() {
    const backup = localStorage.getItem($240af90fbaec7c06$var$BACKUP_KEY);
    if (!backup) {
        console.warn("restoreSave(): nothing stashed \u2014 no fixture has been loaded, so the live save is left alone.");
        return false;
    }
    localStorage.setItem($240af90fbaec7c06$var$SAVE_KEY, backup);
    localStorage.removeItem($240af90fbaec7c06$var$BACKUP_KEY);
    localStorage.removeItem($240af90fbaec7c06$var$ACTIVE_KEY);
    location.reload();
    return true;
}
function $240af90fbaec7c06$export$45e422e963dadb5c() {
    const bar = (0, $dcf0234742c4b19b$export$d2e04e586301da9d)();
    if (!bar) return;
    const active = localStorage.getItem($240af90fbaec7c06$var$ACTIVE_KEY);
    const hasBackup = !!localStorage.getItem($240af90fbaec7c06$var$BACKUP_KEY);
    for (const f of $240af90fbaec7c06$export$18c53a34fcd81ece){
        const btn = (0, $dcf0234742c4b19b$export$3edc0c30f7140ad8)({
            label: f.label,
            title: `Dev only \u{2014} load the "${f.name}" fixture \u{2192} ${f.layer}.\n${f.desc}

Overwrites the live save; your real one is kept until you press \u{21A9}.`,
            onClick: ()=>$240af90fbaec7c06$export$fad9145e0ce507a0(f.name)
        });
        // The loaded fixture is marked, because the strip is otherwise the one
        // place in the UI that cannot tell you which save you are looking at —
        // and a fixture you did not mean to be in explains a lot of confusing
        // test results.
        if (f.name === active) {
            btn.style.color = '#fbbf24';
            btn.style.borderColor = '#92400e';
        }
        bar.appendChild(btn);
    }
    // Restore is last and visually apart: it is the way OUT of fixture-land,
    // and pressing it by mistake while reaching for a fixture costs a reload.
    const restore = (0, $dcf0234742c4b19b$export$3edc0c30f7140ad8)({
        label: "\u21A9",
        title: hasBackup ? "Dev only \u2014 restore the save that was live before the first fixture load" : "Dev only \u2014 no stashed save (no fixture has been loaded yet)",
        onClick: ()=>{
            if (hasBackup) $240af90fbaec7c06$export$4fd8d4441084914c();
        }
    });
    restore.style.marginLeft = '4px';
    if (hasBackup) {
        restore.style.color = '#4ade80';
        restore.style.borderColor = '#166534';
    } else {
        restore.style.opacity = '0.4';
        restore.style.cursor = 'default';
    }
    bar.appendChild(restore);
}
function $240af90fbaec7c06$export$17bd57c6fd7474d9() {
    if (!(0, $dcf0234742c4b19b$export$6dd1bbd39f571125)()) return;
    console.info(`%cDev fixtures:%c loadFixture('${$240af90fbaec7c06$var$NAMES.join("'|'")}') \xb7 restoreSave() \u{2014} or use the buttons top-left`, 'font-weight:bold', '');
}






/**
 * Config Validation - fail fast when generated config is missing or malformed.
 *
 * `js/constants.js` is GENERATED (npm run build) from js/data/*. If a build is
 * stale, partial, or a data export gets renamed, the old habit of reading
 * balance values through `config.x?.y || <inline default>` silently substitutes
 * a different game: marks, XP and credit curves quietly change and nothing
 * reports it. Those inline fallbacks also rot — they were the ORIGINAL tuning
 * values and drifted years out of date while reading like documentation.
 *
 * So: balance reads are now direct (config.progressionScaling.commandMarks.x),
 * and this module is the one place that checks the config is actually there.
 * Called once at boot, before any game state loads.
 *
 * Pure - no browser or gameState dependency, so the simulator and tests can
 * assert the same contract.
 */ /**
 * Required config paths, as [dotted path, kind].
 *
 * kind:
 *   'object'  - must be a non-null object with at least one own key
 *   'number'  - must be a finite number
 *   'divisor' - finite number, and not 0 (it is used as a denominator)
 *
 * Only values the code READS belong here. Adding a path makes it a hard boot
 * requirement, so add when code starts depending on it, not speculatively.
 */ const $ab3705241c399f11$export$56d525b7f833c577 = [
    // Core game data
    [
        'raidTierData',
        'object'
    ],
    [
        'raidRegions',
        'object'
    ],
    [
        'commonAreas',
        'object'
    ],
    [
        'factionSkills',
        'object'
    ],
    [
        'itemRarities',
        'object'
    ],
    [
        'commandUpgrades',
        'object'
    ],
    // Balance SSOT - js/data/progressionScaling.js
    [
        'progressionScaling.recipeInputs',
        'object'
    ],
    [
        'progressionScaling.raidXpTierMultipliers',
        'object'
    ],
    [
        'progressionScaling.skillEventDamage',
        'object'
    ],
    [
        'progressionScaling.bonusEventCascadeMultipliers',
        'object'
    ],
    [
        'progressionScaling.skillPointsPerLevel.base',
        'number'
    ],
    [
        'progressionScaling.skillPointsPerLevel.levelDivisor',
        'divisor'
    ],
    [
        'progressionScaling.skillPointsPerLevel.increment',
        'number'
    ],
    [
        'progressionScaling.synergyUnlocks.minLevel',
        'number'
    ],
    [
        'progressionScaling.synergyUnlocks.cost',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perTechGear',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perArtifactUnlock',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perArtifactCraft',
        'number'
    ],
    [
        'progressionScaling.commandMarks.t3WinsDivisor',
        'divisor'
    ],
    [
        'progressionScaling.commandMarks.perLevel',
        'number'
    ],
    [
        'progressionScaling.commandMarks.unlockThreshold',
        'number'
    ],
    [
        'progressionScaling.promotionCreditLevy.keepFraction',
        'number'
    ],
    [
        'progressionScaling.promotionCreditLevy.floor',
        'number'
    ],
    [
        'progressionScaling.creditsScaling.globalMultiplier',
        'number'
    ],
    [
        'progressionScaling.creditsScaling.tierMultipliers',
        'object'
    ],
    [
        'progressionScaling.craftingCostScaling.globalMultiplier',
        'number'
    ],
    [
        'progressionScaling.craftingCostScaling.rarityMultipliers',
        'object'
    ],
    [
        'progressionScaling.craftingDiscountPerTour',
        'number'
    ],
    [
        'progressionScaling.energyPurchaseScaling.escalationFactor',
        'number'
    ],
    // Here for exactly the reason in this file's header: it was read through
    // `?? 0`, and that fallback fails silently in the worst possible way — a stale
    // build ships a game where no key ever drops and the Archive is permanently
    // empty, which looks identical to "the player has not found one yet".
    //
    // `collapseKeys` itself is deliberately NOT listed. The item arrays it sits
    // beside (itemsCommon, itemsStoryRelics, …) are not validated here either;
    // data-completeness is a build-time question that collapseKeys.test.js
    // already answers, where this file's job is the balance values whose absence
    // is invisible at runtime.
    [
        'progressionScaling.collapseKeyDropChance',
        'number'
    ]
];
function $ab3705241c399f11$var$readPath(root, path) {
    return path.split('.').reduce((node, key)=>node == null ? undefined : node[key], root);
}
function $ab3705241c399f11$var$describeProblem(path, kind, value) {
    if (value === undefined) return `${path} is missing`;
    if (kind === 'object') {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return `${path} should be an object, got ${Array.isArray(value) ? 'array' : typeof value}`;
        if (Object.keys(value).length === 0) return `${path} is an empty object`;
        return null;
    }
    if (!Number.isFinite(value)) return `${path} should be a finite number, got ${JSON.stringify(value)}`;
    if (kind === 'divisor' && value === 0) return `${path} is 0, but it is used as a divisor`;
    return null;
}
function $ab3705241c399f11$export$127f9a442b42d18(config) {
    if (config == null || typeof config !== 'object') return [
        'config module did not load at all'
    ];
    const problems = [];
    for (const [path, kind] of $ab3705241c399f11$export$56d525b7f833c577){
        const problem = $ab3705241c399f11$var$describeProblem(path, kind, $ab3705241c399f11$var$readPath(config, path));
        if (problem) problems.push(problem);
    }
    return problems;
}
function $ab3705241c399f11$export$82367cdd05923d12(config) {
    const problems = $ab3705241c399f11$export$127f9a442b42d18(config);
    if (problems.length === 0) return;
    throw new Error(`Game config failed to load (${problems.length} problem${problems.length === 1 ? '' : 's'}). ` + `js/constants.js is generated \u{2014} run \`npm run build\`.
  - ${problems.join('\n  - ')}`);
}



const $8f5438719ac05b79$export$5def58af4fd46132 = Symbol('abort');
const $8f5438719ac05b79$export$da980962bd2147a4 = Symbol('activeElement');
const $8f5438719ac05b79$export$2f2960ad29426dcb = Symbol('asyncTaskManager');
const $8f5438719ac05b79$export$3e74b83f1104272d = Symbol('bodyBuffer');
const $8f5438719ac05b79$export$ab1029bcae9ddb4a = Symbol('buffer');
const $8f5438719ac05b79$export$d3a0c81e6dd45916 = Symbol('cachedResponse');
const $8f5438719ac05b79$export$b89c5c1b934d8237 = Symbol('callbacks');
const $8f5438719ac05b79$export$b96bb35bc88d6fa = Symbol('checked');
const $8f5438719ac05b79$export$c9fa23d9ff60a2d1 = Symbol('childNodes');
const $8f5438719ac05b79$export$bacb5cc5a11aef16 = Symbol('children');
const $8f5438719ac05b79$export$11c615ce16f87241 = Symbol('classList');
const $8f5438719ac05b79$export$5261f17c72b73389 = Symbol('connectedToNode');
const $8f5438719ac05b79$export$cd768479ff770c20 = Symbol('disconnectedFromNode');
const $8f5438719ac05b79$export$7bcafbe05fbfa5b1 = Symbol('connectedToDocument');
const $8f5438719ac05b79$export$62389f4045fa8671 = Symbol('disconnectedFromDocument');
const $8f5438719ac05b79$export$c0100fdcae152d59 = Symbol('contentLength');
const $8f5438719ac05b79$export$8019223850b8bf78 = Symbol('contentType');
const $8f5438719ac05b79$export$76d490348eec5e39 = Symbol('cssText');
const $8f5438719ac05b79$export$7aca2fdfd0625e3a = Symbol('currentScript');
const $8f5438719ac05b79$export$28b27b1605aa05ad = Symbol('currentTarget');
const $8f5438719ac05b79$export$4051a07651545597 = Symbol('data');
const $8f5438719ac05b79$export$93acc5219d6538bb = Symbol('defaultView');
const $8f5438719ac05b79$export$b1fb4cac938035f7 = Symbol('destroy');
const $8f5438719ac05b79$export$7ebb24f7f0859a21 = Symbol('dirtyness');
const $8f5438719ac05b79$export$bd5df0f255a350f8 = Symbol('end');
const $8f5438719ac05b79$export$3e9f948b41964866 = Symbol('entries');
const $8f5438719ac05b79$export$ec50bd62c0d468dd = Symbol('evaluateCSS');
const $8f5438719ac05b79$export$80601be7cebdc7d3 = Symbol('evaluateScript');
const $8f5438719ac05b79$export$145e1b7a763b687a = Symbol('exceptionObserver');
const $8f5438719ac05b79$export$b05ea1b97b1edb0f = Symbol('formNode');
const $8f5438719ac05b79$export$89c21e0f18de79c = Symbol('internalId');
const $8f5438719ac05b79$export$ac607276a8fe9f0a = Symbol('height');
const $8f5438719ac05b79$export$b0d3f7c520d97ddf = Symbol('immediatePropagationStopped');
const $8f5438719ac05b79$export$5a1fde3dfe3b3c2a = Symbol('indeterminate');
const $8f5438719ac05b79$export$be5f715765399e60 = Symbol('isFirstWrite');
const $8f5438719ac05b79$export$2a8d67a8e92bd591 = Symbol('isFirstWriteAfterOpen');
const $8f5438719ac05b79$export$8035c60dfffb0f3c = Symbol('isInPassiveEventListener');
const $8f5438719ac05b79$export$2fb7a00a48619649 = Symbol('isValue');
const $8f5438719ac05b79$export$99a24029806ba245 = Symbol('listenerOptions');
const $8f5438719ac05b79$export$58bed631278dbc67 = Symbol('listeners');
const $8f5438719ac05b79$export$fae23e6e0e86e83a = Symbol('itemsByName');
const $8f5438719ac05b79$export$46676622036c082b = Symbol('nextActiveElement');
const $8f5438719ac05b79$export$46debc62fc90cfe5 = Symbol('observeMutations');
const $8f5438719ac05b79$export$96b91b50ecdf2e19 = Symbol('mutationListeners');
const $8f5438719ac05b79$export$512a1115db01100d = Symbol('ownerDocument');
const $8f5438719ac05b79$export$975cb7bbfe3c62ec = Symbol('ownerElement');
const $8f5438719ac05b79$export$319913b486a9e3fc = Symbol('propagationStopped');
const $8f5438719ac05b79$export$984aa9e1cd8e27bf = Symbol('readyStateManager');
const $8f5438719ac05b79$export$a0c6a011d8b20057 = Symbol('referrer');
const $8f5438719ac05b79$export$4bb7493d241fd8a5 = Symbol('registry');
const $8f5438719ac05b79$export$5884a0b424dd5ef2 = Symbol('relList');
const $8f5438719ac05b79$export$d0c8d979056ee3a9 = Symbol('resetSelection');
const $8f5438719ac05b79$export$da02117a63b881a8 = Symbol('rootNode');
const $8f5438719ac05b79$export$cbcb4f775d907a9e = Symbol('selectNode');
const $8f5438719ac05b79$export$c14ef38ba55762e4 = Symbol('selectedness');
const $8f5438719ac05b79$export$7c69810f7b8835c9 = Symbol('selection');
const $8f5438719ac05b79$export$77eb42331d4516cf = Symbol('setupVMContext');
const $8f5438719ac05b79$export$10fb11023ed0cf27 = Symbol('shadowRoot');
const $8f5438719ac05b79$export$b3571188c770cc5a = Symbol('start');
const $8f5438719ac05b79$export$1d567c320f4763bc = Symbol('style');
const $8f5438719ac05b79$export$44271b4f0c6a3563 = Symbol('target');
const $8f5438719ac05b79$export$5739d30adb1c099 = Symbol('textAreaNode');
const $8f5438719ac05b79$export$970b39750526e0e2 = Symbol('unobserveMutations');
const $8f5438719ac05b79$export$47b1fb35c7874795 = Symbol('reportMutation');
const $8f5438719ac05b79$export$b339d29f76738b20 = Symbol('updateSelectedness');
const $8f5438719ac05b79$export$128fa18b7194ef = Symbol('url');
const $8f5438719ac05b79$export$2ab9a8f9f1186f14 = Symbol('value');
const $8f5438719ac05b79$export$7e3df82ee760448c = Symbol('width');
const $8f5438719ac05b79$export$8291e5b88f90ce4 = Symbol('window');
const $8f5438719ac05b79$export$5201366159206f54 = Symbol('windowResizeListener');
const $8f5438719ac05b79$export$367c557fdd85162f = Symbol('mutationObservers');
const $8f5438719ac05b79$export$fb8fd923cbcaa51 = Symbol('openerFrame');
const $8f5438719ac05b79$export$14386cb9d04bf779 = Symbol('openerWindow');
const $8f5438719ac05b79$export$63b4813c5280c707 = Symbol('popup');
const $8f5438719ac05b79$export$e5a90df53f832dc9 = Symbol('isConnected');
const $8f5438719ac05b79$export$b54be7ce267a037b = Symbol('parentNode');
const $8f5438719ac05b79$export$4debbe1037afe35e = Symbol('nodeType');
const $8f5438719ac05b79$export$45e0b80f1e500bd4 = Symbol('tagName');
const $8f5438719ac05b79$export$82e9f45cca5ba907 = Symbol('prefix');
const $8f5438719ac05b79$export$5a0845c0f7cb1511 = Symbol('scrollHeight');
const $8f5438719ac05b79$export$dc81048565b75a98 = Symbol('scrollWidth');
const $8f5438719ac05b79$export$3e0c8fa3b5e4b3b9 = Symbol('scrollTop');
const $8f5438719ac05b79$export$6eddf9bc7f2b7d80 = Symbol('scrollLeft');
const $8f5438719ac05b79$export$16bd37df0047a29c = Symbol('attributes');
const $8f5438719ac05b79$export$9a6cb5364cfc98aa = Symbol('attributesProxy');
const $8f5438719ac05b79$export$4bb31c815825375a = Symbol('namespaceURI');
const $8f5438719ac05b79$export$1113a6923fc2e342 = Symbol('accessKey');
const $8f5438719ac05b79$export$74bccced03596b17 = Symbol('accessKeyLabel');
const $8f5438719ac05b79$export$720e3813341eb9b = Symbol('offsetHeight');
const $8f5438719ac05b79$export$abda199d6e675d54 = Symbol('offsetWidth');
const $8f5438719ac05b79$export$4ad6bc00a859a01c = Symbol('offsetLeft');
const $8f5438719ac05b79$export$9051df5ff5b6ece8 = Symbol('offsetTop');
const $8f5438719ac05b79$export$1ceecc078aa19b72 = Symbol('clientHeight');
const $8f5438719ac05b79$export$f451d61d633bfdbe = Symbol('clientWidth');
const $8f5438719ac05b79$export$6af8701396d90b51 = Symbol('clientLeft');
const $8f5438719ac05b79$export$b570871c7d022cff = Symbol('clientTop');
const $8f5438719ac05b79$export$a8ff84c12d48cfa6 = Symbol('name');
const $8f5438719ac05b79$export$73c81789889f78fa = Symbol('specified');
const $8f5438719ac05b79$export$1bfc6cbb3cb6245f = Symbol('adoptedStyleSheets');
const $8f5438719ac05b79$export$92ebad0065552617 = Symbol('implementation');
const $8f5438719ac05b79$export$1ae2b664eea77b7e = Symbol('readyState');
const $8f5438719ac05b79$export$be552e86f287cd4b = Symbol('publicId');
const $8f5438719ac05b79$export$b81d14d988111634 = Symbol('systemId');
const $8f5438719ac05b79$export$6ee4201e37a931e2 = Symbol('validationMessage');
const $8f5438719ac05b79$export$1bdd3f9a89b22594 = Symbol('validity');
const $8f5438719ac05b79$export$499f1697a123b0bc = Symbol('returnValue');
const $8f5438719ac05b79$export$7a5d735b2ab6389d = Symbol('elements');
const $8f5438719ac05b79$export$f24224f1c91d8156 = Symbol('length');
const $8f5438719ac05b79$export$b1bc8081da8c9e77 = Symbol('complete');
const $8f5438719ac05b79$export$6a4b566b54dc81c0 = Symbol('naturalHeight');
const $8f5438719ac05b79$export$c32e50dfb9f4ec89 = Symbol('naturalWidth');
const $8f5438719ac05b79$export$46c1c92549715335 = Symbol('loading');
const $8f5438719ac05b79$export$d141bba7fdc215a3 = Symbol('x');
const $8f5438719ac05b79$export$4a5767248b18ef41 = Symbol('y');
const $8f5438719ac05b79$export$8f49a7e9e3141ccc = Symbol('defaultChecked');
const $8f5438719ac05b79$export$3a444357c5f65f65 = Symbol('files');
const $8f5438719ac05b79$export$995990c5c04c46f0 = Symbol('sheet');
const $8f5438719ac05b79$export$7714b48ed08b13f2 = Symbol('volume');
const $8f5438719ac05b79$export$cd215b91700bbebc = Symbol('paused');
const $8f5438719ac05b79$export$283f641d6ed1ac80 = Symbol('currentTime');
const $8f5438719ac05b79$export$6d7f3930b8041bc4 = Symbol('playbackRate');
const $8f5438719ac05b79$export$388da195c50bfd17 = Symbol('defaultPlaybackRate');
const $8f5438719ac05b79$export$987a4e3838aef8c6 = Symbol('muted');
const $8f5438719ac05b79$export$4c9bd91015e50a76 = Symbol('defaultMuted');
const $8f5438719ac05b79$export$164ab51d3829a076 = Symbol('preservesPitch');
const $8f5438719ac05b79$export$8843b826b2cc8d0c = Symbol('buffered');
const $8f5438719ac05b79$export$1f34108aa9eb96ab = Symbol('duration');
const $8f5438719ac05b79$export$a3bc9b8ed74fc = Symbol('error');
const $8f5438719ac05b79$export$999b7b72c79021f2 = Symbol('ended');
const $8f5438719ac05b79$export$8ee3aa19592dce0d = Symbol('networkState');
const $8f5438719ac05b79$export$2d89dd5615a16994 = Symbol('textTracks');
const $8f5438719ac05b79$export$c8243f3943339030 = Symbol('seeking');
const $8f5438719ac05b79$export$5821955352efceb5 = Symbol('seekable');
const $8f5438719ac05b79$export$c6e32fc63aaa6e76 = Symbol('played');
const $8f5438719ac05b79$export$41c562ebe57d11e2 = Symbol('options');
const $8f5438719ac05b79$export$a7db06668cad9adb = Symbol('content');
const $8f5438719ac05b79$export$549ff81930776885 = Symbol('mode');
const $8f5438719ac05b79$export$5e032988b71f6158 = Symbol('host');
const $8f5438719ac05b79$export$926a1681f03b3972 = Symbol('setURL');
const $8f5438719ac05b79$export$cbef64f03c7768af = Symbol('localName');
const $8f5438719ac05b79$export$2792378e23a7920c = Symbol('classRegistry');
const $8f5438719ac05b79$export$be98572e04cea348 = Symbol('nodeStream');
const $8f5438719ac05b79$export$17b07c660794dc13 = Symbol('location');
const $8f5438719ac05b79$export$55abd4691b317664 = Symbol('history');
const $8f5438719ac05b79$export$ec7c8efa7f5790ae = Symbol('navigator');
const $8f5438719ac05b79$export$be623a1d3e871e62 = Symbol('screen');
const $8f5438719ac05b79$export$f119d83aa936d634 = Symbol('sessionStorage');
const $8f5438719ac05b79$export$c2ed3351cac403d1 = Symbol('localStorage');
const $8f5438719ac05b79$export$f020670913e851a6 = Symbol('sandbox');
const $8f5438719ac05b79$export$ae8e35ea29ddac22 = Symbol('cloneNode');
const $8f5438719ac05b79$export$1b8e57c9ea42f1d2 = Symbol('appendChild');
const $8f5438719ac05b79$export$7ae609f7af59e4f7 = Symbol('removeChild');
const $8f5438719ac05b79$export$86b68c7dbeb53c22 = Symbol('insertBefore');
const $8f5438719ac05b79$export$46f78da0e790aab7 = Symbol('replaceChild');
const $8f5438719ac05b79$export$c42c4b43e6ce031e = Symbol('tracks');
const $8f5438719ac05b79$export$264486c0939fa42b = Symbol('constraints');
const $8f5438719ac05b79$export$8e76ac9f37578d1b = Symbol('capabilities');
const $8f5438719ac05b79$export$a5a6e0b888b2c992 = Symbol('settings');
const $8f5438719ac05b79$export$9cd59f9826255e47 = Symbol('clone');
const $8f5438719ac05b79$export$2fb3bf594548fad2 = Symbol('removeNamedItem');
const $8f5438719ac05b79$export$17a1664ed1fb5d6f = Symbol('items');
const $8f5438719ac05b79$export$b0ea99e7ae5aed6c = Symbol('selectedOptions');
const $8f5438719ac05b79$export$d790dbddab3a5a7 = Symbol('styleNode');
const $8f5438719ac05b79$export$49c3ff852145bbc3 = Symbol('updateSheet');
const $8f5438719ac05b79$export$d2adf65b87e47523 = Symbol('clearCache');
const $8f5438719ac05b79$export$772723555d727dca = Symbol('onSetAttribute');
const $8f5438719ac05b79$export$c4c8b87eaa1d4a6d = Symbol('onRemoveAttribute');
const $8f5438719ac05b79$export$34baf9226cd3d576 = Symbol('nodeArray');
const $8f5438719ac05b79$export$2eb2dc5352f5da3 = Symbol('elementArray');
const $8f5438719ac05b79$export$69a3209f1a06c04d = Symbol('cache');
const $8f5438719ac05b79$export$80de6e30a9c630d9 = Symbol('affectsCache');
const $8f5438719ac05b79$export$71730bae229ad1d = Symbol('forms');
const $8f5438719ac05b79$export$f5f8cbac9d743c03 = Symbol('affectsComputedStyleCache');
const $8f5438719ac05b79$export$2fa187e846a241c4 = Symbol('query');
const $8f5438719ac05b79$export$ade5b9b1819f1516 = Symbol('computedStyle');
const $8f5438719ac05b79$export$4198a1a890646286 = Symbol('getFormControlItems');
const $8f5438719ac05b79$export$e8846d4d2446a1c9 = Symbol('getFormControlNamedItem');
const $8f5438719ac05b79$export$ff416b0d33795a06 = Symbol('dataset');
const $8f5438719ac05b79$export$714c5d3403db4c93 = Symbol('getNamespaceItemKey');
const $8f5438719ac05b79$export$5dd1224c2ae94442 = Symbol('getNamedItemKey');
const $8f5438719ac05b79$export$5ca502276fc813a = Symbol('itemsByNamespaceURI');
const $8f5438719ac05b79$export$923f96dd5afa9ce6 = Symbol('proxy');
const $8f5438719ac05b79$export$f5d9e770a4a8bf7b = Symbol('setNamedItem');
const $8f5438719ac05b79$export$4aec0e9d20ba276 = Symbol('getTokenList');
const $8f5438719ac05b79$export$8e830b0a8238aa08 = Symbol('attributeName');
const $8f5438719ac05b79$export$9ea87e299ff6a368 = Symbol('selectedIndex');
const $8f5438719ac05b79$export$82c2e460fb230c2a = Symbol('self');
const $8f5438719ac05b79$export$91124bb58bc04465 = Symbol('parent');
const $8f5438719ac05b79$export$1e95b668f3b82d = Symbol('top');
const $8f5438719ac05b79$export$4bdc600e2ccf60d6 = Symbol('areas');
const $8f5438719ac05b79$export$1a01ae0705bafd37 = Symbol('defaultValue');
const $8f5438719ac05b79$export$3fc11fe47bfd2f32 = Symbol('elementIdMap');
const $8f5438719ac05b79$export$9c4ad76ccad91f4f = Symbol('clonable');
const $8f5438719ac05b79$export$e31e112bc058ddaa = Symbol('delegatesFocus');
const $8f5438719ac05b79$export$c1faf8344a396331 = Symbol('serializable');
const $8f5438719ac05b79$export$60a619da8e8331f = Symbol('slotAssignment');
const $8f5438719ac05b79$export$2221f266c58dd824 = Symbol('assignedNodes');
const $8f5438719ac05b79$export$5f6c46426d2443cb = Symbol('assignedToSlot');
const $8f5438719ac05b79$export$57ba6370ea0e47f8 = Symbol('cells');
const $8f5438719ac05b79$export$2dd197b55cf13440 = Symbol('rows');
const $8f5438719ac05b79$export$838e2a576d4d6ff6 = Symbol('headers');
const $8f5438719ac05b79$export$c63586cd99d53eee = Symbol('tBodies');
const $8f5438719ac05b79$export$6b2a7d5132615086 = Symbol('track');
const $8f5438719ac05b79$export$af7f203a9950b02 = Symbol('controlsList');
const $8f5438719ac05b79$export$6641d4e7d2375a56 = Symbol('mediaKeys');
const $8f5438719ac05b79$export$a98641f1e36ae240 = Symbol('remote');
const $8f5438719ac05b79$export$b86dea9785c8c56f = Symbol('sinkId');
const $8f5438719ac05b79$export$a66885030df323c9 = Symbol('srcObject');
const $8f5438719ac05b79$export$c49f4d1debcf7f5b = Symbol('cues');
const $8f5438719ac05b79$export$b64d6e1c1737858c = Symbol('activeCues');
const $8f5438719ac05b79$export$78062f36b16ed2f8 = Symbol('kind');
const $8f5438719ac05b79$export$1237798dc640739a = Symbol('label');
const $8f5438719ac05b79$export$789c912f57fe164c = Symbol('language');
const $8f5438719ac05b79$export$d560c7e4a29451c2 = Symbol('id');
const $8f5438719ac05b79$export$c164fb211d29dfae = Symbol('illegalConstructor');
const $8f5438719ac05b79$export$ca000e230c0caa3e = Symbol('state');
const $8f5438719ac05b79$export$67ea982130081db = Symbol('canvas');
const $8f5438719ac05b79$export$ace1eea069cbbfe3 = Symbol('popoverTargetElement');
const $8f5438719ac05b79$export$3bf036c976d2370d = Symbol('composed');
const $8f5438719ac05b79$export$a0e54c3daa7db493 = Symbol('bubbles');
const $8f5438719ac05b79$export$95ff25b64c2b7c9d = Symbol('cancelable');
const $8f5438719ac05b79$export$6add31d873bb7f97 = Symbol('defaultPrevented');
const $8f5438719ac05b79$export$adaf9bfc2029072d = Symbol('eventPhase');
const $8f5438719ac05b79$export$c0dbb1ea68a069d3 = Symbol('timeStamp');
const $8f5438719ac05b79$export$bf9fb029d174d554 = Symbol('type');
const $8f5438719ac05b79$export$13a2d28b88853ef2 = Symbol('detail');
const $8f5438719ac05b79$export$ded1884231baf037 = Symbol('globalObject');
const $8f5438719ac05b79$export$ee16d7cb334f2c25 = Symbol('destroyed');
const $8f5438719ac05b79$export$bd75b6d981b9c7f2 = Symbol('aborted');
const $8f5438719ac05b79$export$8e3f89d89ab2e81a = Symbol('browserFrames');
const $8f5438719ac05b79$export$f6a5d0560c16dc39 = Symbol('windowInternalId');
const $8f5438719ac05b79$export$fe2d92c6190fd201 = Symbol('getItemList');
const $8f5438719ac05b79$export$17b5f2f53bc91e64 = Symbol('requiredExtensions');
const $8f5438719ac05b79$export$3d9884d57c583c6e = Symbol('systemLanguage');
const $8f5438719ac05b79$export$51186ad6e864892a = Symbol('transform');
const $8f5438719ac05b79$export$85fd356182841bc1 = Symbol('baseVal');
const $8f5438719ac05b79$export$ac2228a3780c1373 = Symbol('animVal');
const $8f5438719ac05b79$export$2d949ea0af312bcc = Symbol('pathLength');
const $8f5438719ac05b79$export$28441ec3aecc1a1 = Symbol('unitType');
const $8f5438719ac05b79$export$a179c88182cb9d56 = Symbol('viewBox');
const $8f5438719ac05b79$export$29ed369710e4e3ee = Symbol('markerUnits');
const $8f5438719ac05b79$export$365fc137c57b820 = Symbol('markerWidth');
const $8f5438719ac05b79$export$791533ea8a6adb36 = Symbol('markerHeight');
const $8f5438719ac05b79$export$68c286be0e7e55b7 = Symbol('values');
const $8f5438719ac05b79$export$9026555e890bab7 = Symbol('orientType');
const $8f5438719ac05b79$export$40f91b5b71d00141 = Symbol('orientAngle');
const $8f5438719ac05b79$export$f8ea6418a93b1766 = Symbol('refX');
const $8f5438719ac05b79$export$bea20940f2ab408d = Symbol('refY');
const $8f5438719ac05b79$export$b2cbc93d4da94977 = Symbol('readOnly');
const $8f5438719ac05b79$export$2cdd29748c601977 = Symbol('preserveAspectRatio');
const $8f5438719ac05b79$export$3f9d9544b5392aef = Symbol('animatedPoints');
const $8f5438719ac05b79$export$9f048bf86ee2e9d2 = Symbol('points');
const $8f5438719ac05b79$export$723a0c7037372ed6 = Symbol('rx');
const $8f5438719ac05b79$export$ca60ec8735b3eb59 = Symbol('ry');
const $8f5438719ac05b79$export$a274e22fb40f762e = Symbol('cx');
const $8f5438719ac05b79$export$aea64bc1b6f8f415 = Symbol('cy');
const $8f5438719ac05b79$export$43caf9889c228507 = Symbol('r');
const $8f5438719ac05b79$export$3c2731656864509c = Symbol('clipPathUnits');
const $8f5438719ac05b79$export$d7d6c8e209c718dd = Symbol('maskUnits');
const $8f5438719ac05b79$export$d8ca4674d0cabe81 = Symbol('maskContentUnits');
const $8f5438719ac05b79$export$206a4a7add109812 = Symbol('filterUnits');
const $8f5438719ac05b79$export$6c52b8f37a440e30 = Symbol('primitiveUnits');
const $8f5438719ac05b79$export$8f51af5840e0602a = Symbol('href');
const $8f5438719ac05b79$export$cdb484d3c68e5374 = Symbol('x1');
const $8f5438719ac05b79$export$f07ceed34b807c99 = Symbol('y1');
const $8f5438719ac05b79$export$8b7d42aa892c205b = Symbol('x2');
const $8f5438719ac05b79$export$bfb0cc6882fbf1fb = Symbol('y2');
const $8f5438719ac05b79$export$ef9501593e13374e = Symbol('gradientUnits');
const $8f5438719ac05b79$export$6bab994d7a66bebb = Symbol('gradientTransform');
const $8f5438719ac05b79$export$8a144b41063b9858 = Symbol('spreadMethod');
const $8f5438719ac05b79$export$e1f2563e13b909a9 = Symbol('patternUnits');
const $8f5438719ac05b79$export$7885149275f532ef = Symbol('patternContentUnits');
const $8f5438719ac05b79$export$9f3724c8da55136f = Symbol('patternTransform');
const $8f5438719ac05b79$export$68ae324f2f6c6252 = Symbol('fx');
const $8f5438719ac05b79$export$c0dcd1f2238f086d = Symbol('fy');
const $8f5438719ac05b79$export$cc800923e997bb8 = Symbol('offset');
const $8f5438719ac05b79$export$683472f6198a076e = Symbol('disabled');
const $8f5438719ac05b79$export$6f846043e306f02c = Symbol('textLength');
const $8f5438719ac05b79$export$d434f16f6fa84c07 = Symbol('lengthAdjust');
const $8f5438719ac05b79$export$735ee1799fd02602 = Symbol('getAttribute');
const $8f5438719ac05b79$export$9fec4d97f1922e0b = Symbol('setAttribute');
const $8f5438719ac05b79$export$df995fae86a55f06 = Symbol('z');
const $8f5438719ac05b79$export$efccba1c4a2ef57b = Symbol('w');
const $8f5438719ac05b79$export$45b10814cc054894 = Symbol('toArray');
const $8f5438719ac05b79$export$3004f64547af360e = Symbol('fromString');
const $8f5438719ac05b79$export$571d59b505e6bb4e = Symbol('fromArray');
const $8f5438719ac05b79$export$944b09d2ad10b378 = Symbol('angle');
const $8f5438719ac05b79$export$79d7ef402ccfe467 = Symbol('m11');
const $8f5438719ac05b79$export$97f5dbf02e136635 = Symbol('m12');
const $8f5438719ac05b79$export$bde1af0fc10716f0 = Symbol('m13');
const $8f5438719ac05b79$export$cac488ca1cf886cd = Symbol('m14');
const $8f5438719ac05b79$export$274acebb869cd4a0 = Symbol('m21');
const $8f5438719ac05b79$export$7aa0e98362223cb5 = Symbol('m22');
const $8f5438719ac05b79$export$306fac0490f3149e = Symbol('m23');
const $8f5438719ac05b79$export$71ea0096e8c723ec = Symbol('m24');
const $8f5438719ac05b79$export$95ae793e7c4e6543 = Symbol('m31');
const $8f5438719ac05b79$export$63bfc780feafcbf1 = Symbol('m32');
const $8f5438719ac05b79$export$997eccfd0cbd0255 = Symbol('m33');
const $8f5438719ac05b79$export$21d7e274d018da99 = Symbol('m34');
const $8f5438719ac05b79$export$949afd8576dd20f0 = Symbol('m41');
const $8f5438719ac05b79$export$f7918218e24f0114 = Symbol('m42');
const $8f5438719ac05b79$export$7618c0e3d8a311d6 = Symbol('m43');
const $8f5438719ac05b79$export$374ec4744d81b586 = Symbol('m44');
const $8f5438719ac05b79$export$8d2d093544b9c1ff = Symbol('setMatrixValue');
const $8f5438719ac05b79$export$2aff0b95423b51ba = Symbol('translateSelf');
const $8f5438719ac05b79$export$a420c0f8a08efc03 = Symbol('rotateSelf');
const $8f5438719ac05b79$export$6c1b9f1a6a6bc3e0 = Symbol('rotateAxisAngleSelf');
const $8f5438719ac05b79$export$23ddae2b75165d5c = Symbol('scaleSelf');
const $8f5438719ac05b79$export$dca95805d9752040 = Symbol('scale3dSelf');
const $8f5438719ac05b79$export$d73a1f57ff6bc0c3 = Symbol('scaleNonUniformSelf');
const $8f5438719ac05b79$export$48cada4eca6d68ce = Symbol('skewXSelf');
const $8f5438719ac05b79$export$f2ccb77914d8bf17 = Symbol('skewYSelf');
const $8f5438719ac05b79$export$9f5218110e97916c = Symbol('multiplySelf');
const $8f5438719ac05b79$export$9bdad1ae37d738e0 = Symbol('matrix');
const $8f5438719ac05b79$export$c7aa713bdac78167 = Symbol('domMatrix');
const $8f5438719ac05b79$export$2ddd00e60c975f93 = Symbol('getDOMMatrix');
const $8f5438719ac05b79$export$1e7a0e137398bf39 = Symbol('setDOMMatrix');
const $8f5438719ac05b79$export$8efefd68bbabb683 = Symbol('attributeValue');
const $8f5438719ac05b79$export$3c7a5870e7f5ee75 = Symbol('startOffset');
const $8f5438719ac05b79$export$26f73335cc2e7868 = Symbol('method');
const $8f5438719ac05b79$export$5458b64234d1333c = Symbol('spacing');
const $8f5438719ac05b79$export$e2fd68fefd1f88cb = Symbol('in1');
const $8f5438719ac05b79$export$46594abed2c6588b = Symbol('in2');
const $8f5438719ac05b79$export$aaf36426b5008f7a = Symbol('result');
const $8f5438719ac05b79$export$b4c7a57a34b46a4a = Symbol('bias');
const $8f5438719ac05b79$export$5b5be35630ee4885 = Symbol('divisor');
const $8f5438719ac05b79$export$d2a1c7ef8ea4821e = Symbol('edgeMode');
const $8f5438719ac05b79$export$4c64642e02923fa5 = Symbol('kernelMatrix');
const $8f5438719ac05b79$export$78a2cfa446a06db9 = Symbol('kernelUnitLengthX');
const $8f5438719ac05b79$export$d5a510dc7c229103 = Symbol('kernelUnitLengthY');
const $8f5438719ac05b79$export$8fd0aac9d900da8d = Symbol('orderX');
const $8f5438719ac05b79$export$857f6d02ab3af3e8 = Symbol('orderY');
const $8f5438719ac05b79$export$3bc44247294bd916 = Symbol('preserveAlpha');
const $8f5438719ac05b79$export$fe3981a8eebcfaf5 = Symbol('targetX');
const $8f5438719ac05b79$export$f2185c905aa6640 = Symbol('targetY');
const $8f5438719ac05b79$export$d86b85890bac6db8 = Symbol('diffuseConstant');
const $8f5438719ac05b79$export$832a69a4bcf983c6 = Symbol('surfaceScale');
const $8f5438719ac05b79$export$dcdf75081b88279d = Symbol('scale');
const $8f5438719ac05b79$export$a3f0de261983cd60 = Symbol('xChannelSelector');
const $8f5438719ac05b79$export$de825f8e71fac764 = Symbol('yChannelSelector');
const $8f5438719ac05b79$export$c499e0030428ae85 = Symbol('azimuth');
const $8f5438719ac05b79$export$845e8aeb9a42ea24 = Symbol('elevation');
const $8f5438719ac05b79$export$dfa1698a1e9944f5 = Symbol('dx');
const $8f5438719ac05b79$export$df8cac1947751fe2 = Symbol('dy');
const $8f5438719ac05b79$export$de5ca30c0f202eba = Symbol('stdDeviationX');
const $8f5438719ac05b79$export$2d39ca4530a88381 = Symbol('stdDeviationY');
const $8f5438719ac05b79$export$7e802621e4669c62 = Symbol('tableValues');
const $8f5438719ac05b79$export$abff5e70462cbd6b = Symbol('slope');
const $8f5438719ac05b79$export$ab0f802c05dd969b = Symbol('intercept');
const $8f5438719ac05b79$export$f269d0dbcdcbb1a4 = Symbol('amplitude');
const $8f5438719ac05b79$export$abde88043842a778 = Symbol('exponent');
const $8f5438719ac05b79$export$c47cb7c63271266e = Symbol('crossOrigin');
const $8f5438719ac05b79$export$dbd72860f701d4f3 = Symbol('operator');
const $8f5438719ac05b79$export$72716fab198d26f9 = Symbol('radiusX');
const $8f5438719ac05b79$export$d46fdc86894b825c = Symbol('radiusY');
const $8f5438719ac05b79$export$db5a2af817670ee6 = Symbol('specularConstant');
const $8f5438719ac05b79$export$48ceb09a4bdd4d62 = Symbol('specularExponent');
const $8f5438719ac05b79$export$48d8e7684611f6da = Symbol('pointsAtX');
const $8f5438719ac05b79$export$c03ce0928973a32d = Symbol('pointsAtY');
const $8f5438719ac05b79$export$d9f9d56f85cfd076 = Symbol('pointsAtZ');
const $8f5438719ac05b79$export$144854373bfef05c = Symbol('limitingConeAngle');
const $8f5438719ac05b79$export$1b396282c0d11891 = Symbol('baseFrequencyX');
const $8f5438719ac05b79$export$807eb29e865552dc = Symbol('baseFrequencyY');
const $8f5438719ac05b79$export$20bddd3972aa12d2 = Symbol('numOctaves');
const $8f5438719ac05b79$export$7f7d45814fc23e4d = Symbol('seed');
const $8f5438719ac05b79$export$607bca416b189c36 = Symbol('stitchTiles');
const $8f5438719ac05b79$export$ce74d7c7d760417f = Symbol('rotateFromVectorSelf');
const $8f5438719ac05b79$export$30fbe03ab57ee506 = Symbol('flipXSelf');
const $8f5438719ac05b79$export$a1b6e55c1a799c7f = Symbol('flipYSelf');
const $8f5438719ac05b79$export$ab14314deeab381d = Symbol('invertSelf');
const $8f5438719ac05b79$export$f0d11c074a923179 = Symbol('getLength');
const $8f5438719ac05b79$export$7cac36689b656583 = Symbol('currentScale');
const $8f5438719ac05b79$export$bb628a54ab399bc9 = Symbol('rotate');
const $8f5438719ac05b79$export$15e9b7173302ae00 = Symbol('bindMethods');
const $8f5438719ac05b79$export$6065b270a53f18ff = Symbol('xmlProcessingInstruction');
const $8f5438719ac05b79$export$e8e78c978b129247 = Symbol('root');
const $8f5438719ac05b79$export$50060fa398ae0a6 = Symbol('filterNode');
const $8f5438719ac05b79$export$6262c3e04a0774fa = Symbol('customElementReactionStack');
const $8f5438719ac05b79$export$3cc811ff7873d170 = Symbol('dispatching');
const $8f5438719ac05b79$export$cc2c248003684daa = Symbol('modules');
const $8f5438719ac05b79$export$fd2739e17e482e5d = Symbol('preloads');
const $8f5438719ac05b79$export$32180ef41b15b513 = Symbol('body');
const $8f5438719ac05b79$export$89e12c5b50f7529d = Symbol('redirect');
const $8f5438719ac05b79$export$8b29ef2611187a5f = Symbol('referrerPolicy');
const $8f5438719ac05b79$export$e2ef10f86a8d60e8 = Symbol('signal');
const $8f5438719ac05b79$export$990c50f893ee81a0 = Symbol('bodyUsed');
const $8f5438719ac05b79$export$78896651422bbf9e = Symbol('credentials');
const $8f5438719ac05b79$export$656bac03c1547317 = Symbol('blocking');
const $8f5438719ac05b79$export$f3e7c58193966145 = Symbol('moduleImportMap');
const $8f5438719ac05b79$export$cf7b7bc75a9281a8 = Symbol('dispatchError');
const $8f5438719ac05b79$export$cde6a56f9669daf6 = Symbol('supports');
const $8f5438719ac05b79$export$e5560ffd7150410d = Symbol('reason');
const $8f5438719ac05b79$export$16d9772d7787f85 = Symbol('propertyEventListeners');
const $8f5438719ac05b79$export$ff225bc3fa466c48 = Symbol('cssRules');
const $8f5438719ac05b79$export$b722d3af22bfa730 = Symbol('parentRule');
const $8f5438719ac05b79$export$dfea80c48c12841 = Symbol('parentStyleSheet');
const $8f5438719ac05b79$export$7e124d7fd0a718c0 = Symbol('conditionText');
const $8f5438719ac05b79$export$584a5bf9373e3852 = Symbol('keyText');
const $8f5438719ac05b79$export$987d49ffe1b0900f = Symbol('media');
const $8f5438719ac05b79$export$1e5b4ce2fa884e6a = Symbol('styleMap');
const $8f5438719ac05b79$export$87f583ebf1847e9c = Symbol('selectorText');
const $8f5438719ac05b79$export$8f7584c51b5fc4ff = Symbol('cssParser');
const $8f5438719ac05b79$export$7bffc948341a2c5c = Symbol('cssRule');
const $8f5438719ac05b79$export$9b567b5c08a764f9 = Symbol('rulePrefix');
const $8f5438719ac05b79$export$c07a6c2bca9253b4 = Symbol('virtualServerFile');
const $8f5438719ac05b79$export$3ce3cb072716a2c7 = Symbol('frames');
const $8f5438719ac05b79$export$d48af2287e1c82ec = Symbol('disableEvaluation');
const $8f5438719ac05b79$export$5f73145c2c4db2a7 = Symbol('validateJavaScriptExecutionEnvironment');


// Expose only what Alpine templates need in global scope
window.createContractorCard = (0, $bd083a63eb37c143$export$5464865996ba2eb4);
window.getPathRequiredSkills = (0, $cc90b7944b7e868a$export$1311cf265aa89b71);
window.getTeamSkillLevels = (0, $cc90b7944b7e868a$export$bf19dc1273cbd1a1);
window.contractorManager = (0, $803c9a726c40de05$export$ecfe6fdf513f3742);
window.inventoryManager = (0, $607ffae1bbc96660$export$277774029cdaf1);
window.gameState = (0, $f27982cef7035d22$export$8e361a1ffbebf172);
window.config = $ce6dd72bc4611534$exports;
// Dev-only QA helpers (localhost): load a maintained save fixture to exercise
// features (e.g. the whole Command layer) without grinding a save, then put the
// real save back. The catalogue, the loader and the button strip all live in
// devFixtures.js; these globals are the console entry points the qa-player
// skill drives.
if ((0, $dcf0234742c4b19b$export$6dd1bbd39f571125)()) {
    window.loadFixture = (0, $240af90fbaec7c06$export$fad9145e0ce507a0);
    window.restoreSave = (0, $240af90fbaec7c06$export$4fd8d4441084914c);
    (0, $240af90fbaec7c06$export$17bd57c6fd7474d9)();
}
window.Alpine = (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039);
window.craftItem = (0, $52d4eb0e19aef542$export$67f8f6c6271cd4a2);
window.unlockArtifact = (0, $52d4eb0e19aef542$export$506c247f43a19ac3);
window.showCraftingModal = (0, $52d4eb0e19aef542$export$aa7c3ee86bbf0990);
window.showCraftingTreeModal = (0, $52d4eb0e19aef542$export$301cbaf87c15a68f);
window.clearCraftingTreeFilter = (0, $52d4eb0e19aef542$export$e186070c9358ae3a);
window.openContractorModal = (0, $bd083a63eb37c143$export$9a18f3125e8e0eca);
window.reserveContractorFromModal = (0, $bd083a63eb37c143$export$959fb65d2b5e760e);
window.generateTestInventory = (0, $b7695fceb608271e$export$8606b9937b72ca5d);
window.createInventoryCard = (0, $b7695fceb608271e$export$4ac7f915da1fa1c4);
window.clearInventory = (0, $b7695fceb608271e$export$56dcd79bae47b9c1);
window.upgradeSkill = (0, $7df15cefc09eac1b$export$dfab59a277375299);
window.unlockSkillSynergy = (0, $7df15cefc09eac1b$export$8d1a7714ddcaaa75);
window.releaseReservedContractor = (0, $a52c72724dfd3eca$export$e4c69cea9b646118);
window.equipArtifact = (0, $7df15cefc09eac1b$export$1f3b8068ff1292ef);
window.unequipArtifact = (0, $7df15cefc09eac1b$export$fd37f844ae84e59c);
window.showTechniqueGearSelector = (0, $7df15cefc09eac1b$export$4e0f5000083da307);
window.equipTechniqueGear = (0, $7df15cefc09eac1b$export$958ab300c288e475);
window.unequipTechniqueGear = (0, $7df15cefc09eac1b$export$954d5d768998dfd1);
window.closeTechniqueGearSelector = (0, $7df15cefc09eac1b$export$a9326cac8ab4c94a);
window.equipTechniqueGear = (0, $7df15cefc09eac1b$export$958ab300c288e475);
window.unequipTechniqueGear = (0, $7df15cefc09eac1b$export$954d5d768998dfd1);
window.sellItem = (0, $b7695fceb608271e$export$e1c01f683feb5181);
window.purchaseConsumable = (0, $b7695fceb608271e$export$dba564f0cb325527);
window.useConsumable = (0, $b7695fceb608271e$export$dbdf3132d4782af0);
window.openPurchaseModal = (0, $b7695fceb608271e$export$432db33666131f90);
window.closePurchaseModal = (0, $b7695fceb608271e$export$1ed9acaf4451ebfa);
window.toggleEnergyPopup = (0, $b7695fceb608271e$export$4c1b7a82836a6e5c);
window.buyEnergyDirect = (0, $b7695fceb608271e$export$d4a1bdd7cb9254a9);
window.refreshAlpineContractors = (0, $803c9a726c40de05$export$17502054442d56b0);
window.setupPurchaseModalHandler = (0, $b7695fceb608271e$export$fe032c86fe8adff);
window.calculateBulkCraftingCost = (0, $52d4eb0e19aef542$export$5c9f0b8d2a488474);
window.getBulkCraftingCostPercent = (0, $52d4eb0e19aef542$export$3bec963ccca7a0ba);
window.incrementCraftQty = (0, $b7695fceb608271e$export$ad1aa4315d00018a);
window.decrementCraftQty = (0, $b7695fceb608271e$export$7b962277503582ab);
window.updateCraftCost = (0, $b7695fceb608271e$export$8ef1bcc7d93420a1);
window.getMaxCraftableQty = (0, $b7695fceb608271e$export$8e8909cfaf15b391);
window.incrementSellQty = (0, $b7695fceb608271e$export$ff0507185d233e75);
window.decrementSellQty = (0, $b7695fceb608271e$export$a4d3bbe47949d494);
window.updateSellQty = (0, $b7695fceb608271e$export$4b495d34a3840d43);
// Reinitialize Tippy tooltips for dynamically created inventory cards
window.reinitializeInventoryTooltips = function() {
    if (window.tippy) {
        // Idempotent: tear down any existing instances first so callers across
        // render paths (inventory, crafting modal, gear tab) never stack duplicates
        document.querySelectorAll(".inventory-tooltip").forEach((el)=>el._tippy?.destroy());
        tippy(".inventory-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                300,
                0
            ],
            maxWidth: 300,
            allowHTML: true,
            content (reference) {
                const descDiv = reference.querySelector(".inventory-tooltip-content");
                return descDiv ? descDiv.innerHTML : "";
            },
            onMount (instance) {
                instance.popper.style.border = "2px solid white";
                instance.popper.style.borderRadius = "0.5rem";
            },
            onShow (instance) {
                // Create a named function so it can be accurately removed later
                instance._scrollHandler = ()=>instance.hide();
                window.addEventListener('scroll', instance._scrollHandler, {
                    passive: true
                });
            },
            onHide (instance) {
                // Clean up the listener to prevent memory leaks
                window.removeEventListener('scroll', instance._scrollHandler);
            }
        });
    }
};
// Current contractor-list poll delay (see pollContractorList). Module scope so
// the tab-switch handler can reset the backoff when the section is reopened.
let $f69ab99adc4bc920$var$contractorPollDelay = (0, $e7dde87afbac6dd8$export$fa0ee1eb937a38e6);
/**
 * Boot-blocking error banner. Config problems mean the generated constants are
 * stale/partial, so the page must not come up half-working — a console-only
 * error would look like a blank screen with no cause.
 */ function $f69ab99adc4bc920$var$showBootFailure(err) {
    const banner = document.createElement("pre");
    banner.style.cssText = "position:fixed;inset:0;z-index:9999;margin:0;padding:2rem;overflow:auto;background:#1a0d0d;color:#ffb4b4;font:13px/1.5 ui-monospace,monospace;white-space:pre-wrap;";
    banner.textContent = `Idle Extraction failed to start.\n\n${err.message}`;
    document.body.appendChild(banner);
}
// Initialize game
(0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "adding dom event listener");
document.addEventListener("DOMContentLoaded", ()=>{
    // Fail fast on a stale or partial js/constants.js BEFORE anything reads a
    // balance value. Balance reads are direct (no inline fallbacks), so a missing
    // config must stop boot loudly rather than silently run a different game.
    try {
        (0, $ab3705241c399f11$export$82367cdd05923d12)($ce6dd72bc4611534$exports);
    } catch (err) {
        console.error(err);
        $f69ab99adc4bc920$var$showBootFailure(err);
        return;
    }
    // Hydrate procedural avatars as they enter the DOM (covers every render path,
    // including Alpine/raid.js reactive re-renders). Install before any UI renders.
    (0, $1c3a690255c51224$export$f32bf1f4ac79976)();
    // Try to load saved game first
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "doc loaded:", document);
    const loaded = (0, $41a2a1ff52c357a7$export$756e5d66bdd28395)();
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "loaded data: ", loaded);
    if (!loaded) return;
    // Operations that arrived while away, capped at one round per slot so a week
    // off pays the same as a night off. Called from here rather than inside
    // loadGameState: gameState.js importing operations.js would close a cycle
    // (operations -> gameState -> operations), which breaks boot silently.
    (0, $52f5c9f49814d28d$export$f9a694398861c909)();
    // Initialize per-item drop rate multipliers from itemRarities config
    const itemDropRates = {};
    Object.values($ce6dd72bc4611534$exports.itemRarities).forEach((rarity)=>{
        if (rarity.dropChance?.perItem) Object.assign(itemDropRates, rarity.dropChance.perItem);
    });
    if (Object.keys(itemDropRates).length > 0) (0, $00c60928d2fcd8b8$export$16a0347071379537)(itemDropRates);
    // Apply credit and crafting cost scaling from progressionScaling (single source of truth,
    // shared with the headless simulator). Unguarded: assertConfigLoaded above
    // already proved these exist, so a guard here could only hide a real problem.
    (0, $00c60928d2fcd8b8$export$b1b6e81d46587814)($ce6dd72bc4611534$exports.progressionScaling.creditsScaling);
    (0, $00c60928d2fcd8b8$export$b2554e3c8ffeec59)($ce6dd72bc4611534$exports.progressionScaling.craftingCostScaling);
    (0, $00c60928d2fcd8b8$export$12f04c67a6a6e4dd)($ce6dd72bc4611534$exports.progressionScaling.energyPurchaseScaling);
    // Re-apply the per-tour crafting discount AFTER the config seed above, which
    // would otherwise wipe it. This is the reload path that used to lose it.
    (0, $bde36de43872f734$export$6d153901dd951884)();
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId) {
        // Load their inventory (already done above in inventory loading section)
        // Update UI components
        document.getElementById("character-creator").classList.add("hidden");
        document.getElementById("character-display").classList.remove("hidden");
        (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
        // Update character selector to show correct active character
        if (typeof (0, $7df15cefc09eac1b$export$d87722dc17dc5f68) === "function") (0, $7df15cefc09eac1b$export$d87722dc17dc5f68)();
        // Update inventory header
        if (typeof (0, $b7695fceb608271e$export$d2567add70135c10) === "function") (0, $b7695fceb608271e$export$d2567add70135c10)();
    }
    // Resume raid if it was in progress (only if not completed)
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        // Show team
        document.getElementById("raid-team").classList.remove("hidden");
        // Restore log entries
        (0, $a52c72724dfd3eca$export$8f8ffb9ff36daf30)();
        (0, $a52c72724dfd3eca$export$17436b2a8cf51f27)();
        (0, $a52c72724dfd3eca$export$46938b5e497922ff)();
    }
    // No need to sync contractor.reserved flags - we use only reservedContractors list
    // Update team display immediately after contractor sync to ensure reserved contractors show
    if (document.getElementById("grid-team-display")) {
        (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
        (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
    }
    // Build the layer toolbar before the first visibility pass, so the screen
    // tabs it operates on exist.
    (0, $a1ffcc09d1c6aa84$export$544b0f50b5799474)();
    (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
    (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
    // Update tab visibility again after character restoration to account for raid ownership
    setTimeout(()=>{
        (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
        (0, $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b)();
    }, 100);
    // Clean up multiplayer storage after game state is loaded
    (0, $f5272a3e1bbf7d7b$export$347a45e01153443c)();
    // Refresh Alpine stores after loading game state
    (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
    (0, $803c9a726c40de05$export$17502054442d56b0)();
    // Restore raid grid UI if it exists
    if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && document.getElementById("raid-grid-section")) {
        document.getElementById("raid-grid-section").classList.remove("hidden");
        document.getElementById("raid-team").classList.remove("hidden");
        document.getElementById("raid-setup").classList.add("hidden");
        document.getElementById("raid-active").classList.remove("hidden");
        // Update raid active info
        (0, $a52c72724dfd3eca$export$d6f634bba1273a2b)();
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Restoring raid grid display");
        (0, $a52c72724dfd3eca$export$cf8b2a65252147ea)();
        (0, $a52c72724dfd3eca$export$c9b7157fc13410c5)(); // Restore grid header with area info and room count
        // Restore the planning-only item-drop highlight picker (it is populated in
        // the generate-grid handler, which a reload doesn't run). Only in the
        // planning phase — hidden once a raid is in progress or completed.
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted) (0, $a52c72724dfd3eca$export$d72ea71bfd67dd40)();
        // Check if we need to restore completed raid visualization
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo) {
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Restoring completed raid visualization in DOMContentLoaded");
            // Apply completed raid state directly after displayRaidGrid
            (0, $a52c72724dfd3eca$export$20c4edcabec24020)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo);
            // Restore log entries
            if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries && (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries.length > 0) {
                const logEntries = document.getElementById("log-entries");
                if (logEntries) {
                    logEntries.innerHTML = "";
                    (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries.forEach((logEntry)=>{
                        const entry = document.createElement("div");
                        entry.className = `log-entry log-${logEntry.type}`;
                        entry.textContent = logEntry.message;
                        logEntries.appendChild(entry);
                    });
                    logEntries.scrollTop = logEntries.scrollHeight;
                }
            }
        } else {
            // Only call these for non-completed raids
            (0, $a52c72724dfd3eca$export$ed4907da7d4af889)();
            (0, $a52c72724dfd3eca$export$c3f865504cdad6c4)();
        }
        (0, $a52c72724dfd3eca$export$f4fa7fe8ae486c6)();
        (0, $a52c72724dfd3eca$export$d6f634bba1273a2b)();
        (0, $a52c72724dfd3eca$export$25fc6ae0ff69cc)();
    }
    // Monotonic id so a fade-out that is still running can tell it has been
    // superseded by a newer navigation. See activateOnly below.
    let tabTransitionId = 0;
    // Tab switching with animations.
    //
    // DELEGATED rather than bound per button: screen tabs and the active-task
    // button are re-rendered from the layer registry, so listeners attached at
    // boot would be discarded on the first layer switch.
    document.addEventListener("click", (event)=>{
        const btn = event.target.closest?.(".tab-btn");
        if (!btn) return;
        {
            const tabName = btn.getAttribute("data-tab");
            if (tabName == null || tabName == "") return;
            const newTab = document.getElementById(`${tabName}-tab`);
            // One screen can host more than one VIEW. Operations is both a planner
            // and a transit board, and switching between them is a real navigation
            // even though the tab does not change — so this runs BEFORE the
            // already-here guard below, which would otherwise swallow it.
            if (tabName === "operations") // `data-mode` is set only by the toolbar's "New Operation" button; the
            // screen tab carries none, so the default is the transit board.
            (0, $52f5c9f49814d28d$export$a4a190e64d36c7a)(btn.dataset.mode === "plan" ? "plan" : "transit");
            // Don't switch if we are already on (or heading to) this screen.
            //
            // Compares tracked intent rather than the button's `active` class: the
            // class is painted from a re-render that can happen mid fade-out, so a
            // stale one used to make this swallow a legitimate navigation.
            if (tabName === (0, $a1ffcc09d1c6aa84$export$517113b01f92f5fe)()) return;
            // Check raid access for raid tab
            if (tabName === "raid" && !(0, $f27982cef7035d22$export$77866226ea57ca79)()) {
                const raidOwner = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId);
                const ownerName = raidOwner ? raidOwner.name : "another character";
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`Cannot access raid tab - ${ownerName} has an active raid`, "error");
                return;
            }
            if (tabName === "contractors") {
                // Refresh contractor list when opening contractors tab
                if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("contractors")) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("contractors").refresh();
                // Reopening is fresh interest — restart the poll backoff so the next few
                // updates are prompt rather than inheriting a settled 5-minute cadence.
                $f69ab99adc4bc920$var$contractorPollDelay = (0, $e7dde87afbac6dd8$export$fa0ee1eb937a38e6);
            }
            if (tabName === "character") {
                // Inventory and Gear are now sub-tabs of the character page; refresh
                // the active sub-pane so its content is current on return
                window.applyCharSubTab?.();
                // Re-render the card so its state (e.g. edit buttons locked during a
                // raid) is current on every return, not just after an edit/level-up.
                if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
                else (0, $7df15cefc09eac1b$export$d87722dc17dc5f68)?.();
                // With no character this screen IS the creator, whichever route got
                // here. Asserting it on arrival rather than trusting whoever emptied the
                // roster to have set it: promotion and founding both call
                // showCharacterScreenAfterPromotion(), but the layer switcher and the
                // switcher panel are two more ways in, and a blank Field screen is the
                // failure they produced.
                if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
                    document.getElementById("character-creator")?.classList.remove("hidden");
                    document.getElementById("character-display")?.classList.add("hidden");
                }
            }
            if (tabName === "command") // Re-render so marks, upgrade affordability, and gallery are current
            (0, $9a58895c0c0daffa$export$cf457306c8f8ec80)();
            if (tabName === "archive") // Keys arrive while the player is on the raid screen, so the Archive is
            // never current on arrival.
            (0, $8377d004ff5d42b5$export$5dc9bc24597948d9)();
            if (tabName === "command-vault" || tabName === "syndicate-stores") // The vaults change on promotion, founding and every convoy launch —
            // none of which is a thing the player does from these screens, so the
            // store has to be re-read on arrival rather than trusted to be current.
            (0, $607ffae1bbc96660$export$5b73e6a29e58b929)();
            if (tabName === "syndicate") // Same reason: Writs, charter affordability, and founding eligibility
            // all move while the player is elsewhere.
            (0, $9266f6113786f65f$export$8cd027517c8fb270)();
            // Find currently active tab content
            const currentActiveTab = document.querySelector(".tab-content.active");
            // Every activation goes through here, and it leaves EXACTLY ONE screen
            // active. That is not defensive tidying — it is the fix for a real stuck
            // state: switching layer and then immediately pressing the layer's task
            // button (New Operation) queued two fade-outs on the same outgoing tab,
            // because querySelector(".tab-content.active") still returned it the
            // second time. Both animationend handlers then fired and each activated
            // ITS OWN target, leaving two screens stacked and the page scrolling
            // twice its height until something re-clicked the tab.
            const activateOnly = (tab)=>{
                document.querySelectorAll(".tab-content.active").forEach((t)=>{
                    if (t !== tab) t.classList.remove("active", "animate__animated", "animate__fadeOut");
                });
                tab.classList.add("active", "animate__animated", "animate__fadeIn");
                tab.addEventListener("animationend", function handleFadeIn() {
                    tab.classList.remove("animate__animated", "animate__fadeIn");
                    tab.removeEventListener("animationend", handleFadeIn);
                });
            };
            // A superseded transition must not finish: without the token, the older
            // handler still activates the screen the player already navigated away
            // from.
            const transition = ++tabTransitionId;
            // Animate out current tab
            if (currentActiveTab && currentActiveTab !== newTab) {
                currentActiveTab.classList.add("animate__animated", "animate__fadeOut");
                currentActiveTab.addEventListener("animationend", function handleFadeOut() {
                    currentActiveTab.removeEventListener("animationend", handleFadeOut);
                    currentActiveTab.classList.remove("active", "animate__animated", "animate__fadeOut");
                    if (transition !== tabTransitionId) return; // a newer click won
                    activateOnly(newTab);
                });
            } else // No current tab, just show new one with animation
            activateOnly(newTab);
            // Active styling is no longer inferred by matching Tailwind border
            // classes (which encoded each layer's accent as a magic string and had to
            // be edited per layer). renderLayerToolbar() re-renders the screen tabs
            // and colours the active one from the registry's `accent`.
            // Special handling for specific tabs
            if (tabName === "raid") {
                // Re-render region tiles: availability is per-character (Command
                // region locks), so tiles rendered at boot go stale after character
                // creation/switch/promotion or a Regional Charter purchase
                if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress) (0, $f3f2c7a1b1934e01$export$98a6c6e9bfe86f10)();
                setTimeout((0, $a52c72724dfd3eca$export$d86087c4a9b82d46), 250); // Delay for animation
                setTimeout((0, $f3f2c7a1b1934e01$export$6a940d9b4a9b252a), 250);
                (0, $a52c72724dfd3eca$export$a21eeedead301a30)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress ? 'log' : 'highlights');
            } else if (tabName === "character") setTimeout(()=>{}, 150); // Delay for animation to complete
            // Remember where each layer was left, so switching back returns there.
            (0, $a1ffcc09d1c6aa84$export$581d35409857f84f)(tabName);
            // Reflect the new active screen in the toolbar (accent + active state).
            (0, $a1ffcc09d1c6aa84$export$5672aa0b2d188c2b)();
        }
    });
    // Update faction availability when page loads
    (0, $f3f2c7a1b1934e01$export$ac9b2c0e374abc75)();
    // Command layer: reveal state + marks chip on boot
    (0, $9a58895c0c0daffa$export$ca081aebb329a098)();
    // Setup character management events
    (0, $7df15cefc09eac1b$export$b87cdb7b62197ecc)();
    // Update inventory character header
    (0, $b7695fceb608271e$export$d2567add70135c10)();
    // Faction selection
    document.querySelectorAll(".faction-card").forEach((card)=>{
        card.addEventListener("click", ()=>{
            const faction = card.dataset.faction;
            // Check if faction is disabled
            if (card.classList.contains("faction-disabled")) {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)("You already have a character of this faction", "error");
                return;
            }
            // Update selection with Tailwind classes
            document.querySelectorAll(".faction-card").forEach((c)=>{
                c.classList.remove("selected", "text-gray-200", "animate-pulse");
                c.classList.add("text-gray-400");
            });
            card.classList.add("selected", "text-gray-200", "animate-pulse");
            card.classList.remove("text-gray-400");
            (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction = faction;
            // Update header background based on selected faction
            (0, $f3f2c7a1b1934e01$export$ffc032d1101a5382)(faction);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Faction selected:", faction);
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
            (0, $7df15cefc09eac1b$export$44472cbca86113a6)();
        });
    });
    // Character name validation
    const nameInput = document.getElementById("character-name-create");
    const validationMessage = document.getElementById("name-validation-message");
    const debouncedValidate = (0, $42b272c2c0f44bdf$export$61fc7d43ac8f84b0)(async ()=>{
        const name = nameInput.value.trim();
        if (name) {
            validationMessage.className = "text-sm mt-1 text-gray-400";
            validationMessage.textContent = "Checking name availability...";
        }
        const result = await (0, $f5272a3e1bbf7d7b$export$6ebef846cc736ea)(name);
        validationMessage.className = `text-sm mt-1 ${result.className}`;
        validationMessage.textContent = result.message;
        (0, $7df15cefc09eac1b$export$44472cbca86113a6)();
    }, 500);
    nameInput.addEventListener("input", debouncedValidate);
    // Attach all event listeners
    document.getElementById("create-character").addEventListener("click", async ()=>{
        const characterName = nameInput.value.trim();
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction || !characterName || characterName.length < 2) {
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u274C Please enter a valid name and select a faction", "error");
            return;
        }
        // Double-check name uniqueness before creating
        try {
            const isUnique = await (0, $f5272a3e1bbf7d7b$export$6ec81efa6b4944af)(characterName);
            if (!isUnique) {
                (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u274C Character name already exists", "error");
                return;
            }
        } catch (error) {
            console.warn("Could not verify name uniqueness:", error);
        }
        // All faction skills at level 0. createNewCharacter applies the same rule,
        // so this is really just the shape the registration payload is sent in.
        const characterFactionSkills = (0, $f27982cef7035d22$export$f70dbb2553d659e4)((0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction);
        // Create character with all faction skills at level 0
        const characterData = {
            id: "player",
            name: characterName,
            faction: (0, $f27982cef7035d22$export$8e361a1ffbebf172).selectedFaction,
            skills: characterFactionSkills,
            maxHp: 100,
            currentHp: 100,
            injuries: [],
            level: 1,
            xp: 0,
            avatar: (0, $42b272c2c0f44bdf$export$913078032f14f7f)()
        };
        let newCharacter = {};
        try {
            // Register character in multiplayer system
            const registeredCharacter = await (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).registerCharacter(characterData);
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Registered character:", registeredCharacter);
            // Create new character using multi-character system
            newCharacter = (0, $7df15cefc09eac1b$export$c05f4d64df5567a5)({
                ...characterData,
                multiplayerId: registeredCharacter.id || registeredCharacter.character?.id || null,
                ownerToken: registeredCharacter.ownerToken || null
            });
        } catch (error) {
            // Not gated: the user is told multiplayer degraded, so the cause should
            // always be visible in the console.
            console.warn("Failed to register character:", error);
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\u26A0\uFE0F Character created locally. Multiplayer features may be limited.", "warning");
            // Create new character using multi-character system (fallback)
            newCharacter = (0, $7df15cefc09eac1b$export$c05f4d64df5567a5)({
                ...characterData
            });
        }
        // Update gameState.character.skills to match character skills
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).character.skills = {
            ...characterFactionSkills
        };
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Character created:", newCharacter);
        (0, $0c8e0782d8c2833e$export$c7def531c087da85)(`\u{2705} Character "${characterName}" created and registered!`, "success");
        (0, $bd083a63eb37c143$export$aca974319671fb3e)();
        // Hide creator, show character display
        document.getElementById("character-creator").classList.add("hidden");
        document.getElementById("character-display").classList.remove("hidden");
        // Show character info
        (0, $7df15cefc09eac1b$export$2eced2100c12c50d)();
        (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    });
    // Initialize default tier if not set
    if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier) (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier = 1;
    // Generate UI components on load
    (0, $f3f2c7a1b1934e01$export$5d55f9eae051c4dc)();
    (0, $f3f2c7a1b1934e01$export$98a6c6e9bfe86f10)();
    // Generate grid.
    //
    // A named function, not just a click handler, because Auto-Raid Protocol needs
    // the same work done. Clicking the button from automation looked equivalent
    // and is not: `#generate-grid` is DISABLED until the player has driven the
    // raid-setup UI, and a click on a disabled button silently does nothing — so
    // automation would sit there reporting "running" while achieving nothing.
    // Automation drives state, never widgets.
    const setupRaidGrid = ()=>{
        if (!(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier || !(0, $f27982cef7035d22$export$8e361a1ffbebf172).character) return false;
        // Set raid ownership to current character when they start planning a raid
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId = (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId;
        // Update tab visibility now that raid is owned by current character
        (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
        // Clear any existing grid data to ensure fresh generation
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
        // Generate completely new grid with region and tier
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = (0, $cc90b7944b7e868a$export$2ebdd7a7b7382080)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion, (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedTier);
        // WHERE on the planet this raid is (M3 S9). Rolled once, here, and saved
        // with the raid: a region spans four to six hours of longitude, so two
        // raids in the same region land at different times of day — but re-rolling
        // on read would make the sky flicker between paints and shift across a
        // reload. Only the world clock reads it today; it is a location, so
        // anything later that cares where a raid is can read it too.
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidSite = (0, $c454fb723f814d89$export$73436c04d978a296)((0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedRegion);
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Generated raid grid:", (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        // Auto-select start position
        const startPos = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.startPos;
        const startRoom = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.grid[startPos.row][startPos.col];
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = [
            {
                row: startPos.row,
                col: startPos.col,
                room: startRoom
            }
        ];
        (0, $a52c72724dfd3eca$export$cf8b2a65252147ea)();
        (0, $a52c72724dfd3eca$export$c9b7157fc13410c5)(); // Initialize grid header with area info and room count
        (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
        (0, $a52c72724dfd3eca$export$68c4600b33dd0ca8)();
        (0, $a52c72724dfd3eca$export$ed4907da7d4af889)();
        (0, $a52c72724dfd3eca$export$c3f865504cdad6c4)(); // Show initial valid moves
        // Populate the item-drop highlight picker for the freshly generated grid
        (0, $a52c72724dfd3eca$export$6c9e89b1ffed34d7)();
        (0, $a52c72724dfd3eca$export$d72ea71bfd67dd40)();
        (0, $a52c72724dfd3eca$export$a21eeedead301a30)('highlights');
        // Show raid grid section and team section
        document.getElementById("raid-grid-section").classList.remove("hidden");
        document.getElementById("raid-team").classList.remove("hidden");
        // Hide region selection and show raid active state
        document.getElementById("raid-setup").classList.add("hidden");
        document.getElementById("raid-active").classList.remove("hidden");
        // Update current raid info
        (0, $a52c72724dfd3eca$export$f4fa7fe8ae486c6)();
        (0, $a52c72724dfd3eca$export$d6f634bba1273a2b)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        return true;
    };
    document.getElementById("generate-grid").addEventListener("click", setupRaidGrid);
    // Cancel raid button
    // Tear down the current raid. Split out of the click handler so the confirm
    // modal below drives it.
    const performRaidCancel = ()=>{
        // Release any server-side contractor reservations/hires this raid holds
        // before we drop them locally — cancelling abandons the raid without ever
        // reaching finishRaidCore, which is what normally releases them. Best-effort
        // (fire-and-forget); the server's stale-hire sweep is the backstop. Only
        // player contractors (multiplayerId) have server state; AI ones are skipped.
        const cancelActor = (0, $f27982cef7035d22$export$8e361a1ffbebf172).characters?.find((c)=>c.id === (0, $f27982cef7035d22$export$8e361a1ffbebf172).activeCharacterId);
        if (cancelActor?.multiplayerId && typeof (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70) !== "undefined") {
            for (const contractor of (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors || [])if (contractor?.multiplayerId) (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseHiredContractor(contractor.multiplayerId, cancelActor.multiplayerId).catch((err)=>console.error("Failed to release hired contractor on cancel:", err));
            for (const contractor of (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors || [])if (contractor?.multiplayerId) (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).releaseContractor(contractor.multiplayerId, cancelActor.multiplayerId).catch((err)=>console.error("Failed to release reserved contractor on cancel:", err));
        }
        // Hide raid grid section
        document.getElementById("raid-grid-section").classList.add("hidden");
        document.getElementById("raid-team").classList.add("hidden");
        // Clear the planning-only item highlight + picker
        (0, $a52c72724dfd3eca$export$6c9e89b1ffed34d7)();
        // Show region selection and hide raid active state
        document.getElementById("raid-setup").classList.remove("hidden");
        document.getElementById("raid-active").classList.add("hidden");
        // Clear raid state - but keep selectedRegion/selectedTier so the setup
        // screen comes back pre-selected with the previous choices
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress = null;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidCompleted = false;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = null;
        // Update tab visibility now that raid is cleared
        (0, $f3f2c7a1b1934e01$export$2ae62d947e9e1d03)();
        // Release reserved contractors
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
        (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
        // The tile/segment .selected classes are untouched (setup was only
        // hidden); refresh the info panel + Generate button from the kept state
        (0, $f3f2c7a1b1934e01$export$6a940d9b4a9b252a)();
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        (0, $a52c72724dfd3eca$export$96635d91a6ab659a)();
        (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
    };
    document.getElementById("cancel-raid").addEventListener("click", ()=>{
        // Cancelling discards the run, so confirm first. Mid-raid the stakes are
        // real — energy was spent at raid start and isn't refunded, and progress and
        // gathered loot are lost — so that variant warns harder than clearing a
        // setup that hasn't cost anything yet.
        const raid = (0, $f27982cef7035d22$export$8e361a1ffbebf172).currentRaid.raidInProgress;
        const roomsCompleted = raid?.roomsCompleted || 0;
        const clearedNote = roomsCompleted > 0 ? ` (${roomsCompleted} room${roomsCompleted === 1 ? "" : "s"} cleared)` : "";
        const bodyHtml = raid ? `<p class="mb-2">Abandon the raid in progress?</p>
         <p class="text-yellow-400">Your progress${clearedNote} and everything gathered so far are lost, and the energy already spent is not refunded.</p>` : `<p class="mb-2">Clear this raid setup?</p>
         <p class="text-xs text-gray-400">The generated map, chosen path and team are discarded. No energy has been spent yet, and your region and tier stay selected.</p>`;
        (0, $7df15cefc09eac1b$export$655e187f5421a72c)({
            title: raid ? "\u26A0\uFE0F Abandon Raid?" : "\uD83D\uDDFA\uFE0F Clear Raid Setup?",
            bodyHtml: bodyHtml,
            confirmText: raid ? "Abandon Raid" : "Clear Setup",
            cancelText: raid ? "Keep Raiding" : "Go Back",
            confirmClass: raid ? "bg-red-600 hover:bg-red-700" : "bg-yellow-600 hover:bg-yellow-700",
            onConfirm: performRaidCancel
        });
    });
    // Clear path button
    /*
    document.getElementById('clear-path').addEventListener('click', () => {
        gameState.currentRaid.selectedPath = [];
        updatePathDisplay();
        updateGridPathHighlight();
            highlightValidMoves();
        saveGameState();
    });
    */ // Close modal button
    document.getElementById("close-modal").addEventListener("click", ()=>{
        (0, $bd083a63eb37c143$export$5d484cf67c77323e)();
    });
    // Modal background click to close (only if mousedown started on background)
    const contractorModal = document.getElementById("contractor-modal");
    let mousedownTarget = null;
    contractorModal.addEventListener("mousedown", (e)=>{
        mousedownTarget = e.target;
    });
    contractorModal.addEventListener("click", (e)=>{
        if (e.target.id === "contractor-modal" && mousedownTarget?.id === "contractor-modal") (0, $bd083a63eb37c143$export$5d484cf67c77323e)();
    });
    // Setup purchase modal handlers
    (0, $b7695fceb608271e$export$fe032c86fe8adff)();
    // Tab switching handled above with animations
    // Regenerate contractors test button
    document.getElementById("regenerate-contractors-btn").addEventListener("click", ()=>{
        if ((0, $f27982cef7035d22$export$8e361a1ffbebf172).character) {
            (0, $bd083a63eb37c143$export$aca974319671fb3e)();
            // Refresh Alpine.js contractors display
            (0, $803c9a726c40de05$export$17502054442d56b0)();
            (0, $0c8e0782d8c2833e$export$c7def531c087da85)("\uD83D\uDD04 Contractor list regenerated for testing", "info");
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        }
    });
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Setting up periodic updates...");
    // Set up periodic energy regeneration and UI updates
    const regenIntervalMs = 5000;
    setInterval(()=>{
        (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Processing team health regeneration (including self)...");
        const healthChanged = (0, $bd083a63eb37c143$export$3e71fa030a894242)(regenIntervalMs);
        // Update energy first
        (0, $1b3f8df6e579f420$export$e4e85317acdbc3c2)();
        // Currency values and the active-task label come from the layer registry.
        // Values only - refreshToolbarValues() deliberately does not rebuild the
        // chips, so the energy popup survives being open across a tick.
        (0, $a1ffcc09d1c6aa84$export$c6af328ac5cab01b)();
        (0, $9a58895c0c0daffa$export$ca081aebb329a098)(); // one-way Command reveal (announce + re-render)
        // Update reservation timers every second
        if (typeof (0, $bd083a63eb37c143$export$1b23387deaaf022d) !== "undefined") (0, $bd083a63eb37c143$export$1b23387deaaf022d)();
        // Check for expired marketplace contractor reservations
        const contractorsExpired = (0, $bd083a63eb37c143$export$797aa5f00658ac19)();
        // Update UI
        (0, $f3f2c7a1b1934e01$export$d1c957a54f7124bc)();
        if (healthChanged || contractorsExpired) {
            (0, $a52c72724dfd3eca$export$b70ccd83fb3eaefa)();
            (0, $41a2a1ff52c357a7$export$384cd953322e3851)();
        }
        // Auto-Raid Protocol advances at most one step per tick, reading only from
        // gameState — so a reload mid-raid resumes, and a player taking manual
        // control is noticed on the next tick rather than fought by a live promise.
        // The raid functions are injected rather than imported by autoRaid.js: they
        // live in DOM-heavy modules, and passing them keeps the cycle testable.
        // Operations arrive on their own clock; settle whatever is due.
        (0, $52f5c9f49814d28d$export$9dd8092a8219c221)();
        // The world clock (M3 S9) turns whether or not anything else happens. Both
        // calls are no-ops off their own screens — the raid grid's own animation
        // loop drives the day clock above the map, so only these two surfaces need
        // the tick: region tiles in raid planning, and the world map's terminator.
        (0, $f3f2c7a1b1934e01$export$bfd4e77d5f2367cd)();
        (0, $52f5c9f49814d28d$export$4af0774c25cece2a)();
        (0, $9f2007d9cd6d0433$export$8e2efb5378addfbb)({
            generateGrid: setupRaidGrid,
            autoScoutPath: $9a58895c0c0daffa$export$478f57514b105434,
            autoReserveContractors: $9a58895c0c0daffa$export$95f7842af258a4dd,
            startRaid: $a52c72724dfd3eca$export$bb6b71fe7f08b971,
            resetRaid: $a52c72724dfd3eca$export$8dc8f2c13318a5b7,
            promoteAndSucceed: $9266f6113786f65f$export$e62c6e81abdadce7
        }).catch((err)=>console.error("Auto-Raid tick failed:", err));
        // Auto-Fabricator works the DEAD TIME — while a raid runs, or while the
        // raid cycle waits on energy. Crafting in the launch path would delay every
        // raid by a tick per component, and a tech-gear tree is several. The window
        // is decided here because only main.js sees both the raid and the cycle.
        // Auto-Fabricator: one craft per tick while it is switched on. It shares
        // nothing with the raid cycle above and cannot delay it, so it runs on the
        // same plain schedule rather than waiting for a window.
        (0, $4122a28830cdd562$export$109e3e91403b4584)();
    }, regenIntervalMs); // Update every 5 seconds
    // Refresh the contractor list to show latest availability (both main list and
    // modal). A self-rescheduling timeout rather than setInterval, because the
    // cadence backs off: 10s, 20s, 40s ... settling at ~5m20s while the section
    // stays open, so a page left open all day stops hammering the API. Any poll
    // that finds the UI off-screen resets the cadence, so reopening the section
    // (which also refreshes immediately via the tab handler) is responsive again.
    const pollContractorList = ()=>{
        const contractorsTab = document.getElementById("contractors-tab");
        const modal = document.getElementById("contractor-modal");
        // document.hidden covers a backgrounded browser tab — no point polling for a
        // list nobody is looking at.
        const onScreen = (el)=>!document.hidden && el && !el.classList.contains("hidden") && window.getComputedStyle(el).display !== "none";
        const contractorsTabVisible = onScreen(contractorsTab);
        const modalVisible = onScreen(modal);
        if (contractorsTabVisible || modalVisible) {
            // Refresh Alpine store (updates modal)
            if ((0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("contractors")) (0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).store("contractors").refresh();
            // Refresh main list display
            if (contractorsTabVisible) (0, $bd083a63eb37c143$export$fada499eccb8a752)();
            $f69ab99adc4bc920$var$contractorPollDelay = (0, $e7dde87afbac6dd8$export$64b66d963f6d5043)($f69ab99adc4bc920$var$contractorPollDelay);
        } else $f69ab99adc4bc920$var$contractorPollDelay = (0, $e7dde87afbac6dd8$export$fa0ee1eb937a38e6);
        setTimeout(pollContractorList, $f69ab99adc4bc920$var$contractorPollDelay);
    };
    setTimeout(pollContractorList, $f69ab99adc4bc920$var$contractorPollDelay);
    // Auto-sync when coming back online
    window.addEventListener("online", ()=>{
        setTimeout(()=>{
            (0, $f5272a3e1bbf7d7b$export$e4477200b6413a70).syncLocalCharacters();
            (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Multiplayer system initialized");
        }, 1000); // Give a moment for connection to stabilize
    });
    // Startup marketplace reconciliation, ordered because each step feeds the next:
    //   1. re-onboard pre-token (legacy) characters so they have a multiplayerId,
    //   2. refresh their listing state from the server (local marketplaceData is a
    //      snapshot taken at listing time and can be stale),
    //   3. act on it — expire listings and collect any pending payouts.
    // Non-blocking; each step is best-effort and must not stop the next.
    (0, $f3f2c7a1b1934e01$export$bb017115af5d1f34)().catch((err)=>console.error("Error claiming legacy characters:", err)).then(()=>(0, $f3f2c7a1b1934e01$export$162c77cf09613261)()).catch((err)=>console.error("Error syncing marketplace listings:", err)).finally(()=>(0, $f3f2c7a1b1934e01$export$9124d6474b00dfc4)());
    setInterval(()=>{
        (0, $f3f2c7a1b1934e01$export$9124d6474b00dfc4)();
    }, 600000); // Update every 10 minutes
    // Initialize Tippy.js tooltips for all elements
    if (window.tippy) {
        // Initialize contractor tooltips
        tippy(".contractor-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 400,
            allowHTML: true
        });
        // Initialize skill tooltips
        tippy(".skill-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 300,
            allowHTML: true
        });
        // Initialize room tooltips (if they exist)
        tippy(".room-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 350,
            allowHTML: true,
            content (reference) {
                return reference.dataset.tippyContent;
            }
        });
        // Initialize inventory item tooltips
        tippy(".inventory-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                300,
                0
            ],
            maxWidth: 300,
            allowHTML: true,
            content (reference) {
                // Get the description from the hidden div if it exists
                const descDiv = reference.querySelector(".inventory-tooltip-content");
                return descDiv ? descDiv.innerHTML : "";
            },
            onMount (instance) {
                instance.popper.style.border = "2px solid white";
                instance.popper.style.borderRadius = "0.5rem";
            },
            onShow (instance) {
                // Create a named function so it can be accurately removed later
                instance._scrollHandler = ()=>instance.hide();
                window.addEventListener('scroll', instance._scrollHandler, {
                    passive: true
                });
            },
            onHide (instance) {
                // Clean up the listener to prevent memory leaks
                window.removeEventListener('scroll', instance._scrollHandler);
            }
        });
    }
    // Show game UI with fade-in after everything is loaded
    const gameContainer = document.getElementById("game-container");
    if (gameContainer) {
        gameContainer.style.display = "";
        gameContainer.style.opacity = "0";
        gameContainer.style.transition = "opacity 0.3s ease-in";
        setTimeout(()=>{
            gameContainer.style.opacity = "1";
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 10);
    }
    // How To Play button
    document.getElementById("how-to-btn").addEventListener("click", ()=>{
        // Built on open, not at boot: the Command reveal fires on a background tick,
        // so a guide captured earlier would still be hiding a layer the header shows.
        const html = (0, $42b272c2c0f44bdf$export$189173d473c82c30)((0, $d702ea8c52a4a088$export$ec50a2d4695064b2)());
        (0, $42b272c2c0f44bdf$export$d7e8d4d4450c819c)("Gameplay Guide", `
            <div class="gameplay-guide prose prose-invert max-w-none max-h-[70vh] overflow-y-auto">
                ${html}
            </div>
        `);
    });
    document.getElementById("version-display").textContent = `v${0, $0637c4e4ee3b431f$export$9badeb9b04b4b71c}`;
    // Dev-only strip: tablet check, then one button per save fixture. Both
    // self-gate to localhost via devBar.js. Viewport first so it stays leftmost.
    (0, $1829d481bf452b83$export$d95b3e0536e68b56)();
    (0, $240af90fbaec7c06$export$45e422e963dadb5c)();
});
document.addEventListener("alpine:init", ()=>{
    (0, $8fffcb1ac554ad26$export$1c9f709888824e05)((0, $8fffcb1ac554ad26$export$31ff2235b44019b8).ui, "Initializing Alpine Stores");
    (0, $803c9a726c40de05$export$7532162a9c4df7a1)();
    (0, $607ffae1bbc96660$export$5e57bb1ccaa580e5)();
    // Vault screen bodies. Injected HERE, not later: alpine:init fires before
    // Alpine walks the DOM, so this markup gets initialized with everything else.
    // Injecting after Alpine.start() would need a manual initTree and would leave
    // the directives inert if that were ever forgotten.
    const paneBody = (id, source, accent, empty)=>{
        const host = document.getElementById(id);
        if (host) host.innerHTML = (0, $607ffae1bbc96660$export$4d450619ebe70217)(source, accent, empty);
    };
    paneBody("command-vault-body", "commandVault", "#b18cff", "Nothing outbound. Promote a character to send their kit onward.");
    paneBody("syndicate-stores-body", "syndicateStores", "#e0a84c", "Nothing on the dock. Founding delivers what the Guild Vault has consigned.");
});
(0, $b42d55c73dda5cc5$export$2e2bcd8739ae039).start();


//# sourceMappingURL=repo.441b0f07.js.map
